(function() {
    'use strict';

    angular
        .module('app', ['ngAnimate', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap',
            'pascalprecht.translate', 'oc.lazyLoad', 'ngCacheBuster', 'ngStorage', 'angular-ladda', 'angularMoment', 'ui.mask', 'angular.filter', 'oi.select', 'rzSlider', 'bm.uiTour']);

    //module.config(function (TourConfigProvider) {
    //    TourConfigProvider.enableNavigationInterceptors();
    //});

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('ReportsService', ['$resource', 'apiUrl', ReportsService]);

    function ReportsService($resource, apiUrl) {
        var service = $resource(apiUrl + 'reports/:subjId', {}, {
            getPfReports: {
                url: apiUrl + 'reports/pfReports',
                method: 'GET',
                isArray: true
            }
        });
        return service;
    }
})();
(function() {
    'use strict';

    angular.module('app')
        .directive('reportsDt', ['$timeout', '$translate', reportsDt]);

    function reportsDt($timeout, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            targets: 6,
                            orderable: false,
                            searchable: false
                        }],
                        autoWidth: false,
                        order: [
                            [1, 'asc']
                        ],
                        drawCallback: function () {
                            var searchBox = $('div#reportsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.repts.searchText'));
                            $('div#reportsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('ReportsCtrl', ['$rootScope', '$filter', '$translate', '$http', '$uibModal', 'AppService', 'surveyTypes', 'surveySections', 'scoreTypes', 'chartGrps', 'reports', 'apiUrl', ReportsCtrl])
        .controller('AddParameterModalCtrl', ['$uibModalInstance', '$scope', '$http', '$translate', '$filter', 'filterOptions', 'apiUrl', 'requestParams', 'requestObj', 'filterParamOptions', AddParameterModalCtrl]);

    function ReportsCtrl($rootScope, $filter, $translate, $http, $uibModal, AppService, surveyTypes, surveySections, scoreTypes, chartGrps, reports, apiUrl) {
        var vm = this;
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        vm.ladda = {};
        var dateFormatPref = $filter('filter')($rootScope.referenceData.DATE_FORMT_CD.refItems, {
            cd: $rootScope.account.userPrefs.PREF_DATE_FORMT
        }, true)[0];

        var reportPref = $filter('filter')($rootScope.referenceData.REPT_LAYOUT_CD.refItems, {
            cd: $rootScope.account.userPrefs.PREF_REPT_LAYOUT
        }, true)[0];

        if ($rootScope.subject) {
            reports = $rootScope.subject.reports;
        }
        vm.reports = [];
        if (reports) {
            angular.forEach(reports, function(report) {
                if (report && report.sysDocText) {
                    var reptJson = JSON.parse(report.sysDocText.replace(/(\r\n\t|\n|\r\t)/gm, ''));
                    var downloadOption = $filter('filter')(reptJson.reptOptions, {
                        layoutCd: reportPref.cd
                    }, true)[0];
                    if (downloadOption) {
                        report.downloadOption = downloadOption;
                        report.reptName = reptJson.reptName;
                        report.reptDataClass = reptJson.reptDataClass;
                        report.icon = reptJson.reptIcon;
                        report.downloadFormatIcon = reptJson.reptDownloadFormatIcon;
                        report.downloadFormatColor = reptJson.reptDownloadFormatColor;
                        report.reportLayout = reportPref.nm;
                        report.parms = reptJson.parms;
                        vm.reports.push(report);
                    }
                }
                vm.ladda[report.sysDocCd] = false;
            });
        }

        vm.downloadReport = function(report) {
            var requestObj = {
                languageCd: report.sysDocLangCd,
                className: report.reptDataClass,
                title: report.sysDocName,
                subtitle: report.sysDocDesc,
                dtFmt: dateFormatPref.nm,
                tz: tz,
                asOfDateLabel: $filter('dateRangeLabel')($rootScope.userParms.DT_RANGE_CD.val),
                asOfFromDate: $rootScope.userParms.DT_RANGE_CD.val.asOfFromDate,
                asOfToDate: $rootScope.userParms.DT_RANGE_CD.val.asOfToDate,
                paperSize: report.downloadOption.layoutCd
            };
            if ($rootScope.userParms.ORG_ID) {
                requestObj.orgLabel = $filter('userParmLabel')($rootScope.userParms.ORG_ID.val, 'ORG_ID');
                requestObj.orgId = $rootScope.userParms.ORG_ID.val;
            }
            var parms = report.parms;
            if (parms) {
                var addParameterModalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'add-parameter-dialog-template.html',
                    controller: 'AddParameterModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    resolve: {
                        filterOptions: function() {
                            return createFilterOptions(parms);
                        },
                        requestParams: function() {
                            return {
                                subject: $rootScope.subject,
                                templtName: report.downloadOption.templtName,
                                reptName: report.sysDocName
                            };
                        },
                        requestObj: function() {
                            return requestObj;
                        },
                        filterParamOptions: function() {
                            return {
                                obsvTypes: $rootScope.referenceData.OBSV_TYPE.refItems.filter(function(obsvType) {
                                    return obsvType.cd !== 'DOCU';
                                }),
                                obsvPriotSeqs: $filter('orderBy')($rootScope.referenceData.OBSV_PRIOT_SEQ.refItems, 'dispSeq'),
                                hierLvls: $rootScope.referenceData.HIER_LVL.refItems,
                                l2HierNodes: $filter('orderBy')($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq').filter(function(hierNode) {
                                    return hierNode.entity.hierLvlId === 2;
                                }),
                                l3HierNodes: $filter('orderBy')($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq').filter(function(hierNode) {
                                    return hierNode.entity.hierLvlId === 3;
                                }),
                                survTypes: $filter('orderBy')(surveyTypes.data, 'dispSeq'),
                                survSects: $filter('orderBy')(surveySections.data, ['survTypeDispSeq', 'survSectSeq']),
                                scoreTypes: $filter('orderBy')(scoreTypes.data, 'dispSeq'),
                                scoreHierLvls: $rootScope.referenceData.SCORE_HIER_LVL.refItems,
                                l2ScoreHierNodes: $filter('orderBy')($rootScope.referenceData.SCORE_HIER_NODE.refItems, 'dispSeq').filter(function(hierNode) {
                                    return hierNode.entity.scoreHierLvlId === 2;
                                }),
                                l3ScoreHierNodes: $filter('orderBy')($rootScope.referenceData.SCORE_HIER_NODE.refItems, 'dispSeq').filter(function(hierNode) {
                                    return hierNode.entity.scoreHierLvlId === 3;
                                }),
                                chartGrps: $filter('orderBy')(chartGrps.data, 'grpSeq')
                            };
                        }
                    }
                });
                addParameterModalInstance.result.then(function(data) {
                    if (data) {
                        createPdfFile(report.reptName, data);
                    }
                });
            } else {
                vm.ladda[report.sysDocCd] = true;
                $http.post(apiUrl + 'reports/' + ($rootScope.subject ? $rootScope.subject.subjId + '/' : '') + report.downloadOption.templtName, requestObj).success(function(data) {
                    vm.ladda[report.sysDocCd] = false;
                    if (typeof(data) !== 'undefined') {
                        createPdfFile(report.reptName, data);
                        toastr.success(
                            $translate.instant('subj.repts.toast.downldReptSuccess', {
                                reptName: report.sysDocName
                            }),
                            $translate.instant('subj.repts.pageTitle'),
                            toastr.options
                        );
                    } else {
                        toastr.error(
                            $translate.instant('subj.repts.toast.downldReptError', {
                                reptName: report.sysDocName
                            }),
                            $translate.instant('subj.repts.pageTitle'),
                            toastr.options
                        );
                    }
                }).error(function() {
                    vm.ladda[report.sysDocCd] = false;
                    toastr.error(
                        $translate.instant('subj.repts.toast.downldReptError', {
                            title: report.sysDocName
                        }),
                        $translate.instant('subj.repts.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        function createFilterOptions(parms) {
            var filterOptions = [];
            angular.forEach(parms, function(parm) {
                var label;
                switch (parm) {
                case 'obsv_type_cd':
                    label = 'Observation Type';
                    break;
                case 'obsv_priot_seq':
                    label = 'Observation Priority';
                    break;
                case 'sys_doc_sub_grp':
                    label = 'Group';
                    break;
                }
                filterOptions.push({
                    param: parm,
                    label: label
                });
            });
            return filterOptions;
        }

        function createPdfFile(fileName, data) {
            var a = document.createElement('a');
            document.body.appendChild(a);
            var fileArrayBuffer = base64ToArrayBuffer(data);
            var file = new Blob([fileArrayBuffer], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }

        function base64ToArrayBuffer(base64) {
            if (typeof(base64) !== 'undefined') {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }
            return base64;
        }
    }

    function AddParameterModalCtrl($uibModalInstance, $scope, $http, $translate, $filter, filterOptions, apiUrl, requestParams, requestObj, filterParamOptions) {
        var modal = this;
        modal.laddaSave = false;
        modal.addSubmitted = false;
        modal.submitted = false;
        modal.filterParamOptions = filterParamOptions;
        modal.rptParamOpt = 'full';
        modal.newFilter = {
            param: ''
        };
        modal.filters = [];

        var hierLvl2Label = $filter('filter')(filterParamOptions.hierLvls, {
            cd: '2'
        }, true)[0].nm;
        var hierLvl3Label = $filter('filter')(filterParamOptions.hierLvls, {
            cd: '3'
        }, true)[0].nm;

        function getFilterOptions() {
            var f = [];
            angular.forEach(filterOptions, function(filterOption) {
                if (
                    (filterOption.param === 'hier_node_id' && $filter('filter')(modal.filters, {param: 'l2_hier_node'}, true).length === 0 && $filter('filter')(modal.filters, {param: 'l3_hier_node'}, true).length === 0)
                    || (filterOption.param === 'surv_type_sect' && $filter('filter')(modal.filters, {param: 'surv_type_cd'}, true).length === 0 && $filter('filter')(modal.filters, {param: 'surv_sect'}, true).length === 0)
                    || (filterOption.param === 'score_type' && $filter('filter')(modal.filters, {param: 'score_type_cd'}, true).length === 0 && $filter('filter')(modal.filters, {param: 'l2_score_hier_node'}, true).length === 0 && $filter('filter')(modal.filters, {param: 'l3_score_hier_node'}, true).length === 0)
                    || (filterOption.param !== 'hier_node_id' && filterOption.param !== 'surv_type_sect' && filterOption.param !== 'score_type' && $filter('filter')(modal.filters, {param: filterOption.param}, true).length === 0)
                ) {
                    if (filterOption.param === 'hier_node_id') {
                        f.push({
                            param: 'l2_hier_node',
                            label: hierLvl2Label
                        });
                        f.push({
                            param: 'l3_hier_node',
                            label: hierLvl3Label
                        });
                    } else if (filterOption.param === 'surv_type_sect') {
                        f.push({
                            param: 'surv_type_cd',
                            label: 'Survey Type'
                        });
                        f.push({
                            param: 'surv_sect',
                            label: 'Survey Section'
                        });
                    } else if (filterOption.param === 'score_type') {
                        f.push({
                            param: 'score_type_cd',
                            label: 'Score Type'
                        });
                        f.push({
                            param: 'l2_score_hier_node',
                            label: 'L2 Node'
                        });
                        f.push({
                            param: 'l3_score_hier_node',
                            label: 'L3 Node'
                        });
                    } else {
                        f.push(filterOption);
                    }
                }
            });
            return f;
        }
        modal.filterOptions = getFilterOptions();
        $scope.$watch('modal.newFilter.param', function() {
            onChange();
        });

        $scope.$watch('modal.newFilter.val', function() {
            onChange();
        });

        modal.paramNull = function() {
            return !modal.newFilter.val || modal.newFilter.val.length === 0;
        };

        modal.addFilterBtnDisabled = function() {
            return (!modal.newFilter.param);
        };

        modal.addFilter = function() {
            modal.addSubmitted = true;
            if (!modal.paramNull()) {
                modal.filters.push(modal.newFilter);
                modal.newFilter = {
                    param: ''
                };
                modal.addSubmitted = false;
            }
            modal.filterOptions = getFilterOptions();
        };

        modal.removeFilter = function(index) {
            modal.filters.splice(index, 1);
            modal.filterOptions = getFilterOptions();
        };

        modal.resetVal = function() {
            delete modal.newFilter.val;
        };

        function onChange() {
            modal.submitted = false;
        }

        modal.getFilterLabel = function(param) {
            if (param === 'l2_hier_node') {
                return hierLvl2Label;
            }
            if (param === 'l3_hier_node') {
                return hierLvl3Label;
            }
            if (param === 'surv_type_cd') {
                return 'Survey Type';
            }
            if (param === 'surv_sect') {
                return 'Survey Section';
            }
            if (param === 'score_type_cd') {
                return 'Score Type';
            }
            if (param === 'l2_score_hier_node') {
                return 'L2 Node';
            }
            if (param === 'l3_score_hier_node') {
                return 'L3 Node';
            }
            if (param) {
                return $filter('filter')(filterOptions, {
                    param: param
                }, true)[0].label;
            }
            return '';
        };

        modal.getFilterVal = function(filter) {
            var vals = [];
            if (filter.param === 'obsv_type_cd') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.obsvTypes, {
                        cd: filterVal
                    }, true)[0].nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'obsv_priot_seq') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.obsvPriotSeqs, {
                        cd: filterVal
                    }, true)[0].nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'l2_hier_node') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.l2HierNodes, {
                        cd: filterVal
                    }, true)[0].nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'l3_hier_node') {
                angular.forEach(filter.val, function(filterVal) {
                    var node = $filter('filter')(modal.filterParamOptions.l3HierNodes, {
                        cd: filterVal
                    }, true)[0];
                    vals.push(node.entity.parntHierNodeName + ': ' + node.nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'surv_type_cd') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.survTypes, {
                        survTypeCd: filterVal
                    }, true)[0].survTypeName);
                });
                return vals.join(', ');
            } else if (filter.param === 'surv_sect') {
                angular.forEach(filter.val, function(filterVal) {
                    var survTypeCd = filterVal.split('|')[0];
                    var survVersSeq = parseInt(filterVal.split('|')[1]);
                    var survSectSeq = parseInt(filterVal.split('|')[2]);
                    var node = $filter('filter')(modal.filterParamOptions.survSects, {
                        survTypeCd: survTypeCd,
                        survVersSeq: survVersSeq,
                        survSectSeq: survSectSeq
                    }, true)[0];
                    vals.push(node.survTypeName + ': ' + node.survSectName);
                });
                return vals.join(', ');
            } else if (filter.param === 'score_type_cd') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.scoreTypes, {
                        scoreTypeCd: filterVal
                    }, true)[0].scoreTypeName);
                });
                return vals.join(', ');
            } else if (filter.param === 'l2_score_hier_node') {
                angular.forEach(filter.val, function(filterVal) {
                    var node = $filter('filter')(modal.filterParamOptions.l2ScoreHierNodes, {
                        cd: filterVal
                    }, true)[0];
                    vals.push(node.entity.scoreTypeName + ': ' + node.nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'l3_score_hier_node') {
                angular.forEach(filter.val, function(filterVal) {
                    var node = $filter('filter')(modal.filterParamOptions.l3ScoreHierNodes, {
                        cd: filterVal
                    }, true)[0];
                    vals.push(node.entity.scoreTypeName + ': ' + node.entity.parntScoreHierNodeName + ': ' + node.nm);
                });
                return vals.join(', ');
            } else if (filter.param === 'sys_doc_sub_grp') {
                angular.forEach(filter.val, function(filterVal) {
                    vals.push($filter('filter')(modal.filterParamOptions.chartGrps, {
                        grpId: filterVal
                    }, true)[0].grpName);
                });
                return vals.join(', ');
            }
        };

        modal.submit = function() {
            modal.submitted = true;
            if (modal.rptParamOpt === 'full' || !modal.newFilter.param) {
                modal.laddaSave = true;
                if (modal.rptParamOpt === 'filter') {
                    requestObj.filters = [];
                    angular.forEach(modal.filters, function(queryParam) {
                        var filter = {
                            param: queryParam.param
                        };
                        //if (queryParam.param === 'obsv_type_cd' || queryParam.param === 'obsv_priot_seq' || queryParam.param === 'l2_hier_node' || queryParam.param === 'l3_hier_node' || queryParam.param === 'surv_type_cd' || queryParam.param === 'surv_sect' || queryParam.param === 'score_type_cd') {
                        filter.val = queryParam.val.join(',');
                        //}
                        requestObj.filters.push(filter);
                    });
                }
                $http.post(apiUrl + 'reports/' + (requestParams.subject ? requestParams.subject.subjId + '/' : '') + requestParams.templtName, requestObj).success(function(data) {
                    modal.laddaSave = false;
                    if (typeof(data) !== 'undefined') {
                        toastr.success(
                            $translate.instant('subj.repts.toast.downldReptSuccess', {
                                reptName: requestParams.reptName
                            }),
                            $translate.instant('subj.repts.pageTitle'),
                            toastr.options
                        );
                        $uibModalInstance.close(data);
                    } else {
                        toastr.error(
                            $translate.instant('subj.repts.toast.downldReptError', {
                                reptName: requestParams.reptName
                            }),
                            $translate.instant('subj.repts.pageTitle'),
                            toastr.options
                        );
                        $uibModalInstance.close();
                    }
                }).error(function() {
                    toastr.error(
                        $translate.instant('subj.repts.toast.downldReptError', {
                            reptName: requestParams.reptName
                        }),
                        $translate.instant('subj.repts.pageTitle'),
                        toastr.options
                    );
                    $uibModalInstance.close();
                });
            }
        };

        modal.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('DashboardCtrl', ['$rootScope', '$state', '$timeout', '$translate', '$filter', 'filterFilter', 'userActivityMetrics', DashboardCtrl]);

    function DashboardCtrl($rootScope, $state, $timeout, $translate, $filter, filterFilter, userActivityMetrics) {
        var vm = this;
        vm.showDashFlag = $rootScope.subject.showDashFlag;
        vm.pctChangeFlag = $rootScope.sysParms.DASH_SCORE_PCT_CHG_FLAG.toLowerCase() === 'true' ? true : false;
        vm.pctChangeDp = $rootScope.sysParms.DASH_SCORE_PCT_CHG_DP;

        if ($rootScope.subject.scores) {
            $rootScope.subject.scores.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
        }
        $rootScope.subject.obsvs.sort(function(a, b) {
            return a.dispSeq - b.dispSeq;
        });

        if ($rootScope.subject.survey) {
            vm.surveyArray = filterFilter($rootScope.surveySections, {
                survTypeCd: $rootScope.subject.survey.type.cd
            });
            vm.surveyIndex = ($filter('orderBy')(vm.surveyArray, 'survSectSeq'))[0].survSectSeq;
        }

        vm.subjStageScores = filterFilter($rootScope.subjStageScores, {
            subjStageId: $rootScope.subject.subjStageId
        });

        // User Activity Metrics
        vm.userActivityData = {};
        if (userActivityMetrics && userActivityMetrics.length > 0) {
            $('body').append('<span class="users-bg-color">&nbsp</span>');
            $('body').append('<span class="orgs-bg-color">&nbsp</span>');
            vm.userActivityUserLoginsColour = $($('.users-bg-color')[0]).css('background-color');
            vm.userActivityEventsColour = $($('.orgs-bg-color')[0]).css('background-color');
            $('.users-bg-color').remove();
            $('.orgs-bg-color').remove();

            var loginSeries = {
                seriesType: 'bar',
                seriesColor: vm.userActivityUserLoginsColour,
                elements: []
            };
            var eventSeries = {
                seriesType: 'line',
                seriesColor: vm.userActivityEventsColour,
                axis: 'secondary',
                elements: []
            };

            userActivityMetrics.sort(function(a, b) {
                return new Date(a.activityDate) - new Date(b.activityDate);
            });

            angular.forEach(userActivityMetrics, function(userActivity) {
                var loginCntText = $translate.instant('subj.portflDashbrd.usrActvtyMetricPULoginCntLabel') + ': ' + userActivity.userLoginActivityCnt;
                var eventCntText = $translate.instant('subj.portflDashbrd.usrActvtyMetricPUEventCntLabel') + ': ' + userActivity.subjEventActivityCnt;
                var tip = '<div class="idmx-d3-tip" tooltip-animation-class="fade">'
                    + '<div class="arrow"></div>'
                    + '<div class="popover-inner">'
                    + '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">'
                    + '<div class="color-box" style="background-color:' + loginSeries.seriesColor + '"></div>'
                    + '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + $translate.instant('subj.dashbrd.usrActvtyMetricXAxisLabel') + ': ' + $filter('shortDateFormatWithDay')(userActivity.activityDate) + '</h3></div>'
                    + '</div>'
                    + '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">'
                    + loginCntText + '&nbsp;&nbsp;' + eventCntText
                    + '</div>'
                    + '</div>'
                    + '</div>';
                loginSeries.elements.push({
                    category: userActivity.activityDate,
                    label: $filter('dayOfWeekFormat')(userActivity.activityDate).charAt(0),
                    value: userActivity.userLoginActivityCnt,
                    labelCssClass: ($filter('isoDayOfWeekFormat')(userActivity.activityDate) >= 6) ? 'chart-axis-label-fade' : null,
                    tip: tip
                });
                eventSeries.elements.push({
                    category: userActivity.activityDate,
                    value: userActivity.subjEventActivityCnt
                });
            });
            vm.userActivityData = {
                series: [loginSeries, eventSeries]
            };
        }

        vm.userActivityChartConfig = {
            width: 1141,
            height: 130,
            padding: {
                top: 15,
                bottom: 3,
                left: 3,
                right: 3
            },
            orientation: 'vertical',
            seriesLayout: 'grouped',
            catgAxisLabel: $translate.instant('subj.dashbrd.usrActvtyMetricXAxisLabel'),
            valueAxisPrimaryLabel: $translate.instant('subj.dashbrd.usrActvtyMetricYAxis1Label'),
            valueAxisSecondaryLabel: $translate.instant('subj.dashbrd.usrActvtyMetricYAxis2Label'),
            showGridlines: false,
            showLegend: false
        };

        vm.gotoObsvs = function(obsvTypeCd) {
            $rootScope.obsvTypeFilter = obsvTypeCd;
            $state.go('app.subject.observations');
        };

        $timeout(function() {
            if ($rootScope.subject.obsvs && $rootScope.subject.obsvs.length) {
                vm.obsvTypeName = $rootScope.subject.obsvs[0].obsvTypeName;
                vm.obsvTypeCd = $rootScope.subject.obsvs[0].obsvTypeCd;
                $('#subj-dash-obsvs').on('slide.bs.carousel', function (e) {
                    var idx = parseInt($(e.relatedTarget).attr('index'));
                    vm.obsvTypeName = $rootScope.subject.obsvs[idx].obsvTypeName;
                    vm.obsvTypeCd = $rootScope.subject.obsvs[idx].obsvTypeCd;
                });
                if ($rootScope.subject.obsvs.length < 2) {
                    $('#nextObsv').hide();
                    $('#prevObsv').hide();
                } else {
                    $('#prevObsv').hide();
                }

                vm.slideObsv = function(e, action) {
                    $('#subj-dash-obsvs').carousel(action);
                    var idx = parseInt($('#subj-dash-obsvs .active').index('#subj-dash-obsvs .item'));
                    if (action === 'prev' && $rootScope.subject.obsvs.length > 1) {
                        $('#nextObsv').show();
                        if (idx === 1) {
                            $('#nextObsv').show();
                            $('#prevObsv').hide();
                        }
                    } else if (action === 'next') {
                        $('#prevObsv').show();
                        idx++;
                        if (idx === ($rootScope.subject.obsvs.length - 1)) {
                            $('#nextObsv').hide();
                        }
                    }
                    e.preventDefault();
                    return false;
                };
            }
        });

        $timeout(function() {
            if ($rootScope.subject.scores && $rootScope.subject.scores.length) {
                vm.scoreTypeName = $rootScope.subject.scores[0].scoreTypeName;
                vm.scoreTypeCd = $rootScope.subject.scores[0].scoreTypeCd;
                $('#subj-dash-scores').on('slide.bs.carousel', function (e) {
                    var idx = parseInt($(e.relatedTarget).attr('index'));
                    vm.scoreTypeName = $rootScope.subject.scores[idx].scoreTypeName;
                    vm.scoreTypeCd = $rootScope.subject.scores[idx].scoreTypeCd;
                });
                if ($rootScope.subject.scores.length < 2) {
                    $('#nextSubjScore').hide();
                    $('#prevSubjScore').hide();
                } else {
                    $('#prevSubjScore').hide();
                }

                vm.slideScore = function(e, action) {
                    $('#subj-dash-scores').carousel(action);
                    var idx = parseInt($('#subj-dash-scores .active').index('#subj-dash-scores .item'));
                    if (action === 'prev' && $rootScope.subject.scores.length > 1) {
                        $('#nextSubjScore').show();
                        if (idx === 1) {
                            $('#nextSubjScore').show();
                            $('#prevSubjScore').hide();
                        }
                    } else if (action === 'next') {
                        $('#prevSubjScore').show();
                        idx++;
                        if (idx === ($rootScope.subject.scores.length - 1)) {
                            $('#nextSubjScore').hide();
                        }
                    }
                    e.preventDefault();
                    return false;
                };
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app')
        .directive('activityDt', ['$timeout', '$filter', '$translate', '$compile', activityDt]);

    function activityDt($timeout, $filter, $translate, $compile) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        retrieve: true,
                        paging: true,
                        lengthChange: false,
                        searching: true,
                        ordering: true,
                        data: scope.vm.events,
                        columns: [{
                            data: 'featIconName',
                            class: 'align-center',
                            orderable: false,
                            searchable: false,
                            render: function(data, type) {
                                if (data && type === 'display' || type === 'filter') {
                                    return '<i class="fa fa ' + data + ' idmx-heading-icon" style="font-size: 20px;"></i>';
                                }
                                return data;
                            }
                        }, {
                            data: 'eventText',
                            render: function(data, type, row) {
                                if (data && type === 'display' || type === 'filter') {
                                    data = $filter('replaceEventToken')(data);
                                    if (row.isNew) {
                                        var lblNew = $translate.instant('subj.actvty.newEventLabel');
                                        data = data + ' <sup class="label lbl-negative">' + lblNew + '</sup>';
                                    }
                                    return data;
                                }
                                return data;
                            }
                        }, {
                            data: 'eventTypePrioritySeq',
                            render: function(data, type) {
                                if (data && type === 'display' || type === 'filter') {
                                    data = '<span class="label" activity-badge priority=' + data + '> ' + scope.vm.prioritySeqName(data) + '</span>';
                                }
                                return data;
                            }
                        }, {
                            data: 'crtTmstmp',
                            render: function(data, type) {
                                if (data && type === 'display' || type === 'filter') {
                                    return $filter('mixedDateFormat')(data);
                                }
                                return data;
                            }
                        }],
                        order: [
                            [3, 'desc']
                        ],
                        drawCallback: function() {
                            $compile(element)(scope);
                            var searchBox = $('div#activityTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.home.searchText')).attr('id', 'search-box-active-tab');
                            $('div#activityTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('ActivityCtrl', ['$rootScope', '$stateParams', '$translate', '$filter', 'SubjectService', 'SubjectsService', 'UserService', 'events', ActivityCtrl]);

    function ActivityCtrl($rootScope, $stateParams, $translate, $filter, SubjectService, SubjectsService, UserService, events) {
        var vm = this;
        vm.showActvtyFlag = $rootScope.subject.showActvtyFlag;
        var subjId = $stateParams.id;
        SubjectsService.saveLastAccs({
            subjectId: subjId
        });

        vm.events = events;
        vm.prioritySeqName = function(cd) {
            var prioritySeq = $rootScope.referenceData.EVENT_TYPE_PRIOT_SEQ.refItems.filter(function(item) {
                return parseInt(item.cd, 10) === cd;
            });
            return prioritySeq[0] && prioritySeq[0].nm ? prioritySeq[0].nm : '';

        };
        vm.numNewEvents = function() {
            return $filter('filter')(vm.events, {
                isNew: true
            }, true).length;
        };

        vm.acknowEvents = function() {
            return SubjectService.acknowEvents({
                subjId: subjId
            }).$promise.then(function(response) {
                toastr.success(
                    $translate.instant('subj.actvty.toast.acknowActvtySuccess'),
                    $translate.instant('subj.actvty.pageTitle'),
                    toastr.options
                );
                vm.events = response.events;
                $rootScope.subjEvents = UserService.getEvents({});
                repopulateActivityTable();
            }, function() {
                toastr.error(
                    $translate.instant('subj.actvty.toast.acknowActvtyError'),
                    $translate.instant('subj.actvty.pageTitle'),
                    toastr.options
                );
            });
        };

        function repopulateActivityTable() {
            var table = $('#activityTable').DataTable();
            table.clear();
            table
                .rows
                .add(vm.events)
                .draw();
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('scoreTab1', ['$timeout', scoreTab1])
        .directive('scoreTab2', ['$timeout', scoreTab2])
        .directive('scoreTab3', ['$timeout', scoreTab3])
        .directive('scoreTab4', ['$timeout', scoreTab4])
        .directive('flwupSubjEffDateIsValid', ['$timeout', flwupSubjEffDateIsValid])
        .directive('nextTargetScoreValIsValid', [nextTargetScoreValIsValid]);

    function scoreTab1($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    $('#search-box-parameters-tab').hide();
                    $('.add-score-target').hide();
                    $timeout(function() {
                        scope.vm.activeTab = 1;
                    });
                });
            }
        };
    }

    function scoreTab2($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    $('#search-box-parameters-tab').hide();
                    $('.add-score-target').hide();
                    $timeout(function() {
                        scope.vm.activeTab = 2;
                    });
                });
            }
        };
    }

    function scoreTab3($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    $('#search-box-parameters-tab').show();
                    $('.add-score-target').show();

                    $timeout(function () {
                        scope.vm.activeTab = 3;
                        var headerHeight = $('#idmx-page-header').height();
                        var pageTitleHeight = $('#idmx-page-title').height();
                        var footerHeight = 54;
                        var heightToSub = headerHeight + pageTitleHeight + footerHeight + 100;
                        $('#tab-4').css('height', 'calc(100vh - ' + heightToSub + 'px)');
                    }, 1000);

                    $('#flwupSubjEffDate').datepicker().on('changeDate', function() {
                        $('#flwupSubjEffDate').focus();
                    });
                });
            }
        };
    }

    function scoreTab4($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    $('#search-box-parameters-tab').hide();
                    $('.add-score-target').hide();
                    $timeout(function() {
                        scope.vm.activeTab = 4;
                    });
                });
            }
        };
    }

    function flwupSubjEffDateIsValid($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attrs, ctrl) {
                $('.fa-calendar, .input-group-addon').on('click', function() {
                    $timeout(function() {
                        $('#flwupSubjEffDate').datepicker('show');
                    });
                });
                ctrl.$validators.subjDateInvalid = function(modelValue) {
                    return modelValue && moment(modelValue, scope.vm.dateFormat, true).isValid();
                };
                ctrl.$validators.subjDateGtPrevValid = function(modelValue) {
                    if (modelValue && moment(modelValue, scope.vm.dateFormat, true).isValid()) {
                        return moment(modelValue, scope.vm.datePlaceholder, true).isAfter(moment(scope.$root.subject.subjEffDate));
                    }
                    return true;
                };
                ctrl.$validators.subjDateLtPrevValid = function(modelValue) {
                    if (modelValue && moment(modelValue, scope.vm.dateFormat, true).isValid() && scope.vm.flwupSubj && scope.vm.flwupSubj.nextSubjEffDate) {
                        return moment(modelValue, scope.vm.datePlaceholder, true).isBefore(moment(scope.vm.flwupSubj.nextSubjEffDate));
                    }
                    return true;
                };
            }
        };
    }

    function nextTargetScoreValIsValid() {
        return {
            require: 'ngModel',
            link: function(scope, elem, attrs, ctrl) {
                ctrl.$validators.invalid = function(modelValue) {
                    if (!modelValue) {
                        return true;
                    }
                    if (isNaN(modelValue) || modelValue > parseFloat(attrs.max)) {
                        return false;
                    }
                    return true;
                };
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('ScoreTypeCtrl', ['$rootScope', '$scope', '$state', '$translate', '$filter', '$timeout', 'ScoreService', 'subjGrpScore', 'scoreHierLevels', 'scoreHierNodeTargets', 'flwupSubj', 'account', 'sysParms', ScoreTypeCtrl]);

    function ScoreTypeCtrl($rootScope, $scope, $state, $translate, $filter, $timeout, ScoreService, subjGrpScore, scoreHierLevels, scoreHierNodeTargets, flwupSubj, account, sysParms) {
        var vm = this;
        vm.maxTargetableLvlId = scoreHierNodeTargets.maxTargetableLvlId || 0;
        vm.showLevel = function(scoreHierLvlId) {
            return scoreHierLvlId <= vm.maxTargetableLvlId;
        };
        vm.scoreCurrTargDispFlag = sysParms.data.SCORE_CURR_TARG_DISP_FLAG && sysParms.data.SCORE_CURR_TARG_DISP_FLAG.toLowerCase() === 'true';
        vm.latestTargFlag = sysParms.data.SCORE_COMP_LATEST_TARG_FLAG && sysParms.data.SCORE_COMP_LATEST_TARG_FLAG.toLowerCase() === 'true';
        vm.targetableNodesExist = scoreHierNodeTargets.targetableNodesExist;
        vm.rootTargetNode = scoreHierNodeTargets.rootTargetNode;

        var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
        vm.references = $rootScope.referenceData;
        var fullDateFormat = vm.references.DATE_FORMT_CD.refItems.filter(function(refData) {
            return (refData.cd === prefDateFormat);
        });
        var dateFormat = fullDateFormat[0].nm;
        vm.dateFormat = dateFormat;
        vm.datePlaceholder = dateFormat;
        vm.dateMask = dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

        //datepicker options
        $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
        $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = vm.dateFormat.toLowerCase();
        $.fn.datepicker.defaults.todayHighlight = true;
        $.fn.datepicker.defaults.autoclose = true; //close the datepicker immediately when a date is selected
        $.fn.datepicker.defaults.showOnFocus = false; //show the datepicker when the input field associated with it receives focus

        var maxColor = 40; // max no of color codes defined in variable.less file
        var idxColor;
        var subjId = $rootScope.subject.subjId;
        vm.subjPerms = $rootScope.subject.myUserPermsns;
        vm.scoreTypeCd = null;
        if (subjGrpScore.status === 403) {
            subjGrpScore = null;
        } else {
            vm.scoreTypeCd = subjGrpScore.scoreTypeCd;
            vm.scoreTypeName = subjGrpScore.scoreTypeName;
            vm.scoreTypeDesc = subjGrpScore.scoreTypeDesc;
        }

        $rootScope.breadcrumb = vm.scoreTypeName ? vm.scoreTypeName : null;

        $timeout(function() {
            if (window.localStorage.getItem('scoreCurrentTab')) {
                vm.activeTab = parseInt(window.localStorage.getItem('scoreCurrentTab'), 10);
                window.localStorage.removeItem('scoreCurrentTab');
            } else if (vm.subjPerms && vm.subjPerms.indexOf('VIEW_WGTD_SCORE_BREAKDN') !== -1) {
                vm.activeTab = 1;
            } else if (vm.subjPerms && vm.subjPerms.indexOf('VIEW_SCORE_COMP') !== -1) {
                vm.activeTab = 2;
            } else if (vm.subjPerms && vm.subjPerms.indexOf('UPDT_SCORE_TARGS') !== -1 && vm.targetableNodesExist) {
                vm.activeTab = 3;
            } else if (vm.subjPerms && vm.subjPerms.indexOf('VIEW_SCORE_HIST') !== -1 && vm.history.subjScores.length > 1) {
                vm.activeTab = 4;
            }
        });

        function addColor(nodes) {
            angular.forEach(nodes, function(node) {
                var cls = 'chart-bg-color-' + idxColor++;
                var dottedCls = '.' + cls;
                var prnt = $('body');
                $(prnt).append('<span class=' + cls + '>&nbsp</span>');
                var el = $(dottedCls)[0];
                var color = $(el).css('background-color');
                if (idxColor > maxColor) {
                    idxColor = 1;
                }
                $(el).remove();
                if (node) {
                    node.seriesColor = color;
                }
            });
            angular.forEach(nodes, function(node) {
                if (node) {
                    addColor(node.children);
                }
            });
        }

        function addScoreDesc(nodes) {
            angular.forEach(nodes, function(node) {
                var scoreLabel;
                if (node.hasOwnProperty('scoreVal')) {
                    var scoreDesc = {};
                    scoreLabel = $translate.instant('score.home.scorePUScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.scoreVal, node.scoreValDpCnt);
                    scoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.tier, scoreDesc);
                    node.scoreDesc = scoreDesc;
                }
                if (node.hasOwnProperty('target')) {
                    var targetScoreDesc = {};
                    scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.target.val, node.scoreValDpCnt);
                    targetScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.target.tier, targetScoreDesc);
                    node.target.scoreDesc = targetScoreDesc;
                }
                if (node.hasOwnProperty('prevTarget')) {
                    var prevTargetScoreDesc = {};
                    scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.prevTarget.targetScoreVal, node.scoreValDpCnt);
                    prevTargetScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.prevTarget.targetScoreTier, prevTargetScoreDesc, node.scoreValDpCnt);
                    node.prevTarget.scoreDesc = prevTargetScoreDesc;
                }
                if (node.hasOwnProperty('nextTarget')) {
                    var nextTargetScoreDesc = {};
                    if (node.nextTarget.targetScoreVal !== undefined) {
                        scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                        scoreLabel += ': ' + $filter('number')(node.nextTarget.targetScoreVal, node.scoreValDpCnt);
                        nextTargetScoreDesc.scoreLabel = scoreLabel;
                        createScoreDesc(node, node.nextTarget.targetScoreTier, nextTargetScoreDesc);
                        node.nextTarget.scoreDesc = nextTargetScoreDesc;
                    } else if (node.nextTarget.val !== undefined) {
                        scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                        scoreLabel += ': ' + $filter('number')(node.nextTarget.val, node.scoreValDpCnt);
                        nextTargetScoreDesc.scoreLabel = scoreLabel;
                        createScoreDesc(node, node.nextTarget.tier, nextTargetScoreDesc);
                        node.nextTarget.scoreDesc = nextTargetScoreDesc;
                    }
                }
                if (node.hasOwnProperty('lastTarget')) {
                    var lastTargetScoreDesc = {};
                    scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.lastTarget.val, node.scoreValDpCnt);
                    lastTargetScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.lastTarget.tier, lastTargetScoreDesc);
                    node.lastTarget.scoreDesc = lastTargetScoreDesc;
                }
                if (node.hasOwnProperty('peerGrps')) {
                    angular.forEach(node.peerGrps, function(peerGrp) {
                        var peerGrpScoreDesc = {};
                        scoreLabel = peerGrp.peerGrpName.replace('\'', '&apos;');
                        scoreLabel += ': ' + $filter('number')(peerGrp.val, node.scoreValDpCnt);
                        peerGrpScoreDesc.scoreLabel = scoreLabel;
                        createScoreDesc(node, peerGrp.tier, peerGrpScoreDesc);
                        peerGrp.scoreDesc = peerGrpScoreDesc;
                    });
                }
                addScoreDesc(node.children);
            });
        }

        function createScoreDesc(node, tier, scoreDesc) {
            scoreDesc.nodeName = node.scoreHierNodeName;
            if (tier) {
                scoreDesc.tierRange = $translate.instant('score.home.scorePUTierRangeLabel')
                    + ': ' + $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt);
                scoreDesc.tierDesc = $translate.instant('score.home.scorePUTierDescLabel') + ': ' + tier.tierDesc;
            }
        }

        if (subjGrpScore) {
            addScoreDesc(subjGrpScore.subjScores);
        }

        function addCategories(children) {
            angular.forEach(children, function(child) {
                if (child) {
                    child.category = child.scoreHierNodeName;
                    if (child.children) {
                        addCategories(child.children);
                    }
                }
            });
        }

        if (subjGrpScore && subjGrpScore.subjScores) {
            vm.currSubjScore = $filter('filter')(subjGrpScore.subjScores, {
                subjId: subjId
            }, true)[0];
        } else {
            vm.currSubjScore = null;
        }

        function getNode(scoreHierNodeId, nodes) {
            if (nodes && scoreHierNodeId) {
                var retNode;
                for (var i = 0; i < nodes.length; i++) {
                    var node = nodes[i];
                    if (node.scoreHierNodeId === scoreHierNodeId) {
                        return node;
                    } else if (node.children && node.children.length > 0) {
                        retNode = getNode(scoreHierNodeId, node.children);
                        if (retNode) {
                            return retNode;
                        }
                    }
                }
            }
        }

        vm.getChildren = function(nodes, parentScoreHierNodeId) {
            var chartData = [];
            angular.forEach(nodes, function(node) {
                if (node.parentScoreHierNodeId === parentScoreHierNodeId) {
                    chartData.push(node);
                }
                if (node.children && node.children.length > 0) {
                    var chartChildrenData = vm.getChildren(node.children, parentScoreHierNodeId);
                    if (chartChildrenData.length > 0) {
                        chartData = chartData.concat(chartChildrenData);
                    }
                }
            });
            return chartData;
        };

        vm.calcTotalScoreWgtVal = function(children) {
            var totalScoreWgtVal = 0;
            angular.forEach(children, function(child) {
                if (child) {
                    totalScoreWgtVal += child.scoreWgtVal;
                }
            });
            return totalScoreWgtVal;
        };

        vm.chartTitle = function(scoreHierNodeId) {
            if (!scoreHierNodeId) {
                return vm.currSubjScore.scoreHierNodeName;
            }
            var chartTitle;
            var node = getNode(scoreHierNodeId, subjGrpScore.subjScores);
            if (node) {
                chartTitle = $translate.instant('score.home.wgtdScoreBreakdn.chartDesc', {
                    scoreHierNodeName: node.scoreHierNodeName, scoreHierLvlName: node.children[0].scoreHierLvlName
                });
            }
            return chartTitle;
        };

        vm.keyTitle = function(scoreHierLvlName) {
            return $translate.instant('score.scoreType.keyTitle', {
                scoreHierLvlName: scoreHierLvlName
            });
        };

        vm.scoreBadgePopoverDesc = function(scoreHierNodeId) {
            if (!scoreHierNodeId) {
                return vm.currSubjScore.scoreDesc;
            }
            var node = getNode(scoreHierNodeId, [vm.currSubjScore]);
            if (node) {
                return node.scoreDesc;
            }
        };

        vm.scoreBadgePopoverPct = function(scoreHierNodeId) {
            if (!scoreHierNodeId) {
                return vm.currSubjScore.scoreVal / vm.currSubjScore.maxNodeScoreVal;
            }
            var node = getNode(scoreHierNodeId, [vm.currSubjScore]);
            if (node) {
                return node.scoreVal / node.maxNodeScoreVal;
            }
        };

        vm.scoreBadgeVal = function(scoreHierNodeId) {
            if (!scoreHierNodeId) {
                return $filter('number')(vm.currSubjScore.scoreVal, vm.currSubjScore.scoreValDpCnt);
            }
            var node = getNode(scoreHierNodeId, [vm.currSubjScore]);
            if (node) {
                return $filter('number')(node.scoreVal, node.scoreValDpCnt);
            }
        };

        /*-----------------------------------------------------*/
        ////   Current Subject Aster Chart Data Prep Start   ////
        /*-----------------------------------------------------*/

        if (vm.currSubjScore) {
            idxColor = 2; // Reset color index (#1 is for top level node which is not plotted in aster chart)
            var asterSubjCategories = [];
            asterSubjCategories = angular.copy(vm.currSubjScore.children);
            addColor(asterSubjCategories);
            addAsterChartFields(asterSubjCategories, vm.calcTotalScoreWgtVal(asterSubjCategories));
            addCategories(asterSubjCategories);

            function addAsterChartFields(children, totalScoreWgtVal) {
                angular.forEach(children, function(child) {
                    if (child) {
                        var scoreDesc = child.scoreDesc;
                        var scoreLabel = scoreDesc.scoreLabel;
                        var tierRange = scoreDesc.tierRange ? (scoreDesc.tierRange + '<br>') : '';
                        var tierDesc = scoreDesc.tierDesc ? scoreDesc.tierDesc : '';

                        child.scoreWeight = child.scoreWgtVal / totalScoreWgtVal;
                        child.weightedScore = child.scoreWeight * child.scoreVal;
                        if (isNaN(child.scoreWgtVal)) {
                            child.scoreWgtVal = 1;
                            child.scoreWeight = 1;
                            child.weightedScore = child.scoreWeight * child.scoreVal;
                        }
                        var weightLabel = $translate.instant('score.home.scorePUWgtLabel');
                        weightLabel += ': ' + (child.scoreWeight * 100).toFixed(1);
                        child.tip =
                            '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                            '<div class="arrow"></div>' +
                            '<div class="popover-inner" > ' +
                            '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                            '</div>' +

                            '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' +
                            scoreLabel + ',&nbsp;&nbsp;' + weightLabel + '% <br>' +
                            tierRange +
                            tierDesc +
                            '</div>' +
                            '</div>' +
                            '</div>';
                        if (child.children) {
                            addAsterChartFields(child.children, vm.calcTotalScoreWgtVal(child.children));
                        }
                    }
                });
            }

            vm.currSubjHierNodeId;
            vm.currSubjChartConfig = {
                chartEl: '#asterChart',
                width: 550,
                height: 400,
                fixedWidth: true,
                fixedHieght: true,
                marginTop: 5,
                marginBottom: 40,
                marginLeft: 40,
                marginRight: 10,
                deriveMaxVal: false,
                redrawTriggerEl: '#current-score-tab',
                drawTargetBars: true,
                orientation: 'aster',
                type: 'grouped',
                enableDrill: true,
                keysEl: '#aster-chart-keys'
            };

            vm.currSubjChartMaxVal = function(scoreHierNodeId) {
                var maxVal = 0;
                var nodes = (!scoreHierNodeId) ? asterSubjCategories : vm.getChildren(asterSubjCategories, scoreHierNodeId);
                if (nodes && nodes.length > 0) {
                    maxVal = nodes[0].maxNodeScoreVal;
                }
                return maxVal;
            };

            vm.currSubjChartData = function(scoreHierNodeId) {
                var chartSeries = [];
                var nodes = (!scoreHierNodeId) ? asterSubjCategories : vm.getChildren(asterSubjCategories, scoreHierNodeId);
                angular.forEach(nodes, function(node) {
                    chartSeries.push({
                        seriesTitle: node.category,
                        weight: node.scoreWgtVal,
                        value: node.scoreVal,
                        tip: node.tip,
                        color: node.seriesColor,
                        scoreHierNodeId: node.scoreHierNodeId,
                        hasChildren: (node.children.length) ? true : false
                    });
                });
                return {
                    series: chartSeries
                };
            };

            vm.asterChartKeyData = asterSubjCategories;
        }

        /*-----------------------------------------------------*/
        ////       Score History Chart Data Prep Start       ////
        /*-----------------------------------------------------*/

        if (subjGrpScore && vm.subjPerms && vm.subjPerms.indexOf('VIEW_SCORE_HIST') !== -1) {
            vm.history = angular.copy(subjGrpScore);
            //sort history nodes by subject effective date
            if (vm.history && vm.history.subjScores) {
                vm.history.subjScores.sort(function(a, b) {
                    return new Date(a.subjEffDate) - new Date(b.subjEffDate);
                });
            }

            function addHistoryChartCategories(children) {
                angular.forEach(children, function(child) {
                    child.category = $filter('shortDateFormat')(child.subjEffDate);
                    if (child.children) {
                        addHistoryChartCategories(child.children);
                    }
                });
            }

            function addHistoryChartFields(children) {
                angular.forEach(children, function(child) {
                    var scoreDesc = child.scoreDesc;
                    var scoreLabel = scoreDesc.scoreLabel;
                    var tierRange = scoreDesc.tierRange ? (scoreDesc.tierRange + '<br>') : '';
                    var tierDesc = scoreDesc.tierDesc ? scoreDesc.tierDesc : '';
                    child.scoreWeight = child.scoreWgtVal / vm.calcTotalScoreWgtVal(children);
                    child.weightedScore = child.scoreWeight * child.scoreVal;
                    var weightLabel = $translate.instant('score.home.scorePUWgtLabel');
                    weightLabel += ': ' + (child.scoreWeight * 100).toFixed(1);
                    child.tip =
                        '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                        '<div class="arrow"></div>' +
                        '<div class="popover-inner" > ' +
                        '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                            '</div>' +
                        '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' +
                        scoreLabel + ',&nbsp;&nbsp;' + weightLabel + '%<br>' +
                        tierRange +
                        tierDesc +
                        '</div>' +
                        '</div>' +
                        '</div>';
                    if (child.children) {
                        addHistoryChartFields(child.children);
                    }
                });
            }

            angular.forEach(vm.history.subjScores, function(subjScore) {
                idxColor = 1;
                addHistoryChartCategories([subjScore]);
                addColor([subjScore]);
                addHistoryChartFields([subjScore]);
            });

            vm.historyChartConfig = function(historyChartHierNodeId) {
                var maxVal = 0;
                var children = [];
                if (!historyChartHierNodeId) {
                    children = vm.history.subjScores;
                } else {
                    angular.forEach(vm.history.subjScores, function(node) {
                        var childNodes = vm.getChildren(node.children, historyChartHierNodeId);
                        if (childNodes.length > 0) {
                            children = children.concat(childNodes);
                        }
                    });
                }
                if (children && children.length > 0) {
                    maxVal = children[0].maxNodeScoreVal;
                }
                return {
                    width: 550,
                    height: 400,
                    fixedWidth: true,
                    fixedHeight: true,
                    padding: {
                        top: 15,
                        bottom: 0,
                        left: 0,
                        right: 0
                    },
                    catgAxisLabel: $translate.instant('score.home.scoreHist.xAxisLabel'),
                    valueAxisLabel: $translate.instant('score.home.scoreHist.yAxisLabel'),
                    valueAxisMaxVal: maxVal,
                    orientation: 'vertical',
                    seriesLayout: 'stacked',
                    valueScaleTicksNum: 10,
                    showGridlines: true,
                    showLegend: false,
                    enableClick: true
                };
            };

            vm.setHistoryChartHierNodeIdFromChart = function(series) {
                if (series.hasChildren) {
                    $scope.$apply(function() {
                        vm.historyChartHierNodeId = series.scoreHierNodeId;
                    });
                }
            };

            vm.setHistoryChartHierNodeIdFromKey = function(hierNodeId) {
                $scope.$apply(function() {
                    vm.historyChartHierNodeId = hierNodeId;
                });
            };

            vm.historyChartHierNodeId = null;
            vm.historyChartData = function(historyChartHierNodeId) {
                var chartSeries = [];
                var children = [];
                if (!historyChartHierNodeId) {
                    children = vm.history.subjScores;
                } else {
                    angular.forEach(vm.history.subjScores, function(node) {
                        var childNodes = vm.getChildren(node.children, historyChartHierNodeId);
                        if (childNodes.length > 0) {
                            children = children.concat(childNodes);
                        }
                    });
                }

                angular.forEach(children, function(child) {
                    var series = $filter('filter')(chartSeries, { seriesTitle: child.scoreHierNodeName }, true)[0];
                    if (!series) {
                        series = {
                            seriesTitle: child.scoreHierNodeName,
                            seriesDesc: child.scoreHierNodeDesc,
                            seriesColor: child.seriesColor,
                            scoreHierNodeId: child.scoreHierNodeId,
                            hasChildren: (child.children.length) ? true : false,
                            elements: []
                        };
                        chartSeries.push(series);
                    }
                    series.elements.push({
                        category: child.category,
                        value: child.weightedScore,
                        tip: child.tip
                    });
                });
                return {
                    series: chartSeries
                };
            };
            vm.historyChartKeyData = [vm.history.subjScores[0]];
        }

        /*-----------------------------------------------------*/
        ////     Score Comparison Chart Data Prep Start      ////
        /*-----------------------------------------------------*/
        if (vm.currSubjScore && vm.subjPerms && vm.subjPerms.indexOf('VIEW_SCORE_COMP') !== -1) {
            vm.peerGroups = [];
            if (vm.currSubjScore && vm.currSubjScore.peerGrps) {
                vm.currSubjScore.peerGrps.forEach(function(peerGrp) {
                    vm.peerGroups.push(peerGrp);
                });
            }

            //get peergrp and target colours
            var peerGrpCls = 'compare-to-peergrp';
            var peerGrpDottedCls = '.' + peerGrpCls;
            var peerGrpPrnt = $('body');
            $(peerGrpPrnt).append('<div class=' + peerGrpCls + '>&nbsp</span>');
            var peerGrpEl = $(peerGrpDottedCls)[0];
            var peerGrpColor = $(peerGrpEl).css('border-left-color');

            var targCls = 'compare-to-target';
            var targDottedCls = '.' + targCls;
            var targPrnt = $('body');
            $(targPrnt).append('<div class=' + targCls + '>&nbsp</span>');
            var targEl = $(targDottedCls)[0];
            var targColor = $(targEl).css('border-left-color');

            if (vm.peerGroups.length) {
                vm.peerGroups.sort(function(a, b) {
                    return a.peerGrpId - b.peerGrpId;
                });
                vm.selectedPeerGrp = vm.peerGroups[0];
            }

            var scScoreHierNodes = [];

            function loadScChartData() {
                idxColor = 1; // Reset color index
                scScoreHierNodes = [angular.copy(vm.currSubjScore)];
                addColor(scScoreHierNodes);
                addScSubjChartFields(scScoreHierNodes);
                addCategories(scScoreHierNodes);
            }
            loadScChartData();

            function addScSubjChartFields(children) {
                angular.forEach(children, function(child) {
                    var scoreDesc = child.scoreDesc;
                    var scoreLabel = scoreDesc.scoreLabel;
                    var tierRange = scoreDesc.tierRange ? (scoreDesc.tierRange + '<br>') : '';
                    var tierDesc = scoreDesc.tierDesc ? scoreDesc.tierDesc : '';
                    child.tip =
                        '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                        '<div class="arrow"></div>' +
                        '<div class="popover-inner" > ' +
                        '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                        '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                        '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                        '</div>' +
                        '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + scoreLabel + '<br>' +
                        tierRange +
                        tierDesc +
                        ' </div>' +
                        '</div>' +
                        '</div>';
                    if (child.target && child.target.scoreDesc) {
                        var targScoreDesc = child.target.scoreDesc;
                        var targScoreLabel = targScoreDesc.scoreLabel;
                        var targTierRange = targScoreDesc.tierRange ? (targScoreDesc.tierRange + '<br>') : '';
                        var targTierDesc = targScoreDesc.tierDesc ? targScoreDesc.tierDesc : '';
                        child.target.tip =
                            '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                            '<div class="arrow"></div>' +
                            '<div class="popover-inner" > ' +
                            '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                            '</div>' +
                            '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + targScoreLabel + '<br>' +
                            targTierRange +
                            targTierDesc +
                            ' </div>' +
                            '</div>' +
                            '</div>';
                    }
                    if (child.nextTarget && child.nextTarget.scoreDesc) {
                        var nextTargScoreDesc = child.nextTarget.scoreDesc;
                        var nextTargScoreLabel = nextTargScoreDesc.scoreLabel;
                        var nextTargTierRange = nextTargScoreDesc.tierRange ? (nextTargScoreDesc.tierRange + '<br>') : '';
                        var nextTargTierDesc = nextTargScoreDesc.tierDesc ? nextTargScoreDesc.tierDesc : '';
                        child.nextTarget.tip =
                            '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                            '<div class="arrow"></div>' +
                            '<div class="popover-inner" > ' +
                            '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                            '</div>' +
                            '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + nextTargScoreLabel + '<br>' +
                            nextTargTierRange +
                            nextTargTierDesc +
                            ' </div>' +
                            '</div>' +
                            '</div>';
                    }
                    if (child.lastTarget && child.lastTarget.scoreDesc) {
                        var lastTargScoreDesc = child.lastTarget.scoreDesc;
                        var lastTargScoreLabel = lastTargScoreDesc.scoreLabel;
                        var lastTargTierRange = lastTargScoreDesc.tierRange ? (lastTargScoreDesc.tierRange + '<br>') : '';
                        var lastTargTierDesc = lastTargScoreDesc.tierDesc ? lastTargScoreDesc.tierDesc : '';
                        child.lastTarget.tip =
                            '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                            '<div class="arrow"></div>' +
                            '<div class="popover-inner" > ' +
                            '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                            '</div>' +
                            '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + lastTargScoreLabel + '<br>' +
                            lastTargTierRange +
                            lastTargTierDesc +
                            ' </div>' +
                            '</div>' +
                            '</div>';
                    }
                    if (child.peerGrps) {
                        angular.forEach(child.peerGrps, function(peerGrp) {
                            if (peerGrp.scoreDesc) {
                                var peerGrpScoreDesc = peerGrp.scoreDesc;
                                var peerGrpScoreLabel = peerGrpScoreDesc.scoreLabel;
                                var peerGrpTierRange = peerGrpScoreDesc.tierRange ? (peerGrpScoreDesc.tierRange + '<br>') : '';
                                var peerGrpTierDesc = peerGrpScoreDesc.tierDesc ? peerGrpScoreDesc.tierDesc : '';
                                peerGrp.tip =
                                    '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                                    '<div class="arrow"></div>' +
                                    '<div class="popover-inner" > ' +
                                    '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                                    '<div class="color-box" style="background-color:' + child.seriesColor + '"></div>' +
                                    '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + child.scoreHierNodeName + '</h3></div>' +
                                    '</div>' +
                                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + peerGrpScoreLabel + '<br>' +
                                    peerGrpTierRange +
                                    peerGrpTierDesc +
                                    ' </div>' +
                                    '</div>' +
                                    '</div>';
                            }
                        });
                    }
                    if (child.children) {
                        addScSubjChartFields(child.children);
                    }
                });
            }

            vm.scChartConfig = function(scHierNodeId) {
                var maxVal = 0;
                var nodes = (!scHierNodeId) ? scScoreHierNodes : vm.getChildren(scScoreHierNodes, scHierNodeId);
                if (nodes && nodes.length > 0) {
                    maxVal = nodes[0].maxNodeScoreVal;
                }
                return {
                    width: 550,
                    height: 400,
                    fixedWidth: true,
                    fixedHeight: true,
                    padding: {
                        top: 15,
                        bottom: 0,
                        left: 0,
                        right: 0
                    },
                    valueAxisLabel: $translate.instant('score.home.scoreComp.xAxisLabel'),
                    catgAxisLabel: $translate.instant('score.home.scoreComp.yAxisLabel', {
                        scoreHierLvlName: nodes[0].scoreHierLvlName
                    }),
                    valueAxisMaxVal: maxVal,
                    orientation: 'horizontal',
                    seriesLayout: 'stacked',
                    valueScaleTicksNum: 10,
                    showCatgAxisScaleLabels: false,
                    showGridlines: true,
                    showLegend: false,
                    enableClick: true,
                    minBarSize: 3,
                    markRadius: 4,
                    markStrokeWidth: 1
                };
            };

            vm.scHierNodeId; ///// updated via key click
            vm.setComparisonChartHierNodeIdFromChart = function(series) {
                if (series.hasChildren) {
                    $scope.$apply(function() {
                        vm.scHierNodeId = series.scoreHierNodeId;
                    });
                }
            };

            vm.setComparisonChartHierNodeIdFromKey = function(hierNodeId) {
                $scope.$apply(function() {
                    vm.scHierNodeId = hierNodeId;
                });
            };

            vm.compareToPeerGrp = vm.peerGroups.length !== 0;

            vm.isTargetDisabled = function(scHierNodeId) {
                var isTargetDisabled = true;
                angular.forEach((!scHierNodeId) ? scScoreHierNodes : vm.getChildren(scScoreHierNodes, scHierNodeId), function(node) {
                    if (node && ((!vm.latestTargFlag && (node.target || node.nextTarget)) || (vm.latestTargFlag && node.lastTarget))) {
                        isTargetDisabled = false;
                    }
                });
                return isTargetDisabled;
            };
            vm.isCurrentTargetDisabled = function(scHierNodeId) {
                var isTargetDisabled = true;
                angular.forEach((!scHierNodeId) ? scScoreHierNodes : vm.getChildren(scScoreHierNodes, scHierNodeId), function(node) {
                    if (node && (node.target)) {
                        isTargetDisabled = false;
                    }
                });
                return isTargetDisabled;
            };
            vm.isNextTargetDisabled = function(scHierNodeId) {
                var isTargetDisabled = true;
                angular.forEach((!scHierNodeId) ? scScoreHierNodes : vm.getChildren(scScoreHierNodes, scHierNodeId), function(node) {
                    if (node && (node.nextTarget)) {
                        isTargetDisabled = false;
                    }
                });
                return isTargetDisabled;
            };

            vm.targetsExist = false;
            vm.nextTargetsExist = false;
            function findTargets(nodes) {
                angular.forEach(nodes, function(node) {
                    if (node.target) {
                        vm.targetsExist = true;
                    }
                    if (node.nextTarget) {
                        vm.nextTargetsExist = true;
                    }
                    if ((!vm.targetsExist || !vm.nextTargetsExist) && node.children && node.children.length) {
                        findTargets(node.children);
                    }
                });
            }
            findTargets(scScoreHierNodes);

            vm.targetType = (vm.targetsExist ? 'current' : (vm.nextTargetsExist ? 'next' : null));
            vm.compareToTarget = vm.targetsExist || vm.nextTargetsExist;

            vm.scData = function(scHierNodeId) {
                var chartSeries = [];
                var nodes = (!scHierNodeId) ? scScoreHierNodes : vm.getChildren(scScoreHierNodes, scHierNodeId);

                angular.forEach(nodes, function(node) {
                    var series = {
                        seriesTitle: node.scoreHierNodeName,
                        seriesColor: node.seriesColor,
                        baseTip: node.tip,
                        scoreHierNodeId: node.scoreHierNodeId,
                        hasChildren: (node.children.length) ? true : false,
                        elements: []
                    };

                    var element = {
                        category: node.category,
                        value: node.scoreVal,
                        tip: node.tip,
                        marks: []
                    };

                    //add marks and calculate if overlay is needed
                    var maxMarksVal = 0;
                    if (vm.compareToPeerGrp) {
                        var peerGrp = $filter('filter')(node.peerGrps, {
                            peerGrpId: vm.selectedPeerGrp.peerGrpId
                        }, true)[0];
                        element.marks.push({
                            value: (peerGrp.val) ? peerGrp.val : 0,
                            color: peerGrpColor,
                            tip: peerGrp.tip
                        });
                        maxMarksVal = (peerGrp.val) ? peerGrp.val : 0;
                    }
                    if (vm.compareToTarget) {
                        if (!vm.latestTargFlag && vm.targetType === 'current' && node.target) {
                            element.marks.push({
                                value: node.target.val,
                                color: targColor,
                                tip: node.target.tip
                            });
                            maxMarksVal = Math.max(maxMarksVal, node.target.val);
                        } else if (!vm.latestTargFlag && vm.targetType === 'next' && node.nextTarget) {
                            element.marks.push({
                                value: node.nextTarget.val,
                                color: targColor,
                                tip: node.nextTarget.tip
                            });
                            maxMarksVal = Math.max(maxMarksVal, node.nextTarget.val);
                        } else if (vm.latestTargFlag && node.lastTarget) {
                            element.marks.push({
                                value: node.lastTarget.val,
                                color: targColor,
                                tip: node.lastTarget.tip
                            });
                            maxMarksVal = Math.max(maxMarksVal, node.lastTarget.val);
                        }
                    }
                    if (maxMarksVal > node.scoreVal) {
                        series.overlayPattern = 'diagonalHatch';
                        series.overlayColor = node.seriesColor;
                        element.overlayValueMin = node.scoreVal;
                        element.overlayValueMax = maxMarksVal;
                        element.overlayTip = node.tip;
                    }
                    series.elements.push(element);
                    chartSeries.push(series);
                });
                return {
                    series: chartSeries
                };
            };

            vm.scChartKeyData = scScoreHierNodes;

            vm.reloadScChartData = function() {
                ScoreService.getSubjGrpScore({
                    scoreType: vm.scoreTypeCd,
                    subjId: subjId
                }).$promise.then(function(data) {
                    vm.currSubjScore = $filter('filter')(data.subjScores, {
                        subjId: subjId
                    }, true)[0];
                    addScoreDesc([vm.currSubjScore]);
                    loadScChartData();
                    vm.isTargetsExist = false;
                    findTargets(scTargCategories);
                }, function() {
                });
            };
        }

        /*-----------------------------------------------------*/
        ////     Score Targets Data Table Start      ////
        /*-----------------------------------------------------*/

        if (vm.subjPerms && vm.subjPerms.indexOf('UPDT_SCORE_TARGS') !== -1) {

            var targetsCopied = flwupSubj !== undefined && flwupSubj.subjId !== undefined;

            var allNodes = [];
            if (scoreHierNodeTargets.rootTargetNode) {
                enrichAndCollectNodes(scoreHierNodeTargets.rootTargetNode);
            }

            vm.rowNodes = [];
            var leftIndent = 15;
            if (allNodes && allNodes.length > 0) {
                buildHierNodeTree(allNodes[0], leftIndent);
            }
            var rowNodesCopy = angular.copy(vm.rowNodes);

            function enrichAndCollectNodes(node) {
                addScoreDescription(vm.rootTargetNode);
                node.targetScorePct = node.targetScoreVal / node.maxNodeScoreVal * 100;
                node.currentScorePct = node.currentScoreVal / node.maxNodeScoreVal * 100;
                node.nextTargetScorePct = node.nextTargetScoreVal / node.maxNodeScoreVal * 100;
                allNodes.push(node);
                if (node.children && node.children.length) {
                    node.children = node.children.sort(function(a, b) {
                        return a.scoreHierNodeId - b.scoreHierNodeId;
                    });
                    angular.forEach(node.children, function(child) {
                        addScoreDescription(child);
                        enrichAndCollectNodes(child);
                    });
                }
            }

            function buildHierNodeTree(hierNode, lvl) {
                hierNode.lvl = lvl;
                hierNode.lvlStyle = lvl + 'px';
                vm.rowNodes.push(hierNode);
                if (hierNode.children && hierNode.children.length > 0) {
                    for (var i = 0, len = hierNode.children.length; i < len; i++) {
                        buildHierNodeTree(hierNode.children[i], lvl + leftIndent);
                    }
                } else {
                    var d = lvl + 12;
                    hierNode.lvlStyle = d + 'px';
                }
            }

            function addScoreDescription(node) {
                if (node.hasOwnProperty('currentScoreVal')) {
                    var currentScoreDesc = {};
                    currentScoreDesc.scoreLabel = $translate.instant('score.home.scorePUCurrScoreLabel').replace('\'', '&apos;')
                        + ': ' + $filter('number')(node.currentScoreVal, node.scoreValDpCnt);
                    createScoreDesc(node, node.currentScoreTier, currentScoreDesc);
                    node.currentScoreDesc = currentScoreDesc;
                }
                if (node.hasOwnProperty('targetScoreVal')) {
                    var targetScoreDesc = {};
                    targetScoreDesc.scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;')
                        + ': ' + $filter('number')(node.targetScoreVal, node.scoreValDpCnt);
                    createScoreDesc(node, node.targetScoreTier, targetScoreDesc);
                    node.targetScoreDesc = targetScoreDesc;
                }
                if (node.hasOwnProperty('nextTargetScoreVal')) {
                    var nextTargetScoreDesc = {};
                    nextTargetScoreDesc.scoreLabel = $translate.instant('score.home.scoreTarg.nextTargScoreHeader').replace('\'', '&apos;')
                        + ': ' + $filter('number')(node.nextTargetScoreVal, node.scoreValDpCnt);
                    createScoreDesc(node, getTier(node.nextTargetScoreVal, node.tiers), nextTargetScoreDesc);
                    node.nextTargetScoreDesc = nextTargetScoreDesc;
                }
            }

            function getTier(scoreVal, tiers) {
                var tier;
                angular.forEach(tiers, function(t) {
                    if ((t.minRange < scoreVal || (t.minScoreInclsvFlag && t.minRange === parseFloat(scoreVal))) && (t.maxRange > scoreVal || (t.maxScoreInclsvFlag && t.maxRange === parseFloat(scoreVal)))) {
                        tier = t;
                    }
                });
                return tier;
            }

            vm.collapse = function(scoreHierNode, clickedNode) {
                if (clickedNode === false) {
                    $('#' + scoreHierNode.scoreHierNodeId).hide();
                } else {
                    $('#down-' + scoreHierNode.scoreHierNodeId).hide();
                    $('#up-' + scoreHierNode.scoreHierNodeId).show();
                }
                if (scoreHierNode.children && scoreHierNode.children.length > 0) {
                    for (var i = 0, len = scoreHierNode.children.length; i < len; i++) {
                        vm.collapse(scoreHierNode.children[i], false);
                    }
                }
            };

            vm.expand = function(scoreHierNode) {
                $('#up-' + scoreHierNode.scoreHierNodeId).hide();
                $('#down-' + scoreHierNode.scoreHierNodeId).show();
                if (scoreHierNode.children && scoreHierNode.children.length > 0) {
                    for (var i = 0, len = scoreHierNode.children.length; i < len; i++) {
                        expandNode(scoreHierNode.children[i]);
                    }
                }
            };

            function expandNode(scoreHierNode) {
                $('#' + scoreHierNode.scoreHierNodeId).show();
                $('#down-' + scoreHierNode.scoreHierNodeId).hide();
                if (scoreHierNode.children && scoreHierNode.children.length > 0) {
                    $('#up-' + scoreHierNode.scoreHierNodeId).show();
                }
            }

            vm.hasSubjDataCloneDecsnFlag = sysParms.data.SUBJ_DATA_CLONE_END_USR_DECSN_FLAG && sysParms.data.SUBJ_DATA_CLONE_END_USR_DECSN_FLAG.toLowerCase() === 'true' && scoreHierNodeTargets.currSubjClonableSubjElemsFlag;
            vm.subjEffDate = moment($rootScope.subject.subjEffDate, 'YYYY-MM-DD').format(vm.dateFormat);
            vm.flwupSubjEffDate = null;
            var flwupSubjEffDateCopy = null;
            vm.flwupSubjExists = true;
            vm.subjDataCloneFlag = !vm.hasSubjDataCloneDecsnFlag;

            $timeout(function() {
                if (flwupSubj && flwupSubj.subjId) {
                    vm.flwupSubj = flwupSubj;
                    vm.flwupSubjEffDate = moment(flwupSubj.subjEffDate, 'YYYY-MM-DD').format(dateFormat);
                } else {
                    vm.flwupSubjEffDate = null;
                    vm.flwupSubjExists = false;
                }
                flwupSubjEffDateCopy = angular.copy(vm.flwupSubjEffDate);
                $('#flwupSubjEffDate').focus();
            });

            vm.validateDate = function(dateInput) {
                var isDateValid = moment(dateInput, dateFormat, true).isValid();
                if (isDateValid) {
                    vm.subject.subjEffDate = moment(dateInput, dateFormat).format('YYYY-MM-DD');
                    return true;
                }
                return false;
            };

            $scope.$watch('vm.flwupSubjEffDate', function(newVal) {
                if (!targetsCopied && newVal) {
                    targetsCopied = true;
                    angular.forEach(vm.rowNodes, function(node) {
                        node.nextTargetScoreVal = node.targetScoreVal;
                    });
                }
            });

            vm.updateNextTargetScoreVal = function(node) {
                if (node.nextTargetScoreVal || node.nextTargetScoreVal === '0') {
                    node.nextTargetScoreVal = parseFloat(node.nextTargetScoreVal);
                    node.nextTargetScorePct = node.nextTargetScoreVal / node.maxNodeScoreVal * 100;
                    addScoreDescription(node);
                } else {
                    delete node.nextTargetScoreVal;
                    delete node.nextTargetScoreDesc;
                    delete node.nextTargetScorePct;
                }
            };

            vm.maxNextTargetScoreVal = function(node) {
                var scoreHierLvl = $filter('filter')(scoreHierLevels, {
                    scoreHierLvlId: node.scoreHierLvlId
                }, true)[0];
                if (scoreHierLvl) {
                    return scoreHierLvl.maxNodeScoreVal;
                }
                return null;
            };

            vm.saveBtnDisabled = function(scoreTargetForm) {
                return !(vm.flwupSubjEffDate && scoreTargetForm && scoreTargetForm.$dirty && scoreTargetForm.$valid);
            };

            vm.resetPage = function () {
                vm.flwupSubjEffDate = angular.copy(flwupSubjEffDateCopy);
                vm.rowNodes = angular.copy(rowNodesCopy);
            };

            vm.saveScoreTargets = function(form) {
                vm.savingScoreHierNodeTargets = true;
                if ($.isEmptyObject(form.$error) && vm.flwupSubjEffDate) {
                    var data = {
                        currSubjId: $rootScope.subject.subjId,
                        addFlwupSubj: !vm.flwupSubjExists,
                        flwupSubjId: (vm.flwupSubjExists) ? vm.flwupSubj.subjId : null,
                        scoreTypeCd: vm.scoreTypeCd,
                        scoreVersSeq: scoreHierNodeTargets.scoreVersSeq,
                        flwupSubjEffDate: moment(vm.flwupSubjEffDate, dateFormat).format('YYYY-MM-DD'),
                        flwupSubjScoreHierNodeTargetVals: getFlwupSubjScoreTargetsVals(),
                        dataCloneFlag: vm.subjDataCloneFlag,
                        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
                    };
                    ScoreService.saveSubjScoreHierNodeTargets(data, function() {//onSuccess
                        vm.flwupSubjExists = true;
                        toastr.success(
                            $translate.instant('score.home.scoreTarg.toast.saveScoreTargsSuccess'),
                            $translate.instant('score.home.scoreTargsTab'),
                            toastr.options
                        );
                        vm.savingScoreHierNodeTargets = false;
                        window.localStorage.setItem('scoreCurrentTab', 3);
                        $state.reload();
                    }, function() {//onError
                        vm.savingScoreHierNodeTargets = false;
                        toastr.error(
                            $translate.instant('score.home.scoreTarg.toast.updtScoreTargsError'),
                            $translate.instant('score.home.scoreTargsTab'),
                            toastr.options
                        );
                    });
                } else {
                    vm.savingScoreHierNodeTargets = false;
                }
            };

            function getFlwupSubjScoreTargetsVals() {
                var flwupSubjScoreTargets = {};
                angular.forEach(vm.rowNodes, function(node) {
                    flwupSubjScoreTargets[node.scoreHierNodeId] = node.nextTargetScoreVal;
                });
                return flwupSubjScoreTargets;
            }
        }
    }

})();
/* Copyright (c) 2010-2012 Marcus Westin */
(function(){function o(){try{return r in t&&t[r]}catch(e){return!1}}var e={},t=window,n=t.document,r="localStorage",i="__storejs__",s;e.disabled=!1,e.set=function(e,t){},e.get=function(e){},e.remove=function(e){},e.clear=function(){},e.transact=function(t,n,r){var i=e.get(t);r==null&&(r=n,n=null),typeof i=="undefined"&&(i=n||{}),r(i),e.set(t,i)},e.getAll=function(){},e.serialize=function(e){return JSON.stringify(e)},e.deserialize=function(e){if(typeof e!="string")return undefined;try{return JSON.parse(e)}catch(t){return e||undefined}};if(o())s=t[r],e.set=function(t,n){return n===undefined?e.remove(t):(s.setItem(t,e.serialize(n)),n)},e.get=function(t){return e.deserialize(s.getItem(t))},e.remove=function(e){s.removeItem(e)},e.clear=function(){s.clear()},e.getAll=function(){var t={};for(var n=0;n<s.length;++n){var r=s.key(n);t[r]=e.get(r)}return t};else if(n.documentElement.addBehavior){var u,a;try{a=new ActiveXObject("htmlfile"),a.open(),a.write('<script>document.w=window</script><iframe src="/favicon.ico"></frame>'),a.close(),u=a.w.frames[0].document,s=u.createElement("div")}catch(f){s=n.createElement("div"),u=n.body}function l(t){return function(){var n=Array.prototype.slice.call(arguments,0);n.unshift(s),u.appendChild(s),s.addBehavior("#default#userData"),s.load(r);var i=t.apply(e,n);return u.removeChild(s),i}}var c=new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]","g");function h(e){return e.replace(c,"___")}e.set=l(function(t,n,i){return n=h(n),i===undefined?e.remove(n):(t.setAttribute(n,e.serialize(i)),t.save(r),i)}),e.get=l(function(t,n){return n=h(n),e.deserialize(t.getAttribute(n))}),e.remove=l(function(e,t){t=h(t),e.removeAttribute(t),e.save(r)}),e.clear=l(function(e){var t=e.XMLDocument.documentElement.attributes;e.load(r);for(var n=0,i;i=t[n];n++)e.removeAttribute(i.name);e.save(r)}),e.getAll=l(function(t){var n=t.XMLDocument.documentElement.attributes,r={};for(var i=0,s;s=n[i];++i){var o=h(s.name);r[s.name]=e.deserialize(t.getAttribute(o))}return r})}try{e.set(i,i),e.get(i)!=i&&(e.disabled=!0),e.remove(i)}catch(f){e.disabled=!0}e.enabled=!e.disabled,typeof module!="undefined"&&typeof module!="function"?module.exports=e:typeof define=="function"&&define.amd?define(e):this.store=e})();
/**
 * This work is licensed under the Creative Commons Attribution-Share Alike 3.0
 * United States License. To view a copy of this license,
 * visit http://creativecommons.org/licenses/by-sa/3.0/us/ or send a letter
 * to Creative Commons, 171 Second Street, Suite 300, San Francisco, California, 94105, USA.
 *
 * Modified by: Jill Elaine
 * Email: jillelaine01@gmail.com
 *
 * Configurable idle (no activity) timer and logout redirect for jQuery.
 * Works across multiple windows, tabs and iframes from the same domain.
 *
 * Dependencies: JQuery v1.7+, JQuery UI, store.js from https://github.com/marcuswestin/store.js - v1.3.4+
 *
 * Commented and console logged for debugging with Firefox & Firebug or similar
 * version 1.0.10
 **/

/*global jQuery: false, document: false, store: false, clearInterval: false, setInterval: false, setTimeout: false, clearTimeout: false, window: false, alert: false, console: false*/
/*jslint indent: 2, sloppy: true, plusplus: true*/

(function ($) {

  $.fn.idleTimeout = function (userRuntimeConfig) {

    //##############################
    //## Public Configuration Variables
    //##############################
    var defaultConfig = {
      //originalTitle: "",
      redirectUrl: '/logout',      // redirect to this url on logout. Set to "redirectUrl: false" to disable redirect

      // idle settings
      idleTimeLimit: 30,           // 30 seconds for testing. 'No activity' time limit in seconds. 1200 = 20 Minutes
      idleCheckHeartbeat: 2,       // Frequency to check for idle timeouts in seconds

      // optional custom callback to perform before logout
      customCallback: false,       // set to false for no customCallback
      // customCallback:    function () {    // define optional custom js function
          // perform custom action before logout
      // },

      // configure which activity events to detect
      // http://www.quirksmode.org/dom/events/
      // https://developer.mozilla.org/en-US/docs/Web/Reference/Events
      activityEvents: 'click keypress scroll wheel mousewheel', // separate each event with a space

      // warning dialog box configuration
      enableDialog: true,           // set to false for logout without warning dialog
      dialogDisplayLimit: 120,       // 20 seconds for testing. Time to display the warning dialog before logout (and optional callback) in seconds. 180 = 3 Minutes
      dialogTitle: 'Session Expiration Warning', // also displays on browser title bar
      dialogText: 'Because you have been inactive, your session is about to expire.',
      dialogTimeRemaining: 'Time remaining',
      dialogStayLoggedInButton: 'Stay Logged In',
      dialogLogOutNowButton: 'Log Out Now',

      // error message if https://github.com/marcuswestin/store.js not enabled
      errorAlertMessage: 'Please disable "Private Mode", or upgrade to a modern browser. Or perhaps a dependent file missing. Please see: https://github.com/marcuswestin/store.js',

      // server-side session keep-alive timer
      sessionKeepAliveTimer: 600,   // ping the server at this interval in seconds. 600 = 10 Minutes. Set to false to disable pings
      sessionKeepAliveUrl: window.location.href // set URL to ping - does not apply if sessionKeepAliveTimer: false
    },

    //##############################
    //## Private Variables
    //##############################
      currentConfig = $.extend(defaultConfig, userRuntimeConfig), // merge default and user runtime configuration
      origTitle = currentConfig.originalTitle, // save original browser title
      originalTitle,
      storeConfiguration, // public function support, store private configuration variables
      activityDetector,
      startKeepSessionAlive, stopKeepSessionAlive, keepSession, keepAlivePing, // session keep alive
      idleTimer, remainingTimer, checkIdleTimeout, checkIdleTimeoutLoop, startIdleTimer, stopIdleTimer, // idle timer
      openWarningDialog, dialogTimer, checkDialogTimeout, startDialogTimer, stopDialogTimer, isDialogOpen, destroyWarningDialog, countdownDisplay, // warning dialog
      logoutUser,
      checkForIframes, includeIframes, attachEventIframe; // iframes

    //##############################
    //## Public Functions
    //##############################
    // trigger a manual user logout
    // use this code snippet on your site's Logout button: $.fn.idleTimeout().logout();
    this.logout = function () {
      store.set('idleTimerLoggedOut', true);
    };

    // trigger a recheck for iframes
    // use this code snippet after an iframe is inserted into the document: $.fn.idleTimeout().iframeRecheck()
    this.iframeRecheck = function () {
      checkForIframes();
    };

    //##############################
    //## Private Functions
    //##############################
    //----------- PUBLIC FUNCTION SUPPORT --------------//
    // WORK AROUND - save currentConfig.activityEvents value to 'store.js' variable for use in function: attachEventIframe
    storeConfiguration = function () {
      store.set('activityEvents', currentConfig.activityEvents);
    };

    //----------- KEEP SESSION ALIVE FUNCTIONS --------------//
    startKeepSessionAlive = function () {
      keepSession = function () {
        $.get(currentConfig.sessionKeepAliveUrl);
        startKeepSessionAlive();
      };

      keepAlivePing = setTimeout(keepSession, (currentConfig.sessionKeepAliveTimer * 1000));
    };

    stopKeepSessionAlive = function () {
      clearTimeout(keepAlivePing);
    };

    //----------- ACTIVITY DETECTION FUNCTION --------------//
    activityDetector = function () {

      $('body').on(currentConfig.activityEvents, function () {

        if (!currentConfig.enableDialog || (currentConfig.enableDialog && isDialogOpen() !== true)) {
          startIdleTimer();
        } else {
          //console.log('warning dialog open. activity ignored');
        }
      });
    };

    //----------- IDLE TIMER FUNCTIONS --------------//
    checkIdleTimeout = function () {

      var timeIdleTimeout = (store.get('idleTimerLastActivity') + (currentConfig.idleTimeLimit * 1000));

      if ($.now() > timeIdleTimeout) {
        if (!currentConfig.enableDialog) { // warning dialog is disabled
          logoutUser(); // immediately log out user when user is idle for idleTimeLimit
        } else if (currentConfig.enableDialog && isDialogOpen() !== true) {
          openWarningDialog();
          startDialogTimer(); // start timing the warning dialog
        }
      } else if (store.get('idleTimerLoggedOut') === true) { //a 'manual' user logout?
        logoutUser();
      } else {
        if (currentConfig.enableDialog && isDialogOpen() === true) {

          destroyWarningDialog();
          stopDialogTimer();
        }
      }
    };

    startIdleTimer = function () {
      stopIdleTimer();
      store.set('idleTimerLastActivity', $.now());
      checkIdleTimeoutLoop();
    };

    // continually check if user inactivity has exceeded the idleTimeLimit
    checkIdleTimeoutLoop = function () {
      checkIdleTimeout();
      idleTimer = setTimeout(checkIdleTimeoutLoop, (currentConfig.idleCheckHeartbeat * 1000));
    };

    stopIdleTimer = function () {
      clearTimeout(idleTimer);
    };

    //----------- WARNING DIALOG FUNCTIONS --------------//
    openWarningDialog = function () {
      var cancelBtn = $("#idletimeout-resume");
      cancelBtn.bind("click", function(e){
        e.preventDefault();
        console.log('Stay Logged In button clicked');
            destroyWarningDialog();
            stopDialogTimer();
            startIdleTimer();
          });
      $("#idletimer_warning_dialog").show();

      // start the countdown display
      countdownDisplay();

      // change title bar to warning message
      document.title = currentConfig.dialogTitle;

      // if keep-alive is enabled, stop the session keep-alive ping
      if (currentConfig.sessionKeepAliveTimer) {
        stopKeepSessionAlive();
      }
    };

    checkDialogTimeout = function () {
      var timeDialogTimeout = (store.get('idleTimerLastActivity') + (currentConfig.idleTimeLimit * 1000) + (currentConfig.dialogDisplayLimit * 1000));

      if (($.now() > timeDialogTimeout) || (store.get('idleTimerLoggedOut') === true)) {
        logoutUser();
      }
    };

    startDialogTimer = function () {
      dialogTimer = setInterval(checkDialogTimeout, (currentConfig.idleCheckHeartbeat * 1000));
    };

    stopDialogTimer = function () {
      clearInterval(dialogTimer);
      clearInterval(remainingTimer);
    };

    isDialogOpen = function () {
      var dialogOpen = $("#idletimer_warning_dialog").is(":visible");

      if (dialogOpen === true) {
        return true;
      }
      return false;
    };

    destroyWarningDialog = function () {
      $('#countdownDisplay').html("");
      $("#idletimer_warning_dialog").hide();

      // if keep-alive is enabled, restart the session keep-alive ping
      if (currentConfig.sessionKeepAliveTimer) {
        startKeepSessionAlive();
      }
    };

    // display remaining time on warning dialog
    countdownDisplay = function () {secs = "";
      var dialogDisplaySeconds = currentConfig.dialogDisplayLimit, mins, secs;

      remainingTimer = setInterval(function () {
        mins = Math.floor(dialogDisplaySeconds / 60); // minutes
        if (mins < 10) { mins = '0' + mins; }
        secs = dialogDisplaySeconds - (mins * 60); // seconds
        if (secs < 10) { secs = '0' + secs; }
        $('#countdownDisplay').html(dialogDisplaySeconds);
        dialogDisplaySeconds -= 1;
      }, 1000);
    };

    //----------- LOGOUT USER FUNCTION --------------//
    logoutUser = function () {
      store.set('idleTimerLoggedOut', true);

      if (currentConfig.sessionKeepAliveTimer) {
        stopKeepSessionAlive();
      }

      if (currentConfig.customCallback) {
        currentConfig.customCallback();
        clearTimeout(keepAlivePing);
        clearTimeout(idleTimer);
        clearInterval(dialogTimer);
        clearInterval(remainingTimer);
      }

      if (currentConfig.redirectUrl) {
        console.log('logout function redirect to URL');
        window.location.href = currentConfig.redirectUrl;
      }
    };

    //----------- IFRAME FUNCTIONS --------------//
    // triggered when a dialog is opened, recheck for iframes
    $("body").on("dialogopen", function () {
      if (currentConfig.enableDialog && isDialogOpen() !== true) {
        checkForIframes();
      } else {
        //console.log('warning dialog opened. No recheck for iframes.');
      }
    });

    // document must be in readyState 'complete' before checking for iframes - $(document).ready() is not good enough!
    checkForIframes = function () {
      var docReadyCheck, isDocReady;

      docReadyCheck = function () {
        if (document.readyState === "complete") {
          clearInterval(isDocReady);
          includeIframes();
        }
      };

      isDocReady = setInterval(docReadyCheck, 1000); // check once a second to see if document is complete
    };

    // find and include iframes
    includeIframes = function (elementContents) {
      if (!elementContents) {
        elementContents = $(document);
      }

      var iframeCount = 0;

      elementContents.find('iframe,frame').each(function () {
        if ($(this).hasClass('jit-inspected') === false) {

          try {

            includeIframes($(this).contents()); // recursive call to include nested iframes

            // attach event code for most modern browsers
            $(this).on('load', attachEventIframe($(this))); // Browser NOT IE < 11

            // attach event code for older Internet Explorer browsers
            var domElement = $(this)[iframeCount]; // convert jquery object to dom element

            if (domElement.attachEvent) { // Older IE Browser < 11
              domElement.attachEvent('onload', attachEventIframe($(this)));
            }

            iframeCount++;

          } catch (err) {
            /* Unfortunately, if the 'includeIframes' function is manually triggered multiple times in quick succession,
             * this 'try/catch' block may not have time to complete,
             * and so it might error out,
             * and iframes that are NOT cross-site may be set to "cross-site"
             * and activity may or may not bubble to parent page.
             * Fortunately, this is a rare occurrence!
             */
            console.log('found cross-site iframe - add classes "jit-inspected" & "cross-site"');
            $(this).addClass('jit-inspected cross-site');
          }

        } else {
          console.log('iframe already has class jit-inspected');
        }

      });

    };

    // attach events to each iframe
    attachEventIframe = function (iframeItem) {
      // retrieve stored value as currentConfig will not include private userRuntimeConfig
      // when this function is called by public function, iframeRecheck
      console.log('currentConfig.activityEvents: ' + currentConfig.activityEvents + '.');
      var iframeContents = iframeItem.contents(), storeActivityEvents = store.get('activityEvents');

      try {

        iframeContents.on(storeActivityEvents, function (event) {
          $('body').trigger(event);
        });

        iframeItem.addClass('jit-inspected'); // add "jit-inspected" class, so we don't need to check this iframe again

      } catch (err) {
        //console.log('problem with attachment of activity events to this iframe');
      }

    };

    //###############################
    // Build & Return the instance of the item as a plugin
    // This is your construct.
    //###############################
    return this.each(function () {

      if (store.enabled) {

        store.set('idleTimerLastActivity', $.now());
        store.set('idleTimerLoggedOut', false);

        storeConfiguration();

        activityDetector();

        if (currentConfig.sessionKeepAliveTimer) {
          startKeepSessionAlive();
        }

        startIdleTimer();

        checkForIframes();

      } else {
        console.log('store.js not enabled, or browser "private mode"?');
        alert(currentConfig.errorAlertMessage);
      }

    });
  };
}(jQuery));
/*
 * guides 1.2.9
 * Simple way to highlighting DOM elements and guide your users with step-by-step welcome tours in your web app.
 * https://github.com/ejulianova/guides
 *
 * Copyright 2015, Elena Petrova <elena.julianova@gmail.com>
 * Released under the MIT license.
*/

(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var Guides = require('./modules/Guides');

$.fn.guides = function (option, optionData) {
    return this.each(function () {
        var $this = $(this),
            data = $this.data('guides'),
            options = typeof option === 'object' && option;

        if (!data && typeof options == 'string') return;
        if (!data) $this.data('guides', (data = new Guides(this, options)));
        if (typeof option == 'string') data[option](optionData);
    });
};

$.guides = function (options) {
    return new Guides(null, options);
};

$.fn.guides.Constructor = Guides;
},{"./modules/Guides":3}],2:[function(require,module,exports){
var format = require('./format');

var Guide = function (guide, $container, options) {
    this.guide = guide;
    this._language = this._languages[options.language.toLowerCase()];
    this._distance = guide.distance || options.distance;
    this._arrowColor = guide.arrowColor || options.arrowColor;
    this._class = guide.cssClass || options.cssClass || '';
    this.$highlightedElement = $(guide.element).addClass('guides-current-element');
    this.$container = $container;
    this.init();
};

Guide.prototype._languages = {
    en: {
      cancel: 'Skip for Now',
      previous: 'Previous',
      next: 'Next',
      ok: 'Got It!'
    },
    es: {
      cancel: 'Saltar Por Ahora',
      previous: 'Anterior',
      next: 'Siguiente',
      ok: '¡Lo Tengo!'
    }
};

Guide.prototype._arrowSize = 10;
// Mx1,y1, Cdx1,dy1,dx2,dy2,x2,y2
// (x1,y1) - start point
// (dx1,dy1) - curve control point 1
// (dx2,dy2) - curve control point 2
// (x2,y2) - end point
Guide.prototype._path = 'M{0},{1} C{2},{3},{4},{5},{6},{7}';
Guide.prototype._arrowTemplate = '<svg width="{0}" height="{1}" pointer-events="none">\
    <defs>\
        <marker id="arrow" markerWidth="13" markerHeight="13" refX="2" refY="6" orient="auto">\
            <path d="M2,1 L2,{3} L{3},6 L2,2" style="fill:{4};"></path>\
        </marker>\
    </defs>\
    <path id="line" d="{2}" style="stroke:{4}; stroke-width: 1.25px; fill: none; marker-end: url(#arrow);"></path>\
</svg>';

Guide.prototype.init = function() {
    this.$guide = $('<div />', {
        'class': 'guides-fade-in guides-guide ' + this._class
    });
    var inner = $('<div />' , {
        'class': 'guides-inner',
        'html': '<p>' + this.guide.html + '</p]>'
    }).appendTo(this.$guide);
    var span = $('<span/>', {
        'style': 'width: 100%; text-align: right'
    }).appendTo(inner);
    this.$skipBtn = $('<button />', {
        'class': 'btn btn-default',
        'style': 'margin-right: 5px',
        'html': this._language.cancel ? this._language.cancel : this._languages.en.cancel
    }).appendTo(span);
    this.$prevBtn = $('<button />', {
        'class': 'btn idmx-link-btn',
        'style': 'margin-right: 5px',
        'html': this._language.previous ? this._language.previous : this._languages.en.previous
    }).appendTo(span);
    this.$nextBtn = $('<button />', {
        'class': 'btn idmx-link-btn',
        'style': 'margin-right: 5px',
        'html': this._language.next ? this._language.next : this._languages.en.next
    }).appendTo(span);
    this.$endBtn = $('<button />', {
        'class': 'btn idmx-link-btn',
        'html': this._language.ok ? this._language.ok : this._languages.en.ok
    }).appendTo(span);
    this._position();
    return this;
};

Guide.prototype._position = function () {
    if (this.$highlightedElement && this.$highlightedElement.length > 0) {
        this._attachToElement();
        this.$guide.appendTo(this.$container);
        this._renderArrow();
    } else {
        this._center();
    }
    this._scrollIntoView();
};

Guide.prototype._center = function () {
    this.$guide
        .css('visibility', 'hidden')
        .appendTo(this.$container)
        .addClass('guides-center')
        .css({
            left: (window.innerWidth * (3/ 8)),
            right: (window.innerWidth * (3/ 8)),
            textAlign: 'left',
            top: (window.innerHeight / 2) - (this.$guide.outerHeight() / 2)
        }).css('visibility', 'visible');
};

Guide.prototype._attachToElement = function () {
    var elOffset = this.$highlightedElement.offset(),
        docWidth = $('body').width(),
        docHeight = $('body').height(),
        leftSpace = elOffset.left,
        topSpace = elOffset.top,
        highlightedElementWidth = this.$highlightedElement.outerWidth(),
        highlightedElementHeight = this.$highlightedElement.outerHeight(),
        rightSpace = docWidth - leftSpace - highlightedElementWidth,
        bottomSpace = docHeight - topSpace - highlightedElementHeight,
        css = {
            top: docHeight / 2 > elOffset.top ? elOffset.top : 'auto',
            left: docWidth / 2 > elOffset.left ? elOffset.left : 'auto',
            right: docWidth / 2 > elOffset.left ? 'auto' : docWidth - elOffset.left - highlightedElementWidth,
            bottom: docHeight / 2 > elOffset.top ? 'auto' : elOffset.bottom
        };

    switch (Math.max(leftSpace, rightSpace, topSpace, bottomSpace)) {
    case leftSpace:
        this.position = 'left';
        css.paddingRight = this._distance;
        css.right = $(document).width() - elOffset.left;
        css.left = 'auto';
        break;
    case topSpace:
        this.position = 'top';
        css.paddingBottom = this._distance;
        css.bottom = $(document).height() - elOffset.top;
        css.top = 'auto';
        break;
    case rightSpace:
        this.position = 'right';
        css.paddingLeft = this._distance;
        css.left = elOffset.left + highlightedElementWidth;
        css.right = 'auto';
        break;
    default:
        this.position = 'bottom';
        css.paddingTop = this._distance;
        css.top = elOffset.top + highlightedElementHeight;
        css.bottom = 'auto';
        break;
    }
    this.$guide.addClass('guides-' + this.position).css(css);
};

Guide.prototype._renderArrow = function() {
    this._width = this.$guide.outerWidth();
    this._height = this.$guide.outerHeight();
    this.$guide.append(format(this._arrowTemplate,
        this._width, this._distance, this[this.position](), this._arrowSize, this._arrowColor));
};

Guide.prototype.top = function () {
    var coord = this._verticalAlign();
    return this._getPath(coord);
};

Guide.prototype.bottom = function () {
    var coord = this._verticalAlign(true);
    return this._getPath(coord);
};

Guide.prototype.left = function () {
    var coord = this._horizontalAlign();
    return this._getPath(coord);
};

Guide.prototype.right = function () {
    var coord = this._horizontalAlign(true);
    return this._getPath(coord);
};

Guide.prototype._getPath = function (coord) {
    return format(this._path, coord.x1, coord.y1, coord.dx1, coord.dy1, coord.dx2, coord.dy2, coord.x2, coord.y2);
};

Guide.prototype._getFluctuation = function () {
    return Math.floor(Math.random() * 20) + 10;
};

Guide.prototype._verticalAlign = function (bottom) {
    var x1 = this._width / 2,
        y1 = bottom ? this._distance : 0,
        x2 = Math.max(
                Math.min(
                    this.$highlightedElement.offset().left + (this.$highlightedElement.outerWidth() / 2) - this.$guide.offset().left,
                    this._width - this._arrowSize),
                this._arrowSize),
        y2 = bottom ? this._arrowSize : this._distance - this._arrowSize;
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        dx1: Math.max(0, Math.min(Math.abs((2 * x1) - x2) / 3, this._width) + this._getFluctuation()),
        dy1: bottom
            ? Math.max(0, y2 + (Math.abs(y1 - y2) * 3 / 4))
            : Math.max(0, y1 + (Math.abs(y1 - y2) * 3 / 4)),
        dx2: Math.max(0, Math.min(Math.abs(x1 - (x2 * 3)) / 2, this._width) - this._getFluctuation()),
        dy2: bottom
            ? Math.max(0, y2 + (Math.abs(y1 - y2) * 3 / 4))
            : Math.max(0, y1 + (Math.abs(y1 - y2) * 3 / 4))
    }
};

Guide.prototype._horizontalAlign = function (right) {
    var x1 = right ? this._distance : this._width - this._distance,
        y1 = this._height / 2,
        x2 = right ? this._arrowSize : this._width - this._arrowSize,
        y2 = Math.max(
                Math.min(
                    this.$highlightedElement.offset().top + (this.$highlightedElement.outerHeight() / 2) - this.$guide.offset().top,
                    this._height - this._arrowSize),
                this._arrowSize);
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        dx1: right
            ? Math.max(0, x2 + (Math.abs(x1 - x2) * 3 / 4))
            : Math.max(0, x1 + Math.abs(x1 - x2) * 3 / 4),
        dy1: Math.max(0, Math.min(Math.abs((2 * y1) - y2) / 3, this._height) + this._getFluctuation()),
        dx2: right
            ? Math.max(0, x2 + (Math.abs(x1 - x2) * 3 / 4))
            : Math.max(0, x1 + Math.abs(x1 - x2) * 3 / 4),
        dy2: Math.max(0, Math.min(Math.abs(y1 - (y2 * 3)) / 2, this._height) + this._getFluctuation())
    }
};

Guide.prototype._scrollIntoView = function () {
    if (this.$highlightedElement.length === 0) {
        $('html,body').animate({
          scrollTop: 0
        }, 500);
        return;
    }
    var guideOffset = this.$guide.offset(),
        top = guideOffset.top,
        bottom = guideOffset.top + this.$guide.outerHeight(),
        left = guideOffset.left,
        right = guideOffset.left + this.$guide.outerWidth(),
        scrollTop = $(document).scrollTop(),
        scrollLeft = $(document).scrollLeft();

    //scroll vertically to element if it is not visible in the view port
    if (scrollTop > top || scrollTop + $(window).height() < bottom) {
        $('html,body').animate({
          scrollTop: this.position === 'bottom' ? top - 100 : top
        }, 500);
    }

    //scroll horizontally to element if it is not visible in the view port
    if (scrollLeft > left || scrollLeft + $(window).width() < right) {
        $('html,body').animate({
          scrollLeft: this.position === 'righ' ? left - 100 : left
        }, 500);
    }
};

Guide.prototype.destroy = function() {
    this.$highlightedElement.removeClass('guides-current-element');
    this.$guide.remove();
};

module.exports = Guide;
},{"./format":4}],3:[function(require,module,exports){
var Guide = require('./Guide');

var Guides = function (element, options) {
    this.element = element;
    this.$element = $(element);
    this.options = {};
    this._current = 0;
    this.setOptions(options);
    if (element) {
        this.$element.on('click.guides', $.proxy(this.start, this));
    }
};

Guides.DEFAULTS = {
    distance: 100,
    arrowColor: '#676a6c',
    cssClass: '',
    guides: []
};

Guides.prototype.start = function(e) {
    if (e) {
        e.preventDefault();
    }
    if (this._isAlreadyRunning()) {
        return this;
    }
    this._current = 0;
    this._renderCanvas()
        ._renderGuide(this.options.guides[this._current])
        ._callback('start');
    return this;
};

Guides.prototype.skip = function() {
    if (this.$canvas) {
        this.$canvas.remove();
        this.$canvas = null;
    }
    if (this._currentGuide) {
        this._currentGuide.destroy();
        this._currentGuide = null;
    }
    $(document).off('keyup.guides');
    this._callback('skip');
    return this;
};

Guides.prototype.end = function() {
    if (this.$canvas) {
        this.$canvas.remove();
        this.$canvas = null;
    }
    if (this._currentGuide) {
        this._currentGuide.destroy();
        this._currentGuide = null;
    }
    $(document).off('keyup.guides');
    this._callback('end');
    return this;
};

Guides.prototype.next = function () {
    this._renderGuide(this.options.guides[++this._current])
        ._callback('next');
    return this;
};

Guides.prototype.prev = function () {
    if (!this._current) {
        return;
    }
    this._renderGuide(this.options.guides[--this._current])
        ._callback('prev');
    return this;
};

Guides.prototype.setOptions = function(options) {
    if (typeof options !== 'object') {
        return this;
    }
    this.options = $.extend({}, Guides.DEFAULTS, this.options, options);
};

Guides.prototype.destroy = function() {
    this.end();
    this.$element.off('click.guides');
    this._callback('destroy');
    return this;
};

Guides.prototype._callback = function (eventName) {
    var callback = this.options[eventName],
        eventObject = {
            sender: this
        };

    if (this._currentGuide) {
        eventObject.$element = this._currentGuide.guide.element;
        eventObject.$guide = this._currentGuide.$element;
    }

    if ($.isFunction(callback)) {
        callback.apply(this, [eventObject]);
    }
};

Guides.prototype._isAlreadyRunning = function () {
    return !!this.$canvas;
};

Guides.prototype._renderCanvas = function () {
    this.$canvas = $('<div />', {
            'class': 'guides-canvas guides-fade-in',
            'html': '<div class="guides-overlay"></div><div class="guides-mask"></div>'
        }).appendTo('body');
    this._bindNavigation();
    return this;
};

Guides.prototype._renderGuide = function (guide) {
    if (!guide) { //no more guides
        this.end();
        return this;
    }

    if (this._currentGuide) {
        this._currentGuide.destroy();
    }

    this._callback('render', guide);

    if ($.isFunction(guide.render)) {
        guide.render.apply(this, [guide]);
    }
    this._currentGuide = new Guide(guide, this.$canvas, this.options);
    this._currentGuide.$skipBtn.on('click.guides', $.proxy(this.skip, this));
    if (this._current) {
        this._currentGuide.$prevBtn.on('click.guides', $.proxy(this.prev, this));
    } else {
        this._currentGuide.$prevBtn.css('display', 'none');
    }
    if (this._current < this.options.guides.length - 1) {
        this._currentGuide.$nextBtn.on('click.guides', $.proxy(this.next, this));
        this._currentGuide.$endBtn.css('display', 'none');
    } else {
        this._currentGuide.$nextBtn.css('display', 'none');
        this._currentGuide.$endBtn.on('click.guides', $.proxy(this.end, this));
    }
    return this;
};

Guides.prototype._bindNavigation = function () {
    //this.$canvas.on('click.guides', $.proxy(this._onCanvasClick, this));
    $(document).on('keyup.guides', $.proxy(this._onDocKeyUp, this));
    return this;
};

Guides.prototype._onCanvasClick = function (e) {
    this.next();
};

Guides.prototype._onDocKeyUp = function (e) {
    switch (e.which) {
    case 27: //esc
        this.end();
        break;
    case 39: //right arrow
    case 32: //space
        this.next();
        break;
    case 37: //left arrow
    case 8: //backspace
        e.preventDefault();
        this.prev();
        break;
    default:
        break;
    }
};

module.exports = Guides;
},{"./Guide":2}],4:[function(require,module,exports){
module.exports = function format () {
  var s = arguments[0];
  for (var i = 0; i < arguments.length - 1; i++) {
    var reg = new RegExp("\\{" + i + "\\}", "gm");
    s = s.replace(reg, arguments[i + 1]);
  }
  return s;
};
},{}]},{},[1])
!function(a){a.fn.datepicker.dates["zh-TW"]={days:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],daysShort:["週日","週一","週二","週三","週四","週五","週六"],daysMin:["日","一","二","三","四","五","六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthsShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],today:"今天",format:"yyyy年mm月dd日",weekStart:1,clear:"清除"}}(jQuery);
!function(a){a.fn.datepicker.dates["zh-CN"]={days:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],daysShort:["周日","周一","周二","周三","周四","周五","周六"],daysMin:["日","一","二","三","四","五","六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthsShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],today:"今日",clear:"清除",format:"yyyy年mm月dd日",titleFormat:"yyyy年mm月",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.vi={days:["Chủ nhật","Thứ hai","Thứ ba","Thứ tư","Thứ năm","Thứ sáu","Thứ bảy"],daysShort:["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"],daysMin:["CN","T2","T3","T4","T5","T6","T7"],months:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],monthsShort:["Th1","Th2","Th3","Th4","Th5","Th6","Th7","Th8","Th9","Th10","Th11","Th12"],today:"Hôm nay",clear:"Xóa",format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["uz-latn"]={days:["Yakshanba","Dushanba","Seshanba","Chorshanba","Payshanba","Juma","Shanba"],daysShort:["Yak","Du","Se","Chor","Pay","Ju","Sha"],daysMin:["Ya","Du","Se","Cho","Pa","Ju","Sha"],months:["Yanvar","Fevral","Mart","Aprel","May","Iyun","Iyul","Avgust","Sentabr","Oktabr","Noyabr","Dekabr"],monthsShort:["Yan","Fev","Mar","Apr","May","Iyn","Iyl","Avg","Sen","Okt","Noy","Dek"],today:"Bugun",clear:"O'chirish",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Oylar"}}(jQuery);
!function(a){a.fn.datepicker.dates["uz-cyrl"]={days:["Якшанба","Душанба","Сешанба","Чоршанба","Пайшанба","Жума","Шанба"],daysShort:["Якш","Ду","Се","Чор","Пай","Жу","Ша"],daysMin:["Як","Ду","Се","Чо","Па","Жу","Ша"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Бугун",clear:"Ўчириш",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Ойлар"}}(jQuery);
!function(a){a.fn.datepicker.dates.uk={days:["Неділя","Понеділок","Вівторок","Середа","Четвер","П'ятниця","Субота"],daysShort:["Нед","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Cічень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthsShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],today:"Сьогодні",clear:"Очистити",format:"dd.mm.yyyy",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.tr={days:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],daysShort:["Pz","Pzt","Sal","Çrş","Prş","Cu","Cts"],daysMin:["Pz","Pzt","Sa","Çr","Pr","Cu","Ct"],months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthsShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],today:"Bugün",clear:"Temizle",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.tk={days:["Ýekşenbe","Duşenbe","Sişenbe","Çarşenbe","Penşenbe","Anna","Şenbe"],daysShort:["Ýek","Duş","Siş","Çar","Pen","Ann","Şen"],daysMin:["Ýe","Du","Si","Ça","Pe","An","Şe"],months:["Ýanwar","Fewral","Mart","Aprel","Maý","Iýun","Iýul","Awgust","Sentýabr","Oktýabr","Noýabr","Dekabr"],monthsShort:["Ýan","Few","Mar","Apr","Maý","Iýn","Iýl","Awg","Sen","Okt","Noý","Dek"],today:"Bu gün",monthsTitle:"Aýlar",clear:"Aýyr",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.th={days:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัส","ศุกร์","เสาร์","อาทิตย์"],daysShort:["อา","จ","อ","พ","พฤ","ศ","ส","อา"],daysMin:["อา","จ","อ","พ","พฤ","ศ","ส","อา"],months:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],monthsShort:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],today:"วันนี้"}}(jQuery);
!function(a){a.fn.datepicker.dates.tg={days:["Якшанбе","Душанбе","Сешанбе","Чоршанбе","Панҷшанбе","Ҷумъа","Шанбе"],daysShort:["Яшб","Дшб","Сшб","Чшб","Пшб","Ҷум","Шнб"],daysMin:["Яш","Дш","Сш","Чш","Пш","Ҷм","Шб"],months:["Январ","Феврал","Март","Апрел","Май","Июн","Июл","Август","Сентябр","Октябр","Ноябр","Декабр"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Имрӯз",monthsTitle:"Моҳҳо",clear:"Тоза намудан",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.ta={days:["ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி"],daysShort:["ஞாயி","திங்","செவ்","புத","வியா","வெள்","சனி"],daysMin:["ஞா","தி","செ","பு","வி","வெ","ச"],months:["ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","மே","ஜூன்","ஜூலை","ஆகஸ்டு","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்"],monthsShort:["ஜன","பிப்","மார்","ஏப்","மே","ஜூன்","ஜூலை","ஆக","செப்","அக்","நவ","டிச"],today:"இன்று",monthsTitle:"மாதங்கள்",clear:"நீக்கு",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.sw={days:["Jumapili","Jumatatu","Jumanne","Jumatano","Alhamisi","Ijumaa","Jumamosi"],daysShort:["J2","J3","J4","J5","Alh","Ij","J1"],daysMin:["2","3","4","5","A","I","1"],months:["Januari","Februari","Machi","Aprili","Mei","Juni","Julai","Agosti","Septemba","Oktoba","Novemba","Desemba"],monthsShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ago","Sep","Okt","Nov","Des"],today:"Leo"}}(jQuery);
!function(a){a.fn.datepicker.dates.sv={days:["söndag","måndag","tisdag","onsdag","torsdag","fredag","lördag"],daysShort:["sön","mån","tis","ons","tor","fre","lör"],daysMin:["sö","må","ti","on","to","fr","lö"],months:["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december"],monthsShort:["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec"],today:"Idag",format:"yyyy-mm-dd",weekStart:1,clear:"Rensa"}}(jQuery);
!function(a){a.fn.datepicker.dates.sr={days:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],daysShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],daysMin:["Н","По","У","Ср","Ч","Пе","Су"],months:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthsShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],today:"Данас",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["sr-latin"]={days:["Nedelja","Ponedeljak","Utorak","Sreda","Četvrtak","Petak","Subota"],daysShort:["Ned","Pon","Uto","Sre","Čet","Pet","Sub"],daysMin:["N","Po","U","Sr","Č","Pe","Su"],months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],today:"Danas",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.sq={days:["E Diel","E Hënë","E Martē","E Mërkurë","E Enjte","E Premte","E Shtunë"],daysShort:["Die","Hën","Mar","Mër","Enj","Pre","Shtu"],daysMin:["Di","Hë","Ma","Më","En","Pr","Sht"],months:["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"],monthsShort:["Jan","Shk","Mar","Pri","Maj","Qer","Korr","Gu","Sht","Tet","Nën","Dhjet"],today:"Sot"}}(jQuery);
!function(a){a.fn.datepicker.dates.sl={days:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"],daysShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],daysMin:["Ne","Po","To","Sr","Če","Pe","So"],months:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],today:"Danes",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.sk={days:["Nedeľa","Pondelok","Utorok","Streda","Štvrtok","Piatok","Sobota"],daysShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],daysMin:["Ne","Po","Ut","St","Št","Pia","So"],months:["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"],monthsShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],today:"Dnes",clear:"Vymazať",weekStart:1,format:"d.m.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.si={days:["ඉරිදා","සඳුදා","අඟහරුවාදා","බදාදා","බ්‍රහස්පතින්දා","සිකුරාදා","සෙනසුරාදා"],daysShort:["ඉරි","සඳු","අඟ","බදා","බ්‍රහ","සිකු","සෙන"],daysMin:["ඉ","ස","අ","බ","බ්‍ර","සි","සෙ"],months:["ජනවාරි","පෙබරවාරි","මාර්තු","අප්‍රේල්","මැයි","ජුනි","ජූලි","අගෝස්තු","සැප්තැම්බර්","ඔක්තෝබර්","නොවැම්බර්","දෙසැම්බර්"],monthsShort:["ජන","පෙබ","මාර්","අප්‍රේ","මැයි","ජුනි","ජූලි","අගෝ","සැප්","ඔක්","නොවැ","දෙසැ"],today:"අද",monthsTitle:"මාස",clear:"මකන්න",weekStart:0,format:"yyyy-mm-dd"}}(jQuery);
!function(a){a.fn.datepicker.dates.ru={days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вск","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Месяцы"}}(jQuery);
!function(a){a.fn.datepicker.dates.ro={days:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],daysShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],daysMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],months:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthsShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],today:"Astăzi",clear:"Șterge",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.pt={days:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"],daysShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],daysMin:["Do","Se","Te","Qu","Qu","Se","Sa"],months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthsShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],today:"Hoje",monthsTitle:"Meses",clear:"Limpar",format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["pt-BR"]={days:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"],daysShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],daysMin:["Do","Se","Te","Qu","Qu","Se","Sa"],months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthsShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],today:"Hoje",monthsTitle:"Meses",clear:"Limpar",format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.pl={days:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],daysShort:["Niedz.","Pon.","Wt.","Śr.","Czw.","Piąt.","Sob."],daysMin:["Ndz.","Pn.","Wt.","Śr.","Czw.","Pt.","Sob."],months:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthsShort:["Sty.","Lut.","Mar.","Kwi.","Maj","Cze.","Lip.","Sie.","Wrz.","Paź.","Lis.","Gru."],today:"Dzisiaj",weekStart:1,clear:"Wyczyść",format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.oc={days:["Dimenge","Diluns","Dimars","Dimècres","Dijòus","Divendres","Dissabte"],daysShort:["Dim","Dil","Dmr","Dmc","Dij","Div","Dis"],daysMin:["dg","dl","dr","dc","dj","dv","ds"],months:["Genièr","Febrièr","Març","Abrial","Mai","Junh","Julhet","Agost","Setembre","Octobre","Novembre","Decembre"],monthsShort:["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Dec"],today:"Uèi",monthsTitle:"Meses",clear:"Escafar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.no={days:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],daysShort:["søn","man","tir","ons","tor","fre","lør"],daysMin:["sø","ma","ti","on","to","fr","lø"],months:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","vovember","desember"],monthsShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],today:"i dag",monthsTitle:"Måneder",clear:"Nullstill",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.nl={days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],daysShort:["zo","ma","di","wo","do","vr","za"],daysMin:["zo","ma","di","wo","do","vr","za"],months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],today:"Vandaag",monthsTitle:"Maanden",clear:"Wissen",weekStart:1,format:"dd-mm-yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["nl-BE"]={days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],daysShort:["zo","ma","di","wo","do","vr","za"],daysMin:["zo","ma","di","wo","do","vr","za"],months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],today:"Vandaag",monthsTitle:"Maanden",clear:"Leegmaken",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.ms={days:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],daysShort:["Aha","Isn","Sel","Rab","Kha","Jum","Sab"],daysMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],months:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthsShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],today:"Hari Ini",clear:"Bersihkan"}}(jQuery);
!function(a){a.fn.datepicker.dates.mn={days:["Ням","Даваа","Мягмар","Лхагва","Пүрэв","Баасан","Бямба"],daysShort:["Ням","Дав","Мяг","Лха","Пүр","Баа","Бям"],daysMin:["Ня","Да","Мя","Лх","Пү","Ба","Бя"],months:["Хулгана","Үхэр","Бар","Туулай","Луу","Могой","Морь","Хонь","Бич","Тахиа","Нохой","Гахай"],monthsShort:["Хул","Үхэ","Бар","Туу","Луу","Мог","Мор","Хон","Бич","Тах","Нох","Гах"],today:"Өнөөдөр",clear:"Тодорхой",format:"yyyy.mm.dd",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.mk={days:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"],daysShort:["Нед","Пон","Вто","Сре","Чет","Пет","Саб"],daysMin:["Не","По","Вт","Ср","Че","Пе","Са"],months:["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],monthsShort:["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],today:"Денес",format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.me={days:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],daysShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],daysMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],today:"Danas",weekStart:1,clear:"Izbriši",format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.lv={days:["Svētdiena","Pirmdiena","Otrdiena","Trešdiena","Ceturtdiena","Piektdiena","Sestdiena"],daysShort:["Sv","P","O","T","C","Pk","S"],daysMin:["Sv","Pr","Ot","Tr","Ce","Pk","Se"],months:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],monthsShort:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],monthsTitle:"Mēneši",today:"Šodien",clear:"Nodzēst",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.lt={days:["Sekmadienis","Pirmadienis","Antradienis","Trečiadienis","Ketvirtadienis","Penktadienis","Šeštadienis"],daysShort:["S","Pr","A","T","K","Pn","Š"],daysMin:["Sk","Pr","An","Tr","Ke","Pn","Št"],months:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],monthsShort:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],today:"Šiandien",monthsTitle:"Mėnesiai",clear:"Išvalyti",weekStart:1,format:"yyyy-mm-dd"}}(jQuery);
!function(a){a.fn.datepicker.dates.ko={days:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],daysShort:["일","월","화","수","목","금","토"],daysMin:["일","월","화","수","목","금","토"],months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],monthsShort:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],today:"오늘",clear:"삭제",format:"yyyy-mm-dd",titleFormat:"yyyy년mm월",weekStart:0}}(jQuery);
!function(a){a.fn.datepicker.dates.km={days:["អាទិត្យ","ចន្ទ","អង្គារ","ពុធ","ព្រហស្បតិ៍","សុក្រ","សៅរ៍"],daysShort:["អា.ទិ","ចន្ទ","អង្គារ","ពុធ","ព្រ.ហ","សុក្រ","សៅរ៍"],daysMin:["អា.ទិ","ចន្ទ","អង្គារ","ពុធ","ព្រ.ហ","សុក្រ","សៅរ៍"],months:["មករា","កុម្ភះ","មិនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ"],monthsShort:["មករា","កុម្ភះ","មិនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ"],today:"ថ្ងៃនេះ",clear:"សំអាត"}}(jQuery);
!function(a){a.fn.datepicker.dates.kk={days:["Жексенбі","Дүйсенбі","Сейсенбі","Сәрсенбі","Бейсенбі","Жұма","Сенбі"],daysShort:["Жек","Дүй","Сей","Сәр","Бей","Жұм","Сен"],daysMin:["Жк","Дс","Сс","Ср","Бс","Жм","Сн"],months:["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],monthsShort:["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],today:"Бүгін",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.ka={days:["კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი"],daysShort:["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"],daysMin:["კვ","ორ","სა","ოთ","ხუ","პა","შა"],months:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],monthsShort:["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],today:"დღეს",clear:"გასუფთავება",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.ja={days:["日曜","月曜","火曜","水曜","木曜","金曜","土曜"],daysShort:["日","月","火","水","木","金","土"],daysMin:["日","月","火","水","木","金","土"],months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthsShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],today:"今日",format:"yyyy/mm/dd",titleFormat:"yyyy年mm月",clear:"クリア"}}(jQuery);
!function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",monthsTitle:"Mesi",clear:"Cancella",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",clear:"Cancella",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.is={days:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"],daysShort:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"],daysMin:["Su","Má","Þr","Mi","Fi","Fö","La"],months:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],monthsShort:["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],today:"Í Dag"}}(jQuery);
!function(a){a.fn.datepicker.dates.id={days:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"],daysShort:["Mgu","Sen","Sel","Rab","Kam","Jum","Sab"],daysMin:["Mg","Sn","Sl","Ra","Ka","Ju","Sa"],months:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],monthsShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Ags","Sep","Okt","Nov","Des"],today:"Hari Ini",clear:"Kosongkan"}}(jQuery);
!function(a){a.fn.datepicker.dates.hy={days:["Կիրակի","Երկուշաբթի","Երեքշաբթի","Չորեքշաբթի","Հինգշաբթի","Ուրբաթ","Շաբաթ"],daysShort:["Կիր","Երկ","Երե","Չոր","Հին","Ուրբ","Շաբ"],daysMin:["Կի","Եկ","Եք","Չո","Հի","Ու","Շա"],months:["Հունվար","Փետրվար","Մարտ","Ապրիլ","Մայիս","Հունիս","Հուլիս","Օգոստոս","Սեպտեմբեր","Հոկտեմբեր","Նոյեմբեր","Դեկտեմբեր"],monthsShort:["Հնվ","Փետ","Մար","Ապր","Մայ","Հուն","Հուլ","Օգս","Սեպ","Հոկ","Նոյ","Դեկ"],today:"Այսօր",clear:"Ջնջել",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Ամիսնէր"}}(jQuery);
!function(a){a.fn.datepicker.dates.hu={days:["vasárnap","hétfő","kedd","szerda","csütörtök","péntek","szombat"],daysShort:["vas","hét","ked","sze","csü","pén","szo"],daysMin:["V","H","K","Sze","Cs","P","Szo"],months:["január","február","március","április","május","június","július","augusztus","szeptember","október","november","december"],monthsShort:["jan","feb","már","ápr","máj","jún","júl","aug","sze","okt","nov","dec"],today:"ma",weekStart:1,clear:"töröl",titleFormat:"yyyy. MM",format:"yyyy.mm.dd"}}(jQuery);
!function(a){a.fn.datepicker.dates.hr={days:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],daysShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],daysMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],months:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthsShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],today:"Danas"}}(jQuery);
!function(a){a.fn.datepicker.dates.hi={days:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],daysShort:["सूर्य","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],daysMin:["र","सो","मं","बु","गु","शु","श"],months:["जनवरी","फ़रवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितम्बर","अक्टूबर","नवंबर","दिसम्बर"],monthsShort:["जन","फ़रवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितं","अक्टूबर","नवं","दिसम्बर"],today:"आज",monthsTitle:"महीने",clear:"साफ",weekStart:1,format:"dd / mm / yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.he={days:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת","ראשון"],daysShort:["א","ב","ג","ד","ה","ו","ש","א"],daysMin:["א","ב","ג","ד","ה","ו","ש","א"],months:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],monthsShort:["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"],today:"היום",rtl:!0}}(jQuery);
!function(a){a.fn.datepicker.dates.gl={days:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"],daysShort:["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"],daysMin:["Do","Lu","Ma","Me","Xo","Ve","Sa"],months:["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],monthsShort:["Xan","Feb","Mar","Abr","Mai","Xun","Xul","Ago","Sep","Out","Nov","Dec"],today:"Hoxe",clear:"Limpar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.fr={days:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],daysShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],daysMin:["d","l","ma","me","j","v","s"],months:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthsShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],today:"Aujourd'hui",monthsTitle:"Mois",clear:"Effacer",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.fr={days:["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"],daysShort:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],daysMin:["D","L","Ma","Me","J","V","S"],months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],monthsShort:["Jan","Fév","Mar","Avr","Mai","Jui","Jul","Aou","Sep","Oct","Nov","Déc"],today:"Aujourd'hui",monthsTitle:"Mois",clear:"Effacer",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.fo={days:["Sunnudagur","Mánadagur","Týsdagur","Mikudagur","Hósdagur","Fríggjadagur","Leygardagur"],daysShort:["Sun","Mán","Týs","Mik","Hós","Frí","Ley"],daysMin:["Su","Má","Tý","Mi","Hó","Fr","Le"],months:["Januar","Februar","Marts","Apríl","Mei","Juni","Juli","August","Septembur","Oktobur","Novembur","Desembur"],monthsShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],today:"Í Dag",clear:"Reinsa"}}(jQuery);
!function(a){a.fn.datepicker.dates.fi={days:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"],daysShort:["sun","maa","tii","kes","tor","per","lau"],daysMin:["su","ma","ti","ke","to","pe","la"],months:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],monthsShort:["tam","hel","maa","huh","tou","kes","hei","elo","syy","lok","mar","jou"],today:"tänään",clear:"Tyhjennä",weekStart:1,format:"d.m.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.fa={days:["یک‌شنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنج‌شنبه","جمعه","شنبه","یک‌شنبه"],daysShort:["یک","دو","سه","چهار","پنج","جمعه","شنبه","یک"],daysMin:["ی","د","س","چ","پ","ج","ش","ی"],months:["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],monthsShort:["ژان","فور","مار","آور","مه","ژون","ژوی","اوت","سپت","اکت","نوا","دسا"],today:"امروز",clear:"پاک کن",weekStart:1,format:"yyyy/mm/dd"}}(jQuery);
!function(a){a.fn.datepicker.dates.eu={days:["Igandea","Astelehena","Asteartea","Asteazkena","Osteguna","Ostirala","Larunbata"],daysShort:["Ig","Al","Ar","Az","Og","Ol","Lr"],daysMin:["Ig","Al","Ar","Az","Og","Ol","Lr"],months:["Urtarrila","Otsaila","Martxoa","Apirila","Maiatza","Ekaina","Uztaila","Abuztua","Iraila","Urria","Azaroa","Abendua"],monthsShort:["Urt","Ots","Mar","Api","Mai","Eka","Uzt","Abu","Ira","Urr","Aza","Abe"],today:"Gaur",monthsTitle:"Hilabeteak",clear:"Ezabatu",weekStart:1,format:"yyyy/mm/dd"}}(jQuery);
!function(a){a.fn.datepicker.dates.et={days:["Pühapäev","Esmaspäev","Teisipäev","Kolmapäev","Neljapäev","Reede","Laupäev"],daysShort:["Pühap","Esmasp","Teisip","Kolmap","Neljap","Reede","Laup"],daysMin:["P","E","T","K","N","R","L"],months:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],monthsShort:["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],today:"Täna",clear:"Tühjenda",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.es={days:["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],daysShort:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],daysMin:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],monthsShort:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],today:"Hoy",monthsTitle:"Meses",clear:"Borrar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.eo={days:["dimanĉo","lundo","mardo","merkredo","ĵaŭdo","vendredo","sabato"],daysShort:["dim.","lun.","mar.","mer.","ĵaŭ.","ven.","sam."],daysMin:["d","l","ma","me","ĵ","v","s"],months:["januaro","februaro","marto","aprilo","majo","junio","julio","aŭgusto","septembro","oktobro","novembro","decembro"],monthsShort:["jan.","feb.","mar.","apr.","majo","jun.","jul.","aŭg.","sep.","okt.","nov.","dec."],today:"Hodiaŭ",clear:"Nuligi",weekStart:1,format:"yyyy-mm-dd"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-ZA"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:1,format:"yyyy/mm/d"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-NZ"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:1,format:"d/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-IE"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-GB"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-CA"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:0,format:"yyyy-mm-dd"}}(jQuery);
!function(a){a.fn.datepicker.dates["en-AU"]={days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",monthsTitle:"Months",clear:"Clear",weekStart:1,format:"d/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.el={days:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"],daysShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],daysMin:["Κυ","Δε","Τρ","Τε","Πε","Πα","Σα"],months:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],monthsShort:["Ιαν","Φεβ","Μαρ","Απρ","Μάι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],today:"Σήμερα",clear:"Καθαρισμός",weekStart:1,format:"d/m/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.de={days:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],daysShort:["Son","Mon","Die","Mit","Don","Fre","Sam"],daysMin:["So","Mo","Di","Mi","Do","Fr","Sa"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthsShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],today:"Heute",monthsTitle:"Monate",clear:"Löschen",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.da={days:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],daysShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],daysMin:["Sø","Ma","Ti","On","To","Fr","Lø"],months:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],today:"I Dag",weekStart:1,clear:"Nulstil",format:"dd/mm/yyyy",monthsTitle:"Måneder"}}(jQuery);
!function(a){a.fn.datepicker.dates.cy={days:["Sul","Llun","Mawrth","Mercher","Iau","Gwener","Sadwrn"],daysShort:["Sul","Llu","Maw","Mer","Iau","Gwe","Sad"],daysMin:["Su","Ll","Ma","Me","Ia","Gwe","Sa"],months:["Ionawr","Chewfror","Mawrth","Ebrill","Mai","Mehefin","Gorfennaf","Awst","Medi","Hydref","Tachwedd","Rhagfyr"],monthsShort:["Ion","Chw","Maw","Ebr","Mai","Meh","Gor","Aws","Med","Hyd","Tach","Rha"],today:"Heddiw"}}(jQuery);
!function(a){a.fn.datepicker.dates.cs={days:["Neděle","Pondělí","Úterý","Středa","Čtvrtek","Pátek","Sobota"],daysShort:["Ned","Pon","Úte","Stř","Čtv","Pát","Sob"],daysMin:["Ne","Po","Út","St","Čt","Pá","So"],months:["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"],monthsShort:["Led","Úno","Bře","Dub","Kvě","Čer","Čnc","Srp","Zář","Říj","Lis","Pro"],today:"Dnes",clear:"Vymazat",monthsTitle:"Měsíc",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.ca={days:["Diumenge","Dilluns","Dimarts","Dimecres","Dijous","Divendres","Dissabte"],daysShort:["Diu","Dil","Dmt","Dmc","Dij","Div","Dis"],daysMin:["dg","dl","dt","dc","dj","dv","ds"],months:["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],monthsShort:["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"],today:"Avui",monthsTitle:"Mesos",clear:"Esborrar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.bs={days:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],daysShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],daysMin:["N","Po","U","Sr","Č","Pe","Su"],months:["Januar","Februar","Mart","April","Maj","Juni","Juli","August","Septembar","Oktobar","Novembar","Decembar"],monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],today:"Danas",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.br={days:["Sul","Lun","Meurzh","Merc'her","Yaou","Gwener","Sadorn"],daysShort:["Sul","Lun","Meu.","Mer.","Yao.","Gwe.","Sad."],daysMin:["Su","L","Meu","Mer","Y","G","Sa"],months:["Genver","C'hwevrer","Meurzh","Ebrel","Mae","Mezheven","Gouere","Eost","Gwengolo","Here","Du","Kerzu"],monthsShort:["Genv.","C'hw.","Meur.","Ebre.","Mae","Mezh.","Goue.","Eost","Gwen.","Here","Du","Kerz."],today:"Hiziv",monthsTitle:"Miz",clear:"Dilemel",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.bn={days:["রবিবার","সোমবার","মঙ্গলবার","বুধবার","বৃহস্পতিবার","শুক্রবার","শনিবার"],daysShort:["রবিবার","সোমবার","মঙ্গলবার","বুধবার","বৃহস্পতিবার","শুক্রবার","শনিবার"],daysMin:["রবি","সোম","মঙ্গল","বুধ","বৃহস্পতি","শুক্র","শনি"],months:["জানুয়ারী","ফেব্রুয়ারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","অগাস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"],monthsShort:["জানুয়ারী","ফেব্রুয়ারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","অগাস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"],today:"আজ",monthsTitle:"মাস",clear:"পরিষ্কার",weekStart:0,format:"mm/dd/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.bg={days:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"],daysShort:["Нед","Пон","Вто","Сря","Чет","Пет","Съб"],daysMin:["Н","П","В","С","Ч","П","С"],months:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],monthsShort:["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],today:"днес"}}(jQuery);
!function(a){a.fn.datepicker.dates.az={days:["Bazar","Bazar ertəsi","Çərşənbə axşamı","Çərşənbə","Cümə axşamı","Cümə","Şənbə"],daysShort:["B.","B.e","Ç.a","Ç.","C.a","C.","Ş."],daysMin:["B.","B.e","Ç.a","Ç.","C.a","C.","Ş."],months:["Yanvar","Fevral","Mart","Aprel","May","İyun","İyul","Avqust","Sentyabr","Oktyabr","Noyabr","Dekabr"],monthsShort:["Yan","Fev","Mar","Apr","May","İyun","İyul","Avq","Sen","Okt","Noy","Dek"],today:"Bu gün",weekStart:1}}(jQuery);
!function(a){a.fn.datepicker.dates.ar={days:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","الأحد"],daysShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت","أحد"],daysMin:["ح","ن","ث","ع","خ","ج","س","ح"],months:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthsShort:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],today:"هذا اليوم",rtl:!0}}(jQuery);
!function(a){a.fn.datepicker.dates["ar-tn"]={days:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","الأحد"],daysShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت","أحد"],daysMin:["ح","ن","ث","ع","خ","ج","س","ح"],months:["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويليه","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthsShort:["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويليه","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],today:"هذا اليوم",rtl:!0}}(jQuery);
var config;
var data;
var svgScaleFactor = 1;
var font = '"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif';
var patternIdx = 1;

function drawChart(_config, _data) {
    if (_data && _config) {
        config = {};
        config.id = _config.id;
        config.elemWidth = _config.elemWidth;
        config.debugLayout = (_config.debugLayout !== undefined) ? _config.debugLayout : false;
        config.animation = (_config.animation !== undefined) ? _config.animation : true;
        config.orientation = (_config.orientation) ? _config.orientation : 'vertical';
        config.seriesLayout = (_config.seriesLayout) ? _config.seriesLayout : 'stacked';
        config.width = _config.width;
        config.height = _config.height;
        config.viewBox = '0 0 ' + config.width + ' ' + config.height;
        config.preserveAspectRatio = (_config.preserveAspectRatio) ? _config.preserveAspectRatio : 'xMinYMin meet';
        config.fixedWidth = (_config.fixedWidth !== undefined) ? _config.fixedWidth : false;
        config.fixedHeight = (_config.fixedHeight !== undefined) ? _config.fixedHeight : false;
        config.showLegend = (_config.showLegend !== undefined) ? _config.showLegend : true;
        config.download = (_config.download !== undefined) ? _config.download : false;
        config.padding = {
            top: (_config.padding && _config.padding.top !== undefined) ? _config.padding.top : 15,
            bottom: (_config.padding && _config.padding.bottom !== undefined) ? _config.padding.bottom : 15,
            left: (_config.padding && _config.padding.left !== undefined) ? _config.padding.left : 15,
            right: (_config.padding && _config.padding.right !== undefined) ? _config.padding.right : 15
        };
        config.chartTitle = _config.chartTitle;
        config.fontSize = {
            chartTitle: (_config.chartTitleFontSize) ? _config.chartTitleFontSize : 14,
            legend: (_config.legendFontSize) ? _config.legendFontSize : 12,
            axisLabel: (_config.axisLabelFontSize) ? _config.axisLabelFontSize : 12,
            tickLabel: (_config.axisScaleLabelFontSize) ? _config.axisScaleLabelFontSize : 10,
            noDataFoundMessg: (_config.noDataFoundMessg) ? _config.noDataFoundMessg : 13
        };
        config.fontWeight = {
            chartTitle: 600,
            legend: 600,
            axisLabel: 600,
            tickLabel: 400,
            tickLabelHighlight: 800
        }
        config.highlightColor = (_config.highlightColor) ? _config.highlightColor : '#ff0000';
        config.highlightStrokeWidth = 2;
        config.highlightLegendText = (_config.highlightLegendText) ? _config.highlightLegendText : null;
        config.textPadding = 10;
        config.minBarSize = (_config.minBarSize !== undefined) ? _config.minBarSize : 0,
        config.mark = {
            inverseColor: (_config.markInverseColor) ? _config.markInverseColor : '#ffffff',
            radius: (_config.markRadius !== undefined) ? _config.markRadius : 6,
            strokeWidth: (_config.markStrokeWidth !== undefined) ? _config.markStrokeWidth : 2
        }
        config.xAxis = {};
        config.yAxis = {};
        if (config.orientation === 'vertical') {
            //if vertical valueAxis = yAxis
            if (_config.valueAxisPosn) {
                config.yAxis.primaryAxisPosn = _config.valueAxisPosn;
            } else if (_config.valueAxisPrimaryPosn) {
                config.yAxis.primaryAxisPosn = _config.valueAxisPrimaryPosn;
            }
            if (_config.valueAxisSecondaryPosn && config.seriesLayout !== 'stacked') {
                config.yAxis.secondaryAxisPosn = _config.valueAxisSecondaryPosn;
            }
            config.yAxis.primaryLabel = (_config.valueAxisLabel) ? _config.valueAxisLabel : _config.valueAxisPrimaryLabel;
            config.yAxis.primaryTicksNum = (_config.valueAxisScaleTicksNum) ? _config.valueAxisScaleTicksNum : ((_config.valueAxisPrimaryScaleTicksNum) ? _config.valueAxisPrimaryScaleTicksNum : 5);
            config.yAxis.showPrimaryTickLabels = (_config.showValueAxisScaleLabels !== undefined) ? _config.showValueAxisScaleLabels : ((_config.showValueAxisPrimaryScaleLabels !== undefined) ? _config.showValueAxisPrimaryScaleLabels : true);
            config.yAxis.primaryTickLabelPrefix = (_config.valueAxisScaleLabelPrefix) ? _config.valueAxisScaleLabelPrefix : _config.valueAxisPrimaryScaleLabelPrefix;
            config.yAxis.primaryTickLabelSuffix = (_config.valueAxisScaleLabelSuffix) ? _config.valueAxisScaleLabelSuffix : _config.valueAxisPrimaryScaleLabelSuffix;
            if (config.seriesLayout !== 'stacked') {
                config.yAxis.secondaryLabel = _config.valueAxisSecondaryLabel;
                config.yAxis.secondaryTicksNum = (_config.valueAxisSecondaryScaleTicksNum) ? _config.valueAxisSecondaryScaleTicksNum : 5;
                config.yAxis.showSecondaryTickLabels = (_config.showValueAxisSecondaryScaleLabels !== undefined) ? _config.showValueAxisSecondaryScaleLabels : true;
                config.yAxis.secondaryTickLabelPrefix = _config.valueAxisSecondaryScaleLabelPrefix;
                config.yAxis.secondaryTickLabelSuffix = _config.valueAxisSecondaryScaleLabelSuffix;
            }
            
            config.xAxis.primary = true;
            if (_config.catgAxisPosn) {
                config.xAxis.primaryAxisPosn = _config.catgAxisPosn;
            }
            config.xAxis.primaryLabel = _config.catgAxisLabel;
            config.xAxis.showPrimaryTickLabels = (_config.showCatgAxisScaleLabels !== undefined) ? _config.showCatgAxisScaleLabels : true;
        } else {
            //if horizontal valueAxis = xAxis
            if (_config.valueAxisPosn) {
                config.xAxis.primaryAxisPosn = _config.valueAxisPosn;
            } else if (_config.valueAxisPrimaryPosn) {
                config.xAxis.primaryAxisPosn = _config.valueAxisPrimaryPosn;
            }
            if (_config.valueAxisSecondaryPosn && config.seriesLayout !== 'stacked') {
                config.xAxis.secondaryAxisPosn = _config.valueAxisSecondaryPosn;
            }
            config.xAxis.primaryLabel = (_config.valueAxisLabel) ? _config.valueAxisLabel : _config.valueAxisPrimaryLabel;
            config.xAxis.primaryTicksNum = (_config.valueAxisScaleTicksNum) ? _config.valueAxisScaleTicksNum : ((_config.valueAxisPrimaryScaleTicksNum) ? _config.valueAxisPrimaryScaleTicksNum : 5);
            config.xAxis.showPrimaryTickLabels = (_config.showValueAxisScaleLabels !== undefined) ? _config.showValueAxisScaleLabels : ((_config.showValueAxisPrimaryScaleLabels !== undefined) ? _config.showValueAxisPrimaryScaleLabels : true);
            config.xAxis.primaryTickLabelPrefix = (_config.valueAxisScaleLabelPrefix) ? _config.valueAxisScaleLabelPrefix : _config.valueAxisPrimaryScaleLabelPrefix;
            config.xAxis.primaryTickLabelSuffix = (_config.valueAxisScaleLabelSuffix) ? _config.valueAxisScaleLabelSuffix : _config.valueAxisPrimaryScaleLabelSuffix;
            if (config.seriesLayout !== 'stacked') {
                config.xAxis.secondaryLabel = _config.valueAxisSecondaryLabel;
                config.xAxis.secondaryTicksNum = (_config.valueAxisSecondaryScaleTicksNum) ? _config.valueAxisSecondaryScaleTicksNum : 5;
                config.xAxis.showSecondaryTickLabels = (_config.showValueAxisSecondaryScaleLabels !== undefined) ? _config.showValueAxisSecondaryScaleLabels : true;
                config.xAxis.secondaryTickLabelPrefix = _config.valueAxisSecondaryScaleLabelPrefix;
                config.xAxis.secondaryTickLabelSuffix = _config.valueAxisSecondaryScaleLabelSuffix;
            }
            
            config.yAxis.primary = true;
            if (_config.catgAxisPosn) {
                config.yAxis.primaryAxisPosn = _config.catgAxisPosn;
            }
            config.yAxis.primaryLabel = _config.catgAxisLabel;
            config.yAxis.showPrimaryTickLabels = (_config.showCatgAxisScaleLabels !== undefined) ? _config.showCatgAxisScaleLabels : true;
            config.yAxis.tickLabelMaxWidth = (config.yAxis.showPrimaryTickLabels) ? (_config.catgAxisScaleLabelMaxWidth) ? _config.catgAxisScaleLabelMaxWidth : (config.width * 0.75) : 0;
        }
        config.axisStrokeWidth = 1;
        config.showGridlines = (_config.showGridlines !== undefined) ? _config.showGridlines : true;
        config.tickSize = 8;
        config.tickPadding = 3;
        config.maxValuePrimary = (_config.valueAxisMaxVal !== undefined) ? _config.valueAxisMaxVal : _config.valueAxisPrimaryMaxVal;
        config.maxValueSecondary = _config.valueAxisSecondaryMaxVal;
        config.barPadding = 0.3;
        config.opacityHighlight = 1;
        config.opacity = 0.7;
        config.textColor = (_config.textColor) ? _config.textColor : '#676A6C';
        config.lineColor = (_config.lineColor) ? _config.lineColor : '#676A6C';
        config.gridlineColor = (_config.gridlineColor) ? _config.gridlineColor : '#DDDDDD';
        config.enableClick = (_config.enableClick != undefined) ? _config.enableClick : false;

        data = _data;
        if (data.series) {
            data.visibleSeries = []; //array of series to plot on chart
            for (var i = 0; i < data.series.length; i++) {
                var series = data.series[i];
                series.visible = (series.visible !== undefined) ? series.visible : true;
                series.seriesType = (series.seriesType) ? series.seriesType : 'bar';
                series.axis = (series.axis) ? series.axis : 'primary';
                if (series.axis === 'primary') {
                    if (config.orientation === 'vertical') {
                        config.yAxis.primary = true;
                    } else {
                        config.xAxis.primary = true;
                    }
                }
                if (series.axis === 'secondary' && config.seriesLayout !== 'stacked') {
                    if (config.orientation === 'vertical') {
                        config.yAxis.secondary = true;
                    } else {
                        config.xAxis.secondary = true;
                    }
                }
                if (series.visible) {
                    data.visibleSeries.push(series);
                }
            }
        }
        
        svgScaleFactor = (config.width / config.elemWidth);
        
        var svg = d3.select('#' + config.id)
            .append('svg')
            .attr('id', config.id + '_svg')
            .attr('class', 'chart-svg')
            .attr('viewBox', config.viewBox);
  
        if (config.preserveAspectRatio) {
            svg.attr('preserveAspectRatio', config.preserveAspectRatio);
        }
        if (config.fixedWidth) {
            svg.attr('width', config.width);
        }
        if (config.fixedHeight) {
            svg.attr('height', config.height);
        }
  
        svg.append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', config.width)
            .attr('height', config.height)
            .attr('fill', 'white');
        if (config.elemWidth) {
            if (data.series && data.series.length > 0) {
                drawChartElements(svg);
            } else {
                drawNoDataFoundMessg(svg, data.noDataFoundMessg);
            }
        }
    }
}

function drawNoDataFoundMessg(svg, msg) {
    //Chart Title
    if (config.chartTitle) {
        var chartTitleWidth = config.width - ((config.padding.left + config.padding.right) * svgScaleFactor);
        var chartTitleHeight = measure(config.chartTitle, chartTitleWidth, config.fontSize.chartTitle * svgScaleFactor, config.fontWeight.chartTitle).height;
        chartTitleBlock = {
            x: config.padding.left * svgScaleFactor,
            y: config.padding.top * svgScaleFactor,
            width: chartTitleWidth,
            height: chartTitleHeight
        };
        addTextBlock(svg, config.chartTitle, chartTitleBlock, 0, config.fontSize.chartTitle * svgScaleFactor, config.fontWeight.chartTitle, 'left');
        chartTitleBlock.height += config.padding.top * svgScaleFactor;
        svg.append('line')
            .attr('x1', 0)
            .attr('y1', chartTitleBlock.y + chartTitleBlock.height)
            .attr('x2', config.width)
            .attr('y2', chartTitleBlock.y + chartTitleBlock.height)
            .attr('stroke', '#e7eaec')
            .attr('stroke-width', 1 * svgScaleFactor);
    }
    svg.append('svg:foreignObject')
        .attr('width', config.width)
        .attr('height', config.height)
        .attr('x', 0)
        .attr('y', 0)
        .append('xhtml:div')
            .attr('class', 'alert message-info')
            .attr('style', 'position: absolute; overflow-wrap: break-word; left: 25%; right: 25%; top: 25%; padding: 15px; font-size: ' + config.fontSize.noDataFoundMessg * svgScaleFactor + 'px;')
            .append('xhtml:span')
                .html(msg);
}

function drawChartElements(svg) {
    patternIdx = 1;
    var tooltip = d3.select('#chart-tip');
    if (!tooltip.node()) {
        tooltip = d3.select('body')
            .append('div')
            .attr('id', 'chart-tip')
            .attr('class', 'chart-tip')
            .style('position', 'absolute')
            .style('z-index', '1000')
            .style('visibility', 'hidden');
    }
    data.categories = getAllCategories(data);
    var maxValuePrimary = (config.maxValuePrimary !== undefined) ? config.maxValuePrimary : calculateMaxVal(data, 'primary', config.seriesLayout);
    var maxValueSecondary = (config.maxValueSecondary !== undefined) ? config.maxValueSecondary : calculateMaxVal(data, 'secondary', config.seriesLayout);
    //add extra padding to right if chart is horizontal for tick label
    if (config.orientation === 'horizontal' && config.xAxis.showPrimaryTickLabels) {
        var maxValueTickLabel = (config.xAxis.primaryTickLabelPrefix ? config.xAxis.primaryTickLabelPrefix : '') + maxValuePrimary + (config.xAxis.primaryTickLabelSuffix ? config.xAxis.primaryTickLabelSuffix : '');
        config.padding.right += (measure(maxValueTickLabel, -1, config.fontSize.tickLabel * svgScaleFactor, config.fontWeight.tickLabel).width / 2);
    }
    
    var chartTitleBlock = {
        height: 0
    };
    var chartTitlePaddingBlock = {
        height: 0
    };
    //Chart Title
    if (config.chartTitle) {
        var chartTitleWidth = config.width - ((config.padding.left + config.padding.right) * svgScaleFactor);
        if (config.download && config.padding.left + 25 > config.padding.right) {
            chartTitleWidth -= ((config.padding.left + 25 - config.padding.right) * svgScaleFactor);
        }
        var chartTitleHeight = measure(config.chartTitle, chartTitleWidth, config.fontSize.chartTitle * svgScaleFactor, config.fontWeight.chartTitle).height;
        chartTitleBlock = {
            x: config.padding.left * svgScaleFactor,
            y: config.padding.top * svgScaleFactor,
            width: chartTitleWidth,
            height: chartTitleHeight
        };
        addTextBlock(svg, config.chartTitle, chartTitleBlock, 0, config.fontSize.chartTitle * svgScaleFactor, config.fontWeight.chartTitle, 'left');
        chartTitleBlock.height += config.padding.top * svgScaleFactor;
        svg.append('line')
            .attr('x1', 0)
            .attr('y1', chartTitleBlock.y + chartTitleBlock.height)
            .attr('x2', config.width)
            .attr('y2', chartTitleBlock.y + chartTitleBlock.height)
            .attr('stroke', '#e7eaec')
            .attr('stroke-width', 1 * svgScaleFactor);
        chartTitlePaddingBlock.height = config.padding.top * svgScaleFactor;
    }
  
    //legend
    var legendBlock = {
        height: 0
    };
    var legendPaddingBlock = {
        height: 0
    };
    //draw legend if multiple series, or an element in series 1 has a highlight
    if (config.showLegend && data.series && (data.series.length > 1 || config.highlightLegendText)) {
        var allLegendText = '';
        if (data.series.length > 1) {
            for (i = 0; i < data.series.length; i++) {
                allLegendText += data.series[i].seriesName;
            };
        }
        if (config.highlightLegendText) {
            allLegendText += config.highlightLegendText;
        }
        var legendWidth = config.width - ((config.padding.left + config.padding.right) * svgScaleFactor);
        var legendLineHeight = measure(allLegendText, -1, config.fontSize.legend * svgScaleFactor, config.fontWeight.legend).height;
        var padding = legendLineHeight * 0.15;
        var legendG = svg.append('g')
            .attr('name', 'legend');
        var seriesLegends = [];
        if (data.series.length > 1) {
            for (i = 0; i < data.series.length; i++) {
                var seriesLegendG = legendG.append('g');
                seriesLegendG.append('rect')
                    .attr('x', 0)
                    .attr('y', padding)
                    .attr('rx', padding)
                    .attr('ry', padding)
                    .attr('width', legendLineHeight - (padding * 2))
                    .attr('height', legendLineHeight - (padding * 2))
                    .attr('fill', data.series[i].seriesColor)
                    .attr('fill-opacity', (data.series[i].visible) ? config.opacity : 0)
                    .attr('stroke', (data.series[i].visible) ? 'none' : data.series[i].seriesColor)
                    .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor)
                    .attr('stroke-opacity', (!data.series[i].visible) ? config.opacity : 0)
                    .attr('chart-id', config.id)
                    .attr('series', i)
                    .attr('cursor', 'pointer')
                    .on('click', function(d, idx, nodes) {
                        var chartId = d3.select(nodes[idx]).attr('chart-id');
                        var series = d3.select(nodes[idx]).attr('series');
                        document.getElementById(chartId).setAttribute('toggle-series-visibility', series);
                    });
                seriesLegendG.append('text')
                    .attr('x', legendLineHeight)
                    .attr('y', '1em')
                    .attr('fill', config.textColor)
                    .attr('font-size', config.fontSize.legend * svgScaleFactor)
                    .attr('font-weight', config.fontWeight.legend)
                    .attr('font-family', font)
                    .attr('chart-id', config.id)
                    .attr('series', i)
                    .attr('cursor', 'pointer')
                    .text(data.series[i].seriesName)
                    .call(truncate, legendWidth - legendLineHeight)
                    .on('click', function(d, idx, nodes) {
                        var chartId = d3.select(nodes[idx]).attr('chart-id');
                        var series = d3.select(nodes[idx]).attr('series');
                        document.getElementById(chartId).setAttribute('toggle-series-visibility', series);
                    });
                seriesLegends.push(seriesLegendG);
            };
        }
        if (config.highlightLegendText) {
            var highlightLegendG = legendG.append('g');
            highlightLegendG.append('rect')
                .attr('x', 0)
                .attr('y', padding)
                .attr('rx', padding)
                .attr('ry', padding)
                .attr('width', legendLineHeight - (padding * 2))
                .attr('height', legendLineHeight - (padding * 2))
                .attr('fill', 'none')
                .attr('stroke', config.highlightColor)
                .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor);
            highlightLegendG.append('text')
                .attr('x', legendLineHeight)
                .attr('y', '1em')
                .attr('fill', config.textColor)
                .attr('font-size', config.fontSize.legend * svgScaleFactor)
                .attr('font-weight', config.fontWeight.legend)
                .attr('font-family', font)
                .text(config.highlightLegendText)
                .call(truncate, legendWidth - legendLineHeight);
            seriesLegends.push(highlightLegendG);
        }
        var posX = 0;
        var posY = 0;
        for (i = 0; i < seriesLegends.length; i++) {
            var seriesLegendWidth = seriesLegends[i].node().getBBox().width;
            if (posX + seriesLegendWidth > legendWidth) {
                posX = 0;
                posY += legendLineHeight;
            }
            seriesLegends[i].attr('transform', 'translate(' + posX + ' ' + posY + ')');
            posX += seriesLegendWidth + legendLineHeight;
        }
        legendBlock = {
            x: config.padding.left * svgScaleFactor,
            y: config.height - (legendLineHeight + posY) - (config.padding.bottom * svgScaleFactor),
            width: legendWidth,
            height: legendLineHeight + posY
        };
        legendG.attr('transform', 'translate(' + legendBlock.x + ' ' + legendBlock.y + ')');
        legendBlock.y -= config.padding.bottom * svgScaleFactor;
        legendBlock.height += config.padding.bottom * svgScaleFactor;
        drawRectangle(legendG, {x: 0, y: 0, width: legendWidth, height: legendLineHeight}, 0, 'brown');
        svg.append('line')
            .attr('x1', 0)
            .attr('y1', legendBlock.y)
            .attr('x2', config.width)
            .attr('y2', legendBlock.y)
            .attr('stroke', '#e7eaec')
            .attr('stroke-width', 1 * svgScaleFactor);
        legendPaddingBlock.height = config.padding.bottom * svgScaleFactor;
    }
  
    //measure tick label blocks
    var xAxisPrimaryTickBlock = {
        height: config.xAxis.primary ? (config.tickSize + config.tickPadding) * svgScaleFactor : 0
    };
    var xAxisPrimaryTickLabelBlock = {
        height: 0
    };
    var xAxisPrimaryLabelPaddingBlock = {
        height: 0
    };
    var xAxisPrimaryLabelBlock = {
        height: 0
    };
    var xAxisPrimaryPaddingBlock = {
        height: 0
    };
    
    var xAxisSecondaryTickBlock = {
        height: config.xAxis.secondary ? (config.tickSize + config.tickPadding) * svgScaleFactor : 0
    };
    var xAxisSecondaryTickLabelBlock = {
        height: 0
    };
    var xAxisSecondaryLabelPaddingBlock = {
        height: 0
    };
    var xAxisSecondaryLabelBlock = {
        height: 0
    };
    var xAxisSecondaryPaddingBlock = {
        height: 0
    };
    
    var yAxisPrimaryTickBlock = {
        width: config.yAxis.primary ? (config.tickSize + config.tickPadding) * svgScaleFactor : 0
    };
    var yAxisPrimaryTickLabelBlock = {
        width: 0
    };
    var yAxisPrimaryLabelPaddingBlock = {
        width: 0
    };
    var yAxisPrimaryLabelBlock = {
        width: 0
    };
    var yAxisPrimaryPaddingBlock = {
        width: 0
    };

    var yAxisSecondaryTickBlock = {
        width: config.yAxis.secondary ? (config.tickSize + config.tickPadding) * svgScaleFactor : 0
    };
    var yAxisSecondaryTickLabelBlock = {
        width: 0
    };
    var yAxisSecondaryLabelPaddingBlock = {
        width: 0
    };
    var yAxisSecondaryLabelBlock = {
        width: 0
    };
    var yAxisSecondaryPaddingBlock = {
        width: 0
    };

    if (config.orientation === 'vertical') {
        if (config.xAxis.showPrimaryTickLabels) {
            for (i = 0; i < data.categories.length; i++) {
                var category = data.categories[i];
                var fontWeight;
                if (!category.highlight) {
                    fontWeight = config.fontWeight.tickLabel;
                } else {
                    fontWeight = config.fontWeight.tickLabelHighlight;
                }
                xAxisPrimaryTickLabelBlock.height = Math.max(xAxisPrimaryTickLabelBlock.height, measure((category.label) ? category.label : category.val, -1, config.fontSize.tickLabel * svgScaleFactor, fontWeight).height);
            }
        }
        if (config.yAxis.primary && config.yAxis.showPrimaryTickLabels) {
            yAxisPrimaryTickLabelBlock.width = measure((config.yAxis.primaryTickLabelPrefix ? config.yAxis.primaryTickLabelPrefix : '') + maxValuePrimary + (config.yAxis.primaryTickLabelSuffix ? config.yAxis.primaryTickLabelSuffix : ''), -1, config.fontSize.tickLabel * svgScaleFactor, config.fontWeight.tickLabel).width;
        }
        if (config.yAxis.secondary && config.yAxis.showSecondaryTickLabels) {
            yAxisSecondaryTickLabelBlock.width = measure((config.yAxis.secondaryTickLabelPrefix ? config.yAxis.secondaryTickLabelPrefix : '') + maxValueSecondary + (config.yAxis.secondaryTickLabelSuffix ? config.yAxis.secondaryTickLabelSuffix : ''), -1, config.fontSize.tickLabel * svgScaleFactor, config.fontWeight.tickLabel).width;
        }
    } else { //horizontal
        if (config.xAxis.primary && config.xAxis.showPrimaryTickLabels) {
            xAxisPrimaryTickLabelBlock.height = measure('0', -1, config.fontSize.tickLabel * svgScaleFactor, config.fontWeight.tickLabel).height;
        }
        if (config.xAxis.secondary && config.xAxis.showSecondaryTickLabels) {
            xAxisSecondaryTickLabelBlock.height = measure('0', -1, config.fontSize.tickLabel * svgScaleFactor, config.fontWeight.tickLabel).height;
        }
        if (config.yAxis.showPrimaryTickLabels) {
            for (i = 0; i < data.categories.length; i++) {
                var category = data.categories[i];
                var fontWeight;
                if (!category.highlight) {
                    fontWeight = config.fontWeight.tickLabel;
                } else {
                    fontWeight = config.fontWeight.tickLabelHighlight;
                }
                yAxisPrimaryTickLabelBlock.width = Math.max(yAxisPrimaryTickLabelBlock.width, measure((category.label) ? category.label : category.val, -1, config.fontSize.tickLabel * svgScaleFactor, fontWeight).width);
            }
            if (!config.yAxis.primaryAxisPosn) {
                yAxisPrimaryTickLabelBlock.width = Math.min(yAxisPrimaryTickLabelBlock.width, config.yAxis.tickLabelMaxWidth);
            }
        }
    }

    //calculate axes positions
    var chartOrigin = {
        left: config.yAxis.primaryAxisPosn ? config.yAxis.primaryAxisPosn : 0,
        leftFixed: (config.yAxis.primary && config.yAxis.primaryAxisPosn === undefined) ? false : true,
        right: config.yAxis.secondaryAxisPosn ? config.yAxis.secondaryAxisPosn : 0,
        rightFixed: (config.yAxis.secondary && config.yAxis.secondaryAxisPosn === undefined) ? false : true,
        bottom: config.xAxis.primaryAxisPosn ? config.xAxis.primaryAxisPosn : 0,
        bottomFixed: (config.xAxis.primary && config.xAxis.primaryAxisPosn === undefined) ? false : true,
        top: config.xAxis.secondaryAxisPosn ? config.xAxis.secondaryAxisPosn : 0,
        topFixed: (config.xAxis.secondary && config.xAxis.secondaryAxisPosn === undefined) ? false : true,
    }
    if (config.xAxis.primaryLabel) {
        xAxisPrimaryLabelPaddingBlock.height = config.textPadding * svgScaleFactor;
    }
    if (config.xAxis.secondaryLabel) {
        xAxisSecondaryLabelPaddingBlock.height = config.textPadding * svgScaleFactor;
    }
    if (config.yAxis.primaryLabel) {
        yAxisPrimaryLabelPaddingBlock.width = config.textPadding * svgScaleFactor;
    }
    if (config.yAxis.secondaryLabel) {
        yAxisSecondaryLabelPaddingBlock.width = config.textPadding * svgScaleFactor;
    }
    var startXAxisWidth = config.width - ((config.padding.left + config.padding.right) * svgScaleFactor);
    if (!chartOrigin.leftFixed) {
        startXAxisWidth -= (yAxisPrimaryTickBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width);
    } else {
        startXAxisWidth -= (chartOrigin.left * svgScaleFactor);
    }
    if (!chartOrigin.rightFixed) {
        startXAxisWidth -= (yAxisSecondaryTickBlock.width + yAxisSecondaryTickLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width);
    } else {
        startXAxisWidth -= (chartOrigin.right * svgScaleFactor);
    }
    var startYAxisHeight = config.height - ((config.padding.top + config.padding.bottom) * svgScaleFactor) - (chartTitleBlock.height + chartTitlePaddingBlock.height + legendBlock.height + legendPaddingBlock.height);
    if (!chartOrigin.bottomFixed) {
        startYAxisHeight -= (xAxisPrimaryTickBlock.height + xAxisPrimaryTickLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height);
    } else {
        startYAxisHeight -= (chartOrigin.bottom * svgScaleFactor);
    }
    if (!chartOrigin.topFixed) {
        startYAxisHeight -= (xAxisSecondaryTickBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height);
    } else {
        startYAxisHeight -= (chartOrigin.top * svgScaleFactor);
    }
    var stable = false;
    xAxisPrimaryLabelBlock.width = startXAxisWidth;
    xAxisSecondaryLabelBlock.width = startXAxisWidth;
    yAxisPrimaryLabelBlock.height = startYAxisHeight;
    yAxisSecondaryLabelBlock.height = startYAxisHeight;
    prevHeightAdjust = 0;
    prevWidthAdjust = 0;
    var prevYAxisLabelHeight = 0;
    var breakCnt = 0;
    do { //iteratively measure x and y axis labels (with wrapping) until dimensions are stable
        var widthAdjust = 0;
        var heightAdjust = 0;
        xAxisPrimaryLabelBlock.height = measure(config.xAxis.primaryLabel, xAxisPrimaryLabelBlock.width, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel).height;
        if (!chartOrigin.bottomFixed) {
            heightAdjust += xAxisPrimaryLabelBlock.height;
        }
        xAxisSecondaryLabelBlock.height = measure(config.xAxis.secondaryLabel, xAxisSecondaryLabelBlock.width, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel).height;
        if (!chartOrigin.topFixed) {
            heightAdjust += xAxisSecondaryLabelBlock.height;
        }
        yAxisPrimaryLabelBlock.height = startYAxisHeight - heightAdjust;
        yAxisSecondaryLabelBlock.height = startYAxisHeight - heightAdjust;
        yAxisPrimaryLabelBlock.width = measure(config.yAxis.primaryLabel, yAxisPrimaryLabelBlock.height, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel).height;
        if (!chartOrigin.leftFixed) {
            widthAdjust += yAxisPrimaryLabelBlock.width;
        }
        yAxisSecondaryLabelBlock.width = measure(config.yAxis.secondaryLabel, yAxisSecondaryLabelBlock.height, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel).height;
        if (!chartOrigin.rightFixed) {
            widthAdjust += yAxisSecondaryLabelBlock.width;
        }
        xAxisPrimaryLabelBlock.width = startXAxisWidth - widthAdjust;
        xAxisSecondaryLabelBlock.width = startXAxisWidth - widthAdjust;
        if (heightAdjust === prevHeightAdjust && widthAdjust === prevWidthAdjust) {
            stable = true;
        } else {
            prevHeightAdjust = heightAdjust;
            prevWidthAdjust = widthAdjust;
        }
        if (breakCnt++ === 10) {
            console.log('cant get stable dimensions, so breaking');
            stable = true;
        }
    } while (!stable);

    //fit axis elements into fixed space (if necessary)
    if (config.xAxis.primary && config.xAxis.primaryAxisPosn) {
        var scaledXAxisPosn = config.xAxis.primaryAxisPosn * svgScaleFactor;
        if (scaledXAxisPosn >= xAxisPrimaryLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height + xAxisPrimaryTickLabelBlock.height + xAxisPrimaryTickBlock.height) {
            //add extra padding
            xAxisPrimaryPaddingBlock.height = scaledXAxisPosn - (xAxisPrimaryLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height + xAxisPrimaryTickLabelBlock.height + xAxisPrimaryTickBlock.height);
            xAxisPrimaryLabelBlock.y -= xAxisPrimaryPaddingBlock.height;
        } else if (scaledXAxisPosn > xAxisPrimaryLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height + xAxisPrimaryTickBlock.height) {
            //remove tick labels
            xAxisPrimaryTickLabelBlock.height = 0;
            config.xAxis.showPrimaryTickLabels = false;
            xAxisPrimaryPaddingBlock.height = scaledXAxisPosn - (xAxisPrimaryLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height + xAxisPrimaryTickBlock.height);
            xAxisPrimaryLabelBlock.y -= xAxisPrimaryPaddingBlock.height;
        } else if (scaledXAxisPosn >= xAxisPrimaryTickBlock.height) {
            //drop tick labels and axis label and add padding
            xAxisPrimaryTickLabelBlock.height = 0;
            config.xAxis.showPrimaryTickLabels = false;
            xAxisPrimaryLabelBlock.height = 0;
            xAxisPrimaryLabelPaddingBlock.height = 0;
            delete config.xAxis.primaryLabel;
            xAxisPrimaryPaddingBlock.height = scaledXAxisPosn - xAxisPrimaryTickBlock.height;
            xAxisPrimaryLabelBlock.y -= xAxisPrimaryPaddingBlock.height;
        } else {
            //drop tick labels and axis label and reduce width of ticks
            xAxisPrimaryTickLabelBlock.height = 0;
            config.xAxis.showPrimaryTickLabels = false;
            xAxisPrimaryLabelBlock.height = 0;
            xAxisPrimaryLabelPaddingBlock.height = 0;
            delete config.xAxis.primaryLabel;
        }
    }
    if (config.xAxis.secondary && config.xAxis.secondaryAxisPosn) {
        var scaledXAxisPosn = config.xAxis.secondaryAxisPosn * svgScaleFactor;
        if (scaledXAxisPosn >= xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height) {
            //add extra padding
            xAxisSecondaryPaddingBlock.height = scaledXAxisPosn - (xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height);
            xAxisSecondaryLabelBlock.y -= xAxisSecondaryPaddingBlock.height;
        } else if (scaledXAxisPosn > xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickBlock.height) {
            //remove tick labels
            xAxisSecondaryTickLabelBlock.height = 0;
            config.xAxis.showSecondaryTickLabels = false;
            xAxisSecondaryPaddingBlock.height = scaledXAxisPosn - (xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickBlock.height);
            xAxisSecondaryLabelBlock.y -= xAxisSecondaryPaddingBlock.height;
        } else if (scaledXAxisPosn >= xAxisSecondaryTickBlock.height) {
            //drop tick labels and axis label and add padding
            xAxisSecondaryTickLabelBlock.height = 0;
            config.xAxis.showSecondaryTickLabels = false;
            xAxisSecondaryLabelBlock.height = 0;
            xAxisSecondaryLabelPaddingBlock.height = 0;
            delete config.xAxis.secondaryLabel;
            xAxisSecondaryPaddingBlock.height = scaledXAxisPosn - xAxisSecondaryTickBlock.height;
            xAxisSecondaryLabelBlock.y -= xAxisSecondaryPaddingBlock.height;
        } else {
            //drop tick labels and axis label and reduce width of ticks
            xAxisSecondaryTickLabelBlock.height = 0;
            config.xAxis.showSecondaryTickLabels = false;
            xAxisSecondaryLabelBlock.height = 0;
            xAxisSecondaryLabelPaddingBlock.height = 0;
            delete config.xAxis.secondaryLabel;
        }
    }
    if (config.yAxis.primary && config.yAxis.primaryAxisPosn) {
        var scaledYAxisPosn = config.yAxis.primaryAxisPosn * svgScaleFactor;
        if (scaledYAxisPosn >= yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width) {
            //add extra padding
            yAxisPrimaryPaddingBlock.width = scaledYAxisPosn - (yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width);
            yAxisPrimaryLabelBlock.x += yAxisPrimaryPaddingBlock.width;
        } else if (scaledYAxisPosn > yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickBlock.width) {
            //reduce width of tick labels
            yAxisPrimaryTickLabelBlock.width = scaledYAxisPosn - (yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickBlock.width);
        } else if (scaledYAxisPosn >= yAxisPrimaryTickBlock.width) {
            //drop tick labels and axis label and add padding
            yAxisPrimaryTickLabelBlock.width = 0;
            config.yAxis.showPrimaryTickLabels = false;
            yAxisPrimaryLabelBlock.width = 0;
            yAxisPrimaryLabelPaddingBlock.width = 0;
            delete config.yAxis.primaryLabel;
            yAxisPrimaryPaddingBlock.width = scaledYAxisPosn - yAxisPrimaryTickBlock.width;
            yAxisPrimaryLabelBlock.x += yAxisPrimaryPaddingBlock.width;
        } else {
            //drop tick labels and axis label.  Axis will have to move
            yAxisPrimaryTickLabelBlock.width = 0;
            config.yAxis.showPrimaryTickLabels = false;
            yAxisPrimaryLabelBlock.width = 0;
            delete config.yAxis.primaryLabel;
        }
    }
    if (config.yAxis.secondary && config.yAxis.secondaryAxisPosn) {
        var scaledYAxisPosn = config.yAxis.secondaryAxisPosn * svgScaleFactor;
        if (scaledYAxisPosn >= yAxisSecondaryLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width + yAxisSecondaryTickLabelBlock.width + yAxisSecondaryTickBlock.width) {
            //add extra padding
            yAxisSecondaryPaddingBlock.width = scaledYAxisPosn - (yAxisSecondaryLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width + yAxisSecondaryTickLabelBlock.width + yAxisSecondaryTickBlock.width);
            yAxisSecondaryLabelBlock.x += yAxisSecondaryPaddingBlock.width;
        } else if (scaledYAxisPosn > yAxisSecondaryLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width + yAxisSecondaryTickBlock.width) {
            //reduce width of tick labels
            yAxisSecondaryTickLabelBlock.width = scaledYAxisPosn - (yAxisSecondaryLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width + yAxisSecondaryTickBlock.width);
        } else if (scaledYAxisPosn >= yAxisSecondaryTickBlock.width) {
            //drop tick labels and axis label and add padding
            yAxisSecondaryTickLabelBlock.width = 0;
            config.yAxis.showSecondaryTickLabels = false;
            yAxisSecondaryLabelBlock.width = 0;
            yAxisSecondaryLabelPaddingBlock.width = 0;
            delete config.yAxis.secondaryLabel;
            yAxisSecondaryPaddingBlock.width = scaledYAxisPosn - yAxisSecondaryTickBlock.width;
            yAxisSecondaryLabelBlock.x += yAxisSecondaryPaddingBlock.width;
        } else {
            //drop tick labels and axis label.  Axis will have to move
            yAxisSecondaryTickLabelBlock.width = 0;
            config.yAxis.showSecondaryTickLabels = false;
            yAxisSecondaryLabelBlock.width = 0;
            delete config.yAxis.secondaryLabel;
        }
    }
    
    if (config.debugLayout) {
        xAxisPrimaryPaddingBlock.width = xAxisPrimaryLabelBlock.width;
        xAxisPrimaryPaddingBlock.x = (config.padding.left * svgScaleFactor) + yAxisPrimaryPaddingBlock.width + yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width;
        xAxisPrimaryPaddingBlock.y = config.height - (config.padding.bottom * svgScaleFactor) - (legendBlock.height + legendPaddingBlock.height) - xAxisPrimaryPaddingBlock.height;
        drawRectangle(svg, xAxisPrimaryPaddingBlock, 0, 'yellow');
    
        xAxisSecondaryPaddingBlock.width = xAxisSecondaryLabelBlock.width;
        xAxisSecondaryPaddingBlock.x = (config.padding.left * svgScaleFactor) + yAxisPrimaryPaddingBlock.width + yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width;
        xAxisSecondaryPaddingBlock.y = (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height);
        drawRectangle(svg, xAxisSecondaryPaddingBlock, 0, 'yellow');

        yAxisPrimaryPaddingBlock.height = yAxisPrimaryLabelBlock.height;
        yAxisPrimaryPaddingBlock.x = config.padding.left * svgScaleFactor;
        yAxisPrimaryPaddingBlock.y = (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height) + (xAxisSecondaryPaddingBlock.height + xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height);
        drawRectangle(svg, yAxisPrimaryPaddingBlock, 0, 'yellow');
    
        yAxisSecondaryPaddingBlock.height = yAxisSecondaryLabelBlock.height;
        yAxisSecondaryPaddingBlock.x = config.width - (config.padding.right * svgScaleFactor) - yAxisSecondaryPaddingBlock.width;
        yAxisSecondaryPaddingBlock.y = (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height) + (xAxisSecondaryPaddingBlock.height + xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height);
        drawRectangle(svg, yAxisSecondaryPaddingBlock, 0, 'yellow');
    }
    
    //axis labels
    if (config.xAxis.primary) {
        xAxisPrimaryLabelBlock.x = (config.padding.left * svgScaleFactor) + yAxisPrimaryPaddingBlock.width + yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width;
        xAxisPrimaryLabelBlock.y = config.height - (config.padding.bottom * svgScaleFactor) - (legendBlock.height + legendPaddingBlock.height) - (xAxisPrimaryPaddingBlock.height + xAxisPrimaryLabelBlock.height);
        addTextBlock(svg, config.xAxis.primaryLabel, xAxisPrimaryLabelBlock, 0, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel, 'middle');
    }
    if (config.xAxis.secondary) {
        xAxisSecondaryLabelBlock.x = (config.padding.left * svgScaleFactor) + yAxisPrimaryPaddingBlock.width + yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width;
        xAxisSecondaryLabelBlock.y = (config.padding.top * svgScaleFactor) + chartTitleBlock.height + chartTitlePaddingBlock.height + xAxisSecondaryPaddingBlock.height;
        addTextBlock(svg, config.xAxis.secondaryLabel, xAxisSecondaryLabelBlock, 0, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel, 'middle');
    }
    if (config.yAxis.primary) {
        yAxisPrimaryLabelBlock.x = config.padding.left * svgScaleFactor + yAxisPrimaryPaddingBlock.width;
        yAxisPrimaryLabelBlock.y = (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height) + (xAxisSecondaryPaddingBlock.height + xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height);
        //yAxisLabel is rotated so need to change values
        addTextBlock(svg, config.yAxis.primaryLabel, {
            x: yAxisPrimaryLabelBlock.x,
            y: yAxisPrimaryLabelBlock.y + yAxisPrimaryLabelBlock.height,
            height: yAxisPrimaryLabelBlock.width,
            width: yAxisPrimaryLabelBlock.height
        }, -90, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel, 'middle');
    }
    if (config.yAxis.secondary) {
        yAxisSecondaryLabelBlock.x = config.width - (config.padding.right * svgScaleFactor) - yAxisSecondaryLabelBlock.width - yAxisSecondaryPaddingBlock.width;
        yAxisSecondaryLabelBlock.y = (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height) + (xAxisSecondaryPaddingBlock.height + xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height);
        //yAxisLabel is rotated so need to change values
        addTextBlock(svg, config.yAxis.secondaryLabel, {
            x: yAxisSecondaryLabelBlock.x,
            y: yAxisSecondaryLabelBlock.y + yAxisSecondaryLabelBlock.height,
            height: yAxisSecondaryLabelBlock.width,
            width: yAxisSecondaryLabelBlock.height
        }, -90, config.fontSize.axisLabel * svgScaleFactor, config.fontWeight.axisLabel, 'middle');
    }
    
    //add chart element before axes so it draws underneath
    var chartBlock = {
        x: (config.padding.left * svgScaleFactor) + (yAxisPrimaryPaddingBlock.width + yAxisPrimaryLabelBlock.width + yAxisPrimaryLabelPaddingBlock.width + yAxisPrimaryTickLabelBlock.width + yAxisPrimaryTickBlock.width),
        y: (config.padding.top * svgScaleFactor) + (chartTitleBlock.height + chartTitlePaddingBlock.height) + (xAxisSecondaryPaddingBlock.height + xAxisSecondaryLabelBlock.height + xAxisSecondaryLabelPaddingBlock.height + xAxisSecondaryTickLabelBlock.height + xAxisSecondaryTickBlock.height)
    };
    chartBlock.width = config.width - chartBlock.x - (yAxisSecondaryPaddingBlock.width + yAxisSecondaryLabelBlock.width + yAxisSecondaryLabelPaddingBlock.width + yAxisSecondaryTickLabelBlock.width + yAxisSecondaryTickBlock.width) - (config.padding.right * svgScaleFactor);
    chartBlock.height = config.height - chartBlock.y - (legendBlock.height + legendPaddingBlock.height) - (xAxisPrimaryPaddingBlock.height + xAxisPrimaryLabelBlock.height + xAxisPrimaryLabelPaddingBlock.height + xAxisPrimaryTickLabelBlock.height + xAxisPrimaryTickBlock.height) - (config.padding.bottom * svgScaleFactor);
    var chartG = svg.append('g')
        .attr('transform', 'translate(' + chartBlock.x + ' ' + chartBlock.y + ')');
    drawRectangle(svg, chartBlock, 0, 'red');
  
    //axes
    if (config.xAxis.primary) {
        xAxisPrimaryTickBlock.x = chartBlock.x;
        xAxisPrimaryTickBlock.y = chartBlock.y + chartBlock.height;
        xAxisPrimaryTickBlock.width = chartBlock.width;
    }
    if (config.xAxis.secondary) {
        xAxisSecondaryTickBlock.x = chartBlock.x;
        xAxisSecondaryTickBlock.y = chartBlock.y;
        xAxisSecondaryTickBlock.width = chartBlock.width;
    }
    if (config.yAxis.primary) {
        yAxisPrimaryTickBlock.x = chartBlock.x;
        yAxisPrimaryTickBlock.y = chartBlock.y;
        yAxisPrimaryTickBlock.height = chartBlock.height;
    }
    if (config.yAxis.secondary) {
        yAxisSecondaryTickBlock.x = chartBlock.x + chartBlock.width;
        yAxisSecondaryTickBlock.y = chartBlock.y;
        yAxisSecondaryTickBlock.height = chartBlock.height;
    }
    var xScalePrimary;
    var xAxisPrimary;
    var xScalePrimary;
    var xAxisPrimary;
    var yScalePrimary;
    var yAxisPrimary;
    var yScalePrimary;
    var yAxisPrimary;
    if (config.orientation === 'vertical') {
        xScalePrimary = d3.scaleBand()
            .domain(data.categories.map(function(item) {
                return item.val
            }))
            .range([0, xAxisPrimaryTickBlock.width])
            .padding(config.barPadding);
        xAxisPrimary = d3.axisBottom(xScalePrimary)
            .tickFormat(function(d) {
                if (config.xAxis.showPrimaryTickLabels) {
                    var category = getCategory(d);
                    return (category.label) ? category.label : category.val;
                }
                return null;
            })
            .tickSize(config.tickSize * svgScaleFactor, 0);
        if (config.yAxis.primary) {
            yScalePrimary = d3.scaleLinear()
                .domain([0, maxValuePrimary])
                .range([yAxisPrimaryTickBlock.height, 0]);
            yAxisPrimary = d3.axisLeft(yScalePrimary)
                .tickFormat(function(d) {
                    if (config.yAxis.showPrimaryTickLabels) {
                        return (config.yAxis.primaryTickLabelPrefix ? config.yAxis.primaryTickLabelPrefix : '')
                            + d
                            + (config.yAxis.primaryTickLabelSuffix ? config.yAxis.primaryTickLabelSuffix : '');
                    }
                    return null;
                })
                .tickSize(config.tickSize * svgScaleFactor, 0)
                .ticks(config.yAxis.primaryTicksNum);
        }
        if (config.yAxis.secondary) {
            yScaleSecondary = d3.scaleLinear()
                .domain([0, maxValueSecondary])
                .range([yAxisSecondaryTickBlock.height, 0]);
            yAxisSecondary = d3.axisRight(yScaleSecondary)
                .tickFormat(function(d) {
                    if (config.yAxis.showSecondaryTickLabels) {
                        return (config.yAxis.secondaryTickLabelPrefix ? config.yAxis.secondaryTickLabelPrefix : '')
                            + d
                            + (config.yAxis.secondaryTickLabelSuffix ? config.yAxis.secondaryTickLabelSuffix : '');
                    }
                    return null;
                })
                .tickSize(config.tickSize * svgScaleFactor, 0)
                .ticks(config.yAxis.secondaryTicksNum);
        }
    } else if (config.orientation === 'horizontal') {
        if (config.xAxis.primary) {
            xScalePrimary = d3.scaleLinear()
                .domain([0, maxValuePrimary])
                .range([0, xAxisPrimaryTickBlock.width]);
            xAxisPrimary = d3.axisBottom(xScalePrimary)
                .tickFormat(function(d) {
                    if (config.xAxis.showPrimaryTickLabels) {
                        return (config.xAxis.primaryTickLabelPrefix ? config.xAxis.primaryTickLabelPrefix : '')
                            + d
                            + (config.xAxis.primaryTickLabelSuffix ? config.xAxis.primaryTickLabelSuffix : '');
                    }
                    return null;
                })
                .tickSize(config.tickSize * svgScaleFactor, 0)
                .ticks(config.xAxis.primaryTicksNum);
        }
        if (config.xAxis.secondary) {
            xScaleSecondary = d3.scaleLinear()
                .domain([0, maxValueSecondary])
                .range([0, xAxisSecondaryTickBlock.width]);
            xAxisSecondary = d3.axisTop(xScaleSecondary)
                .tickFormat(function(d) {
                    if (config.xAxis.showSecondaryTickLabels) {
                        return (config.xAxis.secondaryTickLabelPrefix ? config.xAxis.secondaryTickLabelPrefix : '')
                            + d
                            + (config.xAxis.secondaryTickLabelSuffix ? config.xAxis.secondaryTickLabelSuffix : '');
                    }
                    return null;
                })
                .tickSize(config.tickSize * svgScaleFactor, 0)
                .ticks(config.xAxis.secondaryTicksNum);
        }
        yScalePrimary = d3.scaleBand()
            .domain(data.categories.map(function(item) {
                return item.val
            }))
            .range([0, yAxisPrimaryTickBlock.height])
            .padding(config.barPadding);
        yAxisPrimary = d3.axisLeft(yScalePrimary)
            .tickFormat(function(d) {
                if (config.yAxis.showPrimaryTickLabels) {
                    var category = getCategory(d);
                    return (category.label) ? category.label : category.val;
                }
                return null;
            })
            .tickSize(config.tickSize * svgScaleFactor, 0);
    }
  
    if (config.xAxis.primary) {
        var xAxisPrimaryG = svg.append('g')
            .attr('transform', 'translate(' + xAxisPrimaryTickBlock.x + ' ' + xAxisPrimaryTickBlock.y + ')')
            .call(xAxisPrimary);
        xAxisPrimaryG
            .attr('font-size', null)
            .attr('font-family', null);
        xAxisPrimaryG.selectAll('path')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        xAxisPrimaryG.selectAll('line')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        xAxisPrimaryG.selectAll('text')
            .attr('font-size', config.fontSize.tickLabel * svgScaleFactor)
            .attr('font-family', font)
            .attr('font-weight', function(d) {
                if (config.orientation === 'vertical') { //xaxis = category axis
                    var category = getCategory(d);
                    if (category.highlight) {
                        return config.fontWeight.tickLabelHighlight;
                    }
                }
                return config.fontWeight.tickLabel;
            })
            .attr('fill', config.textColor)
            .attr('class', function(d) {
                if (config.orientation === 'vertical') { //xaxis = category axis
                    var category = getCategory(d);
                    if (category.cssClass) {
                        return category.cssClass;
                    }
                }
                return null;
            });
        if (config.orientation === 'vertical') { //truncate category labels if on x-axis
            xAxisPrimaryG.selectAll('text')
                .call(truncate, xScalePrimary.bandwidth());
        }
    }

    if (config.xAxis.secondary) {
        var xAxisSecondaryG = svg.append('g')
            .attr('transform', 'translate(' + xAxisSecondaryTickBlock.x + ' ' + xAxisSecondaryTickBlock.y + ')')
            .call(xAxisSecondary);
        xAxisSecondaryG
            .attr('font-size', null)
            .attr('font-family', null);
        xAxisSecondaryG.selectAll('path')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        xAxisSecondaryG.selectAll('line')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        xAxisSecondaryG.selectAll('text')
            .attr('font-size', config.fontSize.tickLabel * svgScaleFactor)
            .attr('font-family', font)
            .attr('font-weight', function(d) {
                return config.fontWeight.tickLabel;
            })
            .attr('fill', config.textColor)
    }
    
    if (config.yAxis.primary) {
        var yAxisPrimaryG = svg.append('g')
            .attr('transform', 'translate(' + yAxisPrimaryTickBlock.x + ' ' + yAxisPrimaryTickBlock.y + ')')
            .call(yAxisPrimary);
        yAxisPrimaryG
            .attr('font-size', null)
            .attr('font-family', null);
        yAxisPrimaryG.selectAll('path')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        yAxisPrimaryG.selectAll('line')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        yAxisPrimaryG.selectAll('text')
            .attr('font-size', config.fontSize.tickLabel * svgScaleFactor)
            .attr('font-family', font)
            .attr('font-weight', function(d) {
                if (config.orientation === 'horizontal') { //yaxis = category axis
                    var category = getCategory(d);
                    if (category.highlight) {
                        return config.fontWeight.tickLabelHighlight;
                    }
                }
                return config.fontWeight.tickLabel
            })
            .attr('fill', config.textColor)
            .attr('class', function(d) {
                if (config.orientation === 'horizontal') { //yaxis = category axis
                    var category = getCategory(d);
                    if (category.cssClass) {
                        return category.cssClass;
                    }
                }
                return null;
            })
            .call(truncate, yAxisPrimaryTickLabelBlock.width);
    }
    
    if (config.yAxis.secondary) {
        var yAxisSecondaryG = svg.append('g')
            .attr('transform', 'translate(' + yAxisSecondaryTickBlock.x + ' ' + yAxisSecondaryTickBlock.y + ')')
            .call(yAxisSecondary);
        yAxisSecondaryG
            .attr('font-size', null)
            .attr('font-family', null);
        yAxisSecondaryG.selectAll('path')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        yAxisSecondaryG.selectAll('line')
            .attr('stroke', config.lineColor)
            .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        yAxisSecondaryG.selectAll('text')
            .attr('font-size', config.fontSize.tickLabel * svgScaleFactor)
            .attr('font-family', font)
            .attr('font-weight', function(d) {
                return config.fontWeight.tickLabel
            })
            .attr('fill', config.textColor)
            .call(truncate, yAxisSecondaryTickLabelBlock.width);
    }
    
    if (config.xAxis.primary) {
      drawRectangle(svg, xAxisPrimaryTickBlock, 0, 'blue');
      drawRectangle(svg, {x: xAxisPrimaryTickBlock.x, y: xAxisPrimaryTickBlock.y + xAxisPrimaryTickBlock.height, width: xAxisPrimaryTickBlock.width, height: xAxisPrimaryTickLabelBlock.height}, 0, 'green');
    }
    if (config.xAxis.secondary) {
        drawRectangle(svg, {x: xAxisSecondaryTickBlock.x, y: xAxisSecondaryTickBlock.y - xAxisSecondaryTickBlock.height, width: xAxisSecondaryTickBlock.width, height: xAxisSecondaryTickLabelBlock.height}, 0, 'blue');
        drawRectangle(svg, {x: xAxisSecondaryTickBlock.x, y: xAxisSecondaryTickBlock.y - xAxisSecondaryTickBlock.height - xAxisSecondaryTickLabelBlock.height, width: xAxisSecondaryTickBlock.width, height: xAxisSecondaryTickLabelBlock.height}, 0, 'green');
    }
    drawRectangle(svg, {x: yAxisPrimaryTickBlock.x - yAxisPrimaryTickBlock.width, y: yAxisPrimaryTickBlock.y, width: yAxisPrimaryTickBlock.width, height: yAxisPrimaryTickBlock.height}, 0, 'blue');
    drawRectangle(svg, {x: yAxisPrimaryTickBlock.x - yAxisPrimaryTickBlock.width - yAxisPrimaryTickLabelBlock.width, y: yAxisPrimaryTickBlock.y, width: yAxisPrimaryTickLabelBlock.width, height: yAxisPrimaryTickBlock.height}, 0, 'green');
  
    //gridlines
    if (config.showGridlines) {
        if (config.orientation === 'vertical') {
            chartG.selectAll().data(yScalePrimary.ticks(config.yAxis.primaryTicksNum)).enter()
                .append('line')
                    .attr('x1', 0)
                    .attr('y1', function(d) {
                        return yScalePrimary(d);
                    })
                    .attr('x2', function(d) {
                        if (yScalePrimary(d) === chartBlock.height) {
                            return 0;
                        }
                        return chartBlock.width;
                    })
                    .attr('y2', function(d) {
                        return yScalePrimary(d);
                    })
                    .attr('stroke', config.gridlineColor)
                    .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor)
                    .attr('stroke-dasharray', ('1, 1'));
        } else { //horizontal
            chartG.selectAll().data(xScalePrimary.ticks(config.xAxis.primaryTicksNum)).enter()
                .append('line')
                    .attr('x1', function(d) {
                        return xScalePrimary(d);
                    })
                    .attr('y1', function(d) {
                        if (xScalePrimary(d) === 0) {
                            return chartBlock.height;
                        }
                        return 0;
                    })
                    .attr('x2', function(d) {
                        return xScalePrimary(d);
                    })
                    .attr('y2', chartBlock.height)
                    .attr('stroke', config.gridlineColor)
                    .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor)
                    .attr('stroke-dasharray', ('1, 1'));
        }
    }
  
    //chart
    if (config.seriesLayout === 'stacked') {
        var cumulativeValues = [];
        for (i = 0; i < data.visibleSeries.length; i++) {
            var series = data.visibleSeries[i];
            var patternId = null;
            if (series.overlayPattern) {
                patternId = createPattern(svg, series);
            }
            for (j = 0; j < series.elements.length; j++) {
                var element = series.elements[j];
                if (series.baseTip) {
                    if (config.orientation === 'vertical') {
                        drawChartBaseBar(chartG, series, element, tooltip, series.baseTip, {
                            x: xScalePrimary(series.seriesTitle),
                            y: 0,
                            width: xScalePrimary.bandwidth(),
                            height: chartBlock.height
                        });
                    } else { //horizontal
                        drawChartBaseBar(chartG, series, element, tooltip, series.baseTip, {
                            x: 0,
                            y: yScalePrimary(series.seriesTitle),
                            width: series.axis === 'primary' ? xAxisPrimaryTickBlock.width : xAxisSecondaryTickBlock.width,
                            height: yScalePrimary.bandwidth()
                        });
                    }
                }
                var cumulativeValue = cumulativeValues.filter(function(val) {
                   return val.category === element.category; 
                })[0];
                if (!cumulativeValue) {
                    cumulativeValue = {
                        category: element.category,
                        value: 0
                    };
                    cumulativeValues.push(cumulativeValue);
                }
                if (config.orientation === 'vertical') {
                    drawChartBar(chartG, series, element, null, tooltip, element.tip, {
                        x: xScalePrimary(element.category),
                        y: chartBlock.height,
                        width: xScalePrimary.bandwidth(),
                        height: 0
                    }, {
                        x: xScalePrimary(element.category),
                        y: yScalePrimary(cumulativeValue.value + element.value),
                        width: xScalePrimary.bandwidth(),
                        height: chartBlock.height - yScalePrimary(element.value)
                    });
                    if (element.overlayValueMin != undefined && element.overlayValueMax !== undefined) {
                        drawChartBar(chartG, series, element, patternId, tooltip, element.overlayTip, {
                            x: xScalePrimary(element.category),
                            y: chartBlock.height,
                            width: xScalePrimary.bandwidth(),
                            height: 0
                        }, {
                            x: xScalePrimary(element.category),
                            y: yScalePrimary(cumulativeValue.value + element.overlayValueMax),
                            width: xScalePrimary.bandwidth(),
                            height: chartBlock.height - yScalePrimary(element.overlayValueMax - element.overlayValueMin)
                        });
                    }
                    if (element.marks) {
                        for (k = 0; k < element.marks.length; k++) {
                            var mark = element.marks[k];
                            drawChartMark(chartG, {
                                cx: xScalePrimary(element.category),
                                cy: yScalePrimary(cumulativeValue.value + mark.value)
                            }, {
                                x1: xScalePrimary(element.category),
                                y1: yScalePrimary(cumulativeValue.value + mark.value),
                                x2: xScalePrimary(element.category) + xScalePrimary.bandwidth(),
                                y2: yScalePrimary(cumulativeValue.value + mark.value)
                            }, mark.color, (mark.value < element.value), tooltip, mark.Tip);
                        }
                    }
                } else { //horizontal
                    drawChartBar(chartG, series, element, null, tooltip, element.tip, {
                        x: xScalePrimary(cumulativeValue.value),
                        y: yScalePrimary(element.category),
                        width: 0,
                        height: yScalePrimary.bandwidth()
                    }, {
                        x: xScalePrimary(cumulativeValue.value),
                        y: yScalePrimary(element.category),
                        width: Math.max(xScalePrimary(element.value), config.minBarSize * svgScaleFactor),
                        height: yScalePrimary.bandwidth()
                    });
                    if (element.overlayValueMin != undefined && element.overlayValueMax !== undefined) {
                        drawChartBar(chartG, series, element, patternId, tooltip, element.overlayTip, {
                            x: xScalePrimary(cumulativeValue.value + element.overlayValueMin),
                            y: yScalePrimary(element.category),
                            width: 0,
                            height: yScalePrimary.bandwidth()
                        }, {
                            x: xScalePrimary(cumulativeValue.value + element.overlayValueMin),
                            y: yScalePrimary(element.category),
                            width: xScalePrimary(element.overlayValueMax - element.overlayValueMin),
                            height: yScalePrimary.bandwidth()
                        });
                    }
                    if (element.marks) {
                        for (k = 0; k < element.marks.length; k++) {
                            var mark = element.marks[k];
                            drawChartMark(chartG, {
                                cx: xScalePrimary(cumulativeValue.value + mark.value),
                                cy: yScalePrimary(element.category) + yScalePrimary.bandwidth()
                            }, {
                                x1: xScalePrimary(cumulativeValue.value + mark.value),
                                y1: yScalePrimary(element.category) + yScalePrimary.bandwidth(),
                                x2: xScalePrimary(cumulativeValue.value + mark.value),
                                y2: yScalePrimary(element.category)
                            }, mark.color, (mark.value < element.value), tooltip, mark.tip);
                        }
                    }
                }
                cumulativeValue.value += element.value;
            }
        }
    } else if (config.seriesLayout === 'grouped') {
        var barSeriesCnt = 0;
        for (i = 0; i < data.visibleSeries.length; i++) {
            if (data.visibleSeries[i].seriesType === 'bar') {
                barSeriesCnt++;
            }
        }
        for (i = 0; i < data.visibleSeries.length; i++) {
            var series = data.visibleSeries[i];
            if (series.seriesType === 'bar') {
                var patternId = null;
                if (series.overlayPattern) {
                    patternId = createPattern(svg, series);
                }
                var seriesG = chartG.append('g');
                if (config.orientation === 'vertical') {
                    seriesG.attr('transform', function() {
                        return 'translate(' + (xScalePrimary.bandwidth() / barSeriesCnt + 2) * i + ', 0)';
                    });
                } else { //horizontal
                    seriesG.attr('transform', function() {
                        return 'translate(0, ' + (yScalePrimary.bandwidth() / barSeriesCnt + 2) * i + ')';
                    });
                }
                for (j = 0; j < series.elements.length; j++) {
                    var element = series.elements[j];
                    if (element.value !== undefined) {
                        if (config.orientation === 'vertical') {
                            drawChartBaseBar(seriesG, series, element, tooltip, element.tip, {
                                x: xScalePrimary(element.category),
                                y: 0,
                                width: (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                height: chartBlock.height
                            });
                            drawChartBar(seriesG, series, element, null, tooltip, element.tip, {
                                x: xScalePrimary(element.category),
                                y: chartBlock.height,
                                width: (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                height: 0
                            }, {
                                x: xScalePrimary(element.category),
                                y: series.axis === 'primary' ? yScalePrimary(element.value) : yScaleSecondary(element.value),
                                width: (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                height: chartBlock.height - (series.axis === 'primary' ? yScalePrimary(element.value) : yScaleSecondary(element.value))
                            });
                            if (element.overlayValueMin != undefined && element.overlayValueMax !== undefined) {
                                drawChartBar(seriesG, series, element, patternId, tooltip, element.overlayTip, {
                                    x: xScalePrimary(element.category),
                                    y: series.axis === 'primary' ? yScalePrimary(element.overlayValueMin) : yScaleSecondary(element.overlayValueMin),
                                    width: (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                    height: 0
                                }, {
                                    x: xScalePrimary(element.category),
                                    y: yScalePrimary(element.overlayValueMax),
                                    width: (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                    height: chartBlock.height - (series.axis === 'primary' ? yScalePrimary(element.overlayValueMax - element.overlayValueMin) : yScaleSecondary(element.overlayValueMax - element.overlayValueMin))
                                });
                            }
                            if (element.marks) {
                                for (k = 0; k < element.marks.length; k++) {
                                    var mark = element.marks[k];
                                    drawChartMark(seriesG, {
                                        cx: xScalePrimary(element.category),
                                        cy: series.axis === 'primary' ? yScalePrimary(mark.value) : yScaleSecondary(mark.value)
                                    }, {
                                        x1: xScalePrimary(element.category),
                                        y1: series.axis === 'primary' ? yScalePrimary(mark.value) : yScaleSecondary(mark.value),
                                        x2: xScalePrimary(element.category) + (xScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                        y2: series.axis === 'primary' ? yScalePrimary(mark.value) : yScaleSecondary(mark.value)
                                    }, mark.color, (mark.value < element.value), tooltip, mark.tip);
                                }
                            }
                        } else { //horizontal
                            drawChartBaseBar(seriesG, series, element, tooltip, element.tip, {
                                x: 0,
                                y: yScalePrimary(element.category),
                                width: series.axis === 'primary' ? xAxisPrimaryTickBlock.width : xAxisSecondaryTickBlock.width,
                                height: (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                            });
                            drawChartBar(seriesG, series, element, null, tooltip, element.tip, {
                                x: 0,
                                y: yScalePrimary(element.category),
                                width: 0,
                                height: (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                            }, {
                                x: 0,
                                y: yScalePrimary(element.category),
                                width: series.axis === 'primary' ? Math.max(xScalePrimary(element.value), config.minBarSize * svgScaleFactor) : Math.max(xScaleSecondary(element.value), config.minBarSize * svgScaleFactor),
                                height: (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                            });
                            if (element.overlayValueMin != undefined && element.overlayValueMax !== undefined) {
                                drawChartBar(seriesG, series, element, patternId, tooltip, element.overlayTip, {
                                    x: series.axis === 'primary' ? xScalePrimary(element.overlayValueMin) : xScaleSecondary(element.overlayValueMin),
                                    y: yScalePrimary(element.category),
                                    width: 0,
                                    height: (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                                }, {
                                    x: series.axis === 'primary' ? xScalePrimary(element.overlayValueMin) : xScaleSecondary(element.overlayValueMin),
                                    y: yScalePrimary(element.category),
                                    width: series.axis === 'primary' ? xScalePrimary(element.overlayValueMax - element.overlayValueMin) : xScaleSecondary(element.overlayValueMax - element.overlayValueMin),
                                    height: (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                                });
                            }
                            if (element.marks) {
                                for (k = 0; k < element.marks.length; k++) {
                                    var mark = element.marks[k];
                                    drawChartMark(seriesG, {
                                        cx: series.axis === 'primary' ? xScalePrimary(mark.value) : xScaleSecondary(mark.value),
                                        cy: yScalePrimary(element.category) + (yScalePrimary.bandwidth() / barSeriesCnt) - 2
                                    }, {
                                        x1: series.axis === 'primary' ? xScalePrimary(mark.value) : xScaleSecondary(mark.value),
                                        y1: yScalePrimary(element.category) + (yScalePrimary.bandwidth() / barSeriesCnt) - 2,
                                        x2: series.axis === 'primary' ? xScalePrimary(mark.value) : xScaleSecondary(mark.value),
                                        y2: yScalePrimary(element.category)
                                    }, mark.color, (mark.value < element.value), tooltip, mark.tip);
                                }
                            }
                        }
                    }
                }
            } else if (series.seriesType === 'line') {
                if (config.orientation === 'vertical') {
                    var centralPadding = xScalePrimary.bandwidth() / 2;
                    var line = d3.line()
                        .x(function(d) {
                            return xScalePrimary(d.category) + centralPadding;
                        })
                        .y(function(d) {
                            return series.axis === 'primary' ? yScalePrimary(d.value) : yScaleSecondary(d.value);
                        });
                    var area = d3.area()
                        .x(function(d) {
                            return xScalePrimary(d.category) + centralPadding;
                        })
                        .y0(yScalePrimary(0))
                        .y1(function(d) {
                            return series.axis === 'primary' ? yScalePrimary(d.value) : yScaleSecondary(d.value);
                        });
                    chartG.append('path')
                        .datum(series.elements)
                        .attr('d', line)
                        .attr('stroke', series.seriesColor)
                        .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor)
                        .attr('fill', 'none')
                        .attr('pointer-events', 'none');
                    chartG.append('path')
                        .data([series.elements])
                        .attr('d', area)
                        .attr('fill', series.seriesColor)
                        .attr('fill-opacity', .3)
                        .attr('pointer-events', 'none');
                } else {  //horizontal
                    var centralPadding = yScalePrimary.bandwidth() / 2;
                    var line = d3.line()
                        .x(function(d) {
                            return series.axis === 'primary' ? xScalePrimary(d.value) : xScaleSecondary(d.value);
                        })
                        .y(function(d) {
                            return yScalePrimary(d.category) + centralPadding;
                        });
                    var area = d3.area()
                        .x0(xScalePrimary(0))
                        .x1(function(d) {
                            return series.axis === 'primary' ? xScalePrimary(d.value) : xScaleSecondary(d.value);
                        })
                        .y(function(d) {
                            return yScalePrimary(d.category) + centralPadding;
                        });
                    chartG.append('path')
                        .datum(series.elements)
                        .attr('d', line)
                        .attr('stroke', series.seriesColor)
                        .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor)
                        .attr('fill', 'none')
                        .attr('pointer-events', 'none');
                    chartG.append('path')
                        .data([series.elements])
                        .attr('d', area)
                        .attr('fill', series.seriesColor)
                        .attr('fill-opacity', .3)
                        .attr('pointer-events', 'none');
                }
            }
        }
    }
}

function drawChartBaseBar(svg, series, element, tooltip, tip, bar) {
    svg.append('rect')
        .attr('x', bar.x)
        .attr('y', bar.y)
        .attr('width', bar.width)
        .attr('height', bar.height)
        .attr('fill-opacity', 0)
        .style('cursor', 'pointer')
        .on('mouseover', function() {
            tooltip.html(tip);
            tooltip.style('visibility', 'visible');
        })
        .on('mousemove', function() {
            reposTip(tooltip);
        })
        .on('mouseout', function() {
            tooltip.style('visibility', 'hidden');
        })
        .on('click', function() {
            if (config.enableClick) {
                if (tip) {
                    tooltip.style('visibility', 'hidden');
                }
                document.getElementById(config.id).setAttribute('series', JSON.stringify(series));
                document.getElementById(config.id).setAttribute('element', JSON.stringify(element));
            }
        });
}

function drawChartBar(svg, series, element, patternId, tooltip, tip, start, end) {
    var highlightColor = (element.highlight) ? config.highlightColor : null;
    if (config.animation) {
        var rect = svg.append('rect')
            .attr('x', start.x)
            .attr('y', start.y)
            .attr('width', (highlightColor && !start.width) ? config.highlightStrokeWidth * svgScaleFactor : start.width)
            .attr('height', (highlightColor && !start.height) ? config.highlightStrokeWidth * svgScaleFactor : start.height)
            .attr('fill', (patternId) ? 'url(#' + patternId + ')' : series.seriesColor)
            .attr('fill-opacity', config.opacity);
        if (highlightColor) {
            rect.attr('stroke', highlightColor)
                .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor);
        } else {
            rect.attr('stroke', 'none');
        }
        if (tip) {
            rect.style('cursor', 'pointer')
                .on('mouseover', function() {
                    setFillOpacity(this, config.opacityHighlight);
                    tooltip.html(tip);
                    return tooltip.style('visibility', 'visible');
                })
                .on('mousemove', function() {
                    reposTip(tooltip);
                })
                .on('mouseout', function() {
                    setFillOpacity(this, config.opacity);
                    return tooltip.style('visibility', 'hidden');
                });
        }
        rect.on('click', function() {
            if (config.enableClick) {
                if (element.tip) {
                    tooltip.style('visibility', 'hidden');
                }
                document.getElementById(config.id).setAttribute('series', JSON.stringify(series));
                document.getElementById(config.id).setAttribute('element', JSON.stringify(element));
            }
        });
        if (end) {
            rect.transition()
                .delay(patternId ? 300 : 0)
                .duration(500)
                .attr('x', end.x)
                .attr('y', end.y)
                .attr('width', (highlightColor && !end.width) ? config.highlightStrokeWidth * svgScaleFactor : end.width)
                .attr('height', (highlightColor && !end.height) ? config.highlightStrokeWidth * svgScaleFactor : end.height);
        }
    } else if (!end) {
        var rect = svg.append('rect')
            .attr('x', start.x)
            .attr('y', start.y)
            .attr('width', (highlightColor && !start.width) ? config.highlightStrokeWidth * svgScaleFactor : start.width)
            .attr('height', (highlightColor && !start.height) ? config.highlightStrokeWidth * svgScaleFactor : start.height)
            .attr('fill', (patternId) ? 'url(#' + patternId + ')' : series.seriesColor)
            .attr('fill-opacity', config.opacity);
        if (highlightColor) {
            rect.attr('stroke', highlightColor)
                .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor);
        } else {
            rect.attr('stroke', 'none');
        }
    } else {
        var rect = svg.append('rect')
            .attr('x', end.x)
            .attr('y', end.y)
            .attr('width', (highlightColor && !end.width) ? config.highlightStrokeWidth * svgScaleFactor : end.width)
            .attr('height', (highlightColor && !end.height) ? config.highlightStrokeWidth * svgScaleFactor : end.height)
            .attr('fill', (patternId) ? 'url(#' + patternId + ')' : series.seriesColor)
            .attr('fill-opacity', config.opacity);
        if (highlightColor) {
            rect.attr('stroke', highlightColor)
                .attr('stroke-width', config.highlightStrokeWidth * svgScaleFactor);
        } else {
            rect.attr('stroke', 'none');
        }
    }
}

function drawChartMark(svg, circle, line, color, invertLineColor, tooltip, tip) {
    var mark = svg.append('g');
    if (config.animation) {
        mark.append('line')
            .attr('x1', line.x1)
            .attr('y1', line.y1)
            .attr('x2', line.x1)
            .attr('y2', line.y1)
            .attr('stroke', (invertLineColor) ? config.mark.inverseColor : color)
            .attr('stroke-width', config.mark.strokeWidth * svgScaleFactor)
            .transition()
                .delay(600)
                .duration(500)
                .attr('x2', line.x2)
                .attr('y2', line.y2);
        mark.append('circle')
            .attr('cx', circle.cx)
            .attr('cy', circle.cy)
            .attr('r', 0)
            .attr('fill', color)
            .attr('stroke', config.mark.inverseColor)
            .attr('stroke-width', config.mark.strokeWidth * svgScaleFactor)
            .transition()
                .delay(600)
                .duration(500)
                .attr('r', config.mark.radius * svgScaleFactor);
        if (tip) {
            mark.style('cursor', 'pointer')
                .on('mouseover', function() {
                    tooltip.html(tip);
                    return tooltip.style('visibility', 'visible');
                })
                .on('mousemove', function() {
                    reposTip(tooltip);
                })
                .on('mouseout', function() {
                    return tooltip.style('visibility', 'hidden');
                });
        }
    } else {
        mark.append('line')
            .attr('x1', line.x1)
            .attr('y1', line.y1)
            .attr('x2', line.x2)
            .attr('y2', line.y2)
            .attr('stroke', (invertLineColor) ? config.mark.inverseColor : color)
            .attr('stroke-width', config.mark.strokeWidth * svgScaleFactor);
        mark.append('circle')
            .attr('cx', circle.cx)
            .attr('cy', circle.cy)
            .attr('r', config.mark.radius * svgScaleFactor)
            .attr('fill', color)
            .attr('stroke', config.mark.inverseColor)
            .attr('stroke-width', config.mark.strokeWidth * svgScaleFactor);
    }
}

function createPattern(svg, series) {
    if (series.overlayPattern === 'diagonalHatch') {
        svg.append('defs')
            .append('pattern')
                .attr('id', 'pattern-' + config.id + '-' + patternIdx)
                .attr('patternUnits', 'userSpaceOnUse')
                .attr('width', 6 * svgScaleFactor)
                .attr('height', 6 * svgScaleFactor)
                .append('path')
                    .attr('d', 'M' + (-1.5 * svgScaleFactor) + ',' + (1.5 * svgScaleFactor) + ' l' + (3 * svgScaleFactor) + ',' + (-3 * svgScaleFactor) + ' M0,' + (6 * svgScaleFactor) + ' l' + (6 * svgScaleFactor) + ',' + (-6 * svgScaleFactor) + ' M' + (4.5 * svgScaleFactor) + ',' + (7.5 * svgScaleFactor) + ' l' + (3 * svgScaleFactor) + ',' + (-3 * svgScaleFactor) + '')
                    .attr('stroke', series.overlayColor)
                    .attr('stroke-opacity', config.opacity)
                    .attr('stroke-width', config.axisStrokeWidth * svgScaleFactor);
        return 'pattern-' + config.id + '-' + patternIdx++;
    }
}

function reposTip(tooltip) {
    var toolTipYPos = 25;
    var toolTipXPos = 15;
    return tooltip.style('top', (d3.event.pageY - toolTipYPos) + 'px').style('left', (d3.event.pageX + toolTipXPos) + 'px');
}

function setFillOpacity(selector, opacity) {
    d3.select(selector).attr('fill-opacity', function() {
        return opacity;
    });
}

function addTextBlock(svg, title, block, rotation, fontSize, fontWeight, justification) {
    var x;
    if (justification === 'middle') {
        x = block.width / 2;
    } else if (justification === 'right') {
        x = block.width;
    } else {
        justification === 'left';
        x = 0;
    }
    svg.append('text')
        .attr('transform', 'translate(' + block.x + ' ' + block.y + ') rotate(' + rotation + ')')
        .attr('x', x)
        .attr('y', 0)
        .attr('fill', config.textColor)
        .attr('font-size', fontSize)
        .attr('font-weight', fontWeight)
        .attr('font-family', font)
        .attr('text-anchor', justification)
        .text(title)
        .call(wrap, block.width);
    drawRectangle(svg, block, rotation, 'black');
}

// create a dummy element, apply the appropriate classes,
// and then measure the element
function measure(text, width, fontSize, fontWeight) {
    if (width !== Number.POSITIVE_INFINITY && width !== Number.NEGATIVE_INFINITY) {
        if (!text || text.length === 0) {
            return {
                height: 0,
                width: 0
            };
        }
        var container = d3.select('body').append('svg');
        var textNode = container.append('text')
            .attr('x', 0)
            .attr('y', 0)
            .attr('font-family', font)
            .attr('font-size', fontSize)
            .attr('font-weight', fontWeight)
            .text(text)
            .call(wrap, width);
        var bbox = textNode.node().getBBox();
        container.remove();
        return {
            height: bbox.height,
            width: bbox.width + 2 //add a little extra padding
        };
    }
}

function wrap(text, width) {
    if (width > 0) {
        text.each(function() {
            var text = d3.select(this);
            var words = text.text().split(/\s+/).reverse();
            var word;
            var line = [];
            var lineNumber = 0;
            var lineHeight = 1.1; // ems
            var x = text.attr('x');
            var y = text.attr('y');
            var dy = 0.9;
            var tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');
            while (word = words.pop()) { //eslint-disable-line
                line.push(word);
                tspan.text(line.join(' '));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(' '));
                    line = [word];
                    tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
                }
            }
        });
    }
}


var truncate = function(text, width) {
    if (width > 0) {
        text.each(function() {
            var self = d3.select(this);
            var text = self.text();
            var textLength = self.node().getComputedTextLength();
            while (textLength > width) {
                text = text.slice(0, -1);
                if (text.length > 0) {
                    self.text(text + '...');
                } else {
                    self.text('');
                }
                textLength = self.node().getComputedTextLength();
            }
        });
    }
};

function calculateMaxVal(data, axis, seriesLayout) {
    //get total values for category
    var categoryValues = [];
    var maxValue = 0;
    if (seriesLayout === 'grouped') {
        for (i = 0; i < data.visibleSeries.length; i++) {
            var series = data.visibleSeries[i];
            if (series.axis === axis) {
                for (j = 0; j < series.elements.length; j++) {
                    var element = series.elements[j];
                    maxValue = Math.max(maxValue, element.value);
                    if (element.overlayValueMax !== undefined) {
                        maxValue = Math.max(maxValue, element.overlayValueMax);
                    }
                }
            }
        }
    } else if (seriesLayout === 'stacked') {
        for (i = 0; i < data.visibleSeries.length; i++) {
            var series = data.visibleSeries[i];
            for (j = 0; j < series.elements.length; j++) {
                var element = series.elements[j];
                var categoryValue = categoryValues.filter(function(val) {
                    return val.category === element.category; 
                })[0];
                if (!categoryValue) {
                    categoryValue = {
                        category: element.category,
                        value: 0
                    };
                    categoryValues.push(categoryValue);
                }
                categoryValue.value += (element.overlayValueMax !== undefined) ? element.overlayValueMax : element.value;
            }
        }
        //find maximum category
        for (i = 0; i < categoryValues.length; i++) {
            maxValue = Math.max(maxValue, categoryValues[i].value);
        }
    }
    var mult = Math.pow(10, 1 - Math.floor(Math.log(maxValue) / Math.LN10) - 1);
    return Math.ceil(maxValue * mult) / mult;
}

function getAllCategories(data) {
    var chartCategories = [];
    for (i = 0; i < data.visibleSeries.length; i++) {
        for (j = 0; j < data.visibleSeries[i].elements.length; j++) {
            var element = data.visibleSeries[i].elements[j];
            if (chartCategories.filter(function(cat) {
                return cat.val === element.category; 
            }).length === 0) {
                chartCategories.push({
                    val: element.category
                });
            }
            var cat = chartCategories.filter(function(cat) {
                return cat.val === element.category; 
            })[0];
            if (element.label && !cat.label) {
                cat.label = element.label;
            }
            if (element.labelCssClass && !cat.cssClass) {
                cat.cssClass = element.labelCssClass;
            }
            if (element.highlight && !cat.highlight) {
                cat.highlight = element.highlight;
            }
        }
    }
    return chartCategories;
}

function getCategory(d) {
    return data.categories.filter(function(cat) {
        return cat.val === d; 
    })[0];
}

function drawRectangle(svg, block, rotation, color) {
    if (config.debugLayout && block.x >= 0 && block.y >= 0 && block.width && block.height) {
        svg.append('rect')
            .attr('transform', 'translate(' + block.x + ' ' + block.y + ') rotate(' + rotation + ')')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', block.width)
            .attr('height', block.height)
            .attr('fill', 'none')
            .attr('stroke', color)
            .attr('stroke-width', 0.5);
    }
}
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.1.2 - 2016-02-01
 * License: MIT
 */angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.debounce","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]),angular.module("ui.bootstrap.tpls",["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/popup.html","uib/template/datepicker/year.html","uib/template/modal/backdrop.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.collapse",[]).directive("uibCollapse",["$animate","$q","$parse","$injector",function(a,b,c,d){var e=d.has("$animateCss")?d.get("$animateCss"):null;return{link:function(d,f,g){function h(){f.hasClass("collapse")&&f.hasClass("in")||b.resolve(l(d)).then(function(){f.removeClass("collapse").addClass("collapsing").attr("aria-expanded",!0).attr("aria-hidden",!1),e?e(f,{addClass:"in",easing:"ease",to:{height:f[0].scrollHeight+"px"}}).start()["finally"](i):a.addClass(f,"in",{to:{height:f[0].scrollHeight+"px"}}).then(i)})}function i(){f.removeClass("collapsing").addClass("collapse").css({height:"auto"}),m(d)}function j(){return f.hasClass("collapse")||f.hasClass("in")?void b.resolve(n(d)).then(function(){f.css({height:f[0].scrollHeight+"px"}).removeClass("collapse").addClass("collapsing").attr("aria-expanded",!1).attr("aria-hidden",!0),e?e(f,{removeClass:"in",to:{height:"0"}}).start()["finally"](k):a.removeClass(f,"in",{to:{height:"0"}}).then(k)}):k()}function k(){f.css({height:"0"}),f.removeClass("collapsing").addClass("collapse"),o(d)}var l=c(g.expanding),m=c(g.expanded),n=c(g.collapsing),o=c(g.collapsed);d.$eval(g.uibCollapse)||f.addClass("in").addClass("collapse").attr("aria-expanded",!0).attr("aria-hidden",!1).css({height:"auto"}),d.$watch(g.uibCollapse,function(a){a?j():h()})}}}]),angular.module("ui.bootstrap.accordion",["ui.bootstrap.collapse"]).constant("uibAccordionConfig",{closeOthers:!0}).controller("UibAccordionController",["$scope","$attrs","uibAccordionConfig",function(a,b,c){this.groups=[],this.closeOthers=function(d){var e=angular.isDefined(b.closeOthers)?a.$eval(b.closeOthers):c.closeOthers;e&&angular.forEach(this.groups,function(a){a!==d&&(a.isOpen=!1)})},this.addGroup=function(a){var b=this;this.groups.push(a),a.$on("$destroy",function(c){b.removeGroup(a)})},this.removeGroup=function(a){var b=this.groups.indexOf(a);-1!==b&&this.groups.splice(b,1)}}]).directive("uibAccordion",function(){return{controller:"UibAccordionController",controllerAs:"accordion",transclude:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/accordion/accordion.html"}}}).directive("uibAccordionGroup",function(){return{require:"^uibAccordion",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/accordion/accordion-group.html"},scope:{heading:"@",isOpen:"=?",isDisabled:"=?"},controller:function(){this.setHeading=function(a){this.heading=a}},link:function(a,b,c,d){d.addGroup(a),a.openClass=c.openClass||"panel-open",a.panelClass=c.panelClass||"panel-default",a.$watch("isOpen",function(c){b.toggleClass(a.openClass,!!c),c&&d.closeOthers(a)}),a.toggleOpen=function(b){a.isDisabled||b&&32!==b.which||(a.isOpen=!a.isOpen)};var e="accordiongroup-"+a.$id+"-"+Math.floor(1e4*Math.random());a.headingId=e+"-tab",a.panelId=e+"-panel"}}}).directive("uibAccordionHeading",function(){return{transclude:!0,template:"",replace:!0,require:"^uibAccordionGroup",link:function(a,b,c,d,e){d.setHeading(e(a,angular.noop))}}}).directive("uibAccordionTransclude",function(){return{require:"^uibAccordionGroup",link:function(a,b,c,d){a.$watch(function(){return d[c.uibAccordionTransclude]},function(a){a&&(b.find("span").html(""),b.find("span").append(a))})}}}),angular.module("ui.bootstrap.alert",[]).controller("UibAlertController",["$scope","$attrs","$interpolate","$timeout",function(a,b,c,d){a.closeable=!!b.close;var e=angular.isDefined(b.dismissOnTimeout)?c(b.dismissOnTimeout)(a.$parent):null;e&&d(function(){a.close()},parseInt(e,10))}]).directive("uibAlert",function(){return{controller:"UibAlertController",controllerAs:"alert",templateUrl:function(a,b){return b.templateUrl||"uib/template/alert/alert.html"},transclude:!0,replace:!0,scope:{type:"@",close:"&"}}}),angular.module("ui.bootstrap.buttons",[]).constant("uibButtonConfig",{activeClass:"active",toggleEvent:"click"}).controller("UibButtonsController",["uibButtonConfig",function(a){this.activeClass=a.activeClass||"active",this.toggleEvent=a.toggleEvent||"click"}]).directive("uibBtnRadio",["$parse",function(a){return{require:["uibBtnRadio","ngModel"],controller:"UibButtonsController",controllerAs:"buttons",link:function(b,c,d,e){var f=e[0],g=e[1],h=a(d.uibUncheckable);c.find("input").css({display:"none"}),g.$render=function(){c.toggleClass(f.activeClass,angular.equals(g.$modelValue,b.$eval(d.uibBtnRadio)))},c.on(f.toggleEvent,function(){if(!d.disabled){var a=c.hasClass(f.activeClass);(!a||angular.isDefined(d.uncheckable))&&b.$apply(function(){g.$setViewValue(a?null:b.$eval(d.uibBtnRadio)),g.$render()})}}),d.uibUncheckable&&b.$watch(h,function(a){d.$set("uncheckable",a?"":null)})}}}]).directive("uibBtnCheckbox",function(){return{require:["uibBtnCheckbox","ngModel"],controller:"UibButtonsController",controllerAs:"button",link:function(a,b,c,d){function e(){return g(c.btnCheckboxTrue,!0)}function f(){return g(c.btnCheckboxFalse,!1)}function g(b,c){return angular.isDefined(b)?a.$eval(b):c}var h=d[0],i=d[1];b.find("input").css({display:"none"}),i.$render=function(){b.toggleClass(h.activeClass,angular.equals(i.$modelValue,e()))},b.on(h.toggleEvent,function(){c.disabled||a.$apply(function(){i.$setViewValue(b.hasClass(h.activeClass)?f():e()),i.$render()})})}}}),angular.module("ui.bootstrap.carousel",[]).controller("UibCarouselController",["$scope","$element","$interval","$timeout","$animate",function(a,b,c,d,e){function f(){for(;s.length;)s.shift()}function g(a){if(angular.isUndefined(p[a].index))return p[a];for(var b=0,c=p.length;c>b;++b)if(p[b].index===a)return p[b]}function h(c,d,g){t||(angular.extend(c,{direction:g,active:!0}),angular.extend(o.currentSlide||{},{direction:g,active:!1}),e.enabled(b)&&!a.$currentTransition&&c.$element&&o.slides.length>1&&(c.$element.data(q,c.direction),o.currentSlide&&o.currentSlide.$element&&o.currentSlide.$element.data(q,c.direction),a.$currentTransition=!0,e.on("addClass",c.$element,function(b,c){if("close"===c&&(a.$currentTransition=null,e.off("addClass",b),s.length)){var d=s.pop(),g=a.indexOfSlide(d),i=g>o.getCurrentIndex()?"next":"prev";f(),h(d,g,i)}})),o.currentSlide=c,r=d,k())}function i(){m&&(c.cancel(m),m=null)}function j(b){b.length||(a.$currentTransition=null,f())}function k(){i();var b=+a.interval;!isNaN(b)&&b>0&&(m=c(l,b))}function l(){var b=+a.interval;n&&!isNaN(b)&&b>0&&p.length?a.next():a.pause()}var m,n,o=this,p=o.slides=a.slides=[],q="uib-slideDirection",r=-1,s=[];o.currentSlide=null;var t=!1;o.addSlide=function(b,c){b.$element=c,p.push(b),1===p.length||b.active?(a.$currentTransition&&(a.$currentTransition=null),o.select(p[p.length-1]),1===p.length&&a.play()):b.active=!1},o.getCurrentIndex=function(){return o.currentSlide&&angular.isDefined(o.currentSlide.index)?+o.currentSlide.index:r},o.next=a.next=function(){var b=(o.getCurrentIndex()+1)%p.length;return 0===b&&a.noWrap()?void a.pause():o.select(g(b),"next")},o.prev=a.prev=function(){var b=o.getCurrentIndex()-1<0?p.length-1:o.getCurrentIndex()-1;return a.noWrap()&&b===p.length-1?void a.pause():o.select(g(b),"prev")},o.removeSlide=function(a){angular.isDefined(a.index)&&p.sort(function(a,b){return+a.index>+b.index});var b=s.indexOf(a);-1!==b&&s.splice(b,1);var c=p.indexOf(a);p.splice(c,1),d(function(){p.length>0&&a.active?c>=p.length?o.select(p[c-1]):o.select(p[c]):r>c&&r--}),0===p.length&&(o.currentSlide=null,f())},o.select=a.select=function(b,c){var d=a.indexOfSlide(b);void 0===c&&(c=d>o.getCurrentIndex()?"next":"prev"),b&&b!==o.currentSlide&&!a.$currentTransition?h(b,d,c):b&&b!==o.currentSlide&&a.$currentTransition&&(s.push(b),b.active=!1)},a.indexOfSlide=function(a){return angular.isDefined(a.index)?+a.index:p.indexOf(a)},a.isActive=function(a){return o.currentSlide===a},a.pause=function(){a.noPause||(n=!1,i())},a.play=function(){n||(n=!0,k())},a.$on("$destroy",function(){t=!0,i()}),a.$watch("noTransition",function(a){e.enabled(b,!a)}),a.$watch("interval",k),a.$watchCollection("slides",j)}]).directive("uibCarousel",function(){return{transclude:!0,replace:!0,controller:"UibCarouselController",controllerAs:"carousel",templateUrl:function(a,b){return b.templateUrl||"uib/template/carousel/carousel.html"},scope:{interval:"=",noTransition:"=",noPause:"=",noWrap:"&"}}}).directive("uibSlide",function(){return{require:"^uibCarousel",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/carousel/slide.html"},scope:{active:"=?",actual:"=?",index:"=?"},link:function(a,b,c,d){d.addSlide(a,b),a.$on("$destroy",function(){d.removeSlide(a)}),a.$watch("active",function(b){b&&d.select(a)})}}}).animation(".item",["$animateCss",function(a){function b(a,b,c){a.removeClass(b),c&&c()}var c="uib-slideDirection";return{beforeAddClass:function(d,e,f){if("active"===e){var g=!1,h=d.data(c),i="next"===h?"left":"right",j=b.bind(this,d,i+" "+h,f);return d.addClass(h),a(d,{addClass:i}).start().done(j),function(){g=!0}}f()},beforeRemoveClass:function(d,e,f){if("active"===e){var g=!1,h=d.data(c),i="next"===h?"left":"right",j=b.bind(this,d,i,f);return a(d,{addClass:i}).start().done(j),function(){g=!0}}f()}}}]),angular.module("ui.bootstrap.dateparser",[]).service("uibDateParser",["$log","$locale","dateFilter","orderByFilter",function(a,b,c,d){function e(a,b){var c=[],e=a.split(""),f=a.indexOf("'");if(f>-1){var g=!1;a=a.split("");for(var h=f;h<a.length;h++)g?("'"===a[h]&&(h+1<a.length&&"'"===a[h+1]?(a[h+1]="$",e[h+1]=""):(e[h]="",g=!1)),a[h]="$"):"'"===a[h]&&(a[h]="$",e[h]="",g=!0);a=a.join("")}return angular.forEach(n,function(d){var f=a.indexOf(d.key);if(f>-1){a=a.split(""),e[f]="("+d.regex+")",a[f]="$";for(var g=f+1,h=f+d.key.length;h>g;g++)e[g]="",a[g]="$";a=a.join(""),c.push({index:f,key:d.key,apply:d[b],matcher:d.regex})}}),{regex:new RegExp("^"+e.join("")+"$"),map:d(c,"index")}}function f(a,b,c){return 1>c?!1:1===b&&c>28?29===c&&(a%4===0&&a%100!==0||a%400===0):3===b||5===b||8===b||10===b?31>c:!0}function g(a){return parseInt(a,10)}function h(a,b){return a&&b?l(a,b):a}function i(a,b){return a&&b?l(a,b,!0):a}function j(a,b){var c=Date.parse("Jan 01, 1970 00:00:00 "+a)/6e4;return isNaN(c)?b:c}function k(a,b){return a=new Date(a.getTime()),a.setMinutes(a.getMinutes()+b),a}function l(a,b,c){c=c?-1:1;var d=j(b,a.getTimezoneOffset());return k(a,c*(d-a.getTimezoneOffset()))}var m,n,o=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.init=function(){m=b.id,this.parsers={},this.formatters={},n=[{key:"yyyy",regex:"\\d{4}",apply:function(a){this.year=+a},formatter:function(a){var b=new Date;return b.setFullYear(Math.abs(a.getFullYear())),c(b,"yyyy")}},{key:"yy",regex:"\\d{2}",apply:function(a){this.year=+a+2e3},formatter:function(a){var b=new Date;return b.setFullYear(Math.abs(a.getFullYear())),c(b,"yy")}},{key:"y",regex:"\\d{1,4}",apply:function(a){this.year=+a},formatter:function(a){var b=new Date;return b.setFullYear(Math.abs(a.getFullYear())),c(b,"y")}},{key:"M!",regex:"0?[1-9]|1[0-2]",apply:function(a){this.month=a-1},formatter:function(a){var b=a.getMonth();return/^[0-9]$/.test(b)?c(a,"MM"):c(a,"M")}},{key:"MMMM",regex:b.DATETIME_FORMATS.MONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.MONTH.indexOf(a)},formatter:function(a){return c(a,"MMMM")}},{key:"MMM",regex:b.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.SHORTMONTH.indexOf(a)},formatter:function(a){return c(a,"MMM")}},{key:"MM",regex:"0[1-9]|1[0-2]",apply:function(a){this.month=a-1},formatter:function(a){return c(a,"MM")}},{key:"M",regex:"[1-9]|1[0-2]",apply:function(a){this.month=a-1},formatter:function(a){return c(a,"M")}},{key:"d!",regex:"[0-2]?[0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a},formatter:function(a){var b=a.getDate();return/^[1-9]$/.test(b)?c(a,"dd"):c(a,"d")}},{key:"dd",regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a},formatter:function(a){return c(a,"dd")}},{key:"d",regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a},formatter:function(a){return c(a,"d")}},{key:"EEEE",regex:b.DATETIME_FORMATS.DAY.join("|"),formatter:function(a){return c(a,"EEEE")}},{key:"EEE",regex:b.DATETIME_FORMATS.SHORTDAY.join("|"),formatter:function(a){return c(a,"EEE")}},{key:"HH",regex:"(?:0|1)[0-9]|2[0-3]",apply:function(a){this.hours=+a},formatter:function(a){return c(a,"HH")}},{key:"hh",regex:"0[0-9]|1[0-2]",apply:function(a){this.hours=+a},formatter:function(a){return c(a,"hh")}},{key:"H",regex:"1?[0-9]|2[0-3]",apply:function(a){this.hours=+a},formatter:function(a){return c(a,"H")}},{key:"h",regex:"[0-9]|1[0-2]",apply:function(a){this.hours=+a},formatter:function(a){return c(a,"h")}},{key:"mm",regex:"[0-5][0-9]",apply:function(a){this.minutes=+a},formatter:function(a){return c(a,"mm")}},{key:"m",regex:"[0-9]|[1-5][0-9]",apply:function(a){this.minutes=+a},formatter:function(a){return c(a,"m")}},{key:"sss",regex:"[0-9][0-9][0-9]",apply:function(a){this.milliseconds=+a},formatter:function(a){return c(a,"sss")}},{key:"ss",regex:"[0-5][0-9]",apply:function(a){this.seconds=+a},formatter:function(a){return c(a,"ss")}},{key:"s",regex:"[0-9]|[1-5][0-9]",apply:function(a){this.seconds=+a},formatter:function(a){return c(a,"s")}},{key:"a",regex:b.DATETIME_FORMATS.AMPMS.join("|"),apply:function(a){12===this.hours&&(this.hours=0),"PM"===a&&(this.hours+=12)},formatter:function(a){return c(a,"a")}},{key:"Z",regex:"[+-]\\d{4}",apply:function(a){var b=a.match(/([+-])(\d{2})(\d{2})/),c=b[1],d=b[2],e=b[3];this.hours+=g(c+d),this.minutes+=g(c+e)},formatter:function(a){return c(a,"Z")}},{key:"ww",regex:"[0-4][0-9]|5[0-3]",formatter:function(a){return c(a,"ww")}},{key:"w",regex:"[0-9]|[1-4][0-9]|5[0-3]",formatter:function(a){return c(a,"w")}},{key:"GGGG",regex:b.DATETIME_FORMATS.ERANAMES.join("|").replace(/\s/g,"\\s"),formatter:function(a){return c(a,"GGGG")}},{key:"GGG",regex:b.DATETIME_FORMATS.ERAS.join("|"),formatter:function(a){return c(a,"GGG")}},{key:"GG",regex:b.DATETIME_FORMATS.ERAS.join("|"),formatter:function(a){return c(a,"GG")}},{key:"G",regex:b.DATETIME_FORMATS.ERAS.join("|"),formatter:function(a){return c(a,"G")}}]},this.init(),this.filter=function(a,c){if(!angular.isDate(a)||isNaN(a)||!c)return"";c=b.DATETIME_FORMATS[c]||c,b.id!==m&&this.init(),this.formatters[c]||(this.formatters[c]=e(c,"formatter"));var d=this.formatters[c],f=d.map,g=c;return f.reduce(function(b,c,d){var e=g.match(new RegExp("(.*)"+c.key));return e&&angular.isString(e[1])&&(b+=e[1],g=g.replace(e[1]+c.key,"")),c.apply?b+c.apply.call(null,a):b},"")},this.parse=function(c,d,g){if(!angular.isString(c)||!d)return c;d=b.DATETIME_FORMATS[d]||d,d=d.replace(o,"\\$&"),b.id!==m&&this.init(),this.parsers[d]||(this.parsers[d]=e(d,"apply"));var h=this.parsers[d],i=h.regex,j=h.map,k=c.match(i),l=!1;if(k&&k.length){var n,p;angular.isDate(g)&&!isNaN(g.getTime())?n={year:g.getFullYear(),month:g.getMonth(),date:g.getDate(),hours:g.getHours(),minutes:g.getMinutes(),seconds:g.getSeconds(),milliseconds:g.getMilliseconds()}:(g&&a.warn("dateparser:","baseDate is not a valid date"),n={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0});for(var q=1,r=k.length;r>q;q++){var s=j[q-1];"Z"===s.matcher&&(l=!0),s.apply&&s.apply.call(n,k[q])}var t=l?Date.prototype.setUTCFullYear:Date.prototype.setFullYear,u=l?Date.prototype.setUTCHours:Date.prototype.setHours;return f(n.year,n.month,n.date)&&(!angular.isDate(g)||isNaN(g.getTime())||l?(p=new Date(0),t.call(p,n.year,n.month,n.date),u.call(p,n.hours||0,n.minutes||0,n.seconds||0,n.milliseconds||0)):(p=new Date(g),t.call(p,n.year,n.month,n.date),u.call(p,n.hours,n.minutes,n.seconds,n.milliseconds))),p}},this.toTimezone=h,this.fromTimezone=i,this.timezoneToOffset=j,this.addDateMinutes=k,this.convertTimezoneToLocal=l}]),angular.module("ui.bootstrap.isClass",[]).directive("uibIsClass",["$animate",function(a){var b=/^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/,c=/^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;return{restrict:"A",compile:function(d,e){function f(a,b,c){i.push(a),j.push({scope:a,element:b}),o.forEach(function(b,c){g(b,a)}),a.$on("$destroy",h)}function g(b,d){var e=b.match(c),f=d.$eval(e[1]),g=e[2],h=k[b];if(!h){var i=function(b){var c=null;j.some(function(a){var d=a.scope.$eval(m);return d===b?(c=a,!0):void 0}),h.lastActivated!==c&&(h.lastActivated&&a.removeClass(h.lastActivated.element,f),c&&a.addClass(c.element,f),h.lastActivated=c)};k[b]=h={lastActivated:null,scope:d,watchFn:i,compareWithExp:g,watcher:d.$watch(g,i)}}h.watchFn(d.$eval(g))}function h(a){var b=a.targetScope,c=i.indexOf(b);if(i.splice(c,1),j.splice(c,1),i.length){var d=i[0];angular.forEach(k,function(a){a.scope===b&&(a.watcher=d.$watch(a.compareWithExp,a.watchFn),a.scope=d)})}else k={}}var i=[],j=[],k={},l=e.uibIsClass.match(b),m=l[2],n=l[1],o=n.split(",");return f}}}]),angular.module("ui.bootstrap.position",[]).factory("$uibPosition",["$document","$window",function(a,b){var c,d={normal:/(auto|scroll)/,hidden:/(auto|scroll|hidden)/},e={auto:/\s?auto?\s?/i,primary:/^(top|bottom|left|right)$/,secondary:/^(top|bottom|left|right|center)$/,vertical:/^(top|bottom)$/};return{getRawNode:function(a){return a[0]||a},parseStyle:function(a){return a=parseFloat(a),isFinite(a)?a:0},offsetParent:function(c){function d(a){return"static"===(b.getComputedStyle(a).position||"static")}c=this.getRawNode(c);for(var e=c.offsetParent||a[0].documentElement;e&&e!==a[0].documentElement&&d(e);)e=e.offsetParent;return e||a[0].documentElement},scrollbarWidth:function(){if(angular.isUndefined(c)){var b=angular.element('<div style="position: absolute; top: -9999px; width: 50px; height: 50px; overflow: scroll;"></div>');a.find("body").append(b),c=b[0].offsetWidth-b[0].clientWidth,c=isFinite(c)?c:0,b.remove()}return c},scrollParent:function(c,e){c=this.getRawNode(c);var f=e?d.hidden:d.normal,g=a[0].documentElement,h=b.getComputedStyle(c),i="absolute"===h.position,j=c.parentElement||g;if(j===g||"fixed"===h.position)return g;for(;j.parentElement&&j!==g;){var k=b.getComputedStyle(j);if(i&&"static"!==k.position&&(i=!1),!i&&f.test(k.overflow+k.overflowY+k.overflowX))break;j=j.parentElement}return j},position:function(c,d){c=this.getRawNode(c);var e=this.offset(c);if(d){var f=b.getComputedStyle(c);e.top-=this.parseStyle(f.marginTop),e.left-=this.parseStyle(f.marginLeft)}var g=this.offsetParent(c),h={top:0,left:0};return g!==a[0].documentElement&&(h=this.offset(g),h.top+=g.clientTop-g.scrollTop,h.left+=g.clientLeft-g.scrollLeft),{width:Math.round(angular.isNumber(e.width)?e.width:c.offsetWidth),height:Math.round(angular.isNumber(e.height)?e.height:c.offsetHeight),top:Math.round(e.top-h.top),left:Math.round(e.left-h.left)}},offset:function(c){c=this.getRawNode(c);var d=c.getBoundingClientRect();return{width:Math.round(angular.isNumber(d.width)?d.width:c.offsetWidth),height:Math.round(angular.isNumber(d.height)?d.height:c.offsetHeight),top:Math.round(d.top+(b.pageYOffset||a[0].documentElement.scrollTop)),left:Math.round(d.left+(b.pageXOffset||a[0].documentElement.scrollLeft))}},viewportOffset:function(c,d,e){c=this.getRawNode(c),e=e!==!1?!0:!1;var f=c.getBoundingClientRect(),g={top:0,left:0,bottom:0,right:0},h=d?a[0].documentElement:this.scrollParent(c),i=h.getBoundingClientRect();if(g.top=i.top+h.clientTop,g.left=i.left+h.clientLeft,h===a[0].documentElement&&(g.top+=b.pageYOffset,g.left+=b.pageXOffset),g.bottom=g.top+h.clientHeight,g.right=g.left+h.clientWidth,e){var j=b.getComputedStyle(h);g.top+=this.parseStyle(j.paddingTop),g.bottom-=this.parseStyle(j.paddingBottom),g.left+=this.parseStyle(j.paddingLeft),g.right-=this.parseStyle(j.paddingRight)}return{top:Math.round(f.top-g.top),bottom:Math.round(g.bottom-f.bottom),left:Math.round(f.left-g.left),right:Math.round(g.right-f.right)}},parsePlacement:function(a){var b=e.auto.test(a);return b&&(a=a.replace(e.auto,"")),a=a.split("-"),a[0]=a[0]||"top",e.primary.test(a[0])||(a[0]="top"),a[1]=a[1]||"center",e.secondary.test(a[1])||(a[1]="center"),b?a[2]=!0:a[2]=!1,a},positionElements:function(a,c,d,f){a=this.getRawNode(a),c=this.getRawNode(c);var g=angular.isDefined(c.offsetWidth)?c.offsetWidth:c.prop("offsetWidth"),h=angular.isDefined(c.offsetHeight)?c.offsetHeight:c.prop("offsetHeight");d=this.parsePlacement(d);var i=f?this.offset(a):this.position(a),j={top:0,left:0,placement:""};if(d[2]){var k=this.viewportOffset(a),l=b.getComputedStyle(c),m={width:g+Math.round(Math.abs(this.parseStyle(l.marginLeft)+this.parseStyle(l.marginRight))),height:h+Math.round(Math.abs(this.parseStyle(l.marginTop)+this.parseStyle(l.marginBottom)))};if(d[0]="top"===d[0]&&m.height>k.top&&m.height<=k.bottom?"bottom":"bottom"===d[0]&&m.height>k.bottom&&m.height<=k.top?"top":"left"===d[0]&&m.width>k.left&&m.width<=k.right?"right":"right"===d[0]&&m.width>k.right&&m.width<=k.left?"left":d[0],d[1]="top"===d[1]&&m.height-i.height>k.bottom&&m.height-i.height<=k.top?"bottom":"bottom"===d[1]&&m.height-i.height>k.top&&m.height-i.height<=k.bottom?"top":"left"===d[1]&&m.width-i.width>k.right&&m.width-i.width<=k.left?"right":"right"===d[1]&&m.width-i.width>k.left&&m.width-i.width<=k.right?"left":d[1],"center"===d[1])if(e.vertical.test(d[0])){var n=i.width/2-g/2;k.left+n<0&&m.width-i.width<=k.right?d[1]="left":k.right+n<0&&m.width-i.width<=k.left&&(d[1]="right")}else{var o=i.height/2-m.height/2;k.top+o<0&&m.height-i.height<=k.bottom?d[1]="top":k.bottom+o<0&&m.height-i.height<=k.top&&(d[1]="bottom")}}switch(d[0]){case"top":j.top=i.top-h;break;case"bottom":j.top=i.top+i.height;break;case"left":j.left=i.left-g;break;case"right":j.left=i.left+i.width}switch(d[1]){case"top":j.top=i.top;break;case"bottom":j.top=i.top+i.height-h;break;case"left":j.left=i.left;break;case"right":j.left=i.left+i.width-g;break;case"center":e.vertical.test(d[0])?j.left=i.left+i.width/2-g/2:j.top=i.top+i.height/2-h/2}return j.top=Math.round(j.top),j.left=Math.round(j.left),j.placement="center"===d[1]?d[0]:d[0]+"-"+d[1],j},positionArrow:function(a,c){a=this.getRawNode(a);var d=a.querySelector(".tooltip-inner, .popover-inner");if(d){var f=angular.element(d).hasClass("tooltip-inner"),g=f?a.querySelector(".tooltip-arrow"):a.querySelector(".arrow");if(g){if(c=this.parsePlacement(c),"center"===c[1])return void angular.element(g).css({top:"",bottom:"",right:"",left:"",margin:""});var h="border-"+c[0]+"-width",i=b.getComputedStyle(g)[h],j="border-";j+=e.vertical.test(c[0])?c[0]+"-"+c[1]:c[1]+"-"+c[0],j+="-radius";var k=b.getComputedStyle(f?d:a)[j],l={top:"auto",bottom:"auto",left:"auto",right:"auto",margin:0};switch(c[0]){case"top":l.bottom=f?"0":"-"+i;break;case"bottom":l.top=f?"0":"-"+i;break;case"left":l.right=f?"0":"-"+i;break;case"right":l.left=f?"0":"-"+i}l[c[1]]=k,angular.element(g).css(l)}}}}}]),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.position"]).value("$datepickerSuppressError",!1).constant("uibDatepickerConfig",{datepickerMode:"day",formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",maxDate:null,maxMode:"year",minDate:null,minMode:"day",ngModelOptions:{},shortcutPropagation:!1,showWeeks:!0,yearColumns:5,yearRows:4}).controller("UibDatepickerController",["$scope","$attrs","$parse","$interpolate","$locale","$log","dateFilter","uibDatepickerConfig","$datepickerSuppressError","uibDateParser",function(a,b,c,d,e,f,g,h,i,j){var k=this,l={$setViewValue:angular.noop},m={},n=[];this.modes=["day","month","year"],b.datepickerOptions?angular.forEach(["formatDay","formatDayHeader","formatDayTitle","formatMonth","formatMonthTitle","formatYear","initDate","maxDate","maxMode","minDate","minMode","showWeeks","shortcutPropagation","startingDay","yearColumns","yearRows"],function(b){switch(b){case"formatDay":case"formatDayHeader":case"formatDayTitle":case"formatMonth":case"formatMonthTitle":case"formatYear":k[b]=angular.isDefined(a.datepickerOptions[b])?d(a.datepickerOptions[b])(a.$parent):h[b];break;case"showWeeks":case"shortcutPropagation":case"yearColumns":case"yearRows":k[b]=angular.isDefined(a.datepickerOptions[b])?a.datepickerOptions[b]:h[b];break;case"startingDay":angular.isDefined(a.datepickerOptions.startingDay)?k.startingDay=a.datepickerOptions.startingDay:angular.isNumber(h.startingDay)?k.startingDay=h.startingDay:k.startingDay=(e.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7;break;case"maxDate":case"minDate":a.datepickerOptions[b]?a.$watch(function(){return a.datepickerOptions[b]},function(a){a?angular.isDate(a)?k[b]=j.fromTimezone(new Date(a),m.timezone):k[b]=new Date(g(a,"medium")):k[b]=null,k.refreshView()}):k[b]=h[b]?j.fromTimezone(new Date(h[b]),m.timezone):null;break;case"maxMode":case"minMode":a.datepickerOptions[b]?a.$watch(function(){return a.datepickerOptions[b]},function(c){k[b]=a[b]=angular.isDefined(c)?c:datepickerOptions[b],("minMode"===b&&k.modes.indexOf(a.datepickerMode)<k.modes.indexOf(k[b])||"maxMode"===b&&k.modes.indexOf(a.datepickerMode)>k.modes.indexOf(k[b]))&&(a.datepickerMode=k[b])}):k[b]=a[b]=h[b]||null;break;case"initDate":a.datepickerOptions.initDate?(this.activeDate=j.fromTimezone(a.datepickerOptions.initDate,m.timezone)||new Date,a.$watch(function(){return a.datepickerOptions.initDate},function(a){a&&(l.$isEmpty(l.$modelValue)||l.$invalid)&&(k.activeDate=j.fromTimezone(a,m.timezone),k.refreshView())})):this.activeDate=new Date}}):(angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle"],function(c){k[c]=angular.isDefined(b[c])?d(b[c])(a.$parent):h[c]}),angular.forEach(["showWeeks","yearRows","yearColumns","shortcutPropagation"],function(c){k[c]=angular.isDefined(b[c])?a.$parent.$eval(b[c]):h[c]}),angular.isDefined(b.startingDay)?k.startingDay=a.$parent.$eval(b.startingDay):angular.isNumber(h.startingDay)?k.startingDay=h.startingDay:k.startingDay=(e.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7,angular.forEach(["minDate","maxDate"],function(c){b[c]?n.push(a.$parent.$watch(b[c],function(a){a?angular.isDate(a)?k[c]=j.fromTimezone(new Date(a),m.timezone):k[c]=new Date(g(a,"medium")):k[c]=null,k.refreshView()})):k[c]=h[c]?j.fromTimezone(new Date(h[c]),m.timezone):null}),angular.forEach(["minMode","maxMode"],function(c){b[c]?n.push(a.$parent.$watch(b[c],function(d){k[c]=a[c]=angular.isDefined(d)?d:b[c],("minMode"===c&&k.modes.indexOf(a.datepickerMode)<k.modes.indexOf(k[c])||"maxMode"===c&&k.modes.indexOf(a.datepickerMode)>k.modes.indexOf(k[c]))&&(a.datepickerMode=k[c])})):k[c]=a[c]=h[c]||null}),angular.isDefined(b.initDate)?(this.activeDate=j.fromTimezone(a.$parent.$eval(b.initDate),m.timezone)||new Date,n.push(a.$parent.$watch(b.initDate,function(a){a&&(l.$isEmpty(l.$modelValue)||l.$invalid)&&(k.activeDate=j.fromTimezone(a,m.timezone),k.refreshView())}))):this.activeDate=new Date),a.datepickerMode=a.datepickerMode||h.datepickerMode,a.uniqueId="datepicker-"+a.$id+"-"+Math.floor(1e4*Math.random()),a.disabled=angular.isDefined(b.disabled)||!1,angular.isDefined(b.ngDisabled)&&n.push(a.$parent.$watch(b.ngDisabled,function(b){a.disabled=b,k.refreshView()})),a.isActive=function(b){return 0===k.compare(b.date,k.activeDate)?(a.activeDateId=b.uid,!0):!1},this.init=function(a){l=a,m=a.$options||h.ngModelOptions,l.$modelValue&&(this.activeDate=l.$modelValue),l.$render=function(){k.render()}},this.render=function(){if(l.$viewValue){var a=new Date(l.$viewValue),b=!isNaN(a);b?this.activeDate=j.fromTimezone(a,m.timezone):i||f.error('Datepicker directive: "ng-model" value must be a Date object')}this.refreshView()},this.refreshView=function(){if(this.element){a.selectedDt=null,this._refreshView(),a.activeDt&&(a.activeDateId=a.activeDt.uid);var b=l.$viewValue?new Date(l.$viewValue):null;b=j.fromTimezone(b,m.timezone),l.$setValidity("dateDisabled",!b||this.element&&!this.isDisabled(b))}},this.createDateObject=function(b,c){var d=l.$viewValue?new Date(l.$viewValue):null;d=j.fromTimezone(d,m.timezone);var e={date:b,label:j.filter(b,c),selected:d&&0===this.compare(b,d),disabled:this.isDisabled(b),current:0===this.compare(b,new Date),customClass:this.customClass(b)||null};return d&&0===this.compare(b,d)&&(a.selectedDt=e),k.activeDate&&0===this.compare(e.date,k.activeDate)&&(a.activeDt=e),e},this.isDisabled=function(c){return a.disabled||this.minDate&&this.compare(c,this.minDate)<0||this.maxDate&&this.compare(c,this.maxDate)>0||b.dateDisabled&&a.dateDisabled({date:c,mode:a.datepickerMode})},this.customClass=function(b){return a.customClass({date:b,mode:a.datepickerMode})},this.split=function(a,b){for(var c=[];a.length>0;)c.push(a.splice(0,b));return c},a.select=function(b){if(a.datepickerMode===k.minMode){var c=l.$viewValue?j.fromTimezone(new Date(l.$viewValue),m.timezone):new Date(0,0,0,0,0,0,0);c.setFullYear(b.getFullYear(),b.getMonth(),b.getDate()),c=j.toTimezone(c,m.timezone),l.$setViewValue(c),l.$render()}else k.activeDate=b,a.datepickerMode=k.modes[k.modes.indexOf(a.datepickerMode)-1]},a.move=function(a){var b=k.activeDate.getFullYear()+a*(k.step.years||0),c=k.activeDate.getMonth()+a*(k.step.months||0);k.activeDate.setFullYear(b,c,1),k.refreshView()},a.toggleMode=function(b){b=b||1,a.datepickerMode===k.maxMode&&1===b||a.datepickerMode===k.minMode&&-1===b||(a.datepickerMode=k.modes[k.modes.indexOf(a.datepickerMode)+b])},a.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var o=function(){k.element[0].focus()};a.$on("uib:datepicker.focus",o),a.keydown=function(b){var c=a.keys[b.which];if(c&&!b.shiftKey&&!b.altKey&&!a.disabled)if(b.preventDefault(),k.shortcutPropagation||b.stopPropagation(),"enter"===c||"space"===c){if(k.isDisabled(k.activeDate))return;a.select(k.activeDate)}else!b.ctrlKey||"up"!==c&&"down"!==c?(k.handleKeyDown(c,b),k.refreshView()):a.toggleMode("up"===c?1:-1)},a.$on("$destroy",function(){for(;n.length;)n.shift()()})}]).controller("UibDaypickerController",["$scope","$element","dateFilter",function(a,b,c){function d(a,b){return 1!==b||a%4!==0||a%100===0&&a%400!==0?f[b]:29}function e(a){var b=new Date(a);b.setDate(b.getDate()+4-(b.getDay()||7));var c=b.getTime();return b.setMonth(0),b.setDate(1),Math.floor(Math.round((c-b)/864e5)/7)+1}var f=[31,28,31,30,31,30,31,31,30,31,30,31];this.step={months:1},this.element=b,this.init=function(b){angular.extend(b,this),a.showWeeks=b.showWeeks,b.refreshView()},this.getDates=function(a,b){for(var c,d=new Array(b),e=new Date(a),f=0;b>f;)c=new Date(e),d[f++]=c,e.setDate(e.getDate()+1);return d;
},this._refreshView=function(){var b=this.activeDate.getFullYear(),d=this.activeDate.getMonth(),f=new Date(this.activeDate);f.setFullYear(b,d,1);var g=this.startingDay-f.getDay(),h=g>0?7-g:-g,i=new Date(f);h>0&&i.setDate(-h+1);for(var j=this.getDates(i,42),k=0;42>k;k++)j[k]=angular.extend(this.createDateObject(j[k],this.formatDay),{secondary:j[k].getMonth()!==d,uid:a.uniqueId+"-"+k});a.labels=new Array(7);for(var l=0;7>l;l++)a.labels[l]={abbr:c(j[l].date,this.formatDayHeader),full:c(j[l].date,"EEEE")};if(a.title=c(this.activeDate,this.formatDayTitle),a.rows=this.split(j,7),a.showWeeks){a.weekNumbers=[];for(var m=(11-this.startingDay)%7,n=a.rows.length,o=0;n>o;o++)a.weekNumbers.push(e(a.rows[o][m].date))}},this.compare=function(a,b){var c=new Date(a.getFullYear(),a.getMonth(),a.getDate()),d=new Date(b.getFullYear(),b.getMonth(),b.getDate());return c.setFullYear(a.getFullYear()),d.setFullYear(b.getFullYear()),c-d},this.handleKeyDown=function(a,b){var c=this.activeDate.getDate();if("left"===a)c-=1;else if("up"===a)c-=7;else if("right"===a)c+=1;else if("down"===a)c+=7;else if("pageup"===a||"pagedown"===a){var e=this.activeDate.getMonth()+("pageup"===a?-1:1);this.activeDate.setMonth(e,1),c=Math.min(d(this.activeDate.getFullYear(),this.activeDate.getMonth()),c)}else"home"===a?c=1:"end"===a&&(c=d(this.activeDate.getFullYear(),this.activeDate.getMonth()));this.activeDate.setDate(c)}}]).controller("UibMonthpickerController",["$scope","$element","dateFilter",function(a,b,c){this.step={years:1},this.element=b,this.init=function(a){angular.extend(a,this),a.refreshView()},this._refreshView=function(){for(var b,d=new Array(12),e=this.activeDate.getFullYear(),f=0;12>f;f++)b=new Date(this.activeDate),b.setFullYear(e,f,1),d[f]=angular.extend(this.createDateObject(b,this.formatMonth),{uid:a.uniqueId+"-"+f});a.title=c(this.activeDate,this.formatMonthTitle),a.rows=this.split(d,3)},this.compare=function(a,b){var c=new Date(a.getFullYear(),a.getMonth()),d=new Date(b.getFullYear(),b.getMonth());return c.setFullYear(a.getFullYear()),d.setFullYear(b.getFullYear()),c-d},this.handleKeyDown=function(a,b){var c=this.activeDate.getMonth();if("left"===a)c-=1;else if("up"===a)c-=3;else if("right"===a)c+=1;else if("down"===a)c+=3;else if("pageup"===a||"pagedown"===a){var d=this.activeDate.getFullYear()+("pageup"===a?-1:1);this.activeDate.setFullYear(d)}else"home"===a?c=0:"end"===a&&(c=11);this.activeDate.setMonth(c)}}]).controller("UibYearpickerController",["$scope","$element","dateFilter",function(a,b,c){function d(a){return parseInt((a-1)/f,10)*f+1}var e,f;this.element=b,this.yearpickerInit=function(){e=this.yearColumns,f=this.yearRows*e,this.step={years:f}},this._refreshView=function(){for(var b,c=new Array(f),g=0,h=d(this.activeDate.getFullYear());f>g;g++)b=new Date(this.activeDate),b.setFullYear(h+g,0,1),c[g]=angular.extend(this.createDateObject(b,this.formatYear),{uid:a.uniqueId+"-"+g});a.title=[c[0].label,c[f-1].label].join(" - "),a.rows=this.split(c,e),a.columns=e},this.compare=function(a,b){return a.getFullYear()-b.getFullYear()},this.handleKeyDown=function(a,b){var c=this.activeDate.getFullYear();"left"===a?c-=1:"up"===a?c-=e:"right"===a?c+=1:"down"===a?c+=e:"pageup"===a||"pagedown"===a?c+=("pageup"===a?-1:1)*f:"home"===a?c=d(this.activeDate.getFullYear()):"end"===a&&(c=d(this.activeDate.getFullYear())+f-1),this.activeDate.setFullYear(c)}}]).directive("uibDatepicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/datepicker/datepicker.html"},scope:{datepickerMode:"=?",datepickerOptions:"=?",dateDisabled:"&",customClass:"&",shortcutPropagation:"&?"},require:["uibDatepicker","^ngModel"],controller:"UibDatepickerController",controllerAs:"datepicker",link:function(a,b,c,d){var e=d[0],f=d[1];e.init(f)}}}).directive("uibDaypicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/datepicker/day.html"},require:["^uibDatepicker","uibDaypicker"],controller:"UibDaypickerController",link:function(a,b,c,d){var e=d[0],f=d[1];f.init(e)}}}).directive("uibMonthpicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/datepicker/month.html"},require:["^uibDatepicker","uibMonthpicker"],controller:"UibMonthpickerController",link:function(a,b,c,d){var e=d[0],f=d[1];f.init(e)}}}).directive("uibYearpicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/datepicker/year.html"},require:["^uibDatepicker","uibYearpicker"],controller:"UibYearpickerController",link:function(a,b,c,d){var e=d[0];angular.extend(e,d[1]),e.yearpickerInit(),e.refreshView()}}}).constant("uibDatepickerPopupConfig",{altInputFormats:[],appendToBody:!1,clearText:"Clear",closeOnDateSelection:!0,closeText:"Done",currentText:"Today",datepickerPopup:"yyyy-MM-dd",datepickerPopupTemplateUrl:"uib/template/datepicker/popup.html",datepickerTemplateUrl:"uib/template/datepicker/datepicker.html",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},onOpenFocus:!0,showButtonBar:!0}).controller("UibDatepickerPopupController",["$scope","$element","$attrs","$compile","$parse","$document","$rootScope","$uibPosition","dateFilter","uibDateParser","uibDatepickerPopupConfig","$timeout","uibDatepickerConfig",function(a,b,c,d,e,f,g,h,i,j,k,l,m){function n(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function o(b){var c=j.parse(b,t,a.date);if(isNaN(c))for(var d=0;d<E.length;d++)if(c=j.parse(b,E[d],a.date),!isNaN(c))return c;return c}function p(a){if(angular.isNumber(a)&&(a=new Date(a)),!a)return null;if(angular.isDate(a)&&!isNaN(a))return a;if(angular.isString(a)){var b=o(a);if(!isNaN(b))return j.toTimezone(b,C.timezone)}return B.$options&&B.$options.allowInvalid?a:void 0}function q(a,b){var d=a||b;return c.ngRequired||d?(angular.isNumber(d)&&(d=new Date(d)),d?angular.isDate(d)&&!isNaN(d)?!0:angular.isString(d)?!isNaN(o(b)):!1:!0):!0}function r(c){if(a.isOpen||!a.disabled){var d=D[0],e=b[0].contains(c.target),f=void 0!==d.contains&&d.contains(c.target);!a.isOpen||e||f||a.$apply(function(){a.isOpen=!1})}}function s(c){27===c.which&&a.isOpen?(c.preventDefault(),c.stopPropagation(),a.$apply(function(){a.isOpen=!1}),b[0].focus()):40!==c.which||a.isOpen||(c.preventDefault(),c.stopPropagation(),a.$apply(function(){a.isOpen=!0}))}var t,u,v,w,x,y,z,A,B,C,D,E,F={},G=!1,H=[];a.watchData={},this.init=function(h){if(B=h,C=h.$options||m.ngModelOptions,u=angular.isDefined(c.closeOnDateSelection)?a.$parent.$eval(c.closeOnDateSelection):k.closeOnDateSelection,v=angular.isDefined(c.datepickerAppendToBody)?a.$parent.$eval(c.datepickerAppendToBody):k.appendToBody,w=angular.isDefined(c.onOpenFocus)?a.$parent.$eval(c.onOpenFocus):k.onOpenFocus,x=angular.isDefined(c.datepickerPopupTemplateUrl)?c.datepickerPopupTemplateUrl:k.datepickerPopupTemplateUrl,y=angular.isDefined(c.datepickerTemplateUrl)?c.datepickerTemplateUrl:k.datepickerTemplateUrl,E=angular.isDefined(c.altInputFormats)?a.$parent.$eval(c.altInputFormats):k.altInputFormats,a.showButtonBar=angular.isDefined(c.showButtonBar)?a.$parent.$eval(c.showButtonBar):k.showButtonBar,k.html5Types[c.type]?(t=k.html5Types[c.type],G=!0):(t=c.uibDatepickerPopup||k.datepickerPopup,c.$observe("uibDatepickerPopup",function(a,b){var c=a||k.datepickerPopup;if(c!==t&&(t=c,B.$modelValue=null,!t))throw new Error("uibDatepickerPopup must have a date format specified.")})),!t)throw new Error("uibDatepickerPopup must have a date format specified.");if(G&&c.uibDatepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");z=angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"),a.ngModelOptions=angular.copy(C),a.ngModelOptions.timezone=null,z.attr({"ng-model":"date","ng-model-options":"ngModelOptions","ng-change":"dateSelection(date)","template-url":x}),A=angular.element(z.children()[0]),A.attr("template-url",y),G&&"month"===c.type&&(A.attr("datepicker-mode",'"month"'),A.attr("min-mode","month")),a.datepickerOptions&&angular.forEach(a.datepickerOptions,function(a,b){-1===["minDate","maxDate","minMode","maxMode","initDate","datepickerMode"].indexOf(b)?A.attr(n(b),a):A.attr(n(b),"datepickerOptions."+b)}),angular.forEach(["minMode","maxMode","datepickerMode","shortcutPropagation"],function(b){if(c[b]){var d=e(c[b]),f={get:function(){return d(a.$parent)}};if(A.attr(n(b),"watchData."+b),"datepickerMode"===b){var g=d.assign;f.set=function(b){g(a.$parent,b)}}Object.defineProperty(a.watchData,b,f)}}),angular.forEach(["minDate","maxDate","initDate"],function(b){if(c[b]){var d=e(c[b]);H.push(a.$parent.$watch(d,function(c){"minDate"===b||"maxDate"===b?(null===c?F[b]=null:angular.isDate(c)?F[b]=j.fromTimezone(new Date(c),C.timezone):F[b]=new Date(i(c,"medium")),a.watchData[b]=null===c?null:F[b]):a.watchData[b]=j.fromTimezone(new Date(c),C.timezone)})),A.attr(n(b),"watchData."+b)}}),c.dateDisabled&&A.attr("date-disabled","dateDisabled({ date: date, mode: mode })"),angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","showWeeks","startingDay","yearRows","yearColumns"],function(a){angular.isDefined(c[a])&&A.attr(n(a),c[a])}),c.customClass&&A.attr("custom-class","customClass({ date: date, mode: mode })"),G?B.$formatters.push(function(b){return a.date=j.fromTimezone(b,C.timezone),b}):(B.$$parserName="date",B.$validators.date=q,B.$parsers.unshift(p),B.$formatters.push(function(b){return B.$isEmpty(b)?(a.date=b,b):(a.date=j.fromTimezone(b,C.timezone),angular.isNumber(a.date)&&(a.date=new Date(a.date)),j.filter(a.date,t))})),B.$viewChangeListeners.push(function(){a.date=o(B.$viewValue)}),b.on("keydown",s),D=d(z)(a),z.remove(),v?f.find("body").append(D):b.after(D),a.$on("$destroy",function(){for(a.isOpen===!0&&(g.$$phase||a.$apply(function(){a.isOpen=!1})),D.remove(),b.off("keydown",s),f.off("click",r);H.length;)H.shift()()})},a.getText=function(b){return a[b+"Text"]||k[b+"Text"]},a.isDisabled=function(b){return"today"===b&&(b=new Date),a.watchData.minDate&&a.compare(b,F.minDate)<0||a.watchData.maxDate&&a.compare(b,F.maxDate)>0},a.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth(),a.getDate())-new Date(b.getFullYear(),b.getMonth(),b.getDate())},a.dateSelection=function(c){angular.isDefined(c)&&(a.date=c);var d=a.date?j.filter(a.date,t):null;b.val(d),B.$setViewValue(d),u&&(a.isOpen=!1,b[0].focus())},a.keydown=function(c){27===c.which&&(c.stopPropagation(),a.isOpen=!1,b[0].focus())},a.select=function(b){if("today"===b){var c=new Date;angular.isDate(a.date)?(b=new Date(a.date),b.setFullYear(c.getFullYear(),c.getMonth(),c.getDate())):b=new Date(c.setHours(0,0,0,0))}a.dateSelection(b)},a.close=function(){a.isOpen=!1,b[0].focus()},a.disabled=angular.isDefined(c.disabled)||!1,c.ngDisabled&&H.push(a.$parent.$watch(e(c.ngDisabled),function(b){a.disabled=b})),a.$watch("isOpen",function(c){c?a.disabled?a.isOpen=!1:(a.position=v?h.offset(b):h.position(b),a.position.top=a.position.top+b.prop("offsetHeight"),l(function(){w&&a.$broadcast("uib:datepicker.focus"),f.on("click",r)},0,!1)):f.off("click",r)})}]).directive("uibDatepickerPopup",function(){return{require:["ngModel","uibDatepickerPopup"],controller:"UibDatepickerPopupController",scope:{datepickerOptions:"=?",isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&",customClass:"&"},link:function(a,b,c,d){var e=d[0],f=d[1];f.init(e)}}}).directive("uibDatepickerPopupWrap",function(){return{replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/datepicker/popup.html"}}}),angular.module("ui.bootstrap.debounce",[]).factory("$$debounce",["$timeout",function(a){return function(b,c){var d;return function(){var e=this,f=Array.prototype.slice.call(arguments);d&&a.cancel(d),d=a(function(){b.apply(e,f)},c)}}}]),angular.module("ui.bootstrap.dropdown",["ui.bootstrap.position"]).constant("uibDropdownConfig",{appendToOpenClass:"uib-dropdown-open",openClass:"open"}).service("uibDropdownService",["$document","$rootScope",function(a,b){var c=null;this.open=function(b){c||(a.on("click",d),a.on("keydown",e)),c&&c!==b&&(c.isOpen=!1),c=b},this.close=function(b){c===b&&(c=null,a.off("click",d),a.off("keydown",e))};var d=function(a){if(c&&!(a&&"disabled"===c.getAutoClose()||a&&3===a.which)){var d=c.getToggleElement();if(!(a&&d&&d[0].contains(a.target))){var e=c.getDropdownElement();a&&"outsideClick"===c.getAutoClose()&&e&&e[0].contains(a.target)||(c.isOpen=!1,b.$$phase||c.$apply())}}},e=function(a){27===a.which?(c.focusToggleElement(),d()):c.isKeynavEnabled()&&-1!==[38,40].indexOf(a.which)&&c.isOpen&&(a.preventDefault(),a.stopPropagation(),c.focusDropdownEntry(a.which))}}]).controller("UibDropdownController",["$scope","$element","$attrs","$parse","uibDropdownConfig","uibDropdownService","$animate","$uibPosition","$document","$compile","$templateRequest",function(a,b,c,d,e,f,g,h,i,j,k){var l,m,n=this,o=a.$new(),p=e.appendToOpenClass,q=e.openClass,r=angular.noop,s=c.onToggle?d(c.onToggle):angular.noop,t=!1,u=null,v=!1,w=i.find("body");b.addClass("dropdown"),this.init=function(){if(c.isOpen&&(m=d(c.isOpen),r=m.assign,a.$watch(m,function(a){o.isOpen=!!a})),angular.isDefined(c.dropdownAppendTo)){var e=d(c.dropdownAppendTo)(o);e&&(u=angular.element(e))}t=angular.isDefined(c.dropdownAppendToBody),v=angular.isDefined(c.keyboardNav),t&&!u&&(u=w),u&&n.dropdownMenu&&(u.append(n.dropdownMenu),b.on("$destroy",function(){n.dropdownMenu.remove()}))},this.toggle=function(a){return o.isOpen=arguments.length?!!a:!o.isOpen},this.isOpen=function(){return o.isOpen},o.getToggleElement=function(){return n.toggleElement},o.getAutoClose=function(){return c.autoClose||"always"},o.getElement=function(){return b},o.isKeynavEnabled=function(){return v},o.focusDropdownEntry=function(a){var c=n.dropdownMenu?angular.element(n.dropdownMenu).find("a"):b.find("ul").eq(0).find("a");switch(a){case 40:angular.isNumber(n.selectedOption)?n.selectedOption=n.selectedOption===c.length-1?n.selectedOption:n.selectedOption+1:n.selectedOption=0;break;case 38:angular.isNumber(n.selectedOption)?n.selectedOption=0===n.selectedOption?0:n.selectedOption-1:n.selectedOption=c.length-1}c[n.selectedOption].focus()},o.getDropdownElement=function(){return n.dropdownMenu},o.focusToggleElement=function(){n.toggleElement&&n.toggleElement[0].focus()},o.$watch("isOpen",function(c,d){if(u&&n.dropdownMenu){var e,i,m=h.positionElements(b,n.dropdownMenu,"bottom-left",!0);if(e={top:m.top+"px",display:c?"block":"none"},i=n.dropdownMenu.hasClass("dropdown-menu-right"),i?(e.left="auto",e.right=window.innerWidth-(m.left+b.prop("offsetWidth"))+"px"):(e.left=m.left+"px",e.right="auto"),!t){var v=h.offset(u);e.top=m.top-v.top+"px",i?e.right=window.innerWidth-(m.left-v.left+b.prop("offsetWidth"))+"px":e.left=m.left-v.left+"px"}n.dropdownMenu.css(e)}var w=u?u:b;if(g[c?"addClass":"removeClass"](w,u?p:q).then(function(){angular.isDefined(c)&&c!==d&&s(a,{open:!!c})}),c)n.dropdownMenuTemplateUrl&&k(n.dropdownMenuTemplateUrl).then(function(a){l=o.$new(),j(a.trim())(l,function(a){var b=a;n.dropdownMenu.replaceWith(b),n.dropdownMenu=b})}),o.focusToggleElement(),f.open(o);else{if(n.dropdownMenuTemplateUrl){l&&l.$destroy();var x=angular.element('<ul class="dropdown-menu"></ul>');n.dropdownMenu.replaceWith(x),n.dropdownMenu=x}f.close(o),n.selectedOption=null}angular.isFunction(r)&&r(a,c)}),a.$on("$locationChangeSuccess",function(){"disabled"!==o.getAutoClose()&&(o.isOpen=!1)})}]).directive("uibDropdown",function(){return{controller:"UibDropdownController",link:function(a,b,c,d){d.init()}}}).directive("uibDropdownMenu",function(){return{restrict:"A",require:"?^uibDropdown",link:function(a,b,c,d){if(d&&!angular.isDefined(c.dropdownNested)){b.addClass("dropdown-menu");var e=c.templateUrl;e&&(d.dropdownMenuTemplateUrl=e),d.dropdownMenu||(d.dropdownMenu=b)}}}}).directive("uibDropdownToggle",function(){return{require:"?^uibDropdown",link:function(a,b,c,d){if(d){b.addClass("dropdown-toggle"),d.toggleElement=b;var e=function(e){e.preventDefault(),b.hasClass("disabled")||c.disabled||a.$apply(function(){d.toggle()})};b.bind("click",e),b.attr({"aria-haspopup":!0,"aria-expanded":!1}),a.$watch(d.isOpen,function(a){b.attr("aria-expanded",!!a)}),a.$on("$destroy",function(){b.unbind("click",e)})}}}}),angular.module("ui.bootstrap.stackedMap",[]).factory("$$stackedMap",function(){return{createNew:function(){var a=[];return{add:function(b,c){a.push({key:b,value:c})},get:function(b){for(var c=0;c<a.length;c++)if(b===a[c].key)return a[c]},keys:function(){for(var b=[],c=0;c<a.length;c++)b.push(a[c].key);return b},top:function(){return a[a.length-1]},remove:function(b){for(var c=-1,d=0;d<a.length;d++)if(b===a[d].key){c=d;break}return a.splice(c,1)[0]},removeTop:function(){return a.splice(a.length-1,1)[0]},length:function(){return a.length}}}}}),angular.module("ui.bootstrap.modal",["ui.bootstrap.stackedMap"]).factory("$$multiMap",function(){return{createNew:function(){var a={};return{entries:function(){return Object.keys(a).map(function(b){return{key:b,value:a[b]}})},get:function(b){return a[b]},hasKey:function(b){return!!a[b]},keys:function(){return Object.keys(a)},put:function(b,c){a[b]||(a[b]=[]),a[b].push(c)},remove:function(b,c){var d=a[b];if(d){var e=d.indexOf(c);-1!==e&&d.splice(e,1),d.length||delete a[b]}}}}}}).provider("$uibResolve",function(){var a=this;this.resolver=null,this.setResolver=function(a){this.resolver=a},this.$get=["$injector","$q",function(b,c){var d=a.resolver?b.get(a.resolver):null;return{resolve:function(a,e,f,g){if(d)return d.resolve(a,e,f,g);var h=[];return angular.forEach(a,function(a){angular.isFunction(a)||angular.isArray(a)?h.push(c.resolve(b.invoke(a))):angular.isString(a)?h.push(c.resolve(b.get(a))):h.push(c.resolve(a))}),c.all(h).then(function(b){var c={},d=0;return angular.forEach(a,function(a,e){c[e]=b[d++]}),c})}}}]}).directive("uibModalBackdrop",["$animateCss","$injector","$uibModalStack",function(a,b,c){function d(b,d,e){e.modalInClass&&(a(d,{addClass:e.modalInClass}).start(),b.$on(c.NOW_CLOSING_EVENT,function(c,f){var g=f();b.modalOptions.animation?a(d,{removeClass:e.modalInClass}).start().then(g):g()}))}return{replace:!0,templateUrl:"uib/template/modal/backdrop.html",compile:function(a,b){return a.addClass(b.backdropClass),d}}}]).directive("uibModalWindow",["$uibModalStack","$q","$animate","$animateCss","$document",function(a,b,c,d,e){return{scope:{index:"@"},replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"uib/template/modal/window.html"},link:function(f,g,h){g.addClass(h.windowClass||""),g.addClass(h.windowTopClass||""),f.size=h.size,f.close=function(b){var c=a.getTop();c&&c.value.backdrop&&"static"!==c.value.backdrop&&b.target===b.currentTarget&&(b.preventDefault(),b.stopPropagation(),a.dismiss(c.key,"backdrop click"))},g.on("click",f.close),f.$isRendered=!0;var i=b.defer();h.$observe("modalRender",function(a){"true"===a&&i.resolve()}),i.promise.then(function(){var i=null;h.modalInClass&&(i=d(g,{addClass:h.modalInClass}).start(),f.$on(a.NOW_CLOSING_EVENT,function(a,b){var e=b();d?d(g,{removeClass:h.modalInClass}).start().then(e):c.removeClass(g,h.modalInClass).then(e)})),b.when(i).then(function(){if(!e[0].activeElement||!g[0].contains(e[0].activeElement)){var a=g[0].querySelector("[autofocus]");a?a.focus():g[0].focus()}});var j=a.getTop();j&&a.modalRendered(j.key)})}}}]).directive("uibModalAnimationClass",function(){return{compile:function(a,b){b.modalAnimation&&a.addClass(b.uibModalAnimationClass)}}}).directive("uibModalTransclude",function(){return{link:function(a,b,c,d,e){e(a.$parent,function(a){b.empty(),b.append(a)})}}}).factory("$uibModalStack",["$animate","$animateCss","$document","$compile","$rootScope","$q","$$multiMap","$$stackedMap",function(a,b,c,d,e,f,g,h){function i(){for(var a=-1,b=t.keys(),c=0;c<b.length;c++)t.get(b[c]).value.backdrop&&(a=c);return a}function j(a,b){var c=t.get(a).value,d=c.appendTo;t.remove(a),m(c.modalDomEl,c.modalScope,function(){var b=c.openedClass||s;u.remove(b,a),d.toggleClass(b,u.hasKey(b)),k(!0)},c.closedDeferred),l(),b&&b.focus?b.focus():d.focus&&d.focus()}function k(a){var b;t.length()>0&&(b=t.top().value,b.modalDomEl.toggleClass(b.windowTopClass||"",a))}function l(){if(p&&-1===i()){var a=q;m(p,q,function(){a=null}),p=void 0,q=void 0}}function m(a,c,d,e){function g(){g.done||(g.done=!0,b(a,{event:"leave"}).start().then(function(){a.remove(),e&&e.resolve()}),c.$destroy(),d&&d())}var h,i=null,j=function(){return h||(h=f.defer(),i=h.promise),function(){h.resolve()}};return c.$broadcast(v.NOW_CLOSING_EVENT,j),f.when(i).then(g)}function n(a){if(a.isDefaultPrevented())return a;var b=t.top();if(b)switch(a.which){case 27:b.value.keyboard&&(a.preventDefault(),e.$apply(function(){v.dismiss(b.key,"escape key press")}));break;case 9:v.loadFocusElementList(b);var c=!1;a.shiftKey?(v.isFocusInFirstItem(a)||v.isModalFocused(a,b))&&(c=v.focusLastFocusableElement()):v.isFocusInLastItem(a)&&(c=v.focusFirstFocusableElement()),c&&(a.preventDefault(),a.stopPropagation())}}function o(a,b,c){return!a.value.modalScope.$broadcast("modal.closing",b,c).defaultPrevented}var p,q,r,s="modal-open",t=h.createNew(),u=g.createNew(),v={NOW_CLOSING_EVENT:"modal.stack.now-closing"},w=0,x="a[href], area[href], input:not([disabled]), button:not([disabled]),select:not([disabled]), textarea:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable=true]";return e.$watch(i,function(a){q&&(q.index=a)}),c.on("keydown",n),e.$on("$destroy",function(){c.off("keydown",n)}),v.open=function(b,f){var g=c[0].activeElement,h=f.openedClass||s;k(!1),t.add(b,{deferred:f.deferred,renderDeferred:f.renderDeferred,closedDeferred:f.closedDeferred,modalScope:f.scope,backdrop:f.backdrop,keyboard:f.keyboard,openedClass:f.openedClass,windowTopClass:f.windowTopClass,animation:f.animation,appendTo:f.appendTo}),u.put(h,b);var j=f.appendTo,l=i();if(!j.length)throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");l>=0&&!p&&(q=e.$new(!0),q.modalOptions=f,q.index=l,p=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'),p.attr("backdrop-class",f.backdropClass),f.animation&&p.attr("modal-animation","true"),d(p)(q),a.enter(p,j));var m=angular.element('<div uib-modal-window="modal-window"></div>');m.attr({"template-url":f.windowTemplateUrl,"window-class":f.windowClass,"window-top-class":f.windowTopClass,size:f.size,index:t.length()-1,animate:"animate"}).html(f.content),f.animation&&m.attr("modal-animation","true"),a.enter(d(m)(f.scope),j).then(function(){a.addClass(j,h)}),t.top().value.modalDomEl=m,t.top().value.modalOpener=g,v.clearFocusListCache()},v.close=function(a,b){var c=t.get(a);return c&&o(c,b,!0)?(c.value.modalScope.$$uibDestructionScheduled=!0,c.value.deferred.resolve(b),j(a,c.value.modalOpener),!0):!c},v.dismiss=function(a,b){var c=t.get(a);return c&&o(c,b,!1)?(c.value.modalScope.$$uibDestructionScheduled=!0,c.value.deferred.reject(b),j(a,c.value.modalOpener),!0):!c},v.dismissAll=function(a){for(var b=this.getTop();b&&this.dismiss(b.key,a);)b=this.getTop()},v.getTop=function(){return t.top()},v.modalRendered=function(a){var b=t.get(a);b&&b.value.renderDeferred.resolve()},v.focusFirstFocusableElement=function(){return r.length>0?(r[0].focus(),!0):!1},v.focusLastFocusableElement=function(){return r.length>0?(r[r.length-1].focus(),!0):!1},v.isModalFocused=function(a,b){if(a&&b){var c=b.value.modalDomEl;if(c&&c.length)return(a.target||a.srcElement)===c[0]}return!1},v.isFocusInFirstItem=function(a){return r.length>0?(a.target||a.srcElement)===r[0]:!1},v.isFocusInLastItem=function(a){return r.length>0?(a.target||a.srcElement)===r[r.length-1]:!1},v.clearFocusListCache=function(){r=[],w=0},v.loadFocusElementList=function(a){if((void 0===r||!r.length)&&a){var b=a.value.modalDomEl;b&&b.length&&(r=b[0].querySelectorAll(x))}},v}]).provider("$uibModal",function(){var a={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$rootScope","$q","$document","$templateRequest","$controller","$uibResolve","$uibModalStack",function(b,c,d,e,f,g,h){function i(a){return a.template?c.when(a.template):e(angular.isFunction(a.templateUrl)?a.templateUrl():a.templateUrl)}var j={},k=null;return j.getPromiseChain=function(){return k},j.open=function(e){function j(){return r}var l=c.defer(),m=c.defer(),n=c.defer(),o=c.defer(),p={result:l.promise,opened:m.promise,closed:n.promise,rendered:o.promise,close:function(a){return h.close(p,a)},dismiss:function(a){return h.dismiss(p,a)}};if(e=angular.extend({},a.options,e),e.resolve=e.resolve||{},e.appendTo=e.appendTo||d.find("body").eq(0),!e.template&&!e.templateUrl)throw new Error("One of template or templateUrl options is required.");var q,r=c.all([i(e),g.resolve(e.resolve,{},null,null)]);return q=k=c.all([k]).then(j,j).then(function(a){var c=e.scope||b,d=c.$new();d.$close=p.close,d.$dismiss=p.dismiss,d.$on("$destroy",function(){d.$$uibDestructionScheduled||d.$dismiss("$uibUnscheduledDestruction")});var g,i={};e.controller&&(i.$scope=d,i.$uibModalInstance=p,angular.forEach(a[1],function(a,b){i[b]=a}),g=f(e.controller,i),e.controllerAs&&(e.bindToController&&(g.$close=d.$close,g.$dismiss=d.$dismiss,angular.extend(g,c)),d[e.controllerAs]=g)),h.open(p,{scope:d,deferred:l,renderDeferred:o,closedDeferred:n,content:a[0],animation:e.animation,backdrop:e.backdrop,keyboard:e.keyboard,backdropClass:e.backdropClass,windowTopClass:e.windowTopClass,windowClass:e.windowClass,windowTemplateUrl:e.windowTemplateUrl,size:e.size,openedClass:e.openedClass,appendTo:e.appendTo}),m.resolve(!0)},function(a){m.reject(a),l.reject(a)})["finally"](function(){k===q&&(k=null)}),p},j}]};return a}),angular.module("ui.bootstrap.paging",[]).factory("uibPaging",["$parse",function(a){return{create:function(b,c,d){b.setNumPages=d.numPages?a(d.numPages).assign:angular.noop,b.ngModelCtrl={$setViewValue:angular.noop},b._watchers=[],b.init=function(e,f){b.ngModelCtrl=e,b.config=f,e.$render=function(){b.render()},d.itemsPerPage?b._watchers.push(c.$parent.$watch(a(d.itemsPerPage),function(a){b.itemsPerPage=parseInt(a,10),c.totalPages=b.calculateTotalPages(),b.updatePage()})):b.itemsPerPage=f.itemsPerPage,c.$watch("totalItems",function(a,d){(angular.isDefined(a)||a!==d)&&(c.totalPages=b.calculateTotalPages(),b.updatePage())})},b.calculateTotalPages=function(){var a=b.itemsPerPage<1?1:Math.ceil(c.totalItems/b.itemsPerPage);return Math.max(a||0,1)},b.render=function(){c.page=parseInt(b.ngModelCtrl.$viewValue,10)||1},c.selectPage=function(a,d){d&&d.preventDefault();var e=!c.ngDisabled||!d;e&&c.page!==a&&a>0&&a<=c.totalPages&&(d&&d.target&&d.target.blur(),b.ngModelCtrl.$setViewValue(a),b.ngModelCtrl.$render())},c.getText=function(a){return c[a+"Text"]||b.config[a+"Text"]},c.noPrevious=function(){return 1===c.page},c.noNext=function(){return c.page===c.totalPages},b.updatePage=function(){b.setNumPages(c.$parent,c.totalPages),c.page>c.totalPages?c.selectPage(c.totalPages):b.ngModelCtrl.$render()},c.$on("$destroy",function(){for(;b._watchers.length;)b._watchers.shift()()})}}}]),angular.module("ui.bootstrap.pager",["ui.bootstrap.paging"]).controller("UibPagerController",["$scope","$attrs","uibPaging","uibPagerConfig",function(a,b,c,d){a.align=angular.isDefined(b.align)?a.$parent.$eval(b.align):d.align,c.create(this,a,b)}]).constant("uibPagerConfig",{itemsPerPage:10,previousText:"« Previous",nextText:"Next »",align:!0}).directive("uibPager",["uibPagerConfig",function(a){return{scope:{totalItems:"=",previousText:"@",nextText:"@",ngDisabled:"="},require:["uibPager","?ngModel"],controller:"UibPagerController",controllerAs:"pager",templateUrl:function(a,b){return b.templateUrl||"uib/template/pager/pager.html"},replace:!0,link:function(b,c,d,e){var f=e[0],g=e[1];g&&f.init(g,a)}}}]),angular.module("ui.bootstrap.pagination",["ui.bootstrap.paging"]).controller("UibPaginationController",["$scope","$attrs","$parse","uibPaging","uibPaginationConfig",function(a,b,c,d,e){function f(a,b,c){return{number:a,text:b,active:c}}function g(a,b){var c=[],d=1,e=b,g=angular.isDefined(i)&&b>i;g&&(j?(d=Math.max(a-Math.floor(i/2),1),e=d+i-1,e>b&&(e=b,d=e-i+1)):(d=(Math.ceil(a/i)-1)*i+1,e=Math.min(d+i-1,b)));for(var h=d;e>=h;h++){var m=f(h,h,h===a);c.push(m)}if(g&&i>0&&(!j||k||l)){if(d>1){if(!l||d>3){var n=f(d-1,"...",!1);c.unshift(n)}if(l){if(3===d){var o=f(2,"2",!1);c.unshift(o)}var p=f(1,"1",!1);c.unshift(p)}}if(b>e){if(!l||b-2>e){var q=f(e+1,"...",!1);c.push(q)}if(l){if(e===b-2){var r=f(b-1,b-1,!1);c.push(r)}var s=f(b,b,!1);c.push(s)}}}return c}var h=this,i=angular.isDefined(b.maxSize)?a.$parent.$eval(b.maxSize):e.maxSize,j=angular.isDefined(b.rotate)?a.$parent.$eval(b.rotate):e.rotate,k=angular.isDefined(b.forceEllipses)?a.$parent.$eval(b.forceEllipses):e.forceEllipses,l=angular.isDefined(b.boundaryLinkNumbers)?a.$parent.$eval(b.boundaryLinkNumbers):e.boundaryLinkNumbers;a.boundaryLinks=angular.isDefined(b.boundaryLinks)?a.$parent.$eval(b.boundaryLinks):e.boundaryLinks,a.directionLinks=angular.isDefined(b.directionLinks)?a.$parent.$eval(b.directionLinks):e.directionLinks,d.create(this,a,b),b.maxSize&&h._watchers.push(a.$parent.$watch(c(b.maxSize),function(a){i=parseInt(a,10),h.render()}));var m=this.render;this.render=function(){m(),a.page>0&&a.page<=a.totalPages&&(a.pages=g(a.page,a.totalPages))}}]).constant("uibPaginationConfig",{itemsPerPage:10,boundaryLinks:!1,boundaryLinkNumbers:!1,directionLinks:!0,firstText:"First",previousText:"Previous",nextText:"Next",lastText:"Last",rotate:!0,forceEllipses:!1}).directive("uibPagination",["$parse","uibPaginationConfig",function(a,b){return{scope:{totalItems:"=",firstText:"@",previousText:"@",nextText:"@",lastText:"@",ngDisabled:"="},require:["uibPagination","?ngModel"],controller:"UibPaginationController",controllerAs:"pagination",templateUrl:function(a,b){return b.templateUrl||"uib/template/pagination/pagination.html"},replace:!0,link:function(a,c,d,e){var f=e[0],g=e[1];g&&f.init(g,b)}}}]),angular.module("ui.bootstrap.tooltip",["ui.bootstrap.position","ui.bootstrap.stackedMap"]).provider("$uibTooltip",function(){function a(a){var b=/[A-Z]/g,c="-";return a.replace(b,function(a,b){return(b?c:"")+a.toLowerCase()})}var b={placement:"top",placementClassPrefix:"",animation:!0,popupDelay:0,popupCloseDelay:0,useContentExp:!1},c={mouseenter:"mouseleave",click:"click",outsideClick:"outsideClick",focus:"blur",none:""},d={};this.options=function(a){angular.extend(d,a)},this.setTriggers=function(a){angular.extend(c,a)},this.$get=["$window","$compile","$timeout","$document","$uibPosition","$interpolate","$rootScope","$parse","$$stackedMap",function(e,f,g,h,i,j,k,l,m){function n(a){if(27===a.which){var b=o.top();b&&(b.value.close(),o.removeTop(),b=null)}}var o=m.createNew();return h.on("keypress",n),k.$on("$destroy",function(){h.off("keypress",n)}),function(e,k,m,n){function p(a){var b=(a||n.trigger||m).split(" "),d=b.map(function(a){return c[a]||a});return{show:b,hide:d}}n=angular.extend({},b,d,n);var q=a(e),r=j.startSymbol(),s=j.endSymbol(),t="<div "+q+'-popup title="'+r+"title"+s+'" '+(n.useContentExp?'content-exp="contentExp()" ':'content="'+r+"content"+s+'" ')+'placement="'+r+"placement"+s+'" popup-class="'+r+"popupClass"+s+'" animation="animation" is-open="isOpen"origin-scope="origScope" style="visibility: hidden; display: block; top: -9999px; left: -9999px;"></div>';return{compile:function(a,b){var c=f(t);return function(a,b,d,f){function j(){M.isOpen?q():m()}function m(){(!L||a.$eval(d[k+"Enable"]))&&(u(),x(),M.popupDelay?G||(G=g(r,M.popupDelay,!1)):r())}function q(){s(),M.popupCloseDelay?H||(H=g(t,M.popupCloseDelay,!1)):t()}function r(){return s(),u(),M.content?(v(),void M.$evalAsync(function(){M.isOpen=!0,y(!0),R()})):angular.noop}function s(){G&&(g.cancel(G),G=null),I&&(g.cancel(I),I=null)}function t(){M&&M.$evalAsync(function(){M&&(M.isOpen=!1,y(!1),M.animation?F||(F=g(w,150,!1)):w())})}function u(){H&&(g.cancel(H),H=null),F&&(g.cancel(F),F=null)}function v(){D||(E=M.$new(),D=c(E,function(a){J?h.find("body").append(a):b.after(a);
}),z())}function w(){s(),u(),A(),D&&(D.remove(),D=null),E&&(E.$destroy(),E=null)}function x(){M.title=d[k+"Title"],P?M.content=P(a):M.content=d[e],M.popupClass=d[k+"Class"],M.placement=angular.isDefined(d[k+"Placement"])?d[k+"Placement"]:n.placement;var b=parseInt(d[k+"PopupDelay"],10),c=parseInt(d[k+"PopupCloseDelay"],10);M.popupDelay=isNaN(b)?n.popupDelay:b,M.popupCloseDelay=isNaN(c)?n.popupCloseDelay:c}function y(b){O&&angular.isFunction(O.assign)&&O.assign(a,b)}function z(){Q.length=0,P?(Q.push(a.$watch(P,function(a){M.content=a,!a&&M.isOpen&&t()})),Q.push(E.$watch(function(){N||(N=!0,E.$$postDigest(function(){N=!1,M&&M.isOpen&&R()}))}))):Q.push(d.$observe(e,function(a){M.content=a,!a&&M.isOpen?t():R()})),Q.push(d.$observe(k+"Title",function(a){M.title=a,M.isOpen&&R()})),Q.push(d.$observe(k+"Placement",function(a){M.placement=a?a:n.placement,M.isOpen&&R()}))}function A(){Q.length&&(angular.forEach(Q,function(a){a()}),Q.length=0)}function B(a){M&&M.isOpen&&D&&(b[0].contains(a.target)||D[0].contains(a.target)||q())}function C(){var a=d[k+"Trigger"];S(),K=p(a),"none"!==K.show&&K.show.forEach(function(a,c){"outsideClick"===a?(b.on("click",j),h.on("click",B)):a===K.hide[c]?b.on(a,j):a&&(b.on(a,m),b.on(K.hide[c],q)),b.on("keypress",function(a){27===a.which&&q()})})}var D,E,F,G,H,I,J=angular.isDefined(n.appendToBody)?n.appendToBody:!1,K=p(void 0),L=angular.isDefined(d[k+"Enable"]),M=a.$new(!0),N=!1,O=angular.isDefined(d[k+"IsOpen"])?l(d[k+"IsOpen"]):!1,P=n.useContentExp?l(d[e]):!1,Q=[],R=function(){D&&D.html()&&(I||(I=g(function(){D.css({top:0,left:0});var a=i.positionElements(b,D,M.placement,J);D.css({top:a.top+"px",left:a.left+"px",visibility:"visible"}),n.placementClassPrefix&&D.removeClass("top bottom left right"),D.removeClass(n.placementClassPrefix+"top "+n.placementClassPrefix+"top-left "+n.placementClassPrefix+"top-right "+n.placementClassPrefix+"bottom "+n.placementClassPrefix+"bottom-left "+n.placementClassPrefix+"bottom-right "+n.placementClassPrefix+"left "+n.placementClassPrefix+"left-top "+n.placementClassPrefix+"left-bottom "+n.placementClassPrefix+"right "+n.placementClassPrefix+"right-top "+n.placementClassPrefix+"right-bottom");var c=a.placement.split("-");D.addClass(c[0]+" "+n.placementClassPrefix+a.placement),i.positionArrow(D,a.placement),I=null},0,!1)))};M.origScope=a,M.isOpen=!1,o.add(M,{close:t}),M.contentExp=function(){return M.content},d.$observe("disabled",function(a){a&&s(),a&&M.isOpen&&t()}),O&&a.$watch(O,function(a){M&&!a===M.isOpen&&j()});var S=function(){K.show.forEach(function(a){"outsideClick"===a?b.off("click",j):(b.off(a,m),b.off(a,j))}),K.hide.forEach(function(a){"outsideClick"===a?h.off("click",B):b.off(a,q)})};C();var T=a.$eval(d[k+"Animation"]);M.animation=angular.isDefined(T)?!!T:n.animation;var U,V=k+"AppendToBody";U=V in d&&void 0===d[V]?!0:a.$eval(d[V]),J=angular.isDefined(U)?U:J,a.$on("$destroy",function(){S(),w(),o.remove(M),M=null})}}}}}]}).directive("uibTooltipTemplateTransclude",["$animate","$sce","$compile","$templateRequest",function(a,b,c,d){return{link:function(e,f,g){var h,i,j,k=e.$eval(g.tooltipTemplateTranscludeScope),l=0,m=function(){i&&(i.remove(),i=null),h&&(h.$destroy(),h=null),j&&(a.leave(j).then(function(){i=null}),i=j,j=null)};e.$watch(b.parseAsResourceUrl(g.uibTooltipTemplateTransclude),function(b){var g=++l;b?(d(b,!0).then(function(d){if(g===l){var e=k.$new(),i=d,n=c(i)(e,function(b){m(),a.enter(b,f)});h=e,j=n,h.$emit("$includeContentLoaded",b)}},function(){g===l&&(m(),e.$emit("$includeContentError",b))}),e.$emit("$includeContentRequested",b)):m()}),e.$on("$destroy",m)}}}]).directive("uibTooltipClasses",["$uibPosition",function(a){return{restrict:"A",link:function(b,c,d){if(b.placement){var e=a.parsePlacement(b.placement);c.addClass(e[0])}else c.addClass("top");b.popupClass&&c.addClass(b.popupClass),b.animation()&&c.addClass(d.tooltipAnimationClass)}}}]).directive("uibTooltipPopup",function(){return{replace:!0,scope:{content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"uib/template/tooltip/tooltip-popup.html"}}).directive("uibTooltip",["$uibTooltip",function(a){return a("uibTooltip","tooltip","mouseenter")}]).directive("uibTooltipTemplatePopup",function(){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"uib/template/tooltip/tooltip-template-popup.html"}}).directive("uibTooltipTemplate",["$uibTooltip",function(a){return a("uibTooltipTemplate","tooltip","mouseenter",{useContentExp:!0})}]).directive("uibTooltipHtmlPopup",function(){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"uib/template/tooltip/tooltip-html-popup.html"}}).directive("uibTooltipHtml",["$uibTooltip",function(a){return a("uibTooltipHtml","tooltip","mouseenter",{useContentExp:!0})}]),angular.module("ui.bootstrap.popover",["ui.bootstrap.tooltip"]).directive("uibPopoverTemplatePopup",function(){return{replace:!0,scope:{title:"@",contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"uib/template/popover/popover-template.html"}}).directive("uibPopoverTemplate",["$uibTooltip",function(a){return a("uibPopoverTemplate","popover","click",{useContentExp:!0})}]).directive("uibPopoverHtmlPopup",function(){return{replace:!0,scope:{contentExp:"&",title:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"uib/template/popover/popover-html.html"}}).directive("uibPopoverHtml",["$uibTooltip",function(a){return a("uibPopoverHtml","popover","click",{useContentExp:!0})}]).directive("uibPopoverPopup",function(){return{replace:!0,scope:{title:"@",content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"uib/template/popover/popover.html"}}).directive("uibPopover",["$uibTooltip",function(a){return a("uibPopover","popover","click")}]),angular.module("ui.bootstrap.progressbar",[]).constant("uibProgressConfig",{animate:!0,max:100}).controller("UibProgressController",["$scope","$attrs","uibProgressConfig",function(a,b,c){var d=this,e=angular.isDefined(b.animate)?a.$parent.$eval(b.animate):c.animate;this.bars=[],a.max=angular.isDefined(a.max)?a.max:c.max,this.addBar=function(b,c,f){e||c.css({transition:"none"}),this.bars.push(b),b.max=a.max,b.title=f&&angular.isDefined(f.title)?f.title:"progressbar",b.$watch("value",function(a){b.recalculatePercentage()}),b.recalculatePercentage=function(){var a=d.bars.reduce(function(a,b){return b.percent=+(100*b.value/b.max).toFixed(2),a+b.percent},0);a>100&&(b.percent-=a-100)},b.$on("$destroy",function(){c=null,d.removeBar(b)})},this.removeBar=function(a){this.bars.splice(this.bars.indexOf(a),1),this.bars.forEach(function(a){a.recalculatePercentage()})},a.$watch("max",function(b){d.bars.forEach(function(b){b.max=a.max,b.recalculatePercentage()})})}]).directive("uibProgress",function(){return{replace:!0,transclude:!0,controller:"UibProgressController",require:"uibProgress",scope:{max:"=?"},templateUrl:"uib/template/progressbar/progress.html"}}).directive("uibBar",function(){return{replace:!0,transclude:!0,require:"^uibProgress",scope:{value:"=",type:"@"},templateUrl:"uib/template/progressbar/bar.html",link:function(a,b,c,d){d.addBar(a,b,c)}}}).directive("uibProgressbar",function(){return{replace:!0,transclude:!0,controller:"UibProgressController",scope:{value:"=",max:"=?",type:"@"},templateUrl:"uib/template/progressbar/progressbar.html",link:function(a,b,c,d){d.addBar(a,angular.element(b.children()[0]),{title:c.title})}}}),angular.module("ui.bootstrap.rating",[]).constant("uibRatingConfig",{max:5,stateOn:null,stateOff:null,titles:["one","two","three","four","five"]}).controller("UibRatingController",["$scope","$attrs","uibRatingConfig",function(a,b,c){var d={$setViewValue:angular.noop};this.init=function(e){d=e,d.$render=this.render,d.$formatters.push(function(a){return angular.isNumber(a)&&a<<0!==a&&(a=Math.round(a)),a}),this.stateOn=angular.isDefined(b.stateOn)?a.$parent.$eval(b.stateOn):c.stateOn,this.stateOff=angular.isDefined(b.stateOff)?a.$parent.$eval(b.stateOff):c.stateOff;var f=angular.isDefined(b.titles)?a.$parent.$eval(b.titles):c.titles;this.titles=angular.isArray(f)&&f.length>0?f:c.titles;var g=angular.isDefined(b.ratingStates)?a.$parent.$eval(b.ratingStates):new Array(angular.isDefined(b.max)?a.$parent.$eval(b.max):c.max);a.range=this.buildTemplateObjects(g)},this.buildTemplateObjects=function(a){for(var b=0,c=a.length;c>b;b++)a[b]=angular.extend({index:b},{stateOn:this.stateOn,stateOff:this.stateOff,title:this.getTitle(b)},a[b]);return a},this.getTitle=function(a){return a>=this.titles.length?a+1:this.titles[a]},a.rate=function(b){!a.readonly&&b>=0&&b<=a.range.length&&(d.$setViewValue(d.$viewValue===b?0:b),d.$render())},a.enter=function(b){a.readonly||(a.value=b),a.onHover({value:b})},a.reset=function(){a.value=d.$viewValue,a.onLeave()},a.onKeydown=function(b){/(37|38|39|40)/.test(b.which)&&(b.preventDefault(),b.stopPropagation(),a.rate(a.value+(38===b.which||39===b.which?1:-1)))},this.render=function(){a.value=d.$viewValue}}]).directive("uibRating",function(){return{require:["uibRating","ngModel"],scope:{readonly:"=?",onHover:"&",onLeave:"&"},controller:"UibRatingController",templateUrl:"uib/template/rating/rating.html",replace:!0,link:function(a,b,c,d){var e=d[0],f=d[1];e.init(f)}}}),angular.module("ui.bootstrap.tabs",[]).controller("UibTabsetController",["$scope",function(a){var b=this,c=b.tabs=a.tabs=[];b.select=function(a){angular.forEach(c,function(b){b.active&&b!==a&&(b.active=!1,b.onDeselect(),a.selectCalled=!1)}),a.active=!0,a.selectCalled||(a.onSelect(),a.selectCalled=!0)},b.addTab=function(a){c.push(a),1===c.length&&a.active!==!1?a.active=!0:a.active?b.select(a):a.active=!1},b.removeTab=function(a){var e=c.indexOf(a);if(a.active&&c.length>1&&!d){var f=e===c.length-1?e-1:e+1;b.select(c[f])}c.splice(e,1)};var d;a.$on("$destroy",function(){d=!0})}]).directive("uibTabset",function(){return{transclude:!0,replace:!0,scope:{type:"@"},controller:"UibTabsetController",templateUrl:"uib/template/tabs/tabset.html",link:function(a,b,c){a.vertical=angular.isDefined(c.vertical)?a.$parent.$eval(c.vertical):!1,a.justified=angular.isDefined(c.justified)?a.$parent.$eval(c.justified):!1}}}).directive("uibTab",["$parse",function(a){return{require:"^uibTabset",replace:!0,templateUrl:"uib/template/tabs/tab.html",transclude:!0,scope:{active:"=?",heading:"@",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},controllerAs:"tab",link:function(b,c,d,e,f){b.$watch("active",function(a){a&&e.select(b)}),b.disabled=!1,d.disable&&b.$parent.$watch(a(d.disable),function(a){b.disabled=!!a}),b.select=function(){b.disabled||(b.active=!0)},e.addTab(b),b.$on("$destroy",function(){e.removeTab(b)}),b.$transcludeFn=f}}}]).directive("uibTabHeadingTransclude",function(){return{restrict:"A",require:"^uibTab",link:function(a,b){a.$watch("headingElement",function(a){a&&(b.html(""),b.append(a))})}}}).directive("uibTabContentTransclude",function(){function a(a){return a.tagName&&(a.hasAttribute("uib-tab-heading")||a.hasAttribute("data-uib-tab-heading")||a.hasAttribute("x-uib-tab-heading")||"uib-tab-heading"===a.tagName.toLowerCase()||"data-uib-tab-heading"===a.tagName.toLowerCase()||"x-uib-tab-heading"===a.tagName.toLowerCase())}return{restrict:"A",require:"^uibTabset",link:function(b,c,d){var e=b.$eval(d.uibTabContentTransclude);e.$transcludeFn(e.$parent,function(b){angular.forEach(b,function(b){a(b)?e.headingElement=b:c.append(b)})})}}}),angular.module("ui.bootstrap.timepicker",[]).constant("uibTimepickerConfig",{hourStep:1,minuteStep:1,secondStep:1,showMeridian:!0,showSeconds:!1,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0,templateUrl:"uib/template/timepicker/timepicker.html"}).controller("UibTimepickerController",["$scope","$element","$attrs","$parse","$log","$locale","uibTimepickerConfig",function(a,b,c,d,e,f,g){function h(){var b=+a.hours,c=a.showMeridian?b>0&&13>b:b>=0&&24>b;return c?(a.showMeridian&&(12===b&&(b=0),a.meridian===u[1]&&(b+=12)),b):void 0}function i(){var b=+a.minutes;return b>=0&&60>b?b:void 0}function j(){var b=+a.seconds;return b>=0&&60>b?b:void 0}function k(a){return null===a?"":angular.isDefined(a)&&a.toString().length<2?"0"+a:a.toString()}function l(a){m(),t.$setViewValue(new Date(r)),n(a)}function m(){t.$setValidity("time",!0),a.invalidHours=!1,a.invalidMinutes=!1,a.invalidSeconds=!1}function n(b){if(t.$modelValue){var c=r.getHours(),d=r.getMinutes(),e=r.getSeconds();a.showMeridian&&(c=0===c||12===c?12:c%12),a.hours="h"===b?c:k(c),"m"!==b&&(a.minutes=k(d)),a.meridian=r.getHours()<12?u[0]:u[1],"s"!==b&&(a.seconds=k(e)),a.meridian=r.getHours()<12?u[0]:u[1]}else a.hours=null,a.minutes=null,a.seconds=null,a.meridian=u[0]}function o(a){r=q(r,a),l()}function p(a,b){return q(a,60*b)}function q(a,b){var c=new Date(a.getTime()+1e3*b),d=new Date(a);return d.setHours(c.getHours(),c.getMinutes(),c.getSeconds()),d}var r=new Date,s=[],t={$setViewValue:angular.noop},u=angular.isDefined(c.meridians)?a.$parent.$eval(c.meridians):g.meridians||f.DATETIME_FORMATS.AMPMS;a.tabindex=angular.isDefined(c.tabindex)?c.tabindex:0,b.removeAttr("tabindex"),this.init=function(b,d){t=b,t.$render=this.render,t.$formatters.unshift(function(a){return a?new Date(a):null});var e=d.eq(0),f=d.eq(1),h=d.eq(2),i=angular.isDefined(c.mousewheel)?a.$parent.$eval(c.mousewheel):g.mousewheel;i&&this.setupMousewheelEvents(e,f,h);var j=angular.isDefined(c.arrowkeys)?a.$parent.$eval(c.arrowkeys):g.arrowkeys;j&&this.setupArrowkeyEvents(e,f,h),a.readonlyInput=angular.isDefined(c.readonlyInput)?a.$parent.$eval(c.readonlyInput):g.readonlyInput,this.setupInputEvents(e,f,h)};var v=g.hourStep;c.hourStep&&s.push(a.$parent.$watch(d(c.hourStep),function(a){v=+a}));var w=g.minuteStep;c.minuteStep&&s.push(a.$parent.$watch(d(c.minuteStep),function(a){w=+a}));var x;s.push(a.$parent.$watch(d(c.min),function(a){var b=new Date(a);x=isNaN(b)?void 0:b}));var y;s.push(a.$parent.$watch(d(c.max),function(a){var b=new Date(a);y=isNaN(b)?void 0:b}));var z=!1;c.ngDisabled&&s.push(a.$parent.$watch(d(c.ngDisabled),function(a){z=a})),a.noIncrementHours=function(){var a=p(r,60*v);return z||a>y||r>a&&x>a},a.noDecrementHours=function(){var a=p(r,60*-v);return z||x>a||a>r&&a>y},a.noIncrementMinutes=function(){var a=p(r,w);return z||a>y||r>a&&x>a},a.noDecrementMinutes=function(){var a=p(r,-w);return z||x>a||a>r&&a>y},a.noIncrementSeconds=function(){var a=q(r,A);return z||a>y||r>a&&x>a},a.noDecrementSeconds=function(){var a=q(r,-A);return z||x>a||a>r&&a>y},a.noToggleMeridian=function(){return r.getHours()<12?z||p(r,720)>y:z||p(r,-720)<x};var A=g.secondStep;c.secondStep&&s.push(a.$parent.$watch(d(c.secondStep),function(a){A=+a})),a.showSeconds=g.showSeconds,c.showSeconds&&s.push(a.$parent.$watch(d(c.showSeconds),function(b){a.showSeconds=!!b})),a.showMeridian=g.showMeridian,c.showMeridian&&s.push(a.$parent.$watch(d(c.showMeridian),function(b){if(a.showMeridian=!!b,t.$error.time){var c=h(),d=i();angular.isDefined(c)&&angular.isDefined(d)&&(r.setHours(c),l())}else n()})),this.setupMousewheelEvents=function(b,c,d){var e=function(a){a.originalEvent&&(a=a.originalEvent);var b=a.wheelDelta?a.wheelDelta:-a.deltaY;return a.detail||b>0};b.bind("mousewheel wheel",function(b){z||a.$apply(e(b)?a.incrementHours():a.decrementHours()),b.preventDefault()}),c.bind("mousewheel wheel",function(b){z||a.$apply(e(b)?a.incrementMinutes():a.decrementMinutes()),b.preventDefault()}),d.bind("mousewheel wheel",function(b){z||a.$apply(e(b)?a.incrementSeconds():a.decrementSeconds()),b.preventDefault()})},this.setupArrowkeyEvents=function(b,c,d){b.bind("keydown",function(b){z||(38===b.which?(b.preventDefault(),a.incrementHours(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementHours(),a.$apply()))}),c.bind("keydown",function(b){z||(38===b.which?(b.preventDefault(),a.incrementMinutes(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementMinutes(),a.$apply()))}),d.bind("keydown",function(b){z||(38===b.which?(b.preventDefault(),a.incrementSeconds(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementSeconds(),a.$apply()))})},this.setupInputEvents=function(b,c,d){if(a.readonlyInput)return a.updateHours=angular.noop,a.updateMinutes=angular.noop,void(a.updateSeconds=angular.noop);var e=function(b,c,d){t.$setViewValue(null),t.$setValidity("time",!1),angular.isDefined(b)&&(a.invalidHours=b),angular.isDefined(c)&&(a.invalidMinutes=c),angular.isDefined(d)&&(a.invalidSeconds=d)};a.updateHours=function(){var a=h(),b=i();t.$setDirty(),angular.isDefined(a)&&angular.isDefined(b)?(r.setHours(a),r.setMinutes(b),x>r||r>y?e(!0):l("h")):e(!0)},b.bind("blur",function(b){t.$setTouched(),null===a.hours||""===a.hours?e(!0):!a.invalidHours&&a.hours<10&&a.$apply(function(){a.hours=k(a.hours)})}),a.updateMinutes=function(){var a=i(),b=h();t.$setDirty(),angular.isDefined(a)&&angular.isDefined(b)?(r.setHours(b),r.setMinutes(a),x>r||r>y?e(void 0,!0):l("m")):e(void 0,!0)},c.bind("blur",function(b){t.$setTouched(),null===a.minutes?e(void 0,!0):!a.invalidMinutes&&a.minutes<10&&a.$apply(function(){a.minutes=k(a.minutes)})}),a.updateSeconds=function(){var a=j();t.$setDirty(),angular.isDefined(a)?(r.setSeconds(a),l("s")):e(void 0,void 0,!0)},d.bind("blur",function(b){!a.invalidSeconds&&a.seconds<10&&a.$apply(function(){a.seconds=k(a.seconds)})})},this.render=function(){var b=t.$viewValue;isNaN(b)?(t.$setValidity("time",!1),e.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(b&&(r=b),x>r||r>y?(t.$setValidity("time",!1),a.invalidHours=!0,a.invalidMinutes=!0):m(),n())},a.showSpinners=angular.isDefined(c.showSpinners)?a.$parent.$eval(c.showSpinners):g.showSpinners,a.incrementHours=function(){a.noIncrementHours()||o(60*v*60)},a.decrementHours=function(){a.noDecrementHours()||o(60*-v*60)},a.incrementMinutes=function(){a.noIncrementMinutes()||o(60*w)},a.decrementMinutes=function(){a.noDecrementMinutes()||o(60*-w)},a.incrementSeconds=function(){a.noIncrementSeconds()||o(A)},a.decrementSeconds=function(){a.noDecrementSeconds()||o(-A)},a.toggleMeridian=function(){var b=i(),c=h();a.noToggleMeridian()||(angular.isDefined(b)&&angular.isDefined(c)?o(720*(r.getHours()<12?60:-60)):a.meridian=a.meridian===u[0]?u[1]:u[0])},a.blur=function(){t.$setTouched()},a.$on("$destroy",function(){for(;s.length;)s.shift()()})}]).directive("uibTimepicker",["uibTimepickerConfig",function(a){return{require:["uibTimepicker","?^ngModel"],controller:"UibTimepickerController",controllerAs:"timepicker",replace:!0,scope:{},templateUrl:function(b,c){return c.templateUrl||a.templateUrl},link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f,b.find("input"))}}}]),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.debounce","ui.bootstrap.position"]).factory("uibTypeaheadParser",["$parse",function(a){var b=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(c){var d=c.match(b);if(!d)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+c+'".');return{itemName:d[3],source:a(d[4]),viewMapper:a(d[2]||d[1]),modelMapper:a(d[1])}}}}]).controller("UibTypeaheadController",["$scope","$element","$attrs","$compile","$parse","$q","$timeout","$document","$window","$rootScope","$$debounce","$uibPosition","uibTypeaheadParser",function(a,b,c,d,e,f,g,h,i,j,k,l,m){function n(){N.moveInProgress||(N.moveInProgress=!0,N.$digest()),Y()}function o(){N.position=D?l.offset(b):l.position(b),N.position.top+=b.prop("offsetHeight")}var p,q,r=[9,13,27,38,40],s=200,t=a.$eval(c.typeaheadMinLength);t||0===t||(t=1);var u=a.$eval(c.typeaheadWaitMs)||0,v=a.$eval(c.typeaheadEditable)!==!1;a.$watch(c.typeaheadEditable,function(a){v=a!==!1});var w,x,y=e(c.typeaheadLoading).assign||angular.noop,z=e(c.typeaheadOnSelect),A=angular.isDefined(c.typeaheadSelectOnBlur)?a.$eval(c.typeaheadSelectOnBlur):!1,B=e(c.typeaheadNoResults).assign||angular.noop,C=c.typeaheadInputFormatter?e(c.typeaheadInputFormatter):void 0,D=c.typeaheadAppendToBody?a.$eval(c.typeaheadAppendToBody):!1,E=c.typeaheadAppendTo?a.$eval(c.typeaheadAppendTo):null,F=a.$eval(c.typeaheadFocusFirst)!==!1,G=c.typeaheadSelectOnExact?a.$eval(c.typeaheadSelectOnExact):!1,H=e(c.typeaheadIsOpen).assign||angular.noop,I=a.$eval(c.typeaheadShowHint)||!1,J=e(c.ngModel),K=e(c.ngModel+"($$$p)"),L=function(b,c){return angular.isFunction(J(a))&&q&&q.$options&&q.$options.getterSetter?K(b,{$$$p:c}):J.assign(b,c)},M=m.parse(c.uibTypeahead),N=a.$new(),O=a.$on("$destroy",function(){N.$destroy()});N.$on("$destroy",O);var P="typeahead-"+N.$id+"-"+Math.floor(1e4*Math.random());b.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":P});var Q,R;I&&(Q=angular.element("<div></div>"),Q.css("position","relative"),b.after(Q),R=b.clone(),R.attr("placeholder",""),R.val(""),R.css({position:"absolute",top:"0px",left:"0px","border-color":"transparent","box-shadow":"none",opacity:1,background:"none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",color:"#999"}),b.css({position:"relative","vertical-align":"top","background-color":"transparent"}),Q.append(R),R.after(b));var S=angular.element("<div uib-typeahead-popup></div>");S.attr({id:P,matches:"matches",active:"activeIdx",select:"select(activeIdx, evt)","move-in-progress":"moveInProgress",query:"query",position:"position","assign-is-open":"assignIsOpen(isOpen)",debounce:"debounceUpdate"}),angular.isDefined(c.typeaheadTemplateUrl)&&S.attr("template-url",c.typeaheadTemplateUrl),angular.isDefined(c.typeaheadPopupTemplateUrl)&&S.attr("popup-template-url",c.typeaheadPopupTemplateUrl);var T=function(){I&&R.val("")},U=function(){N.matches=[],N.activeIdx=-1,b.attr("aria-expanded",!1),T()},V=function(a){return P+"-option-"+a};N.$watch("activeIdx",function(a){0>a?b.removeAttr("aria-activedescendant"):b.attr("aria-activedescendant",V(a))});var W=function(a,b){return N.matches.length>b&&a?a.toUpperCase()===N.matches[b].label.toUpperCase():!1},X=function(c,d){var e={$viewValue:c};y(a,!0),B(a,!1),f.when(M.source(a,e)).then(function(f){var g=c===p.$viewValue;if(g&&w)if(f&&f.length>0){N.activeIdx=F?0:-1,B(a,!1),N.matches.length=0;for(var h=0;h<f.length;h++)e[M.itemName]=f[h],N.matches.push({id:V(h),label:M.viewMapper(N,e),model:f[h]});if(N.query=c,o(),b.attr("aria-expanded",!0),G&&1===N.matches.length&&W(c,0)&&(angular.isNumber(N.debounceUpdate)||angular.isObject(N.debounceUpdate)?k(function(){N.select(0,d)},angular.isNumber(N.debounceUpdate)?N.debounceUpdate:N.debounceUpdate["default"]):N.select(0,d)),I){var i=N.matches[0].label;angular.isString(c)&&c.length>0&&i.slice(0,c.length).toUpperCase()===c.toUpperCase()?R.val(c+i.slice(c.length)):R.val("")}}else U(),B(a,!0);g&&y(a,!1)},function(){U(),y(a,!1),B(a,!0)})};D&&(angular.element(i).on("resize",n),h.find("body").on("scroll",n));var Y=k(function(){N.matches.length&&o(),N.moveInProgress=!1},s);N.moveInProgress=!1,N.query=void 0;var Z,$=function(a){Z=g(function(){X(a)},u)},_=function(){Z&&g.cancel(Z)};U(),N.assignIsOpen=function(b){H(a,b)},N.select=function(d,e){var f,h,i={};x=!0,i[M.itemName]=h=N.matches[d].model,f=M.modelMapper(a,i),L(a,f),p.$setValidity("editable",!0),p.$setValidity("parse",!0),z(a,{$item:h,$model:f,$label:M.viewMapper(a,i),$event:e}),U(),N.$eval(c.typeaheadFocusOnSelect)!==!1&&g(function(){b[0].focus()},0,!1)},b.on("keydown",function(a){if(0!==N.matches.length&&-1!==r.indexOf(a.which)){if(-1===N.activeIdx&&(9===a.which||13===a.which))return U(),void N.$digest();a.preventDefault();var b;switch(a.which){case 9:case 13:N.$apply(function(){angular.isNumber(N.debounceUpdate)||angular.isObject(N.debounceUpdate)?k(function(){N.select(N.activeIdx,a)},angular.isNumber(N.debounceUpdate)?N.debounceUpdate:N.debounceUpdate["default"]):N.select(N.activeIdx,a)});break;case 27:a.stopPropagation(),U(),N.$digest();break;case 38:N.activeIdx=(N.activeIdx>0?N.activeIdx:N.matches.length)-1,N.$digest(),b=S.find("li")[N.activeIdx],b.parentNode.scrollTop=b.offsetTop;break;case 40:N.activeIdx=(N.activeIdx+1)%N.matches.length,N.$digest(),b=S.find("li")[N.activeIdx],b.parentNode.scrollTop=b.offsetTop}}}),b.bind("focus",function(a){w=!0,0!==t||p.$viewValue||g(function(){X(p.$viewValue,a)},0)}),b.bind("blur",function(a){A&&N.matches.length&&-1!==N.activeIdx&&!x&&(x=!0,N.$apply(function(){angular.isObject(N.debounceUpdate)&&angular.isNumber(N.debounceUpdate.blur)?k(function(){N.select(N.activeIdx,a)},N.debounceUpdate.blur):N.select(N.activeIdx,a)})),!v&&p.$error.editable&&(p.$viewValue="",b.val("")),w=!1,x=!1});var aa=function(a){b[0]!==a.target&&3!==a.which&&0!==N.matches.length&&(U(),j.$$phase||N.$digest())};h.on("click",aa),a.$on("$destroy",function(){h.off("click",aa),(D||E)&&ba.remove(),D&&(angular.element(i).off("resize",n),h.find("body").off("scroll",n)),S.remove(),I&&Q.remove()});var ba=d(S)(N);D?h.find("body").append(ba):E?angular.element(E).eq(0).append(ba):b.after(ba),this.init=function(b,c){p=b,q=c,N.debounceUpdate=p.$options&&e(p.$options.debounce)(a),p.$parsers.unshift(function(b){return w=!0,0===t||b&&b.length>=t?u>0?(_(),$(b)):X(b):(y(a,!1),_(),U()),v?b:b?void p.$setValidity("editable",!1):(p.$setValidity("editable",!0),null)}),p.$formatters.push(function(b){var c,d,e={};return v||p.$setValidity("editable",!0),C?(e.$model=b,C(a,e)):(e[M.itemName]=b,c=M.viewMapper(a,e),e[M.itemName]=void 0,d=M.viewMapper(a,e),c!==d?c:b)})}}]).directive("uibTypeahead",function(){return{controller:"UibTypeaheadController",require:["ngModel","^?ngModelOptions","uibTypeahead"],link:function(a,b,c,d){d[2].init(d[0],d[1])}}}).directive("uibTypeaheadPopup",["$$debounce",function(a){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&",assignIsOpen:"&",debounce:"&"},replace:!0,templateUrl:function(a,b){return b.popupTemplateUrl||"uib/template/typeahead/typeahead-popup.html"},link:function(b,c,d){b.templateUrl=d.templateUrl,b.isOpen=function(){var a=b.matches.length>0;return b.assignIsOpen({isOpen:a}),a},b.isActive=function(a){return b.active===a},b.selectActive=function(a){b.active=a},b.selectMatch=function(c,d){var e=b.debounce();angular.isNumber(e)||angular.isObject(e)?a(function(){b.select({activeIdx:c,evt:d})},angular.isNumber(e)?e:e["default"]):b.select({activeIdx:c,evt:d})}}}}]).directive("uibTypeaheadMatch",["$templateRequest","$compile","$parse",function(a,b,c){return{scope:{index:"=",match:"=",query:"="},link:function(d,e,f){var g=c(f.templateUrl)(d.$parent)||"uib/template/typeahead/typeahead-match.html";a(g).then(function(a){var c=angular.element(a.trim());e.replaceWith(c),b(c)(d)})}}}]).filter("uibTypeaheadHighlight",["$sce","$injector","$log",function(a,b,c){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function e(a){return/<.*>/g.test(a)}var f;return f=b.has("$sanitize"),function(b,g){return!f&&e(b)&&c.warn("Unsafe use of typeahead please use ngSanitize"),b=g?(""+b).replace(new RegExp(d(g),"gi"),"<strong>$&</strong>"):b,f||(b=a.trustAsHtml(b)),b}}]),angular.module("uib/template/accordion/accordion-group.html",[]).run(["$templateCache",function(a){a.put("uib/template/accordion/accordion-group.html",'<div class="panel" ng-class="panelClass || \'panel-default\'">\n  <div role="tab" id="{{::headingId}}" aria-selected="{{isOpen}}" class="panel-heading" ng-keypress="toggleOpen($event)">\n    <h4 class="panel-title">\n      <a role="button" data-toggle="collapse" href aria-expanded="{{isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle" ng-click="toggleOpen()" uib-accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!isOpen}}" role="tabpanel" class="panel-collapse collapse" uib-collapse="!isOpen">\n    <div class="panel-body" ng-transclude></div>\n  </div>\n</div>\n')}]),angular.module("uib/template/accordion/accordion.html",[]).run(["$templateCache",function(a){a.put("uib/template/accordion/accordion.html",'<div role="tablist" class="panel-group" ng-transclude></div>')}]),angular.module("uib/template/alert/alert.html",[]).run(["$templateCache",function(a){a.put("uib/template/alert/alert.html",'<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissible\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close({$event: $event})">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n')}]),angular.module("uib/template/carousel/carousel.html",[]).run(["$templateCache",function(a){a.put("uib/template/carousel/carousel.html",'<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n  <div class="carousel-inner" ng-transclude></div>\n  <a role="button" href class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>\n    <span class="sr-only">previous</span>\n  </a>\n  <a role="button" href class="right carousel-control" ng-click="next()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>\n    <span class="sr-only">next</span>\n  </a>\n  <ol class="carousel-indicators" ng-show="slides.length > 1">\n    <li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)">\n      <span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span>\n    </li>\n  </ol>\n</div>')}]),angular.module("uib/template/carousel/slide.html",[]).run(["$templateCache",function(a){a.put("uib/template/carousel/slide.html",'<div ng-class="{\n    \'active\': active\n  }" class="item text-center" ng-transclude></div>\n')}]),angular.module("uib/template/datepicker/datepicker.html",[]).run(["$templateCache",function(a){a.put("uib/template/datepicker/datepicker.html",'<div class="uib-datepicker" ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <uib-daypicker ng-switch-when="day" tabindex="0"></uib-daypicker>\n  <uib-monthpicker ng-switch-when="month" tabindex="0"></uib-monthpicker>\n  <uib-yearpicker ng-switch-when="year" tabindex="0"></uib-yearpicker>\n</div>')}]),angular.module("uib/template/datepicker/day.html",[]).run(["$templateCache",function(a){a.put("uib/template/datepicker/day.html",'<table class="uib-daypicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-weeks" ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default btn-sm"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
}]),angular.module("uib/template/datepicker/month.html",[]).run(["$templateCache",function(a){a.put("uib/template/datepicker/month.html",'<table class="uib-monthpicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-months" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/datepicker/popup.html",[]).run(["$templateCache",function(a){a.put("uib/template/datepicker/popup.html",'<div>\n  <ul class="uib-datepicker-popup dropdown-menu" dropdown-nested ng-if="isOpen" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n    <li ng-transclude></li>\n    <li ng-if="showButtonBar" class="uib-button-bar">\n    <span class="btn-group pull-left">\n      <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select(\'today\')" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n      <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n    </span>\n      <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close()">{{ getText(\'close\') }}</button>\n    </li>\n  </ul>\n</div>\n')}]),angular.module("uib/template/datepicker/year.html",[]).run(["$templateCache",function(a){a.put("uib/template/datepicker/year.html",'<table class="uib-yearpicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::columns - 2}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-years" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-year text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/modal/backdrop.html",[]).run(["$templateCache",function(a){a.put("uib/template/modal/backdrop.html",'<div class="modal-backdrop"\n     uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n')}]),angular.module("uib/template/modal/window.html",[]).run(["$templateCache",function(a){a.put("uib/template/modal/window.html",'<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n    uib-modal-animation-class="fade"\n    modal-in-class="in"\n    ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}">\n    <div class="modal-dialog {{size ? \'modal-\' + size : \'\'}}"><div class="modal-content" uib-modal-transclude></div></div>\n</div>\n')}]),angular.module("uib/template/pager/pager.html",[]).run(["$templateCache",function(a){a.put("uib/template/pager/pager.html",'<ul class="pager">\n  <li ng-class="{disabled: noPrevious()||ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext()||ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>\n')}]),angular.module("uib/template/pagination/pagination.html",[]).run(["$templateCache",function(a){a.put("uib/template/pagination/pagination.html",'<ul class="pagination">\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-first"><a href ng-click="selectPage(1, $event)">{{::getText(\'first\')}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-prev"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}" class="pagination-page"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-next"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-last"><a href ng-click="selectPage(totalPages, $event)">{{::getText(\'last\')}}</a></li>\n</ul>\n')}]),angular.module("uib/template/tooltip/tooltip-html-popup.html",[]).run(["$templateCache",function(a){a.put("uib/template/tooltip/tooltip-html-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n</div>\n')}]),angular.module("uib/template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function(a){a.put("uib/template/tooltip/tooltip-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n')}]),angular.module("uib/template/tooltip/tooltip-template-popup.html",[]).run(["$templateCache",function(a){a.put("uib/template/tooltip/tooltip-template-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner"\n    uib-tooltip-template-transclude="contentExp()"\n    tooltip-template-transclude-scope="originScope()"></div>\n</div>\n')}]),angular.module("uib/template/popover/popover-html.html",[]).run(["$templateCache",function(a){a.put("uib/template/popover/popover-html.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind-html="contentExp()"></div>\n  </div>\n</div>\n')}]),angular.module("uib/template/popover/popover-template.html",[]).run(["$templateCache",function(a){a.put("uib/template/popover/popover-template.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content"\n        uib-tooltip-template-transclude="contentExp()"\n        tooltip-template-transclude-scope="originScope()"></div>\n  </div>\n</div>\n')}]),angular.module("uib/template/popover/popover.html",[]).run(["$templateCache",function(a){a.put("uib/template/popover/popover.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n')}]),angular.module("uib/template/progressbar/bar.html",[]).run(["$templateCache",function(a){a.put("uib/template/progressbar/bar.html",'<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>\n')}]),angular.module("uib/template/progressbar/progress.html",[]).run(["$templateCache",function(a){a.put("uib/template/progressbar/progress.html",'<div class="progress" ng-transclude aria-labelledby="{{::title}}"></div>')}]),angular.module("uib/template/progressbar/progressbar.html",[]).run(["$templateCache",function(a){a.put("uib/template/progressbar/progressbar.html",'<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>\n</div>\n')}]),angular.module("uib/template/rating/rating.html",[]).run(["$templateCache",function(a){a.put("uib/template/rating/rating.html",'<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <span ng-repeat-start="r in range track by $index" class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    <i ng-repeat-end ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')" ng-attr-title="{{r.title}}" aria-valuetext="{{r.title}}"></i>\n</span>\n')}]),angular.module("uib/template/tabs/tab.html",[]).run(["$templateCache",function(a){a.put("uib/template/tabs/tab.html",'<li ng-class="{active: active, disabled: disabled}" class="uib-tab">\n  <a href ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n</li>\n')}]),angular.module("uib/template/tabs/tabset.html",[]).run(["$templateCache",function(a){a.put("uib/template/tabs/tabset.html",'<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         uib-tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n')}]),angular.module("uib/template/timepicker/timepicker.html",[]).run(["$templateCache",function(a){a.put("uib/template/timepicker/timepicker.html",'<table class="uib-timepicker">\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group uib-time hours" ng-class="{\'has-error\': invalidHours}">\n        <input style="width:50px;" type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()">\n      </td>\n      <td class="uib-separator">:</td>\n      <td class="form-group uib-time minutes" ng-class="{\'has-error\': invalidMinutes}">\n        <input style="width:50px;" type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()">\n      </td>\n      <td ng-show="showSeconds" class="uib-separator">:</td>\n      <td class="form-group uib-time seconds" ng-class="{\'has-error\': invalidSeconds}" ng-show="showSeconds">\n        <input style="width:50px;" type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()">\n      </td>\n      <td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(a){a.put("uib/template/typeahead/typeahead-match.html",'<a href\n   tabindex="-1"\n   ng-bind-html="match.label | uibTypeaheadHighlight:query"\n   ng-attr-title="{{match.label}}"></a>\n')}]),angular.module("uib/template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(a){a.put("uib/template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),angular.module("ui.bootstrap.carousel").run(function(){!angular.$$csp().noInlineStyle&&angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>')}),angular.module("ui.bootstrap.datepicker").run(function(){!angular.$$csp().noInlineStyle&&angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;}.uib-button-bar{padding:10px 9px 2px;}</style>')}),angular.module("ui.bootstrap.timepicker").run(function(){!angular.$$csp().noInlineStyle&&angular.element(document).find("head").prepend('<style type="text/css">.uib-time input{width:50px;}</style>')}),angular.module("ui.bootstrap.typeahead").run(function(){!angular.$$csp().noInlineStyle&&angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>')});
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

"use strict";

angular.module("ui.checkbox", []).directive("checkbox", function() {
    return {
        scope: {},
        require: "ngModel",
        restrict: "E",
        replace: "true",
        template: "<button type=\"button\" ng-style=\"stylebtn\" class=\"btn btn-white\" ng-class=\"{'btn-xs': size==='default', 'btn-sm': size==='large', 'btn-lg': size==='largest'}\">" +
            "<span ng-style=\"styleicon\" class=\"glyphicon\" ng-class=\"{'fa fa-check': checked===true}\"></span>" +
            "</button>",
        link: function(scope, elem, attrs, modelCtrl) {

            var label = elem.next('span');

            scope.size = "default";
            // Default Button Styling
            scope.stylebtn = {};
            // Default Checkmark Styling
            scope.styleicon = {"width": "10px", "left": "-1px"};
            // If size is undefined, Checkbox has normal size (Bootstrap 'xs')
            if(attrs.large !== undefined) {
                scope.size = "large";
                scope.stylebtn = {"padding-top": "2px", "padding-bottom": "2px", "height": "30px"};
                scope.styleicon = {"width": "8px", "left": "-5px", "font-size": "17px"};
            }
            if(attrs.larger !== undefined) {
                scope.size = "larger";
                scope.stylebtn = {"padding-top": "2px", "padding-bottom": "2px", "height": "34px"};
                scope.styleicon = {"width": "8px", "left": "-8px", "font-size": "22px"};
            }
            if(attrs.largest !== undefined) {
                scope.size = "largest";
                scope.stylebtn = {"padding-top": "2px", "padding-bottom": "2px", "height": "45px"};
                scope.styleicon = {"width": "11px", "left": "-11px", "font-size": "30px"};
            }

            var trueValue = true;
            var falseValue = false;

            // If defined set true value
            if(attrs.ngTrueValue !== undefined) {
                trueValue = attrs.ngTrueValue;

            }
            // If defined set false value
            if(attrs.ngFalseValue !== undefined) {
                falseValue = attrs.ngFalseValue;
            }

            // Check if name attribute is set and if so add it to the DOM element
            if(scope.name !== undefined) {
                elem.name = scope.name;
            }

            // Update element when model changes
            scope.$watch(function() {
                if(modelCtrl.$modelValue === trueValue || modelCtrl.$modelValue === true) {
                    modelCtrl.$setViewValue(trueValue);
                    label.addClass('todo-completed');
                } else {
                    modelCtrl.$setViewValue(falseValue);
                }
                return modelCtrl.$modelValue;
            }, function(newVal, oldVal) {
                scope.checked = modelCtrl.$modelValue === trueValue;
            }, true);

            // On click swap value and trigger onChange function
            elem.bind("click", function() {

                scope.$apply(function() {
                    if(modelCtrl.$modelValue === falseValue) {
                        modelCtrl.$setViewValue(trueValue);
                        label.toggleClass('todo-completed');
                    } else {
                        modelCtrl.$setViewValue(falseValue);
                        label.toggleClass('todo-completed');
                    }
                });
            });
        }
    };
});
(function() {
    'use strict';

    angular
        .module("app")
        .constant("momentCalendar", {
            "EN": {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
            },
            "ES": {
                sameDay: '[hoy]',
                nextDay: '[mañana]',
                nextWeek: 'dddd',
                lastDay: '[ayer]',
                lastWeek: '[el] dddd [pasado]',
            }
        })

})();
!function(e,a){"object"==typeof exports&&"undefined"!=typeof module&&"function"==typeof require?a(require("../moment")):"function"==typeof define&&define.amd?define(["../moment"],a):a(e.moment)}(this,function(e){"use strict";e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,_){return e<12?_?"vm":"VM":_?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[M\xf4re om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("ar-dz",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u0623\u062d_\u0625\u062b_\u062b\u0644\u0627_\u0623\u0631_\u062e\u0645_\u062c\u0645_\u0633\u0628".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:4}}),e.defineLocale("ar-kw",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:12}});var a={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},r=function(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5},i={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},_=function(n){return function(e,a,_,s){var d=r(e),t=i[n][r(e)];return 2===d&&(t=t[a?0:1]),t.replace(/%d/i,e)}},s=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"];e.defineLocale("ar-ly",{months:s,monthsShort:s,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:_("s"),ss:_("s"),m:_("m"),mm:_("m"),h:_("h"),hh:_("h"),d:_("d"),dd:_("d"),M:_("M"),MM:_("M"),y:_("y"),yy:_("y")},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),e.defineLocale("ar-ma",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:6,doy:12}});var d={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},t={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"};e.defineLocale("ar-sa",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return t[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return d[e]}).replace(/,/g,"\u060c")},week:{dow:0,doy:6}}),e.defineLocale("ar-tn",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}});var n={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},m={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},o=function(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5},u={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},l=function(n){return function(e,a,_,s){var d=o(e),t=u[n][o(e)];return 2===d&&(t=t[a?0:1]),t.replace(/%d/i,e)}},M=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"];e.defineLocale("ar",{months:M,monthsShort:M,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:l("s"),ss:l("s"),m:l("m"),mm:l("m"),h:l("h"),hh:l("h"),d:l("d"),dd:l("d"),M:l("M"),MM:l("M"),y:l("y"),yy:l("y")},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return m[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return n[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}});var L={1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-\xfcnc\xfc",4:"-\xfcnc\xfc",100:"-\xfcnc\xfc",6:"-nc\u0131",9:"-uncu",10:"-uncu",30:"-uncu",60:"-\u0131nc\u0131",90:"-\u0131nc\u0131"};function Y(e,a,_){var s,d;return"m"===_?a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443":"h"===_?a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443":e+" "+(s=+e,d={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",hh:a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",dd:"\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",yy:"\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e"}[_].split("_"),s%10==1&&s%100!=11?d[0]:2<=s%10&&s%10<=4&&(s%100<10||20<=s%100)?d[1]:d[2])}e.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split("_"),weekdaysShort:"Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),weekdaysMin:"Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",lastDay:"[d\xfcn\u0259n] LT",lastWeek:"[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \u0259vv\u0259l",s:"birne\xe7\u0259 saniy\u0259",ss:"%d saniy\u0259",m:"bir d\u0259qiq\u0259",mm:"%d d\u0259qiq\u0259",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,isPM:function(e){return/^(g\xfcnd\xfcz|ax\u015fam)$/.test(e)},meridiem:function(e,a,_){return e<4?"gec\u0259":e<12?"s\u0259h\u0259r":e<17?"g\xfcnd\xfcz":"ax\u015fam"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,ordinal:function(e){if(0===e)return e+"-\u0131nc\u0131";var a=e%10;return e+(L[a]||L[e%100-a]||L[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("be",{months:{format:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split("_"),standalone:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split("_")},monthsShort:"\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split("_"),weekdays:{format:"\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),standalone:"\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),isFormat:/\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., HH:mm",LLLL:"dddd, D MMMM YYYY \u0433., HH:mm"},calendar:{sameDay:"[\u0421\u0451\u043d\u043d\u044f \u045e] LT",nextDay:"[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",lastDay:"[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",nextWeek:function(){return"[\u0423] dddd [\u045e] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";case 1:case 2:case 4:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u0440\u0430\u0437 %s",past:"%s \u0442\u0430\u043c\u0443",s:"\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",m:Y,mm:Y,h:Y,hh:Y,d:"\u0434\u0437\u0435\u043d\u044c",dd:Y,M:"\u043c\u0435\u0441\u044f\u0446",MM:Y,y:"\u0433\u043e\u0434",yy:Y},meridiemParse:/\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u044b":e<12?"\u0440\u0430\u043d\u0456\u0446\u044b":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0430\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+"-\u044b":e+"-\u0456";case"D":return e+"-\u0433\u0430";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("bg",{months:"\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u044f\u043d\u0440_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u043d\u0435\u0441 \u0432] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432] LT",nextWeek:"dddd [\u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0412 \u0438\u0437\u043c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";case 1:case 2:case 4:case 5:return"[\u0412 \u0438\u0437\u043c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0441\u043b\u0435\u0434 %s",past:"\u043f\u0440\u0435\u0434\u0438 %s",s:"\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u043d\u0438",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0430",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,_=e%100;return 0===e?e+"-\u0435\u0432":0===_?e+"-\u0435\u043d":10<_&&_<20?e+"-\u0442\u0438":1===a?e+"-\u0432\u0438":2===a?e+"-\u0440\u0438":7===a||8===a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),weekdays:"Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm"},calendar:{sameDay:"[Bi l\u025br\u025b] LT",nextDay:"[Sini l\u025br\u025b] LT",nextWeek:"dddd [don l\u025br\u025b] LT",lastDay:"[Kunu l\u025br\u025b] LT",lastWeek:"dddd [t\u025bm\u025bnen l\u025br\u025b] LT",sameElse:"L"},relativeTime:{future:"%s k\u0254n\u0254",past:"a b\u025b %s b\u0254",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"l\u025br\u025b kelen",hh:"l\u025br\u025b %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}});var h={1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"},y={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"};e.defineLocale("bn",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09c0_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2_\u0986\u0997_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u0983_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return y[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return h[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a&&4<=e||"\u09a6\u09c1\u09aa\u09c1\u09b0"===a&&e<5||"\u09ac\u09bf\u0995\u09be\u09b2"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u09b0\u09be\u09a4":e<10?"\u09b8\u0995\u09be\u09b2":e<17?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<20?"\u09ac\u09bf\u0995\u09be\u09b2":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}});var c={1:"\u0f21",2:"\u0f22",3:"\u0f23",4:"\u0f24",5:"\u0f25",6:"\u0f26",7:"\u0f27",8:"\u0f28",9:"\u0f29",0:"\u0f20"},k={"\u0f21":"1","\u0f22":"2","\u0f23":"3","\u0f24":"4","\u0f25":"5","\u0f26":"6","\u0f27":"7","\u0f28":"8","\u0f29":"9","\u0f20":"0"};function p(e,a,_){var s,d,t;return e+" "+(s={mm:"munutenn",MM:"miz",dd:"devezh"}[_],2!==e?s:void 0!==(t={m:"v",b:"v",d:"z"})[(d=s).charAt(0)]?t[d.charAt(0)]+d.substring(1):d)}function D(e,a,_){var s=e+" ";switch(_){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}e.defineLocale("bo",{months:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),monthsShort:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),weekdays:"\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysShort:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysMin:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",nextDay:"[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",nextWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",lastDay:"[\u0f41\u0f0b\u0f66\u0f44] LT",lastWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0f63\u0f0b",past:"%s \u0f66\u0f94\u0f53\u0f0b\u0f63",s:"\u0f63\u0f58\u0f0b\u0f66\u0f44",ss:"%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",m:"\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",mm:"%d \u0f66\u0f90\u0f62\u0f0b\u0f58",h:"\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",hh:"%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",d:"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",dd:"%d \u0f49\u0f72\u0f53\u0f0b",M:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",MM:"%d \u0f5f\u0fb3\u0f0b\u0f56",y:"\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",yy:"%d \u0f63\u0f7c"},preparse:function(e){return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g,function(e){return k[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return c[e]})},meridiemParse:/\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"===a&&4<=e||"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"===a&&e<5||"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c":e<10?"\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66":e<17?"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44":e<20?"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42":"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"},week:{dow:0,doy:6}}),e.defineLocale("br",{months:"Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h[e]mm A",LTS:"h[e]mm:ss A",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY h[e]mm A",LLLL:"dddd, D [a viz] MMMM YYYY h[e]mm A"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warc'hoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Dec'h da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s 'zo",s:"un nebeud segondenno\xf9",ss:"%d eilenn",m:"ur vunutenn",mm:p,h:"un eur",hh:"%d eur",d:"un devezh",dd:p,M:"ur miz",MM:p,y:"ur bloaz",yy:function(e){switch(function e(a){return 9<a?e(a%10):a}(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}},dayOfMonthOrdinalParse:/\d{1,2}(a\xf1|vet)/,ordinal:function(e){return e+(1===e?"a\xf1":"vet")},week:{dow:1,doy:4}}),e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:D,m:D,mm:D,h:D,hh:D,d:"dan",dd:D,M:"mjesec",MM:D,y:"godinu",yy:D},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ca",{months:{standalone:"gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[dem\xe0 a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){var _=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8";return"w"!==a&&"W"!==a||(_="a"),e+_},week:{dow:1,doy:4}});var T="leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),f="led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_");function w(e){return 1<e&&e<5&&1!=~~(e/10)}function g(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"p\xe1r sekund":"p\xe1r sekundami";case"ss":return a||s?d+(w(e)?"sekundy":"sekund"):d+"sekundami";break;case"m":return a?"minuta":s?"minutu":"minutou";case"mm":return a||s?d+(w(e)?"minuty":"minut"):d+"minutami";break;case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?d+(w(e)?"hodiny":"hodin"):d+"hodinami";break;case"d":return a||s?"den":"dnem";case"dd":return a||s?d+(w(e)?"dny":"dn\xed"):d+"dny";break;case"M":return a||s?"m\u011bs\xedc":"m\u011bs\xedcem";case"MM":return a||s?d+(w(e)?"m\u011bs\xedce":"m\u011bs\xedc\u016f"):d+"m\u011bs\xedci";break;case"y":return a||s?"rok":"rokem";case"yy":return a||s?d+(w(e)?"roky":"let"):d+"lety";break}}function H(e,a,_,s){var d={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?d[_][0]:d[_][1]}function b(e,a,_,s){var d={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?d[_][0]:d[_][1]}function S(e,a,_,s){var d={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?d[_][0]:d[_][1]}e.defineLocale("cs",{months:T,monthsShort:f,monthsParse:function(e,a){var _,s=[];for(_=0;_<12;_++)s[_]=new RegExp("^"+e[_]+"$|^"+a[_]+"$","i");return s}(T,f),shortMonthsParse:function(e){var a,_=[];for(a=0;a<12;a++)_[a]=new RegExp("^"+e[a]+"$","i");return _}(f),longMonthsParse:function(e){var a,_=[];for(a=0;a<12;a++)_[a]=new RegExp("^"+e[a]+"$","i");return _}(T),weekdays:"ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),weekdaysShort:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),weekdaysMin:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[z\xedtra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v ned\u011bli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve st\u0159edu v] LT";case 4:return"[ve \u010dtvrtek v] LT";case 5:return"[v p\xe1tek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[v\u010dera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou ned\u011bli v] LT";case 1:case 2:return"[minul\xe9] dddd [v] LT";case 3:return"[minulou st\u0159edu v] LT";case 4:case 5:return"[minul\xfd] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"p\u0159ed %s",s:g,ss:g,m:g,mm:g,h:g,hh:g,d:g,dd:g,M:g,MM:g,y:g,yy:g},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("cv",{months:"\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),monthsShort:"\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split("_"),weekdays:"\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split("_"),weekdaysShort:"\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split("_"),weekdaysMin:"\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",LLL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",LLLL:"dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm"},calendar:{sameDay:"[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextDay:"[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastDay:"[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextWeek:"[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastWeek:"[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",sameElse:"L"},relativeTime:{future:function(e){return e+(/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)?"\u0440\u0435\u043d":/\u04ab\u0443\u043b$/i.exec(e)?"\u0442\u0430\u043d":"\u0440\u0430\u043d")},past:"%s \u043a\u0430\u044f\u043b\u043b\u0430",s:"\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",ss:"%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",m:"\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",hh:"%d \u0441\u0435\u0445\u0435\u0442",d:"\u043f\u04d7\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",MM:"%d \u0443\u0439\u04d1\u0445",y:"\u043f\u04d7\u0440 \u04ab\u0443\u043b",yy:"%d \u04ab\u0443\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-\u043c\u04d7\u0448/,ordinal:"%d-\u043c\u04d7\u0448",week:{dow:1,doy:7}}),e.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn \xf4l",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var a="";return 20<e?a=40===e||50===e||60===e||80===e||100===e?"fed":"ain":0<e&&(a=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][e]),e+a},week:{dow:1,doy:4}}),e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"p\xe5 dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"f\xe5 sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"et \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-at",{months:"J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:H,mm:"%d Minuten",h:H,hh:"%d Stunden",d:H,dd:H,M:H,MM:H,y:H,yy:H},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-ch",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:b,mm:"%d Minuten",h:b,hh:"%d Stunden",d:b,dd:b,M:b,MM:b,y:b,yy:b},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:S,mm:"%d Minuten",h:S,hh:"%d Stunden",d:S,dd:S,M:S,MM:S,y:S,yy:S},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var v=["\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9","\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9","\u0789\u07a7\u0783\u07a8\u0797\u07aa","\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa","\u0789\u07ad","\u0796\u07ab\u0782\u07b0","\u0796\u07aa\u078d\u07a6\u0787\u07a8","\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa","\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa","\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa"],j=["\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6","\u0780\u07af\u0789\u07a6","\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6","\u0784\u07aa\u078b\u07a6","\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8","\u0780\u07aa\u0786\u07aa\u0783\u07aa","\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa"];e.defineLocale("dv",{months:v,monthsShort:v,weekdays:j,weekdaysShort:j,weekdaysMin:"\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0789\u0786|\u0789\u078a/,isPM:function(e){return"\u0789\u078a"===e},meridiem:function(e,a,_){return e<12?"\u0789\u0786":"\u0789\u078a"},calendar:{sameDay:"[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",nextDay:"[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",nextWeek:"dddd LT",lastDay:"[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",lastWeek:"[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",sameElse:"L"},relativeTime:{future:"\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",past:"\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",s:"\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",ss:"d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",m:"\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",mm:"\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",h:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",hh:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",d:"\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",dd:"\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",M:"\u0789\u07a6\u0780\u07ac\u0787\u07b0",MM:"\u0789\u07a6\u0790\u07b0 %d",y:"\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",yy:"\u0787\u07a6\u0780\u07a6\u0783\u07aa %d"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:7,doy:12}}),e.defineLocale("el",{monthsNominativeEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split("_"),monthsGenitiveEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split("_"),months:function(e,a){return e?"string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:"\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split("_"),weekdays:"\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split("_"),weekdaysShort:"\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split("_"),weekdaysMin:"\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),meridiem:function(e,a,_){return 11<e?_?"\u03bc\u03bc":"\u039c\u039c":_?"\u03c0\u03bc":"\u03a0\u039c"},isPM:function(e){return"\u03bc"===(e+"").toLowerCase()[0]},meridiemParse:/[\u03a0\u039c]\.?\u039c?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",nextDay:"[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[\u03a7\u03b8\u03b5\u03c2 {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";default:return"[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,a){var _,s=this._calendarEl[e],d=a&&a.hours();return((_=s)instanceof Function||"[object Function]"===Object.prototype.toString.call(_))&&(s=s.apply(a)),s.replace("{}",d%12==1?"\u03c3\u03c4\u03b7":"\u03c3\u03c4\u03b9\u03c2")},relativeTime:{future:"\u03c3\u03b5 %s",past:"%s \u03c0\u03c1\u03b9\u03bd",s:"\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",ss:"%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",m:"\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",mm:"%d \u03bb\u03b5\u03c0\u03c4\u03ac",h:"\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",hh:"%d \u03ce\u03c1\u03b5\u03c2",d:"\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",dd:"%d \u03bc\u03ad\u03c1\u03b5\u03c2",M:"\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",MM:"%d \u03bc\u03ae\u03bd\u03b5\u03c2",y:"\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",yy:"%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1"},dayOfMonthOrdinalParse:/\d{1,2}\u03b7/,ordinal:"%d\u03b7",week:{dow:1,doy:4}}),e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}}),e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-il",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}}),e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_a\u016dg_sep_okt_nov_dec".split("_"),weekdays:"diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_\u0135a_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D[-a de] MMMM, YYYY",LLL:"D[-a de] MMMM, YYYY HH:mm",LLLL:"dddd, [la] D[-a de] MMMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,a,_){return 11<e?_?"p.t.m.":"P.T.M.":_?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodia\u016d je] LT",nextDay:"[Morga\u016d je] LT",nextWeek:"dddd [je] LT",lastDay:"[Hiera\u016d je] LT",lastWeek:"[pasinta] dddd [je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"anta\u016d %s",s:"sekundoj",ss:"%d sekundoj",m:"minuto",mm:"%d minutoj",h:"horo",hh:"%d horoj",d:"tago",dd:"%d tagoj",M:"monato",MM:"%d monatoj",y:"jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}});var x="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),P="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),W=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],E=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?P[e.month()]:x[e.month()]:x},monthsRegex:E,monthsShortRegex:E,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:W,longMonthsParse:W,shortMonthsParse:W,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var A="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),O="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?O[e.month()]:A[e.month()]:A},monthsParseExact:!0,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"MMMM [de] D [de] YYYY",LLL:"MMMM [de] D [de] YYYY h:mm A",LLLL:"dddd, MMMM [de] D [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:6}});var F="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),z="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),J=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],I=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;function N(e,a,_,s){var d={s:["m\xf5ne sekundi","m\xf5ni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["\xfche minuti","\xfcks minut"],mm:[e+" minuti",e+" minutit"],h:["\xfche tunni","tund aega","\xfcks tund"],hh:[e+" tunni",e+" tundi"],d:["\xfche p\xe4eva","\xfcks p\xe4ev"],M:["kuu aja","kuu aega","\xfcks kuu"],MM:[e+" kuu",e+" kuud"],y:["\xfche aasta","aasta","\xfcks aasta"],yy:[e+" aasta",e+" aastat"]};return a?d[_][2]?d[_][2]:d[_][1]:s?d[_][0]:d[_][1]}e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?z[e.month()]:F[e.month()]:F},monthsRegex:I,monthsShortRegex:I,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:J,longMonthsParse:J,shortMonthsParse:J,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("et",{months:"jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[T\xe4na,] LT",nextDay:"[Homme,] LT",nextWeek:"[J\xe4rgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s p\xe4rast",past:"%s tagasi",s:N,ss:N,m:N,mm:N,h:N,hh:N,d:N,dd:"%d p\xe4eva",M:N,MM:N,y:N,yy:N},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var R={1:"\u06f1",2:"\u06f2",3:"\u06f3",4:"\u06f4",5:"\u06f5",6:"\u06f6",7:"\u06f7",8:"\u06f8",9:"\u06f9",0:"\u06f0"},K={"\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9","\u06f0":"0"};e.defineLocale("fa",{months:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),monthsShort:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),weekdays:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysShort:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,isPM:function(e){return/\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e)},meridiem:function(e,a,_){return e<12?"\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631":"\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631"},calendar:{sameDay:"[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",nextDay:"[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",nextWeek:"dddd [\u0633\u0627\u0639\u062a] LT",lastDay:"[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",lastWeek:"dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",sameElse:"L"},relativeTime:{future:"\u062f\u0631 %s",past:"%s \u067e\u06cc\u0634",s:"\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",ss:"\u062b\u0627\u0646\u06cc\u0647 d%",m:"\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",mm:"%d \u062f\u0642\u06cc\u0642\u0647",h:"\u06cc\u06a9 \u0633\u0627\u0639\u062a",hh:"%d \u0633\u0627\u0639\u062a",d:"\u06cc\u06a9 \u0631\u0648\u0632",dd:"%d \u0631\u0648\u0632",M:"\u06cc\u06a9 \u0645\u0627\u0647",MM:"%d \u0645\u0627\u0647",y:"\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/[\u06f0-\u06f9]/g,function(e){return K[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return R[e]}).replace(/,/g,"\u060c")},dayOfMonthOrdinalParse:/\d{1,2}\u0645/,ordinal:"%d\u0645",week:{dow:6,doy:12}});var C="nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" "),G=["nolla","yhden","kahden","kolmen","nelj\xe4n","viiden","kuuden",C[7],C[8],C[9]];function B(e,a,_,s){var d,t,n="";switch(_){case"s":return s?"muutaman sekunnin":"muutama sekunti";case"ss":return s?"sekunnin":"sekuntia";case"m":return s?"minuutin":"minuutti";case"mm":n=s?"minuutin":"minuuttia";break;case"h":return s?"tunnin":"tunti";case"hh":n=s?"tunnin":"tuntia";break;case"d":return s?"p\xe4iv\xe4n":"p\xe4iv\xe4";case"dd":n=s?"p\xe4iv\xe4n":"p\xe4iv\xe4\xe4";break;case"M":return s?"kuukauden":"kuukausi";case"MM":n=s?"kuukauden":"kuukautta";break;case"y":return s?"vuoden":"vuosi";case"yy":n=s?"vuoden":"vuotta";break}return t=s,n=((d=e)<10?t?G[d]:C[d]:d)+" "+n}e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[t\xe4n\xe4\xe4n] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s p\xe4\xe4st\xe4",past:"%s sitten",s:B,ss:B,m:B,mm:B,h:B,hh:B,d:B,dd:B,M:B,MM:B,y:B,yy:B},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fo",{months:"januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),weekdaysShort:"sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),weekdaysMin:"su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[\xcd dag kl.] LT",nextDay:"[\xcd morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xcd gj\xe1r kl.] LT",lastWeek:"[s\xed\xf0stu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s s\xed\xf0ani",s:"f\xe1 sekund",ss:"%d sekundir",m:"ein minutt",mm:"%d minuttir",h:"ein t\xedmi",hh:"%d t\xedmar",d:"ein dagur",dd:"%d dagar",M:"ein m\xe1na\xf0i",MM:"%d m\xe1na\xf0ir",y:"eitt \xe1r",yy:"%d \xe1r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fr-ca",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}}),e.defineLocale("fr-ch",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}}),e.defineLocale("fr",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}});var q="jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),$="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");e.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?$[e.month()]:q[e.month()]:q},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[\xf4fr\xfbne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien min\xfat",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}});function U(e,a,_,s){var d={s:["thodde secondanim","thodde second"],ss:[e+" secondanim",e+" second"],m:["eka mintan","ek minute"],mm:[e+" mintanim",e+" mintam"],h:["eka horan","ek hor"],hh:[e+" horanim",e+" horam"],d:["eka disan","ek dis"],dd:[e+" disanim",e+" dis"],M:["eka mhoinean","ek mhoino"],MM:[e+" mhoineanim",e+" mhoine"],y:["eka vorsan","ek voros"],yy:[e+" vorsanim",e+" vorsam"]};return a?d[_][0]:d[_][1]}e.defineLocale("gd",{months:["Am Faoilleach","An Gearran","Am M\xe0rt","An Giblean","An C\xe8itean","An t-\xd2gmhios","An t-Iuchar","An L\xf9nastal","An t-Sultain","An D\xe0mhair","An t-Samhain","An D\xf9bhlachd"],monthsShort:["Faoi","Gear","M\xe0rt","Gibl","C\xe8it","\xd2gmh","Iuch","L\xf9n","Sult","D\xe0mh","Samh","D\xf9bh"],monthsParseExact:!0,weekdays:["Did\xf2mhnaich","Diluain","Dim\xe0irt","Diciadain","Diardaoin","Dihaoine","Disathairne"],weekdaysShort:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],weekdaysMin:["D\xf2","Lu","M\xe0","Ci","Ar","Ha","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-m\xe0ireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-d\xe8 aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"m\xecos",MM:"%d m\xecosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}}),e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextDay:function(){return"[ma\xf1\xe1 "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"\xe1s":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"\xe1":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"\xe1s":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("gom-latn",{months:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Ieta to] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fatlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:U,ss:U,m:U,mm:U,h:U,hh:U,d:U,dd:U,M:U,MM:U,y:U,yy:U},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(e,a){switch(a){case"D":return e+"er";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:1,doy:4},meridiemParse:/rati|sokalli|donparam|sanje/,meridiemHour:function(e,a){return 12===e&&(e=0),"rati"===a?e<4?e:e+12:"sokalli"===a?e:"donparam"===a?12<e?e:e+12:"sanje"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"rati":e<12?"sokalli":e<16?"donparam":e<20?"sanje":"rati"}});var Q={1:"\u0ae7",2:"\u0ae8",3:"\u0ae9",4:"\u0aea",5:"\u0aeb",6:"\u0aec",7:"\u0aed",8:"\u0aee",9:"\u0aef",0:"\u0ae6"},V={"\u0ae7":"1","\u0ae8":"2","\u0ae9":"3","\u0aea":"4","\u0aeb":"5","\u0aec":"6","\u0aed":"7","\u0aee":"8","\u0aef":"9","\u0ae6":"0"};e.defineLocale("gu",{months:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split("_"),monthsShort:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split("_"),monthsParseExact:!0,weekdays:"\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split("_"),weekdaysShort:"\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split("_"),weekdaysMin:"\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),longDateFormat:{LT:"A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LTS:"A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LLLL:"dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7"},calendar:{sameDay:"[\u0a86\u0a9c] LT",nextDay:"[\u0a95\u0abe\u0ab2\u0ac7] LT",nextWeek:"dddd, LT",lastDay:"[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",lastWeek:"[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0aae\u0abe",past:"%s \u0aaa\u0ac7\u0ab9\u0ab2\u0abe",s:"\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",ss:"%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",m:"\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",mm:"%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",h:"\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",hh:"%d \u0a95\u0ab2\u0abe\u0a95",d:"\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",dd:"%d \u0aa6\u0abf\u0ab5\u0ab8",M:"\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",MM:"%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",y:"\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",yy:"%d \u0ab5\u0ab0\u0acd\u0ab7"},preparse:function(e){return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g,function(e){return V[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Q[e]})},meridiemParse:/\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0ab0\u0abe\u0aa4"===a?e<4?e:e+12:"\u0ab8\u0ab5\u0abe\u0ab0"===a?e:"\u0aac\u0aaa\u0acb\u0ab0"===a?10<=e?e:e+12:"\u0ab8\u0abe\u0a82\u0a9c"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0ab0\u0abe\u0aa4":e<10?"\u0ab8\u0ab5\u0abe\u0ab0":e<17?"\u0aac\u0aaa\u0acb\u0ab0":e<20?"\u0ab8\u0abe\u0a82\u0a9c":"\u0ab0\u0abe\u0aa4"},week:{dow:0,doy:6}}),e.defineLocale("he",{months:"\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split("_"),monthsShort:"\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split("_"),weekdays:"\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split("_"),weekdaysShort:"\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),weekdaysMin:"\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [\u05d1]MMMM YYYY",LLL:"D [\u05d1]MMMM YYYY HH:mm",LLLL:"dddd, D [\u05d1]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",nextDay:"[\u05de\u05d7\u05e8 \u05d1\u05be]LT",nextWeek:"dddd [\u05d1\u05e9\u05e2\u05d4] LT",lastDay:"[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",lastWeek:"[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",sameElse:"L"},relativeTime:{future:"\u05d1\u05e2\u05d5\u05d3 %s",past:"\u05dc\u05e4\u05e0\u05d9 %s",s:"\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",ss:"%d \u05e9\u05e0\u05d9\u05d5\u05ea",m:"\u05d3\u05e7\u05d4",mm:"%d \u05d3\u05e7\u05d5\u05ea",h:"\u05e9\u05e2\u05d4",hh:function(e){return 2===e?"\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd":e+" \u05e9\u05e2\u05d5\u05ea"},d:"\u05d9\u05d5\u05dd",dd:function(e){return 2===e?"\u05d9\u05d5\u05de\u05d9\u05d9\u05dd":e+" \u05d9\u05de\u05d9\u05dd"},M:"\u05d7\u05d5\u05d3\u05e9",MM:function(e){return 2===e?"\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd":e+" \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd"},y:"\u05e9\u05e0\u05d4",yy:function(e){return 2===e?"\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd":e%10==0&&10!==e?e+" \u05e9\u05e0\u05d4":e+" \u05e9\u05e0\u05d9\u05dd"}},meridiemParse:/\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,isPM:function(e){return/^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(e)},meridiem:function(e,a,_){return e<5?"\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8":e<10?"\u05d1\u05d1\u05d5\u05e7\u05e8":e<12?_?'\u05dc\u05e4\u05e0\u05d4"\u05e6':"\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":e<18?_?'\u05d0\u05d7\u05d4"\u05e6':"\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":"\u05d1\u05e2\u05e8\u05d1"}});var Z={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},X={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};function ee(e,a,_){var s=e+" ";switch(_){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}e.defineLocale("hi",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u092c\u091c\u0947",LTS:"A h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0915\u0932] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u0932] LT",lastWeek:"[\u092a\u093f\u091b\u0932\u0947] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u092e\u0947\u0902",past:"%s \u092a\u0939\u0932\u0947",s:"\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0902\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u091f",mm:"%d \u092e\u093f\u0928\u091f",h:"\u090f\u0915 \u0918\u0902\u091f\u093e",hh:"%d \u0918\u0902\u091f\u0947",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",MM:"%d \u092e\u0939\u0940\u0928\u0947",y:"\u090f\u0915 \u0935\u0930\u094d\u0937",yy:"%d \u0935\u0930\u094d\u0937"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return X[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Z[e]})},meridiemParse:/\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924"===a?e<4?e:e+12:"\u0938\u0941\u092c\u0939"===a?e:"\u0926\u094b\u092a\u0939\u0930"===a?10<=e?e:e+12:"\u0936\u093e\u092e"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0930\u093e\u0924":e<10?"\u0938\u0941\u092c\u0939":e<17?"\u0926\u094b\u092a\u0939\u0930":e<20?"\u0936\u093e\u092e":"\u0930\u093e\u0924"},week:{dow:0,doy:6}}),e.defineLocale("hr",{months:{format:"sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:ee,m:ee,mm:ee,h:ee,hh:ee,d:"dan",dd:ee,M:"mjesec",MM:ee,y:"godinu",yy:ee},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var ae="vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");function _e(e,a,_,s){var d=e;switch(_){case"s":return s||a?"n\xe9h\xe1ny m\xe1sodperc":"n\xe9h\xe1ny m\xe1sodperce";case"ss":return d+(s||a)?" m\xe1sodperc":" m\xe1sodperce";case"m":return"egy"+(s||a?" perc":" perce");case"mm":return d+(s||a?" perc":" perce");case"h":return"egy"+(s||a?" \xf3ra":" \xf3r\xe1ja");case"hh":return d+(s||a?" \xf3ra":" \xf3r\xe1ja");case"d":return"egy"+(s||a?" nap":" napja");case"dd":return d+(s||a?" nap":" napja");case"M":return"egy"+(s||a?" h\xf3nap":" h\xf3napja");case"MM":return d+(s||a?" h\xf3nap":" h\xf3napja");case"y":return"egy"+(s||a?" \xe9v":" \xe9ve");case"yy":return d+(s||a?" \xe9v":" \xe9ve")}return""}function se(e){return(e?"":"[m\xfalt] ")+"["+ae[this.day()]+"] LT[-kor]"}function de(e){return e%100==11||e%10!=1}function te(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"nokkrar sek\xfandur":"nokkrum sek\xfandum";case"ss":return de(e)?d+(a||s?"sek\xfandur":"sek\xfandum"):d+"sek\xfanda";case"m":return a?"m\xedn\xfata":"m\xedn\xfatu";case"mm":return de(e)?d+(a||s?"m\xedn\xfatur":"m\xedn\xfatum"):a?d+"m\xedn\xfata":d+"m\xedn\xfatu";case"hh":return de(e)?d+(a||s?"klukkustundir":"klukkustundum"):d+"klukkustund";case"d":return a?"dagur":s?"dag":"degi";case"dd":return de(e)?a?d+"dagar":d+(s?"daga":"d\xf6gum"):a?d+"dagur":d+(s?"dag":"degi");case"M":return a?"m\xe1nu\xf0ur":s?"m\xe1nu\xf0":"m\xe1nu\xf0i";case"MM":return de(e)?a?d+"m\xe1nu\xf0ir":d+(s?"m\xe1nu\xf0i":"m\xe1nu\xf0um"):a?d+"m\xe1nu\xf0ur":d+(s?"m\xe1nu\xf0":"m\xe1nu\xf0i");case"y":return a||s?"\xe1r":"\xe1ri";case"yy":return de(e)?d+(a||s?"\xe1r":"\xe1rum"):d+(a||s?"\xe1r":"\xe1ri")}}e.defineLocale("hu",{months:"janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),monthsShort:"jan_feb_m\xe1rc_\xe1pr_m\xe1j_j\xfan_j\xfal_aug_szept_okt_nov_dec".split("_"),weekdays:"vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),weekdaysShort:"vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,_){return e<12?!0===_?"de":"DE":!0===_?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return se.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return se.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s m\xfalva",past:"%s",s:_e,ss:_e,m:_e,mm:_e,h:_e,hh:_e,d:_e,dd:_e,M:_e,MM:_e,y:_e,yy:_e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("hy-am",{months:{format:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split("_"),standalone:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split("_")},monthsShort:"\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split("_"),weekdays:"\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),weekdaysShort:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),weekdaysMin:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0569.",LLL:"D MMMM YYYY \u0569., HH:mm",LLLL:"dddd, D MMMM YYYY \u0569., HH:mm"},calendar:{sameDay:"[\u0561\u0575\u057d\u0585\u0580] LT",nextDay:"[\u057e\u0561\u0572\u0568] LT",lastDay:"[\u0565\u0580\u0565\u056f] LT",nextWeek:function(){return"dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},lastWeek:function(){return"[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},sameElse:"L"},relativeTime:{future:"%s \u0570\u0565\u057f\u0578",past:"%s \u0561\u057c\u0561\u057b",s:"\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",ss:"%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",m:"\u0580\u0578\u057a\u0565",mm:"%d \u0580\u0578\u057a\u0565",h:"\u056a\u0561\u0574",hh:"%d \u056a\u0561\u0574",d:"\u0585\u0580",dd:"%d \u0585\u0580",M:"\u0561\u0574\u056b\u057d",MM:"%d \u0561\u0574\u056b\u057d",y:"\u057f\u0561\u0580\u056b",yy:"%d \u057f\u0561\u0580\u056b"},meridiemParse:/\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,isPM:function(e){return/^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(e)},meridiem:function(e){return e<4?"\u0563\u056b\u0577\u0565\u0580\u057e\u0561":e<12?"\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561":e<17?"\u0581\u0565\u0580\u0565\u056f\u057e\u0561":"\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,ordinal:function(e,a){switch(a){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-\u056b\u0576":e+"-\u0580\u0564";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?11<=e?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("is",{months:"jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),monthsShort:"jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),weekdays:"sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),weekdaysShort:"sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),weekdaysMin:"Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[\xed dag kl.] LT",nextDay:"[\xe1 morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xed g\xe6r kl.] LT",lastWeek:"[s\xed\xf0asta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s s\xed\xf0an",s:te,ss:te,m:te,mm:te,h:"klukkustund",hh:te,d:te,dd:te,M:te,MM:te,y:te,yy:te},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ja",{months:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split("_"),weekdaysShort:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),weekdaysMin:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm"},meridiemParse:/\u5348\u524d|\u5348\u5f8c/i,isPM:function(e){return"\u5348\u5f8c"===e},meridiem:function(e,a,_){return e<12?"\u5348\u524d":"\u5348\u5f8c"},calendar:{sameDay:"[\u4eca\u65e5] LT",nextDay:"[\u660e\u65e5] LT",nextWeek:function(e){return e.week()<this.week()?"[\u6765\u9031]dddd LT":"dddd LT"},lastDay:"[\u6628\u65e5] LT",lastWeek:function(e){return this.week()<e.week()?"[\u5148\u9031]dddd LT":"dddd LT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}\u65e5/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u6570\u79d2",ss:"%d\u79d2",m:"1\u5206",mm:"%d\u5206",h:"1\u6642\u9593",hh:"%d\u6642\u9593",d:"1\u65e5",dd:"%d\u65e5",M:"1\u30f6\u6708",MM:"%d\u30f6\u6708",y:"1\u5e74",yy:"%d\u5e74"}}),e.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,a){return 12===e&&(e=0),"enjing"===a?e:"siyang"===a?11<=e?e:e+12:"sonten"===a||"ndalu"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}}),e.defineLocale("ka",{months:{standalone:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split("_"),format:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10e1_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10e1_\u10db\u10d0\u10e0\u10e2\u10e1_\u10d0\u10de\u10e0\u10d8\u10da\u10d8\u10e1_\u10db\u10d0\u10d8\u10e1\u10e1_\u10d8\u10d5\u10dc\u10d8\u10e1\u10e1_\u10d8\u10d5\u10da\u10d8\u10e1\u10e1_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10e1_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10e1_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10e1_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10e1_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10e1".split("_")},monthsShort:"\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split("_"),weekdays:{standalone:"\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split("_"),format:"\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split("_"),isFormat:/(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/},weekdaysShort:"\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split("_"),weekdaysMin:"\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",nextDay:"[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",lastDay:"[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",nextWeek:"[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",lastWeek:"[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",sameElse:"L"},relativeTime:{future:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10ec\u10d4\u10da\u10d8)/.test(e)?e.replace(/\u10d8$/,"\u10e8\u10d8"):e+"\u10e8\u10d8"},past:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(e)?e.replace(/(\u10d8|\u10d4)$/,"\u10d8\u10e1 \u10ec\u10d8\u10dc"):/\u10ec\u10d4\u10da\u10d8/.test(e)?e.replace(/\u10ec\u10d4\u10da\u10d8$/,"\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc"):void 0},s:"\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",ss:"%d \u10ec\u10d0\u10db\u10d8",m:"\u10ec\u10e3\u10d7\u10d8",mm:"%d \u10ec\u10e3\u10d7\u10d8",h:"\u10e1\u10d0\u10d0\u10d7\u10d8",hh:"%d \u10e1\u10d0\u10d0\u10d7\u10d8",d:"\u10d3\u10e6\u10d4",dd:"%d \u10d3\u10e6\u10d4",M:"\u10d7\u10d5\u10d4",MM:"%d \u10d7\u10d5\u10d4",y:"\u10ec\u10d4\u10da\u10d8",yy:"%d \u10ec\u10d4\u10da\u10d8"},dayOfMonthOrdinalParse:/0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,ordinal:function(e){return 0===e?e:1===e?e+"-\u10da\u10d8":e<20||e<=100&&e%20==0||e%100==0?"\u10db\u10d4-"+e:e+"-\u10d4"},week:{dow:1,doy:7}});var ne={0:"-\u0448\u0456",1:"-\u0448\u0456",2:"-\u0448\u0456",3:"-\u0448\u0456",4:"-\u0448\u0456",5:"-\u0448\u0456",6:"-\u0448\u044b",7:"-\u0448\u0456",8:"-\u0448\u0456",9:"-\u0448\u044b",10:"-\u0448\u044b",20:"-\u0448\u044b",30:"-\u0448\u044b",40:"-\u0448\u044b",50:"-\u0448\u0456",60:"-\u0448\u044b",70:"-\u0448\u0456",80:"-\u0448\u0456",90:"-\u0448\u044b",100:"-\u0448\u0456"};e.defineLocale("kk",{months:"\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split("_"),monthsShort:"\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split("_"),weekdays:"\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split("_"),weekdaysShort:"\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split("_"),weekdaysMin:"\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",nextDay:"[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0493\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0456\u0448\u0456\u043d\u0434\u0435",past:"%s \u0431\u04b1\u0440\u044b\u043d",s:"\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",hh:"%d \u0441\u0430\u0493\u0430\u0442",d:"\u0431\u0456\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0456\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0456\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0448\u0456|\u0448\u044b)/,ordinal:function(e){return e+(ne[e]||ne[e%10]||ne[100<=e?100:null])},week:{dow:1,doy:7}});var re={1:"\u17e1",2:"\u17e2",3:"\u17e3",4:"\u17e4",5:"\u17e5",6:"\u17e6",7:"\u17e7",8:"\u17e8",9:"\u17e9",0:"\u17e0"},ie={"\u17e1":"1","\u17e2":"2","\u17e3":"3","\u17e4":"4","\u17e5":"5","\u17e6":"6","\u17e7":"7","\u17e8":"8","\u17e9":"9","\u17e0":"0"};e.defineLocale("km",{months:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),monthsShort:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),weekdays:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),weekdaysShort:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysMin:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,isPM:function(e){return"\u179b\u17d2\u1784\u17b6\u1785"===e},meridiem:function(e,a,_){return e<12?"\u1796\u17d2\u179a\u17b9\u1780":"\u179b\u17d2\u1784\u17b6\u1785"},calendar:{sameDay:"[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",nextDay:"[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",nextWeek:"dddd [\u1798\u17c9\u17c4\u1784] LT",lastDay:"[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",lastWeek:"dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",sameElse:"L"},relativeTime:{future:"%s\u1791\u17c0\u178f",past:"%s\u1798\u17bb\u1793",s:"\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",ss:"%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",m:"\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",mm:"%d \u1793\u17b6\u1791\u17b8",h:"\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",hh:"%d \u1798\u17c9\u17c4\u1784",d:"\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",dd:"%d \u1790\u17d2\u1784\u17c3",M:"\u1798\u17bd\u1799\u1781\u17c2",MM:"%d \u1781\u17c2",y:"\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",yy:"%d \u1786\u17d2\u1793\u17b6\u17c6"},dayOfMonthOrdinalParse:/\u1791\u17b8\d{1,2}/,ordinal:"\u1791\u17b8%d",preparse:function(e){return e.replace(/[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g,function(e){return ie[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return re[e]})},week:{dow:1,doy:4}});var me={1:"\u0ce7",2:"\u0ce8",3:"\u0ce9",4:"\u0cea",5:"\u0ceb",6:"\u0cec",7:"\u0ced",8:"\u0cee",9:"\u0cef",0:"\u0ce6"},oe={"\u0ce7":"1","\u0ce8":"2","\u0ce9":"3","\u0cea":"4","\u0ceb":"5","\u0cec":"6","\u0ced":"7","\u0cee":"8","\u0cef":"9","\u0ce6":"0"};e.defineLocale("kn",{months:"\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split("_"),monthsShort:"\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split("_"),monthsParseExact:!0,weekdays:"\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split("_"),weekdaysShort:"\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split("_"),weekdaysMin:"\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c87\u0c82\u0ca6\u0cc1] LT",nextDay:"[\u0ca8\u0cbe\u0cb3\u0cc6] LT",nextWeek:"dddd, LT",lastDay:"[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",lastWeek:"[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0ca8\u0c82\u0ca4\u0cb0",past:"%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",s:"\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",ss:"%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",m:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",mm:"%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",h:"\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",hh:"%d \u0c97\u0c82\u0c9f\u0cc6",d:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",dd:"%d \u0ca6\u0cbf\u0ca8",M:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",MM:"%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",y:"\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",yy:"%d \u0cb5\u0cb0\u0ccd\u0cb7"},preparse:function(e){return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g,function(e){return oe[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return me[e]})},meridiemParse:/\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"===a?e<4?e:e+12:"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"===a?e:"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"===a?10<=e?e:e+12:"\u0cb8\u0c82\u0c9c\u0cc6"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf":e<10?"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6":e<17?"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8":e<20?"\u0cb8\u0c82\u0c9c\u0cc6":"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"},dayOfMonthOrdinalParse:/\d{1,2}(\u0ca8\u0cc6\u0cd5)/,ordinal:function(e){return e+"\u0ca8\u0cc6\u0cd5"},week:{dow:0,doy:6}}),e.defineLocale("ko",{months:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),monthsShort:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),weekdays:"\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split("_"),weekdaysShort:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),weekdaysMin:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY\ub144 MMMM D\uc77c",LLL:"YYYY\ub144 MMMM D\uc77c A h:mm",LLLL:"YYYY\ub144 MMMM D\uc77c dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY\ub144 MMMM D\uc77c",lll:"YYYY\ub144 MMMM D\uc77c A h:mm",llll:"YYYY\ub144 MMMM D\uc77c dddd A h:mm"},calendar:{sameDay:"\uc624\ub298 LT",nextDay:"\ub0b4\uc77c LT",nextWeek:"dddd LT",lastDay:"\uc5b4\uc81c LT",lastWeek:"\uc9c0\ub09c\uc8fc dddd LT",sameElse:"L"},relativeTime:{future:"%s \ud6c4",past:"%s \uc804",s:"\uba87 \ucd08",ss:"%d\ucd08",m:"1\ubd84",mm:"%d\ubd84",h:"\ud55c \uc2dc\uac04",hh:"%d\uc2dc\uac04",d:"\ud558\ub8e8",dd:"%d\uc77c",M:"\ud55c \ub2ec",MM:"%d\ub2ec",y:"\uc77c \ub144",yy:"%d\ub144"},dayOfMonthOrdinalParse:/\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\uc77c";case"M":return e+"\uc6d4";case"w":case"W":return e+"\uc8fc";default:return e}},meridiemParse:/\uc624\uc804|\uc624\ud6c4/,isPM:function(e){return"\uc624\ud6c4"===e},meridiem:function(e,a,_){return e<12?"\uc624\uc804":"\uc624\ud6c4"}});var ue={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},le={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},Me=["\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0634\u0648\u0628\u0627\u062a","\u0626\u0627\u0632\u0627\u0631","\u0646\u06cc\u0633\u0627\u0646","\u0626\u0627\u06cc\u0627\u0631","\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646","\u062a\u06d5\u0645\u0645\u0648\u0632","\u0626\u0627\u0628","\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644","\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645","\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645"];e.defineLocale("ku",{months:Me,monthsShort:Me,weekdays:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysShort:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,isPM:function(e){return/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e)},meridiem:function(e,a,_){return e<12?"\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc":"\u0626\u06ce\u0648\u0627\u0631\u0647\u200c"},calendar:{sameDay:"[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextDay:"[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastDay:"[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",sameElse:"L"},relativeTime:{future:"\u0644\u0647\u200c %s",past:"%s",s:"\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",ss:"\u0686\u0631\u0643\u0647\u200c %d",m:"\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",mm:"%d \u062e\u0648\u0644\u0647\u200c\u0643",h:"\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",hh:"%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",d:"\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",dd:"%d \u0695\u06c6\u0698",M:"\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",MM:"%d \u0645\u0627\u0646\u06af",y:"\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",yy:"%d \u0633\u0627\u06b5"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return le[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return ue[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}});var Le={0:"-\u0447\u04af",1:"-\u0447\u0438",2:"-\u0447\u0438",3:"-\u0447\u04af",4:"-\u0447\u04af",5:"-\u0447\u0438",6:"-\u0447\u044b",7:"-\u0447\u0438",8:"-\u0447\u0438",9:"-\u0447\u0443",10:"-\u0447\u0443",20:"-\u0447\u044b",30:"-\u0447\u0443",40:"-\u0447\u044b",50:"-\u0447\u04af",60:"-\u0447\u044b",70:"-\u0447\u0438",80:"-\u0447\u0438",90:"-\u0447\u0443",100:"-\u0447\u04af"};function Ye(e,a,_,s){var d={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?d[_][0]:d[_][1]}function he(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10;return he(0===a?e/10:a)}if(e<1e4){for(;10<=e;)e/=10;return he(e)}return he(e/=1e3)}e.defineLocale("ky",{months:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split("_"),weekdaysShort:"\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split("_"),weekdaysMin:"\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",nextDay:"[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0438\u0447\u0438\u043d\u0434\u0435",past:"%s \u043c\u0443\u0440\u0443\u043d",s:"\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",mm:"%d \u043c\u04af\u043d\u04e9\u0442",h:"\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",hh:"%d \u0441\u0430\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0438\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0438\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,ordinal:function(e){return e+(Le[e]||Le[e%10]||Le[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("lb",{months:"Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),weekdaysMin:"So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[G\xebschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:function(e){return he(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e},past:function(e){return he(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e},s:"e puer Sekonnen",ss:"%d Sekonnen",m:Ye,mm:"%d Minutten",h:Ye,hh:"%d Stonnen",d:Ye,dd:"%d Deeg",M:Ye,MM:"%d M\xe9int",y:Ye,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("lo",{months:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),monthsShort:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),weekdays:"\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysShort:"\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysMin:"\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,isPM:function(e){return"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"===e},meridiem:function(e,a,_){return e<12?"\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2":"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"},calendar:{sameDay:"[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextDay:"[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastDay:"[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",sameElse:"L"},relativeTime:{future:"\u0ead\u0eb5\u0e81 %s",past:"%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",s:"\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",ss:"%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",m:"1 \u0e99\u0eb2\u0e97\u0eb5",mm:"%d \u0e99\u0eb2\u0e97\u0eb5",h:"1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",hh:"%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",d:"1 \u0ea1\u0eb7\u0ec9",dd:"%d \u0ea1\u0eb7\u0ec9",M:"1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",MM:"%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",y:"1 \u0e9b\u0eb5",yy:"%d \u0e9b\u0eb5"},dayOfMonthOrdinalParse:/(\u0e97\u0eb5\u0ec8)\d{1,2}/,ordinal:function(e){return"\u0e97\u0eb5\u0ec8"+e}});var ye={ss:"sekund\u0117_sekund\u017ei\u0173_sekundes",m:"minut\u0117_minut\u0117s_minut\u0119",mm:"minut\u0117s_minu\u010di\u0173_minutes",h:"valanda_valandos_valand\u0105",hh:"valandos_valand\u0173_valandas",d:"diena_dienos_dien\u0105",dd:"dienos_dien\u0173_dienas",M:"m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",MM:"m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",y:"metai_met\u0173_metus",yy:"metai_met\u0173_metus"};function ce(e,a,_,s){return a?pe(_)[0]:s?pe(_)[1]:pe(_)[2]}function ke(e){return e%10==0||10<e&&e<20}function pe(e){return ye[e].split("_")}function De(e,a,_,s){var d=e+" ";return 1===e?d+ce(0,a,_[0],s):a?d+(ke(e)?pe(_)[1]:pe(_)[0]):s?d+pe(_)[1]:d+(ke(e)?pe(_)[1]:pe(_)[2])}e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),weekdaysMin:"S_P_A_T_K_Pn_\u0160".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[\u0160iandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Pra\u0117jus\u012f] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prie\u0161 %s",s:function(e,a,_,s){return a?"kelios sekund\u0117s":s?"keli\u0173 sekund\u017ei\u0173":"kelias sekundes"},ss:De,m:ce,mm:De,h:ce,hh:De,d:ce,dd:De,M:ce,MM:De,y:ce,yy:De},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});var Te={ss:"sekundes_sekund\u0113m_sekunde_sekundes".split("_"),m:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),mm:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),h:"stundas_stund\u0101m_stunda_stundas".split("_"),hh:"stundas_stund\u0101m_stunda_stundas".split("_"),d:"dienas_dien\u0101m_diena_dienas".split("_"),dd:"dienas_dien\u0101m_diena_dienas".split("_"),M:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),MM:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};function fe(e,a,_){return _?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function we(e,a,_){return e+" "+fe(Te[_],e,a)}function ge(e,a,_){return fe(Te[_],e,a)}e.defineLocale("lv",{months:"janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),weekdays:"sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[\u0160odien pulksten] LT",nextDay:"[R\u012bt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"p\u0113c %s",past:"pirms %s",s:function(e,a){return a?"da\u017eas sekundes":"da\u017e\u0101m sekund\u0113m"},ss:we,m:ge,mm:we,h:ge,hh:we,d:ge,dd:we,M:ge,MM:we,y:ge,yy:we},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var He={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:2<=e&&e<=4?a[1]:a[2]},translate:function(e,a,_){var s=He.words[_];return 1===_.length?a?s[0]:s[1]:e+" "+He.correctGrammaticalCase(e,s)}};function be(e,a,_,s){switch(_){case"s":return a?"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434":"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";case"ss":return e+(a?" \u0441\u0435\u043a\u0443\u043d\u0434":" \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d");case"m":case"mm":return e+(a?" \u043c\u0438\u043d\u0443\u0442":" \u043c\u0438\u043d\u0443\u0442\u044b\u043d");case"h":case"hh":return e+(a?" \u0446\u0430\u0433":" \u0446\u0430\u0433\u0438\u0439\u043d");case"d":case"dd":return e+(a?" \u04e9\u0434\u04e9\u0440":" \u04e9\u0434\u0440\u0438\u0439\u043d");case"M":case"MM":return e+(a?" \u0441\u0430\u0440":" \u0441\u0430\u0440\u044b\u043d");case"y":case"yy":return e+(a?" \u0436\u0438\u043b":" \u0436\u0438\u043b\u0438\u0439\u043d");default:return e}}e.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedjelje] [u] LT","[pro\u0161log] [ponedjeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srijede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:He.translate,m:He.translate,mm:He.translate,h:He.translate,hh:He.translate,d:"dan",dd:He.translate,M:"mjesec",MM:He.translate,y:"godinu",yy:He.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("mi",{months:"Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),weekdaysShort:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),weekdaysMin:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te h\u0113kona ruarua",ss:"%d h\u0113kona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("mk",{months:"\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split("_"),weekdaysMin:"\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",nextWeek:"[\u0412\u043e] dddd [\u0432\u043e] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";case 1:case 2:case 4:case 5:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u043e\u0441\u043b\u0435 %s",past:"\u043f\u0440\u0435\u0434 %s",s:"\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0438",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,_=e%100;return 0===e?e+"-\u0435\u0432":0===_?e+"-\u0435\u043d":10<_&&_<20?e+"-\u0442\u0438":1===a?e+"-\u0432\u0438":2===a?e+"-\u0440\u0438":7===a||8===a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("ml",{months:"\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split("_"),monthsShort:"\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split("_"),monthsParseExact:!0,weekdays:"\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split("_"),weekdaysShort:"\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split("_"),weekdaysMin:"\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split("_"),longDateFormat:{LT:"A h:mm -\u0d28\u0d41",LTS:"A h:mm:ss -\u0d28\u0d41",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -\u0d28\u0d41",LLLL:"dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41"},calendar:{sameDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",nextDay:"[\u0d28\u0d3e\u0d33\u0d46] LT",nextWeek:"dddd, LT",lastDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",lastWeek:"[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",past:"%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",s:"\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",ss:"%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",m:"\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",mm:"%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",h:"\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",hh:"%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",d:"\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",dd:"%d \u0d26\u0d3f\u0d35\u0d38\u0d02",M:"\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",MM:"%d \u0d2e\u0d3e\u0d38\u0d02",y:"\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",yy:"%d \u0d35\u0d7c\u0d37\u0d02"},meridiemParse:/\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"===a&&4<=e||"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"===a||"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f":e<12?"\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46":e<17?"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d":e<20?"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02":"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"}}),e.defineLocale("mn",{months:"\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split("_"),monthsShort:"1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split("_"),monthsParseExact:!0,weekdays:"\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split("_"),weekdaysShort:"\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split("_"),weekdaysMin:"\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",LLL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",LLLL:"dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm"},meridiemParse:/\u04ae\u04e8|\u04ae\u0425/i,isPM:function(e){return"\u04ae\u0425"===e},meridiem:function(e,a,_){return e<12?"\u04ae\u04e8":"\u04ae\u0425"},calendar:{sameDay:"[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",nextDay:"[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",nextWeek:"[\u0418\u0440\u044d\u0445] dddd LT",lastDay:"[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",lastWeek:"[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",sameElse:"L"},relativeTime:{future:"%s \u0434\u0430\u0440\u0430\u0430",past:"%s \u04e9\u043c\u043d\u04e9",s:be,ss:be,m:be,mm:be,h:be,hh:be,d:be,dd:be,M:be,MM:be,y:be,yy:be},dayOfMonthOrdinalParse:/\d{1,2} \u04e9\u0434\u04e9\u0440/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+" \u04e9\u0434\u04e9\u0440";default:return e}}});var Se={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},ve={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};function je(e,a,_,s){var d="";if(a)switch(_){case"s":d="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";break;case"ss":d="%d \u0938\u0947\u0915\u0902\u0926";break;case"m":d="\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";break;case"mm":d="%d \u092e\u093f\u0928\u093f\u091f\u0947";break;case"h":d="\u090f\u0915 \u0924\u093e\u0938";break;case"hh":d="%d \u0924\u093e\u0938";break;case"d":d="\u090f\u0915 \u0926\u093f\u0935\u0938";break;case"dd":d="%d \u0926\u093f\u0935\u0938";break;case"M":d="\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";break;case"MM":d="%d \u092e\u0939\u093f\u0928\u0947";break;case"y":d="\u090f\u0915 \u0935\u0930\u094d\u0937";break;case"yy":d="%d \u0935\u0930\u094d\u0937\u0947";break}else switch(_){case"s":d="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"ss":d="%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"m":d="\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";break;case"mm":d="%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";break;case"h":d="\u090f\u0915\u093e \u0924\u093e\u0938\u093e";break;case"hh":d="%d \u0924\u093e\u0938\u093e\u0902";break;case"d":d="\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";break;case"dd":d="%d \u0926\u093f\u0935\u0938\u093e\u0902";break;case"M":d="\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";break;case"MM":d="%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";break;case"y":d="\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";break;case"yy":d="%d \u0935\u0930\u094d\u0937\u093e\u0902";break}return d.replace(/%d/i,e)}e.defineLocale("mr",{months:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u0935\u093e\u091c\u0924\u093e",LTS:"A h:mm:ss \u0935\u093e\u091c\u0924\u093e",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",LLLL:"dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0909\u0926\u094d\u092f\u093e] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092e\u093e\u0917\u0940\u0932] dddd, LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u0927\u094d\u092f\u0947",past:"%s\u092a\u0942\u0930\u094d\u0935\u0940",s:je,ss:je,m:je,mm:je,h:je,hh:je,d:je,dd:je,M:je,MM:je,y:je,yy:je},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return ve[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Se[e]})},meridiemParse:/\u0930\u093e\u0924\u094d\u0930\u0940|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u094d\u0930\u0940"===a?e<4?e:e+12:"\u0938\u0915\u093e\u0933\u0940"===a?e:"\u0926\u0941\u092a\u093e\u0930\u0940"===a?10<=e?e:e+12:"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0930\u093e\u0924\u094d\u0930\u0940":e<10?"\u0938\u0915\u093e\u0933\u0940":e<17?"\u0926\u0941\u092a\u093e\u0930\u0940":e<20?"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940":"\u0930\u093e\u0924\u094d\u0930\u0940"},week:{dow:0,doy:6}}),e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),weekdays:"Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),weekdaysShort:"\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),weekdaysMin:"\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[G\u0127ada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-biera\u0127 fil-]LT",lastWeek:"dddd [li g\u0127adda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f\u2019 %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"sieg\u0127a",hh:"%d sieg\u0127at",d:"\u0121urnata",dd:"%d \u0121ranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var xe={1:"\u1041",2:"\u1042",3:"\u1043",4:"\u1044",5:"\u1045",6:"\u1046",7:"\u1047",8:"\u1048",9:"\u1049",0:"\u1040"},Pe={"\u1041":"1","\u1042":"2","\u1043":"3","\u1044":"4","\u1045":"5","\u1046":"6","\u1047":"7","\u1048":"8","\u1049":"9","\u1040":"0"};e.defineLocale("my",{months:"\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split("_"),monthsShort:"\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split("_"),weekdays:"\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split("_"),weekdaysShort:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),weekdaysMin:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",nextDay:"[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",nextWeek:"dddd LT [\u1019\u103e\u102c]",lastDay:"[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",lastWeek:"[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",sameElse:"L"},relativeTime:{future:"\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",past:"\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",s:"\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",ss:"%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",m:"\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",mm:"%d \u1019\u102d\u1014\u1005\u103a",h:"\u1010\u1005\u103a\u1014\u102c\u101b\u102e",hh:"%d \u1014\u102c\u101b\u102e",d:"\u1010\u1005\u103a\u101b\u1000\u103a",dd:"%d \u101b\u1000\u103a",M:"\u1010\u1005\u103a\u101c",MM:"%d \u101c",y:"\u1010\u1005\u103a\u1014\u103e\u1005\u103a",yy:"%d \u1014\u103e\u1005\u103a"},preparse:function(e){return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g,function(e){return Pe[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return xe[e]})},week:{dow:1,doy:4}}),e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var We={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},Ee={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};e.defineLocale("ne",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split("_"),weekdaysShort:"\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split("_"),weekdaysMin:"\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A\u0915\u094b h:mm \u092c\u091c\u0947",LTS:"A\u0915\u094b h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return Ee[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return We[e]})},meridiemParse:/\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u093f"===a?e<4?e:e+12:"\u092c\u093f\u0939\u093e\u0928"===a?e:"\u0926\u093f\u0909\u0901\u0938\u094b"===a?10<=e?e:e+12:"\u0938\u093e\u0901\u091d"===a?e+12:void 0},meridiem:function(e,a,_){return e<3?"\u0930\u093e\u0924\u093f":e<12?"\u092c\u093f\u0939\u093e\u0928":e<16?"\u0926\u093f\u0909\u0901\u0938\u094b":e<20?"\u0938\u093e\u0901\u091d":"\u0930\u093e\u0924\u093f"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u092d\u094b\u0932\u093f] LT",nextWeek:"[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",lastDay:"[\u0939\u093f\u091c\u094b] LT",lastWeek:"[\u0917\u090f\u0915\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u093e",past:"%s \u0905\u0917\u093e\u0921\u093f",s:"\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",mm:"%d \u092e\u093f\u0928\u0947\u091f",h:"\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",hh:"%d \u0918\u0923\u094d\u091f\u093e",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",MM:"%d \u092e\u0939\u093f\u0928\u093e",y:"\u090f\u0915 \u092c\u0930\u094d\u0937",yy:"%d \u092c\u0930\u094d\u0937"},week:{dow:0,doy:6}});var Ae="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),Oe="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),Fe=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],ze=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Oe[e.month()]:Ae[e.month()]:Ae},monthsRegex:ze,monthsShortRegex:ze,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:Fe,longMonthsParse:Fe,shortMonthsParse:Fe,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}});var Je="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),Ie="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),Ne=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],Re=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Ie[e.month()]:Je[e.month()]:Je},monthsRegex:Re,monthsShortRegex:Re,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:Ne,longMonthsParse:Ne,shortMonthsParse:Ne,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_m\xe5n_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_m\xe5_ty_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I g\xe5r klokka] LT",lastWeek:"[F\xf8reg\xe5ande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein m\xe5nad",MM:"%d m\xe5nader",y:"eit \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var Ke={1:"\u0a67",2:"\u0a68",3:"\u0a69",4:"\u0a6a",5:"\u0a6b",6:"\u0a6c",7:"\u0a6d",8:"\u0a6e",9:"\u0a6f",0:"\u0a66"},Ce={"\u0a67":"1","\u0a68":"2","\u0a69":"3","\u0a6a":"4","\u0a6b":"5","\u0a6c":"6","\u0a6d":"7","\u0a6e":"8","\u0a6f":"9","\u0a66":"0"};e.defineLocale("pa-in",{months:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),monthsShort:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),weekdays:"\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split("_"),weekdaysShort:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),weekdaysMin:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),longDateFormat:{LT:"A h:mm \u0a35\u0a1c\u0a47",LTS:"A h:mm:ss \u0a35\u0a1c\u0a47",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",LLLL:"dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47"},calendar:{sameDay:"[\u0a05\u0a1c] LT",nextDay:"[\u0a15\u0a32] LT",nextWeek:"[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",lastDay:"[\u0a15\u0a32] LT",lastWeek:"[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0a35\u0a3f\u0a71\u0a1a",past:"%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",s:"\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",ss:"%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",m:"\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",mm:"%d \u0a2e\u0a3f\u0a70\u0a1f",h:"\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",hh:"%d \u0a18\u0a70\u0a1f\u0a47",d:"\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",dd:"%d \u0a26\u0a3f\u0a28",M:"\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",MM:"%d \u0a2e\u0a39\u0a40\u0a28\u0a47",y:"\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",yy:"%d \u0a38\u0a3e\u0a32"},preparse:function(e){return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g,function(e){return Ce[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ke[e]})},meridiemParse:/\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0a30\u0a3e\u0a24"===a?e<4?e:e+12:"\u0a38\u0a35\u0a47\u0a30"===a?e:"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"===a?10<=e?e:e+12:"\u0a38\u0a3c\u0a3e\u0a2e"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0a30\u0a3e\u0a24":e<10?"\u0a38\u0a35\u0a47\u0a30":e<17?"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30":e<20?"\u0a38\u0a3c\u0a3e\u0a2e":"\u0a30\u0a3e\u0a24"},week:{dow:0,doy:6}});var Ge="stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split("_"),Be="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split("_");function qe(e){return e%10<5&&1<e%10&&~~(e/10)%10!=1}function $e(e,a,_){var s=e+" ";switch(_){case"ss":return s+(qe(e)?"sekundy":"sekund");case"m":return a?"minuta":"minut\u0119";case"mm":return s+(qe(e)?"minuty":"minut");case"h":return a?"godzina":"godzin\u0119";case"hh":return s+(qe(e)?"godziny":"godzin");case"MM":return s+(qe(e)?"miesi\u0105ce":"miesi\u0119cy");case"yy":return s+(qe(e)?"lata":"lat")}}function Ue(e,a,_){var s=" ";return(20<=e%100||100<=e&&e%100==0)&&(s=" de "),e+s+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"}[_]}function Qe(e,a,_){var s,d;return"m"===_?a?"\u043c\u0438\u043d\u0443\u0442\u0430":"\u043c\u0438\u043d\u0443\u0442\u0443":e+" "+(s=+e,d={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442":"\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",hh:"\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",yy:"\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442"}[_].split("_"),s%10==1&&s%100!=11?d[0]:2<=s%10&&s%10<=4&&(s%100<10||20<=s%100)?d[1]:d[2])}e.defineLocale("pl",{months:function(e,a){return e?""===a?"("+Be[e.month()]+"|"+Ge[e.month()]+")":/D MMMM/.test(a)?Be[e.month()]:Ge[e.month()]:Ge},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),weekdays:"niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_\u015br_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dzi\u015b o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedziel\u0119 o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W \u015brod\u0119 o] LT";case 6:return"[W sobot\u0119 o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zesz\u0142\u0105 niedziel\u0119 o] LT";case 3:return"[W zesz\u0142\u0105 \u015brod\u0119 o] LT";case 6:return"[W zesz\u0142\u0105 sobot\u0119 o] LT";default:return"[W zesz\u0142y] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:$e,m:$e,mm:$e,h:$e,hh:$e,d:"1 dzie\u0144",dd:"%d dni",M:"miesi\u0105c",MM:$e,y:"rok",yy:$e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("pt-br",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [\xe0s] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba"}),e.defineLocale("pt",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[m\xe2ine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s \xeen urm\u0103",s:"c\xe2teva secunde",ss:Ue,m:"un minut",mm:Ue,h:"o or\u0103",hh:Ue,d:"o zi",dd:Ue,M:"o lun\u0103",MM:Ue,y:"un an",yy:Ue},week:{dow:1,doy:7}});var Ve=[/^\u044f\u043d\u0432/i,/^\u0444\u0435\u0432/i,/^\u043c\u0430\u0440/i,/^\u0430\u043f\u0440/i,/^\u043c\u0430[\u0439\u044f]/i,/^\u0438\u044e\u043d/i,/^\u0438\u044e\u043b/i,/^\u0430\u0432\u0433/i,/^\u0441\u0435\u043d/i,/^\u043e\u043a\u0442/i,/^\u043d\u043e\u044f/i,/^\u0434\u0435\u043a/i];e.defineLocale("ru",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_")},monthsShort:{format:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_"),standalone:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_")},weekdays:{standalone:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split("_"),format:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split("_"),isFormat:/\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?\] ?dddd/},weekdaysShort:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),monthsParse:Ve,longMonthsParse:Ve,shortMonthsParse:Ve,monthsRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsShortRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsStrictRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,monthsShortStrictRegex:/^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., H:mm",LLLL:"dddd, D MMMM YYYY \u0433., H:mm"},calendar:{sameDay:"[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",nextDay:"[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0447\u0435\u0440\u0435\u0437 %s",past:"%s \u043d\u0430\u0437\u0430\u0434",s:"\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",ss:Qe,m:Qe,mm:Qe,h:"\u0447\u0430\u0441",hh:Qe,d:"\u0434\u0435\u043d\u044c",dd:Qe,M:"\u043c\u0435\u0441\u044f\u0446",MM:Qe,y:"\u0433\u043e\u0434",yy:Qe},meridiemParse:/\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u0438":e<12?"\u0443\u0442\u0440\u0430":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0435\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-\u0439";case"D":return e+"-\u0433\u043e";case"w":case"W":return e+"-\u044f";default:return e}},week:{dow:1,doy:4}});var Ze=["\u062c\u0646\u0648\u0631\u064a","\u0641\u064a\u0628\u0631\u0648\u0631\u064a","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u064a\u0644","\u0645\u0626\u064a","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0621\u0650","\u0622\u06af\u0633\u067d","\u0633\u064a\u067e\u067d\u0645\u0628\u0631","\u0622\u06aa\u067d\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u068a\u0633\u0645\u0628\u0631"],Xe=["\u0622\u0686\u0631","\u0633\u0648\u0645\u0631","\u0627\u06b1\u0627\u0631\u0648","\u0627\u0631\u0628\u0639","\u062e\u0645\u064a\u0633","\u062c\u0645\u0639","\u0687\u0646\u0687\u0631"];e.defineLocale("sd",{months:Ze,monthsShort:Ze,weekdays:Xe,weekdaysShort:Xe,weekdaysMin:Xe,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0627\u0684] LT",nextDay:"[\u0633\u0680\u0627\u06bb\u064a] LT",nextWeek:"dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",lastDay:"[\u06aa\u0627\u0644\u0647\u0647] LT",lastWeek:"[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",sameElse:"L"},relativeTime:{future:"%s \u067e\u0648\u0621",past:"%s \u0627\u06b3",s:"\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",ss:"%d \u0633\u064a\u06aa\u0646\u068a",m:"\u0647\u06aa \u0645\u0646\u067d",mm:"%d \u0645\u0646\u067d",h:"\u0647\u06aa \u06aa\u0644\u0627\u06aa",hh:"%d \u06aa\u0644\u0627\u06aa",d:"\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",dd:"%d \u068f\u064a\u0646\u0647\u0646",M:"\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",MM:"%d \u0645\u0647\u064a\u0646\u0627",y:"\u0647\u06aa \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("se",{months:"o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),monthsShort:"o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),weekdays:"sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),weekdaysShort:"sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s gea\u017ees",past:"ma\u014bit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta m\xe1nnu",MM:"%d m\xe1nut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("si",{months:"\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split("_"),monthsShort:"\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split("_"),weekdays:"\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split("_"),weekdaysShort:"\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split("_"),weekdaysMin:"\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss"},calendar:{sameDay:"[\u0d85\u0daf] LT[\u0da7]",nextDay:"[\u0dc4\u0dd9\u0da7] LT[\u0da7]",nextWeek:"dddd LT[\u0da7]",lastDay:"[\u0d8a\u0dba\u0dda] LT[\u0da7]",lastWeek:"[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",sameElse:"L"},relativeTime:{future:"%s\u0d9a\u0dd2\u0db1\u0dca",past:"%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",s:"\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",ss:"\u0dad\u0dad\u0dca\u0db4\u0dbb %d",m:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",mm:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",h:"\u0db4\u0dd0\u0dba",hh:"\u0db4\u0dd0\u0dba %d",d:"\u0daf\u0dd2\u0db1\u0dba",dd:"\u0daf\u0dd2\u0db1 %d",M:"\u0db8\u0dcf\u0dc3\u0dba",MM:"\u0db8\u0dcf\u0dc3 %d",y:"\u0dc0\u0dc3\u0dbb",yy:"\u0dc0\u0dc3\u0dbb %d"},dayOfMonthOrdinalParse:/\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,ordinal:function(e){return e+" \u0dc0\u0dd0\u0db1\u0dd2"},meridiemParse:/\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,isPM:function(e){return"\u0db4.\u0dc0."===e||"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"===e},meridiem:function(e,a,_){return 11<e?_?"\u0db4.\u0dc0.":"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4":_?"\u0db4\u0dd9.\u0dc0.":"\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4"}});var ea="janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"),aa="jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");function _a(e){return 1<e&&e<5}function sa(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"p\xe1r sek\xfand":"p\xe1r sekundami";case"ss":return a||s?d+(_a(e)?"sekundy":"sek\xfand"):d+"sekundami";break;case"m":return a?"min\xfata":s?"min\xfatu":"min\xfatou";case"mm":return a||s?d+(_a(e)?"min\xfaty":"min\xfat"):d+"min\xfatami";break;case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?d+(_a(e)?"hodiny":"hod\xedn"):d+"hodinami";break;case"d":return a||s?"de\u0148":"d\u0148om";case"dd":return a||s?d+(_a(e)?"dni":"dn\xed"):d+"d\u0148ami";break;case"M":return a||s?"mesiac":"mesiacom";case"MM":return a||s?d+(_a(e)?"mesiace":"mesiacov"):d+"mesiacmi";break;case"y":return a||s?"rok":"rokom";case"yy":return a||s?d+(_a(e)?"roky":"rokov"):d+"rokmi";break}}function da(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"nekaj sekund":"nekaj sekundami";case"ss":return d+=1===e?a?"sekundo":"sekundi":2===e?a||s?"sekundi":"sekundah":e<5?a||s?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return d+=1===e?a?"minuta":"minuto":2===e?a||s?"minuti":"minutama":e<5?a||s?"minute":"minutami":a||s?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return d+=1===e?a?"ura":"uro":2===e?a||s?"uri":"urama":e<5?a||s?"ure":"urami":a||s?"ur":"urami";case"d":return a||s?"en dan":"enim dnem";case"dd":return d+=1===e?a||s?"dan":"dnem":2===e?a||s?"dni":"dnevoma":a||s?"dni":"dnevi";case"M":return a||s?"en mesec":"enim mesecem";case"MM":return d+=1===e?a||s?"mesec":"mesecem":2===e?a||s?"meseca":"mesecema":e<5?a||s?"mesece":"meseci":a||s?"mesecev":"meseci";case"y":return a||s?"eno leto":"enim letom";case"yy":return d+=1===e?a||s?"leto":"letom":2===e?a||s?"leti":"letoma":e<5?a||s?"leta":"leti":a||s?"let":"leti"}}e.defineLocale("sk",{months:ea,monthsShort:aa,weekdays:"nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_\u0161t_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_\u0161t_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nede\u013eu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo \u0161tvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[v\u010dera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minul\xfa nede\u013eu o] LT";case 1:case 2:return"[minul\xfd] dddd [o] LT";case 3:return"[minul\xfa stredu o] LT";case 4:case 5:return"[minul\xfd] dddd [o] LT";case 6:return"[minul\xfa sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:sa,ss:sa,m:sa,mm:sa,h:sa,hh:sa,d:sa,dd:sa,M:sa,MM:sa,y:sa,yy:sa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._\u010det._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_\u010de_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[v\u010deraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prej\u0161njo] [nedeljo] [ob] LT";case 3:return"[prej\u0161njo] [sredo] [ob] LT";case 6:return"[prej\u0161njo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prej\u0161nji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"\u010dez %s",past:"pred %s",s:da,ss:da,m:da,mm:da,h:da,hh:da,d:da,dd:da,M:da,MM:da,y:da,yy:da},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),weekdays:"E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),weekdaysShort:"Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_M\xeb_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,_){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot n\xeb] LT",nextDay:"[Nes\xebr n\xeb] LT",nextWeek:"dddd [n\xeb] LT",lastDay:"[Dje n\xeb] LT",lastWeek:"dddd [e kaluar n\xeb] LT",sameElse:"L"},relativeTime:{future:"n\xeb %s",past:"%s m\xeb par\xeb",s:"disa sekonda",ss:"%d sekonda",m:"nj\xeb minut\xeb",mm:"%d minuta",h:"nj\xeb or\xeb",hh:"%d or\xeb",d:"nj\xeb dit\xeb",dd:"%d dit\xeb",M:"nj\xeb muaj",MM:"%d muaj",y:"nj\xeb vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var ta={words:{ss:["\u0441\u0435\u043a\u0443\u043d\u0434\u0430","\u0441\u0435\u043a\u0443\u043d\u0434\u0435","\u0441\u0435\u043a\u0443\u043d\u0434\u0438"],m:["\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442","\u0458\u0435\u0434\u043d\u0435 \u043c\u0438\u043d\u0443\u0442\u0435"],mm:["\u043c\u0438\u043d\u0443\u0442","\u043c\u0438\u043d\u0443\u0442\u0435","\u043c\u0438\u043d\u0443\u0442\u0430"],h:["\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430"],hh:["\u0441\u0430\u0442","\u0441\u0430\u0442\u0430","\u0441\u0430\u0442\u0438"],dd:["\u0434\u0430\u043d","\u0434\u0430\u043d\u0430","\u0434\u0430\u043d\u0430"],MM:["\u043c\u0435\u0441\u0435\u0446","\u043c\u0435\u0441\u0435\u0446\u0430","\u043c\u0435\u0441\u0435\u0446\u0438"],yy:["\u0433\u043e\u0434\u0438\u043d\u0430","\u0433\u043e\u0434\u0438\u043d\u0435","\u0433\u043e\u0434\u0438\u043d\u0430"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:2<=e&&e<=4?a[1]:a[2]},translate:function(e,a,_){var s=ta.words[_];return 1===_.length?a?s[0]:s[1]:e+" "+ta.correctGrammaticalCase(e,s)}};e.defineLocale("sr-cyrl",{months:"\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split("_"),monthsShort:"\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split("_"),monthsParseExact:!0,weekdays:"\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split("_"),weekdaysMin:"\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",nextDay:"[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",nextWeek:function(){switch(this.day()){case 0:return"[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";case 3:return"[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";case 6:return"[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";case 1:case 2:case 4:case 5:return"[\u0443] dddd [\u0443] LT"}},lastDay:"[\u0458\u0443\u0447\u0435 \u0443] LT",lastWeek:function(){return["[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435 %s",s:"\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:ta.translate,m:ta.translate,mm:ta.translate,h:ta.translate,hh:ta.translate,d:"\u0434\u0430\u043d",dd:ta.translate,M:"\u043c\u0435\u0441\u0435\u0446",MM:ta.translate,y:"\u0433\u043e\u0434\u0438\u043d\u0443",yy:ta.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var na={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:2<=e&&e<=4?a[1]:a[2]},translate:function(e,a,_){var s=na.words[_];return 1===_.length?a?s[0]:s[1]:e+" "+na.correctGrammaticalCase(e,s)}};e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedelje] [u] LT","[pro\u0161log] [ponedeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:na.translate,m:na.translate,mm:na.translate,h:na.translate,hh:na.translate,d:"dan",dd:na.translate,M:"mesec",MM:na.translate,y:"godinu",yy:na.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,a,_){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,a){return 12===e&&(e=0),"ekuseni"===a?e:"emini"===a?11<=e?e:e+12:"entsambama"===a||"ebusuku"===a?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}}),e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),weekdaysShort:"s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),weekdaysMin:"s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Ig\xe5r] LT",nextWeek:"[P\xe5] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"f\xf6r %s sedan",s:"n\xe5gra sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en m\xe5nad",MM:"%d m\xe5nader",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"e":1===a?"a":2===a?"a":"e")},week:{dow:1,doy:4}}),e.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"masiku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}});var ra={1:"\u0be7",2:"\u0be8",3:"\u0be9",4:"\u0bea",5:"\u0beb",6:"\u0bec",7:"\u0bed",8:"\u0bee",9:"\u0bef",0:"\u0be6"},ia={"\u0be7":"1","\u0be8":"2","\u0be9":"3","\u0bea":"4","\u0beb":"5","\u0bec":"6","\u0bed":"7","\u0bee":"8","\u0bef":"9","\u0be6":"0"};e.defineLocale("ta",{months:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),monthsShort:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),weekdays:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split("_"),weekdaysShort:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split("_"),weekdaysMin:"\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",nextDay:"[\u0ba8\u0bbe\u0bb3\u0bc8] LT",nextWeek:"dddd, LT",lastDay:"[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",lastWeek:"[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0b87\u0bb2\u0bcd",past:"%s \u0bae\u0bc1\u0ba9\u0bcd",s:"\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",ss:"%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",m:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",mm:"%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",h:"\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",hh:"%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",d:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",dd:"%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",M:"\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",MM:"%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",y:"\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",yy:"%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd"},dayOfMonthOrdinalParse:/\d{1,2}\u0bb5\u0ba4\u0bc1/,ordinal:function(e){return e+"\u0bb5\u0ba4\u0bc1"},preparse:function(e){return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g,function(e){return ia[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return ra[e]})},meridiemParse:/\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,meridiem:function(e,a,_){return e<2?" \u0baf\u0bbe\u0bae\u0bae\u0bcd":e<6?" \u0bb5\u0bc8\u0b95\u0bb1\u0bc8":e<10?" \u0b95\u0bbe\u0bb2\u0bc8":e<14?" \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd":e<18?" \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1":e<22?" \u0bae\u0bbe\u0bb2\u0bc8":" \u0baf\u0bbe\u0bae\u0bae\u0bcd"},meridiemHour:function(e,a){return 12===e&&(e=0),"\u0baf\u0bbe\u0bae\u0bae\u0bcd"===a?e<2?e:e+12:"\u0bb5\u0bc8\u0b95\u0bb1\u0bc8"===a||"\u0b95\u0bbe\u0bb2\u0bc8"===a?e:"\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"===a&&10<=e?e:e+12},week:{dow:0,doy:6}}),e.defineLocale("te",{months:"\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c42\u0c32\u0c46\u0c56_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split("_"),monthsShort:"\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c42\u0c32\u0c46\u0c56_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split("_"),monthsParseExact:!0,weekdays:"\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split("_"),weekdaysShort:"\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split("_"),weekdaysMin:"\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c28\u0c47\u0c21\u0c41] LT",nextDay:"[\u0c30\u0c47\u0c2a\u0c41] LT",nextWeek:"dddd, LT",lastDay:"[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",lastWeek:"[\u0c17\u0c24] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0c32\u0c4b",past:"%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",s:"\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",ss:"%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",m:"\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",mm:"%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",h:"\u0c12\u0c15 \u0c17\u0c02\u0c1f",hh:"%d \u0c17\u0c02\u0c1f\u0c32\u0c41",d:"\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",dd:"%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",M:"\u0c12\u0c15 \u0c28\u0c46\u0c32",MM:"%d \u0c28\u0c46\u0c32\u0c32\u0c41",y:"\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",yy:"%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41"},dayOfMonthOrdinalParse:/\d{1,2}\u0c35/,ordinal:"%d\u0c35",meridiemParse:/\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"===a?e<4?e:e+12:"\u0c09\u0c26\u0c2f\u0c02"===a?e:"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"===a?10<=e?e:e+12:"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f":e<10?"\u0c09\u0c26\u0c2f\u0c02":e<17?"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02":e<20?"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02":"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"},week:{dow:0,doy:6}}),e.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"minutu balun",ss:"minutu %d",m:"minutu ida",mm:"minutu %d",h:"oras ida",hh:"oras %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}});var ma={0:"-\u0443\u043c",1:"-\u0443\u043c",2:"-\u044e\u043c",3:"-\u044e\u043c",4:"-\u0443\u043c",5:"-\u0443\u043c",6:"-\u0443\u043c",7:"-\u0443\u043c",8:"-\u0443\u043c",9:"-\u0443\u043c",10:"-\u0443\u043c",12:"-\u0443\u043c",13:"-\u0443\u043c",20:"-\u0443\u043c",30:"-\u044e\u043c",40:"-\u0443\u043c",50:"-\u0443\u043c",60:"-\u0443\u043c",70:"-\u0443\u043c",80:"-\u0443\u043c",90:"-\u0443\u043c",100:"-\u0443\u043c"};e.defineLocale("tg",{months:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split("_"),weekdaysShort:"\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split("_"),weekdaysMin:"\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextDay:"[\u041f\u0430\u0433\u043e\u04b3 \u0441\u043e\u0430\u0442\u0438] LT",lastDay:"[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",lastWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",sameElse:"L"},relativeTime:{future:"\u0431\u0430\u044a\u0434\u0438 %s",past:"%s \u043f\u0435\u0448",s:"\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",m:"\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",mm:"%d \u0434\u0430\u049b\u0438\u049b\u0430",h:"\u044f\u043a \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u044f\u043a \u0440\u04ef\u0437",dd:"%d \u0440\u04ef\u0437",M:"\u044f\u043a \u043c\u043e\u04b3",MM:"%d \u043c\u043e\u04b3",y:"\u044f\u043a \u0441\u043e\u043b",yy:"%d \u0441\u043e\u043b"},meridiemParse:/\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0448\u0430\u0431"===a?e<4?e:e+12:"\u0441\u0443\u0431\u04b3"===a?e:"\u0440\u04ef\u0437"===a?11<=e?e:e+12:"\u0431\u0435\u0433\u043e\u04b3"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0448\u0430\u0431":e<11?"\u0441\u0443\u0431\u04b3":e<16?"\u0440\u04ef\u0437":e<19?"\u0431\u0435\u0433\u043e\u04b3":"\u0448\u0430\u0431"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0443\u043c|\u044e\u043c)/,ordinal:function(e){return e+(ma[e]||ma[e%10]||ma[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("th",{months:"\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split("_"),monthsShort:"\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split("_"),monthsParseExact:!0,weekdays:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysShort:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysMin:"\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",LLLL:"\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm"},meridiemParse:/\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,isPM:function(e){return"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"===e},meridiem:function(e,a,_){return e<12?"\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07":"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"},calendar:{sameDay:"[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextDay:"[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextWeek:"dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",lastDay:"[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",lastWeek:"[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",sameElse:"L"},relativeTime:{future:"\u0e2d\u0e35\u0e01 %s",past:"%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",s:"\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",ss:"%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",m:"1 \u0e19\u0e32\u0e17\u0e35",mm:"%d \u0e19\u0e32\u0e17\u0e35",h:"1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",hh:"%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",d:"1 \u0e27\u0e31\u0e19",dd:"%d \u0e27\u0e31\u0e19",M:"1 \u0e40\u0e14\u0e37\u0e2d\u0e19",MM:"%d \u0e40\u0e14\u0e37\u0e2d\u0e19",y:"1 \u0e1b\u0e35",yy:"%d \u0e1b\u0e35"}}),e.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});var oa="pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");function ua(e,a,_,s){var d=function(e){var a=Math.floor(e%1e3/100),_=Math.floor(e%100/10),s=e%10,d="";0<a&&(d+=oa[a]+"vatlh");0<_&&(d+=(""!==d?" ":"")+oa[_]+"maH");0<s&&(d+=(""!==d?" ":"")+oa[s]);return""===d?"pagh":d}(e);switch(_){case"ss":return d+" lup";case"mm":return d+" tup";case"hh":return d+" rep";case"dd":return d+" jaj";case"MM":return d+" jar";case"yy":return d+" DIS"}}e.defineLocale("tlh",{months:"tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),monthsShort:"jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa\u2019leS] LT",nextWeek:"LLL",lastDay:"[wa\u2019Hu\u2019] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"leS":-1!==e.indexOf("jar")?a.slice(0,-3)+"waQ":-1!==e.indexOf("DIS")?a.slice(0,-3)+"nem":a+" pIq"},past:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"Hu\u2019":-1!==e.indexOf("jar")?a.slice(0,-3)+"wen":-1!==e.indexOf("DIS")?a.slice(0,-3)+"ben":a+" ret"},s:"puS lup",ss:ua,m:"wa\u2019 tup",mm:ua,h:"wa\u2019 rep",hh:ua,d:"wa\u2019 jaj",dd:ua,M:"wa\u2019 jar",MM:ua,y:"wa\u2019 DIS",yy:ua},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var la={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'\xfcnc\xfc",4:"'\xfcnc\xfc",100:"'\xfcnc\xfc",6:"'nc\u0131",9:"'uncu",10:"'uncu",30:"'uncu",60:"'\u0131nc\u0131",90:"'\u0131nc\u0131"};function Ma(e,a,_,s){var d={s:["viensas secunds","'iensas secunds"],ss:[e+" secunds",e+" secunds"],m:["'n m\xedut","'iens m\xedut"],mm:[e+" m\xeduts",e+" m\xeduts"],h:["'n \xfeora","'iensa \xfeora"],hh:[e+" \xfeoras",e+" \xfeoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",e+" ars"]};return s?d[_][0]:a?d[_][0]:d[_][1]}function La(e,a,_){var s,d;return"m"===_?a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443":"h"===_?a?"\u0433\u043e\u0434\u0438\u043d\u0430":"\u0433\u043e\u0434\u0438\u043d\u0443":e+" "+(s=+e,d={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",hh:a?"\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d":"\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",MM:"\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",yy:"\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432"}[_].split("_"),s%10==1&&s%100!=11?d[0]:2<=s%10&&s%10<=4&&(s%100<10||20<=s%100)?d[1]:d[2])}function Ya(e){return function(){return e+"\u043e"+(11===this.hours()?"\u0431":"")+"] LT"}}e.defineLocale("tr",{months:"Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),monthsShort:"Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_\xc7ar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[yar\u0131n saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[d\xfcn] LT",lastWeek:"[ge\xe7en] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \xf6nce",s:"birka\xe7 saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir y\u0131l",yy:"%d y\u0131l"},ordinal:function(e,a){switch(a){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'\u0131nc\u0131";var _=e%10;return e+(la[_]||la[e%100-_]||la[100<=e?100:null])}},week:{dow:1,doy:7}}),e.defineLocale("tzl",{months:"Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),weekdaysShort:"S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),weekdaysMin:"S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,a,_){return 11<e?_?"d'o":"D'O":_?"d'a":"D'A"},calendar:{sameDay:"[oxhi \xe0] LT",nextDay:"[dem\xe0 \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[ieiri \xe0] LT",lastWeek:"[s\xfcr el] dddd [lasteu \xe0] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:Ma,ss:Ma,m:Ma,mm:Ma,h:Ma,hh:Ma,d:Ma,dd:Ma,M:Ma,MM:Ma,y:Ma,yy:Ma},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("tzm-latn",{months:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minu\u1e0d",mm:"%d minu\u1e0d",h:"sa\u025ba",hh:"%d tassa\u025bin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}}),e.defineLocale("tzm",{months:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),monthsShort:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),weekdays:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysShort:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysMin:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",nextDay:"[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",nextWeek:"dddd [\u2d34] LT",lastDay:"[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",lastWeek:"dddd [\u2d34] LT",sameElse:"L"},relativeTime:{future:"\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",past:"\u2d62\u2d30\u2d4f %s",s:"\u2d49\u2d4e\u2d49\u2d3d",ss:"%d \u2d49\u2d4e\u2d49\u2d3d",m:"\u2d4e\u2d49\u2d4f\u2d53\u2d3a",mm:"%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",h:"\u2d59\u2d30\u2d44\u2d30",hh:"%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",d:"\u2d30\u2d59\u2d59",dd:"%d o\u2d59\u2d59\u2d30\u2d4f",M:"\u2d30\u2d62o\u2d53\u2d54",MM:"%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",y:"\u2d30\u2d59\u2d33\u2d30\u2d59",yy:"%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f"},week:{dow:6,doy:12}}),e.defineLocale("ug-cn",{months:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),monthsShort:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),weekdays:"\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split("_"),weekdaysShort:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),weekdaysMin:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",LLL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",LLLL:"dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm"},meridiemParse:/\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5"===a||"\u0633\u06d5\u06be\u06d5\u0631"===a||"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646"===a?e:"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646"===a||"\u0643\u06d5\u0686"===a?e+12:11<=e?e:e+12},meridiem:function(e,a,_){var s=100*e+a;return s<600?"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5":s<900?"\u0633\u06d5\u06be\u06d5\u0631":s<1130?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646":s<1230?"\u0686\u06c8\u0634":s<1800?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646":"\u0643\u06d5\u0686"},calendar:{sameDay:"[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",nextDay:"[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",nextWeek:"[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",lastDay:"[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",lastWeek:"[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0643\u06d0\u064a\u0649\u0646",past:"%s \u0628\u06c7\u0631\u06c7\u0646",s:"\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",ss:"%d \u0633\u06d0\u0643\u0648\u0646\u062a",m:"\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",mm:"%d \u0645\u0649\u0646\u06c7\u062a",h:"\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",hh:"%d \u0633\u0627\u0626\u06d5\u062a",d:"\u0628\u0649\u0631 \u0643\u06c8\u0646",dd:"%d \u0643\u06c8\u0646",M:"\u0628\u0649\u0631 \u0626\u0627\u064a",MM:"%d \u0626\u0627\u064a",y:"\u0628\u0649\u0631 \u064a\u0649\u0644",yy:"%d \u064a\u0649\u0644"},dayOfMonthOrdinalParse:/\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"-\u0643\u06c8\u0646\u0649";case"w":case"W":return e+"-\u06be\u06d5\u067e\u062a\u06d5";default:return e}},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:7}}),e.defineLocale("uk",{months:{format:"\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split("_"),standalone:"\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split("_")},monthsShort:"\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),weekdays:function(e,a){var _={nominative:"\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),accusative:"\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),genitive:"\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split("_")};return e?_[/(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a)?"accusative":/\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:_.nominative},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0440.",LLL:"D MMMM YYYY \u0440., HH:mm",LLLL:"dddd, D MMMM YYYY \u0440., HH:mm"},calendar:{sameDay:Ya("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),nextDay:Ya("[\u0417\u0430\u0432\u0442\u0440\u0430 "),lastDay:Ya("[\u0412\u0447\u043e\u0440\u0430 "),nextWeek:Ya("[\u0423] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return Ya("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);case 1:case 2:case 4:return Ya("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"%s \u0442\u043e\u043c\u0443",s:"\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",ss:La,m:La,mm:La,h:"\u0433\u043e\u0434\u0438\u043d\u0443",hh:La,d:"\u0434\u0435\u043d\u044c",dd:La,M:"\u043c\u0456\u0441\u044f\u0446\u044c",MM:La,y:"\u0440\u0456\u043a",yy:La},meridiemParse:/\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u0456":e<12?"\u0440\u0430\u043d\u043a\u0443":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u043e\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-\u0439";case"D":return e+"-\u0433\u043e";default:return e}},week:{dow:1,doy:7}});var ha=["\u062c\u0646\u0648\u0631\u06cc","\u0641\u0631\u0648\u0631\u06cc","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u06cc\u0644","\u0645\u0626\u06cc","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0626\u06cc","\u0627\u06af\u0633\u062a","\u0633\u062a\u0645\u0628\u0631","\u0627\u06a9\u062a\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u062f\u0633\u0645\u0628\u0631"],ya=["\u0627\u062a\u0648\u0627\u0631","\u067e\u06cc\u0631","\u0645\u0646\u06af\u0644","\u0628\u062f\u06be","\u062c\u0645\u0639\u0631\u0627\u062a","\u062c\u0645\u0639\u06c1","\u06c1\u0641\u062a\u06c1"];return e.defineLocale("ur",{months:ha,monthsShort:ha,weekdays:ya,weekdaysShort:ya,weekdaysMin:ya,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0622\u062c \u0628\u0648\u0642\u062a] LT",nextDay:"[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",nextWeek:"dddd [\u0628\u0648\u0642\u062a] LT",lastDay:"[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",lastWeek:"[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0628\u0639\u062f",past:"%s \u0642\u0628\u0644",s:"\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",ss:"%d \u0633\u06cc\u06a9\u0646\u0688",m:"\u0627\u06cc\u06a9 \u0645\u0646\u0679",mm:"%d \u0645\u0646\u0679",h:"\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",hh:"%d \u06af\u06be\u0646\u0679\u06d2",d:"\u0627\u06cc\u06a9 \u062f\u0646",dd:"%d \u062f\u0646",M:"\u0627\u06cc\u06a9 \u0645\u0627\u06c1",MM:"%d \u0645\u0627\u06c1",y:"\u0627\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}}),e.defineLocale("uz",{months:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split("_"),weekdaysShort:"\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split("_"),weekdaysMin:"\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",nextDay:"[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",nextWeek:"dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastDay:"[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastWeek:"[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",sameElse:"L"},relativeTime:{future:"\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",past:"\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",s:"\u0444\u0443\u0440\u0441\u0430\u0442",ss:"%d \u0444\u0443\u0440\u0441\u0430\u0442",m:"\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",mm:"%d \u0434\u0430\u043a\u0438\u043a\u0430",h:"\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u0431\u0438\u0440 \u043e\u0439",MM:"%d \u043e\u0439",y:"\u0431\u0438\u0440 \u0439\u0438\u043b",yy:"%d \u0439\u0438\u043b"},week:{dow:1,doy:7}}),e.defineLocale("vi",{months:"th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,_){return e<12?_?"sa":"SA":_?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [n\u0103m] YYYY",LLL:"D MMMM [n\u0103m] YYYY HH:mm",LLLL:"dddd, D MMMM [n\u0103m] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[H\xf4m nay l\xfac] LT",nextDay:"[Ng\xe0y mai l\xfac] LT",nextWeek:"dddd [tu\u1ea7n t\u1edbi l\xfac] LT",lastDay:"[H\xf4m qua l\xfac] LT",lastWeek:"dddd [tu\u1ea7n r\u1ed3i l\xfac] LT",sameElse:"L"},relativeTime:{future:"%s t\u1edbi",past:"%s tr\u01b0\u1edbc",s:"v\xe0i gi\xe2y",ss:"%d gi\xe2y",m:"m\u1ed9t ph\xfat",mm:"%d ph\xfat",h:"m\u1ed9t gi\u1edd",hh:"%d gi\u1edd",d:"m\u1ed9t ng\xe0y",dd:"%d ng\xe0y",M:"m\u1ed9t th\xe1ng",MM:"%d th\xe1ng",y:"m\u1ed9t n\u0103m",yy:"%d n\u0103m"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.defineLocale("x-pseudo",{months:"J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),monthsShort:"J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),monthsParseExact:!0,weekdays:"S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),weekdaysShort:"S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),weekdaysMin:"S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~\xf3d\xe1~\xfd \xe1t] LT",nextDay:"[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",nextWeek:"dddd [\xe1t] LT",lastDay:"[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",lastWeek:"[L~\xe1st] dddd [\xe1t] LT",sameElse:"L"},relativeTime:{future:"\xed~\xf1 %s",past:"%s \xe1~g\xf3",s:"\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",ss:"%d s~\xe9c\xf3\xf1~ds",m:"\xe1 ~m\xed\xf1~\xfat\xe9",mm:"%d m~\xed\xf1\xfa~t\xe9s",h:"\xe1~\xf1 h\xf3~\xfar",hh:"%d h~\xf3\xfars",d:"\xe1 ~d\xe1\xfd",dd:"%d d~\xe1\xfds",M:"\xe1 ~m\xf3\xf1~th",MM:"%d m~\xf3\xf1t~hs",y:"\xe1 ~\xfd\xe9\xe1r",yy:"%d \xfd~\xe9\xe1rs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("yo",{months:"S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),monthsShort:"S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),weekdays:"A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split("_"),weekdaysShort:"A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split("_"),weekdaysMin:"A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[O\u0300ni\u0300 ni] LT",nextDay:"[\u1ecc\u0300la ni] LT",nextWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",lastDay:"[A\u0300na ni] LT",lastWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",sameElse:"L"},relativeTime:{future:"ni\u0301 %s",past:"%s k\u1ecdja\u0301",s:"i\u0300s\u1eb9ju\u0301 aaya\u0301 die",ss:"aaya\u0301 %d",m:"i\u0300s\u1eb9ju\u0301 kan",mm:"i\u0300s\u1eb9ju\u0301 %d",h:"wa\u0301kati kan",hh:"wa\u0301kati %d",d:"\u1ecdj\u1ecd\u0301 kan",dd:"\u1ecdj\u1ecd\u0301 %d",M:"osu\u0300 kan",MM:"osu\u0300 %d",y:"\u1ecddu\u0301n kan",yy:"\u1ecddu\u0301n %d"},dayOfMonthOrdinalParse:/\u1ecdj\u1ecd\u0301\s\d{1,2}/,ordinal:"\u1ecdj\u1ecd\u0301 %d",week:{dow:1,doy:4}}),e.defineLocale("zh-cn",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",LLLL:"YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:11<=e?e:e+12},meridiem:function(e,a,_){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u5468)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u5468";default:return e}},relativeTime:{future:"%s\u5185",past:"%s\u524d",s:"\u51e0\u79d2",ss:"%d \u79d2",m:"1 \u5206\u949f",mm:"%d \u5206\u949f",h:"1 \u5c0f\u65f6",hh:"%d \u5c0f\u65f6",d:"1 \u5929",dd:"%d \u5929",M:"1 \u4e2a\u6708",MM:"%d \u4e2a\u6708",y:"1 \u5e74",yy:"%d \u5e74"},week:{dow:1,doy:4}}),e.defineLocale("zh-hk",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,_){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.defineLocale("zh-tw",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,_){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929] LT",nextDay:"[\u660e\u5929] LT",nextWeek:"[\u4e0b]dddd LT",lastDay:"[\u6628\u5929] LT",lastWeek:"[\u4e0a]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.locale("en"),e});
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AuthorSurveyCtrl', ['$rootScope', '$uibModal', 'apiUrl', '$http', '$sce', '$translate', '$filter', '$state', '$q', '$stateParams', '$timeout', 'survey', 'AuthorSurveysService', AuthorSurveyCtrl])
        .controller('SummernoteEditorDialogCtrl', ['$uibModalInstance', '$translate', 'fieldToUpdate', 'fieldToUpdateFull', 'content', 'context', 'questSeq', 'save', SummernoteEditorDialogCtrl])
        .controller('ElementOptLabelEditorDialogCtrl', ['$uibModalInstance', '$translate', 'fieldToUpdateFull', 'option', 'elemId', 'saveOptLabel', ElementOptLabelEditorDialogCtrl]);

    function AuthorSurveyCtrl($rootScope, $uibModal, apiUrl, $http, $sce, $translate, $filter, $state, $q, $stateParams, $timeout, survey, AuthorSurveysService) {
        var vm = this;
        vm.updateEnabled = false;
        vm.survey = survey;
        vm.stepWidth = 119;
        vm.numberOfPrevVisibleSteps = 3;
        vm.navScrollPos = 0;
        vm.fadeDirn;
        vm.sldrModel = [];
        vm.sldrOpts = [];

        vm.survSectNameLabel = $translate.instant('sysAdmin.mangSurvs.survSectNameLabel');
        vm.clickToAddSectionNameText = $translate.instant('sysAdmin.mangSurvs.clickToAddText', {
            labelName: vm.survSectNameLabel
        });
        vm.clickToUpdateSectionNameText = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.survSectNameLabel
        });

        vm.survSectDescLabel = $translate.instant('sysAdmin.mangSurvs.survSectDescLabel');
        vm.clickToAddSectionDescText = $translate.instant('sysAdmin.mangSurvs.clickToAddText', {
            labelName: vm.survSectDescLabel
        });
        vm.clickToUpdateSectionDescText = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.survSectDescLabel
        });
        vm.survSectDescPlaceholder = '\u02C2' + vm.survSectDescLabel + '\u02C3';

        vm.survSectInstrsLabel = $translate.instant('sysAdmin.mangSurvs.survSectInstrsLabel');
        vm.clickToAddSectionInstrsText = $translate.instant('sysAdmin.mangSurvs.clickToAddText', {
            labelName: vm.survSectInstrsLabel
        });
        vm.clickToUpdateSectionInstrsText = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.survSectInstrsLabel
        });
        vm.survSectInstrsPlaceholder = '\u02C2' + vm.survSectInstrsLabel + '\u02C3';

        vm.survQuestTextLabel = $translate.instant('sysAdmin.mangSurvs.survQuestTextLabel');
        vm.clickToAddvQuestText = $translate.instant('sysAdmin.mangSurvs.clickToAddText', {
            labelName: vm.survQuestTextLabel
        });
        vm.clickToUpdatevQuestText = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.survQuestTextLabel
        });

        vm.survQuestHelpTextLabel = $translate.instant('sysAdmin.mangSurvs.survQuestHelpTextLabel');
        vm.clickToAddQuestHelpText = $translate.instant('sysAdmin.mangSurvs.clickToAddText', {
            labelName: vm.survQuestHelpTextLabel
        });
        vm.clickToUpdateQuestHelpText = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.survQuestHelpTextLabel
        });
        vm.survQuestHelpTextPlaceholder = '\u02C2' + vm.survQuestHelpTextLabel + '\u02C3';

        vm.optLabel = $translate.instant('sysAdmin.mangSurvs.survQuestElemOptDescLabel');
        vm.clickToUpdateOptLabel = $translate.instant('sysAdmin.mangSurvs.clickToUpdtText', {
            labelName: vm.optLabel
        });

        vm.updtSurvActnHdr = function() {
            return $translate.instant('surv.updtSurv.tabl.actnsHeader');
        };

        if (vm.survey) {
            vm.currentSecSeq = parseInt($stateParams.survSectSeq);
            if (vm.survey.sections && vm.survey.sections.length) {
                vm.survey.sections.sort(function(a, b) {
                    return a.sequence - b.sequence;
                });
                vm.survey.sections = vm.survey.sections.map(function(section) {
                    section.survTypeCd = vm.survey.survTypeCd;
                    return section;
                });
                vm.section = $filter('filter')(vm.survey.sections, {
                    sequence: vm.currentSecSeq
                }, true)[0];
                vm.section.sectionName = $sce.trustAsHtml(vm.section.sectionName);
                vm.section.sectionDesc = $sce.trustAsHtml(vm.section.sectionDesc);
                vm.section.sectionInstrs = $sce.trustAsHtml(vm.section.sectionInstrs);

                if(vm.section) {
                    vm.currentQuestionSeq = vm.section.questions[0].questSeq;
                    vm.currentQuestion = $filter('filter')(vm.section.questions, {questSeq: vm.currentQuestionSeq})[0];
                    vm.previousQuestionSeq = vm.currentQuestionSeq;
                }
            }

            $rootScope.surveyEditor = vm.survey;
            vm.questionSeqs = [];

            var userSurvey = $filter('filter')($rootScope.allLangSurveys, {langCd: $rootScope.userLang, survTypeCd: $stateParams.survTypeCd}, true)[0];
            if (userSurvey) {
                $rootScope.pageSubtitle = userSurvey.survTypeName;
                $rootScope.pageSubtitleDesc = userSurvey.survTypeDesc;
                if (vm.section) {
                    vm.breadCrumbSection = $filter('filter')(userSurvey.sections, {
                        sequence: vm.currentSecSeq
                    }, true)[0];
                    $rootScope.breadcrumb = vm.breadCrumbSection.sectionName;
                }
            }

            if (vm.section) {
                sortQuestions();
                sortElements();
                vm.isDirty = false;
                getQuestionSeqs();
                vm.currentQuestionSeq = vm.section.questions[0].questSeq;
                vm.previousQuestionSeq = vm.currentQuestionSeq;
            }
        }

        function sortQuestions() {
            vm.section.questions.sort(function(a, b) {
                return a.questSeq - b.questSeq;
            });
        }

        //sort and group elements into rows within a question
        function sortElements() {
            angular.forEach(vm.section.questions, function(question) {
                question.questText = (question.questText) ? $sce.trustAsHtml(question.questText) : '';
                question.questHelpText = (question.questHelpText) ? $sce.trustAsHtml(question.questHelpText) : '';
                question.rows = [];
                question.elements.sort(function(a, b) {
                    if (a.rowSeq === b.rowSeq) {
                        return a.elemSeq - b.elemSeq;
                    }
                    return a.rowSeq - b.rowSeq;
                });
                var currRowSeq = question.elements[0].rowSeq;
                var elements = [];
                angular.forEach(question.elements, function(element) {
                    element.questSeq = question.questSeq;  //add questionSeq to each element so we know which question to update on a change
                    if (element.dispLabel && (!element.labelPosnCd || !(element.labelPosnCd === 'TOP' || element.labelPosnCd === 'BOTTOM' || element.labelPosnCd === 'LEFT' || element.labelPosnCd === 'RIGHT'))) {
                        //set position to TOP if not specified
                        element.labelPosnCd = 'TOP';
                    }
                    if (element.dispLabel && (element.labelPosnCd === 'LEFT' || element.labelPosnCd === 'RIGHT')) {
                        //if elem width = 1 then no room for label so set dispLabel to false
                        if (element.elemWidth === 1) {
                            element.dispLabel = false;
                        }
                        //set width to 50% of elem width if not specified
                        if (!element.labelWidth) {
                            element.labelWidth = Math.floor(element.elemWidth / 2);
                        }
                        //labelWidth must be smaller than elem width
                        if (element.labelWidth >= element.elemWidth) {
                            element.labelWidth = element.elemWidth - 1;
                        }
                    }
                    if (element.rowSeq === currRowSeq) {
                        elements.push(element);
                    } else {
                        question.rows.push({
                            rowSeq: currRowSeq,
                            elements: elements
                        });
                        currRowSeq = element.rowSeq;
                        elements = [element];
                    }
                    //sort child elements by tabSeq
                    if (element.childElements) {
                        element.childElements.sort(function(a, b) {
                            return a.elemTabSeq - b.elemTabSeq;
                        });
                    }
                    angular.forEach(element.elemOpts, function (opt) {
                        opt.trustedLabel = $sce.trustAsHtml(opt.label);
                    });

                    //set slider opts
                    if (element.elemInputTypeCd === 'SLDR') {
                        if (element.elemOpts && element.elemOpts.length > 0) {
                            var steps = [];
                            angular.forEach(element.elemOpts, function(elemOpt) {
                                steps.push({
                                    value: elemOpt.label
                                });
                            });
                            vm.sldrOpts[element.elemId] = {
                                showTicks: true,
                                stepsArray: steps
                            };
                            vm.sldrModel[element.elemId] = element.elemOpts[0].label;
                        } else {
                            vm.sldrOpts[element.elemId] = {
                                floor: 0,
                                ceil: 100
                            };
                            vm.sldrModel[element.elemId] = 0;
                        }
                        vm.sldrOpts[element.elemId].showSelectionBar = true;
                        vm.sldrOpts[element.elemId].disabled = !vm.updateEnabled;
                    }
                });
                question.rows.push({
                    rowSeq: currRowSeq,
                    elements: elements
                });
                //sort elements array by tabSeq so can assign tabIndex
                question.elements.sort(function(a, b) {
                    if (a.elemTabSeq === b.elemTabSeq) {
                        return a.rowSeq - b.rowSeq;
                    }
                    return a.elemTabSeq - b.elemTabSeq;
                });
            });
        }

        function getQuestionSeqs() {
            vm.questionSeqs = [];
            angular.forEach(vm.section.questions, function(question) {
                vm.questionSeqs.push(question.questSeq);
            });
        }

        vm.slideLeftRight = function(seq, inc) {
            var elSelector = '#question-' + seq;
            var carouselEl = $(elSelector);
            if (inc === -1) {
                $(carouselEl).removeClass('fadeInRight');
                $(elSelector).addClass('fadeInLeft');
            } else {
                $(carouselEl).removeClass('fadeInLeft');
                $(elSelector).addClass('fadeInRight');
            }
            vm.fadeDirn = (inc < 0) ? 'l' : 'r';
        };

        vm.incrementQuestion = function(questSeq, inc) {
            $timeout(function() {
                var toIndex = vm.questionSeqs.indexOf(questSeq) + inc;
                var toQuestSeq = vm.questionSeqs[toIndex];
                if (toQuestSeq) {
                    vm.gotoQuestion(toQuestSeq, inc);
                }
            }, 500);
        };

        vm.gotoQuestion = function(seq, inc) {
            vm.slideLeftRight(seq, inc);
            vm.previousQuestionSeq = vm.currentQuestionSeq;
            vm.currentQuestionSeq = seq;
            vm.currentQuestion = $filter('filter')(vm.section.questions, {questSeq: vm.currentQuestionSeq})[0];
            var midPoint = (vm.stepWidth / 3) - 20;
            var scrollPos = parseInt(seq) * vm.stepWidth;
            $('.steps-indicator').stop().animate({
                scrollLeft: scrollPos - ((vm.stepWidth * vm.numberOfPrevVisibleSteps) + midPoint)
            }, 500);
        };

        vm.isFirstVisibleQuestion = function(questSeq) {
            var firstQuestion = vm.section.questions[0];
            return firstQuestion.questSeq === questSeq;
        };

        vm.isLastVisibleQuestion = function(questSeq) {
            return vm.section.questions[vm.section.questions.length - 1].questSeq === questSeq;
        };

        vm.isLastVisibleSection = function() {
            return vm.currentSecSeq === vm.survey.sections[vm.survey.sections.length - 1].sequence;
        };

        vm.goToNextSection = function() {
            $state.go('app.admin.surveys.survey.section', { survTypeCd: vm.survey.survTypeCd, survVersSeq: vm.survey.survVersSeq, langCd: $stateParams.langCd, survSectSeq: vm.currentSecSeq + 1 });
        };

        vm.stripHtml = function (html) {
            // Create a new div element
            var temporalDivElement = document.createElement('div');
            // Set the HTML content with the providen
            temporalDivElement.innerHTML = html;
            // Retrieve the text property of the element (cross-browser support)
            return temporalDivElement.textContent || temporalDivElement.innerText || '';
        };

        vm.saveSection = function (field2Update, updatedContent) {
            return $q(function(resolve, reject) {
                var updateSectionDto = {
                    survTypeCd: vm.survey.survTypeCd,
                    survVersSeq: vm.survey.survVersSeq,
                    survSectSeq: parseInt($stateParams.survSectSeq),
                    langCd: $stateParams.langCd,
                    updatedLangText: updatedContent,
                    sectionFieldName: field2Update
                };
                vm.laddaSurvSectSave = true;
                AuthorSurveysService.saveSurvSection({}, updateSectionDto)
                    .$promise.then(function() {
                        $http.get(apiUrl + 'surveys/flushCaches');
                    }).then(function() {
                        vm.isDirty = false;
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        vm.section[field2Update] = $sce.trustAsHtml(updatedContent);
                        if (field2Update === 'sectionName' && $stateParams.langCd === $rootScope.userLang) {
                            var linkHref = '/app/admin/surveys/type/' + vm.survey.survTypeCd + '/version/' + vm.survey.survVersSeq + '/lang/' + $stateParams.langCd + '/section/' + $stateParams.survSectSeq;
                            $('a[href="' + linkHref + '"] span').html(vm.stripHtml(updatedContent));
                        }
                        vm.laddaSurvSectSave = false;
                        resolve('success');
                    }, function() {
                        vm.laddaSurvSectSave = false;
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvError'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        reject('failed to save');
                    });
            });
        };

        vm.saveQuestion = function(field2Update, updatedContent, questSeq) {
            return $q(function(resolve, reject) {
                var updateQuestionDto = {
                    survTypeCd: vm.survey.survTypeCd,
                    survVersSeq: vm.survey.survVersSeq,
                    survSectSeq: parseInt($stateParams.survSectSeq),
                    survQuestSeq: questSeq,
                    langCd: $stateParams.langCd,
                    updatedLangText: updatedContent,
                    questFieldName: field2Update
                };
                resolve('success');
                vm.laddaSurvSectSave = true;
                AuthorSurveysService.saveSurvQuestion({}, updateQuestionDto)
                    .$promise.then(function() {
                        $http.get(apiUrl + 'surveys/flushCaches');
                    }).then(function() {
                        vm.isDirty = false;
                        toastr.success(
                            $translate.instant('surv.updtSurv.toast.saveSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        var questionToUpdate = $filter('filter')(vm.section.questions, {
                            questSeq: questSeq
                        }, true)[0];
                        if (questionToUpdate) {
                            questionToUpdate[field2Update] = $sce.trustAsHtml(updatedContent);
                        }
                        vm.laddaSurvSectSave = false;
                        resolve('success');
                    }, function(err) {
                        vm.laddaSurvSectSave = false;
                        reject(err);
                    });
            });
        };

        vm.save = function(field2Update, content, context, questSeq) {
            return $q(function(resolve, reject) {
                if (context === 'section') {
                    vm.saveSection(field2Update, content, context, questSeq).then(function() {
                        resolve('saved');
                    }, function() {
                        reject('Problem saving');
                    });
                } else if (context === 'question') {
                    vm.saveQuestion(field2Update, content, questSeq).then(function() {
                        resolve('saved');
                    }, function() {
                        reject('Problem saving');
                    });
                }
            });
        };

        vm.openSummernoteEditorDialog = function(fieldToUpdate, fieldToUpdateFull, content, context, questSeq) {
            return $q(function(resolve) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'summernote-editor-dialog-template.html',
                    controller: 'SummernoteEditorDialogCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        fieldToUpdate: function() {
                            return fieldToUpdate;
                        },
                        fieldToUpdateFull: function() {
                            return fieldToUpdateFull;
                        },
                        content: function() {
                            return content;
                        },
                        context: function() {
                            return context;
                        },
                        questSeq: function() {
                            return questSeq;
                        },
                        save: function() {
                            return vm.save;
                        }
                    }
                });
                resolve();
            });
        };

        vm.saveOptLabel = function (updatedLabel, option, elemId) {
            return $q(function(resolve, reject) {
                var updateElementOptDto = {
                    elemId: elemId,
                    elemOptVal: option.value,
                    elemOptDesc: updatedLabel,
                    langCd: $stateParams.langCd
                };

                AuthorSurveysService.saveOptLabel({}, updateElementOptDto)
                    .$promise.then(function() {
                        $http.get(apiUrl + 'surveys/flushCaches');
                    }).then(function() {
                        vm.isDirty = false;
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        //update locally
                        option.label = updatedLabel;
                        option.trustedLabel = $sce.trustAsHtml(updatedLabel);
                        resolve('success');
                    }, function() {
                        toastr.error(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvError'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        reject('failed to save');
                    });
            });
        };

        vm.openElementOptLabelEditorDialog = function(fieldToUpdateFull, option, elemId) {
            return $q(function(resolve) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'element-opt-label-editor-dialog-template.html',
                    controller: 'ElementOptLabelEditorDialogCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        fieldToUpdateFull: function() {
                            return fieldToUpdateFull;
                        },
                        option: function() {
                            return option;
                        },
                        elemId: function() {
                            return elemId;
                        },
                        saveOptLabel: function() {
                            return vm.saveOptLabel;
                        }
                    }
                });
                resolve();
            });
        };
    }

    function SummernoteEditorDialogCtrl($uibModalInstance, $translate, fieldToUpdate, fieldToUpdateFull, content, context, questSeq, save) {
        var modal = this;
        modal.fieldToUpdate = fieldToUpdate;
        modal.fieldToUpdateFull = fieldToUpdateFull;
        modal.content = content;
        modal.hasErrors = false;
        modal.okButton = $translate.instant('sysAdmin.updtSurv.modal.updtButton');
        modal.cancelButton = $translate.instant('sysAdmin.updtSurv.modal.cancelButton');
        modal.title = $translate.instant('sysAdmin.updtSurv.modal.updtTitle', { labelName: fieldToUpdateFull });
        modal.laddaSave = false;
        modal.close = function () {
            if (!modal.hasErrors) {
                modal.laddaSave = true;
                save(fieldToUpdate, $('div.note-editable').html(), context, questSeq).then(function () {
                    modal.laddaSave = false;
                    $uibModalInstance.dismiss('save');
                }, function () {
                    modal.laddaSave = false;
                    $uibModalInstance.dismiss('cancel');
                });
            }
        };
        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function ElementOptLabelEditorDialogCtrl($uibModalInstance, $translate, fieldToUpdateFull, option, elemId, saveOptLabel) {
        var modal = this;
        modal.fieldToUpdateFull = fieldToUpdateFull;
        modal.elemOptDesc = option.label;
        modal.hasErrors = false;
        modal.okButton = $translate.instant('sysAdmin.updtSurv.modal.updtButton');
        modal.cancelButton = $translate.instant('sysAdmin.updtSurv.modal.cancelButton');
        modal.title = $translate.instant('sysAdmin.updtSurv.modal.updtTitle', { labelName: fieldToUpdateFull });
        modal.laddaSave = false;
        modal.close = function () {
            if (!modal.hasErrors) {
                modal.laddaSave = true;
                saveOptLabel($('div.note-editable').html(), option, elemId).then(function () {
                    modal.laddaSave = false;
                    $uibModalInstance.dismiss('saveLabel');
                }, function () {
                    modal.laddaSave = false;
                    $uibModalInstance.dismiss('cancel');
                });
            }
        };
        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('SurvSwitchCtrl', ['$rootScope', '$scope', '$state', SurvSwitchCtrl]);

    function SurvSwitchCtrl($rootScope, $scope, $state) {
        redirect($state.current);
        $scope.$on('$stateChangeSuccess', function(event, toState) {
            redirect(toState);
        });

        function redirect(state) {
            if (state.name === 'app.subject.survey.section') {
                if ($rootScope.subject.myUserPermsns.indexOf('UPDT_SURV') !== -1 && !$rootScope.subject.survViewOnlyFlag) {
                    $state.go('app.subject.survey.section.update');
                } else {
                    $state.go('app.subject.survey.section.view');
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('SurveyService', ['$resource', 'apiUrl', SurveyService]);

    function SurveyService($resource, apiUrl) {
        var service = $resource(apiUrl + 'surveys/:subjId?tz=:tz', {}, {
            query: {
                method: 'GET'
            },
            save: {
                url: apiUrl + 'surveys',
                method: 'POST'
            },
            processSurveyAnswers: {
                url: apiUrl + 'surveys/process',
                method: 'POST'
            },
            accessSurveySection: {
                url: apiUrl + 'surveys/access',
                method: 'POST'
            }
        });
        return service;
    }
})();
(function() {
    'use strict';

    angular.module('app')
        .directive('surveyInput', surveyInput)
        .directive('surveyRadio', surveyRadio)
        .directive('surveyComment', surveyComment)
        .directive('fieldValidation', ['$timeout', fieldValidation])
        .directive('subfieldValidation', ['$timeout', subfieldValidation]);

    function surveyInput() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem, attrs) {
                elem.on('change', function() {
                    if (elem.val() === '') {
                        delete scope.vm.comments[attrs.elemId];
                    }
                });
            }
        };
    }

    function surveyRadio() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem) {
                elem.on('ifUnchecked', function() {
                    setTimeout(function() {
                        delete scope.vm.comments[attrs.elemId];
                    }, 0);
                });
            }
        };
    }

    function surveyComment() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem, attrs, field) {
                var question = $.parseJSON(attrs.question);
                field.$modelValue = scope.vm.comments[question.elemId];
                elem.val(field.$modelValue);
                if (question && (scope.vm.answered(question) && question.addlCmmtReqd)) {
                    if (scope.vm.comments[question.elemId] === undefined) {
                        scope.vm.disableStepper(question);
                    }
                }
            }
        };
    }

    function fieldValidation($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, uiElement, attrs, ngModelCtrl) {
                var element = attrs.element;
                var tempValue;
                var maskConfig;
                var formatValidationString;

                if (element) {
                    element = JSON.parse(element);
                    if (element.elemDispMask) {
                        maskConfig = element.elemDispMask;
                    }

                    //show placeholder if no value
                    $timeout(function() {
                        if (!ngModelCtrl.$modelValue && element.elemDataTypeCd !== 'DATE') {
                            $(uiElement).attr('placeholder', element.elemWatrmkText);
                            ngModelCtrl.$render();
                        }
                    });

                    if (element.formtValdText) {
                        formatValidationString = element.formtValdText;
                    }

                    //Focusin
                    $(uiElement).focusin(function() {
                        if (tempValue && element.elemDataTypeCd !== 'DATE' && element.elemInputTypeCd !== 'DDCB' && element.elemInputTypeCd !== 'DDLB') {
                            ngModelCtrl.$setViewValue(tempValue);
                        } else if (element.elemDataTypeCd !== 'DATE' && element.elemInputTypeCd !== 'DDCB' && element.elemInputTypeCd !== 'DDLB') {
                            ngModelCtrl.$setViewValue(ngModelCtrl.$modelValue);
                        }
                        ngModelCtrl.$render();
                    });

                    $(uiElement).on('keydown', function() {
                        $timeout(function() {
                            scope.vm.freezeOps = false;
                        });
                    });

                    //Blur
                    $(uiElement).on('blur', function() {
                        $timeout(function() {
                            scope.$apply(function() {
                                tempValue = ngModelCtrl.$modelValue;
                                validateAndMask(scope, ngModelCtrl, formatValidationString, element, maskConfig);
                                // add placeholder if no value;
                                if (!tempValue && element.elemDataTypeCd !== 'DATE') {
                                    $(uiElement).attr('placeholder', element.elemWatrmkText);
                                }

                                if (element.elemInputTypeCd === 'DDCB' && scope.vm.ddcbModel[element.elemId] === '') {
                                    scope.vm.answeredElements[element.elemId] = null;
                                    //remove error
                                    delete scope.vm.notInListErrors[element.elemId];
                                }
                                scope.vm.validateFields();
                            });
                        });
                    });

                    //onload
                    $timeout(function() {
                        //Validate formatType
                        validateAndMask(scope, ngModelCtrl, formatValidationString, element, maskConfig);
                        scope.vm.validateFields();
                        //enable datepicker
                        if (scope.vm.updateEnabled && element.elemDataTypeCd === 'DATE') {
                            var uiELemId = 'dp-q-' + element.questSeq + '-el-' + element.elemId + '-' + element.elemInputTypeCd;
                            $('#' + uiELemId).datepicker()
                                .on('changeDate', function(ev) {
                                    scope.vm.freezeOps = false;
                                    var newValue = moment(ev.date, 'YYYY-MM-DD').format(scope.vm.dateFormat);
                                    scope.vm.onDateValueChange(newValue, element);
                                    $(uiElement).blur().focus();
                                })
                                .on('change', function(ev) {
                                    scope.vm.freezeOps = false;
                                    var targetEl = ev.currentTarget.children[0];
                                    var newValue = $(targetEl).val();
                                    scope.vm.onDateValueChange(newValue, element);
                                });
                        }
                    });
                }
            }
        };

        //utility functions
        function validateAndMask(scope, ngModelCtrl, formatValidationString, element, maskConfig) {
            var value;
            var modelValue = ngModelCtrl.$modelValue;
            if (modelValue) {
                value = modelValue.toString();
                if (value) {
                    //Validate formatType
                    var isNan = (element.elemDataTypeCd === 'NUM' && isNaN(modelValue));
                    var invalidFormat = (formatValidationString && !new RegExp(formatValidationString).test(modelValue));
                    var invalidDate = (element.elemDataTypeCd === 'DATE' && !(moment(modelValue, scope.vm.dateFormat, true).isValid()));

                    if (isNan || invalidFormat || invalidDate) {
                        if (isNan) {
                            scope.vm.NaNErrors[element.elemId] = true;
                        } else {
                            delete scope.vm.NaNErrors[element.elemId];
                            scope.vm.formatErrors[element.elemId] = true;
                        }
                        delete scope.vm.answeredElements[element.elemId]; //remove answer
                    } else {
                        delete scope.vm.formatErrors[element.elemId];
                        delete scope.vm.NaNErrors[element.elemId];

                        //if (element.elemDataTypeCd === 'NUM' && maskConfig) {
                        //    var prefix = getPrefix(maskConfig) || '';
                        //    var suffix = getSuffix(maskConfig) || '';
                        //    value = prefix + numeral(modelValue).format(maskConfig.replace(/{[^}]*}/g, '')) + suffix;
                        //}
                    }

                    //if (element.elemDataTypeCd === 'ANUM' && maskConfig) {
                    //    value = formatValue(modelValue.replace(/-|\s/g, ''), maskConfig);
                    //}

                    $timeout(function() {
                        scope.$apply(function() {
                            if (element.elemInputTypeCd !== 'DDCB' && element.elemInputTypeCd !== 'DDLB') {
                                //ngModelCtrl.$viewValue = value;
                                ngModelCtrl.$viewValue = scope.vm.addDisplayMask(modelValue.replace(/-|\s/g, ''), element.elemDataTypeCd, maskConfig);
                                ngModelCtrl.$render();
                            }
                        });
                    });
                }
            } else {
                delete scope.vm.formatErrors[element.elemId];
                delete scope.vm.NaNErrors[element.elemId];
            }
        }
    }

    function subfieldValidation($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, uiElement, attrs, ngModelCtrl) {
                var elemId = attrs.elemid;
                var questSeq = attrs.questseq;
                var childElement = attrs.childElement;
                var rowIndex = scope.$eval(attrs.rowIndex);
                scope.$watch(attrs.rowIndex, function(newValue) {
                    rowIndex = newValue;
                });
                var tempValue;
                var maskConfig;
                var formatValidationString;

                if (elemId && childElement) {
                    childElement = JSON.parse(childElement);

                    if (childElement.elemDispMask) {
                        maskConfig = childElement.elemDispMask;
                    }

                    //show placeholder if no value
                    $timeout(function() {
                        if (!ngModelCtrl.$modelValue && childElement.elemDataTypeCd !== 'DATE') {
                            $(uiElement).attr('placeholder', childElement.elemWatrmkText);
                            ngModelCtrl.$render();
                        }
                    });

                    if (childElement.formtValdText) {
                        formatValidationString = childElement.formtValdText;
                    }

                    //Focusin
                    $(uiElement).focusin(function() {
                        if (tempValue && childElement.elemDataTypeCd !== 'DATE' && childElement.elemInputTypeCd !== 'DDCB' && childElement.elemInputTypeCd !== 'DDLB') {
                            ngModelCtrl.$setViewValue(tempValue);
                            ngModelCtrl.$render();
                        } else if (childElement.elemDataTypeCd !== 'DATE' && childElement.elemInputTypeCd !== 'DDCB' && childElement.elemInputTypeCd !== 'DDLB') {
                            ngModelCtrl.$setViewValue(ngModelCtrl.$modelValue);
                            ngModelCtrl.$render();
                        }
                    });

                    $(uiElement).on('keydown', function() {
                        $timeout(function() {
                            scope.vm.freezeOps = false;
                        });
                    });

                    //Blur
                    $(uiElement).on('blur', function() {
                        $timeout(function() {
                            scope.$apply(function() {
                                tempValue = ngModelCtrl.$modelValue;
                                validateAndMask(scope, ngModelCtrl, formatValidationString, maskConfig, elemId, childElement, rowIndex);
                                if (tempValue) {
                                    if (scope.vm.requiredSubElementErrors[elemId] && scope.vm.requiredSubElementErrors[elemId][rowIndex]) {
                                        delete scope.vm.requiredSubElementErrors[elemId][rowIndex][childElement.elemId];
                                    }
                                }
                                // add placeholder if no value;
                                if (!tempValue && childElement.elemDataTypeCd !== 'DATE') {
                                    $(uiElement).attr('placeholder', childElement.elemWatrmkText);
                                }

                                if (childElement.elemInputTypeCd === 'DDCB' && scope.vm.tablModel[elemId][rowIndex][childElement.elemId] === '') {
                                    var json = JSON.parse(scope.vm.answeredElements[elemId]);
                                    //remove answer
                                    delete json[rowIndex][childElement.elemId];
                                    scope.vm.answeredElements[elemId] = JSON.stringify(json);
                                    //remove error
                                    if (scope.vm.childNotInListErrors[elemId] && scope.vm.childNotInListErrors[elemId][rowIndex]) {
                                        delete scope.vm.childNotInListErrors[elemId][rowIndex][childElement.elemId];
                                    }
                                }

                                scope.vm.validateFields();
                            });
                        });
                    });

                    //onload
                    $timeout(function() {
                        //Validate formatType
                        validateAndMask(scope, ngModelCtrl, formatValidationString, maskConfig, elemId, childElement, rowIndex);
                        scope.vm.validateFields();
                        if (scope.vm.updateEnabled && childElement.elemDataTypeCd === 'DATE') {
                            var uiELemId = 'q-' + questSeq + '-el-' + childElement.elemId + '-row-' + rowIndex + '-' + childElement.elemInputTypeCd;
                            $('#' + uiELemId).datepicker()
                                .on('changeDate', function(ev) {
                                    scope.vm.freezeOps = false;
                                    var newValue = moment(ev.date, 'YYYY-MM-DD').format(scope.vm.dateFormat);
                                    scope.vm.onTablDateValueChange(elemId, childElement, rowIndex, newValue);
                                    $(this).blur().focus();
                                })
                                .on('change', function(ev) {
                                    scope.vm.freezeOps = false;
                                    var targetEl = ev.currentTarget.children[0];
                                    var newValue = $(targetEl).val();
                                    scope.vm.onTablDateValueChange(elemId, childElement, rowIndex, newValue);
                                });
                        }
                    });
                }

            }
        };

        //utility functions
        function validateAndMask(scope, ngModelCtrl, formatValidationString, maskConfig, elemId, childElement, rowIndex) {
            var value;
            var modelValue = ngModelCtrl.$modelValue;
            var json = JSON.parse(scope.vm.answeredElements[elemId]);
            var childValue = scope.vm.tablModel[elemId][rowIndex][childElement.elemId];
            if (modelValue) {
                value = modelValue.toString();
                if (value) {
                    var isNan = (childElement.elemDataTypeCd === 'NUM' && isNaN(modelValue));
                    var invalidFormat = (formatValidationString && !new RegExp(formatValidationString).test(modelValue));
                    var invalidDate = (childElement.elemDataTypeCd === 'DATE' && !(moment(modelValue, scope.vm.dateFormat, true).isValid()));

                    if (!scope.vm.subElemFormatErrors[elemId]) {
                        scope.vm.subElemFormatErrors[elemId] = [];
                    }
                    if (!scope.vm.subElemFormatErrors[elemId][rowIndex]) {
                        scope.vm.subElemFormatErrors[elemId][rowIndex] = {};
                    }

                    if (!scope.vm.subElemNaNErrors[elemId]) {
                        scope.vm.subElemNaNErrors[elemId] = [];
                    }
                    if (!scope.vm.subElemNaNErrors[elemId][rowIndex]) {
                        scope.vm.subElemNaNErrors[elemId][rowIndex] = {};
                    }

                    if (isNan || invalidFormat || invalidDate) {
                        if (isNan) {
                            scope.vm.subElemNaNErrors[elemId][rowIndex][childElement.elemId] = true;
                            delete scope.vm.subElemFormatErrors[elemId][rowIndex][childElement.elemId];
                        } else {
                            delete scope.vm.subElemNaNErrors[elemId][rowIndex][childElement.elemId];
                            scope.vm.subElemFormatErrors[elemId][rowIndex][childElement.elemId] = true;
                        }
                        delete json[rowIndex][childElement.elemId]; //remove answer
                        scope.vm.answeredElements[elemId] = JSON.stringify(json);
                    } else {
                        json[rowIndex][childElement.elemId] = childValue;
                        if (childElement.elemDataTypeCd === 'DATE') {
                            json[rowIndex][childElement.elemId] = moment(childValue, scope.vm.dateFormat).format('YYYY-MM-DD');
                        }

                        delete scope.vm.subElemFormatErrors[elemId][rowIndex][childElement.elemId];
                        delete scope.vm.subElemNaNErrors[elemId][rowIndex][childElement.elemId];

                        //if (childElement.elemDataTypeCd === 'NUM' && maskConfig) {
                        //    var prefix = getPrefix(maskConfig) || '';
                        //    var suffix = getSuffix(maskConfig) || '';
                        //    value = prefix + numeral(modelValue).format(maskConfig.replace(/{[^}]*}/g, '')) + suffix;
                        //}

                        if (childElement.elemInputTypeCd !== 'DDCB' && childElement.elemInputTypeCd !== 'DDLB') {
                            scope.vm.answeredElements[elemId] = JSON.stringify(json);
                        }
                    }

                    //if (childElement.elemDataTypeCd === 'ANUM' && maskConfig) {
                    //    value = formatValue(modelValue.replace(/-|\s/g, ''), maskConfig);
                    //}

                    if (childElement.elemInputTypeCd !== 'DDCB' && childElement.elemInputTypeCd !== 'DDLB') {
                        //ngModelCtrl.$viewValue = value;
                        ngModelCtrl.$viewValue = scope.vm.addDisplayMask(modelValue.replace(/-|\s/g, ''), childElement.elemDataTypeCd, maskConfig);
                        ngModelCtrl.$render();
                    }
                }
            } else {

                if (scope.vm.subElemFormatErrors[elemId] && scope.vm.subElemFormatErrors[elemId][rowIndex]) {
                    delete scope.vm.subElemFormatErrors[elemId][rowIndex][childElement.elemId];
                }
                if (scope.vm.subElemNaNErrors[elemId] && scope.vm.subElemNaNErrors[elemId][rowIndex]) {
                    delete scope.vm.subElemNaNErrors[elemId][rowIndex][childElement.elemId];
                }
            }
        }
    }

    /*function formatValue(modelValue, elemDisplayMask) {
        var placeHolderChar = '#';
        var ValueChar = '*';
        var aValue = modelValue.split('');
        var aMask = elemDisplayMask.split('');
        var retValue = '';
        var maskCharPos = -1;
        angular.forEach(aMask, function(maskChar) {
            if (maskChar === ValueChar) {
                maskCharPos += 1;
                retValue += (aValue[maskCharPos]) ? aValue[maskCharPos] : ' ';
            } else if (maskChar === placeHolderChar) {
                maskCharPos += 1;
                retValue += '*';
            } else {
                retValue += maskChar;
            }
        });
        return retValue;
    }*/

    /*function getPrefix(formatStr) {
        var prefix;
        var prefixStartIdx = formatStr.indexOf('{');
        var prefixEndIdx = formatStr.indexOf('}');
        if (prefixStartIdx !== -1 && prefixStartIdx < 1 && prefixEndIdx !== -1 && formatStr.substring(prefixStartIdx - 1, 0) === '') {
            prefix = formatStr.substring(prefixStartIdx + 1, prefixEndIdx);
        }
        return prefix;
    }

    function getSuffix(formatStr) {
        var suffix;
        var suffixStartIdx = formatStr.lastIndexOf('{');
        var suffixEndIdx = formatStr.lastIndexOf('}');

        if (suffixStartIdx !== -1 && suffixStartIdx > 1 && suffixEndIdx !== -1) {
            suffix = formatStr.substring(suffixStartIdx + 1, suffixEndIdx);
        }
        return suffix;
    }*/
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('SurveyCtrl', ['$rootScope', '$scope', '$sce', '$timeout', '$state', '$stateParams', '$translate', '$q', '$uibModal', '$filter', 'SurveyService', 'SubjectService', 'account', 'surveyState', 'sysParms', SurveyCtrl])
        .controller('SurveyConfirmModalCtrl', ['$uibModalInstance', '$rootScope', '$state', 'SubjectService', 'saveSurvey', 'freezeOps', 'toState', 'toParams', SurveyConfirmModalCtrl])
        .controller('SurveyAdvanceStageModalCtrl', ['$uibModalInstance', '$state', '$translate', 'SubjectService', 'subjId', 'survTypeName', 'currStage', 'toStage', 'advncSubjStageTitl', 'advncSubjStageText', SurveyAdvanceStageModalCtrl])
        .controller('SurveyLogoutModalCtrl', ['$uibModalInstance', '$translate', 'AuthService', 'survTypeName', SurveyLogoutModalCtrl]);

    function SurveyCtrl($rootScope, $scope, $sce, $timeout, $state, $stateParams, $translate, $q, $uibModal, $filter, SurveyService, SubjectService, account, surveyState, sysParms) {
        var vm = this;
        vm.updateEnabled = $rootScope.subject.myUserPermsns.indexOf('UPDT_SURV') !== -1 && !$rootScope.subject.survViewOnlyFlag;
        vm.freezeOps = false;
        vm.fadeDirn;
        var currentSurvSeq = parseInt($stateParams.sectionIdx);
        if (surveyState.staus !== 403) {
            vm.survey = surveyState.activeSurvey;
            vm.section = $filter('filter')(vm.survey.sections, {
                sequence: currentSurvSeq
            }, true)[0];
            vm.elemValidationMsgs = surveyState.elemValidationMsgs;
        }
        var references = $rootScope.referenceData;
        var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
        var fullDateFormat = references.DATE_FORMT_CD.refItems.filter(function(refData) {
            return (refData.cd === prefDateFormat);
        });
        vm.dateFormat = fullDateFormat[0].nm;
        vm.datePlaceholder = vm.dateFormat;
        vm.dateMask = vm.dateFormat.replace('MM', '99').replace('DD', '99').replace('YYYY', '9999');

        //datepicker options
        $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
        $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = vm.dateFormat.toLowerCase();
        $.fn.datepicker.defaults.todayHighlight = true;
        $.fn.datepicker.defaults.autoclose = true; //close the datepicker immediately when a date is selected
        $.fn.datepicker.defaults.showOnFocus = false; //show the datepicker when the input field associated with it receives focus

        vm.showSectionHelp = false;
        vm.showQuestionHelp = (sessionStorage.getItem('showQuestionHelp') === 'true');
        vm.toggleSectionHelp = function() {
            vm.showSectionHelp = !vm.showSectionHelp;
        };
        vm.toggleQuestionHelp = function() {
            vm.showQuestionHelp = !vm.showQuestionHelp;
            sessionStorage.setItem('showQuestionHelp', vm.showQuestionHelp);
        };

        vm.updtSurvActnHdr = function() {
            return $translate.instant('surv.updtSurv.tabl.actnsHeader');
        };

        if (vm.section) {
            var canValidateReqd = {};

            //sort questions in a section
            vm.section.questions.sort(function(a, b) {
                return a.questSeq - b.questSeq;
            });

            if (typeof(vm.section.sectionName) === 'string') {
                vm.section.sectionName = $sce.trustAsHtml(vm.section.sectionName);
            }
            if (typeof(vm.section.sectionDesc) === 'string') {
                vm.section.sectionDesc = $sce.trustAsHtml(vm.section.sectionDesc);
            }
            if (typeof(vm.section.sectionInstrs) === 'string') {
                vm.section.sectionInstrs = $sce.trustAsHtml(vm.section.sectionInstrs);
            }

            //sort and group elements into rows within a question
            angular.forEach(vm.section.questions, function(question) {
                if (typeof(question.questText) === 'string') {
                    question.questText = (question.questText) ? $sce.trustAsHtml(question.questText) : '';
                }
                if (typeof(question.questHelpText) === 'string') {
                    question.questHelpText = (question.questHelpText) ? $sce.trustAsHtml(question.questHelpText) : '';
                }

                question.rows = [];
                question.elements.sort(function(a, b) {
                    if (a.rowSeq === b.rowSeq) {
                        return a.elemSeq - b.elemSeq;
                    }
                    return a.rowSeq - b.rowSeq;
                });
                var currRowSeq = question.elements[0].rowSeq;
                var elements = [];
                angular.forEach(question.elements, function(element) {
                    element.questSeq = question.questSeq;  //add questionSeq to each element so we know which question to update on a change
                    if (element.dispLabel && (!element.labelPosnCd || !(element.labelPosnCd === 'TOP' || element.labelPosnCd === 'BOTTOM' || element.labelPosnCd === 'LEFT' || element.labelPosnCd === 'RIGHT'))) {
                        //set position to TOP if not specified
                        element.labelPosnCd = 'TOP';
                    }
                    if (element.dispLabel && (element.labelPosnCd === 'LEFT' || element.labelPosnCd === 'RIGHT')) {
                        //if elem width = 1 then no room for label so set dispLabel to false
                        if (element.elemWidth === 1) {
                            element.dispLabel = false;
                        }
                        //set width to 50% of elem width if not specified
                        if (!element.labelWidth) {
                            element.labelWidth = Math.floor(element.elemWidth / 2);
                        }
                        //labelWidth must be smaller than elem width
                        if (element.labelWidth >= element.elemWidth) {
                            element.labelWidth = element.elemWidth - 1;
                        }
                    }
                    if (element.rowSeq === currRowSeq) {
                        elements.push(element);
                    } else {
                        question.rows.push({
                            rowSeq: currRowSeq,
                            elements: elements
                        });
                        currRowSeq = element.rowSeq;
                        elements = [element];
                    }
                    //sort child elements by tabSeq
                    if (element.childElements) {
                        element.childElements.sort(function(a, b) {
                            return a.elemTabSeq - b.elemTabSeq;
                        });
                    }
                    //sort elemopts
                    if (element.elemOpts) {
                        element.elemOpts.sort(function(a, b) {
                            return a.elemOptSeq - b.elemOptSeq;
                        });
                    }

                    angular.forEach(element.elemOpts, function(opt) {
                        if (typeof(opt.label) === 'string') {
                            opt.trustedLabel = $sce.trustAsHtml(opt.label);
                        } else {
                            opt.trustedLabel = opt.label;
                        }
                    });
                });
                question.rows.push({
                    rowSeq: currRowSeq,
                    elements: elements
                });
                //sort elements array by tabSeq so can assign tabIndex
                question.elements.sort(function(a, b) {
                    if (a.elemTabSeq === b.elemTabSeq) {
                        return a.rowSeq - b.rowSeq;
                    }
                    return a.elemTabSeq - b.elemTabSeq;
                });
            });
            var ddcbElements = [];
            var dateElements = [];
            var chbxElements = [];
            var sldrElements = [];
            var tablElements = [];
            angular.forEach(vm.section.questions, function(question) {
                ddcbElements = ddcbElements.concat($filter('filter')(question.elements, {
                    elemInputTypeCd: 'DDCB'
                }, true));
                chbxElements = chbxElements.concat($filter('filter')(question.elements, {
                    elemInputTypeCd: 'CHBX'
                }, true));
                dateElements = dateElements.concat($filter('filter')(question.elements, {
                    elemInputTypeCd: 'DATE'
                }, true));
                sldrElements = sldrElements.concat($filter('filter')(question.elements, {
                    elemInputTypeCd: 'SLDR'
                }, true));
                tablElements = tablElements.concat($filter('filter')(question.elements, {
                    elemInputTypeCd: 'TABL'
                }, true));
            });

            vm.answeredElements = surveyState.answers.answerMap;
            vm.comments = surveyState.answers.commentMap;
            $rootScope.isSurveyDirty = false;

            vm.visibleSectionElements = $filter('filter')(surveyState.subjectSurvey.sections, {
                seq: vm.section.sequence
            }, true)[0].visibleElements;
            vm.pendingSectionElements = $filter('filter')(surveyState.subjectSurvey.sections, {
                seq: vm.section.sequence
            }, true)[0].pendingElements;
            vm.naSectionElements = $filter('filter')(surveyState.subjectSurvey.sections, {
                seq: vm.section.sequence
            }, true)[0].naElements;
            var hiddenElements = [];
            angular.forEach(surveyState.subjectSurvey.sections, function(section) {
                hiddenElements = hiddenElements.concat(section.hiddenElements);
            });

            vm.visibleSectionQuestions = function() {
                var visibleQuestions = [];
                angular.forEach(vm.section.questions, function(question) {
                    var visible = true;
                    angular.forEach(question.elements, function(element) {
                        if (vm.visibleSectionElements.indexOf(element.elemId) < 0) {
                            visible = false;
                        }
                    });
                    if (visible) {
                        visibleQuestions.push(question.questSeq);
                    }
                });
                return visibleQuestions;
            };

            vm.pendingSectionQuestions = function() {
                var pendingQuestions = [];
                angular.forEach(vm.section.questions, function(question) {
                    var visible = true;
                    angular.forEach(question.elements, function(element) {
                        if (vm.visibleSectionElements.indexOf(element.elemId) < 0) {
                            visible = false;
                        }
                    });
                    if (!visible) {
                        var pending = true;
                        angular.forEach(question.elements, function(element) {
                            if (vm.pendingSectionElements.indexOf(element.elemId) < 0) {
                                pending = false;
                            }
                        });
                        if (pending) {
                            pendingQuestions.push(question.questSeq);
                        }
                    }
                });
                return pendingQuestions;
            };

            vm.naSectionQuestions = function() {
                var naQuestions = [];
                angular.forEach(vm.section.questions, function(question) {
                    var visible = true;
                    angular.forEach(question.elements, function(element) {
                        if (vm.visibleSectionElements.indexOf(element.elemId) < 0) {
                            visible = false;
                        }
                    });
                    if (!visible) {
                        var na = false;
                        angular.forEach(question.elements, function(element) {
                            if (vm.pendingSectionElements.indexOf(element.elemId) < 0) {
                                na = true;
                            }
                        });
                        if (na) {
                            naQuestions.push(question.questSeq);
                        }
                    }
                });
                return naQuestions;
            };

            vm.isQuestionHidden = function(seq) {
                return vm.visibleSectionQuestions().indexOf(seq) < 0
                    && (
                        (sysParms.data.SURV_DISP_PENDG_QUESTS_FLAG === 'FALSE' && vm.pendingSectionQuestions().indexOf(seq) >= 0)
                        || (sysParms.data.SURV_DISP_NA_QUESTS_FLAG === 'FALSE' && vm.naSectionQuestions().indexOf(seq) >= 0)
                    );
            };

            vm.isNextQuestionHidden = function(seq) {
                return vm.isQuestionHidden(seq + 1);
            };

            vm.isLastStep = function(seq) {
                if (seq === vm.section.questions.length) {
                    return true;
                }
                for (var i = seq; i < vm.section.questions.length; i++) {
                    if (!vm.isNextQuestionHidden(i)) {
                        return false;
                    }
                }
                return true;
            };

            vm.currentQuestionSeq = vm.visibleSectionQuestions()[0];
            vm.currentQuestion = $filter('filter')(vm.section.questions, {questSeq: vm.currentQuestionSeq})[0];
            vm.previousQuestionSeq = vm.currentQuestionSeq;

            vm.setSurveyQuestion = function(seq) {
                var currentQuestionIdx = vm.visibleSectionQuestions().findIndex(function(questSeq) {
                    return questSeq === seq;
                });
                vm.visibleSectionQuestions().forEach(function(questSeq, index) {
                    if (index === parseInt(currentQuestionIdx)) {
                        vm.currentQuestion = $filter('filter')(vm.section.questions, {questSeq: questSeq})[0];
                    }
                });
            };

            function focusFirstOrSelected(question) {
                if (question && question.elements && question.elements.length > 0) {
                    question.elements.sort(function(a, b) {
                        if (a.rowSeq === b.rowSeq) {
                            return a.elemSeq - b.elemSeq;
                        }
                        return a.rowSeq - b.rowSeq;
                    });

                    // Select first element of a each question upon becoming current
                    if (question.elements[0].childElements) {
                        question.elements[0].childElements.sort(function(a, b) {
                            if (a.rowSeq === b.rowSeq) {
                                return a.elemSeq - b.elemSeq;
                            }
                            return a.rowSeq - b.rowSeq;
                        });
                        $('#q-' + question.questSeq + '-el-' + question.elements[0].childElements[0].elemId + '-row-0' + '-' + question.elements[0].childElements[0].elemInputTypeCd).focus();
                    }
                    $('#q-' + question.questSeq + '-el-' + question.elements[0].elemId + '-' + question.elements[0].elemInputTypeCd).focus();

                    // for VTRB and HZRB if one is already selected, focus that instead of the first option, otherwise first option
                    if (question.elements[0].elemInputTypeCd === 'VTRB' || question.elements[0].elemInputTypeCd === 'HZRB') {
                        var optionSelector;
                        var elType = (question.elements[0].elemInputTypeCd === 'VTRB') ? '-VTRB' : '-HZRB';
                        if (vm.answeredElements[question.elements[0].elemId]) {
                            angular.forEach(question.elements[0].elemOpts, function(elemOpt, optIdx) {
                                if (vm.answeredElements[question.elements[0].elemId] === elemOpt.value) {
                                    optionSelector = '#q-' + question.questSeq + '-el-' + optIdx + elType;
                                    $(optionSelector).focus();
                                }
                            });
                        } else {
                            optionSelector = '#q-' + question.questSeq + '-el-0' + elType;
                            $(optionSelector).focus();
                        }
                    }

                    // for SLDR focus on the pointer
                    if (question.elements[0].elemInputTypeCd === 'SLDR') {
                        $('#q-' + question.questSeq + '-el-' + question.elements[0].elemId + '-' + question.elements[0].elemInputTypeCd + ' span.rz-pointer.rz-pointer-min').focus();
                    }
                }
            }

            $(document).ready(function() {
                $timeout(function() {
                    focusFirstOrSelected(vm.currentQuestion);
                    $scope.$watch('vm.currentQuestionSeq', function(newSeq) {
                        var question = $filter('filter')(vm.section.questions, {
                            questSeq: newSeq
                        })[0];
                        $timeout(function() {
                            focusFirstOrSelected(question);
                        }, 1000);
                    }, true);
                }, 1000);
            });

            vm.stepWidth = 119;
            vm.navScrollPos = 0;

            var otherSurveys = [];
            angular.forEach(surveyState.otherSurveys, function(surv) {
                otherSurveys.push({
                    survTypeCd: surv.survTypeCd,
                    survVersSeq: surv.survVersSeq
                });
            });

            $rootScope.pageSubtitle = vm.survey.survTypeName;
            $rootScope.pageSubtitleDesc = vm.survey.survTypeDesc;
            $rootScope.breadcrumb = vm.section.sectionName;

            vm.getViewOnlyAnswer = function(elem) {
                if (elem.elemOpts && elem.elemOpts.length > 0) {
                    return $filter('filter')(elem.elemOpts, {
                        value: vm.answeredElements[elem.elemId]
                    }, true)[0].label;
                }
                if (elem.elemDataTypeCd === 'DATE') {
                    return $filter('shortDateFormat')(vm.answeredElements[elem.elemId]);
                }
                return vm.addDisplayMask(vm.answeredElements[elem.elemId], elem.elemDataTypeCd, elem.elemDispMask);
            };

            vm.getViewOnlyAnswerChild = function(elem, childElem, index) {
                var value = vm.tablModel[elem.elemId][index][childElem.elemId];
                if (childElem.elemInputTypeCd === 'DDLB') {
                    return $filter('filter')(childElem.elemOpts, {
                        value: value
                    }, true)[0].label;
                }
                if (childElem.elemInputTypeCd === 'DDCB') {
                    return value.label;
                }
                if (elem.elemDataTypeCd === 'DATE') {
                    return $filter('shortDateFormat')(value);
                }
                return vm.addDisplayMask(value, childElem.elemDataTypeCd, childElem.elemDispMask);
            };

            vm.addDisplayMask = function(elemValue, dataTypeCd, dispMask) {
                if (dispMask) {
                    if (dataTypeCd === 'ANUM') {
                        var placeHolderChar = '#';
                        var ValueChar = '*';
                        var aValue = elemValue.split('');
                        var aMask = dispMask.split('');
                        var retValue = '';
                        var maskCharPos = -1;
                        angular.forEach(aMask, function(maskChar) {
                            if (maskChar === ValueChar) {
                                maskCharPos += 1;
                                retValue += (aValue[maskCharPos]) ? aValue[maskCharPos] : ' ';
                            } else if (maskChar === placeHolderChar) {
                                maskCharPos += 1;
                                retValue += '*';
                            } else {
                                retValue += maskChar;
                            }
                        });
                        return retValue;
                    }
                    if (dataTypeCd === 'NUM') {
                        var prefix = getPrefix(dispMask) || '';
                        var suffix = getSuffix(dispMask) || '';
                        return prefix + numeral(elemValue).format(dispMask.replace(/{[^}]*}/g, '')) + suffix;
                    }
                }
                return elemValue;
            };

            function getPrefix(dispMask) {
                var prefix;
                var prefixStartIdx = dispMask.indexOf('{');
                var prefixEndIdx = dispMask.indexOf('}');
                if (prefixStartIdx !== -1 && prefixStartIdx < 1 && prefixEndIdx !== -1 && dispMask.substring(prefixStartIdx - 1, 0) === '') {
                    prefix = dispMask.substring(prefixStartIdx + 1, prefixEndIdx);
                }
                return prefix;
            }

            function getSuffix(dispMask) {
                var suffix;
                var suffixStartIdx = dispMask.lastIndexOf('{');
                var suffixEndIdx = dispMask.lastIndexOf('}');

                if (suffixStartIdx !== -1 && suffixStartIdx > 1 && suffixEndIdx !== -1) {
                    suffix = dispMask.substring(suffixStartIdx + 1, suffixEndIdx);
                }
                return suffix;
            }

            $scope.$watch('vm.answeredElements', onAnsweredElements, true);
            $scope.$watch('vm.comments', onAnsweredComment, true);

            vm.isQuestionAnswered = function(question) {
                var questHasInvalidElem = false;
                var questHasReqdElem = false;
                var questHasUnansweredReqdElem = false;
                var questHasAnsweredElem = false;
                angular.forEach(question.elements, function(element) {
                    if (vm.elemValidationMsgs && vm.elemValidationMsgs[element.elemId]) {
                        questHasInvalidElem = true;
                    }
                    if (element.elemReqd) {
                        questHasReqdElem = true;
                        if (!isElementAnswered(element)) {
                            questHasUnansweredReqdElem = true;
                        }
                    }
                    if (isElementAnswered(element)) {
                        questHasAnsweredElem = true;
                    }
                });
                if (questHasInvalidElem) {
                    //any validation errors cause question to be not answered
                    return false;
                }
                if (question.inclAddlCommt && question.addlCommtReqd) {
                    questHasReqdElem = true;
                    if (!vm.comments[question.questId]) {
                        questHasUnansweredReqdElem = true;
                    }
                }
                if (question.inclAddlCommt && vm.comments[question.questId]) {
                    questHasAnsweredElem = true;
                }

                if (questHasReqdElem) {
                    return !questHasUnansweredReqdElem;
                }
                return questHasAnsweredElem;
            };

            function isElementAnswered(element) {
                if (element.elemDataTypeCd.includes('[') && element.elemDataTypeCd.includes(']')) {
                    var allRowsAnswered = true; //start with true and set false if a row is not answered
                    if (vm.answeredElements[element.elemId]) { //ignore NULLs
                        angular.forEach(JSON.parse(vm.answeredElements[element.elemId]), function(row) {
                            if (!checkAllValues(element, row)) {
                                allRowsAnswered = false;
                            }
                        });
                    }
                    return allRowsAnswered;
                }
                if (element.elemDataTypeCd === 'OBJ') {
                    return checkAllValues(element, JSON.parse(vm.answeredElements[element.elemId]));
                }
                return checkAllValues(element, vm.answeredElements[element.elemId]);
            }

            function checkAllValues(element, value) {
                if (element.elemDataTypeCd.includes('OBJ')) {
                    var oneChildAnswered = false;
                    var reqdChildrenAnswered = true;  //start off true and set to false
                    angular.forEach(element.childElements, function(childElement) {
                        var checkVal = checkValue(childElement.elemInputTypeCd, value[childElement.elemId]);
                        if (checkVal) {
                            oneChildAnswered = true;
                        } else if (childElement.elemReqd) {
                            reqdChildrenAnswered = false;
                        }
                    });
                    return oneChildAnswered && reqdChildrenAnswered;
                }
                return checkValue(element.elemInputTypeCd, value);
            }

            function checkValue(elemInputTypeCd, value) {
                return (elemInputTypeCd !== 'CHBX' && (value || value === 0))
                    || (elemInputTypeCd === 'CHBX' && value && value === 'true');
            }

            vm.getSurveyFormTabIndex = function(elemId, childElemId, rowIndex) {
                var i = 1;
                var tabIndex;
                angular.forEach(vm.section.questions, function(question) {
                    angular.forEach(question.elements, function(element) {
                        if (element.elemId === elemId) {
                            if (childElemId) {
                                if (rowIndex) {
                                    i += rowIndex * element.childElements.length;
                                }
                                angular.forEach(element.childElements, function(childElement) {
                                    if (childElement.elemId === childElemId) {
                                        tabIndex = i;
                                    }
                                    i++;
                                });
                            } else if (rowIndex) {
                                tabIndex = i + rowIndex;
                            } else {
                                tabIndex = i;
                            }
                        } else {
                            i += incrementTabIndex(element);
                        }
                    });
                });
                return tabIndex;
            };

            function incrementTabIndex(element) {
                if (element.elemDataTypeCd.contains('[') && element.elemDataTypeCd.contains(']')) {
                    if (element.elemDataTypeCd.contains('OBJ')) {
                        if (vm.answeredElements[element.elemId]) {
                            return element.childElements.length * JSON.parse(vm.answeredElements[element.elemId]).length;
                        }
                        return element.childElements.size();
                    } else if (vm.answeredElements[element.elemId]) {
                        return JSON.parse(vm.answeredElements[element.elemId].length);
                    }
                    return 1;
                } else if (element.elemDataTypeCd.contains('OBJ')) {
                    return element.childElements.size();
                }
                return 1;
            }

            vm.getStepTooltip = function(question) {
                var qState;
                if (vm.isQuestionAnswered(question)) {
                    qState = $translate.instant('surv.home.qAnswdText');
                } else if (vm.pendingSectionQuestions().indexOf(question.questSeq) >= 0) {
                    qState = $translate.instant('surv.home.qPendgText');
                } else if (vm.naSectionQuestions().indexOf(question.questSeq) >= 0) {
                    qState = $translate.instant('surv.home.qNAText');
                } else {
                    qState = $translate.instant('surv.home.qOpenText');
                }
                return $translate.instant('surv.home.qText', {
                    questSeq: question.questSeq
                }) + qState;
            };

            vm.addTableRow = function(element) {
                if (!vm.tablModel[element.elemId]) {
                    vm.tablModel[element.elemId] = [];
                }
                vm.tablModel[element.elemId].push({});
                if (!vm.answeredElements[element.elemId]) {
                    vm.answeredElements[element.elemId] = '[{}]';
                } else {
                    var json = JSON.parse(vm.answeredElements[element.elemId]);
                    json.push({});
                    vm.answeredElements[element.elemId] = JSON.stringify(json);
                }
            };

            vm.isTablDeleteBtnDisabled = function(element) {
                if (vm.updateEnabled && element.elemReqd) {
                    return (JSON.parse(vm.answeredElements[element.elemId]).length === 1);
                }
                return false;
            };

            vm.deleteTableRow = function(element, index) {
                vm.subElemNaNErrors[element.elemId].splice(index, 1);
                vm.subElemFormatErrors[element.elemId].splice(index, 1);

                vm.tablModel[element.elemId].splice(index, 1);
                if (vm.tablModel[element.elemId].length === 0) {
                    vm.answeredElements[element.elemId] = null;
                } else {
                    var json = JSON.parse(vm.answeredElements[element.elemId]);
                    json.splice(index, 1);
                    vm.answeredElements[element.elemId] = JSON.stringify(json);
                }
            };

            //set model for answered ddcb elements
            vm.ddcbModel = [];
            angular.forEach(ddcbElements, function(ddcbElement) {
                vm.ddcbModel[ddcbElement.elemId] = generateDdcbModel(ddcbElement, vm.answeredElements[ddcbElement.elemId]);
            });

            //set model for answered checkbox elements
            vm.chbxModel = [];
            angular.forEach(chbxElements, function(chbxElement) {
                if (vm.answeredElements[chbxElement.elemId]) {
                    vm.chbxModel[chbxElement.elemId] = JSON.parse(vm.answeredElements[chbxElement.elemId]); // values are "true" or "false" so need to parse to boolean
                }
            });

            //set model for answered date elements
            vm.dateModel = [];
            angular.forEach(dateElements, function(dateElement) {
                if (vm.answeredElements[dateElement.elemId]) {
                    vm.dateModel[dateElement.elemId] = moment(vm.answeredElements[dateElement.elemId], 'YYYY-MM-DD').format(vm.dateFormat);
                }
            });

            //set slider model and options
            vm.sldrModel = [];
            vm.sldrOpts = [];
            var sldrNullValues = [];
            var sldrNullElemValues = [];
            var sldrNull = [];
            angular.forEach(sldrElements, function(sldrElement) {
                sldrNull[sldrElement.elemId] = false;
                if (sldrElement.elemOpts && sldrElement.elemOpts.length > 0) {
                    vm.sldrModel[sldrElement.elemId] = $filter('filter')(sldrElement.elemOpts, {
                        value: vm.answeredElements[sldrElement.elemId]
                    }, true)[0].label;
                    var steps = [];
                    angular.forEach(sldrElement.elemOpts, function(elemOpt) {
                        steps.push({
                            value: elemOpt.label
                        });
                    });
                    sldrNullValues[sldrElement.elemId] = sldrElement.elemOpts[0].label;
                    sldrNullElemValues[sldrElement.elemId] = $filter('filter')(sldrElement.elemOpts, {
                        label: sldrNullValues[sldrElement.elemId]
                    }, true)[0].value;
                    vm.sldrOpts[sldrElement.elemId] = {
                        showTicks: true,
                        stepsArray: steps,
                        onEnd: function(sliderId, modelValue) {
                            if (sldrNull[sldrElement.elemId]) {
                                delete vm.answeredElements[sldrElement.elemId];
                            } else {
                                //convert label to elem Opt
                                vm.answeredElements[sldrElement.elemId] = $filter('filter')(sldrElement.elemOpts, {
                                    label: modelValue
                                }, true)[0].value;
                            }
                            $rootScope.isSurveyDirty = true;
                            sldrNull[sldrElement.elemId] = false;
                        }
                    };
                } else {
                    vm.sldrModel[sldrElement.elemId] = (vm.answeredElements[sldrElement.elemId]) ? parseInt(vm.answeredElements[sldrElement.elemId], 10) : 0;
                    sldrNullValues[sldrElement.elemId] = 0;
                    sldrNullElemValues[sldrElement.elemId] = 0;
                    vm.sldrOpts[sldrElement.elemId] = {
                        floor: 0,
                        ceil: 100,
                        onEnd: function(sliderId, modelValue) {
                            if (sldrNull[sldrElement.elemId]) {
                                delete vm.answeredElements[sldrElement.elemId];
                            } else {
                                vm.answeredElements[sldrElement.elemId] = modelValue;
                            }
                            $rootScope.isSurveyDirty = true;
                            sldrNull[sldrElement.elemId] = false;
                        }
                    };
                }
                vm.sldrOpts[sldrElement.elemId].showSelectionBar = true;
                vm.sldrOpts[sldrElement.elemId].disabled = !vm.updateEnabled;
            });

            vm.onSldrKeyup = function(event, elemId) {
                //if vm.answeredElements[elemId] has a value then slider is enabled, so disable by setting sldrNull to true and value to sldrNullValues (and then onEnd event will set vm.answeredElements
                //else slider is disabled so enable by setting vm.answeredElements.  Do not set sldrModel so as not to fire onEnd event
                if (event.keyCode === 32) {
                    if (vm.answeredElements[elemId] !== undefined) {
                        sldrNull[elemId] = true;
                        vm.sldrModel[elemId] = sldrNullValues[elemId];
                    } else {
                        vm.answeredElements[elemId] = sldrNullElemValues[elemId];
                    }
                }
            };

            //set model for answered table elements
            vm.tablModel = [];
            angular.forEach(tablElements, function(tablElement) {
                if (tablElement.childElements && tablElement.childElements.length > 0) {
                    var tablModelData = [];
                    var tableRows = 0;
                    if (vm.answeredElements[tablElement.elemId]) {
                        var tableData = JSON.parse(vm.answeredElements[tablElement.elemId]);
                        tableRows = tableData.length;
                        for (var row = 0; row < tableRows; row++) {
                            var tableRowData = [];
                            angular.forEach(tablElement.childElements, function(childElement) {
                                var cellValue = tableData[row][childElement.elemId];
                                if (cellValue) {
                                    if (childElement.elemInputTypeCd === 'DDCB') {
                                        tableRowData[childElement.elemId] = generateDdcbModel(childElement, cellValue);
                                    } else if (childElement.elemInputTypeCd === 'DATE') {
                                        tableRowData[childElement.elemId] = moment(cellValue, 'YYYY-MM-DD').format(vm.dateFormat);
                                    } else {
                                        tableRowData[childElement.elemId] = cellValue;
                                    }
                                }
                            });
                            tablModelData.push(tableRowData);
                        }
                    }
                    vm.tablModel[tablElement.elemId] = tablModelData;
                    if (tableRows === 0 && tablElement.elemReqd) {
                        vm.addTableRow(tablElement);
                    }
                }
            });

            function generateDdcbModel(element, value) {
                if (value) {
                    var opt = $filter('filter')(element.elemOpts, {
                        value: value
                    })[0];
                    return {
                        value: opt.value,
                        label: opt.label
                    };
                }
                return {};
            }

            //on change events
            vm.onDdcbSelect = function(element, item) {
                vm.answeredElements[element.elemId] = item.value;
                $rootScope.isSurveyDirty = true;
            };

            vm.notInListErrors = {};
            vm.onDdcbChange = function(element, el) {
                $timeout(function() {
                    $scope.$apply(function() {
                        if (vm.ddcbModel[element.elemId] === '') {
                            vm.answeredElements[element.elemId] = null;
                            delete vm.notInListErrors[element.elemId];
                        }
                        if (el.noResults) {
                            vm.notInListErrors[element.elemId] = true;
                        } else {
                            delete vm.notInListErrors[element.elemId];
                        }
                        $rootScope.isSurveyDirty = true;
                    });
                });
            };

            vm.onChbxChange = function(element) {
                vm.answeredElements[element.elemId] = vm.chbxModel[element.elemId].toString();
                $rootScope.isSurveyDirty = true;
            };

            vm.onDateValueChange = function(newValue, element) {
                if (element && element.elemId) {
                    var isDateValid = moment(newValue, vm.dateFormat, true).isValid();
                    if (isDateValid) {
                        vm.dateModel[element.elemId] = newValue;
                        vm.answeredElements[element.elemId] = moment(newValue, vm.dateFormat).format('YYYY-MM-DD');
                    } else {
                        vm.answeredElements[element.elemId] = null;
                    }
                    $rootScope.isSurveyDirty = true;
                }
            };

            vm.onTablDateValueChange = function(elemId, childElement, index, value) {
                var json = JSON.parse(vm.answeredElements[elemId]);
                var isDateValid = moment(value, vm.dateFormat, true).isValid();
                if (value === '' || value === vm.dateFormat) {
                    delete json[index][childElement.elemId];
                } else if (isDateValid) {
                    json[index][childElement.elemId] = moment(value, vm.dateFormat).format('YYYY-MM-DD');
                }
                vm.answeredElements[elemId] = JSON.stringify(json);
                $rootScope.isSurveyDirty = true;
            };

            vm.onTablDdcbSelect = function(element, childElement, index, item) {
                var json = JSON.parse(vm.answeredElements[element.elemId]);
                json[index][childElement.elemId] = item.value;
                vm.answeredElements[element.elemId] = JSON.stringify(json);
                $rootScope.isSurveyDirty = true;
            };

            vm.childNotInListErrors = {};
            vm.onTablDdcbChange = function(element, childElement, index, el) {
                $timeout(function() {
                    $scope.$apply(function() {
                        var json = JSON.parse(vm.answeredElements[element.elemId]);
                        if (vm.tablModel[element.elemId][index][childElement.elemId] === '') {
                            //remove answer
                            delete json[index][childElement.elemId];
                            vm.answeredElements[element.elemId] = JSON.stringify(json);
                            //remove error
                            if (vm.childNotInListErrors[element.elemId] && vm.childNotInListErrors[element.elemId][index]) {
                                delete vm.childNotInListErrors[element.elemId][index][childElement.elemId];
                            }
                        }

                        if (el.noResults) {
                            if (!vm.childNotInListErrors[element.elemId]) {
                                vm.childNotInListErrors[element.elemId] = [];
                            }
                            if (!vm.childNotInListErrors[element.elemId][index]) {
                                vm.childNotInListErrors[element.elemId][index] = {};
                            }
                            //add error
                            vm.childNotInListErrors[element.elemId][index][childElement.elemId] = true;
                        } else if (vm.childNotInListErrors[element.elemId] && vm.childNotInListErrors[element.elemId][index]) {
                             //remove error
                            delete vm.childNotInListErrors[element.elemId][index][childElement.elemId];
                        }
                        $rootScope.isSurveyDirty = true;
                    });
                });
            };

            vm.onTablChbxChange = function(element, childElement, index) {
                var json = JSON.parse(vm.answeredElements[element.elemId]);
                json[index][childElement.elemId] = vm.tablModel[element.elemId][index][childElement.elemId].toString();
                vm.answeredElements[element.elemId] = JSON.stringify(json);
                $rootScope.isSurveyDirty = true;
            };

            vm.onTablChange = function(element, childElement, index) {
                var json = JSON.parse(vm.answeredElements[element.elemId]);
                var value = vm.tablModel[element.elemId][index][childElement.elemId];
                if (value === '') {
                    delete json[index][childElement.elemId];
                } else {
                    json[index][childElement.elemId] = value;
                }
                vm.answeredElements[element.elemId] = JSON.stringify(json);
                $rootScope.isSurveyDirty = true;
            };

            vm.onElementChange = function() {
                $rootScope.isSurveyDirty = true;
            };

            vm.slideLeftRight = function(seq, inc) {
                vm.setSurveyQuestion(seq);
                vm.currentQuestionSeq = seq;
                var visQuestIdx = 0;
                angular.forEach(vm.section.questions, function(question) {
                    if (question.questSeq <= seq && !vm.isQuestionHidden(question.questSeq)) {
                        visQuestIdx++;
                    }
                });
                var midPoint = (vm.stepWidth / 3) - 20;
                var scrollPos = visQuestIdx * vm.stepWidth;
                $('.steps-indicator').animate({
                    scrollLeft: scrollPos - ((vm.stepWidth * 4) + midPoint)
                }, 1000);
                vm.previousQuestionSeq = seq;
                vm.fadeDirn = (inc < 0) ? 'l' : 'r';
            };

            vm.incrementQuestion = function(questSeq, inc) {
                $timeout(function() {
                    var toIndex = vm.visibleSectionQuestions().indexOf(questSeq) + inc;
                    var toQuestSeq = vm.visibleSectionQuestions()[toIndex];
                    if (toQuestSeq) {
                        vm.gotoQuestion(toQuestSeq, inc);
                    }
                }, 500);
            };

            vm.formatErrors = {};
            vm.NaNErrors = {};
            vm.subElemFormatErrors = {};
            vm.subElemNaNErrors = {};

            function loopErrors(errorList, elem) {
                for (var i = 0; i < errorList.length; i++) {
                    var key = errorList[i];
                    if (parseInt(elem.elemId) === parseInt(key)) {
                        vm.freezeOps = true;
                        return false;
                    }
                }
            }

            function loopChildErrors(errorList) {
                if (errorList) {
                    for (var i = 0; i < errorList.length; i++) {
                        var row = errorList[i];
                        if (Object.keys(row).length > 0) {
                            vm.freezeOps = true;
                            return false;
                        }
                    }
                }
            }

            vm.validateFields = function() {
                vm.freezeOps = false;
                var question = $filter('filter')(vm.section.questions, {
                    questSeq: vm.currentQuestionSeq
                })[0];
                validateRequiredFlds(question);
                for (var i = 0; i < question.elements.length; i++) {
                    var elem = question.elements[i];
                    if (elem) {
                        //check vm.formatErrors
                        loopErrors(Object.keys(vm.formatErrors), elem);
                        //check vm.NaNErrors
                        loopErrors(Object.keys(vm.NaNErrors), elem);
                        //check vm.notInListErrors
                        loopErrors(Object.keys(vm.notInListErrors), elem);
                        //check vm.subElemFormatErrors
                        if (vm.subElemFormatErrors[elem.elemId]) { //errorInThisStep
                            loopChildErrors(vm.subElemFormatErrors[elem.elemId]);
                        }
                        //check vm.subElemNaNErrors
                        if (vm.subElemNaNErrors[elem.elemId]) { //errorInThisStep
                            loopChildErrors(vm.subElemNaNErrors[elem.elemId]);
                        }
                        //check vm.childNotInListErrors
                        if (vm.childNotInListErrors[elem.elemId]) { //errorInThisStep
                            loopChildErrors(vm.childNotInListErrors[elem.elemId]);
                        }
                        //check vm.elemValidationMsgs
                        loopErrors(Object.keys(vm.elemValidationMsgs), elem);
                        if (vm.freezeOps) {
                            return false;
                        }
                    }
                }
            };

            function validateRequiredFlds(question) {
                vm.requiredElementErrors = {};
                vm.requiredCommentErrors = {};
                vm.requiredSubElementErrors = {};
                if (canValidateReqd[question.questId]) {
                    angular.forEach(question.elements, function(element) {
                        if (element.elemReqd && (vm.answeredElements[element.elemId] === undefined || vm.answeredElements[element.elemId] === '')) {
                            vm.requiredElementErrors[element.elemId] = true;
                        } else {
                            delete vm.requiredElementErrors[element.elemId];
                        }
                    });
                    vm.requiredCommentErrors[question.questId] = (question.inclAddlCommt && question.addlCommtReqd && !vm.comments[question.questId]);
                    angular.forEach(tablElements, function(tablElement) {
                        if (tablElement.childElements && tablElement.childElements.length > 0) {
                            var tableRows = 0;
                            if (vm.answeredElements[tablElement.elemId] && vm.answeredElements[tablElement.elemId] !== '[{}]') {
                                if (!vm.requiredSubElementErrors[tablElement.elemId]) {
                                    vm.requiredSubElementErrors[tablElement.elemId] = {};
                                }
                                var tableData = JSON.parse(vm.answeredElements[tablElement.elemId]);
                                tableRows = tableData.length;
                                for (var row = 0; row < tableRows; row++) {
                                    if (!vm.requiredSubElementErrors[tablElement.elemId][row]) {
                                        vm.requiredSubElementErrors[tablElement.elemId][row] = [];
                                    }
                                    angular.forEach(tablElement.childElements, function(childElement) {
                                        var cellValue = tableData[row][childElement.elemId];
                                        if (childElement.elemReqd && (cellValue === undefined || cellValue === '')) {
                                            vm.requiredSubElementErrors[tablElement.elemId][row][childElement.elemId] = true;
                                        } else {
                                            delete vm.requiredSubElementErrors[tablElement.elemId][row][childElement.elemId];
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            }

            vm.gotoQuestion = function(seq, inc) {
                if (vm.visibleSectionQuestions().indexOf(seq) >= 0) { //only switch to visible questions
                    if (vm.updateEnabled) {
                        updateSurvey().then(function() {
                            if (!vm.freezeOps) {
                                vm.slideLeftRight(seq, inc);
                                handleCheckBxs();
                                //validate required question fields
                                var question = $filter('filter')(vm.section.questions, {
                                    questSeq: seq
                                })[0];
                                checkQuestionForReqdValidation(question);
                            }
                        });
                    } else {
                        vm.slideLeftRight(seq, inc);
                    }
                }
            };

            checkQuestionForReqdValidation(vm.section.questions[0]);
            function checkQuestionForReqdValidation(question) {
                canValidateReqd[question.questId] = (question.inclAddlCommt && !!vm.comments[question.questId]);
                if (!canValidateReqd[question.questId]) {
                    angular.forEach(question.elements, function(element) {
                        if (vm.answeredElements[element.elemId]) {
                            canValidateReqd[question.questId] = true;
                        }
                    });
                }
            }

            vm.isFirstVisibleQuestion = function(questSeq) {
                var ret = true;
                angular.forEach(vm.section.questions, function(q) {
                    if (q.questSeq < questSeq && vm.visibleSectionQuestions().indexOf(q.questSeq) >= 0) {
                        ret = false;
                    }
                });
                return ret;
            };

            vm.isLastVisibleQuestion = function(questSeq) {
                var ret = true;
                angular.forEach(vm.section.questions, function(q) {
                    if (q.questSeq > questSeq && vm.visibleSectionQuestions().indexOf(q.questSeq) >= 0) {
                        ret = false;
                    }
                });
                return ret;
            };

            vm.isFirstVisibleSection = function() {
                var ret = true;
                angular.forEach(vm.survey.sections, function(q) {
                    if (q.sequence < currentSurvSeq) {
                        ret = false;
                    }
                });
                return ret;
            };

            vm.isLastVisibleSection = function() {
                var ret = true;
                angular.forEach(vm.survey.sections, function(q) {
                    if (q.sequence > currentSurvSeq) {
                        ret = false;
                    }
                });
                return ret;
            };

            vm.isSurveyFinished = function() {
                if (!$rootScope.subject) {
                    return false;
                }
                var ret = true;
                angular.forEach($rootScope.subject.survey.sections, function(section) {
                    if (section.progPct < 100) {
                        ret = false;
                    }
                });
                return ret;
            };

            function handleCheckBxs() {
                var question = $filter('filter')(vm.section.questions, {
                    questSeq: vm.currentQuestionSeq
                })[0];

                var questionStarted = false;
                angular.forEach(question.elements, function(element) {
                    if (isElementAnswered(element)) {
                        questionStarted = true;
                    }
                });

                if (question.inclAddlCommt && vm.comments[question.questId]) {
                    questionStarted = true;
                }

                //set checkbox elements that are not true to false if the question has been started or NULL if not started
                angular.forEach(question.elements, function(element) {
                    if (element.elemInputTypeCd === 'CHBX' && (!vm.answeredElements[element.elemId] || vm.answeredElements[element.elemId] !== 'true')) {
                        if (questionStarted) {
                            vm.answeredElements[element.elemId] = 'false';
                            vm.chbxModel[element.elemId] = false;
                        } else {
                            vm.answeredElements[element.elemId] = null;
                            vm.chbxModel[element.elemId] = null;
                        }
                    }
                });
            }

            function onAnsweredElements(newVal, oldVal) {
                if (newVal !== oldVal) {
                    handleCheckBxs();
                    updateSurvey();
                }
            }

            function onAnsweredComment(newVal, oldVal) {
                if (newVal !== oldVal) {
                    handleCheckBxs();
                    updateSurvey();
                }
            }

            function updateSurvey() {
                return $q(function(resolve) {
                    SurveyService.processSurveyAnswers({
                    }, createProcessSurveyAnswers(), processResponse).$promise.then(function() {
                        vm.validateFields();
                        resolve('success');
                    });
                });
            }

            function processResponse(res) {
                vm.elemValidationMsgs = res.elemValidationMsgs;
                if ($rootScope.subject) {
                    //derived elements
                    if (res.elements) {
                        vm.answeredElements = Object.assign(vm.answeredElements, res.elements);
                    }
                    //progress
                    $rootScope.subject.survey.progPct = res.survey.progPct;
                    angular.forEach(res.survey.sections, function(section) {
                        var sect = $filter('filter')($rootScope.subject.survey.sections, {
                            seq: section.seq
                        }, true)[0];
                        if (sect) {
                            sect.progPct = section.progPct;
                        } else {
                            $rootScope.subject.survey.sections.push({
                                seq: section.seq,
                                progPct: section.progPct
                            });
                        }
                    });
                    //obsv and docu
                    if (res.obsv) {
                        if ($rootScope.subject.obsv) {
                            $rootScope.subject.obsv.cnt = res.obsv.obsvCnt;
                            $rootScope.subject.obsv.highestPriority = res.obsv.obsvMaxWgt;
                        }
                        if ($rootScope.subject.docu) {
                            $rootScope.subject.docu.cnt = res.obsv.docuCnt;
                            $rootScope.subject.docu.satsfdCnt = res.obsv.docuSatsfdCnt;
                            $rootScope.subject.docu.highestPriority = res.obsv.docuMaxWgt;
                        }
                    }
                    //scores
                    angular.forEach(res.scores, function(score) {
                        var scr = $filter('filter')($rootScope.subject.scores, {
                            scoreTypeCd: score.scoreTypeCd
                        })[0];
                        if (scr) {
                            scr.scoreVal = score.scoreVal;
                            scr.scorePct = score.scorePct;
                            scr.scoreValDpCnt = score.scoreValDpCnt;
                            scr.scoreLastUpdate = Date.now();
                        } else {
                            $rootScope.subject.scores.push({
                                scoreVal: score.scoreVal,
                                scorePct: score.scorePct,
                                scoreValDpCnt: score.scoreValDpCnt,
                                scoreLastUpdate: Date.now()
                            });
                        }
                    });
                    //timestamps (for dashboard)
                    if ($rootScope.subject && $rootScope.subject.survey) {
                        $rootScope.subject.survey.lastUpdateTmstmp = Date.now();
                    }
                    if ($rootScope.subject && $rootScope.subject.obsv) {
                        $rootScope.subject.obsv.lastUpdateTmstmp = Date.now();
                    }
                    if ($rootScope.subject && $rootScope.subject.docu) {
                        $rootScope.subject.docu.lastUpdateTmstmp = Date.now();
                    }
                }
                vm.visibleSectionElements = $filter('filter')(res.survey.sections, {
                    seq: vm.section.sequence
                }, true)[0].visibleElements;
                hiddenElements = [];
                angular.forEach(res.survey.sections, function(section) {
                    hiddenElements = hiddenElements.concat(section.hiddenElements);
                });
                vm.pendingSectionElements = $filter('filter')(res.survey.sections, {
                    seq: vm.section.sequence
                }, true)[0].pendingElements;
                vm.naSectionElements = $filter('filter')(res.survey.sections, {
                    seq: vm.section.sequence
                }, true)[0].naElements;
            }

            function createProcessSurveyAnswers() {
                var elements = {};
                angular.forEach(vm.answeredElements, function(node, key) {
                    if (node !== null && node !== '') {
                        elements[key] = node;
                    }
                });
                var comments = {};
                angular.forEach(vm.comments, function(node, key) {
                    if (node && node !== '') {
                        comments[key] = node;
                    }
                });

                return {
                    elements: elements,
                    subjId: $stateParams.id,
                    scoreTypes: surveyState.scoreTypes,
                    activeSurvey: {
                        survTypeCd: vm.survey.survTypeCd,
                        survVersSeq: vm.survey.survVersSeq
                    },
                    otherSurveys: otherSurveys,
                    docuSatsfds: surveyState.docuSatsfds,
                    comments: comments,
                    survSectSeq: currentSurvSeq,
                    subjStageId: $rootScope.subject.subjStageId,
                    tz: Intl.DateTimeFormat().resolvedOptions().timeZone
                };
            }

            vm.saveSurvey = function() {
                return $q(function(resolve) {
                    vm.laddaSave = true;
                    updateSurvey().then(function() {
                        if (!vm.freezeOps) {
                            //remove any newly hidden elements after update from vm.answeredElements
                            angular.forEach(hiddenElements, function(node) {
                                //can't remove from array as that doesn't fire listener to update iCheck, so setting to null instead
                                if (vm.answeredElements[node]) {
                                    vm.answeredElements[node] = null;
                                }
                            });
                            SurveyService.save({}, createProcessSurveyAnswers()).$promise.then(function() {
                                toastr.success(
                                    $translate.instant('surv.updtSurv.toast.saveSurvSuccess'),
                                    $translate.instant('surv.updtSurv.pageTitle'),
                                    toastr.options
                                );
                                $rootScope.isSurveyDirty = false;
                                vm.laddaSave = false;
                                resolve('success');
                            });
                        } else {
                            vm.laddaSave = false;
                            resolve('success');
                        }
                    });
                });
            };

            vm.saveSurveyAndIncrementSection = function(inc) {
                vm.laddaSaveSurvSection = true;
                vm.saveSurvey().then(function() {
                    vm.incrementSection(inc, false, 'app.subject.survey.section.update');
                });
            };

            vm.incrementSection = function(inc, update, state) {
                vm.laddaSaveSurvSection = true;
                if (update) {
                    updateSurvey().then(function() {
                        if (!vm.freezeOps) {
                            $state.go(state, { sectionIdx: currentSurvSeq + inc }, { reload: true });
                        }
                    });
                } else {
                    $state.go(state, { sectionIdx: currentSurvSeq + inc }, { reload: true });
                }
            };

            vm.saveAndFinishSurvey = function() {
                vm.laddaFinish = true;
                vm.saveSurvey().then(function() {
                    vm.finishSurvey();
                });
            };

            vm.finishSurvey = function() {
                if (vm.updateEnabled && $rootScope.subject.myUserPermsns.indexOf('UPDT_SURV_COMPLT_ADVNC_STAGE_PROMPT') >= 0) {
                    openSurveyAdvanceStageDialog($rootScope.subject.subjId, vm.survey.survTypeName, $rootScope.subject.subjStageId);
                } else if (vm.updateEnabled && $rootScope.subject.myUserPermsns.indexOf('UPDT_SURV_COMPLT_ADVNC_STAGE_PROMPT') < 0 && $rootScope.subject.myUserPermsns.indexOf('UPDT_SURV_COMPLT_LOGOUT_PROMPT') >= 0) {
                    openSurveyLogoutDialog($rootScope.subject.subjId, vm.survey.survTypeName);
                } else {
                    $state.go('app.subject');
                }
            };

            $scope.$on('$stateChangeStart', function(event, toState, toParams) {
                var idleTimeoutDialogOpen = $('#idletimer_warning_dialog').is(':visible');
                if ($rootScope.isSurveyDirty && !idleTimeoutDialogOpen) {
                    event.preventDefault();
                    openConfirmDialog(toState, toParams);
                }
            });

            // Register Survey Section View Event
            if (!vm.updateEnabled) {
                SurveyService.accessSurveySection({
                    subjId: $stateParams.id,
                    activeSurvey: {
                        survTypeCd: vm.survey.survTypeCd,
                        survVersSeq: vm.survey.survVersSeq
                    },
                    survSectSeq: currentSurvSeq
                }).$promise.then(function(value) {
                    return value;
                }, function(reason) {
                    return reason;
                });
            }

            function openConfirmDialog(toState, toParams) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'confirm-dialog-template.html',
                    controller: 'SurveyConfirmModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'sm',
                    resolve: {
                        saveSurvey: function() {
                            return vm.saveSurvey;
                        },
                        freezeOps: function() {
                            return vm.freezeOps;
                        },
                        toState: function() {
                            return toState;
                        },
                        toParams: function() {
                            return toParams;
                        }
                    }
                });
            }

            function openSurveyAdvanceStageDialog(subjId, survTypeName, currStageIdx) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'confirm-dialog-template.html',
                    controller: 'SurveyAdvanceStageModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'sm',
                    resolve: {
                        subjId: function() {
                            return subjId;
                        },
                        survTypeName: function() {
                            return survTypeName;
                        },
                        currStage: function() {
                            return references.SUBJ_STAGE.refItems[currStageIdx - 1];
                        },
                        toStage: function() {
                            return references.SUBJ_STAGE.refItems[currStageIdx];
                        },
                        advncSubjStageTitl: function() {
                            return $rootScope.subject.advncSubjStageTitl;
                        },
                        advncSubjStageText: function() {
                            return $rootScope.subject.advncSubjStageText;
                        }
                    }
                });
            }

            function openSurveyLogoutDialog(subjId, survTypeName) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'confirm-dialog-template.html',
                    controller: 'SurveyLogoutModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'sm',
                    resolve: {
                        survTypeName: function() {
                            return survTypeName;
                        }
                    }
                });
            }
        }
    }

    // Please note that $uibModalInstance represents a modal window (instance) dependency.
    // It is not the same as the $uibModal service used above.
    function SurveyConfirmModalCtrl($uibModalInstance, $rootScope, $state, SubjectService, saveSurvey, freezeOps, toState, toParams) {
        var modal = this;
        modal.icon = 'fa-edit';
        modal.title = 'surv.updtSurv.modal.saveSurvTitle';
        modal.text = 'surv.updtSurv.modal.saveSurvText';
        modal.hasErrors = freezeOps;
        if (freezeOps) {
            modal.text = 'surv.updtSurv.modal.saveSurvErrorText';
        }
        modal.okButton = 'surv.updtSurv.modal.saveYesButton';
        modal.cancelButton = 'surv.updtSurv.modal.cancelButton';
        modal.doNotSaveButton = 'surv.updtSurv.modal.saveNoButton';
        modal.close = function() {
            modal.laddaSave = true;
            saveSurvey().then(function() {
                $uibModalInstance.dismiss();
                $state.go(toState, toParams);
            });
        };

        modal.doNotSave = function() {
            $uibModalInstance.dismiss();
            SubjectService.getDetail({
                subjectId: $rootScope.subject.subjId
            }).$promise.then(function(value) {
                $rootScope.subject = value;
            });
            $rootScope.isSurveyDirty = false;
            $state.go(toState, toParams);
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss();
        };
    }

    function SurveyAdvanceStageModalCtrl($uibModalInstance, $state, $translate, SubjectService, subjId, survTypeName, currStage, toStage, advncSubjStageTitl, advncSubjStageText) {
        var modal = this;
        modal.title = advncSubjStageTitl ? advncSubjStageTitl : 'subj.subjStageNav.modal.advncSubjStageTitle';
        modal.text = advncSubjStageText ? advncSubjStageText : $translate.instant('subj.subjStageNav.modal.advncSubjStageText', {
            currStageId: currStage.cd,
            currStageName: currStage.nm,
            nextStageId: toStage.cd,
            nextStageName: toStage.nm
        });
        modal.okButton = 'subj.subjStageNav.modal.advncYesButton';
        modal.cancelButton = 'subj.subjStageNav.modal.advncNoButton';
        modal.close = function() {
            SubjectService.changeStage({
                subjId: subjId,
                increment: 1
            }, null).$promise.then(function() {
                toastr.success(
                    $translate.instant('subj.subjStageNav.toast.advncSubjStageSuccess'),
                    $translate.instant('subj.subjStageNav.pageTitle'),
                    toastr.options
                );
                $uibModalInstance.dismiss();
                $state.go('app.subject', { id: subjId }, { reload: true });
            });
        };
        modal.cancel = function() {
            $uibModalInstance.dismiss();
            $state.go('app.subject');
        };
    }

    function SurveyLogoutModalCtrl($uibModalInstance, $translate, AuthService, survTypeName) {
        var modal = this;
        modal.title = 'surv.updtSurv.modal.logoutTitle';
        modal.text = $translate.instant('surv.updtSurv.modal.logoutDirText', {
            currSurvTypeName: survTypeName
        });
        modal.okButton = 'surv.updtSurv.modal.logoutButton';
        modal.cancelButton = 'subj.subjStageNav.modal.cancelButton';

        modal.close = function() {
            $uibModalInstance.dismiss();
            AuthService.logout('ULO');
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss();
            $state.go('app.subject');
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('ScoreService', ['$resource', 'apiUrl', ScoreService]);

    function ScoreService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'scores/:scoreType/:subjId', {}, {
            query: { //aster chart
                method: 'GET'
            },
            getSubjGrpScore: {
                url: apiUrl + 'scores/history/:scoreType/:subjId',
                method: 'GET',
                isArray: false
            },
            getScoreHierNodes: {
                url: apiUrl + 'scores/pf/scoreHierNodes/:scoreTypeCd',
                method: 'GET'
            },
            getLvl1ScoreTypes: {
                url: apiUrl + 'scores/lvl1/:subjId',
                method: 'GET',
                isArray: true
            },
            getScoreHierLevels: {
                url: apiUrl + 'scores/hierlevel/:scoreType/:subjId',
                method: 'GET',
                isArray: true
            },
            getScoreHierLevelsByScoreType: {
                url: apiUrl + 'scores/hierlevel/:scoreType',
                method: 'GET',
                isArray: true
            },
            getSubjScoreHierNodeTargets: {
                url: apiUrl + 'scores/subjScoreHierNodeTargets/:scoreType/:subjId',
                method: 'GET'
            },
            saveSubjScoreHierNodeTargets: {
                url: apiUrl + 'scores/saveSubjScoreHierNodeTargets',
                method: 'POST'
            },
            getScoreHierNodeTiers: {
                url: apiUrl + 'scores/target/hiernodetiers/:scoreTypeCd/:scoreVersSeq/:subjId/:scoreHierNodeId',
                method: 'GET',
                isArray: true
            }
        });
        return service;
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('ScoreCtrl', ['$rootScope', '$scope', '$state', '$translate', '$filter', '$timeout', 'lvl1ScoreTypes', 'sysParms', ScoreCtrl]);

    function ScoreCtrl($rootScope, $scope, $state, $translate, $filter, $timeout, lvl1ScoreTypes, sysParms) {
        var vm = this;
        vm.lvl1ScoreTypes = lvl1ScoreTypes;
        lvl1ScoreTypes.sort(function(a, b) {
            return a.scoreTypeDispSeq - b.scoreTypeDispSeq;
        });

        $rootScope.breadcrumb = $translate.instant('menu.subj.scorg');

        vm.peerGroups = [];
        if (vm.lvl1ScoreTypes && vm.lvl1ScoreTypes.length > 0 && vm.lvl1ScoreTypes[0].scoreHierNodes[0].peerGrps) {
            angular.forEach(vm.lvl1ScoreTypes[0].scoreHierNodes[0].peerGrps, function(peerGrp) {
                vm.peerGroups.push(peerGrp);
            });
        }

        //get peergrp and target colours
        var peerGrpCls = 'compare-to-peergrp';
        var peerGrpDottedCls = '.' + peerGrpCls;
        var peerGrpPrnt = $('body');
        $(peerGrpPrnt).append('<div class=' + peerGrpCls + '>&nbsp</span>');
        var peerGrpEl = $(peerGrpDottedCls)[0];
        var peerGrpColor = $(peerGrpEl).css('border-left-color');

        var targCls = 'compare-to-target';
        var targDottedCls = '.' + targCls;
        var targPrnt = $('body');
        $(targPrnt).append('<div class=' + targCls + '>&nbsp</span>');
        var targEl = $(targDottedCls)[0];
        var targColor = $(targEl).css('border-left-color');

        if (vm.peerGroups.length) {
            vm.peerGroups.sort(function(a, b) {
                return a.peerGrpId - b.peerGrpId;
            });
            vm.selectedPeerGrp = vm.peerGroups[0];
        }
        vm.latestTargFlag = sysParms.data.SCORE_COMP_LATEST_TARG_FLAG && sysParms.data.SCORE_COMP_LATEST_TARG_FLAG.toLowerCase() === 'true';
        vm.compareToPeerGrp = vm.peerGroups.length !== 0;
        vm.targetsExist = false;
        vm.nextTargetsExist = false;
        vm.isTargetDisabled = true;
        vm.isCurrentTargetDisabled = true;
        vm.isNextTargetDisabled = true;
        vm.scKeyData = [];
        var maxVal = 0;

        var maxColor = 40; // max no of color codes defined in variable.less file
        var idxColor = 1;
        angular.forEach(lvl1ScoreTypes, function(scoreType) {
            var node = scoreType.scoreHierNodes[0];
            maxVal = Math.max(maxVal, scoreType.maxNodeScoreVal);
            if (node.target) {
                vm.targetsExist = true;
            }
            if (node.nextTarget) {
                vm.nextTargetsExist = true;
            }
            if (node && ((!vm.latestTargFlag && (node.target || node.nextTarget)) || (vm.latestTargFlag && node.lastTarget))) {
                vm.isTargetDisabled = false;
            }
            if (node && (node.target)) {
                vm.isCurrentTargetDisabled = false;
            }
            if (node && (node.nextTarget)) {
                vm.isNextTargetDisabled = false;
            }

            var cls = 'chart-bg-color-' + idxColor++;
            var dottedCls = '.' + cls;
            var prnt = $('body');
            $(prnt).append('<span class=' + cls + '>&nbsp</span>');
            var el = $(dottedCls)[0];
            scoreType.seriesColor = $(el).css('background-color');
            $(el).remove();
            if (idxColor > maxColor) {
                idxColor = 1;
            }

            if (node.hasOwnProperty('scoreVal')) {
                var scoreDesc = {};
                scoreLabel = $translate.instant('score.home.scorePUScoreLabel').replace('\'', '&apos;');
                scoreLabel += ': ' + $filter('number')(node.scoreVal, node.scoreValDpCnt);
                scoreDesc.scoreLabel = scoreLabel;
                createScoreDesc(node, node.tier, scoreDesc);
                node.scoreDesc = scoreDesc;
            }
            if (node.hasOwnProperty('target')) {
                var targetScoreDesc = {};
                scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                scoreLabel += ': ' + $filter('number')(node.target.val, node.scoreValDpCnt);
                targetScoreDesc.scoreLabel = scoreLabel;
                createScoreDesc(node, node.target.tier, targetScoreDesc);
                node.target.scoreDesc = targetScoreDesc;
            }
            if (node.hasOwnProperty('prevTarget')) {
                var prevTargetScoreDesc = {};
                scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                scoreLabel += ': ' + $filter('number')(node.prevTarget.targetScoreVal, node.scoreValDpCnt);
                prevTargetScoreDesc.scoreLabel = scoreLabel;
                createScoreDesc(node, node.prevTarget.targetScoreTier, prevTargetScoreDesc, node.scoreValDpCnt);
                node.prevTarget.scoreDesc = prevTargetScoreDesc;
            }
            if (node.hasOwnProperty('nextTarget')) {
                var nextTargetScoreDesc = {};
                if (node.nextTarget.targetScoreVal !== undefined) {
                    scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.nextTarget.targetScoreVal, node.scoreValDpCnt);
                    nextTargetScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.nextTarget.targetScoreTier, nextTargetScoreDesc);
                    node.nextTarget.scoreDesc = nextTargetScoreDesc;
                } else if (node.nextTarget.val !== undefined) {
                    scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(node.nextTarget.val, node.scoreValDpCnt);
                    nextTargetScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, node.nextTarget.tier, nextTargetScoreDesc);
                    node.nextTarget.scoreDesc = nextTargetScoreDesc;
                }
            }
            if (node.hasOwnProperty('lastTarget')) {
                var lastTargetScoreDesc = {};
                scoreLabel = $translate.instant('score.home.scorePUTargScoreLabel').replace('\'', '&apos;');
                scoreLabel += ': ' + $filter('number')(node.lastTarget.val, node.scoreValDpCnt);
                lastTargetScoreDesc.scoreLabel = scoreLabel;
                createScoreDesc(node, node.lastTarget.tier, lastTargetScoreDesc);
                node.lastTarget.scoreDesc = lastTargetScoreDesc;
            }
            if (node.hasOwnProperty('peerGrps')) {
                angular.forEach(node.peerGrps, function(peerGrp) {
                    var peerGrpScoreDesc = {};
                    scoreLabel = peerGrp.peerGrpName.replace('\'', '&apos;');
                    scoreLabel += ': ' + $filter('number')(peerGrp.val, node.scoreValDpCnt);
                    peerGrpScoreDesc.scoreLabel = scoreLabel;
                    createScoreDesc(node, peerGrp.tier, peerGrpScoreDesc);
                    peerGrp.scoreDesc = peerGrpScoreDesc;
                });
            }

            var desc = node.scoreDesc;
            var scoreLabel = desc.scoreLabel;
            var tierRange = desc.tierRange ? (desc.tierRange + '<br>') : '';
            var tierDesc = desc.tierDesc ? desc.tierDesc : '';
            node.tip =
                '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                '<div class="arrow"></div>' +
                '<div class="popover-inner" > ' +
                '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                '<div class="color-box" style="background-color:' + scoreType.seriesColor + '"></div>' +
                '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + scoreType.scoreTypeName + '</h3></div>' +
                '</div>' +
                '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + scoreLabel + '<br>' +
                tierRange +
                tierDesc +
                ' </div>' +
                '</div>' +
                '</div>';
            if (node.target && node.target.scoreDesc) {
                var targScoreDesc = node.target.scoreDesc;
                var targScoreLabel = targScoreDesc.scoreLabel;
                var targTierRange = targScoreDesc.tierRange ? (targScoreDesc.tierRange + '<br>') : '';
                var targTierDesc = targScoreDesc.tierDesc ? targScoreDesc.tierDesc : '';
                node.target.tip =
                    '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-inner" > ' +
                    '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                    '<div class="color-box" style="background-color:' + scoreType.seriesColor + '"></div>' +
                    '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + scoreType.scoreTypeName + '</h3></div>' +
                    '</div>' +
                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + targScoreLabel + '<br>' +
                    targTierRange +
                    targTierDesc +
                    ' </div>' +
                    '</div>' +
                    '</div>';
            }
            if (node.nextTarget && node.nextTarget.scoreDesc) {
                var nextTargScoreDesc = node.nextTarget.scoreDesc;
                var nextTargScoreLabel = nextTargScoreDesc.scoreLabel;
                var nextTargTierRange = nextTargScoreDesc.tierRange ? (nextTargScoreDesc.tierRange + '<br>') : '';
                var nextTargTierDesc = nextTargScoreDesc.tierDesc ? nextTargScoreDesc.tierDesc : '';
                node.nextTarget.tip =
                    '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-inner" > ' +
                    '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                    '<div class="color-box" style="background-color:' + scoreType.seriesColor + '"></div>' +
                    '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + scoreType.scoreTypeName + '</h3></div>' +
                    '</div>' +
                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + nextTargScoreLabel + '<br>' +
                    nextTargTierRange +
                    nextTargTierDesc +
                    ' </div>' +
                    '</div>' +
                    '</div>';
            }
            if (node.lastTarget && node.lastTarget.scoreDesc) {
                var lastTargScoreDesc = node.lastTarget.scoreDesc;
                var lastTargScoreLabel = lastTargScoreDesc.scoreLabel;
                var lastTargTierRange = lastTargScoreDesc.tierRange ? (lastTargScoreDesc.tierRange + '<br>') : '';
                var lastTargTierDesc = lastTargScoreDesc.tierDesc ? lastTargScoreDesc.tierDesc : '';
                node.lastTarget.tip =
                    '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-inner" > ' +
                    '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                    '<div class="color-box" style="background-color:' + scoreType.seriesColor + '"></div>' +
                    '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + scoreType.scoreTypeName + '</h3></div>' +
                    '</div>' +
                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + lastTargScoreLabel + '<br>' +
                    lastTargTierRange +
                    lastTargTierDesc +
                    ' </div>' +
                    '</div>' +
                    '</div>';
            }
            if (node.peerGrps) {
                angular.forEach(node.peerGrps, function(peerGrp) {
                    if (peerGrp.scoreDesc) {
                        var peerGrpScoreDesc = peerGrp.scoreDesc;
                        var peerGrpScoreLabel = peerGrpScoreDesc.scoreLabel;
                        var peerGrpTierRange = peerGrpScoreDesc.tierRange ? (peerGrpScoreDesc.tierRange + '<br>') : '';
                        var peerGrpTierDesc = peerGrpScoreDesc.tierDesc ? peerGrpScoreDesc.tierDesc : '';
                        peerGrp.tip =
                            '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                            '<div class="arrow"></div>' +
                            '<div class="popover-inner" > ' +
                            '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                            '<div class="color-box" style="background-color:' + scoreType.seriesColor + '"></div>' +
                            '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + scoreType.scoreTypeName + '</h3></div>' +
                            '</div>' +
                            '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' + peerGrpScoreLabel + '<br>' +
                            peerGrpTierRange +
                            peerGrpTierDesc +
                            ' </div>' +
                            '</div>' +
                            '</div>';
                    }
                });
            }

            vm.scKeyData.push({
                scoreHierNodeName: scoreType.scoreTypeName,
                scoreHierNodeDesc: scoreType.scoreTypeDesc,
                children: [],
                seriesColor: scoreType.seriesColor
            });
        });

        vm.targetType = (vm.targetsExist ? 'current' : (vm.nextTargetsExist ? 'next' : null));
        vm.compareToTarget = vm.targetsExist || vm.nextTargetsExist;

        function createScoreDesc(node, tier, scoreDesc) {
            scoreDesc.nodeName = node.scoreHierNodeName;
            if (tier) {
                scoreDesc.tierRange = $translate.instant('score.home.scorePUTierRangeLabel')
                    + ': ' + $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt);
                scoreDesc.tierDesc = $translate.instant('score.home.scorePUTierDescLabel') + ': ' + tier.tierDesc;
            }
        }

        vm.scChartConfig = {
            width: 550,
            height: 400,
            fixedWidth: true,
            fixedHeight: true,
            padding: {
                top: 15,
                bottom: 0,
                left: 0,
                right: 0
            },
            valueAxisLabel: $translate.instant('score.home.scoreTypeComp.xAxisLabel'),
            catgAxisLabel: $translate.instant('score.home.scoreTypeComp.yAxisLabel'),
            valueAxisMaxVal: maxVal,
            orientation: 'horizontal',
            seriesLayout: 'stacked',
            valueScaleTicksNum: 10,
            showCatgAxisScaleLabels: false,
            showGridlines: true,
            showLegend: false,
            enableClick: true,
            minBarSize: 3,
            markRadius: 4,
            markStrokeWidth: 1
        };

        vm.scChartData = function() {
            var chartSeries = [];
            angular.forEach(lvl1ScoreTypes, function(scoreType) {
                var node = scoreType.scoreHierNodes[0];
                var series = {
                    seriesTitle: scoreType.scoreTypeName,
                    seriesColor: scoreType.seriesColor,
                    hasChildren: false,
                    baseTip: node.tip,
                    elements: []
                };
                var element = {
                    category: scoreType.scoreTypeName,
                    value: node.scoreVal,
                    tip: node.tip,
                    marks: []
                };

                //add marks and calculate if overlay is needed
                var maxMarksVal = 0;
                if (vm.compareToPeerGrp) {
                    var peerGrp = $filter('filter')(node.peerGrps, {
                        peerGrpId: vm.selectedPeerGrp.peerGrpId
                    }, true)[0];
                    element.marks.push({
                        value: (peerGrp.val) ? peerGrp.val : 0,
                        color: peerGrpColor,
                        tip: peerGrp.tip
                    });
                    maxMarksVal = (peerGrp.val) ? peerGrp.val : 0;
                }
                if (vm.compareToTarget) {
                    if (!vm.latestTargFlag && vm.targetType === 'current' && node.target) {
                        element.marks.push({
                            value: node.target.val,
                            color: targColor,
                            tip: node.target.tip
                        });
                        maxMarksVal = Math.max(maxMarksVal, node.target.val);
                    } else if (!vm.latestTargFlag && vm.targetType === 'next' && node.nextTarget) {
                        element.marks.push({
                            value: node.nextTarget.val,
                            color: targColor,
                            tip: node.nextTarget.tip
                        });
                        maxMarksVal = Math.max(maxMarksVal, node.nextTarget.val);
                    } else if (vm.latestTargFlag && node.lastTarget) {
                        element.marks.push({
                            value: node.lastTarget.val,
                            color: targColor,
                            tip: node.lastTarget.tip
                        });
                        maxMarksVal = Math.max(maxMarksVal, node.lastTarget.val);
                    }
                }
                if (maxMarksVal > node.scoreVal) {
                    series.overlayPattern = 'diagonalHatch';
                    series.overlayColor = scoreType.seriesColor;
                    element.overlayValueMin = node.scoreVal;
                    element.overlayValueMax = maxMarksVal;
                    element.overlayTip = node.tip;
                }
                series.elements.push(element);
                chartSeries.push(series);
            });
            return {
                series: chartSeries
            };
        };

        vm.jumpToScoreTypeFromChart = function(element) {
            var hasPerms = false;
            var subjPerms = ['VIEW_WGTD_SCORE_BREAKDN', 'VIEW_SCORE_COMP', 'UPDT_SCORE_TARGS', 'VIEW_SCORE_HIST'];
            for (var i = 0; i < subjPerms.length; i++) {
                if ($rootScope.subject && $rootScope.subject.myUserPermsns && $rootScope.subject.myUserPermsns.indexOf(subjPerms[i]) !== -1) {
                    hasPerms = true;
                }
            }
            if (hasPerms) {
                var scoreType = $filter('filter')(vm.lvl1ScoreTypes, {
                    scoreTypeName: element.category
                }, true)[0];
                $state.go('app.subject.scoring.type', {
                    id: $rootScope.subject.subjId,
                    scoreTypeCd: scoreType.scoreTypeCd
                }, {
                    reload: true
                });
            }
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('ObservationService', ['$resource', 'apiUrl', ObservationService]);

    function ObservationService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'obsv/:id/node/:nodeId', {}, {
            query: {
                method: 'GET',
                isArray: false
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            updateHierNode: {
                url: apiUrl + 'obsv/updateHierNode',
                method: 'PUT'
            },
            updateObservation: {
                url: apiUrl + 'obsv/updateObservation',
                method: 'PUT'
            },
            updateObsvPriority: {
                url: apiUrl + 'obsv/updateObsvPriority',
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            },
            getPfObservationAnalysis: {
                url: apiUrl + 'obsv/pf/analysis?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET',
                isArray: false
            },
            getPfObsvDistribution: {
                url: apiUrl + 'obsv/pf/distribution?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET',
                isArray: true
            },
            getObservation: {
                url: apiUrl + 'obsv/:subjId',
                method: 'GET',
                isArray: false
            },
            getAllObservations: {
                url: apiUrl + 'obsv/all/:langCd',
                method: 'GET',
                isArray: true
            }

        });

        return service;
    }
})();
(function() {
    'use strict';

    angular.module('app')
        .controller('ObservationsCtrl', ['$rootScope', '$scope', '$timeout', '$filter', '$uibModal', '$sce', '$translate', 'subjStageFeat', 'observations', ObservationsCtrl])
        .controller('ObservationsConfirmModalCtrl', ['$uibModalInstance', '$translate', 'obsv', ObservationsConfirmModalCtrl]);

    function ObservationsCtrl($rootScope, $scope, $timeout, $filter, $uibModal, $sce, $translate, subjStageFeat, observations) {
        var vm = this;
        if (observations.status !== 403) {
            vm.observations = observations.obsvs;
        }

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        vm.showGroupHelp = [];
        vm.showObsvHelp = [];
        vm.toggleGroupHelp = function(idx) {
            vm.showGroupHelp[idx] = !vm.showGroupHelp[idx];
        };
        vm.toggleObsvHelp = function(idx) {
            vm.showObsvHelp[idx] = !vm.showObsvHelp[idx];
        };

        // Preparing initial data
        angular.forEach($rootScope.referenceData.HIER_LVL.refItems, function(refData) {
            if (refData.cd === '2') {
                vm.lvl2HierLvlName = refData.nm;
            }
            if (refData.cd === '3') {
                vm.lvl3HierLvlName = refData.nm;
            }
        });
        if (!vm.lvl2HierLvlName) {
            vm.lvl2HierLvlName = '';
        }
        if (!vm.lvl3HierLvlName) {
            vm.lvl3HierLvlName = '';
        }
        vm.priorityName = $translate.instant('obsv.home.priotLabel');
        vm.typeName = $translate.instant('obsv.home.typeLabel');

        // Get all level3 reference data.
        vm.lvl3Nodes = [];
        angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 3) {
                vm.lvl3Nodes.push({
                    type: vm.lvl3HierLvlName,
                    groupName: 'level3NodeId',
                    nm: value.entity.parntHierNodeName + ': ' + value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc,
                    parentNodeId: value.entity.parntHierNodeId
                });
                return value;
            }
        });

        // add drop down filter object for level2, priority and observation type. level3 Filter are dynamic based on level2 value
        vm.filters = [];
        angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 2) {
                vm.filters.push({
                    type: vm.lvl2HierLvlName,
                    groupName: 'level2NodeId',
                    nm: value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });
        angular.forEach($filter('orderBy')($rootScope.referenceData.OBSV_PRIOT_SEQ.refItems, 'dispSeq'), function(value) {
            vm.filters.push({
                type: vm.priorityName,
                groupName: 'obsvPrioritySeq',
                nm: value.nm,
                cd: parseInt(value.cd, 10),
                desc: typeof value.desc === 'undefined' ? null : value.desc
            });
        });
        angular.forEach($filter('orderBy')($rootScope.referenceData.OBSV_TYPE.refItems, 'dispSeq'), function(value) {
            if (subjStageFeat && subjStageFeat.obsvTypes && subjStageFeat.obsvTypes.length > 0 && subjStageFeat.obsvTypes.indexOf(value.cd) !== -1) {
                vm.filters.push({
                    type: vm.typeName,
                    groupName: 'typeCd',
                    nm: value.nm,
                    cd: value.cd,
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });

        // Display group name and desc
        vm.getGroup = function (cd, groupName) {
            // level3 is not part of vm.filters becuase it is added dynamically in filter based on level2 value
            // Getting it from lvl3Nodes reference data.
            if (groupName === 'level3NodeId') {
                for (var j = 0; j < vm.lvl3Nodes.length; j++) {
                    if (vm.lvl3Nodes[j].cd.toString() === cd) {
                        return vm.lvl3Nodes[j];
                    }
                }
            } else {
                for (var i = 0; i < vm.filters.length; i++) {
                    if (vm.filters[i].cd.toString() === cd && vm.filters[i].groupName === groupName) {
                        return vm.filters[i];
                    }
                }
            }
        };

        vm.level2FilterVal = [];
        vm.priorityFilterVal = [];
        vm.typeFilterVal = [];

        // filter/group/sort default options
        vm.groupByField = 'level2NodeId';
        vm.groupByOrder = false;
        vm.orderByField = 'obsvPrioritySeq';

        //method called after ng-repeat finish rendering
        $scope.$on('buildMasonryLayout', function() {
            var elem = document.querySelector('.grid');
            new Masonry(elem, {
                itemSelector: '.grid-item',
                percentPosition: true
            });
        });

        vm.applyFilter = function() {
            vm.level2FilterVal = [];
            vm.priorityFilterVal = [];
            vm.typeFilterVal = [];
            angular.forEach(vm.filterByField, function (filterItem) {
                switch (filterItem.type) {
                case vm.lvl2HierLvlName:
                    vm.level2FilterVal.push({
                        id: filterItem.cd,
                        childKey: 'level3NodeId',
                        childIds: []
                    });
                    break;
                case vm.priorityName:
                    vm.priorityFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.typeName:
                    vm.typeFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.lvl3HierLvlName:
                    for (var i = vm.level2FilterVal.length - 1; i >= 0; i--) {
                        if (vm.level2FilterVal[i].id === filterItem.parentNodeId) {
                            vm.level2FilterVal[i].childIds.push(filterItem.cd);
                        }
                    }
                }
            });
            includeLvl3Filter();
            $timeout(function () {
                $(':focus').blur();
            });
        };

        vm.getFilteredObsvs = function() {
            return $filter('filterMultiple')(vm.observations, {
                level2NodeId: vm.level2FilterVal,
                obsvPrioritySeq: vm.priorityFilterVal,
                typeCd: vm.typeFilterVal
            });
        };

        vm.getFilterObsvMetrics = function() {
            var cnt = 0;
            var highestPriority = Number.MAX_SAFE_INTEGER;
            angular.forEach(vm.getFilteredObsvs(), function(obsv) {
                cnt++;
                highestPriority = Math.min(highestPriority, obsv.obsvPrioritySeq);
            });
            if (highestPriority === Number.MAX_SAFE_INTEGER) {
                highestPriority = 0;
            }
            return {
                cnt: cnt,
                highestPriority: highestPriority
            };
        };

        function includeLvl3Filter() {
            // clean up vm.filterByField and remove level3 filter if it's parent is removed
            var newArr = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                if (filterItem.type !== vm.lvl3HierLvlName || (filterItem.type === vm.lvl3HierLvlName && findWithAttr(vm.level2FilterVal, 'id', filterItem.parentNodeId) !== -1)) {
                    newArr.push(filterItem);
                }
            });
            vm.filterByField = newArr;

            // clear all level3 from filters drop down
            vm.filters = $filter('filter')(vm.filters, function(value) {
                return value.type !== vm.lvl3HierLvlName;
            });
            // add new level3 filters based on level2 values
            angular.forEach(vm.level2FilterVal, function(filterItem) {
                angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
                    if (value.entity.hierLvlId === 3 && value.entity.parntHierNodeId === filterItem.id) {
                        vm.filters.unshift({
                            type: vm.lvl3HierLvlName,
                            groupName: 'level3NodeId',
                            nm: value.entity.parntHierNodeName + ': ' + value.nm,
                            cd: parseInt(value.cd, 10),
                            desc: typeof value.desc === 'undefined' ? null : value.desc,
                            parentNodeId: value.entity.parntHierNodeId
                        });
                    }
                });
            });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        vm.filterInit = function() {
            if ($rootScope.obsvTypeFilter) {
                vm.filterByField = $filter('filter')(vm.filters, {
                    cd: $rootScope.obsvTypeFilter,
                    groupName: 'typeCd'
                }, true);
                vm.applyFilter();
                $rootScope.obsvTypeFilter = null;
            }
        };

        vm.openWhyDialog = function(obsv) {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'obsv-why-template.html',
                controller: 'ObservationsConfirmModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    obsv: function() {
                        return obsv;
                    }
                }
            });
        };

    }

    // Please note that $uibModalInstance represents a modal window (instance) dependency.
    // It is not the same as the $uibModal service used above.
    function ObservationsConfirmModalCtrl($uibModalInstance, $translate, obsv) {
        var modal = this;
        modal.obsv = obsv;

        modal.getQuestionLabel = function(rule) {
            return rule.survTypeName
                + ' ('
                + rule.survSectName
                + ', '
                + $translate.instant('obsv.home.modal.qText', {
                    questSeq: rule.questSeq
                })
                + ')';
        };

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('DocumentService', ['$resource', 'apiUrl', DocumentService]);

    function DocumentService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'docu/:subjId', {}, {
            getDocuments: {
                method: 'GET',
                isArray: false
            }
        });
        return service;
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('documentsDt', ['$timeout', '$filter', documentsDt]);

    function documentsDt($timeout, $filter) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        searching: false,
                        columnDefs: [{
                            targets: 1,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return $filter('fileSize')(data);
                                }
                                return data;
                            }
                        }, {
                            targets: 3,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            targets: 4,
                            orderable: false
                        }],
                        order: [
                            [3, 'desc']
                        ]
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('DocumentsCtrl', ['$rootScope', '$scope', '$filter', '$uibModal', '$sce', '$translate', '$timeout', 'observations', DocumentsCtrl])
        .controller('DocumentsUploadModalCtrl', ['$rootScope', '$scope', '$uibModalInstance', '$sce', '$http', '$state', '$uibModal', 'DocumentService', 'obsv', 'subj', 'vm', 'refreshStateFlag', 'apiUrl', '$translate', DocumentsUploadModalCtrl])
        .controller('DocumentsBrowseModalCtrl', ['$rootScope', '$scope', '$uibModalInstance', '$uibModal', '$http', '$translate', '$q', 'apiUrl', 'obsv', 'subj', DocumentsBrowseModalCtrl])
        .controller('DocumentsConfirmDeleteModalCtrl', ['$uibModalInstance', '$uibModal', '$http', 'apiUrl', 'fileObj', '$translate', DocumentsConfirmDeleteModalCtrl]);

    function DocumentsCtrl($rootScope, $scope, $filter, $uibModal, $sce, $translate, $timeout, observations) {
        var vm = this;
        if (observations.status !== 403) {
            vm.observations = observations.obsvs;
        }

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        vm.showGroupHelp = [];
        vm.showObsvHelp = [];
        vm.toggleGroupHelp = function(idx) {
            vm.showGroupHelp[idx] = !vm.showGroupHelp[idx];
        };
        vm.toggleObsvHelp = function(idx) {
            vm.showObsvHelp[idx] = !vm.showObsvHelp[idx];
        };

        // Preparing initial data
        angular.forEach($rootScope.referenceData.HIER_LVL.refItems, function(refData) {
            if (refData.cd === '2') {
                vm.lvl2HierLvlName = refData.nm;
            }
            if (refData.cd === '3') {
                vm.lvl3HierLvlName = refData.nm;
            }
        });
        if (!vm.lvl2HierLvlName) {
            vm.lvl2HierLvlName = '';
        }
        if (!vm.lvl3HierLvlName) {
            vm.lvl3HierLvlName = '';
        }
        vm.priorityName = $translate.instant('docu.home.priotLabel');

        // Get all level3 reference data.
        vm.lvl3Nodes = [];
        angular.forEach($filter('orderBy')($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 3) {
                vm.lvl3Nodes.push({
                    type: vm.lvl3HierLvlName,
                    groupName: 'level3NodeId',
                    nm: value.entity.parntHierNodeName + ': ' + value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc,
                    parentNodeId: value.entity.parntHierNodeId
                });
                return value;
            }
        });

        // add drop down filter object for level2, priority. level3 Filter are dynamic based on level2 value
        vm.filters = [];
        angular.forEach($filter('orderBy')($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 2) {
                vm.filters.push({
                    type: vm.lvl2HierLvlName,
                    groupName: 'level2NodeId',
                    nm: value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });
        angular.forEach($filter('orderBy')($rootScope.referenceData.OBSV_PRIOT_SEQ.refItems, 'dispSeq'), function(value) {
            vm.filters.push({
                type: vm.priorityName,
                groupName: 'obsvPrioritySeq',
                nm: value.nm,
                cd: parseInt(value.cd, 10),
                desc: typeof value.desc === 'undefined' ? null : value.desc
            });
        });

        // Display group name and desc
        vm.getGroup = function(cd, groupName) {
            // level3 is not part of vm.filters because it is added dynamically in filter based on level2 value
            // Getting it from lvl3Nodes reference data.
            if (groupName === 'level3NodeId') {
                for (var j = 0; j < vm.lvl3Nodes.length; j++) {
                    if (vm.lvl3Nodes[j].cd.toString() === cd) {
                        return vm.lvl3Nodes[j];
                    }
                }
            } else {
                for (var i = 0; i < vm.filters.length; i++) {
                    if (vm.filters[i].cd.toString() === cd && vm.filters[i].groupName === groupName) {
                        return vm.filters[i];
                    }
                }
            }
        };

        vm.level2FilterVal = [];
        vm.priorityFilterVal = [];

        // filter/group/sort default options
        vm.groupByField = 'level2NodeId';
        vm.groupByOrder = false;
        vm.orderByField = 'obsvPrioritySeq';

        //method called after ng-repeat finish rendering
        $scope.$on('buildMasonryLayout', function() {
            var elem = document.querySelector('.grid');
            if (elem) {
                new Masonry(elem, {
                    itemSelector: '.grid-item',
                    percentPosition: true
                });
            }
        });

        vm.applyFilter = function () {
            vm.level2FilterVal = [];
            vm.priorityFilterVal = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                switch (filterItem.type) {
                case vm.lvl2HierLvlName:
                    vm.level2FilterVal.push({
                        id: filterItem.cd,
                        childKey: 'level3NodeId',
                        childIds: []
                    });
                    break;
                case vm.priorityName:
                    vm.priorityFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.lvl3HierLvlName:
                    for (var i = vm.level2FilterVal.length - 1; i >= 0; i--) {
                        if (vm.level2FilterVal[i].id === filterItem.parentNodeId) {
                            vm.level2FilterVal[i].childIds.push(filterItem.cd);
                        }
                    }
                }
            });
            includeLvl3Filter();
            $timeout(function () {
                $(':focus').blur();
            });
        };

        vm.getFilteredObsvs = function() {
            return $filter('filterMultiple')(vm.observations, {
                level2NodeId: vm.level2FilterVal,
                obsvPrioritySeq: vm.priorityFilterVal
            });
        };

        vm.updateMenuDocuMetrics = function() {
            var cnt = 0;
            var highestPriority = Number.MAX_SAFE_INTEGER;
            var satsfdCnt = 0;
            angular.forEach(vm.observations, function(obsv) {
                cnt++;
                if (obsv.files && obsv.files.length > 0) {
                    satsfdCnt++;
                } else {
                    highestPriority = Math.min(highestPriority, obsv.obsvPrioritySeq);
                }
            });
            if (highestPriority === Number.MAX_SAFE_INTEGER) {
                highestPriority = 0;
            }
            $rootScope.subject.docu = {
                cnt: cnt,
                highestPriority: highestPriority,
                satsfdCnt: satsfdCnt,
                lastUpdateTmstmp: new Date()
            };
        };

        vm.getFilterObsvMetrics = function() {
            var cnt = 0;
            var highestPriority = Number.MAX_SAFE_INTEGER;
            var satsfdCnt = 0;
            angular.forEach(vm.getFilteredObsvs(), function(obsv) {
                cnt++;
                if (obsv.files && obsv.files.length > 0) {
                    satsfdCnt++;
                } else {
                    highestPriority = Math.min(highestPriority, obsv.obsvPrioritySeq);
                }
            });
            if (highestPriority === Number.MAX_SAFE_INTEGER) {
                highestPriority = 0;
            }
            return {
                cnt: cnt,
                highestPriority: highestPriority,
                satsfdCnt: satsfdCnt
            };
        };

        function includeLvl3Filter() {
            // clean up vm.filterByField and remove level3 filter if it's parent is removed
            var newArr = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                if (filterItem.type !== vm.lvl3HierLvlName || (filterItem.type === vm.lvl3HierLvlName && findWithAttr(vm.level2FilterVal, 'id', filterItem.parentNodeId) !== -1)) {
                    newArr.push(filterItem);
                }
            });
            vm.filterByField = newArr;

            // clear all level3 from filters drop down
            vm.filters = $filter('filter')(vm.filters, function(value) {
                return value.type !== vm.lvl3HierLvlName;
            });
            // add new level3 filters based on level2 values
            angular.forEach(vm.level2FilterVal, function(filterItem) {
                angular.forEach($filter('orderBy')($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
                    if (value.entity.hierLvlId === 3 && value.entity.parntHierNodeId === filterItem.id) {
                        vm.filters.unshift({
                            type: vm.lvl3HierLvlName,
                            groupName: 'level3NodeId',
                            nm: value.entity.parntHierNodeName + ': ' + value.nm,
                            cd: parseInt(value.cd, 10),
                            desc: typeof value.desc === 'undefined' ? null : value.desc,
                            parentNodeId: value.entity.parntHierNodeId
                        });
                    }
                });
            });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        vm.openUploadDialog = function (ev, obsv) {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'document-upload-template.html',
                controller: 'DocumentsUploadModalCtrl',
                controllerAs: 'modal',
                scope: $scope,
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    obsv: function () {
                        return obsv;
                    },
                    subj: $rootScope.subject,
                    vm: function () {
                        return vm;
                    },
                    refreshStateFlag: false
                }
            });
        };
    }

    function DocumentsUploadModalCtrl($rootScope, $scope, $uibModalInstance, $sce, $http, $state, $uibModal, DocumentService, obsv, subj, vm, refreshStateFlag, apiUrl, $translate) {
        var modal = this;
        var icon = 'fa-files-o';
        var title = 'docu.home.modal.upldDocTitle';
        var okButton = 'docu.home.modal.upldDocCloseButton';
        modal.obsv = obsv;
        modal.subj = subj;
        modal.icon = icon;
        modal.title = title;
        modal.okButton = okButton;
        modal.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        modal.download = function(fileObj) {
            var subjId = fileObj.subjId;
            var obsvId = fileObj.obsvId;
            var docSeq = fileObj.docSeq;
            var req = {
                method: 'GET',
                url: apiUrl + 'docu/' + subjId + '/downloadDocument/' + obsvId + '/' + docSeq,
                headers: {
                    'Content-Type': 'application/x-www-formurlencoded'
                }
            };

            return $http(req).then(function(response) {
                var a = document.createElement('a');
                document.body.appendChild(a);
                var fileArrayBuffer = base64ToArrayBuffer(response.data.fileData);
                var file = new Blob([fileArrayBuffer], { type: response.data.mimeType });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                var fileName = response.data.fileName;
                a.download = fileName;
                a.click();
                toastr.success(
                    $translate.instant('docu.home.toast.docDownldSuccess'),
                    $translate.instant('docu.home.modal.upldDocTitle'),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('docu.home.toast.docDownldError'),
                    $translate.instant('docu.home.modal.upldDocTitle'),
                    toastr.options
                );
            });
        };

        function base64ToArrayBuffer(base64) {
            if (typeof (base64) !== 'undefined') {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }
            return base64;
        }

        modal.openUploadModal = function() {
            $uibModalInstance.close(); // To close this modal for displaying the Browse file modal
            var documentsBrowseModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'browse-button-template.html',
                controller: 'DocumentsBrowseModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    obsv: obsv,
                    subj: subj
                }
            });
            documentsBrowseModal.result.then(function(data) {
                if ($scope.myFile) {
                    $scope.myFile.length = 0;
                }
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'document-upload-template.html',
                    controller: 'DocumentsUploadModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    resolve: {
                        obsv: (data) ? data : obsv,
                        subj: subj,
                        vm: function() {
                            return vm;
                        },
                        refreshStateFlag: true
                    }
                });
            });
        };

        modal.confirmDelete = function(fileObj) {
            $uibModalInstance.close();
            var confirmDeleteModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'DocumentsConfirmDeleteModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    fileObj: fileObj
                }
            });
            confirmDeleteModal.result.then(function(data) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'document-upload-template.html',
                    controller: 'DocumentsUploadModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    resolve: {
                        obsv: (data) ? data : obsv,
                        subj: subj,
                        vm: function() {
                            return vm;
                        },
                        refreshStateFlag: true
                    }
                });
            });
        };

        modal.close = function() {
            if (refreshStateFlag) {
                DocumentService.getDocuments({
                    subjId: subj.subjId
                }).$promise.then(function(value) {
                    vm.observations = value.obsvs;
                    vm.updateMenuDocuMetrics();
                }, function(reason) {
                    vm.observations = [];
                    return reason;
                });
                $uibModalInstance.close();
            } else {
                $uibModalInstance.close();
            }
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function DocumentsBrowseModalCtrl($rootScope, $scope, $uibModalInstance, $uibModal, $http, $translate, $q, apiUrl, obsv, subj) {
        var modal = this;
        modal.icon = 'fa-files-o';
        modal.title = 'docu.home.modal.addFileTitle';
        modal.okButton = 'docu.home.modal.addFileOkButton';
        modal.cancelButton = 'docu.home.modal.cancelButton';
        modal.maxUploadSize = $rootScope.sysParms.FILE_UPLD_MAX_SIZE;
        modal.laddaSave = false;
        var canceller = $q.defer();
        modal.close = function() {
            if ($scope.myFile && $scope.myFile.length > 0) {
                modal.laddaSave = true;
                var fd = new FormData();
                for (var i in $scope.myFile) {
                    if ($scope.myFile[i].size < $rootScope.sysParms.FILE_UPLD_MAX_SIZE) {
                        fd.append('file[' + i + ']', $scope.myFile[i]);
                    }
                }
                $http.post(apiUrl + 'docu/' + subj.subjId + '/uploadDocument/' + obsv.obsvId, fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    },
                    timeout: canceller.promise
                }).success(function(data) {
                    toastr.success(
                        $translate.instant('docu.home.toast.addFileSuccess'),
                        $translate.instant('docu.home.modal.addFileTitle'),
                        toastr.options
                    );
                    $uibModalInstance.close(data.obsvs[0]);
                }).error(function(data, status) {
                    if (status !== -1) {
                        toastr.error(
                            $translate.instant('docu.home.toast.addFileError'),
                            $translate.instant('docu.home.modal.addFileTitle'),
                            toastr.options
                        );
                    }
                    $uibModalInstance.close();
                });
            } else {
                $uibModalInstance.close();
            }
        };

        modal.cancel = function() {
            canceller.resolve();
            $uibModalInstance.close();
        };
    }

    function DocumentsConfirmDeleteModalCtrl($uibModalInstance, $uibModal, $http, apiUrl, fileObj, $translate) {
        var modal = this;
        modal.icon = 'fa fa-trash';
        modal.title = $translate.instant('docu.home.modal.delFileTitle');
        modal.text = $translate.instant('docu.home.modal.delFileText');
        modal.okButton = $translate.instant('docu.home.modal.delFileDelButton');
        modal.cancelButton = $translate.instant('docu.home.modal.delFileCancelButton');
        modal.laddaSave = false;
        modal.close = function() {
            modal.laddaSave = true;
            $http.delete(apiUrl + 'docu/' + fileObj.subjId + '/' + fileObj.obsvId + '/' + fileObj.docSeq, {
            }).success(function(data) {
                toastr.success(
                    $translate.instant('docu.home.toast.delFileSuccess'),
                    $translate.instant('docu.home.modal.upldDocTitle'),
                    toastr.options
                );
                $uibModalInstance.close(data.obsvs[0]);
            }).error(function() {
                toastr.error(
                    $translate.instant('docu.home.toast.delFileError'),
                    $translate.instant('docu.home.modal.upldDocTitle'),
                    toastr.options
                );
                $uibModalInstance.close();
            });
        };

        modal.cancel = function() {
            $uibModalInstance.close();
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('CollaborationService', ['$resource', 'apiUrl', CollaborationService]);

    function CollaborationService($resource, apiUrl) {
        var service = $resource(apiUrl + 'collab/:id', {}, {
            save: {
                url: apiUrl + 'collab/save',
                method: 'POST'
            },
            getCollab: {
                url: apiUrl + 'collab/:subjId',
                method: 'GET'
            }
        });
        return service;
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('collabUserRoleType', ['$filter', '$translate', '$timeout', collabUserRoleType])
        .directive('collabOrgRoleType', ['$filter', '$translate', '$timeout', collabOrgRoleType]);

    function collabUserRoleType($filter, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var user = scope.$eval(attrs.user);
                var userRoleType = scope.$eval(attrs.userRoleType);
                attrs.$observe('users', function () {
                    processUserRoleType();
                    return $timeout(function () {
                        highlightUserRoleTypeErrors();
                    });
                });
                attrs.$observe('uniqueSubj', function () {
                    processUserRoleType();
                    return $timeout(function () {
                        highlightUserRoleTypeErrors();
                    });
                });

                function processUserRoleType() {
                    //enable checkbox by default and then disable if rule met
                    $(element).iCheck('enable');
                    if (!user.popover) {
                        user.popover = {};
                    }
                    user.popover[userRoleType.userRoleTypeCd] = {};
                    var uniqueUserRoleHolder = scope.vm.getUniqueUserRoleHolder(userRoleType);
                    if (scope.$root.subject.myUserPermsns.indexOf('UPDT_COLLAB') === -1) {
                        //Permission Check
                        //if user has edit/udpate permission
                        user.popover[userRoleType.userRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtMembTitle'),
                            content: $translate.instant('collab.home.valid.noUpdtCollabPermsn')
                        };
                        $(element).iCheck('disable');
                    } else if (!scope.vm.isUserInManageableUsers(user)) {
                        //Permission to Manage check
                        //if user can manage this user
                        user.popover[userRoleType.userRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtMembTitle'),
                            content: $translate.instant('collab.home.valid.noCollabAllOrgsPermsnForMemb')
                        };
                        $(element).iCheck('disable');
                    } else if (!scope.vm.grantblUserRoles.includes(userRoleType.userRoleTypeCd)) {
                        //Grantability Check
                        //if user can grant this user role type
                        user.popover[userRoleType.userRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtMembTitle'),
                            content: $translate.instant('collab.home.valid.noGrantblRolePermsn', {
                                usrRoleTypeName: userRoleType.userRoleTypeName
                            })
                        };
                        $(element).iCheck('disable');
                    } else if (scope.vm.subjsInSubjGrp > 1 && userRoleType.subjTargUsrRoleFlag) {
                        //Check subjTargUsrRoleFlag for repeated assessments
                        //get user holding the target role
                        var userWithTargetRole;
                        angular.forEach(scope.vm.users, function(user) {
                            if (user.subjUserRoles.includes(userRoleType.userRoleTypeCd)) {
                                userWithTargetRole = user;
                            }
                        });
                        if (userWithTargetRole) {
                            user.popover[userRoleType.userRoleTypeCd] = {
                                title: $translate.instant('collab.home.help.updtMembTitle'),
                                content: $translate.instant('collab.home.valid.targUsrRoleType', {
                                    usrFullName: user.userFirstLastName,
                                    usrRoleTypeName: userRoleType.userRoleTypeName
                                })
                            };
                            $(element).iCheck('disable');
                        }
                    } else if (uniqueUserRoleHolder && uniqueUserRoleHolder.userId !== user.userId) {
                        //Uniqueness Check
                        //if unique and held by other user in any org
                        user.popover[userRoleType.userRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtMembTitle'),
                            content: $translate.instant('collab.home.valid.uniqUsrRoleType', {
                                usrFullName: uniqueUserRoleHolder.userFirstLastName,
                                usrRoleTypeName: userRoleType.userRoleTypeName
                            })
                        };
                        $(element).iCheck('disable');
                    } else if (!user.subjUserRoles.includes(userRoleType.userRoleTypeCd)) {
                        //Conflict Check
                        //if user role not selected/held by current user
                        // and the userRoleType has conflicts
                        if (userRoleType.conflictingRoles.length > 0) {
                            //find the conflict that is selected.
                            angular.forEach(userRoleType.conflictingRoles, function (conflictCd) { // userRoleType.conflictingRoles is an array of strings not json objs
                                if (user.subjUserRoles.includes(conflictCd)) {
                                    user.popover[userRoleType.userRoleTypeCd] = {
                                        title: $translate.instant('collab.home.help.updtMembTitle'),
                                        content: $translate.instant('collab.home.valid.conflgUsrRoleType', {
                                            firstUsrRoleTypeName: userRoleType.userRoleTypeName,
                                            secndUsrRoleTypeName: $filter('filter')(scope.vm.userRoleTypes, {userRoleTypeCd: conflictCd}, true)[0].userRoleTypeName
                                        })
                                    };
                                    $(element).iCheck('disable');
                                    return;
                                }
                            });
                        }
                    /*} else if (scope.vm.uniqueRoleClashes.subjId && $filter('filter')(scope.vm.targUserRoleTypes, {userRoleTypeCd: userRoleType.userRoleTypeCd}, true).length > 0) {
                        //check subject unique
                        user.popover[userRoleType.userRoleTypeCd] = {
                            title: 'Subject Exists',
                            content: 'Subject exists with this target role'
                        };*/
                    }
                }

                function highlightUserRoleTypeErrors() {
                    var err = false;
                    if (scope.vm.isUserRoleRequiredAndNotHeld(userRoleType) && !$(element).parent().hasClass('disabled')) {
                        err = true;
                    }
                    if (user.subjUserRoles.length === 0) {
                        err = true;
                    }
                    if (scope.vm.uniqueRoleClashes.subjId && $filter('filter')(scope.vm.targUserRoleTypes, {userRoleTypeCd: userRoleType.userRoleTypeCd}, true).length > 0) {
                        err = true;
                    }
                    if (err) {
                        $(element).parent().addClass('icheckbox_square-red');
                    } else {
                        $(element).parent().removeClass('icheckbox_square-red');
                    }
                }
            }
        };
    }

    function collabOrgRoleType($filter, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var org = scope.$eval(attrs.org);
                var orgRoleType = scope.$eval(attrs.orgRoleType);
                attrs.$observe('orgs', function () {
                    processOrgRoleType();
                    return $timeout(function () {
                        highlightOrgRoleTypeErrors();
                    });
                });
                attrs.$observe('uniqueSubj', function () {
                    return $timeout(function () {
                        highlightOrgRoleTypeErrors();
                    });
                });

                function processOrgRoleType() {
                    $(element).iCheck('enable');
                    if (!org.popover) {
                        org.popover = {};
                    }
                    org.popover[orgRoleType.orgRoleTypeCd] = {};
                    var uniqueOrgRoleHolder = scope.vm.getUniqueOrgRoleHolder(orgRoleType);
                    //Permission Check
                    //if user has edit/udpate permission
                    if (scope.$root.subject.myUserPermsns.indexOf('UPDT_COLLAB') === -1) {
                        org.popover[orgRoleType.orgRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtOrgTitle'),
                            content: $translate.instant('collab.home.valid.noUpdtCollabPermsn')
                        };
                        $(element).iCheck('disable');
                    } else if (!scope.vm.isOrgInManageableOrgs(org)) {
                        //Permission to Manage check
                        //if user can manage this org
                        org.popover[orgRoleType.orgRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtOrgTitle'),
                            content: $translate.instant('collab.home.valid.noCollabAllOrgsPermsnForOrg')
                        };
                        $(element).iCheck('disable');
                    } else if (!org.regstdOrgRoles.includes(orgRoleType.orgRoleTypeCd)) {
                        //if org cannot play an org role type
                        org.popover[orgRoleType.orgRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtOrgTitle'),
                            content: $translate.instant('collab.home.valid.orgRoleTypeNA', {
                                orgRoleTypeName: orgRoleType.orgRoleTypeName
                            })
                        };
                        $(element).iCheck('disable');
                    } else if (scope.vm.subjsInSubjGrp > 1 && orgRoleType.subjTargOrgRoleFlag) {
                        //Check subjTargOrgRoleFlag for repeated assessments
                        //get org holding the target role
                        var orgWithTargetRole;
                        angular.forEach(scope.vm.orgs, function(org) {
                            if (org.subjOrgRoles.includes(orgRoleType.orgRoleTypeCd)) {
                                orgWithTargetRole = org;
                            }
                        });
                        if (orgWithTargetRole) {
                            org.popover[orgRoleType.orgRoleTypeCd] = {
                                title: $translate.instant('collab.home.help.updtOrgTitle'),
                                content: $translate.instant('collab.home.valid.targOrgRoleType', {
                                    orgName: orgWithTargetRole.orgName,
                                    orgRoleTypeName: orgRoleType.orgRoleTypeName
                                })
                            };
                            $(element).iCheck('disable');
                        }
                    } else if (uniqueOrgRoleHolder && uniqueOrgRoleHolder.orgId !== org.orgId) {
                        //Uniqueness Check
                        //if unique and held by any other org
                        org.popover[orgRoleType.orgRoleTypeCd] = {
                            title: $translate.instant('collab.home.help.updtOrgTitle'),
                            content: $translate.instant('collab.home.valid.uniqOrgRoleType', {
                                orgName: uniqueOrgRoleHolder.orgName,
                                orgRoleTypeName: orgRoleType.orgRoleTypeName
                            })
                        };
                        $(element).iCheck('disable');
                    } else if (!org.subjOrgRoles.includes(orgRoleType.orgRoleTypeCd)) {
                        //Check Conflicts
                        // and the orgRoleType has conflicts
                        if (orgRoleType.conflictingRoles.length > 0) {
                            //find the conflict that is selected.
                            angular.forEach(orgRoleType.conflictingRoles, function (conflictCd) { // orgRoleType.conflictingRoles is an array of strings not json objs
                                if (org.subjOrgRoles.includes(conflictCd)) {
                                    org.popover[orgRoleType.orgRoleTypeCd] = {
                                        title: $translate.instant('collab.home.help.updtOrgTitle'),
                                        content: $translate.instant('collab.home.valid.conflgOrgRoleType', {
                                            firstOrgRoleTypeName: orgRoleType.orgRoleTypeName,
                                            secndOrgRoleTypeName: $filter('filter')(scope.vm.orgRoleTypes, {orgRoleTypeCd: conflictCd}, true)[0].orgRoleTypeName
                                        })
                                    };
                                    $(element).iCheck('disable');
                                    return false;
                                }
                            });
                        }
                    }
                }

                function highlightOrgRoleTypeErrors() {
                    var err = false;
                    if (scope.vm.isOrgRoleRequiredAndNotHeld(orgRoleType) && !$(element).parent().hasClass('disabled')) {
                        err = true;
                    }
                    if (org.subjOrgRoles.length === 0) {
                        err = true;
                    }
                    if (scope.vm.uniqueRoleClashes.subjId && $filter('filter')(scope.vm.targOrgRoleTypes, {orgRoleTypeCd: orgRoleType.orgRoleTypeCd}, true).length > 0) {
                        err = true;
                    }
                    if (err) {
                        $(element).parent().addClass('icheckbox_square-red');
                    } else {
                        $(element).parent().removeClass('icheckbox_square-red');
                    }
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('CollaborationCtrl', ['$rootScope', '$scope', '$state', '$filter', '$translate', '$http', '$uibModal', 'CollaborationService', 'SubjectsService', 'collab', 'subjRoleTypes', CollaborationCtrl])
        .controller('CollaborationConfirmModalCtrl', ['$uibModalInstance', '$translate', 'modalText', 'hasErrors', CollaborationConfirmModalCtrl]);

    function CollaborationCtrl($rootScope, $scope, $state, $filter, $translate, $http, $uibModal, CollaborationService, SubjectsService, collab, subjRoleTypes) {
        var vm = this;
        vm.showCollabFlag = $rootScope.subject.showCollabFlag;
        vm.orgs = collab.collabOrgs;
        vm.users = collab.collabUsers;
        vm.grantblUserRoles = collab.grantblUserRoles;
        vm.subjsInSubjGrp = collab.subjsInSubjGrp;
        vm.userRoleTypes = subjRoleTypes.data.userRoleTypes;
        vm.orgRoleTypes = subjRoleTypes.data.orgRoleTypes;
        vm.targUserRoleTypes = $filter('filter')(vm.userRoleTypes, {subjTargUsrRoleFlag: true}, true);
        vm.targOrgRoleTypes = $filter('filter')(vm.orgRoleTypes, {subjTargOrgRoleFlag: true}, true);
        vm.uniqueRoleClashes = {
            unique: true
        };
        vm.disableSave = true;
        vm.disableReset = true;
        vm.collabSaveLadda = false;
        vm.collabResetLadda = false;

        //Translations
        vm.selectNewMembText = $translate.instant('collab.home.selectNewMembText');
        vm.selectNewOrgText = $translate.instant('collab.home.selectNewOrgText');
        vm.addMembTitle = $translate.instant('collab.home.help.addMembTitle');
        vm.addOrgTitle = $translate.instant('collab.home.help.addOrgTitle');
        vm.noUpdtCollabPermsn = $translate.instant('collab.home.valid.noUpdtCollabPermsn');
        vm.noMembsFoundText = $translate.instant('collab.home.noMembsFoundText');
        vm.noMoreUsrsToAdd = $translate.instant('collab.home.valid.noMoreUsrsToAdd');
        vm.noMoreOrgsToAdd = $translate.instant('collab.home.valid.noMoreOrgsToAdd');
        vm.usrRoleTypeReqd = $translate.instant('collab.home.valid.usrRoleTypeReqd');
        vm.orgRoleTypeReqd = $translate.instant('collab.home.valid.orgRoleTypeReqd');

        vm.hasUpdtCollabPerm = function() {
            return $rootScope.subject && $rootScope.subject.myUserPermsns.indexOf('UPDT_COLLAB') !== -1;
        };

        vm.userList = function() {
            return collab.users.filter(function(user) {
                return $filter('filter')(vm.users, {userId: user.userId}, true).length === 0;
            });
        };

        vm.orgList = function() {
            return collab.orgs.filter(function(org) {
                return $filter('filter')(vm.orgs, {orgId: org.orgId}, true).length === 0;
            });
        };

        vm.isUserInManageableUsers = function(user) {
            return $filter('filter')(collab.users, {userId: user.userId}, true).length === 1;
        };

        vm.isOrgInManageableOrgs = function(org) {
            return $filter('filter')(collab.orgs, {orgId: org.orgId}, true).length === 1;
        };

        vm.getMinUserDispSeq = function(org) {
            if (vm.isOrgWithoutUsers(org)) {
                return 100;
            }
            var minUserDispSeq = 100;
            angular.forEach($filter('filter')(vm.users, {orgId: org.orgId}, true), function(user) {
                minUserDispSeq = Math.min(minUserDispSeq, user.dispSeq);
            });
            return minUserDispSeq;
        };

        vm.isUserWithoutRole = function() {
            var ret = false;
            angular.forEach(vm.users, function(user) {
                if (user.subjUserRoles.length === 0) {
                    ret = true;
                }
            });
            return ret;
        };

        vm.isOrgWithoutRole = function() {
            var ret = false;
            angular.forEach(vm.orgs, function(org) {
                if (org.subjOrgRoles.length === 0) {
                    ret = true;
                }
            });
            return ret;
        };

        vm.isOrgWithoutUsers = function(org) {
            return $filter('filter')(vm.users, {
                orgId: org.orgId
            }, true).length === 0;
        };

        vm.requiredUserRoles = $filter('filter')(vm.userRoleTypes, {
            reqdSubjUsrRoleFlag: true
        }, true);

        function processRequiredUserRolesNotHeld() {
            vm.requiredUserRolesNotHeld = [];
            if (vm.requiredUserRoles.length > 0) {
                angular.forEach(vm.requiredUserRoles, function(requiredUserRole) {
                    var roleHeld = false;
                    angular.forEach(vm.users, function(user) {
                        if (user.subjUserRoles.includes(requiredUserRole.userRoleTypeCd)) {
                            roleHeld = true;
                        }
                    });
                    if (!roleHeld) {
                        vm.requiredUserRolesNotHeld.push({
                            roleTypeCd: requiredUserRole.userRoleTypeCd,
                            dispSeq: requiredUserRole.dispSeq,
                            errMsg: $translate.instant('collab.home.valid.reqdUsrRoleType', {
                                usrRoleTypeName: requiredUserRole.userRoleTypeName
                            })
                        });
                    }
                });
            }
        }
        processRequiredUserRolesNotHeld();

        vm.isUserRoleRequiredAndNotHeld = function(userRoleType) {
            return $filter('filter')(vm.requiredUserRolesNotHeld, {roleTypeCd: userRoleType.userRoleTypeCd}, true).length > 0;
        };

        vm.uniqueUserRoleClash = function(userRoleType) {
            return vm.uniqueRoleClashes.subjUserRoleTypes && vm.uniqueRoleClashes.subjUserRoleTypes.includes(userRoleType.userRoleTypeCd);
        };

        vm.requiredOrgRoles = $filter('filter')(vm.orgRoleTypes, {reqdSubjOrgRoleFlag: true}, true);

        function processRequiredOrgRolesNotHeld() {
            vm.requiredOrgRolesNotHeld = [];
            if (vm.requiredOrgRoles.length > 0) {
                angular.forEach(vm.requiredOrgRoles, function(requiredOrgRole) {
                    var roleHeld = false;
                    angular.forEach(vm.orgs, function(org) {
                        if (org.subjOrgRoles.includes(requiredOrgRole.orgRoleTypeCd)) {
                            roleHeld = true;
                        }
                    });
                    if (!roleHeld) {
                        vm.requiredOrgRolesNotHeld.push({
                            roleTypeCd: requiredOrgRole.orgRoleTypeCd,
                            dispSeq: requiredOrgRole.dispSeq,
                            errMsg: $translate.instant('collab.home.valid.reqdOrgRoleType', {
                                orgRoleTypeName: requiredOrgRole.orgRoleTypeName
                            })
                        });
                    }
                });
            }
        }
        processRequiredOrgRolesNotHeld();

        vm.isOrgRoleRequiredAndNotHeld = function(orgRoleType) {
            return $filter('filter')(vm.requiredOrgRolesNotHeld, {roleTypeCd: orgRoleType.orgRoleTypeCd}, true).length > 0;
        };

        vm.uniqueOrgRoleClash = function(orgRoleType) {
            return vm.uniqueRoleClashes.subjOrgRoleTypes && vm.uniqueRoleClashes.subjOrgRoleTypes.includes(orgRoleType.orgRoleTypeCd);
        };

        vm.processUserDeleteBtn = function() {
            angular.forEach(vm.users, function(user) {
                var lastHeldRequiredUserRole = getLastHeldRequiredUserRole(user);
                var lastHeldRequiredUserOrgRole = getLastHeldRequiredUserOrgRole(user);
                if (!vm.hasUpdtCollabPerm()) {
                    user.disableDeleteBtn = true;
                    user.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delMembTitle'),
                        content: $translate.instant('collab.home.valid.noUpdtCollabPermsn')
                    };
                } else if (!vm.isUserInManageableUsers(user)) {
                    user.disableDeleteBtn = true;
                    user.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delMembTitle'),
                        content: $translate.instant('collab.home.valid.noCollabAllOrgsPermsnForMemb')
                    };
                } else if (lastHeldRequiredUserRole) {
                    user.disableDeleteBtn = true;
                    user.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delMembTitle'),
                        content: $translate.instant('collab.home.valid.lastReqdUsrRoleType', {
                            usrRoleTypeName: lastHeldRequiredUserRole.userRoleTypeName
                        })
                    };
                } else if (lastHeldRequiredUserOrgRole) {
                    var org = $filter('filter')(vm.orgs, {orgId: user.orgId}, true)[0];
                    user.disableDeleteBtn = true;
                    user.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delMembTitle'),
                        content: $translate.instant('collab.home.valid.lastUsrOnLastReqdOrgRoleType', {
                            orgName: org.orgName,
                            orgRoleTypeName: lastHeldRequiredUserOrgRole.orgRoleTypeName
                        })
                    };
                } else {
                    user.disableDeleteBtn = false;
                    user.deleteBtnPopover = {};
                }
            });
        };
        vm.processUserDeleteBtn();

        vm.processOrgDeleteBtn = function() {
            angular.forEach(vm.orgs, function(org) {
                var lastHeldRequiredOrgRole = getLastHeldRequiredOrgRole(org);
                if (!vm.hasUpdtCollabPerm()) {
                    org.disableDeleteBtn = true;
                    org.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delOrgTitle'),
                        content: $translate.instant('collab.home.valid.noUpdtCollabPermsn')
                    };
                } else if (!vm.isOrgInManageableOrgs(org)) {
                    org.disableDeleteBtn = true;
                    org.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delOrgTitle'),
                        content: $translate.instant('collab.home.valid.noCollabAllOrgsPermsnForOrg')
                    };
                } else if ($filter('filter')(vm.users, {orgId: org.orgId}, true)[0]) { // user found for this org.
                    org.disableDeleteBtn = true;
                    org.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delOrgTitle'),
                        content: $translate.instant('collab.home.valid.orgHasUsrs')
                    };
                } else if (lastHeldRequiredOrgRole) {
                    org.disableDeleteBtn = true;
                    org.deleteBtnPopover = {
                        title: $translate.instant('collab.home.help.delOrgTitle'),
                        content: $translate.instant('collab.home.valid.lastReqdOrgRoleType', {
                            orgRoleTypeName: lastHeldRequiredOrgRole.orgRoleTypeName
                        })
                    };
                } else {
                    org.disableDeleteBtn = false;
                    org.deleteBtnPopover = {};
                }
            });

        };
        vm.processOrgDeleteBtn();

        function getLastHeldRequiredUserRole(user) {
            var ret;
            angular.forEach(vm.requiredUserRoles, function(requiredUserRole) {
                if (user.subjUserRoles.includes(requiredUserRole.userRoleTypeCd)) {
                    var counter = 0;
                    angular.forEach(vm.users, function(otherUser) {
                        if (user.userId !== otherUser.userId && otherUser.subjUserRoles.includes(requiredUserRole.userRoleTypeCd)) {
                            counter++;
                        }
                    });
                    if (counter === 0) {
                        ret = requiredUserRole;
                    }
                }
            });
            return ret;
        }

        vm.getUniqueUserRoleHolder = function(userRoleType) {
            var ret;
            if (userRoleType.uniqSubjUsrRoleFlag) {
                angular.forEach(vm.users, function(user) {
                    if (user.subjUserRoles.includes(userRoleType.userRoleTypeCd)) {
                        ret = user;
                    }
                });
            }
            return ret;
        };

        function getLastHeldRequiredUserOrgRole(user) {
            var org = $filter('filter')(vm.orgs, {orgId: user.orgId}, true)[0];
            var orgUserCount = $filter('filter')(vm.users, {orgId: org.orgId}, true).length;
            if (orgUserCount > 1) {
                return;
            }
            return getLastHeldRequiredOrgRole(org);
        }

        function getLastHeldRequiredOrgRole(org) {
            var ret;
            angular.forEach(vm.requiredOrgRoles, function(requiredOrgRole) {
                if (org.subjOrgRoles.includes(requiredOrgRole.orgRoleTypeCd)) {
                    var counter = 0;
                    angular.forEach(vm.orgs, function(otherOrg) {
                        if (org.orgId !== otherOrg.orgId && otherOrg.subjOrgRoles.includes(requiredOrgRole.orgRoleTypeCd)) {
                            counter++;
                        }
                    });
                    if (counter === 0) {
                        ret = requiredOrgRole;
                    }
                }
            });
            return ret;
        }

        vm.getUniqueOrgRoleHolder = function(orgRoleType) {
            var ret;
            if (orgRoleType.uniqSubjOrgRoleFlag) {
                angular.forEach(vm.orgs, function(org) {
                    if (org.subjOrgRoles.includes(orgRoleType.orgRoleTypeCd)) {
                        ret = org;
                    }
                });
            }
            return ret;
        };

        (function() {
            $('#btnAddUser').attr('disabled', 'disabled');
        })();

        vm.holdsUserRole = function(user, userRoleType) {
            return user.subjUserRoles.includes(userRoleType.userRoleTypeCd);
        };

        vm.holdsOrgRole = function(org, orgRoleType) {
            return org.subjOrgRoles.includes(orgRoleType.orgRoleTypeCd);
        };

        vm.hasUniqueUserRoleClash = function(user) {
            var hasRole = false;
            angular.forEach(vm.uniqueRoleClashes.subjUserRoleTypes, function(roleType) {
                if (user.subjUserRoles.includes(roleType)) {
                    hasRole = true;
                }
            });
            return hasRole;
        };

        vm.hasUniqueOrgRoleClash = function(org) {
            var hasRole = false;
            angular.forEach(vm.uniqueRoleClashes.subjOrgRoleTypes, function(roleType) {
                if (org.subjOrgRoles.includes(roleType)) {
                    hasRole = true;
                }
            });
            return hasRole;
        };

        vm.userRoleChange = function(user, userRoleType) {
            if (!user.subjUserRoles.includes(userRoleType.userRoleTypeCd)) {
                user.subjUserRoles.push(userRoleType.userRoleTypeCd);
            } else {
                user.subjUserRoles.splice(user.subjUserRoles.indexOf(userRoleType.userRoleTypeCd), 1);
            }
            addPendingAction(user.userId, 'userRoles', 'info', $translate.instant('collab.home.modal.saveUpdtMembRoleText', {usrFullName: user.userLastFirstName}));
            processRequiredUserRolesNotHeld();
            vm.processUserDeleteBtn();
            checkUnique();
            vm.disableSave = false;
            vm.disableReset = false;
        };

        vm.orgRoleChange = function(org, orgRoleType) {
            if (!org.subjOrgRoles.includes(orgRoleType.orgRoleTypeCd)) {
                org.subjOrgRoles.push(orgRoleType.orgRoleTypeCd);
            } else {
                org.subjOrgRoles.splice(org.subjOrgRoles.indexOf(orgRoleType.orgRoleTypeCd), 1);
            }
            addPendingAction(org.orgId, 'orgRoles', 'info', $translate.instant('collab.home.modal.saveUpdtOrgRoleText', {orgName: org.orgName}));
            processRequiredOrgRolesNotHeld();
            vm.processUserDeleteBtn();
            vm.processOrgDeleteBtn();
            checkUnique();
            vm.disableSave = false;
            vm.disableReset = false;
        };

        function checkUnique() {
            var subjOrgRoles = {};
            angular.forEach(vm.orgs, function(org) {
                angular.forEach(org.subjOrgRoles, function(subjOrgRole) {
                    if (subjOrgRoles[subjOrgRole]) {
                        subjOrgRoles[subjOrgRole].push(org.orgId);
                    } else {
                        subjOrgRoles[subjOrgRole] = [org.orgId];
                    }
                });
            });
            var subjUserRoles = {};
            angular.forEach(vm.users, function(user) {
                angular.forEach(user.subjUserRoles, function(subjUserRole) {
                    if (subjUserRoles[subjUserRole]) {
                        subjUserRoles[subjUserRole].push(user.userId);
                    } else {
                        subjUserRoles[subjUserRole] = [user.userId];
                    }
                });
            });
            var roles = {
                exclSubjId: $rootScope.subject.subjId,
                subjOrgRoles: subjOrgRoles,
                subjUserRoles: subjUserRoles
            };
            SubjectsService.unique(roles, function onSuccess(data) {
                vm.uniqueRoleClashes = data;
            });
        }
        checkUnique();

        vm.newUser = null;
        vm.onSelectUser = function(item) {
            if (item) {
                vm.newUser = item;
                $('#btnAddUser').removeAttr('disabled').focus();
            }
        };

        vm.onSelectUserDD = function() {
            var user = $filter('filter')(vm.userList(), { userId: vm.ddUserSelected }, true)[0];
            vm.newUser = user;
            $('#btnAddUser').removeAttr('disabled').focus();
        };

        vm.addUser = function() {
            if (vm.newUser !== null && !$filter('filter')(vm.users, {userId: vm.newUser.userId}, true)[0]) {
                vm.newUser.subjUserRoles = [];
                vm.newUser.disableDeleteBtn = false;
                vm.newUser.deleteBtnPopover = {};
                vm.newUser.sendNewEmail = true;
                $('#txtNewUser').val('');
                vm.ddUserSelected = '';
                if (!$('#btnAddUser').is(':disabled')) {
                    $('#btnAddUser').attr('disabled', 'disabled');
                    vm.users.push(vm.newUser);
                    if ($filter('filter')(vm.orgs, {orgId: vm.newUser.orgId}, true).length === 0) {
                        var newUserOrg = $filter('filter')(collab.orgs, {orgId: vm.newUser.orgId}, true)[0];
                        var newOrg = {
                            orgId: vm.newUser.orgId,
                            orgName: vm.newUser.orgName,
                            subjOrgRoles: [],
                            regstdOrgRoles: newUserOrg.roles
                        };
                        vm.orgs.push(newOrg);
                        addPendingAction(newOrg.orgId, 'newOrg', 'info', $translate.instant('collab.home.modal.saveAddOrgText', {orgName: newOrg.orgName}));
                    }
                    addPendingAction(vm.newUser.userId, 'newUser', 'info', $translate.instant('collab.home.modal.saveAddMembText', {usrFullName: vm.newUser.userLastFirstName}));
                    $('#txtNewUser').focus();
                }
                vm.processUserDeleteBtn();
                vm.processOrgDeleteBtn();
                vm.disableSave = false;
                vm.disableReset = false;
                vm.newUser = null;
            }
        };

        vm.newOrg = null;
        vm.onSelectOrg = function(item) {
            if (item) {
                vm.newOrg = item;
                $('#btnAddOrg').removeAttr('disabled').focus();
            }
        };

        vm.onSelectOrgDD = function() {
            var org = $filter('filter')(vm.orgList(), { orgId: parseInt(vm.ddOrgSelected) }, true)[0];
            vm.newOrg = org;
            $('#btnAddOrg').removeAttr('disabled').focus();
        };

        vm.addOrg = function() {
            if (vm.newOrg !== null && !$filter('filter')(vm.orgs, {orgId: vm.newOrg.orgId}, true)[0]) {
                var newOrgObject = {
                    orgId: vm.newOrg.orgId,
                    orgName: vm.newOrg.orgName,
                    regstdOrgRoles: vm.newOrg.roles,
                    subjOrgRoles: [],
                    deleteBtnPopover: {}
                };
                $('#txtNewOrg').val('');
                vm.ddOrgSelected = '';
                if (!$('#btnAddOrg').is(':disabled')) {
                    $('#btnAddOrg').attr('disabled', 'disabled');
                    vm.orgs.push(newOrgObject);
                    addPendingAction(newOrgObject.orgId, 'newOrg', 'info', $translate.instant('collab.home.modal.saveAddOrgText', {orgName: newOrgObject.orgName}));
                    $('#txtNewOrg').focus();
                    vm.processOrgDeleteBtn();
                }
                vm.newOrg = null;
            }
        };

        vm.sendNewEmailChange = function() {
            vm.disableSave = false;
            vm.disableReset = false;
        };

        vm.removeUser = function(userToRemove) {
            if (userToRemove.disableDeleteBtn === false) {
                var userCounter = 0;
                var userToRemoveIdx;
                angular.forEach(vm.users, function(user, idx) {
                    if (user.orgId === userToRemove.orgId) {
                        userCounter++;
                    }
                    if (user.userId === userToRemove.userId) {
                        userToRemoveIdx = idx;
                    }
                });
                vm.users.splice(userToRemoveIdx, 1);
                addPendingAction(userToRemove.userId, 'removeUser', 'warning', $translate.instant('collab.home.modal.saveDelMembText', {usrFullName: userToRemove.userLastFirstName}));
                if (userCounter === 1) {
                    angular.forEach(vm.orgs, function(org, idx) {
                        if (org.orgId === userToRemove.orgId) {
                            vm.orgs.splice(idx, 1);
                            addPendingAction(org.orgId, 'removeOrg', 'warning', $translate.instant('collab.home.modal.saveDelOrgText', {orgName: org.orgName}));
                        }
                    });
                }
                vm.processUserDeleteBtn();
                vm.processOrgDeleteBtn();
                checkUnique();
                vm.disableSave = false;
                vm.disableReset = false;
            }
        };

        vm.removeOrg = function(orgToRemove) {
            if (orgToRemove.disableDeleteBtn === false) {
                angular.forEach(vm.orgs, function(org, idx) {
                    if (org.orgId === orgToRemove.orgId) {
                        vm.orgs.splice(idx, 1);
                        addPendingAction(org.orgId, 'removeOrg', 'warning', $translate.instant('collab.home.modal.saveDelOrgText', {orgName: org.orgName}));
                    }
                });
                vm.processOrgDeleteBtn();
                checkUnique();
                vm.disableSave = false;
                vm.disableReset = false;
            }
        };

        var pendingActions = [];
        function addPendingAction(actionId, actionType, actionBadgeType, actionDescription) {
            if (!actionExists(actionId, actionType)) {
                pendingActions.push({
                    actionId: actionId,
                    actionType: actionType,
                    actionBadgeType: actionBadgeType,
                    desc: actionDescription
                });
            }
        }

        function actionExists(actionId, actionType) {
            var result = false;
            angular.forEach(pendingActions, function(action) {
                if (action.actionId === actionId && action.actionType === actionType) {
                    result = true;
                }
            });
            return result;
        }

        setTimeout(function() {
            $('#txtNewUser').focus().val('');
        }, 100);

        vm.openConfirmDialog = function(event, toState, toParams) {
            var modalText = pendingActions2String();
            var hasErrors = vm.disableSave || vm.requiredUserRolesNotHeld.length > 0 || vm.requiredOrgRolesNotHeld.length > 0 || vm.isUserWithoutRole() || vm.isOrgWithoutRole();
            if (hasErrors) {
                modalText = $translate.instant('collab.home.modal.saveErrorText');
            }
            event.preventDefault();
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'CollaborationConfirmModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    modalText: function() {
                        return modalText;
                    },
                    hasErrors: function() {
                        return hasErrors;
                    }
                }
            });

            confirmModalInstance.result.then(function() {
                save(toState, toParams);
            }, function(result) {
                if (result === 'doNotSave') {
                    vm.collabSaveLadda = true;
                    if (toState) {
                        pendingActions = [];
                        $state.go(toState.name, toParams);
                    } else {
                        $state.reload();
                    }
                }
            });
        };

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
            if (pendingActions.length > 0 && toState.name !== 'app.subject.collaboration') {
                event.preventDefault();
                vm.openConfirmDialog(event, toState, toParams);
            }
        });

        function pendingActions2String() {
            var sbPendingActions = '<p class="">' + $translate.instant('collab.home.modal.saveText') + '</p>';
            sbPendingActions += '<ul>';
            angular.forEach(pendingActions, function(pendingAction) {
                sbPendingActions += '<li>' + pendingAction.desc + '</li>';
            });
            angular.forEach(vm.users, function(user) {
                if (user.sendNewEmail) {
                    sbPendingActions += '<li>' + $translate.instant('collab.home.modal.saveSendEmailText', {usrFullName: user.userLastFirstName}) + '</li>';
                }
            });
            sbPendingActions += '</ul>';
            return sbPendingActions;
        }

        function save(toState, toParams) {
            vm.collabSaveLadda = true;
            CollaborationService.save(getDataToSave(),
                function onSuccess() {
                    pendingActions = [];
                    toastr.success(
                        $translate.instant('collab.home.toast.updtCollabSuccess'),
                        $translate.instant('collab.home.pageTitle'),
                        toastr.options
                    );
                    if (toState) {
                        $state.go(toState.name, toParams);
                    } else {
                        $state.reload();
                    }
                }, function onError() {
                    toastr.error(
                        $translate.instant('collab.home.toast.updtCollabError'),
                        $translate.instant('collab.home.pageTitle'),
                        toastr.options
                    );
                }
            );
        }

        function getDataToSave() {
            var saveData = {};
            saveData.subjId = collab.subjId;
            saveData.subjOrgs = vm.orgs;
            saveData.subjUsers = vm.users;
            return saveData;
        }

        vm.resetForm = function() {
            vm.collabResetLadda = true;
            pendingActions = [];
            $state.reload();
        };

    }

    function CollaborationConfirmModalCtrl($uibModalInstance, $translate, modalText, hasErrors) {
        var modal = this;
        modal.icon = 'fa-users';
        modal.title = 'collab.home.modal.saveTitle';
        modal.text = modalText;
        modal.okButton = 'collab.home.modal.saveYesButton';
        modal.cancelButton = 'collab.home.modal.cancelButton';
        modal.doNotSaveButton = 'collab.home.modal.saveNoButton';
        modal.hasErrors = hasErrors;

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        modal.doNotSave = function() {
            $uibModalInstance.dismiss('doNotSave');
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('AnalyticsService', ['$resource', 'apiUrl', AnalyticsService]);

    function AnalyticsService($resource, apiUrl) {
        var service = $resource(apiUrl + 'analytics', {}, {
            getPeerGroups: {
                url: apiUrl + 'analytics/peerGroups',
                method: 'GET',
                isArray: true
            },
            getChartCds: {
                url: apiUrl + 'analytics/chartCds',
                method: 'GET',
                isArray: true
            }
        });
        return service;
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AnalyticsCtrl', ['$rootScope', '$translate', '$filter', '$http', '$timeout', 'AppService', 'chartCds', 'peerGrps', 'chartGrps', 'apiUrl', AnalyticsCtrl]);

    function AnalyticsCtrl($rootScope, $translate, $filter, $http, $timeout, AppService, chartCds, peerGrps, chartGrps, apiUrl) {
        var vm = this;
        vm.subject = $rootScope.subject;
        vm.charts = [];
        vm.filteredCharts = vm.charts;

        vm.showHelp = [];
        vm.toggleHelp = function(idx) {
            vm.showHelp[idx] = !vm.showHelp[idx];
        };

        vm.grpTypes = [{
            grpName: $translate.instant('anlytcs.home.chartGrpsLabel'),
            grpSeq: 1
        }];
        vm.selectedGrpType = vm.grpTypes[0];

        vm.peerGrps = $filter('orderBy')(peerGrps.data, 'peerGrpId');
        vm.chartGrps = $filter('orderBy')(chartGrps.data, 'grpSeq');
        vm.filteredChartGrps = vm.chartGrps;
        vm.filteredGrps; // model variable for groups filters drop down

        vm.selectedChartSize;
        vm.chartSizes = [
            {
                id: 1,
                name: $translate.instant('anlytcs.home.sizeLargeLabel'),
                lgCol: 6,
                mdCol: 12,
                smCol: 12,
                xsCol: 12
            },
            {
                id: 3,
                name: $translate.instant('anlytcs.home.sizeSmallLabel'),
                lgCol: 4,
                mdCol: 6,
                smCol: 6,
                xsCol: 12
            }
        ];
        vm.selectedChartSize = vm.chartSizes[0];

        vm.filters = [];

        //add peer group label
        angular.forEach(vm.peerGrps, function(peerGrp) {
            var group = {};
            group.grpId = peerGrp.peerGrpId;
            group.grpName = peerGrp.peerGrpName;
            group.grpTypeId = 2;
            group.grpTypeName = $translate.instant('anlytcs.home.peerGrpsLabel');
            vm.filters.push(group);
        });

        //add charts group label
        angular.forEach(vm.chartGrps, function(grp) {
            var group = {};
            group.grpId = grp.grpId;
            group.grpName = grp.grpName;
            group.grpTypeId = 3;
            group.grpTypeName = $translate.instant('anlytcs.home.chartGrpsLabel');
            vm.filters.push(group);
        });

        if (chartCds || ($rootScope && $rootScope.subject && $rootScope.subject.analytics)) {
            if ($rootScope && $rootScope.subject && $rootScope.subject.analytics) {
                chartCds = $rootScope.subject.analytics;
            }

            vm.filteredPeerGrpIds = [];
            vm.applyFilter = function() {
                vm.filteredPeerGrpIds = [];
                var chartGrps = [];
                angular.forEach(vm.filteredGrps, function(grp) {
                    if (grp.grpTypeId < 3) {
                        vm.filteredPeerGrpIds.push(grp.grpId);
                    } else if (grp.grpTypeId >= 3) {
                        var tempGrp = $filter('filter')(vm.chartGrps, { grpId: grp.grpId })[0];
                        if (tempGrp) {
                            chartGrps.push(tempGrp);
                        }
                    }
                });
                if (chartGrps.length) {
                    vm.filteredChartGrps = chartGrps;
                } else {
                    vm.filteredChartGrps = vm.chartGrps;
                }
                getCharts();
            };

            //initialise chart array
            angular.forEach(chartCds, function() {
                vm.charts.push({});
            });

            getCharts();

            function getCharts() {
                angular.forEach(chartCds, function(chartCd, idx) {
                    var requestObj = {
                        asOfFromDate: $rootScope.userParms.DT_RANGE_CD.val.asOfFromDate,
                        asOfToDate: $rootScope.userParms.DT_RANGE_CD.val.asOfToDate
                    };
                    if ($rootScope.userParms.ORG_ID) {
                        requestObj.orgId = $rootScope.userParms.ORG_ID.val;
                    }
                    if ($rootScope.subject) {
                        requestObj.subjId = $rootScope.subject.subjId;
                    }
                    if (vm.filteredPeerGrpIds && vm.filteredPeerGrpIds.length) {
                        requestObj.peerGrpIds = vm.filteredPeerGrpIds;
                    }
                    $http.post(apiUrl + 'analytics/chart/' + chartCd, requestObj).success(function(chart) {
                        if (chart && chart.config) {
                            chart.config.chartTitle = chart.chartTitle;
                            addTip(chart);
                            if (!chart.config.showValueAxisLabel) {
                                delete chart.config.valueAxisLabel;
                            }
                            delete chart.config.showValueAxisLabel;
                            chart.config.download = (chart.config.allowChartDownld !== undefined) ? chart.config.allowChartDownld : false;
                            chart.config.width = 400;
                            chart.config.height = 300;
                            chart.config.padding = {
                                top: 15,
                                bottom: 15,
                                left: 15,
                                right: 15
                            };

                            //check if any elements have highlights
                            if (chart.data.series) {
                                angular.forEach(chart.data.series, function(series) {
                                    if ($filter('filter')(series.elements, {highlight: true}).length > 0) {
                                        chart.config.highlightLegendText = $translate.instant('anlytcs.home.chart.currSubjSelectText');
                                    }
                                });
                            }
                            vm.charts[idx] = chart;
                        }
                    });
                });
            }

            function addTip(chart) {
                if (chart && chart.data && chart.data.series) {
                    angular.forEach(chart.data.series, function(series) {
                        angular.forEach(series.elements, function(element) {
                            var seriesName = (chart.data.series.length > 1) ? series.seriesName + ': ' : '';
                            if (element.value) {
                                var catgAxisLabel = (chart.config.catgAxisLabel) ? chart.config.catgAxisLabel + ': ' : '';
                                element.tip = '<div class=\'idmx-d3-tip\' tooltip-animation-class=\'fade\'><div class=\'arrow\'></div><div class=\'popover-inner\'>' +
                                    '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                                    '<div class="color-box" style="background-color:' + series.seriesColor + '"></div>' +
                                    '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + seriesName + catgAxisLabel + element.category + '</h3></div>' +
                                    '</div>' +
                                    '<div class=\'popover-content\' style=\'background-color: white; border: 2px solid #f3f3f4; border-top: none;\'>'
                                    + (chart.config.valueAxisLabel ? chart.config.valueAxisLabel + ': ' : '')
                                    + (chart.config.valueAxisScaleLabelPrefix ? chart.config.valueAxisScaleLabelPrefix : '')
                                    + (chart.config.valueAxisValDP !== undefined ? element.value.toFixed(chart.config.valueAxisValDP) : element.value)
                                    + (chart.config.valueAxisScaleLabelSuffix ? chart.config.valueAxisScaleLabelSuffix : '')
                                    + ' &nbsp;&nbsp;&nbsp;&nbsp;</div></div></div>';
                            }
                        });
                    });
                }
            }

            vm.getGroupCharts = function(sysDocSubGrpCd) {
                return $filter('filter')(vm.charts, {sysDocSubGrpCd: sysDocSubGrpCd}, true);
            };

            vm.sizeChange = function() {
                //wait for screen redraw and then trigger a change to each chart object so the directive redraws
                $timeout(function() {
                    angular.forEach(vm.charts, function(chart) {
                        chart.config.resize = vm.selectedChartSize;
                    });
                });
            };

            vm.downloadChart = function(chart) {
                var chartSvg = document.querySelector('svg#' + chart.config.id + '_svg');
                var downloadImagePlaceholderEl = $('#download-image-placeholder');
                var svgString = new XMLSerializer().serializeToString(chartSvg);

                var canvas = document.createElement('canvas');
                canvas.width = chart.config.width * 2;
                canvas.height = chart.config.height * 2;

                var ctx = canvas.getContext('2d');
                var DOMURL = self.URL || self.webkitURL || self;
                var img = new Image();
                var svg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
                var url = DOMURL.createObjectURL(svg);
                var mimeType = 'image/png';
                var mimeTypeImage;
                img.onload = function() {
                    ctx.drawImage(img, 0, 0);
                    mimeTypeImage = canvas.toDataURL(mimeType, 1.0);
                    $(downloadImagePlaceholderEl).innerHTML = '<img src="' + mimeTypeImage + '"/>';
                    DOMURL.revokeObjectURL(mimeTypeImage);
                    var a = document.createElement('a');
                    a.download = chart.chartTitle.replace('.', '') + ' ' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                    a.href = mimeTypeImage;
                    a.click();
                };
                img.src = url;
            };

        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('StateHandler', ['$rootScope', '$state', '$sessionStorage', '$window', '$translate', 'AuthService', 'Principal', StateHandler]);

    function StateHandler($rootScope, $state, $sessionStorage, $window, $translate, AuthService, Principal) {

        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = '0.1';
            console.log('Initializing...');
            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState, fromStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                $rootScope.fromStateParams = fromStateParams;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    AuthService.authorize();
                }
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('ErrorHandlerInterceptor', ['$q', '$rootScope', ErrorHandlerInterceptor]);

    function ErrorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))) {
                $rootScope.$emit('idmxapiApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthInterceptor', ['$sessionStorage', AuthInterceptor]);

    function AuthInterceptor($sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthExpiredInterceptor', ['$q', '$injector', '$sessionStorage', AuthExpiredInterceptor]);

    function AuthExpiredInterceptor($q, $injector, $sessionStorage) {
        var service = {
            responseError: responseError
        };
        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var AuthService = $injector.get('AuthService');
                    AuthService.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('Principal', ['$q', '$sessionStorage', 'AccountService', Principal]);

    function Principal($q, $sessionStorage, AccountService) {
        var parseJwt = function(token) {
            if (token !== undefined) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace('-', '+').replace('_', '/');
                return JSON.parse(window.atob(base64));
            }
        };

        var _identity;
        var _authenticated = false;

        var service = {
            authenticate: authenticate,
            unauthenticate: unauthenticate,
            hasAnyUserPerm: hasAnyUserPerm,
            hasUserPerm: hasUserPerm,
            userPerms: userPerms,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            userPrefs: userPrefs
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function unauthenticate() {
            if (_authenticated) {
                _identity = null;
                _authenticated = null;
            }
        }

        function hasAnyUserPerm(userPerms) {
            if (!_authenticated) {
                return false;
            }
            for (var i = 0; i < userPerms.length; i++) {
                if (parseJwt($sessionStorage.authenticationToken).auth.split(',').indexOf(userPerms[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }

        function hasUserPerm(userPerm) {
            if (!_authenticated) {
                return $q.when(false);
            }
            return parseJwt($sessionStorage.authenticationToken).auth.split(',').indexOf(userPerm) !== -1;
        }

        function userPerms() {
            if (!_authenticated) {
                return $q.when('');
            }
            return parseJwt($sessionStorage.authenticationToken).auth.split(',');
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            AccountService.getWithInterceptor().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function userPrefs() {
            return _identity.userPrefs;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('PasswordService', ['$resource', 'apiUrl', PasswordService]);

    function PasswordService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'authenticate', {}, {
            reqReset: {
                url: apiUrl + 'authenticate/requestPasswordReset?userId=:userId',
                method: 'GET'
            },
            reset: {
                url: apiUrl + 'authenticate/passwordReset',
                method: 'POST'
            },
            validateHash: {
                url: apiUrl + 'authenticate/validateHash?userId=:userId&hash=:hash',
                method: 'GET'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthenticateService', ['$resource', 'apiUrl', AuthenticateService]);

    function AuthenticateService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'activate', {}, {
            get: {
                method: 'GET',
                isArray: false
            },
            activate: {
                url: apiUrl + 'authenticate/activate',
                method: 'POST'
            },
            selfRegister: {
                url: apiUrl + 'authenticate/selfRegister',
                method: 'POST'
            },
            getUserByUserId: {
                url: apiUrl + 'authenticate/getUser?userId=:userId&hash=:hash',
                method: 'GET'
            },
            validateUserId: {
                url: apiUrl + 'authenticate/validateUserId?userId=:userId',
                method: 'GET'
            },
            validateMobileNumber: {
                url: apiUrl + 'authenticate/validateMobileNumber?userId=:userId&moblPhonNum=:moblPhonNum&moblPhonCntryCd=:moblPhonCntryCd',
                method: 'GET'
            },
            logoutLog: {
                url: apiUrl + 'authenticate/logout?sessnEndMthdCd=:sessnEndMthdCd',
                method: 'GET'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthService', ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', AuthService]);

    function AuthService ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider) {
        var service = {
            authorize: authorize,
            login: login,
            logout: logout,
            getPreviousState: getPreviousState,
            resetPreviousState: resetPreviousState
        };

        return service;

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('app');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                // check user is authenticated if required
                if ($rootScope.toState.data.authenticationReqd && !isAuthenticated) {
                    console.log('not authenticated!');
                    storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
                    // now, send them to the signin state so they can log in
                    $state.go('login', { reload: true });
                }

                //set language
                if (isAuthenticated && Principal.userPrefs()) {
                    $translate.use(Principal.userPrefs().PREF_LANG);
                }

                //check user has required system permission
                if ($rootScope.toState.data.userPerms) {
                    if (!Principal.hasAnyUserPerm($rootScope.toState.data.userPerms)) {
                        console.log('accessed denined!');
                        if ($rootScope.toState.data && $rootScope.toState.data.i18n && $rootScope.toState.data.i18n.userPermsMsg) {
                            $rootScope.userPermsMsg = $rootScope.toState.data.i18n.userPermsMsg;
                        } else {
                            $rootScope.userPermsMsg = '403.valid.noPermsn';
                        }
                        $state.go('app.403');
                    }
                }
            }
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                if (data.status === 'success') {
                    Principal.identity(true).then(function() {
                        deferred.resolve(data);
                    });
                }
                deferred.resolve(data);
                return cb();
            }

            return deferred.promise;
        }

        function logout(sessnEndMthdCd) {
            AuthServerProvider.logout(sessnEndMthdCd);
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            if (previousStateName && previousStateParams) {
                var previousState = {
                    name: previousStateName,
                    params: previousStateParams
                };
                $sessionStorage.previousState = previousState;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthServerProvider', ['$state', '$http', '$sessionStorage', 'apiUrl', 'AuthenticateService', 'Principal', AuthServerProvider]);

    function AuthServerProvider($state, $http, $sessionStorage, apiUrl, AuthenticateService, Principal) {
        var service = {
            login: login,
            logout: logout,
            storeAuthenticationToken: storeAuthenticationToken
        };

        return service;

        function login(credentials) {
            return $http.post(apiUrl + 'authenticate', credentials).then(authenticateSuccess);

            function authenticateSuccess(data) {
                if (data.data.idToken) {
                    var bearerToken = data.data.idToken;
                    if (angular.isDefined(bearerToken)) {
                        service.storeAuthenticationToken(bearerToken);
                        return {
                            status: 'success',
                            token: bearerToken
                        };
                    }
                } else if (data.data.tfaRequired) {
                    return {
                        status: 'tfaRequired'
                    };
                } else if (data.data.error) {
                    return {
                        status: 'error',
                        error: data.data.error,
                        suspended: data.data.suspended
                    };
                }
            }
        }

        function logout(sessnEndMthdCd) {
            Principal.unauthenticate();
            if ($state.current.name !== 'login') {
                return AuthenticateService.logoutLog({
                    sessnEndMthdCd: sessnEndMthdCd
                }).$promise.then(function () {
                    delete $sessionStorage.authenticationToken;
                    delete $sessionStorage.bcast;
                    $state.go('login', {}, { reload: true });
                }, function () {
                    delete $sessionStorage.authenticationToken;
                    delete $sessionStorage.bcast;
                    $state.go('login', {}, { reload: true });
                });
            }
        }

        function storeAuthenticationToken(jwt) {
            $sessionStorage.authenticationToken = jwt;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('AccountService', ['$resource', 'apiUrl', AccountService]);

    function AccountService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'account', {}, {
            get: {
                method: 'GET',
                isArray: false
            },
            getWithInterceptor: {
                method: 'GET',
                params: {},
                isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            save: {
                method: 'PUT'
            },
            changePassword: {
                url: apiUrl + 'account/changePassword',
                method: 'POST'
            },
            validatePassword: {
                url: apiUrl + 'account/validatePassword?newPassword=:newPassword',
                method: 'GET'
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('OrgConnxnService', ['$resource', 'apiUrl', OrgConnxnService]);

    function OrgConnxnService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'orgs', {}, {
            get: {
                url: apiUrl + 'orgs/:orgId/orgconnxn/:connxnOrgId',
                params: {
                    connected: '@connected'
                },
                method: 'GET'
            },
            getAll: {
                url: apiUrl + 'orgs/:orgId/orgconnxn/all',
                method: 'GET',
                isArray: true
            },
            create: {
                url: apiUrl + 'orgs/:orgId/orgconnxn',
                params: {
                    connxnOrgId: '@connxnOrgId'
                },
                method: 'POST'
            },
            update: {
                url: apiUrl + 'orgs/:orgId/orgconnxn',
                params: {
                    connxnOrgId: '@connxnOrgId'
                },
                method: 'PUT'
            },
            resendInvite: {
                url: apiUrl + 'orgs/:orgId/orgconnxn/resendInvite/:connxnOrgId',
                method: 'GET'
            },
            validateOrgConnxn: {
                url: apiUrl + 'orgs/:orgId/orgconnxn/validate',
                method: 'GET',
                params: {
                    connxnUserId: '@connxnUserId'
                }
            }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('activeOrgConnxnDt', ['$timeout', '$filter', '$translate', activeOrgConnxnDt])
        .directive('archiveOrgConnxnDt', ['$timeout', '$filter', '$translate', archiveOrgConnxnDt])
        .directive('orgsTab1', ['Principal', orgsTab1])
        .directive('orgsTab2', orgsTab2);

    function activeOrgConnxnDt($timeout, $filter, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            responsivePriority: 1,
                            targets: 0
                        }, {
                            responsivePriority: 2,
                            targets: 1
                        }, {
                            responsivePriority: 3,
                            targets: 2
                        }, {
                            targets: 4,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            responsivePriority: 4,
                            targets: 6,
                            orderable: false,
                            searchable: false
                        }],
                        autoWidth: false,
                        order: [
                            [4, 'desc']
                        ],
                        drawCallback: function () {
                            var searchBox = $('div#activeOrgsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('sysAdmin.mangOrgs.searchText')).attr('id', 'search-box-active-tab');
                            $('div#activeOrgsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function archiveOrgConnxnDt($timeout, $filter, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            responsivePriority: 1,
                            targets: 0
                        }, {
                            responsivePriority: 2,
                            targets: 1
                        }, {
                            responsivePriority: 3,
                            targets: 2
                        }, {
                            targets: 4,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            responsivePriority: 4,
                            targets: 6,
                            orderable: false,
                            searchable: false
                        }],
                        autoWidth: false,
                        order: [
                            [4, 'desc']
                        ],
                        drawCallback: function () {
                            var searchBox = $('div#archivedOrgsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('sysAdmin.mangOrgs.searchText')).attr('id', 'search-box-archive-tab');
                            searchBox.hide(); // hide initially
                            $('div#archivedOrgsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function orgsTab1(Principal) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-active-tab').show();
                    $('#search-box-archive-tab').hide();
                    $('.add-org').attr('disabled', !Principal.hasAnyUserPerm(['MANG_SYS_ADMIN', 'MANG_ORG_ADMIN']));
                });
            }
        };
    }

    function orgsTab2() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-active-tab').hide();
                    $('#search-box-archive-tab').show();
                    $('.add-org').attr('disabled', true);
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminOrgConnxnCtrl', ['$rootScope', '$state', '$translate', 'OrgConnxnService', 'orgconnxns', AdminOrgConnxnCtrl]);

    function AdminOrgConnxnCtrl($rootScope, $state, $translate, OrgConnxnService, orgconnxns) {
        var vm = this;
        vm.orgRoleTypes = $rootScope.referenceData.ORG_ROLE_TYPE.refItems;
        vm.orgId = $state.params.orgId;
        if (orgconnxns.status !== 403) {
            vm.orgconnxns = orgconnxns;
            vm.activeOrgconnxns = vm.orgconnxns.filter(function(orgconnxn) {
                return orgconnxn.connxnStatusCd !== 'V';
            });

            vm.archivedOrgconnxns = vm.orgconnxns.filter(function(orgconnxn) {
                return orgconnxn.connxnStatusCd === 'V';
            });
        }
        vm.roleName = function(cd) {
            return vm.orgRoleTypes.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.cntryName = function(cd) {
            return $rootScope.referenceData.CNTRY_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.statusName = function(cd) {
            return $rootScope.referenceData.ORG_CONNXN_STAT_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.resendInvite = function(connxnOrgId) {
            OrgConnxnService.resendInvite({orgId: vm.orgId, connxnOrgId: connxnOrgId}, function onSuccess() {
                toastr.success(
                    $translate.instant('sysAdmin.mangOrgConnxns.toast.connxnEmailSuccess'),
                    $translate.instant('sysAdmin.mangOrgConnxns.pageTitle'),
                    toastr.options
                );
            }, function onError() {
                toastr.error(
                    $translate.instant('sysAdmin.mangOrgConnxns.toast.connxnEmailError'),
                    $translate.instant('sysAdmin.mangOrgConnxns.pageTitle'),
                    toastr.options
                );
            });
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminEditOrgConnxnCtrl', ['$rootScope', '$state', '$uibModal', '$translate', '$timeout', 'Principal', 'orgconnxn', 'OrgConnxnService', AdminEditOrgConnxnCtrl]);

    function AdminEditOrgConnxnCtrl($rootScope, $state, $uibModal, $translate, $timeout, Principal, orgconnxn, OrgConnxnService) {
        var vm = this;

        if (orgconnxn.status !== 403) {
            vm.orgconnxn = orgconnxn;
        }

        vm.action = 'cancel';
        vm.orgId = $state.params.orgId;
        vm.connxdOrgUsers;
        vm.connxgOrgUsers;
        vm.statusName = function(cd) {
            return $rootScope.referenceData.ORG_CONNXN_STAT_CD.refItems.filter(function (status) {
                return status.cd === cd;
            });
        };

        var isConnecting = orgconnxn.connecting;
        var status = orgconnxn.connxnStatusCd;
        vm.applicableAction = {accept: false, reject: false, revoke: false, reconnect: false};
        vm.instructionTxt = '';
        if (status === 'P' && isConnecting === true) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.pendgConnxgInstrText';
            vm.applicableAction.revoke = true;
        } else if (status === 'P' && isConnecting === false) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.pendgConnxdInstrText';
            vm.applicableAction.accept = true;
            vm.applicableAction.reject = true;
        } else if (status === 'A') {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.actvAllInstrText';
            vm.applicableAction.revoke = true;
        } else if (status === 'J' && isConnecting === true) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.rejctdConnxgInstrText';
            vm.applicableAction.revoke = true;
        } else if (status === 'J' && isConnecting === false) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.rejctdConnxdInstrText';
            vm.applicableAction.accept = true;
        } else if (status === 'V' && isConnecting === true) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.revkdAllInstrText';
            vm.applicableAction.reconnect = true;
        } else if (status === 'V' && isConnecting === false) {
            vm.instructionTxt = 'sysAdmin.updtOrgConnxn.revkdAllInstrText';
            vm.applicableAction.reconnect = true;
        }
        vm.reconnect = function() {
            $rootScope.orgconnxn = vm.orgconnxn;
            $state.go('app.admin.adminOrgs.orgconnxns.addOrgConnxn', {reload: true});
        };
        vm.submit = function(editOrgConnxnForm, action) {
            vm.orgconnxn.connxnStatusCd = action;
            if ($.isEmptyObject(editOrgConnxnForm.$error)) {
                OrgConnxnService.update({orgId: vm.orgId}, vm.orgconnxn, function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.updtOrgConnxn.toast.updtOrgConnxnSuccess'),
                        $translate.instant('sysAdmin.updtOrgConnxn.pageTitle'),
                        toastr.options
                    );
                    $state.go('app.admin.adminOrgs.orgconnxns', {orgId: vm.orgId}, {reload: true});
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.updtOrgConnxn.toast.updtOrgConnxnError'),
                        $translate.instant('sysAdmin.updtOrgConnxn.pageTitle '),
                        toastr.options
                    );
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminAddOrgConnxnCtrl', ['$rootScope', '$q', '$scope', '$state', '$translate', '$filter', '$timeout', 'account', 'Principal', 'OrgConnxnService', 'UserService', 'org', AdminAddOrgConnxnCtrl]);

    function AdminAddOrgConnxnCtrl($rootScope, $q, $scope, $state, $translate, $filter, $timeout, account, Principal, OrgConnxnService, UserService, org) {
        var vm = this;
        vm.orgId = $state.params.orgId;
        vm.orgUsers;
        if (org.status !== 403) {
            vm.org = org;
        }
        vm.hasMangSysPerm = Principal.hasUserPerm('MANG_SYS_ADMIN');
        vm.hasMangOrgPerm = Principal.hasUserPerm('MANG_ORG_ADMIN');
        vm.orgconnxn = {
            connxgUser: {},
            connxgOrg: {
                orgName: org.orgName,
                orgId: org.orgId
            },
            connxdUser: {},
            connxdOrg: {}
        };

        vm.status = $rootScope.referenceData.ORG_CONNXN_STAT_CD.refItems;
        vm.pendingStatusLbl = $filter('filter')(vm.status, {
            cd: 'P'
        }, true)[0].nm;

        if (vm.hasMangOrgPerm && !vm.hasMangSysPerm) {
            vm.orgconnxn.connxgUser.userId = account.data.userId;
        }

        if (vm.hasMangSysPerm && !vm.reconnect) {
            UserService.getUsersByOrg({
                orgId: vm.orgId
            }).$promise.then(function(users) {
                vm.connxgOrgUsers = users;
            }, function(reason) {
                return reason;
            });
        }
        $timeout(function() {
            $('input').on('keydown', function(e) {
                if (e.keyCode === 8 || e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 46) {
                    vm.enableValidate();
                }
            });

            $('input').on('keypress change', function() {
                vm.enableValidate();
            });

            $('#btnSubmit').on('mousedown', function() {
                $scope.newOrgConnxnForm.$submitted = true;
            });
        });

        vm.enableValidate = function() {
            $('#validateBtn').attr('disabled', false);
            $('#btnSubmit').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('#btnSubmit').attr('disabled', true);
            $('#validateBtn').attr('disabled', true);
        };

        vm.validateOrgConnxn = function(connxdUserId) {
            resetError();
            return $q(function(resolve) {
                if ($scope.newOrgConnxnForm.connxdUserId.$error.required === true || $scope.newOrgConnxnForm.connxdUserId.$error.pattern === true) {
                    vm.disableSubmit();
                }
                var isError = false;
                if ($scope.newOrgConnxnForm && $scope.newOrgConnxnForm.connxdUserId.$error.required !== true && $scope.newOrgConnxnForm.connxdUserId.$error.pattern !== true) {
                    OrgConnxnService.validateOrgConnxn({
                        orgId: vm.orgId,
                        connxdUserId: connxdUserId || $scope.newOrgConnxnForm.connxdUserId.$viewValue,
                        add: !vm.reconnect
                    }).$promise.then(function(data) {
                        if (data.invalidConnxndUser) {
                            isError = true;
                            vm.disableSubmit();
                            vm.orgconnxn.connxdOrg.orgName = '';
                            $scope.newOrgConnxnForm.connxdUserId.$invalid = true;
                            $scope.newOrgConnxnForm.connxdUserId.$error.nonexistingUser = true;
                        } else if (data.invalidConnxnAlreadyExist) {
                            isError = true;
                            vm.disableSubmit();
                            vm.orgconnxn.connxdOrg.orgName = data.connectingOrgName;
                            $scope.newOrgConnxnForm.connxdUserId.$invalid = true;
                            $scope.newOrgConnxnForm.connxdUserId.$error.connxnAlreadyExist = true;
                            switch (data.connectionStatus) {
                            case 'Active':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.actvAllOrgConnxnExists');
                                break;
                            case 'Pending/Connecting':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.pendgConnxgConnxnExists');
                                break;
                            case 'Pending/Connected':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.pendgConnxdConnxnExists');
                                break;
                            case 'Rejected/Connecting':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.rejctdConnxgConnxnExists');
                                break;
                            case 'Rejected/Connected':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.rejctdConnxdConnxnExists');
                                break;
                            case 'Revoked':
                                vm.connectionExistsMsg = $translate.instant('sysAdmin.addOrgConnxn.valid.revkdAllOrgConnxnExists');
                                break;
                            }
                        } else if (data.invalidSameOrg && !data.invalidConnxndUser) {
                            isError = true;
                            vm.disableSubmit();
                            vm.orgconnxn.connxdOrg.orgName = data.connectingOrgName;
                            $scope.newOrgConnxnForm.connxdUserId.$invalid = true;
                            $scope.newOrgConnxnForm.connxdUserId.$error.invalidSameOrg = true;
                        }
                        if (!isError) {
                            UserService.getUserForOrgconnxnLkup({
                                userId: vm.orgconnxn.connxdUser.userId
                            }).$promise.then(function(user) {
                                vm.orgconnxn.connxdOrg = {
                                    orgName: user.orgName,
                                    orgId: user.orgId
                                };
                                vm.orgconnxn.connxdUser = user;
                                $scope.newOrgConnxnForm.connxdUserId.$valid = true;
                                $scope.newOrgConnxnForm.connxdUserId.$invalid = false;
                                resetError();
                                return resolve(isError);
                            }, function(reason) {
                                return reason;
                            });
                        }
                    });
                }
            });
        };

        function resetError() {
            if ($scope.newOrgConnxnForm && $scope.newOrgConnxnForm.connxdUserId) {
                $scope.newOrgConnxnForm.connxdUserId.$error.nonexistingUser = false;
                $scope.newOrgConnxnForm.connxdUserId.$error.connxnAlreadyExist = false;
                $scope.newOrgConnxnForm.connxdUserId.$error.invalidSameOrg = false;
            }
        }

        vm.submit = function(newOrgConnxnForm) {
            if ($.isEmptyObject(newOrgConnxnForm.$error)) {
                vm.validateOrgConnxn().then(function (isError) {
                    if (!isError) {
                        OrgConnxnService.create({orgId: vm.orgId, add: !vm.reconnect}, vm.orgconnxn, function onSuccess() {
                            var success = true;
                            if (success === true) {
                                toastr.success(
                                    $translate.instant('sysAdmin.addOrgConnxn.toast.addOrgConnxnSuccess'),
                                    $translate.instant('sysAdmin.addOrgConnxn.pageTitle'),
                                    toastr.options
                                );
                                $state.go('app.admin.adminOrgs.orgconnxns', {orgId: vm.orgId}, {reload: true});
                            }
                        }, function onError() {
                            toastr.error(
                                $translate.instant('sysAdmin.addOrgConnxn.toast.addOrgConnxnError'),
                                $translate.instant('sysAdmin.addOrgConnxn.pageTitle'),
                                toastr.options
                            );
                        });
                    }
                });
            }
        };
        //Reconnect
        vm.reconnect = false;
        if ($rootScope.orgconnxn) {
            //Reconnect
            vm.reconnect = true;
            vm.orgconnxn = $rootScope.orgconnxn;
            var oldOrgConnxn = angular.copy(vm.orgconnxn);
            if (org.orgId !== vm.orgconnxn.connxgOrgId) {
                vm.orgconnxn.connxgUser = oldOrgConnxn.connxdUser;
                vm.orgconnxn.connxgOrg = oldOrgConnxn.connxdOrg;
                vm.orgconnxn.connxdUser = oldOrgConnxn.connxgUser;
                vm.orgconnxn.connxdOrg = oldOrgConnxn.connxgOrg;
            }
            if (vm.hasMangSysPerm) {
                UserService.getUsersByOrg({
                    orgId: vm.orgconnxn.connxgOrg.orgId
                }).$promise.then(function(users) {
                    vm.connxgOrgUsers = users;
                }, function(reason) {
                    return reason;
                });
                UserService.getUsersByOrg({
                    orgId: vm.orgconnxn.connxdOrg.orgId
                }).$promise.then(function(users) {
                    vm.connxdOrgUsers = users;
                }, function(reason) {
                    return reason;
                });
            }
            if (vm.hasMangOrgPerm && !vm.hasMangSysPerm) {
                vm.orgconnxn.connxgUser = {
                    userId: account.data.userId
                };
            }
            if (vm.hasMangOrgPerm && !vm.hasMangSysPerm) {
                vm.orgconnxn.connxdOrg = {};
                angular.element(document).ready(function() {
                    $timeout(function() {
                        $scope.newOrgConnxnForm.connxdUserId.$dirty = true;
                        vm.validateOrgConnxn(vm.orgconnxn.connxdUser.userId);
                    });
                });
            }
            $rootScope.orgconnxn = null;
        }

    }

})();
/**
 * Super simple wysiwyg editor v0.8.12
 * https://summernote.org
 *
 * Copyright 2013- Alan Hong. and other contributors
 * summernote may be freely distributed under the MIT license.
 *
 * Date: 2019-05-16T08:16Z
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('jquery')) :
    typeof define === 'function' && define.amd ? define(['jquery'], factory) :
    (global = global || self, factory(global.jQuery));
  }(this, function ($$1) { 'use strict';
  
    $$1 = $$1 && $$1.hasOwnProperty('default') ? $$1['default'] : $$1;
  
    var Renderer = /** @class */ (function () {
        function Renderer(markup, children, options, callback) {
            this.markup = markup;
            this.children = children;
            this.options = options;
            this.callback = callback;
        }
        Renderer.prototype.render = function ($parent) {
            var $node = $$1(this.markup);
            if (this.options && this.options.contents) {
                $node.html(this.options.contents);
            }
            if (this.options && this.options.className) {
                $node.addClass(this.options.className);
            }
            if (this.options && this.options.data) {
                $$1.each(this.options.data, function (k, v) {
                    $node.attr('data-' + k, v);
                });
            }
            if (this.options && this.options.click) {
                $node.on('click', this.options.click);
            }
            if (this.children) {
                var $container_1 = $node.find('.note-children-container');
                this.children.forEach(function (child) {
                    child.render($container_1.length ? $container_1 : $node);
                });
            }
            if (this.callback) {
                this.callback($node, this.options);
            }
            if (this.options && this.options.callback) {
                this.options.callback($node);
            }
            if ($parent) {
                $parent.append($node);
            }
            return $node;
        };
        return Renderer;
    }());
    var renderer = {
        create: function (markup, callback) {
            return function () {
                var options = typeof arguments[1] === 'object' ? arguments[1] : arguments[0];
                var children = Array.isArray(arguments[0]) ? arguments[0] : [];
                if (options && options.children) {
                    children = options.children;
                }
                return new Renderer(markup, children, options, callback);
            };
        }
    };
  
    var editor = renderer.create('<div class="note-editor note-frame panel panel-default"/>');
    var toolbar = renderer.create('<div class="note-toolbar panel-heading" role="toolbar"></div></div>');
    var editingArea = renderer.create('<div class="note-editing-area"/>');
    var codable = renderer.create('<textarea class="note-codable" role="textbox" aria-multiline="true"/>');
    var editable = renderer.create('<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"/>');
    var statusbar = renderer.create([
        '<output class="note-status-output" aria-live="polite"/>',
        '<div class="note-statusbar" role="status">',
        '  <div class="note-resizebar" role="seperator" aria-orientation="horizontal" aria-label="Resize">',
        '    <div class="note-icon-bar"/>',
        '    <div class="note-icon-bar"/>',
        '    <div class="note-icon-bar"/>',
        '  </div>',
        '</div>',
    ].join(''));
    var airEditor = renderer.create('<div class="note-editor"/>');
    var airEditable = renderer.create([
        '<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"/>',
        '<output class="note-status-output" aria-live="polite"/>',
    ].join(''));
    var buttonGroup = renderer.create('<div class="note-btn-group btn-group">');
    var dropdown = renderer.create('<ul class="dropdown-menu" role="list">', function ($node, options) {
        var markup = Array.isArray(options.items) ? options.items.map(function (item) {
            var value = (typeof item === 'string') ? item : (item.value || '');
            var content = options.template ? options.template(item) : item;
            var option = (typeof item === 'object') ? item.option : undefined;
            var dataValue = 'data-value="' + value + '"';
            var dataOption = (option !== undefined) ? ' data-option="' + option + '"' : '';
            return '<li role="listitem" aria-label="' + value + '"><a href="#" ' + (dataValue + dataOption) + '>' + content + '</a></li>';
        }).join('') : options.items;
        $node.html(markup).attr({ 'aria-label': options.title });
    });
    var dropdownButtonContents = function (contents, options) {
        return contents + ' ' + icon(options.icons.caret, 'span');
    };
    var dropdownCheck = renderer.create('<ul class="dropdown-menu note-check" role="list">', function ($node, options) {
        var markup = Array.isArray(options.items) ? options.items.map(function (item) {
            var value = (typeof item === 'string') ? item : (item.value || '');
            var content = options.template ? options.template(item) : item;
            return '<li role="listitem" aria-label="' + item + '"><a href="#" data-value="' + value + '">' + icon(options.checkClassName) + ' ' + content + '</a></li>';
        }).join('') : options.items;
        $node.html(markup).attr({ 'aria-label': options.title });
    });
    var palette = renderer.create('<div class="note-color-palette"/>', function ($node, options) {
        var contents = [];
        for (var row = 0, rowSize = options.colors.length; row < rowSize; row++) {
            var eventName = options.eventName;
            var colors = options.colors[row];
            var colorsName = options.colorsName[row];
            var buttons = [];
            for (var col = 0, colSize = colors.length; col < colSize; col++) {
                var color = colors[col];
                var colorName = colorsName[col];
                buttons.push([
                    '<button type="button" class="note-color-btn"',
                    'style="background-color:', color, '" ',
                    'data-event="', eventName, '" ',
                    'data-value="', color, '" ',
                    'title="', colorName, '" ',
                    'aria-label="', colorName, '" ',
                    'data-toggle="button" tabindex="-1"></button>',
                ].join(''));
            }
            contents.push('<div class="note-color-row">' + buttons.join('') + '</div>');
        }
        $node.html(contents.join(''));
        if (options.tooltip) {
            $node.find('.note-color-btn').tooltip({
                container: options.container,
                trigger: 'hover',
                placement: 'bottom'
            });
        }
    });
    var dialog = renderer.create('<div class="modal" aria-hidden="false" tabindex="-1" role="dialog"/>', function ($node, options) {
        if (options.fade) {
            $node.addClass('fade');
        }
        $node.attr({
            'aria-label': options.title
        });
        $node.html([
            '<div class="modal-dialog">',
            '  <div class="modal-content">',
            (options.title
                ? '    <div class="modal-header">' +
                    '      <button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-hidden="true">&times;</button>' +
                    '      <h4 class="modal-title">' + options.title + '</h4>' +
                    '    </div>' : ''),
            '    <div class="modal-body">' + options.body + '</div>',
            (options.footer
                ? '    <div class="modal-footer">' + options.footer + '</div>' : ''),
            '  </div>',
            '</div>',
        ].join(''));
    });
    var popover = renderer.create([
        '<div class="note-popover popover in">',
        '  <div class="arrow"/>',
        '  <div class="popover-content note-children-container"/>',
        '</div>',
    ].join(''), function ($node, options) {
        var direction = typeof options.direction !== 'undefined' ? options.direction : 'bottom';
        $node.addClass(direction);
        if (options.hideArrow) {
            $node.find('.arrow').hide();
        }
    });
    var checkbox = renderer.create('<div class="checkbox"></div>', function ($node, options) {
        $node.html([
            '<label' + (options.id ? ' for="' + options.id + '"' : '') + '>',
            ' <input role="checkbox" type="checkbox"' + (options.id ? ' id="' + options.id + '"' : ''),
            (options.checked ? ' checked' : ''),
            ' aria-checked="' + (options.checked ? 'true' : 'false') + '"/>',
            (options.text ? options.text : ''),
            '</label>',
        ].join(''));
    });
    var icon = function (iconClassName, tagName) {
        tagName = tagName || 'i';
        return '<' + tagName + ' class="' + iconClassName + '"/>';
    };
    var ui = {
        editor: editor,
        toolbar: toolbar,
        editingArea: editingArea,
        codable: codable,
        editable: editable,
        statusbar: statusbar,
        airEditor: airEditor,
        airEditable: airEditable,
        buttonGroup: buttonGroup,
        dropdown: dropdown,
        dropdownButtonContents: dropdownButtonContents,
        dropdownCheck: dropdownCheck,
        palette: palette,
        dialog: dialog,
        popover: popover,
        checkbox: checkbox,
        icon: icon,
        options: {},
        button: function ($node, options) {
            return renderer.create('<button type="button" class="note-btn btn btn-default btn-sm" role="button" tabindex="-1">', function ($node, options) {
                if (options && options.tooltip) {
                    $node.attr({
                        title: options.tooltip,
                        'aria-label': options.tooltip
                    }).tooltip({
                        container: (options.container !== undefined) ? options.container : 'body',
                        trigger: 'hover',
                        placement: 'bottom'
                    }).on('click', function (e) {
                        $$1(e.currentTarget).tooltip('hide');
                    });
                }
            })($node, options);
        },
        toggleBtn: function ($btn, isEnable) {
            $btn.toggleClass('disabled', !isEnable);
            $btn.attr('disabled', !isEnable);
        },
        toggleBtnActive: function ($btn, isActive) {
            $btn.toggleClass('active', isActive);
        },
        onDialogShown: function ($dialog, handler) {
            $dialog.one('shown.bs.modal', handler);
        },
        onDialogHidden: function ($dialog, handler) {
            $dialog.one('hidden.bs.modal', handler);
        },
        showDialog: function ($dialog) {
            $dialog.modal('show');
        },
        hideDialog: function ($dialog) {
            $dialog.modal('hide');
        },
        createLayout: function ($note, options) {
            var $editor = (options.airMode ? ui.airEditor([
                ui.editingArea([
                    ui.airEditable(),
                ]),
            ]) : ui.editor([
                ui.toolbar(),
                ui.editingArea([
                    ui.codable(),
                    ui.editable(),
                ]),
                ui.statusbar(),
            ])).render();
            $editor.insertAfter($note);
            return {
                note: $note,
                editor: $editor,
                toolbar: $editor.find('.note-toolbar'),
                editingArea: $editor.find('.note-editing-area'),
                editable: $editor.find('.note-editable'),
                codable: $editor.find('.note-codable'),
                statusbar: $editor.find('.note-statusbar')
            };
        },
        removeLayout: function ($note, layoutInfo) {
            $note.html(layoutInfo.editable.html());
            layoutInfo.editor.remove();
            $note.show();
        }
    };
  
    $$1.summernote = $$1.summernote || {
        lang: {}
    };
    $$1.extend($$1.summernote.lang, {
        'en-US': {
            font: {
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underline',
                clear: 'Remove Font Style',
                height: 'Line Height',
                name: 'Font Family',
                strikethrough: 'Strikethrough',
                subscript: 'Subscript',
                superscript: 'Superscript',
                size: 'Font Size'
            },
            image: {
                image: 'Picture',
                insert: 'Insert Image',
                resizeFull: 'Resize full',
                resizeHalf: 'Resize half',
                resizeQuarter: 'Resize quarter',
                resizeNone: 'Original size',
                floatLeft: 'Float Left',
                floatRight: 'Float Right',
                floatNone: 'Remove float',
                shapeRounded: 'Shape: Rounded',
                shapeCircle: 'Shape: Circle',
                shapeThumbnail: 'Shape: Thumbnail',
                shapeNone: 'Shape: None',
                dragImageHere: 'Drag image or text here',
                dropImage: 'Drop image or Text',
                selectFromFiles: 'Select from files',
                maximumFileSize: 'Maximum file size',
                maximumFileSizeError: 'Maximum file size exceeded.',
                url: 'Image URL',
                remove: 'Remove Image',
                original: 'Original'
            },
            video: {
                video: 'Video',
                videoLink: 'Video Link',
                insert: 'Insert Video',
                url: 'Video URL',
                providers: '(YouTube, Vimeo, Vine, Instagram, DailyMotion or Youku)'
            },
            link: {
                link: 'Link',
                insert: 'Insert Link',
                unlink: 'Unlink',
                edit: 'Edit',
                textToDisplay: 'Text to display',
                url: 'To what URL should this link go?',
                openInNewWindow: 'Open in new window'
            },
            table: {
                table: 'Table',
                addRowAbove: 'Add row above',
                addRowBelow: 'Add row below',
                addColLeft: 'Add column left',
                addColRight: 'Add column right',
                delRow: 'Delete row',
                delCol: 'Delete column',
                delTable: 'Delete table'
            },
            hr: {
                insert: 'Insert Horizontal Rule'
            },
            style: {
                style: 'Style',
                p: 'Normal',
                blockquote: 'Quote',
                pre: 'Code',
                h1: 'Header 1',
                h2: 'Header 2',
                h3: 'Header 3',
                h4: 'Header 4',
                h5: 'Header 5',
                h6: 'Header 6'
            },
            lists: {
                unordered: 'Unordered list',
                ordered: 'Ordered list'
            },
            options: {
                help: 'Help',
                fullscreen: 'Full Screen',
                codeview: 'Code View'
            },
            paragraph: {
                paragraph: 'Paragraph',
                outdent: 'Outdent',
                indent: 'Indent',
                left: 'Align left',
                center: 'Align center',
                right: 'Align right',
                justify: 'Justify full'
            },
            color: {
                recent: 'Recent Color',
                more: 'More Color',
                background: 'Background Color',
                foreground: 'Foreground Color',
                transparent: 'Transparent',
                setTransparent: 'Set transparent',
                reset: 'Reset',
                resetToDefault: 'Reset to default',
                cpSelect: 'Select'
            },
            shortcut: {
                shortcuts: 'Keyboard shortcuts',
                close: 'Close',
                textFormatting: 'Text formatting',
                action: 'Action',
                paragraphFormatting: 'Paragraph formatting',
                documentStyle: 'Document Style',
                extraKeys: 'Extra keys'
            },
            help: {
                'insertParagraph': 'Insert Paragraph',
                'undo': 'Undoes the last command',
                'redo': 'Redoes the last command',
                'tab': 'Tab',
                'untab': 'Untab',
                'bold': 'Set a bold style',
                'italic': 'Set a italic style',
                'underline': 'Set a underline style',
                'strikethrough': 'Set a strikethrough style',
                'removeFormat': 'Clean a style',
                'justifyLeft': 'Set left align',
                'justifyCenter': 'Set center align',
                'justifyRight': 'Set right align',
                'justifyFull': 'Set full align',
                'insertUnorderedList': 'Toggle unordered list',
                'insertOrderedList': 'Toggle ordered list',
                'outdent': 'Outdent on current paragraph',
                'indent': 'Indent on current paragraph',
                'formatPara': 'Change current block\'s format as a paragraph(P tag)',
                'formatH1': 'Change current block\'s format as H1',
                'formatH2': 'Change current block\'s format as H2',
                'formatH3': 'Change current block\'s format as H3',
                'formatH4': 'Change current block\'s format as H4',
                'formatH5': 'Change current block\'s format as H5',
                'formatH6': 'Change current block\'s format as H6',
                'insertHorizontalRule': 'Insert horizontal rule',
                'linkDialog.show': 'Show Link Dialog'
            },
            history: {
                undo: 'Undo',
                redo: 'Redo'
            },
            specialChar: {
                specialChar: 'SPECIAL CHARACTERS',
                select: 'Select Special characters'
            }
        }
    });
  
    var isSupportAmd = typeof define === 'function' && define.amd; // eslint-disable-line
    /**
     * returns whether font is installed or not.
     *
     * @param {String} fontName
     * @return {Boolean}
     */
    function isFontInstalled(fontName) {
        var testFontName = fontName === 'Comic Sans MS' ? 'Courier New' : 'Comic Sans MS';
        var testText = 'mmmmmmmmmmwwwww';
        var testSize = '200px';
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        context.font = testSize + " '" + testFontName + "'";
        var originalWidth = context.measureText(testText).width;
        context.font = testSize + " '" + fontName + "', '" + testFontName + "'";
        var width = context.measureText(testText).width;
        return originalWidth !== width;
    }
    var userAgent = navigator.userAgent;
    var isMSIE = /MSIE|Trident/i.test(userAgent);
    var browserVersion;
    if (isMSIE) {
        var matches = /MSIE (\d+[.]\d+)/.exec(userAgent);
        if (matches) {
            browserVersion = parseFloat(matches[1]);
        }
        matches = /Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent);
        if (matches) {
            browserVersion = parseFloat(matches[1]);
        }
    }
    var isEdge = /Edge\/\d+/.test(userAgent);
    var hasCodeMirror = !!window.CodeMirror;
    var isSupportTouch = (('ontouchstart' in window) ||
        (navigator.MaxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    // [workaround] IE doesn't have input events for contentEditable
    // - see: https://goo.gl/4bfIvA
    var inputEventName = (isMSIE || isEdge) ? 'DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted' : 'input';
    /**
     * @class core.env
     *
     * Object which check platform and agent
     *
     * @singleton
     * @alternateClassName env
     */
    var env = {
        isMac: navigator.appVersion.indexOf('Mac') > -1,
        isMSIE: isMSIE,
        isEdge: isEdge,
        isFF: !isEdge && /firefox/i.test(userAgent),
        isPhantom: /PhantomJS/i.test(userAgent),
        isWebkit: !isEdge && /webkit/i.test(userAgent),
        isChrome: !isEdge && /chrome/i.test(userAgent),
        isSafari: !isEdge && /safari/i.test(userAgent),
        browserVersion: browserVersion,
        jqueryVersion: parseFloat($$1.fn.jquery),
        isSupportAmd: isSupportAmd,
        isSupportTouch: isSupportTouch,
        hasCodeMirror: hasCodeMirror,
        isFontInstalled: isFontInstalled,
        isW3CRangeSupport: !!document.createRange,
        inputEventName: inputEventName
    };
  
    /**
     * @class core.func
     *
     * func utils (for high-order func's arg)
     *
     * @singleton
     * @alternateClassName func
     */
    function eq(itemA) {
        return function (itemB) {
            return itemA === itemB;
        };
    }
    function eq2(itemA, itemB) {
        return itemA === itemB;
    }
    function peq2(propName) {
        return function (itemA, itemB) {
            return itemA[propName] === itemB[propName];
        };
    }
    function ok() {
        return true;
    }
    function fail() {
        return false;
    }
    function not(f) {
        return function () {
            return !f.apply(f, arguments);
        };
    }
    function and(fA, fB) {
        return function (item) {
            return fA(item) && fB(item);
        };
    }
    function self(a) {
        return a;
    }
    function invoke(obj, method) {
        return function () {
            return obj[method].apply(obj, arguments);
        };
    }
    var idCounter = 0;
    /**
     * generate a globally-unique id
     *
     * @param {String} [prefix]
     */
    function uniqueId(prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
    }
    /**
     * returns bnd (bounds) from rect
     *
     * - IE Compatibility Issue: http://goo.gl/sRLOAo
     * - Scroll Issue: http://goo.gl/sNjUc
     *
     * @param {Rect} rect
     * @return {Object} bounds
     * @return {Number} bounds.top
     * @return {Number} bounds.left
     * @return {Number} bounds.width
     * @return {Number} bounds.height
     */
    function rect2bnd(rect) {
        var $document = $(document);
        return {
            top: rect.top + $document.scrollTop(),
            left: rect.left + $document.scrollLeft(),
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
    }
    /**
     * returns a copy of the object where the keys have become the values and the values the keys.
     * @param {Object} obj
     * @return {Object}
     */
    function invertObject(obj) {
        var inverted = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                inverted[obj[key]] = key;
            }
        }
        return inverted;
    }
    /**
     * @param {String} namespace
     * @param {String} [prefix]
     * @return {String}
     */
    function namespaceToCamel(namespace, prefix) {
        prefix = prefix || '';
        return prefix + namespace.split('.').map(function (name) {
            return name.substring(0, 1).toUpperCase() + name.substring(1);
        }).join('');
    }
    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     * @param {Function} func
     * @param {Number} wait
     * @param {Boolean} immediate
     * @return {Function}
     */
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this;
            var args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
    /**
     *
     * @param {String} url
     * @return {Boolean}
     */
    function isValidUrl(url) {
        var expression = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
        return expression.test(url);
    }
    var func = {
        eq: eq,
        eq2: eq2,
        peq2: peq2,
        ok: ok,
        fail: fail,
        self: self,
        not: not,
        and: and,
        invoke: invoke,
        uniqueId: uniqueId,
        rect2bnd: rect2bnd,
        invertObject: invertObject,
        namespaceToCamel: namespaceToCamel,
        debounce: debounce,
        isValidUrl: isValidUrl
    };
  
    /**
     * returns the first item of an array.
     *
     * @param {Array} array
     */
    function head(array) {
        return array[0];
    }
    /**
     * returns the last item of an array.
     *
     * @param {Array} array
     */
    function last(array) {
        return array[array.length - 1];
    }
    /**
     * returns everything but the last entry of the array.
     *
     * @param {Array} array
     */
    function initial(array) {
        return array.slice(0, array.length - 1);
    }
    /**
     * returns the rest of the items in an array.
     *
     * @param {Array} array
     */
    function tail(array) {
        return array.slice(1);
    }
    /**
     * returns item of array
     */
    function find(array, pred) {
        for (var idx = 0, len = array.length; idx < len; idx++) {
            var item = array[idx];
            if (pred(item)) {
                return item;
            }
        }
    }
    /**
     * returns true if all of the values in the array pass the predicate truth test.
     */
    function all(array, pred) {
        for (var idx = 0, len = array.length; idx < len; idx++) {
            if (!pred(array[idx])) {
                return false;
            }
        }
        return true;
    }
    /**
     * returns true if the value is present in the list.
     */
    function contains(array, item) {
        if (array && array.length && item) {
            return array.indexOf(item) !== -1;
        }
        return false;
    }
    /**
     * get sum from a list
     *
     * @param {Array} array - array
     * @param {Function} fn - iterator
     */
    function sum(array, fn) {
        fn = fn || func.self;
        return array.reduce(function (memo, v) {
            return memo + fn(v);
        }, 0);
    }
    /**
     * returns a copy of the collection with array type.
     * @param {Collection} collection - collection eg) node.childNodes, ...
     */
    function from(collection) {
        var result = [];
        var length = collection.length;
        var idx = -1;
        while (++idx < length) {
            result[idx] = collection[idx];
        }
        return result;
    }
    /**
     * returns whether list is empty or not
     */
    function isEmpty(array) {
        return !array || !array.length;
    }
    /**
     * cluster elements by predicate function.
     *
     * @param {Array} array - array
     * @param {Function} fn - predicate function for cluster rule
     * @param {Array[]}
     */
    function clusterBy(array, fn) {
        if (!array.length) {
            return [];
        }
        var aTail = tail(array);
        return aTail.reduce(function (memo, v) {
            var aLast = last(memo);
            if (fn(last(aLast), v)) {
                aLast[aLast.length] = v;
            }
            else {
                memo[memo.length] = [v];
            }
            return memo;
        }, [[head(array)]]);
    }
    /**
     * returns a copy of the array with all false values removed
     *
     * @param {Array} array - array
     * @param {Function} fn - predicate function for cluster rule
     */
    function compact(array) {
        var aResult = [];
        for (var idx = 0, len = array.length; idx < len; idx++) {
            if (array[idx]) {
                aResult.push(array[idx]);
            }
        }
        return aResult;
    }
    /**
     * produces a duplicate-free version of the array
     *
     * @param {Array} array
     */
    function unique(array) {
        var results = [];
        for (var idx = 0, len = array.length; idx < len; idx++) {
            if (!contains(results, array[idx])) {
                results.push(array[idx]);
            }
        }
        return results;
    }
    /**
     * returns next item.
     * @param {Array} array
     */
    function next(array, item) {
        if (array && array.length && item) {
            var idx = array.indexOf(item);
            return idx === -1 ? null : array[idx + 1];
        }
        return null;
    }
    /**
     * returns prev item.
     * @param {Array} array
     */
    function prev(array, item) {
        if (array && array.length && item) {
            var idx = array.indexOf(item);
            return idx === -1 ? null : array[idx - 1];
        }
        return null;
    }
    /**
     * @class core.list
     *
     * list utils
     *
     * @singleton
     * @alternateClassName list
     */
    var lists = {
        head: head,
        last: last,
        initial: initial,
        tail: tail,
        prev: prev,
        next: next,
        find: find,
        contains: contains,
        all: all,
        sum: sum,
        from: from,
        isEmpty: isEmpty,
        clusterBy: clusterBy,
        compact: compact,
        unique: unique
    };
  
    var NBSP_CHAR = String.fromCharCode(160);
    var ZERO_WIDTH_NBSP_CHAR = '\ufeff';
    /**
     * @method isEditable
     *
     * returns whether node is `note-editable` or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    function isEditable(node) {
        return node && $$1(node).hasClass('note-editable');
    }
    /**
     * @method isControlSizing
     *
     * returns whether node is `note-control-sizing` or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    function isControlSizing(node) {
        return node && $$1(node).hasClass('note-control-sizing');
    }
    /**
     * @method makePredByNodeName
     *
     * returns predicate which judge whether nodeName is same
     *
     * @param {String} nodeName
     * @return {Function}
     */
    function makePredByNodeName(nodeName) {
        nodeName = nodeName.toUpperCase();
        return function (node) {
            return node && node.nodeName.toUpperCase() === nodeName;
        };
    }
    /**
     * @method isText
     *
     *
     *
     * @param {Node} node
     * @return {Boolean} true if node's type is text(3)
     */
    function isText(node) {
        return node && node.nodeType === 3;
    }
    /**
     * @method isElement
     *
     *
     *
     * @param {Node} node
     * @return {Boolean} true if node's type is element(1)
     */
    function isElement(node) {
        return node && node.nodeType === 1;
    }
    /**
     * ex) br, col, embed, hr, img, input, ...
     * @see http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
     */
    function isVoid(node) {
        return node && /^BR|^IMG|^HR|^IFRAME|^BUTTON|^INPUT|^AUDIO|^VIDEO|^EMBED/.test(node.nodeName.toUpperCase());
    }
    function isPara(node) {
        if (isEditable(node)) {
            return false;
        }
        // Chrome(v31.0), FF(v25.0.1) use DIV for paragraph
        return node && /^DIV|^P|^LI|^H[1-7]/.test(node.nodeName.toUpperCase());
    }
    function isHeading(node) {
        return node && /^H[1-7]/.test(node.nodeName.toUpperCase());
    }
    var isPre = makePredByNodeName('PRE');
    var isLi = makePredByNodeName('LI');
    function isPurePara(node) {
        return isPara(node) && !isLi(node);
    }
    var isTable = makePredByNodeName('TABLE');
    var isData = makePredByNodeName('DATA');
    function isInline(node) {
        return !isBodyContainer(node) &&
            !isList(node) &&
            !isHr(node) &&
            !isPara(node) &&
            !isTable(node) &&
            !isBlockquote(node) &&
            !isData(node);
    }
    function isList(node) {
        return node && /^UL|^OL/.test(node.nodeName.toUpperCase());
    }
    var isHr = makePredByNodeName('HR');
    function isCell(node) {
        return node && /^TD|^TH/.test(node.nodeName.toUpperCase());
    }
    var isBlockquote = makePredByNodeName('BLOCKQUOTE');
    function isBodyContainer(node) {
        return isCell(node) || isBlockquote(node) || isEditable(node);
    }
    var isAnchor = makePredByNodeName('A');
    function isParaInline(node) {
        return isInline(node) && !!ancestor(node, isPara);
    }
    function isBodyInline(node) {
        return isInline(node) && !ancestor(node, isPara);
    }
    var isBody = makePredByNodeName('BODY');
    /**
     * returns whether nodeB is closest sibling of nodeA
     *
     * @param {Node} nodeA
     * @param {Node} nodeB
     * @return {Boolean}
     */
    function isClosestSibling(nodeA, nodeB) {
        return nodeA.nextSibling === nodeB ||
            nodeA.previousSibling === nodeB;
    }
    /**
     * returns array of closest siblings with node
     *
     * @param {Node} node
     * @param {function} [pred] - predicate function
     * @return {Node[]}
     */
    function withClosestSiblings(node, pred) {
        pred = pred || func.ok;
        var siblings = [];
        if (node.previousSibling && pred(node.previousSibling)) {
            siblings.push(node.previousSibling);
        }
        siblings.push(node);
        if (node.nextSibling && pred(node.nextSibling)) {
            siblings.push(node.nextSibling);
        }
        return siblings;
    }
    /**
     * blank HTML for cursor position
     * - [workaround] old IE only works with &nbsp;
     * - [workaround] IE11 and other browser works with bogus br
     */
    var blankHTML = env.isMSIE && env.browserVersion < 11 ? '&nbsp;' : '<br>';
    /**
     * @method nodeLength
     *
     * returns #text's text size or element's childNodes size
     *
     * @param {Node} node
     */
    function nodeLength(node) {
        if (isText(node)) {
            return node.nodeValue.length;
        }
        if (node) {
            return node.childNodes.length;
        }
        return 0;
    }
    /**
     * returns whether node is empty or not.
     *
     * @param {Node} node
     * @return {Boolean}
     */
    function isEmpty$1(node) {
        var len = nodeLength(node);
        if (len === 0) {
            return true;
        }
        else if (!isText(node) && len === 1 && node.innerHTML === blankHTML) {
            // ex) <p><br></p>, <span><br></span>
            return true;
        }
        else if (lists.all(node.childNodes, isText) && node.innerHTML === '') {
            // ex) <p></p>, <span></span>
            return true;
        }
        return false;
    }
    /**
     * padding blankHTML if node is empty (for cursor position)
     */
    function paddingBlankHTML(node) {
        if (!isVoid(node) && !nodeLength(node)) {
            node.innerHTML = blankHTML;
        }
    }
    /**
     * find nearest ancestor predicate hit
     *
     * @param {Node} node
     * @param {Function} pred - predicate function
     */
    function ancestor(node, pred) {
        while (node) {
            if (pred(node)) {
                return node;
            }
            if (isEditable(node)) {
                break;
            }
            node = node.parentNode;
        }
        return null;
    }
    /**
     * find nearest ancestor only single child blood line and predicate hit
     *
     * @param {Node} node
     * @param {Function} pred - predicate function
     */
    function singleChildAncestor(node, pred) {
        node = node.parentNode;
        while (node) {
            if (nodeLength(node) !== 1) {
                break;
            }
            if (pred(node)) {
                return node;
            }
            if (isEditable(node)) {
                break;
            }
            node = node.parentNode;
        }
        return null;
    }
    /**
     * returns new array of ancestor nodes (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [optional] pred - predicate function
     */
    function listAncestor(node, pred) {
        pred = pred || func.fail;
        var ancestors = [];
        ancestor(node, function (el) {
            if (!isEditable(el)) {
                ancestors.push(el);
            }
            return pred(el);
        });
        return ancestors;
    }
    /**
     * find farthest ancestor predicate hit
     */
    function lastAncestor(node, pred) {
        var ancestors = listAncestor(node);
        return lists.last(ancestors.filter(pred));
    }
    /**
     * returns common ancestor node between two nodes.
     *
     * @param {Node} nodeA
     * @param {Node} nodeB
     */
    function commonAncestor(nodeA, nodeB) {
        var ancestors = listAncestor(nodeA);
        for (var n = nodeB; n; n = n.parentNode) {
            if (ancestors.indexOf(n) > -1)
                return n;
        }
        return null; // difference document area
    }
    /**
     * listing all previous siblings (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [optional] pred - predicate function
     */
    function listPrev(node, pred) {
        pred = pred || func.fail;
        var nodes = [];
        while (node) {
            if (pred(node)) {
                break;
            }
            nodes.push(node);
            node = node.previousSibling;
        }
        return nodes;
    }
    /**
     * listing next siblings (until predicate hit).
     *
     * @param {Node} node
     * @param {Function} [pred] - predicate function
     */
    function listNext(node, pred) {
        pred = pred || func.fail;
        var nodes = [];
        while (node) {
            if (pred(node)) {
                break;
            }
            nodes.push(node);
            node = node.nextSibling;
        }
        return nodes;
    }
    /**
     * listing descendant nodes
     *
     * @param {Node} node
     * @param {Function} [pred] - predicate function
     */
    function listDescendant(node, pred) {
        var descendants = [];
        pred = pred || func.ok;
        // start DFS(depth first search) with node
        (function fnWalk(current) {
            if (node !== current && pred(current)) {
                descendants.push(current);
            }
            for (var idx = 0, len = current.childNodes.length; idx < len; idx++) {
                fnWalk(current.childNodes[idx]);
            }
        })(node);
        return descendants;
    }
    /**
     * wrap node with new tag.
     *
     * @param {Node} node
     * @param {Node} tagName of wrapper
     * @return {Node} - wrapper
     */
    function wrap(node, wrapperName) {
        var parent = node.parentNode;
        var wrapper = $$1('<' + wrapperName + '>')[0];
        parent.insertBefore(wrapper, node);
        wrapper.appendChild(node);
        return wrapper;
    }
    /**
     * insert node after preceding
     *
     * @param {Node} node
     * @param {Node} preceding - predicate function
     */
    function insertAfter(node, preceding) {
        var next = preceding.nextSibling;
        var parent = preceding.parentNode;
        if (next) {
            parent.insertBefore(node, next);
        }
        else {
            parent.appendChild(node);
        }
        return node;
    }
    /**
     * append elements.
     *
     * @param {Node} node
     * @param {Collection} aChild
     */
    function appendChildNodes(node, aChild) {
        $$1.each(aChild, function (idx, child) {
            node.appendChild(child);
        });
        return node;
    }
    /**
     * returns whether boundaryPoint is left edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    function isLeftEdgePoint(point) {
        return point.offset === 0;
    }
    /**
     * returns whether boundaryPoint is right edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    function isRightEdgePoint(point) {
        return point.offset === nodeLength(point.node);
    }
    /**
     * returns whether boundaryPoint is edge or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    function isEdgePoint(point) {
        return isLeftEdgePoint(point) || isRightEdgePoint(point);
    }
    /**
     * returns whether node is left edge of ancestor or not.
     *
     * @param {Node} node
     * @param {Node} ancestor
     * @return {Boolean}
     */
    function isLeftEdgeOf(node, ancestor) {
        while (node && node !== ancestor) {
            if (position(node) !== 0) {
                return false;
            }
            node = node.parentNode;
        }
        return true;
    }
    /**
     * returns whether node is right edge of ancestor or not.
     *
     * @param {Node} node
     * @param {Node} ancestor
     * @return {Boolean}
     */
    function isRightEdgeOf(node, ancestor) {
        if (!ancestor) {
            return false;
        }
        while (node && node !== ancestor) {
            if (position(node) !== nodeLength(node.parentNode) - 1) {
                return false;
            }
            node = node.parentNode;
        }
        return true;
    }
    /**
     * returns whether point is left edge of ancestor or not.
     * @param {BoundaryPoint} point
     * @param {Node} ancestor
     * @return {Boolean}
     */
    function isLeftEdgePointOf(point, ancestor) {
        return isLeftEdgePoint(point) && isLeftEdgeOf(point.node, ancestor);
    }
    /**
     * returns whether point is right edge of ancestor or not.
     * @param {BoundaryPoint} point
     * @param {Node} ancestor
     * @return {Boolean}
     */
    function isRightEdgePointOf(point, ancestor) {
        return isRightEdgePoint(point) && isRightEdgeOf(point.node, ancestor);
    }
    /**
     * returns offset from parent.
     *
     * @param {Node} node
     */
    function position(node) {
        var offset = 0;
        while ((node = node.previousSibling)) {
            offset += 1;
        }
        return offset;
    }
    function hasChildren(node) {
        return !!(node && node.childNodes && node.childNodes.length);
    }
    /**
     * returns previous boundaryPoint
     *
     * @param {BoundaryPoint} point
     * @param {Boolean} isSkipInnerOffset
     * @return {BoundaryPoint}
     */
    function prevPoint(point, isSkipInnerOffset) {
        var node;
        var offset;
        if (point.offset === 0) {
            if (isEditable(point.node)) {
                return null;
            }
            node = point.node.parentNode;
            offset = position(point.node);
        }
        else if (hasChildren(point.node)) {
            node = point.node.childNodes[point.offset - 1];
            offset = nodeLength(node);
        }
        else {
            node = point.node;
            offset = isSkipInnerOffset ? 0 : point.offset - 1;
        }
        return {
            node: node,
            offset: offset
        };
    }
    /**
     * returns next boundaryPoint
     *
     * @param {BoundaryPoint} point
     * @param {Boolean} isSkipInnerOffset
     * @return {BoundaryPoint}
     */
    function nextPoint(point, isSkipInnerOffset) {
        var node, offset;
        if (nodeLength(point.node) === point.offset) {
            if (isEditable(point.node)) {
                return null;
            }
            node = point.node.parentNode;
            offset = position(point.node) + 1;
        }
        else if (hasChildren(point.node)) {
            node = point.node.childNodes[point.offset];
            offset = 0;
        }
        else {
            node = point.node;
            offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
        }
        return {
            node: node,
            offset: offset
        };
    }
    /**
     * returns whether pointA and pointB is same or not.
     *
     * @param {BoundaryPoint} pointA
     * @param {BoundaryPoint} pointB
     * @return {Boolean}
     */
    function isSamePoint(pointA, pointB) {
        return pointA.node === pointB.node && pointA.offset === pointB.offset;
    }
    /**
     * returns whether point is visible (can set cursor) or not.
     *
     * @param {BoundaryPoint} point
     * @return {Boolean}
     */
    function isVisiblePoint(point) {
        if (isText(point.node) || !hasChildren(point.node) || isEmpty$1(point.node)) {
            return true;
        }
        var leftNode = point.node.childNodes[point.offset - 1];
        var rightNode = point.node.childNodes[point.offset];
        if ((!leftNode || isVoid(leftNode)) && (!rightNode || isVoid(rightNode))) {
            return true;
        }
        return false;
    }
    /**
     * @method prevPointUtil
     *
     * @param {BoundaryPoint} point
     * @param {Function} pred
     * @return {BoundaryPoint}
     */
    function prevPointUntil(point, pred) {
        while (point) {
            if (pred(point)) {
                return point;
            }
            point = prevPoint(point);
        }
        return null;
    }
    /**
     * @method nextPointUntil
     *
     * @param {BoundaryPoint} point
     * @param {Function} pred
     * @return {BoundaryPoint}
     */
    function nextPointUntil(point, pred) {
        while (point) {
            if (pred(point)) {
                return point;
            }
            point = nextPoint(point);
        }
        return null;
    }
    /**
     * returns whether point has character or not.
     *
     * @param {Point} point
     * @return {Boolean}
     */
    function isCharPoint(point) {
        if (!isText(point.node)) {
            return false;
        }
        var ch = point.node.nodeValue.charAt(point.offset - 1);
        return ch && (ch !== ' ' && ch !== NBSP_CHAR);
    }
    /**
     * @method walkPoint
     *
     * @param {BoundaryPoint} startPoint
     * @param {BoundaryPoint} endPoint
     * @param {Function} handler
     * @param {Boolean} isSkipInnerOffset
     */
    function walkPoint(startPoint, endPoint, handler, isSkipInnerOffset) {
        var point = startPoint;
        while (point) {
            handler(point);
            if (isSamePoint(point, endPoint)) {
                break;
            }
            var isSkipOffset = isSkipInnerOffset &&
                startPoint.node !== point.node &&
                endPoint.node !== point.node;
            point = nextPoint(point, isSkipOffset);
        }
    }
    /**
     * @method makeOffsetPath
     *
     * return offsetPath(array of offset) from ancestor
     *
     * @param {Node} ancestor - ancestor node
     * @param {Node} node
     */
    function makeOffsetPath(ancestor, node) {
        var ancestors = listAncestor(node, func.eq(ancestor));
        return ancestors.map(position).reverse();
    }
    /**
     * @method fromOffsetPath
     *
     * return element from offsetPath(array of offset)
     *
     * @param {Node} ancestor - ancestor node
     * @param {array} offsets - offsetPath
     */
    function fromOffsetPath(ancestor, offsets) {
        var current = ancestor;
        for (var i = 0, len = offsets.length; i < len; i++) {
            if (current.childNodes.length <= offsets[i]) {
                current = current.childNodes[current.childNodes.length - 1];
            }
            else {
                current = current.childNodes[offsets[i]];
            }
        }
        return current;
    }
    /**
     * @method splitNode
     *
     * split element or #text
     *
     * @param {BoundaryPoint} point
     * @param {Object} [options]
     * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
     * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
     * @param {Boolean} [options.isDiscardEmptySplits] - default: false
     * @return {Node} right node of boundaryPoint
     */
    function splitNode(point, options) {
        var isSkipPaddingBlankHTML = options && options.isSkipPaddingBlankHTML;
        var isNotSplitEdgePoint = options && options.isNotSplitEdgePoint;
        var isDiscardEmptySplits = options && options.isDiscardEmptySplits;
        if (isDiscardEmptySplits) {
            isSkipPaddingBlankHTML = true;
        }
        // edge case
        if (isEdgePoint(point) && (isText(point.node) || isNotSplitEdgePoint)) {
            if (isLeftEdgePoint(point)) {
                return point.node;
            }
            else if (isRightEdgePoint(point)) {
                return point.node.nextSibling;
            }
        }
        // split #text
        if (isText(point.node)) {
            return point.node.splitText(point.offset);
        }
        else {
            var childNode = point.node.childNodes[point.offset];
            var clone = insertAfter(point.node.cloneNode(false), point.node);
            appendChildNodes(clone, listNext(childNode));
            if (!isSkipPaddingBlankHTML) {
                paddingBlankHTML(point.node);
                paddingBlankHTML(clone);
            }
            if (isDiscardEmptySplits) {
                if (isEmpty$1(point.node)) {
                    remove(point.node);
                }
                if (isEmpty$1(clone)) {
                    remove(clone);
                    return point.node.nextSibling;
                }
            }
            return clone;
        }
    }
    /**
     * @method splitTree
     *
     * split tree by point
     *
     * @param {Node} root - split root
     * @param {BoundaryPoint} point
     * @param {Object} [options]
     * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
     * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
     * @return {Node} right node of boundaryPoint
     */
    function splitTree(root, point, options) {
        // ex) [#text, <span>, <p>]
        var ancestors = listAncestor(point.node, func.eq(root));
        if (!ancestors.length) {
            return null;
        }
        else if (ancestors.length === 1) {
            return splitNode(point, options);
        }
        return ancestors.reduce(function (node, parent) {
            if (node === point.node) {
                node = splitNode(point, options);
            }
            return splitNode({
                node: parent,
                offset: node ? position(node) : nodeLength(parent)
            }, options);
        });
    }
    /**
     * split point
     *
     * @param {Point} point
     * @param {Boolean} isInline
     * @return {Object}
     */
    function splitPoint(point, isInline) {
        // find splitRoot, container
        //  - inline: splitRoot is a child of paragraph
        //  - block: splitRoot is a child of bodyContainer
        var pred = isInline ? isPara : isBodyContainer;
        var ancestors = listAncestor(point.node, pred);
        var topAncestor = lists.last(ancestors) || point.node;
        var splitRoot, container;
        if (pred(topAncestor)) {
            splitRoot = ancestors[ancestors.length - 2];
            container = topAncestor;
        }
        else {
            splitRoot = topAncestor;
            container = splitRoot.parentNode;
        }
        // if splitRoot is exists, split with splitTree
        var pivot = splitRoot && splitTree(splitRoot, point, {
            isSkipPaddingBlankHTML: isInline,
            isNotSplitEdgePoint: isInline
        });
        // if container is point.node, find pivot with point.offset
        if (!pivot && container === point.node) {
            pivot = point.node.childNodes[point.offset];
        }
        return {
            rightNode: pivot,
            container: container
        };
    }
    function create(nodeName) {
        return document.createElement(nodeName);
    }
    function createText(text) {
        return document.createTextNode(text);
    }
    /**
     * @method remove
     *
     * remove node, (isRemoveChild: remove child or not)
     *
     * @param {Node} node
     * @param {Boolean} isRemoveChild
     */
    function remove(node, isRemoveChild) {
        if (!node || !node.parentNode) {
            return;
        }
        if (node.removeNode) {
            return node.removeNode(isRemoveChild);
        }
        var parent = node.parentNode;
        if (!isRemoveChild) {
            var nodes = [];
            for (var i = 0, len = node.childNodes.length; i < len; i++) {
                nodes.push(node.childNodes[i]);
            }
            for (var i = 0, len = nodes.length; i < len; i++) {
                parent.insertBefore(nodes[i], node);
            }
        }
        parent.removeChild(node);
    }
    /**
     * @method removeWhile
     *
     * @param {Node} node
     * @param {Function} pred
     */
    function removeWhile(node, pred) {
        while (node) {
            if (isEditable(node) || !pred(node)) {
                break;
            }
            var parent = node.parentNode;
            remove(node);
            node = parent;
        }
    }
    /**
     * @method replace
     *
     * replace node with provided nodeName
     *
     * @param {Node} node
     * @param {String} nodeName
     * @return {Node} - new node
     */
    function replace(node, nodeName) {
        if (node.nodeName.toUpperCase() === nodeName.toUpperCase()) {
            return node;
        }
        var newNode = create(nodeName);
        if (node.style.cssText) {
            newNode.style.cssText = node.style.cssText;
        }
        appendChildNodes(newNode, lists.from(node.childNodes));
        insertAfter(newNode, node);
        remove(node);
        return newNode;
    }
    var isTextarea = makePredByNodeName('TEXTAREA');
    /**
     * @param {jQuery} $node
     * @param {Boolean} [stripLinebreaks] - default: false
     */
    function value($node, stripLinebreaks) {
        var val = isTextarea($node[0]) ? $node.val() : $node.html();
        if (stripLinebreaks) {
            return val.replace(/[\n\r]/g, '');
        }
        return val;
    }
    /**
     * @method html
     *
     * get the HTML contents of node
     *
     * @param {jQuery} $node
     * @param {Boolean} [isNewlineOnBlock]
     */
    function html($node, isNewlineOnBlock) {
        var markup = value($node);
        if (isNewlineOnBlock) {
            var regexTag = /<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g;
            markup = markup.replace(regexTag, function (match, endSlash, name) {
                name = name.toUpperCase();
                var isEndOfInlineContainer = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(name) &&
                    !!endSlash;
                var isBlockNode = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(name);
                return match + ((isEndOfInlineContainer || isBlockNode) ? '\n' : '');
            });
            markup = markup.trim();
        }
        return markup;
    }
    function posFromPlaceholder(placeholder) {
        var $placeholder = $$1(placeholder);
        var pos = $placeholder.offset();
        var height = $placeholder.outerHeight(true); // include margin
        return {
            left: pos.left,
            top: pos.top + height
        };
    }
    function attachEvents($node, events) {
        Object.keys(events).forEach(function (key) {
            $node.on(key, events[key]);
        });
    }
    function detachEvents($node, events) {
        Object.keys(events).forEach(function (key) {
            $node.off(key, events[key]);
        });
    }
    /**
     * @method isCustomStyleTag
     *
     * assert if a node contains a "note-styletag" class,
     * which implies that's a custom-made style tag node
     *
     * @param {Node} an HTML DOM node
     */
    function isCustomStyleTag(node) {
        return node && !isText(node) && lists.contains(node.classList, 'note-styletag');
    }
    var dom = {
        /** @property {String} NBSP_CHAR */
        NBSP_CHAR: NBSP_CHAR,
        /** @property {String} ZERO_WIDTH_NBSP_CHAR */
        ZERO_WIDTH_NBSP_CHAR: ZERO_WIDTH_NBSP_CHAR,
        /** @property {String} blank */
        blank: blankHTML,
        /** @property {String} emptyPara */
        emptyPara: "<p>" + blankHTML + "</p>",
        makePredByNodeName: makePredByNodeName,
        isEditable: isEditable,
        isControlSizing: isControlSizing,
        isText: isText,
        isElement: isElement,
        isVoid: isVoid,
        isPara: isPara,
        isPurePara: isPurePara,
        isHeading: isHeading,
        isInline: isInline,
        isBlock: func.not(isInline),
        isBodyInline: isBodyInline,
        isBody: isBody,
        isParaInline: isParaInline,
        isPre: isPre,
        isList: isList,
        isTable: isTable,
        isData: isData,
        isCell: isCell,
        isBlockquote: isBlockquote,
        isBodyContainer: isBodyContainer,
        isAnchor: isAnchor,
        isDiv: makePredByNodeName('DIV'),
        isLi: isLi,
        isBR: makePredByNodeName('BR'),
        isSpan: makePredByNodeName('SPAN'),
        isB: makePredByNodeName('B'),
        isU: makePredByNodeName('U'),
        isS: makePredByNodeName('S'),
        isI: makePredByNodeName('I'),
        isImg: makePredByNodeName('IMG'),
        isTextarea: isTextarea,
        isEmpty: isEmpty$1,
        isEmptyAnchor: func.and(isAnchor, isEmpty$1),
        isClosestSibling: isClosestSibling,
        withClosestSiblings: withClosestSiblings,
        nodeLength: nodeLength,
        isLeftEdgePoint: isLeftEdgePoint,
        isRightEdgePoint: isRightEdgePoint,
        isEdgePoint: isEdgePoint,
        isLeftEdgeOf: isLeftEdgeOf,
        isRightEdgeOf: isRightEdgeOf,
        isLeftEdgePointOf: isLeftEdgePointOf,
        isRightEdgePointOf: isRightEdgePointOf,
        prevPoint: prevPoint,
        nextPoint: nextPoint,
        isSamePoint: isSamePoint,
        isVisiblePoint: isVisiblePoint,
        prevPointUntil: prevPointUntil,
        nextPointUntil: nextPointUntil,
        isCharPoint: isCharPoint,
        walkPoint: walkPoint,
        ancestor: ancestor,
        singleChildAncestor: singleChildAncestor,
        listAncestor: listAncestor,
        lastAncestor: lastAncestor,
        listNext: listNext,
        listPrev: listPrev,
        listDescendant: listDescendant,
        commonAncestor: commonAncestor,
        wrap: wrap,
        insertAfter: insertAfter,
        appendChildNodes: appendChildNodes,
        position: position,
        hasChildren: hasChildren,
        makeOffsetPath: makeOffsetPath,
        fromOffsetPath: fromOffsetPath,
        splitTree: splitTree,
        splitPoint: splitPoint,
        create: create,
        createText: createText,
        remove: remove,
        removeWhile: removeWhile,
        replace: replace,
        html: html,
        value: value,
        posFromPlaceholder: posFromPlaceholder,
        attachEvents: attachEvents,
        detachEvents: detachEvents,
        isCustomStyleTag: isCustomStyleTag
    };
  
    var Context = /** @class */ (function () {
        /**
         * @param {jQuery} $note
         * @param {Object} options
         */
        function Context($note, options) {
            this.ui = $$1.summernote.ui;
            this.$note = $note;
            this.memos = {};
            this.modules = {};
            this.layoutInfo = {};
            this.options = options;
            this.initialize();
        }
        /**
         * create layout and initialize modules and other resources
         */
        Context.prototype.initialize = function () {
            this.layoutInfo = this.ui.createLayout(this.$note, this.options);
            this._initialize();
            this.$note.hide();
            return this;
        };
        /**
         * destroy modules and other resources and remove layout
         */
        Context.prototype.destroy = function () {
            this._destroy();
            this.$note.removeData('summernote');
            this.ui.removeLayout(this.$note, this.layoutInfo);
        };
        /**
         * destory modules and other resources and initialize it again
         */
        Context.prototype.reset = function () {
            var disabled = this.isDisabled();
            this.code(dom.emptyPara);
            this._destroy();
            this._initialize();
            if (disabled) {
                this.disable();
            }
        };
        Context.prototype._initialize = function () {
            var _this = this;
            // add optional buttons
            var buttons = $$1.extend({}, this.options.buttons);
            Object.keys(buttons).forEach(function (key) {
                _this.memo('button.' + key, buttons[key]);
            });
            var modules = $$1.extend({}, this.options.modules, $$1.summernote.plugins || {});
            // add and initialize modules
            Object.keys(modules).forEach(function (key) {
                _this.module(key, modules[key], true);
            });
            Object.keys(this.modules).forEach(function (key) {
                _this.initializeModule(key);
            });
        };
        Context.prototype._destroy = function () {
            var _this = this;
            // destroy modules with reversed order
            Object.keys(this.modules).reverse().forEach(function (key) {
                _this.removeModule(key);
            });
            Object.keys(this.memos).forEach(function (key) {
                _this.removeMemo(key);
            });
            // trigger custom onDestroy callback
            this.triggerEvent('destroy', this);
        };
        Context.prototype.code = function (html) {
            var isActivated = this.invoke('codeview.isActivated');
            if (html === undefined) {
                this.invoke('codeview.sync');
                return isActivated ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
            }
            else {
                if (isActivated) {
                    this.layoutInfo.codable.val(html);
                }
                else {
                    this.layoutInfo.editable.html(html);
                }
                this.$note.val(html);
                this.triggerEvent('change', html, this.layoutInfo.editable);
            }
        };
        Context.prototype.isDisabled = function () {
            return this.layoutInfo.editable.attr('contenteditable') === 'false';
        };
        Context.prototype.enable = function () {
            this.layoutInfo.editable.attr('contenteditable', true);
            this.invoke('toolbar.activate', true);
            this.triggerEvent('disable', false);
        };
        Context.prototype.disable = function () {
            // close codeview if codeview is opend
            if (this.invoke('codeview.isActivated')) {
                this.invoke('codeview.deactivate');
            }
            this.layoutInfo.editable.attr('contenteditable', false);
            this.invoke('toolbar.deactivate', true);
            this.triggerEvent('disable', true);
        };
        Context.prototype.triggerEvent = function () {
            var namespace = lists.head(arguments);
            var args = lists.tail(lists.from(arguments));
            var callback = this.options.callbacks[func.namespaceToCamel(namespace, 'on')];
            if (callback) {
                callback.apply(this.$note[0], args);
            }
            this.$note.trigger('summernote.' + namespace, args);
        };
        Context.prototype.initializeModule = function (key) {
            var module = this.modules[key];
            module.shouldInitialize = module.shouldInitialize || func.ok;
            if (!module.shouldInitialize()) {
                return;
            }
            // initialize module
            if (module.initialize) {
                module.initialize();
            }
            // attach events
            if (module.events) {
                dom.attachEvents(this.$note, module.events);
            }
        };
        Context.prototype.module = function (key, ModuleClass, withoutIntialize) {
            if (arguments.length === 1) {
                return this.modules[key];
            }
            this.modules[key] = new ModuleClass(this);
            if (!withoutIntialize) {
                this.initializeModule(key);
            }
        };
        Context.prototype.removeModule = function (key) {
            var module = this.modules[key];
            if (module.shouldInitialize()) {
                if (module.events) {
                    dom.detachEvents(this.$note, module.events);
                }
                if (module.destroy) {
                    module.destroy();
                }
            }
            delete this.modules[key];
        };
        Context.prototype.memo = function (key, obj) {
            if (arguments.length === 1) {
                return this.memos[key];
            }
            this.memos[key] = obj;
        };
        Context.prototype.removeMemo = function (key) {
            if (this.memos[key] && this.memos[key].destroy) {
                this.memos[key].destroy();
            }
            delete this.memos[key];
        };
        /**
         * Some buttons need to change their visual style immediately once they get pressed
         */
        Context.prototype.createInvokeHandlerAndUpdateState = function (namespace, value) {
            var _this = this;
            return function (event) {
                _this.createInvokeHandler(namespace, value)(event);
                _this.invoke('buttons.updateCurrentStyle');
            };
        };
        Context.prototype.createInvokeHandler = function (namespace, value) {
            var _this = this;
            return function (event) {
                event.preventDefault();
                var $target = $$1(event.target);
                _this.invoke(namespace, value || $target.closest('[data-value]').data('value'), $target);
            };
        };
        Context.prototype.invoke = function () {
            var namespace = lists.head(arguments);
            var args = lists.tail(lists.from(arguments));
            var splits = namespace.split('.');
            var hasSeparator = splits.length > 1;
            var moduleName = hasSeparator && lists.head(splits);
            var methodName = hasSeparator ? lists.last(splits) : lists.head(splits);
            var module = this.modules[moduleName || 'editor'];
            if (!moduleName && this[methodName]) {
                return this[methodName].apply(this, args);
            }
            else if (module && module[methodName] && module.shouldInitialize()) {
                return module[methodName].apply(module, args);
            }
        };
        return Context;
    }());
  
    $$1.fn.extend({
        /**
         * Summernote API
         *
         * @param {Object|String}
         * @return {this}
         */
        summernote: function () {
            var type = $$1.type(lists.head(arguments));
            var isExternalAPICalled = type === 'string';
            var hasInitOptions = type === 'object';
            var options = $$1.extend({}, $$1.summernote.options, hasInitOptions ? lists.head(arguments) : {});
            // Update options
            options.langInfo = $$1.extend(true, {}, $$1.summernote.lang['en-US'], $$1.summernote.lang[options.lang]);
            options.icons = $$1.extend(true, {}, $$1.summernote.options.icons, options.icons);
            options.tooltip = options.tooltip === 'auto' ? !env.isSupportTouch : options.tooltip;
            this.each(function (idx, note) {
                var $note = $$1(note);
                if (!$note.data('summernote')) {
                    var context = new Context($note, options);
                    $note.data('summernote', context);
                    $note.data('summernote').triggerEvent('init', context.layoutInfo);
                }
            });
            var $note = this.first();
            if ($note.length) {
                var context = $note.data('summernote');
                if (isExternalAPICalled) {
                    return context.invoke.apply(context, lists.from(arguments));
                }
                else if (options.focus) {
                    context.invoke('editor.focus');
                }
            }
            return this;
        }
    });
  
    /**
     * return boundaryPoint from TextRange, inspired by Andy Na's HuskyRange.js
     *
     * @param {TextRange} textRange
     * @param {Boolean} isStart
     * @return {BoundaryPoint}
     *
     * @see http://msdn.microsoft.com/en-us/library/ie/ms535872(v=vs.85).aspx
     */
    function textRangeToPoint(textRange, isStart) {
        var container = textRange.parentElement();
        var offset;
        var tester = document.body.createTextRange();
        var prevContainer;
        var childNodes = lists.from(container.childNodes);
        for (offset = 0; offset < childNodes.length; offset++) {
            if (dom.isText(childNodes[offset])) {
                continue;
            }
            tester.moveToElementText(childNodes[offset]);
            if (tester.compareEndPoints('StartToStart', textRange) >= 0) {
                break;
            }
            prevContainer = childNodes[offset];
        }
        if (offset !== 0 && dom.isText(childNodes[offset - 1])) {
            var textRangeStart = document.body.createTextRange();
            var curTextNode = null;
            textRangeStart.moveToElementText(prevContainer || container);
            textRangeStart.collapse(!prevContainer);
            curTextNode = prevContainer ? prevContainer.nextSibling : container.firstChild;
            var pointTester = textRange.duplicate();
            pointTester.setEndPoint('StartToStart', textRangeStart);
            var textCount = pointTester.text.replace(/[\r\n]/g, '').length;
            while (textCount > curTextNode.nodeValue.length && curTextNode.nextSibling) {
                textCount -= curTextNode.nodeValue.length;
                curTextNode = curTextNode.nextSibling;
            }
            // [workaround] enforce IE to re-reference curTextNode, hack
            var dummy = curTextNode.nodeValue; // eslint-disable-line
            if (isStart && curTextNode.nextSibling && dom.isText(curTextNode.nextSibling) &&
                textCount === curTextNode.nodeValue.length) {
                textCount -= curTextNode.nodeValue.length;
                curTextNode = curTextNode.nextSibling;
            }
            container = curTextNode;
            offset = textCount;
        }
        return {
            cont: container,
            offset: offset
        };
    }
    /**
     * return TextRange from boundary point (inspired by google closure-library)
     * @param {BoundaryPoint} point
     * @return {TextRange}
     */
    function pointToTextRange(point) {
        var textRangeInfo = function (container, offset) {
            var node, isCollapseToStart;
            if (dom.isText(container)) {
                var prevTextNodes = dom.listPrev(container, func.not(dom.isText));
                var prevContainer = lists.last(prevTextNodes).previousSibling;
                node = prevContainer || container.parentNode;
                offset += lists.sum(lists.tail(prevTextNodes), dom.nodeLength);
                isCollapseToStart = !prevContainer;
            }
            else {
                node = container.childNodes[offset] || container;
                if (dom.isText(node)) {
                    return textRangeInfo(node, 0);
                }
                offset = 0;
                isCollapseToStart = false;
            }
            return {
                node: node,
                collapseToStart: isCollapseToStart,
                offset: offset
            };
        };
        var textRange = document.body.createTextRange();
        var info = textRangeInfo(point.node, point.offset);
        textRange.moveToElementText(info.node);
        textRange.collapse(info.collapseToStart);
        textRange.moveStart('character', info.offset);
        return textRange;
    }
    /**
       * Wrapped Range
       *
       * @constructor
       * @param {Node} sc - start container
       * @param {Number} so - start offset
       * @param {Node} ec - end container
       * @param {Number} eo - end offset
       */
    var WrappedRange = /** @class */ (function () {
        function WrappedRange(sc, so, ec, eo) {
            this.sc = sc;
            this.so = so;
            this.ec = ec;
            this.eo = eo;
            // isOnEditable: judge whether range is on editable or not
            this.isOnEditable = this.makeIsOn(dom.isEditable);
            // isOnList: judge whether range is on list node or not
            this.isOnList = this.makeIsOn(dom.isList);
            // isOnAnchor: judge whether range is on anchor node or not
            this.isOnAnchor = this.makeIsOn(dom.isAnchor);
            // isOnCell: judge whether range is on cell node or not
            this.isOnCell = this.makeIsOn(dom.isCell);
            // isOnData: judge whether range is on data node or not
            this.isOnData = this.makeIsOn(dom.isData);
        }
        // nativeRange: get nativeRange from sc, so, ec, eo
        WrappedRange.prototype.nativeRange = function () {
            if (env.isW3CRangeSupport) {
                var w3cRange = document.createRange();
                w3cRange.setStart(this.sc, this.sc.data && this.so > this.sc.data.length ? 0 : this.so);
                w3cRange.setEnd(this.ec, this.sc.data ? Math.min(this.eo, this.sc.data.length) : this.eo);
                return w3cRange;
            }
            else {
                var textRange = pointToTextRange({
                    node: this.sc,
                    offset: this.so
                });
                textRange.setEndPoint('EndToEnd', pointToTextRange({
                    node: this.ec,
                    offset: this.eo
                }));
                return textRange;
            }
        };
        WrappedRange.prototype.getPoints = function () {
            return {
                sc: this.sc,
                so: this.so,
                ec: this.ec,
                eo: this.eo
            };
        };
        WrappedRange.prototype.getStartPoint = function () {
            return {
                node: this.sc,
                offset: this.so
            };
        };
        WrappedRange.prototype.getEndPoint = function () {
            return {
                node: this.ec,
                offset: this.eo
            };
        };
        /**
         * select update visible range
         */
        WrappedRange.prototype.select = function () {
            var nativeRng = this.nativeRange();
            if (env.isW3CRangeSupport) {
                var selection = document.getSelection();
                if (selection.rangeCount > 0) {
                    selection.removeAllRanges();
                }
                selection.addRange(nativeRng);
            }
            else {
                nativeRng.select();
            }
            return this;
        };
        /**
         * Moves the scrollbar to start container(sc) of current range
         *
         * @return {WrappedRange}
         */
        WrappedRange.prototype.scrollIntoView = function (container) {
            var height = $$1(container).height();
            if (container.scrollTop + height < this.sc.offsetTop) {
                container.scrollTop += Math.abs(container.scrollTop + height - this.sc.offsetTop);
            }
            return this;
        };
        /**
         * @return {WrappedRange}
         */
        WrappedRange.prototype.normalize = function () {
            /**
             * @param {BoundaryPoint} point
             * @param {Boolean} isLeftToRight - true: prefer to choose right node
             *                                - false: prefer to choose left node
             * @return {BoundaryPoint}
             */
            var getVisiblePoint = function (point, isLeftToRight) {
                // Just use the given point [XXX:Adhoc]
                //  - case 01. if the point is on the middle of the node
                //  - case 02. if the point is on the right edge and prefer to choose left node
                //  - case 03. if the point is on the left edge and prefer to choose right node
                //  - case 04. if the point is on the right edge and prefer to choose right node but the node is void
                //  - case 05. if the point is on the left edge and prefer to choose left node but the node is void
                //  - case 06. if the point is on the block node and there is no children
                if (dom.isVisiblePoint(point)) {
                    if (!dom.isEdgePoint(point) ||
                        (dom.isRightEdgePoint(point) && !isLeftToRight) ||
                        (dom.isLeftEdgePoint(point) && isLeftToRight) ||
                        (dom.isRightEdgePoint(point) && isLeftToRight && dom.isVoid(point.node.nextSibling)) ||
                        (dom.isLeftEdgePoint(point) && !isLeftToRight && dom.isVoid(point.node.previousSibling)) ||
                        (dom.isBlock(point.node) && dom.isEmpty(point.node))) {
                        return point;
                    }
                }
                // point on block's edge
                var block = dom.ancestor(point.node, dom.isBlock);
                if (((dom.isLeftEdgePointOf(point, block) || dom.isVoid(dom.prevPoint(point).node)) && !isLeftToRight) ||
                    ((dom.isRightEdgePointOf(point, block) || dom.isVoid(dom.nextPoint(point).node)) && isLeftToRight)) {
                    // returns point already on visible point
                    if (dom.isVisiblePoint(point)) {
                        return point;
                    }
                    // reverse direction
                    isLeftToRight = !isLeftToRight;
                }
                var nextPoint = isLeftToRight ? dom.nextPointUntil(dom.nextPoint(point), dom.isVisiblePoint)
                    : dom.prevPointUntil(dom.prevPoint(point), dom.isVisiblePoint);
                return nextPoint || point;
            };
            var endPoint = getVisiblePoint(this.getEndPoint(), false);
            var startPoint = this.isCollapsed() ? endPoint : getVisiblePoint(this.getStartPoint(), true);
            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
        };
        /**
         * returns matched nodes on range
         *
         * @param {Function} [pred] - predicate function
         * @param {Object} [options]
         * @param {Boolean} [options.includeAncestor]
         * @param {Boolean} [options.fullyContains]
         * @return {Node[]}
         */
        WrappedRange.prototype.nodes = function (pred, options) {
            pred = pred || func.ok;
            var includeAncestor = options && options.includeAncestor;
            var fullyContains = options && options.fullyContains;
            // TODO compare points and sort
            var startPoint = this.getStartPoint();
            var endPoint = this.getEndPoint();
            var nodes = [];
            var leftEdgeNodes = [];
            dom.walkPoint(startPoint, endPoint, function (point) {
                if (dom.isEditable(point.node)) {
                    return;
                }
                var node;
                if (fullyContains) {
                    if (dom.isLeftEdgePoint(point)) {
                        leftEdgeNodes.push(point.node);
                    }
                    if (dom.isRightEdgePoint(point) && lists.contains(leftEdgeNodes, point.node)) {
                        node = point.node;
                    }
                }
                else if (includeAncestor) {
                    node = dom.ancestor(point.node, pred);
                }
                else {
                    node = point.node;
                }
                if (node && pred(node)) {
                    nodes.push(node);
                }
            }, true);
            return lists.unique(nodes);
        };
        /**
         * returns commonAncestor of range
         * @return {Element} - commonAncestor
         */
        WrappedRange.prototype.commonAncestor = function () {
            return dom.commonAncestor(this.sc, this.ec);
        };
        /**
         * returns expanded range by pred
         *
         * @param {Function} pred - predicate function
         * @return {WrappedRange}
         */
        WrappedRange.prototype.expand = function (pred) {
            var startAncestor = dom.ancestor(this.sc, pred);
            var endAncestor = dom.ancestor(this.ec, pred);
            if (!startAncestor && !endAncestor) {
                return new WrappedRange(this.sc, this.so, this.ec, this.eo);
            }
            var boundaryPoints = this.getPoints();
            if (startAncestor) {
                boundaryPoints.sc = startAncestor;
                boundaryPoints.so = 0;
            }
            if (endAncestor) {
                boundaryPoints.ec = endAncestor;
                boundaryPoints.eo = dom.nodeLength(endAncestor);
            }
            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
        };
        /**
         * @param {Boolean} isCollapseToStart
         * @return {WrappedRange}
         */
        WrappedRange.prototype.collapse = function (isCollapseToStart) {
            if (isCollapseToStart) {
                return new WrappedRange(this.sc, this.so, this.sc, this.so);
            }
            else {
                return new WrappedRange(this.ec, this.eo, this.ec, this.eo);
            }
        };
        /**
         * splitText on range
         */
        WrappedRange.prototype.splitText = function () {
            var isSameContainer = this.sc === this.ec;
            var boundaryPoints = this.getPoints();
            if (dom.isText(this.ec) && !dom.isEdgePoint(this.getEndPoint())) {
                this.ec.splitText(this.eo);
            }
            if (dom.isText(this.sc) && !dom.isEdgePoint(this.getStartPoint())) {
                boundaryPoints.sc = this.sc.splitText(this.so);
                boundaryPoints.so = 0;
                if (isSameContainer) {
                    boundaryPoints.ec = boundaryPoints.sc;
                    boundaryPoints.eo = this.eo - this.so;
                }
            }
            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
        };
        /**
         * delete contents on range
         * @return {WrappedRange}
         */
        WrappedRange.prototype.deleteContents = function () {
            if (this.isCollapsed()) {
                return this;
            }
            var rng = this.splitText();
            var nodes = rng.nodes(null, {
                fullyContains: true
            });
            // find new cursor point
            var point = dom.prevPointUntil(rng.getStartPoint(), function (point) {
                return !lists.contains(nodes, point.node);
            });
            var emptyParents = [];
            $$1.each(nodes, function (idx, node) {
                // find empty parents
                var parent = node.parentNode;
                if (point.node !== parent && dom.nodeLength(parent) === 1) {
                    emptyParents.push(parent);
                }
                dom.remove(node, false);
            });
            // remove empty parents
            $$1.each(emptyParents, function (idx, node) {
                dom.remove(node, false);
            });
            return new WrappedRange(point.node, point.offset, point.node, point.offset).normalize();
        };
        /**
         * makeIsOn: return isOn(pred) function
         */
        WrappedRange.prototype.makeIsOn = function (pred) {
            return function () {
                var ancestor = dom.ancestor(this.sc, pred);
                return !!ancestor && (ancestor === dom.ancestor(this.ec, pred));
            };
        };
        /**
         * @param {Function} pred
         * @return {Boolean}
         */
        WrappedRange.prototype.isLeftEdgeOf = function (pred) {
            if (!dom.isLeftEdgePoint(this.getStartPoint())) {
                return false;
            }
            var node = dom.ancestor(this.sc, pred);
            return node && dom.isLeftEdgeOf(this.sc, node);
        };
        /**
         * returns whether range was collapsed or not
         */
        WrappedRange.prototype.isCollapsed = function () {
            return this.sc === this.ec && this.so === this.eo;
        };
        /**
         * wrap inline nodes which children of body with paragraph
         *
         * @return {WrappedRange}
         */
        WrappedRange.prototype.wrapBodyInlineWithPara = function () {
            if (dom.isBodyContainer(this.sc) && dom.isEmpty(this.sc)) {
                this.sc.innerHTML = dom.emptyPara;
                return new WrappedRange(this.sc.firstChild, 0, this.sc.firstChild, 0);
            }
            /**
             * [workaround] firefox often create range on not visible point. so normalize here.
             *  - firefox: |<p>text</p>|
             *  - chrome: <p>|text|</p>
             */
            var rng = this.normalize();
            if (dom.isParaInline(this.sc) || dom.isPara(this.sc)) {
                return rng;
            }
            // find inline top ancestor
            var topAncestor;
            if (dom.isInline(rng.sc)) {
                var ancestors = dom.listAncestor(rng.sc, func.not(dom.isInline));
                topAncestor = lists.last(ancestors);
                if (!dom.isInline(topAncestor)) {
                    topAncestor = ancestors[ancestors.length - 2] || rng.sc.childNodes[rng.so];
                }
            }
            else {
                topAncestor = rng.sc.childNodes[rng.so > 0 ? rng.so - 1 : 0];
            }
            // siblings not in paragraph
            var inlineSiblings = dom.listPrev(topAncestor, dom.isParaInline).reverse();
            inlineSiblings = inlineSiblings.concat(dom.listNext(topAncestor.nextSibling, dom.isParaInline));
            // wrap with paragraph
            if (inlineSiblings.length) {
                var para = dom.wrap(lists.head(inlineSiblings), 'p');
                dom.appendChildNodes(para, lists.tail(inlineSiblings));
            }
            return this.normalize();
        };
        /**
         * insert node at current cursor
         *
         * @param {Node} node
         * @return {Node}
         */
        WrappedRange.prototype.insertNode = function (node) {
            var rng = this.wrapBodyInlineWithPara().deleteContents();
            var info = dom.splitPoint(rng.getStartPoint(), dom.isInline(node));
            if (info.rightNode) {
                info.rightNode.parentNode.insertBefore(node, info.rightNode);
            }
            else {
                info.container.appendChild(node);
            }
            return node;
        };
        /**
         * insert html at current cursor
         */
        WrappedRange.prototype.pasteHTML = function (markup) {
            var contentsContainer = $$1('<div></div>').html(markup)[0];
            var childNodes = lists.from(contentsContainer.childNodes);
            var rng = this.wrapBodyInlineWithPara().deleteContents();
            if (rng.so > 0) {
                childNodes = childNodes.reverse();
            }
            childNodes = childNodes.map(function (childNode) {
                return rng.insertNode(childNode);
            });
            if (rng.so > 0) {
                childNodes = childNodes.reverse();
            }
            return childNodes;
        };
        /**
         * returns text in range
         *
         * @return {String}
         */
        WrappedRange.prototype.toString = function () {
            var nativeRng = this.nativeRange();
            return env.isW3CRangeSupport ? nativeRng.toString() : nativeRng.text;
        };
        /**
         * returns range for word before cursor
         *
         * @param {Boolean} [findAfter] - find after cursor, default: false
         * @return {WrappedRange}
         */
        WrappedRange.prototype.getWordRange = function (findAfter) {
            var endPoint = this.getEndPoint();
            if (!dom.isCharPoint(endPoint)) {
                return this;
            }
            var startPoint = dom.prevPointUntil(endPoint, function (point) {
                return !dom.isCharPoint(point);
            });
            if (findAfter) {
                endPoint = dom.nextPointUntil(endPoint, function (point) {
                    return !dom.isCharPoint(point);
                });
            }
            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
        };
        /**
         * create offsetPath bookmark
         *
         * @param {Node} editable
         */
        WrappedRange.prototype.bookmark = function (editable) {
            return {
                s: {
                    path: dom.makeOffsetPath(editable, this.sc),
                    offset: this.so
                },
                e: {
                    path: dom.makeOffsetPath(editable, this.ec),
                    offset: this.eo
                }
            };
        };
        /**
         * create offsetPath bookmark base on paragraph
         *
         * @param {Node[]} paras
         */
        WrappedRange.prototype.paraBookmark = function (paras) {
            return {
                s: {
                    path: lists.tail(dom.makeOffsetPath(lists.head(paras), this.sc)),
                    offset: this.so
                },
                e: {
                    path: lists.tail(dom.makeOffsetPath(lists.last(paras), this.ec)),
                    offset: this.eo
                }
            };
        };
        /**
         * getClientRects
         * @return {Rect[]}
         */
        WrappedRange.prototype.getClientRects = function () {
            var nativeRng = this.nativeRange();
            return nativeRng.getClientRects();
        };
        return WrappedRange;
    }());
    /**
     * Data structure
     *  * BoundaryPoint: a point of dom tree
     *  * BoundaryPoints: two boundaryPoints corresponding to the start and the end of the Range
     *
     * See to http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Position
     */
    var range = {
        /**
         * create Range Object From arguments or Browser Selection
         *
         * @param {Node} sc - start container
         * @param {Number} so - start offset
         * @param {Node} ec - end container
         * @param {Number} eo - end offset
         * @return {WrappedRange}
         */
        create: function (sc, so, ec, eo) {
            if (arguments.length === 4) {
                return new WrappedRange(sc, so, ec, eo);
            }
            else if (arguments.length === 2) { // collapsed
                ec = sc;
                eo = so;
                return new WrappedRange(sc, so, ec, eo);
            }
            else {
                var wrappedRange = this.createFromSelection();
                if (!wrappedRange && arguments.length === 1) {
                    wrappedRange = this.createFromNode(arguments[0]);
                    return wrappedRange.collapse(dom.emptyPara === arguments[0].innerHTML);
                }
                return wrappedRange;
            }
        },
        createFromSelection: function () {
            var sc, so, ec, eo;
            if (env.isW3CRangeSupport) {
                var selection = document.getSelection();
                if (!selection || selection.rangeCount === 0) {
                    return null;
                }
                else if (dom.isBody(selection.anchorNode)) {
                    // Firefox: returns entire body as range on initialization.
                    // We won't never need it.
                    return null;
                }
                var nativeRng = selection.getRangeAt(0);
                sc = nativeRng.startContainer;
                so = nativeRng.startOffset;
                ec = nativeRng.endContainer;
                eo = nativeRng.endOffset;
            }
            else { // IE8: TextRange
                var textRange = document.selection.createRange();
                var textRangeEnd = textRange.duplicate();
                textRangeEnd.collapse(false);
                var textRangeStart = textRange;
                textRangeStart.collapse(true);
                var startPoint = textRangeToPoint(textRangeStart, true);
                var endPoint = textRangeToPoint(textRangeEnd, false);
                // same visible point case: range was collapsed.
                if (dom.isText(startPoint.node) && dom.isLeftEdgePoint(startPoint) &&
                    dom.isTextNode(endPoint.node) && dom.isRightEdgePoint(endPoint) &&
                    endPoint.node.nextSibling === startPoint.node) {
                    startPoint = endPoint;
                }
                sc = startPoint.cont;
                so = startPoint.offset;
                ec = endPoint.cont;
                eo = endPoint.offset;
            }
            return new WrappedRange(sc, so, ec, eo);
        },
        /**
         * @method
         *
         * create WrappedRange from node
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNode: function (node) {
            var sc = node;
            var so = 0;
            var ec = node;
            var eo = dom.nodeLength(ec);
            // browsers can't target a picture or void node
            if (dom.isVoid(sc)) {
                so = dom.listPrev(sc).length - 1;
                sc = sc.parentNode;
            }
            if (dom.isBR(ec)) {
                eo = dom.listPrev(ec).length - 1;
                ec = ec.parentNode;
            }
            else if (dom.isVoid(ec)) {
                eo = dom.listPrev(ec).length;
                ec = ec.parentNode;
            }
            return this.create(sc, so, ec, eo);
        },
        /**
         * create WrappedRange from node after position
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNodeBefore: function (node) {
            return this.createFromNode(node).collapse(true);
        },
        /**
         * create WrappedRange from node after position
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNodeAfter: function (node) {
            return this.createFromNode(node).collapse();
        },
        /**
         * @method
         *
         * create WrappedRange from bookmark
         *
         * @param {Node} editable
         * @param {Object} bookmark
         * @return {WrappedRange}
         */
        createFromBookmark: function (editable, bookmark) {
            var sc = dom.fromOffsetPath(editable, bookmark.s.path);
            var so = bookmark.s.offset;
            var ec = dom.fromOffsetPath(editable, bookmark.e.path);
            var eo = bookmark.e.offset;
            return new WrappedRange(sc, so, ec, eo);
        },
        /**
         * @method
         *
         * create WrappedRange from paraBookmark
         *
         * @param {Object} bookmark
         * @param {Node[]} paras
         * @return {WrappedRange}
         */
        createFromParaBookmark: function (bookmark, paras) {
            var so = bookmark.s.offset;
            var eo = bookmark.e.offset;
            var sc = dom.fromOffsetPath(lists.head(paras), bookmark.s.path);
            var ec = dom.fromOffsetPath(lists.last(paras), bookmark.e.path);
            return new WrappedRange(sc, so, ec, eo);
        }
    };
  
    var KEY_MAP = {
        'BACKSPACE': 8,
        'TAB': 9,
        'ENTER': 13,
        'SPACE': 32,
        'DELETE': 46,
        // Arrow
        'LEFT': 37,
        'UP': 38,
        'RIGHT': 39,
        'DOWN': 40,
        // Number: 0-9
        'NUM0': 48,
        'NUM1': 49,
        'NUM2': 50,
        'NUM3': 51,
        'NUM4': 52,
        'NUM5': 53,
        'NUM6': 54,
        'NUM7': 55,
        'NUM8': 56,
        // Alphabet: a-z
        'B': 66,
        'E': 69,
        'I': 73,
        'J': 74,
        'K': 75,
        'L': 76,
        'R': 82,
        'S': 83,
        'U': 85,
        'V': 86,
        'Y': 89,
        'Z': 90,
        'SLASH': 191,
        'LEFTBRACKET': 219,
        'BACKSLASH': 220,
        'RIGHTBRACKET': 221
    };
    /**
     * @class core.key
     *
     * Object for keycodes.
     *
     * @singleton
     * @alternateClassName key
     */
    var key = {
        /**
         * @method isEdit
         *
         * @param {Number} keyCode
         * @return {Boolean}
         */
        isEdit: function (keyCode) {
            return lists.contains([
                KEY_MAP.BACKSPACE,
                KEY_MAP.TAB,
                KEY_MAP.ENTER,
                KEY_MAP.SPACE,
                KEY_MAP.DELETE,
            ], keyCode);
        },
        /**
         * @method isMove
         *
         * @param {Number} keyCode
         * @return {Boolean}
         */
        isMove: function (keyCode) {
            return lists.contains([
                KEY_MAP.LEFT,
                KEY_MAP.UP,
                KEY_MAP.RIGHT,
                KEY_MAP.DOWN,
            ], keyCode);
        },
        /**
         * @property {Object} nameFromCode
         * @property {String} nameFromCode.8 "BACKSPACE"
         */
        nameFromCode: func.invertObject(KEY_MAP),
        code: KEY_MAP
    };
  
    /**
     * @method readFileAsDataURL
     *
     * read contents of file as representing URL
     *
     * @param {File} file
     * @return {Promise} - then: dataUrl
     */
    function readFileAsDataURL(file) {
        return $$1.Deferred(function (deferred) {
            $$1.extend(new FileReader(), {
                onload: function (e) {
                    var dataURL = e.target.result;
                    deferred.resolve(dataURL);
                },
                onerror: function (err) {
                    deferred.reject(err);
                }
            }).readAsDataURL(file);
        }).promise();
    }
    /**
     * @method createImage
     *
     * create `<image>` from url string
     *
     * @param {String} url
     * @return {Promise} - then: $image
     */
    function createImage(url) {
        return $$1.Deferred(function (deferred) {
            var $img = $$1('<img>');
            $img.one('load', function () {
                $img.off('error abort');
                deferred.resolve($img);
            }).one('error abort', function () {
                $img.off('load').detach();
                deferred.reject($img);
            }).css({
                display: 'none'
            }).appendTo(document.body).attr('src', url);
        }).promise();
    }
  
    var History = /** @class */ (function () {
        function History($editable) {
            this.stack = [];
            this.stackOffset = -1;
            this.$editable = $editable;
            this.editable = $editable[0];
        }
        History.prototype.makeSnapshot = function () {
            var rng = range.create(this.editable);
            var emptyBookmark = { s: { path: [], offset: 0 }, e: { path: [], offset: 0 } };
            return {
                contents: this.$editable.html(),
                bookmark: ((rng && rng.isOnEditable()) ? rng.bookmark(this.editable) : emptyBookmark)
            };
        };
        History.prototype.applySnapshot = function (snapshot) {
            if (snapshot.contents !== null) {
                this.$editable.html(snapshot.contents);
            }
            if (snapshot.bookmark !== null) {
                range.createFromBookmark(this.editable, snapshot.bookmark).select();
            }
        };
        /**
        * @method rewind
        * Rewinds the history stack back to the first snapshot taken.
        * Leaves the stack intact, so that "Redo" can still be used.
        */
        History.prototype.rewind = function () {
            // Create snap shot if not yet recorded
            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
                this.recordUndo();
            }
            // Return to the first available snapshot.
            this.stackOffset = 0;
            // Apply that snapshot.
            this.applySnapshot(this.stack[this.stackOffset]);
        };
        /**
        *  @method commit
        *  Resets history stack, but keeps current editor's content.
        */
        History.prototype.commit = function () {
            // Clear the stack.
            this.stack = [];
            // Restore stackOffset to its original value.
            this.stackOffset = -1;
            // Record our first snapshot (of nothing).
            this.recordUndo();
        };
        /**
        * @method reset
        * Resets the history stack completely; reverting to an empty editor.
        */
        History.prototype.reset = function () {
            // Clear the stack.
            this.stack = [];
            // Restore stackOffset to its original value.
            this.stackOffset = -1;
            // Clear the editable area.
            this.$editable.html('');
            // Record our first snapshot (of nothing).
            this.recordUndo();
        };
        /**
         * undo
         */
        History.prototype.undo = function () {
            // Create snap shot if not yet recorded
            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
                this.recordUndo();
            }
            if (this.stackOffset > 0) {
                this.stackOffset--;
                this.applySnapshot(this.stack[this.stackOffset]);
            }
        };
        /**
         * redo
         */
        History.prototype.redo = function () {
            if (this.stack.length - 1 > this.stackOffset) {
                this.stackOffset++;
                this.applySnapshot(this.stack[this.stackOffset]);
            }
        };
        /**
         * recorded undo
         */
        History.prototype.recordUndo = function () {
            this.stackOffset++;
            // Wash out stack after stackOffset
            if (this.stack.length > this.stackOffset) {
                this.stack = this.stack.slice(0, this.stackOffset);
            }
            // Create new snapshot and push it to the end
            this.stack.push(this.makeSnapshot());
        };
        return History;
    }());
  
    var Style = /** @class */ (function () {
        function Style() {
        }
        /**
         * @method jQueryCSS
         *
         * [workaround] for old jQuery
         * passing an array of style properties to .css()
         * will result in an object of property-value pairs.
         * (compability with version < 1.9)
         *
         * @private
         * @param  {jQuery} $obj
         * @param  {Array} propertyNames - An array of one or more CSS properties.
         * @return {Object}
         */
        Style.prototype.jQueryCSS = function ($obj, propertyNames) {
            if (env.jqueryVersion < 1.9) {
                var result_1 = {};
                $$1.each(propertyNames, function (idx, propertyName) {
                    result_1[propertyName] = $obj.css(propertyName);
                });
                return result_1;
            }
            return $obj.css(propertyNames);
        };
        /**
         * returns style object from node
         *
         * @param {jQuery} $node
         * @return {Object}
         */
        Style.prototype.fromNode = function ($node) {
            var properties = ['font-family', 'font-size', 'text-align', 'list-style-type', 'line-height'];
            var styleInfo = this.jQueryCSS($node, properties) || {};
            styleInfo['font-size'] = parseInt(styleInfo['font-size'], 10);
            return styleInfo;
        };
        /**
         * paragraph level style
         *
         * @param {WrappedRange} rng
         * @param {Object} styleInfo
         */
        Style.prototype.stylePara = function (rng, styleInfo) {
            $$1.each(rng.nodes(dom.isPara, {
                includeAncestor: true
            }), function (idx, para) {
                $$1(para).css(styleInfo);
            });
        };
        /**
         * insert and returns styleNodes on range.
         *
         * @param {WrappedRange} rng
         * @param {Object} [options] - options for styleNodes
         * @param {String} [options.nodeName] - default: `SPAN`
         * @param {Boolean} [options.expandClosestSibling] - default: `false`
         * @param {Boolean} [options.onlyPartialContains] - default: `false`
         * @return {Node[]}
         */
        Style.prototype.styleNodes = function (rng, options) {
            rng = rng.splitText();
            var nodeName = (options && options.nodeName) || 'SPAN';
            var expandClosestSibling = !!(options && options.expandClosestSibling);
            var onlyPartialContains = !!(options && options.onlyPartialContains);
            if (rng.isCollapsed()) {
                return [rng.insertNode(dom.create(nodeName))];
            }
            var pred = dom.makePredByNodeName(nodeName);
            var nodes = rng.nodes(dom.isText, {
                fullyContains: true
            }).map(function (text) {
                return dom.singleChildAncestor(text, pred) || dom.wrap(text, nodeName);
            });
            if (expandClosestSibling) {
                if (onlyPartialContains) {
                    var nodesInRange_1 = rng.nodes();
                    // compose with partial contains predication
                    pred = func.and(pred, function (node) {
                        return lists.contains(nodesInRange_1, node);
                    });
                }
                return nodes.map(function (node) {
                    var siblings = dom.withClosestSiblings(node, pred);
                    var head = lists.head(siblings);
                    var tails = lists.tail(siblings);
                    $$1.each(tails, function (idx, elem) {
                        dom.appendChildNodes(head, elem.childNodes);
                        dom.remove(elem);
                    });
                    return lists.head(siblings);
                });
            }
            else {
                return nodes;
            }
        };
        /**
         * get current style on cursor
         *
         * @param {WrappedRange} rng
         * @return {Object} - object contains style properties.
         */
        Style.prototype.current = function (rng) {
            var $cont = $$1(!dom.isElement(rng.sc) ? rng.sc.parentNode : rng.sc);
            var styleInfo = this.fromNode($cont);
            // document.queryCommandState for toggle state
            // [workaround] prevent Firefox nsresult: "0x80004005 (NS_ERROR_FAILURE)"
            try {
                styleInfo = $$1.extend(styleInfo, {
                    'font-bold': document.queryCommandState('bold') ? 'bold' : 'normal',
                    'font-italic': document.queryCommandState('italic') ? 'italic' : 'normal',
                    'font-underline': document.queryCommandState('underline') ? 'underline' : 'normal',
                    'font-subscript': document.queryCommandState('subscript') ? 'subscript' : 'normal',
                    'font-superscript': document.queryCommandState('superscript') ? 'superscript' : 'normal',
                    'font-strikethrough': document.queryCommandState('strikethrough') ? 'strikethrough' : 'normal',
                    'font-family': document.queryCommandValue('fontname') || styleInfo['font-family']
                });
            }
            catch (e) { }
            // list-style-type to list-style(unordered, ordered)
            if (!rng.isOnList()) {
                styleInfo['list-style'] = 'none';
            }
            else {
                var orderedTypes = ['circle', 'disc', 'disc-leading-zero', 'square'];
                var isUnordered = orderedTypes.indexOf(styleInfo['list-style-type']) > -1;
                styleInfo['list-style'] = isUnordered ? 'unordered' : 'ordered';
            }
            var para = dom.ancestor(rng.sc, dom.isPara);
            if (para && para.style['line-height']) {
                styleInfo['line-height'] = para.style.lineHeight;
            }
            else {
                var lineHeight = parseInt(styleInfo['line-height'], 10) / parseInt(styleInfo['font-size'], 10);
                styleInfo['line-height'] = lineHeight.toFixed(1);
            }
            styleInfo.anchor = rng.isOnAnchor() && dom.ancestor(rng.sc, dom.isAnchor);
            styleInfo.ancestors = dom.listAncestor(rng.sc, dom.isEditable);
            styleInfo.range = rng;
            return styleInfo;
        };
        return Style;
    }());
  
    var Bullet = /** @class */ (function () {
        function Bullet() {
        }
        /**
         * toggle ordered list
         */
        Bullet.prototype.insertOrderedList = function (editable) {
            this.toggleList('OL', editable);
        };
        /**
         * toggle unordered list
         */
        Bullet.prototype.insertUnorderedList = function (editable) {
            this.toggleList('UL', editable);
        };
        /**
         * indent
         */
        Bullet.prototype.indent = function (editable) {
            var _this = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
            $$1.each(clustereds, function (idx, paras) {
                var head = lists.head(paras);
                if (dom.isLi(head)) {
                    var previousList_1 = _this.findList(head.previousSibling);
                    if (previousList_1) {
                        paras
                            .map(function (para) { return previousList_1.appendChild(para); });
                    }
                    else {
                        _this.wrapList(paras, head.parentNode.nodeName);
                        paras
                            .map(function (para) { return para.parentNode; })
                            .map(function (para) { return _this.appendToPrevious(para); });
                    }
                }
                else {
                    $$1.each(paras, function (idx, para) {
                        $$1(para).css('marginLeft', function (idx, val) {
                            return (parseInt(val, 10) || 0) + 25;
                        });
                    });
                }
            });
            rng.select();
        };
        /**
         * outdent
         */
        Bullet.prototype.outdent = function (editable) {
            var _this = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
            $$1.each(clustereds, function (idx, paras) {
                var head = lists.head(paras);
                if (dom.isLi(head)) {
                    _this.releaseList([paras]);
                }
                else {
                    $$1.each(paras, function (idx, para) {
                        $$1(para).css('marginLeft', function (idx, val) {
                            val = (parseInt(val, 10) || 0);
                            return val > 25 ? val - 25 : '';
                        });
                    });
                }
            });
            rng.select();
        };
        /**
         * toggle list
         *
         * @param {String} listName - OL or UL
         */
        Bullet.prototype.toggleList = function (listName, editable) {
            var _this = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
            var bookmark = rng.paraBookmark(paras);
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
            // paragraph to list
            if (lists.find(paras, dom.isPurePara)) {
                var wrappedParas_1 = [];
                $$1.each(clustereds, function (idx, paras) {
                    wrappedParas_1 = wrappedParas_1.concat(_this.wrapList(paras, listName));
                });
                paras = wrappedParas_1;
                // list to paragraph or change list style
            }
            else {
                var diffLists = rng.nodes(dom.isList, {
                    includeAncestor: true
                }).filter(function (listNode) {
                    return !$$1.nodeName(listNode, listName);
                });
                if (diffLists.length) {
                    $$1.each(diffLists, function (idx, listNode) {
                        dom.replace(listNode, listName);
                    });
                }
                else {
                    paras = this.releaseList(clustereds, true);
                }
            }
            range.createFromParaBookmark(bookmark, paras).select();
        };
        /**
         * @param {Node[]} paras
         * @param {String} listName
         * @return {Node[]}
         */
        Bullet.prototype.wrapList = function (paras, listName) {
            var head = lists.head(paras);
            var last = lists.last(paras);
            var prevList = dom.isList(head.previousSibling) && head.previousSibling;
            var nextList = dom.isList(last.nextSibling) && last.nextSibling;
            var listNode = prevList || dom.insertAfter(dom.create(listName || 'UL'), last);
            // P to LI
            paras = paras.map(function (para) {
                return dom.isPurePara(para) ? dom.replace(para, 'LI') : para;
            });
            // append to list(<ul>, <ol>)
            dom.appendChildNodes(listNode, paras);
            if (nextList) {
                dom.appendChildNodes(listNode, lists.from(nextList.childNodes));
                dom.remove(nextList);
            }
            return paras;
        };
        /**
         * @method releaseList
         *
         * @param {Array[]} clustereds
         * @param {Boolean} isEscapseToBody
         * @return {Node[]}
         */
        Bullet.prototype.releaseList = function (clustereds, isEscapseToBody) {
            var _this = this;
            var releasedParas = [];
            $$1.each(clustereds, function (idx, paras) {
                var head = lists.head(paras);
                var last = lists.last(paras);
                var headList = isEscapseToBody ? dom.lastAncestor(head, dom.isList) : head.parentNode;
                var parentItem = headList.parentNode;
                if (headList.parentNode.nodeName === 'LI') {
                    paras.map(function (para) {
                        var newList = _this.findNextSiblings(para);
                        if (parentItem.nextSibling) {
                            parentItem.parentNode.insertBefore(para, parentItem.nextSibling);
                        }
                        else {
                            parentItem.parentNode.appendChild(para);
                        }
                        if (newList.length) {
                            _this.wrapList(newList, headList.nodeName);
                            para.appendChild(newList[0].parentNode);
                        }
                    });
                    if (headList.children.length === 0) {
                        parentItem.removeChild(headList);
                    }
                    if (parentItem.childNodes.length === 0) {
                        parentItem.parentNode.removeChild(parentItem);
                    }
                }
                else {
                    var lastList = headList.childNodes.length > 1 ? dom.splitTree(headList, {
                        node: last.parentNode,
                        offset: dom.position(last) + 1
                    }, {
                        isSkipPaddingBlankHTML: true
                    }) : null;
                    var middleList = dom.splitTree(headList, {
                        node: head.parentNode,
                        offset: dom.position(head)
                    }, {
                        isSkipPaddingBlankHTML: true
                    });
                    paras = isEscapseToBody ? dom.listDescendant(middleList, dom.isLi)
                        : lists.from(middleList.childNodes).filter(dom.isLi);
                    // LI to P
                    if (isEscapseToBody || !dom.isList(headList.parentNode)) {
                        paras = paras.map(function (para) {
                            return dom.replace(para, 'P');
                        });
                    }
                    $$1.each(lists.from(paras).reverse(), function (idx, para) {
                        dom.insertAfter(para, headList);
                    });
                    // remove empty lists
                    var rootLists = lists.compact([headList, middleList, lastList]);
                    $$1.each(rootLists, function (idx, rootList) {
                        var listNodes = [rootList].concat(dom.listDescendant(rootList, dom.isList));
                        $$1.each(listNodes.reverse(), function (idx, listNode) {
                            if (!dom.nodeLength(listNode)) {
                                dom.remove(listNode, true);
                            }
                        });
                    });
                }
                releasedParas = releasedParas.concat(paras);
            });
            return releasedParas;
        };
        /**
         * @method appendToPrevious
         *
         * Appends list to previous list item, if
         * none exist it wraps the list in a new list item.
         *
         * @param {HTMLNode} ListItem
         * @return {HTMLNode}
         */
        Bullet.prototype.appendToPrevious = function (node) {
            return node.previousSibling
                ? dom.appendChildNodes(node.previousSibling, [node])
                : this.wrapList([node], 'LI');
        };
        /**
         * @method findList
         *
         * Finds an existing list in list item
         *
         * @param {HTMLNode} ListItem
         * @return {Array[]}
         */
        Bullet.prototype.findList = function (node) {
            return node
                ? lists.find(node.children, function (child) { return ['OL', 'UL'].indexOf(child.nodeName) > -1; })
                : null;
        };
        /**
         * @method findNextSiblings
         *
         * Finds all list item siblings that follow it
         *
         * @param {HTMLNode} ListItem
         * @return {HTMLNode}
         */
        Bullet.prototype.findNextSiblings = function (node) {
            var siblings = [];
            while (node.nextSibling) {
                siblings.push(node.nextSibling);
                node = node.nextSibling;
            }
            return siblings;
        };
        return Bullet;
    }());
  
    /**
     * @class editing.Typing
     *
     * Typing
     *
     */
    var Typing = /** @class */ (function () {
        function Typing(context) {
            // a Bullet instance to toggle lists off
            this.bullet = new Bullet();
            this.options = context.options;
        }
        /**
         * insert tab
         *
         * @param {WrappedRange} rng
         * @param {Number} tabsize
         */
        Typing.prototype.insertTab = function (rng, tabsize) {
            var tab = dom.createText(new Array(tabsize + 1).join(dom.NBSP_CHAR));
            rng = rng.deleteContents();
            rng.insertNode(tab, true);
            rng = range.create(tab, tabsize);
            rng.select();
        };
        /**
         * insert paragraph
         *
         * @param {jQuery} $editable
         * @param {WrappedRange} rng Can be used in unit tests to "mock" the range
         *
         * blockquoteBreakingLevel
         *   0 - No break, the new paragraph remains inside the quote
         *   1 - Break the first blockquote in the ancestors list
         *   2 - Break all blockquotes, so that the new paragraph is not quoted (this is the default)
         */
        Typing.prototype.insertParagraph = function (editable, rng) {
            rng = rng || range.create(editable);
            // deleteContents on range.
            rng = rng.deleteContents();
            // Wrap range if it needs to be wrapped by paragraph
            rng = rng.wrapBodyInlineWithPara();
            // finding paragraph
            var splitRoot = dom.ancestor(rng.sc, dom.isPara);
            var nextPara;
            // on paragraph: split paragraph
            if (splitRoot) {
                // if it is an empty line with li
                if (dom.isEmpty(splitRoot) && dom.isLi(splitRoot)) {
                    // toogle UL/OL and escape
                    this.bullet.toggleList(splitRoot.parentNode.nodeName);
                    return;
                }
                else {
                    var blockquote = null;
                    if (this.options.blockquoteBreakingLevel === 1) {
                        blockquote = dom.ancestor(splitRoot, dom.isBlockquote);
                    }
                    else if (this.options.blockquoteBreakingLevel === 2) {
                        blockquote = dom.lastAncestor(splitRoot, dom.isBlockquote);
                    }
                    if (blockquote) {
                        // We're inside a blockquote and options ask us to break it
                        nextPara = $$1(dom.emptyPara)[0];
                        // If the split is right before a <br>, remove it so that there's no "empty line"
                        // after the split in the new blockquote created
                        if (dom.isRightEdgePoint(rng.getStartPoint()) && dom.isBR(rng.sc.nextSibling)) {
                            $$1(rng.sc.nextSibling).remove();
                        }
                        var split = dom.splitTree(blockquote, rng.getStartPoint(), { isDiscardEmptySplits: true });
                        if (split) {
                            split.parentNode.insertBefore(nextPara, split);
                        }
                        else {
                            dom.insertAfter(nextPara, blockquote); // There's no split if we were at the end of the blockquote
                        }
                    }
                    else {
                        nextPara = dom.splitTree(splitRoot, rng.getStartPoint());
                        // not a blockquote, just insert the paragraph
                        var emptyAnchors = dom.listDescendant(splitRoot, dom.isEmptyAnchor);
                        emptyAnchors = emptyAnchors.concat(dom.listDescendant(nextPara, dom.isEmptyAnchor));
                        $$1.each(emptyAnchors, function (idx, anchor) {
                            dom.remove(anchor);
                        });
                        // replace empty heading, pre or custom-made styleTag with P tag
                        if ((dom.isHeading(nextPara) || dom.isPre(nextPara) || dom.isCustomStyleTag(nextPara)) && dom.isEmpty(nextPara)) {
                            nextPara = dom.replace(nextPara, 'p');
                        }
                    }
                }
                // no paragraph: insert empty paragraph
            }
            else {
                var next = rng.sc.childNodes[rng.so];
                nextPara = $$1(dom.emptyPara)[0];
                if (next) {
                    rng.sc.insertBefore(nextPara, next);
                }
                else {
                    rng.sc.appendChild(nextPara);
                }
            }
            range.create(nextPara, 0).normalize().select().scrollIntoView(editable);
        };
        return Typing;
    }());
  
    /**
     * @class Create a virtual table to create what actions to do in change.
     * @param {object} startPoint Cell selected to apply change.
     * @param {enum} where  Where change will be applied Row or Col. Use enum: TableResultAction.where
     * @param {enum} action Action to be applied. Use enum: TableResultAction.requestAction
     * @param {object} domTable Dom element of table to make changes.
     */
    var TableResultAction = function (startPoint, where, action, domTable) {
        var _startPoint = { 'colPos': 0, 'rowPos': 0 };
        var _virtualTable = [];
        var _actionCellList = [];
        /// ///////////////////////////////////////////
        // Private functions
        /// ///////////////////////////////////////////
        /**
         * Set the startPoint of action.
         */
        function setStartPoint() {
            if (!startPoint || !startPoint.tagName || (startPoint.tagName.toLowerCase() !== 'td' && startPoint.tagName.toLowerCase() !== 'th')) {
                console.error('Impossible to identify start Cell point.', startPoint);
                return;
            }
            _startPoint.colPos = startPoint.cellIndex;
            if (!startPoint.parentElement || !startPoint.parentElement.tagName || startPoint.parentElement.tagName.toLowerCase() !== 'tr') {
                console.error('Impossible to identify start Row point.', startPoint);
                return;
            }
            _startPoint.rowPos = startPoint.parentElement.rowIndex;
        }
        /**
         * Define virtual table position info object.
         *
         * @param {int} rowIndex Index position in line of virtual table.
         * @param {int} cellIndex Index position in column of virtual table.
         * @param {object} baseRow Row affected by this position.
         * @param {object} baseCell Cell affected by this position.
         * @param {bool} isSpan Inform if it is an span cell/row.
         */
        function setVirtualTablePosition(rowIndex, cellIndex, baseRow, baseCell, isRowSpan, isColSpan, isVirtualCell) {
            var objPosition = {
                'baseRow': baseRow,
                'baseCell': baseCell,
                'isRowSpan': isRowSpan,
                'isColSpan': isColSpan,
                'isVirtual': isVirtualCell
            };
            if (!_virtualTable[rowIndex]) {
                _virtualTable[rowIndex] = [];
            }
            _virtualTable[rowIndex][cellIndex] = objPosition;
        }
        /**
         * Create action cell object.
         *
         * @param {object} virtualTableCellObj Object of specific position on virtual table.
         * @param {enum} resultAction Action to be applied in that item.
         */
        function getActionCell(virtualTableCellObj, resultAction, virtualRowPosition, virtualColPosition) {
            return {
                'baseCell': virtualTableCellObj.baseCell,
                'action': resultAction,
                'virtualTable': {
                    'rowIndex': virtualRowPosition,
                    'cellIndex': virtualColPosition
                }
            };
        }
        /**
         * Recover free index of row to append Cell.
         *
         * @param {int} rowIndex Index of row to find free space.
         * @param {int} cellIndex Index of cell to find free space in table.
         */
        function recoverCellIndex(rowIndex, cellIndex) {
            if (!_virtualTable[rowIndex]) {
                return cellIndex;
            }
            if (!_virtualTable[rowIndex][cellIndex]) {
                return cellIndex;
            }
            var newCellIndex = cellIndex;
            while (_virtualTable[rowIndex][newCellIndex]) {
                newCellIndex++;
                if (!_virtualTable[rowIndex][newCellIndex]) {
                    return newCellIndex;
                }
            }
        }
        /**
         * Recover info about row and cell and add information to virtual table.
         *
         * @param {object} row Row to recover information.
         * @param {object} cell Cell to recover information.
         */
        function addCellInfoToVirtual(row, cell) {
            var cellIndex = recoverCellIndex(row.rowIndex, cell.cellIndex);
            var cellHasColspan = (cell.colSpan > 1);
            var cellHasRowspan = (cell.rowSpan > 1);
            var isThisSelectedCell = (row.rowIndex === _startPoint.rowPos && cell.cellIndex === _startPoint.colPos);
            setVirtualTablePosition(row.rowIndex, cellIndex, row, cell, cellHasRowspan, cellHasColspan, false);
            // Add span rows to virtual Table.
            var rowspanNumber = cell.attributes.rowSpan ? parseInt(cell.attributes.rowSpan.value, 10) : 0;
            if (rowspanNumber > 1) {
                for (var rp = 1; rp < rowspanNumber; rp++) {
                    var rowspanIndex = row.rowIndex + rp;
                    adjustStartPoint(rowspanIndex, cellIndex, cell, isThisSelectedCell);
                    setVirtualTablePosition(rowspanIndex, cellIndex, row, cell, true, cellHasColspan, true);
                }
            }
            // Add span cols to virtual table.
            var colspanNumber = cell.attributes.colSpan ? parseInt(cell.attributes.colSpan.value, 10) : 0;
            if (colspanNumber > 1) {
                for (var cp = 1; cp < colspanNumber; cp++) {
                    var cellspanIndex = recoverCellIndex(row.rowIndex, (cellIndex + cp));
                    adjustStartPoint(row.rowIndex, cellspanIndex, cell, isThisSelectedCell);
                    setVirtualTablePosition(row.rowIndex, cellspanIndex, row, cell, cellHasRowspan, true, true);
                }
            }
        }
        /**
         * Process validation and adjust of start point if needed
         *
         * @param {int} rowIndex
         * @param {int} cellIndex
         * @param {object} cell
         * @param {bool} isSelectedCell
         */
        function adjustStartPoint(rowIndex, cellIndex, cell, isSelectedCell) {
            if (rowIndex === _startPoint.rowPos && _startPoint.colPos >= cell.cellIndex && cell.cellIndex <= cellIndex && !isSelectedCell) {
                _startPoint.colPos++;
            }
        }
        /**
         * Create virtual table of cells with all cells, including span cells.
         */
        function createVirtualTable() {
            var rows = domTable.rows;
            for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                var cells = rows[rowIndex].cells;
                for (var cellIndex = 0; cellIndex < cells.length; cellIndex++) {
                    addCellInfoToVirtual(rows[rowIndex], cells[cellIndex]);
                }
            }
        }
        /**
         * Get action to be applied on the cell.
         *
         * @param {object} cell virtual table cell to apply action
         */
        function getDeleteResultActionToCell(cell) {
            switch (where) {
                case TableResultAction.where.Column:
                    if (cell.isColSpan) {
                        return TableResultAction.resultAction.SubtractSpanCount;
                    }
                    break;
                case TableResultAction.where.Row:
                    if (!cell.isVirtual && cell.isRowSpan) {
                        return TableResultAction.resultAction.AddCell;
                    }
                    else if (cell.isRowSpan) {
                        return TableResultAction.resultAction.SubtractSpanCount;
                    }
                    break;
            }
            return TableResultAction.resultAction.RemoveCell;
        }
        /**
         * Get action to be applied on the cell.
         *
         * @param {object} cell virtual table cell to apply action
         */
        function getAddResultActionToCell(cell) {
            switch (where) {
                case TableResultAction.where.Column:
                    if (cell.isColSpan) {
                        return TableResultAction.resultAction.SumSpanCount;
                    }
                    else if (cell.isRowSpan && cell.isVirtual) {
                        return TableResultAction.resultAction.Ignore;
                    }
                    break;
                case TableResultAction.where.Row:
                    if (cell.isRowSpan) {
                        return TableResultAction.resultAction.SumSpanCount;
                    }
                    else if (cell.isColSpan && cell.isVirtual) {
                        return TableResultAction.resultAction.Ignore;
                    }
                    break;
            }
            return TableResultAction.resultAction.AddCell;
        }
        function init() {
            setStartPoint();
            createVirtualTable();
        }
        /// ///////////////////////////////////////////
        // Public functions
        /// ///////////////////////////////////////////
        /**
         * Recover array os what to do in table.
         */
        this.getActionList = function () {
            var fixedRow = (where === TableResultAction.where.Row) ? _startPoint.rowPos : -1;
            var fixedCol = (where === TableResultAction.where.Column) ? _startPoint.colPos : -1;
            var actualPosition = 0;
            var canContinue = true;
            while (canContinue) {
                var rowPosition = (fixedRow >= 0) ? fixedRow : actualPosition;
                var colPosition = (fixedCol >= 0) ? fixedCol : actualPosition;
                var row = _virtualTable[rowPosition];
                if (!row) {
                    canContinue = false;
                    return _actionCellList;
                }
                var cell = row[colPosition];
                if (!cell) {
                    canContinue = false;
                    return _actionCellList;
                }
                // Define action to be applied in this cell
                var resultAction = TableResultAction.resultAction.Ignore;
                switch (action) {
                    case TableResultAction.requestAction.Add:
                        resultAction = getAddResultActionToCell(cell);
                        break;
                    case TableResultAction.requestAction.Delete:
                        resultAction = getDeleteResultActionToCell(cell);
                        break;
                }
                _actionCellList.push(getActionCell(cell, resultAction, rowPosition, colPosition));
                actualPosition++;
            }
            return _actionCellList;
        };
        init();
    };
    /**
    *
    * Where action occours enum.
    */
    TableResultAction.where = { 'Row': 0, 'Column': 1 };
    /**
    *
    * Requested action to apply enum.
    */
    TableResultAction.requestAction = { 'Add': 0, 'Delete': 1 };
    /**
    *
    * Result action to be executed enum.
    */
    TableResultAction.resultAction = { 'Ignore': 0, 'SubtractSpanCount': 1, 'RemoveCell': 2, 'AddCell': 3, 'SumSpanCount': 4 };
    /**
     *
     * @class editing.Table
     *
     * Table
     *
     */
    var Table = /** @class */ (function () {
        function Table() {
        }
        /**
         * handle tab key
         *
         * @param {WrappedRange} rng
         * @param {Boolean} isShift
         */
        Table.prototype.tab = function (rng, isShift) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var table = dom.ancestor(cell, dom.isTable);
            var cells = dom.listDescendant(table, dom.isCell);
            var nextCell = lists[isShift ? 'prev' : 'next'](cells, cell);
            if (nextCell) {
                range.create(nextCell, 0).select();
            }
        };
        /**
         * Add a new row
         *
         * @param {WrappedRange} rng
         * @param {String} position (top/bottom)
         * @return {Node}
         */
        Table.prototype.addRow = function (rng, position) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var currentTr = $$1(cell).closest('tr');
            var trAttributes = this.recoverAttributes(currentTr);
            var html = $$1('<tr' + trAttributes + '></tr>');
            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Add, $$1(currentTr).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var idCell = 0; idCell < actions.length; idCell++) {
                var currentCell = actions[idCell];
                var tdAttributes = this.recoverAttributes(currentCell.baseCell);
                switch (currentCell.action) {
                    case TableResultAction.resultAction.AddCell:
                        html.append('<td' + tdAttributes + '>' + dom.blank + '</td>');
                        break;
                    case TableResultAction.resultAction.SumSpanCount:
                        if (position === 'top') {
                            var baseCellTr = currentCell.baseCell.parent;
                            var isTopFromRowSpan = (!baseCellTr ? 0 : currentCell.baseCell.closest('tr').rowIndex) <= currentTr[0].rowIndex;
                            if (isTopFromRowSpan) {
                                var newTd = $$1('<div></div>').append($$1('<td' + tdAttributes + '>' + dom.blank + '</td>').removeAttr('rowspan')).html();
                                html.append(newTd);
                                break;
                            }
                        }
                        var rowspanNumber = parseInt(currentCell.baseCell.rowSpan, 10);
                        rowspanNumber++;
                        currentCell.baseCell.setAttribute('rowSpan', rowspanNumber);
                        break;
                }
            }
            if (position === 'top') {
                currentTr.before(html);
            }
            else {
                var cellHasRowspan = (cell.rowSpan > 1);
                if (cellHasRowspan) {
                    var lastTrIndex = currentTr[0].rowIndex + (cell.rowSpan - 2);
                    $$1($$1(currentTr).parent().find('tr')[lastTrIndex]).after($$1(html));
                    return;
                }
                currentTr.after(html);
            }
        };
        /**
         * Add a new col
         *
         * @param {WrappedRange} rng
         * @param {String} position (left/right)
         * @return {Node}
         */
        Table.prototype.addCol = function (rng, position) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = $$1(cell).closest('tr');
            var rowsGroup = $$1(row).siblings();
            rowsGroup.push(row);
            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Add, $$1(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
                var currentCell = actions[actionIndex];
                var tdAttributes = this.recoverAttributes(currentCell.baseCell);
                switch (currentCell.action) {
                    case TableResultAction.resultAction.AddCell:
                        if (position === 'right') {
                            $$1(currentCell.baseCell).after('<td' + tdAttributes + '>' + dom.blank + '</td>');
                        }
                        else {
                            $$1(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
                        }
                        break;
                    case TableResultAction.resultAction.SumSpanCount:
                        if (position === 'right') {
                            var colspanNumber = parseInt(currentCell.baseCell.colSpan, 10);
                            colspanNumber++;
                            currentCell.baseCell.setAttribute('colSpan', colspanNumber);
                        }
                        else {
                            $$1(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
                        }
                        break;
                }
            }
        };
        /*
        * Copy attributes from element.
        *
        * @param {object} Element to recover attributes.
        * @return {string} Copied string elements.
        */
        Table.prototype.recoverAttributes = function (el) {
            var resultStr = '';
            if (!el) {
                return resultStr;
            }
            var attrList = el.attributes || [];
            for (var i = 0; i < attrList.length; i++) {
                if (attrList[i].name.toLowerCase() === 'id') {
                    continue;
                }
                if (attrList[i].specified) {
                    resultStr += ' ' + attrList[i].name + '=\'' + attrList[i].value + '\'';
                }
            }
            return resultStr;
        };
        /**
         * Delete current row
         *
         * @param {WrappedRange} rng
         * @return {Node}
         */
        Table.prototype.deleteRow = function (rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = $$1(cell).closest('tr');
            var cellPos = row.children('td, th').index($$1(cell));
            var rowPos = row[0].rowIndex;
            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Delete, $$1(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
                if (!actions[actionIndex]) {
                    continue;
                }
                var baseCell = actions[actionIndex].baseCell;
                var virtualPosition = actions[actionIndex].virtualTable;
                var hasRowspan = (baseCell.rowSpan && baseCell.rowSpan > 1);
                var rowspanNumber = (hasRowspan) ? parseInt(baseCell.rowSpan, 10) : 0;
                switch (actions[actionIndex].action) {
                    case TableResultAction.resultAction.Ignore:
                        continue;
                    case TableResultAction.resultAction.AddCell:
                        var nextRow = row.next('tr')[0];
                        if (!nextRow) {
                            continue;
                        }
                        var cloneRow = row[0].cells[cellPos];
                        if (hasRowspan) {
                            if (rowspanNumber > 2) {
                                rowspanNumber--;
                                nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                                nextRow.cells[cellPos].setAttribute('rowSpan', rowspanNumber);
                                nextRow.cells[cellPos].innerHTML = '';
                            }
                            else if (rowspanNumber === 2) {
                                nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                                nextRow.cells[cellPos].removeAttribute('rowSpan');
                                nextRow.cells[cellPos].innerHTML = '';
                            }
                        }
                        continue;
                    case TableResultAction.resultAction.SubtractSpanCount:
                        if (hasRowspan) {
                            if (rowspanNumber > 2) {
                                rowspanNumber--;
                                baseCell.setAttribute('rowSpan', rowspanNumber);
                                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                                    baseCell.innerHTML = '';
                                }
                            }
                            else if (rowspanNumber === 2) {
                                baseCell.removeAttribute('rowSpan');
                                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                                    baseCell.innerHTML = '';
                                }
                            }
                        }
                        continue;
                    case TableResultAction.resultAction.RemoveCell:
                        // Do not need remove cell because row will be deleted.
                        continue;
                }
            }
            row.remove();
        };
        /**
         * Delete current col
         *
         * @param {WrappedRange} rng
         * @return {Node}
         */
        Table.prototype.deleteCol = function (rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = $$1(cell).closest('tr');
            var cellPos = row.children('td, th').index($$1(cell));
            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Delete, $$1(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
                if (!actions[actionIndex]) {
                    continue;
                }
                switch (actions[actionIndex].action) {
                    case TableResultAction.resultAction.Ignore:
                        continue;
                    case TableResultAction.resultAction.SubtractSpanCount:
                        var baseCell = actions[actionIndex].baseCell;
                        var hasColspan = (baseCell.colSpan && baseCell.colSpan > 1);
                        if (hasColspan) {
                            var colspanNumber = (baseCell.colSpan) ? parseInt(baseCell.colSpan, 10) : 0;
                            if (colspanNumber > 2) {
                                colspanNumber--;
                                baseCell.setAttribute('colSpan', colspanNumber);
                                if (baseCell.cellIndex === cellPos) {
                                    baseCell.innerHTML = '';
                                }
                            }
                            else if (colspanNumber === 2) {
                                baseCell.removeAttribute('colSpan');
                                if (baseCell.cellIndex === cellPos) {
                                    baseCell.innerHTML = '';
                                }
                            }
                        }
                        continue;
                    case TableResultAction.resultAction.RemoveCell:
                        dom.remove(actions[actionIndex].baseCell, true);
                        continue;
                }
            }
        };
        /**
         * create empty table element
         *
         * @param {Number} rowCount
         * @param {Number} colCount
         * @return {Node}
         */
        Table.prototype.createTable = function (colCount, rowCount, options) {
            var tds = [];
            var tdHTML;
            for (var idxCol = 0; idxCol < colCount; idxCol++) {
                tds.push('<td>' + dom.blank + '</td>');
            }
            tdHTML = tds.join('');
            var trs = [];
            var trHTML;
            for (var idxRow = 0; idxRow < rowCount; idxRow++) {
                trs.push('<tr>' + tdHTML + '</tr>');
            }
            trHTML = trs.join('');
            var $table = $$1('<table>' + trHTML + '</table>');
            if (options && options.tableClassName) {
                $table.addClass(options.tableClassName);
            }
            return $table[0];
        };
        /**
         * Delete current table
         *
         * @param {WrappedRange} rng
         * @return {Node}
         */
        Table.prototype.deleteTable = function (rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            $$1(cell).closest('table').remove();
        };
        return Table;
    }());
  
    var KEY_BOGUS = 'bogus';
    /**
     * @class Editor
     */
    var Editor = /** @class */ (function () {
        function Editor(context) {
            var _this = this;
            this.context = context;
            this.$note = context.layoutInfo.note;
            this.$editor = context.layoutInfo.editor;
            this.$editable = context.layoutInfo.editable;
            this.options = context.options;
            this.lang = this.options.langInfo;
            this.editable = this.$editable[0];
            this.lastRange = null;
            this.style = new Style();
            this.table = new Table();
            this.typing = new Typing(context);
            this.bullet = new Bullet();
            this.history = new History(this.$editable);
            this.context.memo('help.undo', this.lang.help.undo);
            this.context.memo('help.redo', this.lang.help.redo);
            this.context.memo('help.tab', this.lang.help.tab);
            this.context.memo('help.untab', this.lang.help.untab);
            this.context.memo('help.insertParagraph', this.lang.help.insertParagraph);
            this.context.memo('help.insertOrderedList', this.lang.help.insertOrderedList);
            this.context.memo('help.insertUnorderedList', this.lang.help.insertUnorderedList);
            this.context.memo('help.indent', this.lang.help.indent);
            this.context.memo('help.outdent', this.lang.help.outdent);
            this.context.memo('help.formatPara', this.lang.help.formatPara);
            this.context.memo('help.insertHorizontalRule', this.lang.help.insertHorizontalRule);
            this.context.memo('help.fontName', this.lang.help.fontName);
            // native commands(with execCommand), generate function for execCommand
            var commands = [
                'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript',
                'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
                'formatBlock', 'removeFormat', 'backColor',
            ];
            for (var idx = 0, len = commands.length; idx < len; idx++) {
                this[commands[idx]] = (function (sCmd) {
                    return function (value) {
                        _this.beforeCommand();
                        document.execCommand(sCmd, false, value);
                        _this.afterCommand(true);
                    };
                })(commands[idx]);
                this.context.memo('help.' + commands[idx], this.lang.help[commands[idx]]);
            }
            this.fontName = this.wrapCommand(function (value) {
                return _this.fontStyling('font-family', "\'" + value + "\'");
            });
            this.fontSize = this.wrapCommand(function (value) {
                return _this.fontStyling('font-size', value + 'px');
            });
            for (var idx = 1; idx <= 6; idx++) {
                this['formatH' + idx] = (function (idx) {
                    return function () {
                        _this.formatBlock('H' + idx);
                    };
                })(idx);
                this.context.memo('help.formatH' + idx, this.lang.help['formatH' + idx]);
            }
            this.insertParagraph = this.wrapCommand(function () {
                _this.typing.insertParagraph(_this.editable);
            });
            this.insertOrderedList = this.wrapCommand(function () {
                _this.bullet.insertOrderedList(_this.editable);
            });
            this.insertUnorderedList = this.wrapCommand(function () {
                _this.bullet.insertUnorderedList(_this.editable);
            });
            this.indent = this.wrapCommand(function () {
                _this.bullet.indent(_this.editable);
            });
            this.outdent = this.wrapCommand(function () {
                _this.bullet.outdent(_this.editable);
            });
            /**
             * insertNode
             * insert node
             * @param {Node} node
             */
            this.insertNode = this.wrapCommand(function (node) {
                if (_this.isLimited($$1(node).text().length)) {
                    return;
                }
                var rng = _this.getLastRange();
                rng.insertNode(node);
                range.createFromNodeAfter(node).select();
                _this.setLastRange();
            });
            /**
             * insert text
             * @param {String} text
             */
            this.insertText = this.wrapCommand(function (text) {
                if (_this.isLimited(text.length)) {
                    return;
                }
                var rng = _this.getLastRange();
                var textNode = rng.insertNode(dom.createText(text));
                range.create(textNode, dom.nodeLength(textNode)).select();
                _this.setLastRange();
            });
            /**
             * paste HTML
             * @param {String} markup
             */
            this.pasteHTML = this.wrapCommand(function (markup) {
                if (_this.isLimited(markup.length)) {
                    return;
                }
                markup = _this.context.invoke('codeview.purify', markup);
                var contents = _this.getLastRange().pasteHTML(markup);
                range.createFromNodeAfter(lists.last(contents)).select();
                _this.setLastRange();
            });
            /**
             * formatBlock
             *
             * @param {String} tagName
             */
            this.formatBlock = this.wrapCommand(function (tagName, $target) {
                var onApplyCustomStyle = _this.options.callbacks.onApplyCustomStyle;
                if (onApplyCustomStyle) {
                    onApplyCustomStyle.call(_this, $target, _this.context, _this.onFormatBlock);
                }
                else {
                    _this.onFormatBlock(tagName, $target);
                }
            });
            /**
             * insert horizontal rule
             */
            this.insertHorizontalRule = this.wrapCommand(function () {
                var hrNode = _this.getLastRange().insertNode(dom.create('HR'));
                if (hrNode.nextSibling) {
                    range.create(hrNode.nextSibling, 0).normalize().select();
                    _this.setLastRange();
                }
            });
            /**
             * lineHeight
             * @param {String} value
             */
            this.lineHeight = this.wrapCommand(function (value) {
                _this.style.stylePara(_this.getLastRange(), {
                    lineHeight: value
                });
            });
            /**
             * create link (command)
             *
             * @param {Object} linkInfo
             */
            this.createLink = this.wrapCommand(function (linkInfo) {
                var linkUrl = linkInfo.url;
                var linkText = linkInfo.text;
                var isNewWindow = linkInfo.isNewWindow;
                var rng = linkInfo.range || _this.getLastRange();
                var additionalTextLength = linkText.length - rng.toString().length;
                if (additionalTextLength > 0 && _this.isLimited(additionalTextLength)) {
                    return;
                }
                var isTextChanged = rng.toString() !== linkText;
                // handle spaced urls from input
                if (typeof linkUrl === 'string') {
                    linkUrl = linkUrl.trim();
                }
                if (_this.options.onCreateLink) {
                    linkUrl = _this.options.onCreateLink(linkUrl);
                }
                else {
                    // if url doesn't have any protocol and not even a relative or a label, use http:// as default
                    linkUrl = /^([A-Za-z][A-Za-z0-9+-.]*\:|#|\/)/.test(linkUrl)
                        ? linkUrl : 'http://' + linkUrl;
                }
                var anchors = [];
                if (isTextChanged) {
                    rng = rng.deleteContents();
                    var anchor = rng.insertNode($$1('<A>' + linkText + '</A>')[0]);
                    anchors.push(anchor);
                }
                else {
                    anchors = _this.style.styleNodes(rng, {
                        nodeName: 'A',
                        expandClosestSibling: true,
                        onlyPartialContains: true
                    });
                }
                $$1.each(anchors, function (idx, anchor) {
                    $$1(anchor).attr('href', linkUrl);
                    if (isNewWindow) {
                        $$1(anchor).attr('target', '_blank');
                    }
                    else {
                        $$1(anchor).removeAttr('target');
                    }
                });
                var startRange = range.createFromNodeBefore(lists.head(anchors));
                var startPoint = startRange.getStartPoint();
                var endRange = range.createFromNodeAfter(lists.last(anchors));
                var endPoint = endRange.getEndPoint();
                range.create(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset).select();
                _this.setLastRange();
            });
            /**
             * setting color
             *
             * @param {Object} sObjColor  color code
             * @param {String} sObjColor.foreColor foreground color
             * @param {String} sObjColor.backColor background color
             */
            this.color = this.wrapCommand(function (colorInfo) {
                var foreColor = colorInfo.foreColor;
                var backColor = colorInfo.backColor;
                if (foreColor) {
                    document.execCommand('foreColor', false, foreColor);
                }
                if (backColor) {
                    document.execCommand('backColor', false, backColor);
                }
            });
            /**
             * Set foreground color
             *
             * @param {String} colorCode foreground color code
             */
            this.foreColor = this.wrapCommand(function (colorInfo) {
                document.execCommand('styleWithCSS', false, true);
                document.execCommand('foreColor', false, colorInfo);
            });
            /**
             * insert Table
             *
             * @param {String} dimension of table (ex : "5x5")
             */
            this.insertTable = this.wrapCommand(function (dim) {
                var dimension = dim.split('x');
                var rng = _this.getLastRange().deleteContents();
                rng.insertNode(_this.table.createTable(dimension[0], dimension[1], _this.options));
            });
            /**
             * remove media object and Figure Elements if media object is img with Figure.
             */
            this.removeMedia = this.wrapCommand(function () {
                var $target = $$1(_this.restoreTarget()).parent();
                if ($target.parent('figure').length) {
                    $target.parent('figure').remove();
                }
                else {
                    $target = $$1(_this.restoreTarget()).detach();
                }
                _this.context.triggerEvent('media.delete', $target, _this.$editable);
            });
            /**
             * float me
             *
             * @param {String} value
             */
            this.floatMe = this.wrapCommand(function (value) {
                var $target = $$1(_this.restoreTarget());
                $target.toggleClass('note-float-left', value === 'left');
                $target.toggleClass('note-float-right', value === 'right');
                $target.css('float', (value === 'none' ? '' : value));
            });
            /**
             * resize overlay element
             * @param {String} value
             */
            this.resize = this.wrapCommand(function (value) {
                var $target = $$1(_this.restoreTarget());
                value = parseFloat(value);
                if (value === 0) {
                    $target.css('width', '');
                }
                else {
                    $target.css({
                        width: value * 100 + '%',
                        height: ''
                    });
                }
            });
        }
        Editor.prototype.initialize = function () {
            var _this = this;
            // bind custom events
            this.$editable.on('keydown', function (event) {
                if (event.keyCode === key.code.ENTER) {
                    _this.context.triggerEvent('enter', event);
                }
                _this.context.triggerEvent('keydown', event);
                if (!event.isDefaultPrevented()) {
                    if (_this.options.shortcuts) {
                        _this.handleKeyMap(event);
                    }
                    else {
                        _this.preventDefaultEditableShortCuts(event);
                    }
                }
                if (_this.isLimited(1, event)) {
                    return false;
                }
            }).on('keyup', function (event) {
                _this.setLastRange();
                _this.context.triggerEvent('keyup', event);
            }).on('focus', function (event) {
                _this.setLastRange();
                _this.context.triggerEvent('focus', event);
            }).on('blur', function (event) {
                _this.context.triggerEvent('blur', event);
            }).on('mousedown', function (event) {
                _this.context.triggerEvent('mousedown', event);
            }).on('mouseup', function (event) {
                _this.setLastRange();
                _this.context.triggerEvent('mouseup', event);
            }).on('scroll', function (event) {
                _this.context.triggerEvent('scroll', event);
            }).on('paste', function (event) {
                _this.setLastRange();
                _this.context.triggerEvent('paste', event);
            });
            this.$editable.attr('spellcheck', this.options.spellCheck);
            // init content before set event
            this.$editable.html(dom.html(this.$note) || dom.emptyPara);
            this.$editable.on(env.inputEventName, func.debounce(function () {
                _this.context.triggerEvent('change', _this.$editable.html(), _this.$editable);
            }, 10));
            this.$editor.on('focusin', function (event) {
                _this.context.triggerEvent('focusin', event);
            }).on('focusout', function (event) {
                _this.context.triggerEvent('focusout', event);
            });
            if (!this.options.airMode) {
                if (this.options.width) {
                    this.$editor.outerWidth(this.options.width);
                }
                if (this.options.height) {
                    this.$editable.outerHeight(this.options.height);
                }
                if (this.options.maxHeight) {
                    this.$editable.css('max-height', this.options.maxHeight);
                }
                if (this.options.minHeight) {
                    this.$editable.css('min-height', this.options.minHeight);
                }
            }
            this.history.recordUndo();
            this.setLastRange();
        };
        Editor.prototype.destroy = function () {
            this.$editable.off();
        };
        Editor.prototype.handleKeyMap = function (event) {
            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
            var keys = [];
            if (event.metaKey) {
                keys.push('CMD');
            }
            if (event.ctrlKey && !event.altKey) {
                keys.push('CTRL');
            }
            if (event.shiftKey) {
                keys.push('SHIFT');
            }
            var keyName = key.nameFromCode[event.keyCode];
            if (keyName) {
                keys.push(keyName);
            }
            var eventName = keyMap[keys.join('+')];
            if (eventName) {
                if (this.context.invoke(eventName) !== false) {
                    event.preventDefault();
                }
            }
            else if (key.isEdit(event.keyCode)) {
                this.afterCommand();
            }
        };
        Editor.prototype.preventDefaultEditableShortCuts = function (event) {
            // B(Bold, 66) / I(Italic, 73) / U(Underline, 85)
            if ((event.ctrlKey || event.metaKey) &&
                lists.contains([66, 73, 85], event.keyCode)) {
                event.preventDefault();
            }
        };
        Editor.prototype.isLimited = function (pad, event) {
            pad = pad || 0;
            if (typeof event !== 'undefined') {
                if (key.isMove(event.keyCode) ||
                    (event.ctrlKey || event.metaKey) ||
                    lists.contains([key.code.BACKSPACE, key.code.DELETE], event.keyCode)) {
                    return false;
                }
            }
            if (this.options.maxTextLength > 0) {
                if ((this.$editable.text().length + pad) >= this.options.maxTextLength) {
                    return true;
                }
            }
            return false;
        };
        /**
         * create range
         * @return {WrappedRange}
         */
        Editor.prototype.createRange = function () {
            this.focus();
            this.setLastRange();
            return this.getLastRange();
        };
        Editor.prototype.setLastRange = function () {
            this.lastRange = range.create(this.editable);
        };
        Editor.prototype.getLastRange = function () {
            if (!this.lastRange) {
                this.setLastRange();
            }
            return this.lastRange;
        };
        /**
         * saveRange
         *
         * save current range
         *
         * @param {Boolean} [thenCollapse=false]
         */
        Editor.prototype.saveRange = function (thenCollapse) {
            if (thenCollapse) {
                this.getLastRange().collapse().select();
            }
        };
        /**
         * restoreRange
         *
         * restore lately range
         */
        Editor.prototype.restoreRange = function () {
            if (this.lastRange) {
                this.lastRange.select();
                this.focus();
            }
        };
        Editor.prototype.saveTarget = function (node) {
            this.$editable.data('target', node);
        };
        Editor.prototype.clearTarget = function () {
            this.$editable.removeData('target');
        };
        Editor.prototype.restoreTarget = function () {
            return this.$editable.data('target');
        };
        /**
         * currentStyle
         *
         * current style
         * @return {Object|Boolean} unfocus
         */
        Editor.prototype.currentStyle = function () {
            var rng = range.create();
            if (rng) {
                rng = rng.normalize();
            }
            return rng ? this.style.current(rng) : this.style.fromNode(this.$editable);
        };
        /**
         * style from node
         *
         * @param {jQuery} $node
         * @return {Object}
         */
        Editor.prototype.styleFromNode = function ($node) {
            return this.style.fromNode($node);
        };
        /**
         * undo
         */
        Editor.prototype.undo = function () {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.undo();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
        };
        /*
        * commit
        */
        Editor.prototype.commit = function () {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.commit();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
        };
        /**
         * redo
         */
        Editor.prototype.redo = function () {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.redo();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
        };
        /**
         * before command
         */
        Editor.prototype.beforeCommand = function () {
            this.context.triggerEvent('before.command', this.$editable.html());
            // keep focus on editable before command execution
            this.focus();
        };
        /**
         * after command
         * @param {Boolean} isPreventTrigger
         */
        Editor.prototype.afterCommand = function (isPreventTrigger) {
            this.normalizeContent();
            this.history.recordUndo();
            if (!isPreventTrigger) {
                this.context.triggerEvent('change', this.$editable.html(), this.$editable);
            }
        };
        /**
         * handle tab key
         */
        Editor.prototype.tab = function () {
            var rng = this.getLastRange();
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.table.tab(rng);
            }
            else {
                if (this.options.tabSize === 0) {
                    return false;
                }
                if (!this.isLimited(this.options.tabSize)) {
                    this.beforeCommand();
                    this.typing.insertTab(rng, this.options.tabSize);
                    this.afterCommand();
                }
            }
        };
        /**
         * handle shift+tab key
         */
        Editor.prototype.untab = function () {
            var rng = this.getLastRange();
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.table.tab(rng, true);
            }
            else {
                if (this.options.tabSize === 0) {
                    return false;
                }
            }
        };
        /**
         * run given function between beforeCommand and afterCommand
         */
        Editor.prototype.wrapCommand = function (fn) {
            return function () {
                this.beforeCommand();
                fn.apply(this, arguments);
                this.afterCommand();
            };
        };
        /**
         * insert image
         *
         * @param {String} src
         * @param {String|Function} param
         * @return {Promise}
         */
        Editor.prototype.insertImage = function (src, param) {
            var _this = this;
            return createImage(src, param).then(function ($image) {
                _this.beforeCommand();
                if (typeof param === 'function') {
                    param($image);
                }
                else {
                    if (typeof param === 'string') {
                        $image.attr('data-filename', param);
                    }
                    $image.css('width', Math.min(_this.$editable.width(), $image.width()));
                }
                $image.show();
                range.create(_this.editable).insertNode($image[0]);
                range.createFromNodeAfter($image[0]).select();
                _this.setLastRange();
                _this.afterCommand();
            }).fail(function (e) {
                _this.context.triggerEvent('image.upload.error', e);
            });
        };
        /**
         * insertImages
         * @param {File[]} files
         */
        Editor.prototype.insertImagesAsDataURL = function (files) {
            var _this = this;
            $$1.each(files, function (idx, file) {
                var filename = file.name;
                if (_this.options.maximumImageFileSize && _this.options.maximumImageFileSize < file.size) {
                    _this.context.triggerEvent('image.upload.error', _this.lang.image.maximumFileSizeError);
                }
                else {
                    readFileAsDataURL(file).then(function (dataURL) {
                        return _this.insertImage(dataURL, filename);
                    }).fail(function () {
                        _this.context.triggerEvent('image.upload.error');
                    });
                }
            });
        };
        /**
         * insertImagesOrCallback
         * @param {File[]} files
         */
        Editor.prototype.insertImagesOrCallback = function (files) {
            var callbacks = this.options.callbacks;
            // If onImageUpload set,
            if (callbacks.onImageUpload) {
                this.context.triggerEvent('image.upload', files);
                // else insert Image as dataURL
            }
            else {
                this.insertImagesAsDataURL(files);
            }
        };
        /**
         * return selected plain text
         * @return {String} text
         */
        Editor.prototype.getSelectedText = function () {
            var rng = this.getLastRange();
            // if range on anchor, expand range with anchor
            if (rng.isOnAnchor()) {
                rng = range.createFromNode(dom.ancestor(rng.sc, dom.isAnchor));
            }
            return rng.toString();
        };
        Editor.prototype.onFormatBlock = function (tagName, $target) {
            // [workaround] for MSIE, IE need `<`
            document.execCommand('FormatBlock', false, env.isMSIE ? '<' + tagName + '>' : tagName);
            // support custom class
            if ($target && $target.length) {
                // find the exact element has given tagName
                if ($target[0].tagName.toUpperCase() !== tagName.toUpperCase()) {
                    $target = $target.find(tagName);
                }
                if ($target && $target.length) {
                    var className = $target[0].className || '';
                    if (className) {
                        var currentRange = this.createRange();
                        var $parent = $$1([currentRange.sc, currentRange.ec]).closest(tagName);
                        $parent.addClass(className);
                    }
                }
            }
        };
        Editor.prototype.formatPara = function () {
            this.formatBlock('P');
        };
        Editor.prototype.fontStyling = function (target, value) {
            var rng = this.getLastRange();
            if (rng) {
                var spans = this.style.styleNodes(rng);
                $$1(spans).css(target, value);
                // [workaround] added styled bogus span for style
                //  - also bogus character needed for cursor position
                if (rng.isCollapsed()) {
                    var firstSpan = lists.head(spans);
                    if (firstSpan && !dom.nodeLength(firstSpan)) {
                        firstSpan.innerHTML = dom.ZERO_WIDTH_NBSP_CHAR;
                        range.createFromNodeAfter(firstSpan.firstChild).select();
                        this.setLastRange();
                        this.$editable.data(KEY_BOGUS, firstSpan);
                    }
                }
            }
        };
        /**
         * unlink
         *
         * @type command
         */
        Editor.prototype.unlink = function () {
            var rng = this.getLastRange();
            if (rng.isOnAnchor()) {
                var anchor = dom.ancestor(rng.sc, dom.isAnchor);
                rng = range.createFromNode(anchor);
                rng.select();
                this.setLastRange();
                this.beforeCommand();
                document.execCommand('unlink');
                this.afterCommand();
            }
        };
        /**
         * returns link info
         *
         * @return {Object}
         * @return {WrappedRange} return.range
         * @return {String} return.text
         * @return {Boolean} [return.isNewWindow=true]
         * @return {String} [return.url=""]
         */
        Editor.prototype.getLinkInfo = function () {
            var rng = this.getLastRange().expand(dom.isAnchor);
            // Get the first anchor on range(for edit).
            var $anchor = $$1(lists.head(rng.nodes(dom.isAnchor)));
            var linkInfo = {
                range: rng,
                text: rng.toString(),
                url: $anchor.length ? $anchor.attr('href') : ''
            };
            // When anchor exists,
            if ($anchor.length) {
                // Set isNewWindow by checking its target.
                linkInfo.isNewWindow = $anchor.attr('target') === '_blank';
            }
            return linkInfo;
        };
        Editor.prototype.addRow = function (position) {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.beforeCommand();
                this.table.addRow(rng, position);
                this.afterCommand();
            }
        };
        Editor.prototype.addCol = function (position) {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.beforeCommand();
                this.table.addCol(rng, position);
                this.afterCommand();
            }
        };
        Editor.prototype.deleteRow = function () {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.beforeCommand();
                this.table.deleteRow(rng);
                this.afterCommand();
            }
        };
        Editor.prototype.deleteCol = function () {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.beforeCommand();
                this.table.deleteCol(rng);
                this.afterCommand();
            }
        };
        Editor.prototype.deleteTable = function () {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
                this.beforeCommand();
                this.table.deleteTable(rng);
                this.afterCommand();
            }
        };
        /**
         * @param {Position} pos
         * @param {jQuery} $target - target element
         * @param {Boolean} [bKeepRatio] - keep ratio
         */
        Editor.prototype.resizeTo = function (pos, $target, bKeepRatio) {
            var imageSize;
            if (bKeepRatio) {
                var newRatio = pos.y / pos.x;
                var ratio = $target.data('ratio');
                imageSize = {
                    width: ratio > newRatio ? pos.x : pos.y / ratio,
                    height: ratio > newRatio ? pos.x * ratio : pos.y
                };
            }
            else {
                imageSize = {
                    width: pos.x,
                    height: pos.y
                };
            }
            $target.css(imageSize);
        };
        /**
         * returns whether editable area has focus or not.
         */
        Editor.prototype.hasFocus = function () {
            return this.$editable.is(':focus');
        };
        /**
         * set focus
         */
        Editor.prototype.focus = function () {
            // [workaround] Screen will move when page is scolled in IE.
            //  - do focus when not focused
            if (!this.hasFocus()) {
                this.$editable.focus();
            }
        };
        /**
         * returns whether contents is empty or not.
         * @return {Boolean}
         */
        Editor.prototype.isEmpty = function () {
            return dom.isEmpty(this.$editable[0]) || dom.emptyPara === this.$editable.html();
        };
        /**
         * Removes all contents and restores the editable instance to an _emptyPara_.
         */
        Editor.prototype.empty = function () {
            this.context.invoke('code', dom.emptyPara);
        };
        /**
         * normalize content
         */
        Editor.prototype.normalizeContent = function () {
            this.$editable[0].normalize();
        };
        return Editor;
    }());
  
    var Clipboard = /** @class */ (function () {
        function Clipboard(context) {
            this.context = context;
            this.$editable = context.layoutInfo.editable;
        }
        Clipboard.prototype.initialize = function () {
            this.$editable.on('paste', this.pasteByEvent.bind(this));
        };
        /**
         * paste by clipboard event
         *
         * @param {Event} event
         */
        Clipboard.prototype.pasteByEvent = function (event) {
            var clipboardData = event.originalEvent.clipboardData;
            if (clipboardData && clipboardData.items && clipboardData.items.length) {
                // paste img file
                var item = clipboardData.items.length > 1 ? clipboardData.items[1] : lists.head(clipboardData.items);
                if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
                    this.context.invoke('editor.insertImagesOrCallback', [item.getAsFile()]);
                }
                this.context.invoke('editor.afterCommand');
            }
        };
        return Clipboard;
    }());
  
    var Dropzone = /** @class */ (function () {
        function Dropzone(context) {
            this.context = context;
            this.$eventListener = $$1(document);
            this.$editor = context.layoutInfo.editor;
            this.$editable = context.layoutInfo.editable;
            this.options = context.options;
            this.lang = this.options.langInfo;
            this.documentEventHandlers = {};
            this.$dropzone = $$1([
                '<div class="note-dropzone">',
                '  <div class="note-dropzone-message"/>',
                '</div>',
            ].join('')).prependTo(this.$editor);
        }
        /**
         * attach Drag and Drop Events
         */
        Dropzone.prototype.initialize = function () {
            if (this.options.disableDragAndDrop) {
                // prevent default drop event
                this.documentEventHandlers.onDrop = function (e) {
                    e.preventDefault();
                };
                // do not consider outside of dropzone
                this.$eventListener = this.$dropzone;
                this.$eventListener.on('drop', this.documentEventHandlers.onDrop);
            }
            else {
                this.attachDragAndDropEvent();
            }
        };
        /**
         * attach Drag and Drop Events
         */
        Dropzone.prototype.attachDragAndDropEvent = function () {
            var _this = this;
            var collection = $$1();
            var $dropzoneMessage = this.$dropzone.find('.note-dropzone-message');
            this.documentEventHandlers.onDragenter = function (e) {
                var isCodeview = _this.context.invoke('codeview.isActivated');
                var hasEditorSize = _this.$editor.width() > 0 && _this.$editor.height() > 0;
                if (!isCodeview && !collection.length && hasEditorSize) {
                    _this.$editor.addClass('dragover');
                    _this.$dropzone.width(_this.$editor.width());
                    _this.$dropzone.height(_this.$editor.height());
                    $dropzoneMessage.text(_this.lang.image.dragImageHere);
                }
                collection = collection.add(e.target);
            };
            this.documentEventHandlers.onDragleave = function (e) {
                collection = collection.not(e.target);
                if (!collection.length) {
                    _this.$editor.removeClass('dragover');
                }
            };
            this.documentEventHandlers.onDrop = function () {
                collection = $$1();
                _this.$editor.removeClass('dragover');
            };
            // show dropzone on dragenter when dragging a object to document
            // -but only if the editor is visible, i.e. has a positive width and height
            this.$eventListener.on('dragenter', this.documentEventHandlers.onDragenter)
                .on('dragleave', this.documentEventHandlers.onDragleave)
                .on('drop', this.documentEventHandlers.onDrop);
            // change dropzone's message on hover.
            this.$dropzone.on('dragenter', function () {
                _this.$dropzone.addClass('hover');
                $dropzoneMessage.text(_this.lang.image.dropImage);
            }).on('dragleave', function () {
                _this.$dropzone.removeClass('hover');
                $dropzoneMessage.text(_this.lang.image.dragImageHere);
            });
            // attach dropImage
            this.$dropzone.on('drop', function (event) {
                var dataTransfer = event.originalEvent.dataTransfer;
                // stop the browser from opening the dropped content
                event.preventDefault();
                if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
                    _this.$editable.focus();
                    _this.context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
                }
                else {
                    $$1.each(dataTransfer.types, function (idx, type) {
                        var content = dataTransfer.getData(type);
                        if (type.toLowerCase().indexOf('text') > -1) {
                            _this.context.invoke('editor.pasteHTML', content);
                        }
                        else {
                            $$1(content).each(function (idx, item) {
                                _this.context.invoke('editor.insertNode', item);
                            });
                        }
                    });
                }
            }).on('dragover', false); // prevent default dragover event
        };
        Dropzone.prototype.destroy = function () {
            var _this = this;
            Object.keys(this.documentEventHandlers).forEach(function (key) {
                _this.$eventListener.off(key.substr(2).toLowerCase(), _this.documentEventHandlers[key]);
            });
            this.documentEventHandlers = {};
        };
        return Dropzone;
    }());
  
    var CodeMirror;
    if (env.hasCodeMirror) {
        CodeMirror = window.CodeMirror;
    }
    /**
     * @class Codeview
     */
    var CodeView = /** @class */ (function () {
        function CodeView(context) {
            this.context = context;
            this.$editor = context.layoutInfo.editor;
            this.$editable = context.layoutInfo.editable;
            this.$codable = context.layoutInfo.codable;
            this.options = context.options;
        }
        CodeView.prototype.sync = function () {
            var isCodeview = this.isActivated();
            if (isCodeview && env.hasCodeMirror) {
                this.$codable.data('cmEditor').save();
            }
        };
        /**
         * @return {Boolean}
         */
        CodeView.prototype.isActivated = function () {
            return this.$editor.hasClass('codeview');
        };
        /**
         * toggle codeview
         */
        CodeView.prototype.toggle = function () {
            if (this.isActivated()) {
                this.deactivate();
            }
            else {
                this.activate();
            }
            this.context.triggerEvent('codeview.toggled');
        };
        /**
         * purify input value
         * @param value
         * @returns {*}
         */
        CodeView.prototype.purify = function (value) {
            if (this.options.codeviewFilter) {
                // filter code view regex
                value = value.replace(this.options.codeviewFilterRegex, '');
                // allow specific iframe tag
                if (this.options.codeviewIframeFilter) {
                    var whitelist_1 = this.options.codeviewIframeWhitelistSrc.concat(this.options.codeviewIframeWhitelistSrcBase);
                    value = value.replace(/(<iframe.*?>.*?(?:<\/iframe>)?)/gi, function (tag) {
                        // remove if src attribute is duplicated
                        if (/<.+src(?==?('|"|\s)?)[\s\S]+src(?=('|"|\s)?)[^>]*?>/i.test(tag)) {
                            return '';
                        }
                        for (var _i = 0, whitelist_2 = whitelist_1; _i < whitelist_2.length; _i++) {
                            var src = whitelist_2[_i];
                            // pass if src is trusted
                            if ((new RegExp('src="(https?:)?\/\/' + src.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '\/(.+)"')).test(tag)) {
                                return tag;
                            }
                        }
                        return '';
                    });
                }
            }
            return value;
        };
        /**
         * activate code view
         */
        CodeView.prototype.activate = function () {
            var _this = this;
            this.$codable.val(dom.html(this.$editable, this.options.prettifyHtml));
            this.$codable.height(this.$editable.height());
            this.context.invoke('toolbar.updateCodeview', true);
            this.$editor.addClass('codeview');
            this.$codable.focus();
            // activate CodeMirror as codable
            if (env.hasCodeMirror) {
                var cmEditor_1 = CodeMirror.fromTextArea(this.$codable[0], this.options.codemirror);
                // CodeMirror TernServer
                if (this.options.codemirror.tern) {
                    var server_1 = new CodeMirror.TernServer(this.options.codemirror.tern);
                    cmEditor_1.ternServer = server_1;
                    cmEditor_1.on('cursorActivity', function (cm) {
                        server_1.updateArgHints(cm);
                    });
                }
                cmEditor_1.on('blur', function (event) {
                    _this.context.triggerEvent('blur.codeview', cmEditor_1.getValue(), event);
                });
                cmEditor_1.on('change', function (event) {
                    _this.context.triggerEvent('change.codeview', cmEditor_1.getValue(), cmEditor_1);
                });
                // CodeMirror hasn't Padding.
                cmEditor_1.setSize(null, this.$editable.outerHeight());
                this.$codable.data('cmEditor', cmEditor_1);
            }
            else {
                this.$codable.on('blur', function (event) {
                    _this.context.triggerEvent('blur.codeview', _this.$codable.val(), event);
                });
                this.$codable.on('input', function (event) {
                    _this.context.triggerEvent('change.codeview', _this.$codable.val(), _this.$codable);
                });
            }
        };
        /**
         * deactivate code view
         */
        CodeView.prototype.deactivate = function () {
            // deactivate CodeMirror as codable
            if (env.hasCodeMirror) {
                var cmEditor = this.$codable.data('cmEditor');
                this.$codable.val(cmEditor.getValue());
                cmEditor.toTextArea();
            }
            var value = this.purify(dom.value(this.$codable, this.options.prettifyHtml) || dom.emptyPara);
            var isChange = this.$editable.html() !== value;
            this.$editable.html(value);
            this.$editable.height(this.options.height ? this.$codable.height() : 'auto');
            this.$editor.removeClass('codeview');
            if (isChange) {
                this.context.triggerEvent('change', this.$editable.html(), this.$editable);
            }
            this.$editable.focus();
            this.context.invoke('toolbar.updateCodeview', false);
        };
        CodeView.prototype.destroy = function () {
            if (this.isActivated()) {
                this.deactivate();
            }
        };
        return CodeView;
    }());
  
    var EDITABLE_PADDING = 24;
    var Statusbar = /** @class */ (function () {
        function Statusbar(context) {
            this.$document = $$1(document);
            this.$statusbar = context.layoutInfo.statusbar;
            this.$editable = context.layoutInfo.editable;
            this.options = context.options;
        }
        Statusbar.prototype.initialize = function () {
            var _this = this;
            if (this.options.airMode || this.options.disableResizeEditor) {
                this.destroy();
                return;
            }
            this.$statusbar.on('mousedown', function (event) {
                event.preventDefault();
                event.stopPropagation();
                var editableTop = _this.$editable.offset().top - _this.$document.scrollTop();
                var onMouseMove = function (event) {
                    var height = event.clientY - (editableTop + EDITABLE_PADDING);
                    height = (_this.options.minheight > 0) ? Math.max(height, _this.options.minheight) : height;
                    height = (_this.options.maxHeight > 0) ? Math.min(height, _this.options.maxHeight) : height;
                    _this.$editable.height(height);
                };
                _this.$document.on('mousemove', onMouseMove).one('mouseup', function () {
                    _this.$document.off('mousemove', onMouseMove);
                });
            });
        };
        Statusbar.prototype.destroy = function () {
            this.$statusbar.off();
            this.$statusbar.addClass('locked');
        };
        return Statusbar;
    }());
  
    var Fullscreen = /** @class */ (function () {
        function Fullscreen(context) {
            var _this = this;
            this.context = context;
            this.$editor = context.layoutInfo.editor;
            this.$toolbar = context.layoutInfo.toolbar;
            this.$editable = context.layoutInfo.editable;
            this.$codable = context.layoutInfo.codable;
            this.$window = $$1(window);
            this.$scrollbar = $$1('html, body');
            this.onResize = function () {
                _this.resizeTo({
                    h: _this.$window.height() - _this.$toolbar.outerHeight()
                });
            };
        }
        Fullscreen.prototype.resizeTo = function (size) {
            this.$editable.css('height', size.h);
            this.$codable.css('height', size.h);
            if (this.$codable.data('cmeditor')) {
                this.$codable.data('cmeditor').setsize(null, size.h);
            }
        };
        /**
         * toggle fullscreen
         */
        Fullscreen.prototype.toggle = function () {
            this.$editor.toggleClass('fullscreen');
            if (this.isFullscreen()) {
                this.$editable.data('orgHeight', this.$editable.css('height'));
                this.$editable.data('orgMaxHeight', this.$editable.css('maxHeight'));
                this.$editable.css('maxHeight', '');
                this.$window.on('resize', this.onResize).trigger('resize');
                this.$scrollbar.css('overflow', 'hidden');
            }
            else {
                this.$window.off('resize', this.onResize);
                this.resizeTo({ h: this.$editable.data('orgHeight') });
                this.$editable.css('maxHeight', this.$editable.css('orgMaxHeight'));
                this.$scrollbar.css('overflow', 'visible');
            }
            this.context.invoke('toolbar.updateFullscreen', this.isFullscreen());
        };
        Fullscreen.prototype.isFullscreen = function () {
            return this.$editor.hasClass('fullscreen');
        };
        return Fullscreen;
    }());
  
    var Handle = /** @class */ (function () {
        function Handle(context) {
            var _this = this;
            this.context = context;
            this.$document = $$1(document);
            this.$editingArea = context.layoutInfo.editingArea;
            this.options = context.options;
            this.lang = this.options.langInfo;
            this.events = {
                'summernote.mousedown': function (we, e) {
                    if (_this.update(e.target, e)) {
                        e.preventDefault();
                    }
                },
                'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function () {
                    _this.update();
                },
                'summernote.disable': function () {
                    _this.hide();
                },
                'summernote.codeview.toggled': function () {
                    _this.update();
                }
            };
        }
        Handle.prototype.initialize = function () {
            var _this = this;
            this.$handle = $$1([
                '<div class="note-handle">',
                '<div class="note-control-selection">',
                '<div class="note-control-selection-bg"></div>',
                '<div class="note-control-holder note-control-nw"></div>',
                '<div class="note-control-holder note-control-ne"></div>',
                '<div class="note-control-holder note-control-sw"></div>',
                '<div class="',
                (this.options.disableResizeImage ? 'note-control-holder' : 'note-control-sizing'),
                ' note-control-se"></div>',
                (this.options.disableResizeImage ? '' : '<div class="note-control-selection-info"></div>'),
                '</div>',
                '</div>',
            ].join('')).prependTo(this.$editingArea);
            this.$handle.on('mousedown', function (event) {
                if (dom.isControlSizing(event.target)) {
                    event.preventDefault();
                    event.stopPropagation();
                    var $target_1 = _this.$handle.find('.note-control-selection').data('target');
                    var posStart_1 = $target_1.offset();
                    var scrollTop_1 = _this.$document.scrollTop();
                    var onMouseMove_1 = function (event) {
                        _this.context.invoke('editor.resizeTo', {
                            x: event.clientX - posStart_1.left,
                            y: event.clientY - (posStart_1.top - scrollTop_1)
                        }, $target_1, !event.shiftKey);
                        _this.update($target_1[0]);
                    };
                    _this.$document
                        .on('mousemove', onMouseMove_1)
                        .one('mouseup', function (e) {
                        e.preventDefault();
                        _this.$document.off('mousemove', onMouseMove_1);
                        _this.context.invoke('editor.afterCommand');
                    });
                    if (!$target_1.data('ratio')) { // original ratio.
                        $target_1.data('ratio', $target_1.height() / $target_1.width());
                    }
                }
            });
            // Listen for scrolling on the handle overlay.
            this.$handle.on('wheel', function (e) {
                e.preventDefault();
                _this.update();
            });
        };
        Handle.prototype.destroy = function () {
            this.$handle.remove();
        };
        Handle.prototype.update = function (target, event) {
            if (this.context.isDisabled()) {
                return false;
            }
            var isImage = dom.isImg(target);
            var $selection = this.$handle.find('.note-control-selection');
            this.context.invoke('imagePopover.update', target, event);
            if (isImage) {
                var $image = $$1(target);
                var position = $image.position();
                var pos = {
                    left: position.left + parseInt($image.css('marginLeft'), 10),
                    top: position.top + parseInt($image.css('marginTop'), 10)
                };
                // exclude margin
                var imageSize = {
                    w: $image.outerWidth(false),
                    h: $image.outerHeight(false)
                };
                $selection.css({
                    display: 'block',
                    left: pos.left,
                    top: pos.top,
                    width: imageSize.w,
                    height: imageSize.h
                }).data('target', $image); // save current image element.
                var origImageObj = new Image();
                origImageObj.src = $image.attr('src');
                var sizingText = imageSize.w + 'x' + imageSize.h + ' (' + this.lang.image.original + ': ' + origImageObj.width + 'x' + origImageObj.height + ')';
                $selection.find('.note-control-selection-info').text(sizingText);
                this.context.invoke('editor.saveTarget', target);
            }
            else {
                this.hide();
            }
            return isImage;
        };
        /**
         * hide
         *
         * @param {jQuery} $handle
         */
        Handle.prototype.hide = function () {
            this.context.invoke('editor.clearTarget');
            this.$handle.children().hide();
        };
        return Handle;
    }());
  
    var defaultScheme = 'http://';
    var linkPattern = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/]{2}|mailto:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i;
    var AutoLink = /** @class */ (function () {
        function AutoLink(context) {
            var _this = this;
            this.context = context;
            this.events = {
                'summernote.keyup': function (we, e) {
                    if (!e.isDefaultPrevented()) {
                        _this.handleKeyup(e);
                    }
                },
                'summernote.keydown': function (we, e) {
                    _this.handleKeydown(e);
                }
            };
        }
        AutoLink.prototype.initialize = function () {
            this.lastWordRange = null;
        };
        AutoLink.prototype.destroy = function () {
            this.lastWordRange = null;
        };
        AutoLink.prototype.replace = function () {
            if (!this.lastWordRange) {
                return;
            }
            var keyword = this.lastWordRange.toString();
            var match = keyword.match(linkPattern);
            if (match && (match[1] || match[2])) {
                var link = match[1] ? keyword : defaultScheme + keyword;
                var node = $$1('<a />').html(keyword).attr('href', link)[0];
                if (this.context.options.linkTargetBlank) {
                    $$1(node).attr('target', '_blank');
                }
                this.lastWordRange.insertNode(node);
                this.lastWordRange = null;
                this.context.invoke('editor.focus');
            }
        };
        AutoLink.prototype.handleKeydown = function (e) {
            if (lists.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
                var wordRange = this.context.invoke('editor.createRange').getWordRange();
                this.lastWordRange = wordRange;
            }
        };
        AutoLink.prototype.handleKeyup = function (e) {
            if (lists.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
                this.replace();
            }
        };
        return AutoLink;
    }());
  
    /**
     * textarea auto sync.
     */
    var AutoSync = /** @class */ (function () {
        function AutoSync(context) {
            var _this = this;
            this.$note = context.layoutInfo.note;
            this.events = {
                'summernote.change': function () {
                    _this.$note.val(context.invoke('code'));
                }
            };
        }
        AutoSync.prototype.shouldInitialize = function () {
            return dom.isTextarea(this.$note[0]);
        };
        return AutoSync;
    }());
  
    var AutoReplace = /** @class */ (function () {
        function AutoReplace(context) {
            var _this = this;
            this.context = context;
            this.options = context.options.replace || {};
            this.keys = [key.code.ENTER, key.code.SPACE, key.code.PERIOD, key.code.COMMA, key.code.SEMICOLON, key.code.SLASH];
            this.previousKeydownCode = null;
            this.events = {
                'summernote.keyup': function (we, e) {
                    if (!e.isDefaultPrevented()) {
                        _this.handleKeyup(e);
                    }
                },
                'summernote.keydown': function (we, e) {
                    _this.handleKeydown(e);
                }
            };
        }
        AutoReplace.prototype.shouldInitialize = function () {
            return !!this.options.match;
        };
        AutoReplace.prototype.initialize = function () {
            this.lastWord = null;
        };
        AutoReplace.prototype.destroy = function () {
            this.lastWord = null;
        };
        AutoReplace.prototype.replace = function () {
            if (!this.lastWord) {
                return;
            }
            var self = this;
            var keyword = this.lastWord.toString();
            this.options.match(keyword, function (match) {
                if (match) {
                    var node = '';
                    if (typeof match === 'string') {
                        node = dom.createText(match);
                    }
                    else if (match instanceof jQuery) {
                        node = match[0];
                    }
                    else if (match instanceof Node) {
                        node = match;
                    }
                    if (!node)
                        return;
                    self.lastWord.insertNode(node);
                    self.lastWord = null;
                    self.context.invoke('editor.focus');
                }
            });
        };
        AutoReplace.prototype.handleKeydown = function (e) {
            // this forces it to remember the last whole word, even if multiple termination keys are pressed
            // before the previous key is let go.
            if (this.previousKeydownCode && lists.contains(this.keys, this.previousKeydownCode)) {
                this.previousKeydownCode = e.keyCode;
                return;
            }
            if (lists.contains(this.keys, e.keyCode)) {
                var wordRange = this.context.invoke('editor.createRange').getWordRange();
                this.lastWord = wordRange;
            }
            this.previousKeydownCode = e.keyCode;
        };
        AutoReplace.prototype.handleKeyup = function (e) {
            if (lists.contains(this.keys, e.keyCode)) {
                this.replace();
            }
        };
        return AutoReplace;
    }());
  
    var Placeholder = /** @class */ (function () {
        function Placeholder(context) {
            var _this = this;
            this.context = context;
            this.$editingArea = context.layoutInfo.editingArea;
            this.options = context.options;
            this.events = {
                'summernote.init summernote.change': function () {
                    _this.update();
                },
                'summernote.codeview.toggled': function () {
                    _this.update();
                }
            };
        }
        Placeholder.prototype.shouldInitialize = function () {
            return !!this.options.placeholder;
        };
        Placeholder.prototype.initialize = function () {
            var _this = this;
            this.$placeholder = $$1('<div class="note-placeholder">');
            this.$placeholder.on('click', function () {
                _this.context.invoke('focus');
            }).html(this.options.placeholder).prependTo(this.$editingArea);
            this.update();
        };
        Placeholder.prototype.destroy = function () {
            this.$placeholder.remove();
        };
        Placeholder.prototype.update = function () {
            var isShow = !this.context.invoke('codeview.isActivated') && this.context.invoke('editor.isEmpty');
            this.$placeholder.toggle(isShow);
        };
        return Placeholder;
    }());
  
    var Buttons = /** @class */ (function () {
        function Buttons(context) {
            this.ui = $$1.summernote.ui;
            this.context = context;
            this.$toolbar = context.layoutInfo.toolbar;
            this.options = context.options;
            this.lang = this.options.langInfo;
            this.invertedKeyMap = func.invertObject(this.options.keyMap[env.isMac ? 'mac' : 'pc']);
        }
        Buttons.prototype.representShortcut = function (editorMethod) {
            var shortcut = this.invertedKeyMap[editorMethod];
            if (!this.options.shortcuts || !shortcut) {
                return '';
            }
            if (env.isMac) {
                shortcut = shortcut.replace('CMD', '⌘').replace('SHIFT', '⇧');
            }
            shortcut = shortcut.replace('BACKSLASH', '\\')
                .replace('SLASH', '/')
                .replace('LEFTBRACKET', '[')
                .replace('RIGHTBRACKET', ']');
            return ' (' + shortcut + ')';
        };
        Buttons.prototype.button = function (o) {
            if (!this.options.tooltip && o.tooltip) {
                delete o.tooltip;
            }
            o.container = this.options.container;
            return this.ui.button(o);
        };
        Buttons.prototype.initialize = function () {
            this.addToolbarButtons();
            this.addImagePopoverButtons();
            this.addLinkPopoverButtons();
            this.addTablePopoverButtons();
            this.fontInstalledMap = {};
        };
        Buttons.prototype.destroy = function () {
            delete this.fontInstalledMap;
        };
        Buttons.prototype.isFontInstalled = function (name) {
            if (!this.fontInstalledMap.hasOwnProperty(name)) {
                this.fontInstalledMap[name] = env.isFontInstalled(name) ||
                    lists.contains(this.options.fontNamesIgnoreCheck, name);
            }
            return this.fontInstalledMap[name];
        };
        Buttons.prototype.isFontDeservedToAdd = function (name) {
            var genericFamilies = ['sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'];
            name = name.toLowerCase();
            return (name !== '' && this.isFontInstalled(name) && genericFamilies.indexOf(name) === -1);
        };
        Buttons.prototype.colorPalette = function (className, tooltip, backColor, foreColor) {
            var _this = this;
            return this.ui.buttonGroup({
                className: 'note-color ' + className,
                children: [
                    this.button({
                        className: 'note-current-color-button',
                        contents: this.ui.icon(this.options.icons.font + ' note-recent-color'),
                        tooltip: tooltip,
                        click: function (e) {
                            var $button = $$1(e.currentTarget);
                            if (backColor && foreColor) {
                                _this.context.invoke('editor.color', {
                                    backColor: $button.attr('data-backColor'),
                                    foreColor: $button.attr('data-foreColor')
                                });
                            }
                            else if (backColor) {
                                _this.context.invoke('editor.color', {
                                    backColor: $button.attr('data-backColor')
                                });
                            }
                            else if (foreColor) {
                                _this.context.invoke('editor.color', {
                                    foreColor: $button.attr('data-foreColor')
                                });
                            }
                        },
                        callback: function ($button) {
                            var $recentColor = $button.find('.note-recent-color');
                            if (backColor) {
                                $recentColor.css('background-color', _this.options.colorButton.backColor);
                                $button.attr('data-backColor', _this.options.colorButton.backColor);
                            }
                            if (foreColor) {
                                $recentColor.css('color', _this.options.colorButton.foreColor);
                                $button.attr('data-foreColor', _this.options.colorButton.foreColor);
                            }
                            else {
                                $recentColor.css('color', 'transparent');
                            }
                        }
                    }),
                    this.button({
                        className: 'dropdown-toggle',
                        contents: this.ui.dropdownButtonContents('', this.options),
                        tooltip: this.lang.color.more,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    this.ui.dropdown({
                        items: (backColor ? [
                            '<div class="note-palette">',
                            '  <div class="note-palette-title">' + this.lang.color.background + '</div>',
                            '  <div>',
                            '    <button type="button" class="note-color-reset btn btn-light" data-event="backColor" data-value="inherit">',
                            this.lang.color.transparent,
                            '    </button>',
                            '  </div>',
                            '  <div class="note-holder" data-event="backColor"/>',
                            '  <div>',
                            '    <button type="button" class="note-color-select btn" data-event="openPalette" data-value="backColorPicker">',
                            this.lang.color.cpSelect,
                            '    </button>',
                            '    <input type="color" id="backColorPicker" class="note-btn note-color-select-btn" value="' + this.options.colorButton.backColor + '" data-event="backColorPalette">',
                            '  </div>',
                            '  <div class="note-holder-custom" id="backColorPalette" data-event="backColor"/>',
                            '</div>',
                        ].join('') : '') +
                            (foreColor ? [
                                '<div class="note-palette">',
                                '  <div class="note-palette-title">' + this.lang.color.foreground + '</div>',
                                '  <div>',
                                '    <button type="button" class="note-color-reset btn btn-light" data-event="removeFormat" data-value="foreColor">',
                                this.lang.color.resetToDefault,
                                '    </button>',
                                '  </div>',
                                '  <div class="note-holder" data-event="foreColor"/>',
                                '  <div>',
                                '    <button type="button" class="note-color-select btn" data-event="openPalette" data-value="foreColorPicker">',
                                this.lang.color.cpSelect,
                                '    </button>',
                                '    <input type="color" id="foreColorPicker" class="note-btn note-color-select-btn" value="' + this.options.colorButton.foreColor + '" data-event="foreColorPalette">',
                                '  <div class="note-holder-custom" id="foreColorPalette" data-event="foreColor"/>',
                                '</div>',
                            ].join('') : ''),
                        callback: function ($dropdown) {
                            $dropdown.find('.note-holder').each(function (idx, item) {
                                var $holder = $$1(item);
                                $holder.append(_this.ui.palette({
                                    colors: _this.options.colors,
                                    colorsName: _this.options.colorsName,
                                    eventName: $holder.data('event'),
                                    container: _this.options.container,
                                    tooltip: _this.options.tooltip
                                }).render());
                            });
                            /* TODO: do we have to record recent custom colors within cookies? */
                            var customColors = [
                                ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'],
                            ];
                            $dropdown.find('.note-holder-custom').each(function (idx, item) {
                                var $holder = $$1(item);
                                $holder.append(_this.ui.palette({
                                    colors: customColors,
                                    colorsName: customColors,
                                    eventName: $holder.data('event'),
                                    container: _this.options.container,
                                    tooltip: _this.options.tooltip
                                }).render());
                            });
                            $dropdown.find('input[type=color]').each(function (idx, item) {
                                $$1(item).change(function () {
                                    var $chip = $dropdown.find('#' + $$1(this).data('event')).find('.note-color-btn').first();
                                    var color = this.value.toUpperCase();
                                    $chip.css('background-color', color)
                                        .attr('aria-label', color)
                                        .attr('data-value', color)
                                        .attr('data-original-title', color);
                                    $chip.click();
                                });
                            });
                        },
                        click: function (event) {
                            event.stopPropagation();
                            var $parent = $$1('.' + className);
                            var $button = $$1(event.target);
                            var eventName = $button.data('event');
                            var value = $button.attr('data-value');
                            if (eventName === 'openPalette') {
                                var $picker = $parent.find('#' + value);
                                var $palette = $$1($parent.find('#' + $picker.data('event')).find('.note-color-row')[0]);
                                // Shift palette chips
                                var $chip = $palette.find('.note-color-btn').last().detach();
                                // Set chip attributes
                                var color = $picker.val();
                                $chip.css('background-color', color)
                                    .attr('aria-label', color)
                                    .attr('data-value', color)
                                    .attr('data-original-title', color);
                                $palette.prepend($chip);
                                $picker.click();
                            }
                            else if (lists.contains(['backColor', 'foreColor'], eventName)) {
                                var key = eventName === 'backColor' ? 'background-color' : 'color';
                                var $color = $button.closest('.note-color').find('.note-recent-color');
                                var $currentButton = $button.closest('.note-color').find('.note-current-color-button');
                                $color.css(key, value);
                                $currentButton.attr('data-' + eventName, value);
                                _this.context.invoke('editor.' + eventName, value);
                            }
                        }
                    }),
                ]
            }).render();
        };
        Buttons.prototype.addToolbarButtons = function () {
            var _this = this;
            this.context.memo('button.style', function () {
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.magic), _this.options),
                        tooltip: _this.lang.style.style,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdown({
                        className: 'dropdown-style',
                        items: _this.options.styleTags,
                        title: _this.lang.style.style,
                        template: function (item) {
                            if (typeof item === 'string') {
                                item = { tag: item, title: (_this.lang.style.hasOwnProperty(item) ? _this.lang.style[item] : item) };
                            }
                            var tag = item.tag;
                            var title = item.title;
                            var style = item.style ? ' style="' + item.style + '" ' : '';
                            var className = item.className ? ' class="' + item.className + '"' : '';
                            return '<' + tag + style + className + '>' + title + '</' + tag + '>';
                        },
                        click: _this.context.createInvokeHandler('editor.formatBlock')
                    }),
                ]).render();
            });
            var _loop_1 = function (styleIdx, styleLen) {
                var item = this_1.options.styleTags[styleIdx];
                this_1.context.memo('button.style.' + item, function () {
                    return _this.button({
                        className: 'note-btn-style-' + item,
                        contents: '<div data-value="' + item + '">' + item.toUpperCase() + '</div>',
                        tooltip: _this.lang.style[item],
                        click: _this.context.createInvokeHandler('editor.formatBlock')
                    }).render();
                });
            };
            var this_1 = this;
            for (var styleIdx = 0, styleLen = this.options.styleTags.length; styleIdx < styleLen; styleIdx++) {
                _loop_1(styleIdx, styleLen);
            }
            this.context.memo('button.bold', function () {
                return _this.button({
                    className: 'note-btn-bold',
                    contents: _this.ui.icon(_this.options.icons.bold),
                    tooltip: _this.lang.font.bold + _this.representShortcut('bold'),
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.bold')
                }).render();
            });
            this.context.memo('button.italic', function () {
                return _this.button({
                    className: 'note-btn-italic',
                    contents: _this.ui.icon(_this.options.icons.italic),
                    tooltip: _this.lang.font.italic + _this.representShortcut('italic'),
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.italic')
                }).render();
            });
            this.context.memo('button.underline', function () {
                return _this.button({
                    className: 'note-btn-underline',
                    contents: _this.ui.icon(_this.options.icons.underline),
                    tooltip: _this.lang.font.underline + _this.representShortcut('underline'),
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.underline')
                }).render();
            });
            this.context.memo('button.clear', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.eraser),
                    tooltip: _this.lang.font.clear + _this.representShortcut('removeFormat'),
                    click: _this.context.createInvokeHandler('editor.removeFormat')
                }).render();
            });
            this.context.memo('button.strikethrough', function () {
                return _this.button({
                    className: 'note-btn-strikethrough',
                    contents: _this.ui.icon(_this.options.icons.strikethrough),
                    tooltip: _this.lang.font.strikethrough + _this.representShortcut('strikethrough'),
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.strikethrough')
                }).render();
            });
            this.context.memo('button.superscript', function () {
                return _this.button({
                    className: 'note-btn-superscript',
                    contents: _this.ui.icon(_this.options.icons.superscript),
                    tooltip: _this.lang.font.superscript,
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.superscript')
                }).render();
            });
            this.context.memo('button.subscript', function () {
                return _this.button({
                    className: 'note-btn-subscript',
                    contents: _this.ui.icon(_this.options.icons.subscript),
                    tooltip: _this.lang.font.subscript,
                    click: _this.context.createInvokeHandlerAndUpdateState('editor.subscript')
                }).render();
            });
            this.context.memo('button.fontname', function () {
                var styleInfo = _this.context.invoke('editor.currentStyle');
                // Add 'default' fonts into the fontnames array if not exist
                $$1.each(styleInfo['font-family'].split(','), function (idx, fontname) {
                    fontname = fontname.trim().replace(/['"]+/g, '');
                    if (_this.isFontDeservedToAdd(fontname)) {
                        if (_this.options.fontNames.indexOf(fontname) === -1) {
                            _this.options.fontNames.push(fontname);
                        }
                    }
                });
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents('<span class="note-current-fontname"/>', _this.options),
                        tooltip: _this.lang.font.name,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdownCheck({
                        className: 'dropdown-fontname',
                        checkClassName: _this.options.icons.menuCheck,
                        items: _this.options.fontNames.filter(_this.isFontInstalled.bind(_this)),
                        title: _this.lang.font.name,
                        template: function (item) {
                            return '<span style="font-family: \'' + item + '\'">' + item + '</span>';
                        },
                        click: _this.context.createInvokeHandlerAndUpdateState('editor.fontName')
                    }),
                ]).render();
            });
            this.context.memo('button.fontsize', function () {
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents('<span class="note-current-fontsize"/>', _this.options),
                        tooltip: _this.lang.font.size,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdownCheck({
                        className: 'dropdown-fontsize',
                        checkClassName: _this.options.icons.menuCheck,
                        items: _this.options.fontSizes,
                        title: _this.lang.font.size,
                        click: _this.context.createInvokeHandlerAndUpdateState('editor.fontSize')
                    }),
                ]).render();
            });
            this.context.memo('button.color', function () {
                return _this.colorPalette('note-color-all', _this.lang.color.recent, true, true);
            });
            this.context.memo('button.forecolor', function () {
                return _this.colorPalette('note-color-fore', _this.lang.color.foreground, false, true);
            });
            this.context.memo('button.backcolor', function () {
                return _this.colorPalette('note-color-back', _this.lang.color.background, true, false);
            });
            this.context.memo('button.ul', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.unorderedlist),
                    tooltip: _this.lang.lists.unordered + _this.representShortcut('insertUnorderedList'),
                    click: _this.context.createInvokeHandler('editor.insertUnorderedList')
                }).render();
            });
            this.context.memo('button.ol', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.orderedlist),
                    tooltip: _this.lang.lists.ordered + _this.representShortcut('insertOrderedList'),
                    click: _this.context.createInvokeHandler('editor.insertOrderedList')
                }).render();
            });
            var justifyLeft = this.button({
                contents: this.ui.icon(this.options.icons.alignLeft),
                tooltip: this.lang.paragraph.left + this.representShortcut('justifyLeft'),
                click: this.context.createInvokeHandler('editor.justifyLeft')
            });
            var justifyCenter = this.button({
                contents: this.ui.icon(this.options.icons.alignCenter),
                tooltip: this.lang.paragraph.center + this.representShortcut('justifyCenter'),
                click: this.context.createInvokeHandler('editor.justifyCenter')
            });
            var justifyRight = this.button({
                contents: this.ui.icon(this.options.icons.alignRight),
                tooltip: this.lang.paragraph.right + this.representShortcut('justifyRight'),
                click: this.context.createInvokeHandler('editor.justifyRight')
            });
            var justifyFull = this.button({
                contents: this.ui.icon(this.options.icons.alignJustify),
                tooltip: this.lang.paragraph.justify + this.representShortcut('justifyFull'),
                click: this.context.createInvokeHandler('editor.justifyFull')
            });
            var outdent = this.button({
                contents: this.ui.icon(this.options.icons.outdent),
                tooltip: this.lang.paragraph.outdent + this.representShortcut('outdent'),
                click: this.context.createInvokeHandler('editor.outdent')
            });
            var indent = this.button({
                contents: this.ui.icon(this.options.icons.indent),
                tooltip: this.lang.paragraph.indent + this.representShortcut('indent'),
                click: this.context.createInvokeHandler('editor.indent')
            });
            this.context.memo('button.justifyLeft', func.invoke(justifyLeft, 'render'));
            this.context.memo('button.justifyCenter', func.invoke(justifyCenter, 'render'));
            this.context.memo('button.justifyRight', func.invoke(justifyRight, 'render'));
            this.context.memo('button.justifyFull', func.invoke(justifyFull, 'render'));
            this.context.memo('button.outdent', func.invoke(outdent, 'render'));
            this.context.memo('button.indent', func.invoke(indent, 'render'));
            this.context.memo('button.paragraph', function () {
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.alignLeft), _this.options),
                        tooltip: _this.lang.paragraph.paragraph,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdown([
                        _this.ui.buttonGroup({
                            className: 'note-align',
                            children: [justifyLeft, justifyCenter, justifyRight, justifyFull]
                        }),
                        _this.ui.buttonGroup({
                            className: 'note-list',
                            children: [outdent, indent]
                        }),
                    ]),
                ]).render();
            });
            this.context.memo('button.height', function () {
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.textHeight), _this.options),
                        tooltip: _this.lang.font.height,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdownCheck({
                        items: _this.options.lineHeights,
                        checkClassName: _this.options.icons.menuCheck,
                        className: 'dropdown-line-height',
                        title: _this.lang.font.height,
                        click: _this.context.createInvokeHandler('editor.lineHeight')
                    }),
                ]).render();
            });
            this.context.memo('button.table', function () {
                return _this.ui.buttonGroup([
                    _this.button({
                        className: 'dropdown-toggle',
                        contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.table), _this.options),
                        tooltip: _this.lang.table.table,
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    _this.ui.dropdown({
                        title: _this.lang.table.table,
                        className: 'note-table',
                        items: [
                            '<div class="note-dimension-picker">',
                            '  <div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"/>',
                            '  <div class="note-dimension-picker-highlighted"/>',
                            '  <div class="note-dimension-picker-unhighlighted"/>',
                            '</div>',
                            '<div class="note-dimension-display">1 x 1</div>',
                        ].join('')
                    }),
                ], {
                    callback: function ($node) {
                        var $catcher = $node.find('.note-dimension-picker-mousecatcher');
                        $catcher.css({
                            width: _this.options.insertTableMaxSize.col + 'em',
                            height: _this.options.insertTableMaxSize.row + 'em'
                        }).mousedown(_this.context.createInvokeHandler('editor.insertTable'))
                            .on('mousemove', _this.tableMoveHandler.bind(_this));
                    }
                }).render();
            });
            this.context.memo('button.link', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.link),
                    tooltip: _this.lang.link.link + _this.representShortcut('linkDialog.show'),
                    click: _this.context.createInvokeHandler('linkDialog.show')
                }).render();
            });
            this.context.memo('button.picture', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.picture),
                    tooltip: _this.lang.image.image,
                    click: _this.context.createInvokeHandler('imageDialog.show')
                }).render();
            });
            this.context.memo('button.video', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.video),
                    tooltip: _this.lang.video.video,
                    click: _this.context.createInvokeHandler('videoDialog.show')
                }).render();
            });
            this.context.memo('button.hr', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.minus),
                    tooltip: _this.lang.hr.insert + _this.representShortcut('insertHorizontalRule'),
                    click: _this.context.createInvokeHandler('editor.insertHorizontalRule')
                }).render();
            });
            this.context.memo('button.fullscreen', function () {
                return _this.button({
                    className: 'btn-fullscreen',
                    contents: _this.ui.icon(_this.options.icons.arrowsAlt),
                    tooltip: _this.lang.options.fullscreen,
                    click: _this.context.createInvokeHandler('fullscreen.toggle')
                }).render();
            });
            this.context.memo('button.codeview', function () {
                return _this.button({
                    className: 'btn-codeview',
                    contents: _this.ui.icon(_this.options.icons.code),
                    tooltip: _this.lang.options.codeview,
                    click: _this.context.createInvokeHandler('codeview.toggle')
                }).render();
            });
            this.context.memo('button.redo', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.redo),
                    tooltip: _this.lang.history.redo + _this.representShortcut('redo'),
                    click: _this.context.createInvokeHandler('editor.redo')
                }).render();
            });
            this.context.memo('button.undo', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.undo),
                    tooltip: _this.lang.history.undo + _this.representShortcut('undo'),
                    click: _this.context.createInvokeHandler('editor.undo')
                }).render();
            });
            this.context.memo('button.help', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.question),
                    tooltip: _this.lang.options.help,
                    click: _this.context.createInvokeHandler('helpDialog.show')
                }).render();
            });
        };
        /**
         * image: [
         *   ['imageResize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
         *   ['float', ['floatLeft', 'floatRight', 'floatNone']],
         *   ['remove', ['removeMedia']],
         * ],
         */
        Buttons.prototype.addImagePopoverButtons = function () {
            var _this = this;
            // Image Size Buttons
            this.context.memo('button.resizeFull', function () {
                return _this.button({
                    contents: '<span class="note-fontsize-10">100%</span>',
                    tooltip: _this.lang.image.resizeFull,
                    click: _this.context.createInvokeHandler('editor.resize', '1')
                }).render();
            });
            this.context.memo('button.resizeHalf', function () {
                return _this.button({
                    contents: '<span class="note-fontsize-10">50%</span>',
                    tooltip: _this.lang.image.resizeHalf,
                    click: _this.context.createInvokeHandler('editor.resize', '0.5')
                }).render();
            });
            this.context.memo('button.resizeQuarter', function () {
                return _this.button({
                    contents: '<span class="note-fontsize-10">25%</span>',
                    tooltip: _this.lang.image.resizeQuarter,
                    click: _this.context.createInvokeHandler('editor.resize', '0.25')
                }).render();
            });
            this.context.memo('button.resizeNone', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.rollback),
                    tooltip: _this.lang.image.resizeNone,
                    click: _this.context.createInvokeHandler('editor.resize', '0')
                }).render();
            });
            // Float Buttons
            this.context.memo('button.floatLeft', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.floatLeft),
                    tooltip: _this.lang.image.floatLeft,
                    click: _this.context.createInvokeHandler('editor.floatMe', 'left')
                }).render();
            });
            this.context.memo('button.floatRight', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.floatRight),
                    tooltip: _this.lang.image.floatRight,
                    click: _this.context.createInvokeHandler('editor.floatMe', 'right')
                }).render();
            });
            this.context.memo('button.floatNone', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.rollback),
                    tooltip: _this.lang.image.floatNone,
                    click: _this.context.createInvokeHandler('editor.floatMe', 'none')
                }).render();
            });
            // Remove Buttons
            this.context.memo('button.removeMedia', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.trash),
                    tooltip: _this.lang.image.remove,
                    click: _this.context.createInvokeHandler('editor.removeMedia')
                }).render();
            });
        };
        Buttons.prototype.addLinkPopoverButtons = function () {
            var _this = this;
            this.context.memo('button.linkDialogShow', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.link),
                    tooltip: _this.lang.link.edit,
                    click: _this.context.createInvokeHandler('linkDialog.show')
                }).render();
            });
            this.context.memo('button.unlink', function () {
                return _this.button({
                    contents: _this.ui.icon(_this.options.icons.unlink),
                    tooltip: _this.lang.link.unlink,
                    click: _this.context.createInvokeHandler('editor.unlink')
                }).render();
            });
        };
        /**
         * table : [
         *  ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
         *  ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
         * ],
         */
        Buttons.prototype.addTablePopoverButtons = function () {
            var _this = this;
            this.context.memo('button.addRowUp', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.rowAbove),
                    tooltip: _this.lang.table.addRowAbove,
                    click: _this.context.createInvokeHandler('editor.addRow', 'top')
                }).render();
            });
            this.context.memo('button.addRowDown', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.rowBelow),
                    tooltip: _this.lang.table.addRowBelow,
                    click: _this.context.createInvokeHandler('editor.addRow', 'bottom')
                }).render();
            });
            this.context.memo('button.addColLeft', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.colBefore),
                    tooltip: _this.lang.table.addColLeft,
                    click: _this.context.createInvokeHandler('editor.addCol', 'left')
                }).render();
            });
            this.context.memo('button.addColRight', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.colAfter),
                    tooltip: _this.lang.table.addColRight,
                    click: _this.context.createInvokeHandler('editor.addCol', 'right')
                }).render();
            });
            this.context.memo('button.deleteRow', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.rowRemove),
                    tooltip: _this.lang.table.delRow,
                    click: _this.context.createInvokeHandler('editor.deleteRow')
                }).render();
            });
            this.context.memo('button.deleteCol', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.colRemove),
                    tooltip: _this.lang.table.delCol,
                    click: _this.context.createInvokeHandler('editor.deleteCol')
                }).render();
            });
            this.context.memo('button.deleteTable', function () {
                return _this.button({
                    className: 'btn-md',
                    contents: _this.ui.icon(_this.options.icons.trash),
                    tooltip: _this.lang.table.delTable,
                    click: _this.context.createInvokeHandler('editor.deleteTable')
                }).render();
            });
        };
        Buttons.prototype.build = function ($container, groups) {
            for (var groupIdx = 0, groupLen = groups.length; groupIdx < groupLen; groupIdx++) {
                var group = groups[groupIdx];
                var groupName = Array.isArray(group) ? group[0] : group;
                var buttons = Array.isArray(group) ? ((group.length === 1) ? [group[0]] : group[1]) : [group];
                var $group = this.ui.buttonGroup({
                    className: 'note-' + groupName
                }).render();
                for (var idx = 0, len = buttons.length; idx < len; idx++) {
                    var btn = this.context.memo('button.' + buttons[idx]);
                    if (btn) {
                        $group.append(typeof btn === 'function' ? btn() : btn);
                    }
                }
                $group.appendTo($container);
            }
        };
        /**
         * @param {jQuery} [$container]
         */
        Buttons.prototype.updateCurrentStyle = function ($container) {
            var _this = this;
            var $cont = $container || this.$toolbar;
            var styleInfo = this.context.invoke('editor.currentStyle');
            this.updateBtnStates($cont, {
                '.note-btn-bold': function () {
                    return styleInfo['font-bold'] === 'bold';
                },
                '.note-btn-italic': function () {
                    return styleInfo['font-italic'] === 'italic';
                },
                '.note-btn-underline': function () {
                    return styleInfo['font-underline'] === 'underline';
                },
                '.note-btn-subscript': function () {
                    return styleInfo['font-subscript'] === 'subscript';
                },
                '.note-btn-superscript': function () {
                    return styleInfo['font-superscript'] === 'superscript';
                },
                '.note-btn-strikethrough': function () {
                    return styleInfo['font-strikethrough'] === 'strikethrough';
                }
            });
            if (styleInfo['font-family']) {
                var fontNames = styleInfo['font-family'].split(',').map(function (name) {
                    return name.replace(/[\'\"]/g, '')
                        .replace(/\s+$/, '')
                        .replace(/^\s+/, '');
                });
                var fontName_1 = lists.find(fontNames, this.isFontInstalled.bind(this));
                $cont.find('.dropdown-fontname a').each(function (idx, item) {
                    var $item = $$1(item);
                    // always compare string to avoid creating another func.
                    var isChecked = ($item.data('value') + '') === (fontName_1 + '');
                    $item.toggleClass('checked', isChecked);
                });
                $cont.find('.note-current-fontname').text(fontName_1).css('font-family', fontName_1);
            }
            if (styleInfo['font-size']) {
                var fontSize_1 = styleInfo['font-size'];
                $cont.find('.dropdown-fontsize a').each(function (idx, item) {
                    var $item = $$1(item);
                    // always compare with string to avoid creating another func.
                    var isChecked = ($item.data('value') + '') === (fontSize_1 + '');
                    $item.toggleClass('checked', isChecked);
                });
                $cont.find('.note-current-fontsize').text(fontSize_1);
            }
            if (styleInfo['line-height']) {
                var lineHeight_1 = styleInfo['line-height'];
                $cont.find('.dropdown-line-height li a').each(function (idx, item) {
                    // always compare with string to avoid creating another func.
                    var isChecked = ($$1(item).data('value') + '') === (lineHeight_1 + '');
                    _this.className = isChecked ? 'checked' : '';
                });
            }
        };
        Buttons.prototype.updateBtnStates = function ($container, infos) {
            var _this = this;
            $$1.each(infos, function (selector, pred) {
                _this.ui.toggleBtnActive($container.find(selector), pred());
            });
        };
        Buttons.prototype.tableMoveHandler = function (event) {
            var PX_PER_EM = 18;
            var $picker = $$1(event.target.parentNode); // target is mousecatcher
            var $dimensionDisplay = $picker.next();
            var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
            var $highlighted = $picker.find('.note-dimension-picker-highlighted');
            var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');
            var posOffset;
            // HTML5 with jQuery - e.offsetX is undefined in Firefox
            if (event.offsetX === undefined) {
                var posCatcher = $$1(event.target).offset();
                posOffset = {
                    x: event.pageX - posCatcher.left,
                    y: event.pageY - posCatcher.top
                };
            }
            else {
                posOffset = {
                    x: event.offsetX,
                    y: event.offsetY
                };
            }
            var dim = {
                c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
                r: Math.ceil(posOffset.y / PX_PER_EM) || 1
            };
            $highlighted.css({ width: dim.c + 'em', height: dim.r + 'em' });
            $catcher.data('value', dim.c + 'x' + dim.r);
            if (dim.c > 3 && dim.c < this.options.insertTableMaxSize.col) {
                $unhighlighted.css({ width: dim.c + 1 + 'em' });
            }
            if (dim.r > 3 && dim.r < this.options.insertTableMaxSize.row) {
                $unhighlighted.css({ height: dim.r + 1 + 'em' });
            }
            $dimensionDisplay.html(dim.c + ' x ' + dim.r);
        };
        return Buttons;
    }());
  
    var Toolbar = /** @class */ (function () {
        function Toolbar(context) {
            this.context = context;
            this.$window = $$1(window);
            this.$document = $$1(document);
            this.ui = $$1.summernote.ui;
            this.$note = context.layoutInfo.note;
            this.$editor = context.layoutInfo.editor;
            this.$toolbar = context.layoutInfo.toolbar;
            this.$editable = context.layoutInfo.editable;
            this.$statusbar = context.layoutInfo.statusbar;
            this.options = context.options;
            this.isFollowing = false;
            this.followScroll = this.followScroll.bind(this);
        }
        Toolbar.prototype.shouldInitialize = function () {
            return !this.options.airMode;
        };
        Toolbar.prototype.initialize = function () {
            var _this = this;
            this.options.toolbar = this.options.toolbar || [];
            if (!this.options.toolbar.length) {
                this.$toolbar.hide();
            }
            else {
                this.context.invoke('buttons.build', this.$toolbar, this.options.toolbar);
            }
            if (this.options.toolbarContainer) {
                this.$toolbar.appendTo(this.options.toolbarContainer);
            }
            this.changeContainer(false);
            this.$note.on('summernote.keyup summernote.mouseup summernote.change', function () {
                _this.context.invoke('buttons.updateCurrentStyle');
            });
            this.context.invoke('buttons.updateCurrentStyle');
            if (this.options.followingToolbar) {
                this.$window.on('scroll resize', this.followScroll);
            }
        };
        Toolbar.prototype.destroy = function () {
            this.$toolbar.children().remove();
            if (this.options.followingToolbar) {
                this.$window.off('scroll resize', this.followScroll);
            }
        };
        Toolbar.prototype.followScroll = function () {
            if (this.$editor.hasClass('fullscreen')) {
                return false;
            }
            var editorHeight = this.$editor.outerHeight();
            var editorWidth = this.$editor.width();
            var toolbarHeight = this.$toolbar.height();
            var statusbarHeight = this.$statusbar.height();
            // check if the web app is currently using another static bar
            var otherBarHeight = 0;
            if (this.options.otherStaticBar) {
                otherBarHeight = $$1(this.options.otherStaticBar).outerHeight();
            }
            var currentOffset = this.$document.scrollTop();
            var editorOffsetTop = this.$editor.offset().top;
            var editorOffsetBottom = editorOffsetTop + editorHeight;
            var activateOffset = editorOffsetTop - otherBarHeight;
            var deactivateOffsetBottom = editorOffsetBottom - otherBarHeight - toolbarHeight - statusbarHeight;
            if (!this.isFollowing &&
                (currentOffset > activateOffset) && (currentOffset < deactivateOffsetBottom - toolbarHeight)) {
                this.isFollowing = true;
                this.$toolbar.css({
                    position: 'fixed',
                    top: otherBarHeight,
                    width: editorWidth
                });
                this.$editable.css({
                    marginTop: this.$toolbar.height() + 5
                });
            }
            else if (this.isFollowing &&
                ((currentOffset < activateOffset) || (currentOffset > deactivateOffsetBottom))) {
                this.isFollowing = false;
                this.$toolbar.css({
                    position: 'relative',
                    top: 0,
                    width: '100%'
                });
                this.$editable.css({
                    marginTop: ''
                });
            }
        };
        Toolbar.prototype.changeContainer = function (isFullscreen) {
            if (isFullscreen) {
                this.$toolbar.prependTo(this.$editor);
            }
            else {
                if (this.options.toolbarContainer) {
                    this.$toolbar.appendTo(this.options.toolbarContainer);
                }
            }
            this.followScroll();
        };
        Toolbar.prototype.updateFullscreen = function (isFullscreen) {
            this.ui.toggleBtnActive(this.$toolbar.find('.btn-fullscreen'), isFullscreen);
            this.changeContainer(isFullscreen);
        };
        Toolbar.prototype.updateCodeview = function (isCodeview) {
            this.ui.toggleBtnActive(this.$toolbar.find('.btn-codeview'), isCodeview);
            if (isCodeview) {
                this.deactivate();
            }
            else {
                this.activate();
            }
        };
        Toolbar.prototype.activate = function (isIncludeCodeview) {
            var $btn = this.$toolbar.find('button');
            if (!isIncludeCodeview) {
                $btn = $btn.not('.btn-codeview');
            }
            this.ui.toggleBtn($btn, true);
        };
        Toolbar.prototype.deactivate = function (isIncludeCodeview) {
            var $btn = this.$toolbar.find('button');
            if (!isIncludeCodeview) {
                $btn = $btn.not('.btn-codeview');
            }
            this.ui.toggleBtn($btn, false);
        };
        return Toolbar;
    }());
  
    var LinkDialog = /** @class */ (function () {
        function LinkDialog(context) {
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.$body = $$1(document.body);
            this.$editor = context.layoutInfo.editor;
            this.options = context.options;
            this.lang = this.options.langInfo;
            context.memo('help.linkDialog.show', this.options.langInfo.help['linkDialog.show']);
        }
        LinkDialog.prototype.initialize = function () {
            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
            var body = [
                '<div class="form-group note-form-group">',
                "<label class=\"note-form-label\">" + this.lang.link.textToDisplay + "</label>",
                '<input class="note-link-text form-control note-form-control note-input" type="text" />',
                '</div>',
                '<div class="form-group note-form-group">',
                "<label class=\"note-form-label\">" + this.lang.link.url + "</label>",
                '<input class="note-link-url form-control note-form-control note-input" type="text" value="http://" />',
                '</div>',
                !this.options.disableLinkTarget
                    ? $$1('<div/>').append(this.ui.checkbox({
                        className: 'sn-checkbox-open-in-new-window',
                        text: this.lang.link.openInNewWindow,
                        checked: true
                    }).render()).html()
                    : '',
            ].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-link-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"" + buttonClass + "\" value=\"" + this.lang.link.insert + "\" disabled>";
            this.$dialog = this.ui.dialog({
                className: 'link-dialog',
                title: this.lang.link.insert,
                fade: this.options.dialogsFade,
                body: body,
                footer: footer
            }).render().appendTo($container);
        };
        LinkDialog.prototype.destroy = function () {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
        };
        LinkDialog.prototype.bindEnterKey = function ($input, $btn) {
            $input.on('keypress', function (event) {
                if (event.keyCode === key.code.ENTER) {
                    event.preventDefault();
                    $btn.trigger('click');
                }
            });
        };
        /**
         * toggle update button
         */
        LinkDialog.prototype.toggleLinkBtn = function ($linkBtn, $linkText, $linkUrl) {
            this.ui.toggleBtn($linkBtn, $linkText.val() && $linkUrl.val());
        };
        /**
         * Show link dialog and set event handlers on dialog controls.
         *
         * @param {Object} linkInfo
         * @return {Promise}
         */
        LinkDialog.prototype.showLinkDialog = function (linkInfo) {
            var _this = this;
            return $$1.Deferred(function (deferred) {
                var $linkText = _this.$dialog.find('.note-link-text');
                var $linkUrl = _this.$dialog.find('.note-link-url');
                var $linkBtn = _this.$dialog.find('.note-link-btn');
                var $openInNewWindow = _this.$dialog
                    .find('.sn-checkbox-open-in-new-window input[type=checkbox]');
                _this.ui.onDialogShown(_this.$dialog, function () {
                    _this.context.triggerEvent('dialog.shown');
                    // If no url was given and given text is valid URL then copy that into URL Field
                    if (!linkInfo.url && func.isValidUrl(linkInfo.text)) {
                        linkInfo.url = linkInfo.text;
                    }
                    $linkText.on('input paste propertychange', function () {
                        // If linktext was modified by input events,
                        // cloning text from linkUrl will be stopped.
                        linkInfo.text = $linkText.val();
                        _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                    }).val(linkInfo.text);
                    $linkUrl.on('input paste propertychange', function () {
                        // Display same text on `Text to display` as default
                        // when linktext has no text
                        if (!linkInfo.text) {
                            $linkText.val($linkUrl.val());
                        }
                        _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                    }).val(linkInfo.url);
                    if (!env.isSupportTouch) {
                        $linkUrl.trigger('focus');
                    }
                    _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                    _this.bindEnterKey($linkUrl, $linkBtn);
                    _this.bindEnterKey($linkText, $linkBtn);
                    var isNewWindowChecked = linkInfo.isNewWindow !== undefined
                        ? linkInfo.isNewWindow : _this.context.options.linkTargetBlank;
                    $openInNewWindow.prop('checked', isNewWindowChecked);
                    $linkBtn.one('click', function (event) {
                        event.preventDefault();
                        deferred.resolve({
                            range: linkInfo.range,
                            url: $linkUrl.val(),
                            text: $linkText.val(),
                            isNewWindow: $openInNewWindow.is(':checked')
                        });
                        _this.ui.hideDialog(_this.$dialog);
                    });
                });
                _this.ui.onDialogHidden(_this.$dialog, function () {
                    // detach events
                    $linkText.off();
                    $linkUrl.off();
                    $linkBtn.off();
                    if (deferred.state() === 'pending') {
                        deferred.reject();
                    }
                });
                _this.ui.showDialog(_this.$dialog);
            }).promise();
        };
        /**
         * @param {Object} layoutInfo
         */
        LinkDialog.prototype.show = function () {
            var _this = this;
            var linkInfo = this.context.invoke('editor.getLinkInfo');
            this.context.invoke('editor.saveRange');
            this.showLinkDialog(linkInfo).then(function (linkInfo) {
                _this.context.invoke('editor.restoreRange');
                _this.context.invoke('editor.createLink', linkInfo);
            }).fail(function () {
                _this.context.invoke('editor.restoreRange');
            });
        };
        return LinkDialog;
    }());
  
    var LinkPopover = /** @class */ (function () {
        function LinkPopover(context) {
            var _this = this;
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.options = context.options;
            this.events = {
                'summernote.keyup summernote.mouseup summernote.change summernote.scroll': function () {
                    _this.update();
                },
                'summernote.disable summernote.dialog.shown': function () {
                    _this.hide();
                }
            };
        }
        LinkPopover.prototype.shouldInitialize = function () {
            return !lists.isEmpty(this.options.popover.link);
        };
        LinkPopover.prototype.initialize = function () {
            this.$popover = this.ui.popover({
                className: 'note-link-popover',
                callback: function ($node) {
                    var $content = $node.find('.popover-content,.note-popover-content');
                    $content.prepend('<span><a target="_blank"></a>&nbsp;</span>');
                }
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.link);
        };
        LinkPopover.prototype.destroy = function () {
            this.$popover.remove();
        };
        LinkPopover.prototype.update = function () {
            // Prevent focusing on editable when invoke('code') is executed
            if (!this.context.invoke('editor.hasFocus')) {
                this.hide();
                return;
            }
            var rng = this.context.invoke('editor.getLastRange');
            if (rng.isCollapsed() && rng.isOnAnchor()) {
                var anchor = dom.ancestor(rng.sc, dom.isAnchor);
                var href = $$1(anchor).attr('href');
                this.$popover.find('a').attr('href', href).html(href);
                var pos = dom.posFromPlaceholder(anchor);
                this.$popover.css({
                    display: 'block',
                    left: pos.left,
                    top: pos.top
                });
            }
            else {
                this.hide();
            }
        };
        LinkPopover.prototype.hide = function () {
            this.$popover.hide();
        };
        return LinkPopover;
    }());
  
    var ImageDialog = /** @class */ (function () {
        function ImageDialog(context) {
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.$body = $$1(document.body);
            this.$editor = context.layoutInfo.editor;
            this.options = context.options;
            this.lang = this.options.langInfo;
        }
        ImageDialog.prototype.initialize = function () {
            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
            var imageLimitation = '';
            if (this.options.maximumImageFileSize) {
                var unit = Math.floor(Math.log(this.options.maximumImageFileSize) / Math.log(1024));
                var readableSize = (this.options.maximumImageFileSize / Math.pow(1024, unit)).toFixed(2) * 1 +
                    ' ' + ' KMGTP'[unit] + 'B';
                imageLimitation = "<small>" + (this.lang.image.maximumFileSize + ' : ' + readableSize) + "</small>";
            }
            var body = [
                '<div class="form-group note-form-group note-group-select-from-files">',
                '<label class="note-form-label">' + this.lang.image.selectFromFiles + '</label>',
                '<input class="note-image-input form-control-file note-form-control note-input" ',
                ' type="file" name="files" accept="image/*" multiple="multiple" />',
                imageLimitation,
                '</div>',
                '<div class="form-group note-group-image-url" style="overflow:auto;">',
                '<label class="note-form-label">' + this.lang.image.url + '</label>',
                '<input class="note-image-url form-control note-form-control note-input ',
                ' col-md-12" type="text" />',
                '</div>',
            ].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-image-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"" + buttonClass + "\" value=\"" + this.lang.image.insert + "\" disabled>";
            this.$dialog = this.ui.dialog({
                title: this.lang.image.insert,
                fade: this.options.dialogsFade,
                body: body,
                footer: footer
            }).render().appendTo($container);
        };
        ImageDialog.prototype.destroy = function () {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
        };
        ImageDialog.prototype.bindEnterKey = function ($input, $btn) {
            $input.on('keypress', function (event) {
                if (event.keyCode === key.code.ENTER) {
                    event.preventDefault();
                    $btn.trigger('click');
                }
            });
        };
        ImageDialog.prototype.show = function () {
            var _this = this;
            this.context.invoke('editor.saveRange');
            this.showImageDialog().then(function (data) {
                // [workaround] hide dialog before restore range for IE range focus
                _this.ui.hideDialog(_this.$dialog);
                _this.context.invoke('editor.restoreRange');
                if (typeof data === 'string') { // image url
                    // If onImageLinkInsert set,
                    if (_this.options.callbacks.onImageLinkInsert) {
                        _this.context.triggerEvent('image.link.insert', data);
                    }
                    else {
                        _this.context.invoke('editor.insertImage', data);
                    }
                }
                else { // array of files
                    _this.context.invoke('editor.insertImagesOrCallback', data);
                }
            }).fail(function () {
                _this.context.invoke('editor.restoreRange');
            });
        };
        /**
         * show image dialog
         *
         * @param {jQuery} $dialog
         * @return {Promise}
         */
        ImageDialog.prototype.showImageDialog = function () {
            var _this = this;
            return $$1.Deferred(function (deferred) {
                var $imageInput = _this.$dialog.find('.note-image-input');
                var $imageUrl = _this.$dialog.find('.note-image-url');
                var $imageBtn = _this.$dialog.find('.note-image-btn');
                _this.ui.onDialogShown(_this.$dialog, function () {
                    _this.context.triggerEvent('dialog.shown');
                    // Cloning imageInput to clear element.
                    $imageInput.replaceWith($imageInput.clone().on('change', function (event) {
                        deferred.resolve(event.target.files || event.target.value);
                    }).val(''));
                    $imageUrl.on('input paste propertychange', function () {
                        _this.ui.toggleBtn($imageBtn, $imageUrl.val());
                    }).val('');
                    if (!env.isSupportTouch) {
                        $imageUrl.trigger('focus');
                    }
                    $imageBtn.click(function (event) {
                        event.preventDefault();
                        deferred.resolve($imageUrl.val());
                    });
                    _this.bindEnterKey($imageUrl, $imageBtn);
                });
                _this.ui.onDialogHidden(_this.$dialog, function () {
                    $imageInput.off();
                    $imageUrl.off();
                    $imageBtn.off();
                    if (deferred.state() === 'pending') {
                        deferred.reject();
                    }
                });
                _this.ui.showDialog(_this.$dialog);
            });
        };
        return ImageDialog;
    }());
  
    /**
     * Image popover module
     *  mouse events that show/hide popover will be handled by Handle.js.
     *  Handle.js will receive the events and invoke 'imagePopover.update'.
     */
    var ImagePopover = /** @class */ (function () {
        function ImagePopover(context) {
            var _this = this;
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.editable = context.layoutInfo.editable[0];
            this.options = context.options;
            this.events = {
                'summernote.disable': function () {
                    _this.hide();
                }
            };
        }
        ImagePopover.prototype.shouldInitialize = function () {
            return !lists.isEmpty(this.options.popover.image);
        };
        ImagePopover.prototype.initialize = function () {
            this.$popover = this.ui.popover({
                className: 'note-image-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.image);
        };
        ImagePopover.prototype.destroy = function () {
            this.$popover.remove();
        };
        ImagePopover.prototype.update = function (target, event) {
            if (dom.isImg(target)) {
                var pos = dom.posFromPlaceholder(target);
                var posEditor = dom.posFromPlaceholder(this.editable);
                this.$popover.css({
                    display: 'block',
                    left: this.options.popatmouse ? event.pageX - 20 : pos.left,
                    top: this.options.popatmouse ? event.pageY : Math.min(pos.top, posEditor.top)
                });
            }
            else {
                this.hide();
            }
        };
        ImagePopover.prototype.hide = function () {
            this.$popover.hide();
        };
        return ImagePopover;
    }());
  
    var TablePopover = /** @class */ (function () {
        function TablePopover(context) {
            var _this = this;
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.options = context.options;
            this.events = {
                'summernote.mousedown': function (we, e) {
                    _this.update(e.target);
                },
                'summernote.keyup summernote.scroll summernote.change': function () {
                    _this.update();
                },
                'summernote.disable': function () {
                    _this.hide();
                }
            };
        }
        TablePopover.prototype.shouldInitialize = function () {
            return !lists.isEmpty(this.options.popover.table);
        };
        TablePopover.prototype.initialize = function () {
            this.$popover = this.ui.popover({
                className: 'note-table-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.table);
            // [workaround] Disable Firefox's default table editor
            if (env.isFF) {
                document.execCommand('enableInlineTableEditing', false, false);
            }
        };
        TablePopover.prototype.destroy = function () {
            this.$popover.remove();
        };
        TablePopover.prototype.update = function (target) {
            if (this.context.isDisabled()) {
                return false;
            }
            var isCell = dom.isCell(target);
            if (isCell) {
                var pos = dom.posFromPlaceholder(target);
                this.$popover.css({
                    display: 'block',
                    left: pos.left,
                    top: pos.top
                });
            }
            else {
                this.hide();
            }
            return isCell;
        };
        TablePopover.prototype.hide = function () {
            this.$popover.hide();
        };
        return TablePopover;
    }());
  
    var VideoDialog = /** @class */ (function () {
        function VideoDialog(context) {
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.$body = $$1(document.body);
            this.$editor = context.layoutInfo.editor;
            this.options = context.options;
            this.lang = this.options.langInfo;
        }
        VideoDialog.prototype.initialize = function () {
            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
            var body = [
                '<div class="form-group note-form-group row-fluid">',
                "<label class=\"note-form-label\">" + this.lang.video.url + " <small class=\"text-muted\">" + this.lang.video.providers + "</small></label>",
                '<input class="note-video-url form-control note-form-control note-input" type="text" />',
                '</div>',
            ].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-video-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"" + buttonClass + "\" value=\"" + this.lang.video.insert + "\" disabled>";
            this.$dialog = this.ui.dialog({
                title: this.lang.video.insert,
                fade: this.options.dialogsFade,
                body: body,
                footer: footer
            }).render().appendTo($container);
        };
        VideoDialog.prototype.destroy = function () {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
        };
        VideoDialog.prototype.bindEnterKey = function ($input, $btn) {
            $input.on('keypress', function (event) {
                if (event.keyCode === key.code.ENTER) {
                    event.preventDefault();
                    $btn.trigger('click');
                }
            });
        };
        VideoDialog.prototype.createVideoNode = function (url) {
            // video url patterns(youtube, instagram, vimeo, dailymotion, youku, mp4, ogg, webm)
            var ytRegExp = /\/\/(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w|-]{11})(?:(?:[\?&]t=)(\S+))?$/;
            var ytRegExpForStart = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/;
            var ytMatch = url.match(ytRegExp);
            var igRegExp = /(?:www\.|\/\/)instagram\.com\/p\/(.[a-zA-Z0-9_-]*)/;
            var igMatch = url.match(igRegExp);
            var vRegExp = /\/\/vine\.co\/v\/([a-zA-Z0-9]+)/;
            var vMatch = url.match(vRegExp);
            var vimRegExp = /\/\/(player\.)?vimeo\.com\/([a-z]*\/)*(\d+)[?]?.*/;
            var vimMatch = url.match(vimRegExp);
            var dmRegExp = /.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
            var dmMatch = url.match(dmRegExp);
            var youkuRegExp = /\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/;
            var youkuMatch = url.match(youkuRegExp);
            var qqRegExp = /\/\/v\.qq\.com.*?vid=(.+)/;
            var qqMatch = url.match(qqRegExp);
            var qqRegExp2 = /\/\/v\.qq\.com\/x?\/?(page|cover).*?\/([^\/]+)\.html\??.*/;
            var qqMatch2 = url.match(qqRegExp2);
            var mp4RegExp = /^.+.(mp4|m4v)$/;
            var mp4Match = url.match(mp4RegExp);
            var oggRegExp = /^.+.(ogg|ogv)$/;
            var oggMatch = url.match(oggRegExp);
            var webmRegExp = /^.+.(webm)$/;
            var webmMatch = url.match(webmRegExp);
            var fbRegExp = /(?:www\.|\/\/)facebook\.com\/([^\/]+)\/videos\/([0-9]+)/;
            var fbMatch = url.match(fbRegExp);
            var $video;
            if (ytMatch && ytMatch[1].length === 11) {
                var youtubeId = ytMatch[1];
                var start = 0;
                if (typeof ytMatch[2] !== 'undefined') {
                    var ytMatchForStart = ytMatch[2].match(ytRegExpForStart);
                    if (ytMatchForStart) {
                        for (var n = [3600, 60, 1], i = 0, r = n.length; i < r; i++) {
                            start += (typeof ytMatchForStart[i + 1] !== 'undefined' ? n[i] * parseInt(ytMatchForStart[i + 1], 10) : 0);
                        }
                    }
                }
                $video = $$1('<iframe>')
                    .attr('frameborder', 0)
                    .attr('src', '//www.youtube.com/embed/' + youtubeId + (start > 0 ? '?start=' + start : ''))
                    .attr('width', '640').attr('height', '360');
            }
            else if (igMatch && igMatch[0].length) {
                $video = $$1('<iframe>')
                    .attr('frameborder', 0)
                    .attr('src', 'https://instagram.com/p/' + igMatch[1] + '/embed/')
                    .attr('width', '612').attr('height', '710')
                    .attr('scrolling', 'no')
                    .attr('allowtransparency', 'true');
            }
            else if (vMatch && vMatch[0].length) {
                $video = $$1('<iframe>')
                    .attr('frameborder', 0)
                    .attr('src', vMatch[0] + '/embed/simple')
                    .attr('width', '600').attr('height', '600')
                    .attr('class', 'vine-embed');
            }
            else if (vimMatch && vimMatch[3].length) {
                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>')
                    .attr('frameborder', 0)
                    .attr('src', '//player.vimeo.com/video/' + vimMatch[3])
                    .attr('width', '640').attr('height', '360');
            }
            else if (dmMatch && dmMatch[2].length) {
                $video = $$1('<iframe>')
                    .attr('frameborder', 0)
                    .attr('src', '//www.dailymotion.com/embed/video/' + dmMatch[2])
                    .attr('width', '640').attr('height', '360');
            }
            else if (youkuMatch && youkuMatch[1].length) {
                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>')
                    .attr('frameborder', 0)
                    .attr('height', '498')
                    .attr('width', '510')
                    .attr('src', '//player.youku.com/embed/' + youkuMatch[1]);
            }
            else if ((qqMatch && qqMatch[1].length) || (qqMatch2 && qqMatch2[2].length)) {
                var vid = ((qqMatch && qqMatch[1].length) ? qqMatch[1] : qqMatch2[2]);
                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>')
                    .attr('frameborder', 0)
                    .attr('height', '310')
                    .attr('width', '500')
                    .attr('src', 'http://v.qq.com/iframe/player.html?vid=' + vid + '&amp;auto=0');
            }
            else if (mp4Match || oggMatch || webmMatch) {
                $video = $$1('<video controls>')
                    .attr('src', url)
                    .attr('width', '640').attr('height', '360');
            }
            else if (fbMatch && fbMatch[0].length) {
                $video = $$1('<iframe>')
                    .attr('frameborder', 0)
                    .attr('src', 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(fbMatch[0]) + '&show_text=0&width=560')
                    .attr('width', '560').attr('height', '301')
                    .attr('scrolling', 'no')
                    .attr('allowtransparency', 'true');
            }
            else {
                // this is not a known video link. Now what, Cat? Now what?
                return false;
            }
            $video.addClass('note-video-clip');
            return $video[0];
        };
        VideoDialog.prototype.show = function () {
            var _this = this;
            var text = this.context.invoke('editor.getSelectedText');
            this.context.invoke('editor.saveRange');
            this.showVideoDialog(text).then(function (url) {
                // [workaround] hide dialog before restore range for IE range focus
                _this.ui.hideDialog(_this.$dialog);
                _this.context.invoke('editor.restoreRange');
                // build node
                var $node = _this.createVideoNode(url);
                if ($node) {
                    // insert video node
                    _this.context.invoke('editor.insertNode', $node);
                }
            }).fail(function () {
                _this.context.invoke('editor.restoreRange');
            });
        };
        /**
         * show image dialog
         *
         * @param {jQuery} $dialog
         * @return {Promise}
         */
        VideoDialog.prototype.showVideoDialog = function (text) {
            var _this = this;
            return $$1.Deferred(function (deferred) {
                var $videoUrl = _this.$dialog.find('.note-video-url');
                var $videoBtn = _this.$dialog.find('.note-video-btn');
                _this.ui.onDialogShown(_this.$dialog, function () {
                    _this.context.triggerEvent('dialog.shown');
                    $videoUrl.on('input paste propertychange', function () {
                        _this.ui.toggleBtn($videoBtn, $videoUrl.val());
                    });
                    if (!env.isSupportTouch) {
                        $videoUrl.trigger('focus');
                    }
                    $videoBtn.click(function (event) {
                        event.preventDefault();
                        deferred.resolve($videoUrl.val());
                    });
                    _this.bindEnterKey($videoUrl, $videoBtn);
                });
                _this.ui.onDialogHidden(_this.$dialog, function () {
                    $videoUrl.off();
                    $videoBtn.off();
                    if (deferred.state() === 'pending') {
                        deferred.reject();
                    }
                });
                _this.ui.showDialog(_this.$dialog);
            });
        };
        return VideoDialog;
    }());
  
    var HelpDialog = /** @class */ (function () {
        function HelpDialog(context) {
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.$body = $$1(document.body);
            this.$editor = context.layoutInfo.editor;
            this.options = context.options;
            this.lang = this.options.langInfo;
        }
        HelpDialog.prototype.initialize = function () {
            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
            var body = [
                '<p class="text-center">',
                '<a href="http://summernote.org/" target="_blank">Summernote 0.8.12</a> · ',
                '<a href="https://github.com/summernote/summernote" target="_blank">Project</a> · ',
                '<a href="https://github.com/summernote/summernote/issues" target="_blank">Issues</a>',
                '</p>',
            ].join('');
            this.$dialog = this.ui.dialog({
                title: this.lang.options.help,
                fade: this.options.dialogsFade,
                body: this.createShortcutList(),
                footer: body,
                callback: function ($node) {
                    $node.find('.modal-body,.note-modal-body').css({
                        'max-height': 300,
                        'overflow': 'scroll'
                    });
                }
            }).render().appendTo($container);
        };
        HelpDialog.prototype.destroy = function () {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
        };
        HelpDialog.prototype.createShortcutList = function () {
            var _this = this;
            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
            return Object.keys(keyMap).map(function (key) {
                var command = keyMap[key];
                var $row = $$1('<div><div class="help-list-item"/></div>');
                $row.append($$1('<label><kbd>' + key + '</kdb></label>').css({
                    'width': 180,
                    'margin-right': 10
                })).append($$1('<span/>').html(_this.context.memo('help.' + command) || command));
                return $row.html();
            }).join('');
        };
        /**
         * show help dialog
         *
         * @return {Promise}
         */
        HelpDialog.prototype.showHelpDialog = function () {
            var _this = this;
            return $$1.Deferred(function (deferred) {
                _this.ui.onDialogShown(_this.$dialog, function () {
                    _this.context.triggerEvent('dialog.shown');
                    deferred.resolve();
                });
                _this.ui.showDialog(_this.$dialog);
            }).promise();
        };
        HelpDialog.prototype.show = function () {
            var _this = this;
            this.context.invoke('editor.saveRange');
            this.showHelpDialog().then(function () {
                _this.context.invoke('editor.restoreRange');
            });
        };
        return HelpDialog;
    }());
  
    var AIR_MODE_POPOVER_X_OFFSET = 20;
    var AirPopover = /** @class */ (function () {
        function AirPopover(context) {
            var _this = this;
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.options = context.options;
            this.events = {
                'summernote.keyup summernote.mouseup summernote.scroll': function () {
                    _this.update();
                },
                'summernote.disable summernote.change summernote.dialog.shown': function () {
                    _this.hide();
                },
                'summernote.focusout': function (we, e) {
                    // [workaround] Firefox doesn't support relatedTarget on focusout
                    //  - Ignore hide action on focus out in FF.
                    if (env.isFF) {
                        return;
                    }
                    if (!e.relatedTarget || !dom.ancestor(e.relatedTarget, func.eq(_this.$popover[0]))) {
                        _this.hide();
                    }
                }
            };
        }
        AirPopover.prototype.shouldInitialize = function () {
            return this.options.airMode && !lists.isEmpty(this.options.popover.air);
        };
        AirPopover.prototype.initialize = function () {
            this.$popover = this.ui.popover({
                className: 'note-air-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.air);
        };
        AirPopover.prototype.destroy = function () {
            this.$popover.remove();
        };
        AirPopover.prototype.update = function () {
            var styleInfo = this.context.invoke('editor.currentStyle');
            if (styleInfo.range && !styleInfo.range.isCollapsed()) {
                var rect = lists.last(styleInfo.range.getClientRects());
                if (rect) {
                    var bnd = func.rect2bnd(rect);
                    this.$popover.css({
                        display: 'block',
                        left: Math.max(bnd.left + bnd.width / 2, 0) - AIR_MODE_POPOVER_X_OFFSET,
                        top: bnd.top + bnd.height
                    });
                    this.context.invoke('buttons.updateCurrentStyle', this.$popover);
                }
            }
            else {
                this.hide();
            }
        };
        AirPopover.prototype.hide = function () {
            this.$popover.hide();
        };
        return AirPopover;
    }());
  
    var POPOVER_DIST = 5;
    var HintPopover = /** @class */ (function () {
        function HintPopover(context) {
            var _this = this;
            this.context = context;
            this.ui = $$1.summernote.ui;
            this.$editable = context.layoutInfo.editable;
            this.options = context.options;
            this.hint = this.options.hint || [];
            this.direction = this.options.hintDirection || 'bottom';
            this.hints = Array.isArray(this.hint) ? this.hint : [this.hint];
            this.events = {
                'summernote.keyup': function (we, e) {
                    if (!e.isDefaultPrevented()) {
                        _this.handleKeyup(e);
                    }
                },
                'summernote.keydown': function (we, e) {
                    _this.handleKeydown(e);
                },
                'summernote.disable summernote.dialog.shown': function () {
                    _this.hide();
                }
            };
        }
        HintPopover.prototype.shouldInitialize = function () {
            return this.hints.length > 0;
        };
        HintPopover.prototype.initialize = function () {
            var _this = this;
            this.lastWordRange = null;
            this.$popover = this.ui.popover({
                className: 'note-hint-popover',
                hideArrow: true,
                direction: ''
            }).render().appendTo(this.options.container);
            this.$popover.hide();
            this.$content = this.$popover.find('.popover-content,.note-popover-content');
            this.$content.on('click', '.note-hint-item', function (e) {
                _this.$content.find('.active').removeClass('active');
                $$1(e.currentTarget).addClass('active');
                _this.replace();
            });
        };
        HintPopover.prototype.destroy = function () {
            this.$popover.remove();
        };
        HintPopover.prototype.selectItem = function ($item) {
            this.$content.find('.active').removeClass('active');
            $item.addClass('active');
            this.$content[0].scrollTop = $item[0].offsetTop - (this.$content.innerHeight() / 2);
        };
        HintPopover.prototype.moveDown = function () {
            var $current = this.$content.find('.note-hint-item.active');
            var $next = $current.next();
            if ($next.length) {
                this.selectItem($next);
            }
            else {
                var $nextGroup = $current.parent().next();
                if (!$nextGroup.length) {
                    $nextGroup = this.$content.find('.note-hint-group').first();
                }
                this.selectItem($nextGroup.find('.note-hint-item').first());
            }
        };
        HintPopover.prototype.moveUp = function () {
            var $current = this.$content.find('.note-hint-item.active');
            var $prev = $current.prev();
            if ($prev.length) {
                this.selectItem($prev);
            }
            else {
                var $prevGroup = $current.parent().prev();
                if (!$prevGroup.length) {
                    $prevGroup = this.$content.find('.note-hint-group').last();
                }
                this.selectItem($prevGroup.find('.note-hint-item').last());
            }
        };
        HintPopover.prototype.replace = function () {
            var $item = this.$content.find('.note-hint-item.active');
            if ($item.length) {
                var node = this.nodeFromItem($item);
                // XXX: consider to move codes to editor for recording redo/undo.
                this.lastWordRange.insertNode(node);
                range.createFromNode(node).collapse().select();
                this.lastWordRange = null;
                this.hide();
                this.context.triggerEvent('change', this.$editable.html(), this.$editable[0]);
                this.context.invoke('editor.focus');
            }
        };
        HintPopover.prototype.nodeFromItem = function ($item) {
            var hint = this.hints[$item.data('index')];
            var item = $item.data('item');
            var node = hint.content ? hint.content(item) : item;
            if (typeof node === 'string') {
                node = dom.createText(node);
            }
            return node;
        };
        HintPopover.prototype.createItemTemplates = function (hintIdx, items) {
            var hint = this.hints[hintIdx];
            return items.map(function (item, idx) {
                var $item = $$1('<div class="note-hint-item"/>');
                $item.append(hint.template ? hint.template(item) : item + '');
                $item.data({
                    'index': hintIdx,
                    'item': item
                });
                return $item;
            });
        };
        HintPopover.prototype.handleKeydown = function (e) {
            if (!this.$popover.is(':visible')) {
                return;
            }
            if (e.keyCode === key.code.ENTER) {
                e.preventDefault();
                this.replace();
            }
            else if (e.keyCode === key.code.UP) {
                e.preventDefault();
                this.moveUp();
            }
            else if (e.keyCode === key.code.DOWN) {
                e.preventDefault();
                this.moveDown();
            }
        };
        HintPopover.prototype.searchKeyword = function (index, keyword, callback) {
            var hint = this.hints[index];
            if (hint && hint.match.test(keyword) && hint.search) {
                var matches = hint.match.exec(keyword);
                hint.search(matches[1], callback);
            }
            else {
                callback();
            }
        };
        HintPopover.prototype.createGroup = function (idx, keyword) {
            var _this = this;
            var $group = $$1('<div class="note-hint-group note-hint-group-' + idx + '"/>');
            this.searchKeyword(idx, keyword, function (items) {
                items = items || [];
                if (items.length) {
                    $group.html(_this.createItemTemplates(idx, items));
                    _this.show();
                }
            });
            return $group;
        };
        HintPopover.prototype.handleKeyup = function (e) {
            var _this = this;
            if (!lists.contains([key.code.ENTER, key.code.UP, key.code.DOWN], e.keyCode)) {
                var wordRange = this.context.invoke('editor.getLastRange').getWordRange();
                var keyword_1 = wordRange.toString();
                if (this.hints.length && keyword_1) {
                    this.$content.empty();
                    var bnd = func.rect2bnd(lists.last(wordRange.getClientRects()));
                    if (bnd) {
                        this.$popover.hide();
                        this.lastWordRange = wordRange;
                        this.hints.forEach(function (hint, idx) {
                            if (hint.match.test(keyword_1)) {
                                _this.createGroup(idx, keyword_1).appendTo(_this.$content);
                            }
                        });
                        // select first .note-hint-item
                        this.$content.find('.note-hint-item:first').addClass('active');
                        // set position for popover after group is created
                        if (this.direction === 'top') {
                            this.$popover.css({
                                left: bnd.left,
                                top: bnd.top - this.$popover.outerHeight() - POPOVER_DIST
                            });
                        }
                        else {
                            this.$popover.css({
                                left: bnd.left,
                                top: bnd.top + bnd.height + POPOVER_DIST
                            });
                        }
                    }
                }
                else {
                    this.hide();
                }
            }
        };
        HintPopover.prototype.show = function () {
            this.$popover.show();
        };
        HintPopover.prototype.hide = function () {
            this.$popover.hide();
        };
        return HintPopover;
    }());
  
    $$1.summernote = $$1.extend($$1.summernote, {
        version: '0.8.12',
        plugins: {},
        dom: dom,
        range: range,
        options: {
            langInfo: $$1.summernote.lang['en-US'],
            modules: {
                'editor': Editor,
                'clipboard': Clipboard,
                'dropzone': Dropzone,
                'codeview': CodeView,
                'statusbar': Statusbar,
                'fullscreen': Fullscreen,
                'handle': Handle,
                // FIXME: HintPopover must be front of autolink
                //  - Script error about range when Enter key is pressed on hint popover
                'hintPopover': HintPopover,
                'autoLink': AutoLink,
                'autoSync': AutoSync,
                'autoReplace': AutoReplace,
                'placeholder': Placeholder,
                'buttons': Buttons,
                'toolbar': Toolbar,
                'linkDialog': LinkDialog,
                'linkPopover': LinkPopover,
                'imageDialog': ImageDialog,
                'imagePopover': ImagePopover,
                'tablePopover': TablePopover,
                'videoDialog': VideoDialog,
                'helpDialog': HelpDialog,
                'airPopover': AirPopover
            },
            buttons: {},
            lang: 'en-US',
            followingToolbar: false,
            otherStaticBar: '',
            // toolbar
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['fullscreen', 'codeview', 'help']],
            ],
            // popover
            popatmouse: true,
            popover: {
                image: [
                    ['resize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                    ['float', ['floatLeft', 'floatRight', 'floatNone']],
                    ['remove', ['removeMedia']],
                ],
                link: [
                    ['link', ['linkDialogShow', 'unlink']],
                ],
                table: [
                    ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                    ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
                ],
                air: [
                    ['color', ['color']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['para', ['ul', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture']],
                ]
            },
            // air mode: inline editor
            airMode: false,
            width: null,
            height: null,
            linkTargetBlank: true,
            focus: false,
            tabSize: 4,
            styleWithSpan: true,
            shortcuts: true,
            textareaAutoSync: true,
            hintDirection: 'bottom',
            tooltip: 'auto',
            container: 'body',
            maxTextLength: 0,
            blockquoteBreakingLevel: 2,
            spellCheck: true,
            styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            fontNames: [
                'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New',
                'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande',
                'Tahoma', 'Times New Roman', 'Verdana',
            ],
            fontNamesIgnoreCheck: [],
            fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36'],
            // pallete colors(n x n)
            colors: [
                ['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF'],
                ['#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF'],
                ['#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE'],
                ['#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD'],
                ['#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5'],
                ['#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B'],
                ['#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842'],
                ['#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031'],
            ],
            // http://chir.ag/projects/name-that-color/
            colorsName: [
                ['Black', 'Tundora', 'Dove Gray', 'Star Dust', 'Pale Slate', 'Gallery', 'Alabaster', 'White'],
                ['Red', 'Orange Peel', 'Yellow', 'Green', 'Cyan', 'Blue', 'Electric Violet', 'Magenta'],
                ['Azalea', 'Karry', 'Egg White', 'Zanah', 'Botticelli', 'Tropical Blue', 'Mischka', 'Twilight'],
                ['Tonys Pink', 'Peach Orange', 'Cream Brulee', 'Sprout', 'Casper', 'Perano', 'Cold Purple', 'Careys Pink'],
                ['Mandy', 'Rajah', 'Dandelion', 'Olivine', 'Gulf Stream', 'Viking', 'Blue Marguerite', 'Puce'],
                ['Guardsman Red', 'Fire Bush', 'Golden Dream', 'Chelsea Cucumber', 'Smalt Blue', 'Boston Blue', 'Butterfly Bush', 'Cadillac'],
                ['Sangria', 'Mai Tai', 'Buddha Gold', 'Forest Green', 'Eden', 'Venice Blue', 'Meteorite', 'Claret'],
                ['Rosewood', 'Cinnamon', 'Olive', 'Parsley', 'Tiber', 'Midnight Blue', 'Valentino', 'Loulou'],
            ],
            colorButton: {
                foreColor: '#000000',
                backColor: '#FFFF00'
            },
            lineHeights: ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],
            tableClassName: 'table table-bordered',
            insertTableMaxSize: {
                col: 10,
                row: 10
            },
            dialogsInBody: false,
            dialogsFade: false,
            maximumImageFileSize: null,
            callbacks: {
                onBeforeCommand: null,
                onBlur: null,
                onBlurCodeview: null,
                onChange: null,
                onChangeCodeview: null,
                onDialogShown: null,
                onEnter: null,
                onFocus: null,
                onImageLinkInsert: null,
                onImageUpload: null,
                onImageUploadError: null,
                onInit: null,
                onKeydown: null,
                onKeyup: null,
                onMousedown: null,
                onMouseup: null,
                onPaste: null,
                onScroll: null
            },
            codemirror: {
                mode: 'text/html',
                htmlMode: true,
                lineNumbers: true
            },
            codeviewFilter: false,
            codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml)[^>]*?>/gi,
            codeviewIframeFilter: true,
            codeviewIframeWhitelistSrc: [],
            codeviewIframeWhitelistSrcBase: [
                'www.youtube.com',
                'www.youtube-nocookie.com',
                'www.facebook.com',
                'vine.co',
                'instagram.com',
                'player.vimeo.com',
                'www.dailymotion.com',
                'player.youku.com',
                'v.qq.com',
            ],
            keyMap: {
                pc: {
                    'ENTER': 'insertParagraph',
                    'CTRL+Z': 'undo',
                    'CTRL+Y': 'redo',
                    'TAB': 'tab',
                    'SHIFT+TAB': 'untab',
                    'CTRL+B': 'bold',
                    'CTRL+I': 'italic',
                    'CTRL+U': 'underline',
                    'CTRL+SHIFT+S': 'strikethrough',
                    'CTRL+BACKSLASH': 'removeFormat',
                    'CTRL+SHIFT+L': 'justifyLeft',
                    'CTRL+SHIFT+E': 'justifyCenter',
                    'CTRL+SHIFT+R': 'justifyRight',
                    'CTRL+SHIFT+J': 'justifyFull',
                    'CTRL+SHIFT+NUM7': 'insertUnorderedList',
                    'CTRL+SHIFT+NUM8': 'insertOrderedList',
                    'CTRL+LEFTBRACKET': 'outdent',
                    'CTRL+RIGHTBRACKET': 'indent',
                    'CTRL+NUM0': 'formatPara',
                    'CTRL+NUM1': 'formatH1',
                    'CTRL+NUM2': 'formatH2',
                    'CTRL+NUM3': 'formatH3',
                    'CTRL+NUM4': 'formatH4',
                    'CTRL+NUM5': 'formatH5',
                    'CTRL+NUM6': 'formatH6',
                    'CTRL+ENTER': 'insertHorizontalRule',
                    'CTRL+K': 'linkDialog.show'
                },
                mac: {
                    'ENTER': 'insertParagraph',
                    'CMD+Z': 'undo',
                    'CMD+SHIFT+Z': 'redo',
                    'TAB': 'tab',
                    'SHIFT+TAB': 'untab',
                    'CMD+B': 'bold',
                    'CMD+I': 'italic',
                    'CMD+U': 'underline',
                    'CMD+SHIFT+S': 'strikethrough',
                    'CMD+BACKSLASH': 'removeFormat',
                    'CMD+SHIFT+L': 'justifyLeft',
                    'CMD+SHIFT+E': 'justifyCenter',
                    'CMD+SHIFT+R': 'justifyRight',
                    'CMD+SHIFT+J': 'justifyFull',
                    'CMD+SHIFT+NUM7': 'insertUnorderedList',
                    'CMD+SHIFT+NUM8': 'insertOrderedList',
                    'CMD+LEFTBRACKET': 'outdent',
                    'CMD+RIGHTBRACKET': 'indent',
                    'CMD+NUM0': 'formatPara',
                    'CMD+NUM1': 'formatH1',
                    'CMD+NUM2': 'formatH2',
                    'CMD+NUM3': 'formatH3',
                    'CMD+NUM4': 'formatH4',
                    'CMD+NUM5': 'formatH5',
                    'CMD+NUM6': 'formatH6',
                    'CMD+ENTER': 'insertHorizontalRule',
                    'CMD+K': 'linkDialog.show'
                }
            },
            icons: {
                'align': 'note-icon-align',
                'alignCenter': 'note-icon-align-center',
                'alignJustify': 'note-icon-align-justify',
                'alignLeft': 'note-icon-align-left',
                'alignRight': 'note-icon-align-right',
                'rowBelow': 'note-icon-row-below',
                'colBefore': 'note-icon-col-before',
                'colAfter': 'note-icon-col-after',
                'rowAbove': 'note-icon-row-above',
                'rowRemove': 'note-icon-row-remove',
                'colRemove': 'note-icon-col-remove',
                'indent': 'note-icon-align-indent',
                'outdent': 'note-icon-align-outdent',
                'arrowsAlt': 'note-icon-arrows-alt',
                'bold': 'note-icon-bold',
                'caret': 'note-icon-caret',
                'circle': 'note-icon-circle',
                'close': 'note-icon-close',
                'code': 'note-icon-code',
                'eraser': 'note-icon-eraser',
                'floatLeft': 'note-icon-float-left',
                'floatRight': 'note-icon-float-right',
                'font': 'note-icon-font',
                'frame': 'note-icon-frame',
                'italic': 'note-icon-italic',
                'link': 'note-icon-link',
                'unlink': 'note-icon-chain-broken',
                'magic': 'note-icon-magic',
                'menuCheck': 'note-icon-menu-check',
                'minus': 'note-icon-minus',
                'orderedlist': 'note-icon-orderedlist',
                'pencil': 'note-icon-pencil',
                'picture': 'note-icon-picture',
                'question': 'note-icon-question',
                'redo': 'note-icon-redo',
                'rollback': 'note-icon-rollback',
                'square': 'note-icon-square',
                'strikethrough': 'note-icon-strikethrough',
                'subscript': 'note-icon-subscript',
                'superscript': 'note-icon-superscript',
                'table': 'note-icon-table',
                'textHeight': 'note-icon-text-height',
                'trash': 'note-icon-trash',
                'underline': 'note-icon-underline',
                'undo': 'note-icon-undo',
                'unorderedlist': 'note-icon-unorderedlist',
                'video': 'note-icon-video'
            }
        }
    });
  
    $$1.summernote = $$1.extend($$1.summernote, {
        ui: ui
    });
  
  }));
  //# sourceMappingURL=summernote.js.map
/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

/*$(document).ready(function () {

    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = $("#wrapper").height() - 61;
        $(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeight = $('nav.navbar-default').height();
        var wrapperHeight = $('#page-wrapper').height();

        //$(".sidebar-panel").css("min-height", wrapperHeigh - 61 + "px");

        if(navbarHeight > wrapperHeight){
            $('#page-wrapper').css("min-height", navbarHeight + "px");
        }

        if(navbarHeight < wrapperHeight){
            $('#page-wrapper').css("min-height", $(window).height()  + "px");
        }

        if ($('body').hasClass('fixed-nav')) {
            if (navbarHeight > wrapperHeight) {
                $('#page-wrapper').css("min-height", navbarHeight + "px");
            } else {
                $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
            }
        }

    }


    $(window).bind("load resize scroll", function() {
        if(!$("body").hasClass('body-small')) {
            fix_height();
        }
    });

    // Move right sidebar top after scroll
    $(window).scroll(function(){
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav') ) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });


    setTimeout(function(){
        fix_height();
    })
});*/

// Minimalize menu when screen is less than 768px
$(window).bind("load resize", function () {
    if ($(document).width() < 992) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }
});

/*!
 * iCheck v1.0.2, http://git.io/arlzeA
 * ===================================
 * Powerful jQuery and Zepto plugin for checkboxes and radio buttons customization
 *
 * (c) 2013 Damir Sultanov, http://fronteed.com
 * MIT Licensed
 */

(function($) {

  // Cached vars
  var _iCheck = 'iCheck',
    _iCheckHelper = _iCheck + '-helper',
    _checkbox = 'checkbox',
    _radio = 'radio',
    _checked = 'checked',
    _unchecked = 'un' + _checked,
    _disabled = 'disabled',a
    _determinate = 'determinate',
    _indeterminate = 'in' + _determinate,
    _update = 'update',
    _type = 'type',
    _click = 'click',
    _touch = 'touchbegin.i touchend.i',
    _add = 'addClass',
    _remove = 'removeClass',
    _callback = 'trigger',
    _label = 'label',
    _cursor = 'cursor',
    _mobile = /ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);

  // Plugin init
  $.fn[_iCheck] = function(options, fire) {

    // Walker
    var handle = 'input[type="' + _checkbox + '"], input[type="' + _radio + '"]',
      stack = $(),
      walker = function(object) {
        object.each(function() {
          var self = $(this);

          if (self.is(handle)) {
            stack = stack.add(self);
          } else {
            stack = stack.add(self.find(handle));
          }
        });
      };

    // Check if we should operate with some method
    if (/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(options)) {

      // Normalize method's name
      options = options.toLowerCase();

      // Find checkboxes and radio buttons
      walker(this);

      return stack.each(function() {
        var self = $(this);

        if (options == 'destroy') {
          tidy(self, 'ifDestroyed');
        } else {
          operate(self, true, options);
        }

        // Fire method's callback
        if ($.isFunction(fire)) {
          fire();
        }
      });

    // Customization
    } else if (typeof options == 'object' || !options) {

      // Check if any options were passed
      var settings = $.extend({
          checkedClass: _checked,
          disabledClass: _disabled,
          indeterminateClass: _indeterminate,
          labelHover: true
        }, options),

        selector = settings.handle,
        hoverClass = settings.hoverClass || 'hover',
        focusClass = settings.focusClass || 'focus',
        activeClass = settings.activeClass || 'active',
        labelHover = !!settings.labelHover,
        labelHoverClass = settings.labelHoverClass || 'hover',

        // Setup clickable area
        area = ('' + settings.increaseArea).replace('%', '') | 0;

      // Selector limit
      if (selector == _checkbox || selector == _radio) {
        handle = 'input[type="' + selector + '"]';
      }

      // Clickable area limit
      if (area < -50) {
        area = -50;
      }

      // Walk around the selector
      walker(this);

      return stack.each(function() {
        var self = $(this);

        // If already customized
        tidy(self);

        var node = this,
          id = node.id,

          // Layer styles
          offset = -area + '%',
          size = 100 + (area * 2) + '%',
          layer = {
            position: 'absolute',
            top: offset,
            left: offset,
            display: 'block',
            width: size,
            height: size,
            margin: 0,
            padding: 0,
            background: '#fff',
            border: 0,
            opacity: 0
          },

          // Choose how to hide input
          hide = _mobile ? {
            position: 'absolute',
            visibility: 'hidden'
          } : area ? layer : {
            position: 'absolute',
            opacity: 0
          },

          // Get proper class
          className = node[_type] == _checkbox ? settings.checkboxClass || 'i' + _checkbox : settings.radioClass || 'i' + _radio,

          // Find assigned labels
          label = $(_label + '[for="' + id + '"]').add(self.closest(_label)),

          // Check ARIA option
          aria = !!settings.aria,

          // Set ARIA placeholder
          ariaID = _iCheck + '-' + Math.random().toString(36).substr(2,6),

          // Parent & helper
          parent = '<div class="' + className + '" ' + (aria ? 'role="' + node[_type] + '" ' : ''),
          helper;

        // Set ARIA "labelledby"
        if (aria) {
          label.each(function() {
            parent += 'aria-labelledby="';

            if (this.id) {
              parent += this.id;
            } else {
              this.id = ariaID;
              parent += ariaID;
            }

            parent += '"';
          });
        }

        // Wrap input
        parent = self.wrap(parent + '/>')[_callback]('ifCreated').parent().append(settings.insert);

        // Layer addition
        helper = $('<ins class="' + _iCheckHelper + '"/>').css(layer).appendTo(parent);

        // Finalize customization
        self.data(_iCheck, {o: settings, s: self.attr('style')}).css(hide);
        !!settings.inheritClass && parent[_add](node.className || '');
        !!settings.inheritID && id && parent.attr('id', _iCheck + '-' + id);
        parent.css('position') == 'static' && parent.css('position', 'relative');
        operate(self, true, _update);

        // Label events
        if (label.length) {
          label.on(_click + '.i mouseover.i mouseout.i ' + _touch, function(event) {
            var type = event[_type],
              item = $(this);

            // Do nothing if input is disabled
            if (!node[_disabled]) {

              // Click
              if (type == _click) {
                if ($(event.target).is('a')) {
                  return;
                }
                operate(self, false, true);

              // Hover state
              } else if (labelHover) {

                // mouseout|touchend
                if (/ut|nd/.test(type)) {
                  parent[_remove](hoverClass);
                  item[_remove](labelHoverClass);
                } else {
                  parent[_add](hoverClass);
                  item[_add](labelHoverClass);
                }
              }

              if (_mobile) {
                event.stopPropagation();
              } else {
                return false;
              }
            }
          });
        }

        // Input events
        self.on(_click + '.i focus.i blur.i keyup.i keydown.i keypress.i', function(event) {
          var type = event[_type],
            key = event.keyCode;

          // Click
          if (type == _click) {
            return false;

          // Keydown
          } else if (type == 'keydown' && key == 32) {
            if (!(node[_type] == _radio && node[_checked])) {
              if (node[_checked]) {
                off(self, _checked);
              } else {
                on(self, _checked);
              }
            }

            return false;

          // Keyup
          } else if (type == 'keyup' && node[_type] == _radio && key == 32) {
            !node[_checked] && on(self, _checked);

          // Focus/blur
          } else if (/us|ur/.test(type)) {
            parent[type == 'blur' ? _remove : _add](focusClass);
          }
        });

        // Helper events
        helper.on(_click + ' mousedown mouseup mouseover mouseout ' + _touch, function(event) {
          var type = event[_type],

            // mousedown|mouseup
            toggle = /wn|up/.test(type) ? activeClass : hoverClass;

          // Do nothing if input is disabled
          if (!node[_disabled]) {

            // Click
            if (type == _click) {
              operate(self, false, true);

            // Active and hover states
            } else {

              // State is on
              if (/wn|er|in/.test(type)) {

                // mousedown|mouseover|touchbegin
                parent[_add](toggle);

              // State is off
              } else {
                parent[_remove](toggle + ' ' + activeClass);
              }

              // Label hover
              if (label.length && labelHover && toggle == hoverClass) {

                // mouseout|touchend
                label[/ut|nd/.test(type) ? _remove : _add](labelHoverClass);
              }
            }

            if (_mobile) {
              event.stopPropagation();
            } else {
              return false;
            }
          }
        });
      });
    } else {
      return this;
    }
  };

  // Do something with inputs
  function operate(input, direct, method) {
    var node = input[0],
      state = /er/.test(method) ? _indeterminate : /bl/.test(method) ? _disabled : _checked,
      active = method == _update ? {
        checked: node[_checked],
        disabled: node[_disabled],
        indeterminate: input.attr(_indeterminate) == 'true' || input.attr(_determinate) == 'false'
      } : node[state];

    // Check, disable or indeterminate
    if (/^(ch|di|in)/.test(method) && !active) {
      on(input, state);

    // Uncheck, enable or determinate
    } else if (/^(un|en|de)/.test(method) && active) {
      off(input, state);

    // Update
    } else if (method == _update) {

      // Handle states
      for (var each in active) {
        if (active[each]) {
          on(input, each, true);
        } else {
          off(input, each, true);
        }
      }

    } else if (!direct || method == 'toggle') {

      // Helper or label was clicked
      if (!direct) {
        input[_callback]('ifClicked');
      }

      // Toggle checked state
      if (active) {
        if (node[_type] !== _radio) {
          off(input, state);
        }
      } else {
        on(input, state);
      }
    }
  }

  // Add checked, disabled or indeterminate state
  function on(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== true) {

      // Toggle assigned radio buttons
      if (!keep && state == _checked && node[_type] == _radio && node.name) {
        var form = input.closest('form'),
          inputs = 'input[name="' + node.name + '"]';

        inputs = form.length ? form.find(inputs) : $(inputs);

        inputs.each(function() {
          if (this !== node && $(this).data(_iCheck)) {
            off($(this), state);
          }
        });
      }

      // Indeterminate state
      if (indeterminate) {

        // Add indeterminate state
        node[state] = true;

        // Remove checked state
        if (node[_checked]) {
          off(input, _checked, 'force');
        }

      // Checked or disabled state
      } else {

        // Add checked or disabled state
        if (!keep) {
          node[state] = true;
        }

        // Remove indeterminate state
        if (checked && node[_indeterminate]) {
          off(input, _indeterminate, false);
        }
      }

      // Trigger callbacks
      callbacks(input, checked, state, keep);
    }

    // Add proper cursor
    if (node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'default');
    }

    // Add state class
    parent[_add](specific || option(input, state) || '');

    // Set ARIA attribute
    if (!!parent.attr('role') && !indeterminate) {
      parent.attr('aria-' + (disabled ? _disabled : _checked), 'true');
    }

    // Remove regular state class
    parent[_remove](regular || option(input, callback) || '');
  }

  // Remove checked, disabled or indeterminate state
  function off(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== false) {

      // Toggle state
      if (indeterminate || !keep || keep == 'force') {
        node[state] = false;
      }

      // Trigger callbacks
      callbacks(input, checked, callback, keep);
    }

    // Add proper cursor
    if (!node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'pointer');
    }

    // Remove state class
    parent[_remove](specific || option(input, state) || '');

    // Set ARIA attribute
    if (!!parent.attr('role') && !indeterminate) {
      parent.attr('aria-' + (disabled ? _disabled : _checked), 'false');
    }

    // Add regular state class
    parent[_add](regular || option(input, callback) || '');
  }

  // Remove all traces
  function tidy(input, callback) {
    if (input.data(_iCheck)) {

      // Remove everything except input
      input.parent().html(input.attr('style', input.data(_iCheck).s || ''));

      // Callback
      if (callback) {
        input[_callback](callback);
      }

      // Unbind events
      input.off('.i').unwrap();
      $(_label + '[for="' + input[0].id + '"]').add(input.closest(_label)).off('.i');
    }
  }

  // Get some option
  function option(input, state, regular) {
    if (input.data(_iCheck)) {
      return input.data(_iCheck).o[state + (regular ? '' : 'Class')];
    }
  }

  // Capitalize some string
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Executable handlers
  function callbacks(input, checked, callback, keep) {
    if (!keep) {
      if (checked) {
        input[_callback]('ifToggled');
      }

      input[_callback]('ifChanged')[_callback]('if' + capitalize(callback));
    }
  }
})(window.jQuery || window.Zepto);

(function () {
    'use strict';

    angular
        .module('app')
        .factory('UserService', ['$resource', 'apiUrl', UserService]);

    function UserService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'users', {}, {
            query: {
                method: 'GET',
                isArray: true
            },
            get: {
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            getUser: {
                url: apiUrl + 'users/details',
                method: 'GET',
                params: {
                    userId: '@userId'
                },
                isArray: false
            },
            getUsersByUserOrg: {
                url: apiUrl + 'users/org',
                method: 'GET',
                params: {
                    userId: '@userId'
                },
                isArray: true
            },
            getUsersByOrg: {
                url: apiUrl + 'users/org/:orgId',
                method: 'GET',
                isArray: true
            },
            getCollabUsers: {
                url: apiUrl + 'users/collab?subjId=:subjId',
                method: 'GET',
                isArray: true
            },
            resendInvite: {
                url: apiUrl + 'users/resendInvite?userId=:userId',
                method: 'GET'
            },
            resendWelcome: {
                url: apiUrl + 'users/resendWelcome?userId=:userId',
                method: 'GET'
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            updateStatus: {
                url: apiUrl + 'users/status',
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            },
            replace: {
                url: apiUrl + 'users/replace',
                method: 'PUT'
            },
            validateMobileNumber: {
                url: apiUrl + 'users/validateMobileNumber?userId=:userId&moblPhonNum=:moblPhonNum&moblPhonCntryCd=:moblPhonCntryCd',
                method: 'GET'
            },
            hasRoleOnSubj: {
                url: apiUrl + 'users/hasRoleOnSubj?userId=:userId'
            },
            getPfUserMetrics: {
                url: apiUrl + 'users/pf/metrics?orgId=:orgId',
                method: 'GET',
                isArray: false
            },
            getEvents: {
                url: apiUrl + 'users/events',
                method: 'GET'
            },
            getGrantblUserRoles: {
                url: apiUrl + 'users/grantblUserRoles',
                method: 'GET'
            },
            getBcasts: {
                url: apiUrl + 'users/broadcasts',
                method: 'GET'
            },
            getBcast: {
                url: apiUrl + 'users/broadcast/:bcastId',
                method: 'GET'
            },
            saveUserBcastView: {
                url: apiUrl + 'users/broadcast/:bcastId',
                method: 'POST',
                params: {
                    bcastId: '@bcastId'
                }
            },
            getPushBcasts: {
                url: apiUrl + 'users/broadcasts/push?featCd=:featCd',
                method: 'GET',
                isArray: true
            },
            getPageTour: {
                url: apiUrl + 'users/pageTour/:pageRefCd',
                method: 'GET'
            },
            saveUserPageTourView: {
                url: apiUrl + 'users/pageTour/:pageRefCd',
                method: 'POST',
                params: {
                    pageRefCd: '@pageRefCd',
                    pageTourSeq: '@pageTourSeq'
                }
            },
            getPfUserActivityMetrics: {
                url: apiUrl + 'users/pf/activityMetrics?orgId=:orgId&tz=:tz',
                method: 'GET',
                isArray: true
            },
            getUserForOrgconnxnLkup: {
                url: apiUrl + 'users/orgconnxnlkup',
                method: 'GET',
                params: {
                    userId: '@userId'
                },
                isArray: false
            }
        });
        return service;
    }
})();

    (function() {
        'use strict';

        angular
            .module('app')
            .directive('activeUsersDt', ['$timeout', '$filter', '$translate', activeUsersDt])
            .directive('archiveUsersDt', ['$timeout', '$filter', '$translate', archiveUsersDt])
            .directive('usersTab1', usersTab1)
            .directive('usersTab2', usersTab2);

        function activeUsersDt($timeout, $filter, $translate) {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    $timeout(function() {
                        element.DataTable({
                            language: {
                                url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                            },
                            lengthChange: false,
                            responsive: {
                                details: {
                                    type: 'none'
                                }
                            },
                            autoWidth: false,
                            columnDefs: [{
                                responsivePriority: 1,
                                targets: 0
                            }, {
                                responsivePriority: 2,
                                targets: 1
                            }, {
                                responsivePriority: 3,
                                targets: 2
                            }, {
                                targets: 4,
                                render: function(data, type) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateFormat')(data);
                                    }
                                    return data;
                                }
                            }, {
                                targets: 5,
                                render: function(data, type) {
                                    if (type === 'display' || type === 'filter') {
                                        var splitStr = '<div></div>'; //since <td> has badges content too, it was added to get date only
                                        var dateOnly = data.split(splitStr)[0].trim();
                                        var textOnly = data.split(splitStr)[1].trim();
                                        if ($filter('dateFormat')(dateOnly) !== 'Invalid date') {
                                            return $filter('dateFormat')(dateOnly) + textOnly;
                                        }
                                    }
                                    return data;
                                }
                            }, {
                                responsivePriority: 4,
                                targets: 7,
                                orderable: false,
                                searchable: false
                            }],
                            order: [
                                [4, 'desc']
                            ],
                            drawCallback: function () {
                                var searchBox = $('div#activeUsersTable_filter input');
                                searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                                searchBox.attr('placeholder', $translate.instant('sysAdmin.mangUsrs.searchText')).attr('id', 'search-box-active-tab');
                                $('div#activeUsersTable_filter').find('label').hide();
                            }
                        });
                    });
                }
            };
        }

        function archiveUsersDt($timeout, $filter, $translate) {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    $timeout(function() {
                        element.DataTable({
                            language: {
                                url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                            },
                            columnDefs: [{
                                targets: 7,
                                orderable: false,
                                searchable: false
                            }, {
                                targets: 4,
                                render: function(data, type) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateFormat')(data);
                                    }
                                    return data;
                                }
                            }, {
                                targets: 5,
                                render: function(data, type) {
                                    if (type === 'display' || type === 'filter') {
                                        var splitStr = '<div></div>'; //since <td> has badges content too, it was added to get date only
                                        var dateOnly = data.split(splitStr)[0].trim();
                                        var textOnly = data.split(splitStr)[1].trim();
                                        if ($filter('dateFormat')(dateOnly) !== 'Invalid date') {
                                            return $filter('dateFormat')(dateOnly) + textOnly;
                                        }
                                    }
                                    return data;
                                }
                            }],
                            lengthChange: false,
                            responsive: {
                                details: {
                                    type: 'none'
                                }
                            },
                            autoWidth: false,
                            order: [
                                [4, 'desc']
                            ],
                            drawCallback: function () {
                                var searchBox = $('div#archivedUsersTable_filter input');
                                searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                                searchBox.attr('placeholder', $translate.instant('sysAdmin.mangUsrs.searchText')).attr('id', 'search-box-archive-tab');
                                searchBox.hide(); // hide initially
                                $('div#archivedUsersTable_filter').find('label').hide();
                            }
                        });
                    });
                }
            };
        }

        function usersTab1() {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    element.click(function () {
                        $('#search-box-active-tab').show();
                        $('#search-box-archive-tab').hide();
                        $('.add-user').attr('disabled', false);
                    });
                }
            };
        }

        function usersTab2() {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    element.click(function () {
                        $('#search-box-active-tab').hide();
                        $('#search-box-archive-tab').show();
                        $('.add-user').attr('disabled', true);
                    });
                }
            };
        }
    })();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminUserCtrl', ['$rootScope', '$state', '$filter', '$timeout', '$uibModal', 'PasswordService', 'UserService', 'users', '$translate', AdminUserCtrl])
        .controller('AdminUserConfirmUserModalCtrl', ['$uibModalInstance', 'action', AdminUserConfirmUserModalCtrl]);

    function AdminUserCtrl($rootScope, $state, $filter, $timeout, $uibModal, PasswordService, UserService, users, $translate) {
        var vm = this;
        vm.users = users;
        vm.getSuspendedUserStatusHelpText = function(user) {
            return $translate.instant('sysAdmin.mangUsrs.help.suspExpText', { suspExpTmstmp: $filter('completeDateTimeFormat')(user.suspExpTmstmp) });
        };

        vm.userRoleTypeList = $rootScope.referenceData.USR_ROLE_TYPE.refItems;
        var currentTab = window.localStorage.getItem('usersCurrentTab');
        if (currentTab) {
            $('#manageUsersTab a[data-target="' + currentTab + '"]').tab('show');
            window.localStorage.removeItem('usersCurrentTab');
        }

        vm.activeUsers = vm.users.filter(function(user) {
            return (user.userStatCd === 'A' || user.userStatCd === 'P' || user.userStatCd === 'S' || user.userStatCd === 'I');
        });

        vm.archivedUsers = vm.users.filter(function(user) {
            return user.userStatCd === 'R';
        });

        vm.statusName = function(cd) {
            return $rootScope.referenceData.USR_STAT_CD.refItems.filter(function(status) {
                return status.cd === cd;
            });
        };

        vm.roleName = function(cd) {
            return vm.userRoleTypeList.filter(function(role) {
                return role.cd === cd;
            });
        };

        vm.resendInvite = function(userId) {
            UserService.resendInvite({ userId: userId }, function() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.acctVerfcEmailSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.acctVerfcEmailError'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            });
        };

        vm.resendWelcome = function(userId) {
            UserService.resendWelcome({
                userId: userId
            }, function() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.regstWelcmEmailSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.regstWelcmEmailError'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            });
        };

        vm.passwordReset = function(userId) {
            PasswordService.reqReset({
                userId: userId
            }, function() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.passwdEmailSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.passwdResetEmailError'),
                    $translate.instant('sysAdmin.mangUsrs.pageTitle'),
                    toastr.options
                );
            });
        };

        vm.openConfirmDialog = function(user, action) {
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'AdminUserConfirmUserModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    action: function() {
                        return action;
                    }
                }
            });
            confirmModalInstance.result.then(function() {
                if (action === 'Delete') {
                    vm.deleteUser(user.userId, user.orgId);
                } else if (action === 'Archive') {
                    vm.archiveUser(user.userId, user.orgId);
                } else if (action === 'Restore') {
                    vm.restoreUser(user.userId, user.orgId);
                }
            }, function() {
                //dialog canceled
            });
        };

        vm.archiveUser = function(userId, orgId) {
            UserService.updateStatus({
                userId: userId,
                orgId: orgId,
                userStatCd: 'R'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.archvSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.modal.archvTitle'),
                    toastr.options
                );
                $state.reload();
            }, function onError() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.archvError'),
                    $translate.instant('sysAdmin.mangUsrs.modal.archvTitle'),
                    toastr.options
                );
            });
        };

        vm.restoreUser = function(userId, orgId) {
            UserService.updateStatus({
                userId: userId,
                orgId: orgId,
                userStatCd: 'A'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.restrSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.modal.restrTitle'),
                    toastr.options
                );
                $state.reload();
            }, function onError() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.restrError'),
                    $translate.instant('sysAdmin.mangUsrs.modal.restrTitle'),
                    toastr.options
                );
            });
        };

        vm.deleteUser = function(userId, orgId) {
            UserService.updateStatus({
                userId: userId,
                orgId: orgId,
                userStatCd: 'D'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('sysAdmin.mangUsrs.toast.delSuccess'),
                    $translate.instant('sysAdmin.mangUsrs.modal.delTitle'),
                    toastr.options
                );
                window.localStorage.setItem('usersCurrentTab', '#tab-2');
                $state.reload().then(function() {
                    $timeout(function() {
                        $('.add-user').attr('disabled', true);
                    });
                });
            }, function onError() {
                toastr.error(
                    $translate.instant('sysAdmin.mangUsrs.toast.delError'),
                    $translate.instant('sysAdmin.mangUsrs.modal.delTitle'),
                    toastr.options
                );
            });
        };
    }

    function AdminUserConfirmUserModalCtrl($uibModalInstance, action) {
        var modal = this;
        var title = '';
        var body = '';
        var icon = '';
        var okButton = '';

        if (action === 'Delete') {
            icon = 'fa-trash';
            title = 'sysAdmin.mangUsrs.modal.delTitle';
            body = 'sysAdmin.mangUsrs.modal.delText';
            okButton = 'sysAdmin.mangUsrs.modal.delOkButton';
        } else if (action === 'Archive') {
            icon = 'fa-archive';
            title = 'sysAdmin.mangUsrs.modal.archvTitle';
            body = 'sysAdmin.mangUsrs.modal.archvText';
            okButton = 'sysAdmin.mangUsrs.modal.archvOkButton';
        } else if (action === 'Restore') {
            icon = 'fa-undo';
            title = 'sysAdmin.mangUsrs.modal.restrTitle';
            body = 'sysAdmin.mangUsrs.modal.restrText';
            okButton = 'sysAdmin.mangUsrs.modal.restrOkButton';
        }

        modal.icon = icon;
        modal.title = title;
        modal.text = body;
        modal.cancelButton = 'sysAdmin.mangUsrs.modal.cancelButton';
        modal.okButton = okButton;

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminReplaceUserCtrl', ['$state', '$translate', 'UserService', 'user', 'orgUsers', AdminReplaceUserCtrl]);

    function AdminReplaceUserCtrl($state, $translate, UserService, user, orgUsers) {
        var vm = this;
        vm.ladda = false;
        if (user.status !== 403) {
            vm.user = user;
            vm.orgUsers = orgUsers;

            //remove current user from orgUsers
            vm.orgUsers.splice(vm.orgUsers.findIndex(function(user) {
                return user.userId === vm.user.userId;
            }), 1);
            vm.orgUsers.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
            if (vm.orgUsers.length === 1) {
                vm.newUserId = vm.orgUsers[0].userId;
            }

            vm.submit = function(replaceUserForm) {
                if ($.isEmptyObject(replaceUserForm.$error)) {
                    vm.ladda = true;
                    UserService.replace({
                        orgId: vm.user.orgId,
                        currentUserId: vm.user.userId,
                        newUserId: vm.newUserId
                    }, function onSuccess() {
                        toastr.success(
                            $translate.instant('sysAdmin.replUsr.toast.replUsrSuccess'),
                            $translate.instant('sysAdmin.replUsr.pageTitle'),
                            toastr.options
                        );
                        $state.go('app.admin.adminUsers', {}, {
                            reload: true
                        });
                    }, function onError() {
                        vm.ladda = false;
                        toastr.error(
                            $translate.instant('sysAdmin.replUsr.toast.replUsrError'),
                            $translate.instant('sysAdmin.replUsr.pageTitle'),
                            toastr.options
                        );
                    });
                }
            };
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('adminEditUserStatus', [adminEditUserStatus])
        .directive('adminEditUserPref', [adminEditUserPref])
        .directive('adminEditUserMobileCountry', [adminEditUserMobileCountry])
        .directive('adminEditUserOfficeCountry', [adminEditUserOfficeCountry])
        .directive('adminEditUserOrganization', [adminEditUserOrganization])
        .directive('convertToNumber', [convertToNumber]);

    function adminEditUserStatus() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm) {
                var elmValue;
                $(elm).on('ifClicked', function(e) {
                    setTimeout(function() {
                        elmValue = $(e.target).val();
                        $(e.target).iCheck('check');
                        scope.vm.user.userStatCd = elmValue;
                        scope.vm.enableSubmit();
                    }, 0);
                });
            }
        };
    }

    function adminEditUserPref() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm) {
                var elmValue;
                var elmId;
                $(elm).on('ifClicked', function(e) {
                    setTimeout(function() {
                        elmValue = $(e.target).val();
                        elmId = $(e.target).attr('name');
                        $(e.target).iCheck('check');
                        scope.vm.user.userPrefs[elmId] = elmValue;
                        scope.vm.enableSubmit();
                    }, 0);
                });
            }
        };
    }

    function adminEditUserOfficeCountry() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.user.offcPhonCntryCd !== '') {
                    scope.vm.countryCode(scope.vm.user.offcPhonCntryCd, 'ph');
                    if (scope.vm.phoneCodeSelected) {
                        controller.$viewValue = scope.vm.phoneCodeSelected.nm;
                        controller.$modelValue = scope.vm.phoneCodeSelected;
                        controller.$$lastCommittedViewValue = scope.vm.phoneCodeSelected.nm;
                        controller.$render();
                        controller.$invalid = false;
                        controller.$setValidity('required', true);
                    }
                }
            }
        };
    }

    function adminEditUserMobileCountry() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.user.moblPhonCntryCd !== '') {
                    scope.vm.countryCode(scope.vm.user.moblPhonCntryCd, 'mb');
                    if (scope.vm.mobileCodeSelected) {
                        controller.$viewValue = scope.vm.mobileCodeSelected.nm;
                        controller.$modelValue = scope.vm.mobileCodeSelected;
                        controller.$$lastCommittedViewValue = scope.vm.mobileCodeSelected.nm;
                        controller.$render();
                        controller.$invalid = false;
                        controller.$setValidity('required', true);
                    }
                }
            }
        };
    }

    function adminEditUserOrganization() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.user.orgId !== '') {
                    scope.vm.getOrg(scope.vm.user.orgId);
                    controller.$viewValue = scope.vm.orgSelected.desc;
                    controller.$modelValue = scope.vm.orgSelected;
                    controller.$$lastCommittedViewValue = scope.vm.orgSelected.desc;
                    controller.$render();
                    controller.$invalid = false;
                    controller.$setValidity('required', true);
                }
            }
        };
    }

    function convertToNumber() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function(val) {
                    return '' + val;
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminEditUserCtrl', ['$rootScope', '$scope', '$state', '$http', 'apiUrl', '$filter', '$timeout', '$translate', 'UserService', 'Principal', 'user', 'orgs', 'grantblUserRoles', 'sysUserRoleTypes', AdminEditUserCtrl]);

    function AdminEditUserCtrl($rootScope, $scope, $state, $http, apiUrl, $filter, $timeout, $translate, UserService, Principal, user, orgs, grantblUserRoles, sysUserRoleTypes) {
        var vm = this;
        vm.userRoleTypes = sysUserRoleTypes.data.userRoleTypes;
        vm.grantblUserRoles = grantblUserRoles;
        vm.user = user;
        var langCd = vm.user.userPrefs.PREF_LANG;
        vm.suspendedUserPopoverText = $translate.instant('sysAdmin.mangUsrs.help.suspExpText', { suspExpTmstmp: $filter('completeDateTimeFormat')(vm.user.suspExpTmstmp) });
        vm.systemRolesDirty = false;
        vm.references = $rootScope.referenceData;
        vm.status = $rootScope.referenceData.USR_STAT_CD.refItems;
        vm.codes = $rootScope.referenceData.PHON_CNTRY_CD.refItems;
        vm.userPrefTypes = $rootScope.referenceData.USR_PREF_TYPE.refItems;
        vm.pendingStatus = $filter('filter') (vm.references.USR_STAT_CD.refItems, {
            cd: 'P'
        }, true)[0].nm;
        vm.statusList = [];
        vm.userRoles = {};
        vm.userForm = null;
        vm.moblPhonNum = vm.user.moblPhonNum;
        vm.moblPhonCode = vm.user.moblPhonCntryCd;
        vm.twoFactorAuthReq = $rootScope.sysParms.TFA_ENBLD_FLAG; //is two factor authentication required or not?
        vm.orgSelected = user.orgId;

        vm.hasUserPerm = function() {
            return !vm.user.status || vm.user.status !== 403;
        };

        $scope.$watch('userForm', function(form) {
            if (form) {
                vm.userForm = form;
            }
        });

        $scope.$watch('vm.user.userStatCd', function(newVal, oldVal) {
            console.log(oldVal);
            console.log(newVal);
            if (oldVal === 'P' && newVal === 'A') {
                vm.showPasswd = true;
            } else if (oldVal === 'A' && newVal === 'P') {
                vm.showPasswd = false;
            }
        });

        angular.forEach(vm.user.userRoles, function(value) {
            vm.userRoles[value] = true;
        });

        vm.orgs = orgs.filter(function(org) {
            return org.orgStatCd === 'A';
        });

        angular.forEach(vm.orgs, function(item) {
            if (typeof (item.orgRefNum) !== 'undefined') {
                item.desc = item.orgName + ' (' + item.orgRefNum + ')';
            } else {
                item.desc = item.orgName;
            }
        });

        vm.getOrg = function(id) {
            return vm.orgs.filter(function(item) {
                if (item.orgId === id) {
                    vm.orgSelected = item;
                    return item;
                }
            });
        };

        vm.user.pseudoPassword = '';
        vm.user.confirmPasswdText = '';

        vm.status.forEach(function(status) {
            if (status.cd !== 'D' && status.cd !== 'R') {// Ignoring deleted and archived statuses
                vm.statusList.push(status);
            }
        });

        vm.availableStatusList = [];
        vm.statusList.forEach(function(status) {
            if (vm.user.userStatCd === 'A' || vm.user.userStatCd === 'I') {
                if (status.cd !== 'S' && status.cd !== 'R' && status.cd !== 'P') {
                    vm.availableStatusList.push(status);
                }
            }
            if (vm.user.userStatCd === 'S' && status.cd !== 'P') {
                vm.availableStatusList.push(status);
            }
            if (vm.user.userStatCd === 'P' && (status.cd === 'P' || status.cd === 'A')) {
                vm.availableStatusList.push(status);
            }
        });

        vm.countryCode = function(cd, type) {
            return $rootScope.referenceData.PHON_CNTRY_CD.refItems.filter(function(item) {
                if (item.cd === cd) {
                    if (type === 'ph') {
                        vm.phoneCodeSelected = item;
                    } else {
                        vm.mobileCodeSelected = item;
                    }
                    return item;
                }
            });
        };

        vm.hasMangSysPerm = Principal.hasUserPerm('MANG_SYS_ADMIN');
        vm.hasMangOrgPerm = Principal.hasUserPerm('MANG_ORG_ADMIN');

        vm.onSelectParent = function() {
            var selectedVal = vm.user.orgId;
            if (selectedVal !== undefined && selectedVal !== '') {
                vm.enableSubmit();
            }
        };

        if (vm.orgs.length === 1 && !vm.hasMangSysPerm) {
            vm.parentOrgName = vm.orgs[0].desc;
            vm.user.orgId = vm.orgs[0].orgId;
        }

        vm.setUserRoles = function() {
            vm.user.userRoles = [];
            angular.forEach(vm.userRoles, function(value, key) {
                if (value) {
                    vm.user.userRoles.push(key);
                }
            });
            return true;
        };

        vm.roleChange = function() {
            vm.setUserRoles();
            vm.systemRolesDirty = true;
            vm.enableSubmit();
        };

        vm.updateUserRoles = function(role) {
            var index = vm.user.userRoles.indexOf(role);
            if (index !== -1) {
                vm.user.userRoles.splice(index, 1);
            } else {
                vm.user.userRoles.push(role);
            }
        };

        vm.onOrgSelectedCallback = function($item, $modelValue) {
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.orgId = $modelValue.orgId;
                }
            }
            vm.enableSubmit();
        };

        vm.onPhoneCodeSelectedCallback = function($item, $modelValue) {
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.offcPhonCntryCd = $modelValue.cd;
                }
            }
            vm.enableSubmit();
        };

        vm.onMobileCodeSelectedCallback = function($item, $modelValue) {
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.moblPhonCntryCd = $modelValue.cd;
                }
            }
            vm.enableSubmit();
        };

        $('#orgField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#phField').focus();
            }
        });

        $('#phField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#offcPhonNum').focus();
            }
        });

        $('#mobileField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#mobilePhonNum').focus();
            }
        });

        $('#btnSubmit').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').trigger('click');
            }
        });

        $http.get(apiUrl + 'authenticate/passwdRules/' + langCd, {
        }).success(function(data) {
            if (data.length) {
                vm.policyPopover = {
                    templateUrl: 'passwd-policy-template.html'
                };
                vm.tempRules = prepRuleData(data);
                vm.validatePasswordPolicy(vm.ngModelCtrl);
                $('#' + vm.ngModelCtrl.$name).trigger('change');
            }
        });

        function prepRuleData(rules) {
            rules.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
            var retList = [];
            rules.forEach(function(rule) {
                var tempRule = {};
                tempRule.dispSeq = rule.dispSeq;
                tempRule.invert = rule.passwdRuleParms.invert;
                tempRule.charListRegExp = rule.passwdRuleParms.charListRegExp;
                tempRule.passwdRuleText = rule.passwdRuleText;
                retList.push(tempRule);
            });
            return retList;
        }

        vm.showPasswd = false;
        vm.showPasswdFields = function(e) {
            e.preventDefault();
            vm.showPasswd = true;
        };

        vm.isValidPasswd = true;
        vm.validatePasswordPolicy = function(ngModelCtrl) {
            if (ngModelCtrl) {
                vm.isValidPasswd = true;
                vm.rulesList = [];
                angular.forEach(vm.tempRules, function(rule) {
                    vm.rulesList[rule.dispSeq] = (!rule.invert) ? validatePolicyItem(rule, ngModelCtrl) : validatePolicyItemInvert(rule, ngModelCtrl);
                });
            }
        };

        function validatePolicyItem(rule, ngModelCtrl) {
            var ret = rule.passwdRuleText;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            } else {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        function validatePolicyItemInvert(rule, ngModelCtrl) {
            var ret;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            } else {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        vm.validateMobileNumber = function(userForm) {
            var $modelValue = userForm.mobileField.$modelValue;
            if (userForm.mobilePhonNum.$viewValue !== '' && $modelValue !== undefined && typeof ($modelValue) === 'object') {
                UserService.validateMobileNumber({
                    userId: vm.user.userId,
                    moblPhonNum: userForm.mobilePhonNum.$viewValue,
                    moblPhonCntryCd: vm.user.moblPhonCntryCd
                }).$promise.then(function(result) {
                    if (result.valid) {
                        userForm.mobilePhonNum.$valid = true;
                        userForm.mobilePhonNum.$error.mobileNumberExists = false;
                        userForm.mobilePhonNum.$setValidity('mobileNumberExists', true);
                    } else {
                        vm.disableSubmit();
                        vm.userId = result.userId;
                        userForm.mobilePhonNum.$invalid = true;
                        userForm.mobilePhonNum.$error.mobileNumberExists = true;
                        userForm.mobilePhonNum.$setValidity('mobileNumberExists', false);
                    }
                });
            }
        };

        vm.submit = function(userForm) {
            vm.disableSubmit();
            var phone = userForm.phField.$modelValue;
            var phViewVal = userForm.phField.$viewValue;
            var mobile = userForm.mobileField.$modelValue;
            var mbViewVal = userForm.mobileField.$viewValue;
            if (mbViewVal === '') {
                vm.user.moblPhonCntryCd = '';
            }
            if (phViewVal === '') {
                vm.user.offcPhonCntryCd = '';
            }
            if ((phViewVal !== '' && typeof (phone) !== 'object') || (mbViewVal !== '' && typeof (mobile) !== 'object')) {
                return false;
            }
            if ($.isEmptyObject(userForm.$error)) {
                if (vm.user.userStatCd === 'P') {
                    vm.user.password = '';
                }
                vm.user.password = jQuery('#password').val();
                UserService.update(vm.user, function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.updtUsr.toast.updtUsrSuccess'),
                        $translate.instant('sysAdmin.updtUsr.pageTitle'),
                        toastr.options
                    );
                    $state.go('app.admin.adminUsers', {}, {
                        reload: true
                    });
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.updtUsr.toast.updtUsrError'),
                        $translate.instant('sysAdmin.updtUsr.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        $timeout(function() {
            $('input').on('keypress', function() {
                vm.enableSubmit();
            });
            $('input').on('paste', function() {
                vm.enableSubmit();
            });
        });

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit();
            }
        };

        vm.isSubmitDisabled = function() {
            return $('.add-usr-submit-btn').is(':disabled');
        };

        vm.enableSubmit = function() {
            $('.add-usr-submit-btn').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('.add-usr-submit-btn').attr('disabled', true);
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('adminAddUserEmail', [adminAddUserEmail])
        .directive('adminAddUserPref', [adminAddUserPref])
        .directive('validateUserRoleType', ['$filter', '$translate', validateUserRoleType]);

    function adminAddUserEmail() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                field.$validators.emailExists = function(modelValue, viewValue) {
                    if (viewValue !== undefined && viewValue !== '') {
                        var exists = false;
                        scope.vm.users.forEach(function(user) {
                            if (user.userId === viewValue.toLowerCase()) {
                                exists = true;
                            }
                        });
                        return !exists;
                    }
                };
            }
        };
    }

    function adminAddUserPref() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm) {
                var elmValue;
                var elmId;
                $(elm).on('ifClicked', function(e) {
                    setTimeout(function() {
                        elmValue = $(e.target).val();
                        elmId = $(e.target).attr('id');
                        $(e.target).iCheck('check');
                        scope.vm.user.userPrefs[elmId] = elmValue;
                        scope.vm.enableSubmit();
                    }, 0);
                });
            }
        };
    }

    function validateUserRoleType($filter, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var userRoleType = scope.$eval(attrs.userRoleType);
                attrs.$observe('roles', function(roles) {
                    processSysRoleType(roles);
                });

                function processSysRoleType(roles) {
                    $(element).iCheck('enable');
                    if (!userRoleType.popover) {
                        userRoleType.popover = {};
                    }
                    userRoleType.popover[userRoleType.userRoleTypeCd] = {};
                    if (!roles.includes(userRoleType.userRoleTypeCd)) {
                        var conflictingRoles = userRoleType.conflictingRoles;
                        if (conflictingRoles && conflictingRoles.length > 0) {
                            angular.forEach(conflictingRoles, function(conflictCd) {
                                if (roles.includes(conflictCd)) {
                                    userRoleType.popover[userRoleType.userRoleTypeCd] = {
                                        title: 'System Roles',
                                        content: $translate.instant('sysAdmin.mangUsrs.valid.conflgUsrRoleType', {
                                            firstUsrRoleTypeName: userRoleType.userRoleTypeName,
                                            secndUsrRoleTypeName: $filter('filter')(scope.vm.userRoleTypes, { userRoleTypeCd: conflictCd }, true)[0].userRoleTypeName
                                        })
                                    };
                                    $(element).iCheck('disable');
                                    return;
                                }
                            });
                        }
                    }
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminAddUserCtrl', ['$rootScope', '$scope', '$state', '$sessionStorage', '$filter', '$timeout', '$translate', 'UserService', 'Principal', 'account', 'users', 'orgs', 'grantblUserRoles', 'sysUserRoleTypes', AdminAddUserCtrl]);

    function AdminAddUserCtrl($rootScope, $scope, $state, $sessionStorage, $filter, $timeout, $translate, UserService, Principal, account, users, orgs, grantblUserRoles, sysUserRoleTypes) {
        var vm = this;
        vm.userRoleTypes = sysUserRoleTypes.data.userRoleTypes;
        vm.grantblUserRoles = grantblUserRoles;
        vm.orgId = account.data.orgId;
        vm.users = users;
        vm.references = $rootScope.referenceData;
        vm.pendingStatus = $filter('filter') (vm.references.USR_STAT_CD.refItems, {
            cd: 'P'
        }, true)[0].nm;
        vm.codes = $rootScope.referenceData.PHON_CNTRY_CD.refItems;
        vm.userPrefTypes = $rootScope.referenceData.USR_PREF_TYPE.refItems;
        // To store the $rootScope.users value in $sessionStorage to persist values even after page refresh
        if (typeof ($sessionStorage.users) !== 'object') {
            $sessionStorage.users = $scope.users; //setting value in $sessionStorage for first time only
        } else {
            $scope.users = $sessionStorage.users; // if $sessionStorage has object assign it to $scope.users
        }

        vm.orgs = orgs.filter(function(org) {
            return org.orgStatCd === 'A';
        });
        vm.myOrg = vm.orgs.filter(function(org) {
            return (org.orgId === vm.orgId);
        });

        angular.forEach(vm.orgs, function(item) {
            if (typeof (item.orgRefNum) !== 'undefined') {
                item.desc = item.orgName + ' (' + item.orgRefNum + ')';
            } else {
                item.desc = item.orgName;
            }
        });

        vm.user = {
            userId: null,
            userFirstName: null,
            userLastName: null,
            orgId: null,
            userStatCd: 'P',
            uiUsrFlag: true,
            password: null,
            currSubjId: null,
            offcPhonCntryCd: null,
            offcPhonNum: null,
            moblPhonCntryCd: null,
            moblPhonNum: null,
            tfaProvUserId: null
        };

        vm.user.userPrefs = {};
        angular.forEach(vm.userPrefTypes, function(prefType) {
            vm.user.userPrefs[prefType.entity.userPrefTypeCd] = prefType.entity.defaultUserPrefCd;
        });

        vm.userRoles = {};
        $('#userFirstName').focus();

        vm.updateUserRoles = function(role) {
            var index = vm.user.userRoles.indexOf(role);
            if (index !== -1) {
                vm.user.userRoles.splice(index, 1);
            } else {
                vm.user.userRoles.push(role);
            }
        };

        vm.onOrgSelectedCallback = function($item, $modelValue) {
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.orgId = $modelValue.orgId;
                    $scope.newUserForm.orgField.$valid = true;
                    return false;
                }
                $scope.newUserForm.orgField.$invalid = true;
                return true;
            }
            vm.enableSubmit();
        };

        vm.onPhSelectedCallback = function() {
            var $modelValue = $scope.newUserForm.phField.$modelValue;
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.offcPhonCntryCd = $modelValue.cd;
                    $scope.newUserForm.phField.$valid = true;
                    return false;
                }
                $scope.newUserForm.phField.$invalid = true;
                return true;
            }
        };

        vm.onMbSelectedCallback = function() {
            var $modelValue = $scope.newUserForm.mobileField.$modelValue;
            if ($modelValue !== undefined && typeof ($modelValue) === 'object') {
                if (typeof ($modelValue) === 'object') {
                    vm.user.moblPhonCntryCd = $modelValue.cd;
                    $scope.newUserForm.mobileField.$valid = true;
                    return false;
                }
                $scope.newUserForm.mobileField.$invalid = true;
                return true;
            }
        };

        vm.setUserRoles = function() {
            vm.user.userRoles = [];
            angular.forEach(vm.userRoles, function(value, key) {
                if (value) {
                    vm.user.userRoles.push(key);
                }
            });
            return true;
        };

        vm.roleChange = function() {
            vm.setUserRoles();
            vm.enableSubmit();
        };

        vm.hasMangSysPerm = Principal.hasUserPerm('MANG_SYS_ADMIN');
        vm.hasMangOrgPerm = Principal.hasUserPerm('MANG_ORG_ADMIN');

        if (!vm.hasMangSysPerm && !vm.hasMangOrgPerm) {
            vm.user.orgId = vm.orgId;
        }

        if (vm.orgs.length === 1 && !vm.hasMangSysPerm) {
            vm.parentOrgName = vm.orgs[0].desc;
            vm.user.orgId = vm.orgs[0].orgId;
        }

        vm.onSelectParent = function() {
            vm.enableSubmit();
        };

        $timeout(function() {
            $('input').on('keypress', function() {
                vm.enableSubmit();
            });
        });

        $('#orgField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#phField').focus();
            }
        });

        $('#phField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#offcPhonNum').focus();
            }
        });

        $('#mobileField').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#moblPhonNum').focus();
            }
        });

        $('#btnSubmit').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').trigger('click');
            }
        });

        vm.validateMobileNumber = function() {
            vm.onMbSelectedCallback();
            var $modelValue = $scope.newUserForm.mobileField.$modelValue;
            if ($scope.newUserForm.moblPhonNum.$viewValue !== '' && $modelValue !== undefined && typeof ($modelValue) === 'object') {
                UserService.validateMobileNumber({
                    userId: vm.user.userId,
                    moblPhonNum: $scope.newUserForm.moblPhonNum.$viewValue,
                    moblPhonCntryCd: vm.user.moblPhonCntryCd
                }).$promise.then(function(result) {
                    if (result.valid) {
                        $scope.newUserForm.moblPhonNum.$valid = true;
                        $scope.newUserForm.moblPhonNum.$error.mobileNumberExists = false;
                        $scope.newUserForm.moblPhonNum.$setValidity('mobileNumberExists', true);
                    } else {
                        vm.disableSubmit();
                        vm.userId = result.userId;
                        $scope.newUserForm.moblPhonNum.$invalid = true;
                        $scope.newUserForm.moblPhonNum.$error.mobileNumberExists = true;
                        $scope.newUserForm.moblPhonNum.$setValidity('mobileNumberExists', false);
                    }
                });
            } else {
                $scope.newUserForm.moblPhonNum.$valid = true;
                $scope.newUserForm.moblPhonNum.$error.mobileNumberExists = false;
                $scope.newUserForm.moblPhonNum.$setValidity('mobileNumberExists', true);
            }
        };

        vm.submit = function(newUserForm) {
            vm.user.userStatCd = 'P';
            vm.disableSubmit();
            vm.onPhSelectedCallback();
            vm.onMbSelectedCallback();

            var phone = $scope.newUserForm.phField.$modelValue;
            var phViewVal = $scope.newUserForm.phField.$viewValue;
            var mobile = $scope.newUserForm.mobileField.$modelValue;
            var mbViewVal = $scope.newUserForm.mobileField.$viewValue;

            if ((phViewVal !== '' && typeof (phone) !== 'object') || (mbViewVal !== '' && typeof (mobile) !== 'object')) {
                return false;
            }

            if ($.isEmptyObject(newUserForm.$error)) {
                UserService.save(vm.user, function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.addUsr.toast.addUsrSuccess'),
                        $translate.instant('sysAdmin.addUsr.pageTitle'),
                        toastr.options
                    );
                    $state.go('app.admin.adminUsers', {}, {
                        reload: true
                    });
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.addUsr.toast.addUsrError'),
                        $translate.instant('sysAdmin.addUsr.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit();
            }
        };

        vm.isSubmitDisabled = function() {
            return $('.add-user-submit-btn').is(':disabled');
        };

        vm.enableSubmit = function() {
            $('.add-user-submit-btn').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('.add-user-submit-btn').attr('disabled', true);
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthorSurveysService', ['$resource', 'apiUrl', AuthorSurveysService]);

    function AuthorSurveysService($resource, apiUrl) {
        var service = $resource(apiUrl + 'surveys', {}, {
            getSurveys: {
                url: apiUrl + 'surveys/all',
                method: 'GET',
                isArray: true
            },
            getSurvey: {
                url: apiUrl + 'surveys/type/:survTypeCd/version/:survVersSeq/lang/:langCd',

                method: 'GET'
            },
            saveSurvSection: {
                url: apiUrl + 'surveys/saveSection',
                method: 'PUT'
            },
            saveSurvQuestion: {
                url: apiUrl + 'surveys/saveQuestion',
                method: 'PUT'
            },
            saveOptLabel: {
                url: apiUrl + 'surveys/saveOptLabel',
                method: 'PUT'
            }
        });
        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('authorSurveysDt', ['$timeout', '$compile', authorSurveysDt]);

    function authorSurveysDt($timeout, $compile) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                $timeout(function () {
                    element.dataTable({
                        // TODO: What if scope.$root.userLang is null
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        retrieve: true,
                        paging: true,
                        lengthChange: false,
                        searching: false,
                        ordering: true,
                        bSortCellsTop: true,
                        autoWidth: false,
                        data: scope.vm.userSurveys,
                        columns: [
                            {
                                render: function (data, type, row) {
                                    return '<a ng-click="vm.getSurvey(\'' + row.survTypeCd + '\',' + row.survVersSeq + ',\'' + row.langCd + '\',' + row.survSectSeq + ')">' +
                                    '<span>' + row.survTypeName + '</span>' +
                                    '</a>';
                                }
                            },
                            {
                                data: 'survTypeCd'
                            },
                            {
                                data: 'survTypeDesc'
                            },
                            {
                                orderable: false,
                                render: function (data, type, row) {
                                    var actionsBtn = '<div uib-dropdown ignore-disabled-links>' +
                                                        '<a class="idmx-dd-link-btn" uib-dropdown-toggle="" data-toggle="dropdown">' +
                                                            '<span class="clear">' +
                                                                '<span class="text-xs block"><span translate="sysAdmin.mangSurvs.actnButton"></span> <b class="caret"></b></span>' +
                                                            '</span>' +
                                                        '</a>' +
                                                        '<ul uib-dropdown-menu class="animated flipInX m-t-xs pull-right">' +
                                                            '<li>' +
                                                                '<a ng-click="vm.getSurvey(\'' + row.survTypeCd + '\',' + row.survVersSeq + ',\'' + row.langCd + '\',' + row.survSectSeq + ')">' +
                                                                    '<i class="fa fa-pencil-square-o" uib-tooltip="{{\'sysAdmin.mangSurvs.updtButton\' | translate}}"></i>&nbsp;' +
                                                                    '<span translate="sysAdmin.mangSurvs.updtButton">Update</span>' +
                                                                '</a>' +
                                                            '</li>' +
                                                        '</ul>' +
                                                    '</div>';
                                    return actionsBtn;
                                }
                            }
                        ],
                        order: [
                            [1, 'asc']
                        ],
                        drawCallback: function () {
                            $compile(element)(scope);
                        }
                    });
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('AuthorSurveysCtrl', ['$rootScope', '$state', '$translate', 'surveys', 'langCds', AuthorSurveysCtrl]);

    function AuthorSurveysCtrl($rootScope, $state, $translate, surveys, langCds) {
        var vm = this;
        vm.userLang = $rootScope.userLang;
        vm.languages = langCds.data.refItems;
        vm.selectLangText = $translate.instant('sysAdmin.mangSurvs.selectLangText');
        //determine minSurvSection
        surveys.map(function (survey) {
            if (survey.sections && survey.sections.length) {
                survey.sections = survey.sections.sort(function (a, b) {
                    return a.sequence - b.sequence;
                });
            }
            survey.survSectSeq = survey.sections[0].sequence;
            return survey;
        });

        vm.userSurveys;

        function filterSurveys() {
            var result = surveys.filter(function (survey) {
                return survey.langCd === vm.userLang;
            });
            return result;
        }

        vm.userSurveys = filterSurveys();
        vm.changeLanguage = function () {
            vm.userSurveys = filterSurveys();
            redrawSurveysTable();
        };

        function redrawSurveysTable() {
            var table = $('#surveys').DataTable();
            table.clear();
            table.data = vm.userSurveys;
            table.rows.add(vm.userSurveys).draw();
        }

        vm.getSurvey = function (survTypeCd, survVersSeq, langCd, survSectSeq) {
            $state.go('app.admin.surveys.survey.section', {
                survTypeCd: survTypeCd,
                survVersSeq: survVersSeq,
                langCd: langCd,
                survSectSeq: survSectSeq
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('SettingsService', ['$resource', 'apiUrl', SettingsService]);

    function SettingsService($resource, apiUrl) {
        var service = $resource(apiUrl + 'sysparm', {}, {
            getSysParms: {
                url: apiUrl + 'sysparm',
                method: 'GET',
                isArray: true
            },
            getAllSysDocs: {
                url: apiUrl + 'sysdocs',
                method: 'GET',
                isArray: true
            },
            saveSysParms: {
                url: apiUrl + 'sysparm',
                method: 'PUT',
                isArray: true
            }
        });
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('settingsSysDocDt', ['$filter', '$compile', settingsSysDocDt])
        .directive('settingsSysParmDt', ['$filter', '$compile', '$translate', settingsSysParmDt])
        .directive('settingTab1', settingTab1)
        .directive('settingTab2', settingTab2);

    function settingsSysDocDt($filter, $compile) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.DataTable({
                    language: {
                        url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                    },
                    retrieve: true,
                    paging: false,
                    lengthChange: false,
                    searching: false,
                    ordering: true,
                    data: scope.vm.sysDocs,
                    columns: [{
                        data: 'docName',
                        render: function(data, type, row) {
                            if (type === 'display' && row.fileData !== null) {
                                return '<a ng-click=\'vm.download("' + row.sysDocCd + '")\'>' + data + '</a>';
                            }
                            return data;
                        },
                        orderable: false
                    }, {
                        data: 'sysDocLangCd',
                        render: function(data) {
                            return $filter('filter')(scope.vm.references.LANG_CD.refItems, {
                                cd: data
                            }, true)[0].nm;
                        },
                        orderable: false
                    }, {
                        data: 'filename',
                        orderable: false
                    }, {
                        data: 'filesize',
                        render: function(data, type) {
                            if (data && type === 'display') {
                                return $filter('fileSize')(data);
                            }
                            return data;
                        },
                        orderable: false
                    }, {
                        data: 'username'
                    }, {
                        data: 'dateUploaded',
                        render: function(data, type) {
                            if (data && type === 'display' || type === 'filter') {
                                return $filter('dateFormat')(data);
                            }
                            return data;
                        },
                        orderable: false
                    }, {
                        data: 'docSeq',
                        render: function(data, type, row) {
                            if (type === 'display') {
                                var downloadLink = '<li><span class="disabledAction"><a><i class="fa fa-eye" uib-tooltip="{{\'sysAdmin.mangSettings.docsViewButton\' | translate}}"></i>&<span translate="sysAdmin.mangSettings.docsViewButton"></span></a></span></li>';
                                if (row.fileData !== null) {
                                    downloadLink = '<li><a ng-click=\'vm.download("' + row.sysDocCd + '", "' + row.sysDocLangCd + '")\'><i class="fa fa-eye" uib-tooltip="{{\'sysAdmin.mangSettings.docsViewButton\' | translate}}"></i>&nbsp;<span translate="sysAdmin.mangSettings.docsViewButton"></span></a></li>';
                                }
                                return '<div uib-dropdown ignore-disabled-links>'
                                     + '    <a class="idmx-dd-link-btn" uib-dropdown-toggle="" data-toggle="dropdown">'
                                     + '        <span class="clear">'
                                     + '            <span class="text-xs block">'
                                     + '                <span translate="sysAdmin.mangSettings.docsActnButton"></span>'
                                     + '                <b class="caret"></b>'
                                     + '            </span>'
                                     + '        </span>'
                                     + '    </a>'
                                     + '    <ul uib-dropdown-menu class="animated flipInX m-t-xs pull-right">'
                                     + '        <li>'
                                     + '            <a ng-click=\'vm.upload("' + row.sysDocCd + '", "' + row.sysDocLangCd + '")\'>'
                                     + '                <i class="fa fa-upload" uib-tooltip="{{\'sysAdmin.mangSettings.docsUpldButton\' | translate}}"></i>&nbsp;'
                                     + '                <span translate="sysAdmin.mangSettings.docsUpldButton"></span>'
                                     + '            </a>'
                                     + '        </li>'
                                     + downloadLink
                                     + '    </ul>'
                                     + '</div>';
                            }
                            if (type === 'sort') {
                                return data;
                            }
                            return data;
                        },
                        orderable: false
                    }],
                    order: [
                        [6, 'asc'], [1, 'asc']
                    ],
                    drawCallback: function() {
                        $compile(element)(scope);
                    }
                });
            }
        };
    }

    function settingsSysParmDt($filter, $compile, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.DataTable({
                    language: {
                        url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                    },
                    retrieve: true,
                    lengthChange: false,
                    data: scope.vm.sysParms,
                    columns: [{
                        data: 'sysParmDispSeq',
                        width: '20px'
                    }, {
                        data: 'sysParmCd',
                        render: function(data, type, row) {
                            if (type === 'display') {
                                return '<span popover-append-to-body="true" popover-placement="right"'
                                     + 'popover-trigger="mouseenter" popover-animation="true" popover-title="' + data + '"'
                                     + 'uib-popover="' + row.sysParmDesc + '" style="cursor: pointer;">' + data + '</span>';
                            }
                            return data;
                        },
                        width: '250px'
                    }, {
                        data: 'sysParmValue',
                        render: function(data, type, row) {
                            if (type === 'display') {
                                return '<div ng-class="{\'has-error\': sysParmForm.' + row.sysParmCd + '.$invalid && (sysParmForm.' + row.sysParmCd + '.$dirty || sysParmForm.$submitted)}">'
                                     + '    <textarea rows="1" class="form-control" id="text' + row.sysParmCd + '" name="' + row.sysParmCd + '" ng-model="vm.getSysParm(\'' + row.sysParmCd + '\').sysParmValue" ng-model-options="{updateOn: \'blur\'}" style="resize: none;overflow: hidden;" required></textarea>'
                                     + '    <span class="help-block m-b-none" multiple ng-show="sysParmForm.' + row.sysParmCd + '.$invalid && (sysParmForm.' + row.sysParmCd + '.$dirty || sysParmForm.$submitted)" ng-messages="sysParmForm[' + row.sysParmCd + '].$error">'
                                     + '        <span translate="sysAdmin.mangSettings.valid.parmValReqd"></span>'
                                     + '    </span>'
                                     + '</div>';
                            }
                            return data;
                        }
                    }, {
                        data: 'lastUpdtTmstmp',
                        render: function(data, type) {
                            if (data && type === 'display' || type === 'filter') {
                                return $filter('dateFormat')(data);
                            }
                            return data;
                        },
                        width: '180px'
                    }],
                    order: [
                        [0, 'asc']
                    ],
                    drawCallback: function () {
                        $compile(element)(scope);
                        var searchBox = $('div#sysParmTable_filter input');
                        searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                        searchBox.attr('placeholder', $translate.instant('sysAdmin.mangSettings.parmsSearchText')).attr('id', 'search-box-parameters-tab');
                        $('div#sysParmTable_filter').find('label').hide();
                    }
                });
            }
        };
    }

    function settingTab1() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-parameters-tab').show();
                });
            }
        };
    }

    function settingTab2() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-parameters-tab').hide();
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminSettingsCtrl', ['$rootScope', '$scope', '$state', '$uibModal', '$http', '$filter', '$timeout', '$translate', 'SettingsService', 'apiUrl', 'sysDocs', 'sysParms', AdminSettingsCtrl])
        .controller('SysDocBrowseModalCtrl', ['$rootScope', '$uibModalInstance', SysDocBrowseModalCtrl]);

    function AdminSettingsCtrl($rootScope, $scope, $state, $uibModal, $http, $filter, $timeout, $translate, SettingsService, apiUrl, sysDocs, sysParms) {
        var vm = this;
        vm.sysDocs = sysDocs;
        vm.sysParms = sysParms;
        vm.disableReset = true;
        vm.references = $rootScope.referenceData;

        $timeout(function() {
            $('#btnUpdate').attr('disabled', true);
            $('textarea').on('keypress paste keydown change', function() {
                $timeout(function() {
                    if ($scope.sysParmForm.$invalid) {
                        $('#btnUpdate').attr('disabled', true);
                    } else {
                        $('#btnUpdate').attr('disabled', false);
                    }
                });
            });
        });

        vm.getSysParm = function(sysParmCd) {
            return $filter('filter')(vm.sysParms, {
                sysParmCd: sysParmCd
            }, true)[0];
        };

        var maxUploadSize = $rootScope.sysParms.FILE_UPLD_MAX_SIZE;

        vm.download = function(sysDocCd, sysDocLangCd) {
            var req = {
                method: 'GET',
                url: apiUrl + 'sysdocs/download/' + sysDocCd + '/' + sysDocLangCd,
                headers: {
                    'Content-Type': 'application/x-www-formurlencoded'
                }
            };
            return $http(req).then(function(response) {
                var a = document.createElement('a');
                document.body.appendChild(a);
                var nmArr = response.data.mimeType;
                var fileArrayBuffer = base64ToArrayBuffer(response.data.fileData);
                var file = new Blob([fileArrayBuffer], {
                    type: nmArr
                });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                var fileName = response.data.fileName;
                a.download = fileName;
                a.click();
                toastr.success(
                    $translate.instant('sysAdmin.mangSettings.toast.viewDocSuccess'),
                    $translate.instant('sysAdmin.mangSettings.pageTitle'),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('sysAdmin.mangSettings.toast.viewDocError'),
                    $translate.instant('sysAdmin.mangSettings.pageTitle'),
                    toastr.options
                );
            });
        };

        function base64ToArrayBuffer(base64) {
            if (typeof (base64) !== 'undefined') {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }
            return base64;
        }

        vm.upload = function(sysDocCd, sysDocLangCd) {
            var udAfterDocUploadModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'sysDoc-browse-button-template.html',
                controller: 'SysDocBrowseModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm'
            });

            udAfterDocUploadModalInstance.result.then(function() {
                var fd = new FormData();
                if ($scope.myFile[0].size < maxUploadSize) {
                    fd.append('sysDocCd', sysDocCd);
                    fd.append('sysDocLangCd', sysDocLangCd);
                    fd.append('file', $scope.myFile[0]);
                    fd.append('filename', $scope.myFile[0].name);
                    fd.append('filesize', $scope.myFile[0].size);
                }
                $http.post(apiUrl + 'sysdocs/upload', fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    }
                }).success(function(data) {
                    vm.sysDocs = data;
                    repopulateSysDocTable();
                    toastr.success(
                        $translate.instant('sysAdmin.mangSettings.toast.upldDocSuccess'),
                        $translate.instant('sysAdmin.mangSettings.pageTitle'),
                        toastr.options
                    );
                }).error(function() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangSettings.toast.upldDocError'),
                        $translate.instant('sysAdmin.mangSettings.pageTitle'),
                        toastr.options
                    );
                });
                $scope.myFile.length = 0;
            });
        };

        function repopulateSysDocTable() {
            var table = $('#sysDocTable').DataTable();
            table.clear();
            table
                .rows
                .add(vm.sysDocs)
                .draw();
        }

        //SysParms

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else {
                vm.enableUpdate();
            }
        };

        vm.enableUpdate = function() {
            vm.disableReset = false;
            $('#btnUpdate').attr('disabled', false);
        };

        vm.disableButtons = function() {
            vm.disableReset = true;
            $('#btnUpdate').attr('disabled', true);
        };

        vm.resetForm = function() {
            vm.disableButtons();
            SettingsService.getSysParms(function onSuccess(data) {
                vm.sysParms = data;
                repopulateSysParmTable();
            });
        };

        vm.submit = function(sysParmForm) {
            vm.disableButtons();
            var sysParmList = [];
            angular.forEach(sysParmForm, function(value) {
                if (typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$dirty) {
                    if (value.$modelValue) {
                        sysParmList.push({
                            sysParmCd: value.$name,
                            sysParmValue: value.$modelValue
                        });
                    }
                }
            });

            if (sysParmList && !$scope.sysParmForm.$invalid) {
                SettingsService.saveSysParms(sysParmList, function onSuccess(data) {
                    toastr.success(
                        $translate.instant('sysAdmin.mangSettings.toast.parmsUpdtSuccess'),
                        $translate.instant('sysAdmin.mangSettings.pageTitle'),
                        toastr.options
                    );
                    vm.sysParms = data;
                    repopulateSysParmTable();
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangSettings.toast.parmsUpdtError'),
                        $translate.instant('sysAdmin.mangSettings.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        function repopulateSysParmTable() {
            var table = $('#sysParmTable').DataTable();
            table.clear();
            table
                .rows
                .add(vm.sysParms)
                .draw();
        }

    }

    function SysDocBrowseModalCtrl($rootScope, $uibModalInstance) {
        var modal = this;
        modal.icon = 'fa-files-o';
        modal.title = 'sysAdmin.mangSettings.modal.upldDocTitle';
        modal.okButton = 'sysAdmin.mangSettings.modal.upldDocOkButton';
        modal.cancelButton = 'sysAdmin.mangSettings.modal.cancelButton';
        modal.maxUploadSize = $rootScope.sysParms.FILE_UPLD_MAX_SIZE;
        modal.close = function() {
            $uibModalInstance.close();
        };
        modal.cancel = function(selectedFilesArray) {
            if (selectedFilesArray !== undefined) {
                selectedFilesArray.length = 0;
            }
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('OrgService', ['$resource', 'apiUrl', OrgService]);

    function OrgService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'orgs', {}, {
            get: {
                url: apiUrl + 'orgs/:orgId',
                method: 'GET'
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                url: apiUrl + 'orgs/:orgId',
                method: 'DELETE'
            },
            getOrgs: {
                url: apiUrl + 'orgs?view=:view',
                method: 'GET',
                isArray: true
            },
            getCollabOrgs: {
                url: apiUrl + 'orgs/collab?subjId=:subjId&view=:view',
                method: 'GET',
                isArray: true
            },
            getPfOrgMetrics: {
                url: apiUrl + 'orgs/pf/metrics?orgId=:orgId',
                method: 'GET',
                isArray: false
            },
            getOrgWithHierarchy: {
                url: apiUrl + 'orgs/:orgId/hierarchy',
                method: 'GET',
                isArray: false
            }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('activeOrgsDt', ['$timeout', '$filter', '$translate', activeOrgsDt])
        .directive('archiveOrgsDt', ['$timeout', '$filter', '$translate', archiveOrgsDt])
        .directive('hierarchyOrgsDt', ['$timeout', '$filter', hierarchyOrgsDt])
        .directive('orgsTab1', ['Principal', orgsTab1])
        .directive('orgsTab2', orgsTab2);

    function activeOrgsDt($timeout, $filter, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            targets: 0,
                            width: '50px'
                        }, {
                            responsivePriority: 1,
                            targets: 1
                        }, {
                            responsivePriority: 2,
                            targets: 2
                        }, {
                            responsivePriority: 3,
                            targets: 3
                        }, {
                            targets: 5,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            targets: 8,
                            width: '54px'
                        }],
                        autoWidth: false,
                        order: [
                            [5, 'desc']
                        ],
                        drawCallback: function () {
                            var searchBox = $('div#activeOrgsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('sysAdmin.mangOrgs.searchText')).attr('id', 'search-box-active-tab');
                            $('div#activeOrgsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function archiveOrgsDt($timeout, $filter, $translate) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            responsivePriority: 1,
                            targets: 0
                        }, {
                            responsivePriority: 2,
                            targets: 1
                        }, {
                            responsivePriority: 3,
                            targets: 2
                        }, {
                            targets: 4,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            responsivePriority: 4,
                            targets: 7,
                            orderable: false,
                            searchable: false
                        }],
                        autoWidth: false,
                        order: [
                            [4, 'desc']
                        ],
                        drawCallback: function () {
                            var searchBox = $('div#archivedOrgsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('sysAdmin.mangOrgs.searchText')).attr('id', 'search-box-archive-tab');
                            searchBox.hide(); // hide initially
                            $('div#archivedOrgsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function hierarchyOrgsDt($timeout, $filter) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        lengthChange: false,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        columnDefs: [{
                            targets: 0,
                            orderable: false
                        }, {
                            responsivePriority: 1,
                            targets: 1,
                            width: '250px',
                            orderable: false
                        }, {
                            responsivePriority: 2,
                            targets: 2,
                            orderable: false
                        }, {
                            responsivePriority: 3,
                            targets: 3,
                            orderable: false
                        }, {
                            targets: 4,
                            orderable: false
                        }, {
                            targets: 5,
                            orderable: false,
                            render: function(data, type) {
                                if ((type === 'display' || type === 'filter') && data) {
                                    return $filter('dateFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            targets: 6,
                            orderable: false
                        }, {
                            targets: 7,
                            orderable: false
                        }, {
                            responsivePriority: 4,
                            targets: 8,
                            orderable: false,
                            searchable: false
                        }, {
                            targets: 9,
                            orderable: false
                        }],
                        autoWidth: false,
                        order: [],
                        bPaginate: false,
                        drawCallback: function () {
                            $('div#hierarchyOrgsTable_filter').hide();
                        }
                    });
                });
            }
        };
    }

    function orgsTab1(Principal) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-active-tab').show();
                    $('#search-box-archive-tab').hide();
                    $('.add-org').attr('disabled', !Principal.hasAnyUserPerm(['MANG_SYS_ADMIN', 'MANG_ORG_ADMIN']));
                });
            }
        };
    }

    function orgsTab2() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function () {
                    $('#search-box-active-tab').hide();
                    $('#search-box-archive-tab').show();
                    $('.add-org').attr('disabled', true);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AdminOrgCtrl', ['$rootScope', '$state', '$uibModal', '$translate', '$timeout', 'Principal', 'OrgService', 'orgs', AdminOrgCtrl])
        .controller('AdminOrgConfirmModalCtrl', ['$uibModalInstance', 'confirmFor', AdminOrgConfirmModalCtrl]);

    function AdminOrgCtrl($rootScope, $state, $uibModal, $translate, $timeout, Principal, OrgService, orgs) {
        var vm = this;
        vm.orgs = orgs;
        vm.orgRoleTypes = $rootScope.referenceData.ORG_ROLE_TYPE.refItems;
        var currentTab = window.localStorage.getItem('orgsCurrentTab');
        if (currentTab) {
            $('#manageOrgTab a[data-target="' + currentTab + '"]').tab('show');
            window.localStorage.removeItem('orgsCurrentTab');
        }

        vm.activeOrgs = vm.orgs.filter(function(org) {
            return org.orgStatCd === 'A';
        });

        vm.archivedOrgs = vm.orgs.filter(function(org) {
            return org.orgStatCd === 'R';
        });

        vm.statusName = function(cd) {
            return $rootScope.referenceData.ORG_STAT_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.cntryName = function(cd) {
            return $rootScope.referenceData.CNTRY_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.roleName = function(cd) {
            return vm.orgRoleTypes.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.hasChildren = function(org) {
            if (org.childIds === undefined || org.childIds.length === 0) {
                return false;
            }
            return true;
        };

        vm.getHierachyPosition = function(org) {
            if (!org.parentOrgId && org.childIds && org.childIds.length) {
                return 'top';
            }
            if (org.parentOrgId && org.childIds && org.childIds.length > 0) {
                return 'mid';
            }
            if (org.parentOrgId && (!org.childIds || (org.childIds && !org.childIds.length > 0))) {
                return 'bot';
            }
            return 'no';
        };

        vm.getHierarchySortPosition = function(org) {
            var pos = vm.getHierachyPosition(org);
            if (pos === 'top') {
                return 1;
            }
            if (pos === 'mid') {
                return 2;
            }
            if (pos === 'bot') {
                return 3;
            }
            return 4;
        };

        vm.openConfirmDialog = function(ev, confirmFor, org) {
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'AdminOrgConfirmModalCtrl',
                controllerAs: 'modal',
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    org: function() {
                        return org;
                    },
                    confirmFor: function() {
                        return confirmFor;
                    }
                }
            });
            confirmModalInstance.result.then(function() {
                if (confirmFor === 'Delete') {
                    vm.deleteOrg(org);
                } else if (confirmFor === 'Archive') {
                    vm.archiveOrg(org);
                } else if (confirmFor === 'Restore') {
                    vm.restoreOrg(org);
                }
            }, function() {
                //dialog canceled
            });
        };

        vm.archiveOrg = function(org) {
            org.orgStatCd = 'R';
            OrgService.update(org,
                function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.mangOrgs.toast.archvSuccess'),
                        $translate.instant('sysAdmin.mangOrgs.modal.archvTitle'),
                        toastr.options
                    );
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangOrgs.toast.archvError'),
                        $translate.instant('sysAdmin.mangOrgs.modal.archvTitle'),
                        toastr.options
                    );
                }
            );
        };

        vm.restoreOrg = function(org) {
            org.orgStatCd = 'A';
            OrgService.update(org,
                function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.mangOrgs.toast.restrSuccess'),
                        $translate.instant('sysAdmin.mangOrgs.modal.restrTitle'),
                        toastr.options
                    );
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangOrgs.toast.restrError'),
                        $translate.instant('sysAdmin.mangOrgs.modal.restrTitle'),
                        toastr.options
                    );
                }
            );
        };

        vm.deleteOrg = function(org) {
            org.orgStatCd = 'D';
            OrgService.update(org,
                function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.mangOrgs.toast.delSuccess'),
                        $translate.instant('sysAdmin.mangOrgs.modal.delTitle'),
                        toastr.options
                    );
                    window.localStorage.setItem('orgsCurrentTab', '#tab-2');
                    $state.reload().then(function() {
                        $timeout(function() {
                            $('.add-org').attr('disabled', true);
                        });
                    });
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangOrgs.toast.delError'),
                        $translate.instant('sysAdmin.mangOrgs.modal.delTitle'),
                        toastr.options
                    );
                }
            );
        };

    }

    // Please note that $uibModalInstance represents a modal window (instance) dependency.
    // It is not the same as the $uibModal service used above.
    function AdminOrgConfirmModalCtrl($uibModalInstance, confirmFor) {
        var modal = this;
        var title = '';
        var body = '';
        var icon = '';
        var okButton = confirmFor;

        if (confirmFor === 'Delete') {
            icon = 'fa-trash';
            title = 'sysAdmin.mangOrgs.modal.delTitle';
            body = 'sysAdmin.mangOrgs.modal.delText';
            okButton = 'sysAdmin.mangOrgs.modal.delOkButton';
        } else if (confirmFor === 'Archive') {
            icon = 'fa-archive';
            title = 'sysAdmin.mangOrgs.modal.archvTitle';
            body = 'sysAdmin.mangOrgs.modal.archvText';
            okButton = 'sysAdmin.mangOrgs.modal.archvOkButton';
        } else if (confirmFor === 'Restore') {
            icon = 'fa-undo';
            title = 'sysAdmin.mangOrgs.modal.restrTitle';
            body = 'sysAdmin.mangOrgs.modal.restrText';
            okButton = 'sysAdmin.mangOrgs.modal.restrOkButton';
        }

        modal.icon = icon;
        modal.title = title;
        modal.text = body;
        modal.okButton = okButton;
        modal.cancelButton = 'sysAdmin.mangOrgs.modal.cancelButton';

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('OrgHierarchyCtrl', ['$rootScope', '$state', '$uibModal', '$translate', 'OrgService', 'baseOrg', OrgHierarchyCtrl])
        .controller('OrgHierarchyConfirmModalCtrl', ['$uibModalInstance', 'confirmFor', OrgHierarchyConfirmModalCtrl]);

    function OrgHierarchyCtrl($rootScope, $state, $uibModal, $translate, OrgService, baseOrg) {
        var vm = this;
        vm.orgRoleTypes = $rootScope.referenceData.ORG_ROLE_TYPE.refItems;
        vm.rowNodes = [];
        var leftIndent = 15;
        if (baseOrg.parentOrgs && baseOrg.parentOrgs.length) {
            baseOrg.parentOrgs = sort(baseOrg.parentOrgs, baseOrg);
            for (var i = 0; i < baseOrg.parentOrgs.length; i++) {
                baseOrg.parentOrgs[i].isParentOrg = true;
                baseOrg.parentOrgs[i].lvl = leftIndent;
                baseOrg.parentOrgs[i].lvlStyle = leftIndent + 'px';
                vm.rowNodes.push(baseOrg.parentOrgs[i]);
                leftIndent += 15;
            }
        }

        function sort(arr, baseOrg) {
            var sortedArr = [];
            var checkOrg = baseOrg;
            for (var i = arr.length - 1; i >= 0; i--) {
                for (var j = 0; j < arr.length; j++) {
                    if (parseInt(arr[j].orgId) === parseInt(checkOrg.parentOrgId)) {
                        sortedArr[i] = arr[j];
                        checkOrg = arr[j];
                        break;
                    }
                }
            }
            return sortedArr;
        }

        vm.getHierachyPosition = function(org) {
            if (!org.parentOrgId && org.childIds && org.childIds.length) {
                return 'top';
            }
            if (org.parentOrgId && org.childIds && org.childIds.length > 0) {
                return 'mid';
            }
            if (org.parentOrgId && (!org.childIds || (org.childIds && !org.childIds.length > 0))) {
                return 'bot';
            }
            return 'no';
        };

        function buildOrgTree(org, lvl) {
            org.lvl = lvl;
            vm.rowNodes.push(org);
            if (org.childOrgs && org.childOrgs.length > 0) {
                org.lvlStyle = lvl + 'px';
                for (var i = 0; i < org.childOrgs.length; i++) {
                    buildOrgTree(org.childOrgs[i], lvl + 15);
                }
            } else {
                org.lvlStyle = (lvl + 12) + 'px';
            }
        }
        buildOrgTree(baseOrg, leftIndent);

        vm.collapse = function(org, clickedNode) {
            if (clickedNode === false) {
                $('#' + org.orgId).hide();
            } else {
                $('#down-' + org.orgId).hide();
                $('#up-' + org.orgId).show();
            }
            if (org.childOrgs && org.childOrgs.length > 0) {
                for (var i = 0, len = org.childOrgs.length; i < len; i++) {
                    if (!org.childOrgs[i].isParentOrg) {
                        vm.collapse(org.childOrgs[i], false);
                    }
                }
            }
        };

        vm.expand = function(org) {
            $('#up-' + org.orgId).hide();
            $('#down-' + org.orgId).show();
            if (org.childOrgs && org.childOrgs.length > 0) {
                for (var i = 0, len = org.childOrgs.length; i < len; i++) {
                    expandOrg(org.childOrgs[i]);
                }
            }
        };

        function expandOrg(org) {
            $('#' + org.orgId).show();
            $('#down-' + org.orgId).hide();
            if (org.childOrgs && org.childOrgs.length > 0) {
                $('#up-' + org.orgId).show();
            }
        }

        vm.backToOrg = function() {
            $state.go('app.admin.adminOrgs', {}, {reload: true});
        };

        vm.addChild = function(orgId) {
            $state.go('app.admin.adminOrgs.adminAddOrg', {parentOrgId: orgId}, {reload: true});
        };

        // Copied from orgcontroller
        vm.statusName = function(cd) {
            return $rootScope.referenceData.ORG_STAT_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.cntryName = function(cd) {
            return $rootScope.referenceData.CNTRY_CD.refItems.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.roleName = function(cd) {
            return vm.orgRoleTypes.filter(function(item) {
                return item.cd === cd;
            });
        };

        vm.hasChildren = function(org) {
            if (org.childIds === undefined || org.childIds.length === 0) {
                return false;
            }
            return true;
        };

        vm.openConfirmDialog = function(ev, confirmFor, org) {
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'OrgHierarchyConfirmModalCtrl',
                controllerAs: 'modal',
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    org: function() {
                        return org;
                    },
                    confirmFor: function() {
                        return confirmFor;
                    }
                }
            });
            confirmModalInstance.result.then(function() {
                if (confirmFor === 'Archive') {
                    vm.archiveOrg(org);
                }
            }, function() {
                //dialog canceled
            });
        };

        vm.archiveOrg = function(org) {
            org.orgStatCd = 'R';
            OrgService.update(org,
                function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.mangOrgs.toast.archvSuccess'),
                        $translate.instant('sysAdmin.mangOrgs.modal.archvTitle'),
                        toastr.options
                    );
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.mangOrgs.toast.archvError'),
                        $translate.instant('sysAdmin.mangOrgs.modal.archvTitle'),
                        toastr.options
                    );
                }
            );
        };
    }

    function OrgHierarchyConfirmModalCtrl($uibModalInstance, confirmFor) {
        var modal = this;
        var title = '';
        var body = '';
        var icon = '';
        var okButton = confirmFor;

        if (confirmFor === 'Archive') {
            icon = 'fa-archive';
            title = 'sysAdmin.mangOrgs.modal.archvTitle';
            body = 'sysAdmin.mangOrgs.modal.archvText';
            okButton = 'sysAdmin.mangOrgs.modal.archvOkButton';
        }
        modal.icon = icon;
        modal.title = title;
        modal.text = body;
        modal.okButton = okButton;
        modal.cancelButton = 'sysAdmin.mangOrgs.modal.cancelButton';

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('adminEditOrgRefNum', [adminEditOrgRefNum])
        .directive('adminEditOrgCountry', [adminEditOrgCountry])
        .directive('adminEditParentOrg', [adminEditParentOrg])
        .directive('convertToNumber', [convertToNumber]);

    function adminEditOrgRefNum() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                controller.$validators.refNumExists = function(modelValue, viewValue) {
                    if (viewValue !== undefined && viewValue !== '') {
                        var exists = false;
                        scope.orgs.forEach(function(org) {
                            if (org.orgRefNum === viewValue && org.orgId !== scope.orgId) {
                                exists = true;
                            }
                        });
                        return !exists;
                    }
                };
            }
        };
    }

    function adminEditOrgCountry() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.org.country !== '') {
                    scope.vm.getCountry(scope.vm.org.country);
                    if (scope.vm.selectedCountry) {
                        controller.$viewValue = scope.vm.selectedCountry.nm;
                        controller.$modelValue = scope.vm.selectedCountry;
                        controller.$$lastCommittedViewValue = scope.vm.selectedCountry.nm;
                        controller.$render();
                        controller.$invalid = false;
                        controller.$setValidity('required', true);
                    }
                }
            }
        };
    }

    function adminEditParentOrg() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.org.parentOrgId !== '') {
                    scope.vm.getParentOrg(scope.vm.org.parentOrgId);
                    if (scope.vm.selectedParentOrg) {
                        controller.$viewValue = scope.vm.selectedParentOrg.desc;
                        controller.$modelValue = scope.vm.selectedParentOrg;
                        controller.$$lastCommittedViewValue = scope.vm.selectedParentOrg.desc;
                        controller.$render();
                        controller.$invalid = false;
                    }
                }
            }
        };
    }

    function convertToNumber() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function(val) {
                    return '' + val;
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdminEditOrgCtrl', ['$rootScope', '$scope', '$state', '$translate', '$timeout', 'Principal', 'OrgService', 'orgs', 'org', AdminEditOrgCtrl]);

    function AdminEditOrgCtrl($rootScope, $scope, $state, $translate, $timeout, Principal, OrgService, orgs, org) {
        var vm = this;
        $scope.orgs = orgs;
        vm.countries = $rootScope.referenceData.CNTRY_CD.refItems;
        vm.orgRoleTypes = $rootScope.referenceData.ORG_ROLE_TYPE.refItems;
        vm.status = $rootScope.referenceData.ORG_STAT_CD.refItems;
        vm.systemRolesDirty = false;
        vm.org = org;
        vm.enterOrgAddress = (vm.org.addrTypeCd !== undefined);
        vm.orgRoles = {};
        $scope.orgId = vm.org.orgId;

        vm.hasMangSysPerm = Principal.hasUserPerm('MANG_SYS_ADMIN');
        vm.hasMangOrgPerm = Principal.hasUserPerm('MANG_ORG_ADMIN');

        vm.hasOrgPerm = function() {
            return !vm.org.status || vm.org.status !== 403;
        };

        vm.isSysRoleDisabled = function(cd) {
            return vm.org.assgndSubjOrgRoles && vm.org.assgndSubjOrgRoles.indexOf(cd) !== -1;
        };

        vm.isUserOrg = function() {
            return (vm.org.orgId === $rootScope.account.orgId);
        };

        $('#organizationName').focus(); //for initial cursor position

        angular.forEach(vm.orgRoleTypes, function(role) {
            if (vm.org.assgndSubjOrgRoles && vm.org.assgndSubjOrgRoles.indexOf(role.cd) !== -1) {
                role.popoverTitle = role.nm;
                role.popoverMsg = $translate.instant('sysAdmin.updtOrg.valid.orgRoleTypeInUse', {orgRoleTypeName: role.nm});
            }
        });

        vm.setOrgRoles = function() {
            vm.org.roles = [];
            angular.forEach(vm.orgRoles, function(value, key) {
                if (value) {
                    vm.org.roles.push(key);
                }
            });
            return true;
        };

        var actvOrgs = orgs.filter(function(org) {
            return (org.orgStatCd === 'A');
        });

        var currentOrgChildIds = [];

        if (vm.org.childIds) {
            currentOrgChildIds = vm.org.childIds;
        }

        vm.parentOrgs = [];
        angular.forEach(actvOrgs, function(org) {
            if (vm.org.orgId !== org.orgId && currentOrgChildIds.indexOf(org.orgId) === -1) {
                vm.parentOrgs.push({
                    orgId: org.orgId,
                    desc: org.orgName + ((org.orgRefNum) ? ' (' + org.orgRefNum + ')' : '')
                });
            }
        });

        if (vm.parentOrgs.length === 1 && !vm.hasMangSysPerm) {
            vm.parentOrgName = vm.parentOrgs[0].desc;
            vm.org.parentOrgId = vm.parentOrgs[0].orgId;
        }

        if (vm.isUserOrg) {
            vm.parentOrgName = (vm.org.parentOrgName) ? vm.org.parentOrgName + ((vm.org.parentOrgRefNum) ? ' (' + vm.org.parentOrgRefNum + ')' : '') : $translate.instant('sysAdmin.mangOrgs.noParntOrgText');
        }

        $scope.$watch('vm.enterOrgAddress', function() {
            vm.enableSubmit();
        });

        vm.onParentOrgSelect = function($item, $modelValue) {
            if ($modelValue !== undefined) {
                vm.org.parentOrgId = $item.orgId;
                vm.enableSubmit();
            }
        };

        vm.onSelectParent = function() {
            var selectedVal = vm.org.parentOrgId;
            if (selectedVal !== undefined && selectedVal !== '') {
                vm.enableSubmit();
            }
        };

        vm.roleChange = function() {
            vm.setOrgRoles();
            vm.systemRolesDirty = true;
            vm.enableSubmit();
        };

        vm.onSelect = function($item, $modelValue) {
            if ($modelValue !== undefined && typeof($modelValue) === 'object') {
                vm.org.country = $modelValue.cd;
                vm.enableSubmit();
            }
        };

        $('#country').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').focus();
            }
        });

        $('#btnSubmit').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').trigger('click');
            }
        });

        angular.forEach(vm.org.roles, function(value) {
            vm.orgRoles[value] = true;
        });

        vm.statusName = function(cd) {
            return $rootScope.referenceData.ORG_STAT_CD.refItems.filter(function (status) {
                return status.cd === cd;
            });
        };

        vm.getCountry = function(cd) {
            return $rootScope.referenceData.CNTRY_CD.refItems.filter(function (item) {
                if (item.cd === cd) {
                    vm.selectedCountry = item;
                    return item;
                }
            });
        };

        vm.getParentOrg = function(parentOrgId) {
            angular.forEach(vm.parentOrgs, function(org) {
                if (org.orgId === parentOrgId) {
                    vm.selectedParentOrg = org;
                    return org;
                }
            });
        };

        vm.submit = function(orgForm) {
            vm.disableSubmit();
            if (vm.hasMangSysPerm && (typeof(orgForm.parentOrgId.$modelValue) === 'undefined' || orgForm.parentOrgId.$modelValue === '')) {
                vm.org.parentOrgId = null;
            }
            if (typeof(vm.org.orgRefNum) === 'undefined' || vm.org.orgRefNum === '') {
                vm.org.orgRefNum = null;
            }
            vm.org.addrTypeCd = vm.enterOrgAddress ? 'MAIN' : null;
            if ($.isEmptyObject(orgForm.$error)) {
                OrgService.update(vm.org, function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.updtOrg.toast.updtOrgSuccess'),
                        $translate.instant('sysAdmin.updtOrg.pageTitle'),
                        toastr.options
                    );
                    navigateBack();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.updtOrg.toast.updtOrgError'),
                        $translate.instant('sysAdmin.updtOrg.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        vm.cancel = function() {
            navigateBack();
        };

        function navigateBack() {
            if ($rootScope.fromState && $rootScope.fromState.name) {
                return $state.go($rootScope.fromState.name, $rootScope.fromStateParams, {reload: true});
            }
            return $state.go('app.admin.adminOrgs', {}, {reload: true});
        }

        $timeout(function() {
            $('input').on('keypress', function() {
                vm.enableSubmit();
            });
            $('input').on('paste', function () {
                vm.enableSubmit();
            });
        });

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit();
            }
        };

        vm.enableSubmit = function() {
            $('#btnSubmit').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('#btnSubmit').attr('disabled', true);
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('adminAddOrgRefNum', [adminAddOrgRefNum]);

    function adminAddOrgRefNum() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                field.$validators.refNumExists = function(modelValue, viewValue) {
                    if (viewValue !== undefined && viewValue !== '') {
                        var exists = false;
                        scope.orgs.forEach(function(org) {
                            if (org.orgRefNum === viewValue) {
                                exists = true;
                            }
                        });
                        return !exists;
                    }
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdminAddOrgCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$filter', '$timeout', 'Principal', 'OrgService', 'orgs', AdminAddOrgCtrl]);

    function AdminAddOrgCtrl($rootScope, $scope, $state, $stateParams, $translate, $filter, $timeout, Principal, OrgService, orgs) {
        var vm = this;
        $scope.orgs = orgs;
        vm.countries = $rootScope.referenceData.CNTRY_CD.refItems;
        vm.orgRoleTypes = $rootScope.referenceData.ORG_ROLE_TYPE.refItems;
        vm.status = $rootScope.referenceData.ORG_STAT_CD.refItems;
        vm.activeStatusLbl = $filter('filter')(vm.status, {
            cd: 'A'
        }, true)[0].nm;
        vm.systemRolesDirty = false;
        vm.org = {
            orgId: null,
            orgName: '',
            orgRefNum: '',
            orgStatCd: 'A',
            addrLine1: '',
            addrLine2: '',
            city: '',
            regnName: '',
            postCode: '',
            roles: [],
            country: '',
            parentOrgId: null
        };
        vm.enterOrgAddress = false;
        vm.orgRoles = {};

        vm.hasMangSysPerm = Principal.hasUserPerm('MANG_SYS_ADMIN');
        vm.hasMangOrgPerm = Principal.hasUserPerm('MANG_ORG_ADMIN');

        $('#organizationName').focus(); //for initial cursor position

        vm.setOrgRoles = function() {
            vm.org.roles = [];
            angular.forEach(vm.orgRoles, function(value, key) {
                if (value) {
                    vm.org.roles.push(key);
                }
            });
            return true;
        };

        var actvOrgs = orgs.filter(function(org) {
            return (org.orgStatCd === 'A');
        });

        vm.parentOrgs = [];
        angular.forEach(actvOrgs, function(org) {
            vm.parentOrgs.push({
                orgId: org.orgId,
                desc: org.orgName + ((org.orgRefNum) ? ' (' + org.orgRefNum + ')' : '')
            });
        });

        vm.roleChange = function() {
            vm.setOrgRoles();
            vm.systemRolesDirty = true;
            vm.enableSubmit();
        };

        $timeout(function() {
            $('input').on('keypress', function() {
                vm.enableSubmit();
            });
        });

        $scope.$watch('vm.enterOrgAddress', function() {
            vm.enableSubmit();
        });

        vm.onParentOrgSelect = function($item, $modelValue) {
            if ($modelValue !== undefined) {
                vm.org.parentOrgId = $item.orgId;
                vm.enableSubmit();
            }
        };

        vm.onSelectParent = function() {
            vm.enableSubmit();
        };

        vm.onSelect = function() {
            if ($scope.orgForm.country) {
                var $modelValue = $scope.orgForm.country.$modelValue;
                if ($modelValue !== undefined) {
                    if (typeof($modelValue) === 'object') {
                        vm.org.country = $modelValue.cd;
                        $scope.orgForm.country.$valid = true;
                        return false;
                    }
                    $scope.orgForm.country.$invalid = true;
                    return true;
                }
            }
        };

        if (vm.parentOrgs.length === 1 && !vm.hasMangSysPerm) {
            vm.parentOrgName = vm.parentOrgs[0].desc;
            vm.org.parentOrgId = vm.parentOrgs[0].orgId;
        }

        if ($rootScope.fromState && $rootScope.fromState.name === 'app.admin.adminOrgs.orgHierarchy') {
            if (vm.hasMangOrgPerm && !vm.hasMangSysPerm) {
                vm.org.parentOrgId = '' + $stateParams.parentOrgId;
            } else if (vm.hasMangSysPerm) {
                angular.forEach(vm.parentOrgs, function(org) {
                    if (org.orgId === $stateParams.parentOrgId) {
                        vm.selectedParentOrg = org;
                        vm.org.parentOrgId = org.orgId;
                    }
                });
            }
        }

        $('#country').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').focus();
            }
        });

        $('#btnSubmit').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $('#btnSubmit').trigger('click');
            }
        });

        vm.submit = function(orgForm) {
            vm.disableSubmit();
            if (vm.hasMangSysPerm && (typeof(orgForm.parentOrgId.$modelValue) === 'undefined' || orgForm.parentOrgId.$modelValue === '')) {
                vm.org.parentOrgId = null;
            }
            if (typeof(vm.org.orgRefNum) === 'undefined' || vm.org.orgRefNum === '') {
                vm.org.orgRefNum = null;
            }
            vm.onSelect();
            vm.org.addrTypeCd = vm.enterOrgAddress ? 'MAIN' : null;
            if ($.isEmptyObject(orgForm.$error)) {
                OrgService.create(vm.org, function onSuccess() {
                    toastr.success(
                        $translate.instant('sysAdmin.addOrg.toast.addOrgSuccess'),
                        $translate.instant('sysAdmin.addOrg.pageTitle'),
                        toastr.options
                    );
                    navigateBack();
                }, function onError() {
                    toastr.error(
                        $translate.instant('sysAdmin.addOrg.toast.addOrgError'),
                        $translate.instant('sysAdmin.addOrg.pageTitle'),
                        toastr.options
                    );
                });
            }
        };
        vm.cancel = function() {
            navigateBack();
        };

        function navigateBack() {
            if ($rootScope.fromState && $rootScope.fromState.name) {
                return $state.go($rootScope.fromState.name, $rootScope.fromStateParams, {reload: true});
            }
            return $state.go('app.admin.adminOrgs', {}, {reload: true});
        }

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit();
            }
        };

        vm.enableSubmit = function() {
            $('#btnSubmit').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('#btnSubmit').attr('disabled', true);
        };

    }

})();

(function() {
    'use strict';

    angular.module('app')
        .controller('ManageObservationsCtrl', ['$scope', '$state', '$stateParams', '$filter', '$uibModal', '$sce', '$translate', '$q', 'observations', 'langCd', 'obsvPriotSeq', 'hierLvl', 'hierNode', 'obsvType', 'ObservationService', ManageObservationsCtrl])
        .controller('ObsvSummernoteEditorDialogCtrl', ['$uibModalInstance', '$translate', 'fieldToUpdate', 'fieldToUpdateFull', 'content', 'obj', 'context', 'save', ObsvSummernoteEditorDialogCtrl]);

    function ManageObservationsCtrl($scope, $state, $stateParams, $filter, $uibModal, $sce, $translate, $q, observations, langCd, obsvPriotSeq, hierLvl, hierNode, obsvType, ObservationService) {
        var vm = this;
        vm.observations = observations;
        $scope.totalObsvs = vm.observations.length;
        $scope.currentPage = 0;
        vm.obsvsPerPage = 10;
        $scope.maxSize = 5; //Number of pager buttons to show

        vm.obsvPriotSeq = obsvPriotSeq.data;
        vm.hierLvl = hierLvl.data;
        vm.hierNode = hierNode.data;
        vm.obsvType = obsvType.data;
        vm.obsvPriorityRefItems = vm.obsvPriotSeq.refItems;

        //method called after ng-repeat finish rendering
        $scope.$on('buildMasonryLayout', function() {
            var elem = document.querySelector('.grid');
            new Masonry(elem, {
                itemSelector: '.grid-item',
                percentPosition: true
            });
        });

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        // Preparing initial data
        var hierLvl2Name;
        var hierLvl3Name;
        angular.forEach(vm.hierLvl.refItems, function(refData) {
            if (refData.cd === '2') {
                hierLvl2Name = refData.nm;
            }
            if (refData.cd === '3') {
                hierLvl3Name = refData.nm;
            }
        });

        //Labels
        vm.lvl2HierLvlName = hierLvl2Name ? hierLvl2Name : '';
        vm.lvl3HierLvlName = hierLvl3Name ? hierLvl3Name : '';
        vm.priorityName = $translate.instant('obsv.home.priotLabel');
        vm.typeName = $translate.instant('obsv.home.typeLabel');

        // Get all level3 reference data.
        vm.lvl3Nodes = [];
        angular.forEach($filter('orderBy')(vm.hierNode.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvl && value.entity.hierLvl.hierLvlId === 3) {
                vm.lvl3Nodes.push({
                    type: vm.lvl3HierLvlName,
                    groupName: 'level3NodeId',
                    nm: value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc,
                    parentNodeId: value.entity.parntHierNode.hierNodeId
                });
                return value;
            }
        });

        // add drop down filter object for level2, priority and observation type. level3 Filter are dynamic based on level2 value
        vm.filters = [];
        angular.forEach($filter('orderBy')(vm.hierNode.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvl && value.entity.hierLvl.hierLvlId === 2) {
                vm.filters.push({
                    type: vm.lvl2HierLvlName,
                    groupName: 'level2NodeId',
                    nm: value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });

        angular.forEach($filter('orderBy')(vm.obsvPriotSeq.refItems, 'dispSeq'), function(value) {
            vm.filters.push({
                type: vm.priorityName,
                groupName: 'obsvPrioritySeq',
                nm: value.nm,
                cd: parseInt(value.cd, 10),
                desc: typeof value.desc === 'undefined' ? null : value.desc
            });
        });

        angular.forEach($filter('orderBy')(vm.obsvType.refItems, 'dispSeq'), function(value) {
            if (value.cd !== 'DOCU') {
                vm.filters.push({
                    type: vm.typeName,
                    groupName: 'typeCd',
                    nm: value.nm,
                    cd: value.cd,
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });

        // Display group name and desc
        vm.getGroup = function(cd, groupName) {
            // level3 is not part of vm.filters becuase it is added dynamically in filter based on level2 value
            // Getting it from lvl3Nodes reference data.
            if (groupName === 'level3NodeId') {
                for (var j = 0; j < vm.lvl3Nodes.length; j++) {
                    if (vm.lvl3Nodes[j].cd.toString() === cd) {
                        return vm.lvl3Nodes[j];
                    }
                }
            } else {
                for (var i = 0; i < vm.filters.length; i++) {
                    if (vm.filters[i].cd.toString() === cd && vm.filters[i].groupName === groupName) {
                        return vm.filters[i];
                    }
                }
            }
        };

        vm.level2FilterVal = [];
        vm.priorityFilterVal = [];
        vm.typeFilterVal = [];
        vm.applyFilter = function () {
            $scope.currentPage = 0;
            vm.level2FilterVal = [];
            vm.priorityFilterVal = [];
            vm.typeFilterVal = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                switch (filterItem.type) {
                case vm.lvl2HierLvlName:
                    vm.level2FilterVal.push({
                        id: filterItem.cd,
                        childKey: 'level3NodeId',
                        childIds: []
                    });
                    break;
                case vm.priorityName:
                    vm.priorityFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.typeName:
                    vm.typeFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.lvl3HierLvlName:
                    for (var i = vm.level2FilterVal.length - 1; i >= 0; i--) {
                        if (vm.level2FilterVal[i].id === filterItem.parentNodeId) {
                            vm.level2FilterVal[i].childIds.push(filterItem.cd);
                        }
                    }
                }
            });
            includeLvl3Filter();
            var obsvs = $filter('filterMultiple')(vm.observations, { level2NodeId: vm.level2FilterVal, obsvPrioritySeq: vm.priorityFilterVal, typeCd: vm.typeFilterVal }, true);
            $scope.totalObsvs = obsvs.length;
        };

        function includeLvl3Filter() {
            // clean up vm.filterByField and remove level3 filter if it's parent is removed
            var newArr = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                if (filterItem.type !== vm.lvl3HierLvlName || (filterItem.type === vm.lvl3HierLvlName && findWithAttr(vm.level2FilterVal, 'id', filterItem.parentNodeId) !== -1)) {
                    newArr.push(filterItem);
                }
            });
            vm.filterByField = newArr;

            // clear all level3 from filters drop down
            vm.filters = $filter('filter')(vm.filters, function(value) {
                return value.type !== vm.lvl3HierLvlName;
            });
            // add new level3 filters based on level2 values
            angular.forEach(vm.level2FilterVal, function(filterItem) {
                angular.forEach($filter('orderBy')(vm.hierNode.refItems, 'dispSeq'), function(value) {
                    if (value.entity.hierLvl && value.entity.hierLvl.hierLvlId === 3
                        && value.entity.parntHierNode.hierNodeId === filterItem.id) {
                        var name = vm.getGroup(value.entity.parntHierNode.hierNodeId.toString(), 'level2NodeId').nm + ': ' + value.nm;
                        vm.filters.unshift({
                            type: vm.lvl3HierLvlName,
                            groupName: 'level3NodeId',
                            nm: name,
                            cd: parseInt(value.cd, 10),
                            desc: typeof value.desc === 'undefined' ? null : value.desc,
                            parentNodeId: value.entity.parntHierNode.hierNodeId
                        });
                    }
                });
            });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        // filter/group/sort default options
        vm.groupByField = 'level2NodeId';
        vm.groupByOrder = false;
        vm.orderByField = 'obsvPrioritySeq';

        vm.langCd = $stateParams.langCd;
        vm.selectLangText = $translate.instant('sysAdmin.mangSurvs.selectLangText');
        vm.languages = langCd.data.refItems;
        vm.priorityModel = '';
        vm.priorityLadda = false;

        vm.changeLanguage = function() {
            $state.go('app.admin.observations', { langCd: vm.langCd }, {reload: true});
        };

        vm.updateObsvPriority = function(obsv, obsvPrioritySeq) {
            return $q(function(resolve, reject) {
                var updateObsvDto = {
                    obsvId: obsv.obsvId,
                    obsvPrioritySeq: obsvPrioritySeq
                };
                ObservationService.updateObsvPriority({}, updateObsvDto)
                    .$promise.then(function () {
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        obsv.obsvPrioritySeq = obsvPrioritySeq;
                        resolve('success');
                    }, function() {
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvError'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        reject('failed to update observation priority');
                    });
            });
        };

        vm.updateObservation = function (fieldToUpdate, updatedContent, obsv) {
            return $q(function(resolve, reject) {
                var updateObsvDto = {
                    obsvId: obsv.obsvId,
                    langCd: vm.langCd.toUpperCase(),
                    updatedLangText: updatedContent,
                    fieldToUpdate: fieldToUpdate
                };
                vm.laddaUpdateObsv = true;
                ObservationService.updateObservation({}, updateObsvDto)
                    .$promise.then(function() {
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        //update on client
                        if (fieldToUpdate === 'assrtText') {
                            obsv.name = updatedContent;
                        } else if (fieldToUpdate === 'detlText') {
                            obsv.desc = updatedContent;
                        }
                        resolve('success');
                    }, function() {
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvError'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        reject('failed to save');
                    });
            });
        };

        vm.updateHierNode = function(fieldToUpdate, updatedContent, hierNode) {
            return $q(function(resolve, reject) {
                var updateQuestionDto = {
                    hierNodeId: hierNode.cd,
                    langCd: vm.langCd.toUpperCase(),
                    updatedLangText: updatedContent,
                    fieldToUpdate: fieldToUpdate
                };
                resolve('success');
                vm.laddaUpdateHierNode = true;
                ObservationService.updateHierNode({}, updateQuestionDto)
                    .$promise.then(function() {
                        vm.laddaUpdateHierNode = false;
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvSuccess'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        //update on client
                        if (fieldToUpdate === 'hierNodeName') {
                            hierNode.nm = updatedContent;
                        } else if (fieldToUpdate === 'hierNodeDesc') {
                            hierNode.desc = updatedContent;
                        }
                        resolve('success');
                    }, function(err) {
                        vm.laddaUpdateHierNode = false;
                        toastr.success(
                            $translate.instant('sysAdmin.updtSurv.toast.updtSurvError'),
                            $translate.instant('surv.updtSurv.pageTitle'),
                            toastr.options
                        );
                        reject(err);
                    });
            });
        };

        vm.save = function(fieldToUpdate, content, obj, context) {
            return $q(function(resolve, reject) {
                if (context === 'hierNode') {
                    vm.updateHierNode(fieldToUpdate, content, obj).then(function() {
                        resolve('saved');
                    }, function() {
                        reject('Problem saving');
                    });
                } else if (context === 'obsv') {
                    vm.updateObservation(fieldToUpdate, content, obj).then(function () {

                        resolve('saved');
                    }, function() {
                        reject('Problem saving');
                    });
                }
            });
        };

        vm.openSummernoteEditorDialog = function (fieldToUpdate, fieldToUpdateFull, content, obj, context) {
            return $q(function(resolve) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'summernote-editor-dialog-template.html',
                    controller: 'ObsvSummernoteEditorDialogCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        fieldToUpdate: function() {
                            return fieldToUpdate;
                        },
                        fieldToUpdateFull: function() {
                            return fieldToUpdateFull;
                        },
                        content: function() {
                            return content;
                        },
                        obj: function() {
                            return obj;
                        },
                        context: function() {
                            return context;
                        },
                        save: function() {
                            return vm.save;
                        }
                    }
                });
                resolve();
            });
        };

    }

    function ObsvSummernoteEditorDialogCtrl($uibModalInstance, $translate, fieldToUpdate, fieldToUpdateFull, content, obj, context, save) {
        var modal = this;
        modal.fieldToUpdate = fieldToUpdate;
        modal.title = 'Update ' + fieldToUpdateFull;
        modal.content = content;
        modal.okButton = $translate.instant('sysAdmin.updtSurv.modal.updtButton');
        modal.cancelButton = $translate.instant('sysAdmin.updtSurv.modal.cancelButton');
        modal.laddaSave = false;
        modal.close = function() {
            modal.laddaSave = true;
            save(fieldToUpdate, $('div.note-editable').html(), obj, context).then(function() {
                modal.laddaSave = false;
                $uibModalInstance.dismiss('save');
            }, function() {
                modal.laddaSave = false;
                $uibModalInstance.dismiss('cancel');
            });
        };
        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('SubjStageService', ['$resource', 'apiUrl', SubjStageService]);

    function SubjStageService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'subjectStage', {}, {
            get: {
                url: apiUrl + 'references/subjectStage/:subjStageId',
                method: 'GET',
                isArray: false
            }
        });
        return service;
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('SubjectsService', ['$resource', 'apiUrl', SubjectsService]);

    function SubjectsService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'subjects?view=tab', {}, {
            query: {
                method: 'GET',
                isArray: true
            },
            saveLastAccs: {
                url: apiUrl + 'subjects/lastaccs/:subjectId',
                method: 'GET'
            },
            create: {
                url: apiUrl + 'subjects',
                method: 'POST'
            },
            update: {
                url: apiUrl + 'subjects?action=:action',
                method: 'PUT'
            },
            repeat: {
                url: apiUrl + 'subjects/repeat',
                method: 'POST'
            },
            clone: {
                url: apiUrl + 'subjects/clone',
                method: 'POST'
            },
            getPfSubjectStatusMetrics: {
                url: apiUrl + 'subjects/pf/metrics?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET',
                isArray: false
            },
            getPfSubjectsByStatus: {
                url: apiUrl + 'subjects/pfSubjectsByStatus/:statusCd?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET',
                isArray: true
            },
            getAllScoreDistMetrics: {
                url: apiUrl + 'subjects/pf/allScoreDistMetrics?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET',
                isArray: true
            },
            getScoreDistMetricsByScoreTypeHierNodeId: {
                url: apiUrl + 'subjects/pf/scoreDistMetrics/:scoreTypeCd/:scoreHierNodeId?asOfFromDate=:asOfFromDate&asOfToDate=:asOfToDate&orgId=:orgId',
                method: 'GET'
            },
            unique: {
                url: apiUrl + 'subjects/findByRoles',
                method: 'POST'
            }
        });
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', routeConfig]);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.subjects', {
                url: '/subjects',
                views: {
                    'content@app': {
                        templateUrl: 'app/subjects/subjects.html',
                        controller: 'SubjectsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.subj.top',
                        pageTitle: 'subj.home.pageTitle',
                        pageDesc: 'subj.home.pageDesc'
                    },
                    icon: 'fa-folder-open',
                    showIconInMenu: true,
                    showInMenu: 'always',
                    menuDispSeq: 2
                },
                resolve: {
                    subjects: ['SubjectsService', getSubjects],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subj');
                        return $translate.refresh();
                    }]
                }
            })

            .state('app.subjects.addSubj', {
                url: '/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/subjects/add.html',
                        controller: 'AddSubjectCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['ADD_SUBJ'],
                    i18n: {
                        menu: 'menu.subj.addSubj',
                        pageTitle: 'subj.addSubj.pageTitle',
                        pageDesc: 'subj.addSubj.pageDesc',
                        userPermsMsg: 'subj.addSubj.valid.noAddSubjPermsn'
                    },
                    icon: 'fa-folder',
                    showInMenu: 'active'
                },
                resolve: {
                    subjStage: ['SubjStageService', getSubjStage],
                    orgs: ['OrgService', getCollabOrgs],
                    users: ['UserService', getCollabUsers]
                }
            })

            .state('app.subjects.repeatSubj', {
                url: '/repeat/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/subjects/repeat.html',
                        controller: 'RepeatSubjectCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['ADD_SUBJ'],
                    i18n: {
                        menu: 'menu.subj.reptSubj',
                        pageTitle: 'subj.reptSubj.pageTitle',
                        pageDesc: 'subj.reptSubj.pageDesc'
                    },
                    icon: 'fa-repeat',
                    showInMenu: 'active'
                },
                resolve: {
                    subject: ['SubjectService', '$stateParams', getSubject],
                    subjStage: ['SubjStageService', getSubjStage],
                    orgs: ['OrgService', '$stateParams', getCollabOrgsForSubj],
                    users: ['UserService', '$stateParams', getCollabUsersForSubj]
                }
            })

            .state('app.subjects.cloneSubj', {
                url: '/clone/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/subjects/clone.html',
                        controller: 'CloneSubjectCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['ADD_SUBJ'],
                    i18n: {
                        menu: 'menu.subj.cloneSubj',
                        pageTitle: 'subj.cloneSubj.pageTitle',
                        pageDesc: 'subj.cloneSubj.pageDesc'
                    },
                    icon: 'fa-copy',
                    showInMenu: 'active'
                },
                resolve: {
                    subject: ['SubjectService', '$stateParams', getSubject],
                    subjStage: ['SubjStageService', getSubjStage],
                    orgs: ['OrgService', '$stateParams', getCollabOrgsForSubj]
                }
            })

            .state('app.subjects.editSubj', {
                url: '/edit/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/subjects/edit.html',
                        controller: 'EditSubjectCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.subj.updtSubj',
                        pageTitle: 'subj.updtSubj.pageTitle',
                        pageDesc: 'subj.updtSubj.pageDesc'
                    },
                    icon: 'fa-folder-o',
                    showInMenu: 'active'
                },
                resolve: {
                    subject: ['SubjectService', '$stateParams', getSubject],
                    collab: ['CollaborationService', '$stateParams', getCollab]
                }
            });

        function getSubjects(SubjectsService) {
            return SubjectsService.query({
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSubject(SubjectService, $stateParams) {
            return SubjectService.getCollab({
                subjectId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSubjStage(SubjStageService) {
            return SubjStageService.get({
                subjStageId: 1
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getCollabOrgs(OrgService) {
            return OrgService.getCollabOrgs({
                view: 'min'
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getCollabOrgsForSubj(OrgService, $stateParams) {
            return OrgService.getCollabOrgs({
                subjId: $stateParams.id,
                view: 'min'
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getCollabUsers(UserService) {
            return UserService.getCollabUsers().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getCollab(CollaborationService, $stateParams) {
            return CollaborationService.getCollab({
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getCollabUsersForSubj(UserService, $stateParams) {
            return UserService.getCollabUsers({
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

    }

})();

(function() {
    'use strict';

    angular.module('app')
        .directive('activeSubjectsDt', ['$filter', '$compile', '$translate', '$timeout', activeSubjectsDt])
        .directive('scheduledSubjectsDt', ['$filter', '$compile', '$translate', '$timeout', scheduledSubjectsDt])
        .directive('archiveSubjectsDt', ['$filter', '$compile', '$translate', '$timeout', archiveSubjectsDt])
        .directive('subjsTab1', ['$timeout', subjsTab1])
        .directive('subjsTab2', ['$timeout', subjsTab2])
        .directive('subjsTab3', ['$timeout', subjsTab3]);

    function activeSubjectsDt($filter, $compile, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        retrieve: true,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        autoWidth: true,
                        lengthChange: false,
                        data: scope.vm.activeSubjects,
                        columns: [{
                            data: null,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return '<a ui-sref="app.subject({id: ' + data.subjId + '})">'
                                        + (data.subjDesc ? '<span uib-popover="' + data.subjDesc + '" popover-title="{{\'subj.home.subjDescTitle\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top">' : '')
                                        + data.targetName
                                        + (data.subjDesc ? '</span>' : '')
                                        + '</a>';
                                }
                                return data.targetName;
                            },
                            visible: scope.vm.targOrgColHdr
                        }, {
                            data: 'subjEffDate',
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type, row) {
                                if (type === 'display') {
                                    if (!scope.vm.subjEffDateOverdueFlag || moment(data).endOf('day').toDate() >= new Date() || row.subjStartDate) {
                                        return '<a ui-sref="app.subject({id: ' + row.subjId + '})">' + $filter('dateOnlyFormat')(data) + '</a>';
                                    }
                                    return '<a ui-sref="app.subject({id: ' + row.subjId + '})"><span class="action-negative-color" uib-popover="{{\'subj.home.help.subjEffDtOvdueText\' | translate}}" popover-title="{{\'subj.home.subjEffDtHeader\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top" style="cursor: pointer;"><strong>' + $filter('dateOnlyFormat')(data) + '<strong></span></a>';
                                }
                                if (type === 'filter') {
                                    return $filter('dateOnlyFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            data: 'myUserRoles',
                            responsivePriority: 2,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '';
                                    angular.forEach(data, function(x) {
                                        disp += '<span class="lbl-roles" uib-popover="' + scope.vm.roleName(x)[0].desc + '" popover-title="' + scope.vm.roleName(x)[0].nm + '" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top">';
                                        disp += scope.vm.roleName(x)[0].nm;
                                        disp += '</span>';
                                    });
                                    return disp;
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            responsivePriority: 3,
                            render: function(data, type) {
                                if (data.lastAccessed) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateFormat')(data.lastAccessed);
                                    }
                                    return data.lastAccessed;
                                }
                                return '';
                            }
                        }, {
                            data: 'subjStageName',
                            responsivePriority: 2,
                            render: function(data, type, row) {
                                if (!row.subjStartDate && row.targetsSet) {
                                    if (type === 'display') {
                                        return '<span class="lbl-status-negative" translate="subj.home.stageTargSetText"><span>';
                                    }
                                    return $translate.instant('subj.home.stageTargSetText');
                                }
                                if (type === 'display') {
                                    return '<span class="lbl-stages">' + data + '<span>';
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 1,
                            visible: scope.vm.hasActvSurvMetricPerm,
                            render: function(data, type) {
                                if (data.survey && (scope.vm.hasSubjectPermission(data.myUserPermsns, 'UPDT_SURV') || scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SURV'))) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-edit idmx-heading-icon"></i>'
                                            + '<span survey-percent-badge percent="' + data.survey.progPct + '">' + data.survey.progPct + '%</span>';
                                    }
                                    return data.survey.progPct;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvObsvMetricPerm,
                            render: function(data, type) {
                                if (data.obsv && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_OBSV')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-flag-o idmx-heading-icon"></i>'
                                            + '<span obsv-cnt-badge obsv-cnt-wgt="' + data.obsv.highestPriority + '">' + data.obsv.cnt + '</span>';
                                    }
                                    return data.obsv.cnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvDocMetricPerm,
                            type: 'string',
                            render: function(data, type) {
                                if (data.docu && scope.vm.hasSubjectPermission(data.myUserPermsns, 'MANG_DOC')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-files-o idmx-heading-icon"></i>'
                                            + '<span docu-badge docu-cnt="' + data.docu.cnt + '" docu-wgt="' + data.docu.highestPriority + '" docu-satsfd="' + data.docu.satsfdCnt + '">' + data.docu.satsfdCnt + '/' + data.docu.cnt + '</span>';
                                    }
                                    if (type === 'sort') {
                                        //padd both numbers to sort properly as strings
                                        return ('000000' + data.docu.satsfdCnt).slice(-6) + '|' + ('000000' + data.docu.cnt).slice(-6);
                                    }
                                    return data.docu.satsfdCnt + '/' + data.docu.cnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvScoreMetricPerm,
                            render: function(data, type) {
                                if (data.scores && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SCORE')) {
                                    if (type === 'display') {
                                        if (data.scores.length === 1) {
                                            return '<i class="fa fa-bar-chart-o idmx-heading-icon"></i>'
                                                + '<span score-badge score-pct="' + data.scores[0].scorePct + '">' + $filter('number')(data.scores[0].scoreVal, data.scores[0].scoreValDpCnt) + '</span>';
                                        }
                                        return '<i class="fa fa-bar-chart-o idmx-heading-icon"></i>'
                                            + '<span class="badge background-scoring"><i class="fa fa-fw fa-check"></i></span>';
                                    }
                                    if (data.scores.length === 1) {
                                        return data.scores[0].scoreVal;
                                    }
                                    return Number.MAX_SAFE_INTEGER;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            orderable: false,
                            searchable: false,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '<div uib-dropdown disable-empty-drop-down>'
                                        + '    <a class="idmx-dd-link-btn" uib-dropdown-toggle="" data-toggle="dropdown">'
                                        + '        <span class="clear"><span class="text-xs block"><span translate="subj.home.actnButton"></span> <b class="caret"></b></span></span>'
                                        + '    </a>'
                                        + '    <ul uib-dropdown-menu class="animated flipInX m-t-xs pull-right">';
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'UPDT_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.updateSubject(' + data.subjId + ')">'
                                            + '        <i class="fa fa-edit" uib-tooltip="{{\'subj.home.updtButton\' | translate}}"></i> <span translate="subj.home.updtButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'ARCHV_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.openConfirmDialog($event, \'Archive\', ' + data.subjId + ')">'
                                            + '        <i class="fa fa-archive" uib-tooltip="{{\'subj.home.archvButton\' | translate}}"></i> <span translate="subj.home.archvButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    disp += '    </ul>'
                                        + '</div>';
                                    return disp;
                                }
                                return '';
                            }
                        }],
                        order: [
                            [3, 'desc']
                        ],
                        drawCallback: function() {
                            $compile(element)(scope);
                            var searchBox = $('div#activeSubjectsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box hidden-xs').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.home.searchText')).attr('id', 'search-box-active-tab');
                            $('div#activeSubjectsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function scheduledSubjectsDt($filter, $compile, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        retrieve: true,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        autoWidth: true,
                        lengthChange: false,
                        data: scope.vm.scheduledSubjects,
                        columns: [{
                            data: null,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return '<a ui-sref="app.subject({id: ' + data.subjId + '})">'
                                        + (data.subjDesc ? '<span uib-popover="' + data.subjDesc + '" popover-title="{{\'subj.home.subjDescTitle\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top">' : '')
                                        + data.targetName
                                        + (data.subjDesc ? '</span>' : '')
                                        + '</a>';
                                }
                                return data.targetName;
                            },
                            visible: scope.vm.targOrgColHdr
                        }, {
                            data: 'subjEffDate',
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type, row) {
                                if (type === 'display' || type === 'filter') {
                                    return '<a ui-sref="app.subject({id: ' + row.subjId + '})">' + $filter('dateOnlyFormat')(data) + '</a>';
                                }
                                return data;
                            }
                        }, {
                            data: 'myUserRoles',
                            responsivePriority: 2,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '';
                                    angular.forEach(data, function(x) {
                                        disp += '<span class="lbl-roles" uib-popover="' + scope.vm.roleName(x)[0].desc + '" popover-title="' + scope.vm.roleName(x)[0].nm + '" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top">';
                                        disp += scope.vm.roleName(x)[0].nm;
                                        disp += '</span>';
                                    });
                                    return disp;
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            responsivePriority: 3,
                            render: function(data, type) {
                                if (data.lastAccessed) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateFormat')(data.lastAccessed);
                                    }
                                    return data.lastAccessed;
                                }
                                return '';
                            }
                        }, {
                            data: 'subjStageName',
                            responsivePriority: 2,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return '<span class="lbl-stages">' + data + '<span>';
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 1,
                            visible: scope.vm.hasActvSurvMetricPerm,
                            render: function(data, type) {
                                if (data.survey && (scope.vm.hasSubjectPermission(data.myUserPermsns, 'UPDT_SURV') || scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SURV'))) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-edit idmx-heading-icon"></i>'
                                            + '<span survey-percent-badge percent="' + data.survey.progPct + '">' + data.survey.progPct + '%</span>';
                                    }
                                    return data.survey.progPct;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvObsvMetricPerm,
                            render: function(data, type) {
                                if (data.obsv && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_OBSV')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-flag-o idmx-heading-icon"></i>'
                                            + '<span obsv-cnt-badge obsv-cnt-wgt="' + data.obsv.highestPriority + '">' + data.obsv.cnt + '</span>';
                                    }
                                    return data.obsv.cnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvDocMetricPerm,
                            type: 'string',
                            render: function(data, type) {
                                if (data.docu && scope.vm.hasSubjectPermission(data.myUserPermsns, 'MANG_DOC')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-files-o idmx-heading-icon"></i>'
                                            + '<span docu-badge docu-cnt="' + data.docu.cnt + '" docu-wgt="' + data.docu.highestPriority + '" docu-satsfd="' + data.docu.satsfdCnt + '">' + data.docu.satsfdCnt + '/' + data.docu.cnt + '</span>';
                                    }
                                    if (type === 'sort') {
                                        //padd both numbers to sort properly as strings
                                        return ('000000' + data.docu.satsfdCnt).slice(-6) + '|' + ('000000' + data.docu.cnt).slice(-6);
                                    }
                                    return data.docu.satsfdCnt + '/' + data.docu.cnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasActvScoreMetricPerm,
                            render: function(data, type) {
                                if (data.scores && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SCORE')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-bar-chart-o idmx-heading-icon"></i>'
                                            + '<span score-badge score-pct="' + data.scores[0].scorePct + '">' + $filter('number')(data.scores[0].scoreVal, data.scores[0].scoreValDpCnt) + '</span>';
                                    }
                                    return data.scores[0].scoreVal;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            orderable: false,
                            searchable: false,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '<div uib-dropdown disable-empty-drop-down>'
                                        + '    <a class="idmx-dd-link-btn" uib-dropdown-toggle="" data-toggle="dropdown">'
                                        + '        <span class="clear"><span class="text-xs block"><span translate="subj.home.actnButton"></span> <b class="caret"></b></span></span>'
                                        + '    </a>'
                                        + '    <ul uib-dropdown-menu class="animated flipInX m-t-xs pull-right">';
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'UPDT_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.updateSubject(' + data.subjId + ')">'
                                            + '        <i class="fa fa-edit" uib-tooltip="{{\'subj.home.updtButton\' | translate}}"></i> <span translate="subj.home.updtButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'ARCHV_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.openConfirmDialog($event, \'Archive\', ' + data.subjId + ')">'
                                            + '        <i class="fa fa-archive" uib-tooltip="{{\'subj.home.archvButton\' | translate}}"></i> <span translate="subj.home.archvButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    disp += '    </ul>'
                                        + '</div>';
                                    return disp;
                                }
                                return '';
                            }
                        }],
                        order: [
                            [3, 'desc']
                        ],
                        drawCallback: function() {
                            $compile(element)(scope);
                            var searchBox = $('div#scheduledSubjectsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box hidden-xs').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.home.searchText')).attr('id', 'search-box-scheduled-tab');
                            $('div#scheduledSubjectsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function archiveSubjectsDt($filter, $compile, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        retrieve: true,
                        responsive: {
                            details: {
                                type: 'none'
                            }
                        },
                        autoWidth: true,
                        lengthChange: false,
                        data: scope.vm.archivedSubjects,
                        columns: [{
                            data: null,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return (data.subjDesc ? '<span uib-popover="' + data.subjDesc + '" popover-title="{{\'subj.home.subjDescTitle\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top" style="cursor: pointer">' : '')
                                    + data.targetName
                                    + (data.subjDesc ? '</span>' : '');
                                }
                                return data.targetName;
                            },
                            visible: scope.vm.targOrgColHdr
                        }, {
                            data: 'subjEffDate',
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display' || type === 'filter') {
                                    return $filter('dateOnlyFormat')(data);
                                }
                                return data;
                            }
                        }, {
                            data: 'myUserRoles',
                            responsivePriority: 2,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '';
                                    angular.forEach(data, function(x) {
                                        disp += '<span class="lbl-roles" uib-popover="' + scope.vm.roleName(x)[0].desc + '" popover-title="' + scope.vm.roleName(x)[0].nm + '" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top">';
                                        disp += scope.vm.roleName(x)[0].nm;
                                        disp += '</span>';
                                    });
                                    return disp;
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            responsivePriority: 3,
                            render: function(data, type) {
                                if (data.lastAccessed) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateFormat')(data.lastAccessed);
                                    }
                                    return data.lastAccessed;
                                }
                                return '';
                            }
                        }, {
                            data: 'subjStageName',
                            responsivePriority: 2,
                            render: function(data, type) {
                                if (type === 'display') {
                                    return '<span class="lbl-stages">' + data + '<span>';
                                }
                                return data;
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 1,
                            visible: scope.vm.hasArchvSurvMetricPerm,
                            render: function(data, type) {
                                if (data.survey && (scope.vm.hasSubjectPermission(data.myUserPermsns, 'UPDT_SURV') || scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SURV'))) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-edit idmx-heading-icon"></i>'
                                            + '<span survey-percent-badge percent="' + data.survey.progPct + '">' + data.survey.progPct + '%</span>';
                                    }
                                    return data.survey.progPct;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasArchvObsvMetricPerm,
                            render: function(data, type) {
                                if (data.obsv && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_OBSV')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-flag-o idmx-heading-icon"></i>'
                                            + '<span obsv-cnt-badge obsv-cnt-wgt="' + data.obsv.highestPriority + '">' + data.obsv.cnt + '</span>';
                                    }
                                    return data.obsv.cnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasArchvDocMetricPerm,
                            render: function(data, type) {
                                if (data.docu && scope.vm.hasSubjectPermission(data.myUserPermsns, 'MANG_DOC')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-files-o idmx-heading-icon"></i>'
                                            + '<span docu-badge docu-cnt="' + data.docu.cnt + '" docu-wgt="' + data.docu.highestPriority + '" docu-satsfd="' + data.docu.satsfdCnt + '">' + data.docu.satsfdCnt + '/' + data.docu.cnt + '</span>';
                                    }
                                    return data.docu.satsfdCnt;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            responsivePriority: 4,
                            visible: scope.vm.hasArchvScoreMetricPerm,
                            render: function(data, type) {
                                if (data.scores && scope.vm.hasSubjectPermission(data.myUserPermsns, 'VIEW_SCORE')) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-bar-chart-o idmx-heading-icon"></i>'
                                            + '<span score-badge score-pct="' + data.scores[0].scorePct + '">' + $filter('number')(data.scores[0].scoreVal, data.scores[0].scoreValDpCnt) + '</span>';
                                    }
                                    return data.scores[0].scoreVal;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            orderable: false,
                            searchable: false,
                            className: 'all',
                            responsivePriority: 0,
                            render: function(data, type) {
                                if (type === 'display') {
                                    var disp = '<div uib-dropdown disable-empty-drop-down>'
                                        + '    <a class="idmx-dd-link-btn" uib-dropdown-toggle="" data-toggle="dropdown">'
                                        + '        <span class="clear"><span class="text-xs block"><span translate="subj.home.actnButton"></span> <b class="caret"></b></span></span>'
                                        + '    </a>'
                                        + '    <ul uib-dropdown-menu class="animated flipInX m-t-xs pull-right">';
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'RESTR_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.openConfirmDialog($event, \'Restore\', ' + data.subjId + ')">'
                                            + '        <i class="fa fa-undo" uib-tooltip="Restore"></i> <span translate="subj.home.restrButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    if (scope.vm.hasSubjectPermission(data.myUserPermsns, 'DEL_SUBJ')) {
                                        disp += '<li>'
                                            + '    <a ng-click="vm.openConfirmDialog($event, \'Delete\', ' + data.subjId + ')">'
                                            + '        <i class="fa fa-trash" uib-tooltip="Delete"></i> <span translate="subj.home.delButton"></span>'
                                            + '    </a>'
                                            + '</li>';
                                    }
                                    if (!scope.vm.hasSubjectPermission(data.myUserPermsns, 'DEL_SUBJ')) {
                                        disp += '<li>'
                                            + '    <span class="disabledAction">'
                                            + '        <a>'
                                            + '            <i class="fa fa-trash" uib-tooltip="Delete"></i> <span translate="subj.home.delButton"></span>'
                                            + '        </a>'
                                            + '    </span>'
                                            + '</li>';
                                    }
                                    disp += '    </ul>'
                                        + '</div>';
                                    return disp;
                                }
                                return '';
                            }
                        }],
                        order: [
                            [3, 'desc']
                        ],
                        drawCallback: function() {
                            $compile(element)(scope);
                            var searchBox = $('div#archivedSubjectsTable_filter input');
                            searchBox.addClass('input form-control idmx-search-box hidden-xs').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.home.searchText')).attr('id', 'search-box-archive-tab');
                            $('div#archivedSubjectsTable_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function subjsTab1($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    //remove search boxes as will get added back again as DT is regenerated
                    $('#search-box-active-tab').remove();
                    $('#search-box-scheduled-tab').remove();
                    $('#search-box-archive-tab').remove();
                    $timeout(function() {
                        scope.vm.activeTab = 1;
                    });
                });
            }
        };
    }

    function subjsTab2($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    //remove search boxes as will get added back again as DT is regenerated
                    $('#search-box-active-tab').remove();
                    $('#search-box-scheduled-tab').remove();
                    $('#search-box-archive-tab').remove();
                    $timeout(function() {
                        scope.vm.activeTab = 2;
                    });
                });
            }
        };
    }

    function subjsTab3($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.click(function() {
                    //remove search boxes as will get added back again as DT is regenerated
                    $('#search-box-active-tab').remove();
                    $('#search-box-scheduled-tab').remove();
                    $('#search-box-archive-tab').remove();
                    $timeout(function() {
                        scope.vm.activeTab = 3;
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('SubjectsCtrl', ['$rootScope', '$state', '$translate', '$timeout', '$uibModal', 'SubjectsService', 'sysParms', 'subjects', 'targetRoleTypeName', SubjectsCtrl])
        .controller('SubjectsConfirmModalCtrl', ['$uibModalInstance', 'confirmFor', SubjectsConfirmModalCtrl]);

    function SubjectsCtrl($rootScope, $state, $translate, $timeout, $uibModal, SubjectsService, sysParms, subjects, targetRoleTypeName) {
        var vm = this;
        vm.ladda = false;
        vm.activeTab = 1;
        vm.subjects = subjects.filter(function(subject) {
            return subject.myUserPermsns.length > 0;
        });
        vm.subjEffDateOverdueFlag = sysParms.data.SUBJ_EFF_DATE_OVERDUE_FLAG.toUpperCase() === 'TRUE';
        vm.targetRoleTypeName = targetRoleTypeName.data;

        angular.forEach(vm.subjects, function(subj) {
            if (subj.scores && subj.scores.length > 1) {
                subj.scores.sort(function(a, b) {
                    return a.dispSeq - b.dispSeq;
                });
            }
        });

        vm.activeSubjects = vm.subjects.filter(function(subject) {
            return subject.subjStat.cd === 'A' && (moment(subject.subjEffDate).startOf('day').toDate() <= new Date() || subject.subjStartDate);
        });

        vm.scheduledSubjects = vm.subjects.filter(function(subject) {
            return subject.subjStat.cd === 'A' && moment(subject.subjEffDate).startOf('day').toDate() > new Date() && !subject.subjStartDate;
        });

        vm.archivedSubjects = vm.subjects.filter(function(subject) {
            return subject.subjStat.cd === 'R';
        });

        vm.hasSubjectPermission = function(subjectPerms, perm) {
            return subjectPerms.indexOf(perm) !== -1;
        };

        vm.hasActvSurvMetricPerm = false;
        vm.hasActvObsvMetricPerm = false;
        vm.hasActvDocMetricPerm = false;
        vm.hasActvScoreMetricPerm = false;
        angular.forEach(vm.activeSubjects, function(subj) {
            if (subj.survey && (vm.hasSubjectPermission(subj.myUserPermsns, 'UPDT_SURV') || vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_SURV'))) {
                vm.hasActvSurvMetricPerm = true;
            }
            if (subj.obsv && vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_OBSV')) {
                vm.hasActvObsvMetricPerm = true;
            }
            if (subj.docu && vm.hasSubjectPermission(subj.myUserPermsns, 'MANG_DOC')) {
                vm.hasActvDocMetricPerm = true;
            }
            if (subj.scores && vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_SCORE')) {
                vm.hasActvScoreMetricPerm = true;
            }
        });

        vm.hasArchvSurvMetricPerm = false;
        vm.hasArchvObsvMetricPerm = false;
        vm.hasArchvDocMetricPerm = false;
        vm.hasArchvScoreMetricPerm = false;
        angular.forEach(vm.archivedSubjects, function(subj) {
            if (subj.survey && (vm.hasSubjectPermission(subj.myUserPermsns, 'UPDT_SURV') || vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_SURV'))) {
                vm.hasArchvSurvMetricPerm = true;
            }
            if (subj.obsv && vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_OBSV')) {
                vm.hasArchvObsvMetricPerm = true;
            }
            if (subj.docu && vm.hasSubjectPermission(subj.myUserPermsns, 'MANG_DOC')) {
                vm.hasArchvDocMetricPerm = true;
            }
            if (subj.scores && vm.hasSubjectPermission(subj.myUserPermsns, 'VIEW_SCORE')) {
                vm.hasArchvScoreMetricPerm = true;
            }
        });

        var currentTab = window.localStorage.getItem('subjectsCurrentTab');
        if (currentTab) {
            $('#manageSubjTab a[data-target="' + currentTab + '"]').tab('show');
            window.localStorage.removeItem('subjectsCurrentTab');
            $timeout(function() {
                vm.activeTab = 2;
            });
        }

        vm.roleName = function(cd) {
            return $rootScope.referenceData.USR_ROLE_TYPE.refItems.filter(function(role) {
                return role.cd === cd;
            });
        };

        vm.statusName = function(cd) {
            return $rootScope.referenceData.USR_STAT_CD.refItems.filter(function(status) {
                return status.cd === cd;
            });
        };

        vm.addSubjBtn = function() {
            addSubject();
        };

        vm.openConfirmDialog = function(ev, confirmFor, subjId) {
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'SubjectsConfirmModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    confirmFor: function() {
                        return confirmFor;
                    }
                }
            });
            confirmModalInstance.result.then(function() {
                if (confirmFor === 'Delete') {
                    deleteSubject(subjId);
                } else if (confirmFor === 'Archive') {
                    archiveSubject(subjId);
                } else if (confirmFor === 'Restore') {
                    activateSubject(subjId);
                }
            }, function() {
                //dialog canceled
            });
        };

        function addSubject() {
            $state.go('app.subjects.addSubj');
        }

        vm.updateSubject = function(subjId) {
            updateLastAccs(subjId);
            $state.go('app.subjects.editSubj', {
                id: subjId
            });
        };

        function deleteSubject(subjId) {
            SubjectsService.update({action: 'SUBJ_DEL'}, {
                subjId: subjId,
                subjStatCd: 'D'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('subj.home.toast.delSuccess'),
                    $translate.instant('subj.home.modal.delTitle'),
                    toastr.options
                );
                window.localStorage.setItem('subjectsCurrentTab', '#tab-2');
                $state.reload();
            }, function onError() {
                toastr.error(
                    $translate.instant('subj.home.toast.delError'),
                    $translate.instant('subj.home.modal.delTitle'),
                    toastr.options
                );
            });
        }

        function archiveSubject(subjId) {
            SubjectsService.update({action: 'SUBJ_ARCHV'}, {
                subjId: subjId,
                subjStatCd: 'R'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('subj.home.toast.archvSuccess'),
                    $translate.instant('subj.home.modal.archvTitle'),
                    toastr.options
                );
                $state.reload();
            }, function onError() {
                toastr.error(
                    $translate.instant('subj.home.toast.archvError'),
                    $translate.instant('subj.home.modal.archvTitle'),
                    toastr.options
                );
            });
        }

        function activateSubject(subjId) {
            SubjectsService.update({action: 'SUBJ_RESTR'}, {
                subjId: subjId,
                subjStatCd: 'A'
            }, function onSuccess() {
                toastr.success(
                    $translate.instant('subj.home.toast.restrSuccess'),
                    $translate.instant('subj.home.modal.restrTitle'),
                    toastr.options
                );
                $state.reload();
            }, function() {
                toastr.error(
                    $translate.instant('subj.home.toast.restrError'),
                    $translate.instant('subj.home.modal.restrTitle'),
                    toastr.options
                );
            });
        }

        function updateLastAccs(subjId) {
            SubjectsService.saveLastAccs({
                subjectId: subjId
            }, function() {
            }, function() {
            });
        }
    }

    function SubjectsConfirmModalCtrl($uibModalInstance, confirmFor) {
        var modal = this;
        var title = '';
        var body = '';
        var icon = '';
        var okButton = confirmFor;

        if (confirmFor === 'Delete') {
            icon = 'fa-trash';
            title = 'subj.home.modal.delTitle';
            body = 'subj.home.modal.delText';
            okButton = 'subj.home.modal.delOkButton';
        } else if (confirmFor === 'Archive') {
            icon = 'fa-archive';
            title = 'subj.home.modal.archvTitle';
            body = 'subj.home.modal.archvText';
            okButton = 'subj.home.modal.archvOkButton';
        } else if (confirmFor === 'Restore') {
            icon = 'fa-undo';
            title = 'subj.home.modal.restrTitle';
            body = 'subj.home.modal.restrText';
            okButton = 'subj.home.modal.restrOkButton';
        }

        modal.icon = icon;
        modal.title = title;
        modal.text = body;
        modal.okButton = okButton;
        modal.cancelButton = 'subj.home.modal.cancelButton';

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .directive('repeatSubjEffectiveDate', [repeatSubjEffectiveDate]);

    function repeatSubjEffectiveDate() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                if (scope.$root.subject) {
                    field.$validators.subjDateInvalid = function(modelValue) {
                        if (modelValue !== undefined && modelValue !== '') {
                            var isDateValid = scope.vm.validateDate(modelValue);
                            if (!isDateValid) {
                                scope.subjForm.subjEffectiveDate.$invalid = true;
                                scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', false);
                                return false;
                            }
                            scope.subjForm.subjEffectiveDate.$valid = true;
                            scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                            return true;
                        }
                        scope.subjForm.subjEffectiveDate.$valid = true;
                        scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                        return true;
                    };

                    field.$validators.subjDateGtPrevValid = function(modelValue) {
                        if (!scope.subjForm.subjEffectiveDate.$error.subjDateInvalid && modelValue) {
                            if (scope.vm.maxSubjEffDate) {
                                var maxSubjEffDate = new Date(scope.vm.maxSubjEffDate);
                                var date = moment(modelValue, scope.vm.datePlaceholder).format('YYYY-MM-DD');
                                var currentSubjDate = new Date(date);
                                // current eff date should be greater than the previous subject eff date.
                                if (currentSubjDate > maxSubjEffDate) { // valid
                                    setTimeout(function() {
                                        scope.subjForm.subjEffectiveDate.$valid = true;
                                        scope.$digest();
                                    }, 0);
                                    scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                                    return true;
                                }
                                setTimeout(function() {
                                    scope.subjForm.subjEffectiveDate.$invalid = true;
                                    scope.$digest();
                                }, 0);
                                scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', false);
                                return false;
                            }
                        } else {
                            scope.subjForm.subjEffectiveDate.$valid = true;
                            scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                            return true;
                        }
                    };
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('RepeatSubjectCtrl', ['$rootScope', '$scope', '$state', '$translate', '$filter', 'SubjectsService', 'Principal', 'conflgUsrRoles', 'conflgOrgRoles', 'account', 'subject', 'subjStage', 'orgs', 'users', RepeatSubjectCtrl]);

    function RepeatSubjectCtrl($rootScope, $scope, $state, $translate, $filter, SubjectsService, Principal, conflgUsrRoles, conflgOrgRoles, account, subject, subjStage, orgs, users) {
        var vm = this;
        vm.ladda = false;
        if (subject.status === 403) {
            $rootScope.subject = null;
        } else {
            vm.owner = account.data.userFirstLastName;
            var orgId = account.data.orgId;
            vm.orgName = account.data.orgName;
            vm.subjUserRolesDirty = false;
            vm.subjOrgRolesDirty = false;
            vm.subjStageName = subjStage.name;
            $rootScope.subject = subject;
            vm.maxSubjEffDate = subject.maxSubjEffDate;

          //get perms and store locally so don't get stuck in loop when Principal is cleared on logout
            var userPerms = Principal.userPerms();
            vm.hasPerm = function(perm) {
                return userPerms.indexOf(perm) !== -1;
            };

            $('#subjEffectiveDate').focus(); //for initial cursor position
            vm.subject = {
                subjId: subject.subjId,
                subjGrpId: subject.subjGrpId,
                subjDesc: subject.subjDesc,
                subjEffDate: '',
                subjStatCd: 'A',
                subjDataCloneFlag: null,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            };

            vm.hasSubjDataCloneDecsnFlag = function() {
                return $rootScope.sysParms.SUBJ_DATA_CLONE_END_USR_DECSN_FLAG.toLowerCase() === 'true' && subject.clonableSubjElemsFlag;
            };

            var references = $rootScope.referenceData;

            var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
            var fullDateFormat = references.DATE_FORMT_CD.refItems.filter(function(refData) {
                return (refData.cd === prefDateFormat);
            });
            var dateFormat = fullDateFormat[0].nm;
            vm.datePlaceholder = dateFormat;
            vm.dateMask = dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

            //datepicker options
            $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
            $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = dateFormat.toLowerCase();
            $.fn.datepicker.defaults.todayHighlight = true;
            $.fn.datepicker.defaults.autoclose = true;
            $.fn.datepicker.defaults.showOnFocus = false;
            $('#datepicker').datepicker().on('changeDate', function() {
                $('.add-sub-submit-btn').attr('disabled', false);
                $('#subjEffectiveDate').focus();
            });

            vm.reqdTargSubjOrgRoles = {};
            vm.subjOrgRoles = {};

            // Filter all the required org role types.
            vm.reqdTargOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return orgRoleType.entity.subjBasedOrgRoleFlag && (orgRoleType.entity.reqdSubjOrgRoleFlag || orgRoleType.entity.subjTargOrgRoleFlag);
            });

            var uniqOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return orgRoleType.entity.subjBasedOrgRoleFlag && orgRoleType.entity.uniqSubjOrgRoleFlag;
            });

            var targOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return orgRoleType.entity.subjBasedOrgRoleFlag && orgRoleType.entity.subjTargOrgRoleFlag;
            });

            // Filter all roles for user org
            vm.userOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return account.data.orgRoles.indexOf(orgRoleType.cd) !== -1 && orgRoleType.entity.subjBasedOrgRoleFlag;
            });

            vm.orgsForTargOrgRole = function(orgRoleTypeCd) {
                var orgsForTargOrgRole = [];
                angular.forEach(subject.subjReqdTargOrgRoles[orgRoleTypeCd], function(subjReqdOrgId) {
                    var subjReqdOrg = $filter('filter')(orgs, {
                        orgId: subjReqdOrgId
                    }, true)[0];
                    orgsForTargOrgRole.push(subjReqdOrg.orgNamePlusRefNum);
                });
                return orgsForTargOrgRole;
            };

            vm.orgsForOrgRole = function(orgRoleTypeCd) {
                var orgsForOrgRole = [];
                var relatedConflgRoles = conflgOrgRoles.data[orgRoleTypeCd];
                angular.forEach(orgs, function(org) {
                    if (org.roles.indexOf(orgRoleTypeCd) > -1) {
                        //check not in conflicting role
                        var found = false;
                        if (relatedConflgRoles) {
                            angular.forEach(relatedConflgRoles, function(relatedConflgRole) {
                                if (
                                    (vm.reqdTargSubjOrgRoles[relatedConflgRole] && vm.reqdTargSubjOrgRoles[relatedConflgRole].orgId === org.orgId) ||
                                    (org.orgId === orgId && vm.subjOrgRoles[relatedConflgRole])
                                ) {
                                    found = true;
                                }
                            });
                        }
                        if (!found) {
                            orgsForOrgRole.push({
                                orgId: org.orgId,
                                orgNamePlusRefNum: org.orgNamePlusRefNum,
                                cd: orgRoleTypeCd
                            });
                        }
                    }
                });
                if (orgsForOrgRole.length === 1) {
                    vm.reqdTargSubjOrgRoles[orgRoleTypeCd] = orgsForOrgRole[0];
                    if (orgsForOrgRole[0].orgId === orgId) {
                        vm.subjOrgRoles[orgRoleTypeCd] = true;
                    }
                }
                return $filter('orderBy')(orgsForOrgRole, 'desc');
            };

            //initialise vm.reqdTargSubjOrgRoles and vm.subjOrgRoles
            angular.forEach(vm.reqdTargOrgRoleTypes, function(orgRoleType) {
                vm.orgsForOrgRole(orgRoleType.cd);
            });

            //initialise vm.subjOrgRoles with target roles
            angular.forEach(targOrgRoleTypes, function(orgRoleType) {
                angular.forEach(subject.subjReqdTargOrgRoles[orgRoleType.cd], function(subjReqdOrgId) {
                    if (subjReqdOrgId === orgId) {
                        vm.subjOrgRoles[orgRoleType.cd] = true;
                    }
                });
            });

            //selection of reqd org role typeahead
            vm.reqdTargOrgRoleTypesChanged = function(orgRoleTypeCd) {
                $('#' + orgRoleTypeCd + '_orIp').iCheck('uncheck');
                disableSubmit();
            };

            //update of reqd org role typeahead
            vm.reqdTargOrgRoleTypesSelected = function($model) {
                if ($model && $model.orgId === orgId) {
                    vm.subjOrgRoles[$model.cd] = true;
                }
                enableSubmit();
            };

            vm.reqdTargOrgRoleTypesSelectedFromDropdown = function(orgRoleTypeCd) {
                if (vm.reqdTargSubjOrgRoles[orgRoleTypeCd] && vm.reqdTargSubjOrgRoles[orgRoleTypeCd].orgId === orgId) {
                    vm.subjOrgRoles[orgRoleTypeCd] = true;
                } else {
                    vm.subjOrgRoles[orgRoleTypeCd] = false;
                }
                enableSubmit();
            };

            //update of user org role checkboxes
            vm.updateUserOrgRoleTypes = function(orgRoleTypeCd) {
                var checked = vm.subjOrgRoles[orgRoleTypeCd];
                var reqdTargFlag = ($filter('filter')(vm.reqdTargOrgRoleTypes, {
                    cd: orgRoleTypeCd
                }, true).length > 0);
                if (reqdTargFlag) {
                    if (checked) {
                        var org = $filter('filter')(orgs, {
                            orgId: orgId
                        }, true)[0];
                        vm.reqdTargSubjOrgRoles[orgRoleTypeCd] = {
                            orgId: orgId,
                            orgNamePlusRefNum: org.orgNamePlusRefNum,
                            cd: orgRoleTypeCd
                        };
                    } else {
                        delete vm.reqdTargSubjOrgRoles[orgRoleTypeCd];
                    }
                }
                vm.subjOrgRolesDirty = true;
                enableSubmit();
            };

            //enable/disable org role checkboxes
            vm.isMyOrgRoleTypeDisabled = function(orgRoleTypeCd) {
                var disabled = false;
                var orgs = vm.orgsForOrgRole(orgRoleTypeCd);

                //check for target role
                angular.forEach(targOrgRoleTypes, function(targOrgRoleType) {
                    if (targOrgRoleType.cd === orgRoleTypeCd) {
                        disabled = true;
                    }
                });

                //check for reqd and only held by user org
                if (orgs.length === 1 && orgs[0].orgId === orgId) {
                    disabled = true;
                }

                //check for conflicting roles
                var conflgRoles = conflgOrgRoles.data[orgRoleTypeCd];
                angular.forEach(conflgRoles, function(conflgRole) {
                    if (vm.subjOrgRoles[conflgRole]) {
                        disabled = true;
                    }
                });

                //check for unique roles held by other org
                angular.forEach(uniqOrgRoleTypes, function(uniqOrgRoleType) {
                    if (uniqOrgRoleType.cd === orgRoleTypeCd && vm.reqdTargSubjOrgRoles[uniqOrgRoleType.cd] && vm.reqdTargSubjOrgRoles[uniqOrgRoleType.cd].orgId !== orgId) {
                        disabled = true;
                    }
                });

                if (disabled) {
                    $('#' + orgRoleTypeCd + '_or' + 'Div > .icheckbox_square-idmx').addClass('idmx_cursor_not_allowed');
                } else {
                    $('#' + orgRoleTypeCd + '_or' + 'Div > .icheckbox_square-idmx').removeClass('idmx_cursor_not_allowed');
                }
                return disabled;
            };

            vm.subjUserRoles = {};
            vm.reqdTargSubjUserRoles = {};

            vm.userRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
                return userRoleType.entity.subjBasedUsrRoleFlag;
            });

            vm.reqdTargUserRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
                return userRoleType.entity.subjBasedUsrRoleFlag && (userRoleType.entity.reqdSubjUsrRoleFlag || userRoleType.entity.subjTargUsrRoleFlag);
            });

            var targUserRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
                return userRoleType.entity.subjBasedUsrRoleFlag && userRoleType.entity.subjTargUsrRoleFlag;
            });

            vm.usersForTargUserRole = function(userRoleTypeCd) {
                var usersForTargUserRole = [];
                angular.forEach(subject.subjReqdTargUserRoles[userRoleTypeCd], function(subjTargUser) {
                    usersForTargUserRole.push(subjTargUser.userLastFirstNamePlusOrgPlusId);
                });
                return usersForTargUserRole;
            };

            vm.usersForUserRole = function(userRoleTypeCd) {
                var usersForUserRole = [];
                var relatedConflgRoles = conflgUsrRoles.data[userRoleTypeCd];
                angular.forEach(users, function(user) {
                    //check not in conflicting role
                    var found = false;
                    if (relatedConflgRoles) {
                        angular.forEach(relatedConflgRoles, function(relatedConflgRole) {
                            if (
                                (vm.reqdTargSubjUserRoles[relatedConflgRole] && vm.reqdTargSubjUserRoles[relatedConflgRole].userId === user.userId) ||
                                (user.userId === account.data.userId && vm.subjUserRoles[relatedConflgRole])
                            ) {
                                found = true;
                            }
                        });
                    }
                    if (!found) {
                        usersForUserRole.push({
                            userId: user.userId,
                            userLastFirstNamePlusOrgPlusId: user.userLastFirstNamePlusOrgPlusId,
                            cd: userRoleTypeCd
                        });
                    }
                });
                if (usersForUserRole.length === 1) {
                    angular.forEach(vm.reqdTargUserRoleTypes, function(reqdTargUserRoleType) {
                        if (reqdTargUserRoleType.cd === userRoleTypeCd) {
                            vm.reqdTargSubjUserRoles[userRoleTypeCd] = usersForUserRole[0];
                            if (usersForUserRole[0].userId === account.data.userId) {
                                vm.subjUserRoles[userRoleTypeCd] = true;
                            }
                        }
                    });
                }
                return $filter('orderBy')(usersForUserRole, 'userLastFirstNamePlusOrgPlusId');
            };

            //initialise vm.reqdTargSubjUserRoles and vm.subjUserRoles
            angular.forEach(vm.reqdTargUserRoleTypes, function(userRoleType) {
                vm.usersForUserRole(userRoleType.cd);
            });

            //initialise vm.subjUserRoles with target roles
            angular.forEach(targUserRoleTypes, function(userRoleType) {
                angular.forEach(subject.subjReqdTargUserRoles[userRoleType.cd], function(subjReqdTargUserId) {
                    if (subjReqdTargUserId.userId === account.data.userId) {
                        vm.subjUserRoles[userRoleType.cd] = true;
                    }
                });
            });

            //selection of reqd user role typeahead
            vm.reqdTargUserRoleTypesChanged = function(userRoleTypeCd) {
                $('#' + userRoleTypeCd + '_urIp').iCheck('uncheck');
                disableSubmit();
            };

            //update of reqd user role typeahead
            vm.reqdTargUserRoleTypesSelected = function($model) {
                if ($model && $model.userId === account.data.userId) {
                    vm.subjUserRoles[$model.cd] = true;
                }
                enableSubmit();
            };

            vm.reqdTargUserRoleTypesSelectedFromDropdown = function(userRoleTypeCd) {
                if (vm.reqdTargSubjUserRoles[userRoleTypeCd] && vm.reqdTargSubjUserRoles[userRoleTypeCd].userId === account.data.userId) {
                    vm.subjUserRoles[userRoleTypeCd] = true;
                } else {
                    vm.subjUserRoles[userRoleTypeCd] = false;
                }
                enableSubmit();
            };

            //update of subj user roles checkboxes
            vm.updateSubjUserRoleTypes = function(userRoleTypeCd) {
                var checked = vm.subjUserRoles[userRoleTypeCd];
                var reqdTargFlag = ($filter('filter')(vm.reqdTargUserRoleTypes, {
                    cd: userRoleTypeCd
                }, true).length > 0);
                if (reqdTargFlag) {
                    if (checked) {
                        var user = $filter('filter')(users, {
                            userId: account.data.userId
                        }, true)[0];
                        vm.reqdTargSubjUserRoles[userRoleTypeCd] = {
                            userId: user.userId,
                            userLastFirstNamePlusOrgPlusId: user.userLastFirstNamePlusOrgPlusId,
                            cd: userRoleTypeCd
                        };
                    } else {
                        delete vm.reqdTargSubjUserRoles[userRoleTypeCd];
                    }
                }
                vm.subjUserRolesDirty = true;
                enableSubmit();
            };

            // enables/disables subj user role checkboxes
            vm.isUserRoleTypeDisabled = function(userRoleTypeCd) {
                var disabled = false;

                //check role target
                if (($filter('filter')(targUserRoleTypes, {
                    cd: userRoleTypeCd
                }, true).length > 0)) {
                    disabled = true;
                }

                //check for reqd and only held by user
                if (vm.usersForUserRole(userRoleTypeCd).length === 1) {
                    disabled = true;
                }

                //check role conflicting
                var conflgRoles = conflgUsrRoles.data[userRoleTypeCd];
                angular.forEach(conflgRoles, function(conflgRole) {
                    if (vm.subjUserRoles[conflgRole]) {
                        disabled = true;
                    }
                });
                if (disabled) {
                    $('#' + userRoleTypeCd + '_ar' + 'Div > .icheckbox_square-idmx').addClass('idmx_cursor_not_allowed');
                } else {
                    $('#' + userRoleTypeCd + '_ar' + 'Div > .icheckbox_square-idmx').removeClass('idmx_cursor_not_allowed');
                }
                return disabled;
            };

            function triggerValidations() {
                angular.forEach($scope.subjForm.$error.required, function(field) {
                    field.$setDirty();
                });
            }

            vm.validateDate = function(dateInput) {
                var isDateValid = moment(dateInput, dateFormat, true).isValid();
                if (isDateValid) {
                    vm.subject.subjEffDate = moment(dateInput, dateFormat).format('YYYY-MM-DD');
                    return true;
                }
                return false;
            };

            vm.validateUserOrgRoleTypes = function() {
                var valid = false;
                for (var key in vm.subjOrgRoles) {
                    if (vm.subjOrgRoles[key]) {
                        valid = true;
                        break;
                    }
                }
                return valid;
            };

            vm.validateUserRoleTypes = function() {
                var valid = false;
                for (var key in vm.subjUserRoles) {
                    if (vm.subjUserRoles[key]) {
                        valid = true;
                        break;
                    }
                }
                return valid;
            };

            vm.submit = function(subjForm) {
                disableSubmit();
                triggerValidations();
                if ($.isEmptyObject(subjForm.$error) && vm.validateUserOrgRoleTypes() && vm.validateUserRoleTypes() && checkRoles()) {
                    vm.ladda = true;
                    prepareRolesForSubmit();
                    SubjectsService.repeat(vm.subject, function onSuccess() {
                        toastr.success(
                            $translate.instant('subj.reptSubj.toast.reptSubjSuccess'),
                            $translate.instant('subj.reptSubj.pageTitle'),
                            toastr.options
                        );
                        $state.go('app.subjects', {}, {reload: true});
                    }, function onError() {
                        vm.ladda = false;
                        toastr.error(
                            $translate.instant('subj.reptSubj.toast.reptSubjError'),
                            $translate.instant('subj.reptSubj.pageTitle'),
                            toastr.options
                        );
                    });
                }
            };

            function checkRoles() {
                for (var reqdOrgKey in vm.reqdTargSubjOrgRoles) {
                    if (!vm.reqdTargSubjOrgRoles[reqdOrgKey].orgId) {
                        return false;
                    }
                }
                for (var reqdUserKey in vm.reqdTargSubjUserRoles) {
                    if (!vm.reqdTargSubjUserRoles[reqdUserKey].userId) {
                        return false;
                    }
                }
                return true;
            }

            function prepareRolesForSubmit() {
                vm.subject.subjOrgRoles = {};
                //add org roles to vm.subject
                angular.forEach(vm.reqdTargOrgRoleTypes, function(reqdTargOrgRoleType) {
                    vm.subject.subjOrgRoles[reqdTargOrgRoleType.cd] = [];
                    if (reqdTargOrgRoleType.entity.subjTargOrgRoleFlag) {
                        //if targ then copy existing data
                        angular.forEach(subject.subjReqdTargOrgRoles[reqdTargOrgRoleType.cd], function(subjReqdOrgId) {
                            vm.subject.subjOrgRoles[reqdTargOrgRoleType.cd].push(subjReqdOrgId);
                        });
                    } else {
                        //if reqd then get from model
                        vm.subject.subjOrgRoles[reqdTargOrgRoleType.cd].push(vm.reqdTargSubjOrgRoles[reqdTargOrgRoleType.cd].orgId);
                    }
                });

                //add user org roles to vm.subject if don't already exist
                for (var subjOrgKey in vm.subjOrgRoles) {
                    if (vm.subjOrgRoles[subjOrgKey]) {
                        if (vm.subject.subjOrgRoles[subjOrgKey]) {
                            if (vm.subject.subjOrgRoles[subjOrgKey].indexOf(orgId) === -1) {
                                vm.subject.subjOrgRoles[subjOrgKey].push(orgId);
                            }
                        } else {
                            vm.subject.subjOrgRoles[subjOrgKey] = [orgId];
                        }
                    }
                }

                vm.subject.subjUserRoles = {};
                //add user roles to vm.subject
                angular.forEach(vm.reqdTargUserRoleTypes, function(reqdTargUserRoleType) {
                    vm.subject.subjUserRoles[reqdTargUserRoleType.cd] = [];
                    if (reqdTargUserRoleType.entity.subjTargUsrRoleFlag) {
                        //if targ then copy existing data
                        angular.forEach(subject.subjReqdTargUserRoles[reqdTargUserRoleType.cd], function(subjReqdUser) {
                            vm.subject.subjUserRoles[reqdTargUserRoleType.cd].push(subjReqdUser.userId);
                        });
                    } else {
                        //if reqd then get from model
                        vm.subject.subjUserRoles[reqdTargUserRoleType.cd].push(vm.reqdTargSubjUserRoles[reqdTargUserRoleType.cd].userId);
                    }
                });

                //add user roles to vm.subject if don't already exist
                for (var subjUserKey in vm.subjUserRoles) {
                    if (vm.subjUserRoles[subjUserKey]) {
                        if (vm.subject.subjUserRoles[subjUserKey]) {
                            if (vm.subject.subjUserRoles[subjUserKey].indexOf(account.data.userId) === -1) {
                                vm.subject.subjUserRoles[subjUserKey].push(account.data.userId);
                            }
                        } else {
                            vm.subject.subjUserRoles[subjUserKey] = [account.data.userId];
                        }
                    }
                }
            }

            vm.onKeyDown = function($event) {
                var keyCode = $event.keyCode || $event.which;
                if (keyCode === 13) {
                    $event.preventDefault();
                } else if (keyCode === 8) {
                    enableSubmit();
                }
            };

            $('input').on('keypress', function() {
                enableSubmit();
            });

            $('input').on('paste', function () {
                enableSubmit();
            });

            function enableSubmit() {
                $('.add-sub-submit-btn').attr('disabled', false);
            }

            function disableSubmit() {
                $('.add-sub-submit-btn').attr('disabled', true);
            }

        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('editSubjEffectiveDate', [editSubjEffectiveDate]);

    function editSubjEffectiveDate() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                if (scope.$root.subject) {
                    field.$validators.subjDateInvalid = function(modelValue) {
                        if (scope.updateSubForm) {
                            if (modelValue !== undefined && modelValue !== '') {
                                var isDateValid = scope.vm.validateDate(modelValue);
                                if (!isDateValid) {
                                    scope.updateSubForm.subjEffectiveDate.$invalid = true;
                                    scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateInvalid', false);
                                    return false;
                                }
                                scope.updateSubForm.subjEffectiveDate.$valid = true;
                                scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                                return true;
                            }
                            scope.updateSubForm.subjEffectiveDate.$valid = true;
                            scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                            return true;
                        }
                    };

                    field.$validators.subjDateGtPrevValid = function(modelValue) {
                        if (scope.updateSubForm) {
                            if (!scope.updateSubForm.subjEffectiveDate.$error.subjDateInvalid && modelValue) {
                                if (scope.vm.prevSubjEffDate) {
                                    var prevSubjDate = new Date(scope.vm.prevSubjEffDate);
                                    var date = moment(modelValue, scope.vm.datePlaceholder).format('YYYY-MM-DD');
                                    var currentSubjDate = new Date(date);

                                    // current eff date should be greater than the previous subject eff date.
                                    if (currentSubjDate > prevSubjDate) { // valid
                                        setTimeout(function() {
                                            scope.updateSubForm.subjEffectiveDate.$valid = true;
                                            scope.$digest();
                                        }, 0);
                                        scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                                        return true;
                                    }
                                    // invalid
                                    setTimeout(function() {
                                        scope.updateSubForm.subjEffectiveDate.$invalid = true;
                                        scope.$digest();
                                    }, 0);
                                    scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', false);
                                    return false;
                                }
                            } else {
                                scope.updateSubForm.subjEffectiveDate.$valid = true;
                                scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                                return true;
                            }
                        }
                    };

                    field.$validators.subjDateLtPrevValid = function(modelValue) {
                        if (scope.updateSubForm) {
                            if (!scope.updateSubForm.subjEffectiveDate.$error.subjDateInvalid && modelValue) {
                                if (scope.vm.nextSubjEffDate) {
                                    var nextSubjDate = new Date(scope.vm.nextSubjEffDate);
                                    var date = moment(modelValue, scope.vm.datePlaceholder).format('YYYY-MM-DD');
                                    var currentSubjDate = new Date(date);

                                    // current eff date should be smaller than the next subject eff date
                                    if (currentSubjDate < nextSubjDate) { // valid
                                        setTimeout(function() {
                                            scope.updateSubForm.subjEffectiveDate.$valid = true;
                                            scope.$digest();
                                        }, 0);
                                        scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateLtPrevValid', true);
                                        return true;
                                    }
                                    // invalid
                                    setTimeout(function() {
                                        scope.updateSubForm.subjEffectiveDate.$invalid = true;
                                        scope.$digest();
                                    }, 0);
                                    scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateLtPrevValid', false);
                                    return false;
                                }
                            } else {
                                scope.updateSubForm.subjEffectiveDate.$valid = true;
                                scope.updateSubForm.subjEffectiveDate.$setValidity('subjDateLtPrevValid', true);
                                return true;
                            }
                        }
                    };
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('EditSubjectCtrl', ['$rootScope', '$state', '$translate', '$filter', 'SubjectsService', 'subject', 'account', 'collab', EditSubjectCtrl]);

    function EditSubjectCtrl($rootScope, $state, $translate, $filter, SubjectsService, subject, account, collab) {
        var vm = this;
        vm.ladda = false;
        if (subject.status === 403) {
            $rootScope.subject = null;
        } else {
            vm.owner = account.data.userFirstLastName;
            vm.orgName = account.data.orgName;
            vm.nextSubjEffDate = subject.nextSubjEffDate;
            vm.prevSubjEffDate = subject.prevSubjEffDate;
            vm.subjStageName = subject.subjStageName;
            $rootScope.subject = subject;
            $('#subjEffectiveDate').focus(); //for initial cursor position
            vm.subject = {
                subjId: subject.subjId,
                subjDesc: subject.subjDesc,
                subjEffDate: subject.subjEffDate,
                subjStatCd: 'A'
            };

            var references = $rootScope.referenceData;

            var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
            var fullDateFormat = references.DATE_FORMT_CD.refItems.filter(function(refData) {
                return (refData.cd === prefDateFormat);
            });
            var dateFormat = fullDateFormat[0].nm;
            vm.datePlaceholder = dateFormat;
            vm.dateMask = dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

            //datepicker options
            $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
            $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = dateFormat.toLowerCase();
            $.fn.datepicker.defaults.todayHighlight = true;
            $.fn.datepicker.defaults.autoclose = true;
            $.fn.datepicker.defaults.showOnFocus = false;
            $('#datepicker').datepicker().on('changeDate', function() {
                $('.add-sub-submit-btn').attr('disabled', false);
                $('#subjEffectiveDate').focus();
            });

            if (vm.subject.subjEffDate) {
                vm.subjEffectiveDate = moment(vm.subject.subjEffDate, 'YYYY-MM-DD').format(dateFormat);
            }

            // Filter all the org role types.
            vm.orgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return orgRoleType.entity.subjBasedOrgRoleFlag;
            });

            // Filter all the required/target user role types.
            vm.userRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
                return userRoleType.entity.subjBasedUsrRoleFlag;
            });

            vm.orgsForOrgRole = function(orgRoleType) {
                var orgsForOrgRole = [];
                angular.forEach(collab.collabOrgs, function(org) {
                    if (org.subjOrgRoles.indexOf(orgRoleType) >= 0) {
                        orgsForOrgRole.push(org);
                    }
                });
                return orgsForOrgRole;
            };

            vm.usersForUserRole = function(userRoleType) {
                var usersForUserRole = [];
                angular.forEach(collab.collabUsers, function(user) {
                    if (user.subjUserRoles.indexOf(userRoleType) >= 0) {
                        usersForUserRole.push(user);
                    }
                });
                return usersForUserRole;
            };

            // set saved date in user preferred format
            // method to validate date
            vm.validateDate = function(dateInput) {
                var isDateValid = moment(dateInput, dateFormat, true).isValid();
                if (isDateValid) {
                    vm.subject.subjEffDate = moment(dateInput, dateFormat).format('YYYY-MM-DD');
                    return true;
                }
                return false;
            };

            vm.submit = function(updateSubForm) {
                vm.ladda = true;
                disableSubmit();
                if ($.isEmptyObject(updateSubForm.$error)) {
                    SubjectsService.update(vm.subject, function onSuccess() {
                        toastr.success(
                            $translate.instant('subj.updtSubj.toast.updtSubjSuccess'),
                            $translate.instant('subj.updtSubj.pageTitle'),
                            toastr.options
                        );
                        $state.go('app.subjects', {}, {reload: true});
                    }, function onError() {
                        vm.ladda = false;
                        toastr.error(
                            $translate.instant('subj.updtSubj.toast.updtSubjError'),
                            $translate.instant('subj.updtSubj.pageTitle'),
                            toastr.options
                        );
                    });
                }
            };

            vm.onKeyDown = function($event) {
                var keyCode = $event.keyCode || $event.which;
                if (keyCode === 13) {
                    $event.preventDefault();
                } else if (keyCode === 8) {
                    enableSubmit();
                }
            };

            $('input').on('keypress', function() {
                enableSubmit();
            });

            $('input').on('paste', function () {
                enableSubmit();
            });

            function enableSubmit() {
                $('.add-sub-submit-btn').attr('disabled', false);
            }

            function disableSubmit() {
                $('.add-sub-submit-btn').attr('disabled', true);
            }
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('cloneSubjEffectiveDate', [cloneSubjEffectiveDate]);

    function cloneSubjEffectiveDate() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                if (scope.$root.subject) {
                    field.$validators.subjDateInvalid = function(modelValue) {
                        if (modelValue !== undefined && modelValue !== '') {
                            var isDateValid = scope.vm.validateDate(modelValue);
                            if (!isDateValid) {
                                scope.subjForm.subjEffectiveDate.$invalid = true;
                                scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', false);
                                return false;
                            }
                            scope.subjForm.subjEffectiveDate.$valid = true;
                            scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                            return true;
                        }
                        scope.subjForm.subjEffectiveDate.$valid = true;
                        scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                        return true;
                    };
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('CloneSubjectCtrl', ['$rootScope', '$state', '$translate', '$filter', 'SubjectsService', 'sysParms', 'subject', 'account', 'subjStage', 'orgs', CloneSubjectCtrl]);

    function CloneSubjectCtrl($rootScope, $state, $translate, $filter, SubjectsService, sysParms, subject, account, subjStage, orgs) {
        var vm = this;
        vm.ladda = false;
        if (subject.status === 403) {
            $rootScope.subject = null;
        } else {
            vm.owner = account.data.userFirstLastName;
            vm.orgName = account.data.orgName;
            vm.subjStageName = subjStage.name;
            $rootScope.subject = subject;
            $('#subjEffectiveDate').focus(); //for initial cursor position
            vm.subject = {
                subjId: subject.subjId,
                subjDesc: subject.subjDesc,
                subjEffDate: subject.subjEffDate,
                subjStatCd: 'A'
            };

            vm.sysParms = sysParms.data;
            var references = $rootScope.referenceData;

            var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
            var fullDateFormat = references.DATE_FORMT_CD.refItems.filter(function(refData) {
                return (refData.cd === prefDateFormat);
            });
            var dateFormat = fullDateFormat[0].nm;
            vm.datePlaceholder = dateFormat;
            vm.dateMask = dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

            //datepicker options
            $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
            $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = dateFormat.toLowerCase();
            $.fn.datepicker.defaults.todayHighlight = true;
            $.fn.datepicker.defaults.autoclose = true;
            $.fn.datepicker.defaults.showOnFocus = false;
            $('#datepicker').datepicker().on('changeDate', function() {
                $('.add-sub-submit-btn').attr('disabled', false);
                $('#subjEffectiveDate').focus();
            });

            if (vm.subject.subjEffDate) {
                vm.subjEffectiveDate = moment(vm.subject.subjEffDate, 'YYYY-MM-DD').format(dateFormat);
            }

            vm.reqdSubjOrgRoles = {};
            vm.subjOrgRoles = {};

            // Filter all the required org role types.
            vm.reqdOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return orgRoleType.entity.subjBasedOrgRoleFlag && orgRoleType.entity.reqdSubjOrgRoleFlag;
            });

            // Filter all roles for user org
            vm.userOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
                return account.data.orgRoles.indexOf(orgRoleType.cd) !== -1 && orgRoleType.entity.subjBasedOrgRoleFlag;
            });

            vm.orgsForReqdOrgRole = function(orgRoleType) {
                var orgsForReqdOrgRole = [];
                angular.forEach(subject.subjReqdTargOrgRoles[orgRoleType], function(subjReqdOrgId) {
                    var subjReqdOrg = $filter('filter')(orgs, {
                        orgId: subjReqdOrgId
                    }, true)[0];
                    //returning an object causing an infinite loop error in the HTML - not sure why
                    orgsForReqdOrgRole.push(subjReqdOrg.orgNamePlusRefNum);
                });
                return orgsForReqdOrgRole;
            };

            //initialise vm.reqdSubjOrgRoles with base roles
            for (var key in subject.subjReqdTargOrgRoles) {
                vm.reqdSubjOrgRoles[key] = [];
                angular.forEach(subject.subjReqdTargOrgRoles[key], function(orgId) {
                    var org = $filter('filter')(orgs, {
                        orgId: orgId
                    }, true)[0];
                    vm.reqdSubjOrgRoles[key].push(org.orgNamePlusRefNum);
                });
            }

            //initialise vm.subjOrgRoles with base roles
            angular.forEach(subject.subjUserOrgRoles, function(subjUserOrgRole) {
                vm.subjOrgRoles[subjUserOrgRole] = true;
            });

            vm.subjUserRoles = {};

            vm.userRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
                return userRoleType.entity.subjBasedUsrRoleFlag;
            });

            //initialise vm.subjUserRoles and vm.subject with base roles
            angular.forEach(subject.myUserRoles, function(userRoleType) {
                vm.subjUserRoles[userRoleType] = true;
            });

            // set saved date in user preferred format
            // method to validate date
            vm.validateDate = function(dateInput) {
                var isDateValid = moment(dateInput, dateFormat, true).isValid();
                if (isDateValid) {
                    vm.subject.subjEffDate = moment(dateInput, dateFormat).format('YYYY-MM-DD');
                    return true;
                }
                return false;
            };

            vm.validateUserOrgRoleTypes = function() {
                var valid = false;
                for (var key in vm.subjOrgRoles) {
                    if (vm.subjOrgRoles[key]) {
                        valid = true;
                        break;
                    }
                }
                return valid;
            };

            vm.validateUserRoleTypes = function() {
                var valid = false;
                for (var key in vm.subjUserRoles) {
                    if (vm.subjUserRoles[key]) {
                        valid = true;
                        break;
                    }
                }
                return valid;
            };

            vm.submit = function(subjForm) {
                vm.ladda = true;
                if ($.isEmptyObject(subjForm.$error) && vm.validateUserOrgRoleTypes() && vm.validateUserRoleTypes()) {
                    SubjectsService.clone(vm.subject, function onSuccess() {
                        toastr.success(
                            $translate.instant('subj.cloneSubj.toast.cloneSubjSuccess'),
                            $translate.instant('subj.cloneSubj.pageTitle'),
                            toastr.options
                        );
                        $state.go('app.subjects', {}, {reload: true});
                    }, function onError() {
                        vm.ladda = false;
                        toastr.error(
                            $translate.instant('subj.cloneSubj.toast.cloneSubjError'),
                            $translate.instant('subj.cloneSubj.pageTitle'),
                            toastr.options
                        );
                    });
                }
            };

            vm.onKeyDown = function($event) {
                var keyCode = $event.keyCode || $event.which;
                if (keyCode === 13) {
                    $event.preventDefault();
                }
            };
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('addSubjEffectiveDate', [addSubjEffectiveDate]);

    function addSubjEffectiveDate() {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, field) {
                field.$validators.subjDateInvalid = function(modelValue) {
                    if (modelValue !== undefined && modelValue !== '') {
                        var isDateValid = scope.vm.validateDate(modelValue);
                        if (!isDateValid) {
                            scope.subjForm.subjEffectiveDate.$invalid = true;
                            scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', false);
                            return false;
                        }
                        scope.subjForm.subjEffectiveDate.$valid = true;
                        scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                        return true;
                    }
                    scope.subjForm.subjEffectiveDate.$valid = true;
                    scope.subjForm.subjEffectiveDate.$setValidity('subjDateInvalid', true);
                    return true;
                };

                field.$validators.subjDateGtPrevValid = function(modelValue) {
                    if (!scope.subjForm.subjEffectiveDate.$error.subjDateInvalid && modelValue) {
                        if (scope.vm.repeatSubject) {
                            var maxSubjEffDate = new Date(scope.vm.repeatSubject.subjEffDate);
                            var date = moment(modelValue, scope.vm.datePlaceholder).format('YYYY-MM-DD');
                            var currentSubjDate = new Date(date);
                            // current eff date should be greater than the previous subject eff date.
                            if (currentSubjDate > maxSubjEffDate) { // valid
                                setTimeout(function() {
                                    scope.subjForm.subjEffectiveDate.$valid = true;
                                    scope.$digest();
                                }, 0);
                                scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                                return true;
                            }
                            setTimeout(function() {
                                scope.subjForm.subjEffectiveDate.$invalid = true;
                                scope.$digest();
                            }, 0);
                            scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', false);
                            return false;
                        }
                    } else {
                        scope.subjForm.subjEffectiveDate.$valid = true;
                        scope.subjForm.subjEffectiveDate.$setValidity('subjDateGtPrevValid', true);
                        return true;
                    }
                };
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('AddSubjectCtrl', ['$rootScope', '$scope', '$state', '$translate', '$filter', 'SubjectsService', 'Principal', 'conflgUsrRoles', 'conflgOrgRoles', 'account', 'subjStage', 'orgs', 'users', 'targetRoleTypeName', AddSubjectCtrl]);

    function AddSubjectCtrl($rootScope, $scope, $state, $translate, $filter, SubjectsService, Principal, conflgUsrRoles, conflgOrgRoles, account, subjStage, orgs, users, targetRoleTypeName) {
        var vm = this;
        vm.ladda = false;
        vm.owner = account.data.userFirstLastName;
        var orgId = account.data.orgId;
        vm.orgName = account.data.orgName;
        vm.subjUserRolesDirty = false;
        vm.subjOrgRolesDirty = false;
        vm.subjStageName = subjStage.name;
        vm.targetRoleTypeName = targetRoleTypeName.data;
        $('#subjEffectiveDate').focus(); //for initial cursor position
        vm.subject = {
            subjId: null,
            subjDesc: '',
            subjEffDate: '',
            subjStatCd: 'A',
            subjDataCloneFlag: null
        };

        var references = $rootScope.referenceData;

        vm.repeatSubject = null;

        var prefDateFormat = account.data.userPrefs.PREF_DATE_FORMT;
        var fullDateFormat = references.DATE_FORMT_CD.refItems.filter(function(refData) {
            return (refData.cd === prefDateFormat);
        });

        //get perms and store locally so don't get stuck in loop when Principal is cleared on logout
        var userPerms = Principal.userPerms();
        vm.hasPerm = function(perm) {
            return userPerms.indexOf(perm) !== -1;
        };

        var dateFormat = fullDateFormat[0].nm;
        vm.datePlaceholder = dateFormat;
        vm.dateMask = dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

        //datepicker options
        $.fn.datepicker.defaults.language = $rootScope.userLang.toLowerCase();
        $.fn.datepicker.dates[$rootScope.userLang.toLowerCase()].format = dateFormat.toLowerCase();
        $.fn.datepicker.defaults.todayHighlight = true;
        $.fn.datepicker.defaults.autoclose = true;
        $.fn.datepicker.defaults.showOnFocus = false;
        $('#datepicker').datepicker().on('changeDate', function() {
            $('.add-sub-submit-btn').attr('disabled', false);
            $('#subjEffectiveDate').focus();
        });

        vm.subjEffectiveDate = moment().format(dateFormat);

        vm.showCloneFlag = function() {
            return $rootScope.sysParms.SUBJ_DATA_CLONE_END_USR_DECSN_FLAG.toLowerCase() === 'true' && vm.repeatSubject;
        };

        ////////////
        //org roles
        ////////////

        vm.reqdSubjOrgRoles = {};
        vm.subjOrgRoles = {};

        // Filter all the required org role types.
        vm.reqdOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
            return orgRoleType.entity.subjBasedOrgRoleFlag && orgRoleType.entity.reqdSubjOrgRoleFlag;
        });

        // Filter all roles for user org
        vm.userOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(role) {
            return account.data.orgRoles.indexOf(role.cd) !== -1 && role.entity.subjBasedOrgRoleFlag;
        });

        vm.orgsForOrgRole = function(orgRoleType) {
            var orgsForOrgRole = [];
            angular.forEach(orgs, function(org) {
                if (org.roles.indexOf(orgRoleType) > -1) {
                    orgsForOrgRole.push({
                        orgId: org.orgId,
                        orgNamePlusRefNum: org.orgNamePlusRefNum,
                        cd: orgRoleType
                    });
                }
            });
            if (orgsForOrgRole.length === 1) {
                enableSubmit();
                angular.forEach(vm.reqdOrgRoleTypes, function(reqdOrgRoleType) {
                    if (reqdOrgRoleType.cd === orgRoleType) {
                        vm.reqdSubjOrgRoles[orgRoleType] = orgsForOrgRole[0];
                        if (orgsForOrgRole[0].orgId === orgId) {
                            vm.subjOrgRoles[orgRoleType] = true;
                        }
                    }
                });
            }
            return $filter('orderBy')(orgsForOrgRole, 'orgNamePlusRefNum');
        };

        // Filter all the required org role types.
        vm.notReqdOrgRoleTypes = references.ORG_ROLE_TYPE.refItems.filter(function(orgRoleType) {
            return orgRoleType.entity.subjBasedOrgRoleFlag && !orgRoleType.entity.reqdSubjOrgRoleFlag && $filter('filter')(vm.orgsForOrgRole(orgRoleType.cd), {orgId: orgId}, true).length > 0;
        });
        if (vm.notReqdOrgRoleTypes.length === 1) {
            vm.subjOrgRoles[vm.notReqdOrgRoleTypes[0].cd] = true;
        }

        //initialise vm.reqdSubjOrgRoles and vm.subjOrgRoles with required roles that only have one org
        angular.forEach(vm.reqdOrgRoleTypes, function(orgRoleType) {
            vm.orgsForOrgRole(orgRoleType.cd);
        });

        vm.orgRoleTypeConflict = function(orgRoleTypeCd) {
            if (!vm.reqdSubjOrgRoles[orgRoleTypeCd]) {
                return null;
            }
            var conflict = null;
            if (conflgOrgRoles.data[orgRoleTypeCd]) {
                angular.forEach(conflgOrgRoles.data[orgRoleTypeCd], function(relatedConflgRole) {
                    if (vm.reqdSubjOrgRoles[relatedConflgRole] && vm.reqdSubjOrgRoles[relatedConflgRole].orgId === vm.reqdSubjOrgRoles[orgRoleTypeCd].orgId) {
                        conflict = $filter('filter')(vm.reqdOrgRoleTypes, {cd: vm.reqdSubjOrgRoles[relatedConflgRole].cd}, true)[0].nm;
                    }
                });
            }
            return conflict;
        };

        vm.showMyOrgRoleTypes = function() {
            var show = true;
            angular.forEach(vm.reqdOrgRoleTypes, function(reqdOrgRoleType) {
                if (!vm.reqdSubjOrgRoles[reqdOrgRoleType.cd] || !vm.reqdSubjOrgRoles[reqdOrgRoleType.cd].orgId || vm.reqdSubjOrgRoles[reqdOrgRoleType.cd].orgId === orgId) {
                    show = false;
                }
            });
            return show;
        };

        //enable/disable org role checkboxes
        vm.isMyOrgRoleTypeDisabled = function(orgRoleType) {
            var disabled = vm.notReqdOrgRoleTypes.length === 1;

            //check for conflicting roles
            var conflgRoles = conflgOrgRoles.data[orgRoleType];
            angular.forEach(conflgRoles, function(conflgRole) {
                if (vm.subjOrgRoles[conflgRole]) {
                    disabled = true;
                }
            });

            if (disabled) {
                $('#' + orgRoleType + '_or' + 'Div > .icheckbox_square-idmx').addClass('idmx_cursor_not_allowed');
            } else {
                $('#' + orgRoleType + '_or' + 'Div > .icheckbox_square-idmx').removeClass('idmx_cursor_not_allowed');
            }
            return disabled;
        };

        //selection of reqd org role typeahead
        vm.reqdOrgRoleTypesChanged = function() {
            checkUnique();
            disableSubmit();
        };

        //update of reqd org role typeahead
        vm.reqdOrgRoleTypesSelected = function() {
            checkUnique();
            enableSubmit();
        };

        vm.reqdOrgRoleTypesSelectedFromDropdown = function() {
            checkUnique();
            enableSubmit();
        };

        //update of user org role checkboxes
        vm.updateMyOrgRoleTypes = function() {
            checkUnique();
            enableSubmit();
        };

        ////////////
        //user roles
        ////////////

        vm.reqdSubjUserRoles = {};
        vm.subjUserRoles = {};

        vm.userRoleTypes = references.USR_ROLE_TYPE.refItems.filter(function(userRoleType) {
            return userRoleType.entity.subjBasedUsrRoleFlag;
        });

        vm.reqdUserRoleTypes = vm.userRoleTypes.filter(function(userRoleType) {
            return userRoleType.entity.reqdSubjUsrRoleFlag;
        });

        vm.usersForUserRole = function(userRoleTypeCd) {
            var usersForUserRole = [];
            angular.forEach(users, function(user) {
                usersForUserRole.push({
                    userId: user.userId,
                    userLastFirstNamePlusOrgPlusId: user.userLastFirstNamePlusOrgPlusId,
                    cd: userRoleTypeCd
                });
            });
            if (usersForUserRole.length === 1) {
                enableSubmit();
                angular.forEach(vm.reqdUserRoleTypes, function(reqdUserRoleType) {
                    if (reqdUserRoleType.cd === userRoleTypeCd) {
                        vm.reqdSubjUserRoles[userRoleTypeCd] = usersForUserRole[0];
                        if (usersForUserRole[0].userId === account.data.userId) {
                            vm.subjUserRoles[userRoleTypeCd] = true;
                        }
                    }
                });
            }
            return $filter('orderBy')(usersForUserRole, 'userLastFirstNamePlusOrgPlusId');
        };

        vm.notReqdUserRoleTypes = vm.userRoleTypes.filter(function(userRoleType) {
            return !userRoleType.entity.reqdSubjUsrRoleFlag;
        });
        if (vm.notReqdUserRoleTypes.length === 1) {
            vm.subjUserRoles[vm.notReqdUserRoleTypes[0].cd] = true;
        }

        vm.userRoleTypeConflict = function(userRoleTypeCd) {
            if (!vm.reqdSubjUserRoles[userRoleTypeCd]) {
                return null;
            }
            var conflict = null;
            if (conflgUsrRoles.data[userRoleTypeCd]) {
                angular.forEach(conflgUsrRoles.data[userRoleTypeCd], function(relatedConflgRole) {
                    if (vm.reqdSubjUserRoles[relatedConflgRole] && vm.reqdSubjUserRoles[relatedConflgRole].userId === vm.reqdSubjUserRoles[userRoleTypeCd].userId) {
                        conflict = $filter('filter')(vm.reqdUserRoleTypes, {cd: vm.reqdSubjUserRoles[relatedConflgRole].cd}, true)[0].nm;
                    }
                });
            }
            return conflict;
        };

        vm.showMyUserRoleTypes = function() {
            var show = true;
            angular.forEach(vm.reqdUserRoleTypes, function(reqdUserRoleType) {
                if (!vm.reqdSubjUserRoles[reqdUserRoleType.cd] || !vm.reqdSubjUserRoles[reqdUserRoleType.cd].userId || vm.reqdSubjUserRoles[reqdUserRoleType.cd].userId === account.data.userId) {
                    show = false;
                }
            });
            return show;
        };

        // enables/disables userRoleType checkboxes
        vm.isMyUserRoleTypeDisabled = function(userRoleType) {
            var disabled = vm.notReqdUserRoleTypes.length === 1;

            //check role conflicting
            var conflgRoles = conflgUsrRoles.data[userRoleType];
            angular.forEach(conflgRoles, function(conflgRole) {
                if (vm.subjUserRoles[conflgRole]) {
                    disabled = true;
                }
            });
            if (disabled) {
                $('#' + userRoleType + '_ar' + 'Div > .icheckbox_square-idmx').addClass('idmx_cursor_not_allowed');
            } else {
                $('#' + userRoleType + '_ar' + 'Div > .icheckbox_square-idmx').removeClass('idmx_cursor_not_allowed');
            }
            return disabled;
        };

        //selection of reqd user role typeahead
        vm.reqdUserRoleTypesChanged = function() {
            checkUnique();
            disableSubmit();
        };

        //update of reqd user role typeahead
        vm.reqdUserRoleTypesSelected = function() {
            checkUnique();
            enableSubmit();
        };

        vm.reqdUserRoleTypesSelectedFromDropdown = function() {
            checkUnique();
            enableSubmit();
        };

        vm.updateSubjUserRoleTypes = function() {
            checkUnique();
            enableSubmit();
        };

        /////////////
        // uniqueness
        /////////////

        function checkUnique() {
            //org roles
            var subjOrgRoles = {};
            for (var reqdOrgKey in vm.reqdSubjOrgRoles) {
                if (vm.reqdSubjOrgRoles[reqdOrgKey]) {
                    subjOrgRoles[reqdOrgKey] = [vm.reqdSubjOrgRoles[reqdOrgKey].orgId];
                }
            }
            //user roles
            var subjUserRoles = {};
            for (var userKey in vm.reqdSubjUserRoles) {
                if (vm.reqdSubjUserRoles[userKey] && vm.reqdSubjUserRoles[userKey].userId) {
                    subjUserRoles[userKey] = [vm.reqdSubjUserRoles[userKey].userId];
                }
            }
            var roles = {
                subjOrgRoles: subjOrgRoles,
                subjUserRoles: subjUserRoles
            };
            SubjectsService.unique(roles, function onSuccess(data) {
                if (data.subjId) {
                    vm.repeatSubject = data;
                } else {
                    vm.repeatSubject = null;
                }
                $scope.subjForm.subjEffectiveDate.$validate();
            });
        }
        checkUnique();

        function triggerValidations() {
            angular.forEach($scope.subjForm.$error.required, function(field) {
                field.$setDirty();
            });
        }

        vm.validateDate = function(dateInput) {
            var isDateValid = moment(dateInput, dateFormat, true).isValid();
            if (isDateValid) {
                vm.subject.subjEffDate = moment(dateInput, dateFormat).format('YYYY-MM-DD');
                return true;
            }
            return false;
        };

        function validateReqdOrgRoles() {
            var valid = true;
            angular.forEach(vm.reqdOrgRoleTypes, function(orgRoleType) {
                if (vm.orgRoleTypeConflict(orgRoleType.cd)) {
                    valid = false;
                }
            });
            return valid;
        }

        function validateReqdUserRoles() {
            var valid = true;
            angular.forEach(vm.reqdUserRoleTypes, function(userRoleType) {
                if (vm.userRoleTypeConflict(userRoleType.cd)) {
                    valid = false;
                }
            });
            return valid;
        }

        vm.validateMyOrgRoles = function() {
            if (!vm.showMyOrgRoleTypes()) {
                return true;
            }
            var valid = false;
            angular.forEach(vm.notReqdOrgRoleTypes, function(orgRoleType) {
                if (vm.subjOrgRoles[orgRoleType.cd]) {
                    valid = true;
                }
            });
            return valid;
        };

        vm.validateMyUserRoles = function() {
            if (!vm.showMyUserRoleTypes()) {
                return true;
            }
            var valid = false;
            angular.forEach(vm.notReqdUserRoleTypes, function(userRoleType) {
                if (vm.subjUserRoles[userRoleType.cd]) {
                    valid = true;
                }
            });
            return valid;
        };

        vm.submit = function(subjForm) {
            disableSubmit();
            triggerValidations();
            if ($.isEmptyObject(subjForm.$error) && validateReqdOrgRoles() && validateReqdUserRoles() && vm.validateMyOrgRoles() && vm.validateMyUserRoles()) {
                vm.ladda = true;
                prepareRolesForSubmit();
                SubjectsService.create(vm.subject, function onSuccess() {
                    toastr.success(
                        $translate.instant('subj.addSubj.toast.addSubjSuccess'),
                        $translate.instant('subj.addSubj.pageTitle'),
                        toastr.options
                    );
                    $state.go('app.subjects', {}, {reload: true});
                }, function onError() {
                    vm.ladda = false;
                    toastr.error(
                        $translate.instant('subj.addSubj.toast.addSubjError'),
                        $translate.instant('subj.addSubj.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        function prepareRolesForSubmit() {
            vm.subject.subjOrgRoles = {};
            //add reqd roles to vm.subject
            for (var reqdOrgKey in vm.reqdSubjOrgRoles) {
                vm.subject.subjOrgRoles[reqdOrgKey] = [vm.reqdSubjOrgRoles[reqdOrgKey].orgId];
            }
            if (vm.showMyOrgRoleTypes()) {
                for (var subjOrgKey in vm.subjOrgRoles) {
                    if (vm.subjOrgRoles[subjOrgKey]) {
                        var userSubjOrgRole = subjOrgKey;
                        if (vm.subject.subjOrgRoles[userSubjOrgRole]) {
                            if (vm.subject.subjOrgRoles[userSubjOrgRole].indexOf(orgId) === -1) {
                                vm.subject.subjOrgRoles[userSubjOrgRole].push(orgId);
                            }
                        } else {
                            vm.subject.subjOrgRoles[userSubjOrgRole] = [orgId];
                        }
                    }
                }
            }

            vm.subject.subjUserRoles = {};
            //add reqd user roles to vm.subject
            for (var reqdUserKey in vm.reqdSubjUserRoles) {
                vm.subject.subjUserRoles[reqdUserKey] = [vm.reqdSubjUserRoles[reqdUserKey].userId];
            }
            if (vm.showMyUserRoleTypes()) {
                for (var subjUserKey in vm.subjUserRoles) {
                    if (vm.subjUserRoles[subjUserKey]) {
                        var userSubjUserRole = subjUserKey;
                        if (vm.subject.subjUserRoles[userSubjUserRole]) {
                            if (vm.subject.subjUserRoles[userSubjUserRole].indexOf(account.data.userId) === -1) {
                                vm.subject.subjUserRoles[userSubjUserRole].push(account.data.userId);
                            }
                        } else {
                            vm.subject.subjUserRoles[userSubjUserRole] = [account.data.userId];
                        }
                    }
                }
            }
        }

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                enableSubmit();
            }
        };

        $('input').on('keypress', function() {
            enableSubmit();
        });

        $('input').on('paste', function () {
            enableSubmit();
        });

        function enableSubmit() {
            $('.add-sub-submit-btn').attr('disabled', false);
        }

        function disableSubmit() {
            $('.add-sub-submit-btn').attr('disabled', true);
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('SubjectService', ['$resource', 'apiUrl', SubjectService]);

    function SubjectService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'subjects/:subjectId?view=detail', {}, {
            query: {
                method: 'GET',
                isArray: true
            },
            get: {
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            getMin: {
                url: apiUrl + 'subjects/:subjectId?view=min',
                method: 'GET',
                isArray: false
            },
            getTab: {
                url: apiUrl + 'subjects/:subjectId?view=tab',
                method: 'GET',
                isArray: false
            },
            getDetail: {
                url: apiUrl + 'subjects/:subjectId?view=detail',
                method: 'GET',
                isArray: false
            },
            getFlwupSubj: {
                url: apiUrl + 'subjects/:subjectId/getFlwupSubj',
                method: 'GET',
                isArray: false
            },
            getCollab: {
                url: apiUrl + 'subjects/:subjectId?view=collab',
                method: 'GET',
                isArray: false
            },
            getSubjEvents: {
                url: apiUrl + 'subjects/:subjId/events',
                method: 'GET'
            },
            changeStage: {
                url: apiUrl + 'subjects/changeStage/:subjId/:increment',
                method: 'PUT'
            },
            acknowEvents: {
                url: apiUrl + 'subjects/:subjId/acknowEvents',
                method: 'GET'
            },
            getUserActivityMetrics: {
                url: apiUrl + 'subjects/:subjId/activityMetrics?tz=:tz',
                method: 'GET',
                isArray: true
            },
            getSubjCurrStageFeat: {
                url: apiUrl + 'subjects/:subjId/stagefeat/:featCd',
                method: 'GET'
            }
        });
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', routeConfig]);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.subject', {
                url: '/subject/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/subject/subject.html',
                        controller: 'SubjCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'Subject Name',
                        pageTitle: 'subj.home.pageTitle',
                        pageDesc: 'subj.home.pageDesc'
                    },
                    icon: 'fa-briefcase',
                    showIconInMenu: true,
                    showInMenu: 'subject',
                    menuDispSeq: 3
                },
                resolve: {
                    subject: ['SubjectService', '$stateParams', getSubject],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subj');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.subject.summary', {
                abstract: true,
                url: '/summary',
                data: {
                    subjPerms: ['VIEW_DASH', 'VIEW_ACTVTY', 'DOWNLD_REPT'],
                    i18n: {
                        menu: 'menu.subj.summ'
                    },
                    icon: 'fa-sun-o',
                    showIconInMenu: true
                }
            })
            .state('app.subject.summary.dashboard', {
                url: '/dashboard',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/summary/dashboard/dashboard.html',
                        controller: 'DashboardCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_DASH'],
                    i18n: {
                        menu: 'menu.subj.dashbrd',
                        pageTitle: 'subj.dashbrd.pageTitle',
                        pageDesc: 'subj.dashbrd.pageDesc',
                        subjPermsMsg: 'subj.dashbrd.valid.noViewDashPermsn'
                    },
                    icon: 'fa-th-large',
                    showIconInMenu: false
                },
                resolve: {
                    userActivityMetrics: ['SubjectService', '$stateParams', getUserActivityMetrics]
                }
            })
            .state('app.subject.summary.activity', {
                url: '/activity',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/summary/activity/activity.html',
                        controller: 'ActivityCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_ACTVTY'],
                    i18n: {
                        menu: 'menu.subj.actvty',
                        pageTitle: 'subj.actvty.pageTitle',
                        pageDesc: 'subj.actvty.pageDesc',
                        subjPermsMsg: 'subj.actvty.valid.noViewActvtyPermsn'
                    },
                    icon: 'fa-comments-o',
                    showIconInMenu: false
                },
                resolve: {
                    events: ['SubjectService', '$stateParams', getSubjEvents]
                }
            })
            .state('app.subject.summary.reports', {
                url: '/reports',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/summary/reports/reports.html',
                        controller: 'ReportsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['DOWNLD_REPT'],
                    i18n: {
                        menu: 'menu.subj.repts',
                        pageTitle: 'subj.repts.pageTitle',
                        pageDesc: 'subj.repts.pageDesc',
                        subjPermsMsg: 'subj.repts.valid.noDownldReptPermsn'
                    },
                    icon: 'fa-file-text-o',
                    showIconInMenu: false
                },
                resolve: {
                    reports: [function() {
                        return null;
                    }]
                }
            })
            .state('app.subject.survey', {
                abstract: true,
                url: '/survey',
                data: {
                    section: 'survey',
                    subjPerms: ['UPDT_SURV', 'VIEW_SURV'],
                    i18n: {
                        menu: 'menu.subj.survey'
                    },
                    icon: 'fa-edit',
                    showIconInMenu: true,
                    setSubtitle: true,
                    setBreadcrumb: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('surv');
                        return $translate.refresh();
                    }]
                }
            })

            .state('app.subject.survey.section', {
                url: '/section/:sectionIdx',
                views: {
                    'subjContent@app.subject': {
                        template: '',
                        controller: 'SurvSwitchCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        pageTitle: 'surv.updtSurv.pageTitle',
                        pageDesc: 'surv.updtSurv.pageDesc',
                        subjPermsMsg: 'surv.home.valid.noSurvPermsn'
                    }
                },
                resolve: {
                    surveyState: ['SurveyService', '$stateParams', getSurveyState]
                }
            })

            .state('app.subject.survey.section.update', {
                url: '/update',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/survey/survey.html',
                        controller: 'SurveyCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['UPDT_SURV'],
                    i18n: {
                        menu: 'Survey Section',
                        pageTitle: 'surv.updtSurv.pageTitle',
                        pageDesc: 'surv.updtSurv.pageDesc',
                        subjPermsMsg: 'surv.home.valid.noSurvPermsn'
                    },
                    showInMenu: 'never'
                }
            })

            .state('app.subject.survey.section.view', {
                url: '/view',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/survey/survey.html',
                        controller: 'SurveyCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'Survey Section',
                        pageTitle: 'surv.viewSurv.pageTitle',
                        pageDesc: 'surv.viewSurv.pageDesc',
                        subjPermsMsg: 'surv.home.valid.noSurvPermsn'

                    },
                    showInMenu: 'never'
                }
            })

            .state('app.subject.observations', {
                url: '/observations',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/observations/observations.html',
                        controller: 'ObservationsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_OBSV'],
                    section: 'observations',
                    i18n: {
                        menu: 'menu.subj.obsvs',
                        pageTitle: 'obsv.home.pageTitle',
                        pageDesc: 'obsv.home.pageDesc',
                        subjPermsMsg: 'obsv.home.valid.noViewObsvPermsn'
                    },
                    icon: 'fa-flag',
                    showIconInMenu: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('obsv');
                        return $translate.refresh();
                    }],
                    observations: ['ObservationService', '$stateParams', getObservation],
                    subjStageFeat: ['SubjectService', '$stateParams', getSubjCurrStageFeat]
                }
            })
            .state('app.subject.documents', {
                url: '/documents',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/documents/documents.html',
                        controller: 'DocumentsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['MANG_DOC'],
                    section: 'documents',
                    i18n: {
                        menu: 'menu.subj.docs',
                        pageTitle: 'docu.home.pageTitle',
                        pageDesc: 'docu.home.pageDesc',
                        subjPermsMsg: 'docu.home.valid.noMangDocPermsn'
                    },
                    icon: 'fa-files-o',
                    showIconInMenu: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('docu');
                        return $translate.refresh();
                    }],
                    observations: ['DocumentService', '$stateParams', getDocuments]
                }
            })
            .state('app.subject.scoring', {
                url: '/scoring',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/scoring/score.html',
                        controller: 'ScoreCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_SCORE'],
                    section: 'scoring',
                    i18n: {
                        menu: 'menu.subj.scorg',
                        pageTitle: 'score.home.pageTitle',
                        pageDesc: 'score.home.pageDesc',
                        subjPermsMsg: 'score.home.valid.noViewScorePermsn'
                    },
                    icon: 'fa-bar-chart-o',
                    showIconInMenu: true,
                    setBreadcrumb: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('score');
                        return $translate.refresh();
                    }],
                    lvl1ScoreTypes: ['ScoreService', '$stateParams', getLvl1ScoreTypes]
                }
            })
            .state('app.subject.scoring.type', {
                url: '/type/:scoreTypeCd',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/scoring/scoreTypes/scoreTypes.html',
                        controller: 'ScoreTypeCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_WGTD_SCORE_BREAKDN', 'VIEW_SCORE_COMP', 'UPDT_SCORE_TARGS', 'VIEW_SCORE_HIST'], //also check hard-coded perms in left-nav controller
                    i18n: {
                        menu: 'Score Type',
                        pageTitle: 'score.scoreType.pageTitle',
                        pageDesc: 'score.scoreType.pageDesc',
                        subjPermsMsg: 'score.home.valid.noViewScorePermsn'
                    }
                },
                resolve: {
                    subjGrpScore: ['ScoreService', '$stateParams', getSubjGrpScore],
                    scoreHierLevels: ['ScoreService', '$stateParams', getScoreHierLevels],
                    scoreHierNodeTargets: ['ScoreService', '$stateParams', getSubjScoreHierNodeTargets],
                    flwupSubj: ['SubjectService', '$stateParams', getFlwupSubj]
                }
            })
            .state('app.subject.analytics', {
                url: '/analytics',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/analytics/analytics.html',
                        controller: 'AnalyticsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['VIEW_ANLYTCS'],
                    section: 'analytics',
                    i18n: {
                        menu: 'menu.subj.anlytcs',
                        pageTitle: 'anlytcs.home.pageTitle',
                        pageDesc: 'anlytcs.home.pageDesc',
                        subjPermsMsg: 'anlytcs.home.valid.noViewAnlytcsPermsn'
                    },
                    icon: 'fa-binoculars',
                    showIconInMenu: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('anlytcs');
                        return $translate.refresh();
                    }],
                    chartCds: [function() {
                        return null;
                    }]
                }
            })
            .state('app.subject.collaboration', {
                url: '/collaboration',
                views: {
                    'subjContent@app.subject': {
                        templateUrl: 'app/subject/collaboration/collaboration.html',
                        controller: 'CollaborationCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    subjPerms: ['MANG_COLLAB'],
                    i18n: {
                        menu: 'menu.subj.collab',
                        pageTitle: 'collab.home.pageTitle',
                        pageDesc: 'collab.home.pageDesc',
                        subjPermsMsg: 'collab.home.valid.noMangCollabPermsn'
                    },
                    icon: 'fa-users',
                    showIconInMenu: true
                },
                resolve: {
                    collab: ['CollaborationService', '$stateParams', getCollab],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('collab');
                        return $translate.refresh();
                    }]
                }
            });

        function getCollab(CollaborationService, $stateParams) {
            return CollaborationService.getCollab({
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSubject(SubjectService, $stateParams) {
            return SubjectService.getDetail({
                subjectId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getFlwupSubj(SubjectService, $stateParams) {
            return SubjectService.getFlwupSubj({
                subjectId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getObservation(ObservationService, $stateParams) {
            return ObservationService.getObservation({
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getDocuments(DocumentService, $stateParams) {
            return DocumentService.getDocuments({
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSubjCurrStageFeat(SubjectService, $stateParams) {
            return SubjectService.getSubjCurrStageFeat({
                subjId: $stateParams.id,
                featCd: 'OBSV'
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSurveyState(SurveyService, $stateParams) {
            return SurveyService.query({
                subjId: $stateParams.id,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getLvl1ScoreTypes(ScoreService, $stateParams) {
            return ScoreService.getLvl1ScoreTypes({
                subjId: $stateParams.id
            }).$promise.then(function (value) {
                return value;
            }, function (reason) {
                return reason;
            });
        }

        function getSubjGrpScore(ScoreService, $stateParams) {
            return ScoreService.getSubjGrpScore({
                scoreType: $stateParams.scoreTypeCd,
                subjId: $stateParams.id
            }).$promise.then(function (value) {
                return value;
            }, function (reason) {
                return reason;
            });
        }

        function getSubjEvents(SubjectService, $stateParams) {
            return SubjectService.getSubjEvents({
                subjId: $stateParams.id
            }).$promise.then(function(response) {
                return response.events;
            }, function(reason) {
                return reason;
            });
        }

        function getSubjScoreHierNodeTargets(ScoreService, $stateParams) {
            return ScoreService.getSubjScoreHierNodeTargets({
                scoreType: $stateParams.scoreTypeCd,
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getScoreHierLevels(ScoreService, $stateParams) {
            return ScoreService.getScoreHierLevels({
                scoreType: $stateParams.scoreTypeCd,
                subjId: $stateParams.id
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getUserActivityMetrics(SubjectService, $stateParams) {
            return SubjectService.getUserActivityMetrics({
                subjId: $stateParams.id,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('hasAnySubjPerms', hasAnySubjPerms)
        .directive('hasntAnySubjPerms', hasntAnySubjPerms)
        .directive('hasAnySubjPermsDisable', hasAnySubjPermsDisable)
        .directive('hasntAnySubjPermsDisable', hasntAnySubjPermsDisable)
        .directive('surveyPercentBadge', ['AppService', surveyPercentBadge])
        .directive('obsvCntBadge', ['AppService', obsvCntBadge])
        .directive('scoreBadge', ['AppService', scoreBadge])
        .directive('docuBadge', ['AppService', docuBadge])
        .directive('dashboardSurveyProgress', ['$timeout', 'AppService', dashboardSurveyProgress])
        .directive('dashboardScoreProgress', ['$timeout', 'AppService', dashboardScoreProgress])
        .directive('dashboardObsvCountProgress', ['$timeout', 'AppService', dashboardObsvCountProgress])
        .directive('dashboardDocProgress', ['$timeout', 'AppService', dashboardDocProgress])
        .directive('dashboardScoreChange', ['$timeout', dashboardScoreChange])
        .directive('scoreDescPopover', ['AppService', scoreDescPopover])
        .directive('scoreGuidancePopover', ['$filter', '$translate', 'AppService', scoreGuidancePopover])
        .directive('obsvSideBar', ['AppService', obsvSideBar])
        .directive('docuSideBar', ['AppService', docuSideBar]);

    function hasAnySubjPerms() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                defineVisibility(attrs.hasAnySubjPerms.replace(/\s+/g, '').replace(/'/g, '"'));

                attrs.$observe('hasAnySubjPerms', function(value) {
                    defineVisibility(value.replace(/\s+/g, '').replace(/'/g, '"'));
                });

                function defineVisibility(subjPerms) {
                    if (subjPerms.length > 0) {
                        var subjPermsJson = JSON.parse(subjPerms);
                        var result = false;
                        for (var i = 0; i < subjPermsJson.length; i++) {
                            if (scope.$root.subject && scope.$root.subject.myUserPermsns && scope.$root.subject.myUserPermsns.indexOf(subjPermsJson[i]) !== -1) {
                                result = true;
                            }
                        }
                        if (!result) {
                            element.replaceWith('');
                        }
                    }
                }
            }
        };
    }

    function hasntAnySubjPerms() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                defineVisibility(attrs.hasntAnySubjPerms.replace(/\s+/g, '').replace(/'/g, '"'));

                attrs.$observe('hasntAnySubjPerms', function(value) {
                    defineVisibility(value.replace(/\s+/g, '').replace(/'/g, '"'));
                });

                function defineVisibility(subjPerms) {
                    if (subjPerms.length > 0) {
                        var subjPermsJson = JSON.parse(subjPerms);
                        var result = false;
                        for (var i = 0; i < subjPermsJson.length; i++) {
                            if (scope.$root.subject && scope.$root.subject.myUserPermsns && scope.$root.subject.myUserPermsns.indexOf(subjPermsJson[i]) !== -1) {
                                result = true;
                            }
                        }
                        if (result) {
                            element.replaceWith('');
                        }
                    }
                }
            }
        };
    }

    function hasAnySubjPermsDisable() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                defineVisibility(attrs.hasAnySubjPermsDisable.replace(/\s+/g, '').replace(/'/g, '"'));

                attrs.$observe('hasAnySubjPermsDisable', function(value) {
                    defineVisibility(value.replace(/\s+/g, '').replace(/'/g, '"'));
                });

                function defineVisibility(subjPerms) {
                    if (subjPerms.length > 0) {
                        setEnabled();
                        var subjPermsJson = JSON.parse(subjPerms);
                        var result = false;
                        for (var i = 0; i < subjPermsJson.length; i++) {
                            if (scope.$root.subject && scope.$root.subject.myUserPermsns && scope.$root.subject.myUserPermsns.indexOf(subjPermsJson[i]) !== -1) {
                                result = true;
                            }
                        }
                        if (result) {
                            setEnabled();
                        } else {
                            setDisabled();
                        }
                    }
                }

                function setEnabled() {
                    element.attr('disabled', false);
                }

                function setDisabled() {
                    element.attr('disabled', true);
                    element.removeAttr('ng-click');
                }
            }
        };
    }

    function hasntAnySubjPermsDisable() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                defineVisibility(attrs.hasntAnySubjPermsDisable.replace(/\s+/g, '').replace(/'/g, '"'));

                attrs.$observe('hasntAnySubjPermsDisable', function(value) {
                    defineVisibility(value.replace(/\s+/g, '').replace(/'/g, '"'));
                });

                function defineVisibility(subjPerms) {
                    if (subjPerms.length > 0) {
                        setEnabled();
                        var subjPermsJson = JSON.parse(subjPerms);
                        var result = false;
                        for (var i = 0; i < subjPermsJson.length; i++) {
                            if (scope.$root.subject && scope.$root.subject.myUserPermsns && scope.$root.subject.myUserPermsns.indexOf(subjPermsJson[i]) !== -1) {
                                result = true;
                            }
                        }
                        if (result) {
                            setEnabled();
                        } else {
                            setDisabled();
                        }
                    }
                }

                function setEnabled() {
                    element.attr('disabled', false);
                }

                function setDisabled() {
                    element.attr('disabled', true);
                    element.removeAttr('ng-click');
                }
            }
        };
    }

    function surveyPercentBadge(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseFloat(attrs.percent));

                attrs.$observe('percent', function(value) {
                    setClass(parseFloat(value));
                });

                function setClass(percent) {
                    if (angular.isNumber(percent) && !isNaN(percent)) {
                        var featureConfig = AppService.featureTierRange('SURV', 'PERCENT', percent);
                        element.addClass('badge');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                }
            }
        };
    }

    function obsvCntBadge(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.obsvCntWgt, 10));

                attrs.$observe('obsvCntWgt', function(value) {
                    setClass(parseInt(value, 10));
                });

                function setClass(wgt) {
                    if (angular.isNumber(wgt) && !isNaN(wgt)) {
                        var featureConfig = AppService.featureTierRange('OBSV', 'PRIOT', wgt);
                        element.addClass('badge');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                }
            }
        };
    }

    function scoreBadge(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseFloat(attrs.scorePct));

                attrs.$observe('scorePct', function(value) {
                    setClass(parseFloat(value));
                });

                function setClass(percent) {
                    if (angular.isNumber(percent) && !isNaN(percent)) {
                        var featureConfig = AppService.featureTierRange('SCORE', 'PERCENT', percent);
                        element.addClass('badge');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                }
            }
        };
    }

    function docuBadge(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.docuCnt, 10), parseInt(attrs.docuWgt, 10), parseInt(attrs.docuSatsfd, 10));

                attrs.$observe('docuCnt', function(value) {
                    setClass(parseInt(value, 10), parseInt(attrs.docuWgt, 10), parseInt(attrs.docuSatsfd, 10));
                });
                attrs.$observe('docuWgt', function(value) {
                    setClass(parseInt(attrs.docuCnt, 10), parseInt(value, 10), parseInt(attrs.docuSatsfd, 10));
                });
                attrs.$observe('docuSatsfd', function(value) {
                    setClass(parseInt(attrs.docuCnt, 10), parseInt(attrs.docuWgt, 10), parseInt(value, 10));
                });

                function setClass(cnt, wgt, satsfd) {
                    if (cnt === satsfd && cnt > 0) {
                        wgt = 100;
                    }
                    if (angular.isNumber(wgt) && !isNaN(wgt)) {
                        var featureConfig = AppService.featureTierRange('DOCU', 'PRIOT', wgt);
                        element.addClass('badge');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                }
            }
        };
    }

    function dashboardSurveyProgress($timeout, AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function() {
                    var percent = scope.$eval(attrs.percent);
                    if (angular.isNumber(percent) && !isNaN(percent)) {
                        var featureConfig = AppService.featureTierRange('SURV', 'PERCENT', percent);
                        element.addClass('progress-bar');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function dashboardScoreProgress($timeout, AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function() {
                    var percent = scope.$eval(attrs.percent);
                    if (angular.isNumber(percent) && !isNaN(percent)) {
                        var featureConfig = AppService.featureTierRange('SCORE', 'PERCENT', percent);
                        element.addClass('progress-bar');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function dashboardObsvCountProgress($timeout, AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function() {
                    var wgt = scope.$eval(attrs.wgt);
                    var obsvCount = scope.$eval(attrs.obsvCount);
                    var totalObsvCount = scope.$eval(attrs.totalObsvCount);
                    if (angular.isNumber(wgt) && !isNaN(wgt)) {
                        var featureConfig = AppService.featureTierRange('OBSV', 'PRIOT', wgt);
                        element.addClass('progress-bar');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                    var percent = (obsvCount / totalObsvCount) * 100;
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function dashboardDocProgress($timeout, AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function() {
                    var docMaxWgt = scope.$eval(attrs.docMaxWgt);
                    var docUploaded = scope.$eval(attrs.docUploaded);
                    var docRequested = scope.$eval(attrs.docRequested);
                    if (docRequested === docUploaded && docRequested > 0) {
                        docMaxWgt = 100;
                    }
                    if (angular.isNumber(docMaxWgt) && !isNaN(docMaxWgt)) {
                        var featureConfig = AppService.featureTierRange('DOCU', 'PRIOT', docMaxWgt);
                        element.addClass('progress-bar');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                    var percent = (docUploaded / docRequested) * 100;
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function dashboardScoreChange($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function() {
                    var prevSubjScoreVal = scope.$eval(attrs.prevSubjScoreVal);
                    var scoreVal = scope.$eval(attrs.scoreVal);
                    var pctChangeFlag = scope.vm.pctChangeFlag;
                    var pctChangeDp = scope.vm.pctChangeDp;

                    var change = scoreVal - prevSubjScoreVal;
                    change = Math.abs(change);
                    var pctChange;
                    if (prevSubjScoreVal === 0) {
                        pctChange = '∞';
                    } else {
                        pctChange = (change / prevSubjScoreVal) * 100;
                        pctChange = parseFloat(pctChange).toFixed(pctChangeDp);
                        pctChange = formatNumber(pctChange);
                        pctChange = pctChange + '%';
                    }
                    change = parseFloat(change).toLocaleString();

                    if (scoreVal > prevSubjScoreVal) {
                        if (pctChangeFlag) {
                            element.html('(<i class="fa fa-angle-up"></i>' + pctChange + ')');
                        } else {
                            element.html('(<i class="fa fa-angle-up"></i>' + change + ')');
                        }
                        element.addClass('ico-good');
                    } else if (prevSubjScoreVal > scoreVal) {
                        if (pctChangeFlag) {
                            element.html('(<i class="fa fa-angle-down"></i>' + pctChange + ')');
                        } else {
                            element.html('(<i class="fa fa-angle-down"></i>' + change + ')');
                        }
                        element.addClass('ico-bad');
                    } else if (prevSubjScoreVal === scoreVal) {
                        if (pctChangeFlag) {
                            pctChange = 0;
                            pctChangeDp = scope.vm.pctChangeDp;
                            pctChange = pctChange.toFixed(pctChangeDp);
                            element.html('(<i class="fa fa-angle-right"></i>' + pctChange + '%)');
                        } else {
                            element.html('(<i class="fa fa-angle-right"></i>' + change + ')');
                        }
                        element.addClass('ico-na');
                    }
                }, 0);

                function formatNumber (num) {
                    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                }
            }
        };
    }

    function scoreDescPopover(AppService) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                d3.select(element[0])
                    .on('mouseover', function () {
                        var elem = d3.select(this);
                        var scorePct = elem.attr('score-pct');
                        var scoreDesc = elem.attr('score-desc');
                        if (scoreDesc) {
                            scoreDesc = JSON.parse(scoreDesc);
                        }
                        var featureConfig = AppService.featureTierRange('SCORE', 'PERCENT', scorePct);
                        elem.style('cursor', 'pointer');
                        if (featureConfig) {
                            showPopover(featureConfig, scoreDesc);
                        }
                    })
                    .on('mouseout', function () {
                        d3.select(this).style('cursor', 'default');
                        d3.selectAll('div.score-desc').remove();
                    });

                function showPopover(featureConfig, scoreDesc) {
                    var scoreLabel = scoreDesc.scoreLabel + '<br>';
                    var tierRange = scoreDesc.tierRange ? (scoreDesc.tierRange + '<br>') : '';
                    var tierDesc = scoreDesc.tierDesc ? scoreDesc.tierDesc : '';
                    var popoverHTML = '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-inner" > ' +
                    '<h3 class="popover-title"> ' +
                    '<div class=\"color-box\" style=\"background:' + featureConfig.configParam.badge.bgColor + '\"></div> ' + scoreDesc.nodeName +
                    '</h3 > ' +
                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' +
                    scoreLabel +
                    tierRange +
                    tierDesc +
                    '</div>' +
                    '</div>' +
                    '</div>';
                    var tooltip = d3.select('body').append('div').attr('class', 'score-desc');
                    tooltip.style('position', 'absolute').style('z-index', '2060');
                    tooltip.style('top', (d3.event.pageY + 10) + 'px').style('left', (d3.event.pageX + 10) + 'px');
                    tooltip.html(popoverHTML);
                    tooltip.style('visibility', 'visible');
                }
            }
        };
    }

    function scoreGuidancePopover($filter, $translate, AppService) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                d3.select(element[0])
                    .on('mouseover', function () {
                        var elem = d3.select(this);
                        var tiers = JSON.parse(elem.attr('tiers'));
                        var maxNodeScoreVal = elem.attr('max-node-score-val');
                        elem.style('cursor', 'pointer');
                        showPopover(tiers, maxNodeScoreVal);
                    })
                    .on('mouseout', function () {
                        d3.select(this).style('cursor', 'default');
                        d3.selectAll('div.score-guidance').remove();
                    });

                function showPopover(tiers, maxNodeScoreVal) {
                    var popoverHTML = '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-inner" > ' +
                    '<h3 class="popover-title"> ' +
                    '<span>' + $translate.instant('score.home.scoreTarg.scoreTiersGuideTitle') + '</span>' +
                    '</h3 > ' +
                    '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' +
                    '<table class="idmx-table table table-striped table-bordered table-hover" style="margin-bottom:0px">' +
                        '<thead>' +
                            '<tr>' +
                            '<th>' + $translate.instant('score.home.scoreTarg.scoreValHeader') + '</th>' +
                            '<th>' + $translate.instant('score.home.scoreTarg.scoreTierDescHeader') + '</th>' +
                            '<tr>' +
                        '</thead>' +
                        '<tbody>';
                    angular.forEach(tiers, function(tier) {
                        //get badge styling
                        var featureConfig = AppService.featureTierRange('SCORE', 'PERCENT', (($filter('scoreTierMinRange')(tier.minRange, tier.minScoreInclsvFlag, tier.scoreValDpCnt) + $filter('scoreTierMaxRange')(tier.maxRange, tier.maxScoreInclsvFlag, tier.scoreValDpCnt)) / 2) / maxNodeScoreVal * 100);
                        popoverHTML += '<tr>' +
                            '<td><span class="badge" style="background-color: ' + featureConfig.configParam.badge.bgColor + '; color: ' + featureConfig.configParam.badge.fgColor + ';">' + $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt) + '</span></td>' +
                            '<td>' + tier.tierDesc + '</td>' +
                        '</tr>';
                    });
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                    var tooltip = d3.select('body').append('div').attr('class', 'score-guidance');
                    tooltip.style('position', 'absolute').style('z-index', '2060');
                    tooltip.style('top', (d3.event.pageY + 10) + 'px').style('left', (d3.event.pageX - 200) + 'px');
                    tooltip.html(popoverHTML);
                    tooltip.style('visibility', 'visible');
                    scope.$apply();
                }
            }
        };
    }

    function obsvSideBar(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.obsvCntWgt, 10));

                attrs.$observe('obsvCntWgt', function(value) {
                    setClass(parseInt(value, 10));
                });

                function setClass(wgt) {
                    if (angular.isNumber(wgt) && !isNaN(wgt)) {
                        var featureConfig = AppService.featureTierRange('OBSV', 'PRIOT', wgt);
                        var borderProp = '3px solid ' + featureConfig.configParam.badge.bgColor;
                        element.css('border-left', borderProp);
                    }
                }
            }
        };
    }

    function docuSideBar(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.obsvCntWgt, 10));

                attrs.$observe('obsvCntWgt', function(value) {
                    setClass(parseInt(value, 10));
                });

                function setClass(wgt) {
                    if (angular.isNumber(wgt) && !isNaN(wgt)) {
                        var featureConfig = AppService.featureTierRange('DOCU', 'PRIOT', wgt);
                        var borderProp = '3px solid ' + featureConfig.configParam.badge.bgColor;
                        element.css('border-left', borderProp);
                    }
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('SubjCtrl', ['$rootScope', '$scope', '$state', '$filter', 'filterFilter', 'SubjectsService', 'subject', SubjCtrl]);

    function SubjCtrl($rootScope, $scope, $state, $filter, filterFilter, SubjectsService, subject) {
        var vm = this;
        vm.showLandingError = false;
        if (!subject || subject.status === 403) {
            $rootScope.subject = null;
        } else {
            $rootScope.subject = subject;
        }
        setSubjPerms($state.current);
        redirect($state.current);

        $scope.$on('$stateChangeSuccess', function(event, toState) {
            setSubjPerms(toState);
            redirect(toState);
        });

        function setSubjPerms(state) {
            vm.subjPerms = (state.data && state.data.subjPerms) ? state.data.subjPerms : '';
            vm.subjPermi18n = (state.data && state.data.i18n && state.data.i18n.subjPermsMsg) ? state.data.i18n.subjPermsMsg : 'subj.home.valid.noPermsn';
        }

        function redirect(state) {
            if (state.name === 'app.subject') {
                if ($rootScope.subject && $rootScope.subject.subjStageFeats) {
                    var subjPerms = $rootScope.subject.myUserPermsns;
                    $rootScope.subject.subjStageFeats.sort(function(a, b) {
                        return a.featPriotSeq - b.featPriotSeq;
                    });
                    for (var i = 0; i < $rootScope.subject.subjStageFeats.length; i++) {
                        var subjStageFeat = $rootScope.subject.subjStageFeats[i];
                        if (findRedirect(subjStageFeat.featCd, subjPerms, $rootScope.subject)) {
                            return;
                        }
                    }
                }
                vm.showLandingError = true;
            }
        }

        function findRedirect(subjStageFeatCd, subjPerms, subject) {
            if (subjStageFeatCd === 'ACTVTY' && subjPerms.indexOf('VIEW_ACTVTY') !== -1 && $rootScope.subject.showActvtyFlag) { // Activity
                updateLastAccs(subject.subjId);
                $state.go('app.subject.summary.activity', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'ANLYTCS' && subjPerms.indexOf('VIEW_ANLYTCS') !== -1 && subject.analytics) { // Analytics
                updateLastAccs(subject.subjId);
                $state.go('app.subject.analytics', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'COLLAB' && subjPerms.indexOf('MANG_COLLAB') !== -1 && subject.showCollabFlag) { // Manage Collaboration
                updateLastAccs(subject.subjId);
                $state.go('app.subject.collaboration', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'DASH' && subjPerms.indexOf('VIEW_DASH') !== -1 && subject.showDashFlag) { // View Dashboard
                updateLastAccs(subject.subjId);
                $state.go('app.subject.summary.dashboard', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'DOCU' && subjPerms.indexOf('MANG_DOC') !== -1 && subject.docu) { // Manage Docs
                updateLastAccs(subject.subjId);
                $state.go('app.subject.documents', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'OBSV' && subjPerms.indexOf('VIEW_OBSV') !== -1 && subject.obsv) { // View Observations
                updateLastAccs(subject.subjId);
                $state.go('app.subject.observations', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'REPT' && subjPerms.indexOf('DOWNLD_REPT') !== -1 && subject.reports && subject.reports.length > 0) { // Reports
                updateLastAccs(subject.subjId);
                $state.go('app.subject.summary.reports', {
                    id: subject.subjId
                });
                return true;
            } else if (subjStageFeatCd === 'SCORE' && subjPerms.indexOf('VIEW_SCORE') !== -1 && subjPerms.indexOf('VIEW_SCORE_TYPE_COMP') !== -1 && subject.scores && subject.scores.length > 0) { // View Score
                updateLastAccs(subject.subjId);
                $state.go('app.subject.scoring', {
                    id: subject.subjId
                }, {
                    reload: true
                });
                return true;
            } else if (subjStageFeatCd === 'SCORE' && subjPerms.indexOf('VIEW_SCORE') !== -1 && (subjPerms.indexOf('VIEW_WGTD_SCORE_BREAKDN') !== -1 || subjPerms.indexOf('VIEW_SCORE_COMP') !== -1 || subjPerms.indexOf('UPDT_SCORE_TARGS') !== -1 || subjPerms.indexOf('VIEW_SCORE_HIST') !== -1) && subject.scores && subject.scores.length > 0) { // View Score Type
                updateLastAccs(subject.subjId);
                $state.go('app.subject.scoring.type', {
                    id: subject.subjId,
                    scoreTypeCd: subject.scores[0].scoreTypeCd
                }, {
                    reload: true
                });
                return true;
            } else if (subjStageFeatCd === 'SURV' && (subjPerms.indexOf('UPDT_SURV') !== -1 || subjPerms.indexOf('VIEW_SURV') !== -1) && subject.survey && subject.survey.type) { // Surveys
                updateLastAccs(subject.subjId);
                var surveyArray = filterFilter($rootScope.surveySections, {
                    survTypeCd: subject.survey.type.cd
                });
                var surveyIndex = ($filter('orderBy')(surveyArray, 'survSectSeq'))[0].survSectSeq;
                $state.go('app.subject.survey.section', {
                    id: subject.subjId,
                    sectionIdx: surveyIndex
                }, {
                    reload: true
                });
                return true;
            }
            return false;
        }

        vm.hasSubjPerms = function(subjPerms) {
            if (subjPerms && subjPerms.length > 0) {
                if (!$rootScope.subject || !$rootScope.subject.myUserPermsns || $rootScope.subject.myUserPermsns.length === 0) {
                    return false;
                }
                for (var i = 0; i < subjPerms.length; i++) {
                    if ($rootScope.subject.myUserPermsns.indexOf(subjPerms[i]) !== -1) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        };

        function updateLastAccs(subjId) {
            SubjectsService.saveLastAccs({
                subjectId: subjId
            }, function() {
            }, function() {
            });
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('selfRegisterPrefRadio', [selfRegisterPrefRadio])
        .directive('selfRegisterValidatePasswordPolicy', ['$timeout', selfRegisterValidatePasswordPolicy]);

    function selfRegisterPrefRadio() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm) {
                $(elm).on('ifClicked', function() {
                    scope.vm.enableSubmit();
                });
            }
        };
    }

    function selfRegisterValidatePasswordPolicy($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                $timeout(function() {
                    scope.vm.ngModelCtrl = ngModelCtrl;
                    $(element).bind('keyup', function() {
                        scope.vm.validatePasswordPolicy(ngModelCtrl);
                        scope.$apply();
                    });
                });

                ngModelCtrl.$validators.policy = function(modelValue) {
                    if (modelValue) {
                        if (!scope.vm.isValidPasswd) {
                            ngModelCtrl.$invalid = true;
                            ngModelCtrl.$setValidity('policy', false);
                            return false;
                        }
                        ngModelCtrl.$invalid = false;
                        ngModelCtrl.$setValidity('policy', true);
                        return true;
                    }
                    ngModelCtrl.$valid = true;
                    ngModelCtrl.$setValidity('policy', true);
                    return true;
                };
            }
        };
    }

})();
								(function () {
    'use strict';

    angular.module('app')
        .controller('SelfRegisterCtrl', ['$rootScope', '$scope', '$state', '$uibModal', '$window', '$filter', '$translate', '$http', 'AuthenticateService', 'apiUrl', 'sysParms', 'properties', 'references', SelfRegisterCtrl])
        .controller('SelfRegisterModalCtrl', ['$rootScope', '$state', '$uibModalInstance', '$translate', 'userId', SelfRegisterModalCtrl]);

    function SelfRegisterCtrl($rootScope, $scope, $state, $uibModal, $window, $filter, $translate, $http, AuthenticateService, apiUrl, sysParms, properties, references) {
        var vm = this;
        vm.references = references.data;

        vm.user = {
            userPrefs: {}
        };

        vm.confirmPassword = '';
        vm.sysParms = sysParms.data;
        vm.properties = properties.data;
        $rootScope.APPL_SH_NAME = vm.sysParms.APPL_SH_NAME;
        vm.userPrefTypes = [];
        vm.terms = false;
        vm.visiteTos = false; // tos pop-up is displayed by clicking the ‘I agree’ checkbox if they have not already visited
        vm.twoFactorAuthReq = vm.sysParms.TFA_ENBLD_FLAG; //is two factor authnetication required or not?
        $('#firstName').focus(); //for initial cursor position
        vm.phnCntryCodes = $filter('orderBy')(vm.references.PHON_CNTRY_CD.refItems, 'dispSeq');
        vm.langCds = $filter('orderBy')(vm.references.LANG_CD.refItems, 'dispSeq');

        vm.switchLang = function(newLangCd) {
            vm.userLang = $filter('filter')(vm.langCds, {cd: newLangCd})[0];
            langCd = newLangCd;
            localStorage.setItem('langCd', langCd);

            //get references in correct languages
            $http.get(apiUrl + 'references?languageCd=' + langCd, {}).success(function(data) {
                $translate.use(langCd);
                vm.references = data;
                vm.phnCntryCodes = $filter('orderBy')(vm.references.PHON_CNTRY_CD.refItems, 'dispSeq');
                vm.langCds = $filter('orderBy')(vm.references.LANG_CD.refItems, 'dispSeq');
            });
            $http.get(apiUrl + 'authenticate/passwdRules/' + langCd, {}).success(function(data) {
                if (data.length) {
                    vm.policyPopover = {
                        templateUrl: 'passwd-policy-template.html'
                    };
                    vm.tempRules = prepRuleData(data);
                    vm.validatePasswordPolicy(vm.ngModelCtrl);
                    $('#' + vm.ngModelCtrl.$name).trigger('change');
                }
            });
        };
        var langCd = localStorage.getItem('langCd');
        if (!langCd) {
            langCd = $window.navigator.languages && $window.navigator.languages[0] || // Chrome / Firefox
                $window.navigator.language ||   // All browsers
                $window.navigator.userLanguage; // IE <= 10
            if (langCd.indexOf('-') >= 0) {
                langCd = langCd.substring(0, langCd.indexOf('-')).trim();
            }
            langCd = langCd.toUpperCase();
        }
        //check language supported by IDMX.  If not set to default
        if (!$filter('filter')(vm.langCds, {cd: langCd}, true).length) {
            var defltLangCd = $filter('filter')(vm.references.USR_PREF_TYPE.refItems, {
                cd: 'PREF_LANG'
            }, true)[0].entity.defaultUserPrefCd;
            langCd = defltLangCd;
        }
        vm.switchLang(langCd);

        //set userPref initial values;
        angular.forEach(vm.references.USR_PREF_TYPE.refItems, function(userPrefType) {
            if (userPrefType.cd === 'PREF_LANG') {
                vm.user.userPrefs.PREF_LANG = langCd;
            } else if (vm.references[userPrefType.entity.lkupTablCd].refItems.length === 1) {
                vm.user.userPrefs[userPrefType.cd] = vm.references[userPrefType.entity.lkupTablCd].refItems[0].cd;
            } else {
                vm.user.userPrefs[userPrefType.cd] = userPrefType.entity.defaultUserPrefCd;
            }
        });

        vm.userPrefTypesToShow = function() {
            var userPrefTypes = [];
            angular.forEach(vm.references.USR_PREF_TYPE.refItems, function(userPrefType) {
                if (vm.references[userPrefType.entity.lkupTablCd].refItems.length > 1) {
                    userPrefTypes.push(userPrefType);
                }
            });
            return userPrefTypes;
        };

        function prepRuleData(rules) {
            rules.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
            var retList = [];
            rules.forEach(function(rule) {
                var tempRule = {};
                tempRule.dispSeq = rule.dispSeq;
                tempRule.invert = rule.passwdRuleParms.invert;
                tempRule.charListRegExp = rule.passwdRuleParms.charListRegExp;
                tempRule.passwdRuleText = rule.passwdRuleText;
                retList.push(tempRule);
            });
            return retList;
        }

        vm.isValidPasswd = true;
        vm.validatePasswordPolicy = function(ngModelCtrl) {
            if (ngModelCtrl) {
                vm.isValidPasswd = true;
                vm.rulesList = [];
                angular.forEach(vm.tempRules, function(rule) {
                    vm.rulesList[rule.dispSeq] = (!rule.invert) ? validatePolicyItem(rule, ngModelCtrl) : validatePolicyItemInvert(rule, ngModelCtrl);
                });
            }
        };

        function validatePolicyItem(rule, ngModelCtrl) {
            var ret = rule.passwdRuleText;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            } else {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        function validatePolicyItemInvert(rule, ngModelCtrl) {
            var ret;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            } else {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        $scope.$watch('vm.user.userPrefs.PREF_LANG', function(newLangCd) {
            vm.switchLang(newLangCd);
        });

        $('input').on('keypress', function() {
            console.log('keypress');
            vm.enableSubmit();
        });

        vm.orgHasRole = function(cd) {
            return vm.user.orgRoles.indexOf(cd) !== -1;
        };

        vm.onOffcPhonCntryCdSelected = function(item) {
            vm.user.offcPhonCntryCd = item.cd;
        };

        vm.onOffcPhonCntryCdChange = function() {
            if (!vm.offcPhonCntryCd) {
                vm.user.offcPhonCntryCd = null;
            }
        };

        vm.onMoblPhonCntryCdSelected = function(item) {
            vm.user.moblPhonCntryCd = item.cd;
            vm.validateMobileNumber();
        };

        vm.onMoblPhonCntryCdChange = function() {
            if (!vm.moblPhonCntryCd) {
                vm.user.moblPhonCntryCd = null;
                vm.validateMobileNumber();
            }
        };

        vm.validateMobileNumber = function() {
            if (vm.user.moblPhonNum && vm.user.moblPhonCntryCd) {
                AuthenticateService.validateMobileNumber({
                    moblPhonNum: vm.user.moblPhonNum,
                    moblPhonCntryCd: vm.user.moblPhonCntryCd
                }).$promise.then(function(result) {
                    if (result.valid) {
                        $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', true);
                    } else {
                        vm.disableSubmit();
                        $scope.registerForm.moblPhonNum.$invalid = true;
                        $scope.registerForm.moblPhonNum.$error.invalidPhoneNumber = true;
                        $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', false);
                    }
                });
            } else {
                console.log($scope);
                $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', true);
            }
        };

        vm.validateUserId = function() {
            if (vm.user.userId) {
                AuthenticateService.validateUserId({
                    userId: vm.user.userId
                }).$promise.then(function(result) {
                    if (result.valid) {
                        $scope.registerForm.userId.$setValidity('invalidUserId', true);
                    } else {
                        vm.disableSubmit();
                        $scope.registerForm.userId.$invalid = true;
                        $scope.registerForm.userId.$error.invalidUserId = true;
                        $scope.registerForm.userId.$setValidity('invalidUserId', false);
                    }
                });
            } else {
                $scope.registerForm.userId.$setValidity('invalidUserId', true);
            }
        };

        vm.submit = function(registerForm) {
            delete vm.user.userPrefs.undefined; //deleting any undefined user preferences
            vm.disableSubmit();
            vm.validateMobileNumber();
            vm.validateUserId();
            if ($.isEmptyObject(registerForm.$error)) {
                AuthenticateService.selfRegister(vm.user, function onSuccess() {
                    $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'confirm-dialog-template.html',
                        controller: 'SelfRegisterModalCtrl',
                        controllerAs: 'modal',
                        backdrop: 'static',
                        keyboard: false,
                        size: 'md',
                        resolve: {
                            userId: function() {
                                return vm.user.userId;
                            }
                        }
                    });
                }, function onError() {
                    toastr.error(
                        $translate.instant('login.compltRegstrn.toast.compltRegstrnError'),
                        $translate.instant('login.selfRegstrn.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        vm.onKeyDown = function($event) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit();
            }
        };

        vm.isSubmitDisabled = function() {
            return $('.register-submit-btn').is(':disabled');
        };

        vm.tosVisited = function() {
            if (vm.visiteTos === false) {
                vm.openTosDialogBox();
            }
            vm.enableSubmit();
        };

        vm.enableSubmit = function() {
            $('.register-submit-btn').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('.register-submit-btn').attr('disabled', true);
        };

        // Set the page title key to the one configured in state or use default one
        if ($state.current.data && $state.current.data.i18n && $state.current.data.i18n.pageTitle) {
            $translate($state.current.data.i18n.pageTitle).then(function (translatedString) {
                $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
            });
        } else {
            $window.document.title = $rootScope.APPL_SH_NAME;
        }

        vm.openTosDialogBox = function() {
            vm.visiteTos = true;
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'info-dialog-template.html',
                controller: 'TosModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    properties: function() {
                        return vm.properties;
                    },
                    sysParms: function() {
                        return vm.sysParms;
                    },
                    langCds: function() {
                        return vm.langCds;
                    },
                    userLang: function() {
                        return vm.userLang;
                    },
                    switchLang: function() {
                        return vm.switchLang;
                    }
                }
            });
        };

    }

    function SelfRegisterModalCtrl($rootScope, $state, $uibModalInstance, $translate, userId) {
        var modal = this;
        modal.title = 'login.selfRegstrn.modal.acctVerfcReqdTitle';
        modal.text = $translate.instant('login.selfRegstrn.modal.acctVerfcReqdText', {emailAddr: userId});
        modal.okButton = 'login.selfRegstrn.modal.acctVerfcReqdButton';
        modal.hideCancelButton = true;

        modal.close = function() {
            $uibModalInstance.close();
            toastr.success(
                $translate.instant('login.selfRegstrn.toast.selfRegstrnSuccess'),
                $translate.instant('login.selfRegstrn.pageTitle'),
                toastr.options
            );
            $rootScope.userEmail = userId;//used this variable on login controller
            $state.go('login', {}, {reload: true});
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
            toastr.success(
                $translate.instant('login.selfRegstrn.toast.selfRegstrnError'),
                $translate.instant('login.selfRegstrn.pageTitle'),
                toastr.options
            );
            $rootScope.userEmail = userId;//used this variable on login controller
            $state.go('login', {}, {reload: true});
        };

    }

})();

(function() {
    'use strict';

    angular.module('app')
        .directive('validatePasswordPolicy', ['$timeout', validatePasswordPolicy]);
    function validatePasswordPolicy($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                $timeout(function() {
                    scope.vm.ngModelCtrl = ngModelCtrl;
                    $(element).bind('keyup', function() {
                        scope.vm.validatePasswordPolicy(ngModelCtrl);
                        scope.$apply();
                    });
                });

                ngModelCtrl.$validators.policy = function(modelValue) {
                    if (modelValue) {
                        if (!scope.vm.isValidPasswd) {
                            ngModelCtrl.$invalid = true;
                            ngModelCtrl.$setValidity('policy', false);
                            return false;
                        }
                        ngModelCtrl.$invalid = false;
                        ngModelCtrl.$setValidity('policy', true);
                        return true;
                    }
                    ngModelCtrl.$valid = true;
                    ngModelCtrl.$setValidity('policy', true);
                    return true;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResetPasswordCtrl', ['$rootScope', '$uibModal', '$state', '$http', 'apiUrl', '$window', '$filter', '$translate', 'PasswordService', 'sysParms', 'properties', 'langCds', 'userPrefTypes', ResetPasswordCtrl]);

    function ResetPasswordCtrl($rootScope, $uibModal, $state, $http, apiUrl, $window, $filter, $translate, PasswordService, sysParms, properties, langCds, userPrefTypes) {
        var vm = this;
        vm.properties = properties.data;
        vm.sysParms = sysParms.data;
        $rootScope.APPL_SH_NAME = vm.sysParms.APPL_SH_NAME;
        vm.userId = $state.params.userId;
        vm.hash = $state.params.hash;
        vm.authenticationError = false;

        PasswordService.validateHash({
            userId: vm.userId,
            hash: vm.hash
        }, function(data) {
            if (data.error) {
                vm.authenticationError = true;
                vm.errorMessage = data.error;
                vm.disableForm();
                switch (data.error.code) {
                case '500':
                    vm.errorI18n = 'login.resetPasswd.valid.reqstNotFound';
                    break;
                case '501':
                    vm.errorI18n = 'login.resetPasswd.valid.reqstExpd';
                    break;
                }
            }
        });

        vm.langCds = $filter('orderBy')(langCds.data.refItems, 'dispSeq');
        vm.switchLang = function(newLangCd) {
            vm.userLang = $filter('filter')(vm.langCds, {cd: newLangCd})[0];
            langCd = newLangCd;
            $translate.use(langCd);
            localStorage.setItem('langCd', langCd);

            $http.get(apiUrl + 'authenticate/passwdRules/' + langCd, {
            }).success(function(data) {
                if (data.length) {
                    vm.policyPopover = {
                        templateUrl: 'passwd-policy-template.html'
                    };
                    vm.tempRules = prepRuleData(data);
                    $('#' + vm.ngModelCtrl.$name).trigger('change');
                    vm.validatePasswordPolicy(vm.ngModelCtrl);
                }
            });
        };

        function prepRuleData(rules) {
            rules.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
            var retList = [];
            rules.forEach(function(rule) {
                var tempRule = {};
                tempRule.dispSeq = rule.dispSeq;
                tempRule.invert = rule.passwdRuleParms.invert;
                tempRule.charListRegExp = rule.passwdRuleParms.charListRegExp;
                tempRule.passwdRuleText = rule.passwdRuleText;
                retList.push(tempRule);
            });
            return retList;
        }

        vm.isValidPasswd = true;
        vm.validatePasswordPolicy = function(ngModelCtrl) {
            if (ngModelCtrl) {
                vm.isValidPasswd = true;
                vm.rulesList = [];
                angular.forEach(vm.tempRules, function(rule) {
                    vm.rulesList[rule.dispSeq] = (!rule.invert) ? validatePolicyItem(rule, ngModelCtrl) : validatePolicyItemInvert(rule, ngModelCtrl);
                });
            }
        };

        function validatePolicyItemInvert(rule, ngModelCtrl) {
            var ret;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            } else {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        function validatePolicyItem(rule, ngModelCtrl) {
            var ret = rule.passwdRuleText;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            } else {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        var langCd = localStorage.getItem('langCd');
        if (!langCd) {
            langCd = $window.navigator.languages && $window.navigator.languages[0] || // Chrome / Firefox
                $window.navigator.language ||   // All browsers
                $window.navigator.userLanguage; // IE <= 10
            if (langCd.indexOf('-') >= 0) {
                langCd = langCd.substring(0, langCd.indexOf('-')).trim();
            }
            langCd = langCd.toUpperCase();
        }
        //check language supported by IDMX.  If not set to default
        if (!$filter('filter')(vm.langCds, {cd: langCd}, true).length) {
            var defltLangCd = $filter('filter')(userPrefTypes.data.refItems, {
                cd: 'PREF_LANG'
            }, true)[0].entity.defaultUserPrefCd;
            langCd = defltLangCd;
        }
        vm.switchLang(langCd);
        $translate($state.current.data.i18n.pageTitle).then(function (translatedString) {
            $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
        });

        $('input').on('keypress', function() {
            vm.enableSubmit();
        });

        vm.passwordReset = function(resetForm) {
            vm.disableSubmit();
            if ($.isEmptyObject(resetForm.$error)) {
                PasswordService.reset({
                    userId: vm.userId,
                    hash: vm.hash,
                    password: vm.password
                }, function() {
                    $rootScope.recPassEmail = vm.userId;
                    toastr.success(
                        $translate.instant('login.resetPasswd.toast.resetPasswdSuccess'),
                        $translate.instant('login.resetPasswd.pageTitle'),
                        toastr.options
                    );
                    $state.go('login', {}, {reload: true});
                }, function onError(error) {
                    toastr.error(
                        $translate.instant('login.resetPasswd.toast.resetPasswdError'),
                        $translate.instant('login.resetPasswd.pageTitle'),
                        toastr.options
                    );
                    vm.errorMessage = error.data.message;
                    vm.disableSubmit();
                    $('#password').attr('disabled', true);
                    $('#confirmPassword').attr('disabled', true);
                });
            }
        };

        vm.enableSubmit = function() {
            $('.reset-btn').attr('disabled', false);
        };

        vm.disableSubmit = function() {
            $('.reset-btn').attr('disabled', true);
        };

        vm.disableForm = function() {
            vm.disableSubmit();
            $('#password').attr('disabled', true);
            $('#confirmPassword').attr('disabled', true);
        };

        vm.navToLogin = function() {
            var userEmail = vm.userId;
            $rootScope.recPassEmail = userEmail;
            $state.go('login');
        };

        vm.openTosDialogBox = function() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'info-dialog-template.html',
                controller: 'TosModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    properties: function() {
                        return vm.properties;
                    },
                    sysParms: function() {
                        return vm.sysParms;
                    },
                    langCds: function() {
                        return vm.langCds;
                    },
                    userLang: function() {
                        return vm.userLang;
                    },
                    switchLang: function() {
                        return vm.switchLang;
                    }
                }
            });
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', registerRoute]);

    function registerRoute($stateProvider) {
        $stateProvider
            .state('register', {
                url: '/register/:hash?:userId',
                templateUrl: 'app/register/register.html',
                controller: 'RegisterCtrl',
                controllerAs: 'vm',
                data: {
                    userRoles: [],
                    i18n: {
                        pageTitle: 'login.compltRegstrn.pageTitle'
                    },
                    showInMenu: 'never'
                },
                resolve: {
                    user: ['AuthenticateService', '$stateParams', '$state', getUserByUserId],
                    sysParms: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms');
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties');
                    }],
                    references: ['$stateParams', '$http', 'apiUrl', function($stateParams, $http, apiUrl) {
                        return $http.get(apiUrl + 'references', {
                            params: {
                                userId: $stateParams.userId
                            }
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('subj');
                        return $translate.refresh();
                    }]
                }
            }).state('selfregister', {
                url: '/selfregister',
                templateUrl: 'app/register/self-register.html',
                controller: 'SelfRegisterCtrl',
                controllerAs: 'vm',
                data: {
                    i18n: {
                        pageTitle: 'login.selfRegstrn.pageTitle'
                    },
                    showInMenu: 'never'
                },
                resolve: {
                    sysParms: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms');
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties');
                    }],
                    references: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('subj');
                        return $translate.refresh();
                    }]
                }
            }).state('resetpassword', {
                url: '/resetpassword/:hash?:userId',
                templateUrl: 'app/register/reset-password.html',
                controller: 'ResetPasswordCtrl',
                controllerAs: 'vm',
                data: {
                    userRoles: [],
                    i18n: {
                        pageTitle: 'login.resetPasswd.pageTitle'
                    },
                    showInMenu: 'never'
                },
                resolve: {
                    sysParms: ['$stateParams', '$http', 'apiUrl', function($stateParams, $http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms');
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties');
                    }],
                    langCds: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/LANG_CD');
                    }],
                    userPrefTypes: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/USR_PREF_TYPE');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            }).state('forgotpassword', {
                url: '/forgotpassword',
                templateUrl: 'app/register/forgot-password.html',
                controller: 'ForgotPasswordCtrl',
                controllerAs: 'vm',
                data: {
                    i18n: {
                        pageTitle: 'login.forgtPasswd.pageTitle'
                    },
                    showInMenu: 'never'
                },
                resolve: {
                    sysParms: ['$http', 'apiUrl', function sysParms($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms');
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties');
                    }],
                    langCds: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/LANG_CD');
                    }],
                    userPrefTypes: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/USR_PREF_TYPE');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });

        function getUserByUserId(AuthenticateService, $stateParams, $state) {
            return AuthenticateService.getUserByUserId({
                userId: $stateParams.userId,
                hash: $stateParams.hash
            }).$promise.then(function(user) {
                return user;
            }, function(reason) {
                $state.go('login');
                return reason;
            });
        }

    }

})();

(function() {
    'use strict';

    angular.module('app')
        .directive('registerPrefRadio', [registerPrefRadio])
        .directive('registerValidatePasswordPolicy', ['$timeout', registerValidatePasswordPolicy]);

    function registerPrefRadio() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm) {
                var elmValue;
                var elmId;
                $(elm).on('ifClicked', function(e) {
                    setTimeout(function() {
                        elmValue = $(e.target).val();
                        elmId = $(e.target).attr('id');
                        $(e.target).iCheck('check');
                        scope.vm.user.userPrefs[elmId] = elmValue;
                        scope.vm.enableSubmit();
                    }, 0);
                });
            }
        };
    }

    function registerValidatePasswordPolicy($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                $timeout(function() {
                    scope.vm.ngModelCtrl = ngModelCtrl;
                    $(element).bind('keyup', function() {
                        scope.vm.validatePasswordPolicy(ngModelCtrl);
                        scope.$apply();
                    });
                });

                ngModelCtrl.$validators.policy = function(modelValue) {
                    if (modelValue) {
                        if (!scope.vm.isValidPasswd) {
                            ngModelCtrl.$invalid = true;
                            ngModelCtrl.$setValidity('policy', false);
                            return false;
                        }
                        ngModelCtrl.$invalid = false;
                        ngModelCtrl.$setValidity('policy', true);
                        return true;
                    }
                    ngModelCtrl.$valid = true;
                    ngModelCtrl.$setValidity('policy', true);
                    return true;
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('app')
        .controller('RegisterCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$uibModal', '$window', '$timeout', '$filter', '$translate', '$http', 'AuthenticateService', 'user', 'apiUrl', 'sysParms', 'properties', 'references', RegisterCtrl]);

    function RegisterCtrl($rootScope, $scope, $state, $stateParms, $uibModal, $window, $timeout, $filter, $translate, $http, AuthenticateService, user, apiUrl, sysParms, properties, references) {
        var vm = this;
        vm.user = user;

        if (!vm.user.userId) {
            //bad hash or userId
            $rootScope.userEmail = $stateParms.userId;//used this variable on login controller
            $rootScope.invalidHash = true;
            $state.go('login', {}, {reload: true});
        } else if (vm.user.passwordSet) {
            //coming from self-registration
            localStorage.setItem('langCd', vm.user.userPrefs.PREF_LANG);
            $translate.use(vm.user.userPrefs.PREF_LANG);
            AuthenticateService.activate(vm.user, function onSuccess() {
                toastr.success(
                    $translate.instant('login.compltRegstrn.toast.compltRegstrnSuccess'),
                    $translate.instant('login.compltRegstrn.pageTitle'),
                    toastr.options
                );
                $rootScope.userEmail = vm.user.userId;//used this variable on login controller
                $state.go('login', {}, {reload: true});
            }, function onError() {
                toastr.error(
                    $translate.instant('login.compltRegstrn.toast.compltRegstrnError'),
                    $translate.instant('login.compltRegstrn.pageTitle'),
                    toastr.options
                );
                $rootScope.userEmail = vm.user.userId;//used this variable on login controller
                $state.go('login', {}, {reload: true});
            });
        } else {
            //coming from admin create user

            vm.references = references.data;
            vm.confirmPassword = '';
            vm.sysParms = sysParms.data;
            vm.properties = properties.data;
            $rootScope.APPL_SH_NAME = vm.sysParms.APPL_SH_NAME;
            vm.userPrefTypes = [];
            vm.terms = false;
            vm.visiteTos = false; // tos pop-up is displayed by clicking the ‘I agree’ checkbox if they have not already visited
            vm.twoFactorAuthReq = vm.sysParms.TFA_ENBLD_FLAG; //is two factor authnetication required or not?
            $('#firstName').focus(); //for initial cursor position
            vm.phnCntryCodes = $filter('orderBy')(vm.references.PHON_CNTRY_CD.refItems, 'dispSeq');
            vm.langCds = $filter('orderBy')(vm.references.LANG_CD.refItems, 'dispSeq');
            vm.orgRoleTypes = $filter('orderBy')(vm.references.ORG_ROLE_TYPE.refItems, 'dispSeq');

            vm.switchLang = function(newLangCd) {
                vm.userLang = $filter('filter')(vm.langCds, {cd: newLangCd})[0];
                langCd = newLangCd;
                localStorage.setItem('langCd', langCd);

                //get references in correct languages
                $http.get(apiUrl + 'references?languageCd=' + langCd, {}).success(function(data) {
                    $translate.use(langCd);
                    vm.references = data;
                    vm.phnCntryCodes = $filter('orderBy')(vm.references.PHON_CNTRY_CD.refItems, 'dispSeq');
                    vm.langCds = $filter('orderBy')(vm.references.LANG_CD.refItems, 'dispSeq');
                    vm.orgRoleTypes = $filter('orderBy')(vm.references.ORG_ROLE_TYPE.refItems, 'dispSeq');
                });
                $http.get(apiUrl + 'authenticate/passwdRules/' + langCd, {}).success(function(data) {
                    if (data.length) {
                        vm.policyPopover = {
                            templateUrl: 'passwd-policy-template.html'
                        };
                        vm.tempRules = prepRuleData(data);
                        vm.validatePasswordPolicy(vm.ngModelCtrl);
                        $('#' + vm.ngModelCtrl.$name).trigger('change');
                    }
                });
            };
            var langCd = vm.user.userPrefs.PREF_LANG;
            if (!langCd) {
                langCd = localStorage.getItem('langCd');
            }
            if (!langCd) {
                langCd = $window.navigator.languages && $window.navigator.languages[0] || // Chrome / Firefox
                    $window.navigator.language ||   // All browsers
                    $window.navigator.userLanguage; // IE <= 10
                if (langCd.indexOf('-') >= 0) {
                    langCd = langCd.substring(0, langCd.indexOf('-')).trim();
                }
                langCd = langCd.toUpperCase();
            }
            //check language supported by IDMX.  If not set to default
            if (!$filter('filter')(vm.langCds, {cd: langCd}, true).length) {
                var defltLangCd = $filter('filter')(vm.references.USR_PREF_TYPE.refItems, {
                    cd: 'PREF_LANG'
                }, true)[0].entity.defaultUserPrefCd;
                langCd = defltLangCd;
            }
            vm.switchLang(langCd);

            //set userPref initial values;
            angular.forEach(vm.references.USR_PREF_TYPE.refItems, function(userPrefType) {
                if (userPrefType.cd === 'PREF_LANG') {
                    vm.user.userPrefs.PREF_LANG = langCd;
                } else if (vm.references[userPrefType.entity.lkupTablCd].refItems.length === 1) {
                    vm.user.userPrefs[userPrefType.cd] = vm.references[userPrefType.entity.lkupTablCd].refItems[0].cd;
                } else {
                    vm.user.userPrefs[userPrefType.cd] = userPrefType.entity.defaultUserPrefCd;
                }
            });

            vm.userPrefTypesToShow = function() {
                var userPrefTypes = [];
                angular.forEach(vm.references.USR_PREF_TYPE.refItems, function(userPrefType) {
                    if (vm.references[userPrefType.entity.lkupTablCd].refItems.length > 1) {
                        userPrefTypes.push(userPrefType);
                    }
                });
                return userPrefTypes;
            };

            function prepRuleData(rules) {
                rules.sort(function(a, b) {
                    return a.dispSeq - b.dispSeq;
                });
                var retList = [];
                rules.forEach(function(rule) {
                    var tempRule = {};
                    tempRule.dispSeq = rule.dispSeq;
                    tempRule.invert = rule.passwdRuleParms.invert;
                    tempRule.charListRegExp = rule.passwdRuleParms.charListRegExp;
                    tempRule.passwdRuleText = rule.passwdRuleText;
                    retList.push(tempRule);
                });
                return retList;
            }

            vm.isValidPasswd = true;
            vm.validatePasswordPolicy = function(ngModelCtrl) {
                if (ngModelCtrl) {
                    vm.isValidPasswd = true;
                    vm.rulesList = [];
                    angular.forEach(vm.tempRules, function(rule) {
                        vm.rulesList[rule.dispSeq] = (!rule.invert) ? validatePolicyItem(rule, ngModelCtrl) : validatePolicyItemInvert(rule, ngModelCtrl);
                    });
                }
            };

            function validatePolicyItem(rule, ngModelCtrl) {
                var ret = rule.passwdRuleText;
                var matcher = new RegExp(rule.charListRegExp);
                if (matcher.test(ngModelCtrl.$viewValue)) {
                    ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
                } else {
                    vm.isValidPasswd = false;
                    ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
                }
                return ret;
            }

            function validatePolicyItemInvert(rule, ngModelCtrl) {
                var ret;
                var matcher = new RegExp(rule.charListRegExp);
                if (matcher.test(ngModelCtrl.$viewValue)) {
                    vm.isValidPasswd = false;
                    ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
                } else {
                    ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
                }
                return ret;
            }

            $scope.$watch('vm.user.userPrefs.PREF_LANG', function(newLangCd) {
                vm.switchLang(newLangCd);
            });

            $timeout(function() {
                $('input').on('keypress', function() {
                    vm.enableSubmit();
                });
            });

            vm.orgHasRole = function(cd) {
                return vm.user.orgRoles.indexOf(cd) !== -1;
            };

            if (vm.user.offcPhonCntryCd) {
                vm.offcPhonCntryCd = $filter('filter')(vm.phnCntryCodes, {
                    cd: vm.user.offcPhonCntryCd
                }, true)[0];
            }

            if (vm.user.moblPhonCntryCd) {
                vm.moblPhonCntryCd = $filter('filter')(vm.phnCntryCodes, {
                    cd: vm.user.moblPhonCntryCd
                }, true)[0];
            }

            vm.onOffcPhonCntryCdSelected = function(item) {
                vm.user.offcPhonCntryCd = item.cd;
            };

            vm.onOffcPhonCntryCdChange = function() {
                if (!vm.offcPhonCntryCd) {
                    vm.user.offcPhonCntryCd = null;
                }
            };

            vm.onMoblPhonCntryCdSelected = function(item) {
                vm.user.moblPhonCntryCd = item.cd;
                vm.validateMobileNumber();
            };

            vm.onMoblPhonCntryCdChange = function() {
                if (!vm.moblPhonCntryCd) {
                    vm.user.moblPhonCntryCd = null;
                    vm.validateMobileNumber();
                }
            };

            vm.validateMobileNumber = function() {
                if (vm.user.moblPhonNum && vm.user.moblPhonCntryCd) {
                    AuthenticateService.validateMobileNumber({
                        moblPhonNum: vm.user.moblPhonNum,
                        moblPhonCntryCd: vm.user.moblPhonCntryCd
                    }).$promise.then(function(result) {
                        if (result.valid) {
                            $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', true);
                        } else {
                            vm.disableSubmit();
                            $scope.registerForm.moblPhonNum.$invalid = true;
                            $scope.registerForm.moblPhonNum.$error.invalidPhoneNumber = true;
                            $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', false);
                        }
                    });
                } else {
                    $scope.registerForm.moblPhonNum.$setValidity('invalidPhoneNumber', true);
                }
            };

            vm.submit = function(registerForm) {
                delete vm.user.userPrefs.undefined; //deleting any undefined user preferences
                if (vm.user.offcPhonNum === '') {
                    delete vm.user.offcPhonNum;
                }
                if (vm.user.moblPhonNum === '') {
                    delete vm.user.moblPhonNum;
                }
                vm.disableSubmit();
                vm.validateMobileNumber();
                if ($.isEmptyObject(registerForm.$error)) {
                    AuthenticateService.activate(vm.user, function onSuccess() {
                        toastr.success(
                            $translate.instant('login.compltRegstrn.toast.compltRegstrnSuccess'),
                            $translate.instant('login.compltRegstrn.pageTitle'),
                            toastr.options
                        );
                        $rootScope.userEmail = vm.user.userId;//used this variable on login controller
                        $state.go('login', {}, {reload: true});
                    }, function onError() {
                        toastr.error(
                            $translate.instant('login.compltRegstrn.toast.compltRegstrnError'),
                            $translate.instant('login.compltRegstrn.pageTitle'),
                            toastr.options
                        );
                    });
                }
            };

            vm.onKeyDown = function($event) {
                var keyCode = $event.keyCode || $event.which;
                if (keyCode === 13) {
                    $event.preventDefault();
                } else if (keyCode === 8) {
                    vm.enableSubmit();
                }
            };

            vm.isSubmitDisabled = function() {
                return $('.register-submit-btn').is(':disabled');
            };

            vm.tosVisited = function() {
                if (vm.visiteTos === false) {
                    vm.openTosDialogBox();
                }
                vm.enableSubmit();
            };

            vm.enableSubmit = function() {
                $('.register-submit-btn').attr('disabled', false);
            };

            vm.disableSubmit = function() {
                $('.register-submit-btn').attr('disabled', true);
            };

            // Set the page title key to the one configured in state or use default one
            if ($state.current.data && $state.current.data.i18n && $state.current.data.i18n.pageTitle) {
                $translate($state.current.data.i18n.pageTitle).then(function (translatedString) {
                    $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
                });
            } else {
                $window.document.title = $rootScope.APPL_SH_NAME;
            }

            vm.openTosDialogBox = function() {
                vm.visiteTos = true;
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'info-dialog-template.html',
                    controller: 'TosModalCtrl',
                    controllerAs: 'modal',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    resolve: {
                        properties: function() {
                            return vm.properties;
                        },
                        sysParms: function() {
                            return vm.sysParms;
                        },
                        langCds: function() {
                            return vm.langCds;
                        },
                        userLang: function() {
                            return vm.userLang;
                        },
                        switchLang: function() {
                            return vm.switchLang;
                        }
                    }
                });
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ForgotPasswordCtrl', ['$rootScope', '$uibModal', '$state', '$window', '$filter', '$translate', 'PasswordService', 'sysParms', 'properties', 'langCds', 'userPrefTypes', ForgotPasswordCtrl]);

    function ForgotPasswordCtrl($rootScope, $uibModal, $state, $window, $filter, $translate, PasswordService, sysParms, properties, langCds, userPrefTypes) {
        var vm = this;
        vm.properties = properties.data;
        vm.emailBlured = false;
        vm.passwordBlured = false;
        vm.sysParms = sysParms.data;
        vm.resetLadda = false;
        $rootScope.APPL_SH_NAME = vm.sysParms.APPL_SH_NAME;
        if ($rootScope.recPassEmail !== '') {
            vm.email = $rootScope.recPassEmail;
            $('.add-reset-btn').attr('disabled', false);
        }

        vm.langCds = $filter('orderBy')(langCds.data.refItems, 'dispSeq');
        vm.switchLang = function(newLangCd) {
            vm.userLang = $filter('filter')(vm.langCds, {cd: newLangCd})[0];
            langCd = newLangCd;
            $translate.use(langCd);
            localStorage.setItem('langCd', langCd);
        };

        var langCd = localStorage.getItem('langCd');
        if (!langCd) {
            langCd = $window.navigator.languages && $window.navigator.languages[0] || // Chrome / Firefox
                $window.navigator.language ||   // All browsers
                $window.navigator.userLanguage; // IE <= 10
            if (langCd.indexOf('-') >= 0) {
                langCd = langCd.substring(0, langCd.indexOf('-')).trim();
            }
            langCd = langCd.toUpperCase();
        }
        //check language supported by IDMX.  If not set to default
        if (!$filter('filter')(vm.langCds, {cd: langCd}, true).length) {
            var defltLangCd = $filter('filter')(userPrefTypes.data.refItems, {
                cd: 'PREF_LANG'
            }, true)[0].entity.defaultUserPrefCd;
            langCd = defltLangCd;
        }
        vm.switchLang(langCd);

        $translate($state.current.data.i18n.pageTitle).then(function (translatedString) {
            $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
        });

        vm.passwordReset = function(forgotPassForm) {
            if ($.isEmptyObject(forgotPassForm.$error)) {
                vm.authenticationError = false;
                vm.userId = vm.email;
                if (vm.userId === '') {
                    return false;
                }
                vm.resetLadda = true;
                PasswordService.reqReset({
                    userId: vm.userId
                }, function(data) {
                    if (data.error) {
                        vm.resetLadda = false;
                        toastr.error(
                            $translate.instant('login.forgtPasswd.toast.passwdResetEmailSentError'),
                            $translate.instant('login.forgtPasswd.pageTitle'),
                            toastr.options
                        );
                        vm.authenticationError = true;
                        switch (data.error.code) {
                        case '101':
                            vm.errorI18n = 'login.forgtPasswd.valid.acctPendg';
                            break;
                        case '102':
                            vm.errorI18n = 'login.forgtPasswd.valid.acctInactv';
                            break;
                        case '103':
                            vm.errorI18n = 'login.forgtPasswd.valid.acctDel';
                            break;
                        case '999':
                            vm.errorI18n = 'login.home.valid.unspecError';
                            vm.errorMsg = data.error.msg;
                            break;
                        }
                    } else {
                        toastr.success(
                            $translate.instant('login.forgtPasswd.toast.passwdResetEmailSentSuccess'),
                            $translate.instant('login.forgtPasswd.pageTitle'),
                            toastr.options
                        );
                        $rootScope.recPassEmail = vm.userId;
                        $state.go('login', {}, {reload: true});
                    }
                });
            }
        };

        $('input').on('keypress', function() {
            vm.enableSubmit();
        });

        vm.submitViaEnterKey = function($event, forgotPassForm) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                forgotPassForm.$submitted = true;
                vm.passwordReset(forgotPassForm);
            }
        };

        vm.enableSubmit = function() {
            $('.add-reset-btn').attr('disabled', false);
        };

        vm.navToLogin = function() {
            var userEmail = vm.email;
            $rootScope.recPassEmail = userEmail;
            $state.go('login');
        };

        vm.openTosDialogBox = function() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'info-dialog-template.html',
                controller: 'TosModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    properties: function() {
                        return vm.properties;
                    },
                    sysParms: function() {
                        return vm.sysParms;
                    },
                    langCds: function() {
                        return vm.langCds;
                    },
                    userLang: function() {
                        return vm.userLang;
                    },
                    switchLang: function() {
                        return vm.switchLang;
                    }
                }
            });
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', routeConfig]);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.profile', {
                url: '/profile',
                views: {
                    'content@app': {
                        templateUrl: 'app/profile/profile.html',
                        controller: 'ProfileCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.header.profile',
                        pageTitle: 'login.profile.pageTitle',
                        pageDesc: 'login.profile.pageDesc'
                    },
                    icon: 'fa-user-circle-o',
                    showInMenu: 'dropdown'
                },
                resolve: {
                    userProfile: ['AccountService', getUser],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('subj');
                        return $translate.refresh();
                    }]
                }
            });
    }

    function getUser(AccountService) {
        return AccountService.get({
        }).$promise.then(function(user) {
            return user;
        }, function(reason) {
            return reason;
        });
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('profilePrefRadio', [profilePrefRadio])
        .directive('userProfilePhoneCode', [userProfilePhoneCode])
        .directive('userProfileMobileCode', [userProfileMobileCode])
        .directive('profileInputFocus', ['$timeout', profileInputFocus]);

    function profilePrefRadio() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem) {
                var elemValue;
                var elemId;
                $(elem).on('ifClicked', function(e) {
                    setTimeout(function() {
                        elemValue = $(e.target).val();
                        elemId = $(e.target).attr('name');
                        $(e.target).iCheck('check');
                        scope.vm.userProfile.userPrefs[elemId] = elemValue;
                        scope.vm.enableSubmit('userPref-edit-submit-btn');
                    }, 0);
                });
            }
        };
    }

    function userProfilePhoneCode() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.userProfile.offcPhonCntryCd !== '') {
                    var selectedPhoneCode = scope.vm.getCountryCode(scope.vm.userProfile.offcPhonCntryCd);
                    scope.vm.phoneCodeSelected = selectedPhoneCode[0];
                    controller.$viewValue = selectedPhoneCode[0].nm;
                    controller.$modelValue = selectedPhoneCode[0];
                    controller.$$lastCommittedViewValue = selectedPhoneCode[0].nm;
                    controller.$render();
                    controller.$invalid = false;
                }
            }
        };
    }

    function userProfileMobileCode() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, controller) {
                if (scope.vm.userProfile.moblPhonCntryCd !== '') {
                    var selectedMobileCode = scope.vm.getCountryCode(scope.vm.userProfile.moblPhonCntryCd);
                    scope.vm.mobileCodeSelected = selectedMobileCode[0];
                    controller.$viewValue = selectedMobileCode[0].nm;
                    controller.$modelValue = selectedMobileCode[0];
                    controller.$$lastCommittedViewValue = selectedMobileCode[0].nm;
                    controller.$render();
                    controller.$invalid = false;
                    controller.$setValidity('required', true);
                }
            }
        };
    }

    function profileInputFocus($timeout) {
        return {
            link: function(scope, element, attrs) {
                scope.$watch(attrs.profileInputFocus, function(val) {
                    if (angular.isDefined(val) && val) {
                        $timeout(function() {
                            element[0].focus();
                        });
                    }
                }, true);

                element.bind('blur', function () {
                    if (angular.isDefined(attrs.profileInputFocusLost)) {
                        scope.$apply(attrs.profileInputFocusLost);
                    }
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ProfileCtrl', ['$rootScope', '$scope', '$state', '$http', 'apiUrl', '$window', '$timeout', '$translate', '$filter', 'AccountService', 'AuthenticateService', 'userProfile', ProfileCtrl]);

    function ProfileCtrl($rootScope, $scope, $state, $http, apiUrl, $window, $timeout, $translate, $filter, AccountService, AuthenticateService, userProfile) {
        var vm = this;

        //set language after window reload when setting user prefs
        var langCd = $rootScope.account.userPrefs.PREF_LANG;
        $translate.use(langCd);
        localStorage.setItem('langCd', langCd);

        vm.userProfile = userProfile;
        vm.systemRoles = [];
        vm.references = $rootScope.referenceData;
        vm.status = vm.references.USR_STAT_CD.refItems;
        vm.userPrefTypes = vm.references.USR_PREF_TYPE.refItems;
        vm.phnCntryCodes = vm.references.PHON_CNTRY_CD.refItems;
        vm.cntryCodes = vm.references.CNTRY_CD.refItems;
        vm.isEnabledPersonalInfoForm = false;
        vm.isEnabledUserPrefForm = false;
        vm.isEnabledPasswordForm = false;
        vm.moblPhonNum = vm.userProfile.moblPhonNum;
        vm.moblPhonCode = vm.userProfile.moblPhonCntryCd;
        vm.currSubj = (vm.userProfile.currentSubj) ? vm.userProfile.currentSubj.targetName : '';
        if (vm.userProfile.currentSubj && vm.userProfile.currentSubj.effDate) {
            vm.currSubj += ' (' + $filter('shortDateFormat')(vm.userProfile.currentSubj.effDate) + ')';
        }
        vm.passwordDto = {
            newPassword: ''
        };

        vm.twoFactorAuthReq = $rootScope.sysParms.TFA_ENBLD_FLAG; //is two factor authnetication required or not?
        vm.cntryName = vm.references.CNTRY_CD.refItems.filter(function(country) {
            if (country.cd === vm.userProfile.orgCountry) {
                return country;
            }
        });

        $http.get(apiUrl + 'authenticate/passwdRules/' + langCd, {
        }).success(function(data) {
            if (data.length) {
                vm.policyPopover = {
                    templateUrl: 'passwd-policy-template.html'
                };
                vm.tempRules = prepRuleData(data);
                vm.validatePasswordPolicy(vm.ngModelCtrl);
                $('#' + vm.ngModelCtrl.$name).trigger('change');
            }
        });

        function prepRuleData(rules) {
            rules.sort(function(a, b) {
                return a.dispSeq - b.dispSeq;
            });
            var retList = [];
            rules.forEach(function(rule) {
                var tempRule = {};
                tempRule.dispSeq = rule.dispSeq;
                tempRule.invert = rule.passwdRuleParms.invert;
                tempRule.charListRegExp = rule.passwdRuleParms.charListRegExp;
                tempRule.passwdRuleText = rule.passwdRuleText;
                retList.push(tempRule);
            });
            return retList;
        }

        vm.isValidPasswd = true;
        vm.validatePasswordPolicy = function(ngModelCtrl) {
            if (ngModelCtrl) {
                vm.isValidPasswd = true;
                vm.rulesList = [];
                angular.forEach(vm.tempRules, function(rule) {
                    vm.rulesList[rule.dispSeq] = (!rule.invert) ? validatePolicyItem(rule, ngModelCtrl) : validatePolicyItemInvert(rule, ngModelCtrl);
                });
            }
        };

        function validatePolicyItem(rule, ngModelCtrl) {
            var ret = rule.passwdRuleText;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            } else {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        function validatePolicyItemInvert(rule, ngModelCtrl) {
            var ret;
            var matcher = new RegExp(rule.charListRegExp);
            if (matcher.test(ngModelCtrl.$viewValue)) {
                vm.isValidPasswd = false;
                ret = '<span class="fa fa-times-circle policy-not-met" style="margin-right: 10px;"></span>&nbsp;<span>' + rule.passwdRuleText + '</span>';
            } else {
                ret = '<span class="fa fa-check-circle policy-met" style="margin-right: 10px;"></span>&nbsp;<span class="policy-met">' + rule.passwdRuleText + '</span>';
            }
            return ret;
        }

        vm.getCountryCode = function(cd) {
            return vm.phnCntryCodes.filter(function (item) {
                if (item.cd === cd) {
                    return item;
                }
            });
        };

        if (vm.userProfile.moblPhonCntryCd) {
            vm.mobileCodeSelected = (vm.getCountryCode(vm.userProfile.moblPhonCntryCd))[0].nm;
        }

        if (vm.userProfile.offcPhonCntryCd) {
            vm.officeCodeSelected = (vm.getCountryCode(vm.userProfile.offcPhonCntryCd))[0].nm;
        }

        angular.forEach(vm.userProfile.userRoles, function(value) {
            $rootScope.referenceData.USR_ROLE_TYPE.refItems.filter(function(role) {
                if (role.cd === value) {
                    vm.systemRoles.push(role);
                }
            });
        });

        vm.statusName = function (cd) {
            return $rootScope.referenceData.USR_STAT_CD.refItems.filter(function (status) {
                return status.cd === cd;
            });
        };

        vm.onMobileCodeSelectedCallback = function() {
            var $modelValue = $scope.personalInfoForm.mobileField.$modelValue;
            if ($modelValue !== undefined && typeof($modelValue) === 'object') {
                vm.userProfile.moblPhonCntryCd = $modelValue.cd;
                $scope.personalInfoForm.mobileField.$valid = true;
                return false;
            }
            return true;
        };

        vm.onPhoneCodeSelectedCallback = function() {
            var $modelValue = $scope.personalInfoForm.phField.$modelValue;
            $('#offcPhonNum').focus();
            if ($modelValue !== undefined && typeof($modelValue) === 'object') {
                vm.userProfile.offcPhonCntryCd = $modelValue.cd;
                $scope.personalInfoForm.phField.$valid = true;
                return false;
            }
            return true;
        };

        $('input').on('keypress', function() {
            var className;
            if (vm.isEnabledPersonalInfoForm) {
                className = 'profile-edit-submit-btn';
            } else if (vm.isEnabledUserPrefForm) {
                className = 'userPref-edit-submit-btn';
            } else if (vm.isEnabledPasswordForm) {
                className = 'password-edit-submit-btn';
            }
            vm.enableSubmit(className);
        });

        $('button').on('keydown', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $(this).trigger('click');
            }
        });

        vm.validateMobileNumber = function() {
            vm.onMobileCodeSelectedCallback();
            var $modelValue = $scope.personalInfoForm.mobileField.$modelValue;
            if ($scope.personalInfoForm.mobilePhonNum.$viewValue !== '' && $modelValue !== undefined && typeof($modelValue) === 'object') {
                var validObj = {
                    userId: vm.userProfile.userId,
                    moblPhonNum: $scope.personalInfoForm.mobilePhonNum.$viewValue,
                    moblPhonCntryCd: vm.userProfile.moblPhonCntryCd
                };
                AuthenticateService.validateMobileNumber(validObj, function onSuccess(result) {
                    if (result.valid) {
                        $scope.personalInfoForm.mobilePhonNum.$valid = true;
                        $scope.personalInfoForm.mobilePhonNum.$error.mobileNumberExists = false;
                        $scope.personalInfoForm.mobilePhonNum.$setValidity('mobileNumberExists', true);
                    } else {
                        vm.disableSubmit('profile-edit-submit-btn');
                        $scope.personalInfoForm.mobilePhonNum.$invalid = true;
                        $scope.personalInfoForm.mobilePhonNum.$error.mobileNumberExists = true;
                        $scope.personalInfoForm.mobilePhonNum.$setValidity('mobileNumberExists', false);
                    }
                }, function onError() {
                    vm.disableSubmit('profile-edit-submit-btn');
                });
            }
        };

        vm.submit = function(personalInfoForm) {
            vm.disableSubmit('profile-edit-submit-btn');
            vm.onPhoneCodeSelectedCallback();
            vm.onMobileCodeSelectedCallback();
            var phone = $scope.personalInfoForm.phField.$modelValue;
            var phViewVal = $scope.personalInfoForm.phField.$viewValue;
            var mobile = $scope.personalInfoForm.mobileField.$modelValue;
            var mbViewVal = $scope.personalInfoForm.mobileField.$viewValue;
            if (mbViewVal === '') {
                vm.userProfile.moblPhonCntryCd = '';
            }
            if (phViewVal === '') {
                vm.userProfile.offcPhonCntryCd = '';
            }
            if ((phViewVal !== '' && typeof(phone) !== 'object') || (mbViewVal !== '' && typeof(mobile) !== 'object')) {
                return false;
            }
            if ($.isEmptyObject(personalInfoForm.$error)) {
                vm.laddaSave = true;
                AccountService.save(vm.userProfile, function onSuccess() {
                    toastr.success(
                        $translate.instant('login.profile.toast.updtPersDetlsSuccess'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                    vm.laddaSave = false;
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('login.profile.toast.updtPersDetlsError'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        vm.submitPasswordForm = function(passwordForm) {
            vm.disableSubmit('password-edit-submit-btn');
            vm.validatePassword();
            if ($.isEmptyObject(passwordForm.$error)) {
                vm.laddaSave = true;
                AccountService.changePassword(vm.passwordDto, function onSuccess() {
                    toastr.success(
                        $translate.instant('login.profile.toast.updtPasswdSuccess'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                    vm.laddaSave = false;
                    $state.reload();
                }, function onError() {
                    toastr.error(
                        $translate.instant('login.profile.toast.updtPasswdError'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                    vm.laddaSave = false;
                    $scope.passwordForm.password.$error.samePassword = true;
                    $scope.passwordForm.password.$setValidity('samePassword', false);
                });
            }
        };

        vm.validatePassword = function() {
            var password = $scope.passwordForm.password.$viewValue;
            if (password !== '' && typeof(password) !== 'undefined' && password.length >= 8) {
                AccountService.validatePassword({
                    newPassword: password
                }, function onSuccess(result) {
                    if (result.validPassword) {
                        $scope.passwordForm.password.$error.samePassword = false;
                        $scope.passwordForm.password.$setValidity('samePassword', true);
                    } else {
                        $scope.passwordForm.password.$error.samePassword = true;
                        $scope.passwordForm.password.$setValidity('samePassword', false);
                    }
                }, function onError() {
                });
            }
        };

        vm.validateConfirmPassword = function() {
            var password = $scope.passwordForm.password.$viewValue;
            var confirmPassword = $scope.passwordForm.confirmPassword.$viewValue;
            if (confirmPassword !== '' && typeof(confirmPassword) !== 'undefined' && confirmPassword.length >= 8 && (password === '' || typeof(password) === 'undefined') && password !== confirmPassword) {
                AccountService.validatePassword({
                    newPassword: confirmPassword
                }, function onSuccess(result) {
                    if (result.validPassword) {
                        $scope.passwordForm.confirmPassword.$error.samePassword = false;
                        $scope.passwordForm.confirmPassword.$setValidity('samePassword', true);
                    } else {
                        $scope.passwordForm.confirmPassword.$error.samePassword = true;
                        $scope.passwordForm.confirmPassword.$setValidity('samePassword', false);
                    }
                }, function onError() {
                });
            }
            $scope.passwordForm.confirmPassword.$error.samePassword = false;
            $scope.passwordForm.confirmPassword.$setValidity('samePassword', true);
        };

        vm.submitUserPrefForm = function(userPrefForm) {
            vm.disableSubmit('userPref-edit-submit-btn');
            if ($.isEmptyObject(userPrefForm.$error)) {
                vm.laddaSave = true;
                AccountService.save(vm.userProfile, function onSuccess() {
                    $rootScope.account.userPrefs = userProfile.userPrefs;
                    toastr.success(
                        $translate.instant('login.profile.toast.updtUsrPrefsSuccess'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                    $timeout(function() {
                        $window.location.reload();
                    }, 3000);
                }, function onError() {
                    toastr.error(
                        $translate.instant('login.profile.toast.updtUsrPrefsError'),
                        $translate.instant('login.profile.pageTitle'),
                        toastr.options
                    );
                });
            }
        };

        vm.isSubmitDisabled = function(className) {
            return $('.' + className).is(':disabled');
        };

        vm.enableSubmit = function(className) {
            $('.' + className).attr('disabled', false);
        };

        vm.disableSubmit = function(className) {
            $('.' + className).attr('disabled', true);
        };

        vm.enableUserPrefForm = function() {
            vm.isEnabledUserPrefForm = true;
            $('input').iCheck('enable');
        };

        vm.resetForm = function() {
            $state.reload();
        };

        vm.onKeyDown = function($event, className) {
            var keyCode = $event.keyCode || $event.which;
            if (keyCode === 13) {
                $event.preventDefault();
            } else if (keyCode === 8) {
                vm.enableSubmit(className);
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', routeConfig]);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.portfolio', {
                url: '/portfolio',
                views: {
                    'content@app': {
                        controller: 'PortfolioCtrl'
                    }
                },
                data: {
                    userPerms: ['VIEW_PORTFL_DASH', 'VIEW_PORTFL_OBSV', 'VIEW_PORTFL_SCORE', 'VIEW_PORTFL_ANLYTCS', 'DOWNLD_PORTFL_REPT', 'VIEW_PORTFL_ACTVTY'],
                    i18n: {
                        menu: 'menu.portfl.top',
                        pageTitle: 'menu.portfl.top'
                    },
                    icon: 'fa-briefcase',
                    showIconInMenu: true,
                    showInMenu: 'always',
                    menuDispSeq: 1
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subj');
                        $translatePartialLoader.addPart('anlytcs');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.portfolio.dashboard', {
                url: '/dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/portfolio/pfDashboard.html',
                        controller: 'PfDashboardCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['VIEW_PORTFL_DASH'],
                    i18n: {
                        menu: 'menu.portfl.dashbrd',
                        pageTitle: 'subj.portflDashbrd.pageTitle',
                        pageDesc: 'subj.portflDashbrd.pageDesc',
                        userPermsMsg: 'subj.portflDashbrd.valid.noViewPortflDashPermsn'
                    },
                    icon: 'fa-th-large'
                },
                resolve: {
                    orgMetrics: ['OrgService', 'userParms', getOrgMetrics],
                    userMetrics: ['UserService', 'userParms', getUserMetrics],
                    subjectStatusMetrics: ['SubjectsService', 'userParms', getSubjectStatusMetrics],
                    allScoreDistMetrics: ['SubjectsService', 'userParms', getAllScoreDistMetrics],
                    allObsvDistMetrics: ['ObservationService', 'userParms', getAllPfObsvDistribution],
                    userActivityMetrics: ['UserService', 'userParms', getPfUserActivityMetrics]
                }
            })
            .state('app.portfolio.subjects', {
                url: '/subjects',
                views: {
                    'content@app': {
                        templateUrl: 'app/portfolio/pfSubjects.html',
                        controller: 'PfSubjectsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['VIEW_PORTFL_SUBJS'],
                    i18n: {
                        menu: 'menu.portfl.subjs',
                        pageTitle: 'subj.portflSubjs.pageTitle',
                        pageDesc: 'subj.portflSubjs.pageDesc',
                        userPermsMsg: 'subj.portflSubjs.valid.noViewPortflSubjsPermsn'
                    },
                    icon: 'fa-folder-open'
                },
                resolve: {
                    pfCompletedSubjects: ['SubjectsService', 'userParms', getPfCompletedSubjects],
                    subjectStatusMetrics: ['SubjectsService', 'userParms', getSubjectStatusMetrics],
                    userParms: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/userParms', {cache: true});
                    }]
                }
            })
            .state('app.portfolio.observations', {
                url: '/observations',
                views: {
                    'content@app': {
                        templateUrl: 'app/portfolio/pfObservations.html',
                        controller: 'PfObservationsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['VIEW_PORTFL_OBSV'],
                    i18n: {
                        menu: 'menu.portfl.obsvs',
                        pageTitle: 'obsv.portflObsvs.pageTitle',
                        pageDesc: 'obsv.portflObsvs.pageDesc',
                        userPermsMsg: 'obsv.portflObsvs.valid.noViewPortflObsvsPermsn'
                    },
                    icon: 'fa-flag'
                },
                resolve: {
                    observations: ['ObservationService', 'userParms', getPfObservationAnalysis],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('obsv');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.portfolio.scoring', {
                abstract: true,
                url: '/scoring',
                data: {
                    userPerms: ['VIEW_PORTFL_SCORE'],
                    i18n: {
                        menu: 'menu.portfl.scorg',
                        userPermsMsg: 'score.portflScore.valid.noViewPortflScorePermsn'
                    },
                    icon: 'fa-bar-chart-o'
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('score');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.portfolio.scoring.type', {
                url: '/type/:scoreTypeCd',
                views: {
                    'content@app': {
                        templateUrl: 'app/portfolio/pfScores.html',
                        controller: 'PfScoresCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        pageTitle: 'score.portflScore.pageTitle',
                        pageDesc: 'score.portflScore.pageDesc',
                        userPermsMsg: 'score.portflScore.valid.noViewPortflScorePermsn'
                    },
                    showIconInMenu: false,
                    setBreadcrumb: true
                },
                resolve: {
                    scoreDistMetrics: ['SubjectsService', 'userParms', '$stateParams', getScoreDistMetricsByScoreTypeHierNodeId],
                    scoreHierNodes: ['ScoreService', '$stateParams', getScoreHierNodes],
                    scoreHierLevels: ['ScoreService', '$stateParams', getScoreHierLevels]
                }
            })
            .state('app.portfolio.analytics', {
                url: '/analytics',
                views: {
                    'content@app': {
                        templateUrl: 'app/subject/analytics/analytics.html',
                        controller: 'AnalyticsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['VIEW_PORTFL_ANLYTCS'],
                    i18n: {
                        menu: 'menu.portfl.anlytcs',
                        pageTitle: 'anlytcs.portflAnlytcs.pageTitle',
                        pageDesc: 'anlytcs.portflAnlytcs.pageDesc',
                        userPermsMsg: 'anlytcs.portflAnlytcs.valid.noViewPortflAnlytcsPermsn'
                    },
                    icon: 'fa-binoculars',
                    showIconInMenu: true
                },
                resolve: {
                    chartCds: ['AnalyticsService', getChartCds]
                }
            })
            .state('app.portfolio.reports', {
                url: '/reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/subject/summary/reports/reports.html',
                        controller: 'ReportsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['DOWNLD_PORTFL_REPT'],
                    i18n: {
                        menu: 'menu.portfl.repts',
                        pageTitle: 'rept.portflRepts.pageTitle',
                        pageDesc: 'rept.portflRepts.pageDesc',
                        userPermsMsg: 'rept.portflRepts.valid.noDownldPortflReptPermsn'
                    },
                    icon: 'fa-file-text-o',
                    showIconInMenu: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rept');
                        return $translate.refresh();
                    }],
                    reports: ['ReportsService', getPfReports]
                }
            });

        function getOrgMetrics(OrgService, userParms) {
            return OrgService.getPfOrgMetrics({
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getUserMetrics(UserService, userParms) {
            return UserService.getPfUserMetrics({
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getPfUserActivityMetrics(UserService, userParms) {
            return UserService.getPfUserActivityMetrics({
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getSubjectStatusMetrics(SubjectsService, userParms) {
            return SubjectsService.getPfSubjectStatusMetrics({
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getPfCompletedSubjects(SubjectsService, userParms) {
            return SubjectsService.getPfSubjectsByStatus({
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null,
                statusCd: 'C'
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getAllScoreDistMetrics(SubjectsService, userParms) {
            return SubjectsService.getAllScoreDistMetrics({
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getPfObservationAnalysis(ObservationService, userParms) {
            return ObservationService.getPfObservationAnalysis({
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getAllPfObsvDistribution(ObservationService, userParms) {
            return ObservationService.getPfObsvDistribution({
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getScoreDistMetricsByScoreTypeHierNodeId(SubjectsService, userParms, $stateParams) {
            return SubjectsService.getScoreDistMetricsByScoreTypeHierNodeId({
                scoreTypeCd: $stateParams.scoreTypeCd,
                scoreHierNodeId: 1,
                asOfFromDate: moment(userParms.data.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                asOfToDate: moment(userParms.data.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                orgId: (userParms.data.ORG_ID) ? userParms.data.ORG_ID.val : null
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getScoreHierNodes(ScoreService, $stateParams) {
            return ScoreService.getScoreHierNodes({
                scoreTypeCd: $stateParams.scoreTypeCd
            }).$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getScoreHierLevels(ScoreService, $stateParams) {
            return ScoreService.getScoreHierLevelsByScoreType({
                scoreType: $stateParams.scoreTypeCd
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getChartCds(AnalyticsService) {
            return AnalyticsService.getChartCds().$promise.then(function(res) {
                return res;
            }, function(reason) {
                return reason;
            });
        }

        function getPfReports(ReportsService) {
            return ReportsService.getPfReports().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('PortfolioCtrl', ['$rootScope', '$scope', '$state', '$filter', 'Principal', PortfolioCtrl]);

    function PortfolioCtrl($rootScope, $scope, $state, $filter, Principal) {
        redirect($state.current);

        $scope.$on('$stateChangeSuccess', function(event, toState) {
            redirect(toState);
        });

        function redirect(state) {
            if (state.name === 'app.portfolio') {
                if (Principal.hasUserPerm('VIEW_PORTFL_DASH')) { // Portfolio Dashboard
                    $state.go('app.portfolio.dashboard');
                } else if (Principal.hasUserPerm('VIEW_PORTFL_SCORE')) { // Portfolio Score
                    var scoreType = ($filter('orderBy')($rootScope.scoreTypes, 'dispSeq')[0]);
                    $state.go('app.portfolio.scoring.type', {scoreTypeCd: scoreType.scoreTypeCd});
                } else if (Principal.hasUserPerm('VIEW_PORTFL_OBSV')) { // Portfolio Observations
                    $state.go('app.portfolio.observations');
                } else if (Principal.hasUserPerm('VIEW_PORTFL_ANLYTCS')) { // Portfolio Analytics
                    $state.go('app.portfolio.analytics');
                } else if (Principal.hasUserPerm('VIEW_PORTFL_SUBJS')) { // Portfolio Subjects
                    $state.go('app.portfolio.subjects');
                } else if (Principal.hasUserPerm('DOWNLD_PORTFL_REPT')) { // Portfolio Reports
                    $state.go('app.portfolio.reports');
                } else { // if none then My Subjects
                    $state.go('app.subjects');
                }
            }
        }
    }

})();
(function() {
    'use strict';

    angular.module('app')
        .directive('subjectsDt', ['$filter', '$compile', '$translate', '$timeout', subjectsDt])
        .directive('subjsTab', ['$timeout', subjsTab])
        .directive('toolTip', [toolTip]);

    function subjectsDt($filter, $compile, $translate, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var subjStatCd = attrs.subjStatCd;

                $timeout(function() {
                    element.DataTable({
                        language: {
                            url: '../app/assets/i18n/datatables/' + scope.$root.userLang + '.json'
                        },
                        stateSave: true,
                        stateDuration: -1,
                        retrieve: true,
                        autoWidth: true,
                        lengthChange: false,
                        data: scope.vm.data[subjStatCd],
                        columns: [{
                            data: null,
                            render: function(data, type) {
                                if (data && data.targetName) {
                                    if (type === 'display') {
                                        return (data.subjDesc ? '<span uib-popover="' + data.subjDesc + '" popover-title="{{\'subj.portflSubjs.subjDescTitle\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top" style="cursor: pointer;">' : '')
                                            + data.targetName
                                            + (data.subjDesc ? '</span>' : '');
                                    }
                                    return data.targetName;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.subjEffDate) {
                                    if (type === 'display') {
                                        if (!scope.vm.subjEffDateOverdueFlag || moment(data.subjEffDate).endOf('day').toDate() >= new Date() || data.subjStartDate) {
                                            return $filter('dateOnlyFormat')(data.subjEffDate);
                                        }
                                        return '<span class="action-negative-color" uib-popover="{{\'subj.portflSubjs.help.subjEffDtOvdueText\' | translate}}" popover-title="{{\'subj.portflSubjs.subjEffDtHeader\' | translate}}" popover-trigger="mouseenter" popover-append-to-body="true" popover-placement="top" style="cursor: pointer;"><strong>' + $filter('dateOnlyFormat')(data.subjEffDate) + '<strong></span>';
                                    }
                                    if (type === 'filter') {
                                        return $filter('dateOnlyFormat')(data.subjEffDate);
                                    }
                                    return data.subjEffDate;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.subjStageName) {
                                    if (!data.subjStartDate && data.targetsSet) {
                                        if (type === 'display') {
                                            return '<span class="lbl-status-negative" translate="subj.home.stageTargSetText"><span>';
                                        }
                                        return $translate.instant('subj.home.stageTargSetText');
                                    }
                                    if (type === 'display') {
                                        return '<span class="lbl-stages">' + data.subjStageName + '<span>';
                                    }
                                    return data.subjStageName;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.subjStartDate) {
                                    if (type === 'display' || type === 'filter') {
                                        if (data.subjStartedByUser) {
                                            var title = $translate.instant('subj.portflSubjs.subjStartUserNameText', {usrFullName: data.subjStartedByUser});
                                            return '<span tool-tip data-toggle="tooltip" data-html="true" data-placement="top" data-title="' + title + '" style="cursor: pointer;">' + $filter('dateOnlyFormat')(data.subjStartDate) + '</span>';
                                        }
                                        return $filter('dateOnlyFormat')(data.subjStartDate);
                                    }
                                    return data.subjStartDate;
                                }
                                return '';
                            }
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.subjEndDate) {
                                    if (type === 'display' || type === 'filter') {
                                        return $filter('dateOnlyFormat')(data.subjEndDate);
                                    }
                                    return data.subjEndDate;
                                }
                                return '';
                            },
                            visible: subjStatCd === 'C' || subjStatCd === 'U',
                            searchable: subjStatCd === 'C' || subjStatCd === 'U'
                        }, {
                            data: null,
                            render: function(data) {
                                if (data && data.survey && data.survey.type) {
                                    return '<span class="lbl-survey">' + data.survey.type.name + '</span>';
                                }
                                return $translate.instant('subj.portflSubjs.noSurvText');
                            },
                            visible: subjStatCd === 'I' || subjStatCd === 'U',
                            searchable: subjStatCd === 'I' || subjStatCd === 'U'
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.survey && data.survey.startDate) {
                                    if (type === 'display' || type === 'filter') {
                                        if (data.survStartedByUser) {
                                            var title = $translate.instant('subj.portflSubjs.survStartUserNameText', {usrFullName: data.survStartedByUser});
                                            return '<span tool-tip data-toggle="tooltip" data-html="true" data-placement="top" data-title="' + title + '" style="cursor: pointer;">' + $filter('dateOnlyFormat')(data.survey.startDate) + '</span>';
                                        }
                                        return $filter('dateOnlyFormat')(data.survey.startDate);
                                    }
                                    return data.survey.startDate;
                                }
                                return '';
                            },
                            visible: subjStatCd === 'I' || subjStatCd === 'U',
                            searchable: subjStatCd === 'I' || subjStatCd === 'U'
                        }, {
                            data: null,
                            className: 'padded-icon-cell',
                            render: function(data, type) {
                                if (data && data.survey) {
                                    if (type === 'display') {
                                        return '<i class="fa fa-edit idmx-heading-icon"></i>'
                                            + '<span survey-percent-badge percent="' + data.survey.progPct + '">' + data.survey.progPct + '%</span>';
                                    }
                                    return data.survey.progPct;
                                }
                                return '';
                            },
                            visible: subjStatCd === 'I' || subjStatCd === 'U',
                            searchable: subjStatCd === 'I' || subjStatCd === 'U'
                        }, {
                            data: null,
                            render: function(data, type) {
                                if (data && data.lastAccessed) {
                                    if (type === 'display' || type === 'filter' && data.lastAccessedByUser) {
                                        var title = $translate.instant('subj.portflSubjs.lastAccsUserNameText', {usrFullName: data.lastAccessedByUser});
                                        return '<span tool-tip data-toggle="tooltip" data-html="true" data-placement="top" data-title="' + title + '" style="cursor: pointer;">' + $filter('dateOnlyFormat')(data.lastAccessed) + '</span>';
                                    }
                                    return data.lastAccessed;
                                }
                                return '';
                            }
                        }],
                        order: [
                            [0, 'asc']
                        ],
                        drawCallback: function() {
                            $compile(element)(scope);
                            var tableName = 'table-' + subjStatCd;
                            var searchBox = $('div#' + tableName + '_filter input');
                            searchBox.addClass('input form-control idmx-search-box hidden-xs').appendTo($('#idmx-table-tools'));
                            searchBox.attr('placeholder', $translate.instant('subj.portflSubjs.searchText')).attr('id', 'search-box-' + subjStatCd).addClass('pfSubjsSearch pull-right');
                            $('div#' + tableName + '_filter').find('label').hide();
                        }
                    });
                });
            }
        };
    }

    function subjsTab($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var subjStatCd = attrs.subjStatCd;
                element.click(function() {
                    //remove search boxes as will get added back again as DT is regenerated
                    $('.pfSubjsSearch').remove();
                    $timeout(function() {
                        scope.vm.activeTab = subjStatCd;
                    });
                });
            }
        };
    }

    function toolTip() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $(element).tooltip();
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('PfSubjectsCtrl', ['$rootScope', '$translate', 'AppService', 'SubjectsService', 'pfCompletedSubjects', 'subjectStatusMetrics', 'subjRoleTypes', 'userParms', 'targetRoleTypeName', 'sysParms', PfSubjectsCtrl]);

    function PfSubjectsCtrl($rootScope, $translate, AppService, SubjectsService, pfCompletedSubjects, subjectStatusMetrics, subjRoleTypes, userParms, targetRoleTypeName, sysParms) {
        var vm = this;
        vm.subjectStatusMetrics = subjectStatusMetrics;
        vm.userParms = userParms;
        vm.showSettings = AppService.showSettings;
        vm.subjEffDateOverdueFlag = sysParms.data.SUBJ_EFF_DATE_OVERDUE_FLAG.toUpperCase() === 'TRUE';
        vm.subjStatuses = [{
            cd: 'C',
            lbl: $translate.instant('subj.portflSubjs.compltTab'),
            loaded: true
        }, {
            cd: 'I',
            lbl: $translate.instant('subj.portflSubjs.inProgTab'),
            loaded: false
        }, {
            cd: 'S',
            lbl: $translate.instant('subj.portflSubjs.schedTab'),
            loaded: false
        }, {
            cd: 'U',
            lbl: $translate.instant('subj.portflSubjs.unschedTab'),
            loaded: false
        }];
        vm.data = {
            C: pfCompletedSubjects
        };
        vm.ladda = false;
        vm.activeTab = 'C';

        vm.targetRoleTypeName = targetRoleTypeName.data;

        angular.forEach(vm.subjStatuses, function(subjStatus) {
            if (!subjStatus.loaded) {
                SubjectsService.getPfSubjectsByStatus({
                    asOfFromDate: moment($rootScope.userParms.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                    asOfToDate: moment($rootScope.userParms.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                    orgId: ($rootScope.userParms.ORG_ID) ? $rootScope.userParms.ORG_ID.val : null,
                    statusCd: subjStatus.cd
                }).$promise.then(function(res) {
                    vm.data[subjStatus.cd] = res;
                    subjStatus.loaded = true;
                });
            }
        });

        vm.hasData = function() {
            var hasData = false;
            angular.forEach(vm.subjStatuses, function(subjStatus) {
                if (subjStatus.loaded && vm.data[subjStatus.cd].length > 0) {
                    hasData = true;
                }
            });
            return hasData;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('PfScoresCtrl', ['$rootScope', '$scope', '$filter', '$translate', 'SubjectsService', 'AppService', '$stateParams', 'scoreDistMetrics', 'scoreHierNodes', 'scoreHierLevels', PfScoresCtrl]);

    function PfScoresCtrl($rootScope, $scope, $filter, $translate, SubjectsService, AppService, $stateParams, scoreDistMetrics, scoreHierNodes, scoreHierLevels) {
        var vm = this;
        vm.showSettings = AppService.showSettings;

        $rootScope.breadcrumb = (scoreDistMetrics.scoreTypeName) ? scoreDistMetrics.scoreTypeName : 'Unknown Score Type';
        vm.scoreHierNodes = [scoreHierNodes];
        vm.scoreHierLvls = scoreHierLevels;

        vm.scoreHierLvls.sort(function(a, b) {
            return a.scoreHierLvlId - b.scoreHierLvlId;
        });
        vm.scoreHierNodes.sort(function(a, b) {
            return a.scoreHierNodeId - b.scoreHierNodeId;
        });

        vm.hierNodes = [];
        function buildNodeNames(parntNode, nodes) {
            angular.forEach(nodes, function(node) {
                var scoreHierLvl = $filter('filter')(vm.scoreHierLvls, {
                    scoreHierLvlId: node.scoreHierLvlId
                }, true)[0];

                if (scoreHierLvl && scoreHierLvl.allowDispFlag) {
                    node.scoreHierNodeModName = node.scoreHierNodeName;
                    if (node.scoreHierLvlId > 2 && node.scoreHierLvlId === scoreHierLvl.scoreHierLvlId && parntNode) {
                        node.scoreHierNodeModName = ((parntNode.scoreHierNodeModName) ? parntNode.scoreHierNodeModName : parntNode.scoreHierNodeName) + ': ' + node.scoreHierNodeName;
                    }
                    vm.hierNodes.push(node);
                }

                if (node.children && node.children.length) {
                    buildNodeNames(node, node.children);
                }
            });
        }
        buildNodeNames(null, vm.scoreHierNodes);

        vm.filteredHierNode = $filter('filter')(vm.hierNodes, { scoreHierNodeId: 1 }, true)[0];
        $scope.$watch('vm.filteredHierNode', function() {
            vm.filteredScoreHierLvl = $filter('filter')(vm.scoreHierLvls, { scoreHierLvlId: vm.filteredHierNode.scoreHierLvlId }, true)[0];
            getScoreDistMetricsByScoreTypeHierNodeId();
        });

        vm.getHierLvl = function() {
            return $filter('filter')(vm.scoreHierLvls, {
                scoreHierLvlId: vm.filteredHierNode.scoreHierLvlId
            }, true)[0];
        };

        function getScoreDistMetricsByScoreTypeHierNodeId() {
            if (vm.filteredHierNode) {
                SubjectsService.getScoreDistMetricsByScoreTypeHierNodeId({
                    scoreTypeCd: $stateParams.scoreTypeCd,
                    scoreHierNodeId: vm.filteredHierNode.scoreHierNodeId,
                    asOfFromDate: moment($rootScope.userParms.DT_RANGE_CD.val.asOfFromDate).format('YYYY-MM-DD'),
                    asOfToDate: moment($rootScope.userParms.DT_RANGE_CD.val.asOfToDate).format('YYYY-MM-DD'),
                    orgId: ($rootScope.userParms.ORG_ID) ? $rootScope.userParms.ORG_ID.val : null
                }).$promise.then(function(res) {
                    vm.meanScore = (res.subjCnt) ? $filter('number')(res.totalScore / res.subjCnt, res.scoreValDpCnt) : '';
                    vm.medianScore = $filter('number')(res.medianScore, res.scoreValDpCnt);
                    vm.minScore = $filter('number')(res.minScore, res.scoreValDpCnt);
                    vm.maxScore = $filter('number')(res.maxScore, res.scoreValDpCnt);
                    prepScoreDistChartData(res);
                });
            }
        }

        vm.chartData = {
            series: []
        };

        function prepScoreDistChartData(scores) {
            if (scores.subjCnt === 0) {
                vm.chartData = {
                    noDataFoundMessg: $translate.instant('score.portflScore.valid.noSubjsFound')
                };
            } else if (scores.subjCnt > 0 && !scores.scoreTiers) {
                vm.chartData = {
                    noDataFoundMessg: $translate.instant('score.portflScore.valid.noDataFound')
                };
            } else {
                var series = {
                    elements: []
                };
                if (vm.filteredHierNode) {
                    series.seriesColor = vm.filteredHierNode.seriesColor;
                }
                if (series.seriesColor) {
                    scores.scoreTiers.sort(function(a, b) {
                        return parseInt(a.minRange) - parseInt(b.minRange);
                    });
                    angular.forEach(scores.scoreTiers, function(tier) {
                        var scorePct = (tier.subjCnt) ? (parseInt(tier.subjCnt) / parseInt(scores.subjCnt)) * 100 : 0;
                        series.elements.push({
                            category: $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt),
                            value: tier.subjCnt,
                            tip: '<div class="idmx-d3-tip" tooltip-animation-class="fade">'
                                + '<div class="arrow"></div>'
                                + '<div class="popover-inner">'
                                + '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">'
                                + '<div class="color-box" style="background-color:' + series.seriesColor + '"></div>'
                                + '<div><h3 style="margin: 0px; margin-top: -1.5px;">' + $translate.instant('score.portflScore.scoreDistro.xAxisLabel') + ': ' + $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt) + '</h3></div>'
                                + '</div>'
                                + '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">'
                                + $translate.instant('score.portflScore.scoreDistro.subjCntPUCntLabel')
                                + ': ' + tier.subjCnt + ' &nbsp;&nbsp;&nbsp;&nbsp; '
                                + $translate.instant('score.portflScore.scoreDistro.subjCntPUPctLabel')
                                + ': ' + scorePct.toFixed() + '%'
                                + '</div>'
                                + '</div>'
                                + '</div>'
                        });
                    });
                }
                vm.chartData = {
                    series: [series]
                };
            }
        }
        prepScoreDistChartData(scoreDistMetrics);

        vm.chartConfig = {
            width: 550,
            height: 320,
            fixedWidth: true,
            fixedHeight: true,
            padding: {
                top: 15,
                bottom: 0,
                left: 0,
                right: 0
            },
            orientation: 'vertical',
            seriesLayout: 'grouped',
            catgAxisLabel: $translate.instant('score.portflScore.scoreDistro.xAxisLabel'),
            showCatgAxisScaleLabels: false,
            valueAxisLabel: $translate.instant('score.portflScore.scoreDistro.yAxisLabel'),
            valueAxisScaleTicksNum: 5,
            showGridlines: true
        };

        var maxColor = 40; // max no of color codes defined in variable.less file
        var idxColor = 1;
        addColor(vm.scoreHierNodes);
        function addColor(nodes) {
            angular.forEach(nodes, function(node) {
                var cls = 'chart-bg-color-' + idxColor++;
                $('body').append('<span class=' + cls + '>&nbsp</span>');
                var color = $($('.' + cls)[0]).css('background-color');
                if (idxColor > maxColor) {
                    idxColor = 1;
                }
                $($('.' + cls)[0]).remove();
                if (node) {
                    node.seriesColor = color;
                }
            });
            angular.forEach(nodes, function(node) {
                if (node) {
                    addColor(node.children);
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('PfObservationsCtrl', ['$rootScope', '$translate', '$scope', '$sce', '$filter', '$timeout', 'AppService', 'observations', PfObservationsCtrl]);

    function PfObservationsCtrl($rootScope, $translate, $scope, $sce, $filter, $timeout, AppService, observations) {
        var vm = this;
        vm.observations = observations;
        vm.showSettings = AppService.showSettings;

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        // Preparing initial data
        angular.forEach($rootScope.referenceData.HIER_LVL.refItems, function(refData) {
            if (refData.cd === '2') {
                vm.lvl2HierLvlName = refData.nm;
            }
            if (refData.cd === '3') {
                vm.lvl3HierLvlName = refData.nm;
            }
        });
        if (!vm.lvl2HierLvlName) {
            vm.lvl2HierLvlName = '';
        }
        if (!vm.lvl3HierLvlName) {
            vm.lvl3HierLvlName = '';
        }
        vm.priorityName = $translate.instant('obsv.home.priotLabel');
        vm.typeName = $translate.instant('obsv.home.typeLabel');

        // Get all level3 reference data.
        vm.lvl3Nodes = [];
        angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 3) {
                vm.lvl3Nodes.push({
                    type: vm.lvl3HierLvlName,
                    groupName: 'level3NodeId',
                    nm: value.entity.parntHierNodeName + ': ' + value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc,
                    parentNodeId: value.entity.parntHierNodeId
                });
                return value;
            }
        });

        // add drop down filter object for level2, priority and observation type. level3 Filter are dynamic based on level2 value
        vm.filters = [];
        angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
            if (value.entity.hierLvlId === 2) {
                vm.filters.push({
                    type: vm.lvl2HierLvlName,
                    groupName: 'level2NodeId',
                    nm: value.nm,
                    cd: parseInt(value.cd, 10),
                    desc: typeof value.desc === 'undefined' ? null : value.desc
                });
            }
        });
        angular.forEach($filter('orderBy')($rootScope.referenceData.OBSV_PRIOT_SEQ.refItems, 'dispSeq'), function(value) {
            vm.filters.push({
                type: vm.priorityName,
                groupName: 'obsvPrioritySeq',
                nm: value.nm,
                cd: parseInt(value.cd, 10),
                desc: typeof value.desc === 'undefined' ? null : value.desc
            });
        });
        angular.forEach($filter('orderBy')($rootScope.referenceData.OBSV_TYPE.refItems, 'dispSeq'), function(value) {
            vm.filters.push({
                type: vm.typeName,
                groupName: 'typeCd',
                nm: value.nm,
                cd: value.cd,
                desc: typeof value.desc === 'undefined' ? null : value.desc
            });
        });

        // Display group name and desc
        vm.getGroup = function(cd, groupName) {
            // level3 is not part of vm.filters because it is added dynamically in filter based on level2 value
            // Getting it from lvl3Nodes reference data.
            if (groupName === 'level3NodeId') {
                for (var j = 0; j < vm.lvl3Nodes.length; j++) {
                    if (vm.lvl3Nodes[j].cd.toString() === cd) {
                        return vm.lvl3Nodes[j];
                    }
                }
            } else {
                for (var i = 0; i < vm.filters.length; i++) {
                    if (vm.filters[i].cd.toString() === cd && vm.filters[i].groupName === groupName) {
                        return vm.filters[i];
                    }
                }
            }
        };

        vm.level2FilterVal = [];
        vm.priorityFilterVal = [];
        vm.typeFilterVal = [];

        // filter/group/sort default options
        vm.groupByField = 'level2NodeId';
        vm.groupByOrder = false;
        vm.orderByField = '-subjCount';

        $scope.$on('buildMasonryLayout', function() {
            var elem = document.querySelector('.grid');
            new Masonry(elem, {
                itemSelector: '.grid-item',
                percentPosition: true
            });
        });

        vm.applyFilter = function() {
            vm.level2FilterVal = [];
            vm.priorityFilterVal = [];
            vm.typeFilterVal = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                switch (filterItem.type) {
                case vm.lvl2HierLvlName:
                    vm.level2FilterVal.push({
                        id: filterItem.cd,
                        childKey: 'level3NodeId',
                        childIds: []
                    });
                    break;
                case vm.priorityName:
                    vm.priorityFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.typeName:
                    vm.typeFilterVal.push({
                        id: filterItem.cd
                    });
                    break;
                case vm.lvl3HierLvlName:
                    for (var i = vm.level2FilterVal.length - 1; i >= 0; i--) {
                        if (vm.level2FilterVal[i].id === filterItem.parentNodeId) {
                            vm.level2FilterVal[i].childIds.push(filterItem.cd);
                        }
                    }
                }
            });
            includeLvl3Filter();
            $timeout(function() {
                $(':focus').blur();
            });
        };

        vm.getFilteredObsvs = function() {
            return $filter('filterMultiple')(vm.observations.obsvs, {
                level2NodeId: vm.level2FilterVal,
                obsvPrioritySeq: vm.priorityFilterVal,
                typeCd: vm.typeFilterVal
            });
        };

        vm.getFilterObsvMetrics = function() {
            var cnt = 0;
            var highestPriority = Number.MAX_SAFE_INTEGER;
            angular.forEach(vm.getFilteredObsvs(), function(obsv) {
                cnt++;
                highestPriority = Math.min(highestPriority, obsv.obsvPrioritySeq);
            });
            if (highestPriority === Number.MAX_SAFE_INTEGER) {
                highestPriority = 0;
            }
            return {
                cnt: cnt,
                highestPriority: highestPriority
            };
        };

        function includeLvl3Filter() {
            // clean up vm.filterByField and remove level3 filter if it's parent is removed
            var newArr = [];
            angular.forEach(vm.filterByField, function(filterItem) {
                if (filterItem.type !== vm.lvl3HierLvlName || (filterItem.type === vm.lvl3HierLvlName && findWithAttr(vm.level2FilterVal, 'id', filterItem.parentNodeId) !== -1)) {
                    newArr.push(filterItem);
                }
            });
            vm.filterByField = newArr;

            // clear all level3 from filters drop down
            vm.filters = $filter('filter')(vm.filters, function(value) {
                return value.type !== vm.lvl3HierLvlName;
            });
            // add new level3 filters based on level2 values
            angular.forEach(vm.level2FilterVal, function(filterItem) {
                angular.forEach($filter('orderBy') ($rootScope.referenceData.HIER_NODE.refItems, 'dispSeq'), function(value) {
                    if (value.entity.hierLvlId === 3 && value.entity.parntHierNodeId === filterItem.id) {
                        vm.filters.unshift({
                            type: vm.lvl3HierLvlName,
                            groupName: 'level3NodeId',
                            nm: value.entity.parntHierNodeName + ': ' + value.nm,
                            cd: parseInt(value.cd, 10),
                            desc: typeof value.desc === 'undefined' ? null : value.desc,
                            parentNodeId: value.entity.parntHierNodeId
                        });
                    }
                });
            });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        vm.filterInit = function() {
            if ($rootScope.obsvTypeFilter) {
                vm.filterByField = $filter('filter')(vm.filters, {
                    cd: $rootScope.obsvTypeFilter,
                    groupName: 'typeCd'
                }, true);
                vm.applyFilter();
                $rootScope.obsvTypeFilter = null;
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('pfDashboardOrgCoverageProgress', ['$timeout', pfDashboardOrgCoverageProgress])
        .directive('pfDashboardUserCoverageProgress', ['$timeout', pfDashboardUserCoverageProgress])
        .directive('pfDashboardSubjectStatusProgress', ['$parse', pfDashboardSubjectStatusProgress])
        .directive('subjObservationProgress', ['AppService', subjObservationProgress]);

    function pfDashboardOrgCoverageProgress($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function () {
                    element.addClass('progress-bar');
                    element.addClass('org-metrics-progress-bar-bg');
                    var percent = scope.$eval(attrs.percent);
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function pfDashboardUserCoverageProgress($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function () {
                    element.addClass('progress-bar');
                    element.addClass('user-metrics-progress-bar-bg');
                    var percent = scope.$eval(attrs.percent);
                    element.css('width', percent + '%');
                }, 0);
            }
        };
    }

    function pfDashboardSubjectStatusProgress($parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs) {
                var ngModel = $parse(attrs.ngModel);
                element.css('width', ngModel(scope) + '%');
                scope.$watch('vm.subjectStatusMetrics', function () {
                    ngModel = $parse(attrs.ngModel);
                    element.css('width', ngModel(scope) + '%');
                });
            }
        };
    }

    function subjObservationProgress(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var percent = scope.$eval(attrs.percent);
                if (angular.isNumber(percent) && !isNaN(percent)) {
                    var featureConfig = AppService.featureTierRange('OBSV', 'COVRG', percent);
                    element.addClass('progress-bar');
                    element.css('background-color', featureConfig.configParam.badge.bgColor);
                    element.css('color', featureConfig.configParam.badge.fgColor);
                }
                element.css('width', percent + '%');
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('PfDashboardCtrl', ['$rootScope', '$state', '$translate', '$filter', '$timeout', 'uiTourService', 'AppService', 'orgMetrics', 'userMetrics', 'subjectStatusMetrics', 'allScoreDistMetrics', 'allObsvDistMetrics', 'userActivityMetrics', PfDashboardCtrl]);

    function PfDashboardCtrl($rootScope, $state, $translate, $filter, $timeout, uiTourService, AppService, orgMetrics, userMetrics, subjectStatusMetrics, allScoreDistMetrics, allObsvDistMetrics, userActivityMetrics) {
        var vm = this;

        vm.showSettings = AppService.showSettings;
        //Org Metric
        vm.orgMetrics = orgMetrics;
        vm.orgsCoverage = (orgMetrics.coveredOrgsCnt && orgMetrics.allOrgsCnt) ? (orgMetrics.coveredOrgsCnt / orgMetrics.allOrgsCnt) * 100 : 0;

        //User Metric
        vm.userMetrics = userMetrics;
        vm.usersCoverage = (userMetrics.coveredUsersCnt && userMetrics.allUsersCnt) ? (userMetrics.coveredUsersCnt / userMetrics.allUsersCnt) * 100 : 0;

        //Subj Status Metric
        function prepSubjectStatusMetrics() {
            if (vm.subjectStatusMetrics.totalSubjsCnt > 0) {
                vm.totalPct = 100;
                vm.completedPct = (vm.subjectStatusMetrics.completedCnt / vm.subjectStatusMetrics.totalSubjsCnt) * 100;
                vm.inProgressPct = (vm.subjectStatusMetrics.inProgressCnt / vm.subjectStatusMetrics.totalSubjsCnt) * 100;
                vm.scheduledPct = (vm.subjectStatusMetrics.scheduledCnt / vm.subjectStatusMetrics.totalSubjsCnt) * 100;
                vm.unscheduledPct = (vm.subjectStatusMetrics.unscheduledCnt / vm.subjectStatusMetrics.totalSubjsCnt) * 100;
            }
        }

        vm.subjectStatusMetrics = subjectStatusMetrics;
        vm.totalPct = 0;
        vm.completedPct = 0;
        vm.inProgressPct = 0;
        vm.scheduledPct = 0;
        vm.unscheduledPct = 0;
        prepSubjectStatusMetrics();

        //Score Dist Metric
        vm.allScoreDistMetrics = allScoreDistMetrics;
        vm.allScoreDistMetrics.sort(function(a, b) {
            return a.dispSeq - b.dispSeq;
        });

        //get chart colour
        $('body').append('<span class="lvl1-score-range-bg-color">&nbsp</span>');
        var scoreDistMetricChartColor = $($('.lvl1-score-range-bg-color')[0]).css('background-color');
        $($('.lvl1-score-range-bg-color')[0]).remove();

        vm.getScoreDistMetricsData = function(scoreDistMetrics) {
            //no data scenarios
            if (scoreDistMetrics.subjCnt === 0) {
                return {
                    noDataFoundMessg: $translate.instant('subj.portflDashbrd.valid.scoreDistroMetricNoSubjsFound')
                };
            }
            if (scoreDistMetrics.subjCnt > 0 && (!scoreDistMetrics.scoreTiers || (scoreDistMetrics.scoreTiers && scoreDistMetrics.scoreTiers.length === 0))) {
                return {
                    noDataFoundMessg: $translate.instant('subj.portflDashbrd.valid.scoreDistroMetricNoDataFound')
                };
            }

            var series = {
                seriesColor: scoreDistMetricChartColor,
                elements: []
            };
            if (scoreDistMetrics && scoreDistMetrics.scoreTiers && scoreDistMetrics.scoreTiers.length) {
                scoreDistMetrics.scoreTiers.sort(function(a, b) {
                    return parseInt(a.minRange) - parseInt(b.minRange);
                });
            }

            angular.forEach(scoreDistMetrics.scoreTiers, function(tier) {
                var scorePct = (tier.subjCnt) ? (parseInt(tier.subjCnt) / parseInt(scoreDistMetrics.subjCnt)) * 100 : 0;
                series.elements.push({
                    category: $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt),
                    value: tier.subjCnt,
                    tip: '<div class="idmx-d3-tip" tooltip-animation-class="fade">' +
                        '<div class="arrow"></div>' +
                        '<div class="popover-inner">' +
                        '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">' +
                        '<div class="color-box" style="background-color:' + series.seriesColor + '"></div>' +
                        '<div>' +
                        '<h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + $translate.instant('subj.portflDashbrd.scoreDistroMetricXAxisLabel') + ': ' + $filter('scoreTierLabel')(tier.minRange, tier.maxRange, tier.minScoreInclsvFlag, tier.maxScoreInclsvFlag, tier.scoreValDpCnt) + '</h3></div>' +
                        '</div>' +
                        '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">' +
                        $translate.instant('subj.portflDashbrd.scoreDistroMetricPUSubjCntLabel') +
                        ': ' + tier.subjCnt + '<br/>' +
                        $translate.instant('subj.portflDashbrd.scoreDistroMetricPUSubjPctLabel') +
                        ': ' + scorePct.toFixed() + '%' +
                        '</div>' +
                        '</div>' +
                        '</div>'
                });
            });
            return {
                series: [series]
            };
        };

        vm.scoreDistChartConfig = {
            width: 550,
            height: 130,
            padding: {
                top: 15,
                bottom: 3,
                left: 3,
                right: 3
            },
            orientation: 'vertical',
            seriesLayout: 'grouped',
            catgAxisLabel: $translate.instant('subj.portflDashbrd.scoreDistroMetricXAxisLabel'),
            showCatgAxisScaleLabels: false,
            valueAxisLabel: $translate.instant('subj.portflDashbrd.scoreDistroMetricYAxisLabel'),
            showGridlines: true,
            showLegend: false
        };

        //score carousel
        $timeout(function() {
            if (vm.allScoreDistMetrics && vm.allScoreDistMetrics.length) {
                vm.scoreTypeName = vm.allScoreDistMetrics[0].scoreTypeName;
                //vm.scoreTypeCd = vm.allScoreDistMetrics[0].scoreTypeCd;
                $('#dash-scores').on('slide.bs.carousel', function (e) {
                    var idx = parseInt($(e.relatedTarget).attr('index'));
                    vm.scoreTypeName = vm.allScoreDistMetrics[idx].scoreTypeName;
                    //vm.scoreTypeCd = vm.allScoreDistMetrics[idx].scoreTypeCd;
                });
                if (vm.allScoreDistMetrics.length < 2) {
                    $('#nextScore').hide();
                    $('#prevScore').hide();
                } else {
                    $('#prevScore').hide();
                }

                vm.slideScore = function(e, action) {
                    $('#dash-scores').carousel(action);
                    var idx = parseInt($('#dash-scores .active').index('#dash-scores .item'));
                    if (action === 'prev' && vm.allScoreDistMetrics.length > 1) {
                        $('#nextScore').show();
                        if (idx === 1) {
                            $('#nextScore').show();
                            $('#prevScore').hide();
                        }
                    } else if (action === 'next') {
                        $('#prevScore').show();
                        idx++;
                        if (idx === (vm.allScoreDistMetrics.length - 1)) {
                            $('#nextScore').hide();
                        }
                    }
                    e.preventDefault();
                    return false;
                };
            }
        });

        //Obsv Dist Metric
        vm.allObsvDistMetrics = allObsvDistMetrics;
        vm.allObsvDistMetrics.sort(function(a, b) {
            return a.dispSeq - b.dispSeq;
        });

        var meanCntDecimalPlace = ($rootScope.sysParms.PDASH_OBSVS_MEAN_CNT_DP ? $rootScope.sysParms.PDASH_OBSVS_MEAN_CNT_DP : 0);
        angular.forEach(vm.allObsvDistMetrics, function(obsvDistMetrics) {
            var maxColor = 40; // max no of color codes defined in variable.less file
            var idxColor = 2; //skip color 1 as that is for the level 1 node
            //sort by hierNodeId so colours match other charts
            obsvDistMetrics.obsvDists.sort(function(a, b) {
                return parseInt(a.hierNodeId) - parseInt(b.hierNodeId);
            });
            angular.forEach(obsvDistMetrics.obsvDists, function(node) {
                var cls = 'chart-bg-color-' + idxColor++;
                var dottedCls = '.' + cls;
                var prnt = $('body');
                $(prnt).append('<span class=' + cls + '>&nbsp</span>');
                var el = $(dottedCls)[0];
                var color = $(el).css('background-color');
                if (idxColor > maxColor) {
                    idxColor = 1;
                }
                $(el).remove();
                node.seriesColor = color;
                var meanText = $translate.instant('subj.portflDashbrd.obsvsDistroMetricPUMeanObsvCntLabel') + ': ' + node.avgSubjCnt.toFixed(meanCntDecimalPlace);
                var minText = $translate.instant('subj.portflDashbrd.obsvsDistroMetricPUMinObsvCntLabel') + ': ' + node.minSubjVal;
                var maxText = $translate.instant('subj.portflDashbrd.obsvsDistroMetricPUMaxObsvCntLabel') + ': ' + node.maxSubjVal;
                node.tip = '<div class="idmx-d3-tip" tooltip-animation-class="fade">'
                    + '<div class="arrow"></div>'
                    + '<div class="popover-inner">'
                    + '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">'
                    + '<div class="color-box" style="background-color:' + color + '"></div>'
                    + '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + $translate.instant('subj.portflDashbrd.obsvsDistroMetricYAxisLabel') + ': ' + node.hierNodeName + '</h3></div>'
                    + '</div>'
                    + '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">'
                    + meanText
                    + '<br />'
                    + minText
                    + '<br />'
                    + maxText
                    + '</div>'
                    + '</div>'
                    + '</div>';
            });

            //resort by avgSubjCnt for rendering
            obsvDistMetrics.obsvDists.sort(function(a, b) {
                return parseFloat(b.avgSubjCnt) - parseFloat(a.avgSubjCnt);
            });

            var dashOdmNodeCnt = ($rootScope.sysParms.PDASH_ODM_NODE_CNT) ? dashOdmNodeCnt = $rootScope.sysParms.PDASH_ODM_NODE_CNT : 0;
            if (obsvDistMetrics.obsvDists && obsvDistMetrics.obsvDists.length > dashOdmNodeCnt) {
                obsvDistMetrics.obsvDists = obsvDistMetrics.obsvDists.slice(0, dashOdmNodeCnt);
            }
        });

        vm.obsvDistChartData = function(obsvDistMetrics) {
            if (obsvDistMetrics.obsvDists && obsvDistMetrics.obsvDists.length > 0) {
                var chartSeries = [];
                angular.forEach(obsvDistMetrics.obsvDists, function(obsvDist) {
                    var series = $filter('filter')(chartSeries, {
                        seriesTitle: obsvDist.hierNodeName
                    }, true)[0];
                    if (!series) {
                        if (obsvDist.maxSubjVal > 0) {
                            chartSeries.push({
                                seriesTitle: obsvDist.hierNodeName,
                                seriesColor: obsvDist.seriesColor,
                                overlayPattern: 'diagonalHatch',
                                overlayColor: obsvDist.seriesColor,
                                elements: [{
                                    category: obsvDist.hierNodeName,
                                    value: obsvDist.avgSubjCnt,
                                    tip: obsvDist.tip,
                                    overlayValueMin: obsvDist.minSubjVal,
                                    overlayValueMax: obsvDist.maxSubjVal,
                                    overlayTip: obsvDist.tip,
                                    marks: [{
                                        value: obsvDist.minSubjVal,
                                        color: obsvDist.seriesColor,
                                        tip: obsvDist.tip
                                    }, {
                                        value: obsvDist.maxSubjVal,
                                        color: obsvDist.seriesColor,
                                        tip: obsvDist.tip
                                    }]
                                }]
                            });
                        }
                    }
                });
                if (chartSeries.length > 0) {
                    return {
                        series: chartSeries
                    };
                }
            }
            return {
                noDataFoundMessg: (obsvDistMetrics.subjCnt === 0) ? $translate.instant('subj.portflDashbrd.valid.obsvsDistroMetricNoSubjsFound') : $translate.instant('subj.portflDashbrd.valid.obsvsDistroMetricNoDataFound')
            };
        };

        vm.obsvDistChartConfig = {
            width: 550,
            height: 130,
            padding: {
                top: 15,
                bottom: 3,
                left: 3,
                right: 3
            },
            orientation: 'horizontal',
            seriesLayout: 'stacked',
            catgAxisLabel: $translate.instant('subj.portflDashbrd.obsvsDistroMetricYAxisLabel'),
            showCatgAxisScaleLabels: false,
            valueAxisLabel: $translate.instant('subj.portflDashbrd.obsvsDistroMetricXAxisLabel'),
            markRadius: 4,
            markStrokeWidth: 1.5,
            showGridlines: true,
            showLegend: false
        };

        //obsv carousel
        $timeout(function() {
            if (vm.allObsvDistMetrics && vm.allObsvDistMetrics.length) {
                vm.obsvTypeName = vm.allObsvDistMetrics[0].obsvTypeName;
                //vm.obsvTypeCd = vm.allObsvDistMetrics[0].obsvTypeCd;
                $('#dash-obsvs').on('slide.bs.carousel', function (e) {
                    var idx = parseInt($(e.relatedTarget).attr('index'));
                    vm.obsvTypeName = vm.allObsvDistMetrics[idx].obsvTypeName;
                    vm.obsvTypeCd = vm.allObsvDistMetrics[idx].obsvTypeCd;
                });
                if (vm.allObsvDistMetrics.length < 2) {
                    $('#nextObsv').hide();
                    $('#prevObsv').hide();
                } else {
                    $('#prevObsv').hide();
                }

                vm.slideObsv = function(e, action) {
                    $('#dash-obsvs').carousel(action);
                    var idx = parseInt($('#dash-obsvs .active').index('#dash-obsvs .item'));
                    if (action === 'prev' && vm.allObsvDistMetrics.length > 1) {
                        $('#nextObsv').show();
                        if (idx === 1) {
                            $('#nextObsv').show();
                            $('#prevObsv').hide();
                        }
                    } else if (action === 'next') {
                        $('#prevObsv').show();
                        idx++;
                        if (idx === (vm.allObsvDistMetrics.length - 1)) {
                            $('#nextObsv').hide();
                        }
                    }
                    e.preventDefault();
                    return false;
                };
            }
        });

        vm.gotoObsvs = function(obsvTypeCd) {
            $rootScope.obsvTypeFilter = obsvTypeCd;
            $state.go('app.portfolio.observations');
        };

        // User Activity Metrics
        vm.userActivityData = {};
        if (userActivityMetrics && userActivityMetrics.length > 0) {
            $('body').append('<span class="users-bg-color">&nbsp</span>');
            $('body').append('<span class="orgs-bg-color">&nbsp</span>');
            vm.userActivityUserLoginsColour = $($('.users-bg-color')[0]).css('background-color');
            vm.userActivityEventsColour = $($('.orgs-bg-color')[0]).css('background-color');
            $('.users-bg-color').remove();
            $('.orgs-bg-color').remove();

            var loginSeries = {
                seriesType: 'bar',
                seriesColor: vm.userActivityUserLoginsColour,
                elements: []
            };
            var eventSeries = {
                seriesType: 'line',
                seriesColor: vm.userActivityEventsColour,
                axis: 'secondary',
                elements: []
            };

            userActivityMetrics.sort(function(a, b) {
                return new Date(a.activityDate) - new Date(b.activityDate);
            });

            angular.forEach(userActivityMetrics, function(userActivity) {
                var loginCntText = $translate.instant('subj.portflDashbrd.usrActvtyMetricPULoginCntLabel') + ': ' + userActivity.userLoginActivityCnt;
                var eventCntText = $translate.instant('subj.portflDashbrd.usrActvtyMetricPUEventCntLabel') + ': ' + userActivity.subjEventActivityCnt;
                var tip = '<div class="idmx-d3-tip" tooltip-animation-class="fade">'
                    + '<div class="arrow"></div>'
                    + '<div class="popover-inner">'
                    + '<div class="popover-title" style="margin: 0px; padding: 5px 10px; padding-left: 5px; display: flex;">'
                    + '<div class="color-box" style="background-color:' + loginSeries.seriesColor + '"></div>'
                    + '<div><h3 style="margin: 0px; margin-top: 1px; font-size: 14px;">' + $translate.instant('subj.portflDashbrd.usrActvtyMetricXAxisLabel') + ': ' + $filter('shortDateFormatWithDay')(userActivity.activityDate) + '</h3></div>'
                    + '</div>'
                    + '<div class="popover-content" style="background-color: white; border: 2px solid #f3f3f4; border-top: none;">'
                    + loginCntText + '&nbsp;&nbsp;' + eventCntText
                    + '</div>'
                    + '</div>'
                    + '</div>';
                loginSeries.elements.push({
                    category: userActivity.activityDate,
                    label: $filter('dayOfWeekFormat')(userActivity.activityDate).charAt(0),
                    value: userActivity.userLoginActivityCnt,
                    labelCssClass: ($filter('isoDayOfWeekFormat')(userActivity.activityDate) >= 6) ? 'chart-axis-label-fade' : null,
                    tip: tip
                });
                eventSeries.elements.push({
                    category: userActivity.activityDate,
                    value: userActivity.subjEventActivityCnt
                });
            });
            vm.userActivityData = {
                series: [loginSeries, eventSeries]
            };
        }

        vm.userActivityChartConfig = {
            width: 1141,
            height: 130,
            padding: {
                top: 15,
                bottom: 3,
                left: 3,
                right: 3
            },
            orientation: 'vertical',
            seriesLayout: 'grouped',
            catgAxisLabel: $translate.instant('subj.portflDashbrd.usrActvtyMetricXAxisLabel'),
            valueAxisPrimaryLabel: $translate.instant('subj.portflDashbrd.usrActvtyMetricYAxis1Label'),
            valueAxisSecondaryLabel: $translate.instant('subj.portflDashbrd.usrActvtyMetricYAxis2Label'),
            showGridlines: false,
            showLegend: false
        };

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', loginRoute]);

    function loginRoute($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/login/login.html',
                controller: 'LoginCtrl',
                controllerAs: 'vm',
                data: {
                    userRoles: [],
                    i18n: {
                        pageTitle: 'login.home.pageTitle'
                    },
                    showInMenu: 'never'
                },
                resolve: {
                    sysParms: ['$http', 'apiUrl', function sysParms($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms');
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties');
                    }],
                    langCds: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/LANG_CD');
                    }],
                    userPrefTypes: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/USR_PREF_TYPE');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('LoginCtrl', ['$rootScope', '$scope', '$state', '$uibModal', '$sce', '$translate', '$window', '$filter', 'AuthService', 'sysParms', 'properties', 'langCds', 'userPrefTypes', LoginCtrl]);

    function LoginCtrl($rootScope, $scope, $state, $uibModal, $sce, $translate, $window, $filter, AuthService, sysParms, properties, langCds, userPrefTypes) {
        var vm = this;
        vm.emailBlured = false;
        vm.passwordBlured = false;
        vm.tfaBlured = false;
        vm.tfaRequired = false;
        vm.properties = properties.data;
        vm.sysParms = sysParms.data;
        $rootScope.APPL_SH_NAME = vm.sysParms.APPL_SH_NAME;

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };
        vm.submitLadda = false;

        vm.langCds = $filter('orderBy')(langCds.data.refItems, 'dispSeq');
        vm.switchLang = function(newLangCd) {
            vm.userLang = $filter('filter')(vm.langCds, {cd: newLangCd})[0];
            langCd = newLangCd;
            $translate.use(langCd);
            localStorage.setItem('langCd', langCd);
        };

        var langCd = localStorage.getItem('langCd');
        if (!langCd) {
            langCd = $window.navigator.languages && $window.navigator.languages[0] || // Chrome / Firefox
                $window.navigator.language ||   // All browsers
                $window.navigator.userLanguage; // IE <= 10
            if (langCd.indexOf('-') >= 0) {
                langCd = langCd.substring(0, langCd.indexOf('-')).trim();
            }
            langCd = langCd.toUpperCase();
        }
        //check language supported by IDMX.  If not set to default
        if (!$filter('filter')(vm.langCds, {cd: langCd}, true).length) {
            var defltLangCd = $filter('filter')(userPrefTypes.data.refItems, {
                cd: 'PREF_LANG'
            }, true)[0].entity.defaultUserPrefCd;
            langCd = defltLangCd;
        }
        vm.switchLang(langCd);

        var userEmail = '';
        if ($rootScope.userEmail) {
            userEmail = $rootScope.userEmail;
        }
        var original;
        $('#email').focus(); //initially focusing on email input field
        vm.user = {
            email: userEmail,
            password: '',
            rememberme: false
        };

        var userName = localStorage.getItem('userName'); // remember me
        if (userName) {
            vm.user = {
                email: userName,
                password: '',
                rememberme: true
            };
        }
        /*****If a value is set in recover password variable form forgot password page******/
        if ($rootScope.recPassEmail !== undefined) {
            vm.user.email = $rootScope.recPassEmail;
        }

        vm.authenticationError = false;

        original = angular.copy(vm.user);
        // https://github.com/angular/material/issues/1903
        vm.revert = function() {
            vm.user = angular.copy(original);
            $scope.material_login_form.$setPristine();
            $scope.material_login_form.$setUntouched();
            return;
        };

        // Set the page title key to the one configured in state or use default one
        if ($state.current.data && $state.current.data.i18n && $state.current.data.i18n.pageTitle) {
            $translate($state.current.data.i18n.pageTitle).then(function(translatedString) {
                $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
            });
        } else {
            $window.document.title = $rootScope.APPL_SH_NAME;
        }

        vm.login = function(loginForm) {
            if (!loginForm.email || $.isEmptyObject(loginForm.email.$error)) {
                vm.submitLadda = true;
                if (vm.user.rememberme) {
                    localStorage.setItem('userName', vm.user.email);
                } else {
                    localStorage.removeItem('userName');
                }
                /* If there is value in recov password email variable then destroy it after login
                button is pressed, so thta normal remember me functionality comes into place based
                on check/uncheck of remember me checkbox*/
                if ($rootScope.recPassEmail) {
                    delete $rootScope.recPassEmail;
                }

                var loginObj = {
                    username: vm.user.email,
                    password: vm.user.password,
                    languageCd: langCd
                };
                if (vm.tfaRequired) {
                    loginObj.tfaToken = vm.user.tfaToken;
                }
                AuthService.login(loginObj).then(function(data) {
                    if (data.status === 'success') {
                        vm.authenticationError = false;
                        if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                            $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                            $state.go('app');
                        }
                        // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                        // since login is successful, go to stored previousState and clear previousState
                        if (AuthService.getPreviousState()) {
                            var previousState = AuthService.getPreviousState();
                            AuthService.resetPreviousState();
                            $state.go(previousState.name, previousState.params);
                        } else {
                            $state.go('app');
                        }
                    } else if (data.status === 'tfaRequired') {
                        vm.submitLadda = false;
                        vm.authenticationError = false;
                        vm.tfaRequired = true;
                    } else if (data.status === 'error') {
                        vm.submitLadda = false;
                        loginForm.$submitted = false;
                        vm.authenticationError = true;
                        switch (data.error.code) {
                        case '001A':
                            vm.errorI18n = 'login.home.valid.idPasswdInvld';
                            break;
                        case '001B':
                            vm.errorI18n = 'login.home.valid.idPasswdInvldFinal';
                            vm.errorTimeOut = data.error.timeOut;
                            break;
                        case '001C':
                            vm.errorI18n = 'login.home.valid.idPasswdSusp';
                            vm.errorTimeOut = data.error.timeOut;
                            break;
                        case '002A':
                            vm.errorI18n = 'login.home.valid.TFATokenInvld';
                            break;
                        case '002B':
                            vm.errorI18n = 'login.home.valid.TFATokenInvldFinal';
                            vm.errorTimeOut = data.error.timeOut;
                            break;
                        case '002C':
                            vm.errorI18n = 'login.home.valid.TFATokenInvldSusp';
                            vm.errorTimeOut = data.error.timeOut;
                            break;
                        case '100':
                            vm.errorI18n = 'login.home.valid.acctSusp';
                            vm.errorTimeOut = data.error.timeOut;
                            break;
                        case '101':
                            vm.errorI18n = 'login.home.valid.acctPendg';
                            break;
                        case '102':
                            vm.errorI18n = 'login.home.valid.acctInactv';
                            break;
                        case '103':
                            vm.errorI18n = 'login.home.valid.acctDel';
                            break;
                        case '110':
                            vm.errorI18n = 'login.home.valid.orgDel';
                            break;
                        case '999':
                            vm.errorI18n = 'login.home.valid.unspecError';
                            vm.errorMsg = data.error.msg;
                            if (!vm.errorMsg) {
                                vm.errorMsg = '...';
                            }
                            break;
                        }
                        if (data.suspended) { //if suspended then force back to initial login screen
                            vm.tfaRequired = false;
                        }
                    }
                }).catch(function(error) {
                    vm.submitLadda = false;
                    loginForm.$submitted = false;
                    vm.authenticationError = true;
                    vm.errorI18n = 'login.home.valid.unspecError';
                    if (error.data) {
                        vm.errorMsg = error.data.message;
                    }
                    if (!vm.errorMsg) {
                        vm.errorMsg = '...';
                    }
                });
            }
        };

        vm.openTosDialogBox = function() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'info-dialog-template.html',
                controller: 'TosModalCtrl',
                controllerAs: 'modal',
                size: 'lg',
                resolve: {
                    properties: function() {
                        return vm.properties;
                    },
                    sysParms: function() {
                        return vm.sysParms;
                    },
                    langCds: function() {
                        return vm.langCds;
                    },
                    userLang: function() {
                        return vm.userLang;
                    },
                    switchLang: function() {
                        return vm.switchLang;
                    }
                }
            });
        };

        vm.navToForgotPass = function() {
            var userEmail = vm.user.email;
            $rootScope.recPassEmail = userEmail;
            $state.go('forgotpassword');
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('ReferenceService', ['$resource', 'apiUrl', ReferenceService]);

    function ReferenceService ($resource, apiUrl) {
        var service = $resource(apiUrl + 'references/:refCd', {}, {
            query: {
                method: 'GET',
                isArray: false
            },
            get: {
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('PageTitleCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$window', 'apiUrl', 'SubjectService', 'AuthService', PageTitleCtrl]);

    function PageTitleCtrl($rootScope, $scope, $state, $stateParams, $translate, $window, apiUrl, SubjectService, AuthService) {
        var vm = this;
        var previousTitleFromState;
        setTitles($state.current);

        $scope.$on('$stateChangeSuccess', function(event, toState) {
            if (!toState.noPageTitle) {
                setTitles(toState);
            }
        });

        function setTitles(state) {
            vm.icon = (state.data && state.data.icon) ? state.data.icon : '';
            vm.translate = false;
            vm.pageTitle = state.name;
            vm.pageDesc = null;
            vm.setSubtitle = false;
            $window.document.title = $rootScope.APPL_SH_NAME;
            if (state.data) {
                if (state.data.setSubtitle) {
                    vm.setSubtitle = true;
                    vm.section = state.data.section;
                }
                vm.setBreadcrumb = state.data.setBreadcrumb;
                if (state.data.i18n && state.data.i18n.pageTitle) {
                    vm.translate = true;
                    vm.pageTitle = state.data.i18n.pageTitle;
                    $rootScope.pageTitle = state.data.i18n.pageTitle; // needed for help
                    $translate(state.data.i18n.pageTitle).then(function (translatedString) {
                        $window.document.title = $rootScope.APPL_SH_NAME + ' | ' + translatedString;
                    });
                    previousTitleFromState = $rootScope.APPL_SH_NAME + ' | ' + $translate.instant($state.current.data.i18n.pageTitle);
                    if (state.data.i18n.pageDesc) {
                        vm.pageDesc = state.data.i18n.pageDesc;
                        $rootScope.pageDesc = state.data.i18n.pageDesc; // needed for help
                    }
                }
            }
        }

        vm.getPreviousTitle = function () {
            $window.document.title = previousTitleFromState;
        };

        vm.logoutReload = function(sessnEndMthdCd) {
            AuthService.logout(sessnEndMthdCd);
        };

        //Note: idle timer text is set in page-title.html modal
        var logoutTimeLimit = $rootScope.sysParms.LOGIN_TIMEOUT_PERD * 60;
        vm.dialogDisplayLimit = $rootScope.sysParms.LOGIN_TIMEOUT_WARNG_PERD * 60;
        var idleTimeLimit = Math.max(logoutTimeLimit - vm.dialogDisplayLimit, 0);
        $(document).idleTimeout({
            redirectUrl: false,
            idleTimeLimit: idleTimeLimit,
            idleCheckHeartbeat: 5,
            customCallback: function () {
                vm.logoutReload('CTO');
            },
            activityEvents: 'click keypress scroll wheel mousewheel mousemove', // separate each event with a space
            dialogDisplayLimit: vm.dialogDisplayLimit,
            sessionKeepAliveTimer: false,
            originalTitle: previousTitleFromState
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('sideNavigation', ['$timeout', sideNavigation])
        .directive('collapseSideNav', ['$timeout', collapseSideNav])
        .directive('clickableParentMenu', ['$state', clickableParentMenu]);

    function sideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                scope.$watch('routes', function() {
                    // Call the metsiMenu plugin and plug it to sidebar navigation
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Collapse menu in mobile mode after click on element
                var menuElement = $('#side-menu a:not([href$="\\#"])');
                menuElement.click(function() {
                    if ($(window).width() < 769) {
                        $('body').toggleClass('mini-navbar');
                    }
                });

                // Enable initial fixed sidebar
                if ($('body').hasClass('fixed-sidebar')) {
                    var sidebar = element.parent();
                    sidebar.slimScroll({
                        height: '100%',
                        railOpacity: 0.9
                    });
                }
            }
        };
    }

    function collapseSideNav($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize btn idmx-link-btn idmx-header-btn " style="margin-left: 20px;" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: ['$scope', function ($scope) {

                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }

                    if (angular.element('body').hasClass('mini-navbar')) { // minimized
                        angular.element('.survey-footer').css('cssText', 'left: 70px; width: calc(100vw - 70px) !important');
                        angular.element('.nav-second-level').css('cssText', 'width: max-content !important;');
                        angular.element('.sidebar-collapse').css('cssText', 'overflow-x: visible !important;');
                        $('ul').removeClass('scrolled-menu');
                        $('ul li ul li ul').css('cssText', 'margin-left: 55px !important; width: max-content !important;');
                        angular.element('.mini-navbar .nav .nav-second-level li a span:nth-child(2)').css('cssText', 'padding: 1px 7px 2px 7px !important; font-size: 11px !important');
                        angular.element('.sidebar-collapse li ul li a').css('padding-left', '10px');

                        //make sub menu items visible
                        $('#side-menu2').slimScroll({destroy: true});
                        $('#side-menu2').css('cssText', 'overflow-x: visible !important;');
                    } else { //maximized
                        angular.element('.survey-footer').css('cssText', 'left: 260px; width: calc(~"100vw - 260px")');
                        angular.element('.sidebar-collapse ul.nav.nav-second-level').css('cssText', 'width: 100vw !important;');
                        angular.element('.sidebar-collapse').css('cssText', 'overflow-x: hidden !important;');
                        $('ul.first-lvl').addClass('scrolled-menu');
                        $('ul li ul li ul').css('cssText', 'margin-left: 20px !important;');
                        angular.element('#side-menu2 li ul li a span.badge').css('cssText', 'padding: 3px 7px 4px 7px !important; font-size: 11px !important;');
                        angular.element('.sidebar-collapse li ul li a').css('padding-left', '40px');

                        //re-apply slimScroll
                        $('#side-menu2').slimScroll({
                            height: 'calc(100vh - 255.2px)',
                            railVisible: true
                        });
                    }
                    $timeout(function() {
                        $scope.$digest();
                    });
                };
            }]
        };
    }

    function clickableParentMenu($state) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.on('click', function() {
                    scope.$apply(function() {
                        $state.go(attrs.clickableParentMenu);
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('LeftNavCtrl', ['$rootScope', '$scope', '$state', '$sessionStorage', '$filter', 'AuthService', LeftNavCtrl]);

    function LeftNavCtrl($rootScope, $scope, $state, $sessionStorage, $filter, AuthService) {
        var vm = this;
        $scope.$state = $state;
        $rootScope.$parentState = $sessionStorage.parentState;
        $rootScope.$grandParentState = $sessionStorage.grandParentState;
        $rootScope.$greatGrandParentState = $sessionStorage.greatGrandParentState;
        vm.menus = buildMenus();
        vm.dropDownMenus = buildDropDownMenus();

        $scope.$on('$stateChangeSuccess', function() {
            var currentState = $state.current.name;
            var lastIndex = currentState.lastIndexOf('.');
            var parentState = currentState.substr(0, lastIndex);
            lastIndex = parentState.lastIndexOf('.');
            var grandParentState = parentState.substr(0, lastIndex);
            lastIndex = grandParentState.lastIndexOf('.');
            var greatGrandParentState = grandParentState.substr(0, lastIndex);
            $sessionStorage.parentState = parentState;
            $rootScope.$parentState = parentState;
            $sessionStorage.grandParentState = grandParentState;
            $rootScope.$grandParentState = grandParentState;
            $sessionStorage.greatGrandParentState = greatGrandParentState;
            $rootScope.$greatGrandParentState = greatGrandParentState;

            //fixing IDMX-236
            $('ul.nav-second-level').each(function (i, item) {
                var sref = $(item).attr('sref');
                if (sref === currentState || sref === parentState || sref === grandParentState || sref === greatGrandParentState) {
                    $(item).parent('li').addClass('active');
                    $(item).addClass('in');
                }
            });
        });

        vm.logout = function() {
            AuthService.logout('ULO');
        };

        vm.hasSubjPerms = function(subjPerms) {
            if (subjPerms && subjPerms.length > 0) {
                if (!$rootScope.subject || !$rootScope.subject.myUserPermsns || $rootScope.subject.myUserPermsns.length === 0) {
                    return false;
                }
                for (var i = 0; i < subjPerms.length; i++) {
                    if ($rootScope.subject.myUserPermsns.indexOf(subjPerms[i]) >= 0) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        };

        vm.hasAllSubjPerms = function(subjPerms) {
            if (subjPerms && subjPerms.length > 0) {
                if (!$rootScope.subject || !$rootScope.subject.myUserPermsns || $rootScope.subject.myUserPermsns.length === 0) {
                    return false;
                }
                for (var i = 0; i < subjPerms.length; i++) {
                    if ($rootScope.subject.myUserPermsns.indexOf(subjPerms[i]) < 0) {
                        return false;
                    }
                }
                return true;
            }
            return true;
        };

        vm.hasntSubjPerms = function(subjPerms) {
            if (subjPerms && subjPerms.length > 0) {
                return !vm.hasSubjPerms(subjPerms);
            }
            return true;
        };

        vm.hasntAllSubjPerms = function(subjPerms) {
            if (subjPerms && subjPerms.length > 0) {
                return !vm.hasAllSubjPerms(subjPerms);
            }
            return true;
        };

        function buildMenus() {
            var stateTree = [];
            angular.forEach($state.get(), function (state) {
                placeState(stateTree, state);
            });
            var menus = [];
            createMenus(stateTree, menus);
            editShowMenu(menus);
            createShowMenuArrows(menus);
            return menus;
        }

        function buildDropDownMenus() {
            var dropDownMenus = [];
            angular.forEach($state.get(), function (state) {
                createDropDownMenu(state, dropDownMenus);
            });
            return dropDownMenus;
        }

        function placeState(tree, state) {
            var path = state.name.split('.');
            var node = tree;
            var currPath = [];
            angular.forEach(path, function (dir) {
                currPath.push(dir);
                var isLast = currPath.length === path.length;
                if (isLast) {
                    //add state at current level:
                    var copiedState = angular.copy(state);
                    node.push(copiedState);
                } else {
                    //next path part lays deeper
                    var currPathStr = currPath.join('.');
                    var parent;
                    angular.forEach(node, function (item) {
                        if (item.name === currPathStr) {
                            parent = item;
                        }
                    });
                    if (parent) {
                        if (!parent.hasOwnProperty('children')) {
                            parent.children = [];
                        }
                        node = parent.children;
                    }
                }
            });
        }

        function createMenus(stateTree, menus) {
            angular.forEach(stateTree, function(value) {
                if (value.name) {
                    if (value.name === 'app' || value.name === 'app.subject') {
                        if (value.children) {
                            createMenus($filter('orderBy')(value.children, 'data.menuDispSeq'), menus);
                        }
                    } else {
                        var menu = {
                            menu: true,
                            sref: value.name,
                            abstract: value.abstract,
                            i18n: (value.data && value.data.i18n && value.data.i18n.menu) ? value.data.i18n.menu : value.name,
                            icon: (value.data && value.data.icon) ? value.data.icon : '',
                            showMenu: calcShowMenu(value),
                            showIconInMenu: (value.data) ? value.data.showIconInMenu : false,
                            userPerms: (value.data && value.data.userPerms) ? value.data.userPerms : '',
                            subjPerms: (value.data && value.data.subjPerms) ? value.data.subjPerms : '',
                            allSubjPerms: (value.data && value.data.allSubjPerms) ? value.data.allSubjPerms : '',
                            notSubjPerms: (value.data && value.data.notSubjPerms) ? value.data.notSubjPerms : '',
                            notAllSubjPerms: (value.data && value.data.notAllSubjPerms) ? value.data.notAllSubjPerms : ''
                        };
                        menus.push(menu);

                        if (value.children) {
                            menu.children = [];
                            createMenus(value.children, menu.children);
                        }

                        if (value.name === 'app.subject.summary.dashboard') {
                            menu.showMenu = '$root.subject.showDashFlag && vm.hasSubjPerms(["' + value.data.subjPerms + '"])';
                        } else if (value.name === 'app.subject.summary.activity') {
                            menu.showMenu = '$root.subject.showActvtyFlag && vm.hasSubjPerms(["' + value.data.subjPerms + '"])';
                        } else if (value.name === 'app.subject.summary.reports') {
                            menu.showMenu = '$root.subject.reports && $root.subject.reports.length > 0 && vm.hasSubjPerms(["' + value.data.subjPerms + '"])';
                        } else if (value.name === 'app.subject.survey') {
                            addSurveySections(value, menu);
                        } else if (value.name === 'app.subject.observations') {
                            menu.showMenu = '$state.includes("app.subject") && $root.subject.obsv';
                        } else if (value.name === 'app.subject.documents') {
                            menu.showMenu = '$state.includes("app.subject") && $root.subject.docu';
                        } else if (value.name === 'app.subject.analytics') {
                            menu.showMenu = '$state.includes("app.subject") && $root.subject.analytics';
                        } else if (value.name === 'app.subject.scoring') {
                            addScoringSections(value, menu);
                            menu.allSubjPerms = menu.subjPerms.concat('VIEW_SCORE_TYPE_COMP');
                            //add second scoring menu when no permission to see root scores
                            var scoreMenu2 = {
                                menu: true,
                                abstract: true,
                                i18n: (value.data && value.data.i18n && value.data.i18n.menu) ? value.data.i18n.menu : value.name,
                                icon: (value.data && value.data.icon) ? value.data.icon : '',
                                showMenu: calcShowMenu(value),
                                showIconInMenu: (value.data) ? value.data.showIconInMenu : false,
                                userPerms: (value.data && value.data.userPerms) ? value.data.userPerms : '',
                                subjPerms: (value.data && value.data.subjPerms) ? value.data.subjPerms : '',
                                notSubjPerms: ['VIEW_SCORE_TYPE_COMP']
                            };
                            menus.push(scoreMenu2);
                            addScoringSections(value, scoreMenu2);
                        } else if (value.name === 'app.subject.collaboration') {
                            menu.showMenu = '$state.includes("app.subject") && $root.subject.showCollabFlag';
                        } else if (value.name === 'app.portfolio.scoring') {
                            addPfScoringSections(value, menu);
                        } else if (value.name === 'app.admin.surveys') {
                            addSurveySectionsForEdit(menu);
                        } else if (value.name === 'app.admin.observations') {
                            menu.obsv = true;
                            menu.langCd = $rootScope.userLang.toLowerCase();
                        }
                    }
                }
            });
        }

        function addSurveySections(state, node) {
            if ($rootScope.surveySections.length > 0) {
                node.children = [];
                angular.forEach($filter('orderBy')($rootScope.surveySections, 'survSectSeq'), function(value) {
                    var menu = {
                        surveySection: true,
                        survTypeCd: value.survTypeCd,
                        survVersSeq: value.survVersSeq,
                        survSectSeq: value.survSectSeq,
                        sectName: stripHtml(value.survSectName),
                        subjPerms: (state.data && state.data.subjPerms) ? state.data.subjPerms : '',
                        showMenu: '$root.subject.survey.type.cd === "' + value.survTypeCd + '" && $root.subject.survey.version === ' + value.survVersSeq
                    };
                    node.children.push(menu);
                });
            } else {
                delete node.children;
                node.showMenu = false;
            }
        }

        function addScoringSections(state, node) {
            if ($rootScope.subjStageScores.length > 0) {
                node.children = [];
                angular.forEach($filter('orderBy')($rootScope.subjStageScores, 'dispSeq'), function(value) {
                    var menu = {
                        subjStageScore: true,
                        scoreTypeCd: value.scoreTypeCd,
                        scoreTypeName: value.scoreTypeName,
                        subjStageId: value.subjStageId,
                        subjPerms: ['VIEW_WGTD_SCORE_BREAKDN', 'VIEW_SCORE_COMP', 'UPDT_SCORE_TARGS', 'VIEW_SCORE_HIST'],
                        showMenu: '$root.subject.subjStageId === ' + value.subjStageId
                    };
                    node.children.push(menu);
                });
            } else {
                delete node.children;
                node.showMenu = false;
            }
        }

        function addPfScoringSections(state, node) {
            if ($rootScope.scoreTypes.length > 0) {
                node.children = [];
                angular.forEach($filter('orderBy')($rootScope.scoreTypes, 'dispSeq'), function (value) {
                    var menu = {
                        pfScore: true,
                        scoreTypeCd: value.scoreTypeCd,
                        scoreTypeName: value.scoreTypeName,
                        subjPerms: '',
                        showMenu: true
                    };
                    node.children.push(menu);
                });
            } else {
                delete node.children;
                node.showMenu = false;
            }
        }

        function addSurveySectionsForEdit(node) {
            var sectionList = [];
            angular.forEach($rootScope.allLangSurveys, function(survey) {
                angular.forEach(survey.sections, function(section) {
                    section.sectionName = stripHtml(getSurvSectName(section.sequence, survey.survTypeCd, survey.survVersSeq) || section.survSectName);
                    section.survTypeCd = survey.survTypeCd;
                    section.survVersSeq = survey.survVersSeq;
                    section.langCd = survey.langCd;
                    sectionList.push(section);
                });
            });

            angular.forEach($filter('orderBy')(sectionList, 'sequence'), function(value) {
                var menu = {
                    surveySectionEditor: true,
                    survTypeCd: value.survTypeCd,
                    survVersSeq: value.survVersSeq,
                    survSectSeq: value.sequence,
                    langCd: value.langCd,
                    sectName: value.sectionName,
                    userPerms: ['MANG_SYS_ADMIN'],
                    showMenu: '$root.surveyEditor.survTypeCd === "' + value.survTypeCd + '" && $root.surveyEditor.survVersSeq === ' + value.survVersSeq + ' && $root.surveyEditor.langCd === "' + value.langCd + '"'
                };
                node.children.push(menu);
            });
        }

        function getSurvSectName(survSectSeq, survTypeCd, survVersSeq) {
            var section;
            var langSurvey = $filter('filter')($rootScope.allLangSurveys, {
                langCd: $rootScope.userLang,
                survTypeCd: survTypeCd,
                survVersSeq: survVersSeq}, true
            )[0];
            if (langSurvey && survSectSeq) {
                section = $filter('filter')(langSurvey.sections, {sequence: survSectSeq}, true)[0];
            }
            if (section) {
                return stripHtml(section.sectionName);
            }
        }

        function editShowMenu(menus) {
            angular.forEach(menus, function(value) {
                if (value.children && value.children.length > 0) {
                    if (value.showMenu === 'subject') {
                        value.showMenu = '$state.includes("app.subject") && (' + calcShowSubjectMenu(value.children) + ')';
                    }
                    editShowMenu(value.children);
                } else if (value.showMenu === 'subject') {
                    value.showMenu = '$state.includes("app.subject")';
                }
            });
        }

        function createShowMenuArrows(menus) {
            angular.forEach(menus, function(value) {
                value.showMenuArrow = false;
                if (value.children && value.children.length > 0) {
                    value.showMenuArrow = calcShowMenuArrow(value.children);
                    value.showMenuArrowSubjPerms = calcShowMenuArrowSubjPerms(value.children);
                    createShowMenuArrows(value.children);
                }
            });
        }

        function calcShowMenu(state) {
            var showInMenu = (state.data) ? state.data.showInMenu : '';
            if (showInMenu === 'never' || showInMenu === 'dropdown') {
                return false;
            } else if (showInMenu === 'subject') {
                return 'subject';
            } else if (showInMenu === 'active') {
                return '$state.includes("' + state.name + '")';
            }
            // showInMenu === 'always' or not specified
            return true;
        }

        function calcShowSubjectMenu(children) {
            var bits = [];
            angular.forEach(children, function(value) {
                bits.push('(' + value.showMenu + ')');
            });
            return bits.join(' || ');
        }

        function calcShowMenuArrow(children) {
            var bits = [];
            angular.forEach(children, function(value) {
                bits.push('(' + value.showMenu + ')');
            });
            return bits.join(' || ');
        }

        function calcShowMenuArrowSubjPerms(children) {
            var subjPerms = [];
            angular.forEach(children, function(value) {
                if (value.subjPerms && value.subjPerms.length > 0) {
                    subjPerms = subjPerms.concat(value.subjPerms);
                }
            });
            return subjPerms;
        }

        function createDropDownMenu(state, dropDownMenus) {
            if (state.data && state.data.showInMenu === 'dropdown') {
                var menu = {
                    sref: state.name,
                    i18n: (state.data && state.data.i18n && state.data.i18n.menu) ? state.data.i18n.menu : state.name,
                    icon: (state.data && state.data.icon) ? state.data.icon : ''
                };
                dropDownMenus.push(menu);
                return menu;
            }
        }

        function stripHtml(html) {
            // Create a new div element
            var temporalDivElement = document.createElement('div');
            // Set the HTML content with the providen
            temporalDivElement.innerHTML = html;
            // Retrieve the text property of the element (cross-browser support)
            return temporalDivElement.textContent || temporalDivElement.innerText || '';
        }

        vm.collapseMiniNav = function() {
            if (angular.element('body').hasClass('mini-navbar')) {
                angular.element('body').removeClass('mini-navbar');
            }
        };

        vm.collapseMiniNavAndGo = function(sref, parms) {
            if (angular.element('body').hasClass('mini-navbar')) {
                angular.element('body').removeClass('mini-navbar');
            }
            if (sref) {
                $state.go(sref, parms);
            }
        };

    }

})();
(function() {
    'use strict';
    angular
        .module('app')
        .directive('eventPop', ['$compile', eventPop])
        .directive('hoverDecorate', [hoverDecorate]);

    function eventPop($compile) {
        var titleTemplate = '<span class="event-title">' +
            '<i class="fa fa {{event.featIconName}}"></i> ' +
            '<span><strong>{{event.subjName}} </strong></span> ' +
            '<span class="text-muted">({{event.subjEffDate | shortDateFormat}})</span>' +
            '</span> ';

        var contentTemplate = '<span activity-side-bar priority="{{event.eventTypePrioritySeq}}" class="pull-left" style="margin-left:-12px"><p style="padding-left: 5px" class="small event-content-details" ng-bind-html="event.eventText | replaceEventToken"></p></span>' +
            '<p style="padding-left: 5px" class="pull-right text-muted small event-content-tmstmp">{{event.crtTmstmp | mixedDateFormat}}</p>';

        return {
            restrict: 'A',
            transclude: true,
            scope: {
                event: '='
            },
            template: '<span ng-transclude></span>',
            link: function(scope, element) {
                var options = {
                    content: $compile(contentTemplate)(scope),
                    placement: 'left',
                    trigger: 'hover',
                    html: true,
                    title: $compile(titleTemplate)(scope),
                    delay: 100
                };
                $(element).popover(options);
            }
        };
    }

    function hoverDecorate() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $(element).hover(function() {
                    $(element).find('.bold-on-hover').css('font-weight', 'bold');
                }, function() {
                    $(element).find('.bold-on-hover').css('font-weight', 'normal');
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('HeaderCtrl', ['$rootScope', '$scope', '$state', '$sessionStorage', '$timeout', '$uibModal', '$translate', '$filter', 'Principal', 'AuthService', 'SubjectService', 'UserService', HeaderCtrl])
        .controller('SubjectStageModalCtrl', ['$uibModalInstance', 'subjStage', SubjectStageModalCtrl])
        .controller('HeaderConfirmStageModalCtrl', ['$uibModalInstance', '$translate', 'confirmFor', 'currStage', 'toStage', 'advncSubjStageTitl', 'advncSubjStageText', 'retnSubjStageTitl', 'retnSubjStageText', HeaderConfirmStageModalCtrl])
        .controller('TosModalCtrl', ['$uibModalInstance', '$sce', '$http', '$translate', '$filter', 'apiUrl', 'properties', 'sysParms', 'langCds', 'userLang', 'switchLang', TosModalCtrl])
        .controller('BcastModalCtrl', ['$rootScope', '$scope', '$uibModalInstance', 'UserService', 'data', '$timeout', BcastModalCtrl]);

    function HeaderCtrl($rootScope, $scope, $state, $sessionStorage, $timeout, $uibModal, $translate, $filter, Principal, AuthService, SubjectService, UserService) {
        var vm = this;
        vm.referenceData = $rootScope.referenceData;
        vm.stageAdvncSurvCompltFlag = $rootScope.sysParms.STAGE_ADVNC_SURV_COMPLT_FLAG.toLowerCase() === 'true';
        vm.showStageNavigation = false;
        vm.hasAdvncStagePerm = function() {
            return $rootScope.subject && $rootScope.subject.myUserPermsns.indexOf('ADVNC_STAGE') !== -1;
        };

        //Loading Subject data for the first time when user lands on the page.
        loadSubjectStage($state.current);
        getGuides($state.current);

        $scope.$on('$stateChangeSuccess', function(event, toState) {
            if (Principal.isAuthenticated()) {
                getTopBcast(toState);
                getGuides(toState);
            }
            loadSubjectStage(toState);
        });

        function getTopBcast(state) {
            if (!$sessionStorage.bcast) {
                $sessionStorage.bcast = {};
            }
            var featCd = null;
            if (state.name.startsWith('app.admin')) {
                featCd = 'SYSADMIN';
            } else if (state.name === 'app.subjects') {
                featCd = 'SUBJ';
            } else if (state.name.startsWith('app.subject.summary.dashboard')) {
                featCd = 'DASH';
            } else if (state.name === 'app.subject.summary.activity') {
                featCd = 'ACTVTY';
            } else if (state.name === 'app.subject.summary.reports') {
                featCd = 'REPT';
            } else if (state.name.startsWith('app.subject.survey')) {
                featCd = 'SURV';
            } else if (state.name === 'app.subject.observations') {
                featCd = 'OBSV';
            } else if (state.name === 'app.subject.documents') {
                featCd = 'DOCU';
            } else if (state.name.startsWith('app.subject.scoring')) {
                featCd = 'SCORE';
            } else if (state.name === 'app.subject.analytics') {
                featCd = 'ANLYTCS';
            } else if (state.name === 'app.subject.collaboration') {
                featCd = 'COLLAB';
            } else if (state.name.startsWith('app.portfolio.dashboard')) {
                featCd = 'P-DASH';
            } else if (state.name === 'app.portfolio.subjects') {
                featCd = 'P-SUBJ';
            } else if (state.name === 'app.portfolio.observations') {
                featCd = 'P-OBSV';
            } else if (state.name.startsWith('app.portfolio.scoring')) {
                featCd = 'P-SCORE';
            } else if (state.name === 'app.portfolio.analytics') {
                featCd = 'P-ANLYTCS';
            } else if (state.name === 'app.portfolio.reports') {
                featCd = 'P-REPT';
            }
            UserService.getPushBcasts({
                featCd: featCd
            }).$promise.then(function(bcasts) {
                if (bcasts && bcasts.length > 0) {
                    bcasts = $filter('orderBy')(bcasts, ['priotSeq', 'crtTmstmp']);
                    bcasts = bcasts.sort(function(a, b) {
                        if (a.featCd === b.featCd) {
                            if (a.priotSeq === b.priotSeq) {
                                return a.crtTmstmp > b.crtTmstmp ? 1 : (a.crtTmstmp < b.crtTmstmp ? -1 : 0);
                            }
                            return a.priotSeq - b.priotSeq;
                        }
                        return a.featCd === 'LOGIN' ? -1 : 1;
                    });
                    angular.forEach(bcasts, function(bcast) {
                        if (!$sessionStorage.bcast[bcast.bcastId]) {
                            $sessionStorage.bcast[bcast.bcastId] = true;
                            vm.openBcastModalDialog(bcast);
                        }
                    });
                }
            });
        }

        function getGuides(state) {
            vm.pageTours = [];
            UserService.getPageTour({
                pageRefCd: state.name
            }).$promise.then(function(pageTour) {
                vm.pageTour = pageTour;
                if (vm.pageTour && vm.pageTour.pushFlag && !vm.pageTour.isPageTourViewed) {
                    $timeout(function() {
                        vm.runGuide();
                    });
                }
            });
        }

        vm.runGuide = function() {
            if (vm.pageTour && vm.pageTour.pageTourSteps && vm.pageTour.pageTourSteps.length > 0) {
                vm.pageTour.pageTourSteps.sort(function(a, b) {
                    return a.pageTourStepSeq - b.pageTourStepSeq;
                });
                var guides = [];
                angular.forEach(vm.pageTour.pageTourSteps, function(pageTourStep) {
                    guides.push({
                        element: $('#' + pageTourStep.htmlElemId),
                        html: pageTourStep.stepText
                    });
                });
                if (guides.length > 0) {
                    $.guides({
                        guides: guides,
                        end: function() {
                            UserService.saveUserPageTourView({
                                pageRefCd: vm.pageTour.pageRefCd
                            });
                        },
                        language: $rootScope.userLang
                    }).start();
                }
            }
        };

        function loadSubjectStage(state) {
            // show subject stages inside subject or in update subject (only if there is a subject in $rootScope - if NULL means user unauthorized)
            if ((state.name.indexOf('app.subject.') === 0 || state.name === 'app.subjects.editSubj') && $rootScope.subject) {
                vm.showStageNavigation = true;
            } else {
                vm.showStageNavigation = false;
            }
        }

        function advanceNextStage() {
            SubjectService.changeStage({
                subjId: $rootScope.subject.subjId,
                increment: 1
            }, null).$promise.then(function() {
                toastr.success(
                    $translate.instant('subj.subjStageNav.toast.advncSubjStageSuccess'),
                    $translate.instant('subj.subjStageNav.pageTitle'),
                    toastr.options
                );
                $state.go('app.subject', {id: $rootScope.subject.subjId}, {reload: true});
            });
        }

        function returnPreviousStage() {
            SubjectService.changeStage({
                subjId: $rootScope.subject.subjId,
                increment: -1
            }, null).$promise.then(function() {
                toastr.success(
                    $translate.instant('subj.subjStageNav.toast.retnSubjStageSuccess'),
                    $translate.instant('subj.subjStageNav.pageTitle'),
                    toastr.options
                );
                $state.go('app.subject', {id: $rootScope.subject.subjId}, {reload: true});
            });
        }

        vm.getCurrStageTitle = function() {
            var stage = vm.getStageById($rootScope.subject.subjStageId);
            if (stage) {
                return $translate.instant('subj.subjStageNav.help.currStageTitle', {
                    currStageName: stage.nm
                });
            }
            return null;
        };

        vm.getPrevStageHelpTitl = function() {
            if ($rootScope.subject.prevStageHelpTitl) {
                return $rootScope.subject.prevStageHelpTitl;
            }
            var stage = vm.getStageById($rootScope.subject.subjStageId - 1);
            if (stage) {
                return $translate.instant('subj.subjStageNav.help.prevStageTitle', {
                    prevStageName: stage.nm
                });
            }
            return null;
        };

        vm.getPrevStageHelpText = function() {
            if ($rootScope.subject.prevStageHelpText) {
                return $rootScope.subject.prevStageHelpText;
            }
            var stage = vm.getStageById($rootScope.subject.subjStageId - 1);
            if (stage) {
                return $translate.instant('subj.subjStageNav.help.prevStageText');
            }
            return null;
        };

        vm.getNextStageHelpTitl = function() {
            if ($rootScope.subject.nextStageHelpTitl) {
                return $rootScope.subject.nextStageHelpTitl;
            }
            var stage = vm.getStageById($rootScope.subject.subjStageId + 1);
            if (stage) {
                return $translate.instant('subj.subjStageNav.help.nextStageTitle', {
                    nextStageName: stage.nm
                });
            }
            return null;
        };

        vm.getNextStageHelpText = function() {
            if ($rootScope.subject.nextStageHelpText) {
                return $rootScope.subject.nextStageHelpText;
            }
            var stage = vm.getStageById($rootScope.subject.subjStageId - 1);
            if (stage) {
                return $translate.instant('subj.subjStageNav.help.nextStageText');
            }
            return null;
        };

        vm.getStageById = function(stageId) {
            return $filter('filter')(vm.referenceData.SUBJ_STAGE.refItems, {
                cd: stageId.toString()
            }, true)[0];
        };

        vm.openSubjectStageDialog = function() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'subjectstage-dialog-template.html',
                controller: 'SubjectStageModalCtrl',
                controllerAs: '$subjectStageModalCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    subjStage: function() {
                        return vm.referenceData.SUBJ_STAGE.refItems;
                    }
                }
            });
        };

        vm.openConfirmStageDialog = function(confirmFor, advncStageFlag) {
            if (advncStageFlag || $rootScope.isSurveyDirty) {
                return;
            }
            var confirmModalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'confirm-dialog-template.html',
                controller: 'HeaderConfirmStageModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'sm',
                resolve: {
                    confirmFor: function() {
                        return confirmFor;
                    },
                    currStage: function() {
                        return vm.getStageById($rootScope.subject.subjStageId);
                    },
                    toStage: function() {
                        if (confirmFor === 'returnPreviousStage') {
                            return vm.getStageById($rootScope.subject.subjStageId - 1);
                        } else if (confirmFor === 'advanceNextStage') {
                            return vm.getStageById($rootScope.subject.subjStageId + 1);
                        }
                    },
                    advncSubjStageTitl: function() {
                        return $rootScope.subject.advncSubjStageTitl;
                    },
                    advncSubjStageText: function() {
                        return $rootScope.subject.advncSubjStageText;
                    },
                    retnSubjStageTitl: function() {
                        return $rootScope.subject.retnSubjStageTitl;
                    },
                    retnSubjStageText: function() {
                        return $rootScope.subject.retnSubjStageText;
                    }
                }
            });
            confirmModalInstance.result.then(function() {
                if (confirmFor === 'returnPreviousStage') {
                    returnPreviousStage();
                } else if (confirmFor === 'advanceNextStage') {
                    advanceNextStage();
                }
            }, function() {
                //dialog canceled
            });
        };

        vm.openBcast = function(bcastId) {
            UserService.getBcast({
                bcastId: bcastId
            }).$promise.then(function(bcast) {
                vm.openBcastModalDialog(bcast);
            });
        };

        vm.openBcastModalDialog = function(data) {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'bcast-template.html',
                controller: 'BcastModalCtrl',
                controllerAs: 'modal',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    data: function() {
                        return data;
                    }
                }
            });
        };

        vm.logout = function() {
            AuthService.logout('ULO');
        };

    }

    function SubjectStageModalCtrl($uibModalInstance, subjStage) {
        var $subjectStageModalCtrl = this;
        $subjectStageModalCtrl.title = 'subj.subjStageNav.modal.allSubjStagesTitle';
        $subjectStageModalCtrl.subjStage = subjStage;

        $subjectStageModalCtrl.close = function() {
            $uibModalInstance.close();
        };

        $subjectStageModalCtrl.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

    // Please note that $uibModalInstance represents a modal window (instance) dependency.
    // It is not the same as the $uibModal service used above.
    function HeaderConfirmStageModalCtrl($uibModalInstance, $translate, confirmFor, currStage, toStage, advncSubjStageTitl, advncSubjStageText, retnSubjStageTitl, retnSubjStageText) {
        var modal = this;

        if (confirmFor === 'advanceNextStage') {
            modal.title = advncSubjStageTitl ? advncSubjStageTitl : 'subj.subjStageNav.modal.advncSubjStageTitle';
            modal.text = advncSubjStageText ? advncSubjStageText : $translate.instant('subj.subjStageNav.modal.advncSubjStageText', {
                currStageId: currStage.cd,
                currStageName: currStage.nm,
                nextStageId: toStage.cd,
                nextStageName: toStage.nm
            });
            modal.okButton = 'subj.subjStageNav.modal.advncYesButton';
            modal.cancelButton = 'subj.subjStageNav.modal.advncNoButton';
        } else if (confirmFor === 'returnPreviousStage') {
            modal.title = retnSubjStageTitl ? retnSubjStageTitl : 'subj.subjStageNav.modal.retnSubjStageTitle';
            modal.text = retnSubjStageText ? retnSubjStageText : $translate.instant('subj.subjStageNav.modal.retnSubjStageText', {
                currStageId: currStage.cd,
                currStageName: currStage.nm,
                prevStageId: toStage.cd,
                prevStageName: toStage.nm
            });
            modal.okButton = 'subj.subjStageNav.modal.retnYesButton';
            modal.cancelButton = 'subj.subjStageNav.modal.retnNoButton';
        }

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function TosModalCtrl($uibModalInstance, $sce, $http, $translate, $filter, apiUrl, properties, sysParms, langCds, userLang, switchLang) {
        var modal = this;
        modal.isToS = true;
        modal.properties = properties;
        modal.sysParms = sysParms;
        modal.langCds = langCds;
        modal.userLang = userLang;
        modal.switchLang = switchLang;
        var title = 'login.tos.pageTitle';
        var body;
        modal.getToS = function() {
            $http.get(apiUrl + 'authenticate/viewTOS/' + modal.userLang.cd).then(function(res) {
                modal.text = $sce.trustAsHtml(res.data.sysDocText);
            });
        };

        modal.getToS();

        modal.switchLang = function(newLangCd) {
            modal.userLang = $filter('filter')(modal.langCds, {cd: newLangCd})[0];
            switchLang(newLangCd);
            modal.getToS(newLangCd);
        };

        var okButton = 'login.home.closeButton';
        var dwdButton = 'login.tos.downldPDFButton';

        modal.title = title;
        modal.text = body;
        modal.okButton = okButton;
        modal.dwdButton = dwdButton;

        modal.download = function() {
            var req = {
                method: 'GET',
                url: apiUrl + 'authenticate/downloadTOS/' + modal.userLang.cd,
                headers: {
                    'Content-Type': 'application/x-www-formurlencoded'
                }
            };

            return $http(req).then(function(response) {
                var a = document.createElement('a');
                document.body.appendChild(a);
                var fileArrayBuffer = base64ToArrayBuffer(response.data.fileData);
                var file = new Blob([fileArrayBuffer], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                var fileName = response.data.fileName;
                a.download = fileName;
                a.click();
                toastr.success(
                    $translate.instant('login.tos.toast.downldTOSSuccess'),
                    $translate.instant(title),
                    toastr.options
                );
            }, function() {
                toastr.error(
                    $translate.instant('login.tos.toast.downldTOSError'),
                    $translate.instant(title),
                    toastr.options
                );
            });
        };

        modal.close = function() {
            $uibModalInstance.close();
        };

        modal.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function base64ToArrayBuffer(base64) {
            if (typeof(base64) !== 'undefined') {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }
            return base64;
        }
    }

    function BcastModalCtrl($rootScope, $scope, $uibModalInstance, UserService, data, $timeout) {
        var modal = this;
        modal.id = data.bcastId;
        modal.bcastPages = data.bcastPages;
        modal.bcastViewed = data.bcastViewed;

        modal.close = function() {
            $uibModalInstance.dismiss('cancel');
        };

        modal.skip = function() {
            $uibModalInstance.dismiss('cancel');
        };

        modal.save = function() {
            UserService.saveUserBcastView({
                bcastId: data.bcastId
            }).$promise.then(function() {
                //reload broadcasts list
                $rootScope.userBcasts = UserService.getBcasts();
                $uibModalInstance.dismiss('cancel');
            }, function(reason) {
                return reason;
            });
        };

        modal.lastPage = data.bcastPages.length === 1;

        $timeout(function() {
            if (data.bcastPages.length < 2) {
                $('#myCarousel' + modal.id).children('.right').hide();
                $('#myCarousel' + modal.id).children('.left').hide();
            } else {
                $('#myCarousel' + modal.id).children('.left').hide();
            }
        });
        modal.bcastPageView = function(e, action) {
            var carousel = $('#myCarousel' + modal.id);
            var idx = parseInt($('#myCarousel' + modal.id + ' .active').index('#myCarousel' + modal.id + ' .item'));
            if (action === 'prev' && data.bcastPages.length > 1) {
                carousel.children('.right').show();
                if (idx === 1) {
                    carousel.children('.right').show();
                    carousel.children('.left').hide();
                }
                modal.lastPage = false;
            } else if (action === 'next') {
                carousel.children('.left').show();
                idx++;
                if (idx === (data.bcastPages.length - 1)) {
                    modal.lastPage = true;
                    carousel.children('.right').hide();
                }
            }
            e.preventDefault();
            return false;
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('RootCtrl', ['$state', RootCtrl]);

    function RootCtrl($state) {
        $state.go('app');
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('ReferenceService', ['$resource', 'apiUrl', ReferenceService]);

    function ReferenceService($resource, apiUrl) {
        var service = $resource(apiUrl + 'references', {}, {
            getAllReferenceByLang: {
                url: apiUrl + 'references/lang/:langCd',
                method: 'GET'
            }
        });
        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('idmxChart', ['$timeout', '$filter', '$window', '$translate', idmxChart]);

    function idmxChart($timeout, $filter, $window, $translate) {
        return {
            restrict: 'E',
            scope: {
                seriesCallback: '&',
                elementCallback: '&'
            },
            link: function (scope, element, attrs) {
                var data;
                var config;

                data = JSON.parse(attrs.data);
                config = JSON.parse(attrs.config);
                config.id = attrs.id;
                config.elemWidth = 0;
                drawChart(config, data);

                attrs.$observe('data', function(d) {
                    try {
                        data = JSON.parse(d);
                        if (!data.noDataFoundMessg) {
                            data.noDataFoundMessg = $translate.instant('anlytcs.home.valid.noDataFound');
                        }
                        element.html('');
                        drawChart(config, data);
                    } catch(err) {} //eslint-disable-line
                });

                attrs.$observe('config', function(d) {
                    try {
                        var currElemWidth = config.elemWidth;
                        config = JSON.parse(d);
                        config.id = attrs.id;
                        config.elemWidth = currElemWidth;
                        element.html('');
                        drawChart(config, data);
                    } catch(err) {} //eslint-disable-line
                });

                scope.$watch(function() {
                    return element.width();
                }, function(newVal) {
                    config = JSON.parse(attrs.config);
                    config.id = attrs.id;
                    config.elemWidth = newVal;
                    element.html('');
                    drawChart(config, data);
                });

                angular.element($window).bind('resize', function() {
                    scope.$digest();
                });

                //create a MutationObserver to watch for changes to the series or element attributes of the element set by bar-chart.js on click
                //cannot use Angular $watch, etc as this is happening outside of Angular scope
                //on a change the seriesCallback or elementCallback functions defined in the element are called
                $timeout(function() {
                    var observer = new MutationObserver(function(mutations) {
                        angular.forEach(mutations, function(mutation) {
                            if (mutation.attributeName === 'series') {
                                scope.seriesCallback({series: JSON.parse(mutation.target.attributes.series.value)});
                            } else if (mutation.attributeName === 'element') {
                                scope.elementCallback({element: JSON.parse(mutation.target.attributes.element.value)});
                            } else if (mutation.attributeName === 'toggle-series-visibility') {
                                var series = data.series[mutation.target.attributes['toggle-series-visibility'].value];
                                if (series.visible === undefined) {
                                    series.visible = false;
                                } else {
                                    series.visible = !series.visible;
                                }
                                element.html('');
                                drawChart(config, data);
                            }
                        });
                    });
                    observer.observe(document.getElementById(config.id), {
                        attributes: true
                    });
                });
            }
        };
    }

})();
angular.module("app")
.constant("apiUrl", "https://mt.hacyberlogix.com/api/");

(function() {
    'use strict';

    angular
        .module('app')
        .directive('chartKeysAccordion', ['$timeout', '$translate', chartKeysAccordion])
        .directive('chartKeysAccordion2', ['$timeout', '$translate', '$filter', chartKeysAccordion2]);

    function chartKeysAccordion($timeout, $translate) {
        return {
            restrict: 'E',
            link: function(scope, element, attrs) {
                var keys = scope.$eval(attrs.data);
                var field = attrs.field;
                return $timeout(function() {
                    if (keys.length) {
                        buildKeys(keys, element);
                        $(element).on('shown.bs.collapse', function(e) {
                            var elId = '#' + e.target.id;
                            var numChildren = parseInt($(elId, element)[0].attributes.numChildren.nodeValue);
                            var offsetTop = e.target.offsetTop - 30;
                            var parentOffsetTop = $(e.target).parent().parent()[0].offsetTop - 30;
                            var scrollTop = 0;
                            scrollTop = (numChildren > 0) ? offsetTop : parentOffsetTop;
                            $(element).parent().animate({
                                scrollTop: scrollTop
                            }, 500);
                            setTimeout(function() {
                                $(element).parent().slimScroll({
                                    scrollTo: scrollTop + 'px'
                                });
                            }, 500);
                        });
                        scope.$apply();
                    }

                    function buildKeys(chartKeys, el) {
                        angular.forEach(chartKeys, function(node) {
                            setTimeout(function() {
                                var accordionDiv = $('<div class="level2-score" style="border-left: 5px solid ' + node.seriesColor + '" />');
                                el.append(accordionDiv);
                                var randomIdfrPrefix = Math.floor(Math.random() * 100) + 1;
                                var accordionLabel = $('<label id="accordionLabel-' + node.scoreHierNodeId + '-' + randomIdfrPrefix + '" class="key-label toggleLink collapsed" data-toggle="collapse" '
                                    + 'data-target="#accordionContent-' + node.scoreHierNodeId + '-' + randomIdfrPrefix + '"  ' + ' > ' + node.scoreHierNodeName + '</label>');
                                $(accordionDiv).append(accordionLabel);
                                var accordionContent = $('<div numChildren="' + node.children.length + '" id="accordionContent-' + node.scoreHierNodeId + '-' + randomIdfrPrefix + '" style="padding-bottom: 5px;" class="level2-description collapse" />');
                                $(accordionDiv).append(accordionContent);
                                var nodeDesc = $('<span style="text-align: justify; margin-bottom: 5px;">' + node.scoreHierNodeDesc + '</span>');
                                $(accordionContent).append(nodeDesc);

                                $(accordionLabel).on('click', function() {
                                    if ($(this).hasClass('collapsed')) {
                                        var parents = $(this).parents('.collapse.in');
                                        $('.collapse.in', el).not(parents).collapse('hide');
                                        if (node.children && node.children.length > 0) {
                                            scope.vm[field] = node.scoreHierNodeId;
                                        }
                                    } else {
                                        scope.vm[field] = node.parentScoreHierNodeId;
                                    }
                                    scope.$apply();
                                });

                                if (node.children && node.children.length > 0) {
                                    $(accordionContent).append('<hr style="border-bottom: 1px solid #e7eaec; margin-top: 5px; margin-bottom: 10px;" />');
                                    var keyTitle = $translate.instant('score.scoreType.keyTitle', {
                                        scoreHierLvlName: node.children[0].scoreHierLvlName
                                    });
                                    $(accordionContent).append('<div class="scoring-title"' + '<h3 style="font-size: 16px; font-weight: 600; margin-bottom: 10px;">' + keyTitle + '</h3></div>');
                                    buildKeys(node.children, accordionContent);
                                }
                            }, 1000);
                        });
                    }
                });
            }
        };
    }

    function chartKeysAccordion2($timeout, $translate, $filter) {
        return {
            restrict: 'E',
            scope: {
                callback: '&'
            },
            link: function(scope, elem, attrs) {
                var scoreHierNodes = scope.$eval(attrs.data);
                var flattenedScoreHierNodes = [];
                flatten(scoreHierNodes);

                function flatten(scoreHierNodes) {
                    angular.forEach(scoreHierNodes, function(scoreHierNode) {
                        flattenedScoreHierNodes.push(scoreHierNode);
                        if (scoreHierNode.children && scoreHierNode.children.length > 0) {
                            flatten(scoreHierNode.children);
                        }
                    });
                }

                attrs.$observe('selectedNode', function(scoreHierNodeId) {
                    openNode(scoreHierNodeId, flattenedScoreHierNodes, attrs.id);
                });

                $timeout(function() {
                    if (scoreHierNodes.length) {
                        buildScoreHierNodes(scoreHierNodes, elem, attrs.id);
                        $(elem).on('shown.bs.collapse', function(e) {
                            if ($('#' + e.target.id)[0].attributes.numChildren) {
                                var numChildren = parseInt($('#' + e.target.id)[0].attributes.numChildren.nodeValue);
                                var offsetTop = e.target.offsetTop - 30;
                                var parentOffsetTop = $(e.target).parent().parent()[0].offsetTop - 30;
                                var scrollTop = 0;
                                scrollTop = (numChildren > 0) ? offsetTop : parentOffsetTop;
                                $(elem).parent().animate({
                                    scrollTop: scrollTop
                                }, 500);
                                setTimeout(function() {
                                    $(elem).parent().slimScroll({
                                        scrollTo: scrollTop + 'px'
                                    });
                                }, 500);
                            }
                        });
                        scope.$apply();
                    }

                    function buildScoreHierNodes(scoreHierNodes, elem, id) {
                        angular.forEach(scoreHierNodes, function(node) {
                            var nodeDiv = $('<div class="level2-score" style="border-left: 5px solid ' + node.seriesColor + '">');
                            elem.append(nodeDiv);
                            var nodeLabel = $('<label id="node-label-' + node.scoreHierNodeId + '-' + id + '" class="key-label toggleLink collapsed" data-toggle="collapse" '
                                + 'data-target="#node-content-' + node.scoreHierNodeId + '-' + id + '">' + node.scoreHierNodeName + '</label>');
                            $(nodeDiv).append(nodeLabel);
                            var nodeContent = $('<div id="node-content-' + node.scoreHierNodeId + '-' + id + '" style="padding-bottom: 5px;" class="level2-description collapse" numChildren="' + node.children.length + '">');
                            $(nodeDiv).append(nodeContent);
                            var nodeDesc = $('<span style="text-align: justify; margin-bottom: 5px;">' + node.scoreHierNodeDesc + '</span>');
                            $(nodeContent).append(nodeDesc);
                            $(nodeLabel).on('click', function() {
                                if ($(this).hasClass('collapsed')) {
                                    if (node.children && node.children.length > 0) {
                                        scope.callback({hierNodeId: node.scoreHierNodeId});
                                    }
                                } else {
                                    scope.callback({hierNodeId: node.parentScoreHierNodeId});
                                }
                            });
                            if (node.children && node.children.length > 0) {
                                $(nodeContent).append('<hr style="border-bottom: 1px solid #e7eaec; margin-top: 5px; margin-bottom: 10px;" />');
                                var hierLevelTitle = $translate.instant('score.scoreType.keyTitle', {
                                    scoreHierLvlName: node.children[0].scoreHierLvlName
                                });
                                $(nodeContent).append('<div class="scoring-title"><h3 style="font-size: 16px; font-weight: 600; margin-bottom: 10px;">' + hierLevelTitle + '</h3></div>');
                                buildScoreHierNodes(node.children, nodeContent, id);
                            }
                        });
                    }
                });

                function openNode(scoreHierNodeId, scoreHierNodes, elemId) {
                    //show the selected node
                    $('#node-content-' + scoreHierNodeId + '-' + elemId).collapse('show');

                    var scoreHierNode = $filter('filter')(scoreHierNodes, {
                        scoreHierNodeId: parseInt(scoreHierNodeId, 10)
                    }, true)[0];
                    if (scoreHierNode) {
                        //close all children of selected node
                        closeNodes(scoreHierNode.children, elemId);
                        //find siblings and close them (and their children)
                        if (scoreHierNode.parentScoreHierNodeId) {
                            var parentScoreHierNode = $filter('filter')(scoreHierNodes, {
                                scoreHierNodeId: scoreHierNode.parentScoreHierNodeId
                            }, true)[0];
                            angular.forEach(parentScoreHierNode.children, function(childScoreHierNode) {
                                if (childScoreHierNode.scoreHierNodeId !== parseInt(scoreHierNodeId, 10)) {
                                    $('#node-content-' + childScoreHierNode.scoreHierNodeId + '-' + elemId).collapse('hide');
                                    closeNodes(childScoreHierNode.children, elemId);
                                }
                            });
                        }
                    } else {
                        //no node so close all nodes
                        angular.forEach(scoreHierNodes, function(scoreHierNode) {
                            $('#node-content-' + scoreHierNode.scoreHierNodeId + '-' + elemId).collapse('hide');
                        });
                    }
                }

                function closeNodes(scoreHierNodes, elemId) {
                    angular.forEach(scoreHierNodes, function(scoreHierNode) {
                        $('#node-content-' + scoreHierNode.scoreHierNodeId + '-' + elemId).collapse('hide');
                        if (scoreHierNode.children && scoreHierNode.children.length > 0) {
                            closeNodes(scoreHierNode.children);
                        }
                    });
                }
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('asterChart', ['$timeout', '$filter', '$window', asterChart]);

    function asterChart($timeout, $filter, $window) {
        return {
            restrict: 'E',
            link: function(scope, element, attrs) {
                var config = scope.$eval(attrs.config);
                var chartEl = config.chartEl;
                var keysEl = config.keysEl;
                var redrawTriggerEl = config.redrawTriggerEl;
                var margin = {
                    top: config.marginTop,
                    right: config.marginRight,
                    bottom: config.marginBottom,
                    left: config.marginLeft
                };
                var width = config.width;
                var height = config.height;
                var minX = (config.minX !== undefined) ? config.minX : 0;
                var minY = (config.minY !== undefined) ? config.minY : 0;
                var viewBox = minX + ' ' + minY + ' ' + width + ' ' + height;
                var preserveAspectRatio = (config.preserveAspectRatio !== undefined) ? config.preserveAspectRatio : 'xMinYMin meet';
                var fixedWidth = (config.fixedWidth !== undefined) ? config.fixedWidth : false;
                var fixedHeight = (config.fixedHeight !== undefined) ? config.fixedHeight : false;
                var radius = (Math.min(width, height) / 2) - margin.top;
                var innerRadius = 0.2 * radius;
                var alphaHighlight = 1;
                var alphaFade = 0.7;
                var enableDrill = config.enableDrill;
                var prevMaxValue; //needed for animation
                var valuesScaleTicksNum = config.valuesScaleTicksNum || 10;
                var axisScaleLabelFontSize = (config.axisScaleLabelFontSize !== undefined) ? config.axisScaleLabelFontSize : 10;
                var axisScaleCssClass = (config.axisScaleCssClass !== undefined) ? config.axisScaleCssClass : 'chart-axis';
                var field = attrs.field;
                var elemWidth = 0;

                var data;
                var maxVal = scope.$eval(attrs.maxVal);

                attrs.$observe('data', function(d) {
                    data = JSON.parse(d);
                    maxVal = scope.$eval(attrs.maxVal);

                    var foldMaxVal = (prevMaxValue) ? prevMaxValue : ((!config.deriveMaxVal) ? maxVal : calculateMaxValue(data, maxVal));
                    var arc = d3.arc()
                        .innerRadius(innerRadius)
                        .outerRadius(function(d) {
                            return (radius - innerRadius) * (d.data.value / foldMaxVal) + innerRadius;
                        });

                    //fold outlineArc
                    d3.select('.aster-chart-g').selectAll('.outlineArc')
                        .transition().duration(1000)
                        .attrTween('d', function(d) {
                            var i = d3.interpolate(d.endAngle, d.startAngle);
                            return function(t) {
                                d.endAngle = i(t);
                                return arc(d);
                            };
                        });

                    //fold solidArc
                    d3.select('.aster-chart-g').selectAll('.solidArc')
                        .transition().duration(1000)
                        .attrTween('d', function(d) {
                            var i = d3.interpolate(d.endAngle, d.startAngle);
                            return function(t) {
                                d.endAngle = i(t);
                                return arc(d);
                            };
                        });

                    //fold concurrent circles
                    d3.select('.r').selectAll('circle')
                        .transition().duration(1000)
                        .attr('r', 0);

                    $timeout(function() {
                        drawChart(data);
                    }, 1000);
                });

                $(redrawTriggerEl).click(function() {
                    $timeout(function() {
                        drawChart(data);
                    }, 100);
                });

                scope.$watch(function () {
                    return element.width();
                }, function(newVal) {
                    elemWidth = newVal;
                    drawChart(data);
                });

                angular.element($window).bind('resize', function() {
                    scope.$digest();
                });

                function rgbToRgba(rgb, a) {
                    if (rgb) {
                        rgb = rgb.substring(4, rgb.length - 1)
                            .replace(/ /g, '')
                            .split(',');
                        return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + a + ')';
                    }
                }

                function colorHighlight(selector, data, alphaHighlight) {
                    d3.select(selector).attr('fill', function() {
                        return rgbToRgba(data.color, alphaHighlight);
                    });
                }

                function colorFade(selector, data, alphaFade) {
                    d3.select(selector).attr('fill', function() {
                        return rgbToRgba(data.color, alphaFade);
                    });
                }

                function calculateMaxValue(chartData, configMaxVal) {
                    var maxVal = 0;
                    angular.forEach(chartData.series, function(target) {
                        maxVal = Math.max(maxVal, target.value);
                    });
                    if (maxVal === 0) {
                        return configMaxVal;
                    }
                    return $filter('roundUpOneSigFig')(maxVal);
                }

                function openAccordion(scoreHierNodeId) {
                    $('.key-label', keysEl).each(function() {
                        var labelId = $(this).attr('id').split('-')[1];
                        if (parseInt(labelId) === scoreHierNodeId) {
                            $('.collapse', keysEl).each(function() {
                                var divId = $(this).attr('id').split('-')[1];
                                if (parseInt(divId) === scoreHierNodeId) {
                                    var parents = $(this).parents('.collapse.in');
                                    $('.collapse.in', keysEl).not(parents).collapse('hide');
                                    $(this).collapse('show');
                                }
                            });
                            return false;
                        }
                    });
                }

                function drawChart(chartData) {
                    var tooltip = d3.select('#chart-tip');
                    if (!tooltip.node()) {
                        tooltip = d3.select('body')
                            .append('div')
                            .attr('id', 'chart-tip')
                            .attr('class', 'chart-tip')
                            .style('position', 'absolute')
                            .style('z-index', '1000')
                            .style('visibility', 'hidden');
                    }
                    element.html('');
                    maxVal = (!config.deriveMaxVal) ? maxVal : calculateMaxValue(chartData, maxVal);
                    prevMaxValue = maxVal;
                    var svgScaleFactor = (width / elemWidth);
                    var svg = d3.select(chartEl)
                        .append('svg')
                        .attr('class', 'aster-chart-svg')
                        .attr('viewBox', viewBox)
                    ;
                    if (preserveAspectRatio) {
                        svg.attr('preserveAspectRatio', preserveAspectRatio);
                    }
                    if (fixedWidth) {
                        svg.attr('width', width);
                    }
                    if (fixedHeight) {
                        svg.attr('height', height);
                    }
                    //group object
                    var g = svg.append('g')
                        .attr('class', 'aster-chart-g')
                        .attr('transform', 'translate(' + (width / 2) + ',' + ((height / 2) + margin.top) + ')');

                    var pie = d3.pie()
                        .sort(null)
                        .value(function(d) { //return 360/chartData.length;  // This is a hack because we dont have a weight yet.
                            return d.weight;
                        });
                    var arc = d3.arc()
                        .innerRadius(innerRadius)
                        .outerRadius(function(d) {
                            return (radius - innerRadius) * (d.data.value / maxVal) + innerRadius;
                        });

                    var outlineArc = d3.arc().innerRadius(innerRadius).outerRadius(radius);

                    g.selectAll('.outlineArc')
                        .data(pie(chartData.series))
                        .enter().append('path')
                        .attr('fill', function() {
                            return rgbToRgba('rgb(255,255,255)', alphaFade);
                        })
                        .attr('stroke', '#dddddd')
                        .attr('class', 'outlineArc')
                        .attr('d', outlineArc)
                        .on('mouseover', function(d) {
                            // colorHighlight(this, d.data, alphaHighlight);
                            tooltip.html(d.data.tip);
                            $('.chart-tip').css('visibility', 'hidden');
                            return tooltip.style('visibility', 'visible');
                        })
                        .on('mousemove', function() {
                            reposTip(tooltip);
                        })
                        .on('mouseout', function() {
                            // colorFade(this, d.data, alphaFade);
                            return tooltip.style('visibility', 'hidden');
                        }).on('click', function(d) {
                            $timeout(function() {
                                tooltip.style('visibility', 'hidden');
                                if (enableDrill && d.data.hasChildren) {
                                    scope.vm[field] = d.data.scoreHierNodeId;
                                }
                                openAccordion(d.data.scoreHierNodeId);
                            });
                        });

                    g.selectAll('.solidArc')
                        .data(pie(chartData.series))
                        .enter().append('path')
                        .attr('fill', function(d) {
                            return rgbToRgba(d.data.color, alphaFade);
                        })
                        .attr('class', 'solidArc')
                        .attr('stroke', 'none')
                        .attr('d', arc)
                        .on('mouseover', function(d) {
                            colorHighlight(this, d.data, alphaHighlight);
                            tooltip.html(d.data.tip);
                            $('.chart-tip').css('visibility', 'hidden');
                            return tooltip.style('visibility', 'visible');
                        })
                        .on('mousemove', function() {
                            reposTip(tooltip);
                        })
                        .on('mouseout', function(d) {
                            colorFade(this, d.data, alphaFade);
                            return tooltip.style('visibility', 'hidden');
                        }).on('click', function(d) {
                            $timeout(function() {
                                tooltip.style('visibility', 'hidden');
                                if (enableDrill && d.data.hasChildren) {
                                    scope.vm[field] = d.data.scoreHierNodeId;
                                }
                                openAccordion(d.data.scoreHierNodeId);
                            });
                        })
                        .transition().duration(1000)
                        .attrTween('d', function(d) {
                            var i = d3.interpolate(d.startAngle, d.endAngle);
                            return function(t) {
                                d.endAngle = i(t);
                                return arc(d);
                            };
                        })
                        ;

                    /////// Configure Scale ///////
                    var verticalScale = d3.scaleLinear()
                        .domain([0, maxVal])
                        .range([-innerRadius, -radius]);

                    var vertAxis = d3.axisLeft(verticalScale)
                        //.tickFormat(function(d, i) {
                        //    return (i % 2 === 0) ? d : '';
                        //})
                        .ticks(valuesScaleTicksNum % 2 === 0 ? valuesScaleTicksNum / 2 : valuesScaleTicksNum);
                    g.append('g')
                        .attr('class', axisScaleCssClass)
                        .attr('style', 'font-size: ' + axisScaleLabelFontSize * svgScaleFactor + 'px !important')
                        .call(vertAxis);

                    svg.selectAll('.tick').filter(function(d) {
                        return (d === 0);
                    }).remove();

                    /////// Append concentric circles based on scale ///////
                    var circleScale = d3.scaleLinear()
                        .domain([0, maxVal])
                        .range([innerRadius, radius]);

                    svg.append('g')
                        .attr('class', 'r axis')
                        .selectAll('g')
                        .data(verticalScale.ticks((valuesScaleTicksNum % 2 === 0) ? valuesScaleTicksNum / 2 : valuesScaleTicksNum))
                        .enter().append('g')
                        .attr('transform', 'translate(' + (width / 2) + ',' + ((height / 2) + margin.top) + ')')
                        .append('circle')
                        .attr('r', 0)
                        .attr('stroke', '#dddddd')
                        .attr('stroke-width', 1)
                        .style('stroke-dasharray', ('2, 2'))
                        .attr('fill', 'none')
                        .transition().duration(1000)
                        .attr('r', circleScale);
                }

            }
        };
    }

    function reposTip(tooltip) {
        var toolTipYPos = 25;
        var toolTipXPos = 15;
        return tooltip.style('top', (d3.event.pageY - toolTipYPos) + 'px').style('left', (d3.event.pageX + toolTipXPos) + 'px');
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('AppService', ['$rootScope', '$filter', AppService]);

    function AppService($rootScope, $filter) {
        var service = {
            showSettings: showSettings,
            featureTierRange: featureTierRange
        };
        return service;

        function showSettings() {
            $('#settingsTriggerIcon')[0].click();
        }

        function featureTierRange(featCd, configCd, val) {
            var featureTier;
            if ($rootScope.featureTiers && val !== undefined && val !== null && val !== '') {
                var featureTiers = $filter('filter')($rootScope.featureTiers, { featCd: featCd, configCd: configCd }, true);
                var ftSorted = $filter('orderBy')(featureTiers, 'tierSeq', false);
                for (var i = 0; i < ftSorted.length; i++) {
                    var minConfig = ftSorted[i];
                    if ((i + 1) < ftSorted.length) {
                        var maxConfig = ftSorted[i + 1];
                        if (minConfig.minValInclusive && maxConfig.minValInclusive && val >= minConfig.min && val < maxConfig.min) {
                            featureTier = minConfig;
                        } else if (minConfig.minValInclusive && !maxConfig.minValInclusive && val >= minConfig.min && val <= maxConfig.min) {
                            featureTier = minConfig;
                        } else if (!minConfig.minValInclusive && maxConfig.minValInclusive && val > minConfig.min && val < maxConfig.min) {
                            featureTier = minConfig;
                        } else if (!minConfig.minValInclusive && !maxConfig.minValInclusive && val > minConfig.min && val <= maxConfig.min) {
                            featureTier = minConfig;
                        }
                    } else if (minConfig.minValInclusive && val >= minConfig.min) {
                        featureTier = minConfig;
                    } else if (!minConfig.minValInclusive && val > minConfig.min) {
                        featureTier = minConfig;
                    }
                }
            }
            return featureTier;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', '$urlRouterProvider', appRoute]);

    function appRoute($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/app/404');

        $stateProvider
            .state('root', {
                url: '/',
                controller: 'RootCtrl',
                data: {
                    showInMenu: 'never'
                }
            })
            .state('app', {
                url: '/app',
                templateUrl: 'app/app.html',
                controller: 'AppCtrl',
                controllerAs: 'vm',
                data: {
                    authenticationReqd: true,
                    showInMenu: 'never'
                },
                resolve: {
                    authorize: ['AuthService', function (AuthService) {
                        return AuthService.authorize();
                    }],
                    currentUser: ['Principal', function (Principal) {
                        return Principal.identity();
                    }],
                    account: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'account', {cache: true});
                    }],
                    referenceData: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references', {cache: true});
                    }],
                    userParms: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/userParms', {cache: true});
                    }],
                    userParmTypes: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/userParmTypes', {cache: true});
                    }],
                    sysParms: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysParms', {cache: true});
                    }],
                    properties: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/properties', {cache: true});
                    }],
                    surveyTypes: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/surveyTypes', {cache: true});
                    }],
                    surveySections: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/surveySections', {cache: true});
                    }],
                    allLangSurveys: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'surveys/all', {cache: true});
                    }],
                    subjStageScores: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/subjStageScores', { cache: true });
                    }],
                    scoreTypes: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/scoreTypes', { cache: true });
                    }],
                    conflgUsrRoles: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/conflictingRoles/usr', {cache: true});
                    }],
                    conflgOrgRoles: ['$http', 'apiUrl', function ($http, apiUrl) {
                        return $http.get(apiUrl + 'references/conflictingRoles/org', {cache: true});
                    }],
                    sysUserRoleTypes: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/sysUserRoleTypes', { cache: true });
                    }],
                    subjRoleTypes: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/subjRoleTypes', {cache: true});
                    }],
                    featureTiers: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/featureTiers', {cache: true});
                    }],
                    peerGrps: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/peerGroups', {cache: true});
                    }],
                    chartGrps: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/chartGroups', {cache: true});
                    }],
                    targetRoleTypeName: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/targetRoleTypeName', {cache: true});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        $translatePartialLoader.addPart('menu');
                        $translatePartialLoader.addPart('subj');
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.403', {
                url: '/403',
                views: {
                    'content@app': {
                        templateUrl: 'app/core/403.html'
                    }
                },
                data: {
                    authenticationReqd: false,
                    i18n: {
                        pageTitle: '403.pageTitle'
                    },
                    icon: 'fa-exclamation-circle'
                }
            })
            .state('app.404', {
                url: '/404',
                views: {
                    'content@app': {
                        templateUrl: 'app/core/404.html'
                    }
                },
                data: {
                    authenticationReqd: false,
                    i18n: {
                        pageTitle: '404.pageTitle'
                    },
                    icon: 'fa-exclamation-circle'
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .filter('dateFormat', ['$rootScope', dateFormat])
        .filter('dateOnlyFormat', ['$rootScope', 'momentCalendar', dateOnlyFormat])
        .filter('shortDateFormat', ['$rootScope', shortDateFormat])
        .filter('shortDateFormatWithDay', ['$rootScope', shortDateFormatWithDay])
        .filter('dayOfWeekFormat', ['$rootScope', dayOfWeekFormat])
        .filter('isoFormat', ['$rootScope', isoFormat])
        .filter('isoDayOfWeekFormat', ['$rootScope', isoDayOfWeekFormat])
        .filter('mixedDateFormat', ['$rootScope', mixedDateFormat])
        .filter('completeDateTimeFormat', ['$rootScope', completeDateTimeFormat])
        .filter('fileSize', fileSize)
        .filter('roundUpOneSigFig', roundUpOneSigFig)
        .filter('replaceEventToken', ['$filter', replaceEventToken])
        .filter('filterMultiple', ['$filter', filterMultiple])
        .filter('offset', offset)
        .filter('scoreTierLabel', ['$filter', scoreTierLabel])
        .filter('scoreTierMinRange', scoreTierMinRange)
        .filter('scoreTierMaxRange', scoreTierMaxRange)
        .filter('dateRangeLabel', ['$rootScope', '$filter', dateRangeLabel])
        .filter('userParmLabel', ['$rootScope', '$filter', userParmLabel]);

    function offset() {
        return function(input, start) {
            start = parseInt(start, 10);
            return input.slice(start);
        };
    }

    function dateFormat($rootScope) {
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).calendar(null, {
                sameElse: userDatePref + ' LT'
            });
        };
    }

    function dateOnlyFormat($rootScope, momentCalendar) {
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            //use text in momentCalendar.js to get relative names in correct language then add sameElse
            var momentCalendarLocale = momentCalendar[$rootScope.userLang];
            momentCalendarLocale.sameElse = userDatePref;
            return moment(input).calendar(null, momentCalendarLocale);
        };
    }

    function shortDateFormat($rootScope) {
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).format(userDatePref);
        };
    }

    function shortDateFormatWithDay($rootScope) {
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'ddd, DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'ddd, MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).format(userDatePref);
        };
    }

    function dayOfWeekFormat($rootScope) {
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).format('ddd');
        };
    }

    function isoFormat($rootScope) {
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).toISOString();
        };
    }

    function isoDayOfWeekFormat($rootScope) {
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).format('E');
        };
    }

    function mixedDateFormat($rootScope) {
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            if (moment().format(userDatePref) === moment(input).format(userDatePref)) {
                return moment(input).fromNow();
            }
            return moment(input).calendar(null, {
                sameElse: userDatePref + ' LT'
            });
        };
    }

    function completeDateTimeFormat($rootScope) {
        // No relative display, plain date and time (in AM PM) in user format
        var userDatePref = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        if (userDatePref === 'DMY') {
            userDatePref = 'DD/MM/YYYY';
        } else if (userDatePref === 'MDY') {
            userDatePref = 'MM/DD/YYYY';
        }
        return function(input) {
            moment.locale($rootScope.userLocale);
            return moment(input).format(userDatePref + ' LT');
        };
    }

    function fileSize() {
        return function(size) {
            if (isNaN(size)) {
                size = 0;
            }
            if (size < 1024) {
                return size + ' B';
            }
            size /= 1024;
            if (size < 1024) {
                return size.toFixed(1) + ' kB';
            }
            size /= 1024;
            if (size < 1024) {
                return size.toFixed(1) + ' MB';
            }
            size /= 1024;
            if (size < 1024) {
                return size.toFixed(1) + ' GB';
            }
            size /= 1024;
            return size.toFixed(1) + ' TB';
        };
    }

    function roundUpOneSigFig() {
        return function(input) {
            var mult = Math.pow(10, 1 - Math.floor(Math.log(input) / Math.LN10) - 1);
            return Math.ceil(input * mult) / mult;
        };
    }

    function replaceEventToken($filter) {
        return function(eventText) {
            return eventText.replace(/{{(.*?)}}/gi, function(tag) {
                tag = tag.replace('{{', '').replace('}}', '');
                var tagContentType = tag.split(':')[0];
                var tagContentValue = tag.split(':')[1];
                return (tag && tagContentType === 'date') ? $filter('shortDateFormat')(tagContentValue) : '';
            });
        };
    }

    function filterMultiple($filter) {
        return function(items, keyObj) {
            var filterObj = {
                data: items,
                filteredData: [],
                loopCnt: 0,
                applyFilter: function(obj, key) {
                    var fData = [];
                    if (this.filteredData && this.filteredData.length === 0 && this.loopCnt === 0) {
                        this.filteredData = this.data;
                    }
                    if (obj && obj.length > 0) {
                        var fObj = {};
                        if (!angular.isArray(obj)) {
                            fObj[key] = obj;
                            fData = fData.concat($filter('filter')(this.filteredData, fObj, true));
                        } else if (angular.isArray(obj)) {
                            if (obj.length > 0) {
                                for (var i = 0; i < obj.length; i++) {
                                    fObj = {};
                                    if (obj[i].childIds && obj[i].childIds.length > 0) {
                                        for (var j = 0; j < obj[i].childIds.length; j++) {
                                            fObj = {};
                                            fObj[obj[i].childKey] = obj[i].childIds[j];
                                            fData = fData.concat($filter('filter')(this.filteredData, fObj, true));
                                        }
                                    } else {
                                        fObj[key] = obj[i].id;
                                        fData = fData.concat($filter('filter')(this.filteredData, fObj, true));
                                    }
                                }
                            }
                        }
                        this.filteredData = fData;
                        this.loopCnt++;
                    }
                }
            };

            if (keyObj) {
                angular.forEach(keyObj, function(obj, key) {
                    filterObj.applyFilter(obj, key);
                });
            }
            return filterObj.filteredData;
        };
    }

    function scoreTierLabel($filter) {
        return function(minRange, maxRange, minScoreInclsvFlag, maxScoreInclsvFlag, scoreValDpCnt) {
            return $filter('number')($filter('scoreTierMinRange')(minRange, minScoreInclsvFlag, scoreValDpCnt), scoreValDpCnt)
                + ' - '
                + $filter('number')($filter('scoreTierMaxRange')(maxRange, maxScoreInclsvFlag, scoreValDpCnt), scoreValDpCnt);
        };
    }

    function scoreTierMinRange() {
        return function(minRange, minScoreInclsvFlag, scoreValDpCnt) {
            if (minScoreInclsvFlag) {
                return minRange;
            }
            return minRange + (1 / Math.pow(10, scoreValDpCnt));
        };
    }

    function scoreTierMaxRange() {
        return function(maxRange, maxScoreInclsvFlag, scoreValDpCnt) {
            if (maxScoreInclsvFlag) {
                return maxRange;
            }
            return maxRange - (1 / Math.pow(10, scoreValDpCnt));
        };
    }

    function dateRangeLabel($rootScope, $filter) {
        return function(dateRangeCd) {
            if (dateRangeCd) {
                if (dateRangeCd.cd !== 'CUS') {
                    var dateRangeParmType = $filter('filter')($rootScope.userParmTypes, {userParmTypeCd: 'DT_RANGE_CD'}, true)[0];
                    return $filter('filter')(dateRangeParmType.options, {
                        cd: dateRangeCd.cd
                    }, true)[0].nm;
                }
                var asOfFromDate = moment(dateRangeCd.asOfFromDate, 'YYYY-MM-DD');
                var asOfToDate = moment(dateRangeCd.asOfToDate, 'YYYY-MM-DD');
                return $filter('dateOnlyFormat')(asOfFromDate) + ' - ' + $filter('dateOnlyFormat')(asOfToDate);
            }
        };
    }

    function userParmLabel($rootScope, $filter) {
        return function(val, userParmTypeCd) {
            if (val && userParmTypeCd) {
                var userParmType = $filter('filter')($rootScope.userParmTypes, {
                    userParmTypeCd: userParmTypeCd
                }, true)[0];
                var lbl = $filter('filter')(userParmType.options, {
                    cd: val
                }, true)[0].nm;
                return (lbl.length <= 15 ? lbl : lbl.substring(0, 14) + '…');
            }
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('leftNavMenu', ['$parse', leftNavMenu])
        .directive('icheck', ['$timeout', icheck])
        .directive('breadcrumbs', ['$rootScope', '$state', breadcrumbs])
        .directive('extractBreadcrumbTextContent', [extractBreadcrumbTextContent])
        .directive('hasAnyUserPerms', ['Principal', hasAnyUserPerms])
        .directive('hasntAnyUserPerms', ['Principal', hasntAnyUserPerms])
        .directive('hasAnyUserPermsDisable', ['Principal', hasAnyUserPermsDisable])
        .directive('ignoreDisabledLinks', ignoreDisabledLinks)
        .directive('toggleHelp', toggleHelp)
        .directive('toggleSettings', ['$rootScope', '$timeout', toggleSettings])
        .directive('fileModal', ['$parse', fileModal])
        .directive('priorityColor', ['AppService', priorityColor])
        .directive('compareTo', compareTo)
        .directive('disableEmptyDropDown', ['$timeout', disableEmptyDropDown])
        .directive('onFinishRender', ['$timeout', onFinishRender])
        .directive('onHiddenShown', onHiddenShown)
        .directive('activityBadge', ['AppService', activityBadge])
        .directive('activitySideBar', ['AppService', activitySideBar])
        .directive('focusOnLoad', ['$timeout', focusOnLoad])
        .directive('summernoteEditor', ['$timeout', summernoteEditor])
        .directive('elementOptLabelSummernoteEditor', ['$timeout', elementOptLabelSummernoteEditor])
        .directive('bcastSideBar', ['AppService', bcastSideBar])
        .directive('asOfFromDateEl', ['$timeout', asOfFromDateEl])
        .directive('asOfToDateEl', ['$timeout', asOfToDateEl]);

    function leftNavMenu($parse) {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'app/layout/left-nav-template.html',
            link: function(scope, element, attrs) {
                scope.menus = $parse(attrs.leftNavMenu)(scope);
            }
        };
    }

    function asOfFromDateEl($timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element) {
                $timeout(function() {
                    $(element).datepicker({
                        format: scope.vm.dateFormat.toLowerCase(),
                        todayHighlight: true,
                        autoclose: true,
                        showOnFocus: false
                    }).on('changeDate', function(ev) {
                        scope.vm.asOfFromDateStr = moment(ev.date, 'YYYY-MM-DD').format(scope.vm.dateFormat);
                        $('#asOfFromDateEl').focus();
                    });
                });
            }
        };
    }

    function asOfToDateEl($timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element) {
                $timeout(function() {
                    $(element).datepicker({
                        format: scope.vm.dateFormat.toLowerCase(),
                        todayHighlight: true,
                        autoclose: true,
                        showOnFocus: false
                    }).on('changeDate', function(ev) {
                        scope.vm.asOfToDateStr = moment(ev.date, 'YYYY-MM-DD').format(scope.vm.dateFormat);
                        $('#asOfToDateEl').focus();
                    });
                });
            }
        };
    }

    function icheck($timeout) {
        return {
            require: 'ngModel',
            scope: {},
            link: function(scope, element, attrs, model) {
                return $timeout(function() {
                    if (attrs.disabled) {
                        $(element).iCheck(attrs.disabled ? 'disable' : 'enable');
                    }

                    attrs.$observe('disabled', function(disabled) {
                        if (disabled !== undefined) {
                            $(element).iCheck(disabled ? 'disable' : 'enable');
                            $(element).iCheck('update');
                        }
                    });

                    scope.$watch(function() {
                        return model.$modelValue;
                    }, function() {
                        $(element).iCheck('update');
                    });

                    var unSelectable = scope.$eval(attrs.unSelectable);
                    var value = attrs.value;
                    return $(element).iCheck({
                        checkboxClass: attrs.checkboxClass ? attrs.checkboxClass : 'icheckbox_square-idmx',
                        radioClass: attrs.radioClass ? attrs.radioClass : 'iradio_square-idmx'
                    }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox') {
                            model.$setViewValue(event.target.checked);
                            model.$render();
                        }
                    }).on('ifClicked', function() {
                        if ($(element).attr('type') === 'radio') {
                            if (model.$viewValue !== value) {
                                $(element).iCheck('check').focus();
                                model.$setViewValue(value);
                            } else if (unSelectable) {
                                $(element).iCheck('uncheck').focus();
                                model.$setViewValue(undefined);
                            }
                            model.$render();
                        }
                    }).on('keyup', function(e) {
                        if (e.which === 32) {
                            e.preventDefault();
                            if ($(element).attr('type') === 'radio' && unSelectable) {
                                if (model.$viewValue !== value) {
                                    $(element).iCheck('check');
                                    model.$setViewValue(value);
                                } else {
                                    $(element).iCheck('uncheck');
                                    model.$setViewValue(undefined);
                                }
                                model.$render();
                            }
                        }
                    });
                });
            }
        };
    }

    function breadcrumbs($rootScope, $state) {
        return {
            restrict: 'E',
            templateUrl: 'app/core/template/breadcrumb-template.html',
            link: function(scope) {
                scope.breadcrumbs = [];
                if ($state.$current.name !== '') {
                    updateBreadcrumbsArray();
                }

                scope.$on('$stateChangeSuccess', function() {
                    updateBreadcrumbsArray();
                });

                /**
                 * Start with the current state and traverse up the path to build the
                 * array of breadcrumbs that can be used in an ng-repeat in the template.
                 * States where abstract = true are skipped
                 */
                function updateBreadcrumbsArray() {
                    var breadcrumbs = [];
                    var currentState = $state.$current;
                    while (currentState && currentState.name !== '') {
                        if (!(currentState.data && currentState.data.showInMenu === 'never')) {
                            if (currentState.name === 'app.subject') {
                                if ($rootScope.subject) {
                                    breadcrumbs.push({
                                        subject: true
                                    });
                                }
                            } else {
                                var i18n = (currentState.data && currentState.data.i18n && currentState.data.i18n.menu) ? currentState.data.i18n.menu : currentState.name;
                                breadcrumbs.push({
                                    i18n: i18n,
                                    route: (currentState.abstract) ? null : currentState.name
                                });
                                if ((currentState.name === 'app.subjects.editSubj' || currentState.name === 'app.subjects.repeatSubj' || currentState.name === 'app.subjects.cloneSubj') && $rootScope.subject) {
                                    breadcrumbs.push({
                                        subject: true
                                    });
                                }
                            }
                        }
                        currentState = currentState.parent;
                    }
                    //Add app.subjects to app.subject tree
                    if ($state.includes('app.subject')) {
                        breadcrumbs.push({
                            i18n: 'menu.subj.top',
                            route: 'app.subjects'
                        });
                    }
                    breadcrumbs.reverse();
                    scope.breadcrumbs = breadcrumbs;
                }

            }
        };
    }

    function extractBreadcrumbTextContent() {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'app/layout/left-nav-template.html',
            link: function(scope, element, attrs) {
                var html = attrs.html;
                element.replaceWith('<b>' + stripHtml(html) + '</b>');
            }
        };
    }

    function stripHtml(html) {
        // Create a new div element
        var temporalDivElement = document.createElement('div');
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = html;
        // Retrieve the text property of the element (cross-browser support)
        return temporalDivElement.textContent || temporalDivElement.innerText || '';
    }

    function hasAnyUserPerms(Principal) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var userPerms = attrs.hasAnyUserPerms.replace(/\s+/g, '').replace(/'/g, '"');
                var defineVisibility = function() {
                    if (!Principal.hasAnyUserPerm(JSON.parse(userPerms))) {
                        element.replaceWith('');
                    }
                };
                if (userPerms.length > 0) {
                    defineVisibility();
                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility();
                    });
                }
            }
        };
    }

    function hasntAnyUserPerms(Principal) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var userPerms = attrs.hasntAnyUserPerms.replace(/\s+/g, '').replace(/'/g, '"');
                var defineVisibility = function() {
                    if (Principal.hasAnyUserPerm(JSON.parse(userPerms))) {
                        element.replaceWith('');
                    }
                };
                if (userPerms.length > 0) {
                    defineVisibility();
                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility();
                    });
                }
            }
        };
    }

    function hasAnyUserPermsDisable(Principal) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var userPerms = attrs.hasAnyUserPermsDisable.replace(/\s+/g, '').replace(/'/g, '"');
                var setEnabled = function() {
                    element.attr('disabled', false);
                };
                var setDisabled = function() {
                    element.attr('disabled', true);
                    element.removeAttr('ng-click');
                };
                var defineVisibility = function() {
                    setEnabled();
                    var result = Principal.hasAnyUserPerm(JSON.parse(userPerms));
                    if (result) {
                        setEnabled();
                    } else {
                        setDisabled();
                    }
                };

                if (userPerms.length > 0) {
                    defineVisibility();
                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility();
                    });
                }
            }
        };
    }

    function ignoreDisabledLinks() {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, elm) {
                $(document).ready(function() {
                    var menuUlElement = $('ul', elm)[0];
                    var menuLiElements = $(menuUlElement).find('li');
                    var totalLinks = 0;
                    var disabledLinks = 0;
                    //count disabled links
                    $.each(menuLiElements, function(idx, li) {
                        var link = $(li).find('a')[0];
                        if (link !== undefined) {
                            totalLinks += 1;
                        }
                        var disabledLink = $(li).find('span.disabledAction a')[0];
                        if (disabledLink !== undefined) {
                            disabledLinks += 1;
                            //ignore clicks on disabled links
                            $(li).on('click', function(e) {
                                e.stopPropagation();
                            });
                        }
                    });
                    //if all links are disabled
                    if (totalLinks === disabledLinks) {
                        //remove links
                        $.each(menuLiElements, function(idx, li) {
                            $(li).remove();
                        });
                        //disable menu dropdown btn
                        var btnContainerEl = $(menuUlElement).parent()[0];
                        $('.idmx-dd-link-btn', btnContainerEl).attr('disabled', true);
                        $('.idmx-dd-link-btn', btnContainerEl).removeClass('dropdown-toggle');
                    }
                });
            }
        };
    }

    function disableEmptyDropDown($timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, elm) {
                return $timeout(function() {
                    var menuUlElement = $('ul', elm)[0];
                    var menuLiElements = $(menuUlElement).find('li');
                    //if there are no li items
                    if ($(menuLiElements).length === 0) {
                        //remove links
                        //disable menu dropdown btn
                        var btnContainerEl = $(menuUlElement).parent()[0];
                        $('.idmx-dd-link-btn', btnContainerEl).attr('disabled', true);
                        $('.idmx-dd-link-btn', btnContainerEl).removeClass('dropdown-toggle');
                    }
                });
            }
        };
    }

    function toggleHelp() {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element) {
                $(element).on('click', function() {
                    var globalHelpContainer = $('#globalHelpContainer')[0];
                    var helpTriggerIcon = $('#helpTriggerIcon')[0];
                    if ($(helpTriggerIcon).hasClass('spin-icon')) {
                        if ($(globalHelpContainer).hasClass('show')) {
                            $(globalHelpContainer).removeClass('show');
                            $(helpTriggerIcon).removeClass('show');
                        } else {
                            $(globalHelpContainer).addClass('show');
                            $(helpTriggerIcon).addClass('show');

                            //hide settings if showing
                            var settingsContainer = $('#settingsContainer')[0];
                            var settingsTriggerIcon = $('#settingsTriggerIcon')[0];
                            if ($(settingsContainer).hasClass('show')) {
                                $(settingsContainer).removeClass('show');
                                $(settingsTriggerIcon).removeClass('show');
                            }
                        }
                    }
                });
            }
        };
    }

    function toggleSettings($rootScope, $timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element) {
                $(element).on('click', function() {
                    var settingsContainer = $('#settingsContainer')[0];
                    var settingsTriggerIcon = $('#settingsTriggerIcon')[0];
                    if ($(settingsTriggerIcon).hasClass('settings-icon')) {
                        if ($(settingsContainer).hasClass('show')) {
                            $(settingsContainer).removeClass('show');
                            $(settingsTriggerIcon).removeClass('show');
                        } else {
                            $(settingsContainer).addClass('show');
                            $(settingsTriggerIcon).addClass('show');

                            $timeout(function() {
                                scope.vm.selectedDateRangeCd = $rootScope.userParms.DT_RANGE_CD.val.cd;
                                if (scope.vm.selectedDateRangeCd === 'CUS') {
                                    scope.vm.asOfFromDateStr = moment($rootScope.userParms.DT_RANGE_CD.val.asOfFromDate).format(scope.vm.dateFormat);
                                    scope.vm.asOfToDateStr = moment($rootScope.userParms.DT_RANGE_CD.val.asOfToDate).format(scope.vm.dateFormat);
                                }
                                /*AppService.getOrgIdParm().then(function(orgIds) {
                                    if (orgIds) {
                                        scope.vm.selectedOrgIds = orgIds;
                                    }
                                }, function(reason) {
                                    return reason;
                                });*/
                            });
                            //hide help if showing
                            var globalHelpContainer = $('#globalHelpContainer')[0];
                            var helpTriggerIcon = $('#helpTriggerIcon')[0];
                            if ($(globalHelpContainer).hasClass('show')) {
                                $(globalHelpContainer).removeClass('show');
                                $(helpTriggerIcon).removeClass('show');
                            }
                        }
                    }
                });
            }
        };
    }

    function fileModal($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var values = [];
                var model = $parse(attrs.fileModal);
                var uploadSize = attrs.maxLength;
                var isMultiple = attrs.multiple;
                var modelSetter = model.assign;
                element.bind('change', function() {
                    angular.forEach(element[0].files, function(item) {
                        values.push(item);
                        if (item.size > uploadSize) {
                            $('#file_upload_error').css('display', 'block');
                            scope.fileError = true;
                        }
                    });

                    var sizeInvalid = true; //Assuming any file size is not valid
                    angular.forEach(values, function(val) {
                        if (sizeInvalid) {
                            if (val.size < uploadSize) {
                                sizeInvalid = false; //As soon as any valid sized file is browsed, 'Add' button is enabled
                                $('#file-upload-btn').attr('disabled', false);
                            }
                        }
                    });
                    scope.$apply(function() {
                        if (isMultiple) {
                            modelSetter(scope, values);
                        } else {
                            modelSetter(scope, values[0]);
                        }
                    });
                });
            }
        };
    }

    function priorityColor(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.priority, 10));
                function setClass(priority) {
                    if (angular.isNumber(priority) && !isNaN(priority)) {
                        var featureConfig = AppService.featureTierRange('BCAST', 'PRIOT', priority);
                        element.addClass('badge');
                        element.css('background-color', featureConfig.configParam.badge.bgColor);
                        element.css('color', featureConfig.configParam.badge.fgColor);
                    }
                }
            }
        };
    }

    function compareTo() {
        return {
            require: 'ngModel',
            scope: {
                otherModelValue: '=compareTo'
            },
            link: function(scope, element, attributes, model) {
                model.$validators.compareTo = function(modelValue) {
                    return modelValue === scope.otherModelValue;
                };

                scope.$watch('otherModelValue', function() {
                    model.$validate();
                });
            }
        };
    }

    function onFinishRender($timeout) {
        //https://stackoverflow.com/questions/15207788/calling-a-function-when-ng-repeat-has-finished
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if (scope.$last === true) {
                    $timeout(function() {
                        scope.$emit(attrs.onFinishRender);
                    });
                }
            }
        };
    }

    function onHiddenShown() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.on('shown.bs.collapse', function() {
                    scope.$emit(attrs.onHiddenShown);
                });
                element.on('hidden.bs.collapse', function() {
                    scope.$emit(attrs.onHiddenShown);
                });
            }
        };
    }

    function activityBadge(AppService) {
        // adds styling to badge/label type elements
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.priority, 10));
                function setClass(priority) {
                    if (angular.isNumber(priority) && !isNaN(priority)) {
                        var featureConfig = AppService.featureTierRange('ACTVTY', 'PRIOT', priority);
                        if (featureConfig) {
                            element.css('background-color', featureConfig.configParam.badge.bgColor);
                            element.css('color', featureConfig.configParam.badge.fgColor);
                        }
                    }
                }
            }
        };
    }

    function activitySideBar(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.priority, 10));

                function setClass(priority) {
                    if (angular.isNumber(priority) && !isNaN(priority)) {
                        var featureConfig = AppService.featureTierRange('ACTVTY', 'PRIOT', priority);
                        if (featureConfig) {
                            var borderProp = '3px solid ' + featureConfig.configParam.badge.bgColor;
                            element.css('border-left', borderProp);
                        }
                    }
                }
            }
        };
    }

    function focusOnLoad($timeout) {
        //https://stackoverflow.com/questions/36259939/angularjs-input-autofocus-with-ng-if-not-working
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element[0].focus();
                });
            }
        };
    }

    function summernoteEditor($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var htmlContent = attrs.htmlContent;
                var fieldToUpdate = attrs.fieldToUpdate;
                var fieldToUpdateFull = attrs.fieldToUpdateFull;
                $('span.summer-note-error').addClass('hide');
                $(element).html(htmlContent).summernote({
                    height: 100,
                    content: htmlContent,
                    placeholder: '\u02C2' + fieldToUpdateFull + '\u02C3',
                    dialogsInBody: true,
                    dialogsFade: true,  // Add fade effect on dialogs,
                    codeviewIframeFilter: true, // xss protection
                    callbacks: {
                        onChange: function(contents) {
                            scope.editorForm1.$dirty = true;
                            $timeout(function() {
                                if (stripHtml(contents.trim()) === '' && (fieldToUpdate === 'sectionName' || fieldToUpdate === 'questText' || fieldToUpdate === 'hierNodeName' || fieldToUpdate === 'assrtText')) {
                                    $('div.summer-note-error').removeClass('hide');
                                    scope.modal.hasErrors = true;

                                } else {
                                    $('div.summer-note-error').addClass('hide');
                                    scope.modal.hasErrors = false;
                                    scope.editorForm1.$submitted = false;
                                }

                                if (stripHtml(contents.trim()) === '') {
                                    $('div.note-editable').html('');
                                }
                            });
                        },
                        onPaste: function(e) {
                            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                            e.preventDefault();
                            document.execCommand('insertText', false, bufferText);
                        }
                    },
                    toolbar: [
                        ['style', ['bold', 'italic', 'underline', 'clear']],
                        ['insert', ['link']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol']]
                    ]
                });
                $('.dropdown-toggle').dropdown();
            }
        };
    }

    function elementOptLabelSummernoteEditor($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var htmlContent = attrs.htmlContent;
                var fieldToUpdateFull = attrs.fieldToUpdateFull;
                $('span.summer-note-error').addClass('hide');
                $(element).html(htmlContent).summernote({
                    height: 100,
                    content: htmlContent,
                    placeholder: '\u02C2' + fieldToUpdateFull + '\u02C3',
                    dialogsInBody: true,
                    dialogsFade: true,  // Add fade effect on dialogs,
                    codeviewIframeFilter: true, // xss protection
                    callbacks: {
                        onChange: function(contents) {
                            scope.editorForm2.$dirty = true;
                            $timeout(function() {
                                if (stripHtml(contents.trim()) === '') {
                                    $('div.summer-note-error').removeClass('hide');
                                    scope.modal.hasErrors = true;
                                } else {
                                    $('div.summer-note-error').addClass('hide');
                                    scope.modal.hasErrors = false;
                                    scope.editorForm2.$submitted = false;
                                }

                                if (stripHtml(contents.trim()) === '') {
                                    $('div.note-editable').html('');
                                }
                            });
                        },
                        onPaste: function(e) {
                            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                            e.preventDefault();
                            document.execCommand('insertText', false, bufferText);
                        }
                    },

                    toolbar: [
                        ['style', ['bold', 'italic', 'underline', 'clear']],
                        ['insert', ['link']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol']]
                    ]
                });
                $('.dropdown-toggle').dropdown();
            }
        };
    }

    function bcastSideBar(AppService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                setClass(parseInt(attrs.priority, 10));

                function setClass(priority) {
                    if (angular.isNumber(priority) && !isNaN(priority)) {
                        var featureConfig = AppService.featureTierRange('BCAST', 'PRIOT', priority);
                        if (featureConfig) {
                            var borderProp = '3px solid ' + featureConfig.configParam.badge.bgColor;
                            element.css('border-left', borderProp);
                        }
                    }
                }
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('AppCtrl', ['$scope', '$rootScope', '$timeout', '$filter', '$state', '$http', '$sce', '$translate', 'Principal', 'AppService', 'UserService', 'account', 'sysParms', 'properties', 'surveySections', 'allLangSurveys', 'subjStageScores', 'scoreTypes', 'referenceData', 'featureTiers', 'apiUrl', 'userParms', 'userParmTypes', AppCtrl])
        .run(['StateHandler', run]);

    function AppCtrl($scope, $rootScope, $timeout, $filter, $state, $http, $sce, $translate, Principal, AppService, UserService, account, sysParms, properties, surveySections, allLangSurveys, subjStageScores, scoreTypes, referenceData, featureTiers, apiUrl, userParms, userParmTypes) {
        var vm = this;
        $rootScope.userLang = account.data.userPrefs.PREF_LANG;
        $rootScope.userLocale = $rootScope.userLang + '-us';
        $rootScope.account = account.data;
        $rootScope.sysParms = sysParms.data;
        $rootScope.properties = properties.data;
        $rootScope.APPL_SH_NAME = $rootScope.sysParms.APPL_SH_NAME;
        $rootScope.surveySections = surveySections.data;
        $rootScope.allLangSurveys = allLangSurveys.data;
        $rootScope.subjStageScores = subjStageScores.data;
        $rootScope.scoreTypes = scoreTypes.data;
        //sort references
        Object.keys(referenceData.data).forEach(function(key) {
            if (referenceData.data[key].refItems) {
                referenceData.data[key].refItems = $filter('orderBy')(referenceData.data[key].refItems, 'dispSeq');
            }
        });
        $rootScope.referenceData = referenceData.data;
        $rootScope.featureTiers = featureTiers.data;

        // Hardcoded password policy
        $rootScope.passwordPattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*()._-])(?=.{8,})');
        redirect($state.current);

        $rootScope.userParmTypes = userParmTypes.data;
        $rootScope.userParms = userParms.data;

        //process user parms
        vm.selectedUserParm = {};
        vm.selectedUserParmDDcb = {};
        angular.forEach($rootScope.userParmTypes, function(userParmType) {
            if ($rootScope.userParms[userParmType.userParmTypeCd]) {
                if (userParmType.userParmInputTypeCd === 'DDCB') {
                    var opt = $filter('filter')(userParmType.options, {
                        cd: $rootScope.userParms[userParmType.userParmTypeCd].val
                    }, true)[0];
                    vm.selectedUserParmDDcb[userParmType.userParmTypeCd] = {
                        value: opt.cd,
                        nm: opt.nm
                    };
                    //also populate vm.selectedUserParm, so saves if no change
                    vm.selectedUserParm[userParmType.userParmTypeCd] = opt.cd;
                } else if (userParmType.userParmTypeCd === 'DT_RANGE_CD') {
                    vm.selectedUserParm[userParmType.userParmTypeCd] = $rootScope.userParms[userParmType.userParmTypeCd].val.cd;
                } else {
                    vm.selectedUserParm[userParmType.userParmTypeCd] = $rootScope.userParms[userParmType.userParmTypeCd].val;
                }
            }
        });

        var prefDateFormat = $rootScope.account.userPrefs.PREF_DATE_FORMT;
        var fullDateFormat = $rootScope.referenceData.DATE_FORMT_CD.refItems.filter(function(refData) {
            return (refData.cd === prefDateFormat);
        });
        vm.dateFormat = fullDateFormat[0].nm;
        vm.datePlaceholder = vm.dateFormat;
        vm.dateMask = vm.dateFormat.replace('MM', 99).replace('DD', 99).replace('YYYY', 9999);

        vm.onSelectDdcb = function(userParmTypeCd, item) {
            vm.selectedUserParm[userParmTypeCd] = item.cd;
        };

        vm.onDdcbChange = function(userParmTypeCd) {
            $timeout(function() {
                if (vm.selectedUserParmDDcb[userParmTypeCd] === '') {
                    delete vm.selectedUserParm[userParmTypeCd];
                }
            });
        };

        vm.applySettingsDisabled = function() {
            var disable = false;
            angular.forEach($rootScope.userParmTypes, function(userParmType) {
                if (userParmType.userParmInputTypeCd === 'DDCB' && vm.noDdcbItem && vm.noDdcbItem[userParmType.userParmTypeCd] && vm.selectedUserParmDDcb[userParmType.userParmTypeCd] !== '') {
                    disable = true;
                }
                if (userParmType.userParmTypeCd === 'DT_RANGE_CD' && vm.selectedUserParm[userParmType.userParmTypeCd] === 'CUS' && (!vm.asOfFromDateStr || !vm.asOfToDateStr)) {
                    disable = true;
                }
            });
            return disable;
        };

        vm.applySettings = function() {
            var userParms = [];
            angular.forEach($rootScope.userParmTypes, function(userParmType) {
                if (vm.selectedUserParm[userParmType.userParmTypeCd] !== undefined) {
                    var userParm = {
                        userParmTypeCd: userParmType.userParmTypeCd
                    };
                    if (userParmType.userParmTypeCd === 'DT_RANGE_CD') {
                        var val = {
                            cd: vm.selectedUserParm[userParmType.userParmTypeCd]
                        };
                        if (vm.selectedUserParm[userParmType.userParmTypeCd] === 'CUS') {
                            val.asOfFromDate = moment(vm.asOfFromDateStr, vm.dateFormat).format('YYYY-MM-DD');
                            val.asOfToDate = moment(vm.asOfToDateStr, vm.dateFormat).format('YYYY-MM-DD');
                        }
                        userParm.val = JSON.stringify(val);
                    } else {
                        userParm.val = vm.selectedUserParm[userParmType.userParmTypeCd];
                    }
                    userParms.push(userParm);
                }
            });
            $http.post(apiUrl + 'references/userParms', userParms).then(function() {
                location.reload();
            });
        };

        // Checks if the given state is the current state
        $scope.is = function(name) {
            return $state.is(name);
        };

        // Checks if the given state/child states are present
        $scope.includes = function(name) {
            return $state.includes(name);
        };

        removeSubject($state.current);
        removeSurveyEditor($state.current);
        loadSubjEvents();
        loadBcasts();

        //load application help
        (function() {
            $http.get(apiUrl + 'tags/help/' + $rootScope.userLang + '?cacheBuster=' + new Date().getTime(), { dataType: 'jsonp' }).then(function(helpResponse) {
                $rootScope.helpJson = helpResponse.data.help;
            });
        })();

        function setupPageHelp() {
            $rootScope.pageHelp.helpTitle = $rootScope.helpJson.helpTitle;
            $rootScope.pageHelp.overvwTab = $rootScope.helpJson.overvwTab;
            $rootScope.pageHelp.elemsTab = $rootScope.helpJson.elemsTab;
            $rootScope.pageHelp.usageTitle = $rootScope.helpJson.usageTitle;
        }

        $scope.$on('$stateChangeSuccess', function(event, toState) {
            removeSubject(toState);
            removeSurveyEditor(toState);
            loadSubjEvents();
            loadBcasts();

            //application help related code
            if ($rootScope.helpJson === undefined) {
                $http.get(apiUrl + 'tags/help/' + $rootScope.userLang + '?cacheBuster=' + new Date().getTime(), { dataType: 'jsonp' }).then(function(helpResponse) {
                    $rootScope.helpJson = helpResponse.data.help;
                    if ($rootScope.helpJson && $rootScope.helpJson.pages) {
                        $rootScope.pageHelp = $filter('filter')($rootScope.helpJson.pages, { pageRef: toState.name })[0];
                        if ($rootScope.pageHelp !== undefined) {
                            setupPageHelp();
                        }
                    }
                });
            } else {
                $rootScope.pageHelp = $filter('filter')($rootScope.helpJson.pages, { pageRef: toState.name })[0];
                if ($rootScope.pageHelp !== undefined) {
                    setupPageHelp();
                }
            }
            $timeout(function() {
                //slim scroll
                $('#helpScrollArea').slimScroll({
                    height: '320px',
                    railVisible: true
                });
            });

            //application settings related code
            if (toState.name.startsWith('app.portfolio.') || toState.name === 'app.subject.analytics') {
                $rootScope.showUserParmSettings = true;
            } else {
                $rootScope.showUserParmSettings = false;
            }
            vm.settingsIcon = toState.data.icon;
            vm.settingsPageTitle = (toState.data && toState.data.i18n) ? $translate.instant(toState.data.i18n.pageTitle) : '';
            vm.settingsPageParmsInstrText = $translate.instant('settings.home.parmsInstrText');

            //metisMenu manipulation
            $timeout(function() {
                if (angular.element('body').hasClass('mini-navbar')) { // minimized
                    $('ul li ul li ul').css('cssText', 'margin-left: 55px !important; width: max-content !important;');
                } else { //maximized
                    $('ul li ul li ul').css('cssText', 'margin-left: 20px !important;');
                }
            }, 1000);
            redirect(toState);
        });

        $scope.$on('$stateChangeStart', function() {
            var globalHelpContainer = $('#globalHelpContainer')[0];
            var helpTriggerIcon = $('#helpTriggerIcon')[0];
            if ($(globalHelpContainer).hasClass('show')) {
                $(globalHelpContainer).removeClass('show');
                $(helpTriggerIcon).removeClass('show');
            }

            var settingsContainer = $('#settingsContainer')[0];
            var settingsTriggerIcon = $('#settingsTriggerIcon')[0];
            if ($(settingsContainer).hasClass('show')) {
                $(settingsContainer).removeClass('show');
                $(settingsTriggerIcon).removeClass('show');
            }
        });

        function removeSubject(state) {
            if (state.name.indexOf('app.subject') < 0 || state.name === 'app.subjects') {
                $rootScope.subject = null;
                vm.subject = null;
            }
        }

        function removeSurveyEditor(state) {
            if (state.name.indexOf('app.admin.survey') < 0 || state.name === 'app.admin.surveys') {
                $rootScope.surveyEditor = null;
            }
        }

        function loadSubjEvents() {
            if (Principal.isAuthenticated()) {
                $rootScope.subjEvents = UserService.getEvents({});
            }
        }

        function loadBcasts() {
            if (Principal.isAuthenticated()) {
                $rootScope.userBcasts = UserService.getBcasts();
            }
        }

        vm.getHtmlSafeText = function(text) {
            return $sce.trustAsHtml(text);
        };

        function redirect(state) {
            if (state.name === 'app') {
                if (Principal.hasUserPerm('VIEW_PORTFL_DASH') || Principal.hasUserPerm('VIEW_PORTFL_SUBJS') || Principal.hasUserPerm('VIEW_PORTFL_OBSV') || Principal.hasUserPerm('VIEW_PORTFL_SCORE') || Principal.hasUserPerm('VIEW_PORTFL_ANLYTCS') || Principal.hasUserPerm('DOWNLD_PORTFL_REPT')) { // Portfolio Dashboard
                    $state.go('app.portfolio');
                } else { // My Subjects
                    $state.go('app.subjects');
                }
            }
        }
    }

    function run(StateHandler) {
        StateHandler.initialize();
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$httpProvider', '$locationProvider', '$urlMatcherFactoryProvider', '$translateProvider', 'httpRequestInterceptorCacheBusterProvider', 'apiUrl', 'uiMask.ConfigProvider', AppConfig]);

    function AppConfig($httpProvider, $locationProvider, $urlMatcherFactoryProvider, $translateProvider, httpRequestInterceptorCacheBusterProvider, apiUrl, uiMaskConfigProvider) {
        uiMaskConfigProvider.eventsToHandle(['input', 'keyup', 'click', 'focus', 'focusin']);

        $locationProvider.html5Mode({
            enabled: true
        });
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/, /.*i18n.*/], true);

        $httpProvider.interceptors.push('ErrorHandlerInterceptor');
        $httpProvider.interceptors.push('AuthExpiredInterceptor');
        $httpProvider.interceptors.push('AuthInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function(val) {
                return val === true || val === 'true';
            },
            encode: function(val) {
                return val ? 1 : 0;
            },
            equals: function(a, b) {
                return this.is(a) && a === b;
            },
            is: function(val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });

        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: apiUrl + 'tags/i18n/{lang}/{part}?cacheBuster=' + new Date().getTime()
        });
        $translateProvider.useSanitizeValueStrategy('escapeParameters');

        $translateProvider.preferredLanguage('EN');
        $translateProvider.fallbackLanguage('EN');

        toastr.options = {
            closeButton: true,
            progressBar: true,
            onclick: null,
            showDuration: '400',
            timeOut: '3000',
            extendedTimeOut: '2000',
            hideEasing: 'linear'
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(['$stateProvider', routeConfig]);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.admin', {
                url: '/admin',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/admin.html',
                        controller: 'AdminCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['MANG_SYS_ADMIN', 'MANG_ORG_ADMIN'],
                    i18n: {
                        menu: 'menu.sysAdmin.top',
                        pageTitle: 'sysAdmin.home.pageTitle',
                        pageDesc: 'sysAdmin.home.pageDesc'
                    },
                    icon: 'fa-cog',
                    showIconInMenu: true,
                    showInMenu: 'always',
                    menuDispSeq: 4
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('sysAdmin');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.admin.settings', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/settings.html',
                        controller: 'AdminSettingsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['MANG_SYS_ADMIN'],
                    i18n: {
                        menu: 'menu.sysAdmin.settings',
                        pageTitle: 'sysAdmin.mangSettings.pageTitle',
                        pageDesc: 'sysAdmin.mangSettings.pageDesc'
                    },
                    icon: 'fa-th-list',
                    showIconInMenu: true
                },
                resolve: {
                    sysDocs: ['SettingsService', getSysDocs],
                    sysParms: ['SettingsService', getSysParms]
                }
            })
            .state('app.admin.adminOrgs', {
                url: '/orgs',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgs/orgs.html',
                        controller: 'AdminOrgCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.orgs',
                        pageTitle: 'sysAdmin.mangOrgs.pageTitle',
                        pageDesc: 'sysAdmin.mangOrgs.pageDesc',
                        userPermsMsg: 'sysAdmin.mangOrgs.valid.noMangOrgPermsn'
                    },
                    icon: 'fa-building',
                    showIconInMenu: true
                },
                resolve: {
                    orgs: ['OrgService', getOrgs]
                }
            })
            .state('app.admin.adminUsers', {
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/users/users.html',
                        controller: 'AdminUserCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.usrs',
                        pageTitle: 'sysAdmin.mangUsrs.pageTitle',
                        pageDesc: 'sysAdmin.mangUsrs.pageDesc',
                        userPermsMsg: 'sysAdmin.mangUsrs.valid.noMangUsrPermsn'
                    },
                    icon: 'fa-user',
                    showIconInMenu: true
                },
                resolve: {
                    users: ['UserService', getUsers]
                }
            })
            .state('app.admin.adminOrgs.adminAddOrg', {
                url: '/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgs/add.html',
                        controller: 'AdminAddOrgCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    parentOrgId: null
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.addOrg',
                        pageTitle: 'sysAdmin.addOrg.pageTitle',
                        pageDesc: 'sysAdmin.addOrg.pageDesc',
                        userPermsMsg: 'sysAdmin.addOrg.valid.noAddOrgPermsn'
                    },
                    icon: 'fa-building',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    orgs: ['OrgService', getMinOrgs]
                }
            })
            .state('app.admin.adminOrgs.adminEditOrg', {
                url: '/edit/:orgId',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgs/edit.html',
                        controller: 'AdminEditOrgCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.updtOrg',
                        pageTitle: 'sysAdmin.updtOrg.pageTitle',
                        pageDesc: 'sysAdmin.updtOrg.pageDesc',
                        userPermsMsg: 'sysAdmin.updtOrg.valid.noUpdtOrgPermsn'
                    },
                    icon: 'fa-building',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    org: ['OrgService', '$stateParams', getOrg],
                    orgs: ['OrgService', getMinOrgs]
                }
            })
            .state('app.admin.adminUsers.adminAddUser', {
                url: '/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/users/add.html',
                        controller: 'AdminAddUserCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.addUsr',
                        pageTitle: 'sysAdmin.addUsr.pageTitle',
                        pageDesc: 'sysAdmin.addUsr.pageDesc',
                        userPermsMsg: 'sysAdmin.addUsr.valid.noAddUsrPermsn'
                    },
                    icon: 'fa-user',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    users: ['UserService', getUsers],
                    orgs: ['OrgService', getMinOrgs],
                    grantblUserRoles: ['UserService', getGrantblUserRoles]
                }
            })
            .state('app.admin.adminUsers.adminEditUser', {
                url: '/edit?:userId',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/users/edit.html',
                        controller: 'AdminEditUserCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.updtUsr',
                        pageTitle: 'sysAdmin.updtUsr.pageTitle',
                        pageDesc: 'sysAdmin.updtUsr.pageDesc',
                        userPermsMsg: 'sysAdmin.updtUsr.valid.noUpdtUsrPermsn'
                    },
                    icon: 'fa-user',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    user: ['UserService', '$stateParams', getUser],
                    orgs: ['OrgService', getMinOrgs],
                    grantblUserRoles: ['UserService', getGrantblUserRoles],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.admin.adminUsers.adminReplaceUser', {
                url: '/replace?:userId',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/users/replace.html',
                        controller: 'AdminReplaceUserCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.replUsr',
                        pageTitle: 'sysAdmin.replUsr.pageTitle',
                        pageDesc: 'sysAdmin.replUsr.pageDesc',
                        userPermsMsg: 'sysAdmin.replUsr.valid.noReplUsrPermsn'
                    },
                    icon: 'fa-exchange',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    user: ['UserService', '$stateParams', getUser],
                    orgUsers: ['UserService', '$stateParams', getUsersByUserOrg]
                }
            })
            .state('app.admin.document', {
                url: '/docupload',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/upload.html',
                        controller: 'AdminCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.updtUsr',
                        pageTitle: 'sysAdmin.updtUsr.pageTitle',
                        pageDesc: 'sysAdmin.updtUsr.pageDesc'
                    },
                    icon: 'fa-user',
                    showIconInMenu: false,
                    showInMenu: 'active'
                }
            })
            .state('app.admin.adminOrgs.orgconnxns', {
                url: '/:orgId/connxn',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgconnxn/orgconnxn.html',
                        controller: 'AdminOrgConnxnCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.orgConnxns',
                        pageTitle: 'sysAdmin.mangOrgConnxns.pageTitle',
                        pageDesc: 'sysAdmin.mangOrgConnxns.pageDesc',
                        userPermsMsg: 'sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn'
                    },
                    icon: 'fa-link',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    orgconnxns: ['OrgConnxnService', '$stateParams', getAllOrgConnxn]
                }
            })
            .state('app.admin.adminOrgs.orgconnxns.addOrgConnxn', {
                url: '/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgconnxn/add.html',
                        controller: 'AdminAddOrgConnxnCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.addOrgConnxn',
                        pageTitle: 'sysAdmin.addOrgConnxn.pageTitle',
                        pageDesc: 'sysAdmin.addOrgConnxn.pageDesc',
                        userPermsMsg: 'sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn'
                    },
                    icon: 'fa-link',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    org: ['OrgService', '$stateParams', getOrg]
                }
            })
            .state('app.admin.adminOrgs.orgconnxns.editOrgConnxn', {
                url: '/edit/:connxnOrgId?:connecting',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgconnxn/edit.html',
                        controller: 'AdminEditOrgConnxnCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.updtOrgConnxn',
                        pageTitle: 'sysAdmin.updtOrgConnxn.pageTitle',
                        pageDesc: 'sysAdmin.updtOrgConnxn.pageDesc',
                        userPermsMsg: 'sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn'
                    },
                    icon: 'fa-link',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    orgconnxn: ['OrgConnxnService', '$stateParams', getOrgConnxn]
                }
            })
            .state('app.admin.adminOrgs.orgHierarchy', {
                url: '/:orgId/orgHierarchy',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/orgs/orgHierarchy.html',
                        controller: 'OrgHierarchyCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    i18n: {
                        menu: 'menu.sysAdmin.orgHier',
                        pageTitle: 'sysAdmin.mangOrgHier.pageTitle',
                        pageDesc: 'sysAdmin.mangOrgHier.pageDesc'
                    },
                    icon: 'fa-sitemap',
                    showIconInMenu: false,
                    showInMenu: 'active'
                },
                resolve: {
                    baseOrg: ['OrgService', '$stateParams', getOrgWithHierarchy]
                }
            })
            .state('app.admin.surveys', {
                url: '/surveys',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/surveys/author.surveys.html',
                        controller: 'AuthorSurveysCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['MANG_SYS_ADMIN'],
                    i18n: {
                        menu: 'menu.sysAdmin.survs',
                        pageTitle: 'sysAdmin.mangSurvs.pageTitle',
                        pageDesc: 'sysAdmin.mangSurvs.pageDesc',
                        userPermsMsg: 'sysAdmin.mangSurvs.valid.noMangSurvPermsn'
                    },
                    icon: 'fa-edit',
                    showIconInMenu: true,
                    setSubtitle: false,
                    setBreadcrumb: true
                },
                resolve: {
                    surveys: ['$rootScope', 'AuthorSurveysService', getSurveys],
                    langCds: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/LANG_CD');
                    }]
                }
            })
            .state('app.admin.surveys.survey', {
                abstract: true,
                url: '/type/:survTypeCd/version/:survVersSeq/lang/:langCd',
                data: {
                    section: 'survey',
                    userPerms: ['MANG_SYS_ADMIN'],
                    showInMenu: 'never'
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('surv');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app.admin.surveys.survey.section', {
                url: '/section/:survSectSeq',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/surveys/survey/author_survey.html',
                        controller: 'AuthorSurveyCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    userPerms: ['MANG_SYS_ADMIN'],
                    i18n: {
                        pageTitle: 'sysAdmin.mangSurvs.pageTitle',
                        pageDesc: 'sysAdmin.mangSurvs.pageDesc',
                        userPermsMsg: 'sysAdmin.updtSurv.valid.noUpdtSurvPermsn'
                    },
                    showInMenu: true,
                    icon: 'fa-edit',
                    setSubtitle: true,
                    setBreadcrumb: true
                },
                resolve: {
                    survey: ['AuthorSurveysService', '$rootScope', '$stateParams', getSurvey]
                }
/*            })  Remove from menu as delaying implementation of IDMX-647
            .state('app.admin.observations', {
                url: '/observations/:langCd',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/observations/manage.observations.html',
                        controller: 'ManageObservationsCtrl',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    section: 'observations',
                    userPerms: ['MANG_SYS_ADMIN'],
                    i18n: {
                        menu: 'menu.sysAdmin.obsvs',
                        pageTitle: 'obsv.home.pageTitle',
                        pageDesc: 'obsv.home.pageDesc',
                        subjPermsMsg: 'obsv.home.valid.noViewObsvPermsn'
                    },
                    icon: 'fa-flag',
                    showIconInMenu: true
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('obsv');
                        $translatePartialLoader.addPart('surv');
                        return $translate.refresh();
                    }],
                    observations: ['ObservationService', '$stateParams', getAllObservations],
                    langCd: ['$http', 'apiUrl', function($http, apiUrl) {
                        return $http.get(apiUrl + 'references/LANG_CD');
                    }],
                    obsvPriotSeq: ['$http', 'apiUrl', '$stateParams', function($http, apiUrl, $stateParams) {
                        return $http.get(apiUrl + 'references/OBSV_PRIOT_SEQ?languageCd=' + $stateParams.langCd.toUpperCase());
                    }],
                    hierLvl: ['$http', 'apiUrl', '$stateParams', function($http, apiUrl, $stateParams) {
                        return $http.get(apiUrl + 'references/HIER_LVL?languageCd=' + $stateParams.langCd.toUpperCase());
                    }],
                    hierNode: ['$http', 'apiUrl', '$stateParams', function($http, apiUrl, $stateParams) {
                        return $http.get(apiUrl + 'references/HIER_NODE?languageCd=' + $stateParams.langCd.toUpperCase());
                    }],
                    obsvType: ['$http', 'apiUrl', '$stateParams', function($http, apiUrl, $stateParams) {
                        return $http.get(apiUrl + 'references/OBSV_TYPE?languageCd=' + $stateParams.langCd.toUpperCase());
                    }]
                }*/
            });

        function getSurveys($rootScope, AuthorSurveysService) {
            $rootScope.surveyEditor = null;
            return AuthorSurveysService.getSurveys().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSurvey(AuthorSurveysService, $rootScope, $stateParams) {
            var survTypeCd = $stateParams.survTypeCd;
            var survVersSeq = $stateParams.survVersSeq;
            var langCd = $stateParams.langCd;

            if ($rootScope.surveyEditor && $rootScope.surveyEditor.survTypeCd === survTypeCd && $rootScope.surveyEditor.survVersSeq === survVersSeq && $rootScope.surveyEditor.langCd === langCd) {
                return $rootScope.surveyEditor;
            }
            return AuthorSurveysService.getSurvey({
                survVersSeq: $stateParams.survVersSeq,
                survTypeCd: $stateParams.survTypeCd,
                langCd: $stateParams.langCd
            }).$promise.then(function(response) {
                return response;
            }, function(reason) {
                console.log(reason);
            });
        }

        //Remove from menu as delaying implementation of IDMX-647
        /*function getAllObservations(ObservationService, $stateParams) {
            return ObservationService.getAllObservations({
                langCd: $stateParams.langCd.toUpperCase()
            })
                .$promise.then(function(value) {
                    return value;
                }, function(reason) {
                    return reason;
                });
        }*/

        function getUsers(UserService) {
            return UserService.query({}).$promise.then(function(users) {
                return users;
            }, function() {
                $rootScope.simpleToast('Error loading user data...');
            });
        }

        function getUser(UserService, $stateParams) {
            return UserService.getUser({
                userId: $stateParams.userId
            }).$promise.then(function(user) {
                return user;
            }, function(reason) {
                return reason;
            });
        }

        function getUsersByUserOrg(UserService, $stateParams) {
            return UserService.getUsersByUserOrg({
                userId: $stateParams.userId
            }).$promise.then(function(user) {
                return user;
            }, function(reason) {
                return reason;
            });
        }

        function getOrgs(OrgService) {
            return OrgService.getOrgs().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getMinOrgs(OrgService) {
            return OrgService.getOrgs({
                view: 'min'
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getOrgWithHierarchy(OrgService, $stateParams) {
            return OrgService.getOrgWithHierarchy({
                orgId: $stateParams.orgId
            }).$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getGrantblUserRoles(UserService) {
            return UserService.getGrantblUserRoles()
                .$promise.then(function(value) {
                    return value.grantblUserRoleTypes;
                }, function(reason) {
                    return reason;
                });
        }

        function getOrg(OrgService, $stateParams) {
            return OrgService.get({
                orgId: $stateParams.orgId
            }).$promise.then(function(org) {
                return org;
            }, function(reason) {
                return reason;
            });
        }

        function getSysParms(SettingsService) {
            return SettingsService.getSysParms().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getSysDocs(SettingsService) {
            return SettingsService.getAllSysDocs().$promise.then(function(value) {
                return value;
            }, function(reason) {
                return reason;
            });
        }

        function getAllOrgConnxn(OrgConnxnService, $stateParams) {
            return OrgConnxnService.getAll({
                orgId: $stateParams.orgId
            }).$promise.then(function(user) {
                return user;
            }, function(reason) {
                return reason;
            });
        }

        function getOrgConnxn(OrgConnxnService, $stateParams) {
            return OrgConnxnService.get({
                orgId: $stateParams.orgId,
                connxnOrgId: $stateParams.connxnOrgId,
                connecting: $stateParams.connecting
            }).$promise.then(function(user) {
                return user;
            }, function(reason) {
                return reason;
            });
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdminCtrl', ['$rootScope', '$http', 'apiUrl', '$translate', AdminCtrl]);

    function AdminCtrl($rootScope, $http, apiUrl, $translate) {
        var vm = this;
        vm.userLang = $rootScope.userLang.toLowerCase();
        vm.flushCaches = function() {
            $http.get(apiUrl + 'surveys/flushCaches', {
            }).success(function() {
                toastr.success(
                    $translate.instant('sysAdmin.home.toast.flushSysCachesSuccess'),
                    $translate.instant('sysAdmin.home.pageTitle'),
                    toastr.option
                );
            }).error(function() {
                toastr.error(
                    $translate.instant('sysAdmin.home.toast.flushSysCachesError'),
                    $translate.instant('sysAdmin.home.pageTitle'),
                    toastr.options
                );
            });
        };

        vm.reCalcSubjSurv = function() {
            $http.put(apiUrl + 'subjects/recalc?tz=' + Intl.DateTimeFormat().resolvedOptions().timeZone, {
            }).success(function() {
                toastr.success(
                    $translate.instant('sysAdmin.home.toast.reqstRecalcSubjs'),
                    $translate.instant('sysAdmin.home.pageTitle'),
                    toastr.options
                );
                //toastr.success(
                //    $translate.instant('sysAdmin.home.toast.recalcSubjsSuccess'),
                //    $translate.instant('sysAdmin.home.pageTitle'),
                //    toastr.options
                //);
            }).error(function() {
                toastr.error(
                    $translate.instant('sysAdmin.home.toast.recalcSubjsError'),
                    $translate.instant('sysAdmin.home.pageTitle'),
                    toastr.options
                );
            });
        };

    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/app.html","<div id=\"wrapper\" style=\"height: 100vh !important; overflow: hidden;\"><div ng-include=\"\'app/layout/left-nav.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\" style=\"height: 100vh !important; overflow: hidden;\"><div ng-include=\"\'app/layout/header.html\'\"></div><div ng-include=\"\'app/layout/page-title.html\'\"></div><div class=\"row main-view\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"ibox idmx-ibox\"><div ui-view=\"content\"></div></div></div></div></div><div ng-include=\"\'app/layout/footer.html\'\"></div><div ng-include=\"\'app/core/template/confirm-dialog-template.html\'\"></div><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div><div ng-include=\"\'app/core/template/application-help.html\'\"></div><div ng-include=\"\'app/core/template/application-settings.html\'\"></div><div ng-include=\"\'app/core/template/bcast-template.html\'\"></div><div ng-include=\"\'app/core/template/summernote-editor-dialog-template.html\'\"></div><div ng-include=\"\'app/core/template/element-opt-label-editor-dialog-template.html\'\"></div></div></div>");
$templateCache.put("app/admin/admin.html","<div class=\"row\"><div has-any-user-perms=\"[\'MANG_SYS_ADMIN\']\" class=\"col-md-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3 translate=\"sysAdmin.home.settingsCardTitle\"></h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-th-list idmx-heading-icon fa-4x\"></i></div><div class=\"col-md-9\"><p translate=\"sysAdmin.home.settingsCardText\"></p></div></div><div class=\"text-right\"><button ui-sref=\"app.admin.settings\" class=\"btn btn-w-m idmx-link-btn m-t\"><span class=\"ng-scope\" translate=\"sysAdmin.home.mangButton\"></span></button></div></div></div></div><div class=\"col-md-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3 translate=\"sysAdmin.home.orgsCardTitle\"></h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-building idmx-heading-icon fa-4x\"></i></div><div class=\"col-md-9\"><p translate=\"sysAdmin.home.orgsCardText\"></p></div></div><div class=\"text-right\"><button ui-sref=\"app.admin.adminOrgs\" class=\"btn btn-w-m idmx-link-btn m-t\"><span class=\"ng-scope\" translate=\"sysAdmin.home.mangButton\"></span></button></div></div></div></div><div class=\"col-md-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3 translate=\"sysAdmin.home.usrsCardTitle\"></h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-user idmx-heading-icon fa-4x\"></i></div><div class=\"col-md-9\"><p translate=\"sysAdmin.home.usrsCardText\"></p></div></div><div class=\"text-right\"><button ui-sref=\"app.admin.adminUsers\" class=\"btn btn-w-m idmx-link-btn m-t\"><span class=\"ng-scope\" translate=\"sysAdmin.home.mangButton\"></span></button></div></div></div></div><div class=\"col-md-4\" has-any-user-perms=\"[\'MANG_SYS_ADMIN\']\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3 translate=\"sysAdmin.home.survsCardTitle\"></h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-edit idmx-heading-icon fa-4x\"></i></div><div class=\"col-md-9\"><p translate=\"sysAdmin.home.survsCardText\"></p></div></div><div class=\"text-right\"><button ui-sref=\"app.admin.surveys\" class=\"btn btn-w-m idmx-link-btn m-t\"><span class=\"ng-scope\" translate=\"sysAdmin.home.mangButton\"></span></button></div></div></div></div><button has-any-user-perms=\"[\'MANG_SYS_ADMIN\']\" ng-click=\"vm.flushCaches()\" class=\"btn btn-w-m btn-primary m-t\" style=\"margin-left:1%;\" translate=\"sysAdmin.home.flushSysCachesButton\"></button> <button has-any-user-perms=\"[\'MANG_SYS_ADMIN\']\" ng-click=\"vm.reCalcSubjSurv()\" class=\"btn btn-w-m btn-primary m-t\" style=\"margin-left:1%;\" translate=\"sysAdmin.home.recalcSubjsButton\"></button></div>");
$templateCache.put("app/core/403.html","<div class=\"message-error\" translate=\"{{(userPermsMsg) ? userPermsMsg : \'403.valid.noPermsn\'}}\"></div>");
$templateCache.put("app/core/404.html","<div class=\"message-error\" translate=\"404.valid.pageInvld\"></div>");
$templateCache.put("app/layout/footer.html","");
$templateCache.put("app/layout/header.html","<script type=\"text/javascript\">\n    $(document).ready(function () {  \n        $(\'.dropdown-toggle\').dropdown();\n    });  \n</script><div class=\"row border-bottom\" ng-controller=\"HeaderCtrl as vm\" id=\"idmx-page-header\"><nav class=\"navbar navbar-static-top idmx-navbar-header\" role=\"navigation\"><span collapse-side-nav=\"\"></span> <span ng-if=\"vm.showStageNavigation\" class=\"stage-nav\"><span class=\"hidden-xs\" ng-if=\"$root.subject.showPreviousStage\"><span ng-if=\"vm.hasAdvncStagePerm()\"><span ng-if=\"!$root.isSurveyDirty\" class=\"btn idmx-link-btn idmx-header-btn\" type=\"button\" uib-popover=\"{{vm.getPrevStageHelpText()}}\" popover-title=\"{{vm.getPrevStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\" ng-click=\"vm.openConfirmStageDialog(\'returnPreviousStage\')\"><span class=\"glyphicon glyphicon-chevron-left\"></span></span> <span ng-if=\"$root.isSurveyDirty\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.nextStageSaveOrExitText\' | translate}}\" popover-title=\"{{vm.getPrevStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-left\"></span></span></span> <span ng-if=\"!vm.hasAdvncStagePerm()\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.prevStageNoPermText\' | translate}}\" popover-title=\"{{vm.getPrevStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-left\"></span></span></span><button class=\"btn btn-stage\" type=\"button\" ng-click=\"vm.openSubjectStageDialog()\" uib-popover-template=\"\'currentstage-template.html\'\" popover-title=\"{{vm.getCurrStageTitle()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\" style=\"min-width: 140px; margin-top: 14px;\">{{$root.subject.subjStageName}}</button> <span class=\"hidden-xs\" ng-if=\"$root.subject.showNextStage\"><span ng-if=\"vm.hasAdvncStagePerm()\"><span ng-if=\"!$root.subject.advncStageFlag\"><span ng-if=\"(vm.stageAdvncSurvCompltFlag && ($root.subject.survey === undefined || $root.subject.survey.progPct == 100)) || !vm.stageAdvncSurvCompltFlag\"><span ng-if=\"!$root.isSurveyDirty\" class=\"btn idmx-link-btn idmx-header-btn\" type=\"button\" uib-popover=\"{{vm.getNextStageHelpText()}}\" popover-title=\"{{vm.getNextStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\" ng-click=\"vm.openConfirmStageDialog(\'advanceNextStage\', $root.subject.advncStageFlag)\"><span class=\"glyphicon glyphicon-chevron-right\"></span></span> <span ng-if=\"$root.isSurveyDirty\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.nextStageSaveOrExitText\' | translate}}\" popover-title=\"{{vm.getNextStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-right\"></span></span></span><span ng-if=\"vm.stageAdvncSurvCompltFlag && $root.subject.survey.progPct < 100\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.nextStageSurvIncompltText\' | translate}}\" popover-title=\"{{vm.getNextStageHelpTitl()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-right\"></span></span></span><span ng-if=\"$root.subject.advncStageFlag\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.autoAdvncText\' | translate}}\" popover-title=\"{{vm.getNextStageTitle()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-right\"></span></span></span><span ng-if=\"!vm.hasAdvncStagePerm()\" class=\"btn idmx-link-btn idmx-header-btn disabled\" type=\"button\" uib-popover=\"{{\'subj.subjStageNav.help.nextStageNoPermText\' | translate}}\" popover-title=\"{{vm.getNextStageTitle()}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"><span class=\"glyphicon glyphicon-chevron-right\"></span></span></span></span><ul class=\"nav navbar-top-links\" style=\"float: right;\"><li class=\"hidden-xs\" ng-show=\"vm.pageTour && vm.pageTour.pageTourSteps && vm.pageTour.pageTourSteps.length > 0\"><a href=\"#\" ng-click=\"vm.runGuide()\"><i class=\"fa fa-fw fa-question\" style=\"color: #a7b1c2;\"></i></a></li><li class=\"hidden-xs\" ng-show=\"userBcasts.bcasts.length > 0\"><a class=\"dropdown-toggle notification-icon\" data-toggle=\"dropdown\" href=\"#\"><i class=\"fa fa-fw fa-tv\"></i> <span ng-if=\"userBcasts.unviewedBcastCnt\" class=\"badge\" priority-color=\"\" priority=\"{{userBcasts.highestBcastPriot}}\">{{userBcasts.unviewedBcastCnt}}</span></a><ul class=\"dropdown-menu dropdown-alerts\" id=\"bcasts\"><li class=\"link-block\"><span><strong translate=\"subj.bcast.bcastCntText\" translate-values=\"{newBcastCnt: userBcasts.unviewedBcastCnt}\"></strong></span></li><li ng-repeat-end=\"\" class=\"dropdown-divider\"></li><li ng-repeat-start=\"bcast in userBcasts.bcasts | orderBy: \'crtTmstmp\': true\" style=\"color: #212529;\" bcast-side-bar=\"\" priority=\"{{bcast.bcastPriotSeq}}\"><a class=\"dropdown-item\" ng-click=\"vm.openBcast(bcast.bcastId)\" hover-decorate=\"\"><div class=\"row\"><span ng-bind-html=\"bcast.bcastName\" class=\"bold-on-hover\"></span> <span class=\"pull-right text-muted small\">{{bcast.crtTmstmp | mixedDateFormat}}</span> <span><sup class=\"label lbl-negative\" translate=\"subj.bcast.newBcastLabel\" ng-show=\"!bcast.bcastViewed\"></sup></span></div></a></li><li ng-repeat-end=\"\" class=\"dropdown-divider\"></li><li class=\"link-block\"><p><strong translate=\"subj.bcast.bcastInstrText\"></strong></p></li></ul></li><li class=\"hidden-xs\" ng-show=\"subjEvents.events.length > 0\"><a class=\"dropdown-toggle notification-icon\" data-toggle=\"dropdown\" href=\"#\"><i class=\"fa fa-fw fa-bell\"></i> <span ng-if=\"subjEvents.eventCnt\" class=\"badge\" activity-badge=\"\" priority=\"{{subjEvents.highestPriority}}\">{{subjEvents.eventCnt}}</span></a><ul class=\"dropdown-menu dropdown-alerts\" id=\"eventList\"><li class=\"link-block\"><span><strong translate=\"subj.actvty.alertCntText\" translate-values=\"{newEventCnt: subjEvents.eventCnt}\"></strong></span></li><li ng-repeat-end=\"\" class=\"dropdown-divider\"></li><li ng-repeat-start=\"event in subjEvents.events | orderBy: \'crtTmstmp\': true\" style=\"color: #212529;\" activity-side-bar=\"\" priority=\"{{event.eventTypePrioritySeq}}\"><a ui-sref=\"app.subject.summary.activity({id: event.subjId})\" class=\"dropdown-item\" event-pop=\"\" event=\"event\" hover-decorate=\"\"><div class=\"row\"><i class=\"fa fa {{event.featIconName}}\"></i> <span class=\"bold-on-hover\" ng-bind-html=\"event.eventTypeShortText\"></span> <span class=\"pull-right text-muted small\">{{event.crtTmstmp | mixedDateFormat}}</span></div></a></li><li ng-repeat-end=\"\" class=\"dropdown-divider\"></li><li class=\"link-block\"><p><strong translate=\"subj.actvty.alertInstrText\"></strong></p></li></ul></li><li><a class=\"hidden-xs\" ng-click=\"vm.logout()\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i> <span translate=\"menu.header.logout\" class=\"ng-scope\"></span></a> <a class=\"visible-xs\" ng-click=\"vm.logout()\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\" uib-tooltip=\"{{\'menu.header.logout\' | translate}}\" tooltip-placement=\"bottom\"></i></a></li></ul></nav><div ng-include=\"\'app/core/template/subjectstage-dialog-template.html\'\"></div></div><script type=\"text/ng-template\" id=\"currentstage-template.html\"><div>{{vm.getStageById($root.subject.subjStageId).desc}}<br/><br/>{{\'subj.subjStageNav.help.currStageText\' | translate}}</div></script>");
$templateCache.put("app/layout/left-nav-template.html","<li ng-repeat-start=\"menu in menus\" ng-show=\"vm.hasSubjPerms(menu.subjPerms) && vm.hasntSubjPerms(menu.notSubjPerms) && vm.hasAllSubjPerms(menu.allSubjPerms) && vm.hasntAllSubjPerms(menu.allNotSubjPerms) && ({{menu.showMenu}}) && ({{menu.showMenuArrow}}) && vm.hasSubjPerms(menu.showMenuArrowSubjPerms)\" has-any-user-perms=\"{{menu.userPerms}}\" ng-class=\"{\'active\': (menu.sref === $state.current.name || menu.sref === $parentState || menu.sref === $grandParentState)}\" ng-cloak=\"\"><a ng-if=\"menu.menu\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNav()\"><span ng-if=\"!menu.abstract\"><i ng-if=\"menu.icon && menu.showIconInMenu\" class=\"fa {{menu.icon}}\" clickable-parent-menu=\"{{menu.sref}}\"></i> <span class=\"nav-label\" clickable-parent-menu=\"{{menu.sref}}\" translate=\"{{menu.i18n}}\"></span></span> <span ng-if=\"menu.abstract\"><i ng-if=\"menu.icon && menu.showIconInMenu\" class=\"fa {{menu.icon}}\"></i> <span class=\"nav-label\" translate=\"{{menu.i18n}}\"></span></span><span ng-if=\"$root.subject.survey && menu.sref === \'app.subject.survey\'\" survey-percent-badge=\"\" percent=\"{{$root.subject.survey.progPct}}\" class=\"margin-left-5px\">{{$root.subject.survey.progPct}}%</span> <span class=\"fa arrow\"></span></a><ul sref=\"{{menu.sref}}\" left-nav-menu=\"{{menu.children}}\" class=\"nav nav-second-level {{(menu.showMenu && ( menu.sref === $state.current.name || menu.sref === $parentState || menu.sref === $grandParentState || menu.sref === $greatGrandParentState)) ? \'collapse in\' : \'collapse\'}}\" style=\"{{(menu.showMenu && (menu.sref === $parentState || menu.sref === $grandParentState || menu.sref === $greatGrandParentState || menu.sref === $state.current.name)) ? \'height : 100%\' : \'height : 0%\'}}\"></ul></li><li ng-repeat-end=\"\" ng-show=\"vm.hasSubjPerms(menu.subjPerms) && vm.hasntSubjPerms(menu.notSubjPerms) && vm.hasAllSubjPerms(menu.allSubjPerms) && vm.hasntAllSubjPerms(menu.allNotSubjPerms) && ({{menu.showMenu}}) && (!({{menu.showMenuArrow}}) || !vm.hasSubjPerms(menu.showMenuArrowSubjPerms))\" has-any-user-perms=\"{{menu.userPerms}}\" ui-sref-active=\"active\" ng-cloak=\"\"><a ng-if=\"menu.menu && !menu.obsv\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(menu.sref)\"><i ng-if=\"menu.icon && menu.showIconInMenu\" class=\"fa {{menu.icon}}\"></i> <span class=\"nav-label\" translate=\"{{menu.i18n}}\"></span><span ng-if=\"$root.subject.obsv && menu.sref === \'app.subject.observations\'\" obsv-cnt-badge=\"\" obsv-cnt-wgt=\"{{$root.subject.obsv.highestPriority}}\" class=\"margin-left-5px\">{{$root.subject.obsv.cnt}}</span><span ng-if=\"$root.subject.docu && menu.sref === \'app.subject.documents\'\" docu-badge=\"\" docu-cnt=\"{{subject.docu.cnt}}\" docu-wgt=\"{{subject.docu.highestPriority}}\" docu-satsfd=\"{{subject.docu.satsfdCnt}}\" class=\"margin-left-5px\">{{subject.docu.satsfdCnt}}/{{subject.docu.cnt}}</span></a> <a ng-if=\"menu.menu && menu.obsv\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(\'app.admin.observations\', {langCd: menu.langCd}))\"><i ng-if=\"menu.icon && menu.showIconInMenu\" class=\"fa {{menu.icon}}\"></i> <span class=\"nav-label\" translate=\"{{menu.i18n}}\"></span></a> <a ng-if=\"menu.surveySection\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(\'app.subject.survey.section\', {id: $root.subject.subjId, sectionIdx: menu.survSectSeq})\"><span class=\"nav-label\">{{menu.sectName}}</span> <span ng-if=\"$root.subject.survey && $root.subject.survey.sections\" survey-percent-badge=\"\" percent=\"{{($root.subject.survey.sections | filter : {\'seq\': menu.survSectSeq} : true)[0].progPct}}\" class=\"margin-left-5px\">{{($root.subject.survey.sections | filter : {\'seq\': menu.survSectSeq} : true)[0].progPct}}%</span></a> <a ng-if=\"menu.subjStageScore\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(\'app.subject.scoring.type\', {id: $root.subject.subjId, scoreTypeCd: menu.scoreTypeCd})\"><span class=\"nav-label\">{{menu.scoreTypeName}}</span> <span ng-if=\"$root.subject.scores\" score-badge=\"\" score-pct=\"{{($root.subject.scores | filter : {\'scoreTypeCd\': menu.scoreTypeCd} : true)[0].scorePct}}\" class=\"margin-left-5px\">{{($root.subject.scores | filter : {\'scoreTypeCd\': menu.scoreTypeCd} : true)[0].scoreVal | number : ($root.subject.scores | filter : {\'scoreTypeCd\': menu.scoreTypeCd} : true)[0].scoreValDpCnt}}</span></a> <a ng-if=\"menu.pfScore\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(\'app.portfolio.scoring.type\', {scoreTypeCd: menu.scoreTypeCd})\"><span style=\"margin-left: 15px; display: inline-block !important\" class=\"nav-label\">{{menu.scoreTypeName}}</span></a> <a class=\"surv-sect-link\" ng-if=\"menu.surveySectionEditor\" aria-label=\"menu\" ng-click=\"vm.collapseMiniNavAndGo(\'app.admin.surveys.survey.section\', {survTypeCd: menu.survTypeCd, survVersSeq: menu.survVersSeq, langCd: menu.langCd, survSectSeq: menu.survSectSeq})\"><span style=\"margin-left: 15px; display: inline-block !important\" class=\"nav-label\">{{menu.sectName}}</span></a></li>");
$templateCache.put("app/layout/left-nav.html","<nav class=\"navbar-default navbar-static-side idmx-navbar-left\" role=\"navigation\" ng-controller=\"LeftNavCtrl as vm\" style=\"position: fixed;\"><div class=\"sidebar-collapse\" style=\"overflow-x: visible;\"><ul side-navigation=\"\" class=\"nav metismenu dark-bg\" id=\"side-menu\"><li class=\"nav-header idmx-nav-header dark-bg dropdown\"><div class=\"profile-element\"><a ui-sref=\"app\"><img src=\"app/assets/images/logo/2x1_main_inverse.png?bust=1698805291615\" alt=\"logo\" class=\"main-logo\"></a></div><div class=\"logo-element\"><a ui-sref=\"app\"><img src=\"app/assets/images/logo/1x1_main_inverse.png?bust=1698805291615\" alt=\"logo\" class=\"main-logo-collapsed\"></a></div></li><li class=\"nav-header idmx-nav-header-menu dark-bg dropdown\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{account.userFirstLastName}}</strong></span> <span class=\"text-muted text-xs block\">{{account.orgName}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"menu in vm.dropDownMenus\"><a aria-label=\"menu\" ui-sref=\"{{menu.sref}}\" role=\"menuitem\"><i class=\"fa {{menu.icon}}\" aria-hidden=\"true\"></i> &nbsp;&nbsp;&nbsp; <span translate=\"{{menu.i18n}}\" class=\"ng-scope\"></span></a></li><li class=\"divider\"></li><li><a ng-click=\"vm.logout()\" aria-label=\"menu\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i> &nbsp;&nbsp;&nbsp; <span translate=\"menu.header.logout\" class=\"ng-scope\"></span></a></li></ul></div></li></ul><ul side-navigation=\"\" class=\"nav first-lvl scrolled-menu\" id=\"side-menu2\" left-nav-menu=\"{{vm.menus}}\" style=\"height: calc(100vh - 255.2px);\"></ul><div class=\"footer dark-bg copyright\" style=\"border-top: none; text-align: center;\"><div ng-if=\"sysParms.APPL_COPYRT_URL\"><a class=\"copyright-link\" href=\"{{sysParms.APPL_COPYRT_URL}}\" translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: sysParms.APPL_COPYRT}\" target=\"_blank\"></a></div><div ng-if=\"!sysParms.APPL_COPYRT_URL\" translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: sysParms.APPL_COPYRT}\"></div><div><a class=\"copyright-link\" href=\"{{sysParms.APPL_ENGN_BUILT_BY_URL}}\" target=\"_blank\"><span translate=\"menu.header.builtBy\"></span> <span>{{sysParms.APPL_ENGN_BUILT_BY}}</span></a></div><div>v{{properties.appVersion}}</div></div></div></nav><script type=\"text/javascript\">\n    $(function () {\n        setTimeout(function () {\n            $(\'.scrolled-menu\').slimScroll({\n                height: \'calc(100vh - 255.2px)\',\n                railVisible: true\n            });\n        });\n    });\n</script>");
$templateCache.put("app/layout/page-title.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-controller=\"PageTitleCtrl as vm\" id=\"idmx-page-title\" style=\"top: 1px;\"><div class=\"col-lg-9\"><h2><span ng-if=\"vm.icon\"><i class=\"fa {{vm.icon}} idmx-heading-icon\" aria-hidden=\"true\"></i>&nbsp;</span> <span><span translate=\"{{vm.pageTitle}}\" ng-cloak=\"\"></span> <sup><span ng-if=\"vm.setSubtitle && pageSubtitle && pageSubtitleDesc\" class=\"lbl-{{vm.section}} idmx-page-title-label\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{pageSubtitle}}\" uib-popover=\"{{pageSubtitleDesc}}\" ng-cloak=\"\">{{pageSubtitle}}</span> <span ng-if=\"vm.setSubtitle && pageSubtitle && !pageSubtitleDesc\" class=\"lbl-{{vm.section}} idmx-page-title-label\" ng-cloak=\"\">{{pageSubtitle}}</span></sup> <small class=\"hidden-xs\" ng-if=\"vm.pageDesc\" translate=\"{{vm.pageDesc}}\" ng-cloak=\"\"></small></span></h2><div class=\"hidden-xs\"><breadcrumbs ng-cloak=\"\"></breadcrumbs></div></div><div id=\"idletimer_warning_dialog\" class=\"modal\" style=\"display: none;margin-top:12%;\" data-backdrop=\"static\" data-keyboard=\"false\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"modal-title\" translate=\"login.tmOut.modal.tmOutWarnTitle\"></h2></div><div class=\"modal-body\" id=\"modal-body\"><span translate=\"login.tmOut.modal.tmOutWarnText1\"></span> &nbsp; <span id=\"countdownDisplay\" style=\"font-weight:bold\">{{vm.dialogDisplayLimit}}</span> &nbsp; <span translate=\"login.tmOut.modal.tmOutWarnText2\"></span><br><br><b translate=\"login.tmOut.modal.contSessnText\"></b></div><div class=\"modal-footer\"><button id=\"idletimeout-resume\" class=\"btn btn-default\" type=\"button\" data-dismiss=\"modal\" ng-click=\"vm.getPreviousTitle()\" translate=\"login.tmOut.modal.contSessnYesButton\"></button> <button data-style=\"zoom-in\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"vm.logoutReload(\'CTP\');\" translate=\"login.tmOut.modal.contSessnNoButton\"></button></div></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"outer\"><div class=\"middle animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3\"><div class=\"row inner\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{vm.userLang.nm}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"lang in vm.langCds\"><a aria-label=\"menu\" ng-click=\"vm.switchLang(lang.cd)\" role=\"menuitem\"><span class=\"clear\"><span class=\"text-xs\">{{lang.nm}}</span></span></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"font-bold text-center\" style=\"margin-top: 10px\"><span translate=\"login.home.WelcmTitle\"></span></h2><span class=\"hidden-xs\" ng-bind-html=\"vm.getHtmlSafeText(\'login.home.WelcmText\' | translate)\"></span></div></div><div ng-if=\"vm.sysParms.REGST_ENBLD_FLAG === \'TRUE\'\" class=\"row\"><div class=\"col-xs-12\"><span translate=\"login.home.selfRegstrnInstr1Text\"></span> <a ui-sref=\"selfregister\" translate=\"login.home.selfRegstrnLinkText\"></a> <span translate=\"login.home.selfRegstrnInstr2Text\"></span></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=\"ibox-content\" style=\"margin-top: 10px\"><form novalidate=\"\" name=\"login_form\" ng-submit=\"vm.login(login_form)\" class=\"m-t\" role=\"form\"><div ng-if=\"!vm.tfaRequired\" class=\"form-group\" ng-class=\"{\'has-error\': (vm.emailBlured && (login_form.email.$error.required || login_form.email.$error.email)) || invalidHash}\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{\'login.home.emailAddrLabel\' | translate}}\" ng-model=\"vm.user.email\" ng-blur=\"vm.emailBlured = true\" ng-focus=\"vm.emailBlured = false\" required=\"\"> <span class=\"help-block m-b-none\" ng-if=\"invalidHash\"><span translate=\"login.home.valid.usrIdfrHashrNotFound\"></span></span> <span class=\"help-block m-b-none\" ng-messages=\"login_form.email.$error\" multiple=\"\" ng-if=\"vm.emailBlured\"><span ng-message=\"required\" translate=\"login.home.valid.emailAddrReqd\"></span> <span ng-message=\"email\" translate=\"login.home.valid.emailAddrInvld\"></span></span></div><div ng-if=\"!vm.tfaRequired\" class=\"form-group\" ng-class=\"{\'has-error\': vm.passwordBlured && (vm.authenticationError || login_form.password.$error.required)}\"><input name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"{{\'login.home.passwdLabel\' | translate}}\" ng-model=\"vm.user.password\" ng-blur=\"vm.passwordBlured = true\" ng-focus=\"vm.passwordBlured = false\" required=\"\"> <span class=\"help-block m-b-none\" ng-if=\"vm.passwordBlured\" ng-messages=\"login_form.password.$error\"><span ng-message=\"required\" translate=\"login.home.valid.passwdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-if=\"vm.authenticationError\" translate=\"{{vm.errorI18n}}\" translate-values=\"{loginSuspPerd: vm.errorTimeOut, loginSuspLeft:vm.errorTimeOut, msg: vm.errorMsg}\"></span></div><div ng-if=\"vm.tfaRequired\" class=\"form-group\"><span translate=\"login.home.TFAInstrDesc\"></span><div ng-class=\"{\'has-error\': vm.tfaBlured && (vm.authenticationError || login_form.tfaToken.$error.required)}\" style=\"margin-top: 4%\"><input name=\"tfaToken\" type=\"text\" class=\"form-control\" placeholder=\"{{\'login.home.TFATokenLabel\' | translate}}\" ng-model=\"vm.user.tfaToken\" ng-blur=\"vm.tfaBlured = true\" ng-focus=\"vm.tfaBlured = false\" autofocus=\"\" required=\"\"> <span class=\"help-block m-b-none\" ng-if=\"vm.tfaBlured\" ng-messages=\"login_form.tfaToken.$error\"><span ng-message=\"required\" translate=\"login.home.valid.TFATokenReqd\"></span></span> <span class=\"help-block m-b-none\" ng-if=\"vm.authenticationError\" translate=\"{{vm.errorI18n}}\" translate-values=\"{loginSuspPerd: vm.errorTimeOut, msg: vm.errorMsg}\"></span></div></div><div ng-if=\"!vm.tfaRequired\" class=\"form-group\"><div class=\"checkbox checkbox-primary checkbox-inline\"><input name=\"rememberMe\" id=\"rememberMe\" type=\"checkbox\" ng-model=\"vm.user.rememberme\" ng-checked=\"vm.user.rememberme\"> <label for=\"rememberMe\" style=\"padding-left: 5px\"><span translate=\"login.home.rememMeLabel\"></span></label></div>&nbsp; <i class=\"fa fa-info-circle action-navigation-color\" style=\"font-size: 15px; vertical-align:middle\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{\'login.home.rememMeLabel\' | translate}}\" uib-popover=\"{{\'login.home.help.rememMe\' | translate}}\"></i></div><button id=\"btnSubmit\" name=\"btnSubmit\" type=\"submit\" class=\"btn btn-primary block full-width m-b\" ladda=\"vm.submitLadda\" ng-disabled=\"login_form.password.$error.required || (login_form.email.$error.required || login_form.email.$error.pattern) || login_form.tfaToken.$error.required\"><span translate=\"login.home.loginButton\"></span></button><div ng-if=\"!vm.tfaRequired\" class=\"text-center\"><a id=\"frgtPswdLink\" ng-click=\"vm.navToForgotPass()\"><small translate=\"login.home.forgtPasswdLink\"></small></a></div></form></div></div></div><div class=\"row\"><div class=\"col-12\">&nbsp;</div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div class=\"login-logo-container\"><img src=\"app/assets/images/logo/2x1_main.png?bust=1698805291615\" alt=\"login_logo\" class=\"login-logo\"></div></div><div class=\"col-xs-12 col-sm-6 text-center\"><small><span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: vm.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\" translate=\"login.home.tosLink\"></a>.<br>v{{vm.properties.appVersion}}</small></div></div></div></div></div></div></div></div><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div>");
$templateCache.put("app/portfolio/pfDashboard.html","<div class=\"col-xs-12\" style=\"margin-left: -7.5px !important; padding-right: 0px !important\"><div class=\"row\"><div class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_DASH\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><span class=\"label lbl-status pull-right\">{{vm.orgMetrics.orgStatCd}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span><h5><span translate=\"subj.portflDashbrd.orgsMetricTitle\"></span></h5></div><div class=\"ibox-content dash-widget\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{vm.orgMetrics.coveredOrgsCnt}}</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span pf-dashboard-org-coverage-progress=\"\" percent=\"vm.orgsCoverage\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.portflDashbrd.orgsMetricDesc\"></small></div></div><div class=\"date-label\"><span ng-if=\"vm.orgMetrics.lastUpdtTmstmp\">{{vm.orgMetrics.lastUpdtTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!vm.orgMetrics.lastUpdtTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm\" has-any-user-perms=\"[\'MANG_SYS_ADMIN\', \'MANG_ORG_ADMIN\']\" ui-sref=\"app.admin.adminOrgs\"><i class=\"fa fa-plus\"></i></a></div></div></div><div class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_DASH\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><span class=\"label lbl-status pull-right\">{{vm.userMetrics.userStatCd}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span><h5><span translate=\"subj.portflDashbrd.usrsMetricTitle\"></span></h5></div><div class=\"ibox-content dash-widget\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{vm.userMetrics.coveredUsersCnt}}</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span pf-dashboard-user-coverage-progress=\"\" percent=\"vm.usersCoverage\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.portflDashbrd.usrsMetricDesc\"></small></div></div><div class=\"date-label\"><span ng-if=\"vm.userMetrics.lastUpdtTmstmp\">{{vm.userMetrics.lastUpdtTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!vm.userMetrics.lastUpdtTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm\" has-any-user-perms=\"[\'MANG_SYS_ADMIN\', \'MANG_ORG_ADMIN\']\" ui-sref=\"app.admin.adminUsers\"><i class=\"fa fa-plus\"></i></a></div></div></div><div id=\"assessmentStatusMetric\" class=\"col-xs-12 col-lg-6 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_DASH\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><span class=\"label lbl-parms pull-right\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span><h5><span translate=\"subj.portflDashbrd.subjStatMetricTitle\"></span></h5></div><div class=\"ibox-content dash-widget\"><div class=\"row\"><div class=\"col-xs-2 small-left-padding\"><h1 class=\"no-margins custom-metric-h1\">{{vm.subjectStatusMetrics.totalSubjsCnt}}</h1></div><div class=\"col-xs-10\"><div class=\"col-xs-3 small-left-padding\"><h1 class=\"no-margins best-color custom-metric-h1\">{{vm.subjectStatusMetrics.completedCnt}}</h1></div><div class=\"col-xs-3 small-left-padding\"><h1 class=\"no-margins good-color custom-metric-h1\">{{vm.subjectStatusMetrics.inProgressCnt}}</h1></div><div class=\"col-xs-3 small-left-padding\"><h1 class=\"no-margins ok-color custom-metric-h1\">{{vm.subjectStatusMetrics.scheduledCnt}}</h1></div><div class=\"col-xs-3 small-left-padding\"><h1 class=\"no-margins bad-color custom-metric-h1\">{{vm.subjectStatusMetrics.unscheduledCnt}}</h1></div></div></div><div class=\"row\"><div class=\"col-xs-2\"><div class=\"progress progress-mini\" style=\"margin-left: -5px;\"><div class=\"progress-bar progress-bar-default\" role=\"progressbar\" pf-dashboard-subject-status-progress=\"\" ng-model=\"vm.totalPct\"></div></div></div><div class=\"col-xs-10\"><div class=\"progress progress-mini\"><div class=\"progress-bar best-bg\" role=\"progressbar\" pf-dashboard-subject-status-progress=\"\" ng-model=\"vm.completedPct\"></div><div class=\"progress-bar good-bg\" role=\"progressbar\" pf-dashboard-subject-status-progress=\"\" ng-model=\"vm.inProgressPct\"></div><div class=\"progress-bar ok-bg\" role=\"progressbar\" pf-dashboard-subject-status-progress=\"\" ng-model=\"vm.scheduledPct\"></div><div class=\"progress-bar bad-bg\" role=\"progressbar\" pf-dashboard-subject-status-progress=\"\" ng-model=\"vm.unscheduledPct\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-2 small-left-padding\"><small translate=\"subj.portflDashbrd.subjStatMetricTotalDesc\"></small></div><div class=\"col-xs-10\"><div class=\"col-xs-3 small-left-padding\"><small translate=\"subj.portflDashbrd.subjStatMetricCompltDesc\"></small></div><div class=\"col-xs-3 small-left-padding\"><small translate=\"subj.portflDashbrd.subjStatMetricInProgDesc\"></small></div><div class=\"col-xs-3 small-left-padding\"><small translate=\"subj.portflDashbrd.subjStatMetricSchedDesc\"></small></div><div class=\"col-xs-3 small-left-padding\"><small translate=\"subj.portflDashbrd.subjStatMetricUnschedDesc\"></small></div></div></div><div class=\"date-label\"><span ng-if=\"vm.subjectStatusMetrics.lastAccsTmstmp\">{{vm.subjectStatusMetrics.lastAccsTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!vm.subjectStatusMetrics.lastAccsTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"app.portfolio.subjects\"><i class=\"fa fa-plus\"></i></a></div></div></div><div id=\"observationMetric\" class=\"col-xs-12 col-lg-6 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_OBSV\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideObsv($event, \'next\')\" style=\"font-size: 15px;\" data-slide=\"next\" id=\"nextObsv\"><span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span></a><span class=\"label lbl-observations pull-right\" style=\"margin-right: 4px;\">{{vm.obsvTypeName}}</span><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideObsv($event, \'prev\')\" style=\"font-size: 15px;\" data-slide=\"prev\" id=\"prevObsv\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Previous</span></a> <span class=\"label lbl-parms pull-right\" style=\"margin-right: 5px\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span><h5><span translate=\"subj.portflDashbrd.obsvsDistroMetricTitle\"></span></h5></div><div id=\"dash-obsvs\" class=\"carousel slide\" data-interval=\"false\" data-wrap=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item ibox-content zero-bottom-padding zero-top-padding\" ng-class=\"{\'active\': $index === 0}\" index=\"{{$index}}\" ng-repeat=\"obsvDistMetrics in vm.allObsvDistMetrics\"><div ng-if=\"vm.obsvDistChartConfig\"><div><idmx-chart id=\"{{\'obsvDistChart\' + $index}}\" config=\"{{vm.obsvDistChartConfig}}\" data=\"{{vm.obsvDistChartData(obsvDistMetrics)}}\"></idmx-chart></div><a type=\"button\" class=\"btn btn-default btn-sm dash-widget\" ng-click=\"vm.gotoObsvs(obsvDistMetrics.obsvTypeCd)\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></div></div><div class=\"col-xs-12 col-lg-6 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_SCORE\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideScore($event, \'next\')\" style=\"font-size: 15px;\" data-slide=\"next\" id=\"nextScore\"><span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span></a><span class=\"label lbl-scoring pull-right\" style=\"margin-right: 4px;\">{{vm.scoreTypeName}}</span><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideScore($event, \'prev\')\" style=\"font-size: 15px;\" data-slide=\"prev\" id=\"prevScore\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Previous</span></a> <span class=\"label lbl-parms pull-right\" style=\"margin-right: 5px\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span><h5><span translate=\"subj.portflDashbrd.scoreDistroMetricTitle\"></span></h5></div><div id=\"dash-scores\" class=\"carousel slide\" data-interval=\"false\" data-wrap=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item ibox-content zero-bottom-padding zero-top-padding\" ng-class=\"{\'active\': $index === 0}\" index=\"{{$index}}\" ng-repeat=\"scoreDistMetrics in vm.allScoreDistMetrics\"><div ng-if=\"vm.scoreDistChartConfig\"><div><idmx-chart id=\"{{\'scoresDistributionChart\' + $index}}\" config=\"{{vm.scoreDistChartConfig}}\" data=\"{{vm.getScoreDistMetricsData(scoreDistMetrics)}}\"></idmx-chart></div><a type=\"button\" class=\"btn btn-default btn-sm dash-widget\" ui-sref=\"app.portfolio.scoring.type({scoreTypeCd: scoreDistMetrics.scoreTypeCd})\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></div></div><div class=\"col-xs-12 dash-widget-container\" has-any-user-perms=\"[\'VIEW_PORTFL_ACTVTY\']\"><div class=\"ibox\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title\" style=\"text-align: center\"><span class=\"label lbl-parms pull-right\" translate=\"subj.portflDashbrd.usrActvtyLast30DaysLabel\"></span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span> <span class=\"lbl-key pull-right\"><div class=\"color-box\" style=\"background: {{vm.userActivityEventsColour}}\"></div><small translate=\"subj.portflDashbrd.usrActvtyMetricPUEventCntLabel\"></small></span> <span class=\"lbl-key pull-right\"><div class=\"color-box\" style=\"background: {{vm.userActivityUserLoginsColour}}\"></div><small translate=\"subj.portflDashbrd.usrActvtyMetricPULoginCntLabel\"></small></span><h5><span translate=\"subj.portflDashbrd.usrActvtyMetricTitle\"></span></h5></div><div class=\"ibox-content zero-bottom-padding zero-top-padding\"><idmx-chart id=\"userActivityChart\" ng-if=\"vm.userActivityChartConfig\" config=\"{{vm.userActivityChartConfig}}\" data=\"{{vm.userActivityData}}\"></idmx-chart></div></div></div></div></div>");
$templateCache.put("app/portfolio/pfObservations.html","<div class=\"row filter-box\" style=\"background-color: #f3f3f4; margin-left: unset;\"><div class=\"white-bg\" style=\"position: sticky; top: 12px;\"><div class=\"ibox float-e-margins ibox-bottom-margin\"><div class=\"ibox-title scoring-title\"><div class=\"row\" style=\"padding-bottom: 7px; margin-left: -15px;\"><div class=\"col-sm-12\" style=\"padding-left: 0px; padding-right: 0px;\"><div class=\"col-sm-6\" style=\"padding-left: 13px;\"><div style=\"display: flex\"><h4 translate=\"obsv.home.filterLabel\"></h4><div style=\"padding-top: 3px; width: 100%\"><span obsv-cnt-badge=\"\" obsv-cnt-wgt=\"{{vm.getFilterObsvMetrics().highestPriority}}\" class=\"margin-left-5px\">{{vm.getFilterObsvMetrics().cnt}}</span> <span class=\"label lbl-parms pull-right\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span></div></div><oi-select oi-options=\"item.nm group by item.type for (key, item) in vm.filters\" ng-model=\"vm.filterByField\" multiple=\"\" placeholder=\"{{\'obsv.home.allObsvsText\' | translate}}\" list-placeholder=\"{{\'obsv.portflObsvs.valid.noDataFound\' | translate}}\" ng-change=\"vm.applyFilter()\" ng-init=\"vm.filterInit()\"></oi-select></div><div class=\"col-sm-3\" style=\"padding-right: 13px;\"><h4 translate=\"obsv.home.grpLabel\"></h4><select ng-model=\"vm.groupByField\" class=\"form-control pointer\"><option value=\"level2NodeId\">{{vm.lvl2HierLvlName}}</option><option value=\"level3NodeId\">{{vm.lvl3HierLvlName}}</option><option value=\"obsvPrioritySeq\">{{vm.priorityName}}</option><option value=\"typeCd\">{{vm.typeName}}</option></select></div><div class=\"col-sm-3\"><h4 translate=\"obsv.home.sortLabel\"></h4><select ng-model=\"vm.orderByField\" class=\"form-control pointer\"><option value=\"-subjCount\" translate=\"obsv.home.sortCountHLLabel\"></option><option value=\"subjCount\" translate=\"obsv.home.sortCountLHLabel\"></option><option value=\"obsvPrioritySeq\" translate=\"obsv.home.sortPriotHLLabel\"></option><option value=\"-obsvPrioritySeq\" translate=\"obsv.home.sortPriotLHLabel\"></option></select></div></div></div></div></div></div></div><div ng-if=\"vm.observations.totalSubjCnt > 0 && vm.getFilteredObsvs().length === 0\" class=\"message-info col-sm-6 col-sm-offset-3\"><span translate=\"obsv.portflObsvs.valid.noDataFound\"></span></div><div ng-if=\"!vm.observations.totalSubjCnt\" class=\"message-info col-sm-6 col-sm-offset-3\"><span translate=\"obsv.portflObsvs.valid.noSubjsFound\"></span></div><div class=\"grid\" id=\"container\"><span ng-repeat=\"value in vm.getFilteredObsvs() | groupBy:vm.groupByField | toArray:true | orderBy:\'parseInt(value.$key)\' : vm.groupByOrder\" on-finish-render=\"buildMasonryLayout\"><div class=\"grid-item gray-bg\"><div class=\"ibox\"><div class=\"ibox-content\"><h3 ng-class=\"{\'toggleLink collapsed\': vm.getGroup(value.$key, vm.groupByField).desc}\" data-toggle=\"collapse\" data-target=\"#node{{vm.getGroup(value.$key, vm.groupByField).cd}}\">{{vm.getGroup(value.$key, vm.groupByField).nm}}</h3><div ng-show=\"{{vm.getGroup(value.$key, vm.groupByField).desc != null}}\" id=\"node{{vm.getGroup(value.$key, vm.groupByField).cd}}\" class=\"collapse message-help\"><p ng-bind-html=\"vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc)\"></p></div><ul ui-sortable=\"sortableOptions\" class=\"sortable-list connectList agile-list\" ng-model=\"todoList\"><li ng-if=\"value.length\" ng-repeat=\"obsv in value | orderBy:[vm.orderByField , \'obsvId\']\" obsv-side-bar=\"\" obsv-cnt-wgt=\"{{obsv.obsvPrioritySeq}}\"><div><span ng-bind-html=\"obsv.name\"></span> <a class=\"toggleLink collapsed\" data-toggle=\"collapse\" data-target=\"#obsv{{obsv.obsvId}}\"></a></div><div id=\"obsv{{obsv.obsvId}}\" class=\"collapse message-help\" on-hidden-shown=\"buildMasonryLayout\"><p ng-bind-html=\"vm.getHtmlSafeText(obsv.desc)\"></p></div><div class=\"agile-detail\"><a class=\"pull-right btn btn-xs btn-white\"><span>{{obsv.subjCount}} of {{vm.observations.totalSubjCnt}}</span></a> <i class=\"fa fa-flag\"></i> {{obsv.type}}</div><div class=\"progress progress-mini\"><span subj-observation-progress=\"\" percent=\"{{(obsv.subjCount / vm.observations.totalSubjCnt) * 100}}\"></span></div></li></ul></div></div></div></span></div>");
$templateCache.put("app/portfolio/pfScores.html","<div class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a data-target=\"#tab-1\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.portflScore.scoreDistroTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><div class=\"row\"><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><div class=\"ibox-title row\"><div style=\"display: flex\"><h3 style=\"margin-left: 15px; white-space: nowrap\"><span translate=\"score.portflScore.scoreDistro.chartDesc\" translate-values=\"{scoreHierLvlName: vm.getHierLvl().scoreHierLvlName, scoreHierNodeName: vm.filteredHierNode.scoreHierNodeModName}\"></span></h3><div style=\"padding-top: 3px; width: 100%\"><span class=\"label lbl-parms pull-right\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span></div></div></div><div class=\"ibox-content scoring-content\" style=\"padding-left: unset; padding-right: unset; text-align: center;\"><div class=\"ibox ibox-bottom-margin\"><div class=\"ibox-title\" style=\"border: none;\"><div class=\"col-sm-3\"><span translate=\"score.portflScore.scoreDistro.meanScoreLabel\"></span>: {{vm.meanScore}}</div><div class=\"col-sm-3\"><span translate=\"score.portflScore.scoreDistro.medianScoreLabel\"></span>: {{vm.medianScore}}</div><div class=\"col-sm-3\"><span translate=\"score.portflScore.scoreDistro.minScoreLabel\"></span>: {{vm.minScore}}</div><div class=\"col-sm-3\"><span translate=\"score.portflScore.scoreDistro.maxScoreLabel\"></span>: {{vm.maxScore}}</div></div><div class=\"ibox-content\" style=\"text-align: left;\"><idmx-chart id=\"scoresDistributionChart\" ng-if=\"vm.chartConfig && vm.chartData\" config=\"{{vm.chartConfig}}\" data=\"{{vm.chartData}}\"></idmx-chart></div></div></div></div><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><div class=\"ibox margin-bottom-5px float-e-margins\"><div class=\"ibox-content\"><label ng-if=\"vm.hierNodes.length > 0\" class=\"col-sm-3 control-label\" style=\"margin-top: 8px;\" translate=\"score.portflScore.scoreDistro.nodeNameLabel\"></label><div ng-if=\"vm.hierNodes.length > 1\" class=\"col-sm-9\"><select class=\"form-control hier-node-list-width\" ng-model=\"vm.filteredHierNode\" ng-options=\"x.scoreHierNodeModName for x in vm.hierNodes\"><option disabled=\"\" value=\"\" class=\"placeholder-color\" translate=\"score.portflScore.scoreDistro.selectNodeText\"></option></select></div><div ng-if=\"vm.hierNodes.length === 1\" class=\"col-sm-9\" style=\"margin-top: 8px;\" ng-bind-html=\"vm.hierNodes[0].scoreHierNodeModName\"></div><br><br><div class=\"col-lg-12\"><div class=\"scoring-title\"><h3 style=\"font-size: 16px; font-weight: 600; margin-bottom: 10px;\" translate=\"score.home.keyTitle\" translate-values=\"{scoreHierLvlName: vm.filteredScoreHierLvl.scoreHierLvlName}\">{{vm.keyTitle()}}</h3></div><div class=\"level2-score\" style=\"border-left: 5px solid {{vm.filteredHierNode.seriesColor}}\"><label id=\"scoreHierNodeLable\'\" class=\"collapsed\" data-toggle=\"collapse\" data-target=\"\">{{vm.filteredHierNode.scoreHierNodeModName}}</label><div id=\"scoreHierNodeContent\" style=\"padding-bottom: 5px;\" class=\"level2-description collapse in\"><span style=\"text-align: justify; margin-bottom: 5px;\" ng-bind-html=\"vm.filteredHierNode.scoreHierNodeDesc\"></span></div></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/portfolio/pfSubjects.html","<div class=\"ibox-content idmx-ibox-content\" ng-if=\"vm.subjectStatusMetrics.totalSubjsCnt > 0\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\"><div class=\"pull-left\" style=\"margin-top: 10px;\"><span class=\"label lbl-parms pull-right\" ng-click=\"vm.showSettings()\" style=\"margin-left: 5px; margin-right: 5px;\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span></div></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageSubjTab\" class=\"nav nav-tabs\"><li ng-repeat=\"status in vm.subjStatuses\" ng-class=\"{\'active\': $index === 0}\"><a subjs-tab=\"\" data-subj-stat-cd=\"{{status.cd}}\" data-target=\"#tab-{{status.cd}}\" data-toggle=\"tab\" class=\"idmx-tab\" style=\"padding: 10px 20px 10px 25px;\">{{status.lbl}}</a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div ng-repeat=\"status in vm.subjStatuses\" class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-{{status.cd}}\" ng-class=\"{\'active\': $index === 0}\"><div ng-if=\"vm.activeTab === status.cd && status.loaded\"><table id=\"table-{{status.cd}}\" subjects-dt=\"\" data-subj-stat-cd=\"{{status.cd}}\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th>{{vm.targetRoleTypeName}}</th><th translate=\"subj.portflSubjs.subjEffDtHeader\"></th><th translate=\"subj.portflSubjs.stageHeader\"></th><th translate=\"subj.portflSubjs.subjStartDtHeader\"></th><th translate=\"subj.portflSubjs.subjEndDtHeader\"></th><th translate=\"subj.portflSubjs.survNameHeader\"></th><th translate=\"subj.portflSubjs.survStartDtHeader\"></th><th translate=\"subj.portflSubjs.survProgHeader\"></th><th translate=\"subj.portflSubjs.lastAccsHeader\"></th></tr></thead></table></div><div ng-if=\"vm.activeTab === status.cd && !status.loaded\" class=\"row col-xs-6 col-xs-offset-3\"><p>&nbsp;</p><div class=\"message-info\"><span data-translate=\"subj.portflSubjs.dataLoadgText\"></span></div><p>&nbsp;</p></div></div></div></div></div></div></div></div><div ng-if=\"vm.subjectStatusMetrics.totalSubjsCnt === 0\" class=\"row col-xs-6 col-xs-offset-3\"><p>&nbsp;</p><div class=\"message-info\"><span data-translate=\"subj.portflSubjs.valid.noSubjsFound\"></span></div><p>&nbsp;</p></div>");
$templateCache.put("app/profile/profile.html","<style>\n    .popover {\n        max-width: unset !important;\n    }\n</style><div ng-if=\"!vm.isEnabledPersonalInfoForm\" class=\"idmx-row\"><div class=\"col-md-4\"><h2 class=\"no-margins\">{{vm.userProfile.userFirstLastName}}</h2><h4>{{vm.userProfile.orgName}}</h4><small><span class=\"fa fa-map-marker\">&nbsp;</span> <span>{{vm.userProfile.orgCity}}</span> <span ng-if=\"vm.userProfile.orgRegnName\">&nbsp;{{vm.userProfile.orgRegnName}}</span> <span ng-if=\"vm.cntryName\">, {{vm.cntryName[0].nm}}</span></small><div class=\"row col-lg-12\" style=\"margin-top:5px;\"><h4 class=\"col-lg-6 idmx-zero-padded-col\"><b translate=\"login.home.phonNumsTitle\"></b></h4></div><div ng-if=\"!(vm.userProfile.offcPhonCntryCd || vm.userProfile.offcPhonNum || vm.userProfile.moblPhonCntryCd || vm.userProfile.moblPhonNum)\"><div class=\"row form-group\"><span class=\"col-lg-4 control-label small-label text-indent\">N/A</span></div></div><div class=\"row form-group\"><span ng-if=\"vm.userProfile.offcPhonCntryCd || vm.userProfile.offcPhonNum\"><span class=\"col-lg-4 control-label small-label text-indent\" translate=\"login.home.offcLabel\"></span> <span class=\"col-lg-8\" style=\"padding-left:65px;margin:bottom:10px;\"><span ng-if=\"vm.userProfile.offcPhonCntryCd\">(+{{vm.userProfile.offcPhonCntryCd}})</span> {{vm.userProfile.offcPhonNum}}</span></span></div><div class=\"row form-group\"><span ng-if=\"vm.userProfile.moblPhonCntryCd || vm.userProfile.moblPhonNum\"><span class=\"col-lg-4 control-label small-label text-indent\" translate=\"login.home.moblLabel\"></span> <span class=\"col-lg-8\" style=\"padding-left:65px;\"><span ng-if=\"vm.userProfile.moblPhonCntryCd\">(+{{vm.userProfile.moblPhonCntryCd}})</span> {{vm.userProfile.moblPhonNum}}</span></span></div></div><div class=\"col-md-6\"><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.lastLoginLabel\"></span> <span class=\"col-lg-7\" ng-bind=\"vm.userProfile.lastLoginTmstmp | dateFormat\"></span></div><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.subjCntLabel\"></span> <span class=\"col-lg-7\" ng-bind=\"vm.userProfile.totalActiveSubj\"></span></div><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.currSubjLabel\"></span> <span class=\"col-lg-7\" ng-bind=\"vm.currSubj\"></span></div><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.lastAccsLabel\"></span> <span ng-if=\"vm.userProfile.currentSubj && vm.userProfile.currentSubj.lastAccesed\" class=\"col-lg-7\" ng-bind=\"vm.userProfile.currentSubj.lastAccesed | dateFormat\"></span></div><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.sysRoleLabel\"></span> <span class=\"col-lg-7\"><span ng-if=\"vm.systemRoles.length\" class=\"lbl-roles-profile\" ng-repeat=\"role in vm.systemRoles\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-title=\"{{role.nm}}\" uib-popover=\"{{role.desc}}\" popover-placement=\"top\" style=\"margin-right: 5px;\">{{role.nm}}&nbsp;</span> <span ng-if=\"!vm.systemRoles.length\">N/A</span></span></div><div class=\"row form-group\"><span class=\"col-lg-5 control-label small-label text-indent\" translate=\"login.profile.statLabel\"></span> <span class=\"col-lg-7\"><span class=\"lbl-status\" ng-bind=\"vm.statusName(vm.userProfile.userStatCd)[0].nm\"></span></span></div></div><div class=\"col-md-2\"><span class=\"pull-right\"><button id=\"updateUserPrefDet\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.isEnabledPersonalInfoForm = true\" ng-disabled=\"vm.isEnabledUserPrefForm || vm.isEnabledPasswordForm\" translate=\"login.profile.updtPersDetlsButton\"></button></span></div></div><div ng-show=\"vm.isEnabledPersonalInfoForm\" class=\"idmx-row\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(personalInfoForm)\" ng-keydown=\"vm.onKeyDown($event, \'profile-edit-submit-btn\')\" name=\"personalInfoForm\"><div class=\"ibox-content ibox-content-margin\"><h4 class=\"col-lg-12 idmx-zero-padded-col\"><b translate=\"login.home.persDetlsTitle\"></b></h4><div class=\"row form-group\"><label class=\"col-lg-2 control-label small-label text-indent required\" translate=\"login.home.firstNameLabel\" style=\"text-align: left\"></label><div class=\"col-lg-4\"><div class=\"row form-group\" ng-class=\"{\'has-error\': personalInfoForm.userFirstName.$invalid && (personalInfoForm.userFirstName.$dirty || personalInfoForm.$submitted)}\"><input id=\"userFirstName\" name=\"userFirstName\" type=\"text\" class=\"form-control\" ng-model=\"vm.userProfile.userFirstName\" ng-model-options=\"{updateOn: \'blur\'}\" profile-input-focus=\"vm.isEnabledPersonalInfoForm\" profile-input-focus-lost=\"loseFocus()\" required=\"\"> <span ng-if=\"personalInfoForm.userFirstName.$invalid && (personalInfoForm.userFirstName.$dirty || personalInfoForm.$submitted)\" ng-messages=\"personalInfoForm.userFirstName.$error\" class=\"help-block m-b-none\" multiple=\"\"><span ng-message=\"required\" translate=\"login.home.valid.firstNameReqd\"></span></span></div></div><label class=\"col-lg-2 control-label small-label text-indent required\" translate=\"login.home.lastNameLabel\" style=\"text-align: left\"></label><div class=\"col-lg-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': personalInfoForm.userLastName.$invalid && (personalInfoForm.userLastName.$dirty || personalInfoForm.$submitted)}\"><input id=\"userLastName\" name=\"userLastName\" class=\"form-control\" type=\"text\" ng-model=\"vm.userProfile.userLastName\" ng-model-options=\"{updateOn: \'blur\'}\" required=\"\"> <span ng-if=\"personalInfoForm.userLastName.$invalid && (personalInfoForm.userLastName.$dirty || personalInfoForm.$submitted)\" class=\"help-block m-b-none\" ng-messages=\"personalInfoForm.userLastName.$error\" multiple=\"\"><span ng-message=\"required\" translate=\"login.home.valid.lastNameReqd\"></span></span></div></div></div><label class=\"control-label\" translate=\"login.home.phonNumLabel\"></label><div class=\"form-group\"><label class=\"col-lg-2 control-label small-label text-indent\" style=\"text-align: left\" translate=\"login.home.offcLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': (noPhCntry === true || personalInfoForm.phField.$invalid) && (personalInfoForm.phField.$dirty || personalInfoForm.$submitted)}\"><input id=\"phField\" name=\"phField\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.phoneCodeSelected\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onPhoneCodeSelectedCallback()\" typeahead-no-results=\"noPhCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"false\" user-profile-phone-code=\"\"> <span ng-if=\"(noPhCntry === true && personalInfoForm.phField.$viewValue !== \'\') && (personalInfoForm.phField.$dirty || personalInfoForm.$submitted)\" class=\"help-block m-b-none\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: personalInfoForm.phField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': personalInfoForm.offcPhonNum.$invalid && ( personalInfoForm.offcPhonNum.$error.pattern || personalInfoForm.$submitted)}\"><input id=\"offcPhonNum\" name=\"offcPhonNum\" class=\"form-control\" ng-model=\"vm.userProfile.offcPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\"> <span ng-if=\"personalInfoForm.offcPhonNum.$error.pattern || personalInfoForm.$submitted\" class=\"help-block m-b-none\" ng-messages=\"personalInfoForm.offcPhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span></span></div></div><div class=\"form-group\"><label ng-class=\"{\'required\' : vm.twoFactorAuthReq === \'TRUE\' && vm.userProfile.userStatCd !== \'P\'}\" class=\"col-lg-2 control-label small-label text-indent\" style=\"text-align: left\" translate=\"login.home.moblLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': (personalInfoForm.mobileField.$invalid || noCntry === true) && (personalInfoForm.mobileField.$dirty || personalInfoForm.$submitted) || ( personalInfoForm.mobilePhonNum.$error.mobileNumberExists)}\"><input id=\"mobileField\" name=\"mobileField\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.mobileCodeSelected\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-no-results=\"noCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"false\" user-profile-mobile-code=\"\" typeahead-on-select=\"vm.onMobileCodeSelectedCallback()\" ng-blur=\"vm.validateMobileNumber()\" ng-required=\"(vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\')\"> <span ng-if=\"(personalInfoForm.mobileField.$invalid && (personalInfoForm.mobileField.$dirty || personalInfoForm.$submitted))\" ng-messages=\"personalInfoForm.mobileField.$error\" class=\"help-block m-b-none\" multiple=\"\"><span ng-message=\"required\" translate=\"login.home.valid.phonCntryCdReqd\"></span></span> <span ng-if=\"(noCntry === true && personalInfoForm.mobileField.$viewValue !== \'\') && (personalInfoForm.mobileField.$dirty || personalInfoForm.$submitted)\" class=\"help-block m-b-none\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: personalInfoForm.mobileField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': personalInfoForm.mobilePhonNum.$invalid && (personalInfoForm.mobilePhonNum.$dirty || personalInfoForm.mobilePhonNum.$error.pattern || personalInfoForm.$submitted || personalInfoForm.mobilePhonNum.$error.mobileNumberExists), \'required\' : (vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\')}\"><input id=\"mobilePhonNum\" name=\"mobilePhonNum\" class=\"form-control\" ng-model=\"vm.userProfile.moblPhonNum\" ng-model-options=\"{ updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\" ng-blur=\"vm.validateMobileNumber()\" ng-required=\"(vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\')\"> <span ng-if=\"personalInfoForm.mobilePhonNum.$invalid && (personalInfoForm.mobilePhonNum.$dirty || personalInfoForm.mobilePhonNum.$error.pattern || personalInfoForm.$submitted || personalInfoForm.mobilePhonNum.$error.mobileNumberExists)\" class=\"help-block m-b-none\" ng-messages=\"personalInfoForm.mobilePhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span> <span ng-message=\"required\" translate=\"login.home.valid.phonNumReqd\"></span> <span ng-message=\"mobileNumberExists\" translate=\"login.home.valid.moblNumUniq\"></span></span></div></div><div class=\"row form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.resetForm()\" type=\"button\" translate=\"login.home.cancelButton\"></button> <button type=\"submit\" ladda=\"vm.laddaSave\" class=\"btn btn-primary profile-edit-submit-btn\" ng-disabled=\"true\" id=\"submitUserPrefDet\" translate=\"login.home.updtButton\"></button></div></div></div></div></form></div><div class=\"row idmx-row\"><div class=\"col-lg-12\"><div class=\"ibox-content ibox-content-margin\" style=\"margin-top:15px;\"><h4 class=\"col-lg-6 idmx-zero-padded-col\"><b translate=\"login.home.usrDetlsTitle\"></b></h4><div ng-if=\"!vm.isEnabledPasswordForm\" class=\"col-lg-6 idmx-zero-padded-col\" style=\"margin-top:-5px;\"><span class=\"pull-right\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.isEnabledPasswordForm = true\" ng-disabled=\"vm.isEnabledPersonalInfoForm || vm.isEnabledUserPrefForm\" translate=\"login.profile.updtPasswdButton\"></button></span></div><div class=\"row col-lg-12 idmx-zero-padded-col form-group\"><span class=\"col-lg-2 control-label small-label text-indent\" translate=\"login.home.emailAddrLabel\"></span> <span class=\"col-lg-10 padding-left-5px\" ng-bind=\"vm.userProfile.userId\"></span></div><div ng-if=\"!vm.isEnabledPasswordForm\" class=\"row form-group\"><span class=\"col-lg-2 control-label small-label text-indent\" translate=\"login.home.passwdLabel\"></span> <span class=\"col-lg-10 zero-left-padding\">**********</span></div><script type=\"text/ng-template\" id=\"passwd-policy-template.html\"><div class=\"form-group\"> <ul style=\"list-style-type: none; padding-left: 0px;\"> <li ng-repeat=\"(key, value) in vm.rulesList track by key\" ng-bind-html=\"value\"></li> </ul> </div></script><div ng-show=\"vm.isEnabledPasswordForm\" style=\"padding-left:12px;\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submitPasswordForm(passwordForm)\" ng-keydown=\"vm.onKeyDown($event, \'password-edit-submit-btn\')\" name=\"passwordForm\"><div class=\"row form-group\"><div class=\"col-lg-6\" ng-class=\"{\'has-error\': passwordForm.password.$invalid && (passwordForm.password.$dirty || passwordForm.$submitted)}\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" ng-model=\"vm.passwordDto.newPassword\" placeholder=\"{{\'login.home.passwdLabel\' | translate}}\" ng-model-options=\"{updateOn: \'blur\'}\" profile-input-focus=\"vm.isEnabledPasswordForm\" profile-input-focus-lost=\"loseFocus()\" ng-blur=\"vm.validatePassword()\" popover-append-to-body=\"true\" popover-placement=\"center\" popover-trigger=\"focus\" popover-animation=\"true\" popover-title=\"{{\'login.home.help.passwdPolicyTitle\' | translate}}\" uib-popover-template=\"vm.policyPopover.templateUrl\" autocomplete=\"off\" required=\"\" validate-password-policy=\"\"> <span class=\"help-block m-b-none\" ng-show=\"passwordForm.password.$invalid && (passwordForm.password.$dirty || passwordForm.$submitted)\" ng-messages=\"passwordForm.password.$error\"><span ng-message=\"required\" translate=\"login.home.valid.passwdReqd\"></span> <span ng-message=\"samePassword\" translate=\"login.home.valid.passwdDiffReqd\"></span> <span ng-message=\"policy\" translate=\"login.home.valid.passwdPolicyFailed\"></span></span></div><div class=\"col-lg-6\" ng-class=\"{\'has-error\': passwordForm.confirmPassword.$invalid && (passwordForm.confirmPassword.$dirty || passwordForm.$submitted)}\"><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" class=\"form-control\" ng-model=\"vm.confirmPassword\" compare-to=\"passwordForm.password.$viewValue\" placeholder=\"{{\'login.home.confPasswdLabel\' | translate}}\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"false\" ng-blur=\"vm.validateConfirmPassword()\" required=\"\"> <span ng-if=\"passwordForm.confirmPassword.$invalid && (passwordForm.confirmPassword.$dirty || passwordForm.$submitted)\" ng-messages=\"passwordForm.confirmPassword.$error\" class=\"help-block m-b-none\"><span ng-message=\"required\" translate=\"login.home.valid.confPasswdReqd\"></span> <span ng-message=\"compareTo\" translate=\"login.home.valid.passwdMatchReqd\"></span> <span ng-message=\"samePassword\" translate=\"login.home.valid.passwdDiffReqd\"></span></span></div></div><div ng-show=\"vm.isEnabledPasswordForm\" class=\"row form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.resetForm()\" type=\"button\" translate=\"login.home.cancelButton\"></button> <button ladda=\"vm.laddaSave\" ng-disabled=\"passwordForm.$pristine\" class=\"btn btn-primary password-edit-submit-btn\" type=\"submit\" translate=\"login.home.updtButton\"></button></div></div></div></form></div></div></div></div><div class=\"ibox-content ibox-content-margin\" style=\"margin-top:15px;\"><h4 class=\"col-lg-6 idmx-zero-padded-col\"><b translate=\"login.home.usrPrefsTitle\"></b></h4><div ng-if=\"!vm.isEnabledUserPrefForm\" class=\"col-lg-6 idmx-zero-padded-col\" style=\"margin-top:-5px;\"><span class=\"pull-right\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.enableUserPrefForm()\" ng-disabled=\"vm.isEnabledPersonalInfoForm || vm.isEnabledPasswordForm\" id=\"updateUserPrefBtn\" translate=\"login.profile.updtUsrPrefsButton\"></button></span></div><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submitUserPrefForm(userPrefForm)\" name=\"userPrefForm\"><div class=\"row form-group\" ng-repeat=\"upt in vm.userPrefTypes | orderBy:\'dispSeq\'\"><div class=\"col-lg-12 idmx-zero-padded-col\" style=\"margin-top:-5px\"><span class=\"col-lg-2 control-label small-label text-indent\" style=\"text-align: left\">{{upt.nm}}</span><div class=\"col-lg-10 zero-left-padding\"><div ng-repeat=\"(ob, items) in vm.references\"><span ng-if=\"ob === upt.entity.lkupTablCd\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"up in items.refItems | orderBy:\'dispSeq\'\"><input name=\"{{upt.cd}}\" profile-pref-radio=\"\" icheck=\"\" type=\"radio\" ng-checked=\"up.cd === upt.entity.defaultUserPrefCd\" ng-model=\"vm.userProfile.userPrefs[upt.cd]\" ng-value=\"up.cd\" ng-disabled=\"!vm.isEnabledUserPrefForm\" profile-input-focus=\"vm.isEnabledUserPrefForm\" profile-input-focus-lost=\"loseFocus()\"> <label><span class=\"small-label\">{{up.nm}}</span></label></div></span></div></div></div></div><div ng-show=\"vm.isEnabledUserPrefForm\" class=\"row form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.resetForm()\" type=\"button\" translate=\"login.home.cancelButton\"></button> <button id=\"submitUserPref\" ladda=\"vm.laddaSave\" ng-disabled=\"true\" class=\"btn btn-primary userPref-edit-submit-btn\" type=\"submit\" translate=\"login.home.updtButton\"></button></div></div></div></form></div>");
$templateCache.put("app/register/forgot-password.html","<div class=\"outer\"><div class=\"middle animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 col-md-6 col-lg-4 col-sm-offset-2 col-md-offset-3 col-lg-offset-4\"><div class=\"row inner\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{vm.userLang.nm}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"lang in vm.langCds\"><a aria-label=\"menu\" ng-click=\"vm.switchLang(lang.cd)\" role=\"menuitem\"><span class=\"clear\"><span class=\"text-xs\">{{lang.nm}}</span></span></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"font-bold\" style=\"margin-top: 0px;\"><span translate=\"login.forgtPasswd.instrTitle\"></span></h2><p><span translate=\"login.forgtPasswd.instrDesc\"></span></p></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox-content\"><form name=\"forgotPassForm\" novalidate=\"\" class=\"m-t\" role=\"form\" ng-keydown=\"vm.submitViaEnterKey($event,forgotPassForm)\"><div class=\"alert alert-danger\" ng-if=\"vm.authenticationError\" translate=\"{{vm.errorI18n}}\" translate-values=\"{msg: vm.errorMsg}\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': (forgotPassForm.email.$error.required || forgotPassForm.email.$invalid || forgotPassForm.email.$error.email || vm.authenticationError) && (forgotPassForm.email.$dirty || forgotPassForm.$submitted)}\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{\'login.home.emailAddrLabel\' | translate}}\" ng-model=\"vm.email\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" autofocus=\"\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(forgotPassForm.email.$error.required || forgotPassForm.email.$invalid || forgotPassForm.email.$error.email) && (forgotPassForm.email.$dirty || forgotPassForm.$submitted)\" ng-messages=\"forgotPassForm.email.$error\"><span ng-message=\"required\" ng-if=\"forgotPassForm.email.$error.required\" translate=\"login.home.valid.emailAddrReqd\"></span> <span ng-message=\"email\" ng-if=\"forgotPassForm.email.$error.email\" translate=\"login.home.valid.emailAddrInvld\"></span></span></div><button id=\"resetPswd\" type=\"submit\" class=\"btn btn-primary block full-width m-b add-reset-btn\" ng-click=\"vm.passwordReset(forgotPassForm)\" ladda=\"vm.resetLadda\" disabled=\"\"><span translate=\"login.forgtPasswd.sendPasswdResetEmailButton\"></span></button><div class=\"text-center\"><a ng-click=\"vm.navToLogin()\"><small translate=\"login.home.loginLink\"></small></a></div></form></div></div></div><div class=\"row\" style=\"margin-top: 10px\"><div class=\"col-xs-12 text-center\"><small><span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: vm.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\" translate=\"login.home.tosLink\"></a>.<br>v{{vm.properties.appVersion}}</small></div></div></div></div></div></div></div></div><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div>");
$templateCache.put("app/register/register.html","<style>\n    .popover {\n        max-width: unset !important;\n    }\n</style><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(registerForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"registerForm\"><div ng-if=\"vm.user.userId && !vm.user.passwordSet\" class=\"outer\"><div class=\"animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2\"><div class=\"row inner\" style=\"height: 100vh; overflow-y: auto;\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{vm.userLang.nm}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"lang in vm.langCds\"><a aria-label=\"menu\" ng-click=\"vm.user.userPrefs.PREF_LANG = lang.cd\" role=\"menuitem\"><span class=\"clear\"><span class=\"text-xs\">{{lang.nm}}</span></span></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-9\"><h2 class=\"font-bold\" style=\"margin-top: 10px\"><span translate=\"login.compltRegstrn.instrTitle\"></span></h2><p><span translate=\"login.compltRegstrn.instrDesc\"></span></p></div><div class=\"col-xs-12 col-sm-3\"><div class=\"hidden-xs text-right\"><img src=\"app/assets/images/logo/2x1_main.png?bust=1698805291615\" alt=\"registration_logo\" class=\"login-logo\" style=\"max-width: 100%; height: auto !important\"></div><div class=\"visible-xs text-center\"><img src=\"app/assets/images/logo/2x1_main.png?bust=1698805291615\" alt=\"registration_logo\" class=\"login-logo\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox-content\" style=\"margin-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><h4><b><span translate=\"login.home.persDetlsTitle\"></span></b></h4></div></div><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': registerForm.firstName.$invalid && registerForm.$submitted}\"><div><input name=\"firstName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.userFirstName\" ng-model-options=\"{updateOn: \'blur\'}\" autofocus=\"\" id=\"firstName\" placeholder=\"{{\'login.home.firstNameLabel\' | translate}}\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.firstName.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.firstName.$error\"><span ng-message=\"required\" translate=\"login.home.valid.firstNameReqd\"></span></span></div></div><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': registerForm.lastName.$invalid && registerForm.$submitted}\"><div><input name=\"lastName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.userLastName\" ng-model-options=\"{updateOn: \'blur\'}\" placeholder=\"{{\'login.home.lastNameLabel\' | translate}}\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.lastName.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.lastName.$error\"><span ng-message=\"required\" translate=\"login.home.valid.lastNameReqd\"></span></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><span class=\"control-label small-label\"><span translate=\"login.home.phonNumsTitle\"></span></span></div></div><div class=\"row form-group\"><span class=\"col-xs-12 col-sm-2 control-label small-label text-indent\" style=\"text-align : left;\" translate=\"login.home.offcLabel\"></span><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': noOffcPhonCntryCd || (registerForm.offcPhonCntryCd.$invalid && registerForm.$submitted)}\"><input id=\"offcPhonCntryCd\" name=\"offcPhonCntryCd\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.offcPhonCntryCd\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onOffcPhonCntryCdSelected($item)\" typeahead-no-results=\"noOffcPhonCntryCd\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" ng-change=\"vm.onOffcPhonCntryCdChange()\" ng-required=\"vm.user.offcPhonNum\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"registerForm.offcPhonCntryCd.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.offcPhonCntryCd.$error\"><span ng-message=\"required\" translate=\"login.home.valid.phonCntryCdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"noOffcPhonCntryCd\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: registerForm.offcPhonCntryCd.$viewValue}\"></span></span></div><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': registerForm.offcPhonNum.$invalid && (registerForm.offcPhonNum.$error.pattern || registerForm.$submitted), \'required\' : vm.user.offcPhonCntryCd}\"><input id=\"offcPhonNum\" name=\"offcPhonNum\" class=\"form-control\" ng-model=\"vm.user.offcPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\" ng-required=\"vm.user.offcPhonCntryCd\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.offcPhonNum.$invalid && (registerForm.offcPhonNum.$error.pattern || registerForm.$submitted)\" ng-messages=\"registerForm.offcPhonNum.$error\"><span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span> <span ng-message=\"required\" translate=\"login.home.valid.phonNumReqd\"></span></span></div></div><div class=\"form-group\"><span class=\"col-xs-12 col-sm-2 control-label small-label text-indent\" style=\"text-align : left;\" ng-class=\"{\'required\' : vm.twoFactorAuthReq === \'TRUE\'}\" translate=\"login.home.moblLabel\"></span><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': noMoblPhonCntryCd || (registerForm.moblPhonCntryCd.$invalid && registerForm.$submitted)}\"><input id=\"moblPhonCntryCd\" name=\"moblPhonCntryCd\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.moblPhonCntryCd\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onMoblPhonCntryCdSelected($item)\" typeahead-no-results=\"noMoblPhonCntryCd\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" ng-change=\"vm.onMoblPhonCntryCdChange()\" ng-required=\"vm.twoFactorAuthReq === \'TRUE\' || vm.user.moblPhonNum\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"registerForm.moblPhonCntryCd.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.moblPhonCntryCd.$error\"><span ng-message=\"required\" translate=\"login.home.valid.phonCntryCdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"noMoblPhonCntryCd\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: registerForm.moblPhonCntryCd.$viewValue}\"></span></span></div><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': (registerForm.moblPhonNum.$invalid && registerForm.$submitted) || (registerForm.moblPhonNum.$dirty && (registerForm.moblPhonNum.$error.pattern || registerForm.moblPhonNum.$error.invalidPhoneNumber))}\"><input id=\"moblPhonNum\" name=\"moblPhonNum\" class=\"form-control\" ng-model=\"vm.user.moblPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\" ng-change=\"vm.validateMobileNumber();\" ng-required=\"vm.twoFactorAuthReq === \'TRUE\' || vm.user.moblPhonCntryCd\"> <span class=\"help-block m-b-none\" ng-show=\"(registerForm.moblPhonNum.$invalid && registerForm.$submitted) || (registerForm.moblPhonNum.$dirty && (registerForm.moblPhonNum.$error.pattern || registerForm.moblPhonNum.$error.invalidPhoneNumber))\" ng-messages=\"registerForm.moblPhonNum.$error\"><span ng-message=\"required\" ng-if=\"registerForm.$submitted\" translate=\"login.home.valid.phonNumReqd\"></span> <span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span> <span ng-message=\"invalidPhoneNumber\" translate=\"login.home.valid.moblNumUniq\"></span></span></div></div></div><div class=\"hidden-xs ibox-content\" style=\"margin-bottom: 10px; padding: 15px; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><div style=\"display: flex\"><h4><b><span translate=\"login.home.orgDetlsTitle\"></span></b></h4><div style=\"margin-top: 4px;\">&nbsp;- {{vm.user.orgName}}{{vm.user.orgRefNum ? \' (Ref. Num. \' + vm.user.orgRefNum + \')\' : \'\'}}</div></div></div></div><div class=\"form-group\"><span class=\"col-xs-12 col-sm-2 control-label small-label text-indent required\" style=\"text-align: left\" translate=\"login.home.orgRolesLabel\"></span><div class=\"col-xs-12 col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"role in vm.orgRoleTypes | orderBy:\'dispSeq\'\" ng-if=\"role.entity.subjBasedOrgRoleFlag === true\"><input icheck=\"\" type=\"checkbox\" ng-checked=\"vm.orgHasRole(role.cd)\" disabled=\"\" ng-model=\"orgRole\"> <label class=\"lbl-roles-container\" for=\"{{role.cd}}\"><span class=\"lbl-roles label-success label-success-disabled\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{role.nm}}\" uib-popover=\"{{role.desc}}\">{{role.nm}}</span></label></div></div></div></div><div class=\"ibox-content\" style=\"margin-bottom: 10px; padding: 15px; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><div style=\"display: flex\"><h4><b><span translate=\"login.home.usrDetlsTitle\"></span></b></h4><div style=\"margin: 3px;\">&nbsp;- {{vm.user.userId}}</div></div></div></div><script type=\"text/ng-template\" id=\"passwd-policy-template.html\"><div class=\"form-group\"> <ul style=\"list-style-type: none; padding-left: 0px;\"> <li ng-repeat=\"(key, value) in vm.rulesList track by key\" ng-bind-html=\"value\"></li> </ul> </div></script><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': (registerForm.password.$invalid && registerForm.$submitted) || (registerForm.password.$dirty && registerForm.password.$error.policy)}\"><div><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" ng-model-options=\"{ updateOn: \'blur\' }\" placeholder=\"{{\'login.home.passwdLabel\' | translate}}\" autocomplete=\"off\" popover-append-to-body=\"true\" popover-placement=\"center\" popover-trigger=\"focus\" popover-animation=\"true\" popover-title=\"Password Policy\" uib-popover-template=\"vm.policyPopover.templateUrl\" required=\"\" self-register-validate-password-policy=\"\"></div><span class=\"help-block m-b-none\" ng-show=\"(registerForm.password.$invalid && registerForm.$submitted) || (registerForm.password.$dirty && registerForm.password.$error.policy)\" ng-messages=\"registerForm.password.$error\"><span ng-message=\"required\" translate=\"login.home.valid.passwdReqd\"></span> <span ng-message=\"policy\" translate=\"login.home.valid.passwdPolicyFailed\"></span></span></div><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': (registerForm.confirmPassword.$invalid && registerForm.$submitted) || (registerForm.confirmPassword.$viewValue && registerForm.confirmPassword.$dirty && registerForm.confirmPassword.$error.compareTo)}\"><div><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" class=\"form-control\" ng-model=\"vm.confirmPassword\" ng-model-options=\"{ updateOn: \'blur\' }\" compare-to=\"registerForm.password.$viewValue\" placeholder=\"{{\'login.home.confPasswdLabel\' | translate}}\" autocomplete=\"off\" required=\"\"></div><span class=\"help-block m-b-none\" ng-show=\"(registerForm.confirmPassword.$invalid && registerForm.$submitted) || (registerForm.confirmPassword.$viewValue && registerForm.confirmPassword.$dirty && registerForm.confirmPassword.$error.compareTo)\" ng-messages=\"registerForm.confirmPassword.$error\"><span ng-message=\"required\" translate=\"login.home.valid.confPasswdReqd\"></span> <span ng-message=\"compareTo\" translate=\"login.home.valid.passwdMatchReqd\"></span></span></div></div></div><div class=\"ibox-content\" style=\"margin-bottom: 10px; padding: 15px; padding-bottom: 10px;\"><div ng-if=\"vm.userPrefTypesToShow().length > 0\" class=\"row\"><div class=\"col-xs-12\"><h4><b><span translate=\"login.home.usrPrefsTitle\"></span></b></h4></div></div><div ng-if=\"vm.userPrefTypesToShow().length > 0\" class=\"row form-group\" ng-repeat=\"userPrefType in vm.userPrefTypesToShow() | orderBy:\'dispSeq\'\"><div class=\"col-xs-12 col-sm-3\"><label class=\"control-label small-label text-indent required\" style=\"text-align: left;\">{{userPrefType.nm}}</label></div><div class=\"col-xs-12 col-sm-9\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"userPrefTypeItem in vm.references[userPrefType.entity.lkupTablCd].refItems | orderBy:\'dispSeq\'\"><input register-pref-radio=\"\" icheck=\"\" type=\"radio\" name=\"{{userPrefType.cd}}\" ng-model=\"vm.user.userPrefs[userPrefType.cd]\" ng-value=\"userPrefTypeItem.cd\" required=\"\"> <label><span class=\"small-label\">{{userPrefTypeItem.nm}}</span></label></div></div></div><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-6\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.terms\" ng-change=\"vm.tosVisited()\" required=\"\"> &nbsp; <span translate=\"login.compltRegstrn.tosAgrmtText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\"><span translate=\"login.home.tosLink\"></span></a><div ng-class=\"{\'has-error\': !vm.terms && registerForm.$submitted}\"><span class=\"help-block m-b-none\" ng-show=\"!vm.terms && registerForm.$submitted\" style=\"color: #ED5565\" translate=\"login.compltRegstrn.tosAgrmtReqd\"></span></div></div><div class=\"col-xs-12 col-sm-6 text-right\"><a class=\"btn btn-white\" href=\"/login\" translate=\"login.home.cancelButton\"></a> <button class=\"btn btn-primary register-submit-btn\" id=\"registerBtn\" type=\"submit\" ng-disabled=\"true\" translate=\"login.compltRegstrn.regstrButton\"></button></div></div></div></div></div><div class=\"row\" style=\"margin-top: 10px\"><div class=\"col-xs-12 text-center\"><small><span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: vm.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <a ng-click=\"vm.openTosDialogBox()\" translate=\"login.home.tosLink\"></a>.<br>v{{vm.properties.appVersion}}</small></div></div></div></div></div></div></div></div></form><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div>");
$templateCache.put("app/register/reset-password.html","<style>\n    .popover {\n        max-width: unset !important;\n    }\n</style><div class=\"outer\"><div class=\"middle animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 col-md-6 col-lg-4 col-sm-offset-2 col-md-offset-3 col-lg-offset-4\"><div class=\"row inner\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{vm.userLang.nm}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"lang in vm.langCds\"><a aria-label=\"menu\" ng-click=\"vm.switchLang(lang.cd)\" role=\"menuitem\"><span class=\"clear\"><span class=\"text-xs\">{{lang.nm}}</span></span></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"font-bold\" style=\"margin-top: 0px;\"><span translate=\"login.resetPasswd.instrTitle\"></span></h2><p><span translate=\"login.resetPasswd.instrDesc\"></span></p></div></div><div class=\"row\"><script type=\"text/ng-template\" id=\"passwd-policy-template.html\"><div class=\"form-group\"> <ul style=\"list-style-type: none; padding-left: 0px;\"> <li ng-repeat=\"(key, value) in vm.rulesList track by key\" ng-bind-html=\"value\"></li> </ul> </div></script><div class=\"col-xs-12\"><div class=\"ibox-content\"><form name=\"resetForm\" novalidate=\"\" class=\"m-t\" ng-submit=\"vm.passwordReset(resetForm)\" ng-keydown=\"vm.submitViaEnterKey($event,resetForm)\"><div class=\"alert alert-danger\" ng-if=\"vm.authenticationError\" translate=\"{{vm.errorI18n}}\"></div><div class=\"col-lg-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': resetForm.password.$invalid && (resetForm.password.$dirty || resetForm.$submitted)}\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"{{\'login.home.passwdLabel\' | translate}}\" ng-model=\"vm.password\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" popover-append-to-body=\"true\" popover-placement=\"center\" popover-trigger=\"focus\" popover-animation=\"true\" popover-title=\"Password Policy\" uib-popover-template=\"vm.policyPopover.templateUrl\" required=\"\" validate-password-policy=\"\"> <span class=\"help-block m-b-none\" ng-show=\"resetForm.password.$invalid && (resetForm.password.$dirty || resetForm.$submitted)\" ng-messages=\"resetForm.password.$error\"><span ng-message=\"required\" translate=\"login.home.valid.passwdReqd\"></span> <span ng-message=\"policy\" translate=\"login.home.valid.passwdPolicyFailed\"></span></span></div></div><div class=\"col-lg-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': resetForm.confirmPassword.$invalid && (resetForm.confirmPassword.$dirty || resetForm.$submitted)}\"><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" class=\"form-control\" placeholder=\"{{\'login.home.confPasswdLabel\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-model-options=\"{ updateOn: \'blur\' }\" compare-to=\"resetForm.password.$viewValue\" autocomplete=\"off\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"resetForm.confirmPassword.$invalid && (resetForm.confirmPassword.$dirty || resetForm.$submitted)\" ng-messages=\"resetForm.confirmPassword.$error\"><span ng-message=\"required\" translate=\"login.home.valid.confPasswdReqd\"></span> <span ng-message=\"compareTo\" translate=\"login.home.valid.passwdMatchReqd\"></span></span></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b reset-btn\" ng-click=\"vm.passwordReset\" disabled=\"\"><span translate=\"login.resetPasswd.resetButton\"></span></button><div class=\"text-center\"><a ng-click=\"vm.navToLogin()\"><small translate=\"login.home.loginButton\"></small></a></div></form></div></div></div><div class=\"row\" style=\"margin-top: 10px\"><div class=\"col-xs-12 text-center\"><small><span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: vm.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\" translate=\"login.home.tosLink\"></a>.<br>v{{vm.properties.appVersion}}</small></div></div></div></div></div></div></div></div><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div>");
$templateCache.put("app/register/self-register.html","<style>\n    .popover {\n        max-width: unset !important;\n    }\n</style><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(registerForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"registerForm\"><div class=\"outer\"><div class=\"animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2\"><div class=\"row inner\" style=\"height: 100vh; overflow-y: auto;\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"><div class=\"profile-element idmx-profile-menu-container\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"><span class=\"clear\"><i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{vm.userLang.nm}}&nbsp;<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"lang in vm.langCds\"><a aria-label=\"menu\" ng-click=\"vm.user.userPrefs.PREF_LANG = lang.cd\" role=\"menuitem\"><span class=\"clear\"><span class=\"text-xs\">{{lang.nm}}</span></span></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-9\"><h2 class=\"font-bold\" style=\"margin-top: 10px\"><span translate=\"login.selfRegstrn.instrTitle\"></span></h2><p><span translate=\"login.selfRegstrn.instrDesc\"></span></p></div><div class=\"col-xs-12 col-sm-3\"><div class=\"hidden-xs text-right\"><img src=\"app/assets/images/logo/2x1_main.png?bust=1698805291615\" alt=\"registration_logo\" class=\"login-logo\" style=\"max-width: 100%; height: auto !important\"></div><div class=\"visible-xs text-center\"><img src=\"app/assets/images/logo/2x1_main.png?bust=1698805291615\" alt=\"registration_logo\" class=\"login-logo\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox-content\" style=\"margin-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><h4><b><span translate=\"login.home.persDetlsTitle\"></span></b></h4></div></div><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': registerForm.firstName.$invalid && registerForm.$submitted}\"><div><input name=\"firstName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.userFirstName\" ng-model-options=\"{updateOn: \'blur\'}\" autofocus=\"\" id=\"firstName\" placeholder=\"{{\'login.home.firstNameLabel\' | translate}}\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.firstName.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.firstName.$error\"><span ng-message=\"required\" translate=\"login.home.valid.firstNameReqd\"></span></span></div></div><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': registerForm.lastName.$invalid && registerForm.$submitted}\"><div><input name=\"lastName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.userLastName\" ng-model-options=\"{updateOn: \'blur\'}\" placeholder=\"{{\'login.home.lastNameLabel\' | translate}}\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.lastName.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.lastName.$error\"><span ng-message=\"required\" translate=\"login.home.valid.lastNameReqd\"></span></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><span class=\"control-label small-label\"><span translate=\"login.home.phonNumsTitle\"></span></span></div></div><div class=\"row form-group\"><span class=\"col-xs-12 col-sm-2 control-label small-label text-indent\" style=\"text-align : left;\" translate=\"login.home.offcLabel\"></span><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': noOffcPhonCntryCd || (registerForm.offcPhonCntryCd.$invalid && registerForm.$submitted)}\"><input id=\"offcPhonCntryCd\" name=\"offcPhonCntryCd\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.offcPhonCntryCd\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onOffcPhonCntryCdSelected($item)\" typeahead-no-results=\"noOffcPhonCntryCd\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" ng-change=\"vm.onOffcPhonCntryCdChange()\" ng-required=\"vm.user.offcPhonNum\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"registerForm.offcPhonCntryCd.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.offcPhonCntryCd.$error\"><span ng-message=\"required\" translate=\"login.home.valid.phonCntryCdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"noOffcPhonCntryCd\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: registerForm.offcPhonCntryCd.$viewValue}\"></span></span></div><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': registerForm.offcPhonNum.$invalid && (registerForm.offcPhonNum.$error.pattern || registerForm.$submitted), \'required\' : vm.user.offcPhonCntryCd}\"><input id=\"offcPhonNum\" name=\"offcPhonNum\" class=\"form-control\" ng-model=\"vm.user.offcPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\" ng-required=\"vm.user.offcPhonCntryCd\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.offcPhonNum.$invalid && (registerForm.offcPhonNum.$error.pattern || registerForm.$submitted)\" ng-messages=\"registerForm.offcPhonNum.$error\"><span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span> <span ng-message=\"required\" translate=\"login.home.valid.phonNumReqd\"></span></span></div></div><div class=\"form-group\"><span class=\"col-xs-12 col-sm-2 control-label small-label text-indent\" style=\"text-align : left;\" ng-class=\"{\'required\' : vm.twoFactorAuthReq === \'TRUE\'}\" translate=\"login.home.moblLabel\"></span><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': noMoblPhonCntryCd || (registerForm.moblPhonCntryCd.$invalid && registerForm.$submitted)}\"><input id=\"moblPhonCntryCd\" name=\"moblPhonCntryCd\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.moblPhonCntryCd\" placeholder=\"{{\'login.home.selectCntryCdText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.phnCntryCodes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onMoblPhonCntryCdSelected($item)\" typeahead-no-results=\"noMoblPhonCntryCd\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" ng-change=\"vm.onMoblPhonCntryCdChange()\" ng-required=\"vm.twoFactorAuthReq === \'TRUE\' || vm.user.moblPhonNum\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"registerForm.moblPhonCntryCd.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.moblPhonCntryCd.$error\"><span ng-message=\"required\" translate=\"login.home.valid.phonCntryCdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"noMoblPhonCntryCd\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: registerForm.moblPhonCntryCd.$viewValue}\"></span></span></div><div class=\"col-xs-12 col-sm-5\" ng-class=\"{\'has-error\': (registerForm.moblPhonNum.$invalid && registerForm.$submitted) || (registerForm.moblPhonNum.$dirty && (registerForm.moblPhonNum.$error.pattern || registerForm.moblPhonNum.$error.invalidPhoneNumber))}\"><input id=\"moblPhonNum\" name=\"moblPhonNum\" class=\"form-control\" ng-model=\"vm.user.moblPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'login.home.phonNumLabel\' | translate}}\" ng-change=\"vm.validateMobileNumber();\" ng-required=\"vm.twoFactorAuthReq === \'TRUE\' || vm.user.moblPhonCntryCd\"> <span class=\"help-block m-b-none\" ng-show=\"(registerForm.moblPhonNum.$invalid && registerForm.$submitted) || (registerForm.moblPhonNum.$dirty && (registerForm.moblPhonNum.$error.pattern || registerForm.moblPhonNum.$error.invalidPhoneNumber))\" ng-messages=\"registerForm.moblPhonNum.$error\"><span ng-message=\"required\" ng-if=\"registerForm.$submitted\" translate=\"login.home.valid.phonNumReqd\"></span> <span ng-message=\"pattern\" translate=\"login.home.valid.phonNumInvld\"></span> <span ng-message=\"invalidPhoneNumber\" translate=\"login.home.valid.moblNumUniq\"></span></span></div></div></div><div class=\"ibox-content\" style=\"margin-bottom: 10px; padding: 15px; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><div style=\"display: flex\"><h4><b><span translate=\"login.home.usrDetlsTitle\"></span></b></h4></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (registerForm.userId.$invalid && registerForm.$submitted) || (registerForm.userId.$dirty && (registerForm.userId.$error.pattern || registerForm.userId.$error.invalidUserId))}\"><div class=\"col-xs-12\"><input id=\"userId\" name=\"userId\" class=\"form-control\" type=\"text\" ng-model=\"vm.user.userId\" ng-model-options=\"{updateOn: \'blur\'}\" ng-pattern=\"/^[^\\s@]+@([^\\s@.,]+\\.)+[^\\s@.,]{2,}$/\" placeholder=\"{{\'login.home.emailAddrLabel\' | translate}}\" ng-change=\"vm.validateUserId();\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"(registerForm.userId.$invalid && registerForm.$submitted) || (registerForm.userId.$dirty && (registerForm.userId.$error.pattern || registerForm.userId.$error.invalidUserId))\" ng-messages=\"registerForm.userId.$error\"><span ng-message=\"required\" translate=\"login.home.valid.emailAddrReqd\"></span> <span ng-message=\"pattern\" translate=\"login.home.valid.emailAddrInvld\"></span> <span ng-message=\"invalidUserId\" translate=\"login.home.valid.emailAddrExists\"></span></span></div></div><script type=\"text/ng-template\" id=\"passwd-policy-template.html\"><div class=\"form-group\"> <ul style=\"list-style-type: none; padding-left: 0px;\"> <li ng-repeat=\"(key, value) in vm.rulesList track by key\" ng-bind-html=\"value\"></li> </ul> </div></script><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': (registerForm.password.$invalid && registerForm.$submitted) || (registerForm.password.$dirty && registerForm.password.$error.policy)}\"><div><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" ng-model-options=\"{ updateOn: \'blur\' }\" placeholder=\"{{\'login.home.passwdLabel\' | translate}}\" autocomplete=\"off\" popover-append-to-body=\"true\" popover-placement=\"center\" popover-trigger=\"focus\" popover-animation=\"true\" popover-title=\"Password Policy\" uib-popover-template=\"vm.policyPopover.templateUrl\" required=\"\" self-register-validate-password-policy=\"\"></div><span class=\"help-block m-b-none\" ng-show=\"(registerForm.password.$invalid && registerForm.$submitted) || (registerForm.password.$dirty && registerForm.password.$error.policy)\" ng-messages=\"registerForm.password.$error\"><span ng-message=\"required\" translate=\"login.home.valid.passwdReqd\"></span> <span ng-message=\"policy\" translate=\"login.home.valid.passwdPolicyFailed\"></span></span></div><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': (registerForm.confirmPassword.$invalid && registerForm.$submitted) || (registerForm.confirmPassword.$viewValue && registerForm.confirmPassword.$dirty && registerForm.confirmPassword.$error.compareTo)}\"><div><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" class=\"form-control\" ng-model=\"vm.confirmPassword\" ng-model-options=\"{ updateOn: \'blur\' }\" compare-to=\"registerForm.password.$viewValue\" placeholder=\"{{\'login.home.confPasswdLabel\' | translate}}\" autocomplete=\"off\" required=\"\"></div><span class=\"help-block m-b-none\" ng-show=\"(registerForm.confirmPassword.$invalid && registerForm.$submitted) || (registerForm.confirmPassword.$viewValue && registerForm.confirmPassword.$dirty && registerForm.confirmPassword.$error.compareTo)\" ng-messages=\"registerForm.confirmPassword.$error\"><span ng-message=\"required\" translate=\"login.home.valid.confPasswdReqd\"></span> <span ng-message=\"compareTo\" translate=\"login.home.valid.passwdMatchReqd\"></span></span></div></div></div><div ng-if=\"vm.userPrefTypesToShow().length > 0\" class=\"ibox-content\" style=\"margin-bottom: 10px; padding: 15px; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><h4><b><span translate=\"login.home.usrPrefsTitle\"></span></b></h4></div></div><div class=\"row form-group\" ng-repeat=\"userPrefType in vm.userPrefTypesToShow() | orderBy:\'dispSeq\'\"><div class=\"col-xs-12 col-sm-3\"><label class=\"control-label small-label text-indent required\" style=\"text-align: left;\">{{userPrefType.nm}}</label></div><div class=\"col-xs-12 col-sm-9\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"userPrefTypeItem in vm.references[userPrefType.entity.lkupTablCd].refItems | orderBy:\'dispSeq\'\"><input self-register-pref-radio=\"\" icheck=\"\" type=\"radio\" name=\"{{userPrefType.cd}}\" ng-model=\"vm.user.userPrefs[userPrefType.cd]\" ng-value=\"userPrefTypeItem.cd\" required=\"\"> <label><span class=\"small-label\">{{userPrefTypeItem.nm}}</span></label></div></div></div></div><div class=\"hidden-xs ibox-content\" style=\"margin-bottom: 0px; padding: 15px; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-xs-12\"><div style=\"display: flex\"><h4><b><span translate=\"login.home.orgDetlsTitle\"></span></b></h4></div></div></div><div class=\"row form-group\"><div class=\"col-xs-12\" ng-class=\"{\'has-error\': registerForm.orgName.$invalid && registerForm.$submitted}\"><div><input id=\"orgName\" name=\"orgName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.orgName\" ng-model-options=\"{updateOn: \'blur\'}\" placeholder=\"{{\'login.home.orgNameLabel\' | translate}}\" required=\"\"> <span class=\"help-block m-b-none\" ng-show=\"registerForm.orgName.$invalid && registerForm.$submitted\" ng-messages=\"registerForm.orgName.$error\"><span ng-message=\"required\" translate=\"login.home.valid.orgNameReqd\"></span></span></div></div></div><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-6\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.terms\" ng-change=\"vm.tosVisited()\" required=\"\"> &nbsp; <span translate=\"login.selfRegstrn.tosAgrmtText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\"><span translate=\"login.home.tosLink\"></span></a><div ng-class=\"{\'has-error\': !vm.terms && registerForm.$submitted}\"><span class=\"help-block m-b-none\" ng-show=\"!vm.terms && registerForm.$submitted\" style=\"color: #ED5565\" translate=\"login.selfRegstrn.tosAgrmtReqd\"></span></div></div><div class=\"col-xs-12 col-sm-6 text-right\"><a class=\"btn btn-white\" href=\"/login\" translate=\"login.home.cancelButton\"></a> <button class=\"btn btn-primary register-submit-btn\" id=\"registerBtn\" type=\"submit\" ng-disabled=\"true\" translate=\"login.selfRegstrn.regstrButton\"></button></div></div></div></div></div><div class=\"row\" style=\"margin-top: 10px\"><div class=\"col-xs-12 text-center\"><small><span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: vm.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <a ng-click=\"vm.openTosDialogBox($event)\" translate=\"login.home.tosLink\"></a>.<br>v{{vm.properties.appVersion}}</small></div></div></div></div></div></div></div></div></form><div ng-include=\"\'app/core/template/info-dialog-template.html\'\"></div><div ng-include=\"\'app/core/template/confirm-dialog-template.html\'\"></div>");
$templateCache.put("app/subject/subject.html","<div ng-if=\"!vm.showLandingError\"><div ng-if=\"vm.hasSubjPerms(vm.subjPerms)\" ui-view=\"subjContent\"></div><div ng-if=\"!vm.hasSubjPerms(vm.subjPerms)\" class=\"message-error\"><span translate=\"{{vm.subjPermi18n}}\"></span></div></div><div ng-if=\"vm.showLandingError\" class=\"message-error\"><span translate=\"subj.home.valid.noSubjPermsn\"></span></div>");
$templateCache.put("app/subjects/add.html","<script type=\"text/javascript\">\r\n    $(document).ready(function() {\r\n        $.fn.datepicker.defaults.todayHighlight = true;\r\n        $.fn.datepicker.defaults.autoclose = true;\r\n        $.fn.datepicker.defaults.showOnFocus = false;\r\n        $(\'#subjEffectiveDate\').datepicker();\r\n    });\r\n</script><div class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-sm-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(subjForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"subjForm\"><div class=\"form-group\" ng-class=\"{\'has-error\': subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid || subjForm.subjEffectiveDate.$error.subjDateGtPrevValid)}\"><label class=\"col-sm-2 control-label required\" translate=\"subj.home.subjEffDtLabel\"></label><div class=\"col-sm-3\"><div class=\"input-group date\" id=\"datepicker\"><input id=\"subjEffectiveDate\" name=\"subjEffectiveDate\" class=\"form-control\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.subjEffectiveDate\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" add-subj-effective-date=\"\" required=\"\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid || subjForm.subjEffectiveDate.$error.subjDateGtPrevValid)\" ng-messages=\"subjForm.subjEffectiveDate.$error\"><span ng-message=\"subjDateInvalid\" translate=\"subj.home.valid.subjEffDtInvld\"></span> <span ng-message=\"required\" translate=\"subj.home.valid.subjEffDtReqd\"></span> <span ng-message=\"subjDateGtPrevValid\" translate=\"subj.home.valid.subjEffDtGtPrev\"></span></div></div><div class=\"col-sm-7\"><div class=\"control-text\" style=\"padding-left: 0px\"><i class=\"fa fa-lg fa-info-circle idmx-icon idmx_cursor_pointer\" uib-popover=\"{{\'subj.home.help.subjEffDtText\' | translate}}\" popover-title=\"{{\'subj.home.subjEffDtLabel\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"bottom\"></i></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><span translate=\"subj.home.subjDescLabel\"></span></label><div class=\"col-sm-10\"><input type=\"text\" id=\"subjDesc\" ng-model=\"vm.subject.subjDesc\" class=\"form-control\"></div></div><div ng-repeat=\"orgRoleType in vm.reqdOrgRoleTypes | orderBy:\'dispSeq\'\"><div class=\"form-group\"><label class=\"col-sm-2 control-label required\">{{orgRoleType.nm}}</label><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length > 1\"><div ng-if=\"vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-sm-5\" ng-class=\"{\'has-error\': (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid || noOrg === true || vm.orgRoleTypeConflict(orgRoleType.cd)) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)}\"><input id=\"{{orgRoleType.cd}}_reqdOrgRole\" type=\"text\" name=\"{{orgRoleType.cd}}_reqdOrgRole\" ng-model=\"vm.reqdSubjOrgRoles[orgRoleType.cd]\" class=\"typeahead form-control\" placeholder=\"{{\'subj.home.selectOrgText\' | translate}}\" uib-typeahead=\"org as [org.orgNamePlusRefNum] for org in vm.orgsForOrgRole(orgRoleType.cd) | filter:{orgNamePlusRefNum: $viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.reqdOrgRoleTypesSelected()\" typeahead-no-results=\"noOrg\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-change=\"vm.reqdOrgRoleTypesChanged()\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"((subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid || noOrg) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjFormForm.$submitted))\" ng-messages=\"subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleOrgReqd\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.orgRoleTypeConflict(orgRoleType.cd)\"><span translate=\"subj.home.valid.roleOrgConflg\" translate-values=\"{conflgOrgRoleTypeName: orgRoleType.nm, confldOrgRoleTypeName: vm.orgRoleTypeConflict(orgRoleType.cd)}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noOrg && subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$viewValue !== \'\') && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$viewValue}\"></span></span></div><div ng-if=\"!vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-sm-5\" ng-class=\"{\'has-error\': (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid || vm.orgRoleTypeConflict(orgRoleType.cd)) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)}\"><select id=\"{{orgRoleType.cd}}_reqdOrgRole\" name=\"{{orgRoleType.cd}}_reqdOrgRole\" class=\"form-control\" ng-options=\"org.orgNamePlusRefNum for org in vm.orgsForOrgRole(orgRoleType.cd) track by org.orgId\" ng-model=\"vm.reqdSubjOrgRoles[orgRoleType.cd]\" ng-change=\"vm.reqdOrgRoleTypesSelectedFromDropdown()\" required=\"\"><option selected=\"\" value=\"\" class=\"placeholder-color\" ng-model=\"vm.reqdSubjOrgRoles[orgRoleType.cd]\">{{\'subj.home.selectOrgText\' | translate}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)\" ng-messages=\"subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleOrgReqd\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.orgRoleTypeConflict(orgRoleType.cd)\"><span translate=\"subj.home.valid.roleOrgConflg\" translate-values=\"{conflgOrgRoleTypeName: orgRoleType.nm, confldOrgRoleTypeName: vm.orgRoleTypeConflict(orgRoleType.cd)}\"></span></span></div></div><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length === 1\" class=\"col-sm-5\" ng-class=\"{\'has-error\': vm.orgRoleTypeConflict(orgRoleType.cd)}\"><div class=\"control-text\">{{vm.reqdSubjOrgRoles[orgRoleType.cd].orgNamePlusRefNum}}</div><span class=\"help-block m-b-none control-text\" ng-show=\"vm.orgRoleTypeConflict(orgRoleType.cd)\"><span translate=\"subj.home.valid.roleOrgConflg\" translate-values=\"{conflgOrgRoleTypeName: orgRoleType.nm, confldOrgRoleTypeName: vm.orgRoleTypeConflict(orgRoleType.cd)}\"></span></span></div><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length === 0\" class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.reqdSubjOrgRoles[orgRoleType.cd]\" id=\"{{orgRoleType.cd}}_reqdOrgRole\" name=\"{{orgRoleType.cd}}_reqdOrgRole\" required=\"\" style=\"display: none\"><div class=\"control-text has-error\"><span translate=\"subj.home.valid.noRoleOrgsFound\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></div></div></div></div><div ng-repeat=\"userRoleType in vm.reqdUserRoleTypes | orderBy:\'dispSeq\'\"><div class=\"form-group\"><label class=\"col-sm-2 control-label required\">{{userRoleType.nm}}</label><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length > 1\"><div ng-if=\"vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-sm-5\" ng-class=\"{\'has-error\': (subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid || noUser || vm.userRoleTypeConflict(userRoleType.cd)) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)}\"><input id=\"{{userRoleType.cd}}_reqdUserRole\" type=\"text\" name=\"{{userRoleType.cd}}_reqdUserRole\" ng-model=\"vm.reqdSubjUserRoles[userRoleType.cd]\" class=\"typeahead form-control\" placeholder=\"{{\'subj.home.selectUsrText\' | translate}}\" uib-typeahead=\"user as [user.userLastFirstNamePlusOrgPlusId] for user in vm.usersForUserRole(userRoleType.cd) | filter: {userLastFirstNamePlusOrgPlusId: $viewValue} | limitTo: 8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.reqdUserRoleTypesSelected()\" typeahead-no-results=\"noUser\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-change=\"vm.reqdUserRoleTypesChanged()\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"((subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid || noUser) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjFormForm.$submitted))\" ng-messages=\"subjForm[userRoleType.cd + \'_reqdUserRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleUsrReqd\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.userRoleTypeConflict(userRoleType.cd)\"><span translate=\"subj.home.valid.roleUsrConflg\" translate-values=\"{conflgUsrRoleTypeName: userRoleType.nm, confldUsrRoleTypeName: vm.userRoleTypeConflict(userRoleType.cd)}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noUser && subjForm[userRoleType.cd + \'_reqdUserRole\'].$viewValue !== \'\') && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: subjForm[userRoleType.cd + \'_reqdUserRole\'].$viewValue}\"></span></span></div><div ng-if=\"!vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-sm-5\" ng-class=\"{\'has-error\': (subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid || vm.userRoleTypeConflict(userRoleType.cd)) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)}\"><select id=\"{{userRoleType.cd}}_reqdUserRole\" name=\"{{userRoleType.cd}}_reqdUserRole\" class=\"form-control\" ng-options=\"user.userLastFirstNamePlusOrgPlusId for user in vm.usersForUserRole(userRoleType.cd) track by user.userId\" ng-model=\"vm.reqdSubjUserRoles[userRoleType.cd]\" ng-change=\"vm.reqdUserRoleTypesSelectedFromDropdown()\" required=\"\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\" ng-model=\"vm.reqdSubjUserRoles[userRoleType.cd]\">{{\'subj.home.selectUsrText\' | translate}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)\" ng-messages=\"subjForm[userRoleType.cd + \'_reqdUserRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleUsrReqd\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.userRoleTypeConflict(userRoleType.cd)\"><span translate=\"subj.home.valid.roleUsrConflg\" translate-values=\"{conflgUsrRoleTypeName: userRoleType.nm, confldUsrRoleTypeName: vm.userRoleTypeConflict(userRoleType.cd)}\"></span></span></div></div><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length === 1\" class=\"col-sm-5\" ng-class=\"{\'has-error\': vm.userRoleTypeConflict(userRoleType.cd)}\"><div class=\"control-text\">{{vm.reqdSubjUserRoles[userRoleType.cd].userLastFirstNamePlusOrgPlusId}}</div><span class=\"help-block m-b-none control-text\" ng-show=\"vm.userRoleTypeConflict(userRoleType.cd)\"><span translate=\"subj.home.valid.roleUsrConflg\" translate-values=\"{conflgUsrRoleTypeName: userRoleType.nm, confldUsrRoleTypeName: vm.userRoleTypeConflict(userRoleType.cd)}\"></span></span></div><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length === 0\" class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.reqdSubjUserRoles[userRoleType.cd]\" id=\"{{userRoleType.cd}}_reqdUserRole\" name=\"{{userRoleType.cd}}_reqdUserRole\" required=\"\" style=\"display: none\"><div class=\"control-text has-error\"><span translate=\"subj.home.valid.noRoleUsrsFound\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></div></div></div></div><div ng-if=\"vm.showMyOrgRoleTypes()\"><div class=\"form-group\"><label class=\"col-sm-12 subheading-label\"><span translate=\"subj.home.yourOrgRolesText\"></span> - {{vm.orgName}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateMyOrgRoles() && subjForm.$submitted}\"><label class=\"col-sm-2 control-label\"></label><div ng-if=\"vm.notReqdOrgRoleTypes.length > 0\" class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" ng-repeat=\"orgRoleType in vm.notReqdOrgRoleTypes | orderBy:\'dispSeq\'\" id=\"{{orgRoleType.cd}}_orDiv\"><input id=\"{{orgRoleType.cd}}_orIp\" icheck=\"\" ng-model=\"vm.subjOrgRoles[orgRoleType.cd]\" name=\"orgRole\" type=\"checkbox\" custom-popover=\"\" ng-change=\"vm.updateMyOrgRoleTypes(orgRoleType.cd)\" ng-disabled=\"vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)\"> <label for=\"{{orgRoleType.cd}}_orIp\" class=\"lbl-roles-container\"><span id=\"{{orgRoleType.cd}}_orLabel\" ng-class=\"{\'label-success-disabled\': vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)}\" class=\"lbl-roles\" ng-disabled=\"vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-append-to-body=\"true\" popover-title=\"{{orgRoleType.nm}}\" uib-popover=\"{{orgRoleType.desc}}\">{{orgRoleType.nm}}</span></label></div><div class=\"help-block m-b-none\" ng-show=\"!vm.validateMyOrgRoles() && subjForm.$submitted\"><span translate=\"subj.home.valid.orgRoleReqd\"></span></div></div><div ng-if=\"vm.notReqdOrgRoleTypes.length === 0\" class=\"has-error\"><span class=\"help-block\" translate=\"subj.home.valid.noOrgRolesFound\"></span></div></div></div><div ng-if=\"vm.showMyUserRoleTypes()\"><div class=\"form-group\"><label class=\"col-sm-12 subheading-label\"><span translate=\"subj.home.yourUsrRolesText\"></span> - {{vm.owner}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateMyUserRoles() && subjForm.$submitted}\"><label class=\"col-sm-2 control-label\"></label><div ng-if=\"vm.notReqdUserRoleTypes.length > 0\" class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"userRoleType in vm.notReqdUserRoleTypes | orderBy:\'dispSeq\'\"><input id=\"{{userRoleType.cd}}_urIp\" icheck=\"\" ng-model=\"vm.subjUserRoles[userRoleType.cd]\" name=\"subjUserRoles\" type=\"checkbox\" ng-change=\"vm.updateSubjUserRoleTypes()\" ng-disabled=\"vm.isMyUserRoleTypeDisabled(userRoleType.cd)\"> <label class=\"lbl-roles-container\"><span id=\"{{userRoleType.cd}}_userRoleTypeLabel\" ng-class=\"{\'lbl-disabled\': vm.isMyUserRoleTypeDisabled(userRoleType.cd)}\" class=\"lbl-roles\" ng-disabled=\"vm.isMyUserRoleTypeDisabled(userRoleType.cd)\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.nm}}\" uib-popover=\"{{userRoleType.desc}}\">{{userRoleType.nm}}</span></label></div><span class=\"help-block m-b-none\" ng-show=\"!vm.validateMyUserRoles() && subjForm.$submitted\"><span translate=\"subj.home.valid.usrRoleReqd\"></span></span></div><div ng-if=\"vm.notReqdUserRoleTypes.length === 0\" class=\"has-error\"><span class=\"help-block\" translate=\"subj.home.valid.noUsrRolesFound\"></span></div></div></div><div class=\"message-info\"><span translate=\"subj.home.collabInfoText\"></span></div><div ng-if=\"vm.repeatSubject\"><strong translate=\"subj.home.help.prevSubjFoundText\" translate-values=\"{targRoleTypeName: vm.targetRoleTypeName, prevSubjEffDt: (vm.repeatSubject.subjEffDate | dateOnlyFormat)}\"></strong><br>&nbsp;</div><div class=\"form-group\" ng-if=\"vm.showCloneFlag()\"><label class=\"col-lg-2 control-label\" translate=\"subj.home.cloneSubjDataLabel\"></label><div class=\"col-lg-10\"><div class=\"checkbox-inline zero-left-padding\"><input id=\"subjCloneFlagIp\" icheck=\"\" ng-model=\"vm.subject.subjDataCloneFlag\" name=\"subjCloneFlagIp\" type=\"checkbox\"></div></div></div><div class=\"form-group\"><div class=\"col-sm12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.subjects\" translate=\"subj.home.cancelButton\"></button> <button id=\"subjSubmitBtn\" class=\"btn btn-primary add-sub-submit-btn\" type=\"submit\" disabled=\"\" ladda=\"vm.ladda\" translate=\"subj.addSubj.addButton\"></button></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/subjects/clone.html","<div ng-if=\"sysParms.SUBJ_UNIQ_TARGS_FLAG.toUpperCase() !== \'TRUE\'\" class=\"ibox-content idmx-ibox-content\" has-any-subj-perms=\"[\'CLONE_SUBJ\']\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(subjForm)\" name=\"subjForm\" ng-keydown=\"vm.onKeyDown($event)\"><div class=\"form-group\" ng-class=\"{\'has-error\': subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid)}\"><label class=\"col-lg-2 control-label required\" translate=\"subj.home.subjEffDtLabel\"></label><div class=\"col-lg-3\"><div class=\"input-group date\" id=\"datepicker\"><input id=\"subjEffectiveDate\" name=\"subjEffectiveDate\" class=\"form-control\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.subjEffectiveDate\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" clone-subj-effective-date=\"\" required=\"\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid)\" ng-messages=\"subjForm.subjEffectiveDate.$error\"><span ng-message=\"subjDateInvalid\" translate=\"subj.home.valid.subjEffDtInvld\"></span> <span ng-message=\"required\" translate=\"subj.home.valid.subjEffDtReqd\"></span></div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\"><span translate=\"subj.home.subjDescLabel\"></span></label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"vm.subject.subjDesc\" class=\"form-control\"></div></div><div class=\"message-info\"><span translate=\"subj.cloneSubj.cloneInfoText\"></span></div><div ng-repeat=\"orgRoleType in vm.reqdOrgRoleTypes | orderBy:\'dispSeq\'\"><div class=\"form-group\"><label class=\"col-lg-2 control-label required\">{{orgRoleType.nm}}</label><div class=\"col-lg-5\"><div ng-repeat=\"org in vm.orgsForReqdOrgRole(orgRoleType.cd)\" style=\"margin-bottom: 5px;\"><div class=\"control-text\">{{org}}</div></div></div></div></div><div class=\"form-group\"><label class=\"col-lg-12 subheading-label\"><span translate=\"subj.home.yourOrgRolesText\"></span> - {{vm.orgName}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateUserOrgRoleTypes()}\"><label class=\"col-lg-2 control-label\"></label><div class=\"col-lg-10\"><div class=\"checkbox-inline zero-left-padding\" ng-repeat=\"orgRoleType in vm.userOrgRoleTypes | orderBy:\'dispSeq\'\" id=\"{{orgRoleType.cd}}_orDiv\"><input id=\"{{orgRoleType.cd}}_orIp\" icheck=\"\" ng-model=\"vm.subjOrgRoles[orgRoleType.cd]\" name=\"orgRole\" type=\"checkbox\" custom-popover=\"\" disabled=\"\"> <label for=\"{{orgRoleType.cd}}_orIp\"><span id=\"{{orgRoleType.cd}}_orLabel\" class=\"lbl-roles-chk label-success-disabled idmx_cursor_not_allowed\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-append-to-body=\"true\" popover-title=\"{{orgRoleType.nm}}\" uib-popover=\"{{orgRoleType.desc}}\" disabled=\"\">{{orgRoleType.nm}}</span></label></div><div class=\"help-block m-b-none\" ng-show=\"!vm.validateUserOrgRoleTypes() && (vm.subjOrgRolesDirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.orgRoleReqd\"></span></div></div></div><div class=\"form-group\"><label class=\"col-lg-12 subheading-label\"><span translate=\"subj.home.yourUsrRolesText\"></span> - {{vm.owner}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateUserRoleTypes}\"><label class=\"col-sm-2 control-label\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\"><label><input id=\"{{userRoleType.cd}}_userRoleTypeIp\" icheck=\"\" ng-model=\"vm.subjUserRoles[userRoleType.cd]\" name=\"subjUserRoles\" type=\"checkbox\" ng-required=\"!vm.validateUserRoleTypes\" disabled=\"\"> <span id=\"{{userRoleType.cd}}_userRoleTypeLabel\" class=\"lbl-roles-chk lbl-disabled idmx_cursor_not_allowed\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.nm}}\" uib-popover=\"{{userRoleType.desc}}\">{{userRoleType.nm}}</span></label></div><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"!vm.validateUserRoleTypes\" ng-messages=\"subjForm.subjUserRoles.$error\"><span ng-message=\"required\" translate=\"subj.home.valid.orgRoleReqd\"></span></span></div></div><div class=\"message-info\"><span translate=\"subj.home.collabInfoText\"></span></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"subj.home.currStageLabel\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.subjStageName}}</div></div></div><div class=\"form-group\"><div class=\"col-lg12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.subjects\" ui-sref-opts=\"{reload: true}\" translate=\"subj.home.cancelButton\"></button> <button class=\"btn btn-primary add-sub-submit-btn\" type=\"submit\" id=\"subjCloneBtn\" ladda=\"vm.ladda\" translate=\"subj.cloneSubj.cloneButton\"></button></div></div></div></form></div></div></div></div></div>{{sysParms.SUBJ_UNIQ_TARGS_FLAG}}<div ng-if=\"sysParms.SUBJ_UNIQ_TARGS_FLAG.toUpperCase() === \'TRUE\'\" class=\"message-error\" translate=\"subj.cloneSubj.valid.noCloneSubjPermsn\"></div><div ng-if=\"sysParms.SUBJ_UNIQ_TARGS_FLAG.toUpperCase() !== \'TRUE\'\" hasnt-any-subj-perms=\"[\'CLONE_SUBJ\']\" class=\"message-error\" translate=\"subj.cloneSubj.valid.noCloneSubjPermsn\"></div>");
$templateCache.put("app/subjects/edit.html","<div class=\"ibox-content idmx-ibox-content\" has-any-subj-perms=\"[\'UPDT_SUBJ\']\"><div class=\"row idmx-row\"><div class=\"col-sm-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(updateSubForm)\" name=\"updateSubForm\" ng-keydown=\"vm.onKeyDown($event)\"><div class=\"form-group\" ng-class=\"{\'has-error\': updateSubForm.subjEffectiveDate.$invalid && (updateSubForm.$submitted || updateSubForm.subjEffectiveDate.$error.subjDateInvalid || updateSubForm.subjEffectiveDate.$error.subjDateGtPrevValid || updateSubForm.subjEffectiveDate.$error.subjDateLtPrevValid)}\"><label class=\"col-sm-2 control-label required\" translate=\"subj.home.subjEffDtLabel\"></label><div class=\"col-sm-3\"><div class=\"input-group date\" id=\"datepicker\"><input id=\"subjEffectiveDate\" name=\"subjEffectiveDate\" class=\"form-control\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.subjEffectiveDate\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" edit-subj-effective-date=\"\" required=\"\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"updateSubForm.subjEffectiveDate.$invalid && (updateSubForm.$submitted || updateSubForm.subjEffectiveDate.$error.subjDateInvalid || updateSubForm.subjEffectiveDate.$error.subjDateGtPrevValid || updateSubForm.subjEffectiveDate.$error.subjDateLtPrevValid)\" ng-messages=\"updateSubForm.subjEffectiveDate.$error\"><span ng-message=\"subjDateInvalid\" translate=\"subj.home.valid.subjEffDtInvld\"></span> <span ng-message=\"required\" translate=\"subj.home.valid.subjEffDtReqd\"></span> <span ng-message=\"subjDateGtPrevValid\" translate=\"subj.home.valid.subjEffDtGtPrev\"></span> <span ng-message=\"subjDateLtPrevValid\" translate=\"subj.home.valid.subjEffDtLtNext\"></span></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"><span translate=\"subj.home.subjDescLabel\"></span></label><div class=\"col-sm-10\"><input type=\"text\" ng-model=\"vm.subject.subjDesc\" class=\"form-control\"></div></div><div ng-repeat=\"orgRoleType in vm.orgRoleTypes | orderBy:\'dispSeq\'\"><div ng-if=\"orgRoleType.entity.reqdSubjOrgRoleFlag || vm.orgsForOrgRole(orgRoleType.cd).length > 0\" class=\"form-group\"><label class=\"col-sm-2 control-label\" ng-class=\"{required: orgRoleType.entity.reqdSubjOrgRoleFlag}\">{{orgRoleType.nm}}</label><div class=\"col-sm-5\"><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length > 0\" ng-repeat=\"org in vm.orgsForOrgRole(orgRoleType.cd)\"><div class=\"control-text\">{{org.orgNamePlusRefNum}}</div></div><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length === 0\" class=\"control-text has-error\"><span translate=\"subj.home.valid.noRoleOrgsFound\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></div></div></div></div><div ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\"><div ng-if=\"userRoleType.entity.reqdSubjUsrRoleFlag || vm.usersForUserRole(userRoleType.cd).length > 0\" class=\"form-group\"><label class=\"col-sm-2 control-label\" ng-class=\"{required: userRoleType.entity.reqdSubjUsrRoleFlag}\">{{userRoleType.nm}}</label><div class=\"col-sm-5\"><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length > 0\" ng-repeat=\"user in vm.usersForUserRole(userRoleType.cd)\"><div class=\"control-text\">{{user.userLastFirstNamePlusOrgPlusId}}</div></div><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length === 0\" class=\"control-text has-error\"><span translate=\"subj.home.valid.noRoleUsrsFound\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></div></div></div></div><div class=\"message-info\"><span translate=\"subj.home.collabInfoText\"></span></div><div class=\"form-group\"><div class=\"col-sm12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.subjects\" ui-sref-opts=\"{reload: true}\" translate=\"subj.home.cancelButton\"></button> <button class=\"btn btn-primary add-sub-submit-btn\" disabled=\"disabled\" type=\"submit\" id=\"subjEditBtn\" ladda=\"vm.ladda\" translate=\"subj.updtSubj.updtButton\"></button></div></div></div></form></div></div></div></div></div><div hasnt-any-subj-perms=\"[\'UPDT_SUBJ\']\" class=\"message-error\" translate=\"subj.updtSubj.valid.noUpdtSubjPermsn\"></div>");
$templateCache.put("app/subjects/repeat.html","<div class=\"ibox-content idmx-ibox-content\" has-any-subj-perms=\"[\'REPT_SUBJ\']\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(subjForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"subjForm\"><div class=\"form-group\" ng-class=\"{\'has-error\': subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid || subjForm.subjEffectiveDate.$error.subjDateGtPrevValid)}\"><label class=\"col-lg-2 control-label required\" translate=\"subj.home.subjEffDtLabel\"></label><div class=\"col-lg-3\"><div class=\"input-group date\" id=\"datepicker\"><input id=\"subjEffectiveDate\" name=\"subjEffectiveDate\" class=\"form-control\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.subjEffectiveDate\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" repeat-subj-effective-date=\"\" required=\"\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"subjForm.subjEffectiveDate.$invalid && (subjForm.$submitted || subjForm.subjEffectiveDate.$error.subjDateInvalid || subjForm.subjEffectiveDate.$error.subjDateGtPrevValid)\" ng-messages=\"subjForm.subjEffectiveDate.$error\"><span ng-message=\"subjDateInvalid\" translate=\"subj.home.valid.subjEffDtInvld\"></span> <span ng-message=\"required\" translate=\"subj.home.valid.subjEffDtReqd\"></span> <span ng-message=\"subjDateGtPrevValid\" translate=\"subj.home.valid.subjEffDtGtPrev\"></span></div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\"><span translate=\"subj.home.subjDescLabel\"></span></label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"vm.subject.subjDesc\" class=\"form-control\" id=\"subjDesc\"></div></div><div class=\"form-group\" ng-if=\"vm.hasSubjDataCloneDecsnFlag()\"><label class=\"col-lg-2 control-label\" translate=\"subj.home.cloneSubjDataLabel\"></label><div class=\"col-lg-10\"><div class=\"checkbox-inline zero-left-padding\"><input id=\"subjCloneFlagIp\" icheck=\"\" ng-model=\"vm.subject.subjDataCloneFlag\" name=\"subjCloneFlagIp\" type=\"checkbox\"></div></div></div><div ng-repeat=\"orgRoleType in vm.reqdTargOrgRoleTypes | orderBy:\'dispSeq\'\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\" ng-class=\"{\'required\': orgRoleType.entity.reqdSubjOrgRoleFlag}\">{{orgRoleType.nm}}</label><div ng-if=\"orgRoleType.entity.subjTargOrgRoleFlag\" class=\"col-lg-5\"><div ng-repeat=\"org in vm.orgsForTargOrgRole(orgRoleType.cd)\" style=\"margin-bottom: 5px;\"><div class=\"control-text\">{{org}}</div></div></div><span ng-if=\"!orgRoleType.entity.subjTargOrgRoleFlag\"><span ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length > 1\"><div ng-if=\"vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-lg-5\" ng-class=\"{\'has-error\': (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid || noOrg === true) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)}\"><input id=\"{{orgRoleType.cd}}_reqdOrgRole\" type=\"text\" name=\"{{orgRoleType.cd}}_reqdOrgRole\" ng-model=\"vm.reqdTargSubjOrgRoles[orgRoleType.cd]\" class=\"typeahead form-control\" placeholder=\"{{\'subj.home.selectOrgText\' | translate}}\" uib-typeahead=\"org as [org.orgNamePlusRefNum] for org in vm.orgsForOrgRole(orgRoleType.cd) | filter:{orgNamePlusRefNum: $viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.reqdTargOrgRoleTypesSelected($model)\" typeahead-no-results=\"noOrg\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-change=\"vm.reqdTargOrgRoleTypesChanged(\'{{orgRoleType.cd}}\')\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"((subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid || noOrg === true) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjFormForm.$submitted))\" ng-messages=\"subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleOrgReqd\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noOrg === true && subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$viewValue !== \'\') && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$viewValue}\"></span></span></div><div ng-if=\"!vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\') && (vm.hasPerm(\'GLOBAL_COLLAB_HIER_ORGS\') || vm.hasPerm(\'GLOBAL_COLLAB_NETWORK_ORGS\'))\" class=\"col-lg-5\" ng-class=\"{\'has-error\': (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)}\"><select id=\"{{orgRoleType.cd}}_reqdOrgRole\" name=\"{{orgRoleType.cd}}_reqdOrgRole\" class=\"form-control\" ng-options=\"org.orgNamePlusRefNum for org in vm.orgsForOrgRole(orgRoleType.cd) track by org.orgId\" ng-model=\"vm.reqdTargSubjOrgRoles[orgRoleType.cd]\" ng-change=\"vm.reqdTargOrgRoleTypesSelectedFromDropdown(\'{{orgRoleType.cd}}\')\" required=\"\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\" ng-model=\"vm.reqdTargSubjOrgRoles[orgRoleType.cd]\">{{\'subj.home.selectOrgText\' | translate}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$invalid) && (subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$dirty || subjForm.$submitted)\" ng-messages=\"subjForm[orgRoleType.cd + \'_reqdOrgRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleOrgReqd\" translate-values=\"{orgRoleTypeName: orgRoleType.nm}\"></span></span></div></span><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length === 1\" class=\"col-lg-5\"><div class=\"control-text\">{{vm.reqdTargSubjOrgRoles[orgRoleType.cd].desc}}</div></div><div ng-if=\"vm.orgsForOrgRole(orgRoleType.cd).length === 0\" class=\"col-lg-5\"><div class=\"control-text\">N/A</div></div></span></div></div><div ng-repeat=\"userRoleType in vm.reqdTargUserRoleTypes | orderBy:\'dispSeq\'\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\" ng-class=\"{\'required\': userRoleType.entity.reqdSubjUsrRoleFlag}\">{{userRoleType.nm}}</label><div ng-if=\"userRoleType.entity.subjTargUsrRoleFlag\" class=\"col-lg-5\"><div ng-repeat=\"user in vm.usersForTargUserRole(userRoleType.cd)\" style=\"margin-bottom: 5px;\"><div class=\"control-text\">{{user}}</div></div></div><span ng-if=\"!userRoleType.entity.subjTargUsrRoleFlag\"><span ng-if=\"vm.usersForUserRole(userRoleType.cd).length > 1\"><div ng-if=\"vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\')\" class=\"col-lg-5\" ng-class=\"{\'has-error\': (subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid || noUser === true) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)}\"><input id=\"{{userRoleType.cd}}_reqdUserRole\" type=\"text\" name=\"{{userRoleType.cd}}_reqdUserRole\" ng-model=\"vm.reqdTargSubjUserRoles[userRoleType.cd]\" class=\"typeahead form-control\" placeholder=\"{{\'subj.home.selectUsrText\' | translate}}\" uib-typeahead=\"user as [user.userLastFirstNamePlusOrgPlusId] for user in vm.usersForUserRole(userRoleType.cd) | filter:{userLastFirstNamePlusOrgPlusId: $viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.reqdTargUserRoleTypesSelected($model)\" typeahead-no-results=\"noUser\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-change=\"vm.reqdTargUserRoleTypesChanged(\'{{userRoleType.cd}}\')\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"((subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid || noUser === true) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjFormForm.$submitted))\" ng-messages=\"subjForm[userRoleType.cd + \'_reqdUserRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleUsrReqd\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noUser === true && subjForm[userRoleType.cd + \'_reqdUserRole\'].$viewValue !== \'\') && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: subjForm[userRoleType.cd + \'_reqdUserRole\'].$viewValue}\"></span></span></div><div ng-if=\"!vm.hasPerm(\'GLOBAL_COLLAB_ALL_ORGS\') && (vm.hasPerm(\'GLOBAL_COLLAB_HIER_ORGS\') || vm.hasPerm(\'GLOBAL_COLLAB_NETWORK_ORGS\'))\" class=\"col-lg-5\" ng-class=\"{\'has-error\': (subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)}\"><select id=\"{{userRoleType.cd}}_reqdUserRole\" name=\"{{userRoleType.cd}}_reqdUserRole\" class=\"form-control\" ng-options=\"user.userLastFirstNamePlusOrgPlusId for user in vm.usersForUserRole(userRoleType.cd) track by user.userId\" ng-model=\"vm.reqdTargSubjUserRoles[userRoleType.cd]\" ng-change=\"vm.reqdTargUserRoleTypesSelectedFromDropdown(\'{{userRoleType.cd}}\')\" required=\"\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\" ng-model=\"vm.reqdTargSubjUserRoles[userRoleType.cd]\">{{\'subj.home.selectUsrText\' | translate}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(subjForm[userRoleType.cd + \'_reqdUserRole\'].$invalid) && (subjForm[userRoleType.cd + \'_reqdUserRole\'].$dirty || subjForm.$submitted)\" ng-messages=\"subjForm[userRoleType.cd + \'_reqdUserRole\'].$error\"><span ng-message=\"required\" translate=\"subj.home.valid.roleUsrReqd\" translate-values=\"{usrRoleTypeName: userRoleType.nm}\"></span></span></div></span><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length === 1\" class=\"col-lg-5\"><div class=\"control-text\">{{vm.reqdTargSubjUserRoles[userRoleType.cd].userLastFirstNamePlusOrgPlusId}}</div></div><div ng-if=\"vm.usersForUserRole(userRoleType.cd).length === 0\" class=\"col-lg-5\"><div class=\"control-text\">N/A</div></div></span></div></div><div class=\"form-group\"><label class=\"col-lg-12 subheading-label\"><span translate=\"subj.home.yourOrgRolesText\"></span> - {{vm.orgName}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateUserOrgRoleTypes()}\"><label class=\"col-lg-2 control-label\"></label><div class=\"col-lg-10\"><div class=\"checkbox-inline zero-left-padding\" ng-repeat=\"orgRoleType in vm.userOrgRoleTypes | orderBy:\'dispSeq\'\" id=\"{{orgRoleType.cd}}_orDiv\"><input id=\"{{orgRoleType.cd}}_orIp\" icheck=\"\" ng-model=\"vm.subjOrgRoles[orgRoleType.cd]\" name=\"orgRole\" type=\"checkbox\" custom-popover=\"\" ng-change=\"vm.updateUserOrgRoleTypes(orgRoleType.cd)\" ng-disabled=\"vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)\"> <label for=\"{{orgRoleType.cd}}_orIp\"><span id=\"{{orgRoleType.cd}}_orLabel\" ng-class=\"{\'label-success-disabled\': vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)}\" class=\"lbl-roles-chk\" ng-disabled=\"vm.isMyOrgRoleTypeDisabled(orgRoleType.cd)\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-append-to-body=\"true\" popover-title=\"{{orgRoleType.nm}}\" uib-popover=\"{{orgRoleType.desc}}\">{{orgRoleType.nm}}</span></label></div><div class=\"help-block m-b-none\" ng-show=\"!vm.validateUserOrgRoleTypes() && (vm.subjOrgRolesDirty || subjForm.$submitted)\"><span translate=\"subj.home.valid.orgRoleReqd\"></span></div></div></div><div class=\"form-group\"><label class=\"col-lg-12 subheading-label\"><span translate=\"subj.home.yourUsrRolesText\"></span> - {{vm.owner}} *</label></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.validateUserRoleTypes && (vm.subjUserRolesDirty || subjForm.$submitted)}\"><label class=\"col-sm-2 control-label\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\"><label><input id=\"{{userRoleType.cd}}_urIp\" icheck=\"\" ng-model=\"vm.subjUserRoles[userRoleType.cd]\" name=\"subjUserRoles\" type=\"checkbox\" ng-required=\"!vm.validateUserRoleTypes && (vm.subjRolesDirty || subjForm.$submitted)\" ng-change=\"vm.updateSubjUserRoleTypes(userRoleType.cd)\" ng-disabled=\"vm.isUserRoleTypeDisabled(userRoleType.cd)\"> <span id=\"{{userRoleType.cd}}_userRoleTypeLabel\" ng-class=\"{\'lbl-disabled\': vm.isUserRoleTypeDisabled(userRoleType.cd)}\" class=\"lbl-roles-chk\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.nm}}\" uib-popover=\"{{userRoleType.desc}}\">{{userRoleType.nm}}</span></label></div><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"!vm.validateUserRoleTypes && (vm.subjUserRolesDirty || subjForm.$submitted)\" ng-messages=\"subjForm.subjUserRoles.$error\"><span ng-message=\"required\" translate=\"subj.home.valid.orgRoleReqd\"></span></span></div></div><div class=\"message-info\"><span translate=\"subj.home.collabInfoText\"></span></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"subj.home.currStageLabel\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.subjStageName}}</div></div></div><div class=\"form-group\"><div class=\"col-lg12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.subjects\" ui-sref-opts=\"{reload: true}\" translate=\"subj.home.cancelButton\"></button> <button class=\"btn btn-primary add-sub-submit-btn\" type=\"submit\" disabled=\"\" id=\"subjRepeatBtn\" ladda=\"vm.ladda\" translate=\"subj.reptSubj.reptButton\"></button></div></div></div></form></div></div></div></div></div><div hasnt-any-subj-perms=\"[\'REPT_SUBJ\']\" class=\"message-error\" translate=\"subj.reptSubj.valid.noReptSubjPermsn\"></div>");
$templateCache.put("app/subjects/subjects.html","<div class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\">&nbsp;&nbsp; <button id=\"addSubjButton\" has-any-user-perms=\"[\'ADD_SUBJ\']\" type=\"button\" ng-click=\"vm.addSubjBtn()\" class=\"idmx-link-btn add-subj\" ladda=\"vm.ladda\" ng-disabled=\"vm.activeTab === 3\"><i class=\"fa fa-plus-circle\"></i> <span class=\"hidden-xs\" translate=\"subj.home.addSubjButton\"></span></button></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageSubjTab\" class=\"nav nav-tabs\"><li id=\"actvTab\" class=\"active\"><a subjs-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"subj.home.actvTab\" style=\"padding: 10px 20px 10px 25px;\"></a></li><li id=\"schedTab\" class=\"scheduled\"><a subjs-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"subj.home.schedTab\" style=\"padding: 10px 20px 10px 25px;\"></a></li><li id=\"archvdTab\"><a subjs-tab-3=\"\" data-target=\"#tab-3\" data-toggle=\"tab\" class=\"idmx-tab\" ng-class=\"{active: active, disabled: disabled}\" translate=\"subj.home.archvdTab\" style=\"padding: 10px 20px 10px 25px;\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><div ng-if=\"vm.activeTab === 1\"><table active-subjects-dt=\"\" id=\"activeSubjectsTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th id=\"targNameHeader\">{{vm.targetRoleTypeName}}</th><th translate=\"subj.home.subjEffDtHeader\"></th><th translate=\"subj.home.usrRolesHeader\"></th><th translate=\"subj.home.lastAccsHeader\"></th><th translate=\"subj.home.stageHeader\"></th><th translate=\"subj.home.survMetricHeader\"></th><th translate=\"subj.home.obsvsMetricHeader\"></th><th translate=\"subj.home.docsMetricHeader\"></th><th translate=\"subj.home.scorgMetricHeader\"></th><th id=\"actnsHeader\" translate=\"subj.home.actnsHeader\"></th></tr></thead></table></div></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-2\"><div ng-if=\"vm.activeTab === 2\"><table scheduled-subjects-dt=\"\" id=\"scheduledSubjectsTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th>{{vm.targetRoleTypeName}}</th><th translate=\"subj.home.subjEffDtHeader\"></th><th translate=\"subj.home.usrRolesHeader\"></th><th translate=\"subj.home.lastAccsHeader\"></th><th translate=\"subj.home.stageHeader\"></th><th translate=\"subj.home.survMetricHeader\"></th><th translate=\"subj.home.obsvsMetricHeader\"></th><th translate=\"subj.home.docsMetricHeader\"></th><th translate=\"subj.home.scorgMetricHeader\"></th><th translate=\"subj.home.actnsHeader\"></th></tr></thead></table></div></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-3\"><div ng-if=\"vm.activeTab === 3\"><table archive-subjects-dt=\"\" id=\"archivedSubjectsTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th>{{vm.targetRoleTypeName}}</th><th translate=\"subj.home.subjEffDtHeader\"></th><th translate=\"subj.home.usrRolesHeader\"></th><th translate=\"subj.home.lastAccsHeader\"></th><th translate=\"subj.home.stageHeader\"></th><th translate=\"subj.home.survMetricHeader\"></th><th translate=\"subj.home.obsvsMetricHeader\"></th><th translate=\"subj.home.docsMetricHeader\"></th><th translate=\"subj.home.scorgMetricHeader\"></th><th translate=\"subj.home.actnsHeader\"></th></tr></thead></table></div></div></div></div></div></div></div></div><div ng-include=\"\'app/subjects/template/add-subject-dialog-template.html\'\"></div>");
$templateCache.put("app/admin/observations/manage.observations.html","<div class=\"row filter-box\" style=\"background-color: #f3f3f4; margin-left: unset;\"><div class=\"white-bg\" style=\"position: sticky; top: 12px;\"><div class=\"ibox-title scoring-title\"><div style=\"display: flex; flex-wrap: nowrap; justify-content: space-between; align-content: space-between;\"><div style=\"flex: 3; margin-right: 5px;\"><h4 translate=\"obsv.home.filterLabel\"></h4><oi-select oi-options=\"item.nm group by item.type for (key, item) in vm.filters track by item.cd\" ng-model=\"vm.filterByField\" multiple=\"\" placeholder=\"All Observations ...\" list-placeholder=\"No Data Found.\" ng-change=\"vm.applyFilter(event)\" ng-click=\"event = $event\"></oi-select></div><div style=\"margin-right: 5px;\"><h4 translate=\"obsv.home.grpLabel\"></h4><select ng-model=\"vm.groupByField\" class=\"form-control small-select-box\"><option value=\"level2NodeId\">{{vm.lvl2HierLvlName}}</option><option value=\"level3NodeId\">{{vm.lvl3HierLvlName}}</option><option value=\"obsvPrioritySeq\">{{vm.priorityName}}</option><option value=\"typeCd\">{{vm.typeName}}</option></select></div><div style=\"margin-right: 5px;\"><h4 translate=\"obsv.home.sortLabel\"></h4><select ng-model=\"vm.orderByField\" class=\"form-control small-select-box\"><option value=\"obsvPrioritySeq\" translate=\"obsv.home.sortPriotHLLabel\"></option><option value=\"-obsvPrioritySeq\" translate=\"obsv.home.sortPriotLHLabel\"></option></select></div><div><h4>Change Language</h4><select class=\"form-control\" placeholder=\"{{vm.selectLangText}}\" required=\"\" name=\"langCd\" id=\"langCd\" ng-model=\"vm.langCd\" ng-change=\"vm.changeLanguage()\"><option value=\"\" disabled=\"\">{{vm.selectLangText}}</option><option ng-repeat=\"lang in vm.languages\" value=\"{{lang.cd.toLowerCase()}}\">{{lang.nm}}</option></select></div></div><div style=\"display: flex; margin: 0px; align-items: center;\"><ul uib-pagination=\"\" total-items=\"totalObsvs\" ng-model=\"currentPage\" max-size=\"maxSize\" num-pages=\"numPages\" items-per-page=\"vm.obsvsPerPage\" boundary-links=\"true\" rotate=\"false\" class=\"pagination-sm\" style=\"flex: 61%; margin-top: 7px; margin-bottom: 5px;\"></ul><div style=\"display: flex; flex: 39%; float: right;\"><span class=\"form-control\" style=\"flex: 3%; border: none; padding-left: 15px;\">View</span><select class=\"form-control\" style=\"flex: 15%; height: 26.8px; padding: 1px 8px; margin-top: 3px; margin-left: -3px;\" ng-model=\"vm.obsvsPerPage\"><option value=\"10\" ng-selected=\"true\">10</option><option value=\"20\">20</option><option value=\"20\">30</option><option value=\"20\">40</option><option value=\"20\">50</option></select><span class=\"form-control\" style=\"flex: 82%; border: none; float: right; padding-left: 5px;\">Observations Per Page. &nbsp;&nbsp;Total Observation: {{totalObsvs}}</span></div></div></div></div></div><div ng-if=\"totalObsvs === 0\" class=\"message-info\"><span translate=\"obsv.portflObsvs.valid.noDataFound\"></span></div><div class=\"grid\" id=\"container\"><span ng-repeat=\"value in vm.observations | filterMultiple:{level2NodeId:vm.level2FilterVal, obsvPrioritySeq:vm.priorityFilterVal, typeCd: vm.typeFilterVal} | offset: currentPage*vm.obsvsPerPage | limitTo: vm.obsvsPerPage | groupBy:vm.groupByField | toArray:true | orderBy:\'parseInt(value.$key)\' : vm.groupByOrder\" on-finish-render=\"buildMasonryLayout\"><div class=\"grid-item gray-bg\"><div class=\"ibox\"><div class=\"ibox-content\"><div ng-if=\"vm.groupByField === \'level2NodeId\' || vm.groupByField === \'level3NodeId\'\" style=\"display: flex; flex-wrap: nowrap; align-items: baseline; border: 1px solid white;\" class=\"sectionNameWrapper highlight-on-hover\"><h3 ng-bind-html=\"vm.getGroup(value.$key, vm.groupByField).nm\" ng-click=\"vm.openSummernoteEditorDialog(\'hierNodeName\', \'Hierarchy Node Name\', vm.getGroup(value.$key, vm.groupByField).nm, vm.getGroup(value.$key, vm.groupByField), \'hierNode\')\" uib-tooltip=\"{{vm.getGroup(value.$key, vm.groupByField).nm}}\" style=\"margin-bottom: 11px;\"></h3></div><div ng-if=\"vm.groupByField !== \'level2NodeId\' && vm.groupByField !== \'level3NodeId\'\" style=\"display: flex; flex-wrap: nowrap; align-items: baseline; border: 1px solid white;\" class=\"sectionNameWrapper\"><h3 ng-bind-html=\"vm.getGroup(value.$key, vm.groupByField).nm\" style=\"margin-bottom: 11px;\"></h3></div><div ng-if=\"vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc) && vm.getGroup(value.$key, vm.groupByField).desc != null && (vm.groupByField === \'level2NodeId\' || vm.groupByField === \'level3NodeId\')\" uib-tooltip=\"{{vm.clickToUpdateSectionDescText}}\" class=\"message-help highlight-on-hover-help-text\" ng-class=\"{\'notext-editable\': !vm.getGroup(value.$key, vm.groupByField).desc}\"><p ng-bind-html=\"vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc)\" ng-click=\"vm.openSummernoteEditorDialog(\'hierNodeDesc\', \'Hierarchy Node Description\', vm.getGroup(value.$key, vm.groupByField).desc, vm.getGroup(value.$key, vm.groupByField), \'hierNode\')\" style=\"margin: 0 !important; padding: 0 !important;\"></p></div><div ng-if=\"!vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc) && vm.getGroup(value.$key, vm.groupByField).desc != null && (vm.groupByField === \'level2NodeId\' || vm.groupByField === \'level3NodeId\')\" class=\"message-help highlight-on-hover-help-text\" ng-class=\"{\'notext-editable\': !vm.getGroup(value.$key, vm.groupByField).desc}\"><p ng-bind-html=\"vm.clickToAddSectionDescText\" ng-click=\"vm.openSummernoteEditorDialog(\'hierNodeDesc\', \'Hierarchy Node Description\', vm.getGroup(value.$key, vm.groupByField).desc, vm.getGroup(value.$key, vm.groupByField), \'hierNode\')\" style=\"margin: 0 !important; padding: 0 !important;\"></p></div><ul ui-sortable=\"sortableOptions\" class=\"sortable-list connectList agile-list\" ng-model=\"todoList\"><li ng-if=\"value.length\" ng-repeat=\"obsv in value | orderBy:[vm.orderByField , \'obsvId\']\" obsv-side-bar=\"\" obsv-cnt-wgt=\"{{obsv.obsvPrioritySeq}}\" class=\"obsv-card-border obsv-wgt-{{obsv.obsvPrioritySeq}}\"><label style=\"display: inline-block; margin-right: 10px;\">Change Priority:</label><ul style=\"display: inline-block; list-style-type: none; margin: unset; padding: 0px;\"><li ng-repeat=\"priority in vm.obsvPriorityRefItems\" style=\"display: inline-flex; margin-right: 5px; border: none; padding: unset !important;\"><button ng-bind-html=\"vm.getHtmlSafeText(priority.nm)\" ladda=\"vm.priorityLadda\" class=\"btn btn-xs obsv-priority-{{priority.cd}}\" ng-click=\"vm.updateObsvPriority(obsv, priority.cd)\"></button></li></ul><div uib-tooltip=\"{{vm.clickToUpdateSectionDescText}}\" class=\"highlight-on-hover-help-text\" style=\"margin-bottom: 5px; padding: 5px !important; border-radius: 6px;\"><span ng-bind-html=\"vm.getHtmlSafeText(obsv.name)\" ng-click=\"vm.openSummernoteEditorDialog(\'assrtText\', \'Assertion Text\', obsv.name, obsv, \'obsv\')\" style=\"margin: 0 !important; padding: 0 !important;\"></span></div><div ng-show=\"obsv.desc\" uib-tooltip=\"{{vm.clickToUpdateSectionDescText}}\" class=\"message-help highlight-on-hover-help-text\"><p ng-bind-html=\"vm.getHtmlSafeText(obsv.desc)\" ng-click=\"vm.openSummernoteEditorDialog(\'detlText\', \'Detail Text\', obsv.desc, obsv, \'obsv\')\" style=\"margin: 0 !important; padding: 0 !important;\"></p></div><div ng-show=\"!obsv.desc\" class=\"message-help highlight-on-hover-help-text notext-editable\"><p ng-bind-html=\"vm.getHtmlSafeText(obsv.desc)\" ng-click=\"vm.openSummernoteEditorDialog(\'detlText\', \'Detail Text\', obsv.desc, obsv, \'obsv\')\" style=\"margin: 0 !important; padding: 0 !important;\"></p></div><div class=\"agile-detail\"><i class=\"fa fa-flag\"></i>&nbsp;{{obsv.type}}</div></li></ul></div></div></div></span></div><div ng-if=\"!vm.observations\" class=\"message-error\"><span translate=\"obsv.home.valid.noViewObsvPermsn\"></span></div>");
$templateCache.put("app/admin/observations/priority-filter-template.html","<script type=\"text/ng-template\" id=\"priority-filter-template.html\"><style> /**The style is added inside ng-template to just reflect scroll bar style for popups and not window scroll bars**/ *::-webkit-scrollbar, *::-webkit-scrollbar-thumb { width: 26px;height: 40%; border-radius: 13px; background-clip: padding-box; border: 10px solid transparent; } *::-webkit-scrollbar-thumb { box-shadow: inset 0 0 0 10px; } #modal-body-style { border-radius: 3px; overflow: auto; color: rgba(50,50,50, 0); text-shadow: 0 0 black; box-shadow: 0 1px 6px rgba(50,50,50, 0.2); transition: color .5s ease; max-height: calc(100vh - 250px); overflow: auto; } #modal-body-style:hover { color: rgba(50,50,50, 0.8); } #modal-body-style>ol,.modal-body>ol,li { color: #787878; } </style> <div style=\"overflow-y: hidden;\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span></button> <h2 class=\"modal-title\" id=\"modal-title\"> <span><i class=\"fa fa-flag idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"obsv.home.modal.whyThisObsvTitle\" translate-values=\"{obsvTypeName: modal.obsv.type}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body-style\"> <ul class=\"agile-list\" style=\"padding-left:0px; margin-top:-5px;\"> <li class=\"obsv-wgt-{{modal.obsv.obsvPrioritySeq}}\"> {{modal.obsv.name}} <a class=\"toggleLink collapsed\" data-toggle=\"collapse\" data-target=\"#obsvPop{{modal.obsv.obsvId}}\"></a> <div class=\"agile-detail\"> <div id=\"obsvPop{{modal.obsv.obsvId}}\" class=\"collapse message-help\"> <p ng-bind-html=\"modal.obsv.desc\"></p> </div> <i class=\"fa fa-flag\"></i>&nbsp;{{modal.obsv.type}} </div> </li> </ul> <p translate=\"obsv.home.modal.whyThisObsvExplText\" translate-values=\"{obsvTypeName: modal.obsv.type}\"></p> <div ng-repeat=\"rule in modal.obsv.obsvRules | orderBy:[\'subjStageId\', \'survSectSeq\', \'questSeq\']\" class=\"level3-score\" style=\"margin-left:2px; margin-top:5%;\"> <b>{{modal.getQuestionLabel(rule)}}</b> </br></br> <div class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-1\" translate=\"obsv.home.modal.whyThisObsvQuestLabel\"></span> <span class=\"col-sm-11\" ng-bind-html=\"rule.questText\"></span> </div> <div class=\"row\"> <span class=\"col-sm-1\" translate=\"obsv.home.modal.whyThisObsvAnswLabel\"></span> <span class=\"col-sm-11\"> <div ng-repeat=\"elem in rule.elements | orderBy: \'answElemSeq\'\"> <div ng-if=\"!elem.elemLabelText\" class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-12\" ng-bind-html=\"elem.survAnswText\"></span> </div> <div ng-if=\"elem.elemLabelText\" class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-12\">{{elem.elemLabelText}}:&nbsp;<b>{{elem.survAnswText}}</b></span> </div> </div> </span> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn idmx-link-btn\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\" translate=\"obsv.home.modal.whyThisObsvCloseButton\"> </button> </div> </div></script>");
$templateCache.put("app/admin/orgconnxn/add.html","<div class=\"ibox-content idmx-ibox-content\" ng-show=\"vm.org\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(newOrgConnxnForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"newOrgConnxnForm\"><div class=\"form-group\"><label style=\"margin-left:1%;margin-right:1%;font-weight:normal\" translate=\"sysAdmin.addOrgConnxn.addConnxnInstrText\"></label></div><div><div class=\"form-group\"><label class=\"control-label\" style=\"margin-left:1%;\" translate=\"sysAdmin.mangOrgConnxns.connxgTitle\"></label></div><div class=\"form-group\" ng-class=\"{\'has-error\': newOrgConnxnForm.userId.$invalid && newOrgConnxnForm.$submitted}\" ng-if=\"vm.hasMangSysPerm\"><label class=\"col-lg-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxgUsrId\"></label><div class=\"col-lg-10\"><select id=\"userId\" class=\"form-control\" name=\"userId\" ng-model=\"vm.orgconnxn.connxgUser.userId\" ng-disabled=\"vm.orgUsers.length === 0\" required=\"\" focus-on-load=\"\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.addOrgConnxn.selectConnxgUsrText\"></option><option ng-repeat=\"user in vm.connxgOrgUsers | orderBy:\'userLastFirstNamePlusOrgPlusId\'\" value=\"{{user.userId}}\">{{user.userLastFirstNamePlusOrgPlusId}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"newOrgConnxnForm.userId.$invalid && newOrgConnxnForm.$submitted\" ng-messages=\"newOrgConnxnForm.userId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.addOrgConnxn.valid.connxgUsrReqd\"></span></span></div></div><div class=\"form-group\" ng-if=\"!vm.hasMangSysPerm && vm.hasMangOrgPerm\"><label class=\"col-lg-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxgUsrId\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.orgconnxn.userLastFirstNamePlusOrgPlusId}}</div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"sysAdmin.mangOrgConnxns.connxgOrgName\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.orgconnxn.connxgOrg.orgName}}</div></div></div></div><div class=\"form-group\"><label class=\"control-label\" style=\"margin-left:1%;\" translate=\"sysAdmin.mangOrgConnxns.connxdTitle\"></label></div><div class=\"form-group\"><label class=\"col-lg-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxdUsrId\"></label><div ng-if=\"!vm.reconnect || (vm.reconnect && vm.hasMangOrgPerm)\" class=\"col-lg-10\" ng-class=\"{\'has-error\': newOrgConnxnForm.$dirty && (newOrgConnxnForm.$submitted || newOrgConnxnForm.connxdUserId.$dirty) && ( newOrgConnxnForm.connxdUserId.$error.required || newOrgConnxnForm.connxdUserId.$error.pattern || newOrgConnxnForm.connxdUserId.$error.nonexistingUser || newOrgConnxnForm.connxdUserId.$error.connxnAlreadyExist || newOrgConnxnForm.connxdUserId.$error.invalidSameOrg)}\"><div class=\"input-group\"><input id=\"connxdUserId\" name=\"connxdUserId\" type=\"text\" ng-model=\"vm.orgconnxn.connxdUser.userId\" ng-model-options=\"{updateOn:\'change blur\',debounce:{blur:0,change:0}}\" class=\"form-control\" ng-pattern=\"/^[^\\s@]+@([^\\s@.,]+\\.)+[^\\s@.,]{2,}$/\" ng-blur=\"vm.validateOrgConnxn(vm.orgconnxn.connxdUser.userId)\" required=\"\" ng-if=\"!vm.hasMangOrgPerm\"> <input id=\"connxdUserId\" name=\"connxdUserId\" type=\"text\" ng-model=\"vm.orgconnxn.connxdUser.userId\" ng-model-options=\"{updateOn:\'change blur\',debounce:{blur:0,change:0}}\" class=\"form-control\" ng-pattern=\"/^[^\\s@]+@([^\\s@.,]+\\.)+[^\\s@.,]{2,}$/\" ng-blur=\"vm.validateOrgConnxn(vm.orgconnxn.connxdUser.userId)\" required=\"\" focus-on-load=\"\" ng-if=\"vm.hasMangOrgPerm\"> <span class=\"input-group-btn\"><a class=\"btn btn-primary\" type=\"button\" id=\"validateBtn\" ng-click=\"vm.validateOrgConnxn()\" ng-disabled=\"!vm.orgconnxn.connxdUser.userId\" translate=\"sysAdmin.addOrgConnxn.valdConnxdOrgButton\"></a></span></div><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"newOrgConnxnForm.$dirty && (newOrgConnxnForm.$submitted || newOrgConnxnForm.connxdUserId.$dirty) && ( newOrgConnxnForm.connxdUserId.$error.required || newOrgConnxnForm.connxdUserId.$error.pattern || newOrgConnxnForm.connxdUserId.$error.nonexistingUser || newOrgConnxnForm.connxdUserId.$error.connxnAlreadyExist || newOrgConnxnForm.connxdUserId.$error.invalidSameOrg)\" ng-messages=\"newOrgConnxnForm.connxdUserId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.addOrgConnxn.valid.connxdUsrEmailAddrReqd\"></span> <span ng-message=\"pattern\" translate=\"sysAdmin.addOrgConnxn.valid.connxdUsrEmailAddrInvld\"></span> <span ng-message=\"nonexistingUser\" translate=\"sysAdmin.addOrgConnxn.valid.connxdUsrEmailAddrNotFound\"></span> <span ng-message=\"connxnAlreadyExist\">{{vm.connectionExistsMsg}}</span> <span ng-message=\"invalidSameOrg\" translate=\"sysAdmin.addOrgConnxn.valid.connxdOrgInvld\"></span></span></div><div ng-if=\"vm.reconnect && vm.hasMangSysPerm\" class=\"col-lg-10\" ng-class=\"{\'has-error\': newOrgConnxnForm.connxdUserId.$invalid && (newOrgConnxnForm.connxdUserId.$dirty || newOrgConnxnForm.$submitted)}\"><select id=\"connxdUserId\" class=\"form-control\" name=\"connxdUserId\" ng-model=\"vm.orgconnxn.connxdUser.userId\" required=\"\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.addOrgConnxn.selectConnxgUsrText\"></option><option ng-repeat=\"user in vm.connxdOrgUsers | orderBy:\'userId\'\" value=\"{{user.userId}}\">{{user.userId}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"newOrgConnxnForm.connxdUserId.$invalid && (newOrgConnxnForm.connxdUserId.$dirty || newOrgConnxnForm.$submitted)\" ng-messages=\"newOrgConnxnForm.connxdUserId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.addOrgConnxn.valid.connxgUsrReqd\"></span></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"sysAdmin.mangOrgConnxns.connxdName\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.orgconnxn.connxdUser.userLastFirstName}}</div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"sysAdmin.mangOrgConnxns.connxdOrgName\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.orgconnxn.connxdOrg.orgName}}</div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxnStatLabel\"></label><div class=\"col-sm-10\"><div class=\"radio-inline zero-left-padding\"><label><span class=\"lbl-status\">{{vm.pendingStatusLbl}}</span></label></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 0px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.admin.adminOrgs.orgconnxns({connxgOrgId: vm.connxgOrgId})\" style=\"margin-right: 5px;\" translate=\"sysAdmin.mangUsrs.cancelButton\"></button> <button class=\"btn btn-primary add-user-submit-btn\" id=\"btnSubmit\" type=\"submit\" ng-disabled=\"newOrgConnxnForm.$invalid && !newOrgConnxnForm.$dirty\" style=\"margin-right: 5px;\" translate=\"sysAdmin.addOrgConnxn.addButton\"></button></div></div></div></form></div></div></div></div></div><div ng-show=\"!vm.org\" class=\"message-error\"><span translate=\"sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn\"></span></div>");
$templateCache.put("app/admin/orgconnxn/edit.html","<div class=\"ibox-content idmx-ibox-content\" ng-if=\"vm.orgconnxn\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-keydown=\"vm.onKeyDown($event)\" name=\"editOrgConnxnForm\"><div class=\"form-group\"><label style=\"margin-left:1%;margin-right:1%;font-weight:normal\" translate=\"{{vm.instructionTxt}}\"></label></div><div class=\"form-group\"><label class=\"control-label\" style=\"margin-left:1%;\" translate=\"sysAdmin.mangOrgConnxns.connxgTitle\" required=\"\"></label></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxgUsrId\"></label><div class=\"col-sm-10\"><div class=\"control-text\">{{vm.orgconnxn.connxgUser.userLastFirstNamePlusOrgPlusId}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgConnxns.connxgOrgName\"></label><div class=\"col-sm-10\"><div class=\"control-text\">{{vm.orgconnxn.connxgOrg.orgName}}</div></div></div><div class=\"form-group\"><label class=\"control-label\" style=\"margin-left:1%;\" translate=\"sysAdmin.mangOrgConnxns.connxdTitle\"></label></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxdUsrId\" required=\"\"></label><div class=\"col-sm-10\"><div class=\"control-text\">{{vm.orgconnxn.connxdUser.userId}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgConnxns.connxdOrgName\"></label><div class=\"col-sm-10\"><div class=\"control-text\">{{vm.orgconnxn.connxdOrg.orgName}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgConnxns.connxnStatLabel\"></label><div class=\"col-sm-10\"><div class=\"radio-inline zero-left-padding\"><label><span class=\"lbl-status\">{{vm.statusName(vm.orgconnxn.connxnStatusCd)[0].nm}}</span></label></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 0px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: vm.orgId})\" style=\"margin-right: 5px;\" translate=\"sysAdmin.mangUsrs.cancelButton\"></button> <button ng-if=\"vm.applicableAction.accept === true\" ng-click=\"editOrgConnxnForm.$valid && vm.submit(editOrgConnxnForm, \'A\')\" class=\"btn btn-primary add-user-submit-btn\" id=\"btnAccept\" name=\"btnAccept\" type=\"button\" style=\"margin-right: 5px;\" translate=\"sysAdmin.updtOrgConnxn.accptButton\"></button> <button ng-if=\"vm.applicableAction.reject === true\" ng-click=\"editOrgConnxnForm.$valid && vm.submit(editOrgConnxnForm, \'J\')\" class=\"btn btn-primary add-user-submit-btn\" id=\"btnReject\" type=\"button\" style=\"margin-right: 5px;\" translate=\"sysAdmin.updtOrgConnxn.rejctButton\"></button> <button ng-if=\"vm.applicableAction.revoke === true\" ng-click=\"editOrgConnxnForm.$valid && vm.submit(editOrgConnxnForm, \'V\')\" class=\"btn btn-primary add-user-submit-btn\" id=\"btnRevoke\" name=\"btnRevoke\" type=\"button\" style=\"margin-right: 5px;\" translate=\"sysAdmin.updtOrgConnxn.revkButton\"></button> <button ng-if=\"vm.applicableAction.reconnect === true\" ng-click=\"editOrgConnxnForm.$valid && vm.reconnect()\" class=\"btn btn-primary add-user-submit-btn\" id=\"btnReconnect\" type=\"button\" style=\"margin-right: 5px;\" translate=\"sysAdmin.updtOrgConnxn.reconnxButton\"></button></div></div></div></form></div></div></div></div></div><div ng-if=\"!vm.orgconnxn\" class=\"message-error\"><span translate=\"sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn\"></span></div>");
$templateCache.put("app/admin/orgconnxn/orgconnxn.html","<div class=\"ibox-content idmx-ibox-content\" ng-if=\"vm.orgconnxns\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\">&nbsp;&nbsp; <button has-any-user-perms-disable=\"[\'MANG_SYS_ADMIN\',\'MANG_ORG_ADMIN\']\" type=\"button\" ui-sref=\"app.admin.adminOrgs.orgconnxns.addOrgConnxn({orgId: vm.orgId})\" class=\"idmx-link-btn add-org\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"sysAdmin.mangOrgConnxns.addOrgConnxnButton\"></span></button></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageOrgTab\" class=\"nav nav-tabs\"><li class=\"active\"><a orgs-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangOrgConnxns.actvTab\"></a></li><li><a orgs-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" ng-class=\"{active: active, disabled: disabled}\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangOrgConnxns.revkdTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><table active-org-connxn-dt=\"\" id=\"activeOrgsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangOrgs.nameHeader\"></th><th translate=\"sysAdmin.mangOrgs.refNumHeader\"></th><th translate=\"sysAdmin.mangOrgs.cntryHeader\"></th><th translate=\"sysAdmin.mangOrgs.statHeader\"></th><th translate=\"sysAdmin.mangOrgs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangOrgs.sysRolesHeader\"></th><th translate=\"sysAdmin.mangOrgs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"orgconnxn in vm.activeOrgconnxns\"><td><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\">{{orgconnxn.connxnOrg.orgName}}</a></td><td>{{orgconnxn.connxnOrg.orgRefNum}}</td><td>{{vm.cntryName(orgconnxn.connxnOrg.country)[0].nm}}</td><td><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\"><span ng-if=\"orgconnxn.connxnActionReqd\" class=\"lbl-status-negative\" uib-popover=\"{{\'sysAdmin.mangOrgs.help.actvConnxnsAttnReqdText\' | translate}}\" popover-title=\"{{\'sysAdmin.mangOrgs.statHeader\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.statusName(orgconnxn.connxnStatusCd)[0].nm}}</span> <span ng-if=\"!orgconnxn.connxnActionReqd\" class=\"lbl-status\">{{vm.statusName(orgconnxn.connxnStatusCd)[0].nm}}</span></a></td><td>{{orgconnxn.lastUpdtTmstmp}}</td><td><div ng-repeat=\"y in vm.orgRoleTypes | orderBy:\'dispSeq\'\"><div ng-repeat=\"x in orgconnxn.connxnOrg.roles\"><span ng-if=\"y.cd === vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangOrgs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\"><i class=\"fa fa-pencil-square-o\" uib-tooltip=\"{{\'sysAdmin.mangOrgConnxns.updtButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgConnxns.updtButton\"></span></a></li><li ng-if=\"orgconnxn.connecting === true && orgconnxn.connxnStatusCd === \'P\'\"><a ng-click=\"vm.resendInvite(orgconnxn.connxnOrg.orgId)\"><i class=\"fa fa-envelope-o\" uib-tooltip=\"{{\'sysAdmin.mangOrgConnxns.connxnEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgConnxns.connxnEmailButton\"></span></a></li></ul></div></td></tr></tbody></table></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-2\"><table archive-org-connxn-dt=\"\" id=\"archivedOrgsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangOrgs.nameHeader\"></th><th translate=\"sysAdmin.mangOrgs.refNumHeader\"></th><th translate=\"sysAdmin.mangOrgs.cntryHeader\"></th><th translate=\"sysAdmin.mangOrgs.statHeader\"></th><th translate=\"sysAdmin.mangOrgs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangOrgs.sysRolesHeader\"></th><th translate=\"sysAdmin.mangOrgs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"orgconnxn in vm.archivedOrgconnxns\"><td><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\">{{orgconnxn.connxnOrg.orgName}}</a></td><td>{{orgconnxn.connxnOrg.orgRefNum}}</td><td>{{vm.cntryName(orgconnxn.connxnOrg.country)[0].nm}}</td><td><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\"><span ng-if=\"orgconnxn.connxnActionReqd\" class=\"lbl-status-negative\" uib-popover=\"{{\'sysAdmin.mangOrgs.help.actvConnxnsAttnReqdText\' | translate}}\" popover-title=\"{{\'sysAdmin.mangOrgs.statHeader\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.statusName(orgconnxn.connxnStatusCd)[0].nm}}</span> <span ng-if=\"!orgconnxn.connxnActionReqd\" class=\"lbl-status\">{{vm.statusName(orgconnxn.connxnStatusCd)[0].nm}}</span></a></td><td>{{orgconnxn.lastUpdtTmstmp}}</td><td><div ng-repeat=\"y in vm.orgRoleTypes | orderBy:\'dispSeq\'\"><div ng-repeat=\"x in orgconnxn.connxnOrg.roles\"><span ng-if=\"y.cd === vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangOrgs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ui-sref=\"app.admin.adminOrgs.orgconnxns.editOrgConnxn({connxnOrgId: orgconnxn.connxnOrg.orgId, connecting: orgconnxn.connecting})\"><i class=\"fa fa-link\" uib-tooltip=\"{{\'sysAdmin.mangOrgConnxns.updtButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgConnxns.reconnxButton\"></span></a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div><div ng-if=\"!vm.orgconnxns\" class=\"message-error\"><span translate=\"sysAdmin.mangOrgConnxns.valid.noMangOrgConnxnsPermsn\"></span></div>");
$templateCache.put("app/admin/orgs/add.html","<div class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(orgForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"orgForm\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.organizationName.$invalid && (orgForm.organizationName.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgNameLabel\"></label><div class=\"col-sm-10\"><input id=\"organizationName\" name=\"organizationName\" class=\"form-control\" type=\"text\" ng-model=\"vm.org.orgName\" ng-model-options=\"{updateOn: \'blur\'}\" autofocus=\"\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.organizationName.$invalid && (orgForm.organizationName.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.organizationName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgNameReqd\"></span></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.orgRefNumber.$invalid && (orgForm.orgRefNumber.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.orgRefNumLabel\"></label><div class=\"col-sm-10\"><input id=\"orgRefNumber\" name=\"orgRefNumber\" class=\"form-control\" type=\"text\" autocomplete=\"off\" ng-model=\"vm.org.orgRefNum\" ng-model-options=\"{updateOn: \'blur\'}\" admin-add-org-ref-num=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.orgRefNumber.$invalid && (orgForm.orgRefNumber.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.orgRefNumber.$error\"><span ng-message=\"refNumExists\" translate=\"sysAdmin.mangOrgs.valid.orgRefNumExist\"></span></span></div></div><div ng-if=\"vm.hasMangSysPerm\" class=\"form-group\" ng-class=\"{\'has-error\': (noParentOrgId === true && orgForm.parentOrgId.$viewValue !== \'\') && (orgForm.parentOrgId.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.parntOrgLabel\"></label><div class=\"col-sm-10\"><input id=\"parentOrgId\" name=\"parentOrgId\" class=\"typeahead form-control\" type=\"text\" ng-model=\"vm.selectedParentOrg\" placeholder=\"{{\'sysAdmin.mangOrgs.selectParntOrgText\' | translate}}\" uib-typeahead=\"org as [org.desc] for org in vm.parentOrgs | filter:{desc:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onParentOrgSelect($item, $model)\" typeahead-no-results=\"noParentOrgId\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\"> <span class=\"help-block m-b-none\" ng-show=\"(noParentOrgId === true && orgForm.parentOrgId.$viewValue !== \'\') && (orgForm.parentOrgId.$dirty || orgForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: orgForm.parentOrgId.$viewValue}\"></span></span></div></div><div ng-if=\"vm.hasMangOrgPerm && !vm.hasMangSysPerm\" class=\"form-group\" ng-class=\"{\'has-error\': orgForm.parentOrgId.$invalid && (orgForm.parentOrgId.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.parntOrgLabel\"></label><div class=\"col-sm-10\" ng-if=\"vm.parentOrgs.length > 1\"><select class=\"form-control\" name=\"parentOrgId\" id=\"parentOrgId\" ng-model=\"vm.org.parentOrgId\" ng-change=\"vm.onSelectParent()\" required=\"\"><option selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.mangOrgs.selectParntOrgText\"></option><option ng-repeat=\"org in vm.parentOrgs\" value=\"{{org.orgId}}\">{{org.desc}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.parentOrgId.$invalid && (orgForm.parentOrgId.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.parentOrgId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.parntOrgReqd\"></span></span></div><div class=\"col-sm-10\" ng-if=\"vm.parentOrgs.length === 1\"><div class=\"control-text\">{{vm.parentOrgName}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgStatLabel\"></label><div class=\"col-sm-10\"><div class=\"radio-inline zero-left-padding\"><label><span class=\"lbl-status\">{{vm.activeStatusLbl}}</span></label></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgRolesLabel\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"role in vm.orgRoleTypes | orderBy:\'dispSeq\'\"><input id=\"systemRoles\" name=\"systemRoles\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.orgRoles[role.cd]\" ng-required=\"vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)\" ng-change=\"vm.roleChange()\"> <label class=\"lbl-roles-container\"><span class=\"lbl-roles\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{role.nm}}\" uib-popover=\"{{role.desc}}\">{{role.nm}}</span></label></div><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)\" ng-messages=\"orgForm.systemRoles.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgRoleReqd\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.enterAddrLabel\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\"><input id=\"enterOrgAddress\" name=\"enterOrgAddress\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.enterOrgAddress\"></div></div></div><div ng-show=\"vm.enterOrgAddress\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.addrLine1.$invalid && (orgForm.addrLine1.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgAddrLine1Label\"></label><div class=\"col-sm-10\"><input id=\"addrLine1\" name=\"addrLine1\" class=\"form-control\" type=\"text\" ng-model=\"vm.org.addrLine1\" autocomplete=\"off\" ng-model-options=\"{updateOn: \'blur\'}\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.addrLine1.$invalid && (orgForm.addrLine1.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.addrLine1.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgAddrLine1Reqd\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.orgAddrLine2Label\"></label><div class=\"col-sm-10\"><input type=\"text\" ng-model=\"vm.org.addrLine2\" autocomplete=\"off\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\" style=\"margin-bottom: 5px;\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgCityLabel\"></label><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.city.$invalid && (orgForm.city.$dirty || orgForm.$submitted)}\"><div class=\"col-sm-12\"><input id=\"city\" name=\"city\" class=\"form-control\" type=\"text\" ng-model=\"vm.org.city\" autocomplete=\"off\" ng-model-options=\"{updateOn: \'blur\'}\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.city.$invalid && (orgForm.city.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.city.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgCityReqd\"></span></span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate=\"sysAdmin.mangOrgs.orgRegnLabel\"></label><div class=\"col-lg-8\"><input type=\"text\" ng-model=\"vm.org.regnName\" autocomplete=\"off\" ng-model-options=\"{updateOn: \'blur\'}\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div></div><div class=\"col-lg-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.postalCode.$invalid && (orgForm.postalCode.$dirty || orgForm.$submitted)}\"><label class=\"col-lg-6 control-label required\" translate=\"sysAdmin.mangOrgs.orgPostCdLabel\"></label><div class=\"col-lg-6\"><input id=\"postalCode\" name=\"postalCode\" class=\"form-control\" type=\"text\" ng-model=\"vm.org.postCode\" autocomplete=\"off\" ng-model-options=\"{updateOn: \'blur\'}\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.postalCode.$invalid && (orgForm.postalCode.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.postalCode.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgPostCdReqd\"></span></span></div></div></div><div class=\"col-lg-1\"><div class=\"form-group\" style=\"height: 15px;\"><label class=\"col-sm-2 control-label\">&nbsp;</label><div class=\"col-sm-10\"></div></div></div></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (orgForm.country.$invalid || noCntry === true) && (orgForm.country.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgCntryLabel\"></label><div class=\"col-sm-10\"><input id=\"country\" name=\"country\" type=\"text\" ng-model=\"mbSelected\" class=\"typeahead form-control\" placeholder=\"{{\'sysAdmin.mangOrgs.selectCntryText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.countries | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onSelect()\" typeahead-no-results=\"noCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(orgForm.country.$invalid && (orgForm.country.$dirty || orgForm.$submitted))\" ng-messages=\"orgForm.country.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgCntryReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noCntry === true && orgForm.country.$viewValue !== \'\') && (orgForm.country.$dirty || orgForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: orgForm.country.$viewValue}\"></span></span></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><a class=\"btn btn-default form-reset-button\" ng-click=\"vm.cancel()\" translate=\"sysAdmin.mangOrgs.cancelButton\"></a> <button class=\"btn btn-primary\" id=\"btnSubmit\" ng-disabled=\"vm.setOrgRoles()\" type=\"submit\" translate=\"sysAdmin.addOrg.addButton\"></button></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/orgs/edit.html","<div ng-if=\"vm.hasOrgPerm()\" class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(orgForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"orgForm\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.organizationName.$invalid && (orgForm.organizationName.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgNameLabel\"></label><div class=\"col-sm-10\"><input id=\"organizationName\" name=\"organizationName\" type=\"text\" class=\"form-control\" ng-model=\"vm.org.orgName\" ng-model-options=\"{updateOn: \'blur\'}\" autofocus=\"\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.organizationName.$invalid && (orgForm.organizationName.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.organizationName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgNameReqd\"></span></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.orgRefNumber.$invalid && (orgForm.orgRefNumber.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.orgRefNumLabel\"></label><div class=\"col-sm-10\"><input id=\"orgRefNumber\" name=\"orgRefNumber\" type=\"text\" class=\"form-control\" autocomplete=\"off\" ng-model=\"vm.org.orgRefNum\" ng-model-options=\"{updateOn: \'blur\'}\" admin-edit-org-ref-num=\"\" orgid=\"vm.org.orgId\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.orgRefNumber.$invalid && (orgForm.orgRefNumber.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.orgRefNumber.$error\"><span ng-message=\"refNumExists\" translate=\"sysAdmin.mangOrgs.valid.orgRefNumExist\"></span></span></div></div><div ng-if=\"vm.hasMangSysPerm\" class=\"form-group\" ng-class=\"{\'has-error\': (noParentOrgId === true && orgForm.parentOrgId.$viewValue !== \'\') && (orgForm.parentOrgId.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.parntOrgLabel\"></label><div class=\"col-sm-10\"><input id=\"parentOrgId\" name=\"parentOrgId\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.selectedParentOrg\" placeholder=\"{{\'sysAdmin.mangOrgs.selectParntOrgText\' | translate}}\" uib-typeahead=\"org as [org.desc] for org in vm.parentOrgs | filter:{desc:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onParentOrgSelect($item, $model)\" typeahead-no-results=\"noParentOrgId\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" admin-edit-parent-org=\"\"> <span class=\"help-block m-b-none\" ng-show=\"(noParentOrgId === true && orgForm.parentOrgId.$viewValue !== \'\') && (orgForm.parentOrgId.$dirty || orgForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: orgForm.parentOrgId.$viewValue}\"></span></span></div></div><div ng-if=\"vm.hasMangOrgPerm && !vm.hasMangSysPerm\" class=\"form-group\" ng-class=\"{\'has-error\': orgForm.parentOrgId.$invalid && (orgForm.parentOrgId.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.parntOrgLabel\"></label><div class=\"col-sm-10\" ng-if=\"!vm.isUserOrg() && vm.parentOrgs.length > 1\"><select class=\"form-control\" name=\"parentOrgId\" id=\"parentOrgId\" ng-model=\"vm.org.parentOrgId\" ng-change=\"vm.onSelectParent(this)\" convert-to-number=\"\" required=\"\"><option selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.mangOrgs.selectParntOrgText\"></option><option ng-repeat=\"org in vm.parentOrgs\" value=\"{{org.orgId}}\">{{org.desc}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.parentOrgId.$invalid && (orgForm.parentOrgId.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.parentOrgId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.parntOrgReqd\"></span></span></div><div class=\"col-sm-10\" ng-if=\"vm.isUserOrg() || vm.parentOrgs.length === 1\"><div class=\"control-text\">{{vm.parentOrgName}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgStatLabel\"></label><div class=\"col-sm-10\"><span class=\"lbl-status\" ng-bind=\"vm.statusName(vm.org.orgStatCd)[0].nm\"></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgRolesLabel\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px;\" ng-repeat=\"role in vm.orgRoleTypes | orderBy:\'dispSeq\'\"><span popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{role.popoverTitle}}\" uib-popover=\"{{role.popoverMsg}}\"><input id=\"systemRoles\" name=\"systemRoles\" type=\"checkbox\" icheck=\"\" ng-model=\"vm.orgRoles[role.cd]\" ng-value=\"role.cd\" ng-required=\"vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)\" ng-change=\"vm.roleChange()\" ng-disabled=\"vm.isSysRoleDisabled(role.cd)\"></span> <label class=\"lbl-roles-container\"><span class=\"lbl-roles\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{role.nm}}\" uib-popover=\"{{role.desc}}\">{{role.nm}}</span></label></div><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"vm.org.roles.length === 0 && (vm.systemRolesDirty || orgForm.$submitted)\" ng-messages=\"orgForm.systemRoles.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgRoleReqd\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.enterAddrLabel\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\"><input id=\"enterOrgAddress\" name=\"enterOrgAddress\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.enterOrgAddress\"></div></div></div><div ng-show=\"vm.enterOrgAddress\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.addrLine1.$invalid && (orgForm.addrLine1.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgAddrLine1Label\"></label><div class=\"col-sm-10\"><input id=\"addrLine1\" name=\"addrLine1\" type=\"text\" class=\"form-control\" ng-model=\"vm.org.addrLine1\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.addrLine1.$invalid && (orgForm.addrLine1.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.addrLine1.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgAddrLine1Reqd\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangOrgs.orgAddrLine2Label\"></label><div class=\"col-sm-10\"><input type=\"text\" ng-model=\"vm.org.addrLine2\" autocomplete=\"off\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\" style=\"margin-bottom: 5px;\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgCityLabel\"></label><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.city.$invalid && (orgForm.city.$dirty || orgForm.$submitted)}\"><div class=\"col-sm-12\"><input id=\"city\" name=\"city\" type=\"text\" class=\"form-control\" ng-model=\"vm.org.city\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.city.$invalid && (orgForm.city.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.city.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgCityReqd\"></span></span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate=\"sysAdmin.mangOrgs.orgRegnLabel\"></label><div class=\"col-lg-8\"><input type=\"text\" ng-model=\"vm.org.regnName\" autocomplete=\"off\" ng-model-options=\"{updateOn: \'blur\'}\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div></div><div class=\"col-lg-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': orgForm.postalCode.$invalid && (orgForm.postalCode.$dirty || orgForm.$submitted)}\"><label class=\"col-lg-6 control-label required\" translate=\"sysAdmin.mangOrgs.orgPostCdLabel\"></label><div class=\"col-lg-6\"><input id=\"postalCode\" name=\"postalCode\" type=\"text\" class=\"form-control\" ng-model=\"vm.org.postCode\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"orgForm.postalCode.$invalid && (orgForm.postalCode.$dirty || orgForm.$submitted)\" ng-messages=\"orgForm.postalCode.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgPostCdReqd\"></span></span></div></div></div><div class=\"col-lg-1\"><div class=\"form-group\" style=\"height: 15px;\"><label class=\"col-sm-2 control-label\">&nbsp;</label><div class=\"col-sm-10\"></div></div></div></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (orgForm.country.$invalid || noCntry === true) && (orgForm.country.$dirty || orgForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangOrgs.orgCntryLabel\"></label><div class=\"col-sm-10 country\"><input id=\"country\" name=\"country\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.selectedCountry\" placeholder=\"{{\'sysAdmin.mangOrgs.selectCntryText\' | translate}}\" uib-typeahead=\"c as [c.nm] for c in vm.countries | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onSelect($item, $model)\" typeahead-no-results=\"noCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" admin-edit-org-country=\"\" ng-required=\"vm.enterOrgAddress\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(orgForm.country.$invalid && (orgForm.country.$dirty || orgForm.$submitted))\" ng-messages=\"orgForm.country.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangOrgs.valid.orgCntryReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noCntry === true && orgForm.country.$viewValue !== \'\') && (orgForm.country.$dirty || orgForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: orgForm.country.$viewValue}\"></span></span></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 20px;\"><a class=\"btn btn-default form-reset-button\" ng-click=\"vm.cancel()\" translate=\"sysAdmin.mangOrgs.cancelButton\"></a> <button class=\"btn btn-primary\" id=\"btnSubmit\" ng-disabled=\"vm.setOrgRoles()\" type=\"submit\" translate=\"sysAdmin.updtOrg.updtButton\"></button></div></div></div></form></div></div></div></div></div><div ng-if=\"!vm.hasOrgPerm()\" class=\"message-error\"><span translate=\"sysAdmin.updtOrg.valid.noUpdtOrgPermsn\"></span></div>");
$templateCache.put("app/admin/orgs/orgHierarchy.html","<style>\n    .table-bordered > thead > tr > th, .table-bordered > thead > tr > td {\n        background-color: unset;\n    }\n</style><div class=\"ibox-content idmx-ibox-content animated fadeInRight\"><div class=\"panel-body idmx-panel-body\"><div class=\"row\" style=\"padding-bottom: 5px;\"><a><i class=\"fa fa-arrow-left\"></i> <span ng-click=\"vm.backToOrg()\" translate=\"sysAdmin.mangOrgHier.backToMangOrgs\"></span></a></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><table hierarchy-orgs-dt=\"\" id=\"hierarchyOrgsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr style=\"font-weight: bold;\"><td translate=\"sysAdmin.mangOrgs.hierHeader\"></td><td translate=\"sysAdmin.mangOrgs.nameHeader\"></td><td translate=\"sysAdmin.mangOrgs.refNumHeader\"></td><td translate=\"sysAdmin.mangOrgs.cntryHeader\"></td><td translate=\"sysAdmin.mangOrgs.statHeader\"></td><td translate=\"sysAdmin.mangOrgs.lastUpdtHeader\"></td><td translate=\"sysAdmin.mangOrgs.sysRolesHeader\"></td><td has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\" translate=\"sysAdmin.mangOrgs.actvConnxnsHeader\"></td><td translate=\"sysAdmin.mangOrgs.actvUsrsHeader\"></td><td translate=\"sysAdmin.mangOrgs.actnsHeader\"></td></tr></thead><tbody><tr ng-repeat=\"org in vm.rowNodes\" id=\"{{org.orgId}}\"><td style=\"text-align: center;\"><a ng-if=\"!org.isParentOrg || (org.isParentOrg && org.isUserOrg)\" ui-sref=\"app.admin.adminOrgs.orgHierarchy({orgId: org.orgId})\"><span uib-tooltip=\"{{\'sysAdmin.mangOrgs.help.\' + vm.getHierachyPosition(org) + \'HierText\' | translate}}\"><img ng-src=\"{{\'/app/assets/images/org-hier/\' + vm.getHierachyPosition(org) + \'.png?bust=1698805291615\'}}\"></span></a> <span ng-if=\"org.isParentOrg && !org.isUserOrg\" style=\"cursor: not-allowed !important\"><span uib-tooltip=\"{{\'sysAdmin.mangOrgs.help.\' + vm.getHierachyPosition(org) + \'HierText\' | translate}}\"><img ng-src=\"{{\'/app/assets/images/org-hier/\' + vm.getHierachyPosition(org) + \'.png?bust=1698805291615\'}}\"></span></span></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><span ng-if=\"org.isParentOrg\"><span ng-if=\"org.lvl > 15\" style=\"display: flex;\"><span ng-if=\"org.childIds && org.childIds.length > 0\" style=\"margin-left:{{org.lvlStyle}}; margin-right: 15px;\"><i class=\"idmx-arrow idmx-arrow-down\"></i></span> {{org.orgName}}</span> <span ng-if=\"org.lvl === 15\" style=\"display: flex;\"><span ng-if=\"org.childIds && org.childIds.length > 0\" style=\"margin-left:{{org.lvlStyle}}; margin-right: 15px;\"><i class=\"idmx-arrow idmx-arrow-down\"></i></span> {{org.orgName}}</span></span><span ng-if=\"!org.isParentOrg\"><span ng-if=\"org.lvl > 15\" style=\"display: flex;\"><span style=\"margin-left:{{org.lvlStyle}}; margin-right: 15px;\"><span ng-if=\"org.childOrgs && org.childOrgs.length > 0\"><span ng-click=\"vm.collapse(org, true)\" id=\"down-{{org.orgId}}\"><i class=\"idmx-arrow idmx-arrow-down\"></i></span> <span ng-click=\"vm.expand(org)\" id=\"up-{{org.orgId}}\" style=\"display:none\"><i class=\"idmx-arrow idmx-arrow-right\"></i></span></span></span> <a ui-sref=\"app.admin.adminOrgs.adminEditOrg({orgId: org.orgId})\">{{org.orgName}}</a></span> <span ng-if=\"org.lvl === 15\" style=\"display: flex;\"><span style=\"margin-left:{{org.lvlStyle}}; margin-right: 15px;\" ng-if=\"org.childOrgs && org.childOrgs.length > 0\"><span ng-click=\"vm.collapse(org, true)\" id=\"down-{{org.orgId}}\"><i class=\"idmx-arrow idmx-arrow-down\"></i></span> <span ng-click=\"vm.expand(org)\" id=\"up-{{org.orgId}}\" style=\"display:none\"><i class=\"idmx-arrow idmx-arrow-right\"></i></span></span> <a ui-sref=\"app.admin.adminOrgs.adminEditOrg({orgId: org.orgId})\">{{org.orgName}}</a></span></span></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><span ng-if=\"!org.isParentOrg\">{{org.orgRefNum}}</span></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><span ng-if=\"!org.isParentOrg\">{{vm.cntryName(org.country)[0].nm}}</span></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><span class=\"lbl-status\" ng-if=\"!org.isParentOrg\">{{vm.statusName(org.orgStatCd)[0].nm}}</span></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\">{{!org.isParentOrg ? org.lastUpdtTmstmp : \'\'}}</td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><div ng-if=\"!org.isParentOrg\" ng-repeat=\"y in vm.orgRoleTypeList | orderBy:\'dispSeq\'\"><div ng-repeat=\"x in org.roles\"><span ng-if=\"y.cd === vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\" has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\"><a ng-if=\"!org.isParentOrg\" ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: org.orgId})\"><span ng-if=\"org.connxnActionReqd\" class=\"badge-negative\" uib-popover=\"{{\'sysAdmin.mangOrgs.help.actvConnxnsAttnReqdText\' | translate}}\" popover-title=\"{{\'sysAdmin.mangOrgs.actvConnxnsHeader\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{org.activeConnxnCount}}</span> <span ng-if=\"!org.connxnActionReqd\" class=\"badge-orgs-connx\">{{org.activeConnxnCount}}</span></a></td><td ng-class=\"{\'no-right-border\': org.isParentOrg}\"><span class=\"badge-counts\" ng-if=\"!org.isParentOrg\">{{org.orgUsrCount}}</span></td><td nowrap=\"\"><div ng-if=\"!org.isParentOrg\" uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangOrgs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li has-any-user-perms-disable=\"[\'MANG_SYS_ADMIN\',\'MANG_ORG_ADMIN\']\"><a ng-click=\"vm.addChild(org.orgId)\"><i class=\"fa fa-plus\" uib-tooltip=\"{{\'sysAdmin.mangOrgHier.addChildButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgHier.addChildButton\"></span></a></li><li><a ui-sref=\"app.admin.adminOrgs.adminEditOrg({orgId: org.orgId})\"><i class=\"fa fa-pencil-square-o\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.updtButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.updtButton\"></span></a></li><li has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\"><a ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: org.orgId})\"><i class=\"fa fa-link\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.connxButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.connxnsButton\"></span></a></li><li ng-init=\"hasChildren = vm.hasChildren(org)\"><a ng-if=\"!hasChildren\" ng-click=\"vm.openConfirmDialog($event,\'Archive\', org)\"><i class=\"fa fa-archive\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.archvButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.archvButton\"></span></a> <span class=\"disabledAction\" ng-if=\"hasChildren\"><a><i class=\"fa fa-archive\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.archvButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.archvButton\"></span></a></span></li></ul></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin/orgs/orgs.html","<div class=\"ibox-content idmx-ibox-content\" ng-if=\"!vm.treeView\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\">&nbsp;&nbsp; <button has-any-user-perms-disable=\"[\'MANG_SYS_ADMIN\', \'MANG_ORG_ADMIN\']\" type=\"button\" ui-sref=\"app.admin.adminOrgs.adminAddOrg\" class=\"idmx-link-btn add-org\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"sysAdmin.mangOrgs.addOrgButton\"></span></button></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageOrgTab\" class=\"nav nav-tabs\"><li class=\"active\"><a orgs-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangOrgs.actvTab\"></a></li><li><a orgs-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" ng-class=\"{active: active, disabled: disabled}\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangOrgs.archvdTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><table active-orgs-dt=\"\" id=\"activeOrgsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangOrgs.hierHeader\"></th><th translate=\"sysAdmin.mangOrgs.nameHeader\"></th><th translate=\"sysAdmin.mangOrgs.refNumHeader\"></th><th translate=\"sysAdmin.mangOrgs.cntryHeader\"></th><th translate=\"sysAdmin.mangOrgs.statHeader\"></th><th translate=\"sysAdmin.mangOrgs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangOrgs.sysRolesHeader\"></th><th has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\" translate=\"sysAdmin.mangOrgs.actvConnxnsHeader\"></th><th translate=\"sysAdmin.mangOrgs.actvUsrsHeader\"></th><th translate=\"sysAdmin.mangOrgs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"org in vm.activeOrgs\"><td data-sort=\"{{vm.getHierarchySortPosition(org)}}\" style=\"text-align: center;\"><a ui-sref=\"app.admin.adminOrgs.orgHierarchy({orgId: org.orgId})\"><span uib-tooltip=\"{{\'sysAdmin.mangOrgs.help.\' + vm.getHierachyPosition(org) + \'HierText\' | translate}}\"><img ng-src=\"{{\'/app/assets/images/org-hier/\' + vm.getHierachyPosition(org) + \'.png?bust=1698805291615\'}}\"></span></a></td><td><a ui-sref=\"app.admin.adminOrgs.adminEditOrg({orgId: org.orgId})\">{{org.orgName}}</a></td><td>{{org.orgRefNum}}</td><td>{{vm.cntryName(org.country)[0].nm}}</td><td><span class=\"lbl-status\">{{vm.statusName(org.orgStatCd)[0].nm}}</span></td><td>{{org.lastUpdtTmstmp}}</td><td><div ng-repeat=\"y in vm.orgRoleTypes | orderBy: \'dispSeq\'\"><div ng-repeat=\"x in org.roles\"><span ng-if=\"y.cd === vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\"><a ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: org.orgId})\"><span ng-if=\"org.connxnActionReqd\" class=\"badge-negative\" uib-popover=\"{{\'sysAdmin.mangOrgs.help.actvConnxnsAttnReqdText\' | translate}}\" popover-title=\"{{\'sysAdmin.mangOrgs.actvConnxnsHeader\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{org.activeConnxnCount}}</span> <span ng-if=\"!org.connxnActionReqd\" class=\"badge-orgs-connx\">{{org.activeConnxnCount}}</span></a></td><td><span class=\"badge-counts\">{{org.orgUsrCount}}</span></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangOrgs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ui-sref=\"app.admin.adminOrgs.adminEditOrg({orgId: org.orgId})\"><i class=\"fa fa-pencil-square-o\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.updtButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.updtButton\"></span></a></li><li><a ui-sref=\"app.admin.adminOrgs.orgHierarchy({orgId: org.orgId})\"><i class=\"fa fa-sitemap\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.orgHierButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.orgHierButton\"></span></a></li><li has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\"><a ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: org.orgId})\"><i class=\"fa fa-link\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.connxButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.connxnsButton\"></span></a></li><li ng-init=\"hasChildren = vm.hasChildren(org)\"><a ng-if=\"!hasChildren\" ng-click=\"vm.openConfirmDialog($event, \'Archive\', org)\"><i class=\"fa fa-archive\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.archvButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.archvButton\"></span></a> <span class=\"disabledAction\" ng-if=\"hasChildren\"><a><i class=\"fa fa-archive\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.archvButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.archvButton\"></span></a></span></li></ul></div></td></tr></tbody></table></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-2\"><table archive-orgs-dt=\"\" id=\"archivedOrgsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangOrgs.nameHeader\"></th><th translate=\"sysAdmin.mangOrgs.refNumHeader\"></th><th translate=\"sysAdmin.mangOrgs.cntryHeader\"></th><th translate=\"sysAdmin.mangOrgs.statHeader\"></th><th translate=\"sysAdmin.mangOrgs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangOrgs.sysRolesHeader\"></th><th has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\" translate=\"sysAdmin.mangOrgs.actvConnxnsHeader\"></th><th translate=\"sysAdmin.mangOrgs.actvUsrsHeader\"></th><th translate=\"sysAdmin.mangOrgs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"org in vm.archivedOrgs\"><td>{{org.orgName}}</td><td>{{org.orgRefNum}}</td><td>{{vm.cntryName(org.country)[0].nm}}</td><td><span class=\"lbl-status\">{{vm.statusName(org.orgStatCd)[0].nm}}</span></td><td>{{org.lastUpdtTmstmp}}</td><td><div ng-repeat=\"y in vm.orgRoleTypes | orderBy: \'dispSeq\'\"><div ng-repeat=\"x in org.roles\"><span ng-if=\"y.cd === vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td has-any-user-perms=\"[\'MANG_ORG_CONNXNS\']\"><a ui-sref=\"app.admin.adminOrgs.orgconnxns({orgId: org.orgId})\"><span ng-if=\"org.connxnActionReqd\" class=\"badge-negative\" uib-popover=\"{{\'sysAdmin.mangOrgs.help.actvConnxnsAttnReqdText\' | translate}}\" popover-title=\"{{\'sysAdmin.mangOrgs.actvConnxnsHeader\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{org.activeConnxnCount}}</span> <span ng-if=\"!org.connxnActionReqd\" class=\"badge-orgs-connx\">{{org.activeConnxnCount}}</span></a></td><td><span class=\"badge-counts\">{{org.orgUsrCount}}</span></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangOrgs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ng-if=\"org.parentStatCd === \'A\'\" ng-click=\"vm.openConfirmDialog($event, \'Restore\', org)\"><i class=\"fa fa-undo\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.restrButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.restrButton\"></span></a> <span ng-if=\"org.parentStatCd !== \'A\'\" class=\"disabledAction\"><a><i class=\"fa fa-undo\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.restrButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.restrButton\"></span></a></span></li><li><a ng-click=\"vm.openConfirmDialog($event,\'Delete\', org)\"><i class=\"fa fa-trash\" uib-tooltip=\"{{\'sysAdmin.mangOrgs.delButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangOrgs.delButton\"></span></a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/settings/settings.html","<div class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\"></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageSubjTab\" class=\"nav nav-tabs\"><li id=\"tab-1-li\" class=\"active\"><a setting-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\"><span translate=\"sysAdmin.mangSettings.parmsTab\"></span></a></li><li id=\"tab-2-li\"><a setting-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" ng-class=\"{active: active, disabled: disabled}\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\"><span translate=\"sysAdmin.mangSettings.docsTab\"></span></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(sysParmForm)\" name=\"sysParmForm\" ng-keydown=\"vm.onKeyDown($event)\"><div style=\"margin-top: 10px; margin-bottom:10px;\"><p translate=\"sysAdmin.mangSettings.parmsInstrText\"></p></div><table settings-sys-parm-dt=\"\" id=\"sysParmTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th>#</th><th translate=\"sysAdmin.mangSettings.parmsCodeHeader\"></th><th translate=\"sysAdmin.mangSettings.parmsValHeader\"></th><th translate=\"sysAdmin.mangSettings.parmsLastUpdtHeader\"></th></tr></thead></table><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\"><button class=\"btn btn-default form-reset-button\" type=\"button\" ng-click=\"vm.resetForm($event)\" ng-disabled=\"vm.disableReset\" aria-label=\"Reset Changes\" translate=\"sysAdmin.mangSettings.parmsResetButton\"></button> <button class=\"btn btn-primary\" id=\"btnUpdate\" type=\"submit\" disabled=\"\" ng-disabled=\"sysParmForm.$invalid\" translate=\"sysAdmin.mangSettings.parmsUpdtButton\"></button></div></div></div></form></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-2\"><div style=\"margin-top: 10px; margin-bottom:10px;\"><p translate=\"sysAdmin.mangSettings.docsInstrText\"></p></div><table settings-sys-doc-dt=\"\" id=\"sysDocTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangSettings.docsNameHeader\"></th><th translate=\"sysAdmin.mangSettings.docsLangHeader\"></th><th translate=\"sysAdmin.mangSettings.docsFileNameHeader\"></th><th translate=\"sysAdmin.mangSettings.docsFileSizeHeader\"></th><th translate=\"sysAdmin.mangSettings.docsUplddByHeader\"></th><th translate=\"sysAdmin.mangSettings.docsUpldDtHeader\"></th><th translate=\"sysAdmin.mangSettings.docsActnsHeader\"></th></tr></thead></table></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"sysDoc-browse-button-template.html\"><div style=\"max-height:650px;overflow-y: hidden;\"> <form class=\"form-horizontal\" name=\"uploadform\" id=\"uploadform\" method=\"POST\" enctype=\"multipart/form-data\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel(myFile)\"> <span aria-hidden=\"true\">×</span> <span class=\"sr-only\" translate=\"Close\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body-style\"> <span translate=\"sysAdmin.mangSettings.modal.upldDocText\"></span> <ul class=\"browse-modal-list\"> <li ng-repeat=\"file in myFile\" ng-if=\"$index < 1\">{{file.name}}<span style=\"color:#ED5565;\" ng-show=\"file.size>modal.maxUploadSize\"> *</span></li> </ul> <span class=\"file-upload-error\" id=\"file_upload_error\" translate=\"sysAdmin.mangSettings.valid.fileSizeInvld\" translate-values=\"{\'fileSize\': \'{{modal.maxUploadSize | fileSize}}\' }\"></span> <span class=\"btn idmx-link-btn custom-btn-file\" style=\"margin-top:10px;\"> <input type=\"file\" file-modal=\"$parent.myFile\" id=\"file\" name=\"file\" max-length=\"{{modal.maxUploadSize}}\" multiple/> <span translate=\"sysAdmin.mangSettings.modal.upldDocBrowseButton\"></span> </span> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"modal.cancel(myFile)\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button id=\"file-upload-btn\" ng-disabled=\'true\' ladda=\"vm.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div> </form> </div></script>");
$templateCache.put("app/admin/surveys/author.surveys.html","<div class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\"><form novalidate=\"\" ng-submit=\"vm.changeLanguage()\" name=\"changeLanguageForm\"><div style=\"display: flex; flex-wrap: nowrap;\"><div style=\"margin-right: 5px;\"><select class=\"form-control\" placeholder=\"{{vm.selectLangText}}\" required=\"\" name=\"userLang\" id=\"userLang\" ng-model=\"vm.userLang\" ng-change=\"vm.changeLanguage()\"><option value=\"\" disabled=\"\">{{vm.selectLangText}}</option><option ng-repeat=\"lang in vm.languages\" value=\"{{lang.cd}}\">{{lang.nm}}</option></select></div><div><button id=\"addSurveyBtn\" type=\"button\" ng-click=\"vm.addSurvey()\" class=\"idmx-link-btn add-survey disabled\" ladda=\"vm.ladda\" disabled=\"\" style=\"vertical-align: top; cursor: not-allowed\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"sysAdmin.mangSurvs.addSurvButton\"></span></button></div></div></form></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageSubjTab\" class=\"nav nav-tabs\"><li class=\"active\"><a data-target=\"#tab-1\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"sysAdmin.mangSurvs.actvTab\"></a></li><li class=\"disabled\" disabled=\"\"><a class=\"idmx-tab disabled tab-padding\" translate=\"sysAdmin.mangSurvs.pendgTab\" disabled=\"\"></a></li><li class=\"disabled\" disabled=\"\"><a class=\"idmx-tab disabled tab-padding\" translate=\"sysAdmin.mangSurvs.archvdTab\" disabled=\"\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><table author-surveys-dt=\"\" id=\"surveys\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangSurvs.nameHeader\"></th><th translate=\"sysAdmin.mangSurvs.cdHeader\"></th><th translate=\"sysAdmin.mangSurvs.descHeader\"></th><th translate=\"sysAdmin.mangSurvs.actnsHeader\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/users/add.html","<div class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(newUserForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"newUserForm\"><div class=\"form-group\" style=\"margin-bottom: 5px;\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.firstNameLabel\"></label><div class=\"col-sm-10\"><div class=\"col-sm-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': newUserForm.userFirstName.$invalid && (newUserForm.userFirstName.$dirty || newUserForm.$submitted)}\"><input required=\"\" type=\"text\" ng-model=\"vm.user.userFirstName\" autofocus=\"\" id=\"userFirstName\" name=\"userFirstName\" class=\"form-control\" ng-model-options=\"{updateOn: \'blur\'}\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"newUserForm.userFirstName.$invalid && (newUserForm.userFirstName.$dirty || newUserForm.$submitted)\" ng-messages=\"newUserForm.userFirstName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.firstNameReqd\"></span></span></div></div><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.lastNameLabel\"></label><div class=\"col-sm-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': newUserForm.userLastName.$invalid && (newUserForm.userLastName.$dirty || newUserForm.$submitted)}\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.user.userLastName\" ng-model-options=\"{updateOn: \'blur\'}\" id=\"userLastName\" name=\"userLastName\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"newUserForm.userLastName.$invalid && (newUserForm.userLastName.$dirty || newUserForm.$submitted)\" ng-messages=\"newUserForm.userLastName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.lastNameReqd\"></span></span></div></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (newUserForm.userId.$error.required || newUserForm.userId.$invalid || newUserForm.userId.$error.pattern) && (newUserForm.userId.$dirty || newUserForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.emailAddrLabel\"></label><div class=\"col-lg-10\"><input id=\"userId\" name=\"userId\" class=\"form-control\" type=\"text\" ng-model=\"vm.user.userId\" ng-model-options=\"{updateOn: \'blur\'}\" ng-pattern=\"/^[^\\s@]+@([^\\s@.,]+\\.)+[^\\s@.,]{2,}$/\" admin-add-user-email=\"\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(newUserForm.userId.$error.required || newUserForm.userId.$invalid || newUserForm.userId.$error.pattern) && (newUserForm.userId.$dirty || newUserForm.$submitted)\" ng-messages=\"newUserForm.userId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.emailAddrReqd\"></span> <span ng-message=\"pattern\" ng-if=\"newUserForm.userId.$touched\" translate=\"sysAdmin.mangUsrs.valid.emailAddrInvld\"></span> <span ng-message=\"emailExists\" translate=\"sysAdmin.mangUsrs.valid.emailAddrExists\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangUsrs.passwdLabel\"></label><div class=\"col-lg-10\"><div class=\"control-text\" translate=\"sysAdmin.mangUsrs.help.pendgUsrPasswdText\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.statLabel\"></label><div class=\"col-sm-10\"><div class=\"col-sm-5\"><div class=\"radio-inline zero-left-padding\"><label><span class=\"lbl-status\">{{vm.pendingStatus}}</span></label></div></div><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.uiUsrLabel\"></label><div class=\"col-sm-5\"><div class=\"radio-inline zero-left-padding\"><input id=\"uiUsrFlag\" name=\"uiUsrFlag\" icheck=\"\" type=\"checkbox\" ng-checked=\"true\" ng-model=\"vm.user.uiUsrFlag\" ng-change=\"vm.enableSubmit()\"></div></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (newUserForm.orgField.$invalid || noOrgs === true) && (newUserForm.orgField.$dirty || newUserForm.$submitted)}\" ng-if=\"vm.hasMangSysPerm\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.orgLabel\"></label><div class=\"col-sm-10\"><input id=\"orgField\" name=\"orgField\" type=\"text\" ng-model=\"orgSelected\" class=\"typeahead form-control\" placeholder=\"{{\'sysAdmin.mangUsrs.selectOrgText\' | translate}}\" uib-typeahead=\"org as [org.desc] for org in vm.orgs | filter:{desc:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onOrgSelectedCallback($item, $model)\" typeahead-no-results=\"noOrgs\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(newUserForm.orgField.$invalid && (newUserForm.orgField.$dirty || newUserForm.$submitted))\" ng-messages=\"newUserForm.orgField.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.orgReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noOrgs === true && newUserForm.orgField.$viewValue !== \'\') && (newUserForm.orgField.$dirty || newUserForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: newUserForm.orgField.$viewValue}\"></span></span></div></div><div class=\"form-group\" ng-if=\"vm.hasMangOrgPerm && !vm.hasMangSysPerm\" ng-class=\"{\'has-error\': (newUserForm.orgField.$invalid ) && (newUserForm.orgField.$dirty || newUserForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.orgLabel\"></label><div class=\"col-sm-10\" ng-if=\"vm.orgs.length > 1\"><select class=\"form-control\" name=\"orgField\" id=\"orgField\" ng-model=\"vm.user.orgId\" ng-change=\"vm.onSelectParent()\" required=\"\"><option selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.mangUsrs.selectOrgText\"></option><option ng-repeat=\"org in vm.orgs\" value=\"{{org.orgId}}\">{{org.desc}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(newUserForm.orgField.$invalid && (newUserForm.orgField.$dirty || newUserForm.$submitted))\" ng-messages=\"newUserForm.orgField.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.orgReqd\"></span></span></div><div class=\"col-sm-10\" ng-if=\"vm.orgs.length === 1\"><div class=\"control-text\">{{vm.parentOrgName}}</div></div></div><label class=\"row control-label\" style=\"margin-left:5%;\" translate=\"sysAdmin.mangUsrs.phonNumsTitle\"></label><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangUsrs.offcLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': noCntry === true && (newUserForm.phField.$dirty || newUserForm.$submitted)}\"><input id=\"phField\" name=\"phField\" type=\"text\" ng-model=\"phSelected\" class=\"typeahead form-control\" placeholder=\"{{\'sysAdmin.mangUsrs.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.codes | filter:$viewValue | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onPhSelectedCallback()\" typeahead-no-results=\"noCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\"> <span class=\"help-block m-b-none\" ng-show=\"(noCntry === true && newUserForm.phField.$viewValue !== \'\') && (newUserForm.phField.$dirty || newUserForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: newUserForm.phField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': newUserForm.offcPhonNum.$invalid && ( newUserForm.offcPhonNum.$error.pattern || newUserForm.$submitted)}\"><input id=\"offcPhonNum\" name=\"offcPhonNum\" ng-model=\"vm.user.offcPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" class=\"form-control\" placeholder=\"{{\'sysAdmin.mangUsrs.phonNumLabel\' | translate}}\"> <span class=\"help-block m-b-none\" ng-show=\"newUserForm.offcPhonNum.$invalid && ( newUserForm.offcPhonNum.$error.pattern || newUserForm.$submitted)\" ng-messages=\"newUserForm.offcPhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"sysAdmin.mangUsrs.valid.phonNumInvld\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangUsrs.moblLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': (noMbCntry === true && (newUserForm.mobileField.$dirty || newUserForm.$submitted)) || ( newUserForm.moblPhonNum.$error.mobileNumberExists)}\"><input id=\"mobileField\" name=\"mobileField\" type=\"text\" ng-model=\"mbSelected\" class=\"typeahead form-control\" placeholder=\"{{\'sysAdmin.mangUsrs.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.codes | filter:$viewValue | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onMbSelectedCallback()\" typeahead-no-results=\"noMbCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-blur=\"vm.validateMobileNumber()\"> <span class=\"help-block m-b-none\" ng-show=\"(noMbCntry === true && newUserForm.mobileField.$viewValue !== \'\') && (newUserForm.mobileField.$dirty || newUserForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: newUserForm.mobileField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': newUserForm.moblPhonNum.$invalid && ( newUserForm.moblPhonNum.$error.pattern || newUserForm.$submitted || newUserForm.moblPhonNum.$error.mobileNumberExists)}\"><input id=\"moblPhonNum\" name=\"moblPhonNum\" ng-model=\"vm.user.moblPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" class=\"form-control\" placeholder=\"{{\'sysAdmin.mangUsrs.phonNumLabel\' | translate}}\" ng-blur=\"vm.validateMobileNumber()\"> <span class=\"help-block m-b-none\" ng-show=\"newUserForm.moblPhonNum.$invalid && ( newUserForm.moblPhonNum.$error.pattern || newUserForm.$submitted || newUserForm.moblPhonNum.$error.mobileNumberExists)\" ng-messages=\"newUserForm.moblPhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"sysAdmin.mangUsrs.valid.phonNumInvld\"></span> <span ng-message=\"mobileNumberExists\" translate=\"sysAdmin.mangUsrs.valid.moblNumUniq\" translate-values=\"{usrId: vm.userId}\"></span></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.mangUsrs.sysRolesLabel\"></label><div class=\"col-sm-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px; margin-left: 0px;\" ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\" ng-show=\"vm.grantblUserRoles.indexOf(userRoleType.userRoleTypeCd) !== -1\"><label class=\"lbl-roles-container\"><span popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.popover[userRoleType.userRoleTypeCd].title}}\" uib-popover=\"{{userRoleType.popover[userRoleType.userRoleTypeCd].content}}\"><input id=\"systemRoles\" icheck=\"\" type=\"checkbox\" name=\"systemRoles\" ng-model=\"vm.userRoles[userRoleType.userRoleTypeCd]\" ng-change=\"vm.roleChange()\" user-role-type=\"userRoleType\" roles=\"{{vm.user.userRoles}}\" validate-user-role-type=\"\"></span> <span class=\"lbl-roles\" style=\"display: inline-block\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.userRoleTypeName}}\" uib-popover=\"{{userRoleType.userRoleTypeDesc}}\">{{userRoleType.userRoleTypeName}}</span></label></div></div></div><div class=\"form-group\"><div class=\"row col-lg-12\"><label class=\"control-label\" style=\"margin-left:5%;\" translate=\"sysAdmin.mangUsrs.usrPrefsTitle\"></label></div><div class=\"form-group\" ng-repeat=\"upt in vm.userPrefTypes | orderBy:\'dispSeq\'\"><label class=\"col-lg-2 control-label required\">{{upt.nm}}</label><div class=\"col-lg-10\"><div ng-repeat=\"(ob, items) in vm.references\"><span ng-if=\"ob === upt.entity.lkupTablCd\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"up in items.refItems | orderBy:\'dispSeq\'\"><input id=\"{{upt.cd}}\" name=\"{{upt.cd}}\" admin-add-user-pref=\"\" icheck=\"\" type=\"radio\" ng-checked=\"up.cd === upt.entity.defaultUserPrefCd\" ng-model=\"vm.user.userPrefs[upt.cd]\" ng-value=\"up.cd\" required=\"\"> {{up.nm}}</div></span></div></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 0px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.admin.adminUsers\" style=\"margin-right: 5px;\" translate=\"sysAdmin.mangUsrs.cancelButton\"></button> <button class=\"btn btn-primary add-user-submit-btn\" id=\"btnSubmit\" ng-disabled=\"vm.setUserRoles()\" type=\"submit\" style=\"margin-right: 5px;\" translate=\"sysAdmin.addUsr.addButton\"></button></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/users/edit.html","<style>\n    .popover {\n        max-width: unset !important;\n    }\n</style><div ng-if=\"vm.hasUserPerm()\" class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(userForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"userForm\"><div class=\"form-group\" style=\"margin-bottom: 5px;\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.firstNameLabel\"></label><div class=\"col-sm-10\"><div class=\"col-sm-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': userForm.userFirstName.$invalid && (userForm.userFirstName.$dirty || userForm.$submitted)}\"><input id=\"userFirstName\" name=\"userFirstName\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.userFirstName\" ng-model-options=\"{updateOn: \'blur\'}\" autofocus=\"\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"userForm.userFirstName.$invalid && (userForm.userFirstName.$dirty || userForm.$submitted)\" ng-messages=\"userForm.userFirstName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.firstNameReqd\"></span></span></div></div><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.lastNameLabel\"></label><div class=\"col-sm-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': userForm.userLastName.$invalid && (userForm.userLastName.$dirty || userForm.$submitted)}\"><input id=\"userLastName\" name=\"userLastName\" class=\"form-control\" type=\"text\" ng-model=\"vm.user.userLastName\" ng-model-options=\"{ updateOn: \'blur\'}\" required=\"\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"userForm.userLastName.$invalid && (userForm.userLastName.$dirty || userForm.$submitted)\" ng-messages=\"userForm.userLastName.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.lastNameReqd\"></span></span></div></div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label required\" translate=\"sysAdmin.mangUsrs.emailAddrLabel\"></label><div class=\"col-lg-10\"><div class=\"control-text\">{{vm.user.userId}}</div></div></div><script type=\"text/ng-template\" id=\"passwd-policy-template.html\"><div class=\"form-group\"> <ul style=\"list-style-type: none; padding-left: 0px;\"> <li ng-repeat=\"(key, value) in vm.rulesList track by key\" ng-bind-html=\"value\"></li> </ul> </div></script><div class=\"form-group\" style=\"margin-bottom: 5px;\"><label class=\"col-sm-2 control-label\" ng-class=\"{\'required\': vm.user.userStatCd==\'A\'}\" translate=\"sysAdmin.mangUsrs.passwdLabel\"></label><div class=\"col-sm-10\" ng-show=\"vm.user.userStatCd !== \'P\' && vm.showPasswd\"><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': userForm.password.$invalid && (userForm.password.$dirty || userForm.$submitted), \'required\' : vm.user.userStatCd === \'A\'}\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" value=\"password\" ng-model=\"vm.user.pseudoPassword\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-disabled=\"vm.user.userStatCd !== \'A\'\" ng-required=\"vm.user.userStatCd === \'A\' && vm.showPasswd\" autocomplete=\"off\" popover-append-to-body=\"true\" popover-placement=\"center\" popover-trigger=\"focus\" popover-animation=\"true\" popover-title=\"{{\'sysAdmin.mangUsrs.help.passwdPolicyTitle\' | translate}}\" uib-popover-template=\"vm.policyPopover.templateUrl\" validate-password-policy=\"\"> <span class=\"help-block m-b-none\" ng-show=\"userForm.password.$invalid && (userForm.password.$dirty || userForm.$submitted)\" ng-messages=\"userForm.password.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.passwdReqd\"></span> <span ng-message=\"pattern\" translate=\"sysAdmin.mangUsrs.help.passwdPolicyText\"></span> <span ng-message=\"policy\" translate=\"sysAdmin.mangUsrs.valid.passwdPolicyFailed\"></span></span></div></div><label class=\"col-sm-3 control-label\" required=\"\" translate=\"sysAdmin.mangUsrs.confPasswdLabel\"></label><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': userForm.confirmPassword.$invalid && (userForm.confirmPassword.$dirty || userForm.$submitted)}\" ng-show=\"vm.user.userStatCd != \'P\'\"><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" class=\"form-control\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=\"vm.user.confirmPasswdText\" compare-to=\"userForm.password.$viewValue\" ng-disabled=\"vm.user.userStatCd !== \'A\'\" ng-required=\"vm.user.userStatCd === \'A\' && vm.showPasswd\" autocomplete=\"off\"> <span class=\"help-block m-b-none\" ng-show=\"userForm.confirmPassword.$invalid && (userForm.confirmPassword.$dirty || userForm.$submitted)\" ng-messages=\"userForm.confirmPassword.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.confPasswdReqd\"></span> <span ng-messages=\"compareTo\" translate=\"sysAdmin.mangUsrs.valid.passwdMatchReqd\"></span></span></div></div></div><div class=\"col-sm-6\" ng-if=\"!vm.showPasswd\"><div ng-if=\"vm.user.userStatCd !== \'P\'\" class=\"control-text\">************</div><div ng-if=\"vm.user.userStatCd === \'P\'\" class=\"control-text\" translate=\"sysAdmin.mangUsrs.noPasswdText\"></div></div><div class=\"col-sm-4\" ng-if=\"!vm.showPasswd\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"vm.user.userStatCd === \'P\'\" ng-click=\"vm.showPasswdFields($event)\">Update Password</button></div></div><div class=\"form-group idmx-icheck\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.statLabel\"></label><div class=\"col-sm-10\"><div class=\"col-sm-5\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"status in vm.availableStatusList | orderBy:\'status.dispSeq\'\"><input admin-edit-user-status=\"\" icheck=\"\" type=\"radio\" name=\"status\" ng-checked=\"vm.user.userStatCd === status.cd\" ng-value=\"status.cd\" ng-model=\"vm.user.userStatCd\" ng-class=\"{\'lbl-status-disabled\': vm.user.userStatCd ==\'P\'}\"> <label for=\"{{status.nm}}\" class=\"lbl-status-container\"><span ng-if=\"\'S\' === status.cd\" ng-class=\"{\'lbl-status\': vm.user.userStatCd !=\'P\', \'lbl-status-disabled\': vm.user.userStatCd ==\'P\'}\" data-uib-popover=\"{{vm.suspendedUserPopoverText}}\" popover-title=\"{{\'sysAdmin.mangUsrs.help.suspExpTitle\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{status.nm}}</span> <span ng-if=\"\'S\' != status.cd\" class=\"lbl-status\">{{status.nm}}</span></label></div></div><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.uiUsrLabel\"></label><div class=\"col-sm-5\"><div class=\"radio-inline zero-left-padding\"><input id=\"uiUsrFlag\" name=\"uiUsrFlag\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.user.uiUsrFlag\" ng-change=\"vm.enableSubmit()\"></div></div></div></div><div class=\"form-group\" ng-if=\"vm.hasMangSysPerm\" ng-class=\"{\'has-error\': (userForm.orgField.$invalid || noOrgs === true) && (userForm.orgField.$dirty || userForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.orgLabel\"></label><div class=\"col-sm-10\"><input id=\"orgField\" name=\"orgField\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.orgSelected\" placeholder=\"{{\'sysAdmin.mangUsrs.selectOrgText\' | translate}}\" uib-typeahead=\"org as [org.desc] for org in vm.orgs | filter:{desc:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onOrgSelectedCallback($item, $model)\" typeahead-no-results=\"noOrgs\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" required=\"\" admin-edit-user-organization=\"\" ng-disabled=\"vm.user.hasRoleOnSubject\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(userForm.orgField.$invalid && (userForm.orgField.$dirty || userForm.$submitted))\" ng-messages=\"userForm.orgField.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.orgReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noOrgs === true && userForm.orgField.$viewValue !== \'\') && (userForm.orgField.$dirty || userForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: userForm.orgField.$viewValue}\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.user.hasRoleOnSubject\" translate=\"sysAdmin.mangUsrs.help.selectOrgText\"></span></div></div><div class=\"form-group\" ng-if=\"vm.hasMangOrgPerm && !vm.hasMangSysPerm\" ng-class=\"{\'has-error\': (userForm.orgId.$invalid ) && (userForm.orgId.$dirty || userForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.mangUsrs.orgLabel\"></label><div class=\"col-sm-10\" ng-if=\"vm.orgs.length > 1\"><select class=\"form-control\" name=\"orgId\" id=\"orgId\" ng-model=\"vm.user.orgId\" required=\"\" convert-to-number=\"\" ng-change=\"vm.onSelectParent(this)\" ng-disabled=\"vm.user.hasRoleOnSubject\"><option selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.mangUsrs.phonNumsTitle\"></option><option ng-repeat=\"org in vm.orgs\" value=\"{{org.orgId}}\">{{org.desc}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(userForm.orgId.$invalid && (userForm.orgId.$dirty || userForm.$submitted))\" ng-messages=\"userForm.orgId.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.orgReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"vm.user.hasRoleOnSubject\" translate=\"sysAdmin.mangUsrs.help.selectOrgText\"></span></div><div class=\"col-sm-10\" ng-if=\"vm.orgs.length === 1\"><div class=\"control-text\">{{vm.parentOrgName}}</div></div></div><label class=\"row control-label\" style=\"margin-left:5%;\" translate=\"sysAdmin.mangUsrs.phonNumsTitle\"></label><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"sysAdmin.mangUsrs.offcLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': noPhCntry === true && (userForm.phField.$dirty || userForm.$submitted)}\"><input id=\"phField\" name=\"phField\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.phoneCodeSelected\" placeholder=\"{{\'sysAdmin.mangUsrs.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.codes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onPhoneCodeSelectedCallback($item, $model)\" typeahead-no-results=\"noPhCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"false\" admin-edit-user-office-country=\"\"> <span class=\"help-block m-b-none\" ng-show=\"(noPhCntry === true && userForm.phField.$viewValue !== \'\') && (userForm.phField.$dirty || userForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: userForm.phField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': userForm.offcPhonNum.$invalid && ( userForm.offcPhonNum.$error.pattern || userForm.$submitted)}\"><input id=\"offcPhonNum\" name=\"offcPhonNum\" class=\"form-control\" ng-model=\"vm.user.offcPhonNum\" ng-model-options=\"{updateOn: \'blur\'}\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'sysAdmin.mangUsrs.phonNumLabel\' | translate}}\"> <span class=\"help-block m-b-none\" ng-show=\"userForm.offcPhonNum.$error.pattern || userForm.$submitted\" ng-messages=\"userForm.offcPhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"sysAdmin.mangUsrs.valid.phonNumInvld\"></span></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" ng-class=\"{\'required\' : vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\' && vm.user.uiUsrFlag}\" translate=\"sysAdmin.mangUsrs.moblLabel\"></label><div class=\"col-lg-5\" ng-class=\"{\'has-error\': (userForm.mobileField.$invalid || noCntry === true) && (userForm.mobileField.$dirty || userForm.$submitted) || ( userForm.mobilePhonNum.$error.mobileNumberExists)}\"><input id=\"mobileField\" name=\"mobileField\" type=\"text\" class=\"typeahead form-control\" ng-model=\"vm.mobileCodeSelected\" placeholder=\"{{\'sysAdmin.mangUsrs.selectCntryCdText\' | translate}}\" uib-typeahead=\"code as [code.nm] for code in vm.codes | filter:{nm:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onMobileCodeSelectedCallback($item, $model)\" typeahead-no-results=\"noCntry\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"false\" ng-required=\"(vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\' && vm.user.uiUsrFlag)\" admin-edit-user-mobile-country=\"\" ng-blur=\"vm.validateMobileNumber(userForm)\"> <span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"(userForm.mobileField.$invalid && (userForm.mobileField.$dirty || userForm.$submitted))\" ng-messages=\"userForm.mobileField.$error\"><span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.phonCntryCdReqd\"></span></span> <span class=\"help-block m-b-none\" ng-show=\"(noCntry === true && userForm.mobileField.$viewValue !== \'\') && (userForm.mobileField.$dirty || userForm.$submitted)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: userForm.mobileField.$viewValue}\"></span></span></div><div class=\"col-lg-5\" ng-class=\"{\'has-error\': userForm.mobilePhonNum.$invalid && (userForm.mobilePhonNum.$dirty || userForm.mobilePhonNum.$error.pattern || userForm.$submitted || userForm.mobilePhonNum.$error.mobileNumberExists), \'required\' : (vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\' && vm.user.uiUsrFlag)}\"><input id=\"mobilePhonNum\" name=\"mobilePhonNum\" class=\"form-control\" ng-model=\"vm.user.moblPhonNum\" ng-model-options=\"{ updateOn: \'blur\' }\" maxlength=\"20\" ng-pattern=\"/^[0-9]{1,20}$/\" placeholder=\"{{\'sysAdmin.mangUsrs.phonNumLabel\' | translate}}\" ng-required=\"(vm.twoFactorAuthReq === \'TRUE\' && vm.user.userStatCd !== \'P\' && vm.user.uiUsrFlag)\" ng-blur=\"vm.validateMobileNumber(userForm)\"> <span class=\"help-block m-b-none\" ng-show=\"userForm.mobilePhonNum.$invalid && (userForm.mobilePhonNum.$dirty || userForm.mobilePhonNum.$error.pattern || userForm.$submitted || userForm.mobilePhonNum.$error.mobileNumberExists)\" ng-messages=\"userForm.mobilePhonNum.$error\" multiple=\"\"><span ng-message=\"pattern\" translate=\"sysAdmin.mangUsrs.valid.phonNumInvld\"></span> <span ng-message=\"required\" translate=\"sysAdmin.mangUsrs.valid.phonNumReqd\"></span> <span ng-message=\"mobileNumberExists\" translate-values=\"{usrId: vm.userId}\" translate=\"sysAdmin.mangUsrs.valid.moblNumUniq\"></span></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate=\"sysAdmin.mangUsrs.sysRolesLabel\"></label><div class=\"col-lg-10\"><div class=\"checkbox-inline zero-left-padding\" style=\"margin-right: 15px; margin-left: 0px;\" ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\" ng-show=\"vm.grantblUserRoles.indexOf(userRoleType.userRoleTypeCd) !== -1\"><label class=\"lbl-roles-container\"><span popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.popover[userRoleType.userRoleTypeCd].title}}\" uib-popover=\"{{userRoleType.popover[userRoleType.userRoleTypeCd].content}}\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.userRoles[userRoleType.userRoleTypeCd]\" ng-value=\"userRoleType.userRoleTypeCd\" ng-change=\"vm.roleChange()\" user-role-type=\"userRoleType\" roles=\"{{vm.user.userRoles}}\" validate-user-role-type=\"\"></span> <span class=\"lbl-roles\" style=\"display: inline-block\" popover-append-to-body=\"true\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.userRoleTypeName}}\" uib-popover=\"{{userRoleType.userRoleTypeDesc}}\">{{userRoleType.userRoleTypeName}}</span></label></div></div></div><div class=\"form-group\"><div class=\"row col-lg-12\"><label class=\"control-label\" style=\"margin-left:5%;\" translate=\"sysAdmin.mangUsrs.usrPrefsTitle\"></label></div><div class=\"form-group\" ng-repeat=\"upt in vm.userPrefTypes | orderBy:\'dispSeq\'\"><label class=\"col-lg-2 control-label required\">{{upt.nm}}</label><div class=\"col-lg-10\"><div ng-repeat=\"(ob, items) in vm.references\"><span ng-if=\"ob === upt.entity.lkupTablCd\"><div class=\"radio-inline zero-left-padding\" ng-repeat=\"up in items.refItems | orderBy:\'dispSeq\'\"><input name=\"{{upt.cd}}\" admin-edit-user-pref=\"\" icheck=\"\" type=\"radio\" ng-checked=\"up.cd === upt.entity.defaultUserPrefCd\" ng-model=\"vm.user.userPrefs[upt.cd]\" ng-value=\"up.cd\" required=\"\"> {{up.nm}}</div></span></div></div></div></div><div class=\"form-group\"><div class=\"col-lg12\"><div class=\"pull-right\" style=\"margin-right: 30px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.admin.adminUsers\" translate=\"sysAdmin.mangUsrs.cancelButton\"></button> <button ng-disabled=\"vm.setUserRoles()\" class=\"btn btn-primary add-usr-submit-btn\" type=\"submit\" translate=\"sysAdmin.mangUsrs.updtButton\"></button></div></div></div></form></div></div></div></div></div><div ng-if=\"!vm.hasUserPerm()\" class=\"message-error\"><span translate=\"sysAdmin.updtUsr.valid.noUpdtUsrPermsn\"></span></div>");
$templateCache.put("app/admin/users/replace.html","<div ng-if=\"vm.user\" class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><div class=\"message-help\"><span translate=\"sysAdmin.replUsr.pageInstrText\"></span></div><form class=\"form-horizontal\" novalidate=\"\" ng-submit=\"vm.submit(replaceUserForm)\" ng-keydown=\"vm.onKeyDown($event)\" name=\"replaceUserForm\"><div class=\"form-group\"><label class=\"row control-label\" style=\"margin-left: 1%;\" translate=\"sysAdmin.replUsr.currUsrTitle\"></label></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.replUsr.currUsrLabel\"></label><div class=\"col-sm-10\"><div class=\"control-text\">{{vm.user.userLastFirstNamePlusOrgPlusId}}</div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" translate=\"sysAdmin.replUsr.subjCntLabel\"></label><div class=\"col-sm-10\"><div ng-if=\"vm.user.totalActiveSubj > 0\" class=\"control-text\">{{vm.user.totalActiveSubj}}</div><div ng-if=\"vm.user.totalActiveSubj === 0\" class=\"has-error\"><div class=\"control-text\" translate=\"sysAdmin.replUsr.valid.noSubjsFound\"></div></div></div></div><div class=\"form-group\"><label class=\"row control-label\" style=\"margin-left: 1%;\" translate=\"sysAdmin.replUsr.newUsrTitle\"></label></div><div class=\"form-group\" ng-class=\"{\'has-error\': replaceUserForm.newUser.$invalid && (replaceUserForm.newUser.$dirty || replaceUserForm.$submitted)}\"><label class=\"col-sm-2 control-label required\" translate=\"sysAdmin.replUsr.newUsrLabel\"></label><div ng-if=\"vm.user.totalActiveSubj > 0\"><div ng-if=\"vm.orgUsers.length > 1\" class=\"col-sm-10\"><select class=\"form-control\" name=\"newUser\" id=\"newUser\" ng-model=\"vm.newUserId\" required=\"\"><option selected=\"\" value=\"\" class=\"placeholder-color\" translate=\"sysAdmin.replUsr.selectNewUsrText\"></option><option ng-repeat=\"user in vm.orgUsers | orderBy: \'userFirstLastName\'\" value=\"{{user.userId}}\">{{user.userLastFirstNamePlusOrgPlusId}}</option></select><span class=\"help-block m-b-none\" multiple=\"\" ng-show=\"replaceUserForm.newUser.$invalid && (replaceUserForm.newUser.$dirty || replaceUserForm.$submitted)\" ng-messages=\"replaceUserForm.newUser.$error\"><span ng-message=\"required\" translate=\"sysAdmin.replUsr.valid.newUsrReqd\"></span></span></div><div ng-if=\"vm.orgUsers.length === 1\" class=\"col-sm-10\"><div class=\"control-text\">{{vm.orgUsers[0].userLastFirstNamePlusOrgPlusId}}</div></div><div ng-if=\"vm.orgUsers.length === 0\" class=\"col-sm-10 has-error\"><div class=\"control-text\" translate=\"sysAdmin.replUsr.valid.noUsrsFound\"></div></div></div><div ng-if=\"vm.user.totalActiveSubj === 0\" class=\"col-sm-10 has-error\"><div class=\"control-text\" translate=\"sysAdmin.replUsr.valid.newUsrNA\"></div></div></div><div class=\"form-group\"><div class=\"col-lg-12\"><div class=\"pull-right\" style=\"margin-right: 0px;\"><button class=\"btn btn-default form-reset-button\" ui-sref=\"app.admin.adminUsers\" style=\"margin-right: 5px;\" translate=\"sysAdmin.mangUsrs.cancelButton\"></button> <button class=\"btn btn-primary add-user-submit-btn\" id=\"btnSubmit\" ladda=\"vm.ladda\" ng-disabled=\"vm.user.totalActiveSubj === 0 || vm.orgUsers.length === 0 || (replaceUserForm.newUser.$invalid && (replaceUserForm.newUser.$dirty || replaceUserForm.$submitted))\" type=\"submit\" style=\"margin-right: 5px;\" translate=\"sysAdmin.replUsr.replButton\"></button></div></div></div></form></div></div></div></div></div><div ng-if=\"!vm.user\" class=\"message-error\"><span translate=\"sysAdmin.replUsr.valid.noReplUsrPermsn\"></span></div>");
$templateCache.put("app/admin/users/users.html","<div class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\">&nbsp;&nbsp; <button type=\"button\" ui-sref=\"app.admin.adminUsers.adminAddUser\" class=\"idmx-link-btn add-user\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"sysAdmin.mangUsrs.addUsrButton\"></span></button></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"manageUsersTab\" class=\"nav nav-tabs\"><li class=\"active\"><a users-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangUsrs.actvTab\"></a></li><li><a users-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" ng-class=\"{active: active, disabled: disabled}\" style=\"padding: 10px 20px 10px 25px;\" class=\"idmx-tab\" translate=\"sysAdmin.mangUsrs.archvdTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div class=\"tab-pane active animated fadeInRight idmx-tab-pane\" id=\"tab-1\"><table active-users-dt=\"\" id=\"activeUsersTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangUsrs.nameHeader\"></th><th translate=\"sysAdmin.mangUsrs.emailAddrHeader\"></th><th translate=\"sysAdmin.mangUsrs.orgHeader\"></th><th translate=\"sysAdmin.mangUsrs.statHeader\"></th><th translate=\"sysAdmin.mangUsrs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangUsrs.lastLoginHeader\"></th><th translate=\"sysAdmin.mangUsrs.sysRolesHeader\"></th><th translate=\"sysAdmin.mangUsrs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.activeUsers\"><td><a ui-sref=\"app.admin.adminUsers.adminEditUser({userId: user.userId})\">{{user.userLastFirstName}}</a></td><td>{{user.userId}}</td><td>{{user.orgName}}</td><td><span ng-if=\"\'S\' === vm.statusName(user.userStatCd)[0].cd\" class=\"lbl-status idmx_cursor_pointer\" uib-popover=\"{{vm.getSuspendedUserStatusHelpText(user)}}\" popover-title=\"{{\'sysAdmin.mangUsrs.help.suspExpTitle\' | translate}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.statusName(user.userStatCd)[0].nm}}</span> <span ng-if=\"\'S\' != vm.statusName(user.userStatCd)[0].cd\" class=\"lbl-status\">{{vm.statusName(user.userStatCd)[0].nm}}</span></td><td>{{user.lastUpdtTmstmp}}</td><td>{{user.lastLoginTmstmp}}<div></div><span ng-show=\"user.invaldLoginAttmptCnt != null && user.lastLoginTmstmp != null\">&nbsp;&nbsp;</span> <span ng-show=\"user.invaldLoginAttmptCnt != null\" class=\"badge-counts\" style=\"vertical-align: bottom\">{{user.invaldLoginAttmptCnt}}</span></td><td><div ng-repeat=\"y in vm.userRoleTypeList | orderBy:\'-dispSeq\'\"><div ng-repeat=\"x in user.userRoles\"><span ng-if=\"y.cd==vm.roleName(x)[0].cd\" class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></div></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangUsrs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ui-sref=\"app.admin.adminUsers.adminEditUser({userId: user.userId})\"><i class=\"fa fa-edit\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.updtButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.updtButton\"></span></a></li><li><a ng-if=\"user.uiUsrFlag\" ui-sref=\"app.admin.adminUsers.adminReplaceUser({userId: user.userId})\"><i class=\"fa fa-exchange\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.replButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.replButton\"></span></a> <span class=\"disabledAction\" ng-if=\"!user.uiUsrFlag\"><a><i class=\"fa fa-exchange\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.replButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.replButton\"></span></a></span></li><li><a ng-click=\"vm.openConfirmDialog(user, \'Archive\')\"><i class=\"fa fa-archive\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.archvButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.archvButton\"></span></a></li><li class=\"divider\"></li><li><a ng-if=\"user.userStatCd === \'P\' && user.uiUsrFlag\" ng-click=\"vm.resendInvite(user.userId)\"><i class=\"fa fa-envelope-o\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.acctVerfcEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.acctVerfcEmailButton\"></span></a> <span class=\"disabledAction\" ng-if=\"user.userStatCd === \'A\' ||user.userStatCd === \'S\' || user.userStatCd === \'I\' || !user.uiUsrFlag\"><a><i class=\"fa fa-envelope-o\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.acctVerfcEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.acctVerfcEmailButton\"></span></a></span></li><li><a ng-if=\"user.userStatCd === \'A\' && user.uiUsrFlag\" ng-click=\"vm.resendWelcome(user.userId)\"><i class=\"fa fa-thumbs-o-up\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.regstWelcmEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.regstWelcmEmailButton\"></span></a> <span class=\"disabledAction\" ng-if=\"user.userStatCd === \'P\' || user.userStatCd === \'S\' || user.userStatCd === \'I\' || !user.uiUsrFlag\"><a><i class=\"fa fa-thumbs-o-up\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.regstWelcmEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.regstWelcmEmailButton\"></span></a></span></li><li><a ng-if=\"(user.userStatCd === \'A\' || user.userStatCd === \'S\') && user.uiUsrFlag\" ng-click=\"vm.passwordReset(user.userId)\"><i class=\"fa fa-unlock\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.passwdResetEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.passwdResetEmailButton\"></span></a> <span class=\"disabledAction\" ng-if=\"user.userStatCd === \'P\' || user.userStatCd === \'I\' || !user.uiUsrFlag\"><a><i class=\"fa fa-unlock\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.passwdResetEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.passwdResetEmailButton\"></span></a></span></li></ul></div></td></tr></tbody></table></div><div class=\"tab-pane animated fadeInRight idmx-tab-pane\" id=\"tab-2\"><table archive-users-dt=\"\" id=\"archivedUsersTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th translate=\"sysAdmin.mangUsrs.nameHeader\"></th><th translate=\"sysAdmin.mangUsrs.emailAddrHeader\"></th><th translate=\"sysAdmin.mangUsrs.orgHeader\"></th><th translate=\"sysAdmin.mangUsrs.statHeader\"></th><th translate=\"sysAdmin.mangUsrs.lastUpdtHeader\"></th><th translate=\"sysAdmin.mangUsrs.lastLoginHeader\"></th><th translate=\"sysAdmin.mangUsrs.sysRolesHeader\"></th><th translate=\"sysAdmin.mangUsrs.actnsHeader\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.archivedUsers\"><td>{{user.userLastFirstName}}</td><td>{{user.userId}}</td><td>{{user.orgName}}</td><td><span class=\"lbl-status\">{{vm.statusName(user.userStatCd)[0].nm}}</span></td><td>{{user.lastUpdtTmstmp}}</td><td>{{user.lastLoginTmstmp}}<div></div><span ng-show=\"user.invaldLoginAttmptCnt != null && user.lastLoginTmstmp != null\">&nbsp;&nbsp;</span> <span ng-show=\"user.invaldLoginAttmptCnt != null\" class=\"badge-counts\" style=\"vertical-align: bottom\">{{user.invaldLoginAttmptCnt}}</span></td><td><div ng-repeat=\"x in user.userRoles | orderBy:\'dispSeq\'\"><span class=\"lbl-roles\" uib-popover=\"{{vm.roleName(x)[0].desc}}\" popover-title=\"{{vm.roleName(x)[0].nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"top\">{{vm.roleName(x)[0].nm}}</span></div></td><td nowrap=\"\"><div uib-dropdown=\"\" ignore-disabled-links=\"\"><a class=\"idmx-dd-link-btn\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"clear\"><span class=\"text-xs block\"><span translate=\"sysAdmin.mangUsrs.actnButton\"></span> <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs pull-right\"><li><a ng-if=\"user.uiUsrFlag\" ui-sref=\"app.admin.adminUsers.adminReplaceUser({userId: user.userId})\"><i class=\"fa fa-exchange\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.replButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.replButton\"></span></a> <span class=\"disabledAction\" ng-if=\"!user.uiUsrFlag\"><a><i class=\"fa fa-exchange\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.replButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.replButton\"></span></a></span></li><li><a ng-click=\"vm.openConfirmDialog(user, \'Restore\')\" ng-show=\"user.userStatCd === \'R\'\"><i class=\"fa fa-undo\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.restrButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.restrButton\"></span></a></li><li><a ng-click=\"vm.openConfirmDialog(user, \'Delete\')\" ng-show=\"user.userStatCd === \'R\'\"><i class=\"fa fa-trash\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.delButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.delButton\"></span></a></li><li class=\"divider\"></li><li><span class=\"disabledAction\"><a><i class=\"fa fa-envelope-o\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.acctVerfcEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.acctVerfcEmailButton\"></span></a></span></li><li><span class=\"disabledAction\"><a><i class=\"fa fa-thumbs-o-up\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.regstWelcmEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.regstWelcmEmailButton\"></span></a></span></li><li><span class=\"disabledAction\"><a><i class=\"fa fa-unlock\" uib-tooltip=\"{{\'sysAdmin.mangUsrs.passwdResetEmailButton\' | translate}}\"></i>&nbsp; <span translate=\"sysAdmin.mangUsrs.passwdResetEmailButton\"></span></a></span></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/core/template/application-help.html","<script type=\"text/javascript\">\n    $(function() {\n        setTimeout(function(){\n            $(\'#helpScrollArea\').slimScroll({\n                height: \'320px\',\n                railVisible: true\n            });\n        });\n    });\n</script><div ng-class=\"(pageHelp) ? \'spin-icon\' : \'spin-icon-disabled\'\" id=\"helpTriggerIcon\" toggle-help=\"\"><i class=\"fa fa-question-circle\"></i></div><div class=\"theme-config\"><div class=\"theme-config-box\" id=\"globalHelpContainer\"><div class=\"skin-settings help-skin-settings\"><h5>{{pageHelp.helpTitle}}</h5><div ng-if=\"pageHelp.pageIcon || pageHelp.pageTitle\" class=\"row wrapper border-bottom white-bg page-heading ng-scope page-help-box\"><div class=\"col-lg-9\"><h2><span><i class=\"fa {{pageHelp.pageIcon}} idmx-heading-icon\" aria-hidden=\"true\"></i>&nbsp;</span> <span><span>{{pageHelp.pageTitle}}</span></span></h2></div></div><div ng-if=\"(pageHelp.overvwTab && pageHelp.pageDesc) || (pageHelp.elemsTab && pageHelp.elems)\" class=\"ibox-content page-help-ibox-content\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul class=\"nav nav-tabs page-help-nav-tabs\"><li ng-if=\"pageHelp.overvwTab && pageHelp.pageDesc\" class=\"active\"><a data-target=\"#overview\" data-toggle=\"tab\" class=\"idmx-tab\">{{pageHelp.overvwTab}}</a></li><li ng-if=\"pageHelp.elemsTab && pageHelp.elems\" ng-class=\"{\'active\': !pageHelp.overvwTab || !pageHelp.pageDesc}\"><a data-target=\"#elements\" data-toggle=\"tab\" class=\"idmx-tab\">{{pageHelp.elemsTab}}</a></li></ul></div></div><div class=\"panel-body idmx-panel-body page-help-panel-body\" id=\"helpScrollArea\"><div class=\"tab-content\"><div ng-if=\"pageHelp.pageDesc\" class=\"tab-pane active\" id=\"overview\"><p class=\"padded-forward-10px\" ng-bind-html=\"vm.getHtmlSafeText(pageHelp.pageDesc)\"></p><p ng-if=\"pageHelp.pageUsage\" class=\"padded-forward-10px\"><i>{{pageHelp.usageTitle}}</i>:</p><p class=\"padded-forward-10px\" ng-bind-html=\"vm.getHtmlSafeText(pageHelp.pageUsage)\"></p></div><div ng-if=\"pageHelp.elems\" class=\"tab-pane page-help-tab-pan\" id=\"elements\" ng-class=\"{\'active\': !pageHelp.overvwTab || !pageHelp.pageDesc}\"><div ng-repeat=\"element in pageHelp.elems\"><div class=\"help-element-accordion\"><label data-toggle=\"collapse\" class=\"key-label toggleLink ng-binding collapsed\" data-target=\"#help-elem-{{$index}}\">{{element.elemName}}</label><div id=\"help-elem-{{$index}}\" class=\"collapse page-help-collapse\"><p ng-bind-html=\"vm.getHtmlSafeText(element.elemDesc)\"></p><div ng-if=\"element.elemUsage\"><p><i>{{pageHelp.usageTitle}}:</i></p><p ng-bind-html=\"vm.getHtmlSafeText(element.elemUsage)\"></p></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/core/template/application-settings.html","<div ng-if=\"showUserParmSettings\" class=\"settings-icon\" id=\"settingsTriggerIcon\" toggle-settings=\"\"><i class=\"fa fa-cog\"></i></div><div class=\"settings-config\"><div class=\"settings-config-box\" id=\"settingsContainer\"><div class=\"skin-settings help-skin-settings\"><h5 translate=\"settings.home.pageTitle\"></h5><div class=\"row wrapper border-bottom white-bg page-heading ng-scope page-help-box\"><div class=\"col-lg-9\"><h2><span><i class=\"fa {{vm.settingsIcon}} idmx-heading-icon\" aria-hidden=\"true\"></i>&nbsp;</span> <span>{{vm.settingsPageTitle}}</span></h2></div></div><div class=\"ibox-content page-help-ibox-content\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul class=\"nav nav-tabs page-help-nav-tabs\"><li class=\"active\"><a data-target=\"#settings\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"settings.home.parmsTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body page-help-panel-body\" id=\"settingsScrollArea\"><div class=\"tab-content\"><div class=\"tab-pane active settings-form\" id=\"settings\"><p class=\"padded-forward-10px\" ng-bind-html=\"vm.getHtmlSafeText(vm.settingsPageParmsInstrText)\"></p><form class=\"form-inline\" name=\"settingsForm\"><div ng-repeat=\"userParmType in userParmTypes | orderBy:\'dispSeq\'\"><div class=\"row\" style=\"margin-top: 15px\"><div ng-if=\"userParmType.userParmInputTypeCd === \'DDLB\'\"><div class=\"col-xs-3\" style=\"padding-right: 0px;\"><label for=\"{{userParmType.userParmTypeCd}}_Setting\" class=\"control-label pull-right\" style=\"margin-top: 10px;\" popover-append-to-body=\"true\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userParmType.userParmTypeName}}\" uib-popover=\"{{vm.getHtmlSafeText(userParmType.userParmTypeDesc)}}\">{{userParmType.userParmTypeName}}</label></div><div class=\"col-xs-9\"><select id=\"{{userParmType.userParmTypeCd}}_Setting\" class=\"form-control\" ng-model=\"vm.selectedUserParm[userParmType.userParmTypeCd]\" style=\"width: 100%\"><option disabled=\"\" value=\"\" class=\"placeholder-color\">{{userParmType.userParmWaterMarkText}}</option><option ng-repeat=\"item in userParmType.options | orderBy: \'dispSeq\'\" value=\"{{item.cd}}\">{{item.nm}}</option></select></div></div><div ng-if=\"userParmType.userParmInputTypeCd === \'DDCB\'\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.noDdcbItem[userParmType.userParmTypeCd] && settingsForm[userParmType.userParmTypeCd + \'_Setting\'].$viewValue !== \'\'}\" style=\"display: block;\"><div class=\"col-xs-3\" style=\"padding-right: 0px;\"><label for=\"{{userParmType.userParmTypeCd}}_Setting\" class=\"control-label pull-right\" style=\"margin-top: 10px; padding-right: 0px\" popover-append-to-body=\"true\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userParmType.userParmTypeName}}\" uib-popover=\"{{vm.getHtmlSafeText(userParmType.userParmTypeDesc)}}\">{{userParmType.userParmTypeName}}</label></div><div class=\"col-xs-9\"><input id=\"{{userParmType.userParmTypeCd}}_Setting\" name=\"{{userParmType.userParmTypeCd}}_Setting\" class=\"typeahead form-control\" style=\"width: 100%\" type=\"text\" ng-model=\"vm.selectedUserParmDDcb[userParmType.userParmTypeCd]\" placeholder=\"{{userParmType.userParmWaterMarkText}}\" uib-typeahead=\"item as [item.nm] for item in userParmType.options | filter: {nm: $viewValue} | limitTo: 8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onSelectDdcb(userParmType.userParmTypeCd, $item)\" ng-change=\"vm.onDdcbChange(userParmType.userParmTypeCd)\" typeahead-no-results=\"vm.noDdcbItem[userParmType.userParmTypeCd]\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\"> <span class=\"help-block m-b-none\" ng-show=\"vm.noDdcbItem[userParmType.userParmTypeCd] && settingsForm[userParmType.userParmTypeCd + \'_Setting\'].$viewValue !== \'\'\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: settingsForm[userParmType.userParmTypeCd + \'_Setting\'].$viewValue}\"></span></span></div></div></div></div><div ng-if=\"userParmType.userParmTypeCd == \'DT_RANGE_CD\' && vm.selectedUserParm[userParmType.userParmTypeCd] === \'CUS\'\"><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-xs-9 col-xs-offset-3\"><div class=\"row\"><div class=\"col-xs-2\"><label class=\"control-label pull-right\" translate=\"settings.usr.fromDateLabel\" style=\"margin-top: 10px;\"></label></div><div class=\"col-xs-4\"><div class=\"form-group input-group date\" id=\"asOfFromDateEl\" as-of-from-date-el=\"\"><input type=\"text\" class=\"form-control short-width-control\" ng-model=\"vm.asOfFromDateStr\" model-view-value=\"true\" ui-mask=\"{{vm.dateMask}}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" ui-options=\"{allowInvalidValue: false, clearOnBlur: false}\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div></div></div></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-xs-9 col-xs-offset-3\"><div class=\"row\"><div class=\"col-xs-2\"><label class=\"control-label pull-right\" translate=\"settings.usr.toDateLabel\" style=\"margin-top: 10px;\"></label></div><div class=\"col-xs-4\"><div class=\"form-group input-group date\" id=\"asOfToDateEl\" as-of-to-date-el=\"\"><input type=\"text\" class=\"form-control short-width-control\" ng-model=\"vm.asOfToDateStr\" model-view-value=\"true\" ui-mask=\"{{vm.dateMask}}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" ui-options=\"{allowInvalidValue: false, clearOnBlur: false}\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div></div></div></div></div></div></div></form><div><button id=\"btnApplySettings\" class=\"btn btn-primary settings-apply-button\" ng-click=\"vm.applySettings()\" translate=\"settings.home.applyButton\" ng-disabled=\"!settingsForm.$dirty || vm.applySettingsDisabled()\"></button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/core/template/bcast-template.html","<script type=\"text/ng-template\" id=\"bcast-template.html\"><div class=\"modal-content\"> <div id=\"{{\'myCarousel\' + modal.id}}\" class=\"carousel slide\" data-keyboard=\"true\" data-interval=\"false\" style=\"padding-bottom: 10px !important;\" data-wrap=\"false\"> <!-- Wrapper for slides --> <div class=\"carousel-inner\"> <div class=\"item\" ng-repeat=\"bcastPage in modal.bcastPages\" ng-class=\"{\'active\': $index === 0}\"> <div class=\"modal-header\"> <h2 class=\"modal-title\" id=\"modal-title\"> <span><i class=\"fa fa-tv idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{bcastPage.bcastPageTitlText}}\"></span> </h2> </div> <div class=\"modal-body\" style=\"padding: 10px !important;\"> <img ng-src=\"{{\'data:image/jpeg;base64,\' + bcastPage.fileData}}\" alt=\"{{\'subj.bcast.valid.noPageDataFound\' | translate}}\" style=\"max-height:500px;height:auto;width:100%;\"> </div> </div> </div> <div ng-if=\"(modal.bcastPages.length === 0)\" class=\"modal-body message-error\"> <span translate=\"subj.bcast.valid.noPageDataFound\"></span> </div> <!-- Controls --> <a class=\"left carousel-control\" href=\"{{\'#myCarousel\' + modal.id}}\" role=\"button\" data-slide=\"prev\" ng-click=\"modal.bcastPageView($event, \'prev\')\"> <span class=\"glyphicon glyphicon-chevron-left\"></span> </a> <a class=\"right carousel-control\" href=\"{{\'#myCarousel\' + modal.id}}\" role=\"button\" data-slide=\"next\" ng-click=\"modal.bcastPageView($event, \'next\')\"> <span class=\"glyphicon glyphicon-chevron-right\"></span> </a> <div class=\"modal-footer\"> <div class=\"bcast-indicator-container\" ng-if=\"modal.bcastPages.length > 0\"> <ol class=\"carousel-indicators bcast-indicator-icons\"> <li data-target=\"{{\'#myCarousel\' + modal.id}}\" ng-class=\"{\'active\': $index === 0}\" ng-repeat=\"bcastPage in modal.bcastPages\"> </li> </ol> </div> <div class=\"pull-right\" style=\"margin-top: -7px\"> <span ng-if=\"modal.bcastPages.length > 0\"> <button class=\"pull-left btn btn-default form-reset-button\" ng-click=\"modal.skip()\" ng-if=\"modal.bcastPages.length > 0\"> <span translate=\"subj.bcast.cancelButton\"></span> </button> <span ng-if=\"!modal.lastPage\"> <button class=\"pull-left idmx-link-btn\" href=\"{{\'#myCarousel\' + modal.id}}\" role=\"button\" data-slide=\"next\" ng-click=\"modal.bcastPageView($event, \'next\')\"> <span translate=\"subj.bcast.nextButton\"></span> </button> </span> <span ng-if=\"modal.lastPage\"> <button ng-if=\"modal.bcastViewed\" class=\"pull-left idmx-link-btn\" ng-click=\"modal.close()\"> <span translate=\"subj.bcast.closeButton\"></span> </button> <button ng-if=\"!modal.bcastViewed\" class=\"pull-left btn btn-primary\" ng-click=\"modal.save()\"> <span translate=\"subj.bcast.okButton\"></span> </button> </span> </span> <span ng-if=\"modal.bcastPages.length === 0\"> <button class=\"pull-left idmx-link-btn\" ng-click=\"modal.close()\"> <span translate=\"subj.bcast.closeButton\"></span> </button> </span> </div> </div> </div> </div></script>");
$templateCache.put("app/core/template/breadcrumb-template.html","<ol class=\"breadcrumb\"><li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{active: $last}\"><span ng-if=\"!$last\"><a ng-if=\"crumb.route\" ui-sref=\"{{crumb.route}}\" translate=\"{{crumb.i18n}}\" ui-sref-opts=\"{reload: true}\"></a> <span ng-if=\"!crumb.route\" translate=\"{{crumb.i18n}}\"></span> <a ng-if=\"crumb.subject\" ui-sref=\"app.subject({id: subject.subjId})\">{{subject.targetName}} ({{subject.subjEffDate | shortDateFormat}})</a></span> <span ng-if=\"$last\"><span ng-if=\"!crumb.subject && crumb.route !== \'app.admin.surveys\'\"><b ng-if=\"!vm.setBreadcrumb\" translate=\"{{crumb.i18n}}\"></b> <b ng-if=\"vm.setBreadcrumb\" data-html=\"{{breadcrumb}}\" extract-breadcrumb-text-content=\"\"></b></span> <b ng-if=\"crumb.subject\">{{subject.targetName}} ({{subject.subjEffDate | shortDateFormat}})</b></span> <span ng-if=\"$last && crumb.route === \'app.admin.surveys\'\"><span ng-if=\"vm.setBreadcrumb\"><b translate=\"{{crumb.i18n}}\"></b></span></span></li></ol>");
$templateCache.put("app/core/template/confirm-dialog-template.html","<script type=\"text/ng-template\" id=\"confirm-dialog-template.html\"><div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body\"> <span translate=\"{{modal.text}}\"></span> <div ng-if=\"modal.timerText\" idle-countdown=\"countdown\" ng-init=\"countdown=60\" class=\"modal-body\"> You\'ll be logged off in {{countdown}} second(s). </div> </div> <div class=\"modal-footer\"> <button ng-if=\"!modal.hideCancelButton\" class=\"btn btn-default form-reset-button\" type=\"button\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button ng-if=\"modal.doNotSaveButton\" class=\"btn btn-danger form-do-not-save-button\" type=\"button\" ng-click=\"modal.doNotSave()\" ng-disabled=\"modal.laddaSave\"> <span translate=\"{{(modal.doNotSaveButton) ? modal.doNotSaveButton : \'Do Not Save\'}}\"></span> </button> <button id=\"confirm.dialog.ok\" ladda=\"modal.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\" ng-hide=\"modal.hasErrors\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div></script>");
$templateCache.put("app/core/template/element-opt-label-editor-dialog-template.html","<script type=\"text/ng-template\" id=\"element-opt-label-editor-dialog-template.html\"><div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span>{{modal.title}}</span> </h2> </div> <form name=\"editorForm2\" ng-submit=\"modal.close()\"> <div class=\"modal-body\" id=\"modal-body\" style=\"padding: 15px;\"> <div id=\"summernote-editor\" element-opt-label-summernote-editor data-html-content=\"{{modal.elemOptDesc}}\" data-field-to-update-full=\"{{modal.fieldToUpdateFull}}\"></div> <div class=\"has-error hide summer-note-error\" ng-show=\"editorForm2.$submitted && modal.hasErrors\"> <span class=\"help-block m-b-none\"> <span translate=\"sysAdmin.updtSurv.valid.labelReqd\" translate-values=\"{labelName: modal.fieldToUpdateFull}\"></span> </span> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default form-reset-button summer-note-cancel-btn\" type=\"button\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button type=\"submit\" id=\"confirm.dialog.ok\" ladda=\"modal.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary summer-note-update-btn\" type=\"button\" data-dismiss=\"modal\" ng-disabled=\"!editorForm2.$dirty || (editorForm2.$submitted && modal.hasErrors)\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div> </form></script>");
$templateCache.put("app/core/template/info-dialog-template.html","<script type=\"text/ng-template\" id=\"info-dialog-template.html\"><style> /**The style is added inside ng-template to just reflect scroll bar style for popups and not window scroll bars**/ #modal-body-style::-webkit-scrollbar, #modal-body-style::-webkit-scrollbar-thumb { width: 26px;height: 40%; border-radius: 13px; background-clip: padding-box; border: 10px solid transparent; } #modal-body-style::-webkit-scrollbar-thumb { box-shadow: inset 0 0 0 10px; } #modal-body-style { overflow: auto; transition: color .5s ease; max-height: calc(100vh - 275px); overflow: auto; } </style> <div style=\"overflow: hidden;\" class=\"inner\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-hide=\"modal.isToS\" ng-click=\"modal.cancel()\"> <span aria-hidden=\"true\">�</span></button> <div ng-if=\"modal.langCds.length > 1\" style=\"float: right; padding-bottom: 5px;\"> <div class=\"profile-element idmx-profile-menu-container\" uib-dropdown> <a uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" href=\"#\" style=\"background: transparent;\"> <span class=\"clear\"> <i class=\"fa fa-globe\"></i> <span class=\"text-muted text-xs\">{{modal.userLang.nm}}&nbsp;<b class=\"caret\"></b></span> </span> </a> <ul uib-dropdown-menu class=\"animated flipInX m-t-xs\"> <li ng-repeat=\"lang in modal.langCds\"> <a aria-label=\"menu\" ng-click=\"modal.switchLang(lang.cd)\" role=\"menuitem\"> <span class=\"clear\"> <span class=\"text-xs\">{{lang.nm}}</span> </span> </a> </li> </ul> </div> </div> <h2 class=\"modal-title font-bold\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <!-- modal-body --> <div style=\"padding: 20px 30px 30px 30px; background: #f8fafb;\" id=\"modal-body-style\" style=\"background: white !important; z-index: 0\"> <span translate=\"{{modal.text}}\"></span> </div> <div class=\"modal-footer\" style=\"padding-bottom: 0px !important; \"> <div class=\"row\"> <div class=\"col-md-8 text-center\" style=\"margin-bottom: 10px\"> <small> <span translate=\"login.home.copyrtText\" translate-values=\"{applCopyrt: modal.sysParms.APPL_COPYRT}\"></span> <span translate=\"login.home.copyrtInstrText\"></span> <span translate=\"login.home.tosLink\"></span>. <br/> v{{modal.properties.appVersion}} </small> </div> <div class=\"col-md-4\"> <button ng-if=\"modal.dwdButton\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.download()\"> <span translate=\"{{(modal.dwdButton) ? modal.dwdButton : \'OK\'}}\"></span></button> <button class=\"btn idmx-link-btn\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span></button> </div> </div> </div> </div></script>");
$templateCache.put("app/core/template/subjectstage-dialog-template.html","<script type=\"text/ng-template\" id=\"subjectstage-dialog-template.html\"><div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$subjectStageModalCtrl.cancel()\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span></button> <h2 class=\"modal-title\" id=\"modal-title\"> <span translate=\"{{$subjectStageModalCtrl.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body\"> <div> <table> <tr> <td> <ul id=\"container\"> <li class =\"progressbar\" ng-repeat=\"stage in $subjectStageModalCtrl.subjStage | orderBy : \'cd\'\"> <button class=\"btn btn-stage\" style=\"min-width: 140px;\" uib-popover=\"{{stage.desc}}\" popover-title=\"{{stage.nm}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"false\" popover-placement=\"bottom\">{{stage.nm}}</button> </li> </ul> </td> </tr> </table> </div> </div></script>");
$templateCache.put("app/core/template/summernote-editor-dialog-template.html","<script type=\"text/ng-template\" id=\"summernote-editor-dialog-template.html\"><div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span>{{modal.title}}</span> </h2> </div> <form name=\"editorForm1\" ng-submit=\"modal.close()\"> <div class=\"modal-body\" id=\"modal-body\" style=\"padding: 15px;\"> <div id=\"summernote-editor\" summernote-editor data-html-content=\"{{modal.content}}\" data-field-to-update=\"{{modal.fieldToUpdate}}\" data-field-to-update-full=\"{{modal.fieldToUpdateFull}}\"></div> <div class=\"has-error hide summer-note-error\" ng-show=\"editorForm1.$submitted && modal.hasErrors\"> <span class=\"help-block m-b-none\"> <span translate=\"sysAdmin.updtSurv.valid.labelReqd\" translate-values=\"{labelName: modal.fieldToUpdateFull}\"></span> </span> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default form-reset-button summer-note-cancel-btn\" type=\"button\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button type=\"submit\" id=\"confirm.dialog.ok\" ladda=\"modal.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary summer-note-update-btn\" type=\"button\" data-dismiss=\"modal\" ng-disabled=\"!editorForm1.$dirty || (editorForm1.$submitted && modal.hasErrors)\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div> </form></script>");
$templateCache.put("app/subject/analytics/analytics.html","<div ng-if=\"vm.charts && (!vm.subject || vm.subject.analytics)\"><div class=\"row filter-box\" style=\"background-color: #f3f3f4; margin-left: unset;\"><div class=\"white-bg\" style=\"position: sticky; top: 12px;\"><div class=\"ibox float-e-margins ibox-bottom-margin\"><div class=\"ibox-title scoring-title\"><div class=\"row\" style=\"padding-bottom: 7px; margin-left: -15px;\"><div class=\"col-md-12\" style=\"padding-left: 0px; padding-right: 0px;\"><div class=\"col-md-6\" style=\"padding-left: 13px;\"><div style=\"display: flex\"><h4 translate=\"anlytcs.home.filterLabel\"></h4><div style=\"padding-top: 3px; width: 100%\"><span class=\"label lbl-parms pull-right\" ng-click=\"vm.showSettings()\">{{userParms.DT_RANGE_CD.val | dateRangeLabel}}</span> <span ng-if=\"userParms.ORG_ID\" class=\"label lbl-org pull-right\" ng-click=\"vm.showSettings()\">{{userParms.ORG_ID.val | userParmLabel : \'ORG_ID\'}}</span></div></div><oi-select oi-options=\"item.grpName group by item.grpTypeName for (key, item) in vm.filters track by item.grpId\" ng-model=\"vm.filteredGrps\" multiple=\"\" placeholder=\"{{\'anlytcs.home.allSubjsText\' | translate}}\" ng-change=\"vm.applyFilter()\"></oi-select></div><div class=\"col-md-6\" style=\"padding-right: 13px;\"><div class=\"row\"><div class=\"col-sm-6\"><h4 translate=\"anlytcs.home.grpLabel\"></h4><select class=\"form-control\" ng-model=\"vm.groupByField\"><option value=\"\" disabled=\"\">Please select</option><option ng-repeat=\"grp in vm.grpTypes\" value=\"{{grp.grpSeq}}\" selected=\"\">{{grp.grpName}}</option></select></div><div class=\"col-sm-6\"><h4 translate=\"anlytcs.home.sizeLabel\"></h4><select name=\"sizes\" class=\"form-control\" ng-change=\"vm.sizeChange()\" ng-options=\"size.name for size in vm.chartSizes\" ng-model=\"vm.selectedChartSize\"></select></div></div></div></div></div></div></div></div></div><div class=\"row ibox-content\" style=\"margin-left: 0px; margin-right: 0px; margin-bottom: 14px; padding-left: 13px; padding-right: 0px; padding-bottom: 0px;\" ng-repeat=\"grp in vm.filteredChartGrps\"><h3><span ng-bind-html=\"grp.grpName\"></span> <a ng-if=\"grp.grpDesc\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'anlytcs.home.help.sysDocSubGrpInfo\' | translate}}\" ng-click=\"vm.toggleHelp(grp.grpId)\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showHelp[grp.grpId], \'fa-chevron-down\': vm.showHelp[grp.grpId]}\"></i></a></h3><div class=\"collapse message-help\" ng-class=\"{\'show\': vm.showHelp[grp.grpId]}\"><p ng-bind-html=\"grp.grpDesc\"></p></div><div class=\"col-xs-{{vm.selectedChartSize.xsCol}} col-sm-{{vm.selectedChartSize.smCol}} col-md-{{vm.selectedChartSize.mdCol}} col-lg-{{vm.selectedChartSize.lgCol}}\" style=\"margin-bottom: 0px; padding-left: 0px;\" ng-repeat=\"chart in vm.getGroupCharts(grp.grpId)\"><div ng-if=\"chart.config && chart.config.download && chart.data.series && chart.data.series.length > 0\" class=\"ibox-title charts\" style=\"background: transparent; border: none; height: auto; width: 20; position: absolute; right: {{chart.config.padding.left + 15}}px; top: {{chart.config.padding.top}}px; padding: 0 0 0 0; text-align: right\"><div class=\"ibox-tools\"><a class=\"close-link\" ng-click=\"vm.downloadChart(chart)\" title=\"Download\"><i class=\"fa fa-download\"></i></a></div></div><div style=\"border: 1px solid #e7eaec !important; padding: 0 0 0 0; margin-bottom: 15px\"><idmx-chart id=\"{{chart.chartCd}}\" ng-if=\"chart.config\" config=\"{{chart.config}}\" data=\"{{chart.data}}\"></idmx-chart></div></div></div><div ng-if=\"vm.filteredChartGrps.length === 0\" class=\"message-info col-sm-6 col-sm-offset-3\"><span translate=\"anlytcs.home.valid.noChartsFound\"></span></div></div><div id=\"download-image-placeholder\" style=\"display: none;\"></div><div ng-if=\"!vm.charts || (vm.subject && !vm.subject.analytics)\" class=\"message-error\"><span translate=\"anlytcs.home.valid.noViewAnlytcsPermsn\"></span></div>");
$templateCache.put("app/subject/collaboration/collaboration.html","<div ng-if=\"vm.showCollabFlag\"><div class=\"row wrapper border-bottom white-bg no-border-top no-border-bottom left-right-margin-1 add-wrapper\"><div class=\"ibox\"><div class=\"colab-users adjusted-margins\"><table class=\"table collab-add-user-table zero-margin-bottom\"><tbody><tr><td class=\"no-border-top aligned-top\" style=\"vertical-align: top !important;\"><form name=\"collabAddUserForm\"><div has-any-subj-perms=\"[\'COLLAB_ALL_ORGS\']\" class=\"form-group no-margin-no-padding\" ng-class=\"{\'has-error\': noUsers && !(collabAddUserForm.txtNewUser.$viewValue.length < 1)}\"><div class=\"col-sm-12\"><input type=\"text\" class=\"typeahead input form-control\" id=\"txtNewUser\" name=\"txtNewUser\" ng-focus=\"getUsers()\" ng-model=\"mbSelected\" placeholder=\"{{vm.selectNewMembText}}\" uib-typeahead=\"user as [user.userLastFirstNamePlusOrgPlusId] for user in vm.userList() | filter: {userLastFirstNamePlusOrgPlusId: $viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onSelectUser($item, $model, $label)\" typeahead-no-results=\"noUsers\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-disabled=\"!vm.hasUpdtCollabPerm() || vm.userList().length === 0\"> <span style=\"float: left;\" class=\"help-block m-b-none\" ng-show=\"noUsers && !(collabAddUserForm.txtNewUser.$viewValue.length < 1)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: collabAddUserForm.txtNewUser.$viewValue}\"></span></span> <span class=\"help-block m-b-none\" style=\"line-height: 18.5714px; float: right; height: 18.5714px !important;\"><span>&nbsp;</span></span></div></div><div hasnt-any-subj-perms=\"[\'COLLAB_ALL_ORGS\']\" class=\"form-group no-margin-no-padding\"><select id=\"ddNewUser\" class=\"form-control\" name=\"ddNewUser\" ng-model=\"vm.ddUserSelected\" ng-change=\"vm.onSelectUserDD()\" ng-disabled=\"!vm.hasUpdtCollabPerm() || vm.userList().length === 0\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\">{{vm.selectNewMembText}}</option><option ng-repeat=\"user in vm.userList() | orderBy : \'userLastFirstNamePlusOrgPlusId\'\" value=\"{{user.userId}}\">{{user.userLastFirstNamePlusOrgPlusId}}</option></select></div></form></td><td class=\"collab-table-action-cell no-border-top aligned-top\"><button id=\"btnAddUser\" ng-if=\"vm.userList().length > 0\" class=\"btn idmx-link-btn add-user idmx-square-btn\" has-any-subj-perms=\"[\'UPDT_COLLAB\']\" title=\"{{vm.addMembTitle}}\" ng-click=\"vm.addUser()\" disabled=\"disabled\"><span><i class=\"fa fa-plus\"></i></span></button> <span ng-if=\"vm.userList().length === 0\" class=\"btn idmx-link-btn idmx-square-btn disabled\" has-any-subj-perms=\"[\'UPDT_COLLAB\']\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{vm.addMembTitle}}\" uib-popover=\"{{vm.noMoreUsrsToAdd}}\"><span><i class=\"fa fa-plus\"></i></span></span> <span class=\"btn idmx-link-btn idmx-square-btn disabled\" hasnt-any-subj-perms=\"[\'UPDT_COLLAB\']\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{vm.addMembTitle}}\" uib-popover=\"{{vm.noUpdtCollabPermsn}}\"><span><i class=\"fa fa-plus\"></i></span></span></td></tr></tbody></table></div><div class=\"colab-orgs\"><table class=\"table collab-add-org-table zero-margin-bottom\"><tbody><tr><td class=\"no-border-top aligned-top\" style=\"vertical-align: bottom !important;\"><form name=\"collabAddOrgForm\"><div has-any-subj-perms=\"[\'COLLAB_ALL_ORGS\']\" class=\"form-group zero-margin-bottom\" ng-class=\"{\'has-error\': noOrgs && !(collabAddOrgForm.txtNewOrg.$viewValue.length < 1)}\"><div class=\"col-sm-12\"><input type=\"text\" class=\"typeahead input form-control\" id=\"txtNewOrg\" name=\"txtNewOrg\" ng-model=\"mbOrgSelected\" ng-focus=\"getOrgs()\" placeholder=\"{{vm.selectNewOrgText}}\" uib-typeahead=\"org as [org.orgNamePlusRefNum] for org in vm.orgList() | filter: {orgNamePlusRefNum: $viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onSelectOrg($item, $model, $label)\" typeahead-no-results=\"noOrgs\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" typeahead-is-open=\"vm.isOpen\" autocomplete=\"off\" ng-disabled=\"!vm.hasUpdtCollabPerm() || vm.orgList().length === 0\"> <span style=\"float: left;\" class=\"help-block m-b-none\" ng-show=\"noOrgs && !(collabAddOrgForm.txtNewOrg.$viewValue.length < 1)\"><span translate=\"subj.home.valid.ddcbNoDataFound\" translate-values=\"{text: collabAddOrgForm.txtNewOrg.$viewValue}\"></span></span> <span class=\"help-block m-b-none\" style=\"line-height: 18.5714px; float: right; height: 18.5714px !important;\"><span>&nbsp;</span></span></div></div><div hasnt-any-subj-perms=\"[\'COLLAB_ALL_ORGS\']\" class=\"form-group zero-margin-bottom\"><select id=\"ddNewOrg\" class=\"form-control\" name=\"ddNewOrg\" ng-model=\"vm.ddOrgSelected\" ng-change=\"vm.onSelectOrgDD()\" ng-disabled=\"!vm.hasUpdtCollabPerm() || vm.orgList().length === 0\"><option disabled=\"\" selected=\"\" value=\"\" class=\"placeholder-color\">{{vm.selectNewOrgText}}</option><option ng-repeat=\"org in vm.orgList() | orderBy : \'orgNamePlusRefNum\'\" value=\"{{org.orgId}}\">{{org.orgNamePlusRefNum}}</option></select></div></form></td><td class=\"collab-table-action-cell no-border-top aligned-top\"><button id=\"btnAddOrg\" ng-if=\"vm.orgList().length > 0\" class=\"btn idmx-link-btn idmx-square-btn add-org\" has-any-subj-perms=\"[\'UPDT_COLLAB\']\" title=\"{{vm.addOrgTitle}}\" ng-click=\"vm.addOrg()\" disabled=\"disabled\"><span><i class=\"fa fa-plus\"></i></span></button> <span ng-if=\"vm.orgList().length === 0\" class=\"btn idmx-link-btn idmx-square-btn disabled\" has-any-subj-perms=\"[\'UPDT_COLLAB\']\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{vm.addOrgTitle}}\" uib-popover=\"{{vm.noMoreOrgsToAdd}}\"><span><i class=\"fa fa-plus\"></i></span></span> <span class=\"btn idmx-link-btn idmx-square-btn disabled\" hasnt-any-subj-perms=\"[\'UPDT_COLLAB\']\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{vm.addOrgTitle}}\" uib-popover=\"{{vm.noUpdtCollabPermsn}}\"><span><i class=\"fa fa-plus\"></i></span></span></td></tr></tbody></table></div></div></div><div class=\"row wrapper white-bg no-border-bottom left-right-margin-1 margin-bottom-5px\"><div class=\"ibox\"><div class=\"colab-users\"><table class=\"table\" style=\"margin-bottom: 0px;\"><thead><tr><th class=\"collab-table-header-cell no-border-bottom\"><b translate=\"collab.home.membNameHeader\"></b></th><th ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\" class=\"rotate no-border-bottom\"><div><span ng-class=\"{\'lbl-roles-chk-error\': vm.isUserRoleRequiredAndNotHeld(userRoleType) || vm.uniqueUserRoleClash(userRoleType)}\" class=\"lbl-roles truncate\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{userRoleType.userRoleTypeName}}\" uib-popover=\"{{userRoleType.userRoleTypeDesc}}\">{{userRoleType.userRoleTypeName}}</span></div></th><th class=\"collab-table-action-cell rotate no-border-bottom\"><div><span class=\"lbl-collaboration\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{\'collab.home.sendEmailHeader\' | translate}}\" uib-popover=\"{{\'collab.home.help.sendEmailText\' | translate}}\" translate=\"collab.home.sendEmailHeader\"></span></div></th><th class=\"collab-table-action-cell no-border-bottom\">&nbsp;</th></tr></thead></table></div><div class=\"colab-orgs\"><table class=\"table\" style=\"margin-bottom: 0px; margin-left: 20px;\"><thead><tr><th class=\"collab-table-header-cell no-border-bottom\"><b translate=\"collab.home.orgNameHeader\"></b></th><th ng-repeat=\"orgRoleType in vm.orgRoleTypes | orderBy:\'dispSeq\'\" class=\"rotate no-border-bottom org-td-width\"><div><span ng-class=\"{\'lbl-roles-chk-error\': vm.isOrgRoleRequiredAndNotHeld(orgRoleType) || vm.uniqueOrgRoleClash(orgRoleType)}\" class=\"lbl-roles truncate\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{orgRoleType.orgRoleTypeName}}\" uib-popover=\"{{orgRoleType.orgRoleTypeDesc}}\" style=\"padding: 3px 7px; margin-bottom: -3px;\">{{orgRoleType.orgRoleTypeName}}</span></div></th><th class=\"collab-table-action-cell no-border-bottom\">&nbsp;</th></tr></thead></table></div></div></div><div class=\"row wrapper border-bottom white-bg no-border-top no-border-bottom left-right-margin-1 margin-bottom-5px\" ng-repeat=\"org in vm.orgs | orderBy:[\'dispSeq\', vm.getMinUserDispSeq, \'orgName\']\" ng-class=\"{\'margin-bottom-100px\': ($index === vm.orgs.length -1)}\"><div class=\"ibox\"><div class=\"colab-users padded-top-bottom-3px\"><table class=\"table table-striped table-hover collab-content-table\" style=\"margin-bottom: 0px;\"><tbody><tr data-user-id=\"user.userId\" ng-repeat=\"user in vm.users | orderBy:[\'dispSeq\', \'userLastFirstName\']\" ng-if=\"user.orgId === org.orgId\"><td class=\"collab-table-header-cell\"><span ng-class=\"{\'red-normal\': user.subjUserRoles.length === 0 || vm.hasUniqueUserRoleClash(user)}\">{{user.userLastFirstName}}</span></td><td ng-repeat=\"userRoleType in vm.userRoleTypes | orderBy:\'dispSeq\'\" ng-init=\"userCheckboxVariable = vm.holdsUserRole(user, userRoleType)\" class=\"checkbox-td\"><span popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{user.popover[userRoleType.userRoleTypeCd].title}}\" uib-popover=\"{{user.popover[userRoleType.userRoleTypeCd].content}}\"><input icheck=\"\" type=\"checkbox\" ng-model=\"userCheckboxVariable\" ng-change=\"vm.userRoleChange(user, userRoleType)\" user=\"user\" user-role-type=\"userRoleType\" users=\"{{vm.users}}\" unique-subj=\"{{vm.uniqueRoleClashes.subjId}}\" collab-user-role-type=\"\"></span></td><td class=\"collab-table-action-cell\"><input icheck=\"\" type=\"checkbox\" has-any-subj-perms=\"[\'UPDT_COLLAB\']\" ng-if=\"vm.isUserInManageableUsers(user)\" ng-model=\"user.sendNewEmail\" ng-change=\"vm.sendNewEmailChange()\"> <span has-any-subj-perms=\"[\'UPDT_COLLAB\']\" ng-if=\"!vm.isUserInManageableUsers(user)\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{\'collab.home.help.sendEmailTitle\' | translate}}\" uib-popover=\"{{\'collab.home.valid.noCollabAllOrgsPermsnForMemb\' | translate}}\"><input icheck=\"\" type=\"checkbox\" ng-model=\"user.sendNewEmail\" disabled=\"\"></span> <span hasnt-any-subj-perms=\"[\'UPDT_COLLAB\']\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{\'collab.home.help.sendEmailTitle\' | translate}}\" uib-popover=\"{{\'collab.home.valid.noUpdtCollabPermsn\' | translate}}\"><input icheck=\"\" type=\"checkbox\" ng-model=\"user.sendNewEmail\" disabled=\"\"></span></td><td class=\"collab-table-action-cell\"><div ng-disabled=\"user.disableDeleteBtn\" popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{user.deleteBtnPopover.title}}\" uib-popover=\"{{user.deleteBtnPopover.content}}\" ng-click=\"vm.removeUser(user)\" class=\"btn btn-danger idmx-square-btn delete-user\"><i class=\"fa fa-trash-o\"></i></div></td></tr><tr ng-if=\"vm.isOrgWithoutUsers(org)\"><td colspan=\"{{vm.userRoleTypes.length + 2}}\" style=\"text-align: center; font-weight: bold; padding: 1px !important;\"><div class=\"message-info\" style=\"padding: 12px; margin-bottom: 0px;\"><span>{{vm.noMembsFoundText}}</span></div></td></tr></tbody></table></div><div class=\"colab-orgs padded-top-bottom-3px\"><table class=\"table table-striped table-hover collab-content-table\" style=\"margin-bottom: 0px; margin-left: 20px;\"><tbody><tr><td class=\"collab-table-header-cell\"><span ng-class=\"{\'red-normal\': org.subjOrgRoless.length === 0 || vm.hasUniqueOrgRoleClash(org)}\">{{org.orgName}}</span></td><td ng-repeat=\"orgRoleType in vm.orgRoleTypes | orderBy:\'dispSeq\'\" ng-init=\"orgCheckboxVariable = vm.holdsOrgRole(org, orgRoleType)\" class=\"checkbox-td org-td-width\"><span popover-append-to-body=\"true\" popover-placement=\"bottom\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{org.popover[orgRoleType.orgRoleTypeCd].title}}\" uib-popover=\"{{org.popover[orgRoleType.orgRoleTypeCd].content}}\"><input icheck=\"\" type=\"checkbox\" ng-model=\"orgCheckboxVariable\" ng-change=\"vm.orgRoleChange(org, orgRoleType)\" org=\"org\" org-role-type=\"orgRoleType\" orgs=\"{{vm.orgs}}\" unique-subj=\"{{vm.uniqueRoleClashes.subjId}}\" collab-org-role-type=\"\"></span></td><td class=\"collab-table-action-cell\"><div ng-disabled=\"org.disableDeleteBtn\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{org.deleteBtnPopover.title}}\" uib-popover=\"{{org.deleteBtnPopover.content}}\" ng-click=\"vm.removeOrg(org)\" class=\"btn btn-danger idmx-square-btn delete-org\"><i class=\"fa fa-trash-o\"></i></div></td></tr></tbody></table></div></div></div><div class=\"footer fixed zero-bottom-padding\"><div class=\"alert alert-warning left-right-margin-1 red-normal white-bg no-borders strong-font\" style=\"padding-bottom: 0px; padding-top: 0px !important; padding-top: 7px; width: 100%; text-align: left; margin-bottom: 0px !important;\"><div style=\"padding-right: 10px; float: left;\" class=\"colab-users\"><ul style=\"margin-left: -32px;\"><li ng-repeat=\"userRoleType in vm.requiredUserRolesNotHeld | orderBy:\'dispSeq\'\">{{userRoleType.errMsg}}</li><li ng-if=\"vm.isUserWithoutRole()\">{{vm.usrRoleTypeReqd}}</li><li ng-if=\"!vm.subjsInSubjGrp && vm.uniqueRoleClashes.subjId && vm.targUserRoleTypes.length > 0 && vm.targOrgRoleTypes.length === 0\" translate=\"collab.home.valid.usrSubjExists\"></li><li ng-if=\"!vm.subjsInSubjGrp && vm.uniqueRoleClashes.subjId && vm.targUserRoleTypes.length > 0 && vm.targOrgRoleTypes.length > 0\" translate=\"collab.home.valid.orgUsrSubjExists\"></li></ul></div><div style=\"padding-right: 180px !important; float: left;\" class=\"colab-orgs\"><ul style=\"margin-left: -12px;\"><li ng-repeat=\"orgRoleType in vm.requiredOrgRolesNotHeld | orderBy:\'dispSeq\'\">{{orgRoleType.errMsg}}</li><li ng-if=\"vm.isOrgWithoutRole()\">{{vm.orgRoleTypeReqd}}</li><li ng-if=\"!vm.subjsInSubjGrp && vm.uniqueRoleClashes.subjId && vm.targOrgRoleTypes.length > 0 && vm.targUserRoleTypes.length === 0\" translate=\"collab.home.valid.orgSubjExists\"></li><li ng-if=\"!vm.subjsInSubjGrp && vm.uniqueRoleClashes.subjId && vm.targOrgRoleTypes.length > 0 && vm.targUserRoleTypes.length > 0\" translate=\"collab.home.valid.orgUsrSubjExists\"></li></ul></div><div style=\"position: absolute; right: 40px; top: 7px; bottom: 7px;\"><button ladda=\"vm.collabResetLadda\" class=\"btn btn-default form-reset-button\" type=\"button\" ng-click=\"vm.resetForm($event)\" ng-disabled=\"vm.disableReset\" aria-label=\"Reset Changes\" translate=\"collab.home.resetButton\"></button> <button ladda=\"vm.collabSaveLadda\" class=\"btn btn-primary btn-save collab-ladda-btn\" ng-disabled=\"vm.disableSave || vm.requiredUserRolesNotHeld.length > 0 || vm.requiredOrgRolesNotHeld.length > 0 || vm.isUserWithoutRole() || vm.isOrgWithoutRole() || (!vm.subjsInSubjGrp && vm.uniqueRoleClashes.subjId)\" data-style=\"zoom-in\" type=\"button\" ng-click=\"vm.openConfirmDialog($event)\" aria-label=\"Save\" translate=\"collab.home.saveButton\"></button></div></div><br><br><br><br></div></div><div ng-if=\"!vm.showCollabFlag\" class=\"message-error\"><span translate=\"collab.home.valid.noMangCollabPermsn\"></span></div>");
$templateCache.put("app/subject/documents/document-upload-template.html","<script type=\"text/ng-template\" id=\"document-upload-template.html\"><style> /**The style is added inside ng-template to just reflect scroll bar style for popups and not window scroll bars**/ *::-webkit-scrollbar, *::-webkit-scrollbar-thumb { width: 26px;height: 40%; border-radius: 13px; background-clip: padding-box; border: 10px solid transparent; } *::-webkit-scrollbar-thumb { box-shadow: inset 0 0 0 10px; } #modal-body-style { border-radius: 3px; overflow: auto; color: rgba(50,50,50, 0); text-shadow: 0 0 black; box-shadow: 0 1px 6px rgba(50,50,50, 0.2); transition: color .5s ease; max-height: calc(100vh - 250px); overflow: auto; z-index: 0; } #modal-body-style:hover { color: rgba(50,50,50, 0.8); } #modal-body-style>ol,.modal-body>ol,li { color: #787878; } </style> <div style=\"max-height:650px;overflow-y: hidden;\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"docu.home.modal.upldDocCloseButton\"></span></button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body-style\"> <ul class=\'agile-list\' style=\'padding-left:0px;margin-top:-5px;\'> <li ng-class=\"{\'obsv-wgt-best\': modal.obsv.files.length>0}\" docu-side-bar obsv-cnt-wgt=\"{{modal.obsv.obsvPrioritySeq}}\"> {{modal.obsv.name}} <a class=\'toggleLink collapsed\' data-toggle=\'collapse\' data-target=\'#obsvPop{{modal.obsv.obsvId}}\'></a> <div id=\"obsvPop{{modal.obsv.obsvId}}\" class=\"collapse message-help\"> <p ng-bind-html=\"modal.getHtmlSafeText(modal.obsv.desc)\"></p> </div> <div class=\"agile-detail\"> <i class=\"fa fa-files-o\"></i> <span ng-if=\"modal.obsv.files.length != 0\"> <span translate=\"docu.home.lvl3Node.docUplddText\"></span> ({{modal.obsv.files.length}}) </span> <span ng-if=\"modal.obsv.files.length === 0\"> <span translate=\"docu.home.lvl3Node.docReqstdText\"></span> (0) </span> </div> </li> </ul> <p><span translate=\"docu.home.modal.upldDocText\"></span> <button type=\'button\' has-any-subj-perms=\"[\'UPLD_DOC\']\" ng-click=\'modal.openUploadModal(modal.obsv)\' class=\'idmx-link-btn\' style=\'float:right;\'><i class=\"fa fa-plus-circle\"> </i> <span translate=\"docu.home.modal.upldDocAddFileButton\"></span></button> <button disabled=\"true\" type=\'button\' hasnt-any-subj-perms=\"[\'UPLD_DOC\']\" class=\'idmx-link-btn\' style=\'float:right;\'> <span translate=\"docu.home.modal.upldDocAddFileButton\"></span></button> </p><br/> <table documents-dt id=\"documentsTable\" class=\'idmx-table table table-striped table-bordered table-hover\'> <thead> <tr> <th translate=\"docu.home.modal.upldDocFileNameHeader\"></th> <th translate=\"docu.home.modal.upldDocFileSizeHeader\"></th> <th translate=\"docu.home.modal.upldDocUplddByHeader\"></th> <th translate=\"docu.home.modal.upldDocUpldDtHeader\"></th> <th translate=\"docu.home.modal.upldDocActnsHeader\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"file in modal.obsv.files\"> <td>{{file.filename}}</td> <td>{{file.filesize}}</td> <td>{{file.createUserName}}</td> <td>{{file.dateUploaded}}</td> <td> <div uib-dropdown> <button class=\'idmx-dd-link-btn\' uib-dropdown-toggle data-toggle=\'dropdown\'> <span translate=\"docu.home.modal.upldDocActnButton\"></span> <span class=\"caret\"></span> </button> <ul uib-dropdown-menu class=\'animated flipInX m-t-xs pull-right\' style=\'z-index:1000 !important\'> <li> <a ng-click=\"modal.download(file)\"> <i class=\'fa fa-eye\' uib-tooltip=\"{{\'docu.home.modal.upldDocViewButton\' | translate}}\"></i>&nbsp; <span translate=\"docu.home.modal.upldDocViewButton\"></span> </a> </li> <li> <a has-any-subj-perms=\"[\'UPLD_DOC\']\" ng-click=\"modal.confirmDelete(file)\"> <i class=\'fa fa-trash\' uib-tooltip=\"{{\'docu.home.modal.upldDocDelButton\' | translate}}\"></i>&nbsp; <span translate=\"docu.home.modal.upldDocDelButton\"></span> </a> <span class=\"disabledAction\" hasnt-any-subj-perms=\"[\'UPLD_DOC\']\"> <a><i class=\'fa fa-trash\' uib-tooltip=\"{{\'docu.home.modal.upldDocDelButton\' | translate}}\"></i>&nbsp; <span translate=\"docu.home.modal.upldDocDelButton\"></span></a> </span> </li> </ul> </div> </td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button ng-if=\"modal.dwdButton\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.download()\"> <span translate=\"{{(modal.dwdButton) ? modal.dwdButton : \'OK\'}}\"></span></button> <button class=\"btn idmx-link-btn\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span></button> </div> </div></script>");
$templateCache.put("app/subject/documents/documents.html","<div class=\"row filter-box\" style=\"background-color: #f3f3f4; margin-left: unset;\"><div class=\"white-bg\" style=\"position: sticky; top: 12px;\"><div class=\"ibox float-e-margins ibox-bottom-margin\"><div class=\"ibox-title scoring-title\"><div class=\"row\" style=\"padding-bottom: 7px; margin-left: -15px;\"><div class=\"col-md-12\" style=\"padding-left: 0px; padding-right: 0px;\"><div class=\"col-md-6\" style=\"padding-left: 13px;\"><div style=\"display: flex;\"><h4 translate=\"docu.home.filterLabel\"></h4><div style=\"padding-top: 3px;\"><span docu-badge=\"\" docu-cnt=\"{{vm.getFilterObsvMetrics().cnt}}\" docu-wgt=\"{{vm.getFilterObsvMetrics().highestPriority}}\" docu-satsfd=\"{{vm.getFilterObsvMetrics().satsfdCnt}}\" class=\"margin-left-5px\">{{vm.getFilterObsvMetrics().satsfdCnt}}/{{vm.getFilterObsvMetrics().cnt}}</span></div></div><oi-select id=\"filters\" oi-options=\"item.nm group by item.type for (key, item) in vm.filters track by item.cd\" ng-model=\"vm.filterByField\" multiple=\"\" placeholder=\"{{\'docu.home.allDocReqsText\' | translate}}\" ng-change=\"vm.applyFilter()\"></oi-select></div><div class=\"col-md-6\" style=\"padding-right: 13px;\"><div class=\"row\"><div class=\"col-sm-6\"><h4 translate=\"docu.home.grpLabel\"></h4><select ng-model=\"vm.groupByField\" class=\"form-control pointer\"><option value=\"level2NodeId\">{{vm.lvl2HierLvlName}}</option><option value=\"level3NodeId\">{{vm.lvl3HierLvlName}}</option><option value=\"obsvPrioritySeq\">{{vm.priorityName}}</option></select></div><div class=\"col-sm-6\"><h4 translate=\"docu.home.sortLabel\"></h4><select ng-model=\"vm.orderByField\" class=\"form-control pointer\"><option value=\"obsvPrioritySeq\" translate=\"docu.home.sortPriotHLLabel\"></option><option value=\"-obsvPrioritySeq\" translate=\"docu.home.sortPriotLHLabel\"></option></select></div></div></div></div></div></div></div></div></div><div ng-if=\"vm.getFilteredObsvs().length === 0\" class=\"message-info\"><span translate=\"docu.home.valid.noDataFound\"></span></div><div class=\"grid\" id=\"container\" style=\"margin-left: -1px;\"><span ng-repeat=\"value in vm.getFilteredObsvs() | groupBy: vm.groupByField | toArray: true | orderBy: \'parseInt(value.$key)\' : vm.groupByOrder\" on-finish-render=\"buildMasonryLayout\"><div class=\"grid-item gray-bg\"><div class=\"ibox\"><div class=\"ibox-content\"><h3><span>{{vm.getGroup(value.$key, vm.groupByField).nm}}</span> <a ng-if=\"vm.getGroup(value.$key, vm.groupByField).desc\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'docu.home.help.docuHierNodeInfo\' | translate}}\" ng-click=\"vm.toggleGroupHelp(value.$key)\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showGroupHelp[value.$key], \'fa-chevron-down\': vm.showGroupHelp[value.$key]}\"></i></a></h3><div ng-show=\"{{vm.getGroup(value.$key, vm.groupByField).desc != null}}\" class=\"collapse message-help\" ng-class=\"{\'show\': vm.showGroupHelp[value.$key]}\"><p ng-bind-html=\"vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc)\"></p></div><ul ui-sortable=\"sortableOptions\" class=\"sortable-list connectList agile-list\" ng-model=\"todoList\"><li ng-if=\"value.length\" ng-repeat=\"obsv in value | orderBy:[vm.orderByField, \'obsvId\']\" ng-class=\"{\'obsv-wgt-best\': obsv.files.length>0}\" docu-side-bar=\"\" obsv-cnt-wgt=\"{{obsv.obsvPrioritySeq}}\"><div><span ng-bind-html=\"obsv.name\"></span> <a tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'docu.home.help.docuDetlInfo\' | translate}}\" ng-click=\"vm.toggleObsvHelp(obsv.obsvId)\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showObsvHelp[obsv.obsvId], \'fa-chevron-down\': vm.showObsvHelp[obsv.obsvId]}\"></i></a></div><div id=\"obsv{{obsv.obsvId}}\" class=\"collapse message-help\" ng-class=\"{\'show\': vm.showObsvHelp[obsv.obsvId]}\" on-hidden-shown=\"buildMasonryLayout\"><p ng-bind-html=\"vm.getHtmlSafeText(obsv.desc)\"></p></div><div class=\"agile-detail\"><a has-any-subj_perms=\"[\'VIEW_DOC\']\" type=\"button\" class=\"pull-right btn btn-xs btn-white\" ng-click=\"vm.openUploadDialog($event, obsv)\"><span translate=\"docu.home.lvl3Node.nextActnButton\"></span></a> <a hasnt-any-subj_perms=\"[\'VIEW_DOC\']\" type=\"button\" class=\"pull-right btn btn-xs btn-white\" disabled=\"\"><span translate=\"docu.home.lvl3Node.nextActnButton\"></span></a> <i class=\"fa fa-files-o\"></i> <span ng-if=\"obsv.files.length != 0\"><span translate=\"docu.home.lvl3Node.docUplddText\"></span> ({{obsv.files.length}})</span> <span ng-if=\"obsv.files.length === 0\"><span translate=\"docu.home.lvl3Node.docReqstdText\"></span> (0)</span></div></li></ul><div ng-if=\"!value.length\" class=\"message-info\"><span translate=\"docu.home.lvl3Node.noDocReqsText\"></span></div></div></div></div></span></div><div ng-if=\"!vm.observations\" class=\"message-error\"><span translate=\"obsv.home.valid.noViewObsvPermsn\"></span></div><div ng-include=\"\'app/subject/documents/document-upload-template.html\'\"></div><script type=\"text/ng-template\" id=\"browse-button-template.html\"><div style=\"max-height:650px;overflow-y: hidden;\"> <form class=\"form-horizontal\" name=\"uploadform\" id=\"uploadform\" method=\"POST\" enctype=\"multipart/form-data\"> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\"> <span aria-hidden=\"true\">�</span> <span class=\"sr-only\" translate=\"docu.home.modal.upldDocCloseButton\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body-style\"> <span translate=\"docu.home.modal.addFileText\"></span><br/><br/> <span translate=\"docu.home.modal.addFileSelectedText\"></span> <ul class=\"browse-modal-list\"> <li ng-repeat=\"file in myFile\">{{file.name}}<span style=\"color:#ED5565\" ng-show=\"file.size > modal.maxUploadSize\"> *</span></li> </ul> <span class=\"file-upload-error\" id=\"file_upload_error\" translate=\"docu.home.valid.fileSizeInvld\" translate-values=\"{\'fileSize\': \'{{modal.maxUploadSize | fileSize}}\' }\"></span> <span class=\"btn idmx-link-btn custom-btn-file\" style=\"margin-top:10px;\" ng-disabled=\"modal.laddaSave\"> <span translate=\"docu.home.modal.browseButton\"></span> <input type=\"file\" file-modal=\"$parent.myFile\" id=\"file\" name=\"file\" max-length=\"{{modal.maxUploadSize}}\" ng-disabled=\"modal.laddaSave\" multiple/> </span> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"modal.cancel()\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button id=\"file-upload-btn\" ng-disabled=\"true\" ladda=\"modal.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div> </form> </div></script>");
$templateCache.put("app/subject/observations/observations.html","<div class=\"row filter-box\" style=\"background-color: #f3f3f4; margin-left: unset;\"><div class=\"white-bg\" style=\"position: sticky; top: 12px;\"><div class=\"ibox float-e-margins ibox-bottom-margin\"><div class=\"ibox-title scoring-title\"><div class=\"row\" style=\"padding-bottom: 7px; margin-left: -15px;\"><div class=\"col-md-12\" style=\"padding-left: 0px; padding-right: 0px;\"><div class=\"col-md-6\" style=\"padding-left: 13px;\"><div style=\"display: flex;\"><h4 translate=\"obsv.home.filterLabel\"></h4><div style=\"padding-top: 3px;\"><span obsv-cnt-badge=\"\" obsv-cnt-wgt=\"{{vm.getFilterObsvMetrics().highestPriority}}\" class=\"margin-left-5px\">{{vm.getFilterObsvMetrics().cnt}}</span></div></div><oi-select oi-options=\"item.nm group by item.type for (key, item) in vm.filters track by item.cd\" ng-model=\"vm.filterByField\" multiple=\"\" placeholder=\"{{\'obsv.home.allObsvsText\' | translate}}\" ng-change=\"vm.applyFilter(event)\" ng-click=\"event = $event\" ng-init=\"vm.filterInit()\"></oi-select></div><div class=\"col-md-6\" style=\"padding-right: 13px;\"><div class=\"row\"><div class=\"col-sm-6\"><h4 translate=\"obsv.home.grpLabel\"></h4><select ng-model=\"vm.groupByField\" class=\"form-control pointer\"><option value=\"level2NodeId\">{{vm.lvl2HierLvlName}}</option><option value=\"level3NodeId\">{{vm.lvl3HierLvlName}}</option><option value=\"obsvPrioritySeq\">{{vm.priorityName}}</option><option value=\"typeCd\">{{vm.typeName}}</option></select></div><div class=\"col-sm-6\"><h4 translate=\"obsv.home.sortLabel\"></h4><select ng-model=\"vm.orderByField\" class=\"form-control pointer\"><option value=\"obsvPrioritySeq\" translate=\"obsv.home.sortPriotHLLabel\"></option><option value=\"-obsvPrioritySeq\" translate=\"obsv.home.sortPriotLHLabel\"></option></select></div></div></div></div></div></div></div></div></div><div ng-if=\"vm.getFilteredObsvs().length === 0\" class=\"message-info\"><span translate=\"obsv.home.valid.noDataFound\"></span></div><div class=\"grid\" id=\"container\" style=\"margin-left: -1px;\"><span ng-repeat=\"value in vm.getFilteredObsvs() | groupBy:vm.groupByField | toArray:true | orderBy: \'parseInt(value.$key)\' : vm.groupByOrder\" on-finish-render=\"buildMasonryLayout\"><div class=\"grid-item gray-bg\"><div class=\"ibox-content\"><h3><span>{{vm.getGroup(value.$key, vm.groupByField).nm}}</span> <a ng-if=\"vm.getGroup(value.$key, vm.groupByField).desc\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'obsv.home.help.obsvHierNodeInfo\' | translate}}\" ng-click=\"vm.toggleGroupHelp(value.$key)\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showGroupHelp[value.$key], \'fa-chevron-down\': vm.showGroupHelp[value.$key]}\"></i></a></h3><div ng-show=\"{{vm.getGroup(value.$key, vm.groupByField).desc !== null}}\" class=\"message-help message-sm collapse\" ng-class=\"{\'show\': vm.showGroupHelp[value.$key]}\"><span ng-bind-html=\"vm.getHtmlSafeText(vm.getGroup(value.$key, vm.groupByField).desc)\"></span></div><ul ui-sortable=\"sortableOptions\" class=\"sortable-list connectList agile-list\" ng-model=\"todoList\"><li ng-if=\"value.length\" ng-repeat=\"obsv in value | orderBy:[vm.orderByField , \'obsvId\']\" obsv-side-bar=\"\" obsv-cnt-wgt=\"{{obsv.obsvPrioritySeq}}\"><div><span ng-bind-html=\"obsv.name\"></span> <a tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'obsv.home.help.obsvDetlInfo\' | translate}}\" ng-click=\"vm.toggleObsvHelp(obsv.obsvId)\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showObsvHelp[obsv.obsvId], \'fa-chevron-down\': vm.showObsvHelp[obsv.obsvId]}\"></i></a></div><div class=\"collapse message-help message-sm\" ng-class=\"{\'show\': vm.showObsvHelp[obsv.obsvId]}\" on-hidden-shown=\"buildMasonryLayout\"><span ng-bind-html=\"vm.getHtmlSafeText(obsv.desc)\"></span></div><div class=\"agile-detail\"><a class=\"pull-right btn btn-xs btn-white\" ng-click=\"vm.openWhyDialog(obsv)\"><span translate=\"obsv.home.lvl3Node.nextActnButton\"></span></a> <i class=\"fa fa-flag\"></i>&nbsp;{{obsv.type}}</div></li></ul></div></div></span></div><div ng-if=\"!vm.observations\" class=\"message-error\"><span translate=\"obsv.home.valid.noViewObsvPermsn\"></span></div><div ng-include=\"\'app/subject/observations/obsv-why-template.html\'\"></div>");
$templateCache.put("app/subject/observations/obsv-why-template.html","<script type=\"text/ng-template\" id=\"obsv-why-template.html\"><style> /**The style is added inside ng-template to just reflect scroll bar style for popups and not window scroll bars**/ #modal-body-style::-webkit-scrollbar, #modal-body-style::-webkit-scrollbar-thumb { width: 26px;height: 40%; border-radius: 13px; background-clip: padding-box; border: 10px solid transparent; } #modal-body-style::-webkit-scrollbar-thumb { box-shadow: inset 0 0 0 10px; } #modal-body-style { overflow: auto; transition: color .5s ease; max-height: calc(100vh - 275px); overflow: auto; } </style> <div style=\"overflow-y: hidden;\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span></button> <h2 class=\"modal-title\" id=\"modal-title\"> <span><i class=\"fa fa-flag idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"obsv.home.modal.whyThisObsvTitle\" translate-values=\"{obsvTypeName: modal.obsv.type}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body-style\"> <ul class=\"agile-list\" style=\"padding-left:0px; margin-top:-5px;\"> <li obsv-side-bar obsv-cnt-wgt=\"{{modal.obsv.obsvPrioritySeq}}\"> <span ng-bind-html=\"modal.obsv.name\"></span> <a class=\"toggleLink collapsed\" data-toggle=\"collapse\" data-target=\"#obsvPop{{modal.obsv.obsvId}}\"></a> <div id=\"obsvPop{{modal.obsv.obsvId}}\" class=\"collapse message-help message-sm\"> <p ng-bind-html=\"modal.obsv.desc\"></p> </div> <div class=\"agile-detail\"> <i class=\"fa fa-flag\"></i>&nbsp;{{modal.obsv.type}} </div> </li> </ul> <p translate=\"obsv.home.modal.whyThisObsvExplText\" translate-values=\"{obsvTypeName: modal.obsv.type}\"></p> <div ng-repeat=\"rule in modal.obsv.obsvRules | orderBy:[\'survTypeDispSeq\', \'survSectSeq\', \'questSeq\']\" class=\"level3-score\" style=\"margin-left:2px; margin-top:5%;\"> <b ng-bind-html=\"modal.getQuestionLabel(rule)\"></b> </br></br> <div class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-1\" translate=\"obsv.home.modal.whyThisObsvQuestLabel\"></span> <span class=\"col-sm-11\" ng-bind-html=\"rule.questText\"></span> </div> <div class=\"row\"> <span class=\"col-sm-1\" translate=\"obsv.home.modal.whyThisObsvAnswLabel\"></span> <span class=\"col-sm-11\"> <div ng-repeat=\"elem in rule.elements | orderBy: \'answElemSeq\'\"> <div ng-if=\"!elem.elemLabelText\" class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-12\" ng-bind-html=\"elem.survAnswText\"></span> </div> <div ng-if=\"elem.elemLabelText\" class=\"row\" style=\"margin-bottom: 5px;\"> <span class=\"col-sm-12\" ng-bind-html=\"elem.elemLabelText + \': <b>\' + elem.survAnswText + \'</b>\'\"></span> </div> </div> </span> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn idmx-link-btn\" type=\"button\" data-dismiss=\"modal\" ng-click=\"modal.close()\" translate=\"obsv.home.modal.whyThisObsvCloseButton\"> </button> </div> </div></script>");
$templateCache.put("app/subject/scoring/score.html","<script type=\"text/javascript\">\n    $(function () {\n        setTimeout(function () {\n            $(\'#score-comparison-keys\').slimScroll({\n                height: \'calc(100vh - 370px)\',\n                railVisible: true\n            });\n        });\n    });\n</script><div ng-if=\"vm.lvl1ScoreTypes\" class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"scoreTab\" class=\"nav nav-tabs\"><li has-any-subj-perms=\"[\'VIEW_SCORE_TYPE_COMP\']\" class=\"active\"><a data-target=\"#tab-1\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.home.scoreTypeCompTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div id=\"tab-1\" has-any-subj-perms=\"[\'VIEW_SCORE_TYPE_COMP\']\" class=\"tab-pane active animated fadeInRight idmx-tab-pane\" style=\"overflow: hidden\"><div class=\"row\"><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><h3 style=\"margin-left: 15px; margin-bottom: 15px;\"><span translate=\"score.home.scoreTypeComp.chartDesc\"></span></h3><div class=\"ibox-content scoring-content target-scores\"><idmx-chart id=\"scChart\" config=\"{{vm.scChartConfig}}\" data=\"{{vm.scChartData()}}\" element-callback=\"vm.jumpToScoreTypeFromChart(element)\"></idmx-chart></div></div><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 0px;\"><div class=\"ibox margin-bottom-5px float-e-margins\"><div class=\"scoring-title\"><h3 ng-if=\"vm.peerGroups.length !== 0 || vm.targetsExist || vm.nextTargetsExist\" translate=\"score.home.scoreComp.compToText\" style=\"margin-left: 15px;\"></h3><hr ng-if=\"vm.peerGroups.length !== 0 || vm.targetsExist || vm.nextTargetsExist\" style=\"margin: 5px 0px;\"><div class=\"row\"><div class=\"col-md-12\"><div ng-if=\"vm.peerGroups.length !== 0\" class=\"zero-left-padding\" style=\"margin-bottom: 5px;\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-4\"><div class=\"compare-to-peergrp\" style=\"padding-left: 5px; border-radius: 5px;\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px; text-align: right;\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.compareToPeerGrp\" un-selectable=\"true\"></div><label><span class=\"small-label\" style=\"line-height: 23.2px;\" translate=\"score.home.scoreComp.peerGrpLabel\"></span></label></div></div><div class=\"col-xs-8\"><div class=\"pull-left\"><select ng-show=\"vm.peerGroups.length === 1\" class=\"form-control peer-group-select\" ng-model=\"vm.selectedPeerGrp\" ng-options=\"peerGrp.peerGrpName for peerGrp in vm.peerGroups\" disabled=\"\"></select><select ng-show=\"vm.peerGroups.length > 1\" class=\"form-control peer-group-select\" ng-model=\"vm.selectedPeerGrp\" ng-options=\"peerGrp.peerGrpName for peerGrp in vm.peerGroups\"></select></div></div></div></div></div><div ng-if=\"vm.targetsExist || vm.nextTargetsExist\" class=\"zero-left-padding\" style=\"margin-bottom: 5px;\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-class=\"{\'col-xs-4\': !vm.latestTargFlag && vm.targetsExist && vm.nextTargetsExist, \'col-xs-12\': vm.latestTargFlag || !(vm.targetsExist && vm.nextTargetsExist)}\"><div class=\"compare-to-target\" style=\"padding-left: 5px; border-radius: 5px;\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px; text-align: right;\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.compareToTarget\" un-selectable=\"true\" ng-disabled=\"vm.isTargetDisabled\"></div><label><span class=\"small-label\" ng-class=\"{\'disabled\': option.optValue === \'targetScore\' && vm.isTargetDisabled}\" style=\"line-height: 23.2px;\"><span translate=\"score.home.scoreComp.targLabel\"></span> <span ng-if=\"!vm.latestTargFlag && vm.targetsExist && !vm.nextTargetsExist\">(<span translate=\"score.home.scoreComp.targCurrRadio\"></span>)</span> <span ng-if=\"!vm.latestTargFlag && !vm.targetsExist && vm.nextTargetsExist\">(<span translate=\"score.home.scoreComp.targNextRadio\"></span>)</span></span></label></div></div><div ng-if=\"!vm.latestTargFlag && vm.targetsExist && vm.nextTargetsExist\" class=\"col-xs-8\"><div class=\"survey-form-row inline\"><input name=\"targetType\" icheck=\"\" type=\"radio\" value=\"current\" ng-model=\"vm.targetType\" ng-disabled=\"vm.isCurrentTargetDisabled\"> <span class=\"zero-bottom-margin opt-question-label\" translate=\"score.home.scoreComp.targCurrRadio\"></span></div><div class=\"survey-form-row inline\"><input name=\"targetType\" icheck=\"\" type=\"radio\" value=\"next\" ng-model=\"vm.targetType\" ng-disabled=\"vm.isNextTargetDisabled\"> <span class=\"zero-bottom-margin opt-question-label\" translate=\"score.home.scoreComp.targNextRadio\"></span></div></div></div></div></div></div><div class=\"col-md-12\" style=\"margin-left: 15px;\"><h3 translate=\"score.home.keyTitle\"></h3></div></div></div><div class=\"ibox-content scoring-content\" id=\"score-comparison-keys\"><chart-keys-accordion ng-if=\"vm.scKeyData\" style=\"padding-bottom: 0px;\" class=\"target-scores svg-container\" data=\"{{vm.scKeyData}}\"></chart-keys-accordion></div></div></div></div></div></div></div></div></div></div></div><div ng-if=\"!vm.lvl1ScoreTypes\" class=\"message-error\"><span translate=\"score.home.valid.noViewScorePermsn\"></span></div>");
$templateCache.put("app/subject/survey/child-element-help-block.template.html","<span ng-if=\"(noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex].$viewValue) || vm.requiredSubElementErrors[element.elemId][rowIndex][childElement.elemId] || vm.subElemFormatErrors[element.elemId][rowIndex][childElement.elemId] || vm.subElemNaNErrors[element.elemId][rowIndex][childElement.elemId] || vm.elemValidationMsgs[element.elemId][rowIndex][childElement.elemId]\" class=\"help-block m-b-none\" style=\"text-align: left;\"><div ng-if=\"vm.subElemFormatErrors[element.elemId][rowIndex][childElement.elemId]\"><span ng-if=\"!vm.subElemNaNErrors[element.elemId][rowIndex][childElement.elemId] && childElement.elemInputTypeCd !== \'DATE\'\" translate=\"surv.updtSurv.valid.elemFormtInvld\" translate-values=\"{\'elemLabelText\': childElement.elemName, \'elemWatrmkText\': childElement.elemWatrmkText}\"></span> <span ng-if=\"childElement.elemInputTypeCd === \'DATE\'\" translate=\"surv.updtSurv.valid.elemDtInvld\" translate-values=\"{\'elemLabelText\': childElement.elemName, \'usrPrefDtFormtVal\': vm.dateFormat}\"></span></div><div ng-if=\"!vm.subElemFormatErrors[element.elemId][rowIndex][childElement.elemId]\"><span ng-if=\"vm.subElemNaNErrors[element.elemId][rowIndex][childElement.elemId]\" translate=\"surv.updtSurv.valid.elemNotNum\" translate-values=\"{\'elemLabelText\': childElement.elemName}\"></span><div ng-if=\"!vm.subElemNaNErrors[element.elemId][rowIndex][childElement.elemId]\"><span ng-if=\"vm.requiredSubElementErrors[element.elemId][rowIndex][childElement.elemId]\" translate=\"surv.updtSurv.valid.elemReqd\" translate-values=\"{\'elemLabelText\': childElement.elemName}\"></span> <span ng-if=\"vm.elemValidationMsgs[element.elemId][rowIndex][childElement.elemId] && !noResults\">{{vm.elemValidationMsgs[element.elemId][rowIndex][childElement.elemId]}}</span></div></div><span ng-if=\"(noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex].$viewValue)\" translate=\"surv.updtSurv.valid.elemDDCBNotFound\" translate-values=\"{\'elemLabelText\': childElement.elemName, \'elemVal\': elForm[\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex].$viewValue}\"></span></span>");
$templateCache.put("app/subject/survey/element-help-block.template.html","<span ng-if=\"(noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue) || vm.requiredElementErrors[element.elemId] || vm.formatErrors[element.elemId] || vm.NaNErrors[element.elemId] || vm.elemValidationMsgs[element.elemId]\" class=\"help-block m-b-none\" style=\"text-align: left;\"><div ng-if=\"vm.formatErrors[element.elemId]\"><span ng-if=\"!vm.NaNErrors[element.elemId] && element.elemInputTypeCd !== \'DATE\'\" translate=\"surv.updtSurv.valid.elemFormtInvld\" translate-values=\"{\'elemLabelText\': element.elemName, \'elemWatrmkText\': element.elemWatrmkText}\"></span> <span ng-if=\"element.elemInputTypeCd === \'DATE\'\" translate=\"surv.updtSurv.valid.elemDtInvld\" translate-values=\"{\'elemLabelText\': element.elemName, \'usrPrefDtFormtVal\': vm.dateFormat}\"></span></div><div ng-if=\"!vm.formatErrors[element.elemId]\"><span ng-if=\"vm.NaNErrors[element.elemId]\" translate=\"surv.updtSurv.valid.elemNotNum\" translate-values=\"{\'elemLabelText\': element.elemName}\"></span><div ng-if=\"!vm.NaNErrors[element.elemId]\"><span ng-if=\"vm.requiredElementErrors[element.elemId]\" translate=\"surv.updtSurv.valid.elemReqd\" translate-values=\"{\'elemLabelText\': element.elemName}\"></span> <span ng-if=\"vm.elemValidationMsgs[element.elemId] && !noResults\">{{vm.elemValidationMsgs[element.elemId]}}</span></div></div><span ng-if=\"(noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue)\" translate=\"surv.updtSurv.valid.elemDDCBNotFound\" translate-values=\"{\'elemLabelText\': element.elemName, \'elemVal\': elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue}\"></span></span>");
$templateCache.put("app/subject/survey/survey.html","<style type=\"text/css\">\n    .steps-indicator > li {\n        min-width: {{vm.stepWidth + \'px\'}};\n        width: {{vm.stepWidth + \'px\'}};\n    }\n\n    .form-control[disabled] {\n        background-color: #fff;\n        cursor: text;\n    }\n\n    /* Overriding disabled images with readonly images for iradio and icheckbox only on this page*/\n    .iradio_square-idmx.disabled {\n        background-position: -288px 0;\n        cursor: not-allowed !important;\n    }\n\n    .iradio_square-idmx.checked.disabled {\n        background-position: -312px 0;\n        cursor: not-allowed !important;\n    }\n\n    .icheckbox_square-idmx.disabled {\n        background-position: -120px 0;\n        cursor: not-allowed !important;\n    }\n\n    .icheckbox_square-idmx.checked.disabled {\n        background-position: -144px 0;\n        cursor: not-allowed !important;\n    }\n\n</style><div ng-if=\"vm.section\" class=\"row wrapper wrapper-content survey-wrapper-content animated\" style=\"padding-left: 15px; padding-right: 15px;\"><div class=\"ibox float-e-margins border-bottom white-bg\" style=\"margin-bottom: 0px; padding-bottom: 3px !important;\"><div class=\"ibox-title\"><div class=\"surv-heading-text-no-edit\" style=\"margin-bottom: 5px;\"><h3><span ng-bind-html=\"vm.section.sectionName\"></span> <a ng-if=\"vm.section.sectionDesc\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'surv.home.help.survSectInfo\' | translate}}\" ng-click=\"vm.toggleSectionHelp()\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showSectionHelp, \'fa-chevron-down\': vm.showSectionHelp}\"></i></a></h3></div><div class=\"surv-help-text-no-edit collapse\" style=\"margin-bottom: 10px;\" ng-class=\"{\'show\': vm.showSectionHelp}\"><p ng-bind-html=\"vm.section.sectionDesc\" style=\"margin: 0px; cursor: text !important;\"></p></div><div ng-if=\"vm.section.sectionInstrs\" class=\"\" style=\"padding-left: 15px;\"><p ng-bind-html=\"vm.section.sectionInstrs\" style=\"margin: 0px; cursor: text !important;\"></p></div></div><div class=\"ibox-content survey-ibox-content hidden-xs\" style=\"margin-top: 20px; padding-bottom: 0px !important;\"><div class=\"survey-col-lg-12\"><div class=\"steps-indicator-container\"><ul class=\"steps-indicator\"><li id=\"stepper-{{question.questSeq}}\" ng-repeat=\"question in vm.section.questions\" ng-style=\"{width: (100/vm.section.questions.length) + \'%\'};\" ng-hide=\"vm.isQuestionHidden(question.questSeq)\" ng-class=\"{ \'answered\': vm.isQuestionAnswered(question), \'active\': question.questSeq === vm.currentQuestionSeq, \'pending\': vm.pendingSectionQuestions().indexOf(question.questSeq) >= 0, \'na\': vm.naSectionQuestions().indexOf(question.questSeq) >= 0, \'disabled\': (vm.freezeOps && question.questSeq !== vm.currentQuestionSeq) || vm.visibleSectionQuestions().indexOf(question.questSeq) < 0, \'next-step-hidden\': vm.isNextQuestionHidden(question.questSeq), \'last-step\': vm.isLastStep(question.questSeq) }\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{vm.getStepTooltip(question)}}\"><a data-qsequence=\"{{question.questSeq}}\" ng-click=\"vm.gotoQuestion(question.questSeq, (vm.previousQuestionSeq > question.questSeq) ? -1 : 1)\"></a></li></ul></div></div></div></div><form name=\"surveyForm\" novalidate=\"\"><div ng-repeat=\"question in [vm.currentQuestion]\" ng-class=\"{show: question.questSeq === vm.currentQuestionSeq, hide: question.questSeq !== vm.currentQuestionSeq}\"><div class=\"ibox float-e-margins border-bottom animated carousel\" id=\"{{\'question-\'+ question.questSeq}}\" ng-class=\"{fadeInRight: question.questSeq === vm.currentQuestionSeq && vm.fadeDirn === \'r\', fadeInLeft: question.questSeq === vm.currentQuestionSeq && vm.fadeDirn === \'l\'}\" ng-if=\"question.questSeq === vm.currentQuestionSeq\" style=\"margin-top: 0px !important; border-bottom: none !important; margin-bottom: 1px !important;\"><div class=\"ibox-content survey-question-card\" style=\"border-bottom: 0px; margin-bottom: 0px; padding-bottom: 2px; cursor: auto !important;\"><h3 style=\"padding-left: 15px; cursor: text !important;\"><span data-translate=\"surv.home.questText\"></span> {{question.questSeq}}</h3><div style=\"padding: 5px 15px;\"><span ng-bind-html=\"question.questText\" style=\"margin: 0px;\"></span> <a ng-if=\"question.questHelpText\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" uib-tooltip=\"{{\'surv.home.help.survQuestInfo\' | translate}}\" ng-click=\"vm.toggleQuestionHelp()\"><i class=\"fa idmx-chevron\" ng-class=\"{\'fa-chevron-right\': !vm.showQuestionHelp, \'fa-chevron-down\': vm.showQuestionHelp}\"></i></a></div><div ng-show=\"question.questHelpText\" class=\"message-help message-sm collapse\" ng-class=\"{\'show\': vm.showQuestionHelp}\"><p ng-bind-html=\"question.questHelpText\" style=\"cursor: text !important;\"></p></div><ng-form name=\"questionForm\" novalidate=\"\"><div class=\"row survey-form-row\" ng-repeat=\"row in question.rows\" style=\"margin-left: 0px; margin-top: 15px;\"><div ng-repeat=\"element in row.elements\"><ng-form name=\"elForm\" novalidate=\"\"><div ng-if=\"element.elemInputTypeCd !==\'CHBX\'\"><div ng-if=\"!element.dispLabel\" class=\"form-group zero-bottom-margin col-sm-{{element.elemWidth}}\" ng-style=\"{\'visibility\': vm.visibleSectionElements.indexOf(element.elemId) >= 0 ? \'visible\' : \'hidden\'}\" style=\"padding-left: 0px; padding-right: 0px;\"><div ng-include=\"\'app/subject/survey/survey_element.template.html\'\" class=\"col-sm-12\"></div></div><div ng-if=\"element.dispLabel\"><div ng-if=\"element.labelPosnCd === \'TOP\' || element.labelPosnCd === \'BOTTOM\'\" class=\"form-group zero-bottom-margin col-sm-{{element.elemWidth}}\" ng-style=\"{\'visibility\': vm.visibleSectionElements.indexOf(element.elemId) >= 0 ? \'visible\' : \'hidden\'}\"><span ng-if=\"element.labelPosnCd === \'TOP\'\" class=\"control-label\" ng-class=\"{\'required\': element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span><div ng-if=\"element.elemInputTypeCd === \'TABL\'\" style=\"float: right; margin-top: -12px;\"><button ng-if=\"!element.viewOnlyFlag\" type=\"button\" class=\"idmx-link-btn\" ng-click=\"vm.addTableRow(element)\" ng-disabled=\"!vm.updateEnabled\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"surv.updtSurv.tabl.addEntryButton\" translate-values=\"{elemLabelText: element.elemName}\"></span></button></div><div ng-include=\"\'app/subject/survey/survey_element.template.html\'\" style=\"margin-top: 7px;\"></div><span ng-if=\"element.labelPosnCd === \'BOTTOM\'\" class=\"control-label\" ng-class=\"{\'required\': element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span></div><div ng-if=\"element.labelPosnCd === \'LEFT\' || element.labelPosnCd === \'RIGHT\'\" class=\"form-group zero-bottom-margin\" ng-style=\"{\'visibility\': vm.visibleSectionElements.indexOf(element.elemId) >= 0 ? \'visible\' : \'hidden\'}\"><span ng-if=\"element.labelPosnCd === \'LEFT\'\" class=\"col-sm-{{element.labelWidth}} control-label lbl-left text-right\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"{{(element.elemInputTypeCd ===\'CHBX\') ? \'padding-right : 10px !important; margin-top: 0px !important\' : \'\'}}\"></span><div ng-include=\"\'app/subject/survey/survey_element.template.html\'\" class=\"col-sm-{{element.elemWidth - element.labelWidth}}\"></div><span ng-if=\"element.labelPosnCd === \'RIGHT\'\" class=\"col-sm-{{element.labelWidth}} control-label text-left\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"padding-top: 7px; padding-left: 0px; margin-left: -2px;\"></span></div></div></div><div ng-if=\"element.elemInputTypeCd === \'CHBX\'\" class=\"col-sm-{{element.elemWidth}}\" ng-style=\"{\'visibility\': vm.visibleSectionElements.indexOf(element.elemId) >= 0 ? \'visible\' : \'hidden\'}\"><div ng-if=\"element.dispLabel && element.labelPosnCd === \'RIGHT\'\" class=\"form-group\" style=\"text-align : left; display: flex; align-items: stretch; margin-bottom: 0px; margin-top: 7px\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px; vertical-align: unset !important;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled || element.viewOnlyFlag\" tabindex=\"{{element.elemTabSeq}}\"></div><span class=\"control-label lbl-right-chkbox\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" for=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"margin-top: 1.5px !important;\"></span></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'LEFT\'\" class=\"form-group\" style=\"text-align: right; padding-right: 10px; display: flex; float: right; margin-bottom: 0px; margin-top: 8px\"><span ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\':!element.isElemLabel}\" for=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-left: 10px; vertical-align: unset !important;\" \"=\"\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled || element.viewOnlyFlag\" tabindex=\"{{element.elemTabSeq}}\" style=\"margin-top: 1.5px !important;\"></div></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'TOP\'\" class=\"form-group zero-bottom-margin zero-left-padding\"><span class=\"col-sm-12\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"margin-bottom: 5px; padding-left: 0px;\"></span><div class=\"icheckbox icheckbox_square-idmx\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled || element.viewOnlyFlag\" tabindex=\"{{element.elemTabSeq}}\"></div></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'BOTTOM\'\" class=\"form-group zero-bottom-margin zero-left-padding\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"display: block; margin-bottom: 5px !important;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled || element.viewOnlyFlag\" tabindex=\"{{element.elemTabSeq}}\"></div><span class=\"control-label col-sm-12\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"padding-left: 0px;\"></span></div><div ng-if=\"!element.dispLabel\"><div class=\"form-group\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled || element.viewOnlyFlag\" tabindex=\"{{element.elemTabSeq}}\"></div></div><div ng-if=\"!element.viewOnlyFlag\" ng-include=\"\'app/subject/survey/element-help-block.template.html\'\" ng-class=\"{\'has-error\': (noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue) || vm.requiredElementErrors[element.elemId] || vm.formatErrors[element.elemId] || vm.NaNErrors[element.elemId] || vm.elemValidationMsgs[element.elemId]}\"></div></div></ng-form></div></div><div ng-if=\"question.inclAddlCommt\" class=\"row\" style=\"margin-left: 0px;\"><div class=\"form-group zero-bottom-margin col-sm-12\"><hr class=\"survey-comments-hr\"></div><div class=\"form-group zero-bottom-margin col-sm-12\"><label class=\"control-label\" ng-class=\"{\'required\': question.addlCommtReqd}\" for=\"{{\'comments-\' + question.questSeq}}\" data-translate=\"surv.home.commtInstrText\"></label><div ng-class=\"{\'has-error\': vm.requiredCommentErrors[question.questId]}\"><textarea id=\"{{\'comments-\' + question.questSeq}}\" class=\"form-control\" name=\"{{\'comments-\' + question.questSeq}}\" question=\"{{question}}\" maxlength=\"2000\" ng-model=\"vm.comments[question.questId]\" ng-change=\"vm.onElementChange()\" rows=\"3\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\">\n                                    </textarea> <label id=\"comments-req-label\" class=\"md-caption comment-counter\">{{(vm.comments[question.questId].length) ? (vm.comments[question.questId].length) + \'/2000\' : \'0/2000\'}}</label> <span class=\"help-block m-b-none\" ng-show=\"vm.requiredCommentErrors[question.questId]\"><span translate=\"surv.updtSurv.valid.commtReqd\"></span></span><br></div></div></div></ng-form></div></div></div></form></div><div class=\"survey-footer survey-nav-buttons\" ng-if=\"vm.section\"><div ng-repeat=\"question in [vm.currentQuestion]\" ng-class=\"{show: question.questSeq === vm.currentQuestionSeq, hide: question.questSeq !== vm.currentQuestionSeq}\"><span ng-show=\"vm.isFirstVisibleQuestion(question.questSeq)\"><button name=\"savePreviousSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"btn btn-primary btn-save survey-btn\" data-style=\"zoom-in\" type=\"button\" ng-click=\"vm.saveSurveyAndIncrementSection(-1)\" aria-label=\"SAVE and PREVIOUS SECTION\" ng-show=\"vm.updateEnabled && $root.isSurveyDirty\" ng-disabled=\"vm.freezeOps || vm.isFirstVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.savePrevSectButton\"></span></span></button><button name=\"nextSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementSection(-1, true, \'app.subject.survey.section.update\')\" aria-label=\"PREVIOUS SECTION\" ng-show=\"vm.updateEnabled && !$root.isSurveyDirty\" ng-disabled=\"vm.freezeOps || vm.isFirstVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.prevSectButton\"></span></span></button><button name=\"previousSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementSection(-1, false, \'app.subject.survey.section.view\')\" aria-label=\"PREVIOUS SECTION\" ng-show=\"!vm.updateEnabled\" ng-disabled=\"vm.freezeOps || vm.isFirstVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.prevSectButton\"></span></span></button></span><button name=\"prevQuestButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementQuestion(question.questSeq, -1)\" aria-label=\"BACK\" ng-show=\"!vm.isFirstVisibleQuestion(question.questSeq)\" ng-disabled=\"vm.freezeOps\"><span class=\"ng-scope\"><span translate=\"surv.home.prevQuestButton\"></span></span></button><button name=\"nextQuestButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementQuestion(question.questSeq, 1)\" aria-label=\"NEXT\" ng-show=\"!vm.isLastVisibleQuestion(question.questSeq)\" ng-disabled=\"vm.freezeOps\"><span class=\"ng-scope\"><span translate=\"surv.home.nextQuestButton\"></span></span></button><span ng-show=\"vm.isLastVisibleQuestion(question.questSeq)\"><button name=\"saveNextSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"btn btn-primary btn-save survey-btn\" data-style=\"zoom-in\" type=\"button\" ng-click=\"vm.saveSurveyAndIncrementSection(1)\" aria-label=\"SAVE and NEXT SECTION\" ng-show=\"vm.updateEnabled && $root.isSurveyDirty\" ng-disabled=\"vm.freezeOps || vm.isLastVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.saveNextSectButton\"></span></span></button><button name=\"nextSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementSection(1, true, \'app.subject.survey.section.update\')\" aria-label=\"NEXT SECTION\" ng-show=\"vm.updateEnabled && !$root.isSurveyDirty\" ng-disabled=\"vm.freezeOps || vm.isLastVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.nextSectButton\"></span></span></button><button name=\"nextSectButton\" ladda=\"vm.laddaSaveSurvSection\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementSection(1, false, \'app.subject.survey.section.view\')\" aria-label=\"NEXT SECTION\" ng-show=\"!vm.updateEnabled\" ng-disabled=\"vm.freezeOps || vm.isLastVisibleSection()\"><span class=\"ng-scope\"><span translate=\"surv.home.nextSectButton\"></span></span></button></span><span ng-show=\"vm.isSurveyFinished()\"><button name=\"saveFinishButton\" ladda=\"vm.laddaFinish\" class=\"btn btn-primary btn-save survey-btn\" data-style=\"zoom-in\" type=\"button\" ng-click=\"vm.saveAndFinishSurvey()\" aria-label=\"SAVE and FINISH\" ng-show=\"$root.isSurveyDirty\" ng-disabled=\"vm.freezeOps\"><span class=\"ng-scope\"><span translate=\"surv.home.saveFinishButton\"></span></span></button><button name=\"finishButton\" ladda=\"vm.laddaFinish\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.finishSurvey()\" aria-label=\"FINISH\" ng-show=\"!$root.isSurveyDirty\" ng-disabled=\"vm.freezeOps\"><span class=\"ng-scope\"><span translate=\"surv.home.finishButton\"></span></span></button></span><button name=\"saveButton\" class=\"btn btn-primary btn-save survey-ladda-btn\" ladda=\"vm.laddaSave\" data-style=\"zoom-in\" type=\"button\" ng-click=\"vm.saveSurvey()\" aria-label=\"SAVE\" ng-disabled=\"!$root.isSurveyDirty || vm.freezeOps\" style=\"float: right\" ng-show=\"vm.updateEnabled\"><span class=\"ng-scope\"><span translate=\"surv.home.saveButton\"></span></span></button></div></div><div ng-if=\"!vm.section\" class=\"message-error\"><span translate=\"surv.home.valid.noSurvPermsn\"></span></div><script>\n    function fixViewportHeight() {\n        var pageHeaderHeight = $(\'#idmx-page-header\').height();\n        var pageTitleHeight = $(\'#idmx-page-title\').height();\n        var pageTitleContentGap = 10;\n        var footerHeight = 54;\n        var heightToSub = pageHeaderHeight + pageTitleHeight + pageTitleContentGap + footerHeight;\n        $(\'.survey-wrapper-content\').css(\'height\', \'calc(100vh - \' + heightToSub + \'px)\');\n\n    }\n    \n    $(window).bind(\'resize\', function () {\n        setTimeout(function () {\n            fixViewportHeight();\n        }, 1000);\n    });\n\n</script>");
$templateCache.put("app/subject/survey/survey_element.template.html","<div ng-if=\"element.elemInputTypeCd !== \'TABL\'\"><div ng-if=\"element.viewOnlyFlag\" class=\"control-text\">{{vm.getViewOnlyAnswer(element)}}</div><div ng-if=\"!element.viewOnlyFlag\"><div ng-if=\"element.elemInputTypeCd !== \'VTRB\' && element.elemInputTypeCd !== \'HZRB\' && element.elemInputTypeCd !== \'TABL\' && element.elemInputTypeCd !==\'CHBX\'\" ng-class=\"{\'has-error\': (noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue) || vm.requiredElementErrors[element.elemId] || vm.formatErrors[element.elemId] || vm.NaNErrors[element.elemId] || vm.elemValidationMsgs[element.elemId]}\"><rzslider ng-if=\"element.elemInputTypeCd === \'SLDR\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" rz-slider-model=\"vm.sldrModel[element.elemId]\" rz-slider-options=\"vm.sldrOpts[element.elemId]\" ng-class=\"{\'sldr-val\': vm.answeredElements[element.elemId] !== undefined, \'sldr-no-val\': vm.answeredElements[element.elemId] === undefined}\" ng-keyup=\"vm.onSldrKeyup($event, element.elemId)\"></rzslider><input ng-if=\"element.elemInputTypeCd === \'ATXT\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" ng-model=\"vm.answeredElements[element.elemId]\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"vm.onElementChange()\" type=\"text\" ui-options=\"{allowInvalidValue: true, clearOnBlur: true}\" mask-definitions=\"{\'A\': /[a-zA-Z]/, \'@\': /[a-zA-Z0-9]/, \'9\': /\\d/, \'*\': /./}\" ui-mask=\"{{element.elemEditMask}}\" ui-mask-placeholder-char=\"space\" data-element=\"{{element}}\" survey-input=\"\" field-validation=\"\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"><textarea ng-if=\"element.elemInputTypeCd === \'TXTA\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" ng-model=\"vm.answeredElements[element.elemId]\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"vm.onElementChange()\" ui-options=\"{allowInvalidValue: true, clearOnBlur: true}\" mask-definitions=\"{\'A\': /[a-zA-Z]/, \'@\': /[a-zA-Z0-9]/, \'9\': /\\d/, \'*\': /./}\" ui-mask=\"{{element.elemEditMask}}\" ui-mask-placeholder-char=\"space\" data-element=\"{{element}}\" survey-input=\"\" field-validation=\"\" rows=\"3\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"></textarea><select ng-if=\"element.elemInputTypeCd ===\'DDLB\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" ng-model=\"vm.answeredElements[element.elemId]\" ng-change=\"vm.onElementChange()\" data-element=\"{{element}}\" field-validation=\"\" ng-disabled=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"><option value=\"\">{{element.elemWatrmkText}}</option><option ng-repeat=\"option in element.elemOpts | orderBy : \'elemOptSeq\'\" value=\"{{option.value}}\">{{option.label}}</option></select><input ng-show=\"element.elemInputTypeCd ===\'DDCB\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-DDCB\'}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" type=\"text\" ng-model=\"vm.ddcbModel[element.elemId]\" data-element=\"{{element}}\" field-validation=\"\" class=\"typeahead form-control\" placeholder=\"{{element.elemWatrmkText}}\" uib-typeahead=\"option as [option.label] for option in element.elemOpts | orderBy : \'elemOptSeq\' | filter:{label:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onDdcbSelect(element, $item)\" typeahead-no-results=\"noResults\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" ng-change=\"vm.onDdcbChange(element, this)\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"><div ng-if=\"element.elemInputTypeCd === \'DATE\'\" class=\"input-group date\" id=\"{{\'dp-q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\"><input id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" class=\"form-control\" elem-id=\"{{element.elemId}}\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.dateModel[element.elemId]\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"vm.onDateValueChange()\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" data-element=\"{{element}}\" field-validation=\"\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"><div class=\"input-group-addon\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><span class=\"fa fa-calendar\"></span></div></div><div ng-include=\"\'app/subject/survey/element-help-block.template.html\'\"></div></div><div ng-if=\"element.elemInputTypeCd === \'VTRB\' || element.elemInputTypeCd === \'HZRB\'\"><div ng-repeat=\"option in element.elemOpts | orderBy:\'elemOptSeq\'\" class=\"survey-form-row\" ng-class=\"{\'inline\': element.elemInputTypeCd === \'HZRB\', \'row\': element.elemInputTypeCd === \'VTRB\'}\" style=\"margin-top: 7px; {{((!element.dispLabel) ? \'margin-left: 0px; margin-right: 20px;\' : \'margin-left: 0px;\') + \' \' + ((element.elemInputTypeCd === \'VTRB\') ? (($index === element.elemOpts.length -1) ? \'margin-bottom: 0px !important;\': \'margin-bottom: 21px !important;\') : \'\')}}\"><div style=\"display: flex; align-items: stretch;\"><div style=\"min-width: 25px;\"><input id=\"{{\'q-\' + question.questSeq + \'-el-\' + $index + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" icheck=\"\" type=\"radio\" un-selectable=\"true\" value=\"{{option.value}}\" ng-checked=\"option.value === vm.answeredElements[element.elemId]\" ng-model=\"vm.answeredElements[element.elemId]\" ng-change=\"vm.onElementChange()\" data-element=\"{{element}}\" field-validation=\"\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId)}}\"></div><span class=\"zero-bottom-margin opt-question-label\" ng-bind-html=\"option.trustedLabel\"></span></div></div><div class=\"has-error\" ng-include=\"\'app/subject/survey/element-help-block.template.html\'\"></div></div></div></div><div ng-if=\"element.elemInputTypeCd === \'TABL\'\"><div class=\"row\" style=\"margin-top: 5px\"><div class=\"col-sm-12\"><table id=\"repeatingElementsTable\" data-elements=\"{{element.childElements}}\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th ng-repeat=\"childElement in element.childElements | orderBy : \'elemSeq\'\" class=\"{{childElement.elemWidth ? \'col-sm-\' + childElement.elemWidth : \'col\'}}\"><span class=\"control-label\" ng-if=\"childElement.dispLabel\" ng-class=\"{\'required\': childElement.elemReqd, \'idmx_cursor_pointer\': childElement.elemHelpText, \'bold-label\': !childElement.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{childElement.elemName}}\" uib-popover=\"{{childElement.elemHelpText}}\" ng-bind-html=\"childElement.elemLabelText\"></span></th><th ng-if=\"!element.viewOnlyFlag\"><span class=\"control-label\" ng-bind-html=\"vm.updtSurvActnHdr()\"></span></th></tr></thead><tbody><tr ng-repeat=\"(rowIndex, tableRow) in vm.tablModel[element.elemId]\"><td ng-repeat=\"childElement in element.childElements | orderBy : \'elemSeq\'\" style=\"vertical-align: top !important;\"><div ng-include=\"\'app/subject/survey/survey_element_table_children.template.html\'\"></div></td><td ng-if=\"!element.viewOnlyFlag\" style=\"text-align: center; vertical-align: top !important;\"><button type=\"button\" class=\"btn btn-danger idmx-square-btn\" uib-tooltip=\"{{\'surv.updtSurv.tabl.delEntryButton\' | translate}}\" tooltip-append-to-body=\"true\" ng-click=\"vm.deleteTableRow(element, rowIndex)\" ng-disabled=\"vm.isTablDeleteBtnDisabled(element) || !vm.updateEnabled\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/subject/survey/survey_element_table_children.template.html","<div ng-if=\"childElement.viewOnlyFlag\"><div ng-if=\"childElement.elemInputTypeCd !== \'CHBX\'\" class=\"control-text\">{{vm.getViewOnlyAnswerChild(element, childElement, rowIndex)}}</div><div ng-if=\"childElement.elemInputTypeCd ===\'CHBX\'\" class=\"form-group zero-bottom-margin\" style=\"text-align: left;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"tableRow[childElement.elemId]\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-disabled=\"true\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"></div></div><div ng-if=\"!childElement.viewOnlyFlag\"><div ng-if=\"childElement.elemInputTypeCd !== \'VTRB\' && childElement.elemInputTypeCd !== \'HZRB\' && childElement.elemInputTypeCd !==\'CHBX\'\" ng-class=\"{\'has-error\': (noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex].$viewValue) || vm.requiredSubElementErrors[element.elemId][rowIndex][childElement.elemId] || vm.subElemFormatErrors[element.elemId][rowIndex][childElement.elemId] || vm.subElemNaNErrors[element.elemId][rowIndex][childElement.elemId] || vm.elemValidationMsgs[element.elemId][rowIndex][childElement.elemId]}\"><input ng-if=\"childElement.elemInputTypeCd === \'ATXT\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" class=\"form-control\" ng-model=\"tableRow[childElement.elemId]\" ng-model-options=\"{updateOn: \'blur\'}\" type=\"text\" ui-options=\"{allowInvalidValue: true, clearOnBlur: true}\" mask-definitions=\"{\'A\': /[a-zA-Z]/, \'@\': /[a-zA-Z0-9]/, \'9\': /\\d/, \'*\': /./}\" ui-mask=\"{{childElement.elemEditMask}}\" ui-mask-placeholder-char=\"space\" survey-input=\"\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-change=\"vm.onTablChange(element, childElement, rowIndex)\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"><textarea ng-if=\"childElement.elemInputTypeCd === \'TXTA\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" class=\"form-control\" ng-model=\"tableRow[childElement.elemId]\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: true}\" mask-definitions=\"{\'A\': /[a-zA-Z]/, \'@\': /[a-zA-Z0-9]/, \'9\': /\\d/, \'*\': /./}\" ui-mask=\"{{childElement.elemEditMask}}\" ui-mask-placeholder-char=\"space\" survey-input=\"\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" rows=\"3\" ng-change=\"vm.onTablChange(element, childElement, rowIndex)\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\">\n        </textarea><select ng-if=\"childElement.elemInputTypeCd ===\'DDLB\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" class=\"form-control\" ng-model=\"tableRow[childElement.elemId]\" ng-change=\"vm.onTablChange(element, childElement, rowIndex)\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-disabled=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"><option value=\"\">{{childElement.elemWatrmkText}}</option><option ng-repeat=\"option in childElement.elemOpts | orderBy : \'elemOptSeq\'\" value=\"{{option.value}}\">{{option.label}}</option></select><div ng-if=\"childElement.elemInputTypeCd === \'DATE\'\" class=\"input-group date\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\"><input id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" class=\"form-control\" elem-id=\"{{childElement.elemId}}\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"tableRow[childElement.elemId]\" model-view-value=\"true\" ng-model-options=\"{updateOn: \'blur\'}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"><div class=\"input-group-addon\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><span class=\"fa fa-calendar\"></span></div></div><input ng-show=\"childElement.elemInputTypeCd ===\'DDCB\'\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-DDCB\'}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" type=\"text\" ng-model=\"tableRow[childElement.elemId]\" class=\"typeahead form-control\" placeholder=\"{{childElement.elemWatrmkText}}\" uib-typeahead=\"option as [option.label] for option in childElement.elemOpts | orderBy : \'elemOptSeq\' | filter:{label:$viewValue} | limitTo:8\" typeahead-min-length=\"1\" typeahead-on-select=\"vm.onTablDdcbSelect(element, childElement, rowIndex, $item)\" typeahead-no-results=\"noResults\" typeahead-focus-on-select=\"false\" typeahead-select-on-blur=\"true\" autocomplete=\"off\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-change=\"vm.onTablDdcbChange(element, childElement, rowIndex, this)\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"><div ng-include=\"\'app/subject/survey/child-element-help-block.template.html\'\"></div></div><div ng-if=\"(childElement.elemInputTypeCd === \'VTRB\' || childElement.elemInputTypeCd === \'HZRB\')\"><div class=\"row survey-form-row\" style=\"{{($index === childElement.elemOpts.length -1) ? \'margin-bottom: 0px !important;\': \'margin-bottom: 15px !important;\'}}\" ng-repeat=\"option in childElement.elemOpts | orderBy:\'elemOptSeq\'\" ng-class=\"{\'inline\': childElement.elemInputTypeCd === \'HZRB\'}\"><div style=\"display: flex; align-items: stretch;\"><div style=\"min-width: 25px;\"><input id=\"{{\'q-\' + question.questSeq + \'-el-\' + option.value + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" icheck=\"\" type=\"radio\" un-selectable=\"true\" value=\"{{option.value}}\" ng-checked=\"option.value === vm.answeredElements[childElement.elemId]\" ng-model=\"tableRow[childElement.elemId]\" ng-change=\"vm.onTablChange(element, childElement, rowIndex)\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"></div><span class=\"zero-bottom-margin opt-question-label\" ng-bind-html=\"option.label\"></span></div></div><div class=\"has-error\" ng-include=\"\'app/subject/survey/child-element-help-block.template.html\'\"></div></div><div ng-if=\"childElement.elemInputTypeCd ===\'CHBX\'\" class=\"form-group zero-bottom-margin\" style=\"text-align: left;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex + \'-\' + childElement.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + childElement.elemId + \'-row-\' + rowIndex}}\" elem-id=\"{{childElement.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"tableRow[childElement.elemId]\" data-elemid=\"{{element.elemId}}\" data-questseq=\"{{question.questSeq}}\" data-child-element=\"{{childElement}}\" data-row-index=\"rowIndex\" subfield-validation=\"\" ng-change=\"vm.onTablChbxChange(element, childElement, rowIndex)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{vm.getSurveyFormTabIndex(element.elemId, childElement.elemId, rowIndex)}}\"><div class=\"has-error\" ng-include=\"\'app/subject/survey/child-element-help-block.template.html\'\"></div></div></div>");
$templateCache.put("app/subjects/template/add-subject-dialog-template.html","<script type=\"text/ng-template\" id=\"add-subject-dialog-template.html\"><form novalidate ng-submit=\"modal.continue()\" name=\"addSubjDialogForm\" class=\"form-horizontal\"> <div class = \"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate=\"Close\"></span> </button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa {{modal.icon}} idmx-heading-icon\"></i>&nbsp;</span> <span translate=\"{{modal.title}}\"></span> </h2> </div> <div class=\"modal-body\" id=\"modal-body\"> <div style=\"margin-left:15px;\"> <label translate=\"subj.addSubj.modal.addSubjInstrText\" class=\"form-group lbl-dialog\"></label> <div class=\"form-group\"> <div class=\"col-xs-1\"> <input id=\"newSubjRadio\" name=\"subjRadio\" icheck type=\"radio\" value=\"A\" ng-model=\"modal.data.addSubjSelection\" tabindex=\"1\"> </div> <div class=\"col-xs-11\" style=\"padding: 0px !important\"> <span class=\"opt-question-label\" translate=\"subj.addSubj.modal.newSubjRadio\"> </span> </div> </div> <div class=\"form-group\" ng-if=\"modal.data.repeatableSubjs.length > 0\"> <div class=\"col-xs-1\"> <input id=\"reptSubjRadio\" name=\"subjRadio\" icheck type=\"radio\" value=\"R\" ng-model=\"modal.data.addSubjSelection\" tabindex=\"2\"> </div> <div class=\"col-xs-11\" style=\"padding: 0px !important\"> <span class=\"opt-question-label\" translate=\"subj.addSubj.modal.reptSubjRadio\"> </span> </div> </div> <div class=\"form-group\" ng-if=\"modal.data.clonableSubjs.length > 0\"> <div class=\"col-xs-1\"> <input id=\"cloneSubjRadio\" name=\"subjRadio\" icheck type=\"radio\" value=\"C\" ng-model=\"modal.data.addSubjSelection\" tabindex=\"3\"> </div> <div class=\"col-xs-11\" style=\"padding: 0px !important\"> <span class=\"opt-question-label\" translate=\"subj.addSubj.modal.cloneSubjRadio\"> </span> </div> </div> <span ng-if=\"modal.data.addSubjSelection === \'R\'\"> <hr/> <label translate=\"subj.addSubj.modal.selectReptSubjText\" class=\"required form-group lbl-dialog\"> </label> <div ng-class=\"{\'has-error\': addSubjDialogForm.repeatSubjId.$invalid && (addSubjDialogForm.repeatSubjId.$dirty || addSubjDialogForm.$submitted)}\" > <select class=\"form-control\" required ng-disabled=\"modal.data.repeatableSubjs.length === 1\" name=\"repeatSubjId\" id=\"repeatSubjId\" ng-model=\"modal.data.repeatSubjId\" ng-options=\"subj.subjId as subj.label for subj in modal.data.repeatableSubjs | orderBy: [\'targetName\', \'subjEffDate\']\" > <option value=\"\">{{\'subj.addSubj.modal.selectSubjText\' | translate}} </option> </select> <span class=\"help-block m-b-none\" multiple ng-show=\"addSubjDialogForm.repeatSubjId.$invalid && (addSubjDialogForm.repeatSubjId.$dirty || addSubjDialogForm.$submitted)\" ng-messages=\"addSubjDialogForm.repeatSubjId.$error\"> <span ng-message=\"required\" translate=\"subj.addSubj.modal.selectReptSubjText\"></span> </span> </div> </span> <span ng-if=\"modal.data.addSubjSelection === \'C\'\"> <hr/> <label translate=\"subj.addSubj.modal.selectCloneSubjText\" class=\"form-group required lbl-dialog\"> </label> <div ng-class=\"{\'has-error\': addSubjDialogForm.cloneSubjId.$invalid && (addSubjDialogForm.cloneSubjId.$dirty || addSubjDialogForm.$submitted)}\" > <select class=\"form-control\" required ng-disabled=\"modal.data.clonableSubjs.length === 1\" name=\"cloneSubjId\" id=\"cloneSubjId\" ng-model=\"modal.data.cloneSubjId\" ng-options=\"subj.subjId as subj.label for subj in modal.data.clonableSubjs | orderBy: [\'targetName\', \'subjEffDate\']\" > <option value=\"\">{{\'subj.addSubj.modal.selectSubjText\' | translate}} </option> </select> <span class=\"help-block m-b-none\" multiple ng-show=\"addSubjDialogForm.cloneSubjId.$invalid && (addSubjDialogForm.cloneSubjId.$dirty || addSubjDialogForm.$submitted)\" ng-messages=\"addSubjDialogForm.cloneSubjId.$error\"> <span ng-message=\"required\" translate=\"subj.addSubj.modal.valid.selectCloneSubjReqd\"></span> </span> </div> </span> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default form-reset-button\" type=\"button\" ng-click=\"modal.cancel()\"> <span translate=\"{{(modal.cancelButton) ? modal.cancelButton : \'Cancel\'}}\"></span> </button> <button id=\"confirm.dialog.ok\" data-style=\"zoom-in\" class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"addSubjDialogForm.$invalid\"> <span translate=\"{{(modal.okButton) ? modal.okButton : \'OK\'}}\"></span> </button> </div> </form></script>");
$templateCache.put("app/admin/surveys/survey/author_survey.html","<style type=\"text/css\">\n    /*line passing through indicator*/\n    .steps-indicator::before {\n        width: {{((vm.questionSeqs.length - 1) * vm.stepWidth) + \'px\'}};\n    }\n    .steps-indicator> li {\n        min-width: {{vm.stepWidth + \'px\'}};\n        width: {{vm.stepWidth + \'px\'}};\n    }\n\n    .form-control[disabled] {\n        background-color: #fff;\n        cursor: text;\n    }\n\n    /* Overriding disabled images with readonly images for iradio and icheckbox only on this page*/\n    .iradio_square-idmx.disabled {\n        background-position: -288px 0;\n        cursor: not-allowed !important;\n    }\n\n    .iradio_square-idmx.checked.disabled {\n        background-position: -312px 0;\n        cursor: not-allowed !important;\n    }\n\n    .icheckbox_square-idmx.disabled {\n        background-position: -120px 0;\n        cursor: not-allowed !important;\n    }\n\n    .icheckbox_square-idmx.checked.disabled {\n        background-position: -144px 0;\n        cursor: not-allowed !important;\n    }\n    /* .medium-editor-toolbar {\n        z-index: 1000;\n        position: static;\n        visibility: visible;\n    } */\n\n</style><div ng-if=\"vm.section\" class=\"row\" style=\"margin-left: -7px; margin-right: -7px;\"><form name=\"surveyForm\" novalidate=\"\"><div class=\"ibox float-e-margins border-bottom white-bg\" style=\"margin-bottom: 0px; padding-bottom: 3px !important;\"><div class=\"ibox-title\"><div class=\"surv-heading-text exp-chev\" uib-tooltip=\"{{vm.clickToUpdateSectionNameText}}\" ng-click=\"vm.openSummernoteEditorDialog(\'sectionName\', vm.survSectNameLabel, vm.section.sectionName, \'section\')\" aria-expanded=\"true\"><h3 ng-bind-html=\"vm.section.sectionName\"></h3></div><div ng-if=\"vm.stripHtml(vm.section.sectionDesc)\" uib-tooltip=\"{{vm.clickToUpdateSectionDescText}}\" class=\"surv-help-text\"><p ng-bind-html=\"vm.section.sectionDesc\" ng-click=\"vm.openSummernoteEditorDialog(\'sectionDesc\', vm.survSectDescLabel, vm.section.sectionDesc, \'section\')\"></p></div><div ng-if=\"!vm.stripHtml(vm.section.sectionDesc)\" uib-tooltip=\"{{vm.clickToAddSectionDescText}}\" class=\"surv-help-text\" ng-class=\"{\'notext-editable\': !vm.stripHtml(vm.section.sectionDesc)}\"><p ng-bind-html=\"vm.survSectDescPlaceholder\" ng-click=\"vm.openSummernoteEditorDialog(\'sectionDesc\', vm.survSectDescLabel, vm.section.sectionDesc, \'section\')\"></p></div><div ng-if=\"vm.stripHtml(vm.section.sectionInstrs)\" uib-tooltip=\"{{vm.clickToUpdateSectionInstrsText}}\" class=\"surv-instrs-text\"><p ng-bind-html=\"vm.section.sectionInstrs\" ng-click=\"vm.openSummernoteEditorDialog(\'sectionInstrs\', vm.survSectInstrsLabel, vm.section.sectionInstrs, \'section\')\"></p></div><div ng-if=\"!vm.stripHtml(vm.section.sectionInstrs)\" uib-tooltip=\"{{vm.clickToAddSectionInstrsText}}\" class=\"surv-instrs-text\" ng-class=\"{\'notext-editable\': !vm.stripHtml(vm.section.sectionInstrs)}\"><p ng-bind-html=\"vm.survSectInstrsPlaceholder\" ng-click=\"vm.openSummernoteEditorDialog(\'sectionInstrs\', vm.survSectInstrsLabel, vm.section.sectionInstrs, \'section\')\"></p></div></div><div class=\"ibox-content survey-ibox-content hidden-xs\" style=\"margin-top: 20px; padding-bottom: 0px !important;\"><div class=\"survey-col-lg-12\"><div class=\"steps-indicator-container\"><ul class=\"steps-indicator\"><li ng-hide=\"vm.questionSeqs.indexOf(question.questSeq) < 0\" ng-style=\"{width: (100/vm.section.questions.length) + \'%\'}\" ng-repeat=\"question in vm.section.questions\" ng-class=\"{\'active\': question.questSeq === vm.currentQuestionSeq}\"><a data-qsequence=\"{{question.questSeq}}\" ng-click=\"vm.gotoQuestion(question.questSeq, (vm.previousQuestionSeq> question.questSeq) ? -1 : 1)\"></a></li></ul></div></div></div></div><div ng-repeat=\"question in [vm.currentQuestion]\" ng-class=\"{show: question.questSeq === vm.currentQuestionSeq, hide: question.questSeq !== vm.currentQuestionSeq}\"><div class=\"ibox float-e-margins border-bottom animated carousel\" id=\"{{\'question-\'+ question.questSeq}}\" ng-class=\"{fadeInRight: question.questSeq === vm.currentQuestionSeq && vm.fadeDirn === \'r\', fadeInLeft: question.questSeq === vm.currentQuestionSeq && vm.fadeDirn === \'l\'}\" ng-if=\"question.questSeq === vm.currentQuestionSeq\" style=\"margin-top: 0px !important; border-bottom: none !important; margin-bottom: 1px !important;\"><div class=\"ibox-content survey-question-card\" style=\"padding: 15px;\"><h3 style=\"padding-left: 15px; cursor: text !important;\"><span data-translate=\"surv.home.questText\"></span> {{question.questSeq}}</h3><div class=\"surv-quest-text exp-chev\" uib-tooltip=\"{{vm.clickToUpdatevQuestText}}\" aria-expanded=\"true\"><p ng-bind-html=\"question.questText\" ng-click=\"vm.openSummernoteEditorDialog(\'questText\', vm.survQuestTextLabel, question.questText, \'question\', question.questSeq)\"></p></div><div ng-if=\"vm.stripHtml(question.questHelpText)\" uib-tooltip=\"{{vm.clickToUpdateQuestHelpText}}\" class=\"surv-help-text\"><p ng-bind-html=\"question.questHelpText\" ng-click=\"vm.openSummernoteEditorDialog(\'questHelpText\', vm.survQuestHelpTextLabel, question.questHelpText, \'question\', question.questSeq)\"></p></div><div ng-if=\"!vm.stripHtml(question.questHelpText)\" uib-tooltip=\"{{vm.clickToAddQuestHelpText}}\" class=\"surv-help-text\" ng-class=\"{\'notext-editable\': !vm.stripHtml(question.questHelpText)}\"><p ng-bind-html=\"vm.survQuestHelpTextPlaceholder\" ng-click=\"vm.openSummernoteEditorDialog(\'questHelpText\', vm.survQuestHelpTextLabel, question.questHelpText, \'question\', question.questSeq)\"></p></div><br><ng-form name=\"questionForm\" novalidate=\"\"><div class=\"row survey-form-row\" ng-repeat=\"row in question.rows\" style=\"margin-left: 0px;\"><div ng-repeat=\"element in row.elements\"><ng-form name=\"elForm\" novalidate=\"\"><div ng-if=\"!element.dispLabel && element.elemInputTypeCd !==\'CHBX\'\" class=\"form-group zero-bottom-margin col-sm-{{element.elemWidth}}\" style=\"padding-left: 0px; padding-right: 0px;\"><div ng-include=\"\'app/admin/surveys/survey/author_survey_element.template.html\'\" class=\"col-sm-12\"></div></div><div ng-if=\"element.dispLabel && element.elemInputTypeCd !==\'CHBX\'\"><div ng-if=\"element.labelPosnCd === \'TOP\' || element.labelPosnCd === \'BOTTOM\'\" class=\"form-group zero-bottom-margin col-sm-{{element.elemWidth}}\"><span ng-if=\"element.labelPosnCd === \'TOP\'\" class=\"control-label\" ng-class=\"{\'required\': element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span><div ng-if=\"element.elemInputTypeCd === \'TABL\'\" style=\"float: right; margin-top: -12px;\"><button type=\"button\" class=\"idmx-link-btn\" ng-click=\"vm.addTableRow(element)\" ng-disabled=\"!vm.updateEnabled\"><i class=\"fa fa-plus-circle\"></i> <span translate=\"surv.updtSurv.tabl.addEntryButton\" translate-values=\"{elemLabelText: vm.stripHtml(element.elemLabelText)}\"></span></button></div><div ng-include=\"\'app/admin/surveys/survey/author_survey_element.template.html\'\" style=\"margin-top: 7px;\"></div><span ng-if=\"element.labelPosnCd === \'BOTTOM\'\" class=\"control-label\" ng-class=\"{\'required\': element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span></div><div ng-if=\"element.labelPosnCd === \'LEFT\' || element.labelPosnCd === \'RIGHT\'\" class=\"form-group zero-bottom-margin\" style=\"{{(element.labelPosnCd === \'LEFT\') ? \'text-align : right !important\' : (element.labelPosnCd === \'RIGHT\') ? \'text-align : left !important\' : \'\'}}\"><span ng-if=\"element.labelPosnCd === \'LEFT\'\" class=\"col-sm-{{element.labelWidth}} control-label lbl-left\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"{{(element.elemInputTypeCd ===\'CHBX\') ? \'padding-right : 10px !important; margin-top: 0px !important\' : \'\'}}\"></span><div ng-include=\"\'app/admin/surveys/survey/author_survey_element.template.html\'\" class=\"col-sm-{{element.elemWidth - element.labelWidth}}\"></div><span ng-if=\"element.labelPosnCd === \'RIGHT\'\" class=\"col-sm-{{element.labelWidth}} control-label\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"padding-top: 7px; padding-left: 0px; margin-left: -2px;\"></span></div></div><div ng-if=\"element.elemInputTypeCd === \'CHBX\'\" class=\"col-sm-{{element.elemWidth}}\"><div ng-if=\"element.dispLabel && element.labelPosnCd === \'RIGHT\'\" class=\"form-group\" style=\"text-align : left; display: flex; align-items: stretch;\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{element.elemTabSeq}}\"></div><span class=\"control-label lbl-right-chkbox\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" for=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'LEFT\'\" class=\"form-group\" style=\"text-align: right; padding-right: 10px; display: flex; float: right;\"><span ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\':!element.isElemLabel}\" for=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" popover-append-to-body=\"true\" popover-placement=\"left\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\"></span><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-left: 10px; margin-top: -1px;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{element.elemTabSeq}}\"></div></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'TOP\'\" class=\"form-group zero-bottom-margin zero-left-padding\"><span class=\"col-sm-12\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"margin-bottom: 5px; padding-left: 0px;\"></span><div class=\"icheckbox icheckbox_square-idmx\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{element.elemTabSeq}}\"></div></div><div ng-if=\"element.dispLabel && element.labelPosnCd === \'BOTTOM\'\" class=\"form-group zero-bottom-margin zero-left-padding\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"display: block; margin-bottom: 5px !important;\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{element.elemTabSeq}}\"></div><span class=\"control-label col-sm-12\" ng-class=\"{\'required\': element.elemReqd, \'non-required\': !element.elemReqd, \'idmx_cursor_pointer\': element.elemHelpText, \'bold-label\': !element.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{element.elemName}}\" uib-popover=\"{{element.elemHelpText}}\" ng-bind-html=\"element.elemLabelText\" style=\"padding-left: 0px;\"></span></div><div ng-if=\"!element.dispLabel\" class=\"form-group\"><input icheck=\"\" id=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId + \'-\' + element.elemInputTypeCd}}\" name=\"{{\'q-\' + question.questSeq + \'-el-\' + element.elemId}}\" elem-id=\"{{element.elemId}}\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.chbxModel[element.elemId]\" ng-change=\"vm.onChbxChange(element)\" ng-disabled=\"!vm.updateEnabled\" tabindex=\"{{element.elemTabSeq}}\"></div><div ng-include=\"\'app/subject/survey/element-help-block.template.html\'\" ng-class=\"{\'has-error\': (noResults && elForm[\'q-\' + question.questSeq + \'-el-\' + element.elemId].$viewValue) || vm.requiredElementErrors[element.elemId] || vm.formatErrors[element.elemId] || vm.NaNErrors[element.elemId] || vm.elemValidationMsgs[element.elemId]}\"></div></div></ng-form></div></div><div ng-if=\"question.inclAddlCommt\" class=\"row\" style=\"margin-left: 0px;\"><div class=\"form-group zero-bottom-margin col-sm-12\"><hr class=\"survey-comments-hr\"></div><div class=\"form-group zero-bottom-margin col-sm-12\"><label class=\"control-label\" ng-class=\"{\'required\': question.addlCommtReqd}\" for=\"{{\'comments-\' + question.questSeq}}\" data-translate=\"surv.home.commtInstrText\"></label><div ng-class=\"{\'has-error\': vm.requiredCommentErrors[question.questId]}\"><textarea id=\"{{\'comments-\' + question.questSeq}}\" class=\"form-control\" name=\"{{\'comments-\' + question.questSeq}}\" question=\"{{question}}\" maxlength=\"2000\" ng-model=\"vm.comments[question.questId]\" rows=\"3\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\">\n                                    </textarea> <label id=\"comments-req-label\" class=\"md-caption comment-counter\">{{(vm.comments[question.questId].length) ? (vm.comments[question.questId].length) + \'/2000\' : \'0/2000\'}}</label> <span class=\"help-block m-b-none\" ng-show=\"vm.requiredCommentErrors[question.questId]\"><span translate=\"surv.updtSurv.valid.commtReqd\"></span></span><br></div></div></div><br></ng-form></div></div></div></form><div class=\"survey-footer survey-nav-buttons\" ng-if=\"vm.section\"><div ng-repeat=\"question in [vm.currentQuestion]\" ng-class=\"{show: question.questSeq === vm.currentQuestionSeq, hide: question.questSeq !== vm.currentQuestionSeq}\"><button name=\"prevQuestButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementQuestion(question.questSeq, -1)\" aria-label=\"BACK\" ng-disabled=\"vm.isFirstVisibleQuestion(question.questSeq)\"><span class=\"ng-scope\"><span translate=\"surv.home.prevQuestButton\"></span></span></button><button name=\"nextQuestButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.incrementQuestion(question.questSeq, 1)\" aria-label=\"NEXT\" ng-show=\"!vm.isLastVisibleQuestion(question.questSeq)\"><span class=\"ng-scope\"><span translate=\"surv.home.nextQuestButton\"></span></span></button><span ng-show=\"vm.isLastVisibleQuestion(question.questSeq) && !vm.isLastVisibleSection()\"><button name=\"nextSectButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ng-click=\"vm.goToNextSection()\" aria-label=\"NEXT SECTION\"><span class=\"ng-scope\"><span translate=\"surv.home.nextSectButton\"></span></span></button></span> <span ng-show=\"vm.isLastVisibleQuestion(question.questSeq) && vm.isLastVisibleSection()\"><button name=\"finishButton\" class=\"idmx-link-btn survey-btn\" type=\"button\" ui-sref=\"app.admin.surveys\" aria-label=\"FINISH\"><span class=\"ng-scope\"><span translate=\"surv.home.finishButton\"></span></span></button></span></div></div></div>");
$templateCache.put("app/admin/surveys/survey/author_survey_element.template.html","<div ng-if=\"element.elemInputTypeCd !== \'VTRB\' && element.elemInputTypeCd !== \'HZRB\' && element.elemInputTypeCd !== \'TABL\' && element.elemInputTypeCd !==\'CHBX\'\"><rzslider ng-if=\"element.elemInputTypeCd === \'SLDR\'\" rz-slider-model=\"vm.sldrModel[element.elemId]\" rz-slider-options=\"vm.sldrOpts[element.elemId]\" class=\"sldr-no-val\"></rzslider><input ng-if=\"element.elemInputTypeCd === \'ATXT\'\" class=\"form-control\" type=\"text\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><textarea ng-if=\"element.elemInputTypeCd === \'TXTA\'\" class=\"form-control\" rows=\"3\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"></textarea><select ng-if=\"element.elemInputTypeCd ===\'DDLB\'\" class=\"form-control\" ng-disabled=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><option value=\"\">{{element.elemWatrmkText}}</option><option ng-repeat=\"option in element.elemOpts | orderBy : \'elemOptSeq\'\" value=\"{{option.value}}\">{{option.label}}</option></select><input ng-show=\"element.elemInputTypeCd ===\'DDCB\'\" type=\"text\" class=\"typeahead form-control\" placeholder=\"{{element.elemWatrmkText}}\" ng-model=\"vm.dummyModel\" uib-typeahead=\"option as [option.label] for option in element.elemOpts | orderBy : \'elemOptSeq\' | filter:{label:$viewValue} | limitTo:8\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><div ng-if=\"element.elemInputTypeCd === \'DATE\'\" class=\"input-group date\"><input class=\"form-control\" ng-readonly=\"!vm.updateEnabled\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><div class=\"input-group-addon\" ng-class=\"{\'read-only\': !vm.updateEnabled}\"><span class=\"fa fa-calendar\"></span></div></div></div><div ng-if=\"element.elemInputTypeCd === \'VTRB\' || element.elemInputTypeCd === \'HZRB\'\"><div class=\"row survey-form-row\" style=\"{{(!element.dispLabel) ? \'margin-left: 0px; margin-right: 10px;\' : \'margin-left: 0px;\'}} {{($index === element.elemOpts.length -1) ? \'margin-bottom: 0px !important;\': \'margin-bottom: 15px !important;\'}}\" ng-repeat=\"option in element.elemOpts | orderBy:\'elemOptSeq\'\" ng-class=\"{\'inline\': element.elemInputTypeCd === \'HZRB\'}\"><div style=\"display: flex; align-items: stretch;\"><div style=\"min-width: 20px;\"><input icheck=\"\" type=\"radio\" ng-checked=\"false\" ng-model=\"vm.foo\" un-selectable=\"true\" ng-disabled=\"!vm.updateEnabled\"></div><span class=\"highlight-opt-label-on-hover opt-question-label padding-left: 5px !important;\" ng-bind-html=\"option.trustedLabel\" uib-tooltip=\"{{vm.clickToUpdateOptLabel}}\" ng-click=\"vm.openElementOptLabelEditorDialog(vm.optLabel, option, element.elemId)\"></span></div></div></div><div ng-if=\"element.elemInputTypeCd === \'TABL\'\"><div class=\"row\" style=\"margin-top: 5px\"><div class=\"col-sm-12\"><table id=\"repeatingElementsTable\" data-elements=\"{{element.childElements}}\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th ng-repeat=\"childElement in element.childElements | orderBy : \'elemSeq\'\" class=\"{{childElement.elemWidth ? \'col-sm-\' + childElement.elemWidth : \'col\'}}\"><span class=\"control-label\" ng-if=\"childElement.dispLabel\" ng-class=\"{\'required\': childElement.elemReqd, \'idmx_cursor_pointer\': childElement.elemHelpText, \'bold-label\': !childElement.isElemLabel}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-animation=\"true\" popover-title=\"{{childElement.elemName}}\" uib-popover=\"{{childElement.elemHelpText}}\" ng-bind-html=\"childElement.elemLabelText\"></span></th><th><span class=\"control-label\" ng-bind-html=\"vm.updtSurvActnHdr()\"></span></th></tr></thead><tbody><tr ng-repeat=\"(rowIndex, tableRow) in vm.tablModel[element.elemId]\"><td ng-repeat=\"childElement in element.childElements | orderBy : \'elemSeq\'\" style=\"vertical-align: top !important;\"><div ng-include=\"\'app/subject/survey/survey_element_table_children.template.html\'\"></div></td><td style=\"text-align: center; vertical-align: top !important;\"><button type=\"button\" class=\"btn btn-danger idmx-square-btn\" ng-disabled=\"vm.isTablDeleteBtnDisabled(element) || !vm.updateEnabled\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/subject/scoring/scoreTypes/scoreTypes.html","<script type=\"text/javascript\">\n    $(function () {\n        setTimeout(function () {\n            $(\'#aster-chart-keys\').slimScroll({\n                height: \'calc(100vh - 300px)\',\n                railVisible: true\n            });\n\n            $(\'#score-comparison-keys\').slimScroll({\n                height: \'calc(100vh - 370px)\',\n                railVisible: true\n            });\n\n            $(\'#historyKeyContainer\').slimScroll({\n                height: \'calc(100vh - 300px)\',\n                railVisible: true\n            });\n\n            $(\'.scrollable-container\').slimScroll({\n                height: \'calc(100vh - 465px)\',\n                railVisible: true\n            });\n        });\n    });\n</script><div ng-if=\"vm.currSubjScore\" class=\"ibox-content idmx-ibox-content\"><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-heading\"><div class=\"panel-options\"><ul id=\"scoreTab\" class=\"nav nav-tabs\"><li id=\"current-score-tab\" ng-class=\"{\'active\': vm.activeTab === 1}\" has-any-subj_perms=\"[\'VIEW_WGTD_SCORE_BREAKDN\']\"><a score-tab-1=\"\" data-target=\"#tab-1\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.scoreType.wgtdScoreBreakdnTab\"></a></li><li id=\"score-comparison-tab\" ng-class=\"{\'active\': vm.activeTab === 2}\" has-any-subj-perms=\"[\'VIEW_SCORE_COMP\']\"><a score-tab-2=\"\" data-target=\"#tab-2\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.scoreType.scoreCompTab\"></a></li><li id=\"score-targets-tab\" ng-class=\"{\'active\': vm.activeTab === 3}\" ng-if=\"vm.targetableNodesExist\" has-any-subj-perms=\"[\'UPDT_SCORE_TARGS\']\"><a score-tab-3=\"\" data-target=\"#tab-3\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.scoreType.scoreTargsTab\"></a></li><li id=\"score-history-tab\" ng-class=\"{\'active\': vm.activeTab === 4}\" ng-if=\"vm.history.subjScores.length > 1\" has-any-subj-perms=\"[\'VIEW_SCORE_HIST\']\"><a score-tab-4=\"\" data-target=\"#tab-4\" data-toggle=\"tab\" class=\"idmx-tab\" translate=\"score.scoreType.scoreHistTab\"></a></li></ul></div></div><div class=\"panel-body idmx-panel-body\"><div class=\"tab-content\"><div id=\"tab-1\" has-any-subj_perms=\"[\'VIEW_WGTD_SCORE_BREAKDN\']\" class=\"tab-pane animated fadeInRight idmx-tab-pane\" ng-class=\"{\'active\': vm.activeTab === 1}\" style=\"overflow: hidden\"><div class=\"row\"><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><h3 style=\"margin-left: 15px; margin-bottom: 15px;\"><span ng-bind-html=\"vm.chartTitle(vm.currSubjHierNodeId || 1)\"></span> <span score-badge=\"\" score-pct=\"{{vm.scoreBadgePopoverPct(vm.currSubjHierNodeId) * 100}}\" score-desc=\"{{vm.scoreBadgePopoverDesc(vm.currSubjHierNodeId)}}\" score-desc-popover=\"\">{{vm.scoreBadgeVal(vm.currSubjHierNodeId)}}</span></h3><div class=\"ibox-content scoring-content\"><aster-chart id=\"asterChart\" ng-if=\"vm.currSubjChartConfig\" config=\"{{vm.currSubjChartConfig}}\" max-val=\"{{vm.currSubjChartMaxVal(vm.currSubjHierNodeId)}}\" data=\"{{vm.currSubjChartData(vm.currSubjHierNodeId)}}\" data-field=\"currSubjHierNodeId\"></aster-chart></div></div><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 0px;\"><div class=\"ibox margin-bottom-5px float-e-margins\"><div class=\"scoring-title\" style=\"margin-left: 15px;\"><h3>{{vm.keyTitle(vm.currSubjScore.children[0].scoreHierLvlName)}}</h3></div><div class=\"ibox-content scoring-content\" id=\"aster-chart-keys\"><chart-keys-accordion ng-if=\"vm.asterChartKeyData\" style=\"padding-bottom: 0px;\" class=\"target-scores svg-container\" data=\"{{vm.asterChartKeyData}}\" data-field=\"currSubjHierNodeId\"></chart-keys-accordion></div></div></div></div></div><div id=\"tab-2\" has-any-subj-perms=\"[\'VIEW_SCORE_COMP\']\" class=\"tab-pane animated fadeInRight idmx-tab-pane\" ng-class=\"{\'active\': vm.activeTab === 2}\" style=\"overflow: hidden\"><div class=\"row\"><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><h3 style=\"margin-left: 15px; margin-bottom: 15px; line-height: 24px;\"><span ng-bind-html=\"vm.chartTitle(vm.scHierNodeId)\"></span> <span score-badge=\"\" score-pct=\"{{vm.scoreBadgePopoverPct(vm.scHierNodeId) * 100}}\" score-desc=\"{{vm.scoreBadgePopoverDesc(vm.scHierNodeId)}}\" score-desc-popover=\"\">{{vm.scoreBadgeVal(vm.scHierNodeId)}}</span></h3><div class=\"ibox-content scoring-content target-scores\"><idmx-chart id=\"scChart\" ng-if=\"vm.activeTab === 2 && vm.scChartConfig\" config=\"{{vm.scChartConfig(vm.scHierNodeId)}}\" data=\"{{vm.scData(vm.scHierNodeId)}}\" series-callback=\"vm.setComparisonChartHierNodeIdFromChart(series)\"></idmx-chart></div></div><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 0px;\"><div class=\"ibox margin-bottom-5px float-e-margins\"><div class=\"scoring-title\"><h3 ng-if=\"vm.peerGroups.length !== 0 || vm.targetsExist || vm.nextTargetsExist\" translate=\"score.home.scoreComp.compToText\" style=\"margin-left: 15px;\"></h3><hr ng-if=\"vm.peerGroups.length !== 0 || vm.targetsExist || vm.nextTargetsExist\" style=\"margin: 5px 0px;\"><div class=\"row\"><div class=\"col-md-12\"><div ng-if=\"vm.peerGroups.length !== 0\" class=\"zero-left-padding\" style=\"margin-bottom: 5px;\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-4\"><div class=\"compare-to-peergrp\" style=\"padding-left: 5px; border-radius: 5px;\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px; text-align: right;\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.compareToPeerGrp\" un-selectable=\"true\"></div><label><span class=\"small-label\" style=\"line-height: 23.2px;\" translate=\"score.home.scoreComp.peerGrpLabel\"></span></label></div></div><div class=\"col-xs-8\"><div class=\"pull-left\"><select ng-show=\"vm.peerGroups.length === 1\" class=\"form-control peer-group-select\" ng-model=\"vm.selectedPeerGrp\" ng-options=\"peerGrp.peerGrpName for peerGrp in vm.peerGroups\" disabled=\"\"></select><select ng-show=\"vm.peerGroups.length > 1\" class=\"form-control peer-group-select\" ng-model=\"vm.selectedPeerGrp\" ng-options=\"peerGrp.peerGrpName for peerGrp in vm.peerGroups\"></select></div></div></div></div></div><div ng-if=\"vm.targetsExist || vm.nextTargetsExist\" class=\"zero-left-padding\" style=\"margin-bottom: 5px;\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-class=\"{\'col-xs-4\': !vm.latestTargFlag && vm.targetsExist && vm.nextTargetsExist, \'col-xs-12\': vm.latestTargFlag || !(vm.targetsExist && vm.nextTargetsExist)}\"><div class=\"compare-to-target\" style=\"padding-left: 5px; border-radius: 5px;\"><div class=\"icheckbox icheckbox_square-idmx\" style=\"margin-right: 10px; text-align: right;\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-model=\"vm.compareToTarget\" un-selectable=\"true\" ng-disabled=\"vm.isTargetDisabled(vm.scHierNodeId)\"></div><label><span class=\"small-label\" ng-class=\"{\'disabled\': option.optValue === \'targetScore\' && vm.isTargetDisabled(vm.scHierNodeId)}\" style=\"line-height: 23.2px;\"><span translate=\"score.home.scoreComp.targLabel\"></span> <span ng-if=\"!vm.latestTargFlag && vm.targetsExist && !vm.nextTargetsExist\">(<span translate=\"score.home.scoreComp.targCurrRadio\"></span>)</span> <span ng-if=\"!vm.latestTargFlag && !vm.targetsExist && vm.nextTargetsExist\">(<span translate=\"score.home.scoreComp.targNextRadio\"></span>)</span></span></label></div></div><div ng-if=\"!vm.latestTargFlag && vm.targetsExist && vm.nextTargetsExist\" class=\"col-xs-8\"><div class=\"survey-form-row inline\"><input name=\"targetType\" icheck=\"\" type=\"radio\" value=\"current\" ng-model=\"vm.targetType\" ng-disabled=\"vm.isCurrentTargetDisabled(vm.scHierNodeId)\"> <span class=\"zero-bottom-margin opt-question-label\" translate=\"score.home.scoreComp.targCurrRadio\"></span></div><div class=\"survey-form-row inline\"><input name=\"targetType\" icheck=\"\" type=\"radio\" value=\"next\" ng-model=\"vm.targetType\" ng-disabled=\"vm.isNextTargetDisabled(vm.scHierNodeId)\"> <span class=\"zero-bottom-margin opt-question-label\" translate=\"score.home.scoreComp.targNextRadio\"></span></div></div></div></div></div></div><div class=\"col-md-12\" style=\"margin-left: 15px;\"><h3>{{vm.keyTitle(vm.currSubjScore.scoreHierLvlName)}}</h3></div></div></div><div class=\"ibox-content scoring-content\" id=\"score-comparison-keys\"><chart-keys-accordion-2 id=\"comparisonKey\" ng-if=\"vm.scChartKeyData\" class=\"target-scores svg-container\" data=\"{{vm.scChartKeyData}}\" selected-node=\"{{vm.scHierNodeId}}\" callback=\"vm.setComparisonChartHierNodeIdFromKey(hierNodeId)\"></chart-keys-accordion-2></div></div></div></div></div><div id=\"tab-3\" has-any-subj-perms=\"[\'UPDT_SCORE_TARGS\']\" class=\"tab-pane animated fadeInRight idmx-tab-pane\" ng-class=\"{\'active\': vm.activeTab === 3}\" style=\"overflow: hidden\" ng-if=\"vm.targetableNodesExist\"><div class=\"message-help message-sm\" style=\"margin-top: 20px\"><span data-translate=\"score.home.scoreTarg.updtScoreTargInstrText\"></span></div><form class=\"form-horizontal\" novalidate=\"\" name=\"scoreTargetForm\"><div class=\"row\"><div class=\"col-xs-4\"><div class=\"form-group row\"><label class=\"col-xs-7 control-label\" style=\"text-align: left\" data-translate=\"score.home.scoreTarg.currSubjEffDtLabel\"></label><div class=\"col-xs-5\"><div class=\"control-text\">{{vm.subjEffDate}}</div></div></div></div><div class=\"col-xs-5\"><div class=\"form-group row\"><label class=\"col-xs-5 control-label required\" style=\"text-align: left\" data-translate=\"score.home.scoreTarg.nextSubjEffDtLabel\"></label><div class=\"col-xs-7\" ng-class=\"{\'has-error\': scoreTargetForm.flwupSubjEffDate.$dirty && scoreTargetForm.flwupSubjEffDate.$invalid && ((scoreTargetForm.flwupSubjEffDate.$viewValue && scoreTargetForm.flwupSubjEffDate.$viewValue !== vm.datePlaceholder) || vm.flwupSubjExists)}\"><div class=\"input-group date date-picker\" id=\"datepicker\"><input id=\"flwupSubjEffDate\" name=\"flwupSubjEffDate\" class=\"form-control\" ui-mask=\"{{vm.dateMask}}\" ng-model=\"vm.flwupSubjEffDate\" ng-model-options=\"{updateOn: \'blur\'}\" ui-mask-placeholder=\"{{vm.datePlaceholder}}\" ui-options=\"{allowInvalidValue: true, clearOnBlur: false}\" model-view-value=\"true\" required=\"\" flwup-subj-eff-date-is-valid=\"\"><div class=\"input-group-addon\"><span class=\"fa fa-calendar\"></span></div></div><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"scoreTargetForm.flwupSubjEffDate.$dirty && scoreTargetForm.flwupSubjEffDate.$invalid\" ng-messages=\"scoreTargetForm.flwupSubjEffDate.$error\"><span ng-message=\"subjDateInvalid\" translate=\"score.home.scoreTarg.valid.subjEffDtInvld\"></span> <span ng-message=\"subjDateGtPrevValid\" translate=\"score.home.scoreTarg.valid.subjEffDtGtCurr\"></span> <span ng-message=\"subjDateLtPrevValid\" translate=\"score.home.scoreTarg.valid.subjEffDtLtNext\"></span> <span ng-show=\"vm.flwupSubjExists\" ng-message=\"required\" translate=\"score.home.scoreTarg.valid.subjEffDtReqd\"></span></div></div></div></div><div class=\"col-xs-3\"><div class=\"form-group row\" ng-if=\"!vm.flwupSubjExists && vm.hasSubjDataCloneDecsnFlag\"><label class=\"col-xs-8 control-label\" style=\"text-align: left\" translate=\"score.home.scoreTarg.cloneSubjDataLabel\"></label><div class=\"col-xs-2\"><div class=\"checkbox-inline zero-left-padding\"><input id=\"subjCloneFlagIp\" icheck=\"\" ng-model=\"vm.subjDataCloneFlag\" name=\"subjCloneFlagIp\" type=\"checkbox\"></div></div></div></div></div><table class=\"idmx-table table table-striped table-bordered table-hover\" style=\"margin-bottom: 0px; width: 100%;\"><thead><tr><th style=\"width: 44% !important\" data-translate=\"score.home.scoreTarg.nodeNameHeader\"></th><th ng-if=\"vm.scoreCurrTargDispFlag\" style=\"width: 14% !important\" data-translate=\"score.home.scoreTarg.currTargScoreHeader\"></th><th style=\"width: 10% !important\" data-translate=\"score.home.scoreTarg.currScoreHeader\"></th><th style=\"width: 12% !important\" data-translate=\"score.home.scoreTarg.nextTargScoreHeader\"></th><th style=\"width: 10% !important\" data-translate=\"score.home.scoreTarg.scoreTiersGuideTitle\"></th><th style=\"width: 10% !important\" data-translate=\"score.home.scoreTarg.lastUpdtHeader\"></th></tr></thead></table><div class=\"scrollable-container\"><table class=\"idmx-table table table-striped table-bordered table-hover\" style=\"width: 100%;\"><tbody><tr ng-repeat=\"node in vm.rowNodes\" id=\"{{node.scoreHierNodeId}}\" ng-if=\"vm.showLevel(node.scoreHierLvlId)\"><td style=\"width: 44%\"><span style=\"display: flex;\"><span ng-if=\"node.children && node.children.length > 0 && node.scoreHierLvlId < vm.maxTargetableLvlId\" style=\"margin-left: {{node.lvlStyle}}; margin-right: 15px;\"><span ng-click=\"vm.collapse(node, true)\" id=\"down-{{node.scoreHierNodeId}}\"><i class=\"idmx-arrow idmx-arrow-down\"></i></span> <span ng-click=\"vm.expand(node)\" id=\"up-{{node.scoreHierNodeId}}\" style=\"display: none\"><i class=\"idmx-arrow idmx-arrow-right\"></i></span></span> <span ng-if=\"!(node.children && node.children.length > 0 && node.scoreHierLvlId < vm.maxTargetableLvlId)\" style=\"margin-left: {{node.lvlStyle}}; margin-right: 24px;\"></span> {{node.scoreHierNodeName}}</span></td><td ng-if=\"vm.scoreCurrTargDispFlag\" class=\"padded-icon-cell\" style=\"width: 14%; text-align: center !important;\"><div ng-if=\"node.allowTargFlag\"><i class=\"fa fa-bar-chart-o idmx-heading-icon\" ng-if=\"node.targetScoreVal\"></i> <span ng-if=\"node.targetScoreVal\" score-badge=\"\" score-pct=\"{{node.targetScorePct}}\" score-desc=\"{{node.targetScoreDesc}}\" score-desc-popover=\"\">{{node.targetScoreVal | number: node.scoreValDpCnt}}</span></div></td><td ng-if=\"node.currentScoreVal\" class=\"padded-icon-cell\" style=\"width: 10%\"><div ng-if=\"node.allowTargFlag\"><i class=\"fa fa-bar-chart-o idmx-heading-icon\"></i> <span score-badge=\"\" score-pct=\"{{node.currentScorePct}}\" score-desc=\"{{node.currentScoreDesc}}\" score-desc-popover=\"\">{{node.currentScoreVal | number: node.scoreValDpCnt}}</span></div></td><td ng-if=\"!node.currentScoreVal\" style=\"width: 10%; text-align: center !important\"><span ng-if=\"node.allowTargFlag\" data-translate=\"score.home.scoreTarg.noCurrScoreText\"></span></td><td style=\"width: 12%\"><div ng-if=\"node.allowTargFlag\" ng-class=\"{\'has-error\': scoreTargetForm[\'nextTargetScore_\' + $index].$dirty && scoreTargetForm[\'nextTargetScore_\' + $index].$invalid}\"><input type=\"text\" class=\"form-control\" name=\"nextTargetScore_{{$index}}\" ng-model=\"node.nextTargetScoreVal\" ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"vm.updateNextTargetScoreVal(node)\" ng-disabled=\"!vm.flwupSubjEffDate || scoreTargetForm.flwupSubjEffDate.$invalid\" score-pct=\"{{node.nextTargetScorePct}}\" score-desc=\"{{node.nextTargetScoreDesc}}\" score-desc-popover=\"\" max=\"{{vm.maxNextTargetScoreVal(node)}}\" next-target-score-val-is-valid=\"\"><div class=\"help-block m-b-none\" multiple=\"\" ng-show=\"scoreTargetForm[\'nextTargetScore_\' + $index].$dirty && scoreTargetForm[\'nextTargetScore_\' + $index].$invalid\" ng-messages=\"scoreTargetForm[\'nextTargetScore_\' + $index].$error\"><span ng-message=\"invalid\" translate=\"score.home.scoreTarg.valid.nextTargScoreValInvld\"></span></div></div></td><td style=\"width: 10%; text-align: center !important; font-size: 20px\"><i ng-if=\"node.allowTargFlag && node.tiers.length\" class=\"fa fa-info-circle color-help\" score-guidance-popover=\"\" tiers=\"{{node.tiers}}\" max-node-score-val=\"{{node.maxNodeScoreVal}}\"></i></td><td style=\"width: 10%\"><div ng-if=\"node.allowTargFlag\">{{(node.lastUpdtTmstmp) ? (node.lastUpdtTmstmp | dateOnlyFormat) : \'\'}}</div></td></tr></tbody></table></div><br><br><br><div class=\"footer fixed\" style=\"height: 53px; min-height: 53px;\"><div style=\"float: right;\"><button type=\"button\" class=\"btn btn-secondary btn-reset-score-targets\" ng-click=\"vm.resetPage()\" data-translate=\"score.home.scoreTarg.resetButton\"></button> <button type=\"button\" class=\"btn btn-primary btn-save-score-targets\" ladda=\"vm.savingScoreHierNodeTargets\" ng-click=\"vm.saveScoreTargets(scoreTargetForm)\" ng-disabled=\"vm.saveBtnDisabled(scoreTargetForm)\" data-translate=\"score.home.scoreTarg.saveButton\"></button></div></div></form></div><div id=\"tab-4\" ng-if=\"vm.history.subjScores.length > 1\" has-any-subj-perms=\"[\'VIEW_SCORE_HIST\']\" class=\"tab-pane animated fadeInRight idmx-tab-pane\" ng-class=\"{\'active\': vm.activeTab === 4}\"><div class=\"col-md-6\" style=\"padding: 15px; padding-top: 10px;\"><h3 style=\"margin-left: 15px; margin-bottom: 15px;\"><span ng-bind-html=\"vm.chartTitle(vm.historyChartHierNodeId)\"></span></h3><div class=\"ibox-content scoring-content\"><idmx-chart id=\"historyChart\" ng-if=\"vm.activeTab === 4 && vm.historyChartConfig\" config=\"{{vm.historyChartConfig(vm.historyChartHierNodeId)}}\" data=\"{{vm.historyChartData(vm.historyChartHierNodeId)}}\" series-callback=\"vm.setHistoryChartHierNodeIdFromChart(series)\"></idmx-chart></div></div><div class=\"col-md-6\"><div class=\"ibox\"><div class=\"scoring-title\"><h3>{{vm.keyTitle(vm.history.subjScores[0].scoreHierLvlName)}}</h3></div><div class=\"ibox-content scoring-content\" id=\"historyKeyContainer\"><chart-keys-accordion-2 id=\"historyKey\" ng-if=\"vm.historyChartKeyData\" class=\"target-scores svg-container\" data=\"{{vm.historyChartKeyData}}\" selected-node=\"{{vm.historyChartHierNodeId}}\" callback=\"vm.setHistoryChartHierNodeIdFromKey(hierNodeId)\"></chart-keys-accordion-2></div></div></div></div></div></div></div></div></div></div><div ng-if=\"!vm.currSubjScore\" class=\"message-error\"><span translate=\"score.home.valid.noViewScorePermsn\"></span></div>");
$templateCache.put("app/subject/summary/activity/activity.html","<div ng-if=\"vm.showActvtyFlag\" class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\" style=\"position: static !important; float: right;\">&nbsp;&nbsp; <button type=\"button\" class=\"btn btn-primary btn-acknowledge\" ng-disabled=\"vm.numNewEvents() === 0\" ng-click=\"vm.acknowEvents()\"><i class=\"fa fa-check-circle\"></i> <span translate=\"subj.actvty.acknowButton\"></span></button></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><table activity-dt=\"\" id=\"activityTable\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th>&nbsp;</th><th class=\"col-xs-8\" translate=\"subj.actvty.eventTextHeader\"></th><th translate=\"subj.actvty.priotHeader\"></th><th translate=\"subj.actvty.dtTmHeader\"></th></tr></thead></table></div></div></div></div></div><div ng-if=\"!vm.showActvtyFlag\" class=\"message-error\"><span translate=\"subj.actvty.valid.noViewActvtyPermsn\"></span></div>");
$templateCache.put("app/subject/summary/dashboard/dashboard.html","<div class=\"col-xs-12\" style=\"margin-left: -7.5px !important; padding-right: 0px !important\"><div class=\"row\"><div id=\"survWidget\" ng-if=\"$root.subject.survey && $root.subject.survey.type\" class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-subj-perms=\"[\'UPDT_SURV\', \'VIEW_SURV\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><span class=\"label lbl-survey pull-right\">{{$root.subject.survey.type.name}}</span><h5><span translate=\"subj.dashbrd.survMetricTitle\"></span></h5></div><div class=\"ibox-content dash-widget\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{$root.subject.survey.progPct}}%</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span dashboard-survey-progress=\"\" percent=\"$root.subject.survey.progPct\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.dashbrd.survMetricDesc\"></small></div></div><div class=\"date-label\"><span ng-if=\"$root.subject.survey.lastUpdateTmstmp\">{{$root.subject.survey.lastUpdateTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!$root.subject.survey.lastUpdateTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm\" has-any-subj-perms=\"[\'UPDT_SURV\', \'VIEW_SURV\']\" ui-sref=\"app.subject.survey.section({id:$root.subject.subjId, sectionIdx:vm.surveyIndex})\"><i class=\"fa fa-plus\"></i></a></div></div></div><div id=\"obsvWidget\" class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-subj-perms=\"[\'VIEW_OBSV\']\" ng-if=\"$root.subject.obsv\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideObsv($event, \'next\')\" style=\"font-size: 15px;\" data-slide=\"next\" id=\"nextObsv\"><span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span></a><span class=\"label lbl-observations pull-right\" style=\"margin-right: 4px;\">{{vm.obsvTypeName}}</span><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideObsv($event, \'prev\')\" style=\"font-size: 15px;\" data-slide=\"prev\" id=\"prevObsv\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Previous</span></a><h5><span translate=\"subj.dashbrd.obsvsMetricTitle\"></span></h5></div><div id=\"subj-dash-obsvs\" class=\"carousel slide\" data-interval=\"false\" data-wrap=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item ibox-content dash-widget\" ng-class=\"{\'active\': $index === 0}\" index=\"{{$index}}\" ng-repeat=\"obsv in $root.subject.obsvs\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{obsv.cnt}}</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span dashboard-obsv-count-progress=\"\" wgt=\"obsv.highestPriority\" obsv-count=\"obsv.cnt\" total-obsv-count=\"obsv.totalCnt\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.dashbrd.obsvsMetricDesc\"></small></div></div><div class=\"date-label\"><span ng-if=\"obsv.lastUpdateTmstmp\">{{obsv.lastUpdateTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!obsv.lastUpdateTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm dash-widget\" ng-click=\"vm.gotoObsvs(obsv.obsvTypeCd)\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></div><div id=\"docsWidget\" class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-subj-perms=\"[\'MANG_DOC\']\" ng-if=\"$root.subject.docu\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><span class=\"label lbl-documents pull-right\" translate=\"subj.dashbrd.docsMetricScope\"></span><h5><span translate=\"subj.dashbrd.docsMetricTitle\"></span></h5></div><div class=\"ibox-content dash-widget\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{$root.subject.docu.satsfdCnt}}/{{$root.subject.docu.cnt}}</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span dashboard-doc-progress=\"\" doc-max-wgt=\"$root.subject.docu.highestPriority\" doc-uploaded=\"$root.subject.docu.satsfdCnt\" doc-requested=\"$root.subject.docu.cnt\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.dashbrd.docsMetricDesc\">Documents Uploaded/Requested</small></div></div><div class=\"date-label\"><span ng-if=\"$root.subject.docu.lastUpdateTmstmp\">{{$root.subject.docu.lastUpdateTmstmp | dateOnlyFormat}}</span> <span ng-if=\"!$root.subject.docu.lastUpdateTmstmp\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"app.subject.documents\"><i class=\"fa fa-plus\"></i></a></div></div></div><div id=\"scoreWidget\" ng-if=\"vm.subjStageScores.length\" class=\"col-xs-6 col-lg-3 dash-widget-container\" has-any-subj-perms=\"[\'VIEW_SCORE\']\"><div class=\"ibox zero-bottom-margin\"><div class=\"ibox-title\"><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideScore($event, \'next\')\" style=\"font-size: 15px;\" data-slide=\"next\" id=\"nextSubjScore\"><span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span></a><span class=\"label lbl-scoring pull-right\" style=\"margin-right: 4px;\">{{vm.scoreTypeName}}</span><a class=\"pull-right act-nav-color\" role=\"button\" ng-click=\"vm.slideScore($event, \'prev\')\" style=\"font-size: 15px;\" data-slide=\"prev\" id=\"prevSubjScore\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Previous</span></a><h5><span translate=\"subj.dashbrd.scorgMetricTitle\"></span></h5></div><div id=\"subj-dash-scores\" class=\"carousel slide\" data-interval=\"false\" data-wrap=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item ibox-content dash-widget\" ng-class=\"{\'active\': $index === 0}\" index=\"{{$index}}\" ng-repeat=\"score in $root.subject.scores\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"no-margins custom-metric-h1\">{{score.scoreVal | number : score.scoreValDpCnt}} <span ng-if=\"score.prevSubjScoreVal !== \'undefined\' && score.prevSubjScoreVal !== null\" has-any-subj-perms=\"[\'VIEW_SCORE_HIST\']\"><span class=\"lbl-change-score\" dashboard-score-change=\"\" prev-subj-score-val=\"score.prevSubjScoreVal\" score-val=\"score.scoreVal\"></span></span></h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"progress progress-mini\"><span dashboard-score-progress=\"\" percent=\"score.scorePct\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><small translate=\"subj.dashbrd.scorgMetricDesc\"></small></div></div><div class=\"date-label\" style=\"right: 40px;\"><span ng-if=\"score.scoreLastUpdate\">{{score.scoreLastUpdate | dateOnlyFormat}}</span> <span ng-if=\"!score.scoreLastUpdate\">--/--/----</span></div><a type=\"button\" class=\"btn btn-default btn-sm dash-widget\" ui-sref=\"app.subject.scoring.type({id: $root.subject.subjId, scoreTypeCd: score.scoreTypeCd})\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></div><div class=\"col-xs-12 dash-widget-container\" has-any-subj-perms=\"[\'VIEW_ACTVTY\']\"><div class=\"ibox\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title\" style=\"text-align: center\"><span class=\"label lbl-parms pull-right\">Last 30 Days</span> <span class=\"lbl-key pull-right\"><div class=\"color-box\" style=\"background: {{vm.userActivityEventsColour}}\"></div><small translate=\"subj.dashbrd.usrActvtyMetricYAxis2Label\"></small></span> <span class=\"lbl-key pull-right\"><div class=\"color-box\" style=\"background: {{vm.userActivityUserLoginsColour}}\"></div><small translate=\"subj.dashbrd.usrActvtyMetricYAxis1Label\"></small></span><h5><span translate=\"subj.dashbrd.usrActvtyMetricTitle\"></span></h5></div><div class=\"ibox-content zero-bottom-padding zero-top-padding\"><idmx-chart id=\"userActivityChart\" ng-if=\"vm.userActivityChartConfig\" config=\"{{vm.userActivityChartConfig}}\" data=\"{{vm.userActivityData}}\"></idmx-chart></div></div></div></div></div><div ng-if=\"!vm.showDashFlag\" class=\"message-error\"><span translate=\"subj.dashbrd.valid.noViewDashPermsn\"></span></div>");
$templateCache.put("app/subject/summary/reports/add-parameter-dialog-template.html","<script type=\"text/ng-template\" id=\"add-parameter-dialog-template.html\"><div class=\'modal-header\'> <button type=\'button\' class=\'close\' data-dismiss=\'modal\' ng-click=\'modal.cancel()\'> <span aria-hidden=\"true\">×</span><span class=\"sr-only\">Close</span></button> <h2 class=\"modal-title\" id=\"modal-title\"> <span ng-if=\"modal.icon\"><i class=\"fa fa-file-text-o idmx-heading-icon\"></i>&nbsp;</span> <span> <span translate=\"subj.repts.modal.reptParms.pageTitle\"></span> <small translate=\"subj.repts.modal.reptParms.pageDesc\"></small> </span> </h2> </div> <div class=\"modal-body\" id=\"modal-body\"> <div class=\"form-group\"> <div class=\"col-lg-12\"> <div class=\"radio-inline\"> <input icheck type=\"radio\" name=\"reportPreference\" ng-model=\"modal.rptParamOpt\" value=\"full\" ng-checked=\"true\" required> <span translate=\"subj.repts.modal.reptParms.fullReptRadio\"></span> </div> <div class=\"radio-inline zero-left-padding\"> <input icheck type=\"radio\" name=\"reportPreference\" ng-model=\"modal.rptParamOpt\" value=\"filter\" required> <span translate=\"subj.repts.modal.reptParms.useParmsRadio\"></span> </div> </div> </div> <div ng-if=\"modal.rptParamOpt === \'filter\'\" class=\"row idmx-row\" style=\"padding-top: 20px;\"> <div class=\"col-lg-12 idmx-zero-padded-col\"> <div class=\"panel blank-panel\"> <div class=\"panel-body idmx-panel-body\" style=\"max-height: 520px; overflow-y: auto; padding-bottom: 15px !important;\"> <div class=\"row col-xs-12\"><p translate=\"subj.repts.modal.reptParms.newParmTitle\"></p></div> <table class=\"idmx-table table table-striped table-bordered table-hover\" style=\"background: white\"> <thead> <tr> <th class=\"col-xs-1\"></th> <th class=\"col-xs-3\"><span translate=\"subj.repts.modal.reptParms.parmHeader\"></span></th> <th class=\"col-xs-7\"><span translate=\"subj.repts.modal.reptParms.valHeader\"></span></th> <th class=\"col-xs-1\"><span translate=\"subj.repts.modal.reptParms.actnsHeader\"></span></th> </tr> </thead> <tbody> <tr> <td></td> <td style=\"vertical-align: top !important;\"> <select class=\"form-control\" name=\"parameter\" id=\"parameter\" ng-model=\"modal.newFilter.param\" ng-change=\"modal.resetVal()\"> <option selected value=\"\" class=\"placeholder-color\" translate=\"subj.repts.modal.reptParms.parmSelectText\"></option> <option ng-repeat=\"filterOption in modal.filterOptions\" value=\"{{filterOption.param}}\"> {{filterOption.label}} </option> </select> </td> <td style=\"vertical-align: top !important;\"> <div ng-if=\"modal.newFilter.param === \'obsv_type_cd\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"obsvType.cd as obsvType.nm for obsvType in modal.filterParamOptions.obsvTypes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'obsv_priot_seq\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"obsvPriotSeq.cd as obsvPriotSeq.nm for obsvPriotSeq in modal.filterParamOptions.obsvPriotSeqs\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'l2_hier_node\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"l2HierNode.cd as l2HierNode.nm for l2HierNode in modal.filterParamOptions.l2HierNodes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'l3_hier_node\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"l3HierNode.cd as l3HierNode.entity.parntHierNodeName + \': \' + l3HierNode.nm for l3HierNode in modal.filterParamOptions.l3HierNodes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'surv_type_cd\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"survType.survTypeCd as survType.survTypeName for survType in modal.filterParamOptions.survTypes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'surv_sect\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"survSect.survTypeCd + \'|\' + survSect.survVersSeq + \'|\' + survSect.survSectSeq as survSect.survTypeName + \': \' + survSect.survSectName for survSect in modal.filterParamOptions.survSects\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'score_type_cd\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"scoreType.scoreTypeCd as scoreType.scoreTypeName for scoreType in modal.filterParamOptions.scoreTypes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'l2_score_hier_node\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"l2HierNode.cd as l2HierNode.entity.scoreTypeName + \': \' + l2HierNode.nm for l2HierNode in modal.filterParamOptions.l2ScoreHierNodes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'l3_score_hier_node\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"l3HierNode.cd as l3HierNode.entity.scoreTypeName + \': \' + l3HierNode.entity.parntScoreHierNodeName + \': \' + l3HierNode.nm for l3HierNode in modal.filterParamOptions.l3ScoreHierNodes\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.newFilter.param === \'sys_doc_sub_grp\'\" ng-class=\"{\'has-error\': modal.addSubmitted && modal.paramNull()}\"> <oi-select oi-options=\"chartGrp.grpId as chartGrp.grpName for chartGrp in modal.filterParamOptions.chartGrps\" ng-model=\"modal.newFilter.val\" multiple placeholder=\"{{\'subj.repts.modal.reptParms.valSelectText\' | translate}}\" list-placeholder=\"No Data Found.\" ></oi-select> </div> <div ng-if=\"modal.addSubmitted && modal.paramNull()\" class=\"has-error\"> <span class=\"help-block m-b-none\"> <span translate=\"subj.repts.modal.reptParms.valid.valReqd\"></span> </span> </div> </td> <td style=\"vertical-align: top !important; text-align: center;\"> <button class=\"btn btn-primary idmx-square-btn\" ng-disabled=\"modal.addFilterBtnDisabled()\" ng-click=\"modal.addFilter()\" uib-tooltip=\"{{\'subj.repts.modal.reptParms.addButton\' | translate}}\" > <i class=\"fa fa-plus\"></i> </button> </td> </tr> <tr ng-if=\"modal.submitted && modal.newFilter.param\"> <td colspan=\"3\"> <div class=\"has-error\"> <span class=\"help-block m-b-none\"> <span translate=\"subj.repts.modal.reptParms.valid.clickAdd\"></span> </span> </div> </td> </tr> </tbody> </table> <div class=\"row col-xs-12\"><p translate=\"subj.repts.modal.reptParms.currParmsTitle\"></p></div> <table class=\"idmx-table table table-striped table-bordered table-hover\" style=\"background: white\"> <thead> <tr> <th class=\"col-xs-1\"></th> <th class=\"col-xs-3\"><span translate=\"subj.repts.modal.reptParms.parmHeader\"></span></th> <th class=\"col-xs-7\"><span translate=\"subj.repts.modal.reptParms.valHeader\"></span></th> <th class=\"col-xs-1\"><span translate=\"subj.repts.modal.reptParms.actnsHeader\"></span></th> </tr> </thead> <tbody> <tr ng-repeat=\"filter in modal.filters\"> <td style=\"vertical-align: initial !important;\"> <span ng-if=\"$index > 0\">AND</span> </td> <td style=\"vertical-align: initial !important;\"> {{modal.getFilterLabel(filter.param)}} </td> <td style=\"vertical-align: initial !important;\" ng-bind-html=\"modal.getFilterVal(filter)\"> </td> <td style=\"vertical-align: top !important; text-align: center;\"> <button class=\"btn btn-danger idmx-square-btn\" ng-click=\"modal.removeFilter($index)\" uib-tooltip=\"{{\'subj.repts.modal.reptParms.delButton\' | translate}}\" > <i class=\"fa fa-trash\"></i> </button> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default form-reset-button\" type=\"button\" ng-click=\"modal.cancel()\" ng-disabled=\"modal.laddaSave\"> <span translate=\"subj.repts.modal.reptParms.cancelButton\"></span> </button> <button ladda=\"modal.laddaSave\" data-style=\"zoom-in\" class=\"btn btn-primary parameter-submit-btn\" ng-disabled=\"modal.submitted && modal.newFilter.param\" ng-click=\"modal.submit()\"> <span translate=\"subj.repts.modal.reptParms.downldButton\"></span> </button> </div></script>");
$templateCache.put("app/subject/summary/reports/reports.html","<div ng-if=\"vm.reports && vm.reports.length > 0\" class=\"ibox-content idmx-ibox-content\"><div id=\"idmx-table-tools\" class=\"idmx-table-tools\" style=\"position: static !important; float: right;\"></div><div class=\"row idmx-row\"><div class=\"col-lg-12 idmx-zero-padded-col\"><div class=\"panel blank-panel\"><div class=\"panel-body idmx-panel-body\"><table reports-dt=\"\" id=\"reportsTable\" ng-model=\"vm.selected\" class=\"idmx-table table table-striped table-bordered table-hover\"><thead><tr><th></th><th><span>#</span></th><th><span translate=\"subj.repts.reptNameHeader\"></span></th><th class=\"col-xs-4\"><span translate=\"subj.repts.reptDescHeader\"></span></th><th><span translate=\"subj.repts.fileFormtHeader\"></span></th><th><span translate=\"subj.repts.reptLayoutHeader\"></span></th><th><span translate=\"subj.repts.actnHeader\"></span></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports | orderBy:\'sysDocSeq\'\"><td><i class=\"fa {{report.icon}} idmx-heading-icon\" style=\"font-size: 20px;\"></i></td><td>{{$index + 1}}</td><td>{{report.sysDocName}}</td><td>{{report.sysDocDesc}}</td><td class=\"text-center\"><i class=\"fa {{report.downloadFormatIcon}}\" style=\"color: {{report.downloadFormatColor}}; font-size: 20px;\"></i></td><td>{{report.reportLayout}}</td><td><a ladda=\"vm.ladda[report.sysDocCd]\" target=\"_blank\" class=\"btn btn-primary\" ng-click=\"vm.downloadReport(report)\"><i class=\"fa fa-download\"></i> <span translate=\"subj.repts.downldButton\"></span></a></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"!vm.reports || vm.reports.length === 0\" class=\"message-error\"><span translate=\"subj.repts.valid.noDownldReptPermsn\"></span></div><div ng-include=\"\'app/subject/summary/reports/add-parameter-dialog-template.html\'\"></div>");}]);